webpackJsonp([0],{

/***/ "++zH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "number-field.svg";

/***/ }),

/***/ "+3UW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectJobController', ['jobService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', function (jobService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

  // Initialise variables to be used
  $scope.jobSearch = "";
  $scope.jobSearchLoading = false;
  $scope.jobSearchList = [];
  $scope.jobSearchListFull = [];
  $scope.jobSelectCallback = null;
  $scope.listCount = 0;
  $scope.desktopSelected = [];

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'jobNumber'
  };

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.jobSelectFromParent = function (currentJob, cb) {
    $scope.jobSearch = "";
    $scope.jobSearchLoading = false;
    $scope.jobSearchList = [];
    $scope.jobExisting = currentJob;
    $scope.jobSelectCallback = cb;
    $scope.desktopSelected = [];
    if ($stateParams.device == 'desktop') {
      $("#selectJobModal").fadeIn(100);
      $("input[name='selectJobInput']").focus();
    }
    $scope.loadJobList();
  };

  $scope.loadJobList = function (searchValue) {
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      if ($stateParams.device == 'desktop') {
        queryParams.limit = $scope.query.limit;
        queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
        queryParams.sort = $scope.query.order;
      } else {
        queryParams.sort = 'jobNumber';
      }
      if (searchValue != null && searchValue != "") {
        queryParams.search = searchValue;
      }
      jobService.getJobs(queryParams, function (returnObject) {
        $scope.jobSearchList = returnObject;
        if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
          $scope.listCount = returnObject.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        for (var i = 0; i < $scope.jobSearchList.length; i++) {
          $scope.jobSearchList[i].status = $scope.jobSearchList[i].status.charAt(0).toUpperCase() + $scope.jobSearchList[i].status.slice(1);
          if ($scope.jobExisting && $scope.jobSearchList[i].id == $scope.jobExisting.id) {
            $scope.jobSearchList[i].existing = true;
          }
        }
        resolve('Done');
      }, function (err) {
        $scope.jobSearchList = [];
        reject('Error');
      });
    });
  };

  $scope.closeJobSelectList = function () {
    $scope.jobSelectCallback(null);
    if ($stateParams.device == 'desktop') {
      $("#selectJobModal").fadeOut(100);
    }
  };

  $scope.desktopSelectJobContinue = function () {
    var selected = $scope.desktopSelected[0];
    $scope.jobSelectCallback(selected);
    $("#selectJobModal").fadeOut(100);
  };

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.searchJobChange = function (searchValue) {
    $scope.loadJobList(searchValue);
  };

  $scope.updateJobSearch = function (searchValue) {
    $scope.jobSearchLoading = true;
    $scope.jobSearch = searchValue;
    $scope.loadJobList();
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "+8HO":
/***/ (function(module, exports) {

var path = 'views/modals/acceptOrderWizardModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"acceptOrderWizardModal\">\n    <div class=\"modalContainer\" style=\"width: 800px;\">\n      <div class=\"header hidden-xs\">\n        <h1>Accept Order</h1>\n        <div class=\"headerCloseButton\" ng-click=\"close()\">\n          <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div ng-if=\"noTemplates\" class=\"content noPadding\">\n        <div class=\"ojdDesktopSection\">\n          It looks like you haven't created any docket templates yet.  Please go <a ng-click=\"goToCreateDocketTemplates()\">here</a>\n        </div>\n      </div>\n      <div ng-show=\"!noTemplates\" class=\"content noPadding\">\n        \n        <!-- Start Summary Section -->\n        <div class=\"ojdDesktopSection white\">\n          <div class=\"ojdDesktopRow\">\n            <div class=\"ojdDesktopField\">\n              <label class=\"order\">Order Number</label>\n              <h3>{{itemEdit.orderNumber}}</h3>\n            </div>\n            <div class=\"ojdDesktopField\">\n              <label class=\"order\">Customer</label>\n              <h3>{{itemEdit.customerContact.displayName}}</h3>\n            </div>\n          </div>\n          <div class=\"ojdDesktopRow\">\n            <div class=\"ojdDesktopField\" ng-if=\"!itemEdit.xeroQuote\">\n              <label class=\"order\">Supplier Ref No</label>\n              <h3>{{itemEdit.supplierRefNo}}</h3>\n            </div>\n            <div class=\"ojdDesktopField\">\n              <label class=\"order\">Customer Ref No</label>\n              <h3>{{itemEdit.customerRefNo}}</h3>\n            </div>\n          </div>\n        </div>\n        <!-- End Summary Section -->\n        \n        <!-- Start Template Selection Section -->\n        <div ng-show=\"allTemplates.length > 1\" class=\"templateArea\" id=\"templateArea\">\n          <div class=\"modalFormTableHeader\">\n            <div class=\"tableLayoutHelperContainer\">\n              <div class=\"left\" style=\"vertical-align: top;\">\n                <h2>Choose docket template</h2>\n                <div ng-if=\"itemEdit.template && !templateAccordionOpen\">\n                  <md-icon class=\"centerAligned green rightMargin\" md-svg-icon=\"_successtick.svg\"></md-icon>\n                  <span class=\"centerAligned\">{{itemEdit.template.name}}</span>\n                </div>\n                <div id=\"templateSubHead\">\n                  <p class=\"subHead\">\n                    Which template should operators use when creating dockets?\n                  </p>\n                  <span class=\"subHead \">\n                    Not sure?\n                  </span>\n                  <a href=\"https://help.docketbook.com.au/hc/en-us/articles/360049145534-Docket-Template-Overview\" target=\"_blank\">Click here</a>\n                </div>\n              </div>\n              <!--<a ng-if=\"!templateAccordionOpen\" class=\"inlineBlock\" ng-click=\"editTemplate()\">Edit</a>-->\n              <div class=\"right\" style=\"vertical-align: top;\">\n                <div ng-style=\"{visibility: templateAccordionOpen ? 'hidden' : ''}\" class=\"dbButton whiteOutline\" ng-click=\"editTemplate()\">Change Template</div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"adminBasicContentContainer\">\n            <div class=\"adminTemplatesList\" style=\"text-align: center;\">\n              <div class=\"adminTemplateItemOuter\" ng-repeat=\"template in allTemplates\">\n                <div class=\"adminTemplateItem\" ng-click=\"assignTemplate(template)\">\n                  <div class=\"adminTemplateItemInner\">\n                    <div class=\"ribbon\" ng-if=\"itemEdit.template && itemEdit.template.id == template.id\"><span>Selected</span></div>\n                    <div class=\"icon template\"></div>\n                    {{template.name}}\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <!-- Start Resource Selection Section -->\n        <div class=\"modalFormTableHeader\">\n          <h2 class=\"inlineBlock\">Match line items</h2>\n          <p class=\"subHead\">Which resources should be matched with the order line items?</p>\n          <span class=\"subHead\">Not sure? </span>\n          <a href=\"https://help.docketbook.com.au/hc/en-us/articles/360041795973-Resources-Products-\" target=\"_blank\">Click here</a>\n          <p ng-if=\"!itemEdit.template\" class=\"subhead\" style=\"margin-top: 10px;\">Please select a docket template first</p>\n        </div>\n        <div ng-if=\"itemEdit.template\" class=\"ojdDesktopSection noPadding\">\n          <md-table-container>\n            <table md-table md-progress=\"promise\">\n              <thead md-head>\n                <tr md-row>\n                  <th md-column class=\"iconColumn\"></th>\n                  <th md-column>Description</th>\n                  <th md-column>Supplier Resource</th>\n                  <th md-column class=\"iconColumn\"></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row ng-repeat=\"lineItem in itemEdit.lineItems\">\n                  <td md-cell>\n                    <md-icon ng-if=\"lineItem.resource\" class=\"green\" md-svg-icon=\"_successtick.svg\"></md-icon>\n                    <md-icon ng-if=\"!lineItem.resource && ignoredLineItems.includes(lineItem.id)\" md-svg-icon=\"_successtick.svg\"></md-icon>\n                  </td>\n                  <td md-cell>{{lineItem.itemDescription}}</td>\n                  <td md-cell>\n                    <span ng-if=\"lineItem.resource\">{{lineItem.resource.name}} ({{lineItem.resource.identifier}}) - {{lineItem.resource.uom.abbreviation}}</span>\n                    <div ng-if=\"!lineItem.resource && !ignoredLineItems.includes(lineItem.id)\" class=\"dbButton\" ng-click=\"selectResourceForLine(lineItem)\">Select Resource</div>\n                    <span ng-if=\"!lineItem.resource && ignoredLineItems.includes(lineItem.id)\">N/A</span>\n                  </td>\n                  <td md-cell class=\"right\">\n                    <md-menu ng-show=\"!itemEdit.loading\">\n                      <md-button aria-label=\"More Order Actions Menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" aria-label=\"More Options\">\n                        <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n                      </md-button>\n                      <md-menu-content width=\"4\">\n                        <md-menu-item ng-click=\"selectResourceForLine(lineItem)\" aria-label=\"Send Order\">\n                          <md-button>\n                            Edit line item\n                          </md-button>\n                        </md-menu-item>\n                        <md-menu-item ng-show=\"lineItem.resource || !ignoredLineItems.includes(lineItem.id)\" ng-click=\"ignoreLineItem(lineItem)\" aria-label=\"Re Draft Order\">\n                          <md-button>\n                            Ignore line item\n                          </md-button>\n                        </md-menu-item>\n                    </md-menu>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n        <!-- End Resource Selection Section -->\n\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n  \n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"close()\">\n              Cancel\n            </div>\n            <div class=\"dbButton\" ng-click=\"acceptOrder()\" ng-disabled=\"!formComplete || itemEdit.loading\">\n              Accept Order\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "+9Z+":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/addressBookTag.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\">\n    <div class=\"left\">\n      <h3>Contact Tags</h3>\n    </div>\n    <div class=\"right\">\n      <md-button class=\"md-icon-button\" ng-click=\"insertNewTag()\">\n        <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n      </md-button>\n      <md-button class=\"md-icon-button\" ng-click=\"loadTagList()\">\n        <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n      </md-button>\n      <md-menu>\n        <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n          <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"4\">\n          <md-menu-item ng-click=\"deleteSelectedTags()\" aria-label=\"Delete Selected Tags\">\n            <md-button>\n              Delete Selected Tags\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </div>\n  </div>\n\n  <div class=\"settingsTableOuterContainer\">\n    <md-table-container class=\"editableTable\">\n      <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column class=\"iconColumn\"></th>\n            <th md-column><span>Tag</span></th>\n            <th md-column><span>Description</span></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row md-select=\"tag\" md-select-id=\"id\" ng-repeat=\"tag in allTags\">\n            <td md-cell class=\"buttonCell\">\n              <md-button class=\"md-icon-button\" ng-click=\"editTagRow(tag)\" aria-label=\"Edit Tag\" ng-if=\"!tag.editing && !tag.loading\">\n                <md-icon md-svg-icon=\"edit.svg\"></md-icon>\n              </md-button>\n              <md-button class=\"md-icon-button\" ng-click=\"saveTagRow(tag)\" aria-label=\"Save Tag\" ng-if=\"tag.editing && !tag.loading\">\n                <md-icon md-svg-icon=\"resourcesave.svg\"></md-icon>\n              </md-button>\n              <span ng-if=\"tag.loading\">\n                <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-5\" md-diameter=\"20\"></md-progress-circular>\n              </span>\n            </td>\n            <td md-cell class=\"md-clickable\">\n              <md-input-container class=\"md-block\" ng-if=\"tag.editing && !tag.id\">\n                <input ng-model=\"tag.tag\" type=\"text\" required ng-disabled=\"!tag.editing || tag.loading\">\n              </md-input-container>\n              <span ng-if=\"(!tag.editing || (tag.editing && tag.id))\">\n                {{tag.tag}}\n              </span>\n            </td>\n            <td md-cell class=\"md-clickable\">\n              <md-input-container class=\"md-block\" ng-if=\"tag.editing\">\n                <input ng-model=\"tag.description\" type=\"text\" required ng-disabled=\"!tag.editing || tag.loading\">\n              </md-input-container>\n              <span ng-if=\"!tag.editing\">\n                {{tag.description}}\n              </span>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "+IYs":
/***/ (function(module, exports) {

var path = 'views/modals/importContactsModal.html';
var html = "<!-- Import Contacts From File Modal -->\n<div ng-if=\"!(currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled)\" class=\"niceModal desktopSelector\" id=\"importContactsModal\">\n    <div class=\"modalContainer\">\n        <div class=\"header\">\n            <h1>Select File To Import</h1>\n            <div class=\"headerCloseButton\" ng-click=\"close()\">\n                <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n        <form name=\"importContactsForm\" novalidate>\n            <div class=\"content\">\n                Excel files only (.xls or .xlsx)\n                <br/>\n                <br/>\n                <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n            </div>\n        </form>\n\n        <div ng-if=\"selectedTabIndex == 1 || !(currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled)\" class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                </div>\n                <div class=\"right\">\n                    <div class=\"dbButton white margin-right\" ng-click=\"cancelImport()\">\n                        Cancel\n                    </div>\n                    <div class=\"dbButton spinner\" ng-click=\"(importContactsForm.$invalid || contactImport.loading) || importFromFile(file)\" ng-disabled=\"importContactsForm.$invalid || contactImport.loading\">\n                        <span ng-hide=\"contactImport.loading\">Next</span>\n                    </div>\n                    <md-progress-circular ng-show=\"contactImport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<div ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\" class=\"niceModal desktopSelector wide long\" id=\"importContactsModal\">\n    <div class=\"modalContainer\">\n        <div class=\"header hidden-xs\">\n            <h1>Import Contacts</h1>\n            <div class=\"headerCloseButton\" ng-click=\"close()\">\n                <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n\n        <md-progress-circular ng-if=\"xeroSyncLoading == true\" md-diameter=\"35px\" style=\"position: absolute; left: 50%; top: 50%; z-index: 98;\"></md-progress-circular>\n\n        <div class=\"content noPadding\">\n            <md-tabs md-dynamic-height md-selected=\"selectedTabIndex\" md-border-bottom md-autoselect>\n                <md-tab label=\"From Xero\">\n                    <div ng-if=\"!userIsXeroAuthenticated\">Not authenticated</div>\n\n                    <div ng-if=\"userIsXeroAuthenticated\">\n                        <div class=\"splitModalFormLeft noPadding white\">\n                            <div class=\"searchBar\">\n                                <div class=\"title\">\n                                    <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                                </div>\n                                <div class=\"bar\">\n                                    <input type=\"text\" ng-model=\"xeroContactSearchValue\" placeholder=\"Search\" ng-change=\"searchXeroContactChange(xeroContactSearchValue)\" ng-model-options='{debounce:100}'>\n                                </div>\n                            </div>\n                            <div class=\"noListMessage\" ng-show=\"xeroContactSearchList.length <= 0\">\n                                There are no contacts matching your search criteria.\n                            </div>\n\n                            <md-table-container>\n                                <table md-table md-row-select multiple=\"true\" ng-model=\"selectedContacts\" ng-style=\"getTableStyle()\">\n                                    <thead md-head>\n                                    <tr md-row>\n                                        <th md-column><span>Name</span></th>\n                                        <th md-column><span>Address</span></th>\n                                        <th md-column><span>Email</span></th>\n                                    </tr>\n                                    </thead>\n                                    <tbody md-body>\n                                        <tr md-row md-select=\"contact\" md-select-id=\"id\" ng-repeat=\"contact in xeroContactSearchList\" ng-disabled=\"xeroSyncLoading\">\n                                            <td md-cell>\n                                                <span>{{contact.name}}</span>\n                                            </td>\n                                            <td md-cell>\n                                                <span ng-if=\"contact.addresses && contact.addresses.length > 1\">\n                                                    {{stringifyAddress(contact.addresses[0])}}\n                                                    <!--<md-menu>\n                                                        <md-button style=\"margin: 0px; padding: 0px; max-width: 300px; width: 300px; height: 41px; text-align: left;\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n                                                            <span style=\"overflow: hidden; text-overflow: ellipsis; max-width: 270px; display: inline-block; text-transform: none;\">{{stringifyAddress(contact.selectedAddress)}}</span>\n                                                            <md-icon md-svg-src=\"arrow_down.svg\" style=\"margin-bottom: 30px;;\"></md-icon>\n                                                        </md-button>\n                                                        <md-menu-content width=\"4\">\n                                                            <md-menu-item ng-repeat=\"address in contact.addresses\" aria-label=\"address\" ng-click=\"selectAddress(contact, address)\">\n                                                                <md-button>\n                                                                    {{stringifyAddress(address)}}\n                                                                </md-button>\n                                                            </md-menu-item>\n                                                        </md-menu-content>\n                                                    </md-menu>-->\n                                                </span>\n                                                <span style=\"max-width: 300px;\" ng-if=\"contact.addresses && contact.addresses.length == 1\">\n                                                    {{stringifyAddress(contact.addresses[0])}}\n                                                </span>\n                                                <span ng-if=\"!contact.addresses || contact.addresses.length <= 0\">\n\n                                                </span>\n                                            </td>\n                                            <td md-cell>\n                                                <span ng-if=\"contact.emailAddresses.length == 0\">\n\n                                                </span>\n                                                <span ng-if=\"contact.emailAddresses.length > 0\">\n                                                    {{contact.emailAddresses.join(',')}}\n                                                </span>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </md-table-container>\n                        </div>\n                    </div>\n                </md-tab>\n\n                <md-tab label=\"From File\">\n                    <form name=\"importContactsForm\" novalidate>\n                        <div class=\"content\">\n                            Excel files only (.xls or .xlsx)\n                            <br/>\n                            <br/>\n                            <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n                        </div>\n                    </form>\n                </md-tab>\n            </md-tabs>\n        </div>\n        <div ng-if=\"selectedTabIndex == 0\" class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                    <div class=\"dbButton\" ng-click=\"xeroSyncLoading == false && xeroContactSync()\" ng-disabled=\"xeroSyncLoading\">\n                        Sync Xero Contacts\n                    </div>\n                </div>\n                <div class=\"right\">\n                    <div class=\"dbButton white margin-right\" ng-click=\"close()\">\n                        Cancel\n                    </div>\n                    <div class=\"dbButton\" ng-click=\"selectedContacts.length > 0 && !importing && import()\" ng-disabled=\"importing || selectedContacts.length == 0\">\n                        <md-progress-circular class=\"margin-right\" ng-show=\"importing\" class=\"md-hue-2\" md-diameter=\"16px\"></md-progress-circular>\n                        Import\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"selectedTabIndex == 1\" class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                </div>\n                <div class=\"right\">\n                    <div class=\"dbButton white margin-right\" ng-click=\"cancelImport()\">\n                        Cancel\n                    </div>\n                    <div class=\"dbButton spinner\" ng-click=\"(importContactsForm.$invalid || contactImport.loading) || importFromFile(file)\" ng-disabled=\"importContactsForm.$invalid || contactImport.loading\">\n                        <span ng-hide=\"contactImport.loading\">Next</span>\n                    </div>\n                    <md-progress-circular ng-show=\"contactImport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "+RIn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('docketbook').controller('editUserModal', ['addressBookService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', 'userService', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, userService) {

  $scope.member = {};
  $scope.groupsMemberships = [];
  $scope.removedMemberships = [];
  $scope.groupDict = {};
  $scope.allRoles = [];
  $scope.roleDict = {};
  $scope.monitorGroups = [];
  $scope.adminGroups = [];
  $scope.saving = false;
  $scope.superUser = false;
  $scope.originalMemberships = [];
  $scope.rootGroup = {};
  $scope.originalMemberships = [];
  $scope.originalAdminGroups = [];

  $scope.$parent.showEditUserModal = function (member) {
    $scope.saving = false;
    $scope.member = member;
    $scope.groupsMemberships = [];
    $scope.removedMemberships = [];
    $scope.monitorGroups = [];
    $scope.rootGroup = $scope.currentOrg.groups.filter(function (x) {
      return x.parent == null;
    })[0];

    $scope.superUser = $scope.member.isGlobalAdmin;

    $scope.allRoles = [];
    $scope.roleDict = {};

    $scope.groupDict = {};

    $scope.currentOrg.groups.forEach(function (group) {
      $scope.groupDict[group.id] = group;

      if (group.monitors /*.map(m => m.id)*/.includes($scope.member.id)) {
        $scope.monitorGroups.push(group.id);
      }
      if (group.owners /*.map(o => o.id)*/.includes($scope.member.id)) {
        $scope.adminGroups.push(group.id);
      }

      var roles = group.members.filter(function (m) {
        return m.user == $scope.member.id;
      }).map(function (m) {
        return m.role;
      });

      if (roles.length > 0) {
        $scope.groupsMemberships.push({
          groups: [group.id],
          roles: roles
        });
      }
    });

    $scope.groupsMemberships = _.sortBy($scope.groupsMemberships, function (membership) {
      return $scope.groupDict[membership.groups[0]].parents.length == 0 ? -99 : $scope.groupDict[membership.groups[0]].name;
    });
    $scope.originalMemberships = $scope.groupsMemberships.slice();
    $scope.originalMonitorGroups = $scope.monitorGroups.slice();
    $scope.originalAdminGroups = $scope.adminGroups.slice();

    $scope.groupsMemberships.forEach(function (membership) {
      membership.original = Object.assign({}, membership);
    });

    userService.getRoles(null, function (roles) {
      $scope.allRoles = roles;
      roles.forEach(function (role) {
        return $scope.roleDict[role.id] = role;
      });
    }, function (err) {
      $scope.allRoles = [];
    });

    $("#editUserModal").fadeIn(100);
  };

  $scope.roleSelect = function (membership, role) {
    if (membership.original != null && membership.groups[0] == $scope.rootGroup.id && membership.roles.length == 1 && membership.roles[0] == role.id) {
      swal({
        title: "Cannot remove all roles from Main Group",
        text: "Main Group must have at least one role remaining.",
        type: "warning",
        confirmButtonText: "Ok"
      });
    }
  };

  $scope.getGroupsText = function (membership) {
    if (membership.groups && membership.groups.length > 0) {
      return membership.groups.map(function (group) {
        if ($scope.groupDict[group] == null) {
          return 'Unknown';
        } else if ($scope.groupDict[group].parents.length == 0) {
          return 'Main Group';
        } else {
          return $scope.groupDict[group].name;
        }
      }).join(',<br></br>');
    } else {
      return 'Select Groups';
    }
  };

  $scope.getRolesText = function (membership) {
    if (membership.roles && membership.roles.length > 0) {
      return membership.roles.map(function (role) {
        return $scope.roleDict[role] ? $scope.roleDict[role].name : 'Unknown';
      }).join(',<br></br>');
    } else {
      return 'Select Roles';
    }
  };

  $scope.monitorsAny = function (membership) {
    if (membership.groups == null) {
      return false;
    }
    return membership.groups.map(function (group) {
      return $scope.monitorGroups.includes(group);
    }).includes(true);
  };

  $scope.monitorsAll = function (membership) {
    if (membership.groups == null || membership.groups.length == 0) {
      return false;
    }
    return !membership.groups.map(function (group) {
      return $scope.monitorGroups.includes(group);
    }).includes(false);
  };

  $scope.toggleMonitor = function (membership) {
    var remove = $scope.monitorsAll(membership);

    membership.groups.forEach(function (group) {
      if (remove) {
        $scope.monitorGroups = _.without($scope.monitorGroups, group);
      } else {
        if (!$scope.monitorGroups.includes(group)) {
          $scope.monitorGroups.push(group);
        }
      }
    });
  };

  $scope.adminsAny = function (membership) {
    if (membership.groups == null) {
      return false;
    }
    return membership.groups.map(function (group) {
      return $scope.adminGroups.includes(group);
    }).includes(true);
  };

  $scope.adminsAll = function (membership) {
    if (membership.groups == null || membership.groups.length == 0) {
      return false;
    }
    return !membership.groups.map(function (group) {
      return $scope.adminGroups.includes(group);
    }).includes(false);
  };

  $scope.toggleAdmin = function (membership) {
    var remove = $scope.adminsAll(membership);

    membership.groups.forEach(function (group) {
      if (remove) {
        $scope.adminGroups = _.without($scope.adminGroups, group);
      } else {
        if (!$scope.adminGroups.includes(group)) {
          $scope.adminGroups.push(group);
        }
      }
    });
  };

  $scope.cancel = function () {
    $("#editUserModal").fadeOut(100);
  };

  var finished = function finished() {
    $scope.saving = false;
    userService.getOrganisation($scope.currentOrg.id, function (gotGroup) {
      return $scope.currentOrg = gotGroup;
    });
    $scope.$parent.getMembers().then(function () {
      $scope.$parent.loadAllUsers();
    });

    //$("#editUserModal").fadeOut(100)
    window.location.reload();
  };

  $scope.removeUser = function () {
    swal({
      title: "Remove User",
      text: 'Are you sure you wish to remove ' + $scope.member.name.full + ' entirely from the company?',
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        var groupsToRemove = _.sortBy($scope.originalMemberships.map(function (m) {
          return m.groups[0];
        }), function (group) {
          return $scope.groupDict[group].parent == null ? 0 : 1;
        });
        var removedAdmins = $scope.originalAdminGroups.slice();
        var removedMonitors = $scope.originalMonitorGroups.slice();
        var failures = [];

        var removeSuperuser = function removeSuperuser() {
          if ($scope.superUser) {
            var globalAdministrators = $scope.currentOrg.globalAdministrators.slice();
            globalAdministrators = _.without(globalAdministrators, $scope.member.id);
            userService.updateOrganisation($scope.currentOrg.id, { globalAdministrators: globalAdministrators }, finished, function (err) {
              failures.push(err);
              finished();
            });
          } else {
            finished();
          }
        };

        var removeOneGroup = function removeOneGroup() {
          if (groupsToRemove.length == 0) {
            removeSuperuser();
            return;
          }
          var toRemove = groupsToRemove.pop();
          userService.removeMemberFromGroup(toRemove, $scope.member.id, removeOneGroup, function (err) {
            $scope.alertService.presentAutoAlert('removeGroupMember', err);
            removeOneGroup();
          });
        };

        var removeOneAdmin = function removeOneAdmin() {
          if (removedAdmins.length <= 0) {
            removeOneGroup();
            return;
          }

          var toRemove = removedAdmins.pop();
          userService.removeOwnerFromGroup(toRemove, $scope.member.id, removeOneAdmin, function (err) {
            failures.push(err);
            removeOneAdmin();
          });
        };

        var removeOneMonitor = function removeOneMonitor() {
          if (removedMonitors.length <= 0) {
            removeOneAdmin();
            return;
          }

          var toRemove = removedMonitors.pop();
          userService.removeMonitorFromGroup(toRemove, $scope.member.id, removeOneMonitor, function (err) {
            failures.push(err);
            removeOneMonitor();
          });
        };
        removeOneMonitor();
      }
    });
  };

  $scope.allGroupsClick = function (membership) {
    if (membership.groups == null || !membership.groups.includes('All Groups')) {
      // 'All Groups' is added after this function
      membership.groups = [].concat(_toConsumableArray($scope.currentOrg.groups.map(function (group) {
        return group.id;
      })));
    } else {
      membership.groups = ['All Groups'];
    }
  };

  $scope.saveUser = function () {
    var _ref5, _ref6, _ref7, _ref8;

    var validMemberships = $scope.groupsMemberships.map(function (membership) {
      var dupe = Object.assign({}, membership);
      if (dupe.groups == null) {
        dupe.groups = [];
      }
      if (dupe.roles == null) {
        dupe.roles = [];
      }
      dupe.groups = _.without(dupe.groups, 'All Groups');

      return dupe;
    });

    var edits = validMemberships.filter(function (g) {
      return g.original != null;
    });
    var newMemberships = validMemberships.filter(function (g) {
      return g.original == null;
    });
    var removedMemberships = $scope.removedMemberships.slice();

    edits.forEach(function (membership) {
      var _ref, _ref2, _ref3, _ref4;

      var og = membership.original;

      var newGroups = (_ref = _).without.apply(_ref, [membership.groups].concat(_toConsumableArray(og.groups)));
      var removedGroups = (_ref2 = _).without.apply(_ref2, [og.groups].concat(_toConsumableArray(membership.groups)));
      var newRoles = (_ref3 = _).without.apply(_ref3, [membership.roles].concat(_toConsumableArray(og.roles)));
      var removedRoles = (_ref4 = _).without.apply(_ref4, [og.roles].concat(_toConsumableArray(membership.roles)));

      if (newGroups.length > 0) {
        newMemberships.push({ groups: newGroups, roles: membership.roles });
      }
      if (newRoles.length > 0) {
        newMemberships.push({ groups: membership.groups, roles: newRoles });
      }
      if (removedGroups.length > 0) {
        removedMemberships.push({ groups: removedGroups, roles: og.roles });
      }
      if (removedRoles.length > 0) {
        removedMemberships.push({ groups: og.groups, roles: removedRoles });
      }
    });

    var individualAdds = _.uniq(_.flatten(_.flatten(newMemberships.map(function (membership) {
      return membership.groups.map(function (group) {
        return membership.roles.map(function (role) {
          return { group: group, role: role };
        });
      });
    }))));

    var individualDeletes = _.uniq(_.flatten(_.flatten(removedMemberships.map(function (membership) {
      return membership.groups.map(function (group) {
        return membership.roles.map(function (role) {
          return { group: group, role: role };
        });
      });
    }))));

    // ignore where roles have been both added and removed
    var overlaps = individualAdds.filter(function (x) {
      return _.findIndex(individualDeletes, x) != -1;
    });
    individualAdds = individualAdds.filter(function (x) {
      return _.findIndex(overlaps, x) == -1;
    });
    individualDeletes = individualDeletes.filter(function (x) {
      return _.findIndex(overlaps, x) == -1;
    });

    var groupsWithRoles = _.uniq(_.flatten($scope.groupsMemberships.filter(function (x) {
      return x.roles != null && x.roles.length > 0;
    }).map(function (x) {
      return x.groups;
    })));
    var monitorGroupsWithRoles = $scope.monitorGroups.filter(function (group) {
      return groupsWithRoles.includes(group);
    });

    // Monitor edits
    var addedMonitors = (_ref5 = _).without.apply(_ref5, [monitorGroupsWithRoles].concat(_toConsumableArray($scope.originalMonitorGroups), ['All Groups']));
    var removedMonitors = (_ref6 = _).without.apply(_ref6, [$scope.originalMonitorGroups].concat(_toConsumableArray(monitorGroupsWithRoles), ['All Groups']));

    // Admin edits
    var addedAdmins = (_ref7 = _).without.apply(_ref7, [$scope.adminGroups].concat(_toConsumableArray($scope.originalAdminGroups)));
    var removedAdmins = (_ref8 = _).without.apply(_ref8, [$scope.originalAdminGroups].concat(_toConsumableArray($scope.adminGroups)));

    $scope.saving = true;

    var addSuperUser = $q(function (pass, fail) {
      if ($scope.member.isGlobalAdmin != $scope.superUser) {
        var globalAdministrators = $scope.currentOrg.globalAdministrators.slice();

        if ($scope.superUser) {
          globalAdministrators.push($scope.member.id);
        } else {
          globalAdministrators = _.without(globalAdministrators, $scope.member.id);
        }

        userService.updateOrganisation($scope.currentOrg.id, { globalAdministrators: globalAdministrators }, pass, fail);
      } else {
        pass();
      }
    });

    addSuperUser.then(function () {
      var failures = [];

      var removeOneAdmin = function removeOneAdmin() {
        if (removedAdmins.length <= 0) {
          addOneMembership();
          return;
        }

        var toRemove = removedAdmins.pop();
        userService.removeOwnerFromGroup(toRemove, $scope.member.id, removeOneAdmin, function (err) {
          failures.push(err);
          removeOneAdmin();
        });
      };

      var addOneAdmin = function addOneAdmin() {
        if (addedAdmins.length <= 0) {
          removeOneAdmin();
          return;
        }

        var toAdd = addedAdmins.pop();
        var person = [{ user: $scope.member.id, roles: ['owner'] }];
        userService.assignMembersToGroup(toAdd, person, addOneAdmin, function (err) {
          failures.push(err);
          addOneAdmin();
        });
      };

      var removeOneMonitor = function removeOneMonitor() {
        if (removedMonitors.length <= 0) {
          addOneAdmin();
          return;
        }

        var toRemove = removedMonitors.pop();
        userService.removeMonitorFromGroup(toRemove, $scope.member.id, removeOneMonitor, function (err) {
          failures.push(err);
          removeOneMonitor();
        });
      };

      var addOneMonitor = function addOneMonitor() {
        if (addedMonitors.length <= 0) {
          removeOneMonitor();
          return;
        }

        var toAdd = addedMonitors.pop();
        var person = [{ user: $scope.member.id, roles: ['monitor'] }];

        userService.assignMembersToGroup(toAdd, person, addOneMonitor, function (err) {
          failures.push(err);
          addOneMonitor();
        });
      };

      var removeOneMembership = function removeOneMembership() {
        if (individualDeletes.length <= 0) {
          finished();
          return;
        }

        var toRemove = individualDeletes.pop();
        userService.removeMemberRoleFromGroup(toRemove.group, $scope.member.id, toRemove.role, removeOneMembership, function (err) {
          failures.push(err);
          removeOneMembership();
        });
      };

      var addOneMembership = function addOneMembership() {
        if (individualAdds.length <= 0) {
          return removeOneMembership();
        }

        var toAdd = individualAdds.pop();
        var memberAdd = { user: $scope.member.id, role: toAdd.role };
        userService.addMemberToGroup(toAdd.group, memberAdd, addOneMembership, function (err) {
          failures.push(err);
          addOneMembership();
        });
      };
      addOneMonitor();
    });
  };

  $scope.toggleSuperUser = function () {
    $scope.superUser = !$scope.superUser;
  };

  $scope.removeMembership = function (membership) {
    $scope.groupsMemberships = _.without($scope.groupsMemberships, membership);
    // only add removals if it's not a new row
    if (!membership.edit || membership.original) {
      $scope.removedMemberships.push(membership);
    }

    // Remove the monitor flag for any group in the membership that was a monitor and is no longer listed in the modal
    membership.groups.filter(function (group) {
      return $scope.monitorGroups.includes(group);
    }).forEach(function (removedGroup) {
      var otherGroups = _.flatten($scope.groupsMemberships.map(function (membership) {
        return membership.groups;
      }));
      if (!otherGroups.includes(removedGroup)) {
        $scope.monitorGroups = _.without($scope.monitorGroups, removedGroup);
      }
    });

    membership.groups.filter(function (group) {
      return $scope.adminGroups.includes(group);
    }).forEach(function (removedGroup) {
      var otherGroups = _.flatten($scope.groupsMemberships.map(function (membership) {
        return membership.groups;
      }));
      if (!otherGroups.includes(removedGroup)) {
        $scope.adminGroups = _.without($scope.adminGroups, removedGroup);
      }
    });
  };

  $scope.addMembership = function () {
    $scope.groupsMemberships.push({ groups: [], role: {}, new: true });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "+XAm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

angular.module('docketbook').controller('contactsController', ['addressBookService', 'xeroService', 'splitListInterface', '$scope', '$window', 'Restangular', '$state', '$stateParams', 'accessControl', 'uuid', '$q', function (addressBookService, xeroService, splitListInterface, $scope, $window, Restangular, $state, $stateParams, accessControl, uuid, $q) {
  mixpanel.track("Opened Contacts Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentState = $state.current;
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);
  $scope.contactEdit = null;
  $scope.addressBook = [];
  $scope.selected = [];
  $scope.listCount = 50;
  $scope.extra = {};
  $scope.xeroContacts = [];
  $scope.filters = {
    search: "",
    tags: []
  };
  $scope.contactTagsSelected = [];
  $scope.contactEditTags = {
    add: [],
    delete: []
  };
  $scope.bulkTagAssignment = false;

  xeroService.getXeroContacts(function (contacts) {
    $scope.xeroContacts = contacts;
  }, function (err) {
    console.error('could not get xero contacts', err);
  });

  // New list query pagination
  $scope.query = {
    limit: 30,
    page: 1,
    order: 'displayName'
  };
  $scope.promise = null;

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /*****************************/
  /***** Contact Functions *****/
  /*****************************/

  $scope.clearFilters = function () {
    $scope.filters = {
      search: "",
      tags: []
    };
  };

  $scope.closeContactTagSelectList = function () {
    $("#selectContactTagModal").fadeOut(100);
  };

  $scope.handleBulkTagAssignment = function () {
    var tagList = $scope.contactTagsSelected.map(function (tagObj) {
      return tagObj.tag;
    });
    var promises = $scope.selected.map(function (contact) {
      return $q(function (resolve, reject) {
        var updatePayload = {
          id: contact.id,
          tags: {
            add: tagList.filter(function (tag) {
              return contact.tags.indexOf(tag) === -1;
            })
          }
        };
        addressBookService.saveContact(updatePayload, function (contactUpdated) {
          resolve();
        }, function (err) {
          reject(err);
        });
      });
    });
    $q.all(promises).then(function () {
      $scope.bulkTagAssignment = false;
      $scope.loadTagList();
      $scope.closeContactTagSelectList();
    }).catch(function (err) {
      $scope.bulkTagAssignment = false;
      $scope.loadTagList();
      $scope.closeContactTagSelectList();
    });
  };

  $scope.closeContactTagSelectListDone = function () {
    if ($scope.bulkTagAssignment) {
      $scope.handleBulkTagAssignment();
      return;
    }
    if (!$scope.contactEdit.tags) {
      $scope.contactEdit.tags = [];
    }
    $scope.contactTagsSelected.forEach(function (tagObj) {
      var tag = tagObj.tag;
      if ($scope.contactEdit.tags.indexOf(tag) === -1) {
        $scope.contactEdit.tags.push(tag);
        $scope.contactEditTags.add.push(tag);
        if ($scope.contactEditTags.delete.indexOf(tag) !== -1) {
          $scope.contactEditTags.delete = $scope.contactEditTags.delete.filter(function (tag) {
            return tag !== tag;
          });
        }
      }
    });
    $scope.closeContactTagSelectList();
  };

  $scope.removeTagFromContact = function (tag, contact) {
    contact.tags = contact.tags.filter(function (tag) {
      return tag !== tag;
    });
    $scope.contactEditTags.delete.push(tag);
    if ($scope.contactEditTags.add.indexOf(tag) !== -1) {
      $scope.contactEditTags.add = $scope.contactEditTags.add.filter(function (tag) {
        return tag !== tag;
      });
    }
  };

  $scope.addNewTags = function () {
    $scope.contactTagsSelected = [];

    $("#selectContactTagModal").fadeIn(100);
  };

  $scope.loadTagList = function () {
    $scope.loadPromise = $q(function (resolve, reject) {
      addressBookService.getAddressBookTags({}, function (results) {
        $scope.contactTagList = results;
        resolve($scope.allTags);
      }, function (err) {
        $scope.contactTagList = [];
        reject('Error');
      });
    });
  };

  $scope.startBulkTagAssignment = function () {
    $scope.bulkTagAssignment = true;
    $scope.addNewTags();
  };

  $scope.loadTagList();

  $scope.loadAddressBook = function () {
    $scope.promise = $q(function (resolve, reject) {
      var params = {};
      if ($scope.filters.search != null && $scope.filters.search != "") {
        params.search = $scope.filters.search;
      }
      if ($scope.filters.tags && $scope.filters.tags.length > 0) {
        params.tags = $scope.filters.tags.map(function (tag) {
          return tag.tag;
        }).join(',');
      }
      params['limit'] = $scope.query.limit;
      params['offset'] = $scope.query.limit * ($scope.query.page - 1);
      params['sort'] = $scope.query.order;
      addressBookService.getAddressBook(params, function (addressBookList) {
        var count = 0;
        if (params.offset <= 0 && addressBookList.length < params.limit) {
          count = addressBookList.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        $scope.listCount = count;
        $scope.addressBook = addressBookList;
        $scope.addressBook.forEach(function (contactItem) {
          var existingXeroContact = null;
          if (contactItem.externalIdentifiers) {
            contactItem.externalIdentifiers.forEach(function (eid) {
              if (eid.type === 'xero') {
                existingXeroContact = eid;
              }
            });
          }
          if (existingXeroContact) {
            contactItem.xeroContact = existingXeroContact;
          }
        });
        addressBookService.getContactShares(null, function (contactSharesList) {
          $scope.addressBookShares = contactSharesList;
          resolve('Done');
        }, function (err) {
          resolve('Done');
        });
      }, function (err) {
        reject('Error');
      });
    });
  };

  $scope.loadAddressBook();

  $scope.newContact = function () {
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.contactEdit = { editing: true, displayName: '', addresses: [], contactAddresses: [{ emailAddress: '', accessLevel: 'viewer' }], initials: "NC", tags: [] };
    $scope.contactEditTags = {
      add: [],
      delete: []
    };
  };

  $scope.openContact = function (contact) {
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.contactEdit = angular.copy(contact);
    $scope.contactEditTags = {
      add: [],
      delete: []
      // get address to edit
    };if ($scope.contactEdit.addresses != null && $scope.contactEdit.addresses[0] != null) {
      $scope.contactEdit.address = $scope.contactEdit.addresses[0];
    } else {
      $scope.contactEdit.address = {};
    }

    // get shares sent
    if ($scope.contactEdit.contactAddresses && $scope.contactEdit.contactAddresses.length > 0) {
      var recipientsEmails = [];
      for (var i = 0; i < $scope.contactEdit.contactAddresses.length; i++) {
        recipientsEmails.push($scope.contactEdit.contactAddresses[i].emailAddress);
      }
      recipientsEmails.join(',');
      addressBookService.getContactShares({ direction: 'sent', recipients: recipientsEmails }, function (contactSharesSent) {
        if (contactSharesSent && contactSharesSent.length > 0) {
          $scope.contactEdit.shareSent = true;
        } else {
          $scope.contactEdit.shareSent = false;
        }
      }, function (err) {
        $scope.contactEdit.shareSent = false;
      });
    }

    var existingXeroIdentifier = $scope.contactEdit.externalIdentifiers.find(function (eid) {
      return eid.type === 'xero';
    });
    if (existingXeroIdentifier) {
      $scope.contactEdit.xeroID = existingXeroIdentifier.externalId;
    }
    if ($scope.contactEdit.xeroID != null) {
      // find full xero contact from list
      $scope.contactEdit.xeroContact = $scope.xeroContacts.find(function (contact) {
        return contact.externalId == $scope.contactEdit.xeroID;
      });
    }
  };

  $scope.openContactShare = function (contactShare) {
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.contactEdit = angular.copy(contactShare);
    $scope.contactEdit.fromShare = contactShare;
    delete $scope.contactEdit.id;

    // get address to edit
    if ($scope.contactEdit.addresses != null && $scope.contactEdit.addresses[0] != null) {
      $scope.contactEdit.address = $scope.contactEdit.addresses[0];
    } else {
      $scope.contactEdit.address = {};
    }
    $scope.contactEdit.editing = true;
    var contactAddressesFull = [];
    for (var i = 0; i < $scope.contactEdit.contactAddresses.length; i++) {
      var newContact = { emailAddress: $scope.contactEdit.contactAddresses[i], accessLevel: 'viewer' };
      contactAddressesFull.push(newContact);
    }
    $scope.contactEdit.contactAddresses = contactAddressesFull;
  };

  $scope.closeContact = function () {
    $scope.contactEdit = null;
    $scope.splitListFunc.slideTableListDetailClosed();
  };

  $scope.editContact = function (contact) {
    contact.editing = true;
  };

  $scope.addNewContactEmail = function (contact) {
    if (contact.contactAddresses == null) {
      contact.contactAddresses = [];
    }

    contact.contactAddresses.push({ emailAddress: "", accessLevel: "viewer" });
  };

  $scope.removeEmailFromContact = function (email, contact) {
    var index = contact.contactAddresses.indexOf(email);
    if (index != -1) {
      contact.contactAddresses.splice(index, 1);
    }
  };

  var validateContact = function validateContact(contact) {
    var validationErrors = [];
    // check displayName is provided
    if (!contact.displayName || contact.displayName == '') {
      validationErrors.push('Display Name is required');
    }
    // check email addresses are not blank
    if (contact.contactAddresses && contact.contactAddresses.length > 0) {
      for (var i = contact.contactAddresses.length - 1; i >= 0; i--) {
        if (contact.contactAddresses[i]) {
          if (contact.contactAddresses[i].emailAddress == '') {
            // remove this contactAddress
            contact.contactAddresses.splice(i, 1);
          } else {
            // check if is an emailAddress or a mobile number
            var thisEmail = contact.contactAddresses[i].emailAddress;
            var isEmail = false;
            var isMobile = false;
            var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
            if (thisEmail.indexOf('@') != -1 && thisEmail.indexOf('.') != -1) {
              isEmail = true;
            }
            if (thisEmail.length == 10) {
              var foundNotANumber = false;
              for (var j = 0; j < thisEmail.length; j++) {
                if (numbers.indexOf(thisEmail[j]) == -1) {
                  foundNotANumber = true;
                  break;
                }
              }
              if (!foundNotANumber) {
                isMobile = true;
              }
            }
            if (!isEmail && !isMobile) {
              validationErrors.push(thisEmail + ' is not an Email Address or Mobile Number');
            }
          }
        }
      }
    }

    //  check address has all required fields
    var otherFields = ['num', 'streetNum'];
    var requiredFields = ['streetName', 'suburb', 'state', 'postCode', 'country'];
    var niceDisplay = { 'streetName': 'Street Name', 'suburb': 'Suburb', 'state': 'State', 'country': 'Country', 'postCode': 'Post Code' };
    var addressPartComplete = false;
    var requiredFieldMissing = false;
    var fieldsMissing = [];
    if (contact.address) {
      for (var i = 0; i < otherFields.length; i++) {
        if (contact.address[otherFields[i]] != null && contact.address[otherFields[i]] != '') {
          addressPartComplete = true;
          break;
        }
      }
      for (var i = 0; i < requiredFields.length; i++) {
        if (contact.address[requiredFields[i]] == null || contact.address[requiredFields[i]] == '') {
          requiredFieldMissing = true;
          fieldsMissing.push(niceDisplay[requiredFields[i]]);
        } else {
          addressPartComplete = true;
        }
      }
    }

    if (addressPartComplete && requiredFieldMissing) {
      validationErrors.push('Address is missing some required fields - ' + fieldsMissing.join(', '));
    }

    if (validationErrors.length > 0) {
      $scope.alertService.presentAlert('warning', 'Invalid Fields', validationErrors.join('\n'));
      return false;
    } else {
      return true;
    }
  };

  $scope.saveContact = function (con) {
    if (!validateContact(con)) {
      return false;
    }
    var contact = Object.assign({}, con);
    contact.loading = true;
    // re-format addresses array
    // identify if address is empty or not
    var contactAddressKeys = [];
    if (contact.address) {
      contactAddressKeys = Object.keys(contact.address);
    }
    if (contact.id != null) {
      if ((contact.addresses == null || contact.addresses.length <= 0) && contact.address && contactAddressKeys.length > 0) {
        contact.addresses = { 'add': [] };
        contact.addresses.add.push(contact.address);
      } else if (contact.address && contactAddressKeys.length > 0) {
        contact.addresses = { 'update': [] };
        contact.addresses.update.push(contact.address);
      } else {
        delete contact.addresses;
      }
      contact.tags = $scope.contactEditTags;
    } else {
      if (contact.address) {
        contact.addresses = [];
        contact.addresses.push(contact.address);
      }
    }
    if (contact.xeroID && contact.id != null) {
      var existingXeroIdentifier = null;
      if (contact.externalIdentifiers) {
        existingXeroIdentifier = contact.externalIdentifiers.find(function (eid) {
          return eid.type === 'xero';
        });
      }
      if (!contact.externalIdentifiers || existingXeroIdentifier === undefined || existingXeroIdentifier === null || existingXeroIdentifier.externalId !== contact.xeroID) {
        contact.externalIdentifiers = {
          add: [{
            type: 'xero',
            externalId: contact.xeroID
          }]
        };
        if (existingXeroIdentifier !== undefined) {
          contact.externalIdentifiers.remove = [existingXeroIdentifier];
        }
      }
    } else if (contact.xeroID && contact.id == null) {
      contact.externalIdentifiers = [];
      contact.externalIdentifiers.push({
        type: 'xero',
        externalId: contact.xeroID
      });
    }

    addressBookService.saveContact(contact, function (contactUpdated) {
      // if contact is being created from a share - delete the share first
      if (contact.fromShare != null) {
        addressBookService.deleteContactShare(contact.fromShare, function (success) {
          $scope.loadAddressBook();
          $scope.openContact(contactUpdated);
        }, function () {
          $scope.loadAddressBook();
          $scope.contactEdit = null;
        });
      } else {
        $scope.loadAddressBook();
        $scope.openContact(contactUpdated);
      }
    }, function (err) {
      contact.loading = false;
      $scope.alertService.presentAutoAlert('saveContact', err);
    });
  };

  // Remove a contact
  $scope.removeContact = function (contact) {
    addressBookService.deleteContact(contact, function (success) {
      $scope.loadAddressBook(true);
      $scope.closeContact();
    }, function (err) {
      $scope.alertService.presentAutoAlert('deleteContact', err);
    });
  };

  // Remove selected contacts
  $scope.deleteSelectedContacts = function () {
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete these contacts?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        addressBookService.deleteBulkContacts($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            swal("Oops", failures.length + " of " + $scope.selected.length + " contacts could not be deleted.", "warning");
            $scope.loadAddressBook(true);
          } else {
            $scope.loadAddressBook(true);
            $scope.selected = [];
          }
        });
      }
    });
  };

  /**************************/
  /***** Contact Shares *****/
  /**************************/

  $scope.newContactShare = function (shareWith) {
    $scope.shareEdit = {};
    $scope.shareEdit.displayName = $scope.currentOrgGroup.publicName;
    $scope.shareEdit.contactAddresses = $scope.currentOrgGroup.emailAddresses;
    var newContactAddresses = [];
    for (var i = 0; i < $scope.shareEdit.contactAddresses.length; i++) {
      var newContact = { id: uuid.v4(), emailAddress: $scope.shareEdit.contactAddresses[i] };
      newContactAddresses.push(newContact);
    }
    $scope.shareEdit.contactAddresses = newContactAddresses;
    var groupAddress = $scope.currentOrgGroup.address;
    if (groupAddress) {
      $scope.shareEdit.address = groupAddress;
    }
    if (shareWith) {
      $scope.shareEdit.shareWith = shareWith;
      if (shareWith.contactAddresses.length == 1) {
        $scope.shareEdit.recipient = shareWith.contactAddresses[0].emailAddress;
      }
    }
    // setup comment
    var comment = "Hi there,\n\nI would like to connect with you on docketbook.\nMy latest contact details are here!\n\nCheers, " + $scope.currentUser.name.first;
    $scope.shareEdit.comment = comment;
    $("#shareContactModal").fadeIn(100);
  };

  $scope.closeNewShareModal = function () {
    $("#shareContactModal").fadeOut(100);
  };

  $scope.saveShare = function (share) {
    share.loading = true;
    share.addresses = [];
    share.addresses.push(share.address);

    var newContactAddresses = [];
    for (var i = 0; i < share.contactAddresses.length; i++) {
      if (share.contactAddresses[i].emailAddress != null && share.contactAddresses[i].emailAddress != "") {
        newContactAddresses.push(share.contactAddresses[i].emailAddress);
      }
    }
    share.contactAddresses = newContactAddresses;

    if (share.shareWith && share.shareWith.contactAddresses && share.shareWith.contactAddresses.length > 1) {
      // get list of addresses to send contact share to
      var emails = [];
      for (var i = 0; i < share.shareWith.contactAddresses.length; i++) {
        if (share.shareWith.contactAddresses[i].selected) {
          emails.push(share.shareWith.contactAddresses[i].emailAddress.toLowerCase());
        }
      }
      addressBookService.saveBulkContactShares(emails, share, function (failures) {
        $scope.loadAddressBook();
        $scope.shareEdit = null;
        $("#shareContactModal").fadeOut(100);

        if (failures && failures.length > 0) {
          swal("Oops.", failures.length + " of " + emails.length + " shares could not be sent.", "warning");
        }
      });
    } else {
      share.recipient = share.recipient.toLowerCase();
      addressBookService.saveContactShare(share, function (success) {
        $scope.loadAddressBook();
        if (share.shareWith) {
          $scope.contactEdit.shareSent = true;
        }
        $scope.shareEdit = null;
        $("#shareContactModal").fadeOut(100);
      }, function (err) {
        $scope.shareEdit.loading = false;
        $scope.alertService.presentAutoAlert('contactShare', err);
      });
    }
  };

  $scope.addNewShareEmail = function (share) {
    if (share.contactAddresses == null) {
      share.contactAddresses = [];
    }

    var newBlankContact = { id: uuid.v4(), emailAddress: "" };
    share.contactAddresses.push(newBlankContact);
  };

  /****** Validate Contact Emails *******/
  $scope.validateContactEmails = function (contact) {
    if (contact.contactAddresses == null || contact.contactAddresses.length <= 0) {
      return false;
    }
    for (var i = 0; i < contact.contactAddresses.length; i++) {
      if (contact.contactAddresses[i].emailAddress == null || contact.contactAddresses[i].emailAddress == "") {
        return false;
      }
    }
    return true;
  };

  /******* Xero Contact Syncing *******/
  $scope.syncXeroContact = function (contactFor) {
    $scope.xeroContactSelectFromParent(function (contactSelected) {
      if (contactSelected != null) {
        if (!$scope.contactEdit.editing) {
          $scope.contactEdit.editing = true;
        }
        $scope.contactEdit.xeroID = contactSelected.externalId;
        $scope.contactEdit.xeroContact = contactSelected;
      }
    });
  };

  /**** Filters *****/
  $scope.$watch('filters', function () {
    $scope.loadAddressBook();
  }, true);

  $scope.userIsXeroAuthenticated = function () {
    if (!$scope.currentUser.xeroAuthentication) {
      return false;
    }
    if (!$scope.currentUser.xeroAuthentication.authenticatedUntil) {
      return false;
    }
    if (moment($scope.currentUser.xeroAuthentication.authenticatedUntil).isBefore(moment())) {
      return false;
    }
    return true;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("PJh5")))

/***/ }),

/***/ "+gor":
/***/ (function(module, exports, __webpack_require__) {

var path = 'views/pages/paywalled/timesheets.html';
var html = "<div style=\"width: 100%; height: 100%; background-color: white; display: table; padding-top: 40px; padding-bottom: 40px;\">\n    <div style=\"display: table-cell; vertical-align: middle;\">\n        <div class=\"\" style=\"display: flex; margin: auto\">\n            <div style=\"flex: 1 1 auto; min-width: 600px; width: calc(50% - 30px); text-align: end;\">\n                <img style=\"width: 600px\" src=\"" + __webpack_require__("fc0h") + "\"/>\n            </div>\n            <div style=\"width: 60px;\"></div>\n            <div style=\"flex: 1 1 auto; width: calc(50% - 30px);\">\n                <div class=\"lockSectionTextContainer\">\n                    <h3 class=\"darkBlueBold\">TIMESHEETS</h3>\n                    <h1 class=\"boldBlueText\">Automated timesheets make payroll a breeze</h1>\n                    <p class=\"lockJobsText\">Automatically collate times recorded on dockets to generate employee timesheets and push to your payroll system with the click of a button</p>\n                    <a class=\"dbColorText\" target=\"_blank\" href=\"https://help.docketbook.com.au/hc/en-us/articles/360052002973-Timesheets-Overview\">Learn more about Timesheets</a>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"lockSubcardsContainer\">\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Capture times where the work happens</h3>\n                <span>Timesheet data is captured on the docket. One simple form to ensure you get paid and your staff do too.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Validated in the field with digital signatures</h3>\n                <span>A simple sign off in the field can be captured with sign on glass and supported by electronic approvals.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">More than just time</h3>\n                <span>Flexible form design means you can capture rich information about the day, not just the hours worked</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Track every change</h3>\n                <span>Just like dockets, key transactions of timesheets are captured in a secure log that ensures every entry is bonafide.</span>\n            </div>\n        </div>\n\n        <div style=\"text-align: center; margin-top: 100px\">\n            <div class=\"newDbButton\" style=\"width: 250px\" ng-click=\"selectPlan(null, 'docketsTimesheetsView', 'from timesheets paywalled page - upgrade plan')\">\n                Upgrade Plan\n            </div>\n            <div ng-if=\"currentOrg.planFeatures.trialAvailable && !currentOrg.planFeatures.inTrial\" class=\"newDbButton whiteOutline\" style=\"width: 250px; margin-left: 30px;\" ng-click=\"trialButtonClick()\">\n                Start a 7 day free trial\n            </div>\n        </div>\n    </div>\n</div>\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n<ng-include src=\"'views/modals/trialActivatedModal.html'\" ng-controller=\"trialActivatedModalController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "+oWW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "account.svg";

/***/ }),

/***/ "+oZI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+qg2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+stf":
/***/ (function(module, exports) {

var path = 'views/modals/checklistDetailModal.html';
var html = "<div class=\"niceModal\" id=\"checklistDetailModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>{{checklistDetail.checklistTemplate.name}}</h1>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader fixed visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeChecklistDetailModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            {{checklistDetail.checklistTemplate.name}}\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"saveChecklistDetail()\">Save</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"itemDetailModalOuter\">\n        <div class=\"itemDetailModalHeader\">\n          <h3 ng-show=\"checklistDetail.rule=='required'\">\n            This checklist is required before submission\n          </h3>\n          <h3 ng-show=\"checklistDetail.rule=='notRequired'\">\n             This checklist is optional\n          </h3>\n          <!--<div class=\"btn btn-sm btn-rounded btn-outline white\" ng-click=\"resetChecklist(checklistDetail)\">Reset</div>-->\n        </div>\n\n        <div class=\"col-lg-12 checklistItem\" ng-repeat=\"field in checklistDetail.checklistTemplate.fields\">\n          {{field.displayName}}\n          <div class=\"checklistAnswersOuter\">\n            <div class=\"checklistAnswerItemOuter\">\n              <div class=\"checklistAnswerItem {{ checklistsData[checklistDetail.checklistTemplate.id].answers[field.id] == 'ok' ? 'selected' : '' }} ok\"\n                  ng-click=\"setChecklistItem(checklistsData[checklistDetail.checklistTemplate.id].answers, field.id, 'ok')\">\n                Ok\n              </div>\n            </div>\n            <div class=\"checklistAnswerItemOuter\">\n              <div class=\"checklistAnswerItem {{ checklistsData[checklistDetail.checklistTemplate.id].answers[field.id] == 'fail' ? 'selected' : '' }} fail\"\n                  ng-click=\"setChecklistItem(checklistsData[checklistDetail.checklistTemplate.id].answers, field.id, 'fail')\">\n                Fail\n              </div>\n            </div>\n            <div class=\"checklistAnswerItemOuter\">\n              <div class=\"checklistAnswerItem {{ checklistsData[checklistDetail.checklistTemplate.id].answers[field.id] == 'na' ? 'selected' : '' }} na\"\n                  ng-click=\"setChecklistItem(checklistsData[checklistDetail.checklistTemplate.id].answers, field.id, 'na')\">\n                NA\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "+zWA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('acceptOrderWizardModalController', ['addressBookService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', 'docketService', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {
  $scope.formComplete = false;
  $scope.allTemplates = [];
  $scope.itemEdit = {};
  $scope.ignoredLineItems = [];
  $scope.templateAccordionOpen = true;
  $scope.noTemplates = false;

  $scope.$parent.showAcceptOrderWizard = function () {
    $scope.formComplete = false;
    $scope.allTemplates = [];
    $scope.ignoredLineItems = [];
    // link local item edit to parent item edit.  All changes made will be reflected on both.
    $scope.itemEdit = $scope.$parent.itemEdit;

    $("#templateArea").css({ 'max-height': '' });

    if ($scope.itemEdit.template != null) {
      $scope.templateAccordionOpen = false;
      minimiseAccordion();
    } else {
      $scope.templateAccordionOpen = true;
    }
    $scope.loadTemplateList();
    checkFormComplete();

    $("#acceptOrderWizardModal").fadeIn(100);
  };

  var checkFormComplete = function checkFormComplete() {
    $scope.formComplete = false;
    $scope.noTemplates = false;

    if ($scope.itemEdit.template == null) {
      return;
    }

    for (var i = 0; i < $scope.itemEdit.lineItems.length; i++) {
      var lineItem = $scope.itemEdit.lineItems[i];
      if (!lineItem.resource && !$scope.ignoredLineItems.includes(lineItem.id)) {
        return;
      }
    }

    $scope.formComplete = true;
  };

  $scope.editTemplate = function () {
    $scope.templateAccordionOpen = true;
    var height = document.getElementById('templateArea').scrollHeight; //$("#templateArea").scrollHeight()
    $("#templateArea").animate({ 'max-height': height + 'px' }, 200);
    $('#templateSubHead').animate({ opacity: 1 }, 200);
  };

  $scope.close = function () {
    $scope.$parent.cancelEditOrder($scope.itemEdit);
    $("#acceptOrderWizardModal").fadeOut(100);
  };

  $scope.acceptOrder = function () {
    if (!$scope.formComplete || $scope.itemEdit.loading) {
      return;
    }
    $("#acceptOrderWizardModal").fadeOut(100);
    $scope.$parent.acceptOrder($scope.itemEdit, function () {}, function () {
      // error
      $("#acceptOrderWizardModal").fadeIn(100);
    });
  };

  var minimiseAccordion = function minimiseAccordion() {
    var height = document.getElementById('templateArea').scrollHeight;
    $("#templateArea").css({ 'max-height': height + 'px' });
    $("#templateArea").animate({ 'max-height': '85px' }, 200);
    $('#templateSubHead').animate({ opacity: 0 }, 200);
  };

  $scope.assignTemplate = function (template) {
    if (template != null) {
      if (template == $scope.itemEdit.template) {
        minimiseAccordion();
      } else {

        // get full docket template
        docketService.getTemplate(template, function (fullTemplate) {
          $scope.$parent.assignTemplate(fullTemplate, function () {
            $scope.templateAccordionOpen = false;
            checkFormComplete();
            minimiseAccordion();
          });
        }, function (err) {
          $scope.itemEdit.template = null;
          $scope.showToast('Error Loading Docket Template');
          checkFormComplete();
        });
      }
    }
  };

  $scope.selectResourceForLine = function (lineItem) {
    $scope.$parent.selectResourceForLine(lineItem, function () {
      checkFormComplete();
    });
  };

  $scope.loadTemplateList = function () {
    $scope.promise = $q(function (resolve, reject) {
      // Get templates from docketService
      docketService.getTemplates({ "published": "true" }, function (templates) {
        $scope.allTemplates = templates;

        // Display help message if there are no templates
        $scope.noTemplates = $scope.allTemplates.length == 0;

        // Auto select template if there is only 1
        if ($scope.allTemplates.length == 1) {
          $scope.assignTemplate($scope.allTemplates[0]);
        }
        resolve('Done');
      }, function (error) {
        $scope.allTemplates = [];
        reject('Error');
      });
    });
  };

  $scope.goToCreateDocketTemplates = function () {
    $state.go('companySettings.templates', { orgId: $scope.currentOrg.id });
  };

  $scope.ignoreLineItem = function (lineItem) {
    lineItem.resource = null;
    if (!$scope.ignoredLineItems.includes(lineItem.id)) {
      $scope.ignoredLineItems.push(lineItem.id);
    }
    checkFormComplete();
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "/WbT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/dB1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-60x60.png";

/***/ }),

/***/ "/uRc":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/mapTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <!-- Start Map Section -->\n  <div class=\"ojdDesktopSection noPadding noBottomPadding\" style=\"position: relative;\">\n    <div class=\"fullSizeMapOuter\">\n      <div class=\"fullSizeMap\" id=\"fullInteractionMap\">\n      </div>\n    </div>\n    <div class=\"fullSizeMapNoData\">\n      <div class=\"noDataInner\">\n        No location data available\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "/ygr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "left.svg";

/***/ }),

/***/ "01v8":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/uoms.html';
var html = "<div class=\"desktopContainer dashboard adminSettingsView\">\n  <div class=\"dashboardWelcomeHeader\">\n    <div class=\"left\">\n      <h3>Manage Units of Measure</h3>\n      <p>Units of measure that can be assigned to resources.</p>\n    </div>\n    <div class=\"right\">\n      <md-button class=\"md-icon-button\" ng-click=\"openNewUomModal()\" aria-label=\"New Unit of Measure\">\n        <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n      </md-button>\n      <md-button class=\"md-icon-button\" ng-click=\"loadUomsList()\" aria-label=\"Reload UOM List\">\n        <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n      </md-button>\n      <md-menu>\n        <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n          <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"4\">\n          <md-menu-item ng-click=\"deleteSelectedUoms()\" aria-label=\"Delete Selected UOM's\">\n            <md-button>\n              Delete Selected Uoms\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </div>\n  </div>\n\n  <div class=\"adminBasicContentContainer bare\">\n    <div class=\"adminSettingGroupContainer noPadding\" style=\"position:relative;margin-top:0px;\">\n      <div class=\"adminContentInner bare\">\n        <md-table-container>\n          <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n            <thead md-head>\n              <tr md-row>\n                <th md-column><span>Abbreviation</span></th>\n                <th md-column><span>Description</span></th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row md-select=\"uom\" md-select-id=\"id\" ng-repeat=\"uom in allUoms\" ng-click=\"editUom(uom)\">\n                <td md-cell>{{uom.abbreviation}}</td>\n                <td md-cell>{{uom.description}}</td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n        <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadUomsList\" md-total=\"{{listCount}}\" md-page-select>\n        </md-table-pagination>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- New UOM Modal -->\n<div class=\"niceModal desktopSelector\" id=\"newUomModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"uomEdit.id == null\">New Unit of Measure</h1>\n      <h1 ng-show=\"uomEdit.id != null\">Edit Unit of Measure</h1>\n    </div>\n    <form name=\"newUomForm\" novalidate>\n      <div class=\"content\">\n        <md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"uomEdit.isTime\">\n          <md-checkbox ng-model=\"uomEdit.isTime\">Is Time Based</md-checkbox>\n        </md-input-container>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"uomEdit.isTime\">\n            <label>Abbreviation</label>\n            <md-select ng-model=\"uomEdit.abbreviation\">\n              <md-option ng-repeat=\"type in timeTypes\" ng-value=\"type\">{{type}}</md-option>\n            </md-select>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"!uomEdit.isTime\">\n            <label>Abbreviation</label>\n            <input type=\"text\" ng-model=\"uomEdit.abbreviation\" required>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm>\n            <label>Description</label>\n            <textarea ng-model=\"uomEdit.description\"></textarea>\n          </md-input-container>\n        </div>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeNewUomModal()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"(newUomForm.$invalid || uomEdit.loading) || saveNewUom(uomEdit)\" ng-disabled=\"newUomForm.$invalid || uomEdit.loading\">\n              <span ng-hide=\"uomEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"uomEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- End New UOM Modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "07i1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_settings.svg";

/***/ }),

/***/ "0IaA":
/***/ (function(module, exports) {

var path = 'views/preAuthTemplate.html';
var html = "<div id=\"preAuthTemplateOuter\">\n  <div id=\"preAuthContent\" ui-view=\"content\">\n    \n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "0Rb/":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/jobsTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <div class=\"stdLoader\" ng-show=\"orderLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{orderLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"openOrderDesktop(currentOrder)\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Start Jobs Section -->\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Jobs ({{itemEdit.jobs.length >= 10 ? 'Latest 10' : itemEdit.jobs.length}})</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button class=\"md-icon-button\" ng-click=\"jobsListForOrder(itemEdit)\" aria-label=\"View all jobs for order\">\n          <md-icon md-svg-src=\"lines.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"newJobFromOrder(itemEdit)\" ng-disabled=\"!userCanDoAction('addOrderJob', itemEdit)\" aria-label=\"New Job For Order\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <p ng-if=\"itemEdit.jobs == null || itemEdit.jobs.length <= 0\">\n      There are no jobs for this order\n    </p>\n    <md-table-container ng-show=\"itemEdit.jobs != null && itemEdit.jobs.length > 0\">\n      <table md-table multiple md-progress=\"jobsPromise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Job Number</th>\n            <th md-column>Start Date</th>\n            <th md-column>End Date</th>\n            <th md-column>Assigned To</th>\n            <th md-column>Status</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"item in itemEdit.jobs\">\n            <td md-cell>\n              <a ui-sref=\"main.groupJobDetail({jobId: item.id, orderId: itemEdit.id, orderNumber: itemEdit.orderNumber, orgId: currentOrg.id, groupId: currentOrgGroup.id})\">{{ item.jobNumber }}</a>\n            </td>\n            <td md-cell>\n              {{moment(item.startDate).format('DD/MM/YYYY')}}\n            </td>\n            <td md-cell>\n              {{moment(item.endDate).format('DD/MM/YYYY')}}\n            </td>\n            <td md-cell>\n              <span ng-repeat=\"assignee in item.assignees\">{{assignee.name}} ({{assignee.status}}) </span>\n            </td>\n            <td md-cell width=\"100px\"><div class=\"statusDisplay {{item.status}}\">{{item.status}}</div></td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n  <!-- End Jobs Section -->\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "0eZp":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/timeTab.html';
var html = "<div class=\"ojdRow\">\n  <div class=\"ojdField\">\n    <h1>Start Time</h1>\n    <h2 ng-if=\"!itemEdit.editing && itemEdit.startTime\">{{moment(itemEdit.startTime).format('h:m A')}}</h2>\n    <md-input-container class=\"md-block timePickerInput\" flex-gt-sm ng-if=\"itemEdit.editing\">\n      <mdp-time-picker ng-model=\"itemEdit.startTime\" mdp-timezone=\"{{itemEdit.timezone}}\" ng-disabled=\"!itemEdit.editing\" aria-label=\"Start Time\"></mdp-time-picker>\n      <div class=\"validation-messages\" ng-messages=\"docketDetailForm.startTime.$error\">\n        <div ng-message=\"required\">This time is required.</div>\n      </div>\n    </md-input-container>\n  </div>\n  <div class=\"ojdField\">\n    <h1>End Time</h1>\n    <h2 ng-if=\"!itemEdit.editing && itemEdit.endTime\">{{moment(itemEdit.endTime).format('h:m A')}}</h2>\n    <md-input-container class=\"md-block timePickerInput\" flex-gt-sm ng-if=\"itemEdit.editing\">\n      <mdp-time-picker ng-model=\"itemEdit.endTime\" mdp-timezone=\"{{itemEdit.timezone}}\" ng-disabled=\"!itemEdit.editing\" aria-label=\"End Time\"></mdp-time-picker>\n      <div class=\"validation-messages\" ng-messages=\"docketDetailForm.endTime.$error\">\n        <div ng-message=\"required\">This time is required.</div>\n      </div>\n    </md-input-container>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField\">\n    <h1>Break Time (Minutes)</h1>\n    <h2 ng-if=\"!itemEdit.editing\">{{itemEdit.breakTime}}</h2>\n    <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"itemEdit.editing\">\n      <input type=\"number\" pattern=\"[0-9]*\" ng-model=\"itemEdit.breakTime\">\n    </md-input-container>\n  </div>\n  <div class=\"ojdField\">\n    <h1>Travel Time (Minutes)</h1>\n    <h2 ng-if=\"!itemEdit.editing\">{{itemEdit.travelTime}}</h2>\n    <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"itemEdit.editing\">\n      <input type=\"number\" pattern=\"[0-9]*\" ng-model=\"itemEdit.travelTime\">\n    </md-input-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "0fge":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/detail.html';
var html = "<div class=\"mobileContainer\">\n\n  <!-- Job Detail View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState=='job'\" ng-controller=\"jobDetailController\">\n    <div class=\"mobileDetailHeader fixed {{itemEdit.userAssigneeData ? itemEdit.userAssigneeData.status : itemEdit.status}}\">\n      <div class=\"headerLoadingSpinner\">\n        <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"15\" ng-if=\"backgroundLoadCount > 0\"></md-progress-circular>\n      </div>\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"cancelButtonHover\" ng-click=\"closeWithoutSave(itemEdit)\">\n          <div class=\"cancelButton\">\n            <div class=\"line1\"></div>\n            <div class=\"line2\"></div>\n            <div class=\"line3\"></div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"middle\">&nbsp;</div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"saveAndStay(itemEdit)\" ng-show=\"itemEdit.editing\">Save</div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderLower\">\n          <div class=\"left\">\n            <span ng-if=\"itemEdit.jobNumber != 'New Job'\">Job </span>{{itemEdit.jobNumber}}\n          </div>\n          <div class=\"right\">\n            <div class=\"actionButton\" ng-click=\"openBottomSheet()\">\n              <md-icon md-svg-src=\"more_vert.svg\"></md-icon>\n            </div>\n          </div>\n        </div>\n      </div>\n      <ng-include src=\"'views/pages/jobs/mobile/mobileTabBar.html'\" class=\"blockLayoutHelper\"></ng-include>\n    </div>\n\n    <div class=\"itemDetailLoaderUnder\" ng-show=\"itemEdit.loading || jobLoadingError\">\n      <div my-loader text=\"Loading Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n      <div my-loader text=\"Saving Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n      <div class=\"stdLoader\" ng-show=\"jobLoadingError != null\">\n        <div class=\"loaderOuterContainer\">\n          <div class=\"loaderInnerContainer headerPadding\">\n            <div class=\"materialSpinner\">\n              <md-icon md-svg-src=\"error.svg\"></md-icon>\n            </div>\n            <div class=\"loadingText\">\n              {{jobLoadingError}}\n            </div>\n            <div class=\"loadingRetryButton\">\n              <div class=\"dbButton simpleOutline\" ng-click=\"openJobMobile(itemEdit.jobId)\">Retry</div>\n              <br/>\n              <div class=\"dbButton simpleOutline margin-top\" ng-click=\"contactSupportError(jobLoadingErrorFull)\">Contact Support</div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"tableCellHelperContainer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"contentSplitDetail listItemDetail mobile {{itemEdit.statusDisplay}}\">\n          <ng-include src=\"'views/pages/jobs/mobile/jobDetail.html'\" class=\"includeContainer mobileListContainer\"></ng-include>\n        </div>\n      </div>\n    </div>\n    <ng-include src=\"'views/modals/shareJobModal.html'\"></ng-include>\n  </div>\n  <!-- End Job Detail View -->\n\n  <!-- Select Order View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'order'\" ng-controller=\"selectOrderController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeOrderSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Order\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"orderSearchValue\" ng-change=\"searchOrderChange(orderSearchValue)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/orderList.html'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n  </div>\n  <!-- End Select Order View -->\n\n  <!-- Select Assignee View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'assignee'\" ng-controller=\"selectPersonController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closePersonSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Assignee\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"assigneeSearchValue\" ng-change=\"searchPeopleChange(assigneeSearchValue)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/personList.html'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n  </div>\n  <!-- End Select Order View -->\n\n  <!-- Select Line View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'lines'\" ng-controller=\"selectLineController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeLineSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Add Line Item\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    </div>\n    <!--<input type=\"text\" class=\"form-control\" placeholder=\"Search\" ng-model=\"lineSearch\" ng-change=\"updateLineSearch(lineSearch)\">-->\n    <ng-include src=\"'views/selectors/lineItemList.html'\" class=\"includeContainer mobilePadding\"></ng-include>\n  </div>\n  <!-- End Select Line View -->\n\n  <!-- Select Company View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'company'\" ng-controller=\"selectContactController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeContactSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Contact\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"contactSearchValue\" ng-change=\"searchContactChange(contactSearchValue)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/companyList.html'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n    <ng-include src=\"'views/modals/viewContactModal.html'\"></ng-include>\n  </div>\n  <!-- End Select Company View -->\n</div>\n\n<!-- Line Item Modals -->\n<span ng-controller=\"lineItemModalController\">\n  <ng-include src=\"'views/modals/mobileLineItemModal.html'\"></ng-include>\n</span>\n<!-- End Line Item Modals -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "0r42":
/***/ (function(module, exports) {

var path = 'views/selectors/orderList.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"orderSearchLoading || orderLoadingError\">\n  <div my-loader text=\"Loading Orders\" ng-if=\"orderSearchLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"orderLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{orderLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"loadOrderList()\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListTopContainer showMobile\">\n    <div class=\"contentSplitListTopInner\">\n      <div class=\"contentHeader selectCompany\">\n        <h2>Select Order</h2>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"order in orderSearchList\"  ng-click=\"assignOrderToDocket(order)\" id=\"listItem{{order.id}}\">\n          <div class=\"listRowItem itemNumber\">{{order.orderNumber}}</div>\n          <div class=\"listRowItem collapsedDetail\">\n            <span ng-if=\"order.customerContact\">{{order.customerContact.displayName}}<span ng-if=\"order.customerRefNo\"> ({{order.customerRefNo}})</span></span> -\n            <span ng-if=\"order.supplierContact\">{{order.supplierContact.displayName}}<span ng-if=\"order.supplierRefNo\"> ({{order.supplierRefNo}})</span></span>\n          </div>\n        </div>\n\n        <div class=\"mobileListButtons hidden-xs\">\n          <div class=\"btn btn-rounded btn-primary\" ng-click=\"closeOrderSelectList()\">\n            Cancel\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "0v67":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0wnD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('jobMobileDetailController', ['jobService', 'userService', 'orderService', '$rootScope', '$scope', '$state', '$window', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', function (jobService, userService, orderService, $rootScope, $scope, $state, $window, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {
  mixpanel.track("Opened JobsDetail Mobile");

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.itemEdit = null;
  $scope.viewState = 'docket';
  $scope.jobLoadingError = null;
  $scope.cleanAssignees = [];

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  // Include responsive utilities and UI functionality helpers
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  /************************************/
  /***** Job Detail View Controls *****/
  /************************************/

  $scope.openJobMobile = function (job, tabToOpen) {
    $scope.jobLoadingError = null;
    $scope.viewState = 'job';
    var openTab = tabToOpen;
    if ($stateParams.openTab != null) {
      openTab = $stateParams.openTab;
    }
    $scope.prepareForJobFromParent(openTab, null, job);
    jobService.getJob(job, function (jobFull) {
      // setup quantities on lines
      for (var i = 0; i < jobFull.lineItems.length; i++) {
        if (jobFull.lineItems[i].resource.uom.isTime) {
          var quantity = jobFull.lineItems[i].quantity;
          var hours = Math.floor(quantity / 60);
          var minutes = quantity % 60;
          jobFull.lineItems[i].quantityHoursEdit = hours;
          jobFull.lineItems[i].quantityMinutesEdit = minutes;
        } else {
          jobFull.lineItems[i].quantityEdit = jobFull.lineItems[i].quantity;
        }
      }

      if (accessControl.userHasPermission('io.docketbook.ojdapi.getOrder') && jobFull.orderRef != null) {
        orderService.getOrder(jobFull.orderRef, function (orderFull) {
          jobFull.orderRef = orderFull;
          $scope.lastCleanJob = angular.copy(jobFull);
          $scope.loadJobFromParent(jobFull);
          return;
        }, function (err) {
          if (jobFull.order != null) {
            var newOrderRef = {};
            newOrderRef.id = jobFull.order.orderId;
            newOrderRef.orderNumber = jobFull.order.orderNumber;
            jobFull.orderRef = newOrderRef;
          }
          $scope.lastCleanJob = angular.copy(jobFull);
          $scope.loadJobFromParent(jobFull);
          return;
        });
      } else {
        if (jobFull.order != null) {
          var newOrderRef = {};
          newOrderRef.id = jobFull.order.orderId;
          newOrderRef.orderNumber = jobFull.order.orderNumber;
          jobFull.orderRef = newOrderRef;
        }
      }

      $scope.lastCleanJob = angular.copy(jobFull);
      $scope.loadJobFromParent(jobFull);
    }, function (err) {
      $scope.jobLoadingErrorFull = err;
      if (err.status == 403) {
        $scope.jobLoadingError = "You do not have permission to access this job";
      } else {
        $scope.jobLoadingError = "Error Getting Job";
      }
    });
  };

  $scope.newJob = function (fromId) {
    $scope.viewState = 'job';
    $scope.newJobFromParent(fromId);
  };

  $scope.closeWithoutSave = function (job) {
    var currentJob = $scope.getJobFromParent();
    jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
      if (diffCount > 0) {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            jobService.saveJob(diff, function (jobUpdated) {
              $scope.closeJob();
            }, function (err) {
              $scope.alertService.presentAutoAlert('saveJob', err);
            });
          } else if (actionSelected == 'dontSave') {
            $scope.closeJob();
          } else {
            // do nothing - stay where we are
          }
        });
        return;
      } else {
        $scope.closeJob();
      }
    });
  };

  $scope.closeJob = function () {
    var stateBack = {};
    if ($stateParams.stateTrail && $stateParams.stateTrail.length > 0) {
      stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
    }
    var stateOptions = {};
    if (stateBack.orderId) {
      stateOptions.orderId = stateBack.orderId;
    }
    if (stateBack.jobId) {
      stateOptions.jobId = stateBack.jobId;
    }
    if (stateBack.docketId) {
      stateOptions.docketId = stateBack.docketId;
    }
    if (stateBack.fromTab) {
      stateOptions.openTab = stateBack.fromTab;
    }
    if (stateBack.orgId) {
      stateOptions.orgId = stateBack.orgId;
    }
    if (stateBack.groupId) {
      stateOptions.groupId = stateBack.groupId;
    }
    if (stateBack.name) {
      if (stateBack.name == 'main.groupJobDetail' && stateOptions.jobId == 'new') {
        $state.go('main.groupJobs', stateOptions);
      } else {
        $state.go(stateBack.name, stateOptions);
      }
    } else {
      if ($scope.currentOrg != null) {
        $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else {
        $state.go('main.jobs');
      }
    }
  };

  $scope.deleteJob = function (job) {
    jobService.deleteJob(job.id, function () {
      $scope.closeJob();
    }, function (err) {
      $scope.alertService.presentAutoAlert('deleteJob', err);
    });
  };

  $scope.saveAndStay = function (job) {
    var newJob = false;
    if (job.id == null) {
      newJob = true;
    }
    job.loading = true;
    job.loadingType = 'saving';
    jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
      if (diffCount > 0) {
        jobService.saveJob(diff, function (jobUpdated) {
          job.loading = false;
          if (newJob) {
            $scope.showToast('New Job Saved');
            $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobUpdated.id });
            //$scope.openJobMobile(jobUpdated);
          } else {
            $scope.showToast('Job Changes Saved');
            $scope.openJobMobile(jobUpdated.id, $scope.currentActiveTab());
          }
        }, function (err) {
          job.loading = false;
          $scope.alertService.presentAutoAlert('saveJob', err);
        });
      } else {
        job.loading = false;
      }
    });
  };

  /********************************/
  /***** MAIN OPENING CONTROLS ****/
  /********************************/

  // Parameter controls
  $scope.detailControllerReady = function () {
    if ($stateParams.jobId != null) {
      if ($stateParams.jobId == 'new') {
        if ($stateParams.fromOrder != null) {
          $scope.newJob($stateParams.fromOrder);
        } else {
          $scope.newJob();
        }
      } else {
        $scope.openJobMobile($stateParams.jobId);
      }
    }
  };

  /*****************************/
  /***** Job State Actions *****/
  /*****************************/

  $scope.sendJob = function (job) {
    $mdBottomSheet.hide();
    job.loading = true;
    jobService.validateSendJob(job, function () {
      jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
        if (diffCount > 0) {
          diff.status = 'sent';
          jobService.saveJob(diff, function (jobUpdated) {
            $scope.showToast('Job Sent');
            $scope.openJobMobile(jobUpdated.id);
          }, function (err) {
            job.loading = false;
            $scope.alertService.presentAutoAlert('sendJob', err);
          });
        } else {
          jobService.sendJob(job, function () {
            $scope.showToast('Job Sent');
            $scope.openJobMobile(job.id);
          }, function (err) {
            job.loading = false;
            $scope.alertService.presentAutoAlert('sendJob', err);
          });
        }
      });
    }, function (exceptions) {
      job.loading = false;
      $scope.alertService.presentAutoValidationAlert('sendJob', exceptions);
    });
  };

  $scope.closeJobStatus = function (job) {
    $mdBottomSheet.hide();
    job.loading = true;
    jobService.closeJob(job, function () {
      $scope.showToast('Job Closed');
      $scope.openJobMobile(job.id);
    }, function (err) {
      job.loading = false;
      $scope.alertService.presentAutoAlert('closeJob', err);
    });
  };

  $scope.assigneeChangeStatus = function (job, statusTo, method) {
    $mdBottomSheet.hide();
    if (statusTo.toLowerCase() == 'rejected') {
      // check if assignee has any dockets created for this job
      var authoredDocketsCount = 0;
      for (var i = 0; i < job.dockets.length; i++) {
        if (job.dockets[i].author == $scope.currentUser.id) {
          authoredDocketsCount += 1;
        }
      }
      if (authoredDocketsCount > 0) {
        $scope.alertService.presentAutoAlert('rejectJobWithDockets', { status: 400 });
        return;
      }
      swal({
        title: "Reject Job " + job.jobNumber,
        text: "Please provide a reason for rejecting this job.",
        type: "input",
        showCancelButton: true,
        closeOnConfirm: true,
        inputPlaceholder: "Reason"
      }, function (inputValue) {
        if (inputValue === false) {
          return;
        }
        jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, inputValue, function (success) {
          $scope.showToast('Job Status Updated');
          $scope.openJobMobile(job.id);
        }, function (err) {
          $scope.alertService.presentAutoAlert('jobStatusChange', err);
        });
      });
    } else {
      jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, null, function (success) {
        $scope.showToast("Job Status Updated");
        $scope.openJobMobile(job.id);
      }, function (err) {
        $scope.alertService.presentAutoAlert('jobStatusChange', err);
      });
    }
  };

  /******************************/
  /***** List View Controls *****/
  /******************************/

  $scope.showJobDetail = function () {
    $scope.viewState = 'job';
    if ($scope.itemEdit.organisation === $scope.currentOrg.id) {
      $scope.cleanAssignees = $scope.itemEdit.assignees;
    } else {
      $scope.cleanAssignees = $scope.itemEdit.assignees.filter(function (assignee) {
        if ('organisation' in assignee && 'organisationGroup' in assignee) {
          return assignee.organisation === $scope.currentOrg.id && assignee.organisationGroup === $scope.currentOrgGroup.id;
        }
        return true;
      });
    }
  };

  $scope.selectOrderForJob = function (options, cb) {
    $scope.viewState = 'order';
    $scope.selectOrderCallback = cb;
    $scope.orderSelectFromParent(options, function (orderSelected) {
      $scope.selectOrderCallback(orderSelected);
      $scope.showJobDetail();
    });
  };

  $scope.selectPersonForJob = function (assignedUsers, cb) {
    $scope.viewState = 'assignee';
    $scope.selectPersonCallback = cb;
    $scope.personSelectFromParent(assignedUsers, function (personSelected) {
      $scope.selectPersonCallback(personSelected);
      $scope.showJobDetail();
    });
  };

  $scope.selectLineFromOrder = function (sourceList, cb) {
    $scope.viewState = 'lines';
    $scope.selectLineCallback = cb;
    $scope.lineSelectFromParent(sourceList, function (lineSelected) {
      $scope.selectLineCallback(lineSelected);
      $scope.showJobDetail();
    });
  };

  $scope.selectContactForJob = function (cb) {
    $scope.viewState = 'company';
    $scope.selectContactCallback = cb;
    $scope.contactSelectFromParent(null, null, function (companySelected) {
      $scope.selectContactCallback(companySelected);
      $scope.showJobDetail();
    });
  };

  /**************************/
  /***** Modal Controls *****/
  /**************************/

  $scope.editLineItemForJob = function (job, item, cb) {
    $scope.editLineItemCallback = cb;
    $scope.editLineItemFromParent(job, item, function (lineItem) {
      $scope.editLineItemCallback(lineItem);
    });
  };

  /**********************************/
  /***** Comments Functionality *****/
  /**********************************/

  $scope.addCommentToJob = function (job, commentText) {
    var comment = {};
    comment.comment = commentText;
    comment.author = $scope.currentUser.id;
    comment.authorName = $scope.currentUser.name.full;
    comment.date = (0, _momentTimezone2.default)().toISOString();

    jobService.addComment(job, comment, function (jobUpdated) {
      job.comments = jobUpdated.comments;
    }, function (err) {
      $scope.alertService.presentAutoAlert('addJobComment', err);
    });
  };

  $scope.removeCommentFromJob = function (job, comment) {
    jobService.deleteComment(job, comment, function (jobUpdated) {
      job.comments = jobUpdated.comments;
    }, function (err) {
      $scope.alertService.presentAutoAlert('removeJobComment', err);
    });
  };

  $scope.addAssigneeComment = function (job, commentText) {
    jobService.addAssigneeComment(job, commentText, function (jobUpdated) {
      $scope.newComment = { 'commentText': '' };
      job.comments = jobUpdated.comments;
    }, function (error) {
      $scope.alertService.presentAutoAlert('addJobComment', error);
    });
  };

  $scope.deleteAssigneeComment = function (job, comment) {
    if ($scope.currentUser.id == comment.author) {
      jobService.deleteAssigneeComment(job, comment, function (jobUpdated) {
        job.comments = jobUpdated.comments;
      }, function (error) {
        $scope.alertService.presentAutoAlert('removeJobComment', error);
      });
    }
  };

  $scope.clearComment = function (comment) {
    $scope.resetNewComment();
  };

  $scope.toggleCommentControls = function (comment) {
    if ($scope.userHasPermission('io.docketbook.ojdapi.updateJob') || comment.author == $scope.currentUser.id) {
      comment.showControls = !comment.showControls;
    }
  };

  /**************************************/
  /***** Infinite scrolling methods *****/
  /**************************************/

  $scope.loadingMoreItems = false;
  $scope.docketsListLoadingCount = 0;
  angular.element($window).bind('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 20) {
      if ($scope.currentActiveTab() == 'Dockets' && !$scope.loadingMoreItems) {
        // load next page of dockets
        $scope.loadingMoreItems = true;
        $("#docketsLoadingMore").removeClass("hidden");
        $scope.loadJobDocketsNextPage(function () {
          $scope.loadingMoreItems = false;
          $("#docketsLoadingMore").addClass('hidden');
        });
      }
    }
  });

  /*****************************/
  /**** New Docket For Job *****/
  /*****************************/

  $scope.newDocketForJob = function () {
    var currentJob = $scope.getJobFromParent();
    jobService.validateCreateDocket(currentJob, function () {
      if (currentJob != null && currentJob.editing) {
        jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
          if (diffCount > 0) {
            swal({
              title: "Unsaved Changes",
              text: "You have some unsaved changes on this job, are you sure you want to close without saving?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, close job.",
              cancelButtonText: "No, dont close job.",
              closeOnConfirm: true,
              closeOnCancel: true
            }, function (isConfirm) {
              if (isConfirm) {
                goToNewDocket(currentJob);
              }
            });
          } else {
            goToNewDocket(currentJob);
          }
        });
      } else {
        goToNewDocket(currentJob);
      }
    }, function (exceptions) {
      currentJob.loading = false;
      $scope.alertService.presentAutoValidationAlert('jobCreateDocket', exceptions);
    });
  };

  var goToNewDocket = function goToNewDocket(currentJob) {
    var currentTab = $scope.currentActiveTab();
    if ($scope.currentOrg && $scope.currentOrgGroup) {
      $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: currentJob.id, fromTab: currentTab, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    } else if (currentJob.userAssigneeData) {
      $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: currentJob.id, fromTab: currentTab, orgId: currentJob.userAssigneeData.organisation, groupId: currentJob.userAssigneeData.organisationGroup });
    }
  };

  $scope.openDocket = function (docket) {
    var currentJob = $scope.getJobFromParent();
    if (currentJob != null && currentJob.editing) {
      jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
        if (diffCount > 0) {
          swal({
            title: "Unsaved Changes",
            text: "You have some unsaved changes on this job, are you sure you want to close without saving?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, close job.",
            cancelButtonText: "No, dont close job.",
            closeOnConfirm: true,
            closeOnCancel: true
          }, function (isConfirm) {
            if (isConfirm) {
              goToDocket(docket, currentJob);
            }
          });
        } else {
          goToDocket(docket, currentJob);
        }
      });
    } else {
      goToDocket(docket, currentJob);
    }
  };

  var goToDocket = function goToDocket(docket, currentJob) {
    if ($scope.currentOrg && $scope.currentOrgGroup) {
      $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Dockets', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    } else if (currentJob.userAssigneeData && currentJob.userAssigneeData.organisation && currentJob.userAssigneeData.organisationGroup) {
      $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Dockets', orgId: currentJob.userAssigneeData.organisation, groupId: currentJob.userAssigneeData.organisationGroup });
    } else {
      $state.go('main.docketDetail', { docketId: docket.id, fromTab: "Dockets" });
    }
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /*****************************/
  /***** Date/Time Pickers *****/
  /*****************************/

  $scope.showDatePicker = function (field, ev) {
    $mdpDatePicker($scope.itemEdit[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      $scope.itemEdit[field] = selectedDate;
    });
  };

  $scope.showTimePicker = function (field, ev) {
    $mdpTimePicker($scope.itemEdit[field], {
      targetEvent: ev,
      autoSwitch: true
    }).then(function (selectedTime) {
      $scope.itemEdit[field] = selectedTime;
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "1015":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-57x57.png";

/***/ }),

/***/ "12oT":
/***/ (function(module, exports) {

var path = 'views/modals/editBankAccountModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"editBankAccountModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Bank Account</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeEditBankAccountModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"editBankForm\">\n        <div class=\"modalFormTable padding\">\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"33\">\n              <md-input-container class=\"md-block\">\n                <label>Account Name</label>\n                <input type=\"text\" ng-model=\"editBankAccount.bankAccountName\" aria-label=\"Account Name\">\n              </md-input-container>\n              <md-input-container class=\"md-block\">\n                <label>BSB</label>\n                <input type=\"number\" ng-model=\"editBankAccount.bankAccountBsb\" aria-label=\"BSB\">\n              </md-input-container>\n              <md-input-container class=\"md-block\">\n                <label>Account Number</label>\n                <input type=\"number\" ng-model=\"editBankAccount.bankAccountNumber\" aria-label=\"Account Number\">\n              </md-input-container>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white\" ng-click=\"closeEditBankAccountModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(bankAccount.loading || editBankAccount.loading) || saveBankAccount()\" ng-disabled=\"bankAccount.loading || editBankAccount.loading || editBankForm.$invalid\">\n            Save\n            <md-progress-circular ng-show=\"editBankAccount.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "1CjB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dump-truck.svg";

/***/ }),

/***/ "1FEJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "check.svg";

/***/ }),

/***/ "1UHj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').service('billingService', ['Restangular', 'accessControl', function (Restangular, accessControl) {
  var billingDetails = { loading: true };
  var plans = [];

  this.getBillingDetails = function (successCb) {
    var currentOrg = accessControl.currentOrg();

    if (!currentOrg) {
      return;
    }

    this.getOrganisationBilling(currentOrg.id, function (rsp) {
      billingDetails = rsp;
      billingDetails.loading = true;
      if (billingDetails.currentPlanId) {
        for (var i = 0; i < plans.length; i++) {
          if (plans[i].id == billingDetails.currentPlanId) {
            billingDetails.currentPlan = plans[i];
          }
        }
      }

      if (billingDetails.sources && billingDetails.sources.length > 0) {
        billingDetails.currentCard = billingDetails.sources[0];
      }

      billingDetails.loading = false;

      if (successCb) {
        successCb(billingDetails);
      }
    }, function (err) {
      billingDetails.loading = false;
    });
  };

  /******* Get Org Billing ********/
  this.getOrganisationBilling = function (orgId, successCb, failureCb) {
    var baseBilling = Restangular.all('organisations').one(orgId).all('billing');
    baseBilling.customGET().then(successCb, failureCb);
  };

  /******* Update Org Billing *******/
  this.updateOrganisationBilling = function (orgId, billingDetails, successCb, failureCb) {
    var baseBilling = Restangular.all('organisations').one(orgId).all('billing');
    var reqObj = { plan: billingDetails.plan, token: billingDetails.token };

    if (billingDetails.features_trial) {
      reqObj.features_trial = billingDetails.features_trial;
    }
    baseBilling.customPUT(reqObj).then(successCb, failureCb);
  };

  /******** Update Org Billing Contact *********/
  this.updateOrganisationBillingContact = function (orgId, contactDetails, successCb, failureCb) {
    var baseBilling = Restangular.all('organisations').one(orgId).all('billing/contact');
    var fields = ['firstName', 'lastName', 'emailAddress', 'address', 'name', 'phoneNumber'];
    var postObj = {};

    fields.forEach(function (field) {
      if (contactDetails[field] != null) {
        postObj[field] = contactDetails[field];
      }
    });

    baseBilling.customPUT(postObj).then(successCb, failureCb);
  };

  /******* Search ABN *******/
  this.searchAbn = function (abn, successCb, failureCb) {
    Restangular.all('abn').one(abn).customGET().then(successCb, failureCb);
  };

  /******* Get plans for billing ********/
  var sortBy = function sortBy(key) {
    return function (a, b) {
      return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
    };
  };

  this.getPlans = function (successCb, failureCb) {
    if (plans.length > 0) {
      return successCb(plans);
    }

    Restangular.all('plans').getList().then(function (rsp) {
      plans = rsp.concat().sort(sortBy('pricePerInterval'));

      successCb(plans);
    }, failureCb);
  };

  this.getBillingDetails();
}]);

/***/ }),

/***/ "1rFi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('companySettingsChecklistsController', ['$scope', 'docketService', '$window', 'splitListInterface', 'uuid', 'Restangular', '$state', '$stateParams', 'accessControl', '$q', function ($scope, docketService, $window, splitListInterface, uuid, Restangular, $state, $stateParams, accessControl, $q) {
  mixpanel.track("Opened CompanySettings-Checklists Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.templateEdit = null;

  $scope.newField = {};
  $scope.selected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'name'
  };
  $scope.listCount = 0;

  $scope.splitListFunc = new splitListInterface($scope);

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************/
  /**** List Controls *****/
  /************************/

  $scope.loadChecklistsList = function () {
    $scope.promise = $q(function (resolve, reject) {
      // Get templates from docketService
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      docketService.getChecklistTemplates(queryParams, function (checklists) {
        $scope.allChecklistTemplates = checklists;
        if (queryParams.offset <= 0 && checklists.length < queryParams.limit) {
          $scope.listCount = checklists.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (error) {
        $scope.allChecklistTemplates = [];
        reject('Error');
      });
    });
  };

  $scope.loadChecklistsList();

  /*******************************/
  /***** Checklist templates *****/
  /*******************************/

  $scope.newTemplate = function () {
    $scope.templateEdit = { 'fields': [] };
    $("#newTemplateModal").fadeIn(100);
  };

  $scope.closeTemplateEdit = function () {
    $scope.templateEdit = null;
    //$("#newTemplateModal").fadeOut(100);
  };

  $scope.editTemplate = function (template) {
    $scope.templateEdit = template;
    $scope.templateOriginal = angular.copy(template);
    //$("#newTemplateModal").fadeIn(100);
  };

  $scope.saveTemplate = function (template, cb) {
    template.loading = true;
    docketService.saveChecklistTemplate(template, function (templateUpdated) {
      $scope.loadChecklistsList();
      $scope.templateEdit = null;
      $scope.closeTemplateEdit();
    }, function (err) {
      template.loading = false;
      $scope.alertService.presentAutoAlert('saveChecklistTemplate', err);
    });
  };

  $scope.removeFieldFromTemplate = function (field, template) {
    var index = template.fields.indexOf(field);
    if (index != -1) {
      template.fields.splice(index, 1);
    }
  };

  $scope.addBlankFieldToTemplate = function (template) {
    if (template.fields == null) {
      template.field = [];
    }
    var newField = {};
    newField.id = uuid.v4();
    template.fields.push(newField);
  };

  $scope.addFieldToTemplate = function (field, template) {
    if (template.fields == null) {
      template.fields = [];
    }
    // generate a uuid for the field
    field.id = uuid.v4();
    template.fields.push(field);
    $scope.newField = {};
  };

  $scope.configureTemplate = function (template) {
    $scope.templateConfigure = template;
    $scope.templateOriginal = angular.copy(template);
    $scope.splitListFunc.slideTableListDetailOpen();
  };

  $scope.saveNewTemplateConfig = function (template) {
    // iterate over list items and get new order
    var fieldOrder = [];
    $(".blockFieldItem").each(function () {
      if ($(this).attr('id') != null) {
        var fieldId = $(this).attr('id');
        for (var i = 0; i < template.fields.length; i++) {
          if (template.fields[i].id == fieldId) {
            fieldOrder.push(template.fields[i]);
            break;
          }
        }
      }
    });

    template.fields = fieldOrder;
    template.loading = true;
    $scope.saveTemplate(template, function () {
      template.loading = false;
      $scope.loadChecklistsList();
    });
  };

  $scope.deleteSelectedChecklists = function () {
    var count = $scope.selected.length;
    swal({
      title: "Are you sure?",
      text: count + " checklists will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteBulkChecklistTemplates($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkChecklists', { status: 202, requestName: 'Delete bulk checklists - failures ' + failures.length + ' of ' + $scope.selected.length });
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkChecklists', { status: 200 });
          }
          $scope.loadChecklistsList();
        });
      }
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "1yJA":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/templates.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\">\n    <div class=\"left\">\n      <h3>Docket Templates</h3>\n    </div>\n    <div class=\"right\">\n      <div class=\"dbButton\" ng-click=\"newTemplate()\">\n        Create New\n      </div>\n    </div>\n  </div>\n\n  <div class=\"settingsRightContentInner\">\n    <div class=\"adminBasicContentContainer\">\n      <div class=\"adminTemplatesList\">\n        <div class=\"adminTemplateItemOuter {{template.loading ? 'loading' : ''}}\" ng-repeat=\"template in allTemplates\">\n          <div class=\"adminTemplateItem\" ng-click=\"openTemplate(template)\">\n            <div class=\"adminTemplateItemInner\">\n             <div class=\"ribbon\" ng-if=\"template.published\"><span>Published</span></div>\n              <div class=\"icon template\"></div>\n              {{template.name}}\n            </div>\n          </div>\n          <div class=\"overlayLoading\">\n            <md-progress-circular ng-show=\"template.loading\" class=\"md-hue-2\" md-diameter=\"40px\"></md-progress-circular>\n            <div class=\"title\">Duplicating Template</div>\n          </div>\n          <div class=\"overlayActions\">\n            <div class=\"overlayButton\" ng-click=\"duplicateTemplate(template)\">\n              <md-icon md-svg-src=\"copy.svg\"></md-icon>\n              <div class=\"title\">Duplicate</div>\n            </div>\n            <div class=\"overlayButton\" ng-click=\"deleteTemplate(template)\" ng-if=\"!isSampleCompany && !template.published\">\n              <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              <div class=\"title\">Delete</div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "2/1N":
/***/ (function(module, exports) {

var path = 'views/selectors/lineItemList.html';
var html = "<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"lineItem in lineItemList\" ng-show=\"!lineItem.disabled\" ng-click=\"selectLineItem(lineItem)\" id=\"listItem{{lineItem.id}}\">\n          <div class=\"listRowItem status\"><div class=\"quantityDisplay\">{{lineItem.quantity}} {{lineItem.resource.uom.abbreviation}}</div></div>\n          <div class=\"listRowItem itemNumber\">{{lineItem.resource.name}}</div>\n          <div class=\"listRowItem collapsedDetail showCollapsed\">\n            <div class=\"tableLayoutHelperContainer\">\n              <div class=\"left\">{{lineItem.itemDescription}}</div>\n              <div class=\"right\">{{lineItem.resource.identifier}}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"mobileListButtons hidden-xs\">\n          <div class=\"btn btn-rounded btn-primary\" ng-click=\"closeLineSelectList()\">\n            Cancel\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "229m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2.png";

/***/ }),

/***/ "2R8v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

angular.module('docketbook').controller('companySettingsResourcesController', ['resourceService', 'xeroService', '$q', '$scope', 'Restangular', '$state', '$window', '$stateParams', 'accessControl', 'Upload', 'uuid', function (resourceService, xeroService, $q, $scope, Restangular, $state, $window, $stateParams, accessControl, Upload, uuid) {
  mixpanel.track("Opened CompanySettings-Resources Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.loading = false;
  $scope.allXeroItems = [];
  $scope.filteredXeroItems = [];
  $scope.filteredUoms = [];
  $scope.filteredCategories = [];
  $scope.searchTextXeroItem = "";
  $scope.showDeleted = false;

  $scope.selected = [];
  $scope.selected_deleted = [];

  $scope.deltedQuery = {
    limit: 10,
    page: 1,
    order: 'name'
  };

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'name'
  };

  $scope.listCount = 0;

  $scope.loadDeletedResourceList = function () {
    $scope.selected_deleted = [];

    $scope.promise = $q(function (resolve, reject) {
      // setup query params
      var queryParams = {};
      queryParams.limit = $scope.deltedQuery.limit;
      queryParams.offset = $scope.deltedQuery.limit * ($scope.deltedQuery.page - 1);
      queryParams.sort = $scope.deltedQuery.order;
      queryParams.active = 'false';
      resourceService.getResources(queryParams, function (returnData) {
        $scope.allDeletedResources = returnData;
        for (var i = 0; i < $scope.allDeletedResources.length; i++) {
          // check for existing xero item identifier
          if ($scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled && $scope.allDeletedResources[i].externalIdentifiers != null) {
            var existingXeroIdentifier = $scope.allDeletedResources[i].externalIdentifiers.find(function (eid) {
              return eid.type === 'xero';
            });
            if (existingXeroIdentifier) {
              $scope.allDeletedResources[i].xeroID = $scope.allXeroItems.find(function (xeroItem) {
                return xeroItem.externalId === existingXeroIdentifier.externalId;
              });
            }
          }
          $scope.allDeletedResources[i].editing = false;
        }
        if (queryParams.offset <= 0 && returnData.length < queryParams.limit) {
          $scope.listCount = returnData.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (error) {
        $scope.allDeletedResources = [];
        reject('Error');
      });
    });
  };

  $scope.loadDeletedResourceList();

  $scope.loadResourceList = function () {
    $scope.selected = [];
    $scope.promise = $q(function (resolve, reject) {
      // setup query params
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      queryParams.active = 'true';
      resourceService.getResources(queryParams, function (returnData) {
        $scope.allResources = returnData;
        for (var i = 0; i < $scope.allResources.length; i++) {
          // check for existing xero item identifier
          if ($scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled && $scope.allResources[i].externalIdentifiers != null) {
            var existingXeroIdentifier = $scope.allResources[i].externalIdentifiers.find(function (eid) {
              return eid.type === 'xero';
            });
            if (existingXeroIdentifier) {
              $scope.allResources[i].xeroID = $scope.allXeroItems.find(function (xeroItem) {
                return xeroItem.externalId === existingXeroIdentifier.externalId;
              });
            }
          }
          $scope.allResources[i].editing = false;
        }
        if (queryParams.offset <= 0 && returnData.length < queryParams.limit) {
          $scope.listCount = returnData.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (error) {
        $scope.allResources = [];
        reject('Error');
      });
    });
  };

  if ($scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled) {
    // Get cached xero items
    xeroService.getXeroItems({ limit: 800 }, function (items) {
      $scope.allXeroItems = items;
      $scope.filteredXeroItems = angular.copy(items);
      $scope.loadResourceList();
    });
  } else {
    $scope.loadResourceList();
  }

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /**********************************/
  /***** Secondary Data Models ******/
  /**********************************/

  $scope.allResourceCategories = [];
  $scope.sortedResourceCategories = {};
  $scope.allUoms = [];
  $scope.sortedUoms = {};

  $scope.getResourceCategories = function () {
    resourceService.getResourceCategories(null, function (categories) {
      $scope.allResourceCategories = categories;
      $scope.filteredCategories = categories;
    }, function (err) {
      $scope.allResourceCategories = [];
      $scope.filteredCategories = [];
    });
  };

  $scope.getUoms = function () {
    resourceService.getUoms(null, function (uoms) {
      $scope.allUoms = uoms;
      $scope.filteredUoms = uoms;
    }, function (err) {
      $scope.allUoms = [];
      $scope.filteredUoms = [];
    });
  };

  $scope.getResourceCategories();
  $scope.getUoms();

  /**********************************/
  /***** Resources Functinality *****/
  /**********************************/

  // Create a new resource modal
  $scope.addNewResource = function (cb) {
    var newResource = { name: "", identifier: "", editing: true };
    $scope.allResources.splice(0, 0, newResource);
  };

  // Close new resource modal
  $scope.closeNewResourceModal = function () {
    $("#newResourceModal").fadeOut(100);
    $scope.resourceEdit = {};
  };

  $scope.editResource = function (resource) {
    $scope.resourceEdit = angular.copy(resource);
    $scope.resourceEdit.loading = false;
    //$scope.resourceEdit.category = $scope.resourceEdit.category.id;
    //$scope.resourceEdit.uom = $scope.resourceEdit.uom.id;
    $scope.resourceOriginal = angular.copy(resource);
    $("#newResourceModal").fadeIn(100);
  };

  $scope.refreshResources = function () {
    $scope.loadResourceList();
  };

  // update the uom of the currently edited resource
  $scope.updateResourceUom = function () {
    for (var i = 0; i < $scope.allUoms.length; i++) {
      if ($scope.allUoms[i].id == $scope.resourceEdit.resourceType.uom) {
        $scope.resourceEdit.uom = $scope.allUoms[i];
      }
    }
  };

  // Resource Xero Item Selected
  $scope.resourceXeroItemSelected = function (resource) {
    if (resource.xeroID && !resource.identifier) {
      resource.identifier = resource.xeroID.userCode;
    }
    if (resource.xeroID && !resource.name) {
      resource.name = resource.xeroID.name;
    }
  };

  // Edit resource table row
  $scope.editResourceRow = function (resourceRow) {
    resourceRow.editing = true;
    resourceRow.loading = false;
  };

  $scope.saveResourceRow = function (resourceRow, cb) {
    var resourceSave = angular.copy(resourceRow);
    var valid = true;
    if (resourceRow.name == null || resourceRow.name == "") {
      valid = false;
    }
    if (resourceRow.identifier == null || resourceRow.identifier == "") {
      valid = false;
    }
    if (resourceRow.category == null) {
      valid = false;
    } else {
      resourceSave.category = resourceRow.category.id;
    }
    if (resourceRow.uom == null) {
      valid = false;
    } else {
      resourceSave.uom = resourceRow.uom.id;
    }
    resourceSave.name = resourceRow.name;
    resourceSave.identifier = resourceRow.identifier;

    if (!valid) {
      return false;
    }

    resourceRow.editing = false;
    resourceRow.loading = true;
    if (resourceRow.xeroID && resourceRow.id != null) {
      var existingXeroIdentifier = null;
      if (resourceRow.externalIdentifiers) {
        existingXeroIdentifier = resourceRow.externalIdentifiers.find(function (eid) {
          return eid.type === 'xero';
        });
      }
      if (!resourceRow.externalIdentifiers || existingXeroIdentifier === undefined || existingXeroIdentifier === null || existingXeroIdentifier.externalId !== resourceRow.xeroID) {
        resourceSave.externalIdentifiers = {
          add: [{
            type: 'xero',
            externalId: resourceRow.xeroID.externalId
          }]
        };
        if (existingXeroIdentifier !== undefined) {
          resourceSave.externalIdentifiers.delete = [existingXeroIdentifier];
        }
      }
    } else if (resourceRow.xeroID && resourceRow.id == null) {
      resourceSave.externalIdentifiers = [];
      resourceSave.externalIdentifiers.push({
        type: 'xero',
        externalId: resourceRow.xeroID.externalId
      });
    }

    resourceService.saveResource(resourceSave, function (updatedResource) {
      resourceRow.loading = false;
      Object.assign(resourceRow, updatedResource);
      cb && cb();
    }, function (err) {
      resourceRow.loading = false;
      $scope.alertService.presentAutoAlert('saveResource', err);
      cb && cb();
    });
  };

  // Save a new resource for the organisation
  $scope.saveNewResource = function (resource, cb) {
    resource.loading = true;
    resourceService.saveResource(resource, function (updatedResource) {
      resource.loading = false;
      Object.assign(resourceRow, updatedResource);
      if (cb) {
        cb();
      } else {
        $scope.closeNewResourceModal();
        $scope.loadResourceList();
      }
    }, function (err) {
      resource.loading = false;
      $scope.alertService.presentAutoAlert('saveResource', err);
    });
  };

  $scope.saveNewResourceAddAnother = function (resource) {
    $scope.saveNewResource(resource, function () {
      $scope.refreshResources();
      $scope.openNewResourceModal();
    });
  };

  $scope.deleteResource = function (resource) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this resource!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: false,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.removeResource(resource.id, function () {
          $scope.refreshResources();
        }, function (err) {
          swal({
            title: "Error!",
            text: "An error occured while deleting the resource.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        });
      }
    });
  };

  $scope.deleteSelectedResources = function () {
    var count = $scope.selected.length;
    swal({
      title: "Are you sure?",
      text: count + " resources will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.deleteBulkResources($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkResources', { status: 202, requestName: 'Delete bulk resources - failures ' + failures.length + ' of ' + $scope.selected.length });
            $scope.loadResourceList();
            $scope.loadDeletedResourceList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkResources', { status: 200 });
            $scope.loadResourceList();
            $scope.loadDeletedResourceList();
          }
        });
      }
    });
  };

  var restoreResource = function restoreResource(resourceList, cb) {
    if (resourceList.length == 0) {
      cb && cb();
      return;
    }

    var resource = resourceList.pop();
    var clone = angular.copy(resource);
    clone.active = true;
    $scope.saveResourceRow(clone, function () {
      return restoreResource(resourceList, cb);
    });
  };

  $scope.restoreSelectedResources = function () {
    restoreResource($scope.selected_deleted, function () {
      $scope.loadDeletedResourceList();
      $scope.loadResourceList();
    });
  };

  $scope.getResTypeFromId = function (id) {
    if (id.id == null) {
      for (var i = 0; i < $scope.allResourceTypes.length; i++) {
        if ($scope.allResourceTypes[i].id == id) {
          return $scope.allResourceTypes[i];
        }
      }
    } else {
      return id;
    }

    return null;
  };

  $scope.searchXeroItemChange = function (resource, searchText) {
    if (searchText == null || searchText == "") {
      $scope.filteredXeroItems = angular.copy($scope.allXeroItems);
    } else {
      $scope.filteredXeroItems = [];
      for (var i = 0; i < $scope.allXeroItems.length; i++) {
        if ($scope.allXeroItems[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1 || $scope.allXeroItems[i].userCode.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          $scope.filteredXeroItems.push($scope.allXeroItems[i]);
        }
      }
    }
  };

  $scope.searchUomChange = function (resource, searchText) {
    if (searchText == null || searchText == "") {
      $scope.filteredUoms = angular.copy($scope.allUoms);
    } else {
      $scope.filteredUoms = [];
      for (var i = 0; i < $scope.allUoms.length; i++) {
        if ($scope.allUoms[i].abbreviation.toLowerCase().indexOf(searchText.toLowerCase()) != -1 || $scope.allUoms[i].description.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          $scope.filteredUoms.push($scope.allUoms[i]);
        }
      }
    }
  };

  $scope.searchCategoryChange = function (resource, searchText) {
    if (searchText == null || searchText == "") {
      $scope.filteredCategories = angular.copy($scope.allResourceCategories);
    } else {
      $scope.filteredCategories = [];
      for (var i = 0; i < $scope.allResourceCategories.length; i++) {
        if ($scope.allResourceCategories[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          $scope.filteredCategories.push($scope.allResourceCategories[i]);
        }
      }
    }
  };

  /***********************/
  /* RESOURCE CATEGORIES */
  /***********************/

  $scope.resourceCategoriesSelected = [];
  $scope.resourceCategoriesQuery = {
    limit: 100,
    page: 1,
    order: 'name'
  };
  $scope.resourceCategoriesListCount = 0;

  $scope.loadCategoriesList = function () {
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.resourceCategoriesQuery.limit;
      queryParams.offset = $scope.resourceCategoriesQuery.limit * ($scope.resourceCategoriesQuery.page - 1);
      queryParams.sort = $scope.resourceCategoriesQuery.order;
      resourceService.getResourceCategories(queryParams, function (categories) {
        $scope.allResourceCategories = categories;
        if (queryParams.offset <= 0 && categories.length < queryParams.limit) {
          $scope.resourceCategoriesListCount = categories.length;
        } else {
          $scope.resourceCategoriesListCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (err) {
        $scope.allResourceCategories = [];
        reject('Error');
      });
    });
  };

  $scope.loadCategoriesList();

  // Create a new resource type modal
  $scope.openNewResourceCategoryModal = function () {
    $scope.itemEdit = {};
    $("#newResourceCategoryModal").fadeIn(100);
  };

  // Close new resource modal
  $scope.closeNewResourceCategoryModal = function () {
    $("#newResourceCategoryModal").fadeOut(100, function () {
      $scope.itemEdit = {};
    });
  };

  $scope.editResourceCategory = function (item) {
    $scope.itemEdit = item;
    item.loading = false;
    $("#newResourceCategoryModal").fadeIn(100);
  };

  var refreshResourceCategories = function refreshResourceCategories() {
    $scope.loadCategoriesList();
  };

  // Save a new resource cat for the organisation
  $scope.saveNewResourceCategory = function (category) {
    category.loading = true;
    resourceService.saveResourceCategory(category, function (updatedCategory) {
      $("#newResourceCategoryModal").fadeOut(100);
      $scope.loadCategoriesList();
    }, function (err) {
      category.loading = false;
      $scope.alertService.presentAutoAlert('saveResourceCategory', err);
    });
  };

  $scope.deleteSelectedCategories = function () {
    var count = $scope.resourceCategoriesSelected.length;
    swal({
      title: "Are you sure?",
      text: count + " categories will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.deleteBulkResourceCategories($scope.resourceCategoriesSelected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkResourceCategories', { status: 202, requestName: 'Delete bulk resource categories - failures ' + failures.length + ' of ' + $scope.resourceCategoriesSelected.length });
            $scope.loadCategoriesList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkResourceCategories', { status: 200 });
            $scope.loadCategoriesList();
          }
        });
      }
    });
  };

  /*****************/
  /* UOMS Settings */
  /*****************/

  $scope.uomsQuery = {
    limit: 100,
    page: 1,
    order: 'abbreviation'
  };
  $scope.uomsSelected = [];
  $scope.uomsListCount = 0;

  $scope.timeTypes = ['hours', 'hoursminutes', 'minutes'];

  $scope.loadUomsList = function () {
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.uomsQuery.limit;
      queryParams.offset = $scope.uomsQuery.limit * ($scope.uomsQuery.page - 1);
      resourceService.getUoms(queryParams, function (uoms) {
        $scope.allUoms = uoms;
        if (queryParams.offset <= 0 && uoms.length < queryParams.limit) {
          $scope.uomsListCount = uoms.length;
        } else {
          $scope.uomsListCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (err) {
        $scope.allUoms = [];
        reject('Error');
      });
    });
  };

  $scope.loadUomsList();

  // Create a new uom modal
  $scope.openNewUomModal = function () {
    $scope.uomEdit = {};
    $scope.uomEdit.isTime = false;
    $("#newUomModal").fadeIn(100);
  };

  $scope.editUom = function (uom) {
    $scope.uomEdit = uom;
    $("#newUomModal").fadeIn(100);
  };

  // Close new uom modal
  $scope.closeNewUomModal = function () {
    $("#newUomModal").fadeOut(100);
    $scope.uomEdit = {};
  };

  // Save a new uom for the organisation
  $scope.saveNewUom = function (uom) {
    uom.loading = true;
    if (uom.isTime == null) {
      uom.isTime = false;
    }
    resourceService.saveUom(uom, function (updatedUom) {
      $scope.closeNewUomModal();
      $scope.loadUomsList();
    }, function (err) {
      uom.loading = false;
      $scope.alertService.presentAutoAlert('saveUom', err);
    });
  };

  $scope.deleteUom = function (uom) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this unit of measure!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: false,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.removeUom(uom.id, function (success) {
          swal("Deleted!", "The unit of measure has been deleted.", "success");
          $scope.loadUomsList();
        }, function (err) {
          swal({
            title: "Error!",
            text: "An error occured while deleting the unit of measure.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        });
      }
    });
  };

  $scope.deleteSelectedUoms = function () {
    var count = $scope.uomsSelected.length;
    swal({
      title: "Are you sure?",
      text: count + " uom's will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.deleteBulkUoms($scope.uomsSelected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkUoms', { status: 202, requestName: 'Delete bulk uoms - failures ' + failures.length + ' of ' + $scope.uomsSelected.length });
            $scope.loadUomsList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkUoms', { status: 200 });
            $scope.loadUomsList();
          }
        });
      }
    });
  };

  $scope.userIsXeroAuthenticated = function () {
    if (!$scope.currentUser.xeroAuthentication) {
      return false;
    }
    if (!$scope.currentUser.xeroAuthentication.authenticatedUntil) {
      return false;
    }
    if (moment($scope.currentUser.xeroAuthentication.authenticatedUntil).isBefore(moment())) {
      return false;
    }
    return true;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("PJh5")))

/***/ }),

/***/ "2gQD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2pEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectActivityController', ['docketService', '$rootScope', '$window', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', function (docketService, $rootScope, $window, $scope, $state, $stateParams, Restangular, accessControl, $timeout) {

  // Initialise variables to be used
  $scope.activitySearch = "";
  $scope.activitySearchLoading = false;
  $scope.activitySearchList = [];
  $scope.activitySearchListFull = [];
  $scope.activitySearchCallback = null;
  $scope.activityLoading = false;
  $scope.activityLoadingError = null;
  $scope.activityListLoadingCount = 0;
  $scope.listCount = 0;

  $scope.preventLoad = false;

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'fileCode'
  };

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.activitySelectFromParent = function (existing, cb) {
    $scope.activitySearch = "";
    $scope.activitySearchCurrent = "";
    $scope.activitySearchLoading = false;
    $scope.activityLoadingError = null;
    $scope.activitySearchList = [];
    $scope.activitySelectCallback = cb;
    $scope.existingFileCodes = existing;
    $scope.preventLoad = false;
    $scope.query.limit = 10;
    $scope.query.page = 1;
    $scope.loadActivityList(null);
  };

  $scope.loadActivityList = function (searchText) {
    var existing = $scope.existingFileCodes;
    $scope.activitySearchList = [];
    $scope.activitySearchCurrent = searchText;
    $scope.activitySearchLoading = true;
    $scope.getActivityList(searchText, function (fileCodes) {
      for (var i = 0; i < fileCodes.length; i++) {
        var found = false;
        if (existing) {
          for (var j = 0; j < existing.length; j++) {
            if (existing[j].uniqueIdentifier == fileCodes[i].uniqueIdentifier) {
              found = true;
              break;
            }
          }
        }

        if (!found) {
          $scope.activitySearchList.push(fileCodes[i]);
        }
      }
      $scope.activitySearchLoading = false;
    }, function (err) {
      $scope.activitySearchLoading = false;
      $scope.activityLoadingError = "Error loading file codes";
    });
  };

  $scope.selectActivity = function (activity) {
    $scope.activitySelectCallback(activity);
  };

  $scope.closeActivitySelectList = function () {
    $scope.activitySelectCallback(null);
  };

  /************************/
  /**** Load From API *****/
  /************************/

  $scope.getActivityList = function (searchText, successCb, failureCb) {
    var queryParams = {};
    queryParams.limit = $scope.query.limit;
    queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
    queryParams.sort = $scope.query.order;
    if (searchText != null && searchText != "") {
      queryParams.search = searchText;
    }
    docketService.getFileCodes(queryParams, function (returnObject) {
      var fileCodeList = returnObject;
      if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
        $scope.listCount = returnObject.length;
      } else {
        $scope.listCount = queryParams.offset + (queryParams.limit + 1);
      }
      successCb(fileCodeList);
    }, function (err) {
      failureCb(err);
    });
  };

  $scope.loadNextPageOfFileCodes = function (cb) {
    $scope.query.page += 1;
    $scope.getActivityList($scope.activitySearchCurrent, function (fileCodes) {
      if (fileCodes.length == 0) {
        $scope.preventLoad = true;
        cb();
        return;
      }
      for (var i = 0; i < fileCodes.length; i++) {
        $scope.activitySearchList.push(fileCodes[i]);
      }
      cb();
    }, function (err) {
      cb();
    });
  };

  $scope.loadingMoreItems = false;
  $scope.fileCodesLoadingCount = 0;
  angular.element($window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 20) {
      var offset = $scope.query.limit * ($scope.query.page - 1);
      if (!$scope.loadingMoreItems && !$scope.preventLoad) {
        $scope.loadingMoreItems = true;
        $("#fileCodesLoadingMore").removeClass('hidden');
        $scope.loadNextPageOfFileCodes(function () {
          $scope.loadingMoreItems = false;
          $("#fileCodesLoadingMore").addClass("hidden");
        });
      }
    }
  });

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.searchActivityChange = function (searchValue) {
    $scope.query.page = 1;
    $scope.loadActivityList(searchValue);
  };

  $scope.updateActivitySearch = function (searchValue) {
    $scope.query.page = 1;
    $scope.loadActivityList(searchValue);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "2paq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "help.svg";

/***/ }),

/***/ "31Wy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "magnify.svg";

/***/ }),

/***/ "3Pz8":
/***/ (function(module, exports) {

var path = 'views/pages/filing/desktop/filingHeading.html';
var html = "<div class=\"contentHeadingOuter\">\n  <div class=\"contentHeadingInner desktopTableSearch\">\n    <div class=\"headerSplit\">\n      <div class=\"left\">\n        <h1>Docket Filing</h1>\n      </div>\n      <div class=\"middle\">\n        <h2>{{filterHeading}}</h2>\n      </div>\n      <div class=\"right\">\n        <md-button class=\"md-icon-button {{activeFilters > 0 ? 'md-primary' : ''}}\" ng-click=\"showFilters = !showFilters\" aria-label=\"Show / Hide Filters\">\n          <md-icon md-svg-icon=\"filter.svg\"></md-icon>\n          <div class=\"md-icon-hover-count\" ng-show=\"activeFilters > 0\">{{activeFilters}}</div>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"loadDocketFilingList()\" aria-label=\"Reload Filing List\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopFiltersContainer quickFilters\" ng-if=\"showFilters\">\n      <div class=\"filterRow\">\n        <div class=\"filterGroup dates\">\n          <h1>Date</h1>\n          <div class=\"md-block\">\n            <md-input-container class=\"filterDatepicker\">\n              <label>From</label>\n              <md-datepicker ng-model=\"filters.startFromDate\" aria-label=\"From Date Filter\"></md-datepicker>\n            </md-input-container>\n            <md-input-container class=\"filterDatepicker\">\n              <label>To</label>\n              <md-datepicker ng-model=\"filters.endToDate\" aria-label=\"To Date Filter\"></md-datepicker>\n            </md-input-container>\n          </div>\n        </div>\n\n        <div class=\"filterGroup\">\n          <h1>Order</h1>\n          <md-button class=\"md-icon-button selector\" ng-click=\"selectOrderFilter()\" aria-label=\"Select Order Filter\">\n            <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n          </md-button>\n          <md-button class=\"md-icon-button selector\" ng-click=\"filters.order = null\" aria-label=\"Clear Order Filter\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"filters.order.orderNumber\" ng-disabled=\"true\" aria-label=\"Order\">\n          </md-input-container>\n        </div>\n\n        <div class=\"filterGroup\">\n          <h1>Job</h1>\n          <md-button class=\"md-icon-button selector\" ng-click=\"selectJobFilter()\" aria-label=\"Select Job Filter\">\n            <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n          </md-button>\n          <md-button class=\"md-icon-button selector\" ng-click=\"filters.job = null\" aria-label=\"Clear Job Filter\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"filters.job.jobNumber\" ng-disabled=\"true\" aria-label=\"Job\">\n          </md-input-container>\n        </div>\n\n        <div class=\"filterGroup\">\n          <h1>Customer</h1>\n          <md-button class=\"md-icon-button selector\" ng-click=\"selectContactFilter('customer')\" aria-label=\"Select Customer Filter\">\n            <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n          </md-button>\n          <md-button class=\"md-icon-button selector\" ng-click=\"filters.customerContact = null\" aria-label=\"Clear Customer Filter\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"filters.customerContact.displayName\" ng-disabled=\"true\" aria-label=\"Customer Contact\">\n          </md-input-container>\n        </div>\n\n        <div class=\"filterGroup\">\n          <h1>Supplier</h1>\n          <md-button class=\"md-icon-button selector\" ng-click=\"selectContactFilter('supplier')\" aria-label=\"Select Supplier Filter\">\n            <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n          </md-button>\n          <md-button class=\"md-icon-button selector\" ng-click=\"filters.supplierContact = null\" aria-label=\"Clear Supplier Filter\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"filters.supplierContact.displayName\" ng-disabled=\"true\" aria-label=\"Supplier Contact\">\n          </md-input-container>\n        </div>\n\n        <div class=\"filterGroup\">\n          <md-button ng-click=\"clearFilters()\" class=\"\" aria-label=\"Clear All Filters\">\n            Clear All Filters\n          </md-button>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"contentHeadingNavBar filterTabs\">\n      <div class=\"filterTabsContainer filing\">\n        <md-nav-bar md-selected-nav-item=\"filters.statusTab\" nav-bar-aria-label=\"navigation links\">\n          <md-nav-item md-nav-click=\"changeStatusTab('All')\" name=\"All\">All Dockets</md-nav-item>\n          <md-nav-item md-nav-click=\"changeStatusTab('Unfiled')\" name=\"Unfiled\">Unfiled Dockets</md-nav-item>\n          <md-nav-item md-nav-click=\"changeStatusTab('Filed')\" name=\"Filed\">Filed Dockets</md-nav-item>\n        </md-nav-bar>\n      </div>\n      <div class=\"filterSelectorButtons\">\n        <md-menu>\n          <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"openBulkDocketsForFiling()\" aria-label=\"File Selected Dockets\">\n              <md-button>\n                File Dockets\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "3Rdy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3TTx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "menu.svg";

/***/ }),

/***/ "3cXQ":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/list.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"docketsLoading || docketsLoadingError\">\n  <div my-loader text=\"Loading Dockets\" ng-if=\"docketsLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"docketsLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{docketsLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <div class=\"dbButton simpleOutline\" ng-click=\"loadDocketsIntoList()\">Retry</div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"contentList paddingWithoutTabBar tabBarBottomPadding\" id=\"docketScrollList\">\n  <div class=\"customListRowOuter\" ng-repeat=\"item in listItems\" id=\"listItem{{item.id}}\" >\n    <div class=\"customListRow {{item.status}} {{itemEdit.id == item.id ? 'selected' : ''}}\"  ng-click=\"openDocketDetail(item)\">\n      <div class=\"listRowItem status\" ><div class=\"statusDisplay {{item.status}}\">{{item.status}}</div></div>\n      <div class=\"listRowItem itemNumber\">{{item.docketNumber}} <span ng-if=\"!item.assigned && currentOrg == null\">(unassigned)</span></div>\n      <div class=\"listRowItem collapsedDetail showCollapsed\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n            <div class=\"inner\">\n              <span ng-show=\"item.supplierContact\">{{item.supplierContact.displayName}}</span> -\n              <span ng-show=\"item.customerContact\">{{item.customerContact.displayName}}</span>\n            </div>\n          </div>\n          <div class=\"right\">{{moment(item.date).format('DD/MM')}}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"customListRowOuter hidden\" id=\"docketsLoadingMore\">\n    <div class=\"customListRow loadingRow\">\n      <div class=\"progressOuter\">\n        <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\" ng-if=\"loadingMoreItems\"></md-progress-circular>\n      </div>\n      Loading More Dockets\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "3sj4":
/***/ (function(module, exports) {

var path = 'views/modals/searchAbnModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"searchAbnModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Search ABN</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeSearchAbnModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\" ng-if=\"abnSearch.step == 'search'\">\n      <div my-loader text=\"Looking up ABN\" ng-if=\"abnSearch.loading\"></div>\n      <form name=\"abnSearchForm\" novalidate>\n        <div class=\"modalFormTableHeader white intro\">\n          <p>Please enter your ABN, containing only numbers without spaces.</p>\n        </div>\n        <div class=\"modalFormTable padding\">\n          <div layout-gt-sm=\"row\" class=\"filterRow\" ng-if=\"abnSearch.error\">\n            <inline-alert type=\"warning\">Invalid ABN. Please check the ABN you entered is correct.<br/>Make sure it only contains numbers.</inline-alert>\n          </div>\n          <div layout-gt-sm=\"row\" class=\"filterRow\" ng-if=\"abnSearch.saveError\">\n            <inline-alert type=\"warning\">Something went wrong when we tried to save your ABN. Please check the ABN you entered and try again.</inline-alert>\n          </div>\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"33\">\n              <md-input-container class=\"md-block\">\n                <label>ABN</label>\n                <input type=\"text\" ng-model=\"abnSearch.abn\" aria-label=\"ABN\">\n              </md-input-container>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"content noPadding\" ng-if=\"abnSearch.step == 'check'\">\n      <div my-loader text=\"Saving your ABN\" ng-if=\"abnSearch.loading\"></div>\n      <div class=\"modalFormTableHeader white intro\">\n        <p>Please confirm the ABN name below is correct and click save to continue.</p>\n      </div>\n      <div class=\"modalFormTable padding\">\n        <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n          <div flex-gt-sm=\"50\">\n            <md-input-container class=\"md-block\">\n              <label>ABN</label>\n              <input type=\"text\" ng-model=\"abnSearch.abn\" aria-label=\"ABN\" disabled='true'>\n            </md-input-container>\n          </div>\n          <div flex-gt-sm=\"50\">\n            <md-input-container class=\"md-block\">\n              <label>Business Name</label>\n              <input type=\"text\" ng-model=\"abnSearch.abnName\" aria-label=\"Business Name\" disabled='true'>\n            </md-input-container>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white\" ng-click=\"closeSearchAbnModal()\" ng-if=\"abnSearch.step == 'search'\">\n            Cancel\n          </div>\n          <div class=\"dbButton white\" ng-click=\"abnModalBack(abnSearch)\" ng-if=\"abnSearch.step == 'check'\">\n            Back\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(abnSearchForm.$invalid || abnSearch.loading) || searchAbnContinue(abnSearch)\" ng-disabled=\"abnSearchForm.$invalid || abnSearch.loading\" ng-if=\"abnSearch.step == 'search'\">\n            <span ng-hide=\"abnSearch.loading\">Continue</span>\n            <md-progress-circular ng-show=\"abnSearch.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(abnSearch.loading) || saveAbnSearch(abnSearch)\" ng-disabled=\"abnSearch.loading\" ng-if=\"abnSearch.step == 'check'\">\n            <span ng-hide=\"abnSearch.loading\">Save</span>\n            <md-progress-circular ng-show=\"abnSearch.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "45qS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "admin-user.svg";

/***/ }),

/***/ "4KcY":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/docketsBottomSheet.html';
var html = "<md-bottom-sheet class=\"md-list\">\n  <md-list>\n\t\t<md-list-item ng-show=\"userCanDoAction('recallDocket', itemEdit)\">\n      <md-button ng-click=\"reDraftDocket(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Recall Docket</span>\n      </md-button>\n    </md-list-item>\n\t\t<md-list-item ng-show=\"userCanDoAction('reDraftDocket', itemEdit)\">\n      <md-button ng-click=\"reDraftDocket(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Edit Docket</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('sendDocket', itemEdit)\">\n      <md-button ng-click=\"sendDocket(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Send Docket</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('acceptDocket', itemEdit)\">\n      <md-button class=\"md-list-item-content\" ng-click=\"acceptDocket(itemEdit)\">\n        <span class=\"md-inline-list-icon-label\">Accept Docket</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('acceptFileDocket', itemEdit)\">\n      <md-button class=\"md-list-item-content\" ng-click=\"acceptAndFileDocket(itemEdit)\">\n        <span class=\"md-inline-list-icon-label\">Accept and File Docket</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('rejectDocket', itemEdit)\">\n      <md-button class=\"md-list-item-content\" ng-click=\"rejectDocket(itemEdit)\">\n        <span class=\"md-inline-list-icon-label\">Reject Docket</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('downloadDocket', itemEdit)\">\n      <md-button ng-click=\"downloadDocket(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Download Docket</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item >\n      <md-button ng-click=\"shareDocket(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Share Docket</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item >\n      <md-button ng-click=\"deleteDocket(itemEdit)\" class=\"md-list-item-content\" ng-if=\"userCanDoAction('deleteDocket', itemEdit)\">\n        <span class=\"md-inline-list-icon-label\">Delete Docket</span>\n      </md-button>\n    </md-list-item>\n  </md-list>\n</md-bottom-sheet>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "4L1n":
/***/ (function(module, exports) {

var path = 'views/pages/filing/mobile/detail.html';
var html = "<div class=\"mobileContainer filingContainer\" ng-show=\"viewState=='filing'\">\n  <!-- Docket Detail View -->\n  <div class=\"tableLayoutHelperContainer paddingWithoutTabBar\" ng-controller=\"filingDetailController\">\n    <div class=\"mobileDetailHeader new fixed {{docketFiling.filed ? 'Completed' : 'Draft'}}\">\n      <div class=\"headerLoadingSpinner\">\n        <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"15\" ng-show=\"backgroundLoadCount > 0\"></md-progress-circular>\n      </div>\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"cancelButtonHover\" ng-click=\"closeDocketFiling()\">\n          <div class=\"cancelButton\">\n            <div class=\"line1\"></div>\n            <div class=\"line2\"></div>\n            <div class=\"line3\"></div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n          </div>\n          <div class=\"middle\">\n              &nbsp;\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"saveDocketFiling(docketFiling)\" ng-show=\"(docketFiling.method != null)\"><span ng-show=\"docketFiling.dockets.length == 1 && docketFiling.dockets[0].existingDocketFile\">Re-</span>File</div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderLower\">\n          <div class=\"left\">\n            <span ng-if=\"docketFiling.dockets.length == 1\">File {{docketFiling.dockets[0].docketNumber}}</span>\n            <span ng-if=\"docketFiling.dockets.length > 1\">File Dockets</span>\n          </div>\n          <div class=\"right\">\n            <!--<div class=\"actionButton\" ng-click=\"openBottomSheet()\">\n              <md-icon md-svg-src=\"more_vert.svg\"></md-icon>\n            </div>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div my-loader text=\"Loading Docket File\" ng-if=\"docketFiling.loading && docketFiling.loadingType == 'getting'\"></div>\n    <div my-loader text=\"Saving Docket File\" ng-if=\"docketFiling.loading && docketFiling.loadingType != 'getting'\"></div>\n\n    <div class=\"tableCellHelperContainer\">\n\n      <h4 class=\"docketFiledHeading\" ng-show=\"docketFiling.filed && docketFiling.dockets.length == 1\">Docket Filed</h4>\n\n      <md-card class=\"filingDocketCard\" ng-if=\"docketFiling.method == null && docketFiling.resourceSummary && docketFiling.resourceSummary.length > 0\">\n        <md-card-header>\n          <h2>Select File Method</h2>\n        </md-card-header>\n        <md-card-content md-them=\"dbDarkBlue\">\n          <div class=\"dbButton rightMargin\" ng-click=\"changeFileMethod('split',docketFiling)\">\n            File Docket\n          </div>\n          <div class=\"dbButton\" ng-show=\"docketFiling.dockets.length == 1\" ng-click=\"changeFileMethod('lines', docketFiling)\">\n            File Lines\n          </div>\n        </md-card-content>\n      </md-card>\n\n      <md-card class=\"filingDocketCard\" ng-show=\"docketFiling.method == 'lines' && docketFiling.resourceSummary && docketFiling.resourceSummary.length > 0\">\n        <md-card-header>\n          <h2>File Lines</h2>\n          <md-button class=\"md-icon-button\" ng-click=\"docketFiling.method = null\">\n            <md-icon md-svg-src=\"lines.svg\"></md-icon>\n          </md-button>\n        </md-card-header>\n        <md-card-content class=\"noPadding\">\n          <div ng-repeat=\"line in docketFiling.linesSummary\" class=\"splitCodeItem\">\n            <div class=\"fileCodeRow\">\n              <div class=\"left\">\n                {{line.resource.name}} {{line.interaction.interactionTemplate.name}} {{line.quantity}} {{line.resource.uom.abbreviation}} - <strong>{{line.activityCode.fileCode}}</strong>\n              </div>\n              <div class=\"right\">\n                <div class=\"dbButton sml round grey\" ng-click=\"selectActivityForLine(docketFiling, line)\">\n                  <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n                </div>\n              </div>\n            </div>\n          </div>\n        </md-card-content>\n      </md-card>\n\n      <md-card class=\"filingDocketCard\" ng-show=\"docketFiling.method == 'split' && docketFiling.resourceSummary && docketFiling.resourceSummary.length > 0\">\n        <md-card-header>\n          <h2>File Docket</h2>\n          <md-button class=\"md-icon-button\" ng-click=\"docketFiling.method = null\">\n            <md-icon md-svg-src=\"lines.svg\"></md-icon>\n          </md-button>\n        </md-card-header>\n        <md-card-content class=\"noPadding\">\n          <div class=\"splitCodeItem\" ng-show=\"docketFiling.activityCodes.length <= 0\">No file codes selected</div>\n          <div ng-repeat=\"activityCode in docketFiling.activityCodes\" class=\"splitCodeItem fileRow\">\n            <div class=\"fileCodeRow\">\n              <div class=\"left\">\n                <span>{{activityCode.fileCode.fileCode}} - {{activityCode.fileCode.fileName}}</span>\n              </div>\n              <div class=\"right\">\n                <div class=\"dbButton round sml grey\" ng-click=\"selectActivityForSplit(docketFiling, activityCode)\">\n                  <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n                </div>\n                <div class=\"dbButton sml round red\" ng-click=\"removeSplitFileCode(activityCode)\">\n                  <md-icon md-svg-src=\"clear.svg\"></md-icon>\n                </div>\n              </div>\n            </div>\n            <md-slider-container>\n              <md-slider flex=\"\" min=\"0\" max=\"100\" step=\"5\" ng-model=\"activityCode.splitPercentage\" ng-change=\"updateSplitCodePercentages()\" aria-label=\"percentage\">\n              </md-slider>\n              <div flex=\"\" class=\"sliderPercentage\">{{activityCode.splitPercentage}}%</div>\n            </md-slider-container>\n          </div>\n          <div class=\"splitCodeItem centered\">\n            <div class=\"dbButton lightBlue\" ng-click=\"addSplitFileCode()\">\n              Add Another Code\n            </div>\n          </div>\n        </md-card-content>\n      </md-card>\n\n\n      <md-card class=\"filingDocketCard\" ng-show=\"docketFiling.dockets.length == 1\">\n        <md-card-header>\n          <h2>Docket Summary</h2>\n          <div class=\"docketDate\">{{moment(docketFiling.dockets[0].date).format('DD MMM YYYY')}}</div>\n        </md-card-header>\n        <md-card-content>\n          <table ng-if=\"docketFiling.resourceSummary && docketFiling.resourceSummary.length > 0\">\n            <tr ng-repeat=\"resource in docketFiling.resourceSummary\">\n              <td class=\"left\">{{resource.resource.name}}</td>\n              <td class=\"right\">{{resource.totalQuantity}} {{resource.resource.uom.abbreviation}}</td>\n            </tr>\n          </table>\n          <p ng-if=\"!docketFiling.resourceSummary || docketFiling.resourceSummary.length <= 0\">\n            This docket does not have any items. Add items before filing this docket.\n          </p>\n        </md-card-content>\n      </md-card>\n    </div>\n  </div>\n  <!-- End Filing Detail View -->\n</div>\n<div class=\"mobileContainer\" ng-show=\"viewState == 'activity'\">\n  <!-- Select Activity View -->\n  <div class=\"tableLayoutHelperContainer\" ng-controller=\"selectActivityController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeActivitySelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Activity\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"activitySearchValue\" ng-change=\"searchActivityChange(activitySearchValue)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/activityList.html'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n  </div>\n  <!-- End Select Activity View -->\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "4atT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').controller('companySettingsRolesController', ['userService', '$scope', 'Restangular', '$q', '$state', '$window', '$stateParams', 'accessControl', function (userService, $scope, Restangular, $q, $state, $window, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-Roles Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.roleEdit = null;
  $scope.mode = 'list';

  $scope.selected = [];

  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'name'
  };
  $scope.listCount = 0;

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /******* DATA ********/
  userService.getPermissions(null, function (allPermissions) {
    $scope.allPermissions = allPermissions;
    $scope.remainingPermissions = allPermissions;
  }, function (err) {
    $scope.allPermissions = [];
    $scope.remainingPermissions = [];
  });

  /*******************************/
  /***** Roles Functionality *****/
  /*******************************/

  $scope.loadRolesList = function () {
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      userService.getRoles(queryParams, function (allRoles) {
        $scope.allRoles = allRoles;
        if (queryParams.offset <= 0 && allRoles.length < queryParams.limit) {
          $scope.listCount = allRoles.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (err) {
        $scope.allRoles = [];
        reject('Error');
      });
    });
  };

  $scope.loadRolesList();

  function getRemainingPermissions(usedPermissions) {
    var remaining = [];

    for (var i = 0; i < $scope.allPermissions.length; i++) {
      var found = false;
      if (usedPermissions != null) {
        for (var j = 0; j < usedPermissions.length; j++) {
          if (usedPermissions[j].permission.id == $scope.allPermissions[i].id) {
            found = true;
            break;
          }
        }
      }

      if (!found) {
        remaining.push($scope.allPermissions[i]);
      }
    }

    return remaining;
  }

  $scope.newRole = function () {
    $scope.roleEdit = {};
    $scope.roleEdit.permissions = [];
    $scope.remainingPermissions = getRemainingPermissions([]);
    //$("#editRoleModal").fadeIn(100);
  };

  $scope.editRole = function (role) {
    $scope.roleEdit = angular.copy(role);
    $scope.roleOriginal = angular.copy(role);
    // populate permissions first
    for (var i = 0; i < $scope.roleEdit.permissions.length; i++) {
      for (var j = 0; j < $scope.allPermissions.length; j++) {
        if ($scope.allPermissions[j].identifier == $scope.roleEdit.permissions[i].permission) {
          $scope.roleEdit.permissions[i].permission = $scope.allPermissions[j];
          break;
        }
      }
    }
    $scope.remainingPermissions = getRemainingPermissions($scope.roleEdit.permissions);
  };

  $scope.closeEditRoleModal = function () {
    $scope.roleEdit = null;
  };

  $scope.saveRole = function (role) {
    role.loading = true;
    for (var i = 0; i < role.permissions.length; i++) {
      role.permissions[i].permission = role.permissions[i].permission.identifier;
    }
    userService.saveRole(role, function (roleUpdated) {
      $scope.closeEditRoleModal();
      $scope.loadRolesList();
    }, function (err) {
      role.loading = false;
      $scope.alertService.presentAutoAlert('saveRole', err);
    });
  };

  // Close configure view and open list view
  $scope.showItemList = function () {
    $scope.mode = 'list';
    $scope.roleConfigure = {};
  };

  // Remove a permission from a role
  $scope.removePermissionFromRole = function (permission, role) {
    var index = role.permissions.indexOf(permission);

    if (index != -1) {
      role.permissions.splice(index, 1);
    }

    $scope.remainingPermissions = getRemainingPermissions(role.permissions);
  };

  $scope.addUnusedPermissionToRole = function (permission, role) {
    var newPermissionToAdd = { permission: permission, deny: false };
    role.permissions.push(newPermissionToAdd);
    $scope.remainingPermissions.splice($scope.remainingPermissions.indexOf(permission), 1);
  };

  // Add a permission to a role
  $scope.addPermissionToRole = function (permission, denyPermission, role) {
    var newRolePermission = {};
    newRolePermission.permission = permission;
    if (denyPermission) {
      newRolePermission.deny = denyPermission;
    } else {
      newRolePermission.deny = false;
    }

    if (role.permissions == null) {
      role.permissions = [];
    }

    role.permissions.push(newRolePermission);
    $scope.remainingPermissions = getRemainingPermissions(role.permissions);
  };

  $scope.deleteSelectedRoles = function () {
    var count = $scope.selected.length;

    swal({
      title: "Are you sure?",
      text: count + " roles will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        userService.deleteBulkRoles($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkRoles', { status: 202, requestName: 'Delete bulk roles - failures ' + failures.length + ' of ' + $scope.selected.length });
            $scope.loadRolesList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkRoles', { status: 200 });
            $scope.loadRolesList();
          }
        });
      }
    });
  };
}]);

/***/ }),

/***/ "4uCk":
/***/ (function(module, exports) {

var path = 'views/settingsTemplate.html';
var html = "<div id=\"mainTemplateOuter\">\n\n  <div id=\"mainSectionContainer\">\n    <div id=\"header\">\n      <div class=\"tableLayoutHelperContainer\" ui-view=\"scopeNav\" id=\"scopeNav\"></div>\n      <!--<div class=\"blockLayoutHelperContainer\" ui-view=\"mobileNav\" id=\"mobileNav\"></div>-->\n    </div>\n\n    <div style=\"flex-grow: 1; flex-shrink: 1\">\n      <div id=\"contentOuter\" class=\"settingsContentOuter\">\n        <div class=\"settingsMiddleAligner\">\n          <div class=\"settingsOuterContainer\">\n            <div class=\"settingsLeftNav\" ui-view=\"navigation\">\n\n            </div>\n            <div class=\"settingsRightContent\" ui-view=\"content\">\n\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"bottomBanner\" ui-view=\"bottomBanner\"></div>\n  </div>\n</div>\n\n<ng-include src=\"'views/notifications/slider.html'\" ng-controller=\"scopeNavController\"></ng-include>\n<ng-include src=\"'views/modals/selectContactModal.html'\" ng-controller=\"selectContactController\"></ng-include>\n<ng-include src=\"'views/alerts/alertTemplate.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "5/bX":
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,AAEAAAATAQAABAAwRkZUTXDErzgAAAE8AAAAHEdERUYBFwAEAAABWAAAACBHUE9TteZfuwAAAXgAALUER1NVQhabKJgAALZ8AAAAQE9TLzJ2pI8kAAC2vAAAAGBjbWFw5cxCKgAAtxwAAAHiY3Z0IBdyEP0AALkAAAAARmZwZ21TtC+nAAC5SAAAAmVnYXNw//8AAwAAu7AAAAAIZ2x5Zt9hBsoAALu4AACTGGhlYWQL+b1IAAFO0AAAADZoaGVhEBgHkQABTwgAAAAkaG10eOU8SeYAAU8sAAADpmxvY2G/WJxIAAFS1AAAAdZtYXhwAgcBqAABVKwAAAAgbmFtZRaLZqcAAVTMAAACrHBvc3QZ1TLlAAFXeAAAAuVwcmVwVcAXjgABWmAAAAD9d2ViZojgVh0AAVtgAAAABgAAAAEAAAAAzD2izwAAAADSQ9MJAAAAANJDOV8AAQAAAA4AAAAYAAAAAAACAAEAAQDpAAEABAAAAAIAAAABAAAACgBCAFAAA0RGTFQAFGdyZWsAIGxhdG4ALAAEAAAAAP//AAEAAAAEAAAAAP//AAEAAAAEAAAAAP//AAEAAAABa2VybgAIAAAAAQAAAAEABAACAAAAAwAMEAxn+gABDzwABAAAAH0BBAEKARQBIgFEAWIBaAEUAYoB1AICAiQCLgI0AqIC/AM+A4gD2gQgBGIE7AU6BUAFbgWMBbIFyAX+BmAGZgZwBn4HIAcmByYHNAdCByYHJgZmB1AH2ggoCDIHNAhkCQYJGAmWCcgJ1gnoChYKJApOCmQGZgpyCngK2gs0C2YLfAuGC6ALvgvIC9YL4Av6DAAMBgwUDCIMOAw+BnAGYAZwBnAGcAZwByYMaAx+DJgGZgcmBmYGZgZmBmYGZgyyDMQHNAc0BzQHNAzODQANYg2gDaANpg2wDf4OVA6uDsQOxA7KDtAGcAzODvIPBA8WDvIPBA8WDxwCLg8qAAEACf+uAAIAGgAGAKH/8gADAK4ANwCwADcAsQA3AAgAFP/sABX/8gAW/9EAF/+8ABj/1wAa//IAG//lABz/5QAHABT/+gAW//IAF//yABj/8gAa//IAG//yABz/8gABABT/8gAIAAP/rgAU//IAFv/yABf/7AAY//IAG//8ADn/ewBZ/+wAEgAO/5MAFP/sABUABgAWAAYAF//DABj/1wAZ/8kAGgBIABv/8gA5ACMAOwAbAEr/3QBZ/9MAW//6AKH/8ACuAD0AsAAOALEAFAALABUABgAWAA4AF/9/ABoATAA5ACkAO//6AFkAIwBbAAYArgAOALAANwCxABsACAAM/5MAFP+8ABX/8gAW/+UAGv/sABz/8gA5/6gAO//bAAIASv/lAE0ADgABAEr/5QAbABL/PwAU/+wAFf/HABf/VgAY/90AGgA3ABv/yQAc/9cAOQApADsAFABZ/+UAW//XAKH/1wCi/1YApP85AKX/TgCm/1wAp/8zAKr/OQCt/zkArgCPAK//8gCwAD0AsQBMALL/MwC0/yMAuP8ZABYABv/dAAj/8gAJ//oADAAOABUAFAAWAAoAGAAKABoAFAAbAAoAHAAEAB//8gAgAA4AIQA9ACP/+gBCAA4AXwAOAGEADgBjAAYAeQAGAJkADgC5//oA5P/sABAADP/6AA0ABgASAAYAFAAKABYABAAX/+UAIAAGACEAPQA//+UAQgAbAGEABgBmAAYAcgAUAHMAFACZABsA5P/lABIABv/dAAj/8gANABQAEv/yABT/8AAV//wAGgAQACAABgAhADcAQv/sAF8AGwBhABQAaAAbAHIADgBzAA4AmQAOALkABgDk//oAFAAI//IADf/dAA4ABgAU//AAGv/yAB8ADgAgACkAIQA3ACL/+gA//+UAYQApAGgADgBs/7QAcv/sAHMADgB8/7gAmQAbALkABgDj//oA5P+BABEACP/yAAn/+gAM//oAEv/lABT/9gAaAAYAHwAOACAAFAAhACkAI//6AD//+gBC/+wAYQAUAGz/9gByAA4AuQAGAOT/5QAQAAb/5QAMAAYADQAGAA4AFAAU//IAFgAEABoADgAgABQAIQAbACP/8gA///IAQv/dAGEAFABoAAYAuQAGAOT/8gAiAAQABgAG/64ACf/6AAz/+gANAC8ADv+gABL/dwAUAAoAFQAGABYAEAAX/54AGP/nABoAPQAcAA4AH/+8ACAABgAhAEQAIgApACP/8gA/ADcAQv9OAF8AKQBh/7QAY//6AGcAGwBoACkAcgBEAHP/8gB5/8MAfAAOAIH/dwC5/9cA4//lAOQAKQATAAb/8gAI//oACf/lAAz/8gAOAAYAFP/2ABYABAAX//wAGP/8ABz//AAgAAYAIQAUAD//sgBC/+UAYQAGAGX/5QC5AAYA4//6AOT/5QABAE0ADgALABQANwAVAD0AFgApABcADgAYACkAGgCBABsAPQAcADcAOQAGADsABgBZABQABwAU//IAFwAGABgADgAa//IAOf/XADv/5QBZAAYACQAU/90AFf/yABb/5QAXAAYAGv/yADn/wwA7/7QAWf/6AFv/+gAFABQADgAX/+UAGgA3ADv/+gBZABsADQAU//oAFf/2ABb/8AAX/+wAGP/6ABoABgAb//oAOf/JADv/xwBZABQAWwAEAKH/8gCwAAYAGAAJ/+UADv/6ABL/5QAgAAQAIQAZADn/+gA7//wAP//DAEL/8gBZ//oAXv/yAGEABABj//oAbP/sAHT/+gB1//oAef/8AHz/8gCB/9EAof/hALAABACxAAQA3f/yAOT/5QABALAAGQACALAABACxAAQAAwCuABkAsAAOALEACgAoAAn/0QAMACkADQAUAA7/3QAS/38AH//6ACD/+gAhABsAIgAUACP/7AA5AAoAOwAKAD8ANwBBAA4AQv9OAFn/2wBb/+EAXv/lAF8AKQBh/9cAY//yAGgAGwBpABsAbP/sAHQADgB1AA4AeAAbAHn/+gB7AA4Agf9qAJn/+gCh/9MApf+8AK4ATACv//IAsAA3ALEAOQC5//wA3f/lAOQAHwABALAABgADAK4ADgCwAAYAsQAOAAMArgAGALAADgCxAAYAAwCuAC8AsAAQALEAKQAiAAn/0QAM//oADQAUAA7/yQAS/2oAH//yACEAKQAiACkAI//6ADn//AA7/+wAP//yAEL/TgBZAAQAXv/XAGH/1wBpAA4AdAAOAHgAIwB5/90AewAOAIH/VgCZAA4Aof/bAK4AFACwAEgAsQA5ALn/8gC7/9cAvP/XAL3/1wC+/9cA3f/dAOT/+gATAAT/+gAJ//IADP/dAA4ABgAfABQAIAAGACEAIwA5/8kAO//bAD//rgBBAAYAWwAGAGEABgBj//oAmQAGAKH/5wCwAAQAuQAGAOT/1wACALAAGwCxAAoADACi/6oApP+WAKX/pACm/64Ap/+BAK4AUgCv/7IAsAAvALEAUgC9/3sAvv+BAMH/mgAoAAn/rgAMACMADQApAA7/qAAS/2oAH//DACD/1wAiAA4AI//JADkAFAA7ABQAPwApAEH/+gBC/4UAWf/lAFv/8ABe/8MAXwAjAGH/qABj/8MAaAAjAGn/+gBs//IAdAAbAHUAGwB5/7wAewApAHz//ACB/2oAmf/sAKH/zQCl/5oAqv+LAK4ARACv//IAsAAbALEAPwC5/7wA3f+oAOQAKQAEAK4APQCv//YAsAAjALEATAAfAAn/1wAMABsADf/6AA7/2wASABQAH//JACD/5QAi//oAI//HADkAFAA/ABQAQf/yAEIAIwBZ/80AWwAfAF7/wwBfACMAYf/RAGP/+gBoABQAbP/sAHj/+gB5/7wAfP/sAJn/5QCh//IArgBEALAAFACxAB8Auf/dAN3/tAAMAKL/cQCk/3cApv+BAKr/TgCt/04ArgBSAK//tACxACkAsv9SALT/YAC3/0QAuP9gAAMArgApALAAGwCxABsABAAZ/+wArgBgALAADgCxACMACwAU//IAFQAUABb/8gAX/+UAGP/6ABr/+gAb/90AOf9qADsAFABZ/9cAWwAUAAMAOf/6ADv/8gBZAA4ACgAU/90AFv/6ABf/hQAY//IAG//lABz/8gA5/4UAOwAjAFn/rgBbADcABQBMAAYATQApAK4AUgCwAD0AsQBCAAMArgAGALAABgCxAAYAAQDk/90AGAAJ/+wADP/TAA0AIwAS/8kAH//6ACAABgAhABQAIgApACMADgA//9cAQQAOAEL/rgBZAAYAWwAOAF8ADgBj//oAaAApAGkADgB4AC8AfAAKAIH/yQCZAA4Auf/6AOT/+gAWAAn/5QAM//oADQAGABIAKQAf//oAIgAOACMABgA//7wAQgA3AFkADgBbAAYAXwAjAGH/+gBjAA4AaAAGAGz/+gB4AAYAef/sAIEABgC5//oA3f/6AOT/7AAMABn/7ABE//YAov/2AKP/9gCk//YApf/2AKb/9gCn//YAqP/2AK4AYACwAA4AsQAjAAUAGgApADkAIwA7ACMAWQAOAFsAIwACADn/8gA7//IABgAU/+wAFf/yABr/0QA5/6gAO//RAFv/+gAHABT/+gAaAAYAOf/DADv/+gBZ//oAWwAOAKH/+gACABT/+gAW//IAAwAVAAYAFgAOABcADgACABf/8gAaADcABgAaAA4AG//yADkAIwA7ABQAWQApAFsABgABADn/+gABABb/8gADABQAIwAX/8kAGgBMAAMAFP/yABb/8gAa//IABQAU/9EAGv/dADn/vAA7/7wAW//sAAEAGgAOAAoAFP/RABb/3QAX/7wAGP/sABr/8gAb/+UAHP/sADn/YABZ/7gAof/sAAUAjgB7AJEARgCuAA4AsAAGALEADgAGAI4AKQCQAFIAkQA3AK4ADgCwAAYAsQAOAAYAjgA3AJAALwCRABsArgAOALAABgCxAA4ABAAU//IAOf/sADv/5QBZAA4AAgCwAAYAsQAGAAwAov9xAKT/dwCm/4EAqv9OAK3/TgCuAFIAr//RALEAKQCy/1IAtP9gALf/RAC4/2AAGAAJ/+UADP/lAA4ABgAS/5oAHwAGACAABgAhABQAIgAOACMABgA5/90AO//JAD//oABBAAYAQv+0AFkADgBbAA4AYQAUAHkADgCB/7wAmQAGAKH/5QC5AAYA3QAGAOT/vAAPAAn/+gAMABsAEgAOACAABgAhACMAP//XAEIADgBZ//oAbP/XAHz/7ACh/+wAsAAEALEABAC5AAYA5P/sAAEAP/93AAIAP//RAOT/7AATAAQABgAFADcACgA3AAwARAANAAYAIgAjAD8AgQBAAGAATAAGAF8AFABgAGAArgCPALAAUgCxAGoA1wA3ANgAbQDaADcA2wBtAOQAGwAVAAQABgAFADcACf/6AAoANwAMAA4ADQBEACIAWAA/AC8AQAAOAEwACgBNAAYAXwAOAGAADgCuABQAsABvALEAdwDXAFIA2ABEANoAUgDbAEQA5AAOABYABAAGAAUANwAJ//oACgA3AAwAFAANAD0AIgBMAD8ALwBAACMATAAOAE0ADgBfAA4AYAAjAKUABgCuAGYAsABmALEAbQDXAEQA2ABMANoARADbAEwA5AAbAAUAP/+gANf/vADY/7wA2v+8ANv/vAABAD//QgABAD//PQAIABT/3QAW/90AF//yABr/8gA5/7wAO//dAFn/+gBb//oABACuAFIAsABEALEATACy/6oABACuACkAsAA3ALEAKQCy/3EAAQBKABQAAwA5/6gAO/+0AFv/+gAEABUABgAWAAYAF//lABoAIwACACAAAwALAAAADQAPAAkAEQASAAwAFAAbAA4AHgAjABYAJQAuABwAMAA1ACYANwA/ACwAQQBCADUASQBJADcATABMADgATwBPADkAVABUADoAWQBZADsAWwBbADwAXgBhAD0AYwBlAEEAZwBpAEQAbgBuAEcAcgBzAEgAeQB5AEoAfAB8AEsAgQCBAEwAiAChAE0AqwCrAGcArQCyAGgAtQC1AG4AtwC5AG8AwgDCAHIAxADEAHMA1wDeAHQA4wDjAHwAAlfAAAQAAFRgVe4ATACOAAD/M/+o/3//TgAvAAYAN/9/AAQAGwAj/+wAI/8z/2IAGwA3/04ARAAb/zP/3f+BACn/wwAp//IANwApACn/jwA3/9H/fwAjAA4AGwAb/3f/Jf8z/9P/rv/X/xD/3f8zAD3/PQA9/3H/yQAO/+X/7P/yACP/MwA3/3H/yQAE/83/vAAQ/yX/TAA3/3f/e/+F/2D/cQAj/zMAPf8zACP/8v9S/5P/vAAU/8P/Gf9qADf/vP/y/6AAKQAp/uf/mv/yABv/XAAbACn/d//JABv/M//JACMAKQAG/5r/cf+8ACkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+gAAAAAAAA/+cAAAAjAAAAAAAAAAAAAAAAACP/QgAAAAAAAP/N/6gAKQAAAAAAAAAAAAAAFP+gAAD/8v+FAAAAAAAjAAD/5f8fAAD/zf/bAAD/fwAAAAAAG/+FABT/tP/8AAAAAP/XAAAAAAAAAAD/oP/yAAAAAAAAAAAAAP+uAAAAAP+JAAD/hQAAAAAAAAAAAAAAAAAA/4kAAAAAAAAAAAAA/4UAAAAAAAAAAAAAAAD+5QAAAAAAAAAAAAAAAP+uAAAAAAAAAAAAAAAAAAAAAP+8AAAAFP/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/cf+g//L/vAAOAAAAN//nAAAAGwAj//oAAP+T/8kAAAAb/1YAKQAA/3H/0f/DACn/+gAOAAAANwAUABT/5QAA//r/vAAAAAQAGwAb/+z/Qv9O/9P/9v/6/67/5f+aACP/tAAj/+z//AAOAAD/8gAAAAD/QgA3/67/7AAA/9f/0QAU/2r/vgAp/9f/qP/8/6j/dwAG/2IAAP+FAAAAAP/D/8P/0QAA/+z/M/+TABv/yQAA/9cAAAAj/wr/0wAAABv/dwAAAAD/w//dABv/Yv/DAAAAFAAA/8n/1//lABT//P/8AA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5MAAAAAAAD/zQAAABsAAAAAAAAAAAAAAAAADgAAAAAAAAAA/9H/hQAQAAAAAAAAAAAAAAAU//IAAP/s/5MAAAAOABsAAP/T//oAAP/HAAYAAP9cAAAAAAAO/74ADv/D//oAAAAA/7wAAAAAAAAAAP/R/93//AAAAAAAAAAA/9cAAAAA/+wAAP/dAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAD/1wAAAAAAAAAAAAAAAP/DAAAAAAAAAAAAAAAA//wAAAAAAAAAAAAAAAAAAAAA//IAAAAU//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/H/9x/6T/VgAA//oADv+k//wAGwAU/+UAAP8l/1wAAAAO/x8AGwAA/wT/qv9xACn/wwAb/+UADv/6ABT/dQAb/9v/TgAAAAYAGwAA/5b+9v72/6D/rv/y/zP/8v8QABv/PQAb/6j/yQAO//L/vP/lAAD/BAAp/1L/yQAA/6D/pAAU/vz/ewAO/3//av+8/0j/MwAA/xn/8v9IAA7/5f9q/4v/wwAA/7z/BP9WAA7/yf/l/3cAAAAU/rz/k//6ABv/OQAAAAD/f/+uABv/H/+aAAAAFP/l/3//df+FABT/4f/yAAAADv/y/+X/8v/y//L/5f/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABv//P+8AAYAAAAj/+UAAAAAAAb/+gAAAAD/5QAAAAAAAAAAAAAAAP/h/5oAIwAGACkAAAAjAAAAAAAAAAAAAP+0AAYAAAAAABT/9gAAAAD/1wAAAAD/yQAGAAAAAP/yAAAAAAAKAA4AAP/6AAAAAAAAACP/8gAAAAD/7P/6AA4AAP/yAAb/+gAAAAD/+gAGAAYAAAAG/+UAAAAAAAD/8P/6AAAAAAAAAAAAFAAAAAD/9gAAAAYAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/5QAA//IABgAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//L/yQAAAAAABgAAAAAAAAAA/90AAAAAAAAAAAAAAAAAAP/X/7wAAP/yAAAADv/hAAYAAAAAAAD/+v/XAAD/8gAvAA4AAP/2/90AAAAA/9f/8gAEAAAAGQAAAAD/+gAAAAr/+v/6AAoAAAAEAAAAAAAA/90AAAAA//oAAAAA//L/0wAAAAD/wwAG/9EABAAA/8kABv/6AAD/0QAAAAAAAAAGAAAAAAAG/7wABgAAAAAAAAAAAAAAAP9qAAYAAP/d/7wAAAAAAAD/+v/d//oAAAAA/9MAAAAAAA7/5f+uAAQABgAGAAAAAAAAAAD/+gAGAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/R/+cAAAAAAAAAAP/lAAD/5QAA//oAAAAAAAAAAP/l/93/agAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+f/3f/6AAAAAAAGAAAAAAAA/9cAAP/R//oAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAD/+gAA//r//P/yAAAAAP/wAAD/7AAA//r/1wAAAAAAAAAAAAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7AAAAAAAAP/6/93/+gAAAAAAAAAAAAAAAP/lAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8AAAAAAAAAAAAAAAAAUv9xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/90AAAAG/9cAAAAAAAAAAP/y/04AAAAAAAAAAP/JAAAAAABS/4sATAAAAAAAAAAAAAAAAAAAAAAAAP+LAAAAAAAAAAAAAAAA/7wAAAAAAAAAAP+aAAAAAAAAAAAAAAAAAAD/kwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/7wAAAAAAAAAAAAAAAAAAAAA/9EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAv//YAAP/6AAD/1//nAAD/+gAA/93/8gAA//wAAP/yAAD/hQAAAAAAAAAAAAAAAP+6/+X/1//XAAD//P+u//wAAP/yAAAAAP/y//oAAAAAAAAAAAAAAAD/8gAA/9f//v+0AAAAAP/yAAAAAP/l//IAAP/lAAAAAAAA/+wAAAAAAAD/8P+BAAAAAAAAAAAAAP/6AAD/mgAA//L/5f/8AAAABv/yAAAAAAAA//oAAP/lAAD/8gAAAAAAAAAAAAAAAP/6//IAAAAA//oAAAAA//IAAAAAAAAAAP/dAAAAAAAAAAD/5f/y/+X/5f/lAAD/8gAAAAD/5f/y/+X/5f/l/+X/5f/y//L/5QAAAAAAAAAAAAAAAAAAAAAAAP/y/9H/4QAA//oAAP/J/9MAAP/JAAD/5f/lAAAAAAAA/9H/5f85/+UAAAAAAAAAAAAA/67/5f/J/7wAAP/y/+X/+gAA/8kAAP/l/+X/5//d//IAAP/6ABsAAP/XAAD/rgAA/67/+gAA/+UAAAAA/+X/5f/y/+UAAAAAAAAAAP/6AAAAAP/6/38ABgAA/+EAAP/lAAYAAP+g/+X/5f/lAAAAAAAA/+UAAP/XAAAAAAAA/+UAAP/lAAAAAAAAAAD/5f/RAAD/5QAA//L/yQAAAAD/5QAA/+UAAAAA/90AAAAAAAAAAP/l/+X/5f/X/9MAAP/lAAAAAP/l/+X/5f/l/+X/5f/l//L/5f/l/9f/5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+gAAABsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8AAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAA//IAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/y//AAAAAAAAD/8v/wAAD/8gAAAAAAAAAAAAAAAP/s//D/agAAAAAAAAAAAAAAAP/XAAD/8v/lAAAAAAAAAAD//P/6AAAAAAAA//D/+gAAAAAAAAAAAAD/8gAA/+X/9v/XAAAAAAAAAAAAAAAAAAAAAAAA//YADgAA//oAAAAAAAD/8v+oAAAAAP/y//b/7AAAAAD/mgAAAAAAAP/6AAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/3QAAAAAAAAAA/+wAAAAAAAAAAAAAAAAAAP/lAAAAAAAAAAD/5QAAAAD/7P/nAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAP/6AAAAAAAAAAAAAP/6AAYAAAAAAAAAAAAA//z/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAD/+gAA//IAAAAAAAAAAAAAAAAAAP/6//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8v/sAAAAAAAAAAD/8AAA/+UAAAAAAAAAAAAAAAD/5f/s/2oAAAAAAAAAAAAAAAD/1wAAAAD/1wAAAAD/ugAAAAD/0QAA//IAAP/y/+UAAAAAAAAADgAA//IAAP+uAAD/tAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAA/+z/agAAAAD/8gAA/9cAAAAA/5oAAAAAAAAAAAAAAAAAAAAA/90AAAAAAAAAAAAAAAAAAAAAAAYAAP/y//b/+gAAAAD/+v/dAAAAAAAAAAD/8gAAAAD/3QAAAAAAAAAA/+UAAAAA/9f/3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/R/8kAGQAAAGAALwBgACkAAAAvAD0ALwA3/9f/8gAvAGb/oABEAET/0QAAAAAAAAApAEQARABgAFIAAAAOADcAGf/yADcAAAAAAFIAGf+L/8MAAAAjAA7/7AAG/90APf/hAFgADv/8AEQAAAAUAEQAN//JAGD/8AAGAAAACgAAAAD/3f/6ADf/8gAAABv/4f/DAFL/wwBMAAAANwBE/+z/8gAAADcAAP+8AAAAYAAAAEQAAAA3AFIAAAAAACMAAP/lAEwANwAAAAYAN//J//IANwAAADcABgAGAAAAAAAAAAAATABEAD0ARAAOAAYALwBEAAAAAABEAEQARABEAEQARABEACMARABEAAAARAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//wAAAAAAAD/+v/2AAD/8gAA//IAAAAAAAAAAAAAAAD/oAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAP/yAAD//P/6AAAAAAAA//b/+gAAAAAAAAAA//L/+gAA/+wAAP/6AAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAD/+gAAAAD/9v/DAAAAAAAAAAAAAAAAAAD/wwAAAAAAAP/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAP/lAAAAAAAAAAD/5QAAAAD//P/bAAAAAAAAAAAAAAAAAAAAAAAA/+UAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAA/+UAAAAAAAAAAAAAAAAAAP+8AAAAAAAAAAYADv/TAAAAAAAAAAAAAP/dAAAAAAApAAAAAP/w/+UAAAAO/7wAAAAGABsAAAAAAAAAAAAAABD/8gAAACMAAAAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAA//wAAAAA/7QAAP/6AAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAD/8AAAAAAAAAAAAAAAAP8QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAP/DAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//YAAP/2AAAAAP/2AAAAAAAAAAAAAAAAAAAAAP/6AAD/dwAAAAAAAAAAAAAAAP/JAAAAAP/yAAD//P+6AAAAAP/dAAAAAAAA//wAAAAAAAAAAAAAAAD/8gAA/6AAAP+8AAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAA//L/8gAAAAD/8v+LAAAAAAAAAAAAAAAAAAD/mgAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8AAAAAAAAAAAAAAAA//wAAP/yAAAAAAAAAAAAAAAAAAD/8v/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/lAAD/8gAAAAAAAAAAAAAAAP/6/64AAAAAAAYAAAAAAAAAAP/RAAAAAAAA//oAAAAAAAD/vP/DAAD/+gAAAAD/3QAAAAAAAAAAAAD/1wAAAAAAAAAAAAD/8P/RAAAAAP+8/+UAAAAAAAYAAP/l//oAAAAAAAD/+gAGAAAAAAAAAAAAAP/6AAAAAP/sAAAAAP/b/9H/8gAA//IAAP/HAAAAAP+uAAb/8gAA/7QAAAAA//oAAAAAAAAABv/lAAAAAAAAAAAAAAAAAAD/SAAAAAD/0f+uAAAAAAAAAAD/0f/yAAAAAP/TAAAAAAAA//L/qgAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAA//r/pgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAP/6AAAAAAAGAAAAAAAAAAQAAAAAAAAAAAAAAAAAAP/6AAAAAP/6//YAAAAAAAAAAP/6AAAAAAAAAAAARgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAD/8gAAAAAAAAAOAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//wAAAAAAAAAAP/2AAD/+gAAAAAAAAAAAAAAAAAAAAD/hQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//wAAAAAAAAAAAAA//IAAAAA/+z//P/y//oAAAAAAAAAAAAAAAAAAAAA//wAAAAA//z/8gAAAAD//P+0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAA//oAAP/lAAAAAAAAAAAAAAAAAAD/+v/2//IAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAET/7AAAABsAAAAAAAAAAP/yAAAAAAAAAAD/3QAAAAAAI//DAAAADgAAAAAAAAAbAAAAAAAA//IAAP/wAAAAAP/DAAAAAAAAAAAAAP/6AA4AAAAGAAD/vAAAAA4AAP/RAAYABgAEAAAAAP/6AAAAAAAOAAD/1wAAAAD/9gAAAAAADv/2/8n/5QAAAAD/8gAUABsADgAAAAAAAAAA/+X/5QAAAAAAAAAOAAAAAP/yAAD/0QAAAA4AAP/sAAAAAAApAA4AAAAAAA7/8gAOAAAAAAAAAAD/+gAA/+UAAAAAAAAAWAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/93/5f/s/90AAAAAAAD/5f/s//oAAAAAAAD/8gAA//IAAP/s/8MAAP/y//b/5f/yAAAAAAAAAAAAAP/dAAAAAP/y//oAAAAA/+wAAP/s/93/yf/w//IAAP/d/+z/+v/6/9v/+v/6//AAAAAA//oAAAAA/8kAAP/b//r/+v/X/9f/0//X/9f/7AAA/83/8P/l/8kAAP/yAAD/rv/6AAD/3f/6/+UAAAAA/5oAAAAA/+UAAAAAAAAAAP+PAAAAAP/s/8MAAAAA/+cAAP/s/+wAFAAA/+UAAAAA//L/3f/HAAAAAAAOAAAAAAAA//r/3f/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/d/64AAAAAAAYAAAAAAAD//P/RAAAAAP/X/+UAAAAAAAD/mv+uAAD/yQAAAA7/0wAG/+UAAAAA//r/0wAA/8kALwAAAAD/7P/RAAAAAP+8/4UAAAAEAAr/8v/y/93/5QAE/+z/7AAQAAAAAAAOAAD/1/+gAAAABP/sAAAAAP/w/7j/vAAA/7wAFP/DAAAAAP/DAAb/yQAA/5P/1wAAAAAABgAA/9cABv9qAAAAAAAAAAAABv/lAAD/cQAGAAD/0f+uAAD/1wAA//r/0f+0AAD/5f/N/+UABgAA/8n/oP/6AAAAFP/yAAAAAAAA/+wAFAAAAA4AAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAA//r/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+X/1wAGAAAAAP/lAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+v/yAA4AAAAAAAAAAAAAAAQAAAAAAAD/+gAAAA4ADgAA/+cAAAAA//oAAAAA/9cAAAAA//r/4QAA//L/+gAAAAAAAAAAAAAAAAAA/+EAAAAA/93/4QAEAAD/5wAAAAAAAAAA/+EAAAAGAAAABgAAAAAAAP/s//r/1wAAAAAAAP/lAAD/0QAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7AAAAA4AAAAAAAAABAAAAAD/+v/yAAYAAAAAABsAAAAAAAD/7P/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/5QAAAAAAAP/TAAYAKQAAAAAAAAAAAAAAAAAp/4UAAAAAAAD//P/6AEQAAAAAAAAAAAAAAAr/+gAAAAD/5QAAABsAGwAA/9v/LQAA//b/5QAA/9cAAAAAABT/vAAj/+z/8gAA//oAAAAAAAAAAAAA/7z//P/6AAAAAAAAAAD/qgAAAAD/mgAA/7IAAAAAAAAAAAAAAAAAAP+4AAAAAAAAAAAAAP+yAAAAAAAAAAAAAAAA/x8AAP/2AAAAAAAAAAD/wwAAAAAAAAAAAAAAAAAAAAD/4QAAAAoAAAAGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAA//oAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAA/8MAAAAAAAD/+v/wAAAAAAAAAAAAAP/lAAAAAAAjAAD/+gAA//oAAAAAAAAAAAAAAAAAG//s//oAAP/yAAD/+v/6AAAAAAAAAAAAAAAAAAAAAAAA//oAAAAA//r//AAA//r/5QAGAAAABAAAABsAAAAA//oAAAAAAAAAAAAA/+UAAAAA//oAAAAA//IAAAAAAAAAAP/yAAAAAP/6AAYAAAAAAAD/+v/6AAAAAAAA/90AAAAAAAb/3f++AAAAAAAjAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/3f/lACMAAAAvAAAAAAAjAAAAFAAOAAAAAP/lABQAAAAb/9f/zQAA/9cAAAAAAAAAAAAAAAAAAAAUAAAAKQAAACX//AAbAAAAAAAAACP/Vv+0AAAADgAA//oAAP/lABsAAAAOABsAIwAAAAAAGwAAAAD/0QAA//wAGwAAAD3//AAA/8P//P/yAAAAAAA3//z/1wAv/90AG//sAAAAAAAAAAAAAAAAAAD/oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/3QAUAAAAAAAOAAj/3QAAAAAAAAAAACMABv/yAAAAAAAAAAYAAAAAAAAAAP/8AAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/XAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8//IAAAAAAAAAAAAAAAAAAAAAAAD/7P/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8AAD/wwAAAAD/+v/y//IAAAAA//wAAAAAAAAAAAAAAAAAAAAA/9cAAP/6AAAAAP/y//YAAAAAAAAAAAAAAAAAAP/6/9cAAP/dAAAAAAAAAAD/+gAA/9cAAAAA/8kAAAAA/9cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/90AAAAAAAAAAAAAAAD/+gAAAAAAAAAOAAAAAAAA//r/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/yf/dACMAGwBEAA4AAAApAAQAGwA9AAAAAP/dAAYALwBE/8n/3QAA/8MAAAAAAAAADgAAAAAAAABSAAAAFP/yAC8AAAApAAAAAAAAABv/Vv/DAAAAGwAAAAAAAP/RAC//+gAGADcALwAAAAQAPQAAAAD/yQAA//IAAAAAAC8AAAAA/8kABgAAAAAAAAA3//r/5QBE/8kAKf/6AAAAAAAGAAYAAAAAABT/tAAAAAAAAAAAAAYAAAAvAAAAFAAEAAD/8gBYAAAABAAj//L/yQAAAAAAAAAAAAYABv/sAAAAAAAAACMAAAAAAAAADgAAABsAAAAAAAAAAAAAAAAAAAAAAAAAAAAvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAA//IAAP/6AAAAAAAAAAAAAAAA//IABP+FAAAAAAAAAAAAAAAAAAAAAAAA/+wAAAAAAAAAAAAA//oAAAAAAAD/8gAAAAAAAAAEAAD/8v/6AAD/7P/6/+UAAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAP/2AAAAAP/2/6AAAAAA//b/+gAAAAAAAP+8//IAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAD/8AAAAAYAAAAAAAD/+gAA//IAAAAAAAAADgAAAAAAAP/d/9cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKQAAAAAAAAAAAAAAAAAAAAAADv/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAApAAYAAAAAAAAAAAAp/+UAAAAAACkAAAAGAAAAAAAAAAoAAAAAADMAAAAAABsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9AA4AAAAAAAAAAAAU/+cADgAAAAAAAAAAAAAAAAAGAA7/+gAAAAAAAAAAAAAAAAAAAAAAAAAUAAAABgAAAAAAAAAUAAAAAAAAAA4AAAAAAAAALQAAAAAAAAAA/93/+v/yAA4AAAAAAAQABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAvAAAABgAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAAAALwAOAAD/8gAGAA4AAAAAAAAAAAAAAAAAFAAAAAAAAAAAABsAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/d/90AAP/lAAD/8gAUAAAAAP/6AAD/7AAA/+X/1wAAAAD/rv/6AAD/0QAAAAAABAAAAAAAAAAUAAAAAP/2AAAAAP/6AAAAAP/6ABQAAP/D/6gAAAAA//r/5QAA/9cAAP/2AAD/+gAAAAAAAAAAAAAAAP+0ABT/9v/6AAD/8v/l//z/w//6//r/+v/HAAD/9v/DAAD/3QAA/5oAAAAA//z/+v/RAAD//P+g//wAFP/XAAD/+gAAAAD/av/6AAD/+v/DAAAAAP/2/+X/+v/JAAAAAAAAAAD/7P/8/+wAAAAAAAAAAAAAAAAAAP/6//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAA//wAAAAAAAAAAAAAAAAAAAAA/64AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAP/6//r/7AAAAAQAAAAAAAAAAAAAAAAAAP/6AAAAAP/2//YAAAAA//r/0QAAAAAAAP/6AAAAAAAA/9cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/2AAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAA/+X/3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAv/4//dwAAAAAAAP97AAAABgAA/9H/0f/y/6D/5QAAAAAADv/6AAD/yf9xAAT/7P/l/9EAAP/y/+z/7P/d/7L/bf/sAAYABv/6/54AAAAA/5MAAP/6/3//yQAA//r/sv/s/8f/0wAAAAD/i//R/64AAAAA/67/1//w/5r/wwAAAAD/jwAG/3//8v/y/9EAIwAAAAD/vP+6/93/0f/b/7T/k//D/64AAP/sAAD/qP/R/4v/wwAA/7r/wwAAAAYAI//l/8P/5QAAAAYAAP/s/93/7P+F/67/7P+gAAD/5//sABT/+v/6/9H/vP+u/9f/0QAAAAD/+v/d//r/+v/R//r/+gAA/93/+gAA/+wAAAAAAAD/1//yAAAAAAAAAAAAAAAAAAAAAAAAAA4AAP/yAAAAAAAAAAAAAAAAABv/oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAI//sAAAAAAAAAAAABv9WAAAAAAAOAAD/8gAAAAAAAP/hAAAAGwAlAAAAAAAGAAAAAAAAAAD/4QAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABE/6j/yf/yAAD/k/+gAAAADgAb/6D/hQAA/90AAP9qADf/XP+FAAD/3f/J/3EABv+F/4X/k/9x/54AAP+F/9f/w/+aABQADv+g/7IAFAAA/8cACgAA/9cAAAAO/3f//P9iAAD/7P+FAAD/3f+F/3cAAP+g//oAAP/s/+H/+gAAAA7/3f8Z/7oAGwAA//oANwAAAAD/QgAA/4X/hQAG/93/yf93/+wAAAAl/5P/1/+T/8P/dwAbAAD/+gAGAAAATP+g/4UAAAAAAA4ADgAO/4X/f/8z//IACv/X/3UABAAAABT/hf+F/4X/d/93/6j/hQAAAAD/hf+F/4X/hf+F/4X/hQAA/4X/hQAA/64AAAAAAAD/5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/7T/rgAGAAAAPQAAAAAABgAA/9cAIwAAAAD/1wAAAAAAG/+o/9EAAP+0AAAAAAAAAAYAAAAAAAAABgAAAAAAAAAj//IADgAAAAAAAAAA/6j/kwAAAAoAAP/nAAD/vAAG/+cABgAAACMAAAAAAA4AAAAA/6AAAP/nAAAAAAAZ//wAAP+0AAD/+gAAAAAABv/n/8kATP+oACP/8gAAAAD/+v/8AAAAAAAA/38AAAAAAAAAAP/6AAAAIwAA//oAAAAA/9EADgAAAAD/+v/R/6D/+gAAAAAAAAAAAAD/3QAAAAAAAAAOAAAAAAAAAAoAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAP/6AAAAAAAAAAAAAAAAAA4AFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAADv/bAAAAAAAAAAAABgAAAAAAAAAjAAD/5QAAAAD/+v/hAAAAAAAbAAAAAP/6AAAAAAAAAAD/5QAAAAAAAAAAAAAAAP/2AAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAA//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+o/5oABgAAAC8AAAAAAAYAAP/lABsAAAAA/64AAAAGABT/d//DAAD/oAAAAAAAAAAOAAAAAAAAAA4AAP/2AAAAFP/RABQAAAAAAAAAAP8t/38AAAAA//z/5QAA/64AAP/TAAAAAAAbAAAAAAAGAAAAAP+FAAD/0wAAAAAADv/8AAD/i//2AAAAAAAAAAD/2/+0AC//mgAU/+wAAAAA/+EAAAAAAAAAAP9OAAAAAAAAAAAAAAAAABsAAP/6AAAAAP/RAA4AAAAA//r/5f+aAAAAAAAAAAD/+v/w/9cAAAAAAAAAFAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAEAAAAGwAAAAAABAAAAAAAGwAAAAAAAAAAAAAAAAAG/7IAAAAAAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAQAAAAAAAAAAAAAAAEAAAAAAAAAAQADv/wAAAAAAAA//wAAAAAABQAAAAAAAAAAAAAAAAAAP/wAAAAAAAAAAAAAAAAAAD/+gAAAAAADgAAAAYAGwAAAAAAAAAAAAAABgAGAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAA4ABgAAAAAAAAAAAAAABgAAAAAAAAAAAAD/8gAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/5QAAAAAAAAAO//D/+gAAAAAAAAAAAAAAAAAU/4UAAAAAAAAAAP/yAAAAAAAAAAAAAAAA//YAAAAAABT/7AAA//L/8gAAAAD+9gAAAAD/8gAA/8kAAAAAAA7/uAAUAA4ADgAAAAAAAAAAAAAAAAAA/7wADv/8AAAAAAAAAAD/1wAAAAD/iQAA/7wAAAAAAAAAAAAAAAAAAP/RAAAAAAAAAAAAAP93AAAAAAAAAAAAAAAA/s0AAP/6AAAAAAAAAAD/5QAAAAAAAAAAAAAAAAAAAAD/1wAA/+wAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//wAAAAAAAAAAP/6AAAAAAAA//oAAP/dAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7/2wAAAAAAAAAAAAD/0wAAAAAACgAAAAAABP/dAAD/+v/dAAAAAAAEAAD/+gAAAAD/5QAE//L/5QAGAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAP/8AAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAD/7AAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/qAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+UAFAAA/+UAGwAAAA4AAAAAAA4AAP/yAAD/1//dAAAAAAAA/+EAAAAA//r/8gAAABQAAAAAAA4ADv/yAAAAAAAK/90AAAAEAAYAAP/y/+z/5f/2AAD/9v/d//oAAAAA/90ADgAAAAQAAAAAAAAAAAAA//IAG//R//oAAP/n/+wAAAAA/+EAAP/y//oADv/RAAAAGwAAABT/ugAAAAD/8v/s/9cAAAAA/+X/5QAA/+wAAP/6AAAAAP/l//oAAAAGAAAAAAAA//oAAAAG/+X/+gAA//YAAP/6//r/7P/sAAAAAAAvAAAAAAAAAAD/5QAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/y/9f/+gAAAAAAAP/R//YADgAA//oAAAAAAAAAAAAA//L/0QAAAAD/+v/y//r/+gAAAAAAAAAA//z/+gAA//z/+gAAAAYADgAA/93/+v/l//r/+gAE//oAAAAAAAD/8v/6//r/7AAA//oAAAAAAAD/1wAA/+wAAP/6AAD/zf/yAAD/2//yAAD/7P/s//L/8gAG/+UAAP+gAAAAAP/6AAD/8gAAAAD/5QAOAAD/5QAAAAAAAAAA/48AAP/6AAb/7AAAAAD/0//6//r/8gAAAAD//AAAAAAAAP/y/+EAAAAAACMAAAAAAAD/7P/l//oAAAAGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAmAMQAKQArAC0AMAAyADUANQA6ADwAPwA1ADUAKwBIAEkASgBLAAAAOgAEAAYACAAJAAoAAAAAAAAAAAAAAAAAFQAWABgAGQAaABwAHgAhACQAJgAoABkAIQAhABYAFgAkADYANwA5ADsAPQBBAEMARgBHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC0AKQAtAC0ALQAtADUANQA1ADUAKwA1ACsAKwArACsAKwAAACIAOgA6ADoAOgAJACAAFwAVABUAFQAVABUAFQAaABgAGgAaABoAGgAkACQAJAAkABYAIQAWABYAFgAWABYAAAAMADsAOwA7ADsARgAWAEYALQAaAAkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJAAZACQAGQABAAQA5gCDABEAAAAAAAAAbgARAIwAZgAdAFEAKAAiACgAYQB7AAAAAAAAAAAAAAB7AAAAAAAAAB8AHwBaAFQAcgAjAD8ARgCNACoAjQCNAI0AKgCNAI0AVgCNAI0AjQCNACoAjQAqAI0AcAAYAD4AagAeAEEAbwAkAIoAEwAKAHgAAgAAAFAACQAxADEAMQA0ADEACQA2AF8ACQAJAGQAZAAxAGQAMQBkAG0AIQBDAAMAJwBHAAgAKwBYAAsACgBFAAAAZQAAAAAAAAAAAFwAEAAAADcAdwAtAAAAIgA3AAAAAAAAAGkATgAAAAAAYgBsAAAAGgB2ADMAAAAAAAAASQBGAEYARgBGAEYARgBdACoAjQCNAI0AjQCNAI0AjQCNAHEAjQAqACoAKgAqACoAGQAWAD4APgA+AD4AbwCNAEAAUABQAFAAUABQAFAAUAAxADEAMQAxADEANgA2ADYANgAxAGQAMQAxADEAMQAxAF4ASABDAEMAQwBDAAgACQAIACoAMQBvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgAiADIAMAASADIAMAASAA8AKAAAAC0AMwAAAAAARAAAADQANAA0ADQAAgAHACYAPQAAAEQAXQAYAHwAfAAyAIgAmAAzAJoAuABEALoAxABjAOYA6QBuAAJMOgAEAABIxEpmAGMAXgAA/3f/1/+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/w//l/7wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8f/+X/oP+P/7z/d/9i//IAPf+0AAYAGwAG/+z/rgAb//L/7AAvABv/1//8/9f//AAO/64ADv+F/9f/8gAO/vD/8v/XAAb/i//TACMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/3QAAAAAAAAAAAAAAAP8zAAAAAP8lAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/tAAAAAD/hf/s/+z/mgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAP/8AAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/0QAAAAAAAP/l/8f/0QAbAAAAAAAbAAD/7AAAACMADv/6ADcAAAAA//YAAAAAABsAAP/6AAAAAAAAAAAAAP/w/90AAP/y/9EAG//6AAAAAAAbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/w//6AAAAAAAA//oAAAAE/4UAAAAA/4UAAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAP+TAAAAAAAAAAAAFP/J/+z/8v/sAAD/0wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/l/+wAAAAAAAAAAAAA/+z/yQAAAAD/yQAAAAAAAP/yAAAAAAAUAAAAAAAAAAAAAP/dAAAADgAA/+UAAAAU/9EAAAAAAAAADgAA/+z/+gAAAAAADgAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAP/yAAAAAP+PAAD/+v91AAYAAAAA/6AAAAAAAA4AAAAA//oAAAAA//IAAP/6AAD/8gAAAAD/+gAAAAAAAP/6AAD/5f/2AAD/+gAUAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/vAAGAAAAAAAA//oAAAAGABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAAAAAAAAP/DAAAAAABM/+wAAAAOAAAAAAAvAAAABgAAAAAABgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+8ABQAAAAAAAAAAAAAAAAAAAAAAAD/8gAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/x8ABgAAAA4AAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ABgAOAA4AG//y//L/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAAAAAAAAAAAAAAAA/zMAAAAA/wQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+uAAAAAP9x/+UAAP+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACP/qAAA//L/8v/JAAD/5f8K/9EAAP8O/+EAAP/yAAAAAAAAAAAAAAAA/9cAAP/XAAAAAAAA/7wAAAAAAAAAAP/lAAD/vP/y/9H/d/+0//z/3QAAAAb/1wAA//IAAABgAAAAAAAAAAAAAAAAAAAAAAA3/9cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/vP/yAAAAAAAAAAAAAAAA/xAAAP/l/zMAAAAAAAD/f//y//r/vAAAABv/+v+0//r/XAAA/8kAAP+a//b/5f97AAAAAP/sAAAAAP+u/+X/8v/6//r/zQAA/+X/+v/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/7wAAAAAAAD/3f+u/8n/Jf/6/1b+9v/y//r/+v8fAAD/8v/DAAD/5f/sAAD/8v/6AAD/Yv/dAAD/+gAA//r/8gAA/6gAAP/X/0L/wwAA/07/8gAA/9EAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/P/+g/5EAAP+R/3cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/mgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAD/8gAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7/rgAAAAAAAP/XAAD/yf+LAA4AAP9iAAAAAP/yAAAAAAAAAAAAAAAA/+wAAP/yAAAAAAAA/90AAAAAAAAAFP/yAAD/3f/6/7z/d//DAAD/0wAAAAb/+gAAAAAABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+F/+X/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAFAAAAAAAAAAGAAAAAP93AAAAAP9/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/cQAAAAAAAAAAABT/1//6AAAAAAAA//oAAAAAAAD//P/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/woAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/1wAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/qP/X/6D//AAAAC//8gAv/1YARP+e/8kABv/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP93/9f/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+8AAAAAAAAAAAAAAAAAAD/Yv/yAAD/XAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/4UAAAAAAAD/8gAA/7wAAP/yAAAAAP/dAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/vAAAAAAAAAAAAAAAAP8zAAAAAP8EAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/rgAAAAD/Yv/l/+X/oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/dAAAAAAAAAAAAAAAA/zMAAAAA/xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/DAAAAAP+a/+UAAP+uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/3cAAAAAAAAAAP/R/5oAAAA3/+UAGwAOADcAAP/RACMADgAAAC8AAAAAAAAAAAAAAA4AAAAp/9H/7P/6AAb/dwAA//oAG//J//oAGwAAAAAAFAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/hf/l/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAAAAAAAAAAAAAP/6AAD/f//y/+z/TgAAAFgAAP+F//wAAP/JAAAARP/yAAAAAP+aAAD/1wAA/30AAP/d/2IAAP/y//L/+gAG/7z/+gAA/9EAAP+0//L/2wAA//r/8gAAAAAAAAAA/+UAAAAAAAAAAAAAAAAAAAAAAAD/mv+uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAD/+gAAAAYAAP/sABQABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAAAAAAAAAAAAAAAA/zMAAAAA/wQAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+uAAAAAP9x/+z/7P+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAYAAAAAAAAAAAAAAAD/wwAAAAD/wwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAAAA//oAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//r/+gAAAAAAAP/yAAAAAP9xAAAAAP+BAAAAAP/6AAAAAAAAAAAAAAAA//oAAP/8AAAAAAAA//IAAAAAAAAAAAAAAAD/+v/6AAD/3f/lAAD/+gAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+v/6AAAAAAAAAAAAAAAA/7QAAAAA/4UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/s//IAAAAAAAYAAP/RAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8f/+UAAP/s/9H/sv9///IAPf+0AAAAG//6AAD/0QAbAAAAAAAvAAAAAAAA/9H/8AAOAAAAI/+0//IAAAAO/o8AAP/6AAb/Qv/yACMAAAAAAAAAAAAAAAoAAAAAAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/zn/+gAA//IAAP+8AAAAAAAp/9cAAP/6ABsAAP/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/7wAAAAAAAD+nAAAAAAABv+aAAAAFAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/hQAAAAAAAAAAAAAAAAAAABQAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9f/+gAAAAAAAP/RAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/XAAAAAAAAP/y//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8v/6AAAAAAAA//IAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/8MAAAAAAAAAAAAAAAD/JQAAAAD+/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/7T/+gAA/2r/0QAA/5oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/wwAOAAAAAAAAAAD/8gAA/+z/5QAG/7wABgAOAAD/1wAAAAAAAAAAAAAAAAAAAAD/vAAA//IAAP/J//r/1/9WAA7/8gAO//oAAP/yAAAAAAAAAAD/+gAA//oAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/TAAYAAAAAAAAAAAAAAAD/mgAAAAD/dwAAAAAAAAAAAAAAAAAAAAAAAP/8AAAAAAAAAAAAAAAAAAAAAAAA/8sAAAAA//oAAAAA/9H/+gAAAAAAAP/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/4UADgAAAAAAAAAA/+UAAP+BAAAAAP9iAAAAKQAA/6j/1//s/8MAAAAA/9cAAAAA/4UAAP/JAAD/oAAA/7r/BAAA/90AAP+uAAb/wwAAAAAAAP/l/5oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/64AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/8//YAAAAAAAAAAAAAAAAAAP/6//AAAP/2AAD/+gAAAAD/+gAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAAAAb/7P/6//oAAP/y/9f/8gAAAAAAAAAAAAD/1wAAAAYAFP/XAA4ADv+8/9f/rgAU/9v/oP/yABQAI//X/90ABv/JAAb/5f+F//IADgAO/93/0QAAAAAAAP/yAAYAAAAAAAAAAAAAAAb/wwAAAAD/vAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAAAAAAAAAU/+z//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/0QAAAAAAAAAAAAAAAP8zAAAAAP8ZAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/qAAAAAD/Yv/l/+X/mgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/d//l/5EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/4X/5f+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/XAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP9i/64AAP9O/5P/BAAA/64ARP8tAAAAG//hAAD/VgAAAAAAAAAAAAAAAP/dAAD/sgAAAAAAAP+LAAAAAAAA/tP/8AAA/9H/Jf+uACkAAAAA/+UAAAAA//oAAAAA/5oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/oAAAAAAAAAAAAAAAAP8ZAAAAAP8EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/qP/6/7r/Tv/X//L/oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/mgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+gAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/1z/5f+RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/1wAGAAAAAAAAAAAAAAAA/5MAAAAA/4sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/L//oAAP/8AAAABv/D//oAAAAAAAD/4QAAAAD/8gAAAAAAAAAAAAAAAP/JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/yAAAAAAAAAAAAAAAAAAD/5QAAAAD/yQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/8kAAAAAAAAAAAAA//IAAAAAAAAAAP/lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD3/rgAAAAAAAP/RAAD/w/+oAAAAAP9x/+wAAP/dAAAAAAAAAAAAAAAA/90AAP/dAAAAAAAA/9EAAAAAAAAAKf/6AAD/rv/s/9f/oP/dAAD/tAAAABv/yQAAAAAABgB7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACMAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjAAAAAAAjAAAAAAAbAAAABgAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAYAAAAAAAAABgAAAAYAFAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+wAAAAAAEwABgAAAAYAAAAAAC8AAAAGAAAAAAAGAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/6gAAAAAAAAAAAAA/90AAP9OAAAAAP9WAAAAGwAA/6D/+v/6/+UAAAAA//oAAAAA/6AAAP/6AAD/oAAA/8n/OQAAAAAAAP/6AAD/vP/l//IAAAAA/7wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP9o/9f/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+z/+v/6AAAAAP/6//r/+v/6//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/8kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AFAAAAAAAAAAAAAAADv/yAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAAAADgAAACMADgAAAA4AFAAAACMAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/yQAGAAAAAAAAAAAAAAAA/5oAAAAA/38AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+oAAAAAAAAAAAAAP/J/+wAAP/6AAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8v/RAAD/8AAA/8kAAP/RABv/+gAAABv/5QAA/90AAAAAAAAAAAAAAAD/9gAA/+wAAAAAAAD/0QAAAAAAAP/lAAAAAP/R/+H/1wAb//oAAP/lAAAAAP/yAAAAAP/8AHv/rgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABv/yAAAAAP/y//r/yQAA/90AAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+8AAAAAAAAAAAAAAAA/zMAAAAA/x8AAAAAAAAAAAAAAAAAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+aAAAAAP9q/+X/5f+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP93/+X/kQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/2AAAAAAAAAAAAAP/6/3EAAAAA/1IAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//wAAAAAAAD/+gAAAAAAAAAAAAAAAAAAAAYAAP+0/+wAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKQAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACMAAAAAACMAAAAAABsAAAAGAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/90AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/dAAAAAAAAAAAAAAAA/zMAAAAA/x8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+8AAAAAP9x//oAAP+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+uAAAAAP/8//b/8gAA//z/zf/6AAD/oAAGAAD/9gAAAAAAAAAAAAAAAAAAAAD//AAAAAAAAP/yAAAAAAAA/1YADgAAABT/3f/6/9f/+gAAABAAAP/dAAAAAAAAAAYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL/+WAAD//AAA/+X/0f/d/04AAP+g/xD/0QAA//r/QgAO//r/0QAA//L/5QAv//YAAAAA/6D/3QAA//r/5QAA/+z/+v+o//r/yf9W/6T/+v+aAAAABP+uABQAAAAGACkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAAQAAAAGAAYAAP/yAAb/8gAGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAP/JABQAI//sAAD/vAAv/+X/3f/JAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/+v/sAAAAAAAA//oAAP/6/3EAAAAb/6gAGwAA//r/tAAUAAAAFAAA//oAAP/yAAD/wwAAACMAAP/l//oADv+oAAAAAAAAABQAAP/s//oAAAAAAAAAAAAOAAAAAAAA//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/6//oAAP/lAAYAAAAAAAAAAAAAAAD/mgAAAAD/kwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//oAAAAG/9P/+gAA//oAAP/6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/y//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/RAAAAAAAA/9cAAP/RABv/+gAAABsAAAAAAAAAAAAAAAAAAAAAAAD/9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+z/1wAb//oAAAAAAAAABAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP85AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAEUAAwADAD0ABAAEAC4ABQAFACEABgAGAFcABwAHAEYACAAIAFoACQAJAFUACgAKACEACwALAE8ADQANACoADgAOAEAADwAPABEAEAAQACMAEQARABEAEgASADsAEwATADQAFAAUAAwAFQAVAD4AFgAWACQAFwAXAFEAGAAYAGAAGQAZAFwAGgAaABkAGwAbAEkAHAAcADQAHQAeAAkAHwAfAEsAIAAgADUAIQAhADIAIgAiAC0AIwAjAFkAPwA/ABUAQQBBAAsAQgBCAEIAXwBfAEMAYABgAEEAYQBhABgAYwBjACcAZABkAE4AZQBlADgAZwBnAA4AaABoAFYAaQBpAAQAawBrADEAbQBtAF4AbwBvACMAcABwADEAdAB0ABcAdQB1ABoAeAB4AEgAeQB5AEwAewB7ADcAfQB9ABAAgQCBAA8AmQCZACYAuQC5AF8A1QDWACMA1wDXACkA2ADYAAIA2QDZAFsA2gDaACkA2wDbAAIA3ADcAFsA3QDdAB0A3gDeABEA4ADgAF4A4QDhABAA4wDjACAA5ADkADAAAQADAOcAPwBcADYAWgAAAEgAVwA2AAAAQAAAAFIAAwAxAAMARwAlABsAEQAfAAcAIgAlABMAEgAqADIAMgAAAEMAQgAUAAAAAQAoAAIAKAAoACgAAgAoACgAJAAoACgAKAAoAAIAKAACACgAFgAJACcAEAAmABkADAArAAAASQA1AAAAUAAAAAoALgAGAAYABgANAAYALgBBADAALgAuAAUABQAGAAUABgAFAAQALAAYAAsAIwAtACkALwAAAAAANQBOAAAAAAAAAAAAAAAAAAAAAAAAADcAAAA7AAAAMQA3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4AAAAAAAAAGgABAAEAAQABAAEAAQAgAAIAKAAoACgAKAAoACgAKAAoACEAKAACAAIAAgACAAIAAAAIACcAJwAnACcADAAoAB4ACgAKAAoACgAKAAoACgAGAAYABgAGAAYAQQBBAEEAQQAGAAUABgAGAAYABgAGAFQADwAYABgAGAAYACkALgApAAIABgAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAxADoAOAA5ADoAOAA5AAAAAwAAADsAPgAAAAAASwAAAA0ADQANAA0AAgAUAAMACwAAAA0AIwAJAD8APwAgAEEAQgAhAF8AYQAjAGMAZQAmAGcAaQApAGsAawAsAG0AbQAtAG8AcAAuAHQAdQAwAHgAeQAyAHsAewA0AH0AfQA1AIEAgQA2AJkAmQA3ALkAuQA4ANUA3gA5AOAA4QBDAOMA5ABFAAEAAAAKADwAPgADREZMVAAUZ3JlawAebGF0bgAoAAQAAAAA//8AAAAEAAAAAP//AAAABAAAAAD//wAAAAAAAAADBFEBkAAFAAQFMwTNAAAAmgUzBM0AAALNAKQCVgAAAAAFAAAAAAAAAAAAAAMAAAABAAAAAAAAAABVS1dOAEAADfsEBnn+eQAAB9UCDyAAAAEAAAAAA+UFrAAAACAAAgAAAAMAAAADAAAAHAABAAAAAADcAAMAAQAAABwABADAAAAALAAgAAQADAAAAA0AfgD/AVMBeALGAtwgCiAUIBogHiAiICYgLyA6IF8grCEiJfz7BP//AAAAAAANACAAoAFSAXgCxgLcIAAgECAYIBwgIiAmIC8gOSBfIKwhIiX8+wH//wAB//X/4//C/3D/TP3//ergx+DC4L/gvuC74LjgsOCn4IPgN9/C2ukF5QABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEGAAABAAAAAAAAAAECAAAAAgAAAAAAAAAAAAAAAAAAAAEAAAMEBQYHCAkKCwwNDg8QERITFBUWFxgZGhscHR4fICEiIyQlJicoKSorLC0uLzAxMjM0NTY3ODk6Ozw9Pj9AQUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVpbXF1eX2BhAIaHiYuTmJ6joqSmpaepq6qsra+usLGztbS2uLe8u72+AHJkZWndeKFwa+R2agCImgBzAABndwAAAAAAbHwAqLqBY24AAAAAbX3eYoKFl8LD1dba29fYuQDBxADj4OHm5wB52dwAhIyDjYqPkJGOlZYAlJydmwDFxnEAAAB6AAAAAAAAAAPlBawA5wDRANkA4QD2ATUA1wDfAO0A8QD2APoA/gECAMYAvQDAANQA9AD4AOQA6wCgAHcA7wCjAN0AsACcAMQARAURAACwACywABNLsExQWLBKdlmwACM/GLAGK1g9WUuwTFBYfVkg1LABEy4YLbABLCDasAwrLbACLEtSWEUjWSEtsAMsaRggsEBQWCGwQFktsAQssAYrWCEjIXpY3RvNWRtLUlhY/RvtWRsjIbAFK1iwRnZZWN0bzVlZWRgtsAUsDVxaLbAGLLEiAYhQWLAgiFxcG7AAWS2wByyxJAGIUFiwQIhcXBuwAFktsAgsEhEgOS8tsAksIH2wBitYxBvNWSCwAyVJIyCwBCZKsABQWIplimEgsABQWDgbISFZG4qKYSCwAFJYOBshIVlZGC2wCiywBitYIRAbECFZLbALLCDSsAwrLbAMLCAvsAcrXFggIEcjRmFqIFggZGI4GyEhWRshWS2wDSwSESAgOS8giiBHikZhI4ogiiNKsABQWCOwAFJYsEA4GyFZGyOwAFBYsEBlOBshWVktsA4ssAYrWD3WGCEhGyDWiktSWCCKI0kgsABVWDgbISFZGyEhWVktsA8sIyDWIC+wBytcWCMgWEtTGyGwAVlYirAEJkkjiiMgikmKI2E4GyEhISFZGyEhISEhWS2wECwg2rASKy2wESwg0rASKy2wEiwgL7AHK1xYICBHI0ZhaoogRyNGI2FqYCBYIGRiOBshIVkbISFZLbATLCCKIIqHILADJUpkI4oHsCBQWDwbwFktsBQsswBAAUBCQgFLuBAAYwBLuBAAYyCKIIpVWCCKIIpSWCNiILAAI0IbYiCwASNCWSCwQFJYsgAgAENjQrIBIAFDY0KwIGOwGWUcIVkbISFZLbAVLLABQ2MjsABDYyMtAAAAAAAAAf//AAIAAgBEAAACZAVVAAMABwAusQEALzyyBwQh7TKxBgXcPLIDAiHtMgCxAwAvPLIFBCHtMrIHBiL8PLIBAiHtMjMRIRElIREhRAIg/iQBmP5oBVX6q0QEzQAAAAIAtv/yAeEFrAAJAA0AVwCyCAAAK7QDAwAVBCuyCgIAKwGwDi+wAdawCjKxBgjpsAsysQYI6bMMBgEIK7QNEQBGBCuwDS+0DBEARgQrsQ8BK7EMDRESsQgDOTkAsQoDERKwDDkwMTY0NjMyFhQGIyIDIQMjtlc9P1hYPz1TASE5rEl8Wlp8VwW6/AIAAgBMAxAC0wVIAAsAFwBeALAJL7AUM7QDAwAIBCuwDjIBsBgvsADWsQUQ6bMJBQAIK7QIEQANBCuwBRCxDAErsREQ6bMVEQwIK7QUEQANBCuxGQErsQwIERKwAzmxFQARErAOObAREbAPOQAwMRM0NjIWFRQHAyMDJiU0NjIWFRQHAyMDJkxOek4GXFRaBgFwT3pOBlxUWgcEuj5QUD4dEv6FAXseET5QUD4dEv6FAXsjAAAAAgBcAAAFjwUvABsAHwFZALIaAAArshUWGTMzM7IFAQArswYJCg0kFzO0BAQAFwQrswMQHh8kFzK0AAEaBQ0rswIRHB0kFzO0AAQAFwQrsxQXGBskFzKwBy+yCAsMMzMzAbAgL7Aa1rEZEemwGRCxFgErsRUR6bIVFgors0AVEwkrswgVFggrsQcR6bAHL7EIEemyBwgKK7NABwQJK7AVELELASuxDBHpsSEBK7A2Gro+jfJ3ABUrCro+kfKKABUrCrAaELMCGgcTK7MDGgcTK7MGGgcTK7AZELMJGQgTK7AWELMKFgsTK7AVELMNFQwTK7MQFQwTK7MRFQwTK7MUFQwTK7AWELMXFgsTK7AZELMYGQgTK7AaELMbGgcTK7AZELMcGQgTK7AWELMdFgsTK7MeFgsTK7AZELMfGQgTKwNAEAIDBgkKDRARFBcYGxwdHh8uLi4uLi4uLi4uLi4uLi4usEAaADAxEzUhEyE1IRMzAyETMwMhFSEDIRUhAyMTIQMjEzchEyFcASNC/wABJkjDSAEXR8VIAQr+z0EBDv7NSMRH/upIw0joARZC/ukBULIBMbIBSv62AUr+trL+z7L+sAFQ/rABULIBMQAAAAADAGD/EARYBiEAKAAvADYAYwCyIQAAK7EwBOmwBDKyMCEKK7NAMA0JK7IkAAArAbA3L7AJ1rEpDOmwKRCxIwErsgQMLDIyMrEiEemyDhkwMjIysCIQsTMBK7AVMrEeC+mwFDKxOAErsSkJERKxAgE5OQAwMRM3HgEXEScuATU0Njc1MxUeAxcHLgInERceARUUBgcVIzUuAwEUFhcRDgEBPgE1NCYnYOYIamElp7rdqbxXiVYzDN0GHkUvErK/zrW8Z6ZpPAEcTEpHTwFSSUxLSgGFQF+TFwF5CCbAk5jjF9nbDkhjZjdGI0VJEv6RBCfRjZHiGdnXDVN2gwKFOlgOAVASYfy6DmA+OVYVAAAAAAUAZP/uBlwFQgAKAA4AGAAjACwAmQCyCwAAK7IiAAArtCcEABcEK7ArL7QcBAAfBCuwCS+0EgQAFwQrsAwvsw4MAw4rtBcEAB8EKwGwLS+wAdaxDxHpsA8QsRQBK7EGEemwBhCxGgErsSQR6bAkELEpASuxHxHpsS4BK7EUDxESsgkOAzk5ObEpJBESsgwiHDk5OQCxKwsRErIZGh85OTmxFxIRErIBAAY5OTkwMRIQNjMyFhUUBiMiAwEzAQMUFjI2NTQmIgYAEDYzMhYVFAYjIgMUFjI2NCYiBmTHiYjIyIqIDQOy1fxQ0VN8UlJ8UwKZx4mIyMiKiAdTfFJSfFMDbwESwcGJir79UAUv+tED+EJWVkJBVFT8cwESwcGJir0BR0JVVYRUVQAAAAMAi//lBaoFywAgACwAOQB7ALIZAAArshwAACuxJAXpsg0CACuxNwTpAbA6L7AA1rEhB+mwIRCwLSDWEbEIC+mwCC+xLQvpsCEQsTQBK7EQC+mxOwErsS0hERKwBTmwNBG0DRwkKRMkFzmwEBKyFBooOTk5ALEkGRESsBo5sDcRtQAIEBcpMSQXOTAxEzQ+AT8BJyY1ND4CMzIWFRQPARcBEQcBIScGIyIuAjcUFjMyNj8BAQcOARMUFh8BNzY1NCYjIgaLQ2RVDxmmRHCJSKzhzEDyAVrHAUj+w6S61Ganajn0a1VDcD8C/vQxOj1CMi4pVGJcRj5fAWJZlGY/ChurlFeQWjLIoaucL/wBdP7N2/6qrMdBbYdZSG9GRAIBHCUqYAKxMFQyLT5JXEFbUwABAEwDEAFiBUgACwA+ALAJL7QDAwAIBCsBsAwvsADWsQUQ6bEFEOmzCQUACCu0CBEADQQrsQ0BK7EJABESsAI5sQUIERKwAzkAMDETNDYyFhUUBwMjAyZMTnpOBlxUWgYEuj5QUD4dEv6FAXseAAAAAQBi/qgCiQZ3AAsAEwABsAwvsADWsQYR6bENASsAMDETEAEXBgIREBIXBwBiAZyLqbW1qYv+ZAKPAkwBnH+5/lb++v75/la5fQGcAAEAAP6oAicGdwALABMAAbAML7AD1rEJEemxDQErADAxFTYSERACJzcAERABqrS0qosBnP5k27gBqgEIAQcBqrh//mj9sP2x/mgAAAABADsCsgNaBawADgAgALIDAgArAbAPL7AC1rEFEemxEAErsQUCERKwCzkAMDETNxcRMxE3FwcXBycHJzc7PPPB9Dv4oJWkmpebBESwVAEM/vZSsFLRb9fVb88AAAEAagBgBDcERgALAFIAsAAvsAczsQEE6bAFMrIAAQors0AACgkrsgEACiuzQAEDCSsBsAwvsArWsAIysQkR6bAEMrIJCgors0AJBwkrsgoJCiuzQAoACSuxDQErADAxEzUhETMRIRUhESMRagGCygGB/n/KAfTCAZD+cML+bAGUAAAAAAEAhf6uAekBMQATADwAshEAACu0AwMAFAQrsgcAACsBsBQvsA/WtAYRAA0EK7IPBgorswAPAAkrsRUBKwCxAxERErEGDzk5MDE3NDYzMhYVFA4CBzU+ATcGIyImhWJIUmhAZm84SG0BFB1EWJZBWndiZqRiNwd5D4BOClYAAAAAAQBcAe4CngLBAAMAIgCwAC+xAQTpsQEE6QGwBC+xAAErtAMIAAgEK7EFASsAMDETNSEVXAJCAe7T0wAAAQCJ//QB1wFCAAcALwCyBwAAK7QDAwANBCuyBwAAK7QDAwANBCsBsAgvsAHWsQUI6bEFCOmxCQErADAxNjQ2MhYUBiKJYYpjY4pVimNjimEAAAAAAQAA//YDpgW2AAMAFgCyAAAAK7IBAgArAbAEL7EFASsAMDEVATMBAsvb/TUKBcD6QAAAAAIAXP/hBJgFTgAPAB8AQgCyDAAAK7EUBemwHC+xBAXpAbAgL7AA1rEQB+mwEBCxGAErsQgH6bEhASuxGBARErEMBDk5ALEcFBESsQgAOTkwMRMQNzYhIBcWERAHBiEgJyYTEBcWMzI3NhEQJyYjIgcGXHeRARcBFZF3d5H+6/7pkXf0XkyBfk9cXE9+gUxeApgBKrPZ2bP+1v7UstnZsgEs/v96Y2N4AQMBAnhjY3UAAQA5AAACbQUvAAgAOgCyBwAAK7AAL7QBBAAXBCuwBC8BsAkvsAfWsQYM6bIHBgors0AHAAkrsAYQsQQJ6bAEL7EKASsAMDETNT4BNzMRIxE5i74W1fIDjagDjGv60QONAAAAAAEARAAABAQFTgAkAFMAsgAAACuxIgXpsAkvsRcF6QGwJS+wEtaxDAvpsAwQsQYBK7EcB+myBhwKK7NABgAJK7EmASuxBgwRErMDFx8iJBc5ALEJIhESswMPEhwkFzkwMTM2Ej8BNjU0JiMiBhUUFhcnJjU0PgIzMh4CFRQGBwUGByEVRAORp9uqdGtweAYB7gZAdrVua7J2QIZ6/v5xFgKRsgEMZ4lqkFd4imwMMQcRNhZWnXlIQ3KYVX/SS59GUtkAAAABADX/4QQhBS8AIQBeALIdAAArsQQE6bAPL7EQBekBsCIvsADWsQEM6bABELEHASuxGAfpsSMBK7EBABESsQ8QOTmwBxGzDQ4THSQXObAYErEREjk5ALEPBBESswABExgkFzmwEBGwEjkwMRM3HgEzMjY1NCYjIgcnASE1IRUBHgMVFA4CIyIuAjXwBJVvdYeNX04ucQFu/aQDmv6XTI1xRER8v3NwvH5KAYUxc4+DX2twF7YBSNfN/sUCN2SaXVaceEhFdZYAAAIARAAABJMFLwAKAA0ATgCyCQAAK7AAL7AGM7ELBemwBDKwAi8BsA4vsAnWsAwysQgM6bADMrIICQors0AIBgkrsgkICiuzQAkACSuxDwErALECCxESsQENOTkwMRMRASERMxUjESMRJSERRAI1ATvf3/H+XgGiASMBCgMC/M3Z/t0BI9kCOwABAEL/3wQpBS8AHgB5ALAcL7EEBOmwCi+xFgTpsBIvsQ8F6bISDwors0ASDQkrAbAfL7AH1rEZB+mxIAErsDYauj4t8NQAFSsKsA8uDrAOwAWxEhT5DrATwACxDhMuLgGzDg8SEy4uLi6wQBoBsRkHERKxEBE5OQCxCgQRErIAARk5OTkwMRM3HgEzMjY1NCYjIgYHJxMhFSEDPgEzMhYVFAAjIiRC5wiTcWuRlGxEdCXnowLX/c9SKotJyv3+7ODQ/ukBbztsjIZsdYEzKlQCntf+sCsx7c3B/vbtAAAAAAIAXv/hBGgFTgAaACUAbACyFgAAK7EeBOmwJC+xEATpsAovsQUE6QGwJi+wANaxGxDpsBsQsSEBK7ETB+mxJwErsRsAERKwDTmwIRGzBQoQFiQXObATErEIBzk5ALEkHhESsQATOTmwEBGwDTmwChKwCDmwBRGwBzkwMRM0EjYkMzIXByYjIgYHPgEzMhYVFAAjIi4CBRQWMzI2NTQmIgZea74BBpq1ZkZgg7z4ETOybcj6/t7VfMqFSAERmWlslpbYlgJKsQEkxGtCyDXnwU5Q98rL/v5hqOAgboqIcHGHhwAAAAEACgAAA+kFLwAUADoAsgwAACuwAC+xAQXpAbAVL7AM1rELD+myCwwKK7NACwMJK7EWASuxCwwRErANOQCxAAwRErADOTAxEzUhFQ4FAgcjNhI+Az8BCgPfID1pWWlNPwz+DEZda2dUGhkEWNfXGzh0fLrH/vmNlwEe2L6CXxYWAAAAAAMAVv/hBC8FTgAWACAAKwCFALIUAAArsRoE6bAfL7EkBOmwKi+xCQTpAbAsL7AA1rEYB+mwGBCwISDWEbEGDOmwBi+xIQzpsBgQsR0BK7ERB+mwJyDWEbELDOmxLQErsSEGERKwAzmwJxG0CAkaHxQkFzmwCxKwDjkAsR8aERKxEQA5ObAkEbEOAzk5sCoSsQsGOTkwMRM0NjcuATU0JCAEFRQGBx4BFRQEIyIkEhQWMzI2NCYjIgMUFhc+ATU0JiIGVopsX3gBBAGSAQV4X2uL/vTh4P709IVzdYSFdHNneWFjeHnEeAFicLAmI6pipdLSpWGrIyaxb6nY2AEYrHV1rHcBgVRuAQFuVE5ubgAAAgBM/+EETAVOABwAKAB2ALILAAArsRIF6bAYL7EgBOmwJi+xAwTpAbApL7AA1rEdDOmwHRCxIwErsQgQ6bAIELEVDOmwFS+xKgErsR0AERKxDg85ObAjEbMLEhgDJBc5sBUSsBQ5ALESCxESsA45sBgRsA85sCASsBU5sCYRsQgAOTkwMRM0ADMyHgIVEAAhIiYnNx4BMzI2Nw4BIyIuAjcUFjMyNjU0JiMiBkwBH9RqupNW/qb+slOtM0MohkDM4wknqnJbpX9M8ZNraJaXZ2mVA3/LAQRNlPKa/pL+bishyRok4cFEVT1vq29xh4pua4uJAAIAj//0Ad0D8gALABcAPwCyFQAAK7QPAwANBCuyAwEAK7QJAwANBCsBsBgvsAzWsAAysRII6bAGMrESCOmxGQErsRIMERKxAwk5OQAwMRM0NjMyFhUUBiMiJhM0NjMyFhUUBiMiJo9hRURiYkRFYQJhRURiYkRFYQNMRWFhRUNhYP2QRWBgRUNhYAAAAgCP/r4B4wPyAAsAIABZALIeAAArtA8DABUEK7IDAQArtAkDAA0EKwGwIS+wDNawADKxEgjpsRII6bAGMrASELQcEQANBCuwHC+xIgErsRwMERKzCQMPGCQXOQCxDx4RErESHDk5MDETNDYzMhYVFAYjIiYTNDYzMhYVFA4DBzU+ATcGIyImj2FFRGJiREVhAl5ETWMpQVVUKkVoARQbQVMDTEVhYUVDYWD9hT5Ycl1OhVlCIgZzD3pKClEAAAAAAQBIAEQDqARmAAYAABM1ARUJARVIA2D9lQJrAfTAAbLj/tP+0eMAAAIAfwErBEwDfwADAAcAGgCwAC+xAQTpsAQvsQUE6QGwCC+xCQErADAxEzUhFQE1IRV/A838MwPNASvDwwGTwcEAAAAAAQBEAEQDpARmAAYAADc1CQE1ARVEAm79kgNgROEBLwEt5f5OwAAAAAIARP/yA+UFywAjAC4AcwCyLQAAK7QnAwAVBCuyBQIAK7EcBOkBsC8vsADWsR8L6bAfELEUASuxDwnpsxkUJQ4rsSoI6bAPELEZASuxCgfpsTABK7EqJRESsgUWHDk5ObEPFBESsSctOTmwGRGxDRc5OQCxHCcRErMKABEhJBc5MDETND4CMzIeAhUUDwEGFRQXIyY1ND8BNjU0JiMiBhUUFycmADQ2MzIWFRQGIyJEO2+1b260cz7MWGcCzQSmXmF0amx7DOcMAR5YPj1YVz4/BB9PlnxLRXSST9iQPkd7Dww2GL14REZsVnmLXzoiESz8XHxaWj49WAAAAAIAVv+gBlQFywA9AEoAswCyBQIAK7QqBAAXBCuwOi+0NAQAFwQrsA0vsBMztCQEABcEK7BBMrBHL7QZBAAXBCsBsEsvsADWsS8R6bAvELEWASuxPhHpsD4QsUQBK7QhEQANBCuwIRCxJwErtAkRAFsEK7FMASuxRD4RErYQEwUqNDoZJBc5sCERsRwdOTmwJxKyHjY3OTk5ALENNBESsTY3OTmwJBGwEDmwRxK1CRYhACcvJBc5sBkRshwdHjk5OTAxEzQSNiQzMgQSFRQOAQciJicOASMiJjU0EjMyFhc3MwMGFRQWMzI2NTQAIyIOAhUUHgIzMjcXBgQjIiQCJRQWMzI2NzQmIyIOAVaA2QElo84BUL9xuGpObA8ogkaIr+6nQ3YWE7RtBiIkU4D+zfaD46NeV6Dwkt+tXFT+7YHu/ovSAjlPT156A09KQ2k0AqivAS7Qdq7+zb2W9YYBRDs/RMScyAENQD1i/gQeDSIs2ZbdARtcpO+MguCjXYN9Tl7BAWLCWGyrhlNbV4AAAAACABQAAAWcBawABwAKACwAsgAAACuwAzOyAQIAK7QGCAABDSuxBgbpAbALL7EMASsAsQEIERKwCjkwMTMBIQEhAyEDEyEDFAI2ARwCNv7zif2ah90But0FrPpUAW3+kwJQAlIAAwCuAAAEiQWsAA4AFgAfAGMAsgAAACuxDwTpsgECACuxHwTptBcWAAENK7EXBOkBsCAvsADWsQ8H6bAXMrAPELETASuxCw7psBsg1hGxBQfpsSEBK7ETGxESsAg5ALEWDxESsAs5sBcRsAg5sB8SsAU5MDEzESEyFhUUBgceARUUBiMlMzI2NCYjITUzMjY1NCYrAa4B9M3tdmF1j/nJ/tv6b4R7cP7+32p7fG/ZBazZrnGlIx+8gLDh0XHAdc9uXF1uAAEAVv/hBcUFywAlADMAsiEAACuxGAPpsgUCACuxDgPpAbAmL7AA1rETDumxJwErALEOGBEStAoACxscJBc5MDETNBI2JDMyHgIXBy4BIyIOAhUUHgIzMjY3Fw4DIyIkJgJWeswBB46G46BrGecj1a5cqYhSUIesXqvcKeIaa6HmhpP+98p3AtWsASK+akuDp2JOjbBDfs5/e8p/RLeISV+pilBpvgEgAAIArgAABXMFrAAMABkAOACyAAAAK7ENBumyAQIAK7EZBukBsBovsADWsQ0H6bANELETASuxBw/psRsBKwCxGQ0RErAHOTAxMxEhMgQWEhUUAgYEIyUhMj4CNTQuAiMhrgIClQEBv25vwf7/lP72AQJgpX9JSH6lYP78Baxitv7qq6r+67Nh4T55wXp8w3o/AAEArgAABC8FrAALAEcAsgAAACuxCQPpsgECACuxBAPptAgFAAENK7EIBukBsAwvsADWsQkH6bAEMrIJAAors0AJCwkrsAIys0AJBwkrsQ0BKwAwMTMRIRUhESEVIREhFa4Dgf11Ak79sgKLBazl/n/g/n/lAAAAAAEArgAABDUFrAAJAEAAsgAAACuyAQIAK7EEA+m0CAUAAQ0rsQgG6QGwCi+wANaxCQfpsAQysgkACiuzQAkDCSuzQAkHCSuxCwErADAxMxEhFSERIRUhEa4Dh/1vAk79sgWs5/5o4/22AAAAAAEAVv/hBcEFywAsAGwAsiQAACuyKAAAK7EZBumyBgIAK7EPA+m0ICEoBg0rsSAF6QGwLS+wANaxFA7psBQQsSQBK7EjEemyJCMKK7NAJCAJK7EuASuxJBQRErMMBh8oJBc5ALEhKBESshQAJTk5ObAPEbELDDk5MDETND4DMzIeAhcHLgEjIg4CFRQeAjMyPgM3ITUhESMnDgEjIiQmAlZPi7nXcYDeo3Ee6CfcpVuoi1NPhqtfVIxcQR8E/iECxsYTNeahj/7+xXUC14v0s4FBRnueXFiEq0F+z4KBzoFELERZVCjX/SG4Wn1ovQEiAAEArgAABUYFrAALAD8AsgAAACuwBzOyAQIAK7AFM7QDCgABDSuxAwPpAbAML7AA1rELB+mwAjKwCxCxCAErsAQysQcH6bENASsAMDEzETMRIREzESMRIRGu9gKq+Pj9VgWs/agCWPpUAm39kwAAAAABAK4AAAGoBawAAwAhALIAAAArsgECACsBsAQvsADWsQMO6bEDDumxBQErADAxMxEzEa76Baz6VAAAAAABACn/4QPDBawAEQA+ALIPAAArsQYD6bIKAgArAbASL7AA1rEDDOmwAxCxCQErsQwH6bETASuxCQMRErAPOQCxCgYRErEBAjk5MDETNTcVFBYzMjY1ETMRFAIjIgIp8HplY3L2/8rV/AG2XjKIent9bgP4/A7G/u0BAAAAAQCuAAAFXgWsAAsAMACyAAAAK7AHM7IBAgArsAQzAbAML7AA1rELB+mwAjKxDQErALEBABESsQMJOTkwMTMRMxEBIQkBIQEHEa72AnABRP20AlL+y/47wAWs/UgCuP1//NUCddP+XgABAK4AAAQ9BawABQAsALIAAAArsQMD6bIBAgArAbAGL7AA1rEDB+myAwAKK7NAAwUJK7EHASsAMDEzETMRIRWu9gKZBaz7PekAAAAAAQCuAAAG7AWsAAwARgCyAAAAK7EGCTMzsgECACuwBDMBsA0vsADWsQwM6bAMELEHASuxBgfpsQ4BK7EHDBESsQIEOTkAsQEAERKyAwgLOTk5MDEzESEJASERIxEBIwERrgFIAdcB0QFO9P471f5ABaz7rARU+lQELfvTBCn71wABAK4AAAVxBawACQBCALIAAAArsAYzsgECACuwBDMBsAovsADWsQkH6bAJELEDASuxBgfpsQsBK7EDCRESsQIHOTkAsQEAERKxAwg5OTAxMxEhAREzESEBEa4BOQKU9v8A/TMFrPv6BAb6VARM+7QAAgBW/+EGGwXLABQAKABGALIRAAArsRsD6bIGAgArsSQD6QGwKS+wANaxFg7psBYQsSABK7EMDumxKgErsSAWERKyEBEGOTk5ALEkGxESsQwAOTkwMRM0PgMzMh4DFRQCBgQgJCYCEhQeAzMyPgI0LgIjIg4CVlCMutlyc9m7jVB8z/73/uD++M57/DZdfIxKXq2KU1OKrV5KjHxdAteL87OCQUGCs/OLrf7dvWlpvQEjARPMrXpWKUN+zP7MfkMpVnoAAAIArgAABJgFrAAKABMAQgCyAAAAK7IBAgArsRMF6bQJCwABDSuxCQXpAbAUL7AA1rEKB+mwCzKwChCxDwErsQUO6bEVASsAsRMLERKwBTkwMTMRITIEFRQEIyEZASEyNjU0JiMhrgIbzwEA/wDP/tsBAHSGhnT/AAWs+cHC+f3JAxB5Z2l6AAACAFb/gwYbBcsAFwAuAFoAshMAACuxHgPpsgYCACuxKgPpAbAvL7AA1rEZDumwGRCxJQErsQwO6bEwASuxJRkRErIREwY5OTmwDBGyDg8QOTk5ALEeExESsQ8ROTmwKhGyDA4AOTk5MDETND4DMzIeAxUQBxcHJwYjIiQmAhIUHgMzMjcDNxM2NTQuAiMiDgJWUIy62XJz2buNUL2sprKtzpD++M57/DZdfIxKeGHvqPFlU4qtXkqMfF0C14vzs4JBQYKz84v+y9HBjcNlab0BIwETzK16VikvAQqP/vSLxX/MfkMpVnoAAgCuAAAEogWsAA0AFgBYALIAAAArsAkzsgECACuxFgXptAwOAAENK7EMBekBsBcvsADWsQ0H6bAOMrANELESASuxBQ7psAkysRgBK7ESDRESsQoIOTkAsQ4MERKwCDmwFhGwBTkwMTMRITIWFRQGBwEhASMZASEyNjU0JiMhrgItzvmwmAFI/un+z7QBCHKIiHL++AWs+72b3iX9qgI9/cMDF3lkZXoAAQBG/+EEeQXLADEAjACyLQAAK7EEBemyEgIAK7EeBekBsDIvsA7WsSEH6bAhELEHASuxKA7psTMBK7A2GrryzcFgABUrCg6wCxCwCsCxJBX5sCXAALMKCyQlLi4uLgGzCgskJS4uLi6wQBoBsSEOERKwATmwBxGzBBIeLSQXObAoErEYGTk5ALEeBBEStQABDhgZKCQXOTAxEzceATMyNjU0Ji8BLgE1ND4BMzIeAxcHLgMjIgYVFBYfAR4BFRQOAiMiLgJG5QutlH6KZl3MqseF5IVipW1RKwvdBiNAbkVsjldT0b3MRX7HeITWg0sBoEF7qHFYR2oUKyPVn3jNeC9JZWI0RiVJRix8VUZjEism3p1VnnxKUISZAAABABsAAATBBawABwA6ALIGAAArsgECACuxAAPpsAMyAbAIL7AG1rEFB+myBQYKK7NABQMJK7IGBQors0AGAAkrsQkBKwAwMRM1IRUhESMRGwSm/ib1BMXn5/s7BMUAAAABAJ7/4QTZBawAFAA3ALIQAAArsQYD6bIBAgArsAozAbAVL7AA1rEDDOmwAxCxCQErsQwH6bEWASuxCQMRErAQOQAwMRMRMxEUFjMyNjURMxEUDgEjIi4CnvOei42c9pLym3LEk1MB+gOy/FyYpaSZA6T8Tqr3eEaFzgAAAQAUAAAFUAWsAAYAIQCyBgAAK7IAAgArsAMzAbAHL7EIASsAsQAGERKwAjkwMRMhCQEhASMUAQsBlQGYAQT92/oFrPuWBGr6VAAAAAEAGwAACAgFrAAMAMUAsgwAACuyCAkLMzMzsgACACu0AQMEBgckFzMBsA0vsADWsQEQ6bABELEGASuxBw/psQ4BK7A2GrrCRO8gABUrCrAAELAMwA6wARCwAsC6PPLseAAVKwoFsAMusQECCLACwA6xChf5BbALwLrDIOw+ABUrCrAJLrELCgiwCsAOsQUY+QWwBMC6PdvvkQAVKwqxBAUIsAYQsAXABbAHELAIwAMAsgIFCi4uLgFACQIDBAUICQoLDC4uLi4uLi4uLrBAGgAwMRMhCQEhCQEzASMJASMbAQIBIgFUAQABWwEc/v5p/v6f/qD8Baz72wQl+9MELfpUBEr7tgAAAAEAGwAABQwFrAALACYAsgAAACuwCDOyAgIAK7AFMwGwDC+xDQErALECABESsQQKOTkwMTMJASEJASEJASEJARsB5f4fAScBUgFUASD+HQHh/tn+rv6qAtcC1f3sAhT9Kf0rAhL97gAAAQAUAAAFBgWsAAgAMACyBwAAK7IAAgArsAMzAbAJL7AH1rEGB+mxCgErsQYHERKwAjkAsQAHERKwAjkwMRMhCQEhAREjERQBIwFcAV8BFP4A9gWs/aACYPy6/ZoCZgAAAQBWAAAEwwWsAAkAKACyAAAAK7EHA+myBAIAK7EDA+kBsAovsQsBKwCxAwcRErEBBjk5MDEzNQEhNSEVASEVVgMl/PIES/zRAzryA9Pn6fwm6QAAAQCu/r4CZAZkAAcAPQCyBAIAK7QBBAAfBCuwAC+0BQQAHwQrAbAIL7AA1rQHCAAKBCuwAjKxBRHptAcIAAoEK7ADMrEJASsAMDETESEVIxEzFa4Btu3t/r4Hprj5zbsAAQAA//YDqAW2AAMAFgCyAwAAK7IAAgArAbAEL7EFASsAMDERMwEj4QLH3wW2+kAAAQAK/r4BwQZkAAcARgCyAwIAK7QEBAAfBCuwBy+0AAQAHwQrAbAIL7AH1rADMrQGCAAKBCuwBhCxARHpsAEvsAYQtAcIAAoEK7AHL7EJASsAMDEXMxEjNSERIQru7gG3/kmHBjO4+FoAAAAAAQApAtEEDAWuAAYAEQCyAQIAKwGwBy+xCAErADAxEwEzASMJASkBkcEBkef++P71AtEC3f0jAfT+DAAAAQAU/zsEKwAAAAMAGgCyAAAAK7EDBOmyAAAAKwGwBC+xBQErADAxMyEVIRQEF/vpxQAAAAEAOwRiAgwFkQADACAAsAMvtAEDABUEKwGwBC+wANa0AggACQQrsQUBKwAwMRMhEyM7AR20wgWR/tEAAAIAXP/hA8kEBAAgAC0AnACyGQAAK7IeAAArtCQEAB8EK7IQAQArsQkE6QGwLi+wANaxIQvpsCEQsSkBK7IGGyoyMjKxFgvpsS8BK7A2GroJpMC7ABUrCgSwKi4OsCvAsQQZ+bADwACzAwQqKy4uLi4BsgMEKy4uLrBAGgGxIQARErEMDTk5sCkRsRAeOTmwFhKwGTkAsSQZERKwGzmwCRG0AAwNFRYkFzkwMRM0NjclNjU0JiMiBgcnPgEzMh4CFREUFyMmNQ4BIyImNxQWMzI+Aj0BBQ4BXKaHAQBKXl5aawjZDuSxb6hiLw3dCymbb5e77k1ENFZHJ/78PEkBDoCZFCcKPkNVZk8xiL48aYNN/hFfQSFeQlyxizZLGzlnRy0nCkMAAAAAAgCa/+cEiQXLABEAHABdALIAAAArsg0AACuxFQTpsgECACuyBgEAK7EbBOkBsB0vsADWsREL6bECEjIysBEQsRgBK7EJC+mxHgErsRgRERKxBg05OQCxFQARErAQObAbEbAJObAGErADOTAxMxEzET4BMzISFRQOASMiJicVGAEWMzI2NTQmIyKa6SSobdn0cNeOaJ8sl3V3lpR5dgXL/Z8/V/7c5Jfvi1RKhQKH/t6rq5GSpQAAAAEATP/hBBsEBAAgADMAsh4AACuxEwXpsgQBACuxDQXpAbAhL7AA1rEQC+mxIgErALENExEStAkAChgZJBc5MDETND4BMzIeAhcHLgEjIgYVFBYzMj4CNxcOAyMiAEyH6Y5go25HENUUdWhzoKF2N1w6IwrREktvoV7c/tgB9JfyhzlfcT9NTmylkJGpIzs7IEw9cGA5ATAAAgBM/+cEPQXLABQAIABgALINAAArshIAACuxGATpsggCACuyBAEAK7EeBOkBsCEvsADWsRUL6bAVELEHASuxDRsyMrEJC+mxIgErsQcVERKzBBIYHiQXOQCxGA0RErAPObAeEbAAObAEErAHOTAxEzQ+ATMyFhcRMxEUFyMmNQ4BIyIANxQWMzI2NTQmIyIGTHfbiXaTHOcK4wolm2XV/vbtlHl1k5B2d5gB9o/ujVY5Alr662ZQOkdDVwEr5I+vso6NqKoAAAACAEz/4QQZBAQAGAAfAGkAshQAACuxDgTpsgUBACuxHQTptBkLFAUNK7QZBAAXBCsBsCAvsADWsQsL6bAZMrALELEaASuxCAzpsSEBK7EaCxESsgUOFDk5ObAIEbIKEBE5OTkAsQsOERKxEBE5ObAZEbEACDk5MDETND4CMzIAFRQHIR4BMzI3Fw4BIyIuAjchLgEjIgZMUYawXuQBBAf9JwSeb787yCrsrGa4jVPzAeoDfnVqgwH4c8eGTP7o7j4OcZOuP4qySYbN415/hgAAAQAjAAACqgXVABcAWwCyFgAAK7IBAQArsBEzsQAE6bATMrALL7EGBOkBsBgvsBbWsAIysRUM6bAQMrIVFgors0AVEwkrsAgyshYVCiuzQBYACSuxGQErALELARESsAk5sAYRsAg5MDETNTM1NDYzMhcVJiMiDgIdATMVIxEjESOuwJxVKCMzGjAuG+fn8AMXzoqlwRTLCg4fPyyDzvzpAxcAAAACAFL+XAQtA/gAHwArAG8AshUBACuyEQEAK7EpBOmwHS+xBATpsAovsSME6QGwLC+wDdawADKxIAzpsCAQsSYBK7EGFDIysRcK6bEtASuxIA0RErABObAmEbMEChEdJBc5ALEKBBESsQABOTmxKR0RErEHDTk5sBURsBQ5MDEXNx4BMyARNQ4BIyIANTQ+ATMyFhc1MxEUDgMjIiQTFBYzMjY1NCYjIgZS2wyJZQEbI5dnyP77c9SGb5Uj5SJNdLBtwf773Y52c42QcHORNzleeQEraD9SARLThd2EUEJ//HlSk4VgONIC5IKYmoB+m5sAAAAAAQCaAAAEEAXLABMARwCyAAAAK7AKM7IBAgArsgYBACuxDwXpAbAUL7AA1rETC+mwAjKwExCxCwErsQoL6bEVASuxCxMRErAGOQCxBg8RErADOTAxMxEzET4BMzIWFREjETQmIyIGBxGa7TCZVLG77WNqX20DBcv9uj8+3q39iQJOZHl+Y/22AAIAdQAAAaoF3wAJAA0ARgCyCgAAK7ILAQArsAgvtAMDABQEKwGwDi+wAdaxBgjpsQYI6bMNBgEIK7EKC+mwCi+xDQvpsQ8BK7ENChESsQgDOTkAMDESNDYzMhYUBiMiAxEzEXVaP0FbW0E/NesFBIBbW4Ba+1YD5fwbAAAC/9f+XAGqBeEADQAZAE8AsgYBACuwCy+xAgTpsBcvtBEDABQEKwGwGi+wBdaxCAvpsAgQsxkIFA4rsQ4I6bAOL7EUCOmxGwErsQgFERKxERc5OQCxAgsRErANOTAxBxYzMjY1ETMRFAYjIicTNDYzMhYVFAYjIiYpHipBOu2hiFgvnlo/QVtcQD9azQZBQAQ3+7eOshMG10BbW0A/W1sAAQCaAAAESAXLAAsAMgCyAAAAK7AHM7IBAgArsgQBACsBsAwvsADWsQsL6bACMrENASsAsQQAERKxAwk5OTAxMxEzEQEhCQEhAQcRmusBfwE7/mcBov7d/tt7Bcv8hwGT/lr9wQGYgf7pAAAAAQCaAAABhwXLAAMAIQCyAAAAK7IBAgArAbAEL7AA1rEDC+mxAwvpsQUBKwAwMTMRMxGa7QXL+jUAAAAAAQCaAAAGcwQCACMAaACyAAAAK7ERGjMzsgEBACuyBgEAK7ALM7EfBOmwFjIBsCQvsADWsSML6bACMrAjELEbASuxGgvpsBoQsRIBK7ERCumxJQErsRsjERKwBjmwGhGwCTmwEhKwCzkAsQEfERKxAwk5OTAxMxEzFT4BMzIWFzYzMh4CFREjETQmIyIGFREjETQmIyIGFRGa4ymlWWWfJ2naRntlO+ZgYFxz6l9hXnED5X9KUlpWsC1Zll/9eQJgXXB/Xv2wAmBccXxh/bAAAAEAmgAABBAEAgATAEcAsgAAACuwCjOyAQEAK7IGAQArsQ8F6QGwFC+wANaxEwvpsAIysBMQsQsBK7EKC+mxFQErsQsTERKwBjkAsQEPERKwAzkwMTMRMxU+ATMyFhURIxE0JiMiBhURmucvnlqvue1jamJtA+WFUlDerf2JAk5keYVn/cEAAAACAEz/4QRWBAQACwAWAEQAsgkAACuxDwTpsgMBACuxFQXpAbAXL7AA1rENC+mwDRCxEgErsQYM6bEYASuxEg0RErEJAzk5ALEVDxESsQYAOTkwMRM0ADMyABUUACMiABIQFjMyNjU0JiMiTAEl3+ABJv7a4N/+2+2jdHWhoXV0AfTlASv+1eXm/tMBLQF6/tiqqJaUpQAAAAIAmv57BIkD/AAPABsAYACyCwAAK7ETBOmyAQEAK7IGAQArsRkE6bAALwGwHC+wANaxDwvpsQIQMjKwDxCxFgErsQkL6bEdASuxFg8RErMGCxMZJBc5ALETCxESsA45sBkRsQgJOTmwARKwAzkwMRMRMxU+ATMyEhAAIyImJxEDFBYzMjY1NCYjIgaa5Seobtf2/v/UZ58pApZ2d5aVeHaW/nsFaodFWf7c/jj+1048/goDeY2trI6LqqsAAgBM/nsEOQP+ABIAHQBeALIPAAArsRYE6bIIAQArsgQBACuxGwTpsAsvAbAeL7AA1rETC+mwExCxCwErsQcYMjKxCgvpsR8BK7ELExESswQPFhskFzkAsRYPERKwDDmwGxGwADmwCBKwBzkwMRM0PgEzMhYXNTMRIxEOASMiLgE3FBYyNjU0JiMiBkxx2o53mx/j6SWZZ4zcd++V7JaVd3iTAfaQ641eQIX6lgH8Q02L8JSOsLCOjaioAAABAJoAAALhA/IADgAvALIAAAArsgYBACuwATOxCwPpAbAPL7AA1rEOC+mwAjKxEAErALEGCxESsAM5MDEzETMVPgEzMhcVJiMgGQGa5yObYyEeKSX+9APln1FbBvIG/tv+JQAAAQBC/+EDVgQEADAAqwCyLAAAK7EEBOmyEQEAK7QdBAAfBCsBsDEvsA7WsSAK6bAgELEHASuxJwrpsTIBK7A2GrrtdsK+ABUrCg6wCxCwCsCxIwX5sCTAuvISwYkAFSsKsQsKCLALELAKwLEjBfmwJMAAswoLIyQuLi4uAbMKCyMkLi4uLrBAGgGxIA4RErECATk5sAcRswQRHSwkFzmwJxKxFxg5OQCxHQQRErUAAQ4XGCckFzkwMRM3HgEzMjY1NCYvAS4BNTQ2MzIeAxcHLgMjIgYVFBYfAR4BFRQOAiMiLgJCzgZqW0ZQOzqUgYvVmlCDUjscBckDFihILz5SNy6Xi5QwWpRbZqJdMQEOOkhiQjApOgwhHZxqhL0oO05EIToYMDAeRC8nOAkfHqFwO29dOT1gYQAAAQAj//QCmAUXABgAagCyFAAAK7EPBOmyAQEAK7AIM7EABOmwCjKyAQAKK7NAAQYJKwGwGS+wF9axDAvpsAcyshcMCiuzQBcACSuwDBCxBQnpsAUvsgwFCiuzQAwKCSuwETKxGgErALEPFBESsBI5sAARsBE5MDETNTMyNj0BMxEzFSMRFBYzMjcVBiMiJjURIzNMTtfPzz1CKigzX4ugAxLTVkaW/s7T/jJCOwjFFp6LAfUAAQCP/+MEDgPlABYATQCyDwAAK7IUAAArsQYE6bIBAQArsAozAbAXL7AA1rEDC+mwAxCxCQErsBEysQwL6bEYASuxCQMRErAUObAMEbAPOQCxBg8RErAROTAxExEzERQWMzI2NREzERQXIyY1DgEjIiaP7mRlZG3tCuMIJJxbrssBcQJ0/bdkgHtlAk380VpcLkFCSuMAAAABABQAAAQfA+UABgAhALIGAAArsgABACuwAzMBsAcvsQgBKwCxAAYRErACOTAxEyEJATMBIxQBBwEIAQL6/nnuA+X9OALI/BsAAAAAAQAbAAAGaAPlAAwARgCyDAAAK7AIM7IAAQArsQMGMzMBsA0vsADWsQEP6bABELEGASuxBwzpsQ4BK7EGARESsQgMOTkAsQAMERKyAgUKOTk5MDETMxsBMxsBMwEjCwEjG/7K7Pbrx/H+we738vQD5f1OArL9TgKy/BsCzf0zAAABABcAAAQGA+UADwAmALIAAAArsAozsgIBACuwBzMBsBAvsREBKwCxAgARErEGDDk5MDEzCQEhFhIXEyEJASEDBgIHFwFq/pwBGgrJCNoBDv6iAWr+6ugF0goB+AHtEf7eDAE//hf+BAFOCP7MEgAAAQAQ/m0ERAPlAAcAFACyAAEAK7ADMwGwCC+xCQErADAxEyEJATMBIxMQAQ0BHgEN/P2F/u8D5f2KAnb6iAIKAAEATgAAA30D5QAJAC4AsgAAACuxBwTpsgQBACuxAwTpAbAKL7ELASsAsQcAERKwATmxBAMRErAGOTAxMzUBITUhFQEhFU4B+v4QAxv+AAIKzwJF0cj9tNEAAAAAAQBc/scC4QZkACIAXACyCwIAK7QIBAAfBCuwHC+0GQQAHwQrsAAvsQEE6QGwIy+wH9awBDKxFhHpsA4yshYfCiuzQBYbCSuwCTKxJAErALEAGRESsRUfOTmwARGwEjmwCxKxBQ85OTAxEzUyNjURNDY7ARUjIgYVERQGBx4BFREUFjsBFSMiJjURNCZcX3jGuS8tXlpuY2NuWl4tL7nGdwIvzWBlAR7Cw7ZfaP6sY4QWF4Zj/qxoXbbDwgEcZmEAAQCu/scBdwZkAAMAFwABsAQvsADWsQMR6bEDEemxBQErADAxExEzEa7J/scHnfhjAAAAAAEACv7HAo8GZAAiAFwAshACACu0EQQAHwQrsCIvtAAEAB8EK7AaL7EZBOkBsCMvsATWsAsysR4R6bAVMrIEHgors0AEIgkrsBAysSQBKwCxGgARErEFHjk5sBkRsAg5sBASsQsVOTkwMRczMjY1ETQ2Ny4BNRE0JisBNTMyFhURFBYzFSIGFREUBisBCi1eW25jY25bXi0vucZ4X2B3xrkvg11oAVRjhhcWhGMBVGhftsPC/uJlYM1hZv7kwsMAAAEAPQGqBGAC/gAWADMAsA8vsQgE6bMUCA8IK7EDBOkBsBcvsRgBKwCxFA8RErEAFjk5sAgRsAw5sAMSsAs5MDETPgEzMh8BFjMyNjcXDgEjIi8BJiMiBz05qmNsY143OjZgIoc5p2NoaWA6MWxQAjFjajc0Hjg0bGNoOTQcbgAAAgCT/kwBwQQEAAkADQBNALIDAQArtAgDABUEKwGwDi+wANawCjKxBQjpsA0ysQUI6bMMBQAIK7QLEQA8BCuwCy+0DBEAPAQrsQ8BK7EMCxESswIHCAMkFzkAMDETNDYyFhUUBiImGwEzE5NYfFpafFgFPao7A289WFg9PlhX+xwD/PwEAAAAAAIAXAAABAIFMQAcACMALQCyGQAAKwGwJC+wANaxHQrpsB0QsRkBK7EDIDIysRgR6bEFDTIysSUBKwAwMRM0Ejc1MxUeARcHLgEnET4BNxcOAwcVIzUmAjcUFhcRDgFc2aq7jrUdzQ1KPEBRDskQO1d9Sbuq2d9ZS0tZApq3AQYiuLQWqGtINVgT/dUSXTNIM11TPAqyuCIBC7VkjR4CGR+IAAAAAQB/AAAEkQVOAC0AnACyAAAAK7ElBOmwATKwBy+wHzOxCATpsB0ysBgvsQ4E6QGwLi+wC9axGwvpsgsbCiuzQAsHCSuwADKzBBsLCCuxIgrpsiIECiuzQCIfCSuwGxCxKQErsSoK6bAqELAUINYRsRUK6bAVL7EUCumxLwErsSIEERKxHSU5ObAVEbEOGDk5ALEHJRESsSkqOTmxGAgRErILFBU5OTkwMTM1PgE1NCcjNTMmNTQ2MzIeAxcHLgEjIgYVFBchFSEWFRQGByEyNjUXFAYjf2V2CMmDL+64XJReQBwC4QFrW09vNwGB/roEVlMBalZe3cGh1SaSWBgyw2pto+IvSmVkNSVka2NZUoHDIBFgnS5uUhin1AACAFD/4wRcBAQAGgAiAIoAshoAACuwFDOyBwEAK7AMM7QXHhoHDSuxFwTptAoiGgcNK7EKBOkBsCMvsAPWsRwR6bAcELEgASuxEBHpsSQBK7EcAxESswEFBxokFzmwIBGzCBULGSQXObAQErMMDhIUJBc5ALEeFxESsxMAFRkkFzmwIhGzAQUOEiQXObAKErMGCAsNJBc5MDE/ASY1NDcnNxc2Mhc3FwcWFRQHFwcnBiMiJwcSFBYyNjQmIlCVQUOXk5hp8GGWkY9HRY2PkmZ5e2qWjofMhobMc5dkgn9qmpGcPjmXkZRrhIFtj5CUPECYAnXQiIjQhwAAAAABAC8AAAScBS8AFgBwALIOAAArsBAvsAsztBEEABcEK7AJMrAUL7AHM7QVBAAXBCuwBTKwAC+wAzMBsBcvsA7WsBIysQ0L6bAIMrINDgors0ANBwkrsAoysg4NCiuzQA4UCSuwEDKxGAErsQ0OERKwAjkAsQAVERKwAjkwMRMhCQEhATMVIRUhFSERIxEhNSE1ITUzLwEVASsBIgEL/rzw/psBZf6b7f6iAV7+ouMFL/3+AgL96K2XrP7ZASesl60AAAAAAgCu/sUBdwZkAAMABwAdAAGwCC+wANawBDKxAxHpsAYysQMR6bEJASsAMDETETMRAxEzEa7Jycn+xQMx/M8EbgMx/M8AAAAAAgCc/k4D7gXLADcAQwCFALIBAAArsggAACuyGQIAK7EgBOmwNS+xBATpAbBEL7AQ1rEAFTIysTgK6bABMrEjC+mwOBCxHQErsD4ysRwK6bErMTIysUUBK7E4EBESsQwTOTmxHSMRErcECxkHJzU8QiQXObAcEbAuOQCxAQQRErEAMTk5sCARtgoVHB0uPEIkFzkwMRc3FBYzMjY1NCYvAS4DNTQ2NyY1ND4BMzIWFwc0JiMiBhUUHwEeAxUUBgceARUUDgEjIiYTFBYfATY1NCYvAQac32dgU2U3MNJCWlcsYESoesFxweAD4mZeU2hp0UFbWCxgQ1FXesJxwtzeMDrPUDE50U4zKWl2WE0vUBltITxVbUNXhiNztHKzXNWoKWpzXEpfNm0iO1ZtQleGIzibVHK0XdEDLzRKHm43UjNIIG82AAAAAAIAQgR7AuMFhQALABYANQCwCS+wFDO0AwMAJwQrsA8ytAMDACcEKwGwFy+wANaxBhDpsAYQsQwBK7ESEOmxGAErADAxEzQ2MzIWFRQGIyImJTQ2MzIWFRQGIiZCTDc5Tk45OEsBmUw3OE1NcEsFADhNTTg5TEw5OE1NODlMTAAAAwBW/+EGNQXLABEAIgBAAIoAsg4AACu0FgQAFwQrsgUCACu0HwQAFwQrtD41DgUNK7Q+BAAXBCu0Ji8OBQ0rtCYEABcEKwGwQS+wANa0EhEAPAQrsBIQsSMBK7EyEemwMhCxGgErtAkRAEYEK7FCASuxGjIREkAKBA0OBRYfJis5PiQXOQCxLzUREkAJCRIaIysALDg5JBc5MDETNBI2JCAEFhIVFAIGBCAkJgI3FBIEMzIkEjU0LgIjIgQCFzQ2MzIeAhcHLgEjIgYVFBYzMjY3Fw4DIyImVnbJARYBMgEXynd3yv7p/s7+6sl2qJkBC6KhAQqaW5rYeKL+9Zm66KpMf1Y4DagOXFJbfn9cU2ARpA85V39KrOoC15kBGMt4eMv+6Jma/ufLeHjLARmap/7rnp4BFad93qBdnv7sprTsLUtZMT49VYFxcoRYODwwWEst7wAAAAACAHkCXALsBUYAHgApAJYAsBwvtCIEAA4EK7AJL7QQBAAXBCsBsCovsADWsA0ysR8R6bAMMrAfELElASuyBhkmMjIytBMRAFsEK7ErASuwNhq6CbTAvQAVKwoEsCYuDrAnwLEEGvmwA8AAswMEJicuLi4uAbIDBCcuLi6wQBoBsSUfERKxEBw5ObATEbAXOQCxIhwRErAUObAJEbMADA0TJBc5MDETNDY/ATY1NCYjIgYHJz4BMzIWFREUFyMmNQ4BIyImNxQWMzI2PQEHDgF5dl2wNUE8O0cFpgqhgpuUCagJHmlKbYS4MS9FW6goMAMxWmwNGwgpKjZDMiNeipd0/qZMJBs7Lj19YiMxUFgfGAYuAAACADkAzQPbA+UABQALABQAsgEBACuwBzMBsAwvsQ0BKwAwMRMBMwkBIxMBMwkBIzkBF+P+7gEQ45MBF+P+7gEQ4wJYAY3+cf53AYsBjf5x/ncAAAABAFwBIwQvA3kABQAwALAAL7EBBOmyAAEKK7NAAAQJKwGwBi+wBNaxAwnpsgQDCiuzQAQACSuxBwErADAxEzUhESMRXAPTzwKyx/2qAY8AAAEAXAHuAp4CwQADACIAsAAvsQEE6bEBBOkBsAQvsQABK7QDCAAIBCuxBQErADAxEzUhFVwCQgHu09MAAAQAVv/hBjUFywARACIAMAA5ALcAsg4AACu0FgQAFwQrsgUCACu0HwQAFwQrtC8xDgUNK7QvBAAXBCuyLzEKK7NALyMJK7AsMrQlOQ4FDSu0JQQAFwQrAbA6L7AA1rQSEQA8BCuwEhCxIwErtDARAFEEK7AxMrAwELE1ASuxKBHpsCwysCgQsRoBK7QJEQBGBCuxOwErsTAjERKxDgQ5ObA1EbIfLRY5OTmwKBKyDQUrOTk5ALExLxEStAkSGisAJBc5sDkRsCg5MDETNBI2JCAEFhIVFAIGBCAkJgI3FBIEMzIkEjU0LgIjIgQCAREhMhYVFAYHEyMDIxkBMzI2NTQmKwFWdskBFgEyARfKd3fK/un+zv7qyXaomQELoqEBCppbmth4ov71mQE/ATJ3oVxMrsicO2Q9REQ9ZALXmQEYy3h4y/7omZr+58t4eMsBGZqn/uuengEVp33eoF2e/uz9xQM1mG5TgR7+wwEm/toBvDw1NjwAAAABAD0EngJ3BVYAAwAoALAAL7QBBAAfBCu0AQQAHwQrAbAEL7EAASu0AwgACAQrsQUBKwAwMRM1IRU9AjoEnri4AAAAAAIALQK4As0FSgAKABMASACwCS+0DgQAFwQrsBIvtAMEAB8EKwGwFC+wAdaxCxHpsAsQsRABK7EGEemxFQErsRALERKxCQM5OQCxEg4RErIBAAY5OTkwMRIQNjMyFhUUBiMiAxQWMjY0JiIGLceJiMjIiogHU3xRUXxTA3cBEsHBiYq+AUhCVlaEVFUAAgCBAGAEJQRGAAMADwBfALAAL7EBBOmwBC+wCzOxBQTpsAkysgQFCiuzQAQOCSuyBQQKK7NABQcJKwGwEC+wDtawBjKxDRHpsAgysg0OCiuzQA0DCSuwCjKyDg0KK7NADgAJK7AEMrERASsAMDE3NSEVATUhETMRIRUhESMRgQOk/FwBbcoBbf6TymDFxQIdwAEJ/vfA/voBBgAAAQBzAr4CsgW8AB4AYgCyFAIAK7QJBAAXBCuwAC+0HAQAFwQrAbAfL7AR1rAAMrQMEQBGBCuwDBCxBgErsRcR6bAdMrEgASuxDBERErADObAGEbIUGhw5OTmwFxKwGTkAsQkcERKzAw8RFyQXOTAxEzU0PwE2NTQmIyIGFRQXByY1NDYzMhYVFA8BBgchFXOye1Q1MDE5BqwGl4OBmJqRIwYBWgK+GctsSjJBJTU7MBkYAh4gaY6NZolbWBkanAAAAQBxAq4C2QWsABoARgCyDwIAK7QOBAAXBCuwGC+0BAQAFwQrAbAbL7AG1rEVEemxHAErsRUGERKxEBE5OQCxDgQRErMAARIVJBc5sA8RsBE5MDETNx4BMjY1NCYjIgcnNyE1IRUHHgEVFAYjIiZxowhOcEVINSIeQbr+sAI8wV51qouBogONMTRCOio1Mwx9jZqTjgl3YWqSgwAAAQA9BGICDAWRAAMAIACwAC+0AQMAFQQrAbAEL7AA1rQCCAAJBCuxBQErADAxGwEhAT23ARj+9ARiAS/+0QAAAAEAmv57BBkD5QAXAFYAsg8AACuwFjOyFAAAK7EGBOmyAQEAK7AKM7AALwGwGC+wANaxFwvpsAIysBcQsQkBK7ARMrEMC+mxGQErsQkXERKwFDmwDBGwDzkAsQYPERKwETkwMRMRMxEUFjMyNjURMxEUFyMmNQ4BIyInEZrtZGVkbe0L5AgknFtLQP57BWr9t2SAe2UCTfzRUWUuQUJKGf5/AAAAAQA9/m0FBgWsABEARQCyBAIAK7ELBOmwBjKyCwQKK7NACw0JK7AIMgGwEi+wDdaxDBHpsAwQtAAIAAcEK7AAL7AMELEJASuxCBHpsRMBKwAwMRM0PgEzIRUjESMRIxEjESMiJj2E1YMC7cfCw8Ijp/EECoPBXr75fwaB+X8EDugAAAAAAQCFAcUBxwMCAAsAKACwCS+0AwMADQQrtAMDAA0EKwGwDC+wANaxBgjpsQYI6bENASsAMDETNDYzMhYVFAYjIiaFXkJDX15EQ10CYkJeXkJDWloAAQA5/jcCIQAbABcARwCwFS+0AwQADgQrsAkvsQ0D6QGwGC+wBta0EhEAMgQrsRkBK7ESBhESsA45ALEDFRESsAA5sAkRsQESOTmwDRKxDBA5OTAxEzcWMzI2NTQmIyIHJzczBx4BFRQGIyImOVRITiczLiYeG0hioFBYb35+TX/+mmZIHx8aIwpYmnsCXkxQbToAAAEAWAK+AckFrAAIAEUAsgQCACuwAC+0AQQADgQrsgABCiuzQAAHCSsBsAkvsAfWsQYR6bIHBgors0AHAAkrsAYQtAQRADwEK7AEL7EKASsAMDETNT4BNzMRIxFYU2sLqLsEnHsBWDz9EgHeAAIAfwJcA2AFRgAHABEATACwBy+0CwQAFwQrsBAvtAMEABcEKwGwEi+wAdaxCBHpsAgQsQ4BK7EFEemxEwErsQ4IERKzAwYHAiQXOQCxEAsRErMBBAUAJBc5MDESEDYgFhAGIAMUFjMyNjQmIgZ/0gE+0dH+whhrTE1paZpqAy8BRNPT/rzTAXVhbm3Ea2sAAAIAJQDNA8cD5QAFAAsAFACyAAEAK7AGMwGwDC+xDQErADAxEzMJASMBEzMJASMBJeMBF/7r4wEQluMBF/7r4wEQA+X+c/51AYkBj/5z/nUBiQAAAAQAZgAABgAFLwAIAAwAFwAaALIAsgkAACuwFTOwDS+wEzO0GAQAFwQrsBEyshgNCiuzQBgPCSuwAC+0AQQADgQrsgABCiuzQAAHCSuwBC+wCjMBsBsvsAfWsQYR6bIHBgors0AHAAkrsAYQtAQRADwEK7AEL7AGELEWASuwGTKxFRHpsBAyshUWCiuzQBUTCSuyFhUKK7NAFg0JK7EcASuxBgQRErAMObAWEbIKDxg5OTmwFRKwCzkAsQAYERKxDho5OTAxEzU+ATczESMRAwEzASU1ATMRMxUjFSM1JzMRZlNrC6i6ZQOy1fxQAccBYMt/f7jT0wQfewFYPP0TAd374QUv+tGRtQGo/jmWkZGWAQAAAAMAZgAABhAFLwAIAAwAKwCoALINAAArsAkztCkEABcEK7AWL7QhBAAXBCuwAC+0AQQADgQrsgABCiuzQAAHCSuwBC+wCjMBsCwvsAfWsQYR6bIHBgors0AHAAkrsAYQtAQRADwEK7AEL7AGELEeASuwDTK0GREARgQrsBkQsRMBK7EkEemwKjKxLQErsRkHERKyCgwQOTk5sBMRswshJykkFzmwJBKwJjkAsRYpERKzEBweJCQXOTAxEzU+ATczESMRAwEzASE1ND8BNjU0JiMiBhUUFwcmNTQ2MzIWFRQPAQYHIRVmU2sLqLpnA7LV/FACRLJ7VDQwMToGrAaYg4GXmZIjBgFaBB97AVg8/RMB3fvhBS/60RnLbEoyQCU1OjAZGAIeH2mPjWeIW1gZGpwAAAAABABqAAAGmAUvABoAHgApACwAqwCyGwAAK7AnM7AfL7AlM7QqBAAXBCuwIzKyKh8KK7NAKiEJK7AYL7QEBAAXBCuwDi+0DwQAFwQrsBwyAbAtL7AG1rEVEemwFRCxKAErsCsysScR6bAiMrInKAors0AnJQkrsignCiuzQCgfCSuxLgErsRUGERKyEBEeOTk5sCgRshwhKjk5ObAnErAdOQCxBBsRErEgLDk5sA4RswABEhUkFzmwDxKwETkwMRM3HgEyNjU0JiMiByc3ITUhFQceARUUBiMiJhMBMwElNQEzETMVIxUjNSczEWqkCE5wRUg1ICBBuv6wAjzBXnWqi4Gj7AOz1fxPAbEBYMt/f7nT0wMQMjRDOio1NA19jpmTjgl3YWqSg/1MBS/60ZG1Aaj+OZaRkZYBAAAAAAIAI/4tA8MEBAAiACwAewCyJgEAK7QrAwAVBCuwHi+xEQXpAbAtL7AA1rEOB+mwDhCxBQErsQkJ6bAJELMZCSkOK7EkCOmwJC+xKQjpsAkQsRQBK7EZC+mxLgErsSQOERKxDAM5ObApEbERHjk5sQkFERKyCyYrOTk5ALErERESswAGFhkkFzkwMRc0PwE2PQEzFhUUDwEGFRQWMzI2NTQnFxYVFA4CIyIuAgA0NjMyFhQGIyIjy1hkywakXmBzam92DOkLO261b262cj0BVlY/PlhYPj852Y8+R4EVJii/dERFb1Z3jGI2JhkoNk+Ve0tGdJEDuXxXWHpZAAMAFAAABZwHEAAHAAsADgAsALIAAAArsAMzsgECACu0BgwAAQ0rsQYG6QGwDy+xEAErALEBDBESsA45MDEzASEBIQMhAxMhFyMDIQMUAjYBHAI2/vOJ/ZqHNQEv0919AbrdBaz6VAFt/pMHEP78PgJSAAAAAwAUAAAFnAcQAAcACgAOACwAsgAAACuwAzOyAQIAK7QGCAABDSuxBgbpAbAPL7EQASsAsQEIERKwCjkwMTMBIQEhAyEDEyELATchBRQCNgEcAjb+84n9mofdAbrdd9EBMf7dBaz6VAFt/pMCUAJSAXD+/gADABQAAAWcBxAABwAOABEALACyAAAAK7ADM7IBAgArtAYPAAENK7EGBukBsBIvsRMBKwCxAQ8RErAROTAxMwEhASEDIQMTNyEXIycHAyEDFAI2ARwCNv7zif2ah0XuAQj04pmUQwG63QWs+lQBbf6TBhL+/oSE/D4CUgAAAwAUAAAFnAcdAAcAIwAmAIQAsgAAACuwAzOyAQIAK7QGJAABDSuxBgbpsB8vtAwEAB8EK7AVMrMRDB8IK7QaBAAfBCsBsCcvsAjWtCMRAA0EK7AjELEUASu0FxEADQQrsSgBK7EjCBESsQYkOTmwFBG0AgwBGiYkFzmwFxKxBSU5OQCxASQRErAmObERGhESsAg5MDEzASEBIQMhAxM1NDYzMh8BFjMyNj0BMxUUBiMiLwEmIyIGHQEDIQMUAjYBHAI2/vOJ/ZqHYnRZSk0VQBgcI5hyWUhNFTgkGSUeAbrdBaz6VAFt/pMGDi1tdS8NIyEjFTBsdS8PIiMgFfxCAlIAAAAEABQAAAWcBxsABwARABQAHgBuALIAAAArsAMzsgECACu0BhIAAQ0rsQYG6bAQL7AdM7QLAwAeBCuwGDIBsB8vsAnWsQ4Q6bAOELEWASuxGxDpsSABK7EOCRESsgcGEjk5ObAWEbICARQ5OTmwGxKyBAUTOTk5ALEBEhESsBQ5MDEzASEBIQMhAwI0NjMyFhQGIyITIQMSNDYzMhYUBiMiFAI2ARwCNv7zif2ahwdPOTpPTzo5lQG63bRMOTpQUDo5Baz6VAFt/pMGWHJRUXJO/EYCUgG2clFRck4AAwAUAAAFnAcUABAAEwAdAGYAsgAAACuwDDOwDy+xEQbpsBwvtAYEABcEKwGwHi+wA9a0FBEAMgQrsBQQsRkBK7QJEQAyBCuxHwErsRQDERKxARE5ObAZEbETBjk5sAkSsQsSOTkAsRwRERK1AwkLARMWJBc5MDEzASY1NDYzMhYVFAcBIQMhAxMhCwEUFjI2NTQmIgYUAhFanWttnVYCFf7zif2ah90But1mO1Y7O1Y7BU5Nd22VlW1yTPqsAW3+kwJQAlIBcC05OS0sOTkAAAIADgAAB+MFrAAPABIAWACyDAAAK7AAM7EJA+myAQIAK7EEA+m0DhAMAQ0rsQ4E6bQIBQwBDSuxCAbpAbATL7AN1rARMrEJB+mwBDKyCQ0KK7NACQsJK7ACMrNACQcJK7EUASsAMDEzASEVIREhFSERIRUhESEDASERDgPDBBL9dQJO/bICi/x//cnsAXMBsAWs5f5/4P5/5QFx/o8CRAKfAAAAAQBW/jcFxQXLADwAXwCyBQIAK7EOA+mwKC+0LgQADgQrAbA9L7AA1rETDumwExCxMQErtCURADIEK7E+ASuxMRMRErcOBRgiKCs3OCQXObAlEbAhOQCxLigRErArObAOEbQKAAslLCQXOTAxEzQSNiQzMh4CFwcuASMiDgIVFB4CMzI2NxcOAw8BHgEVFAYjIiYnNxYzMjY1NCYjIgcnNy4CAlZ6zAEHjobjoGsZ5yPVrlypiFJQh6xeq9wp4hhejMRyLVhvfn5NfyBUSE4nMy4mHhtIQIjxtmkC1awBIr5qS4OnYk6NsEN+zn97yn9Et4hJV52EWAxHAl5MUG06KWZIHx8aIwpYZAxyvQETAAACAK4AAAQvBxAACwAPAE8AsgAAACuxCQPpsgECACuxBAPptAgFAAENK7EIBukBsBAvsADWsQkH6bAEMrIJAAors0AJCwkrsAIys0AJBwkrsREBK7EJABESsAw5ADAxMxEhFSERIRUhESEVASEXI64Dgf11Ak79sgKL/OoBL9PeBazl/n/g/n/lBxD+AAIArgAABC8HEAALAA8ARwCyAAAAK7EJA+myAQIAK7EEA+m0CAUAAQ0rsQgG6QGwEC+wANaxCQfpsAQysgkACiuzQAkLCSuwAjKzQAkHCSuxEQErADAxMxEhFSERIRUhESEVATchBa4Dgf11Ak79sgKL/ZrRATH+3QWs5f5/4P5/5QYS/v4AAAACAK4AAAQvBxAACwASAE8AsgAAACuxCQPpsgECACuxBAPptAgFAAENK7EIBukBsBMvsADWsQkH6bAEMrIJAAors0AJCwkrsAIys0AJBwkrsRQBK7EJABESsAw5ADAxMxEhFSERIRUhESEVATchFyMnB64Dgf11Ak79sgKL/MntAQnz4ZqTBazl/n/g/n/lBhL+/oSEAAAAAAMArgAABC8HGwALABMAHgCAALIAAAArsQkD6bIBAgArsQQD6bQIBQABDSuxCAbpsBwvsBIztBcDAB4EK7AOMgGwHy+wANaxCQfpsAQysgkACiuzQAkLCSuwAjKzQAkHCSuwABCwDSDWEbEREOmwCRCxFAErsRoQ6bEgASuxCQ0RErEOEzk5sBERsQ8SOTkAMDEzESEVIREhFSERIRUANDYyFhQGIiU0NjMyFhQGIyImrgOB/XUCTv2yAov80U5yUFByAYVNOjlOTjk6TQWs5f5/4P5/5QZYclFRck6HOlBRck5OAAL/oAAAAagHEAADAAcAKgCyBAAAK7IFAgArAbAIL7AE1rEHDumwAjKxCQErsQcEERKxAQM5OQAwMQMhFyMDETMRYAEv090X+gcQ/vnuBaz6VAAAAAIArgAAArYHEAADAAcAKgCyAAAAK7IBAgArAbAIL7AA1rAEMrEDDumxCQErsQMAERKxBQc5OQAwMTMRMxEDNyEFrvr00QEx/t0FrPpUBhL+/gAAAAL/wQAAAqoHEAAGAAoAJwCyBwAAK7IIAgArAbALL7AH1rEKDumxDAErsQoHERKxAQU5OQAwMQM3IRcjJwcTETMRP+0BCPThmpMS+gYS/v6EhPnuBaz6VAAD//wAAAJeBxIABwALABUAZACyCAAAK7IJAgArsBQvsAYztA8DADAEK7ACMgGwFi+wCNaxCw7pswULCAgrsQEP6bABL7EFD+mzDQsICCuxEg/psRcBK7EIARESsQIHOTmwBRGxAwY5ObESCxESsQ8UOTkAMDECNDYyFhQGIhMRMxECNDYzMhYUBiMiBElsS0tsafpKSjc2SUk2NwZbbEtLbEv58AWs+lQGW2xLS2xLAAIAIwAABY8FrAAQACEAZwCyDwAAK7ERBumyAwIAK7EdBum0AQAPAw0rsCAzsQEE6bAeMgGwIi+wD9awAjKxEQfpsB0yshEPCiuzQBEgCSuyDxEKK7NADwAJK7ARELEXASuxCQ/psSMBKwCxAQARErEJFzk5MDETNTMRITIEFhIVFAIGBCMhERMhMj4CNTQuAiMhESEVISOoAgKVAQDAbW7B/v+U/gD2AQJgpX9ISH6kYP78AQz+9AKNvwJgYrb+6quq/uuzYQKN/lQ+ecF6fMN6P/6BvwAAAAIArgAABXEHHQAJACUAjgCyAAAAK7AGM7IBAgArsAQzsCEvtA4EAB8EK7AXMrMTDiEIK7QcBAAfBCsBsCYvsADWsQkH6bAJELEKASu0JREADQQrsCUQsRYBK7QZEQANBCuwGRCxAwErsQYH6bEnASuxJQoRErACObAWEbEOHDk5sQMZERKwBzkAsQEAERKxAwg5ObEhHBESsAo5MDEzESEBETMRIQEREzU0NjMyHwEWMzI2PQEzFRQGIyIvASYjIgYdAa4BOQKU9v8A/TMadFlLTRRAGBwkl3FZSU0UOCQZJQWs+/oEBvpUBEz7tAYOLW11Lw0jISMVMGx1Lw8iIyAVAAAAAwBW/+EGGwcQABQAKAAsAEgAshEAACuxGwPpsgYCACuxJAPpAbAtL7AA1rEWDumwFhCxIAErsQwO6bEuASuxIBYRErQQEQYpKyQXOQCxJBsRErEMADk5MDETND4DMzIeAxUUAgYEICQmAhIUHgMzMj4CNC4CIyIOAhMhFyNWUIy62XJz2buNUHzP/vf+4P74znv8Nl18jEperYpTU4qtXkqMfF0mAS/T3QLXi/OzgkFBgrPzi63+3b1pab0BIwETzK16VilDfsz+zH5DKVZ6Ayb+AAADAFb/4QYbBxAAFAAoACwASACyEQAAK7EbA+myBgIAK7EkA+kBsC0vsADWsRYO6bAWELEgASuxDA7psS4BK7EgFhEStBARBikrJBc5ALEkGxESsQwAOTkwMRM0PgMzMh4DFRQCBgQgJCYCEhQeAzMyPgI0LgIjIg4CATchBVZQjLrZcnPZu41QfM/+9/7g/vjOe/w2XXyMSl6tilNTiq1eSox8XQEu0QEx/t4C14vzs4JBQYKz84ut/t29aWm9ASMBE8ytelYpQ37M/sx+QylWegIo/v4AAAADAFb/4QYbBxAAFAAoAC8ASACyEQAAK7EbA+myBgIAK7EkA+kBsDAvsADWsRYO6bAWELEgASuxDA7psTEBK7EgFhEStBARBiksJBc5ALEkGxESsQwAOTkwMRM0PgMzMh4DFRQCBgQgJCYCEhQeAzMyPgI0LgIjIg4CEzchFyMnB1ZQjLrZcnPZu41QfM/+9/7g/vjOe/w2XXyMSl6tilNTiq1eSox8XT3tAQj04ZqTAteL87OCQUGCs/OLrf7dvWlpvQEjARPMrXpWKUN+zP7MfkMpVnoCKP7+hIQAAwBW/+EGGwcfABQAKABDAIgAshEAACuxGwPpsgYCACuxJAPpsDovtDIEAB8EK7M/MjoIK7QtBAAfBCuwNTIBsEQvsADWsRYO6bAWELEpASu0QxEADQQrsEMQsTQBK7Q3EQANBCuwNxCxIAErsQwO6bFFASuxNEMRErYQERskLQY6JBc5ALEkGxESsQwAOTmxMjoRErApOTAxEzQ+AzMyHgMVFAIGBCAkJgISFB4DMzI+AjQuAiMiDgITNTQ2MzIfARYzMj0BMxUUBiMiLwEmIyIGHQFWUIy62XJz2buNUHzP/vf+4P74znv8Nl18jEperYpTU4qtXkqMfF1ddFlLTRQ+GkCXcVlJTRQ4JRkkAteL87OCQUGCs/OLrf7dvWlpvQEjARPMrXpWKUN+zP7MfkMpVnoCJi1tdS8NIkMVMGx1Lw8iIyAVAAQAVv/hBhsHGwAUACgAMAA4AG4AshEAACuxGwPpsgYCACuxJAPpsDAvsDcztCwDAB4EK7AzMgGwOS+wANaxFg7psBYQsSoBK7EuEOmwLhCxMgErsTYQ6bA2ELEgASuxDA7psToBK7EyLhEStBARGyQGJBc5ALEkGxESsQwAOTkwMRM0PgMzMh4DFRQCBgQgJCYCEhQeAzMyPgI0LgIjIg4CAjQ2MhYUBiIkNDYyFhQGIlZQjLrZcnPZu41QfM/+9/7g/vjOe/w2XXyMSl6tilNTiq1eSox8XSJPclBQcgJHTnJQUHIC14vzs4JBQYKz84ut/t29aWm9ASMBE8ytelYpQ37M/sx+QylWegJuclFRck5OclFRck4AAAAAAQBOAGgEFARCAAsAADcJATcJARcJAQcJAU4BWP6qjQFUAVSN/qoBWI3+qv6q9gFgAV6O/qEBX47+ov6gjgFf/qEAAAADAFb/jwYbBh8AGAAjAC0AbACyEgAAK7EmA+myBgIAK7EeA+kBsC4vsADWsRkO6bAZELErASuxDQ7psS8BK7EZABESsBU5sCsRtQgSFAYcJCQXObANErAJOQCxJhIRErIUFhc5OTmwHhGzDQAbLSQXObAGErIICgs5OTkwMRM0PgMzMhc3FwcWERQCBgQjIicHJzcmExQXASYjIg4DExYzMj4CNTQnVlCMutlyyrOSn5PJfM/+95DPrIukksn8ZAJtbX9KjHxdNv5rfF6tilNjAteL87OCQWe7e73T/sOt/t29aWO1ebvTAUHLhQMhOylWeq39xTdDfsx/v40AAAAAAgCe/+EE2QcQABQAGABCALIQAAArsQYD6bIBAgArsAozAbAZL7AA1rEDDOmwAxCxCQErsQwH6bEaASuxAwARErAVObAJEbMQFhcYJBc5ADAxExEzERQWMzI2NREzERQOASMiLgITIRcjnvOei42c9pLym3LEk1OyAS/T3QH6A7L8XJilpJkDpPxOqvd4RoXOBZb+AAIAnv/hBNkHEAAUABgAQgCyEAAAK7EGA+myAQIAK7AKMwGwGS+wANaxAwzpsAMQsQkBK7EMB+mxGgErsQkDERKzEBUWGCQXObAMEbAXOQAwMRMRMxEUFjMyNjURMxEUDgEjIi4CATchBZ7znouNnPaS8ptyxJNTAXvQATL+3QH6A7L8XJilpJkDpPxOqvd4RoXOBJj+/gAAAgCe/+EE2QcQABQAGwBJALIQAAArsQYD6bIBAgArsAozAbAcL7AA1rEDDOmwAxCxCQErsQwH6bEdASuxAwARErAVObAJEbQQFhcZGyQXObAMErAYOQAwMRMRMxEUFjMyNjURMxEUDgEjIi4CEzchFyMnB57znouNnPaS8ptyxJNTqu0BCPThmpMB+gOy/FyYpaSZA6T8Tqr3eEaFzgSY/v6EhAADAJ7/4QTZBxsAFAAfACoAZACyEAAAK7EGA+myAQIAK7AKM7AdL7AoM7QYAwAeBCuwIzIBsCsvsADWsQMM6bMVAwAIK7EbEOmwAxCxCQErsQwH6bMmDAkIK7EgEOmwIC+xJhDpsSwBK7EgGxESsRAGOTkAMDETETMRFBYzMjY1ETMRFA4BIyIuAhM0NjMyFhQGIyImJTQ2MzIWFAYjIiae856LjZz2kvKbcsSTU6ZNOjlOTjk6TQHjTTo5Tk45Ok0B+gOy/FyYpaSZA6T8Tqr3eEaFzgUXOlBRck5OOTpQUXJOTgACABQAAAUGBxAACAAMADQAsgcAACuyAAIAK7ADMwGwDS+wB9axBgfpsQ4BK7EGBxESsgIKDDk5OQCxAAcRErACOTAxEyEJASEBESMRAzchBRQBIwFcAV8BFP4A9h7RATH+3QWs/aACYPy6/ZoCZgOs/v4AAAIArgAABJgFrAALABQATQCyAAAAK7IBAgArtAoMAAENK7EKBOm0AxQAAQ0rsQME6QGwFS+wANaxCwfpsQIMMjKwCxCxEAErsQcO6bEWASsAsRQMERKxBwY5OTAxMxEzESEyBBAEIyEZASEyNjU0JiMhrvYBGM0BD/7yzP7mAQB0hoV1/wAFrP7w/P6G+f7TAgJ5Zmp8AAAAAQCa/+EEgQXLAD8AjgCyAAAAK7IcAAArtCYEAB8EK7IGAgArsTsE6QGwQC+wANaxPwvpsD8QsTMBK7EQC+mwEBCxOAErsQkL6bAJELAXINYRsSkK6bApL7EXCumxQQErsTM/ERKxISI5ObAQEbUGIyQtNjskFzmwOBKyHCYsOTk5sAkRsg4TFTk5OQCxOyYRErMJFyIjJBc5MDEzETQ+AjMyFhUUDgEPAQYVHgEfAR4BFRQOAiMiLgMnNx4BMzI2NTQmLwEuBDU0PwE2NTQmIyIGFRGaS4OpYMb2N0k0MTwBJi1EY3oqUYxXR3ZMNRcBxAJHSTtCMjVBJDQ/KByFM21uY2WJA+l0uXY/0ZpLfEgiHyIwHyEUHiuiaDZqXDomPE5NJi04XUEpLD4XHQ8cLzVOLZJWIkRaRV+TjPwlAAADAFz/4QPJBZEAIAAkADEAogCyGQAAK7IeAAArtCgEAB8EK7IQAQArsQkE6QGwMi+wANaxJQvpsCUQsS0BK7IGGy4yMjKxFgvpsTMBK7A2GroJpMC7ABUrCgSwLi4OsC/AsQQZ+bADwACzAwQuLy4uLi4BsgMELy4uLrBAGgGxJQARErIMDSE5OTmwLRG0EB4iIyQkFzmwFhKwGTkAsSgZERKwGzmwCRG0AAwNFRYkFzkwMRM0NjclNjU0JiMiBgcnPgEzMh4CFREUFyMmNQ4BIyImEyETIwMUFjMyPgI9AQUOAVymhwEASl5eWmsI2Q7ksW+oYi8N3Qspm2+Xu20BHLXDjU1ENFZHJ/78PEkBDoCZFCcKPkNVZk8xiL48aYNN/hFfQSFeQlyxBP/+0fy7NksbOWdHLScKQwAAAwBc/+EDyQWRACAALQAxAKIAshkAACuyHgAAK7QkBAAfBCuyEAEAK7EJBOkBsDIvsADWsSEL6bAhELEpASuyBhsqMjIysRYL6bEzASuwNhq6CaTAuwAVKwoEsCouDrArwLEEGfmwA8AAswMEKisuLi4uAbIDBCsuLi6wQBoBsSEAERKxDA05ObApEbQQHi4vMSQXObAWErEZMDk5ALEkGRESsBs5sAkRtAAMDRUWJBc5MDETNDY3JTY1NCYjIgYHJz4BMzIeAhURFBcjJjUOASMiJjcUFjMyPgI9AQUOARsBIQFcpocBAEpeXlprCNkO5LFvqGIvDd0LKZtvl7vuTUQ0Vkcn/vw8SUe3ARj+9AEOgJkUJwo+Q1VmTzGIvjxpg03+EV9BIV5CXLGLNksbOWdHLScKQwMLAS/+0QAAAAADAFz/4QPJBYkAIAAnADQApQCyGQAAK7IeAAArtCsEAB8EK7IQAQArsQkE6QGwNS+wANaxKAvpsCgQsTABK7IGGzEyMjKxFgvpsTYBK7A2GroJpMC7ABUrCgSwMS4OsDLAsQQZ+bADwACzAwQxMi4uLi4BsgMEMi4uLrBAGgGxKAARErIMDSE5OTmwMBG1EB4iIyUnJBc5sBYSsRkkOTkAsSsZERKwGzmwCRG0AAwNFRYkFzkwMRM0NjclNjU0JiMiBgcnPgEzMh4CFREUFyMmNQ4BIyImGwEzEyMnBwMUFjMyPgI9AQUOAVymhwEASl5eWmsI2Q7ksW+oYi8N3Qspm2+Xu2nb+N3Lj5BBTUQ0Vkcn/vw8SQEOgJkUJwo+Q1VmTzGIvjxpg03+EV9BIV5CXLED0gEl/tuenvy5NksbOWdHLScKQwAAAwBc/+EDyQWDACAAOABFAM8AshkAACuyHgAAK7Q8BAAfBCuyEAEAK7EJBOmwMC+wNzO0KQQAHwQrsDUg1hG0JAQAHwQrsCsyAbBGL7AA1rE5C+mwORCwNyDWEbQ4EQANBCuwOC+0NxEADQQrsDkQsUEBK7MGGytCJBcysRYL6bQtEQANBCuxRwErsDYaugmkwLsAFSsKBLBCLg6wQ8CxBBn5sAPAALMDBEJDLi4uLgGyAwRDLi4usEAaAbFBABEStA0QHikwJBc5sC0RsBk5ALEJGREStAAMDRUbJBc5MDETNDY3JTY1NCYjIgYHJz4BMzIeAhURFBcjJjUOASMiJhM0NjMyHwEWMzI1MxUUBiMiLwEmIgYVIxMUFjMyPgI9AQUOAVymhwEASl5eWmsI2Q7ksW+oYi8N3Qspm2+Xu3N1XkVKFTwcP5x0XURNFTk+Hpx5TUQ0Vkcn/vw8SQEOgJkUJwo+Q1VmTzGIvjxpg03+EV9BIV5CXLEEBnN4LQwjWiN0ey8MISkv/Ko2Sxs5Z0ctJwpDAAAABABc/+EDyQWFACAALAA5AEQAwACyGQAAK7IeAAArtDAEAB8EK7IQAQArsQkE6bAqL7BCM7QkAwAnBCuwPTIBsEUvsCHWsScQ6bAAINYRsS0L6bAnELE1ASuyBhs2MjIysRYL6bAWELBAINYRsToQ6bA6L7FAEOmxRgErsDYaugmkwLsAFSsKBLA2Lg6wN8CxBBn5sAPAALMDBDY3Li4uLgGyAwQ3Li4usEAaAbEnIRESsQweOTmwOhGyEAkwOTk5sEASsBk5ALEQHhESsQwbOTkwMRM0NjclNjU0JiMiBgcnPgEzMh4CFREUFyMmNQ4BIyImEzQ2MzIWFRQGIyImExQWMzI+Aj0BBQ4BATQ2MzIWFRQGIiZcpocBAEpeXlprCNkO5LFvqGIvDd0LKZtvl7tvTDc5Tk45OEt/TUQ0Vkcn/vw8SQEaTDc4Tk5wSwEOgJkUJwo+Q1VmTzGIvjxpg03+EV9BIV5CXLEEbjhNTTg5TEz8VjZLGzlnRy0nCkMDqThNTjc5TEwAAAAABABc/+EDyQYSACAALAA5AEUA3ACyGQAAK7IeAAArtDAEAB8EK7IQAQArsQkE6bAqL7Q9BAAOBCuwQy+0JAQADgQrAbBGL7AA1rEtC+mzIS0ACCu0OhEADQQrsC0QsTUBK7IGGzYyMjKxFgvpsycWNQgrtEARAA0EK7BAL7QnEQANBCuxRwErsDYaugmkwLsAFSsKBLA2Lg6wN8CxBBn5sAPAALMDBDY3Li4uLgGyAwQ3Li4usEAaAbE6IRESsQweOTmwQBG0CRAqMCQkFzmwJxKwGTkAsQkZERK0AAwNFRskFzmxQz0RErEnITk5MDETNDY3JTY1NCYjIgYHJz4BMzIeAhURFBcjJjUOASMiJhM0NjMyFhUUBiMiJhMUFjMyPgI9AQUOARMUFjMyNjU0JiMiBlymhwEASl5eWmsI2Q7ksW+oYi8N3Qspm2+Xu8+JXmCKi19eiR9NRDRWRyf+/DxJbjMlKDU1KCUzAQ6AmRQnCj5DVWZPMYi+PGmDTf4RX0EhXkJcsQSdYYKCYV+CgvxNNksbOWdHLScKQwPYJjQ0Jig0NQAAAAMAXP/hBqwEBAArADgAPwDnALIkAAArsCkzsR4E6bIkAAArtC8EAB8EK7IQAQArsBUzsQkE6bA9MrQ5GyQQDSu0OQQAFwQrAbBAL7AA1rEsC+mwLBCxNAErsQY1MjKxGwvpsDkysBsQsToBK7EYC+mxQQErsDYaugkewKcAFSsKBLA1Lg6wNsCxBBn5sAPAALMDBDU2Li4uLgGyAwQ2Li4usEAaAbEsABESsQwNOTmwNBGyCRApOTk5sBsSsRInOTmwOhGyFR4kOTk5sBgSshogITk5OQCxHi8RErAnObE5JBESsRggOTmwCRGxDA05ObAQErASOTAxEzQ2NyU2NTQmIyIGByc+ATMyFz4BMzIAFRQHIR4BMzI3Fw4BIyImJwYhIiY3FBYzMj4CPQEFDgEBIS4BIyIGXKaHAQ9LZ19ddgjRDPiq6W9CsV/kAP8E/SMEnnC+Pskp96d50UWA/v+rxO5SRzBXTC3+7D1IAocB7QN/dWuEAQ6AmRQnCj5CWGdKK4e/kUVM/unvKCRykrBBiLRmXcOwiDNKGzhoRS8nCEcBC15/hgABAEz+NQQbBAQANQBfALIEAQArsQ0F6bAjL7QpBAAOBCsBsDYvsADWsRAL6bAQELEsASu0IBEAMgQrsTcBK7EsEBEStw0EEx0jJjIzJBc5sCARsBw5ALEpIxESsCY5sA0RtAkACiAnJBc5MDETND4BMzIeAhcHLgEjIgYVFBYzMj4CNxcOAQ8BHgEVFAYjIiYnNxYzMjY1NCYjIgcnNyYCTIfpjmCjbkcQ1RR1aHOgoXY3XDojCtEkwJMvWG5+fkx/IFRITSc0LiYfG0dDwPoB9JfyhzlfcT9NTmylkJGpIzs7IEx1tRZJAl5MUG06KWZIHx8aIwpYaBkBJgADAEz/4QQZBZEAGAAcACMAcgCyFAAAK7EOBOmyBQEAK7EhBOm0HQsUBQ0rtB0EABcEKwGwJC+wANaxCwvpsB0ysAsQsR4BK7EIDOmxJQErsQsAERKwGTmwHhG1BQ4UGhscJBc5sAgSsgoQETk5OQCxCw4RErEQETk5sB0RsQAIOTkwMRM0PgIzMgAVFAchHgEzMjcXDgEjIi4CEyETIwMhLgEjIgZMUYawXuQBBAf9JwSeb787yCrsrGa4jVOZAR20wrUB6gN+dWqDAfhzx4ZM/ujuPg5xk64/irJJhs0EFP7R/f5ef4YAAwBM/+EEGQWRABgAHwAjAG0AshQAACuxDgTpsgUBACuxHQTptBkLFAUNK7QZBAAXBCsBsCQvsADWsQsL6bAZMrALELEaASuxCAzpsSUBK7EaCxEStQUOFCAhIyQXObAIEbMKEBEiJBc5ALELDhESsRAROTmwGRGxAAg5OTAxEzQ+AjMyABUUByEeATMyNxcOASMiLgI3IS4BIyIGGwEhAUxRhrBe5AEEB/0nBJ5vvzvIKuysZriNU/MB6gN+dWqDgbYBGf7zAfhzx4ZM/ujuPg5xk64/irJJhs3jXn+GAasBL/7RAAAAAAMATP/hBBkFiQAYAB8AJgB0ALIUAAArsQ4E6bIFAQArsSQE6bQgCxQFDSu0IAQAFwQrAbAnL7AA1rELC+mwIDKwCxCxIQErsQgM6bEoASuxCwARErAZObAhEbYFDhQaGx0fJBc5sAgSswoQERwkFzkAsQsOERKxEBE5ObAgEbEACDk5MDETND4CMzIAFRQHIR4BMzI3Fw4BIyIuAhsBMxMjJwcDIS4BIyIGTFGGsF7kAQQH/ScEnm+/O8gq7KxmuI1Tm9z33suQj28B6gN+dWqDAfhzx4ZM/ujuPg5xk64/irJJhs0C5wEl/tuenv38Xn+GAAAEAEz/4QQZBYUAGAAkACsANgCQALIUAAArsQ4E6bIFAQArsSkE6bQlCxQFDSu0JQQAFwQrsCIvsDQztBwDACcEK7AvMgGwNy+wANaxCwvpsCUysxkLAAgrsR8Q6bALELEsASuxMhDpsyYyLAgrsQgM6bE4ASuxHxkRErArObAsEbMOFAUpJBc5sDISsBA5ALELDhESsRAROTmwJRGxAAg5OTAxEzQ+AjMyABUUByEeATMyNxcOASMiLgITNDYzMhYVFAYjIiYTIS4BIyIGATQ2MzIWFRQGIiZMUYawXuQBBAf9JwSeb787yCrsrGa4jVOgTDc5Tk45OEtTAeoDfnVqgwE/TDc4TU1wSwH4c8eGTP7o7j4OcZOuP4qySYbNA4M4TU04OUxM/Zlef4YCSThNTTg5TEwAAAAC/7AAAAGFBZEAAwAHACoAsgQAACuyBQEAKwGwCC+wBNaxBwvpsAIysQkBK7EHBBESsQEDOTkAMDEDIRMjAxEzEVABHbTDJOsFkf7R+54D5fwbAAACAJoAAAJ1BZEAAwAHACkAsgAAACuyAQEAKwGwCC+wANaxAwvpsQkBK7EDABESsgQFBzk5OQAwMTMRMxEDEyEBmuvftgEZ/vMD5fwbBGIBL/7RAAAC/7gAAAJoBYkABgAKACUAsgcAACuyCAEAKwGwCy+wB9axCgvpsQwBK7EKBxESsAU5ADAxAxMzEyMnBxMRMxFI2/jdypCPG+sEZAEl/tuenvucA+X8GwAAA//sAAACMwV/AAcACwAVAGEAsggAACuyCQEAK7AUL7AGM7EPA+mwAjIBsBYvsAjWsQsL6bMFCwgIK7EBDumwAS+xBQ7psw0LCAgrsRIO6bEXASuxCAERErECBzk5sAURsQMGOTmxEgsRErEPFDk5ADAxAjQ2MhYUBiITETMRAjQ2MzIWFAYjIhRGbElJbGjrTkg1NklJNjUEymxJSWxH+30D5fwbBMpsSUlsRwAAAAACAEz/4wRSBeMAHgApAGIAshwAACuxIgTpsCgvsQUE6bALLwGwKi+wANaxIAvpsCAQsSUBK7EXDOmxKwErsSAAERKxDA85ObAlEbcFCwgQEhUcDSQXObAXErETFDk5ALEoIhESsRcAOTmwBRGwCDkwMRM0PgIzMhYXJicFJzcmJzcWFzcXBxIRFA4CIyIAEhAWMzI2NTQmIyJMU4msW1KNJTN7/uxAvVaSSteo5UKg/ESAxnre/tzrpHN0oJ91cwHTcLp2QS8rl3F9lFYxLbY2eGmWR/74/nB60p9bARoBXP74m5mGh5gAAgCaAAAEEAWDABMALACKALIAAAArsAozsgEBACuyBgEAK7EPBemwIy+wKzO0HAQAHwQrsCgg1hG0FwQAHwQrsB4yAbAtL7AA1rETC+mwAjKwExCwKyDWEbQsEQANBCuwLC+0KxEADQQrsBMQsQsBK7AeMrEKC+m0IBEADQQrsS4BK7ELABESsgYPIzk5OQCxBg8RErADOTAxMxEzFT4BMzIWFREjETQmIyIGFREDNDYzMh8BFjMyNTMVFAYjIi8BJiMiBhUjmucvnlqvue1jamJteXVeRkoUPBxAm3RdRE0UOSAfHpwD5YVSUN6t/YkCTmR5hWf9wQSYc3gtDCNaI3R7LwwhKS8AAwBM/+EEVgWRAAsADwAaAE4AsgkAACuxEwTpsgMBACuxGQXpAbAbL7AA1rERC+mwERCxFgErsQYM6bEcASuxEQARErAMObAWEbQJDQMPDiQXOQCxGRMRErEGADk5MDETNAAzMgAVFAAjIgATIRMjAhAWMzI2NTQmIyJMASXf4AEm/trg3/7boAEctMLBo3R1oaF1dAH05QEr/tXl5v7TAS0Eg/7R/ib+2KqolpSlAAADAEz/4QRWBZEACwAWABoATgCyCQAAK7EPBOmyAwEAK7EVBekBsBsvsADWsQ0L6bANELESASuxBgzpsRwBK7ESDREStAkDFxgaJBc5sAYRsBk5ALEVDxESsQYAOTkwMRM0ADMyABUUACMiABIQFjMyNjU0JiMiAxMhAUwBJd/gASb+2uDf/tvto3R1oaF1dAG2ARn+9AH05QEr/tXl5v7TAS0Bev7YqqiWlKUBNQEv/tEAAAADAEz/4QRWBYkACwASAB0AVQCyCQAAK7EWBOmyAwEAK7EcBekBsB4vsADWsRQL6bAUELEZASuxBgzpsR8BK7EUABESsAw5sBkRtQkNDhASAyQXObAGErAPOQCxHBYRErEGADk5MDETNAAzMgAVFAAjIgAbATMTIycHAhAWMzI2NTQmIyJMASXf4AEm/trg3/7bsNv43cuPj4qjdHWhoXV0AfTlASv+1eXm/tMBLQNWASX+256e/iT+2KqolpSlAAADAEz/4QRWBYMACwAjAC4AiQCyCQAAK7EnBOmyAwEAK7EtBemwGy+wIjO0FAQAHwQrsCAg1hG0DwQAHwQrsBYyAbAvL7AA1rElC+mzIyUACCu0IhEADQQrsCUQsSoBK7EGDOmzGAYqCCu0FhEADQQrsBYvtBgRAA0EK7EwASuxFiIRErUJDwMbJy0kFzkAsS0nERKxBgA5OTAxEzQAMzIAFRQAIyIAEzQ2MzIfARYzMjUzFRQGIyIvASYiBhUjEhAWMzI2NTQmIyJMASXf4AEm/trg3/7btHVeRUoVPBw/nHRdRE0VOT4enDejdHWhoXV0AfTlASv+1eXm/tMBLQOKc3gtDCNaI3R7LwwhKS/+Ff7YqqiWlKUABABM/+EEVgWFAAsAFwAiACwAcgCyCQAAK7EbBOmyAwEAK7EhBemwFS+wKjO0DwMAJwQrsCUyAbAtL7AA1rEZC+mzDBkACCuxEhDpsBkQsR4BK7EGDOmzKAYeCCuxIxDpsCMvsSgQ6bEuASuxIxIRErMJAxshJBc5ALEhGxESsQYAOTkwMRM0ADMyABUUACMiABM0NjMyFhUUBiMiJhIQFjMyNjU0JiMiEzQ2MhYVFAYiJkwBJd/gASb+2uDf/tuyTDc5Tk45OEs7o3R1oaF1dLxMbk5NcEsB9OUBK/7V5eb+0wEtA/I4TU04OUxM/cH+2KqolpSlAdM4TU04OUxMAAMAagBQBDUEWgADAA0AFwA0ALAML7QHAwAVBCuwAC+xAQTpsBYvtBEDABUEKwGwGC+wBdawDjKxCgjpsBMysRkBKwAwMRM1IRUANDYzMhYUBiMiAjQ2MzIWFAYjImoDy/2DWDw9VlY9PFhYPD1WVj08AfDKyv63eFZWeFcDO3hXV3hYAAMATP+iBFYERgATABsAIwBsALINAAArsR4E6bIDAQArsRkF6QGwJC+wANaxFAvpsBQQsSEBK7EKDOmxJQErsRQAERKwEDmwIRG1BQ0PAxccJBc5sAoSsAY5ALEeDRESsg8REjk5ObAZEbMKABYjJBc5sAMSsgUHCDk5OTAxEzQAMzIXNxcHFhUUACMiJwcnNyY3FBcBJiMiBhMWMzI2NTQnTAEl35J2a39rf/7a4I50Z4Fnge0nAW0/PnSjnjdCdaEkAfTlAStDhWmFktLm/tNCgWiBkdhlSQHKHaX+SRuolmJGAAIAj//jBA4FkQAWABoAWACyDwAAK7IUAAArsQYE6bIBAQArsAozAbAbL7AA1rEDC+mwAxCxCQErsBEysQwL6bEcASuxAwARErAXObAJEbMUGBkaJBc5sAwSsA85ALEGDxESsBE5MDETETMRFBYzMjY1ETMRFBcjJjUOASMiJhMhEyOP7mRlZG3tCuMIJJxbrstxAR20wwFxAnT9t2SAe2UCTfzRWlwuQUJK4wTL/tEAAgCP/+MEDgWRABYAGgBUALIPAAArshQAACuxBgTpsgEBACuwCjMBsBsvsADWsQML6bADELEJASuwETKxDAvpsRwBK7EJAxESsxQXGBokFzmwDBGxDxk5OQCxBg8RErAROTAxExEzERQWMzI2NREzERQXIyY1DgEjIiYBEyEBj+5kZWRt7QrjCCScW67LAR22ARn+9AFxAnT9t2SAe2UCTfzRWlwuQUJK4wOcAS/+0QACAI//4wQOBYkAFgAdAFsAsg8AACuyFAAAK7EGBOmyAQEAK7AKMwGwHi+wANaxAwvpsAMQsQkBK7ARMrEMC+mxHwErsQMAERKwFzmwCRG0FBgZGx0kFzmwDBKxDxo5OQCxBg8RErAROTAxExEzERQWMzI2NREzERQXIyY1DgEjIiYbATMTIycHj+5kZWRt7QrjCCScW67LZdv43cuPkAFxAnT9t2SAe2UCTfzRWlwuQUJK4wOeASX+256eAAMAj//jBA4FhQAWACIALAB7ALIPAAArshQAACuxBgTpsgEBACuwCjOwIC+wKjO0GgMAJwQrsCUyAbAtL7AA1rEDC+mwFyDWEbEdEOmwAxCxCQErsBEysQwL6bAMELAoINYRsSMQ6bAjL7EoEOmxLgErsSMdERKxFAY5ObAoEbAPOQCxBg8RErAROTAxExEzERQWMzI2NREzERQXIyY1DgEjIiYTNDYzMhYVFAYjIiYlNDYyFhUUBiImj+5kZWRt7QrjCCScW67La0w3OU5OOThLAZlNbk5NcEwBcQJ0/bdkgHtlAk380VpcLkFCSuMEOjhNTTg5TEw5OE1NODlMTAACABD+bQREBZEABwALABQAsgABACuwAzMBsAwvsQ0BKwAwMRMhCQEzASMTAxMhARABDQEeAQ38/YX+7xa2ARn+8wPl/YoCdvqIAgoD6wEv/tEAAAACAJr+ewSJBcsADwAbAGAAsgsAACuxEwTpsgECACuyBgEAK7EZBOmwAC8BsBwvsAHWsQML6bEOEDIysAMQsRYBK7EJC+mxHQErsRYDERKzBgsTGSQXOQCxEwsRErAOObAZEbEICTk5sAYSsAM5MDETETMRPgEzMhIQACMiJicRAxQWMzI2NTQmIyIGmu0qo2jX9v7/1GefKQKWdneWlXh2lv57B1D9n0BS/tz+OP7XTjz+CgN5ja2sjouqqwAAAAADABD+bQREBYUABwATAB4ATgCyAAEAK7ADM7ARL7AcM7QLAwAnBCuwFzIBsB8vsAjWsQ4Q6bAOELEUASuxGhDpsSABK7EOCBESsgUBBzk5ObAUEbACObAaErADOQAwMRMhCQEzASMTAzQ2MzIWFRQGIyImJTQ2MzIWFRQGIiYQAQ0BHgEN/P2F/u/dTDc5Tk45OEsBmkw3OE1NcEsD5f2KAnb6iAIKBIk4TU04OUxMOThNTTg5TEwAAgBW/+EIoAXLABwAMACXALIVAAArsRID6bIZAAArsSMD6bIKAgArsQ0D6bIGAgArsSwD6bQRDhkGDSuxEQbpAbAxL7AA1rEeDumwHhCxKAErsQkVMjKxEgfpsA0yshIoCiuzQBITCSuwCzKzQBIQCSuxMgErsSgeERKxBhk5OQCxEhURErAWObAREbAnObAOErIAHR45OTmwDRGwKDmwChKwCTkwMRM0PgMzMhYXNSEVIREhFSERIRUhNQ4BICQmAhIUHgMzMj4CNC4CIyIOAlZQjLrZcpH7XAN//XYCTv2yAoz8f1z8/uD++M57/DZdfIxKXq2KU1OKrV5KjHxdAteL87OCQWZhqOX+f+D+f+WmX2ZpvQEjARPMrXpWKUN+zP7MfkMpVnoAAAAAAwBM/+EHNQQEACAAKwAyAKQAsh4AACuwGDOxJATpsBIysgMBACuwCTOxKgXpsgMBACuxMATptCwPHgMNK7QsBAAXBCsBsDMvsADWsSIL6bAiELEnASuxDwzpsCwysA8QsS0BK7EMC+mxNAErsSciERKxHgM5ObAPEbEGGzk5sC0SsgkSGDk5ObAMEbIOFBU5OTkAsQ8kERKyFBUiOTk5sSoeERKyDAAbOTk5sQMwERKwBjkwMRM0ADMyFhc+ATMyABUUByEeATMyNxcOASMiJicOASMiABIQFjMyNjU0JiMiBSEuASMiBkwBJd96zEdDxGrkAQMG/ScEnW+/O8kq7ax0zUhGzXrf/tvto3R1oaF1dAKAAeoDfnVqgwH05QErXFZSYP7o7kAMcZOuP4qyXldWXwEtAXr+2KqolpSlzV5/hgAAAwAUAAAFBgcbAAgAEwAbAHMAsgcAACuyAAIAK7ADM7ARL7AaM7QMAwAeBCuwFjIBsBwvsAfWsQYH6bMPBgcIK7EJEOmwCS+xDxDpsxUGBwgrsRkQ6bEdASuxBwkRErIBDBE5OTmxFQ8RErACObEZBhESsgMWGzk5OQCxAAcRErACOTAxEyEJASEBESMRAzQ2MzIWFAYjIiYgNDYyFhQGIhQBIwFcAV8BFP4A9vxOOjlOTjk6TgHqTnJQUHIFrP2gAmD8uv2aAmYEKzpQUXJOTnJRUXJOAAAAAQA9BGQC7gWJAAYAIQCwAC+wAzO0AQMAFQQrAbAHL7EIASsAsQEAERKwBTkwMRsBMxMjJwc93Pfey5CPBGQBJf7bnp4AAAAAAQA1BG8C3wWDABcASgCwDy+wFjO0CAQAHwQrsBQg1hG0AwQAHwQrsAoyAbAYL7AX1rQWEQANBCuwFhCxCgErtAwRAA0EK7EZASuxChYRErEDDzk5ADAxEzQ2MzIfARYzMjUzFRQGIyIvASYiBhUjNXVeRkoUPBxAm3RdRE0VOT4enASYc3gtDCNaI3R7LwwhKS8AAAEAXAHuAp4CwQADAAATNSEVXAJCAe7T0wAAAAABAFwB7gKeAsEAAwAAEzUhFVwCQgHu09MAAAAAAQBcAe4CngLBAAMAABM1IRVcAkIB7tPTAAAAAAEAgQHwBJ4CvgADABcAsAAvsQEE6bEBBOkBsAQvsQUBKwAwMRM1IRWBBB0B8M7OAAEAlgHwCCcCvgADABcAsAAvsQEE6bEBBOkBsAQvsQUBKwAwMRM1IRWWB5EB8M7OAAEATAOLAYUFuAAUAEAAsgYCACuwEi+0DAMAHgQrAbAVL7AA1rQKEQANBCuyCgAKK7MACg8JK7EWASsAsQwSERKxAAo5ObAGEbAHOTAxEzQ+AzcVDgEHNjMyFhUUBiMiJkwmPFBOJ0BfAxYVPE1VQElbBEZKe1E7HQRwDGpBC009OE9nAAEATAOBAY0FvAAUADcAsgMCACu0EgMAFgQrAbAVL7AQ1rQGEQANBCuyEAYKK7MAEAAJK7EWASsAsQMSERKxBhA5OTAxEzQ2MzIWFRQOAwc1PgE3BiMiJkxWQUpgJz9RUChAYQMUFz5NBTE5UmpUTIBUPB0EcQxsRApOAAABAEz+1QGNARAAFAA3ALISAAArtAMDAB4EKwGwFS+wENa0BhEADQQrshAGCiuzABAACSuxFgErALEDEhESsQYQOTkwMTc0NjMyFhUUDgMHNT4BNwYjIiZMVkFKYCc/UVAoQGEDCiE+TYU6UWlVTH9TPR4EcwtsRQpMAAAAAgBMA5EDAAW+ABQAKQBnALIGAgArsBszsBIvsCcztAwDAB4EK7AhMgGwKi+wANa0ChEADQQrsgoACiuzAAoPCSuwChCxFQErtB8RAA0EK7IfFQorswAfJAkrsSsBKwCxDBIRErMAChUfJBc5sAYRsQccOTkwMRM0PgM3FQ4BBzYzMhYVFAYjIiYlND4DNxUOAQc2MzIWFRQGIyImTCY8UE4nQF8DFBc8TVVASVsBeyY9UE4mPl8DFBU9TFZAR1wETEp7UTsdBHALakEKTD04UGdUSntROx0EcAtqQQpMPThQZwAAAgBMA4sC/gW4ABMAJwBZALIDAgArsBcztBEDACYEK7AlMgGwKC+wD9a0BhEADQQrsg8GCiuzAA8ACSuwBhCxIwErtBoRAA0EK7IjGgorswAjFAkrsSkBKwCxAxERErMGDxojJBc5MDETNDYzMhYVFA4CBzU+ATcGIyImJTQ2MzIWFRQOAgc1PgE3BiMiJkxTQEldOVxiMkFeAwohPEsBeVVASFw5XGExQV4BCh89TAUvOk9mVFyQVC0GbwxoRApKPTpPZlRckFQtBm8MaUMKSgAAAAACAEz+3QL+AQoAEwAnAGMAshEAACuwJTO0AwMAJgQrsBcysgcAACuyGwAAKwGwKC+wD9a0BhEADQQrsg8GCiuzAA8ACSuwBhCxIwErtBoRAA0EK7IjGgorswAjFAkrsSkBKwCxAxERErMGDxojJBc5MDE3NDYzMhYVFA4CBzU+ATcGIyImJTQ2MzIWFRQOAgc1PgE3BiMiJkxTQEldOVxiMkFeAwohPEsBeVVASFw5XGExQV4BCh89TIE6T2ZUXJBULQZvDGhECko9Ok9mVFyQVC0GbwxpQwpKAAAAAQCBALID1QQGAAkALgCwCC+0AwMABwQrtAMDAAcEKwGwCi+wANa0BQgABwQrtAUIAAcEK7ELASsAMDETNDYgFhUUBiAmgfsBXvv7/qL7Alqy+vqyrfv7AAMAqP/wBsEBHQALABUAHwBLALIJAAArsRMdMzO0AwMAFQQrsQ4YMjKyCQAAK7QDAwAVBCsBsCAvsADWsQYI6bAGELEMASuxEQjpsBEQsRYBK7EbCOmxIQErADAxNzQ2MzIWFRQGIyImJTQ2MhYVFAYiJiU0NjIWFRQGIiaoVz4/WVk/PVgCdVh+V1d+WAJ2WX5XV35ZhT9ZWT8+V1g9P1lZPz5XVz4/WVk/PldXAAAAAQA5AM0CMwPlAAUAJQCyAQEAKwGwBi+wANa0BAgACQQrsQcBK7EEABESsQIDOTkAMDETATMJASM5ARfj/u4BEOMCWAGN/nH+dwAAAAEAJQDNAh8D5QAFACYAsgABACsBsAYvsADWsAQytAIIAAkEK7EHASuxAgARErAFOQAwMRMzCQEjASXlARX+6+MBEAPl/nP+dQGJAAABAIH/4QVOBU4AKwBdALIoAAArsSIF6bAAL7AeM7QBBAAfBCuwHDKwBy+wFzO0CAQAFwQrsBUysBIvsQ0E6QGwLC+wBNaxGgzpsS0BK7EaBBESsQkrOTkAsQAiERKwJDmxEggRErAQOTAxEzUzJjU0NyM1Mz4CMzIXByYjIgYHIQchBhUUFyEHIR4BMzI3Fw4BIyIkJ4GeBASewTDI/IvViV5knHzMNwIzVv3zBAQBz1T+tzjGfLRpc0vPdtX+o0gBmLQkJiEosozMZV6/SHZysiAnMBy0bnBjsEBM6M8AAAIAQgLBBncFrAAHABQAkQCyAQIAK7EJDDMztAYDAAcEK7IIDhEyMjKyAQIAK7QGAwAHBCuyAQIAK7QABAAXBCuwAzIBsBUvsAbWtAURAFEEK7IFBgors0AFAwkrsgYFCiuzQAYACSuwBRCxCAErtBQRAEYEK7AUELEPASu0DhEAPAQrsRYBK7EPFBESsQoMOTkAsQAGERKyCxATOTk5MDETNSEVIxEjEQERMxsBMxEjEQMjAxFCAmbbsAIC68fC5KjDg74FDp6e/bMCTf2zAuv+JQHb/RUB0P4wAcr+NgAAAQAAAAAD4QPhAAMANQCyAAAAK7QBAwAHBCuyAAAAK7QBAwAHBCsBsAQvsADWtAMIAAcEK7QDCAAHBCuxBQErADAxMREhEQPhA+H8HwAAAAACACMAAAR/BeEAGQAkAIwAshgAACuwEzOyAQEAK7ARM7EABOmwFTKwIy+0HQMAFAQrsAYysB0QsQsE6QGwJS+wGNawAjKxFwzpsBAyshgXCiuzQBgACSuwFxCxFAErsRML6bMZFBoOK7EgCOmxJgErsRoXERKxBgg5ObETFBESsh0iIzk5OQCxCyMRErAJObAdEbIIGiA5OTkwMRM1MzU0NjMyFxUmIyIOAh0BIREjESERIxEBNDYzMhYVFAYiJiOuwJxVKCMzGi8uHAKX6f5S8AJ5WUBBW1yAWQMXzoqlwRTLCg4fPyyD/BsDF/zpAxcCL0FaW0A/W1sAAAABACMAAARWBdUAGwBsALIaAAArsBUzshMCACuwBjOxCwTpsggCACuyAQEAK7ARM7EABOmwFzIBsBwvsBrWsAIysRkM6bAQMrIaGQors0AaAAkrsBkQsRYBK7ASMrEVC+mxHQErsRYZERKxBgg5OQCxCwERErAJOTAxEzUzNTQ2MzIXFSYjIg4CHQEhETMRIxEhESMRI67AnFUoIzMaLy4cAans7P5X8AMXzoqlwRTLCg4fPyyDAeb6NQMX/OkDFwACACMAAAcQBeEALQA5AL4AsiwAACuxIyczM7IIAgArsBgzsQkE6bAZMrAJELEGBOmxFjEyMrAGELQ3AwAUBCuyAQEAK7ERITMzsQAE6bElKTIyAbA6L7As1rACMrErDOmwEDKyLCsKK7NALAAJK7ArELEoASuwEjKxJwzpsCAysCcQsSQBK7EjC+mwIxCzGSM0DiuxLgjpsC4vsTQI6bE7ASuxKCsRErEGCDk5sS4nERKxFhg5ObE0JBESsTE3OTkAsQgJERKxLjQ5OTAxEzUzNTQ2MzIXFSYjIg4CHQEhNTQ2MzIXFSYjIg4CHQEhESMRIREjESERIxEBNDYzMhYVFAYjIiYjrsCcVSgjMxowLhsBn8CcVSgjMxovLhwCnOz+UPD+YfAFCls/QVpbQD9bAxfOiqXBFMsKDh8/LIOKpcEUywoOHz8sg/wbAxf86QMX/OkDFwIvQFtbQD9bWwAAAQAjAAAG7AXVAC8AjwCyLgAAK7ElKTMzsggCACuxGCMzM7EJBOmwGTKwCRCxBgTpsBYysgEBACuxESEzM7EABOmxJysyMgGwMC+wLtawAjKxLQzpsBAysi4tCiuzQC4ACSuwLRCxKgErsBIysSkM6bAgMrApELEmASuwIjKxJQvpsTEBK7EqLRESsQYIOTmxJikRErEWGDk5ADAxEzUzNTQ2MzIXFSYjIg4CHQEhNTQ2MzIXFSYjIg4CHQEhETMRIxEhESMRIREjESOuwJxVKCMzGi8uHAGfwJxVKCMzGi8uHAGw7Oz+UPD+YfADF86KpcEUywoOHz8sg4qlwRTLCg4fPyyDAeb6NQMX/OkDF/zpAxcAAQAAAAEAQQIn7IlfDzz1AB8IAAAAAADSQzlfAAAAANJDOV//oP4tCKAHHwAAAAgAAgAAAAAAAAABAAAH1f3xAAAJFv+g/6AIoAABAAAAAAAAAAAAAAAAAAAA6QLsAEQAAAAAAfsAAAH7AAAClwC2Ax4ATAXrAFwEwgBgBrIAZAWpAIsBrgBMAokAYgKJAAADlQA7BKEAagJuAIUC+QBcAl4AiQOlAAAE8wBcAwIAOQRLAEQEaAA1BLIARARoAEIEpQBeA/MACgSFAFYEpwBMAmoAjwJ0AI8D6wBIBMgAfwPrAEQEKABEBpsAVgWwABQE2wCuBhAAVgXGAK4EpwCuBHQArgYxAFYF8wCuAlYArgRgACkFegCuBHAArgeZAK4GHgCuBnAAVgTQAK4GcABWBPkArgTKAEYE2wAbBXYAngVkABQIIgAbBSsAGwUaABQFFgBWAm4ArgOnAAACbgAKBDUAKQQ/ABQCRwA7BEEAXATUAJoEUwBMBNAATARiAEwCzAAjBLYAUgSXAJoCHgB1AiD/1wRaAJoCIACaBvsAmgSXAJoEoQBMBNQAmgTEAEwDCgCaA6cAQgLrACMEnQCPBDMAFAaDABsEGgAXBFgAEAPKAE4C6wBcAiQArgLrAAoEnQA9AfsAAAJTAJMEXgBcBL4AfwSuAFAEzAAvAiQArgSHAJwDJABCBosAVgNmAHkEAAA5BKkAXAL5AFwGiwBWArQAPQL5AC0EpQCBAyIAcwNLAHECSQA9BKwAmgUvAD0CRQCFAl4AOQJiAFgD3QB/BAAAJQZeAGYGcABmBvMAagPlACMFsAAUBbAAFAWwABQFsAAUBbAAFAWwABQIWgAOBhAAVgSnAK4EpwCuBKcArgSnAK4CVv+gAlYArgJW/8ECVv/8BesAIwYeAK4GcABWBnAAVgZwAFYGcABWBnAAVgRiAE4GcABWBXYAngV2AJ4FdgCeBXYAngUaABQEygCuBKkAmgRBAFwEQQBcBEEAXARBAFwEQQBcBEEAXAb5AFwEUwBMBGIATARiAEwEYgBMBGIATAIe/7ACHgCaAh7/uAIe/+wEmwBMBJcAmgShAEwEoQBMBKEATAShAEwEoQBMBJ8AagShAEwEnQCPBJ0AjwSdAI8EnQCPBFgAEATUAJoEWAAQCRYAVgd+AEwFGgAUAysAPQMUADUDjwAABx8AAAOPAAAHHwAAAl8AAAHHAAABLwAAAS8AAADjAAABbAAAAGUAAAL5AFwC+QBcAvkAXAUgAIEIvACWAc4ATAHXAEwB1wBMA0sATANJAEwDSQBMBFYAgQdoAKgBbAAAAlgAOQJYACUBxwAABXYAgQbxAEID4QAABPMAIwTvACMHhQAjACMAAAAAACwALAAsACwAcgDMAbQCPALSA2oDogPIA+4EHAReBJ4EvATmBQAFWAWKBewGUAaUBwQHdge4CEAIugkACWAJdAmWCaoKKArwCyILhAvYDCAMXAySDQoNQg1gDZ4N0g34DjgOcA7SDxYPig/eEGwQnBDaEQARhBG4EegSEhJCEloSkBKuEsgS5hN6E9YUIhSGFO4VQBW6Ff4WPBaMFsIW4BdIF4wX2Bg2GJQYxhliGbwaCBouGm4aphrGGvQbVBtuG84cDhwOHFIcpB0yHbAeEh42HtofGh/GIFAgeiCiIMAhfCGeIeQiMiKSIuAjACNSI5QjviQIJD4khiSwJTol1CZyJvAnKidkJ6IoJCiSKPopTCnUKhoqXiqqKxwrRitwK5wr9CxgLOItTC24LiYuyi9YL3ov+jBEMJAw4jFUMY4x2jJ6MxgzuDRcNSg17jbCN5Y4FDiIOPw5djoSOjw6ZjqSOuo7XjviPDo8lDz0PYA+AD5CPrQ/DD9kP8JAQkBsQMxBKEG+QmBCzELwQzpDOkM6QzpDOkM6QzpDOkM6QzpDOkM6Q0hDVkNkQ3xDlEPWRBREUkTERS5FnEXIRiBGIEZGRmxGbEbcR0xHdEfySFJJAkmMAAAAAQAAAOoASwAFAAAAAAACAAEAAgAWAAABAAFZAAAAAAAAAA4ArgADAAEECQAAACIAAAADAAEECQABACYAIgADAAEECQACAA4ASAADAAEECQADADoAVgADAAEECQAEADYAkAADAAEECQAFAHgAxgADAAEECQAGACQBPgADAAEECQAQABgBYgADAAEECQARAAwBegADAAEECQDIABYBhgADAAEECQDJADABnAADAAEECQDKAA4BzAADAAEECQDLAAoB2gADAAEECdkDABoB5ABjAG8AcAB5AHIAaQBnAGgAdAAgAG0AaQBzAHMAaQBuAGcAQwBpAHIAYwB1AGwAYQByACAAUwB0AGQAIABNAGUAZABpAHUAbQBSAGUAZwB1AGwAYQByADEALgAwADAAMQA7AFUASwBXAE4AOwBDAGkAcgBjAHUAbABhAHIAUwB0AGQALQBNAGUAZABpAHUAbQBDAGkAcgBjAHUAbABhAHIAIABTAHQAZAAgAE0AZQBkAGkAdQBtACAAUgBlAGcAdQBsAGEAcgBWAGUAcgBzAGkAbwBuACAAMQAuADAAMAAxADsAUABTACAAMAAwADEALgAwADAAMQA7AGgAbwB0AGMAbwBuAHYAIAAxAC4AMAAuADcAMAA7AG0AYQBrAGUAbwB0AGYALgBsAGkAYgAyAC4ANQAuADUAOAAzADIAOQBDAGkAcgBjAHUAbABhAHIAUwB0AGQALQBNAGUAZABpAHUAbQBDAGkAcgBjAHUAbABhAHIAIABTAHQAZABNAGUAZABpAHUAbQBXAGUAYgBmAG8AbgB0ACAAMQAuADAAVAB1AGUAIABPAGMAdAAgADEAMwAgADEAOAA6ADQAMgA6ADMAOQAgADIAMAAxADUAZABlAGYAYQB1AGwAdABvAHIAaQBvAG4ARgBvAG4AdAAgAFMAcQB1AGkAcgByAGUAbAACAAAAAAAA/sMAowAAAAAAAAAAAAAAAAAAAAAAAAAAAOoAAAECAQMAAwAEAAUABgAHAAgACQAKAAsADAANAA4ADwAQABEAEgATABQAFQAWABcAGAAZABoAGwAcAB0AHgAfACAAIQAiACMAJAAlACYAJwAoACkAKgArACwALQAuAC8AMAAxADIAMwA0ADUANgA3ADgAOQA6ADsAPAA9AD4APwBAAEEAQgBDAEQARQBGAEcASABJAEoASwBMAE0ATgBPAFAAUQBSAFMAVABVAFYAVwBYAFkAWgBbAFwAXQBeAF8AYABhAQQAowCEAIUAvQCWAOgAhgCOAIsAnQCpAKQBBQCKANoAgwCTAQYBBwCNAQgAiADDAN4BCQCeAKoA9QD0APYAogCtAMkAxwCuAGIAYwCQAGQAywBlAMgAygDPAMwAzQDOAOkAZgDTANAA0QCvAGcA8ACRANYA1ADVAGgA6wDtAIkAagBpAGsAbQBsAG4AoABvAHEAcAByAHMAdQB0AHYAdwDqAHgAegB5AHsAfQB8ALgAoQB/AH4AgACBAOwA7gC6ALAAsQC7ANgA2QEKAQsBDAENAQ4BDwEQAREBEgETARQBFQEWARcAsgCzALYAtwDEALQAtQDFAIcAqwEYAL4AvwEZARoAjAEbARwBHQEeAR8GZ2x5cGgxB3VuaTAwMEQHdW5pMDBBMAd1bmkwMEFEB3VuaTAwQjIHdW5pMDBCMwd1bmkwMEI1B3VuaTAwQjkHdW5pMjAwMAd1bmkyMDAxB3VuaTIwMDIHdW5pMjAwMwd1bmkyMDA0B3VuaTIwMDUHdW5pMjAwNgd1bmkyMDA3B3VuaTIwMDgHdW5pMjAwOQd1bmkyMDBBB3VuaTIwMTAHdW5pMjAxMQpmaWd1cmVkYXNoB3VuaTIwMkYHdW5pMjA1RgRFdXJvB3VuaTI1RkMHdW5pRkIwMQd1bmlGQjAyB3VuaUZCMDMHdW5pRkIwNAAAALgB/4WwAY0AS7AIUFixAQGOWbFGBitYIbAQWUuwFFJYIbCAWR2wBitcWACwAyBFsAMrRLAGIEWyA60CK7ADK0SwBSBFsgZVAiuwAytEsAQgRbIFMQIrsAMrRAGwByBFsAMrRLAIIEWyBxQCK7EDRnYrRLAJIEWyCBkCK7EDRnYrRLAKIEWyCVMCK7EDRnYrRLALIEWyChoCK7EDRnYrRLAMIEWyC4gCK7EDRnYrRLANIEWyDBkCK7EDRnYrRLAOIEWyDZwCK7EDRnYrRLAPIEWyDlECK7EDRnYrRLAQIEWyDzgCK7EDRnYrRLARIEWyEBQCK7EDRnYrRFmwFCsAAAAAAVYdiN8AAA=="

/***/ }),

/***/ "52ha":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').directive('googleplace', function () {
  return {
    require: 'ngModel',
    scope: {
      ngModel: '=',
      addressModel: '='
    },
    link: function link(scope, element, attrs, model) {
      var options = {
        types: []
      };
      scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
      google.maps.event.addListener(scope.gPlace, 'place_changed', function () {
        scope.$apply(function () {
          model.$setViewValue(element.val());
          var fullPlace = scope.gPlace.getPlace();
          var newAddress = {};
          var locationComponents = { 'subpremise': 'num', 'street_number': 'streetNum',
            'route': 'streetName', 'locality': 'suburb', 'administrative_area_level_1': 'state',
            'postal_code': 'postCode', 'country': 'country', 'administrative_area_level_2': 'city' };
          if (fullPlace && fullPlace.address_components) {
            fullPlace.address_components.forEach(function (item) {
              newAddress[locationComponents[item.types[0]]] = item.long_name;
              if (item.types[0] == 'administrative_area_level_2') {
                newAddress[locationComponents[item.types[0]]] = item.short_name;
              }
            });
          }
          scope.addressModel = newAddress;
        });
      });
    }
  };
});

/***/ }),

/***/ "591S":
/***/ (function(module, exports) {

var path = 'views/modals/selectOrderLine.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectOrderLineModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Order Line</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeOrderLineSelect()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <md-table-container ng-show=\"lineItemList.length > 0\">\n        <table md-table md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Resource</th>\n              <th md-column>Quantity</th>\n              <th md-column>Description</th>\n              <th ng-if=\"isOrderLineReassignment\" md-column>Reference</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"lineItem in lineItemList\" md-select=\"lineItem\" md-auto-select md-select-id=\"id\" ng-disabled=\"lineItem.disabled\" class=\"{{ (lineItem.disabled) ? 'disabled' : '' }}\">\n              <td md-cell>\n                <span ng-if=\"lineItem.resource\">{{lineItem.resource.name}}</span>\n                <span ng-if=\"!lineItem.resource\">No Resource Selected</span>\n              </td>\n              <td md-cell>\n                <span ng-show=\"lineItem.resource.uom.isTime\">\n                  <span ng-show=\"!userCanDoAction('editLineItemJob', itemEdit)\">\n                    {{formatTimeQuantity(lineItem.quantity, lineItem.resource.uom.abbreviation)}}\n                  </span>\n                  <span ng-show=\"userCanDoAction('editLineItemJob', itemEdit)\">\n                    <div layout-gt-sm=\"row\">\n                      <md-input-container flex-gt-sm class=\"md-block\">\n                        <label>Hours</label>\n                        <input type=\"text\" ng-model=\"lineItem.quantityHoursEdit\" aria-label=\"Line Item Hours Quantity\">\n                      </md-input-container>\n                      <md-input-container flex-gt-sm class=\"md-block\">\n                        <label>Minutes</label>\n                        <input type=\"text\" ng-model=\"lineItem.quantityMinutesEdit\" aria-label=\"Line Item Minutes Quantity\">\n                      </md-input-container>\n                    </div>\n                  </span>\n                </span>\n                <span ng-show=\"!lineItem.resource.uom.isTime\">\n                  <span ng-show=\"!userCanDoAction('editLineItemJob', itemEdit)\">\n                    {{lineItem.quantity}} {{lineItem.resource.uom.abbreviation}}\n                  </span>\n                  <span ng-show=\"userCanDoAction('editLineItemJob', itemEdit)\">\n                    <md-input-container class=\"md-block\">\n                      <label>{{lineItem.resource.uom.abbreviation}}</label>\n                      <input type=\"text\" ng-model=\"lineItem.quantityEdit\" aria-label=\"Line Item Quantity\">\n                    </md-input-container>\n                  </span>\n                </span>\n              </td>\n              <td md-cell>\n                {{lineItem.itemDescription}}\n              </td>\n              <td ng-if=\"isOrderLineReassignment\" md-cell>\n                {{lineItem.customerRefNo}}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeOrderLineSelect()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || selectOrderLineContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "59Nj":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/jobDetail.html';
var html = "<form name=\"jobDetailForm\">\n  <div class=\"ojdMobileDetailOuter paddingWithTabBar\">\n    <div class=\"ojdSection {{currentTab == 'General' ? 'mobileShow' : 'mobileHide'}}\" id=\"General\" data-name=\"General\">\n      <ng-include src=\"'views/pages/jobs/mobile/generalTab.html'\"></ng-include>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'AssignedPeople' ? 'mobileShow' : 'mobileHide'}}\" id=\"AssignedPeople\" data-name=\"Assignees\" ng-if=\"userHasPermission('io.docketbook.ojdapi.getJob')\">\n      <ng-include src=\"'views/pages/jobs/mobile/assigneesTab.html'\"></ng-include>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'LineItems' ? 'mobileShow' : 'mobileHide'}}\" id=\"LineItems\" data-name=\"Line Items\">\n      <ng-include src=\"'views/pages/jobs/mobile/lineItemsTab.html'\"></ng-include>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'Dockets' ? 'mobileShow' : 'mobileHide'}}\" id=\"Dockets\" data-name=\"Dockets\">\n      <ng-include src=\"'views/pages/jobs/mobile/docketsTab.html'\"></ng-include>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'Comments' ? 'mobileShow' : 'mobileHide'}}\" id=\"Comments\" data-name=\"Comments\">\n      <ng-include src=\"'views/pages/jobs/mobile/commentsTab.html'\"></ng-include>\n    </div>\n\n    <div id=\"toaster\" class=\"visible-xs\">\n      <!--<div class=\"fabButtonContainer\">\n        <md-button class=\"md-fab md-hue-6\" ng-click=\"openBottomSheet()\" md-theme=\"dbDarkBlue\" aria-label=\"Job Actions\" ng-show=\"!itemEdit.loading\">\n          <md-icon md-svg-src=\"more_vert.svg\"></md-icon>\n        </md-button>\n      </div>-->\n      <div id=\"toasterInner\">\n        <md-content id=\"content1\" ng-cloak>\n\n        </md-content>\n      </div>\n    </div>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "5Cpe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').service('resourceService', ['accessControl', '$http', '$stateParams', '$cookies', '$q', 'Restangular', 'geolocation', function (accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

  this.getResourcesByCategory = function (successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');
    var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');

    params = { active: true

      // first get all resource categories
    };baseResourceCategories.getList(params).then(function (resourceCategories) {
      baseResources.getList().then(function (resources) {
        var categories = {};
        for (var i = 0; i < resourceCategories.length; i++) {
          categories[resourceCategories[i].id] = resourceCategories[i];
          categories[resourceCategories[i].id].resources = [];
        }
        for (var i = 0; i < resources.length; i++) {
          if (resources[i].category != null) {
            categories[resources[i].category.id].resources.push(resources[i]);
          }
        }
        // convert categories dict to an array
        var categoriesArray = [];
        var categoriesKeys = Object.keys(categories);
        for (var i = 0; i < categoriesKeys.length; i++) {
          categoriesArray.push(categories[categoriesKeys[i]]);
        }
        successCb(categoriesArray);
      }, function (err) {
        failureCb(err);
        return;
      });
    }, function (err) {
      failureCb(err);
      return;
    });
  };

  /*********************/
  /***** Resources *****/
  /*********************/

  this.getResources = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    if (!organisation || !organisationGroup) {
      return successCb([]);
    }
    var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');
    if (params == null) {
      params = {};
    }
    if (params.active == null) {
      params.active = true;
    }
    baseResources.getList(params).then(function (resources) {
      successCb(resources);
    }, failureCb);
  };

  this.saveResource = function (resource, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');

    if (resource.id == null) {
      resource.organisation = organisation.id;
      baseResources.post(resource).then(successCb, failureCb);
    } else {
      baseResources.one(resource.id).customPUT(resource).then(successCb, failureCb);
    }
  };

  var deleteResource = function deleteResource(resourceId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseResources = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources');

    if (resourceId.id != null) {
      resourceId = resourceId.id;
    }
    baseResources.one(resourceId).remove().then(successCb, failureCb);
  };

  this.removeResource = deleteResource;

  /********** Delete Bulk Resources **********/
  this.deleteBulkResources = function (resources, successCb) {
    var failures = [];
    deleteResources(resources, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteResources = function deleteResources(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteResource(list[index].id, function (success) {
      deleteResources(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteResources(list, index + 1, failures, successCb);
    });
  };

  this.bulkImportResources = function (resourcesList, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseResourceImport = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('resources?import=true');

    baseResourceImport.customPOST(resourcesList).then(successCb, failureCb);
  };

  /******************************/
  /**** Resource Categories *****/
  /******************************/

  this.getResourceCategories = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    if (organisation == null || organisationGroup == null) {
      if (failureCb) {
        failureCb();
      }
      return;
    }

    var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');

    if (params == null) {
      params = {};
    }
    baseResourceCategories.getList(params).then(function (categories) {
      successCb(categories);
    }, failureCb);
  };

  this.saveResourceCategory = function (resourceCategory, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');

    if (resourceCategory.id == null) {
      resourceCategory.organisation = organisation.id;
      baseResourceCategories.post(resourceCategory).then(successCb, failureCb);
    } else {
      baseResourceCategories.one(resourceCategory.id).customPUT(resourceCategory).then(successCb, failureCb);
    }
  };

  var deleteResourceCategory = function deleteResourceCategory(categoryId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseResourceCategories = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('categories');

    if (categoryId.id != null) {
      categoryId = categoryId.id;
    }

    baseResourceCategories.one(categoryId).remove().then(successCb, failureCb);
  };

  this.removeResourceCategory = deleteResourceCategory;

  /********** Delete Bulk Resource Categories **********/
  this.deleteBulkResourceCategories = function (categories, successCb) {
    var failures = [];
    deleteResourceCategories(categories, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteResourceCategories = function deleteResourceCategories(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteResourceCategory(list[index].id, function (success) {
      deleteResourceCategories(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteResourceCategories(list, index + 1, failures, successCb);
    });
  };

  /***************************/
  /**** Units of Measure *****/
  /***************************/

  this.getUoms = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();

    if (organisation == null || organisationGroup == null) {
      if (failureCb) {
        failureCb();
      }
      return;
    }

    var baseUoms = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('uoms');

    if (params == null) {
      params = {};
    }
    baseUoms.getList(params).then(function (uoms) {
      successCb(uoms);
    }, failureCb);
  };

  this.saveUom = function (uom, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseUoms = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('uoms');

    if (uom.id == null) {
      uom.organisation = organisation.id;
      baseUoms.post(uom).then(successCb, failureCb);
    } else {
      baseUoms.one(uom.id).customPUT(uom).then(successCb, failureCb);
    }
  };

  var deleteUom = function deleteUom(uomId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseUoms = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('uoms');

    if (uomId.id != null) {
      uomId = uomId.id;
    }

    baseUoms.one(uomId).remove().then(successCb, failureCb);
  };

  this.removeUom = deleteUom;

  /********** Delete Bulk UOMS **********/
  this.deleteBulkUoms = function (uoms, successCb) {
    var failures = [];
    deleteUoms(uoms, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteUoms = function deleteUoms(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteUom(list[index].id, function (success) {
      deleteUoms(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteUoms(list, index + 1, failures, successCb);
    });
  };
}]);

/***/ }),

/***/ "5ZyV":
/***/ (function(module, exports) {

var path = 'views/filterBars/jobsFilterBar.html';
var html = "<div class=\"secondaryHeader\">\n  <div class=\"contentHeadingNavBar filterTabs\">\n    <div class=\"filterTabsContainer\">\n      <div class=\"filterSelectors\">\n        <div class=\"filterSelector\" ng-if=\"filters.viewType != 'allocate'\">\n          <h3>Date:</h3>\n          <div class=\"filterDropdown clear\">\n            <md-date-range show-template=\"true\" ng-model=\"dateFilterModel\" custom-templates=\"customTemplate\"></md-date-range>\n          </div>\n        </div>\n        <div class=\"filterSelector\">\n          <h3>Status:</h3>\n          <md-menu>\n            <div class=\"filterDropdown\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              {{prettifyFilterStatusPreview()}}\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" class=\"allSelector\" ng-click=\"swapStatusFilter('all')\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"all\" ng-model=\"filters.statusOptions.allView\">Select All\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"draft\" ng-model=\"filters.statusOptions.draft\">Draft\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('draft')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"sent\" ng-model=\"filters.statusOptions.sent\">Sent\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('sent')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"closed\" ng-model=\"filters.statusOptions.closed\">Closed\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('closed')\">Only</div>\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\">\n          <h3>Assignee Status:</h3>\n          <md-menu>\n            <div class=\"filterDropdown\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              {{prettifyAssigneeFilterStatusPreview()}}\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" class=\"allSelector\" ng-click=\"swapAssigneeStatusFilter('all')\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"all\" ng-model=\"filters.assigneeStatusOptions.allView\">Select All\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"draft\" ng-model=\"filters.assigneeStatusOptions.assigned\">Assigned\n                  <div class=\"filterOnlyButton\" ng-click=\"setAssigneeOnlyFilter('assigned')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"draft\" ng-model=\"filters.assigneeStatusOptions.accepted\">Accepted\n                  <div class=\"filterOnlyButton\" ng-click=\"setAssigneeOnlyFilter('accepted')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"sent\" ng-model=\"filters.assigneeStatusOptions.rejected\">Rejected\n                  <div class=\"filterOnlyButton\" ng-click=\"setAssigneeOnlyFilter('rejected')\">Only</div>\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.customerContact\">\n          <h3>Customer:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <span ng-click=\"selectContactFilter('customer')\">{{filters.customerContact.displayName}}</span>\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('customerContact')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.forwarderContact\">\n          <h3>Subcontractor:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <span ng-click=\"selectContactFilter('forwarder')\">{{filters.forwarderContact.displayName}}</span>\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('forwarderContact')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.order\">\n          <h3>Order:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <span ng-click=\"selectOrderFilter\">{{filters.order.orderNumber}}</span>\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('order')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.jobNumber\">\n          <h3>Job Number:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.jobNumber\" aria-label=\"Job Number Filter\" ng-model-options=\"{debounce:1000}\" ng-change=\"filtersChanged('jobNumber')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('jobNumber')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\">\n          <md-menu>\n            <div class=\"filterDropdown addFilter\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              Add A Filter\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" ng-click=\"selectContactFilter('customer')\" ng-if=\"!filters.customerContact\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Customer\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"selectContactFilter('forwarder')\" ng-if=\"!filters.forwarderContact\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Subcontractor\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"selectOrderFilter()\" ng-if=\"!filters.order\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Order\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.jobNumber = ' '\" ng-if=\"!filters.jobNumber\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Job Number\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\">\n          <div class=\"filterDropdown addFilter\" ng-click=\"clearFilters()\">\n            Clear all filters\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "5j+l":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/auditLogTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <!-- Start Map Section -->\n  <div class=\"ojdDesktopSection noPadding noBottomPadding\" style=\"position: relative;\">\n    <md-table-container>\n      <table md-table>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Date</th>\n            <th md-column>Description</th>\n            <th md-column>User</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"event in itemEdit.eventLog\">\n            <td md-cell>\n              <span ng-if=\"event.addedOn && currentOrgGroup.timeFormat == '12HR'\">{{moment(event.addedOn).tz(itemEdit.timezone).format(\"DD/MM/YYYY hh:mm:ss a\")}}</span>\n              <span ng-if=\"event.addedOn && currentOrgGroup.timeFormat == '24HR'\">{{moment(event.addedOn).tz(itemEdit.timezone).format(\"DD/MM/YYYY HH:mm:ss\")}}</span>\n            </td>\n            <td md-cell>\n              {{event.description}}\n            </td>\n            <td md-cell>\n              {{event.userName}}\n            </td>\n          </tr>\n          <tr ng-if=\"itemEdit.docketFiling.createdAt\">\n            <td md-cell>\n              {{moment(itemEdit.docketFiling.createdAt).format('DD/MM/YYYY hh:mm:ss')}}\n            </td>\n            <td md-cell>\n              Docket File Created\n            </td>\n            <td md-cell>\n\n            </td>\n          </tr>\n          <tr ng-if=\"itemEdit.docketFiling.updatedAt\">\n            <td md-cell>\n              {{moment(itemEdit.docketFiling.updatedAt).format('DD/MM/YYYY hh:mm:ss')}}\n            </td>\n            <td md-cell>\n              Docket File Updated\n            </td>\n            <td md-cell>\n\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "5lJt":
/***/ (function(module, exports) {

var path = 'views/pages/filing/desktop/filingDetail.html';
var html = "<div class=\"ojdDesktopDetailOuter\">\n  <form name=\"docketDetailForm\">\n    <div class=\"ojdDesktopSection header white\">\n      <div class=\"headerTitle\">\n        <h2>Selected</h2>\n        <h1>{{docketFiling.dockets.length}} Dockets</h1>\n      </div>\n\n      <div class=\"bulkActionsButtons\">\n        <md-button class=\"\" aria-label=\"Save Docket Filing\" ng-click=\"saveDocketFiling(docketFiling)\" ng-if=\"!docketFiling.loading && docketFiling.dockets.length > 0\">\n          Save Filing\n        </md-button>\n\n        <md-button class=\"md-icon-button\" aria-label=\"Close Docket Filing\" ng-click=\"closeDocketFiling()\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopMainSections\">\n      <div my-loader text=\"Loading Docket Files\" ng-if=\"docketFiling.loading && docketFiling.loadingType == 'getting'\"></div>\n      <div my-loader text=\"Saving Docket Files\" ng-if=\"docketFiling.loading && docketFiling.loadingType != 'getting'\"></div>\n      <div class=\"stdLoader\" ng-show=\"docketLoadingError != null\">\n        <div class=\"loaderOuterContainer\">\n          <div class=\"loaderInnerContainer\">\n            <div class=\"materialSpinner\">\n              <md-icon md-svg-src=\"error.svg\"></md-icon>\n            </div>\n            <div class=\"loadingText\">\n              {{docketLoadingError}}\n            </div>\n            <div class=\"loadingRetryButton\">\n              <!--<md-button class=\"md-primary\">Retry</md-button>-->\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"ojdDesktopSection noPadding\">\n        <div class=\"sectionHeadingContainer\">\n          <div class=\"sectionHeadingLeft\">\n            <h1 class=\"sectionHeading\">File Codes</h1>\n          </div>\n          <div class=\"sectionHeadingRight\">\n            <md-button ng-if=\"docketFiling.method != 'split'\" ng-click=\"docketFiling.method = 'split'\">\n              File By Docket\n            </md-button>\n            <md-button class=\"md-icon-button\" ng-click=\"addSplitFileCodeDesktop()\" aria-label=\"Add Split File Code\" ng-if=\"docketFiling.method == 'split'\">\n              <md-icon md-svg-src=\"add.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n\n        <p ng-show=\"docketFiling.activityCodes == null || docketFiling.activityCodes.length <= 0\">\n          No file codes have been added.\n        </p>\n\n        <p ng-show=\"docketFiling.method == 'lines'\">\n          Currently filing by lines\n        </p>\n\n        <md-table-container ng-show=\"docketFiling.activityCodes.length > 0 && docketFiling.method == 'split'\">\n          <table md-table>\n            <thead md-head>\n              <tr md-row>\n                <th md-column>File Code</th>\n                <th md-column>Percentage</th>\n                <th md-column ng-if=\"singleUom == true\">Quantities</th>\n                <th md-column>Action</th>\n              </tr>\n              <tr md-row ng-repeat=\"activity in docketFiling.activityCodes\">\n                <td md-cell>\n                  <ng-form name=\"innerForm\">\n                    <md-autocomplete required md-input-name=\"autocomplete\"\n                      ng-disabled=\"docketFiling.method != 'split'\" md-no-cache=\"true\"\n                      md-selected-item=\"activity.fileCode\"\n                      md-search-text=\"searchText\"\n                      md-selected-item-change=\"selectActivityCodeChange(searchText)\"\n                      md-items=\"fileCode in searchFileCodes(searchText)\" md-item-text=\"fileCode.fileName\"\n                      md-min-length=\"0\" placeholder=\"Search for a file code\"\n                      md-menu-class=\"autocomplete-custom-template\">\n                      <md-item-template>\n                        <span class=\"item-title\">{{fileCode.fileCode}} - </span>\n                        <span class=\"item-metadata\">\n                          <span class=\"item-metastat\">{{fileCode.fileName}}</span>\n                          <span class=\"item-metastat\">({{fileCode.costCode}})</span>\n                        </span>\n                      </md-item-template>\n                      <md-not-found>\n                        No matches found.\n                      </md-not-found>\n                    </md-autocomplete>\n                    <div ng-show=\"innerForm.autocomplete.$error.required && innerForm.autocomplete.$touched\" class=\"errorMessage\">\n                      Please select a file code\n                    </div>\n                  </ng-form>\n                </td>\n                <td md-cell>\n                  <input type=\"number\" ng-model=\"activity.splitPercentage_display\" ng-disabled=\"docketFiling.method != 'split'\" ng-change=\"splitPercentageUpdated(activity)\"> %\n                </td>\n                <td md-cell ng-if=\"singleUom == true\">\n                  <input type=\"number\" ng-model=\"activity.splitQuantity\" ng-disabled=\"docketFiling.method != 'split'\" ng-change=\"splitQuantityUpdated(activity)\"> {{singleUomAbbreviation}}\n                </td>\n                <td md-cell>\n                  <md-button class=\"md-icon-button\" ng-click=\"removeSplitFileCode(activity, docketFiling.activityCodes)\" aria-label=\"Remove Split File Code\" ng-if=\"docketFiling.method == 'split'\">\n                    <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                  </md-button>\n                </td>\n              </tr>\n              <tr md-row>\n                <td md-cell>\n                  <b>Summary</b>\n                </td>\n                <td md-cell>\n                  <b>{{totalPercentage()}} %</b>\n                </td>\n                <td md-cell ng-if=\"singleUom == true\">\n                  <b>{{totalQuantity()}} {{singleUomAbbreviation}}</b>\n                </td>\n                <td></td>\n              </tr>\n            </thead>\n          </table>\n        </md-table-container>\n      </div>\n\n      <div class=\"ojdDesktopSection noPadding\">\n        <div class=\"sectionHeadingContainer\">\n          <div class=\"sectionHeadingLeft\">\n            <h1 class=\"sectionHeading\">Lines Summary</h1>\n          </div>\n          <div class=\"sectionHeadingRight\">\n            <md-button ng-click=\"docketFiling.method = 'lines'\" ng-if=\"docketFiling.method != 'lines'\">\n              File By Lines\n            </md-button>\n          </div>\n        </div>\n\n        <p ng-if=\"docketFiling.linesSummary == null || docketFiling.linesSummary.length <= 0\">\n          There are no lines on this docket.\n        </p>\n\n        <md-table-container ng-show=\"docketFiling.linesSummary.length > 0\">\n          <table md-table>\n            <thead md-head>\n              <tr md-row>\n                <th md-column>Resource</th>\n                <th md-column>Line Type</th>\n                <th md-column>Quantity</th>\n                <th md-column>File Code</th>\n                <th md-column>Percent</th>\n                <th md-column>Action</th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row ng-repeat-start=\"line in docketFiling.linesSummary\">\n                <td md-cell>{{line.resource.name}}</td>\n                <td md-cell>{{line.interaction.interactionTemplate.name}}</td>\n                <td md-cell>{{line.quantity}} {{line.resource.uom.abbreviation}}</td>\n                <td md-cell>\n                  <ng-form ng-show=\"line.activityCodes.length == 1\" name=\"innerForm\">\n                    <md-autocomplete required ng-if=\"docketFiling.method == 'lines'\" md-input-name=\"autocomplete\"\n                      ng-disabled=\"false\" md-no-cache=\"true\"\n                      md-selected-item=\"line.activityCodes[0].fileCode\"\n                      md-search-text=\"searchText\"\n                      md-selected-item-change=\"selectActivityCodeChange(searchText)\"\n                      md-items=\"fileCode in searchFileCodes(searchText)\" md-item-text=\"fileCode.fileName\"\n                      md-min-length=\"0\" placeholder=\"Search for a file code\"\n                      md-menu-class=\"autocomplete-custom-template\">\n                      <md-item-template>\n                        <span class=\"item-title\">{{fileCode.fileCode}} - </span>\n                        <span class=\"item-metadata\">\n                          <span class=\"item-metastat\">{{fileCode.fileName}}</span>\n                          <span class=\"item-metastat\">({{fileCode.costCode}})</span>\n                        </span>\n                      </md-item-template>\n                      <md-not-found>\n                        No matches found.\n                      </md-not-found>\n                    </md-autocomplete>\n                    <div ng-show=\"innerForm.autocomplete.$error.required && innerForm.autocomplete.$touched\" class=\"errorMessage\">\n                      Please select a file code\n                    </div>\n                  </ng-form>\n                </td>\n                <td md-cell>\n                  {{getLineTotalPercent(line)}} %\n                </td>\n                <td md-cell>\n                  <md-button ng-disabled=\"docketFiling.method != 'lines'\" ng-click=\"splitLineFiling(line)\">\n                    Split\n                  </md-button>\n                </td>\n              </tr>\n\n              <tr ng-if=\"line.activityCodes.length > 1\" ng-repeat-end ng-repeat=\"activityCode in line.activityCodes\">\n                <td md-cell></td>\n                <td md-cell>{{activityCode.quantity}}</td>\n                <td md-cell>\n                  <input type=\"number\" class='filecodeInput' ng-model=\"activityCode.quantity\" ng-disabled=\"docketFiling.method != 'lines'\" ng-change=\"activityCodeQuantityUpdated(line, activityCode, $index)\"> {{line.resource.uom.abbreviation}}\n                </td>\n                <td md-cell>\n                  <ng-form name=\"innerForm\">\n                    <md-autocomplete required ng-if=\"docketFiling.method == 'lines'\" md-input-name=\"autocomplete\"\n                      ng-disabled=\"false\" md-no-cache=\"true\"\n                      md-selected-item=\"activityCode.fileCode\"\n                      md-search-text=\"searchText\"\n                      md-selected-item-change=\"selectActivityCodeChange(searchText)\"\n                      md-items=\"fileCode in searchFileCodes(searchText)\" md-item-text=\"fileCode.fileName\"\n                      md-min-length=\"0\" placeholder=\"Search for a file code\"\n                      md-menu-class=\"autocomplete-custom-template\">\n                      <md-item-template>\n                        <span class=\"item-title\">{{fileCode.fileCode}} - </span>\n                        <span class=\"item-metadata\">\n                          <span class=\"item-metastat\">{{fileCode.fileName}}</span>\n                          <span class=\"item-metastat\">({{fileCode.costCode}})</span>\n                        </span>\n                      </md-item-template>\n                      <md-not-found>\n                        No matches found.\n                      </md-not-found>\n                    </md-autocomplete>\n                    <div ng-show=\"innerForm.autocomplete.$error.required && innerForm.autocomplete.$touched\" class=\"errorMessage\">\n                      Please select a file code\n                    </div>\n                  </ng-form>\n                </td>\n                <td md-cell>\n                  <input type=\"number\" class='filecodeInput' ng-model=\"activityCode.percentage_display\" ng-disabled=\"docketFiling.method != 'lines'\" ng-change=\"activityCodePercentageUpdated(line, activityCode, $index)\"> %\n                </td>\n                <td md-cell style=\"text-align: center;\">\n                  <md-button class=\"md-icon-button\" ng-click=\"removeSplitLineFiling(line, $index)\" aria-label=\"Remove Split File Code\" ng-if=\"docketFiling.method == 'lines'\">\n                    <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                  </md-button>\n                </td>\n              </tr>\n\n            </tbody>\n          </table>\n        </md-table-container>\n      </div>\n\n      <div class=\"ojdDesktopSection noPadding\">\n        <div class=\"sectionHeadingContainer\">\n          <div class=\"sectionHeadingLeft\">\n            <h1 class=\"sectionHeading\">Dockets Summary</h1>\n          </div>\n          <div class=\"sectionHeadingRight\">\n          </div>\n        </div>\n\n        <md-table-container class=\"docketChecklistTable\" ng-show=\"docketFiling.dockets && docketFiling.dockets.length > 0\">\n          <table md-table multiple>\n            <thead md-head>\n              <tr md-row>\n                <th md-column>Status</th>\n                <th md-column>Docket</th>\n                <th md-column>Filing Status</th>\n                <th md-column></th>\n              </tr>\n            </thead>\n            <tbody md-body ng-repeat=\"docket in docketFiling.dockets\">\n              <tr md-row>\n                <td md-cell>\n                  <div class=\"statusDisplay Completed\" ng-if=\"docket.existingDocketFile\">Filed</div>\n                  <div class=\"statusDisplay Draft\" ng-if=\"!docket.existingDocketFile\">Unfiled</div>\n                </td>\n                <td md-cell>\n                  {{docket.docketNumber}}\n                </td>\n                <td md-cell>\n                  <span ng-show=\"docket.existingDocketFile.fileMethod == 'lines'\">Filed by lines</span>\n                  <span ng-show=\"docket.existingDocketFile.fileMethod == 'split'\">Filed by split - <span ng-if=\"docket.fileCodes\" ng-repeat=\"fileCode in docket.fileCodes\">{{fileCode.fileCode}} ({{fileCode.splitPercentage}}%)&nbsp;&nbsp;</span></span>\n                </td>\n                <td md-cell>\n                  <md-button class=\"md-icon-button\" ng-click=\"docket.detailOpen = !docket.detailOpen\" aria-label=\"Toggle Docket Detail\">\n                    <md-icon md-svg-src=\"arrow_down.svg\" ng-if=\"!docket.detailOpen\"></md-icon>\n                    <md-icon md-svg-src=\"arrow_up.svg\" ng-if=\"docket.detailOpen\"></md-icon>\n                  </md-button>\n                </td>\n              </tr>\n              <tr md-row class=\"checklistDetailRow\" ng-repeat=\"line in docket.linesSummary\" ng-show=\"docket.detailOpen\">\n                <td md-cell colspan=\"2\">\n                  {{line.resource.name}} ({{line.resource.identifier}})\n                </td>\n                <td md-cell>\n                  {{line.interaction.interactionName}} -\n\n                  <span ng-show=\"interaction.resource.uom.isTime\">{{formatTimeQuantity(line.interaction.quantity, line.resource.uom.abbreviation)}}</span>\n                  <span ng-show=\"!interaction.resource.uom.isTime\">{{line.interaction.quantity}}</span>\n                  <span ng-show=\"!interaction.resource.uom.isTime\"> {{line.resource.uom.abbreviation}}</span>\n                </td>\n                <td md-cell>\n                  {{line.activityCode.fileCode}}\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </div>\n    </div>\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "5n2g":
/***/ (function(module, exports) {

var path = 'views/modals/waitToBeInvitedModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"waitToBeInvitedModal\">\n  <div class=\"modalContainer\">\n      <div class=\"header hidden-xs\">\n          <h1>Contact your company's administrator</h1>\n          <div class=\"headerCloseButton\" ng-click=\"closeWaitToBeInvitedModal()\">\n              <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n              </md-button>\n          </div>\n      </div>\n      <div class=\"mobileDetailHeader selectHeader visible-xs\">\n        <div class=\"mobileDetailHeaderInner\">\n          <div class=\"mobileHeaderUpper\">\n            <div class=\"left\">\n              <div class=\"cancelButtonOuter\">\n                <div class=\"cancelButton closeButton\" ng-click=\"closeWaitToBeInvitedModal()\">\n                  <div class=\"line1\"></div>\n                  <div class=\"line2\"></div>\n                  <div class=\"line3\"></div>\n                </div>\n              </div>\n            </div>\n            <div class=\"middle\">\n              Contact your administrator\n            </div>\n            <div class=\"right text\">\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"content\">\n          <div style=\"padding-bottom: 20px;\">\n            Please reach out to the administrator of your company's Docketbook account. They will be able to provide you with a sign up link that is connected to your company.\n          </div>\n      </div>\n\n      <div class=\"footer\">\n          <div class=\"tableLayoutHelperContainer\">\n              <div class=\"left\">\n          </div>\n          <div class=\"right\">\n              <div class=\"dbButton\" ng-click=\"closeWaitToBeInvitedModal()\">\n                  Ok\n              </div>\n          </div>\n      </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "5xBt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('groupSettingsGeneralController', ['docketService', 'billingService', 'xeroService', 'userService', '$scope', 'Restangular', '$window', '$state', '$stateParams', '$timeout', 'accessControl', 'Upload', function (docketService, billingService, xeroService, userService, $scope, Restangular, $window, $state, $stateParams, $timeout, accessControl, Upload) {
  mixpanel.track("Opened GroupSettings-General Desktop");
  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.allTimezones = _momentTimezone2.default.tz.names();
  $scope.allTimeFormats = ['12HR', '24HR'];
  $scope.timeFormatDisplay = { '12HR': '12 Hour Time', '24HR': '24 Hour Time' };
  $scope.sampleCompany = accessControl.isSampleCompany();
  $scope.groupEdit = $scope.currentOrgGroup;
  $scope.apiPath = "";
  $scope.xeroEndpoint = Restangular.all('organisations').one($scope.currentOrg.id).all('groups').one($scope.currentOrgGroup.id).all('xero');
  $scope.xeroOrg = null;
  $scope.orgEdit = $scope.currentOrg;
  $scope.data = { newName: '', loading: false };
  $scope.bankAccount = {
    loading: true,
    active: true,
    primaryAccount: true
  };

  $scope.canViewOrgSettings = $scope.currentOrg.globalAdministrators.includes($scope.currentUser.id) || $scope.userHasPermission('io.docketbook.uoapi.viewOrganisationSettings');

  if (!$scope.canViewOrgSettings) {
    $state.go('companySettings.groups', { orgId: $scope.currentOrg.id }, { location: 'replace' });
  }

  var getBankAccount = function getBankAccount(cb) {
    Restangular.all('organisations').one($scope.currentOrg.id).all('bank_accounts').customGET().then(function (accounts) {
      if (accounts.length > 0) {
        $scope.bankAccount = Object.assign($scope.bankAccount, accounts[0]);
        cb && cb();
      }
      $scope.bankAccount.loading = false;
    }, function () {});
  };

  $scope.saveBankAccount = function () {
    var bankAccountToSave = {};
    Object.keys($scope.editBankAccount).forEach(function (key) {
      return bankAccountToSave[key] = $scope.editBankAccount[key].toString();
    });
    Object.assign(bankAccountToSave, {
      active: true,
      primaryAccount: true
    });
    if ($scope.bankAccount.id) {
      Restangular.all('organisations').one($scope.currentOrg.id).all('bank_accounts').one($scope.bankAccount.id).customPUT(bankAccountToSave).then(function () {
        getBankAccount(function () {
          $scope.closeEditBankAccountModal();
        });
      });
    } else {
      Restangular.all('organisations').one($scope.currentOrg.id).all('bank_accounts').customPOST(bankAccountToSave).then(function () {
        getBankAccount(function () {
          $scope.closeEditBankAccountModal();
        });
      });
    }
  };

  getBankAccount();

  $scope.logoLoading = false;

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /***** DATA *****/

  $scope.removeSampleComplete = function () {
    accessControl.refreshAndGetAllowedOrganisations(function (orgs) {
      $state.go('main.dashboard');
    });
  };

  $scope.removeSampleCompany = function () {
    Restangular.all('organisations').one($scope.currentOrg.id).customDELETE('sample/remove').then($scope.removeSampleComplete, $scope.removeSampleComplete);
  };

  docketService.getTemplates(null, function (templates) {
    $scope.allTemplates = templates;
  }, function (err) {
    $scope.allTemplates = [];
  });

  /***********************************/
  /**** Company Settings Controls ****/
  /***********************************/

  userService.getMembers(null, function (users) {
    $scope.orgUsers = users;
    var globalAdminUsers = [];
    // go through currentOrg globalAdmins and populate names
    for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
      for (var j = 0; j < $scope.orgUsers.length; j++) {
        if ($scope.currentOrg.globalAdministrators[i] == $scope.orgUsers[j].id) {
          globalAdminUsers.push($scope.orgUsers[j]);
        }
      }
    }
    $scope.currentOrg.globalAdminUsers = globalAdminUsers;
  });

  $scope.userIsXeroAuthenticated = function () {
    if (!$scope.currentUser.xeroAuthentication) {
      return false;
    }
    if (!$scope.currentUser.xeroAuthentication.authenticatedUntil) {
      return false;
    }
    if ((0, _momentTimezone2.default)($scope.currentUser.xeroAuthentication.authenticatedUntil).isBefore((0, _momentTimezone2.default)())) {
      return false;
    }
    return true;
  };

  $scope.xeroReauth = function () {
    $scope.directReauthenticate();
  };

  $scope.xeroAuth = function () {
    $scope.xeroConnectLogin('xeroauth');
  };

  $scope.xeroConnect = function () {
    $scope.xeroConnectConfirm(null, function (response) {
      $scope.currentOrg.features.xero = response;
    });
  };

  $scope.fetchXeroOrg = function () {
    if ($scope.currentOrgGroup == null) {
      return;
    }
    $scope.xeroEndpoint.one('organisation').one('current').customGET().then(function (xeroOrg) {
      $scope.xeroOrg = xeroOrg;
      if ($stateParams.action && $stateParams.action == 'xeroauth' && xeroOrg) {
        $timeout(function () {
          $scope.xeroConnect();
        }, 500);
      }
    });
  };

  $scope.xeroDisable = function (cb) {
    $scope.xeroEndpoint.all('enablement').customPUT({
      enabled: false
    }).then(function (response) {
      $scope.xeroAuthenticated = false;
      $scope.currentOrg.features.xero = response;
      return accessControl.refreshCurrentUser();
    }).then(function () {
      $scope.currentUser = accessControl.currentUser();
      cb && cb();
    });
  };

  $scope.toggleXeroQuotes = function () {
    $scope.xeroQuotesEnableLoading = true;
    var settingsUpdate = {};
    if ($scope.currentOrg.features.xero.quotesEnabled) {
      // disable and save
      settingsUpdate.quotesEnabled = false;
    } else {
      // enable and save
      settingsUpdate.quotesEnabled = true;
    }
    $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
      $scope.currentOrg.features.xero.quotesEnabled = settingsUpdate.quotesEnabled;
      $scope.xeroQuotesEnableLoading = false;
      return;
    });
  };

  $scope.toggleXeroDisplayPrices = function () {
    $scope.xeroPricesEnableLoading = true;
    var settingsUpdate = {};
    if ($scope.currentOrg.features.xero.displayUnitPrices) {
      // disable and save
      settingsUpdate.displayUnitPrices = false;
    } else {
      // enable and save
      settingsUpdate.displayUnitPrices = true;
    }
    $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
      $scope.currentOrg.features.xero.displayUnitPrices = settingsUpdate.displayUnitPrices;
      $scope.xeroPricesEnableLoading = false;
      return;
    });
  };

  $scope.toggleXeroInvoicePrices = function () {
    $scope.xeroInvoicePricesEnableLoading = true;
    var settingsUpdate = {};
    if ($scope.currentOrg.features.xero.invoicePricesInheritFromQuote) {
      // disable and save
      settingsUpdate.invoicePricesInheritFromQuote = false;
    } else {
      // enable and save
      settingsUpdate.invoicePricesInheritFromQuote = true;
    }
    $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
      $scope.currentOrg.features.xero.invoicePricesInheritFromQuote = settingsUpdate.invoicePricesInheritFromQuote;
      $scope.xeroInvoicePricesEnableLoading = false;
      return;
    });
  };

  $scope.toggleXeroDocketPdfDisplayPrices = function () {
    $scope.xeroDocketPdfPricesEnableLoading = true;
    var settingsUpdate = {};
    if ($scope.currentOrg.features.xero.docketPdfDisplayUnitPrices) {
      // disable and save
      settingsUpdate.docketPdfDisplayUnitPrices = false;
    } else {
      // enable and save
      settingsUpdate.docketPdfDisplayUnitPrices = true;
    }
    $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
      $scope.currentOrg.features.xero.docketPdfDisplayUnitPrices = settingsUpdate.docketPdfDisplayUnitPrices;
      $scope.xeroDocketPdfPricesEnableLoading = false;
      return;
    });
  };

  $scope.toggleXeroInteractionOnInvoice = function () {
    $scope.xeroInteractionOnInvoiceLoading = true;
    var settingsUpdate = {};
    if ($scope.currentOrg.features.xero.includeInteractionOnInvoice) {
      // disable and save
      settingsUpdate.includeInteractionOnInvoice = false;
    } else {
      // enable and save
      settingsUpdate.includeInteractionOnInvoice = true;
    }
    $scope.xeroEndpoint.all('settings').customPUT(settingsUpdate).then(function (response) {
      $scope.currentOrg.features.xero.includeInteractionOnInvoice = settingsUpdate.includeInteractionOnInvoice;
      $scope.xeroInteractionOnInvoiceLoading = false;
      return;
    });
  };

  $scope.xeroContactSync = function () {
    $scope.xeroContactSyncLoading = true;
    xeroService.xeroContactSync(function (taskInfo) {
      if (taskInfo.status == 'Failed') {
        //$scope.alertService.presentAlert('error', "We couldn't sync your Xero Contacts", "Something went wrong when we tried to sync your Xero Contacts. Please try again or contact support if this error persists.")
        //$scope.xeroContactSyncLoading = false;
        $scope.xeroDisable(function () {
          $scope.xeroAuth();
        });
      } else {
        $scope.xeroContactSyncLoading = false;
        $scope.showContactSyncSuccess = true;
      }
    });
  };

  $scope.xeroItemSync = function () {
    $scope.xeroItemSyncLoading = true;
    xeroService.xeroItemSync({}, function (taskInfo) {
      if (taskInfo.status == 'Failed') {
        $scope.alertService.presentAlert('error', "We couldn't sync your Xero Items", "Something went wrong when we tried to sync your Xero Items. Please try again or contact support if this error persists.");
        $scope.xeroContactSyncLoading = false;
      } else {
        $scope.xeroItemSyncLoading = false;
        $scope.showItemSyncSuccess = true;
      }
    });
  };

  $scope.xeroAuthenticated = $scope.userIsXeroAuthenticated();

  if ($scope.xeroAuthenticated) {
    $scope.fetchXeroOrg();
  }

  $scope.uploadNewLogo = function ($file) {
    $scope.logoLoading = true;
    Upload.upload({
      method: 'POST',
      url: "" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + "/logo",
      data: { file: $file },
      withCredentials: true
    }).then(function (resp) {
      var url = "" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/logo';
      $("#orgLogoImage").attr('src', url);
      $scope.logoLoading = false;
      $scope.alertService.presentAutoAlert('uploadOrgLogo', resp);
      $scope.currentOrg.logoAttachmentName = "logo";
    }, function (resp) {
      $scope.logoLoading = false;
      $scope.alertService.presentAutoAlert('uploadOrgLogo', resp);
    }, function (evt) {
      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  };

  $scope.editName = function () {
    $scope.data = {
      newName: $scope.currentOrg.name,
      loading: false
    };
    $scope.editingName = true;
  };

  $scope.cancelEditName = function () {
    $scope.editingName = false;
  };

  $scope.saveEditName = function () {
    $scope.data.loading = true;
    userService.updateOrganisation($scope.currentOrg.id, { name: $scope.data.newName }, function (updatedOrg) {
      $scope.currentOrg = updatedOrg;
      $scope.data.loading = false;
      $scope.editingName = false;
    }, function (err) {
      swal({
        title: "Oops!",
        text: "Unable to update organisation name. Please try again later",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      $scope.data.loading = false;
    });
  };

  $scope.showEditBankAccount = function () {
    $("#editBankAccountModal").fadeIn(100);
    $scope.editBankAccount = {
      loading: false,
      bankAccountName: '',
      bankAccountBsb: '',
      bankAccountNumber: undefined
    };
  };

  $scope.closeEditBankAccountModal = function () {
    $("#editBankAccountModal").fadeOut(100);
  };

  $scope.searchAbn = function () {
    $("#searchAbnModal").fadeIn(100);
    $scope.abnSearch = { loading: false, abn: "", step: 'search', error: false };
  };

  $scope.closeSearchAbnModal = function () {
    $("#searchAbnModal").fadeOut(100);
  };

  $scope.searchAbnContinue = function (abnSearch) {
    abnSearch.loading = true;
    var abn = abnSearch.abn.replace(/\s+/g, '');
    billingService.searchAbn(abn, function (abnReturned) {
      abnSearch.loading = false;
      abnSearch.step = 'check';
      abnSearch.abnName = abnReturned.abnName;
      abnSearch.error = false;
    }, function (err) {
      abnSearch.loading = false;
      abnSearch.error = true;
    });
  };

  $scope.saveAbnSearch = function (abnSearch) {
    abnSearch.loading = true;
    var abn = abnSearch.abn.replace(/\s+/g, '');
    var updatePayload = { identities: { abn: abn } };
    userService.updateOrganisation($scope.currentOrg.id, updatePayload, function (updatedOrg) {
      $scope.closeSearchAbnModal();
      $scope.currentOrg.identities = updatedOrg.identities;
    }, function (err) {
      abnSearch.step = 'search';
      abnSearch.loading = false;
      abnSearch.saveError = true;
      abnSearch.error = false;
    });
  };

  $scope.abnModalBack = function (abnSearch) {
    abnSearch.step = 'search';
  };

  /**** Other Group Settings Controls ****/

  $scope.editOrgGroup = function (group) {
    $scope.groupEdit = { loading: true };
    userService.getOrganisationGroup(group.id, function (groupFull) {
      $scope.groupEdit = groupFull;
      $scope.groupOriginal = angular.copy(groupFull);
      $scope.newMember = {};
      // get org group members
      userService.getGroupMembers({ 'sort': 'first', 'groupId': group.id }, function (membersUserInfo) {}, function (err) {});
      if ($scope.groupEdit.root) {
        // get full org also
        $scope.orgEdit = $scope.currentOrg;
        $scope.orgOriginal = angular.copy($scope.currentOrg);
      }
    }, function (err) {
      $scope.groupEdit.loading = false;
      //$scope.closeGroupEdit();
      $scope.alertService.presentAutoAlert('getOrgGroup', err);
    });
  };

  if ($scope.canViewOrgSettings) {
    $scope.editOrgGroup($scope.currentOrgGroup);
  }

  $scope.saveOrgGroup = function (group) {
    group.loading = true;
    // get diff and save if diffcount > 0
    userService.getGroupDiff($scope.groupOriginal, group, function (diffCount, diff) {
      if (diffCount > 0) {
        if (group.id == null) {
          diff.parent = $scope.currentOrgGroup.id;
        }
        userService.saveOrganisationGroup(diff, function (groupUpdated) {
          //group.loading = false;

          if (group.root) {
            userService.getOrgDiff($scope.orgOriginal, $scope.orgEdit, function (diffCount, diff) {
              if (diffCount > 0) {
                userService.updateOrganisation($scope.orgOriginal.id, diff, function (success) {
                  group.loading = false;
                  $scope.editOrgGroup(groupUpdated);
                }, function (fail) {
                  group.loading = false;
                  $scope.editOrgGroup(groupUpdated);
                  alert('Error updating organisation');
                });
              } else {
                group.loading = false;
                $scope.editOrgGroup(groupUpdated);
              }
            });
          } else {
            group.loading = false;
            $scope.editOrgGroup(groupUpdated);
          }
        }, function (err) {
          group.loading = false;
          $scope.alertService.presentAutoAlert('saveOrgGroup', err);
        });
      } else if (group.root) {
        userService.getOrgDiff($scope.orgOriginal, $scope.orgEdit, function (diffCount, diff) {
          if (diffCount > 0) {
            userService.updateOrganisation($scope.orgOriginal.id, diff, function (success) {
              group.loading = false;
              $scope.editOrgGroup($scope.currentOrgGroup);
            }, function (fail) {
              group.loading = false;
              $scope.editOrgGroup(groupUpdated);
              alert('Error updating organisation');
            });
          } else {
            group.loading = false;
            $scope.editOrgGroup(groupUpdated);
          }
        });
      } else {
        group.loading = false;
      }
    });
  };

  if ($stateParams.action && $stateParams.action == 'contactsync') {
    $timeout(function () {
      $scope.xeroContactSync();
    }, 1000);
  }
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "5zlz":
/***/ (function(module, exports) {

var path = 'views/modals/editResourceModal.html';
var html = "<!-- Edit Resource Modal -->\n<div class=\"niceModal desktopSelector\" id=\"newResourceModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"resourceEdit.id == null\">New Resource</h1>\n      <h1 ng-show=\"resourceEdit.id != null\">Edit Resource</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeNewResourceModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content\">\n      <form name=\"newResourceForm\" novalidate>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>Resource Name</label>\n            <input type=\"text\" ng-model=\"resourceEdit.name\" required>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>Unique Identifier</label>\n            <input type=\"text\" ng-model=\"resourceEdit.identifier\" required>\n          </md-input-container>\n        </div>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>Category</label>\n            <md-select ng-model=\"resourceEdit.category\" required>\n              <md-option ng-repeat=\"category in allResourceCategories\" ng-value=\"category.id\">{{category.name}}</md-option>\n            </md-select>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>Unit of Measure</label>\n            <md-select ng-model=\"resourceEdit.uom\" required>\n              <md-option ng-repeat=\"uom in allUoms\" ng-value=\"uom.id\">{{uom.abbreviation}} {{uom.description}}</md-option>\n            </md-select>\n          </md-input-container>\n        </div>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <label>Description</label>\n          <textarea ng-model=\"resourceEdit.description\"></textarea>\n        </md-input-container>\n      </div>\n      <div class=\"footer uneven\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeNewResourceModal()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner margin-right\" ng-click=\"(newResourceForm.$invalid || resourceEdit.loading) || saveNewResource(resourceEdit)\" ng-disabled=\"newResourceForm.$invalid || resourceEdit.loading\">\n              <span ng-hide=\"resourceEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"resourceEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"(newResourceForm.$invalid || resourceEdit.loading) || saveNewResourceAddAnother(resourceEdit)\" ng-if=\"resourceEdit.id == null\" ng-disabled=\"newResourceForm.$invalid || resourceEdit.loading\">\n              <span ng-hide=\"resourceEdit.loading\">Save & Add Another</span>\n              <md-progress-circular ng-show=\"resourceEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </form>\n    </div>\n  </div>\n</div>\n<!-- Edit Resource Modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "6/3I":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/billing.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\">\n    <div class=\"left\">\n      <h3>Plan Details & Billing</h3>\n    </div>\n    <div class=\"right\">\n      \n    </div>\n  </div>\n\n  <div class=\"adminTabularContentContainer\">\n    <div class=\"adminLoaderUnder\" ng-if=\"billingDetails.loading\">\n      <div my-loader text=\"Loading Billing Details\"></div>\n    </div>\n    <md-tabs md-dynamic-height md-selected=\"selectedIndex\" md-border-bottom md-autoselect class=\"docketTabsInner\">\n      <md-tab label=\"General\">\n        <div class=\"settingsTabContentInner\">\n          <div ng-if=\"currentOrg.currentPlanId != null\">\n            <div class=\"adminSettingGroupContainer\">\n              <table class=\"settingsTable\">\n                <tr>\n                  <td width=\"200px\" class=\"title\"><h3>Current Plan</h3></td>\n                  <td></td>\n                </tr>\n                <tr>\n                  <td class=\"title\">Name</td>\n                  <td>{{currentOrg.features.inTrialMode ? '14 day free trial -' : ''}}{{currentOrg.plan.name}}</td>\n                </tr>\n                <tr>\n                  <td class=\"title\">Billing Cycle</td>\n                  <td>{{capitaliseBillingCycle(currentOrg.plan.billingCycle)}}</td>\n                </tr>\n                <tr>\n                  <td class=\"title\">Price Per Month</td>\n                  <td>${{currentOrg.plan.pricePerInterval / 100}}</td>\n                </tr>\n                <tr>\n                  <td class=\"title\">Included Dockets</td>\n                  <td ng-if=\"currentOrg.plan.features.includedDockets != -1\">{{currentOrg.plan.features.includedDockets}}</td>\n                  <td ng-if=\"currentOrg.plan.features.includedDockets == -1\">Unlimited</td>\n                </tr>\n                <tr>\n                  <td class=\"title\">Included Org Units</td>\n                  <td>\n                    <span ng-if=\"currentOrg.plan.features.includedOrganisationGroups == 0\">Unlimited</span>\n                    <span ng-if=\"currentOrg.plan.features.includedOrganisationGroups != 0\">{{currentOrg.plan.features.includedOrganisationGroups}}</span>\n                  </td>\n                </tr>\n                <tr>\n                  <td class=\"title\">Included Users</td>\n                  <td ng-if=\"currentOrg.plan.features.includedUsers == -1\">Unlimited</td>\n                  <td ng-if=\"currentOrg.plan.features.includedUsers != -1\">{{currentOrg.plan.features.includedUsers}}</td>\n                </tr>\n              </table>\n            </div>\n          </div>\n\n          <div ng-if=\"billingDetails.currentCard\">\n            <div class=\"adminSettingGroupContainer\">\n              <table class=\"settingsTable\">\n                <tr>\n                  <td width=\"200px\" class=\"title\"><h3>Current Card</h3></td>\n                  <td></td>\n                </tr>\n                <tr>\n                  <td class=\"title\">Last 4 Digits</td>\n                  <td>{{billingDetails.currentCard.last4}}</td>\n                </tr>\n              </table>\n            </div>\n          </div>\n\n          <div class=\"adminSettingGroupContainer\">\n            <span ng-if=\"currentOrg.currentPlanId\">\n              <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                  <div class=\"dbButton lightBlue\" ng-click=\"selectNewPlan()\">Change Plan</div>\n                  <div class=\"dbButton lightBlue\" ng-click=\"updateCardDetails()\" ng-if=\"billingDetails.currentCard\">Change My Card</div>\n                </div>\n                <!--div class=\"right\">\n                  <div class=\"dbButton whiteOutline\" ng-click=\"cancelSubscription()\">Cancel Subscription</div>\n                </div-->\n              </div>\n            </span>\n            <span ng-if=\"!currentOrg.currentPlanId\">\n              <h3>You haven't select a plan yet</h3>\n              <div class=\"dbButton lightBlue\" ng-click=\"selectNewPlan()\">Select Plan</div>\n            </span>\n          </div>\n        </div>\n      </md-tab>\n      <md-tab label=\"Invoices\">\n        <div class=\"settingsTabContentInner\">\n          <div class=\"adminSettingGroupContainer\" ng-if=\"billingDetails.invoices == null || billingDetails.invoices.length <= 0\">\n            <h3>You don't have any invoices yet.</h3>\n          </div>\n          <md-table-container ng-if=\"billingDetails.invoices && billingDetails.invoices.length > 0\">\n            <table md-table md-row-select multiple ng-model=\"selected\">\n              <thead md-head>\n                <tr md-row>\n                  <th md-column><span>Date</span></th>\n                  <th md-column><span>Amount Due</span></th>\n                  <th md-column><span>Amount Paid</span></th>\n                  <th md-column><span>Payment Status</span></th>\n                  <th md-column><span>Download</span></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row md-select=\"invoice\" md-select-id=\"id\" ng-repeat=\"invoice in billingDetails.invoices\">\n                  <td md-cell>{{invoice.date}}</td>\n                  <td md-cell>${{invoice.amountDue}}</td>\n                  <td md-cell>${{invoice.amountPaid}}</td>\n                  <td md-cell><div class=\"statusDisplay {{invoice.status == 'PAID' ? 'Completed' : 'sent'}}\">{{invoice.status}}</div></td>\n                  <td md-cell><md-button class=\"md-icon-button\" ng-click=\"downloadInvoice(invoice)\"><md-icon md-svg-icon=\"file_download.svg\"></md-icon></md-button></td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </md-tab>\n      <md-tab label=\"Contact\">\n        <div class=\"settingsTabContentInner\">\n          <form name=\"billingContactForm\">\n            <h4 class=\"top\">Billing Contact Person</h4>\n            <div class=\"adminSettingGroupContainer\">\n              <div layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>Email Address</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.emailAddress\" required>\n                </md-input-container>\n\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>First Name</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.firstName\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>Last Name</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.lastName\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>Contact Number</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.phoneNumber\">\n                </md-input-container>\n              </div>\n            </div>\n            <h4>Billing Address</h4>\n            <div class=\"adminSettingGroupContainer\">\n              <div layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <label>Street Address</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.address.streetAddress\" required>\n                </md-input-container>\n              </div>\n              <div layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>Suburb</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.address.suburb\" required>\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>State</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.address.state\" required>\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>Post Code</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.address.postCode\" required>\n                </md-input-container>\n              </div>\n              <div layout-gt-sm=\"row\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <label>Country</label>\n                  <input type=\"text\" ng-model=\"billingDetails.contact.address.country\" required>\n                </md-input-container>\n              </div>\n            </div>\n\n            <div class=\"adminContentButtons\">\n              <div class=\"dbButton spinner\" ng-click=\"saveBillingContact(billingDetails)\" ng-disabled=\"billingContactForm.$invalid || billingDetails.contact.loading\">\n                <span ng-hide=\"billingDetails.contact.loading\">Save</span>\n                <md-progress-circular ng-show=\"billingDetails.contact.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n              </div>\n            </div>\n          </form>\n        </div>\n      </md-tab>\n    </md-tabs>\n  </div>\n</div>\n\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "6/oi":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/detail.html';
var html = "<div class=\"mobileContainer\">\n\n  <!-- Docket Detail View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'docket'\" ng-controller=\"docketDetailController\">\n    <div class=\"mobileDetailHeader new fixed {{itemEdit.status}}\">\n      <div class=\"headerLoadingSpinner\">\n        <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"15\" ng-if=\"backgroundLoadCount > 0\"></md-progress-circular>\n      </div>\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"cancelButtonHover\" ng-click=\"closeWithoutSave(itemEdit)\">\n          <div class=\"cancelButton\">\n            <div class=\"line1\"></div>\n            <div class=\"line2\"></div>\n            <div class=\"line3\"></div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"middle\">\n              &nbsp;\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton {{progressiveSaveInProcess ? 'disabled' : ''}}\" ng-click=\"progressiveSaveInProcess || saveAndStay(itemEdit)\" ng-show=\"userCanDoAction('saveDocket', itemEdit)\">Save</div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderLower\">\n          <div class=\"left\">\n            <span ng-if=\"itemEdit.docketNumber != 'New Docket'\">Docket </span>{{itemEdit.docketNumber}}\n          </div>\n          <div class=\"right\">\n            <div class=\"actionButton\" ng-click=\"openBottomSheet()\">\n              <md-icon md-svg-src=\"more_vert.svg\"></md-icon>\n            </div>\n          </div>\n        </div>\n      </div>\n      <ng-include src=\"'views/pages/dockets/mobile/mobileTabBar.html'\" class=\"blockLayoutHelper\"></ng-include>\n    </div>\n\n    <div class=\"itemDetailLoaderUnder\" ng-show=\"itemEdit.loading || docketLoadingError\">\n      <div my-loader text=\"Loading Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n      <div my-loader text=\"Saving Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n      <div class=\"stdLoader\" ng-show=\"docketLoadingError != null\">\n        <div class=\"loaderOuterContainer\">\n          <div class=\"loaderInnerContainer headerPadding\">\n            <div class=\"materialSpinner\">\n              <md-icon md-svg-src=\"error.svg\"></md-icon>\n            </div>\n            <div class=\"loadingText\">\n              {{docketLoadingError}}\n            </div>\n            <div class=\"loadingRetryButton\">\n              <div class=\"dbButton simpleOutline\" ng-click=\"openDocketMobile(itemEdit.docketId)\">Retry</div>\n              <br/>\n              <div class=\"dbButton simpleOutline margin-top\" ng-click=\"contactSupportError(docketLoadingErrorFull)\">Contact Support</div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"tableCellHelperContainer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"contentSplitDetail listItemDetail mobile {{itemEdit.status}}\">\n          <ng-include src=\"'views/pages/dockets/mobile/docketDetail.html'\" class=\"includeContainer mobileListContainer\"></ng-include>\n        </div>\n      </div>\n    </div>\n    <!-- Share Docket / Access Control Modal -->\n    <ng-include src=\"'views/modals/shareDocketModal.html'\"></ng-include>\n    <!-- Assign Docket Modal -->\n    <ng-include src=\"'views/modals/assignDocketModal.html'\"></ng-include>\n  </div>\n  <!-- End Docket Detail View -->\n\n  <!-- Select Company View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'company'\" ng-controller=\"selectContactController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeContactSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Contact\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"contactSearchValue\" ng-change=\"searchContactChange(contactSearchValue)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/companyList.html'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n    <ng-include src=\"'views/modals/viewContactModal.html'\"></ng-include>\n  </div>\n  <!-- End Select Company View -->\n\n  <!-- Select Organisation View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'organisation'\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"cancelSelectOrganisation()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Org Unit\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/organisationList.html'\" class=\"includeContainer mobilePadding\"></ng-include>\n  </div>\n  <!-- End Select Company View -->\n\n  <!-- Select Order View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'order'\" ng-controller=\"selectOrderController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeOrderSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Order\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"orderSearchValue\" ng-change=\"searchOrderChange(orderSearchValue)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/orderList.html'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n  </div>\n  <!-- End Select Order View -->\n\n  <!-- Select Template View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'docketTemplate'\" ng-controller=\"selectTemplateController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeTemplateSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Docket Template\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/templateList.html'\" class=\"includeContainer mobilePadding\"></ng-include>\n  </div>\n  <!-- End Select Template View -->\n\n  <!-- Select Resource View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'resource'\" ng-controller=\"selectResourceController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\" ng-show=\"resourceSelectState == 'category'\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"categoryListBackPress()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Resource Category\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"mobileDetailHeader selectHeader fixed\" ng-show=\"resourceSelectState == 'resource'\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton\" ng-click=\"resourceListBackPress()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select {{resourceCategorySelected.name}} Resources\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"resourceSearchText\" ng-change=\"mobileResourceSearch(resourceSearchText)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/resourceCategoryList.html'\" ng-show=\"resourceSelectState == 'category'\" class=\"includeContainer mobilePadding\"></ng-include>\n    <ng-include src=\"'views/selectors/resourceList.html'\" ng-show=\"resourceSelectState == 'resource'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n  </div>\n  <!-- End Select Resource View -->\n</div>\n\n<!-- Interaction Modals -->\n<span ng-controller=\"interactionModalController\">\n  <ng-include src=\"'views/modals/mobileInteractionModal.html'\"></ng-include>\n</span>\n<!-- End Interaction Modals -->\n<!-- Signature Capture Modal -->\n<span ng-controller=\"signatureModalController\">\n  <ng-include src=\"'views/modals/signatureCaptureModal.html'\"></ng-include>\n</span>\n<!-- End Signature Capture Modal -->\n<!-- Checklist Detail Modal -->\n<span ng-controller=\"checklistModalController\">\n  <ng-include src=\"'views/modals/checklistDetailModal.html'\"></ng-include>\n</span>\n<!-- End Checklist Detail Modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "69jr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').controller('companySettingsFieldsController', ['$scope', 'docketService', 'Restangular', '$state', '$window', '$stateParams', 'accessControl', '$q', function ($scope, docketService, Restangular, $state, $window, $stateParams, accessControl, $q) {
  mixpanel.track("Opened CompanySettings-Fields Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.editField = {};
  $scope.selected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'displayName'
  };
  $scope.listCount = 0;

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************/
  /**** List Controls *****/
  /************************/

  $scope.loadFieldsList = function () {
    $scope.promise = $q(function (resolve, reject) {
      // Get templates from docketService
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      docketService.getFields(queryParams, function (fields) {
        $scope.allFields = fields;
        if (queryParams.offset <= 0 && fields.length < queryParams.limit) {
          $scope.listCount = fields.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (error) {
        $scope.allFields = [];
        reject('Error');
      });
    });
  };

  $scope.loadFieldsList();

  /***************************************/
  /***** Docket Fields Functionality *****/
  /***************************************/

  $scope.openNewFieldModal = function () {
    $scope.newFieldFromParent({}, function (newField) {
      if (newField != null) {
        docketService.saveField(newField, function () {
          $scope.loadFieldsList();
        }, function (err) {
          field.loading = false;
          $scope.alertService.presentAutoAlert('saveField', err);
        });
      }
    });
  };

  $scope.editField = function (field) {
    $scope.editFieldFromParent(field, function (fieldEdited, templatesNeedUpdating, onTemplates) {
      if (fieldEdited != null) {
        docketService.saveField(fieldEdited, function () {
          $scope.loadFieldsList();
          if (templatesNeedUpdating) {
            updateTemplatesWithFieldChange(field, onTemplates);
          }
        }, function (err) {
          field.loading = false;
          $scope.alertService.presentAutoAlert('saveField', err);
        });
      }
    });
  };

  $scope.deleteSelectedFields = function () {
    var count = $scope.selected.length;
    swal({
      title: "Are you sure?",
      text: count + " fields will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteBulkFields($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkFields', { status: 202, requestName: 'Delete bulk field - failures ' + failures.length + ' of ' + $scope.selected.length });
            $scope.loadFieldsList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkFields', { status: 200 });
            $scope.loadFieldsList();
          }
        });
      }
    });
  };

  var updateTemplatesWithFieldChange = function updateTemplatesWithFieldChange(field, templates) {
    for (var i = 0; i < templates.length; i++) {
      docketService.getTemplate(templates[i], function (templateFull) {
        // find interaction templates with this field in it
        for (var j = 0; j < templateFull.interactionTemplates.length; j++) {
          var thisInteraction = templateFull.interactionTemplates[j];
          for (var k = 0; k < thisInteraction.fields.length; k++) {
            if (thisInteraction.fields[k].id == field.id) {
              // this field needs updating
              thisInteraction.fields[k].displayName = field.displayName;
              thisInteraction.fields[k].mandatory = field.mandatory;
              if (field.type == 'select') {
                thisInteraction.fields[k].selectionFields = field.selectionFields;
              }
            }
          }
        }
        // save this template
        docketService.saveTemplate(templateFull, function (templateSaved) {}, function (err) {});
      }, function (err) {});
    }
  };
}]);

/***/ }),

/***/ "70Tx":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/desktop/jobTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div class=\"ojdDesktopSection header {{getStatus(itemEdit)}}\">\n    <div class=\"headerTitle\" ng-if=\"itemEdit.status\">\n      <div class=\"centerAligned\">\n        <h2>Status</h2>\n        <h1>{{getStatus(itemEdit)}}</h1>\n      </div>\n      <div class=\"dbButton floatRight centerAligned\" ng-click=\"showAssignJobModal(itemEdit)\" ng-if=\"userCanDoAction('assignUserToJob', itemEdit) && !itemEdit.loading && getStatus(itemEdit) == 'Unassigned'\">Assign Job</div>\n    </div>\n  </div>\n\n  <div class=\"ojdDesktopSection\">\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\" ng-click=\"!userCanDoAction('changeJobOrder', itemEdit) || selectOrder()\" ng-if=\"itemEdit.id == null || (currentOrg.id == itemEdit.organisation && currentOrgGroup.id == itemEdit.organisationGroup)\">\n        <label class=\"order\">Order</label>\n        <a ui-sref=\"main.groupOrderDetail({orderId: itemEdit.orderRef.id, orgId: currentOrg.id, groupId: currentOrgGroup.id})\" ng-if=\"itemEdit.orderRef && !itemEdit.editing && currentOrg != null\">\n          <h2>{{itemEdit.orderRef.orderNumber}}</h2>\n        </a>\n        <h2 ng-if=\"itemEdit.orderRef && !itemEdit.editing && currentOrg == null\">{{itemEdit.orderRef.orderNumber}}</h2>\n        <h2 ng-if=\"itemEdit.orderRef && itemEdit.editing\">{{itemEdit.orderRef.orderNumber}}</h2>\n        <h2 ng-if=\"!itemEdit.orderRef\">Not Selected</h2>\n        <h3 ng-if=\"userCanDoAction('changeJobOrder', itemEdit)\">\n          Click to <span ng-if=\"itemEdit.orderRef\">change</span><span ng-if=\"!itemEdit.orderRef\">select</span> order\n        </h3>\n      </div>\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Start Date</label>\n        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n          <md-datepicker ng-model=\"itemEdit.startDate\" name=\"startDate\" ng-disabled=\"!userCanDoAction('changeJobStartDate', itemEdit)\" aria-label=\"Start Date\"></md-datepicker>\n        </md-input-container>\n      </div>\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">End Date</label>\n        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n          <md-datepicker ng-model=\"itemEdit.endDate\" name=\"endDate\" ng-disabled=\"!userCanDoAction('changeJobEndDate', itemEdit)\" aria-label=\"End Date\"></md-datepicker>\n        </md-input-container>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\" ng-if=\"itemEdit.orderRef\">\n      <div class=\"ojdDesktopField\" ng-show=\"itemEdit.supplierContact\">\n        <label class=\"order\">Supplier</label>\n        <h2 ng-if=\"itemEdit.supplierContact\">{{itemEdit.supplierContact.displayName}}</h2>\n        <h3 ng-if=\"itemEdit.supplierContact.addresses\">{{stringifyAddress(itemEdit.supplierContact.addresses[0])}}</h3>\n      </div>\n      <div class=\"ojdDesktopField\" ng-show=\"itemEdit.customerContact\">\n        <label class=\"order\">Customer</label>\n        <h2 ng-if=\"itemEdit.customerContact\">{{itemEdit.customerContact.displayName}}</h2>\n        <h3 ng-if=\"itemEdit.customerContact.addresses\">{{stringifyAddress(itemEdit.customerContact.addresses[0])}}</h3>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\" ng-if=\"itemEdit.order\">\n      <div class=\"ojdDesktopField\" ng-show=\"itemEdit.order.supplierRefNo && !itemEdit.xeroQuote\">\n        <label class=\"order\">Supplier Ref No</label>\n        <h2>{{itemEdit.order.supplierRefNo}}</h2>\n      </div>\n\n      <div class=\"ojdDesktopField\" ng-if=\"itemEdit.xeroQuote\">\n        <label class=\"order\">Xero Quote</label>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <div ng-if=\"itemEdit.xeroQuoteFull\">\n            <div class=\"xeroAvatar\"></div>\n            <a target=\"_blank\" href=\"https://go.xero.com/organisationlogin/default.aspx?shortcode={{currentOrg.features.xero.shortCode}}&redirecturl=/Accounts/Receivable/Quotes/Edit/{{itemEdit.xeroQuoteFull.quoteID}}\">{{itemEdit.xeroQuoteFull.quoteNumber}} ({{itemEdit.xeroQuoteFull.status}})</a>\n          </div>\n        </md-input-container>\n      </div>\n\n      <div class=\"ojdDesktopField\" ng-show=\"itemEdit.order.customerRefNo\">\n        <label class=\"order\">Customer Ref No</label>\n        <h2>{{itemEdit.order.customerRefNo}}</h2>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Instructions</label>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <textarea ng-model=\"itemEdit.instructions\" rows=\"2\" md-select-on-focus ng-disabled=\"!userCanDoAction('editJobDetails', itemEdit)\" aria-label=\"Instructions\"></textarea>\n        </md-input-container>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Items</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button aria-label=\"Add Item To Job\" class=\"md-icon-button\" ng-click=\"selectLineItem()\" ng-disabled=\"!itemEdit.orderRef || !(userCanDoAction('addLineItemToJob', itemEdit))\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <p ng-show=\"!itemEdit.orderRef\">Select an order before adding items to this job</p>\n    <p ng-show=\"itemEdit.orderRef && (!itemEdit.lineItems || itemEdit.lineItems.length <= 0)\">No line items have been assigned to this job</p>\n\n    <md-table-container ng-show=\"itemEdit.lineItems && itemEdit.lineItems.length > 0\">\n      <table md-table multiple>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Resource</th>\n            <th md-column>Description</th>\n            <th md-column>Qty</th>\n            <th md-column>Completion</th>\n            <th md-column ng-show=\"itemEdit.editing\"></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"lineItem in itemEdit.lineItems\" ng-show=\"!lineItem.delete\">\n            <td md-cell>\n              {{lineItem.resource.name}} ({{lineItem.resource.identifier}})\n            </td>\n            <td md-cell>\n              <span ng-show=\"userCanDoAction('editLineItemJob', itemEdit)\">\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"lineItem.itemDescription\" aria-label=\"Line Item Description\"></textarea>\n                </md-input-container>\n              </span>\n              <span ng-show=\"!userCanDoAction('editLineItemJob', itemEdit)\">\n                {{lineItem.itemDescription}}\n              </span>\n            </td>\n            <td md-cell width=\"200px\">\n              <span ng-show=\"lineItem.resource.uom.isTime\">\n                <span ng-show=\"!userCanDoAction('editLineItemJob', itemEdit)\">\n                  {{formatTimeQuantity(lineItem.quantity, lineItem.resource.uom.abbreviation)}}\n                </span>\n                <span ng-show=\"userCanDoAction('editLineItemJob', itemEdit)\">\n                  <div layout-gt-sm=\"row\">\n                    <md-input-container flex-gt-sm class=\"md-block\">\n                      <label>Hours</label>\n                      <input type=\"text\" ng-model=\"lineItem.quantityHoursEdit\" aria-label=\"Line Item Hours Quantity\">\n                    </md-input-container>\n                    <md-input-container flex-gt-sm class=\"md-block\">\n                      <label>Minutes</label>\n                      <input type=\"text\" ng-model=\"lineItem.quantityMinutesEdit\" aria-label=\"Line Item Minutes Quantity\">\n                    </md-input-container>\n                  </div>\n                </span>\n              </span>\n              <span ng-show=\"!lineItem.resource.uom.isTime\">\n                <span ng-show=\"!userCanDoAction('editLineItemJob', itemEdit)\">\n                  {{lineItem.quantity}} {{lineItem.resource.uom.abbreviation}}\n                </span>\n                <span ng-show=\"userCanDoAction('editLineItemJob', itemEdit)\">\n                  <md-input-container class=\"md-block\">\n                    <label>{{lineItem.resource.uom.abbreviation}}</label>\n                    <input type=\"text\" ng-model=\"lineItem.quantityEdit\" aria-label=\"Line Item Quantity\">\n                  </md-input-container>\n                </span>\n              </span>\n            </td>\n            <td md-cell>\n              <span ng-if=\"lineItem.resource.uom.isTime && lineItem.completion\">\n                {{formatTimeQuantity(lineItem.completion, lineItem.resource.uom.abbreviation)}}\n              </span>\n              <span ng-if=\"!lineItem.resource.uom.isTime\">\n                {{lineItem.completion.toFixed(2)}} {{lineItem.resource.uom.abbreviation}}\n              </span>\n            </td>\n            <td md-cell ng-show=\"itemEdit.editing\">\n              <md-button class=\"md-icon-button\" aria-label=\"Remove Item\" ng-click=\"removeLineItem(lineItem)\" ng-show=\"userCanDoAction('deleteLineItemFromJob', itemEdit)\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n\n  <div class=\"ojdDesktopSection noPadding\" ng-if=\"currentOrg.id === itemEdit.organisation\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Assigned Subcontractors</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button ng-if=\"currentOrg.planFeatures.jobsSubcontractorAllocation\" aria-label=\"Add Subcontractor To Job\" class=\"md-icon-button\" ng-disabled=\"!userCanDoAction('shareJob', itemEdit)\" ng-click=\"selectSubcontractorContactForAddition()\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n        <md-button ng-if=\"!currentOrg.planFeatures.jobsSubcontractorAllocation\" class=\"lockIcon\" ng-click=\"selectPlan(null, 'jobsSubcontractorAllocation', 'from job details - add subcontractor')\" style=\"min-width: 40px;\">\n          <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"left\">\n            <div style=\"font-size: 12px;\">Unlock allocation of subcontractors features on the Large Plan</div>\n          </md-tooltip>\n        </md-button>\n      </div>\n    </div>\n    <p ng-show='!itemEdit.forwarders || itemEdit.forwarders.length <= 0'>No subcontractors have been assigned to this job</p>\n    <md-table-container ng-show=\"itemEdit.forwarders && itemEdit.forwarders.length > 0\">\n      <table md-table multiple>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Subcontractor</th>\n            <th md-column>Assigned</th>\n            <th md-column>Accepted</th>\n            <th md-column>Rejected</th>\n            <th md-column></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"subcontractor in subcontractorCounts\">\n            <td md-cell>\n              {{subcontractor.name}}\n            </td>\n            <td md-cell>\n              {{subcontractor.assigned}}\n            </td>\n            <td md-cell>\n              {{subcontractor.accepted}}\n            </td>\n            <td md-cell>\n              {{subcontractor.rejected}}\n            </td>\n            <td md-cell>\n              <md-button class=\"md-icon-button pull-right\" aria-label=\"Remove Subcontractor\" ng-click=\"removeSubcontractor(subcontractor.principal)\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Assigned People</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button aria-label=\"Add Person To Job\" class=\"md-icon-button\" ng-disabled=\"!userCanDoAction('assignUserToJob', itemEdit)\" ng-click=\"selectPerson()\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <p ng-show='!cleanAssignees || cleanAssignees.length <= 0'>No people have been assigned to this job</p>\n\n    <md-table-container ng-show=\"cleanAssignees && cleanAssignees.length > 0\">\n      <table md-table multiple>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Status</th>\n            <th md-column>Person</th>\n            <th md-column>Company</th>\n            <th md-column>Comment</th>\n            <th md-column class=\"iconColumn\"></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"assignee in cleanAssignees\" ng-show=\"!assignee.delete\">\n            <td md-cell width=\"100px\">\n              <span ng-if=\"assignee.status\"><div class=\"statusDisplay {{assignee.status}}\">{{assignee.status}}</div></span>\n              <span ng-if=\"!assignee.status\"><div class=\"statusDisplay Assigned\">Assigned</div></span>\n            </td>\n            <td md-cell>\n              {{assignee.name}}\n            </td>\n            <td md-cell>\n              <span ng-if=\"resolutionMap.map[assignee.organisationGroup]\">\n                  {{resolutionMap.map[assignee.organisationGroup].name}}\n              </span>\n            </td>\n            <td md-cell>\n              <span ng-show=\"assignee.rejectionComment\">{{assignee.rejectionComment}}</span>\n            </td>\n            <td md-cell>\n              <md-button class=\"md-icon-button pull-right\" aria-label=\"Remove Assignee\" ng-click=\"unassignPerson(assignee)\" ng-show=\"userCanDoAction('unassignUserFromJob', itemEdit)\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Comments</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button aria-label=\"Add Comment To Job\" class=\"md-icon-button\" ng-click=\"addNewComment(itemEdit)\" ng-disabled=\"!userCanDoAction('addCommentToJob', itemEdit)\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <p ng-show=\"itemEdit.comments == null || itemEdit.comments.length <= 0\">There are no comments for this job yet</p>\n\n    <md-table-container ng-show=\"itemEdit.comments && itemEdit.comments.length > 0\">\n      <table md-table multiple>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Person</th>\n            <th md-column>Comment</th>\n            <th md-column>Date</th>\n            <th md-column ng-show=\"userCanDoAction('removeCommentFromJob', itemEdit)\"></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"comment in itemEdit.comments\" ng-show=\"!comment.delete\">\n            <td md-cell>\n              {{comment.authorName}}\n            </td>\n            <td md-cell>\n            <div ng-bind-html=\"comment.comment\"></div><!--{{comment.comment}}-->\n            </td>\n            <td md-cell>\n              {{moment(comment.date).tz(itemEdit.timezone).format('ddd DD/MM/YYYY hh:mm A')}}\n            </td>\n            <td md-cell ng-show=\"userCanDoAction('removeCommentFromJob', itemEdit)\">\n              <md-button class=\"md-icon-button pull-right\" aria-label=\"Remove Comment\" ng-click=\"removeCommentFromJob(itemEdit, comment)\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "74sJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_contactshare.svg";

/***/ }),

/***/ "7F0w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('companySettingsUomsController', ['resourceService', '$q', '$scope', '$window', 'Restangular', '$state', '$stateParams', 'accessControl', function (resourceService, $q, $scope, $window, Restangular, $state, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-Uoms Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'abbreviation'
  };
  $scope.selected = [];
  $scope.listCount = 0;

  $scope.timeTypes = ['hours', 'hoursminutes', 'minutes'];

  $scope.loadUomsList = function () {
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      resourceService.getUoms(queryParams, function (uoms) {
        $scope.allUoms = uoms;
        if (queryParams.offset <= 0 && uoms.length < queryParams.limit) {
          $scope.listCount = uoms.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (err) {
        $scope.allUoms = [];
        reject('Error');
      });
    });
  };

  $scope.loadUomsList();

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /********************************/
  /***** Unit of Measure Func *****/
  /********************************/

  // Create a new uom modal
  $scope.openNewUomModal = function () {
    $scope.uomEdit = {};
    $scope.uomEdit.isTime = false;
    $("#newUomModal").fadeIn(100);
  };

  $scope.editUom = function (uom) {
    $scope.uomEdit = uom;
    $("#newUomModal").fadeIn(100);
  };

  // Close new uom modal
  $scope.closeNewUomModal = function () {
    $("#newUomModal").fadeOut(100);
    $scope.uomEdit = {};
  };

  // Save a new uom for the organisation
  $scope.saveNewUom = function (uom) {
    uom.loading = true;
    if (uom.isTime == null) {
      uom.isTime = false;
    }
    resourceService.saveUom(uom, function (updatedUom) {
      $scope.closeNewUomModal();
      $scope.loadUomsList();
    }, function (err) {
      uom.loading = false;
      $scope.alertService.presentAutoAlert('saveUom', err);
    });
  };

  $scope.deleteUom = function (uom) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this unit of measure!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: false,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.removeUom(uom.id, function (success) {
          swal("Deleted!", "The unit of measure has been deleted.", "success");
          $scope.loadUomsList();
        }, function (err) {
          swal({
            title: "Error!",
            text: "An error occured while deleting the unit of measure.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        });
      }
    });
  };

  $scope.deleteSelectedUoms = function () {
    var count = $scope.selected.length;
    swal({
      title: "Are you sure?",
      text: count + " uom's will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.deleteBulkUoms($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkUoms', { status: 202, requestName: 'Delete bulk uoms - failures ' + failures.length + ' of ' + $scope.selected.length });
            $scope.loadUomsList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkUoms', { status: 200 });
            $scope.loadUomsList();
          }
        });
      }
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "7ScX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "job.svg";

/***/ }),

/***/ "7o4S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectQuoteController', ['xeroService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', function (xeroService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {

  // Initialise variables to be used
  $scope.quoteSearch = "";
  $scope.quoteSelectCallback = null;
  $scope.quoteSearchList = [];
  $scope.quoteSearchLoading = false;
  $scope.quoteLoadingError = null;

  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'displayName'
  };
  $scope.quotesSelected = [];

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.quoteSelectFromParent = function (cb) {
    $scope.quoteModalMode = 'select';
    $scope.updateQuoteOnSelect = false;
    $scope.quoteSearch = "";
    $scope.quoteSelectCallback = cb;
    $scope.quoteDetail = null;
    if ($scope.device == 'mobile') {} else {
      $("#selectQuoteModal").fadeIn(100);
      $("input[name='searchQuoteInput']").focus();
    }
    $scope.loadQuoteSearchList();
  };

  $scope.loadQuoteSearchList = function (searchValue) {
    $scope.quoteSearchLoading = true;
    $scope.promise = $q(function (resolve, reject) {
      var params = {};
      //params.status = 'DRAFT';
      params.order = 'date DESC';
      // TODO: add search and filter params
      xeroService.getXeroQuotes(params, function (quotes) {
        // filter out quote status's
        var quotesFiltered = [];
        for (var i = 0; i < quotes.length; i++) {
          if (quotes[i].status == 'DRAFT' || quotes[i].status == 'SENT' || quotes[i].status == 'ACCEPTED') {
            quotesFiltered.push(quotes[i]);
          }
        }
        $scope.quoteSearchList = quotesFiltered;
        $scope.quoteSearchListFull = angular.copy(quotesFiltered);

        $scope.quoteSearchList = Restangular.stripRestangular($scope.quoteSearchList);
        $scope.quoteSearchLoading = false;
        resolve('Done');
      }, function (err) {
        $scope.quoteSearchLoading = false;
        $scope.quoteLoadingError = "Error getting quotes";
        reject('Error');
      });
    });
  };

  $scope.selectQuote = function (quote) {
    /*if (($scope.contactModalMode === 'edit') && (!$scope.updateContactOnSelect)) {
      return;
    }*/
    $scope.quoteDetail = angular.copy(quote);
  };

  $scope.selectQuoteContinue = function () {
    if ($scope.quoteDetail) {
      $scope.quoteSelectCallback($scope.quoteDetail);
      $("#selectQuoteModal").fadeOut(100);
    }
  };

  $scope.closeQuoteSelectList = function () {
    $("#selectQuoteModal").fadeOut(100);
    if ($scope.quoteSelectCallback && typeof $scope.quoteSelectCallback === 'function') {
      $scope.quoteSelectCallback(null);
    }
  };

  $scope.searchContactChange = function (searchText) {
    $scope.loadContactSearchList(searchText);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "8M7Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "add.svg";

/***/ }),

/***/ "8Pnt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "clear.svg";

/***/ }),

/***/ "8YUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var errorSvg = __webpack_require__("lk0G");
var clearSvg = __webpack_require__("8Pnt");

angular.module('docketbook').controller('scopeNavController', ['addressBookService', 'userService', 'uuid', '$scope', '$state', '$window', '$location', '$stateParams', 'accessControl', '$rootScope', 'jobService', 'orderService', function (addressBookService, userService, uuid, $scope, $state, $window, $location, $stateParams, accessControl, $rootScope, jobService, orderService) {
  $scope.listView = $state.current.data ? $state.current.data.listView : '';

  $scope.myDocketbook = false;
  $scope.errorSvgImagePath = errorSvg;
  $scope.clearSvgImagePath = clearSvg;
  if ($stateParams.myDocketbook == true) {
    $scope.myDocketbook = true;
  }

  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentUser = accessControl.currentUser();
  $scope.organisations = accessControl.allowedOrganisations();
  $scope.orgUnitSelected = [];
  $scope.userCanDoAction = userService.userCanDoAction;
  $scope.hasJobs = true;
  $scope.hasOrders = true;
  $scope.connections = [];

  $scope.newLook = function () {
    mixpanel.track('Go To React');
    // Save new look preference to local storage
    localStorage.setItem('react-view', true);
    window.location.href = window.location.href.replace('?applicationId=io.docketbook.webui&authType=session', '').replace('/#/', '/app/');
  };

  function updateConnectionCount() {
    $scope.connections = [];

    userService.getUserConnections(function (connections) {
      $scope.connections = $scope.connections.concat(connections);
    });

    if ($scope.currentOrg != null) {
      addressBookService.getFilteredConnections({ statuses: 'requested' }, function (connections) {
        $scope.connections = $scope.connections.concat(connections.filter(function (connection) {
          return connection.status == 'requested' && connection.sourceId != $scope.currentOrg.id;
        }));
      });
    }
  }

  updateConnectionCount();

  $rootScope.updateScopeNavConnections = function () {
    updateConnectionCount();
  };

  jobService.getJobs({ limit: 1, offset: 0 }, function (returnData) {
    $scope.hasJobs = returnData.length > 0;
  });

  orderService.getOrders({ limit: 1, offset: 0 }, function (returnData) {
    $scope.hasOrders = returnData.length > 0;
  });

  var getChildren = function getChildren(group) {
    var children = $scope.currentOrg.groups.filter(function (g) {
      return g.parent == group.id && g.active;
    });
    return _.flatten([group].concat(_toConsumableArray(children.map(function (g) {
      return getChildren(g);
    }))));
  };

  var rootGroup = $scope.currentOrg ? $scope.currentOrg.groups.filter(function (x) {
    return x.parent == null;
  })[0] : null;
  $scope.sortedGroups = rootGroup ? getChildren(rootGroup) : [];

  $rootScope.$on('OrganisationsListRefreshed', function () {
    $scope.organisations = accessControl.allowedOrganisations();
  });

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.mobileNav = false;

  $scope.myCompaniesClick = function () {
    localStorage.removeItem('orgGroup-' + $scope.currentUser.id);
  };

  $scope.logout = function () {
    accessControl.logout($scope.urlVersion, '');
  };

  $scope.goToDockets = function () {
    $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
  };

  $scope.goToContacts = function () {
    $state.go('main.groupContacts', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
  };

  $scope.goToInvoices = function (subRoute) {
    window.location.href = '/app/org/' + $scope.currentOrg.id + '/group/' + $scope.currentOrgGroup.id + '/invoices/list/' + subRoute;
  };

  $scope.openOrgUnits = function (orgId) {
    if ($("#org" + orgId + " ul.inner").css('display') == 'none') {
      $("#org" + orgId + " ul.inner").slideDown();
      $("#org" + orgId + " .openIcon .downIcon").hide();
      $("#org" + orgId + " .openIcon .upIcon").show();
    } else {
      $("#org" + orgId + " ul.inner").slideUp();
      $("#org" + orgId + " .openIcon .downIcon").show();
      $("#org" + orgId + " .openIcon .upIcon").hide();
    }
  };

  $scope.openScopeDropdown = function () {
    if ($("#orgListDropdown").css('display') == 'none') {
      $("#orgListDropdown").slideDown(function () {
        if ($scope.currentOrg != null) {
          $("#org" + $scope.currentOrg.id + " ul.inner").slideDown();
        }
      });
      $(".orgScopeIcon").addClass('open');
    } else {
      $("#orgListDropdown").slideUp();
      $(".orgScopeIcon").removeClass('open');
    }
  };

  $scope.closeScopeDropdown = function () {
    $("#orgListDropdown").slideUp();
    $(".orgScopeIcon").removeClass('open');
  };

  $scope.openUserDropdown = function () {
    if ($("#userDropdown").css('display') == 'none') {
      $("#userDropdown").slideDown();
      $("#userDropdownSelector .downIcon").hide();
      $("#userDropdownSelector .upIcon").show();
    } else {
      $("#userDropdown").slideUp();
      $("#userDropdownSelector .downIcon").show();
      $("#userDropdownSelector .upIcon").hide();
    }
  };

  $scope.changeOrganisation = function (org) {
    if (org != null) {
      $state.go('main.groupDashboard', { orgId: org.id, groupId: 'home' });
    } else {
      $state.go('main.dashboard');
    }
  };

  $scope.changeOrganisationGroup = function (org, orgGroup) {
    $state.go('main.groupDashboard', { orgId: org.id, groupId: orgGroup.id });
  };

  $scope.toggleMobileNav = function () {
    $scope.mobileNav = !$scope.mobileNav;
  };

  $scope.goTo = function (view) {
    var currentPath = $location.path();
    if (currentPath == "/" + view) {
      $scope.mobileNav = false;
    }
    $location.path(view);
  };

  $scope.goToDirect = function (href) {
    $window.location.href = href;
  };

  $scope.openHelp = function () {
    $window.open('https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us', '_blank');
  };

  $scope.openAdminDropdown = function () {
    if ($(".adminDropdown").css('display') == 'none') {
      $(".adminDropdown").slideDown();
    } else {
      $(".adminDropdown").slideUp();
    }
  };

  var addGroupBreadcrumb = function addGroupBreadcrumb(breadcrumbs, successCb) {
    if ($scope.currentOrg.groups.length === 0) {
      return successCb(breadcrumbs);
    }
    if (breadcrumbs[breadcrumbs.length - 1].parent !== null && breadcrumbs[breadcrumbs.length - 1].parent !== undefined) {
      // get full parent group
      var priorLength = breadcrumbs.length;
      for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
        if ($scope.currentOrg.groups[i].id == breadcrumbs[breadcrumbs.length - 1].parent) {
          breadcrumbs.push($scope.currentOrg.groups[i]);
          break;
        }
      }
      if (breadcrumbs.length === priorLength) {
        //we haven't added anything to the breadcrumb trail - we can't go any higher
        //in the chain - bail out.
        return successCb(breadcrumbs);
      }
      addGroupBreadcrumb(breadcrumbs, successCb);
    } else {
      successCb(breadcrumbs);
    }
  };

  $scope.generateGroupsBreadcrumb = function () {
    var breadcrumbGroups = [];
    if ($scope.currentOrgGroup) {
      breadcrumbGroups.push($scope.currentOrgGroup);
      addGroupBreadcrumb(breadcrumbGroups, function (completeList) {
        completeList.reverse();
        $scope.groupBreadcrumbs = completeList;
      });
    } else {
      $scope.groupBreadcrumbs = [];
    }
  };

  $scope.generateGroupsBreadcrumb();

  $scope.openNotificationsSlider = function () {
    $(".notificationsSlideOuterContainer").css({ 'display': 'block' });
    $(".notificationsSlideUnderlay").fadeIn(200);
    $(".notificationsSlideOuterContainer").animate({
      'right': '0px'
    }, 200);
  };

  $scope.closeNotificationsSlider = function () {
    $(".notificationsSlideUnderlay").fadeOut(200);
    $(".notificationsSlideOuterContainer").animate({
      'right': '-300px'
    }, 200, function () {
      $(".notificationsSlideOuterContainer").css({ 'display': 'none' });
    });
  };

  /* Notifications Summary Controls */

  $scope.resetNotificationsSummary = function () {
    $scope.notificationsSummary = {};
    $scope.notificationsSummary.loading = true;
    $scope.notificationsSummary.notifications = [];
  };

  $scope.resetNotificationsSummary();

  $scope.getUserNotifications = function () {
    var notifications = [];

    /**** Contact Share Messages ****/
    addressBookService.getUserContactShares(null, function (contactSharesList) {
      $scope.injectContactShareNotifications(contactSharesList, notifications, function () {
        $scope.notificationsSummary.loading = false;
        $scope.notificationsSummary.notifications = notifications;
      });
    });
  };

  $scope.getUserNotifications();

  $scope.injectContactShareNotifications = function (contactSharesList, notificationsList, cb) {
    for (var i = 0; i < contactSharesList.length; i++) {
      var contactShare = contactSharesList[i];
      var newNotification = { type: 'contactShare' };
      newNotification.title = contactShare.senderName + ' sent you the contact information for ' + contactShare.displayName;
      newNotification.dateTime = "";
      newNotification.contactShare = contactShare;
      newNotification.id = uuid.v4();
      notificationsList.push(newNotification);
    }

    cb();
  };

  $scope.viewNotificationMessage = function (notification) {
    $scope.message = {};
    $scope.message.title = notification.title;
    $scope.message.dateTime = notification.dateTime;
    $scope.message.type = notification.type;

    if (notification.type == 'contactShare') {
      var initials = "";
      if (notification.contactShare.displayName) {
        var split = notification.contactShare.displayName.split(' ');
        if (split.length == 1) {
          initials = split[0].charAt(0).toUpperCase();
        } else if (split.length > 1) {
          initials = split[0].charAt(0).toUpperCase();
          initials += split[1].charAt(0).toUpperCase();
        }
      }
      if (notification.contactShare.comment) {
        $scope.message.body = notification.contactShare.comment.replace(/\n/g, '<br/>');
      }
      $scope.message.contactShare = notification.contactShare;
      $scope.message.contactShare.initials = initials;
    }

    $("#viewMessageModal").fadeIn(100);
    $("#viewMessageModal .modalContainer").draggable();
  };

  $scope.closeViewMessageModal = function () {
    $("#viewMessageModal").fadeOut(100);
  };

  $scope.closeNotification = function (notification) {
    $("#" + notification.id).fadeOut(200, function () {
      if (notification.type == 'contactShare') {
        addressBookService.deleteContactShare(notification.contactShare.id, function (success) {
          for (var i = 0; i < $scope.notificationsSummary.notifications.length; i++) {
            if ($scope.notificationsSummary.notifications[i].id == notification.id) {
              $scope.notificationsSummary.notifications.splice(i, 1);
              break;
            }
          }
        });
      }
    });
  };

  $scope.addContactShareToExisting = function (contactShare) {
    $("#viewMessageModal").fadeOut(100);
    if ($scope.currentOrg != null) {
      $scope.updateContactFromParent(null, null, contactShare, function (contactSelected) {});
    } else {
      $scope.selectOrganisationUnit(function (orgUnit) {
        $scope.updateContactFromParent(orgUnit.organisation, orgUnit.id, contactShare, function (contactSelected) {});
      });
    }
  };

  $scope.newContactFromShare = function (contactShare) {
    $("#viewMessageModal").fadeOut(100);
    if ($scope.currentOrg != null) {
      $scope.createContactFromParent(null, null, contactShare, function (contactSelected) {});
    } else {
      $scope.selectOrganisationUnit(function (orgUnit) {
        if (orgUnit != null) {
          $scope.createContactFromParent(orgUnit.organisation, orgUnit.id, contactShare, function (contactSelected) {});
        }
      });
    }
  };

  $scope.selectOrganisationUnit = function (cb) {
    $("#selectOrgUnitModal").fadeIn(100);
    $scope.orgUnitList = [];
    $scope.orgUnitSelected = [];
    var organisations = accessControl.allowedOrganisations();
    for (var i = 0; i < organisations.length; i++) {
      for (var j = 0; j < organisations[i].groups.length; j++) {
        $scope.orgUnitList.push(organisations[i].groups[j]);
      }
    }
    $scope.selectOrgUnitCallback = cb;
  };

  $scope.closeOrgUnitSelectList = function () {
    $("#selectOrgUnitModal").fadeOut(100);
    $scope.selectOrgUnitCallback(null);
  };

  $scope.orgUnitSelectContinue = function () {
    $("#selectOrgUnitModal").fadeOut(100);
    $scope.selectOrgUnitCallback($scope.orgUnitSelected[0]);
  };

  /***** New Group Modal ******/
  $scope.newOrgGroup = function () {
    /*mixpanel.track("Clicked Create New Org Group");
     if ($scope.currentOrg.groups.length >= $scope.currentOrg.planFeatures.includedOrganisationGroups) {
       return;
    }
    $("#newGroupModal").fadeIn(100);
    $scope.newGroup = {};
    $scope.newGroup.timezone = $scope.currentOrgGroup.timezone;
    $scope.createNewGroupFromParent($scope.currentOrgGroup, function(newGroupCreated) {
      if ( newGroupCreated != null ) {
        mixpanel.track("Created New Org Group");
        accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
          $scope.allOrganisations = orgsList;
          $state.go('main.groupDashboard', {orgId: $scope.currentOrg.id, groupId: newGroupCreated.id});
        });
      } else {
        mixpanel.track("Abandoned New Org Group");
      }
    });*/

    $state.go('companySettings.groups', { orgId: $scope.currentOrg.id });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "8bVM":
/***/ (function(module, exports) {

var path = 'views/filterBars/docketsFilterBar.html';
var html = "<div class=\"secondaryHeader\">\n  <div class=\"contentHeadingNavBar filterTabs\">\n    <div class=\"filterTabsContainer\">\n      <div class=\"filterSelectors\">\n        <div class=\"filterSelector\">\n          <h3>Date:</h3>\n          <div class=\"filterDropdown clear\">\n            <md-date-range show-template=\"true\" ng-model=\"dateFilterModel\" custom-templates=\"customTemplate\"></md-date-range>\n          </div>\n        </div>\n        <div class=\"filterSelector\">\n          <h3>Status:</h3>\n          <md-menu>\n            <div class=\"filterDropdown\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              {{prettifyFilterStatusPreview()}}\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" class=\"allSelector\" ng-click=\"swapStatusFilter('all')\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"all\" ng-model=\"filters.statusOptions.allView\">Select All\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"draft\" ng-model=\"filters.statusOptions.draft\" ng-change=\"statusFilterCheckboxChanged()\">Draft\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('draft')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"sent\" ng-model=\"filters.statusOptions.sent\" ng-change=\"statusFilterCheckboxChanged()\">Sent\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('sent')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"accepted\" ng-model=\"filters.statusOptions.accepted\" ng-change=\"statusFilterCheckboxChanged()\">Accepted\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('accepted')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"rejected\" ng-model=\"filters.statusOptions.rejected\" ng-change=\"statusFilterCheckboxChanged()\">Rejected\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('rejected')\">Only</div>\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.customerSignatureOptions.display\">\n          <h3>Customer Signature:</h3>\n          <md-menu>\n            <div class=\"filterDropdown\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              {{prettifyFilterCustomerSignaturePreview()}}\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" class=\"allSelector\" ng-click=\"swapCustomerSignatureFilter('all')\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"all\" ng-model=\"filters.customerSignatureOptions.allView\">Select All\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"signed\" ng-model=\"filters.customerSignatureOptions.signed\" ng-change=\"customerSignatureFilterCheckboxChanged()\">Signed\n                  <div class=\"filterOnlyButton\" ng-click=\"setCustomerSignatureOnlyFilter('signed')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"sent\" ng-model=\"filters.customerSignatureOptions.unsigned\" ng-change=\"customerSignatureFilterCheckboxChanged()\">Unsigned\n                  <div class=\"filterOnlyButton\" ng-click=\"setCustomerSignatureOnlyFilter('unsigned')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\" ng-click=\"hideCustomerSignatureFilter()\" style=\"cursor:pointer;\">\n                  Hide Filter\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.filedOptions.display\">\n          <h3>Filed Status:</h3>\n          <md-menu>\n            <div class=\"filterDropdown\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              {{prettifyFilterFiledPreview()}}\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" class=\"allSelector\" ng-click=\"swapFiledFilter('all')\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"all\" ng-model=\"filters.filedOptions.allView\">Select All\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"filed\" ng-model=\"filters.filedOptions.filed\" ng-change=\"filedFilterCheckboxChanged()\">Filed\n                  <div class=\"filterOnlyButton\" ng-click=\"setFiledOnlyFilter('filed')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"unfiled\" ng-model=\"filters.filedOptions.unfiled\" ng-change=\"filedFilterCheckboxChanged()\">Unfiled\n                  <div class=\"filterOnlyButton\" ng-click=\"setFiledOnlyFilter('unfiled')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\" ng-click=\"hideFiledFilter()\" style=\"cursor:pointer;\">\n                  Hide Filter\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && filters.invoicedStatusOptions.display  && currentOrg.planFeatures.accountingIntegrationEnabled\">\n          <h3>Invoiced Status:</h3>\n          <md-menu>\n            <div class=\"filterDropdown\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              {{prettifyInvoicedFilterStatusPreview()}}\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" class=\"allSelector\" ng-click=\"swapInvoicedStatusFilter('all')\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"all\" ng-model=\"filters.invoicedStatusOptions.allView\">Select All\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"invoiced\" ng-model=\"filters.invoicedStatusOptions.invoiced\" ng-change=\"invoicedStatusFilterCheckboxChanged()\">Invoiced\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyInvoicedFilter('invoiced')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\">\n                  <input type=\"checkbox\" name=\"uninvoiced\" ng-model=\"filters.invoicedStatusOptions.uninvoiced\" ng-change=\"invoicedStatusFilterCheckboxChanged()\">Uninvoiced\n                  <div class=\"filterOnlyButton\" ng-click=\"setOnlyInvoicedFilter('uninvoiced')\">Only</div>\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\">\n                <div class=\"filterDropdownCheckboxItem\" ng-click=\"hideInvoicedFilter()\" style=\"cursor:pointer;\">\n                  Hide Filter\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.customerContact\">\n          <h3>Customer:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <span ng-click=\"selectContactFilter('customer')\">{{filters.customerContact.displayName}}</span>\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('customerContact')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.supplierContact\">\n          <h3>Supplier:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <span ng-click=\"selectContactFilter('supplier')\">{{filters.supplierContact.displayName}}</span>\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('supplierContact')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.order\">\n          <h3>Order:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <span ng-click=\"selectOrderFilter\">{{filters.order.orderNumber}}</span>\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('order')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.job\">\n          <h3>Job:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <span ng-click=\"selectJobFilter\">{{filters.job.jobNumber}}</span>\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('job')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.author\">\n          <h3>Operator:<h3/>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.author\" aria-label=\"Docket Author Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('author')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('author')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.docketNumber\">\n          <h3>Docket Number:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.docketNumber\" aria-label=\"Docket Number Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('docketNumber')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('docketNumber')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.customerRefNo\">\n          <h3>Customer Ref No:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.customerRefNo\" aria-label=\"Customer Ref No Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('customerRefNo')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('customerRefNo')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.supplierRefNo\">\n          <h3>Supplier Ref No:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.supplierRefNo\" aria-label=\"Supplier Ref No Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('supplierRefNo')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('supplierRefNo')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.customerDisplayName\">\n          <h3>Customer Name:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.customerDisplayName\" aria-label=\"Customer Name Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('customerDisplayName')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('customerDisplayName')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.supplierDisplayName\">\n          <h3>Supplier Name:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.supplierDisplayName\" aria-label=\"Supplier Name Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('supplierDisplayName')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('supplierDisplayName')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.customerSignatureName\">\n          <h3>Signed By:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.customerSignatureName\" aria-label=\"Customer Signature Name Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('customerSignatureName')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('customerSignatureName')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"filterSelector\" ng-if=\"filters.acceptedBy\">\n          <h3>Accepted By:</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"filters.acceptedBy\" aria-label=\"Accepted By Name Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged('acceptedBy')\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('acceptedBy')\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n\n\n        <div class=\"filterSelector\" ng-repeat=\"customFilter in filters.custom\" ng-if=\"customFilter.display\">\n          <h3>{{customFilter.prettyName}}</h3>\n          <div class=\"filterDropdown withClearButton\">\n            <input type=\"text\" ng-model=\"customFilter.value\" aria-label=\"{{customFilter.prettyName}} Filter\" ng-model-options=\"{debounce:500}\" ng-change=\"filtersChanged(customFilter.fieldName)\">\n            <md-button class=\"md-icon-button selector\" ng-click=\"clearCustomFilterItem(customFilter)\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n\n\n        <div class=\"filterSelector\">\n          <md-menu>\n            <div class=\"filterDropdown addFilter\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n              Add A Filter\n            </div>\n            <md-menu-content width=\"4\">\n              <md-menu-item aria-label=\"\" ng-click=\"selectContactFilter('customer')\" ng-if=\"!filters.customerContact\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Customer List Select\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.customerDisplayName = ' '\" ng-if=\"!filters.customerDisplayName\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Customer Name Search\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"selectContactFilter('supplier')\" ng-if=\"!filters.supplierContact\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Supplier List Select\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.supplierDisplayName = ' '\" ng-if=\"!filters.supplierDisplayName\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Supplier Name Search\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"selectOrderFilter()\" ng-if=\"!filters.order\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Order\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"selectJobFilter()\" ng-if=\"!filters.job\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Job\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.author = ' '\" ng-if=\"!filters.author\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Operator\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.docketNumber = ' '\" ng-if=\"!filters.docketNumber\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Docket Number\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.customerRefNo = ' '\" ng-if=\"!filters.customerRefNo\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Customer Ref No\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.supplierRefNo = ' '\" ng-if=\"!filters.supplierRefNo\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Supplier Ref No\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.customerSignatureOptions.display = true\" ng-if=\"filters.customerSignatureOptions.display != true\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Customer Signature\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.customerSignatureName = ' '\" ng-if=\"!filters.customerSignatureName\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Signed By\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.filedOptions.display = true\" ng-if=\"filters.filedOptions.display != true\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Filed Status\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.acceptedBy = ' '\" ng-if=\"!filters.acceptedBy\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Accepted By\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-click=\"filters.invoicedStatusOptions.display = true\" ng-if=\"filters.invoicedStatusOptions.display != true && currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Invoiced Status\n                </div>\n              </md-menu-item>\n              <md-menu-item aria-label=\"\" ng-repeat=\"customFilter in filters.custom\" ng-click=\"customFilter.display = true\" ng-if=\"!customFilter.display\">\n                <div class=\"filterDropdownCheckboxItem button\">\n                  <md-icon md-svg-icon=\"text-field.svg\"></md-icon>{{customFilter.prettyName}}\n                </div>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n        <div class=\"filterSelector\">\n          <div class=\"filterDropdown addFilter\" ng-click=\"clearFilters()\">\n            Clear all filters\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "8mt0":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/generalTab.html';
var html = "<div class=\"ojdDesktopSection header {{itemEdit.status}}\">\n\t<div class=\"headerTitle\" ng-if=\"itemEdit.status\">\n\t\t<h2>Status</h2>\n\t\t<h1>{{itemEdit.status}}</h1>\n\t</div>\n\n\t<!--<div class=\"bulkActionsButtons\">\n\t\t<div class=\"dbButton\" ng-click=\"editDocket(itemEdit)\"\n\t\t\tng-if=\"userCanDoAction('editDocket', itemEdit) && !itemEdit.loading\">\n\t\t\tEdit\n\t\t</div>\n\t\t<div class=\"dbButton\" ng-click=\"reDraftDocket(itemEdit)\"\n\t\t\tng-if=\"userCanDoAction('reDraftDocket', itemEdit) && !itemEdit.loading\">\n\t\t\tEdit\n\t\t</div>\n\t\t<div class=\"dbButton grey rightMargin\" ng-if=\"itemEdit.editing\" ng-click=\"cancelEditDocket(itemEdit)\">\n\t\t\tCancel\n\t\t</div>\n\t\t<div class=\"dbButton\" ng-click=\"saveDocket(itemEdit)\"\n\t\t\tng-if=\"userCanDoAction('saveDocket', itemEdit) && !itemEdit.loading\">\n\t\t\tSave\n\t\t</div>\n\t</div>-->\n</div>\n<div class=\"ojdDesktopSection pleaseSignPart\"\n\tng-show=\"userCanDoAction('captureCustomerSignatureFromCustomer', itemEdit) && !itemEdit.customerSignatureAttachment && !itemEdit.customerSignatureImage && docketIsSignable()\">\n\t<h2>Please sign this docket from {{itemEdit.supplierContact.displayName}}</h2>\n\t<div class=\"dbButton signDocketButton\" ng-click=\"captureCustomerSignatureFromCustomer()\">\n\t\tSign Docket\n\t</div>\n</div>\n<div class=\"ojdDesktopSection\" style=\"text-align:center;\"\n\tng-if=\"!(userCanDoAction('captureCustomerSignatureFromCustomer', itemEdit) && !itemEdit.customerSignatureAttachment && !itemEdit.customerSignatureImage) && !isPreAuthDocket && itemEdit && !itemEdit.assigned && currentOrg == null && !itemEdit.editing\">\n\tThis docket is not assigned to an organisation.\n\t<br/>\n\t<div class=\"dbButton lightBlue margin-top\" ng-click=\"assignDocketOrg(itemEdit)\">Select Organisation</div>\n</div>\n<div class=\"ojdDesktopMainSections\">\n\t<!-- Start Summary Section -->\n\t<div class=\"ojdDesktopSection\">\n\t\t<div class=\"ojdDesktopRow\" ng-if=\"!isPreAuthDocket\">\n\t\t\t<div class=\"ojdDesktopField\"\n\t\t\t\tng-if=\"userHasPermission('io.docketbook.ojdapi.getOrder') || (itemEdit.orderRef && itemEdit.orderRef.orderNumber)\"\n\t\t\t\tng-click=\"!userCanDoAction('changeDocketOrder', itemEdit) || selectOrder()\">\n\t\t\t\t<label class=\"order\">Order</label>\n\t\t\t\t<a ui-sref=\"main.groupOrderDetail({orderId: itemEdit.orderRef.id,orgId:currentOrg.id, groupId:currentOrgGroup.id})\"\n\t\t\t\t\tng-if=\"itemEdit.orderRef && !itemEdit.editing && currentOrg != null\">\n\t\t\t\t\t<h2>{{itemEdit.orderRef.orderNumber !== null && itemEdit.orderRef.orderNumber.length > 0 ? itemEdit.orderRef.orderNumber : \"Pending\" }}\n\t\t\t\t\t</h2>\n\t\t\t\t</a>\n\t\t\t\t<h2 ng-if=\"currentOrg == null && itemEdit.orderRef && !itemEdit.editing\">\n\t\t\t\t\t{{itemEdit.orderRef.orderNumber}}</h2>\n\t\t\t\t<h2 ng-if=\"itemEdit.orderRef && itemEdit.editing\">{{itemEdit.orderRef.orderNumber}}</h2>\n\t\t\t\t<h2 ng-if=\"!itemEdit.orderRef\">Not Selected</h2>\n\t\t\t\t<h3 ng-if=\"userCanDoAction('changeDocketOrder', itemEdit)\">Click to change order</h3>\n\t\t\t</div>\n\t\t\t<div class=\"ojdDesktopField\"\n\t\t\t\tng-show=\"userHasPermission('io.docketbook.ojdapi.getJob') || ( itemEdit.jobRef && itemEdit.jobRef.jobNumber )\">\n\t\t\t\t<label class=\"order\">Job</label>\n\t\t\t\t<a ui-sref=\"main.groupJobDetail({jobId: itemEdit.jobRef.id, orgId: currentOrg.id, groupId: currentOrgGroup.id})\"\n\t\t\t\t\tng-if=\"itemEdit.jobRef && !itemEdit.editing && currentOrg != null\">\n\t\t\t\t\t<h2>{{itemEdit.jobRef.jobNumber}}</h2>\n\t\t\t\t</a>\n\t\t\t\t<a ui-sref=\"main.jobDetail({jobId: itemEdit.jobRef.id})\"\n\t\t\t\t\tng-if=\"itemEdit.jobRef && !itemEdit.editing && currentOrg == null\">\n\t\t\t\t\t<h2>{{itemEdit.jobRef.jobNumber}}</h2>\n\t\t\t\t</a>\n\t\t\t\t<h2 ng-if=\"itemEdit.jobRef && itemEdit.editing\">{{itemEdit.jobRef.jobNumber}}</h2>\n\t\t\t\t<h2 ng-if=\"!itemEdit.jobRef\">Not Selected</h2>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"ojdDesktopRow\" ng-if=\"itemEdit.supplierContact || itemEdit.customerContact\">\n\t\t\t<div class=\"ojdDesktopField\" ng-show=\"itemEdit.supplierContact\">\n\t\t\t\t<label class=\"order\">Supplier</label>\n\t\t\t\t<h2 ng-if=\"itemEdit.supplierContact\">{{itemEdit.supplierContact.displayName}}</h2>\n\t\t\t\t<h3 ng-if=\"itemEdit.supplierContact.addresses\">\n\t\t\t\t\t{{stringifyAddress(itemEdit.supplierContact.addresses[0])}}</h3>\n\t\t\t</div>\n\t\t\t<div class=\"ojdDesktopField\"\n\t\t\t\tng-click=\"!userCanDoAction('changeDocketCustomer', itemEdit) || selectCompany('customerContact')\">\n\t\t\t\t<label class=\"order\">Customer</label>\n\t\t\t\t<h2 ng-if=\"itemEdit.customerContact\">{{itemEdit.customerContact.displayName}}</h2>\n\t\t\t\t<h2 ng-if=\"!itemEdit.customerContact\">Not Selected</h2>\n\t\t\t\t<h3 ng-if=\"itemEdit.customerContact.addresses\">\n\t\t\t\t\t{{stringifyAddress(itemEdit.customerContact.addresses[0])}}</h3>\n\t\t\t\t<h3 ng-if=\"userCanDoAction('changeDocketCustomer', itemEdit)\">Click to select customer</h3>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"ojdDesktopRow\"\n\t\t\tng-if=\"itemEdit.template && itemEdit.template.additionalContactNames && itemEdit.template.additionalContactNames.length > 0\">\n\t\t\t<div class=\"ojdDesktopField\" ng-repeat=\"contact in itemEdit.template.additionalContactNames\"\n\t\t\t\tng-click=\"selectCompany(contact.contactName)\">\n\t\t\t\t<label class=\"order\">{{contact.contactName}}</label>\n\t\t\t\t<h2 ng-if=\"additionalContactMatch(contact.contactName)\">\n\t\t\t\t\t{{additionalContactMatch(contact.contactName).displayName}}\n\t\t\t\t</h2>\n\t\t\t\t<h2 ng-if=\"!(additionalContactMatch(contact.contactName))\">Not\n\t\t\t\t\tSelected</h2>\n\t\t\t\t<h3\n\t\t\t\t\tng-if=\"userCanDoAction('changeDocketCustomer', itemEdit) && !(additionalContactMatch(contact.contactName))\">\n\t\t\t\t\tClick to select\n\t\t\t\t\tcontact\n\t\t\t\t</h3>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"ojdDesktopRow\">\n\t\t\t<div class=\"ojdDesktopField\" ng-show=\"itemEdit.supplierRefNo && !itemEdit.xeroQuote\">\n\t\t\t\t<label class=\"order\">Supplier Ref No</label>\n\t\t\t\t<h2>{{itemEdit.supplierRefNo}}</h2>\n\t\t\t</div>\n\t\t\t<div class=\"ojdDesktopField\" ng-if=\"itemEdit.xeroQuote\">\n\t\t\t\t<label class=\"order\">Xero Quote</label>\n\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm>\n\t\t\t\t\t<div ng-if=\"itemEdit.xeroQuoteFull\">\n\t\t\t\t\t\t<div class=\"xeroAvatar\"></div><a target=\"_blank\"\n\t\t\t\t\t\t\thref=\"https://go.xero.com/organisationlogin/default.aspx?shortcode={{currentOrg.features.xero.shortCode}}&redirecturl=/Accounts/Receivable/Quotes/Edit/{{itemEdit.xeroQuoteFull.quoteID}}\">{{itemEdit.xeroQuoteFull.quoteNumber}}\n\t\t\t\t\t\t\t({{itemEdit.xeroQuoteFull.status}})</a>\n\t\t\t\t\t</div>\n\t\t\t\t</md-input-container>\n\t\t\t</div>\n\t\t\t<div class=\"ojdDesktopField\" ng-show=\"itemEdit.customerRefNo\">\n\t\t\t\t<label class=\"order\">Customer Ref No</label>\n\t\t\t\t<h2>{{itemEdit.customerRefNo}}</h2>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"ojdDesktopRow\" ng-if=\"itemEdit.rejectionComment && itemEdit.status == 'Rejected'\">\n\t\t\t<div class=\"ojdDesktopField\">\n\t\t\t\t<label class=\"order\">Rejection Comment</label>\n\t\t\t\t<h2>{{itemEdit.rejectionComment}}</h2>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"ojdDesktopRow\">\n\t\t\t<div class=\"ojdDesktopField\">\n\t\t\t\t<label class=\"order\">Date</label>\n\t\t\t\t<md-input-container class=\"md-block datepicker\" flex-gt-sm>\n\t\t\t\t\t<md-datepicker ng-model=\"itemEdit.date\" name=\"date\" ng-disabled=\"!itemEdit.editing\"\n\t\t\t\t\t\taria-label=\"Docket Date\"></md-datepicker>\n\t\t\t\t</md-input-container>\n\t\t\t</div>\n\n\t\t\t<div class=\"ojdDesktopField\">\n\t\t\t\t<label class=\"order\">Operator</label>\n\t\t\t\t<h2>{{itemEdit.authorName}}</h2>\n\t\t\t</div>\n\n\t\t\t<div class=\"ojdDesktopField\"\n\t\t\t\tng-click=\"!userCanDoAction('changeDocketTemplate', itemEdit) || selectDocketTemplate()\">\n\t\t\t\t<label class=\"order\">Docket Template</label>\n\t\t\t\t<h2 ng-if=\"itemEdit.template\">{{itemEdit.template.name}}</h2>\n\t\t\t\t<h2 ng-if=\"!itemEdit.template\">Not Selected</h2>\n\t\t\t\t<h3 ng-if=\"userCanDoAction('changeDocketTemplate', itemEdit)\">Click to change template</h3>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<!-- End Summary Section -->\n\n\t<span class=\"repeatingOJDSection\" ng-repeat=\"block in itemEdit.template.blocks\" ng-if=\"block.type != 'checklists' || (block.type == 'checklists' && itemEdit.template.checklistContainers && itemEdit.template.checklistContainers.length > 0)\">\n    <!-- Time Section -->\n    <div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'time'\">\n      <div class=\"sectionHeadingContainer\">\n        <div class=\"sectionHeadingLeft\">\n          <h1 class=\"sectionHeading\">Time</h1>\n        </div>\n        <div class=\"sectionHeadingRight\">\n\t\t\t\t\t<h4 style=\"font-size:12px;\">(Timezone {{itemEdit.timezone}})</h4>\n        </div>\n      </div>\n\n      <div class=\"ojdDesktopPaddingOuter\">\n        <div class=\"ojdDesktopRow\">\n          <div class=\"ojdDesktopField\">\n            <label class=\"order\">Start Time</label>\n            <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"itemEdit.editing\">\n              <mdp-time-picker ng-model=\"itemEdit.startTime\" mdp-timezone=\"{{itemEdit.timezone}}\" mdp-auto-switch=\"true\" ng-disabled=\"!itemEdit.editing\" ng-show=\"itemEdit.editing || (!itemEdit.editing && currentOrgGroup.timeFormat == '12HR')\" aria-label=\"Start Time\" ng-change=\"getDocketTotalTime(itemEdit)\"></mdp-time-picker>\n              <mdp-time-picker ng-model=\"itemEdit.startTime\" mdp-timezone=\"{{itemEdit.timezone}}\" mdp-auto-switch=\"true\" ng-disabled=\"!itemEdit.editing\" ng-show=\"!itemEdit.editing && currentOrgGroup.timeFormat == '24HR'\" aria-label=\"Start Time\" ng-change=\"getDocketTotalTime(itemEdit)\" mdp-format=\"HH:mm\"></mdp-time-picker>\n            </md-input-container>\n\t\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"!itemEdit.editing\">\n\t\t\t\t\t\t\t<span ng-if=\"currentOrgGroup.timeFormat == '12HR' && itemEdit.startTime\">{{moment(itemEdit.startTime).tz(itemEdit.timezone).format('hh:mm A')}}</span>\n\t\t\t\t\t\t\t<span ng-if=\"currentOrgGroup.timeFormat == '24HR' && itemEdit.startTime\">{{moment(itemEdit.startTime).tz(itemEdit.timezone).format('HH:mm')}}</span>\n\t\t\t\t\t\t\t<span ng-if=\"!itemEdit.startTime\">Not Entered</span>\n\t\t\t\t\t\t</md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\">\n            <label class=\"order\">End Time</label>\n            <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"itemEdit.editing\">\n              <mdp-time-picker ng-model=\"itemEdit.endTime\"  mdp-timezone=\"{{itemEdit.timezone}}\" mdp-auto-switch=\"true\" ng-disabled=\"!itemEdit.editing\" ng-show=\"itemEdit.editing || (!itemEdit.editing && currentOrgGroup.timeFormat == '12HR')\" aria-label=\"End Time\" ng-change=\"getDocketTotalTime(itemEdit)\"></mdp-time-picker>\n              <mdp-time-picker ng-model=\"itemEdit.endTime\"  mdp-timezone=\"{{itemEdit.timezone}}\" mdp-auto-switch=\"true\" ng-disabled=\"!itemEdit.editing\" ng-show=\"!itemEdit.editing && currentOrgGroup.timeFormat == '24HR'\" aria-label=\"End Time\" ng-change=\"getDocketTotalTime(itemEdit)\" mdp-format=\"HH:mm\"></mdp-time-picker>\n            </md-input-container>\n\t\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"!itemEdit.editing\">\n\t\t\t\t\t\t\t<span ng-if=\"currentOrgGroup.timeFormat == '12HR' && itemEdit.endTime\">{{moment(itemEdit.endTime).tz(itemEdit.timezone).format('hh:mm A')}}</span>\n\t\t\t\t\t\t\t<span ng-if=\"currentOrgGroup.timeFormat == '24HR' && itemEdit.endTime\">{{moment(itemEdit.endTime).tz(itemEdit.timezone).format('HH:mm')}}</span>\n\t\t\t\t\t\t\t<span ng-if=\"!itemEdit.endTime\">Not Entered</span>\n\t\t\t\t\t\t</md-input-container>\n          </div>\n        </div>\n        <div class=\"ojdDesktopRow\">\n          <div class=\"ojdDesktopField\" ng-click=\"itemEditClosed(itemEdit) || selectBreakTime(itemEdit, 'breakTime')\">\n            <label class=\"order\">Break Time (minutes)</label>\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <input type=\"text\" ng-model=\"itemEdit.breakTime\" ng-disabled=\"!itemEdit.editing\" aria-label=\"Break Time\" ng-change=\"getDocketTotalTime(itemEdit)\">\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-click=\"itemEditClosed(itemEdit) || selectBreakTime(itemEdit, 'travelTime')\">\n            <label class=\"order\">Travel Time (minutes)</label>\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <input type=\"text\" ng-model=\"itemEdit.travelTime\" ng-disabled=\"!itemEdit.editing\" aria-label=\"Travel Time\" ng-change=\"getDocketTotalTime(itemEdit)\">\n            </md-input-container>\n          </div>\n        </div>\n        <div class=\"ojdDesktopRow\">\n          <div class=\"ojdDesktopField\">\n            <label class=\"order\">Total Time (calculated):</label>\n            <h2>{{itemEdit.totalTime}}</h2>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- End Time Section -->\n\n    <!-- Start Items Section -->\n    <div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'resources'\">\n      <div class=\"sectionHeadingContainer\">\n        <div class=\"sectionHeadingLeft\">\n          <h1 class=\"sectionHeading\">Items</h1>\n        </div>\n        <div class=\"sectionHeadingRight\">\n          <md-button class=\"md-icon-button\" ng-disabled=\"!userCanDoAction('addDocketResource', itemEdit)\" ng-click=\"addResource()\" aria-label=\"Add Item To Docket\">\n            <md-icon md-svg-src=\"add.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n\n      <p ng-if=\"itemEdit.resources == null || itemEdit.resources.length <= 0\">\n        There are no items on this docket\n      </p>\n\n\t\t\t<md-table-container class=\"docketResourceTable\" ng-show=\"itemEdit.resources != null && itemEdit.resources.length > 0\">\n\t\t\t\t<table md-table multiple>\n\t\t\t\t\t<thead md-head>\n\t\t\t\t\t\t<tr md-row>\n\t\t\t\t\t\t\t<th md-column>Resource / Line</th>\n\t\t\t\t\t\t\t<th md-column>QTY</th>\n\t\t\t\t\t\t\t<th md-column>Additional Fields</th>\n\t\t\t\t\t\t\t<!--<th md-column>Timestamp</th>-->\n\t\t\t\t\t\t\t<th md-column ng-if=\"xeroDisplayUnitPrices()\">Unit Price</th>\n\t\t\t\t\t\t\t<th md-column ng-if=\"xeroDisplayUnitPrices()\">Total $</th>\n\t\t\t\t\t\t\t<th md-column ng-if=\"itemEdit.orderRef && showLineResyncing\">Order Line</th>\n\t\t\t\t\t\t\t<th md-column ng-if=\"!(itemEdit.orderRef && showLineResyncing)\">Timestamp</th>\n\t\t\t\t\t\t\t<th md-column></th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody md-body ng-repeat=\"resource in itemEdit.resources\">\n\t\t\t\t\t\t<tr md-row ng-show=\"!resource.delete\" class=\"resourceRow\">\n\t\t\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t\t\t{{resource.resource.name}} ({{resource.resource.identifier}})<span ng-if=\"itemEdit.orderRef\"> - {{resource.description}}</span>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t\t\t<span ng-if=\"resource.resource.uom.isTime\">\n\t\t\t\t\t\t\t\t\t{{formatTimeQuantity(getResourceQtySummary(resource), resource.resource.uom.abbreviation)}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if=\"!resource.resource.uom.isTime\">\n\t\t\t\t\t\t\t\t\t{{getResourceQtySummary(resource)}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t<td md-cell></td>\n\t\t\t\t\t\t\t<!--colspan was 2 before timestamp column removed-->\n\t\t\t\t\t\t\t<td md-cell ng-if=\"xeroDisplayUnitPrices()\">\n\t\t\t\t\t\t\t\t<span ng-if=\"resource.xeroQuoteLineItem\">\n\t\t\t\t\t\t\t\t\t${{resource.xeroQuoteLineItem.unitAmount}} (Quote)\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<span ng-if=\"resource.xeroLineItem\">\n\t\t\t\t\t\t\t\t\t${{resource.xeroLineItem.salesDetails.unitPrice}} (Default)\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t<td md-cell ng-if=\"xeroDisplayUnitPrices()\">\n\t\t\t\t\t\t\t\t${{calculateResourceXeroTotalPrice(resource)}}\n\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t<td md-cell ng-if=\"itemEdit.orderRef && showLineResyncing\">\n\t\t\t\t\t\t<span ng-if=\"resource.orderItemId\">\n\t\t\t\t\t\t\t<span ng-if=\"resource.description\"><div class=\"lineOkIcon\"></div><div class=\"iconText\">{{resource.description}}</div></span>\n\t\t\t\t\t\t\t<span ng-if=\"!resource.description\"><div class=\"lineOkIcon\"></div><div class=\"iconText\"></div></span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if=\"!resource.orderItemId\">\n\t\t\t\t\t\t\t<div class=\"lineWarningIcon\"></div><div class=\"iconText\"></div>\n\t\t\t\t\t\t\t<md-button class=\"linkButton\" ng-click=\"linkOrderLineForResource(resource)\" ng-if=\"(itemEdit.status == 'Draft' || itemEdit.status == 'Sent' || itemEdit.status == 'Accepted')\">Link</md-button>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell ng-if=\"!(itemEdit.orderRef && showLineResyncing)\">\n\n\t\t\t\t\t</td>\n\t\t\t\t\t<!--<td md-cell ng-if=\"!itemEdit.editing\">\n\n\t\t\t\t\t</td>-->\n\t\t\t\t\t<td md-cell ng-if=\"!itemEdit.editing\"></td>\n\t\t\t\t\t<td md-cell ng-if=\"itemEdit.editing\">\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" aria-label=\"Add Item Line\" ng-click=\"addInteractionToResource(resource)\"\n\t\t\t\t\t\tng-show=\"itemEdit.editing\" aria-label=\"Add Item Line\">\n\t\t\t\t\t\t<md-icon md-svg-src=\"add.svg\"></md-icon>\n\t\t\t\t\t</md-button>\n\t\t\t\t\t<md-button class=\"md-icon-button\" aria-label=\"Remove Item\"\n\t\t\t\t\tng-click=\"removeResourceFromDocket(resource, itemEdit)\" ng-show=\"itemEdit.editing\" aria-label=\"Remove Item\">\n\t\t\t\t\t<md-icon md-svg-src=\"delete.svg\"></md-icon>\n\t\t\t\t\t</md-button>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr md-row ng-repeat=\"interaction in resource.interactions\" class=\"interactionRow\" ng-show=\"!resource.delete\">\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t{{interaction.interactionName}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<span ng-if=\"!interaction.interactionTemplate.xeroQuantity\">\n\t\t\t\t\t\t\t<span ng-show=\"interaction.resource.uom.isTime\">{{formatTimeQuantity(interaction.quantity, interaction.resource.uom.abbreviation)}}</span>\n\t\t\t\t\t\t\t<span ng-show=\"!interaction.resource.uom.isTime\">{{interaction.quantity}}</span>\n\t\t\t\t\t\t\t<span ng-show=\"!interaction.resource.uom.isTime\"> {{interaction.resource.uom.abbreviation}}</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<span ng-if=\"interaction.interactionTemplate.fields.length > 0\">Yes</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell ng-if=\"xeroDisplayUnitPrices()\"></td>\n\t\t\t\t\t<td md-cell ng-if=\"xeroDisplayUnitPrices()\"></td>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<span ng-if=\"currentOrgGroup.timeFormat == '12HR'\">\n\t\t\t\t\t\t\t{{moment(interaction.createdAt).tz(itemEdit.timezone).format('hh:mm a')}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-if=\"currentOrgGroup.timeFormat == '24HR'\">\n\t\t\t\t\t\t\t{{moment(interaction.createdAt).tz(itemEdit.timezone).format('HH:mm')}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\n\n\t\t\t\t\t<td md-cell ng-if=\"!itemEdit.editing\">\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"editInteraction(interaction)\">\n\t\t\t\t\t\t\t<md-icon md-svg-src=\"magnify.svg\"></md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t</td>\n\n\t\t\t\t\t<td md-cell ng-if=\"itemEdit.editing\">\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"editInteraction(interaction)\"\n\t\t\t\t\t\tng-show=\"!userCanDoAction('editDocketInteraction', itemEdit)\">\n\t\t\t\t\t\t<md-icon md-svg-src=\"magnify.svg\"></md-icon>\n\t\t\t\t\t</md-button>\n\t\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"editInteraction(interaction)\"\n\t\t\t\t\tng-show=\"userCanDoAction('editDocketInteraction', itemEdit)\">\n\t\t\t\t\t<md-icon md-svg-src=\"edit.svg\"></md-icon>\n\t\t\t\t</md-button>\n\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"removeInteractionFromResource(interaction, resource)\"\n\t\t\t\tng-show=\"userCanDoAction('removeDocketInteraction', itemEdit)\" aria-label=\"Remove Line\">\n\t\t\t\t<md-icon md-svg-src=\"delete.svg\"></md-icon>\n\t\t\t</md-button>\n\t\t\t</td>\n</tr>\n</tbody>\n</table>\n</md-table-container>\n</div>\n<!-- End Items Section -->\n\n<!-- Start Signatures Section -->\n<div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'signatures'\">\n\t<div class=\"sectionHeadingContainer\">\n\t\t<div class=\"sectionHeadingLeft\">\n\t\t\t<h1 class=\"sectionHeading\">Signatures</h1>\n\t\t</div>\n\t\t<div class=\"sectionHeadingRight\">\n\t\t</div>\n\t</div>\n\n\t<div class=\"ojdDesktopPaddingOuter\">\n\t\t<div class=\"ojdDesktopRow\">\n\t\t\t<div class=\"ojdDesktopField\"\n\t\t\t\tng-click=\"!userCanDoAction('captureSupplierSignature', itemEdit) || captureSignature('supplierSignature')\">\n\t\t\t\t<div><label class=\"order\">Operator</label></div>\n\t\t\t\t<span ng-if=\"itemEdit.supplierSignatureAttachment && itemEdit.supplierSignatureAttachment != '' && currentOrg != null && currentOrg != undefined\">\n              <img ng-src=\"{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.supplierSignatureAttachment}}\" height=\"90px\">\n            </span>\n\t\t\t\t<span ng-if=\"itemEdit.supplierSignatureAttachment && itemEdit.supplierSignatureAttachment != '' && (currentOrg === null || currentOrg === undefined)\">\n              <img ng-src=\"{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.supplierSignatureAttachment}}\" height=\"90px\">\n            </span>\n\t\t\t\t<h2 ng-if=\"!itemEdit.supplierSignatureAttachment && !itemEdit.supplierSignatureImage\">\n\t\t\t\t\tNot Captured\n\t\t\t\t</h2>\n\t\t\t\t<h3 ng-if=\"userCanDoAction('captureSupplierSignature', itemEdit)\">\n\t\t\t\t\t<span ng-show=\"itemEdit.editing\">Click to capture signature</span>\n\t\t\t\t</h3>\n\t\t\t</div>\n\n\t\t\t<div class=\"ojdDesktopField\"\n\t\t\t\tng-click=\"!userCanDoAction('captureCustomerSignature', itemEdit) || captureSignature('customerSignature')\">\n\t\t\t\t<div>\n\t\t\t\t\t<label class=\"order\">Customer<span ng-if=\"itemEdit.customerSignatureName\"> ({{itemEdit.customerSignatureName}})</span></label>\n\t\t\t\t</div>\n\t\t\t\t<span ng-if=\"!itemEdit.customerSignatureImage && itemEdit.customerSignatureAttachment && itemEdit.customerSignatureAttachment != '' && currentOrg != null\">\n              <img ng-src=\"{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.customerSignatureAttachment}}\" height=\"90px\">\n            </span>\n\t\t\t\t<span ng-if=\"!itemEdit.customerSignatureImage && itemEdit.customerSignatureAttachment && itemEdit.customerSignatureAttachment != '' && currentOrg == null\">\n              <img ng-src=\"{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.customerSignatureAttachment}}\" height=\"90px\">\n            </span>\n\t\t\t\t<span ng-if=\"itemEdit.customerSignatureImage\">\n              <img ng-src=\"{{itemEdit.customerSignatureImage}}\">\n            </span>\n\t\t\t\t<h2 ng-if=\"!itemEdit.customerSignatureAttachment && !itemEdit.customerSignatureImage\">\n\t\t\t\t\tNot Captured\n\t\t\t\t</h2>\n\t\t\t\t<h3 ng-if=\"userCanDoAction('captureCustomerSignature', itemEdit)\">\n\t\t\t\t\t<span ng-show=\"itemEdit.editing\">Click to capture signature</span>\n\t\t\t\t</h3>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<!-- End Signatures Section -->\n\n<!-- Start Custom Section -->\n<div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'custom'\">\n\t<div class=\"sectionHeadingContainer\">\n\t\t<div class=\"sectionHeadingLeft\">\n\t\t\t<h1 class=\"sectionHeading\">{{block.name}}</h1>\n\t\t</div>\n\t\t<div class=\"sectionHeadingRight\">\n\t\t</div>\n\t</div>\n\n\t<div class=\"ojdDesktopPaddingOuter\">\n\t\t<div class=\"ojdDesktopRow\">\n\t\t\t<div class=\"autoRepeatingFieldOuter\" ng-repeat=\"field in block.fields\">\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'datetime' || field.type == 'date'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<md-input-container class=\"md-block datepicker\" flex-gt-sm>\n\t\t\t\t\t\t<md-datepicker ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\"\n\t\t\t\t\t\t\tng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\"></md-datepicker>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'time'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<md-input-container class=\"md-block datepicker\" flex-gt-sm>\n\t\t\t\t\t\t<mdp-time-picker ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\"\n\t\t\t\t\t\t\tng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\"\n\t\t\t\t\t\t\tmdp-timezone=\"{{itemEdit.timezone}}\"></mdp-time-picker>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'text'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm>\n\t\t\t\t\t\t<input type=\"text\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n              </md-input-container>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'boolean'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm>\n\t\t\t\t\t\t<md-checkbox ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\"\n\t\t\t\t\t\t\taria-label=\"{{field.displayName}}\" ng-disabled=\"!itemEdit.editing\">\n\t\t\t\t\t\t</md-checkbox>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'number'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm>\n\t\t\t\t\t\t<input type=\"number\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n              </md-input-container>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'select'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<md-input-container class=\"md-block\">\n\t\t\t\t\t\t<md-select aria-label=\"Select Field Value\"\n\t\t\t\t\t\t\tng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\"\n\t\t\t\t\t\t\tng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n\t\t\t\t\t\t\t<md-option ng-repeat=\"value in field.selectionFields\" ng-value=\"value\">{{value}}</md-option>\n\t\t\t\t\t\t</md-select>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'multiline'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<md-input-container class=\"md-block\">\n\t\t\t\t\t\t<textarea aria-label=\"{{field.displayName}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" rows=\"3\" md-select-on-focus ng-disabled=\"!itemEdit.editing\"></textarea>\n\t\t\t\t\t</md-input-container>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'label'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}}</label>\n\t\t\t\t\t<p class=\"labelFieldText\">{{field.text}}</p>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'address'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<div class=\"group\" ng-show=\"itemEdit.editing\">\n\t\t\t\t\t\t<input type=\"text\" name=\"location\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" address-model=\"newAddress\" googleplace placeholder=\"\" aria-label=\"{{field.displayName}}\">\n\t\t\t\t\t\t<span class=\"highlight\"></span>\n\t\t\t\t\t\t<span class=\"bar\"></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3 ng-show=\"!itemEdit.editing\">{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h3>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'location'\">\n\t\t\t\t\t<label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n\t\t\t\t\t<h3>Coming Soon</h3>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ojdDesktopField\" ng-if=\"field.type == 'signature'\"\n\t\t\t\t\tng-click=\"!(itemEdit.editing && !itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]) || captureFieldSignature(block, field)\">\n\t\t\t\t\t<div><label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label></div>\n\t\t\t\t\t<h2\n\t\t\t\t\t\tng-if=\"!itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]\">\n\t\t\t\t\t\tNot Captured\n\t\t\t\t\t</h2>\n\t\t\t\t\t<span ng-if=\"itemEdit.signatureFields[block.id + '-' + field.id].signatureImage != null\">\n                <img ng-src=\"{{itemEdit.signatureFields[block.id + '-' + field.id].signatureImageFull}}\">\n              </span>\n\t\t\t\t\t<span ng-if=\"itemEdit.templateValueStore[block.id + '-' + field.id] && currentOrg != null\">\n                <img ng-src=\"{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.templateValueStore[block.id + '-' + field.id]}}\" height=\"90px\">\n              </span>\n\t\t\t\t\t<span ng-if=\"itemEdit.templateValueStore[block.id + '-' + field.id] && currentOrg == null\">\n                <img ng-src=\"{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.templateValueStore[block.id + '-' + field.id]}}\" height=\"90px\">\n              </span>\n\t\t\t\t\t<h3\n\t\t\t\t\t\tng-if=\"itemEdit.editing && !itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]\">\n\t\t\t\t\t\t<span>Click to capture signature</span>\n\t\t\t\t\t</h3>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<!-- End Custom Section -->\n\n<!-- Start Checklists Section -->\n<div class=\"ojdDesktopSection noPadding\"\n\tng-if=\"block.type == 'checklists' && itemEdit.template && itemEdit.template.checklistContainers && itemEdit.template.checklistContainers.length > 0\">\n\t<div class=\"sectionHeadingContainer\">\n\t\t<div class=\"sectionHeadingLeft\">\n\t\t\t<h1 class=\"sectionHeading\">Checklists</h1>\n\t\t</div>\n\t\t<div class=\"sectionHeadingRight\">\n\t\t</div>\n\t</div>\n\n\t<p ng-if=\"itemEdit.template.checklistContainers == null || itemEdit.template.checklistContainers.length <= 0\">\n\t\tThere are no checklists on this docket\n\t</p>\n\n\t<md-table-container class=\"docketChecklistTable\"\n\t\tng-show=\"itemEdit.template.checklistContainers != null && itemEdit.template.checklistContainers.length > 0\">\n\t\t<table md-table multiple>\n\t\t\t<thead md-head>\n\t\t\t\t<tr md-row>\n\t\t\t\t\t<th md-column>Checklist</th>\n\t\t\t\t\t<th md-column>Rule</th>\n\t\t\t\t\t<th md-column>Status</th>\n\t\t\t\t\t<th md-column width=\"100px\">Action</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody md-body ng-repeat=\"container in itemEdit.template.checklistContainers\">\n\t\t\t\t<tr md-row>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<strong>{{container.checklistTemplate.name}}</strong>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<span ng-show=\"container.rule == 'required'\">Required Before Submission</span>\n\t\t\t\t\t\t<span ng-show=\"container.rule == 'notRequired'\">Optional</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<span ng-show=\"!itemEdit.checklists[container.checklistTemplate.id].complete\"><div class=\"statusDisplay Declined\">Incomplete</div></span>\n\t\t\t\t\t\t<span ng-show=\"itemEdit.checklists[container.checklistTemplate.id].complete\"><div class=\"statusDisplay Completed\">Complete</div></span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" ng-click=\"container.detailOpen = !container.detailOpen\"\n\t\t\t\t\t\t\taria-label=\"Toggle Checklist Detaild\">\n\t\t\t\t\t\t\t<md-icon md-svg-src=\"arrow_down.svg\" ng-if=\"!container.detailOpen\"></md-icon>\n\t\t\t\t\t\t\t<md-icon md-svg-src=\"arrow_up.svg\" ng-if=\"container.detailOpen\"></md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr md-row class=\"checklistDetailRow\" ng-repeat=\"field in container.checklistTemplate.fields\"\n\t\t\t\t\tng-show=\"container.detailOpen\">\n\t\t\t\t\t<td md-cell colspan=\"3\">\n\t\t\t\t\t\t{{field.displayName}}\n\t\t\t\t\t</td>\n\t\t\t\t\t<td md-cell>\n\t\t\t\t\t\t<md-input-container>\n\t\t\t\t\t\t\t<md-select ng-model=\"itemEdit.checklists[container.checklistTemplate.id].answers[field.id]\"\n\t\t\t\t\t\t\t\tng-disabled=\"!itemEdit.editing\" aria-label=\"Set Checklist Item {{field.displayName}}\"\n\t\t\t\t\t\t\t\tng-change=\"updateDocketChecklists(itemEdit)\">\n\t\t\t\t\t\t\t\t<md-option value=\"ok\">Ok</md-option>\n\t\t\t\t\t\t\t\t<md-option value=\"fail\">Fail</md-option>\n\t\t\t\t\t\t\t\t<md-option value=\"na\">N/A</md-option>\n\t\t\t\t\t\t\t</md-select>\n\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</md-table-container>\n</div>\n<!-- End Checklists Section -->\n</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "8qHh":
/***/ (function(module, exports) {

var path = 'views/pages/groupSettings/admins.html';
var html = "<div class=\"desktopContainer dashboard\">\n  <div class=\"dashboardWelcomeHeader\">\n    <div class=\"left\">\n      <h3>Manage Administrators</h3>\n      <p>Administrators are those who control an organisation, they have no access limitations.  Add, invite or remove members to control those with global access and control. There must always be at least one administrator within an organisation. </p>\n    </div>\n    <div class=\"right\">\n      <div class=\"dbButton lightBlue rightMargin\" ng-click=\"addOwnersToGroup(groupEdit)\">\n        Add Existing\n      </div>\n      <div class=\"dbButton lightBlue\" ng-click=\"!sampleCompany && inviteNewMembers(groupEdit, 'owner')\" ng-disabled=\"sampleCompany\">\n        Invite New\n        <md-tooltip ng-if=\"sampleCompany\">This feature is disabled inside a demo company.</md-tooltip>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"adminBasicContentContainer\">\n    <div class=\"adminSettingGroupContainer noPadding\">\n      <div class=\"tableLayoutHelperContainer\" ng-if=\"!groupEdit.owners\">\n        <div class=\"adminContentEmptyTable\">\n          It doesn't look like you have any owners yet\n        </div>\n      </div>\n      <md-table-container ng-if=\"groupEdit.owners\">\n        <table md-table>\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Name</th>\n              <th md-column>Primary Contact</th>\n              <th md-column></th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"owner in groupEdit.owners\">\n              <td md-cell>{{owner.name.full}}</td>\n              <td md-cell>{{owner.displayEmailAddress}}</td>\n              <td md-cell style=\"text-align: right;\">\n                <div class=\"dbButton red\" ng-click=\"!sampleCompany && removeOwnerFromGroup(owner, groupEdit)\" aria-label=\"Remove Owner From Group\" ng-disabled=\"sampleCompany\">\n                  Remove\n                  <md-tooltip ng-if=\"sampleCompany\">This feature is disabled inside a demo company.</md-tooltip>\n                </div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    </div>\n  </div>\n</div>\n\n\n<ng-include src=\"'views/modals/selectRoleModal.html'\" ng-controller=\"selectRoleController\"></ng-include>\n<ng-include src=\"'views/modals/selectPersonModal.html'\" ng-controller=\"selectPersonController\"></ng-include>\n<ng-include src=\"'views/modals/inviteMembersModal.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "8sn0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').factory('formatHelper', ['$timeout', function ($timeout) {
  var root = {};

  /* Format time quantity */

  root.formatTimeQuantity = function (quantity, abbreviation) {
    // NB: quantity is always in minutes
    var formattedString = "";
    if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
      // display as hours
      var hours = (quantity / 60).toFixed(2);
      formattedString = hours + " Hours";
    }
    if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
      // display as hours and minutes
      var hours = Math.floor(quantity / 60);
      var minutes = quantity % 60;

      formattedString = "";
      if (hours > 0) {
        if (hours == 1) {
          formattedString += hours + " Hour ";
        } else {
          formattedString += hours + " Hours ";
        }
      }
      if (minutes > 0) {
        formattedString += minutes + " Minutes";
      }
    }
    if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
      formattedString = quantity += " Minutes";
    }

    return formattedString;
  };

  /* Stringify Address Helper */

  root.stringifyAddress = function (address) {
    if (!address) {
      return "";
    }
    var strAddress = "";
    if (address.num) {
      strAddress += address.num + ", ";
    }

    if (address.streetNum) {
      strAddress += address.streetNum + " ";
    }

    if (address.streetName) {
      strAddress += address.streetName + " ";
    }

    if (address.suburb) {
      strAddress += address.suburb + ", ";
    }

    if (address.state) {
      strAddress += address.state + ", ";
    }

    if (address.postCode) {
      strAddress += address.postCode + ", ";
    }

    if (address.country) {
      strAddress += address.country;
    }

    return strAddress;
  };

  root.stringifyAddressHtml = function (address) {
    if (!address) {
      return "";
    }
    var strAddress = "";
    if (address.num) {
      strAddress += address.num + ", ";
    }

    if (address.streetNum) {
      strAddress += address.streetNum + " ";
    }

    if (address.streetName) {
      strAddress += address.streetName + "<br/>";
    }

    if (address.suburb) {
      strAddress += address.suburb + ", ";
    }

    if (address.state) {
      strAddress += address.state + "<br/>";
    }

    if (address.postCode) {
      strAddress += address.postCode + ", ";
    }

    if (address.country) {
      strAddress += address.country;
    }

    return strAddress;
  };

  return root;
}]);

/***/ }),

/***/ "9AR7":
/***/ (function(module, exports) {

var path = 'views/modals/selectResourceModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector superWide\" id=\"selectResourceModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Resource <b ng-if=\"orderLineItem\" style=\"white-space: pre;\"> '{{orderLineItem.itemDescription}}'</b></h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeResourceSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <!--<h3 ng-if=\"orderLineItem\">\n        Select resource item for <b>{{orderLineItem.itemDescription}}:</b>\n      </h3>-->\n      <div class=\"searchBar\">\n        <div class=\"title\">\n          <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"bar\">\n          <input name=\"selectResourceInput\" type=\"text\" ng-model=\"resourceSearch\" placeholder=\"Search\" ng-change=\"searchResourceChange(resourceSearch)\" ng-model-options='{debounce:1000}'>\n        </div>\n        <div class=\"selector\">\n          <md-input-container class=\"md-block\">\n            <md-select ng-model=\"query.categoryFilter\" aria-label=\"Select Resource Category\"  ng-change=\"categoryFilterChanged()\">\n              <md-option value=\"all\">All Categories</md-option>\n              <md-option value=\"{{category.id}}\" ng-repeat=\"category in allowedResourceCategories\">{{category.name}}</md-option>\n            </md-select>\n          </md-input-container>\n        </div>\n      </div>\n      <div class=\"noListMessage\" ng-show=\"resourceSearchList.length <= 0\">\n        There are no resources matching your search criteria.\n      </div>\n      <md-table-container class=\"editableTable\" ng-show=\"resourceSearchList.length > 0\">\n        <table md-table md-row-select multiple=\"{{tableSettings.multiple}}\" ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head md-order=\"query.order\" md-on-reorder=\"loadResourceList\">\n            <tr md-row>\n              <th md-column></th>\n              <th md-column md-order-by=\"name\"><span>Name</span></th>\n              <th md-column md-order-by=\"identifier\"><span>Identifier</span></th>\n              <th md-column><span>Category</span></th>\n              <th md-column ng-if=\"desktopLineItems && desktopLineItems.length > 0\">Order Description</th>\n              <th md-column><span>Unit of Measure</span></th>\n              <th md-column ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\"><span>Xero Item</span></th>\n              <th md-column>Status</th>\n              <th md-column></th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row md-select=\"resource\" md-select-id=\"id\" ng-repeat=\"resource in resourceSearchList\" md-auto-select=\"!resource.editing\" ng-style=\"{ cursor: editing? '' : 'pointer' }\" ng-disabled=\"!resource.editing && (resource.existing || (allowedResourceCategoryIds.length > 0 && !allowedResourceCategoryIds.includes(resource.category.id)))\" class=\"{{!resource.editing && (resource.existing || (allowedResourceCategoryIds.length > 0 && !allowedResourceCategoryIds.includes(resource.category.id))) ? 'disabled':''}}\">\n              <td md-cell class=\"buttonCell\">\n                <md-button class=\"md-icon-button\" ng-click=\"editResourceRow(resource)\" aria-label=\"Edit Resource\" ng-if=\"!resource.editing && !resource.loading\">\n                  <md-icon md-svg-icon=\"edit.svg\"></md-icon>\n                </md-button>\n                <md-button class=\"md-icon-button\" ng-click=\"saveResourceRow(resource)\" aria-label=\"Save Resource\" ng-if=\"resource.editing && !resource.loading\">\n                  <md-icon md-svg-icon=\"resourcesave.svg\"></md-icon>\n                </md-button>\n                <span ng-if=\"resource.loading\">\n                  <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-5\" md-diameter=\"20\"></md-progress-circular>\n                </span>\n              </td>\n              <td md-cell>\n                <md-input-container class=\"md-block\" ng-if=\"resource.editing\">\n                  <input ng-model=\"resource.name\" type=\"text\" required ng-disabled=\"!resource.editing || resource.loading\">\n                </md-input-container>\n                <span ng-if=\"!resource.editing\">\n                  {{resource.name}}\n                </span>\n              </td>\n              <td md-cell>\n                <md-input-container class=\"md-block\" ng-if=\"resource.editing\">\n                  <input ng-model=\"resource.identifier\" type=\"text\" required ng-disabled=\"!resource.editing || resource.loading\">\n                </md-input-container>\n                <span ng-if=\"!resource.editing\">\n                  {{resource.identifier}}\n                </span>\n              </td>\n              <td md-cell>\n                <span ng-if=\"resource.editing\">\n                  <md-input-container class=\"md-block\">\n                    <md-autocomplete required md-input-name=\"autocompleteCategory\"\n                      ng-disabled=\"!resource.editing\" md-no-cache=\"true\"\n                      md-selected-item=\"resource.category\"\n                      md-search-text-change=\"searchCategoryChange(resource, searchTextCategory)\"\n                      md-search-text=\"searchTextCategory\"\n                      md-items=\"item in filteredCategories\" md-item-text=\"item.name\"\n                      md-min-length=\"0\" placeholder=\"Search for a category\"\n                      md-menu-class=\"autocomplete-custom-template\">\n                      <md-item-template>\n                        <span class=\"item-title\">{{item.name}}</span>\n                      </md-item-template>\n                      <md-not-found>\n                        No matches found.\n                      </md-not-found>\n                    </md-autocomplete>\n                  </md-input-container>\n                </span>\n                <span ng-if=\"!resource.editing\">\n                  {{resource.category.name}}\n                </span>\n              </td>\n              <td md-cell ng-if=\"desktopLineItems && desktopLineItems.length > 0\">\n                {{resource.lineDescription}}\n              </td>\n              <td md-cell>\n                <span ng-if=\"resource.editing\">\n                  <md-input-container class=\"md-block\">\n                    <md-autocomplete required md-input-name=\"autocompleteUom\"\n                      ng-disabled=\"!resource.editing\" md-no-cache=\"true\"\n                      md-selected-item=\"resource.uom\"\n                      md-search-text-change=\"searchUomChange(resource, searchTextUom)\"\n                      md-search-text=\"searchTextUom\"\n                      md-items=\"item in filteredUoms\" md-item-text=\"item.abbreviation + '(' + item.description + ')'\"\n                      md-min-length=\"0\" placeholder=\"Search for a unit of measure\"\n                      md-menu-class=\"autocomplete-custom-template\">\n                      <md-item-template>\n                        <span class=\"item-title\">{{item.abbreviation}} ({{item.description}})</span>\n                      </md-item-template>\n                      <md-not-found>\n                        No matches found.\n                      </md-not-found>\n                    </md-autocomplete>\n                  </md-input-container>\n                </span>\n                <span ng-if=\"!resource.editing\">\n                  {{resource.uom.abbreviation}} ({{resource.uom.description}})\n                </span>\n              </td>\n              <td md-cell ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n                <span ng-if=\"resource.editing\">\n                  <md-input-container class=\"md-block\">\n                    <md-autocomplete required md-input-name=\"autocompleteXeroID\"\n                      ng-disabled=\"!resource.editing\" md-no-cache=\"true\"\n                      md-selected-item=\"resource.xeroID\"\n                      md-search-text-change=\"searchXeroItemChange(resource, searchTextXeroItem)\"\n                      md-search-text=\"searchTextXeroItem\"\n                      md-selected-item-change=\"resourceXeroItemSelected(resource)\"\n                      md-items=\"item in filteredXeroItems\" md-item-text=\"item.name + ' (' + item.userCode + ')'\"\n                      md-min-length=\"0\" placeholder=\"Search for a xero item\"\n                      md-menu-class=\"autocomplete-custom-template\">\n                      <md-item-template>\n                        <span class=\"item-title\">{{item.name}} ({{item.userCode}})</span>\n                      </md-item-template>\n                      <md-not-found>\n                        No matches found.\n                      </md-not-found>\n                    </md-autocomplete>\n                  </md-input-container>\n                </span>\n                <span ng-if=\"!resource.editing && resource.xeroItem\">\n                  <div class=\"xeroAvatar\"></div>\n                  <span>{{resource.xeroItem.name}} ({{resource.xeroItem.userCode}})</span>\n                </span>\n              </td>\n              <td md-cell>\n                <span ng-show=\"resource.existing\">On Docket</span>\n                <span ng-show=\"!resource.editing && !allowedResourceCategoryIds.includes(resource.category.id)\">Not Available</span>\n              </td>\n              <td md-cell>\n                <md-button ng-show=\"resource.editing\" class=\"md-icon-button\" ng-click=\"cancelEdit(resource, $index)\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n      <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadResourceList\" md-total=\"{{listCount}}\" md-page-select>\n      </md-table-pagination>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <!--<div class=\"left\">\n          <span ng-show=\"desktopSelected.length > 1\">\n            {{desktopSelected.length}} resources will be added to this docket.\n          </span>\n          <span ng-show=\"desktopSelected.length == 1\">\n            1 resource will be added to this docket.\n          </span>\n        </div>-->\n        <div class=\"left\">\n          <div class=\"dbButton whiteOutline\" ng-click=\"addNewResource()\">\n            + Add a New Resource\n          </div>\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeResourceSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || desktopSelectResourceContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "9CBH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "file_download.svg";

/***/ }),

/***/ "9FYg":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/jobsTab.html';
var html = "<h1 class=\"containerHeading hidden-xs\">Jobs</h1>\n\n<div class=\"customListRowOuter\" ng-show=\"userCanDoAction('addOrderJob', itemEdit)\" ng-click=\"newJobForOrder()\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem createNew\"><div class=\"dbButton lightBlue\">New Job</div></div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-show=\"itemEdit.id == null\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem message\">\n      Save order before creating jobs.\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-repeat=\"item in itemEdit.jobs\" id=\"listItem{{item.id}}\">\n  <div class=\"customListRow\" hm-swipeLeft=\"splitListFunc.swipeListItem(item.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(item.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}' ng-click=\"openJob(item)\">\n    <div class=\"listRowItem status\"><div class=\"statusDisplay {{item.status}}\">{{item.status}}</div></div>\n    <div class=\"listRowItem itemNumber\">{{item.jobNumber}}</div>\n    <div class=\"listRowItem collapsedDetail showCollapsed\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\"><span ng-show=\"item.customerContact\">{{item.customerContact.displayName}}</span></div>\n        <div class=\"right\">{{moment(item.startDate).format('DD/MM')}} - {{moment(item.endDate).format('DD/MM')}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter hidden\" id=\"jobsLoadingMore\">\n  <div class=\"customListRow loadingRow\">\n    <div class=\"progressOuter\">\n      <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n    </div>\n    Loading More Jobs\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "9Kjc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "delete.svg";

/***/ }),

/***/ "9bX9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

angular.module('docketbook').controller('preAuthDocketController', ['docketService', '$rootScope', '$cookies', '$scope', '$state', '$stateParams', '$http', 'Restangular', 'accessControl', '$q', function (docketService, $rootScope, $cookies, $scope, $state, $stateParams, $http, Restangular, accessControl, $q) {
  mixpanel.track("Opened Preauth Docket Desktop");

  $scope.currentUser = accessControl.currentUser();

  $scope.moment = moment;
  $scope.docketId = $stateParams.docketId;
  $scope.fullApiPath = "" + "/" + $scope.urlVersion;
  $scope.isPreAuthDocket = true;

  $scope.openDocket = function (docket) {
    $scope.isPreAuthDocket = true;
    $scope.loadDocketFromParent(docket, 0, false);
  };

  $scope.loadDocket = function () {
    if ($scope.docketId) {
      docketService.getDocket($scope.docketId, null, function (fullDocket) {
        $scope.docket = fullDocket;
        $scope.itemEdit = fullDocket;
        $scope.itemEdit.editing = true;

        if ($scope.itemEdit.startTime && $scope.itemEdit.endTime) {
          var totalMinutes = parseInt(moment($scope.itemEdit.endTime).diff(moment($scope.itemEdit.startTime), 'minutes'));

          if ($scope.itemEdit.breakTime) {
            totalMinutes = totalMinutes - $scope.itemEdit.breakTime;
          }
          if ($scope.itemEdit.travelTime) {
            totalMinutes = totalMinutes + $scope.itemEdit.travelTime;
          }

          $scope.itemEdit.totalTime = (totalMinutes / 60).toFixed(2) + ' Hrs';
        }

        if ($scope.itemEdit.templateValueStore) {
          var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
          $scope.signatureAttachments = $scope.itemEdit.attachments.reduce(function (acc, attachment) {
            if (templateStoreValues.indexOf(attachment.id) !== -1) {
              acc.push(attachment.id);
            }
            return acc;
          }, []);
        }

        var resourceCount = $scope.itemEdit.resources.length;
        $scope.itemEdit.resources.forEach(function (item) {
          if (resourceCount <= 2) {
            item.collapsed = false;
          } else {
            item.collapsed = true;
          }
        });
        var attachmentsCount = 0;
        if ($scope.itemEdit.attachments) {
          for (var i = 0; i < $scope.itemEdit.attachments.length; i++) {
            if ($scope.itemEdit.attachments[i].fileName != 'supplier-signature' && $scope.itemEdit.attachments[i].fileName != 'customer-signature') {
              attachmentsCount += 1;
            }
          }
        }
        $scope.itemEdit.attachmentCount = attachmentsCount;
        if ($scope.currentOrg != null && $scope.currentOrgGroup != null && accessControl.userHasPermission('io.docketbook.ojdapi.fileDockets')) {
          $scope.setupFilingDetails($scope.itemEdit);
        }
        //$scope.setupAuditLog($scope.itemEdit);
        $scope.itemEdit.signatureFields = {};

        // Check permissions for this anon users and customer signature
        if (!$scope.docket.customerSignature && $scope.docket.template && $scope.docket.template.blocks.map(function (block) {
          return block.type;
        }).includes('signatures')) {
          var hasApproverRole = false;
          for (var i = 0; i < $scope.currentUser.emailAddresses.length; i++) {
            if ($scope.docket.accessControl[$scope.currentUser.emailAddresses[i]].indexOf('approver') != -1 || $scope.docket.accessControl[$scope.currentUser.emailAddresses[i]].indexOf('editor') != -1) {
              hasApproverRole = true;
            }
          }
          if (hasApproverRole) {
            $scope.docket.askForSignature = true;
          }
        }

        if ($scope.docket.template && $scope.docket.template.attachments) {
          $scope.docket.hasTermsConditions = false;
          $scope.docket.termsAttachments = [];
          for (var i = 0; i < $scope.docket.template.attachments.length; i++) {
            if ($scope.docket.template.attachments[i].type == 'termsConditions') {
              $scope.docket.hasTermsConditions = true;
              $scope.docket.termsAttachments.push($scope.docket.template.attachments[i]);
            }
          }
        }
      }, function (err) {
        alert('error loading this docket');
      });
    }
  };

  $scope.loadDocket();

  $scope.openDocketTermsAttachments = function () {
    for (var i = 0; i < $scope.docket.termsAttachments.length; i++) {
      window.open("" + '/' + $scope.urlVersion + '/dockets/' + $scope.docket.id + '/template/attachment/' + $scope.docket.termsAttachments[i].id);
    }
  };

  $scope.captureSignatureForDocket = function (entity, nameRequired, name, terms, template, cb) {
    $scope.captureSignatureCallback = cb;
    $scope.captureSignatureFromParent(entity, nameRequired, name, terms, template, function (signatureObject) {
      $scope.captureSignatureCallback(signatureObject);
    });
  };

  $scope.getCustomerSignature = function () {
    $scope.captureSignatureForDocket('customerSignature', true, "", true, $scope.itemEdit.template, function (signatureObject) {
      $scope.itemEdit.customerSignatureData = signatureObject.signatureImage;
      $scope.itemEdit.customerSignatureImage = signatureObject.signatureImageFull;
      $scope.itemEdit.customerSignatureName = signatureObject.signatureName;
      $scope.uploadSignature($scope.itemEdit, function () {
        $scope.docket.askForSignature = false;
        $scope.loadDocket();
      }, function () {
        alert('error uploading sig');
      });
    });
  };

  $scope.uploadSignature = function (docket, successCb, failureCb) {
    var signatureImage = docket.customerSignatureData;
    var filename = 'customer-signature';
    var url = "" + '/' + $rootScope.urlVersion + "/dockets/" + docket.id + "/attachment";
    var body = '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
    body += "--__TEST123__";
    if (docket.customerSignatureName) {
      body += "\r\n";
      body += 'content-disposition: form-data; name="jsondata";filename="customername.json"\r\ncontent-type: application/json\r\n\r\n{"customerSignatureName":"' + docket.customerSignatureName + '"}\r\n--__TEST123__--\r\n';
    } else {
      body += "--";
    }
    var header = 'multipart/form-data; boundary="__TEST123__"';
    $http.put(url, body, {
      headers: { 'Content-Type': header },
      withCredentials: true
    }).then(function () {
      successCb();
      return;
    }, function (err) {
      failureCb();
      return;
    });
  };

  $scope.downloadDocket = function () {
    var url = '/v1/dockets/' + $scope.docketId + '/downloadpdf';
    window.open(url, "_blank");
  };

  $scope.login = function () {
    $cookies.remove('dbtoken');
    window.location = '/v1/logout';
  };

  /* Docket Detail Helpers */
  $scope.getResourceQtySummary = function (resourceGrouped) {
    var totalQuantity = 0;
    for (var i = 0; i < resourceGrouped.interactions.length; i++) {
      if ($scope.itemEdit.template.sumOnlyBillableInteractions) {
        if (resourceGrouped.interactions[i].interactionTemplate.billable) {
          totalQuantity += resourceGrouped.interactions[i].quantity;
        }
      } else {
        totalQuantity += resourceGrouped.interactions[i].quantity;
      }
    }

    totalQuantity = totalQuantity.toFixed(2);

    return totalQuantity + " " + resourceGrouped.resource.uom.abbreviation;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("PJh5")))

/***/ }),

/***/ "9jXu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14.png";

/***/ }),

/***/ "9ksV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "clock.svg";

/***/ }),

/***/ "9qDa":
/***/ (function(module, exports) {

var path = 'views/modals/editUserGroupRolesModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"editUserGroupRolesModal\">\n    <div class=\"modalContainer\">\n      <div class=\"header hidden-xs\">\n        <h1>Edit User</h1>\n        <div class=\"headerCloseButton\" ng-click=\"cancel()\">\n          <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div class=\"content noPadding\">\n        \n        <!-- Start Summary Section -->\n        <div class=\"ojdDesktopSection white\">\n          <div class=\"ojdDesktopRow\">\n            <div class=\"ojdDesktopField\">\n              <label class=\"order\">Name</label>\n              <h3>{{member.name.full}}</h3>\n            </div>\n            <div class=\"ojdDesktopField\">\n              <label class=\"order\">Primary Contact</label>\n              <h3>{{member.emailAddress}}</h3>\n            </div>\n          </div>\n          <div class=\"ojdDesktopRow\">\n            <div class=\"ojdDesktopField\">\n              <md-input-container class=\"md-block\" flex-gt-sm=\"10\" aria-label=\"Monitor\">\n                <md-checkbox ng-checked=\"monitor\" ng-click=\"toggleMonitor()\" style=\"width: 150px;\">\n                  Monitor\n                </md-checkbox>\n              </md-input-container>\n            </div>\n            <div class=\"ojdDesktopField\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"10\" aria-label=\"Administrator\">\n                    <md-checkbox ng-checked=\"admin\" ng-click=\"toggleAdmin()\" style=\"width: 150px;\">\n                        Administrator\n                    </md-checkbox>\n                </md-input-container>\n            </div>\n          </div>\n        </div>\n        <!-- End Summary Section -->\n\n        <div ng-if=\"superUser != true\">\n          <div style=\"padding: 30px;\">\n            <div>\n              <h2 style=\"text-align: left; margin-bottom: 30px;\">Access</h2>\n            </div>\n            <md-input-container ng-repeat=\"role in allRoles\" class=\"md-block\" flex-gt-sm=\"10\" aria-label=\"{{role.name}}\">\n                <md-checkbox ng-checked=\"hasRole(role)\" ng-click=\"toggleRole(role)\" style=\"width: 150px;\">\n                    {{role.name}}\n                </md-checkbox>\n            </md-input-container>\n          </div>\n        </div>\n        <div ng-if=\"superUser == true\">\n          <h2 style=\"margin: 30px\">Super User has administrator access to all groups</h2>\n        </div>\n\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\"></div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"cancel()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"saving || saveUser()\" ng-disabled=\"saving\">\n              <span ng-hide=\"saving\">Save</span>\n              <md-progress-circular ng-show=\"saving\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "9x82":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/generalTab.html';
var html = "<div class=\"ojdRow\" ng-if=\"!itemEdit.assigned && currentOrg == null && !itemEdit.editing\">\n  <div class=\"ojdField noEdit disabled\">\n    <h1>Unassigned</h1>\n    <h3>This docket is unassigned</h3>\n    <div class=\"dbButton lightBlue margin-top\" ng-click=\"assignDocketOrg(itemEdit)\">Add To Organisation</div>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField noEdit disabled\">\n    <h1>Status</h1>\n    <h2>{{itemEdit.status}}</h2>\n  </div>\n  <div class=\"ojdField {{userCanDoAction('changeDocketTemplate', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeDocketTemplate', itemEdit) || selectDocketTemplate()\" ng-if=\"!itemEdit.orderRef\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeDocketTemplate', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Docket Template</h1>\n    <h2 ng-if=\"itemEdit.template\">{{itemEdit.template.name}}</h2>\n    <h2 ng-if=\"!itemEdit.template && userCanDoAction('changeDocketTemplate', itemEdit)\">Click to select</h2>\n    <h2 ng-if=\"!itemEdit.template && !userCanDoAction('changeDocketTemplate', itemEdit)\">Not Assigned</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"itemEdit.rejectionComment && itemEdit.status == 'Rejected'\">\n  <div class=\"ojdField disabled\">\n    <h1>Rejection Comment</h1>\n    <h3>{{itemEdit.rejectionComment}}</h3>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField {{userCanDoAction('changeDocketOrder', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeDocketOrder', itemEdit) || selectOrder()\" ng-if=\"userHasPermission('io.docketbook.ojdapi.getOrder')\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeDocketOrder', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Order Number</h1>\n    <h2>{{itemEdit.orderNum ? itemEdit.orderNum : itemEdit.orderRef.orderNumber}}</h2>\n    <h2 ng-if=\"!itemEdit.orderRef && userCanDoAction('changeDocketOrder', itemEdit)\">Click to select</h2>\n    <h2 ng-if=\"!itemEdit.orderRef && !userCanDoAction('changeDocketOrder', itemEdit)\">Not Assigned</h2>\n  </div>\n  <div class=\"ojdField disabled\" ng-if=\"itemEdit.jobRef\">\n    <h1>Job Number</h1>\n    <h2>{{itemEdit.jobRef.jobNumber}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField {{userCanDoAction('changeDocketDate', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeDocketDate', itemEdit) || showDatePicker('date', $event)\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeDocketDate', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Date</h1>\n    <h2>{{moment(itemEdit.date).format('DD/MM/YYYY')}}</h2>\n  </div>\n  <div class=\"ojdField disabled\">\n    <h1>Operator</h1>\n    <h2>{{itemEdit.authorName}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField disabled\">\n    <h1>Supplier</h1>\n    <span ng-if=\"itemEdit.supplierContact\">\n      <h2>{{itemEdit.supplierContact.displayName}}</h2>\n      <h3 ng-if=\"itemEdit.supplierContact.addresses && itemEdit.supplierContact.addresses.length > 0\">\n        {{stringifyAddress(itemEdit.supplierContact.addresses[0])}}\n      </h3>\n    </span>\n    <span ng-if=\"!itemEdit.supplierContact\">\n      <h2>Not Assigned</h2>\n    </span>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField {{userCanDoAction('changeDocketCustomer', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeDocketCustomer', itemEdit) || selectCompany('customerContact')\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeDocketCustomer', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Customer</h1>\n    <span ng-if=\"itemEdit.customerContact\">\n      <h2>{{itemEdit.customerContact.displayName}}</h2>\n      <h3 ng-if=\"itemEdit.customerContact.addresses && itemEdit.customerContact.addresses.length > 0\">\n        {{stringifyAddress(itemEdit.customerContact.addresses[0])}}\n      </h3>\n    </span>\n    <span ng-if=\"!itemEdit.customerContact && userCanDoAction('changeDocketCustomer', itemEdit)\">\n      <h2>Click to select</h2>\n    </span>\n    <span ng-if=\"!itemEdit.customerContact && !userCanDoAction('changeDocketCustomer', itemEdit)\">\n      <h2>Not Assigned</h2>\n    </span>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"itemEdit.supplierContact || itemEdit.customerContact\">\n  <div class=\"ojdField disabled\" ng-if=\"itemEdit.supplierRefNo\">\n    <h1>Supplier Ref No</h1>\n    <h2>{{itemEdit.supplierRefNo}}</h2>\n  </div>\n  <div class=\"ojdField disabled\" ng-if=\"itemEdit.customerRefNo\">\n    <h1>Customer Ref No</h1>\n    <h2>{{itemEdit.customerRefNo}}</h2>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "A3Uk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('createConnectionModalController', ['addressBookService', '$rootScope', '$scope', '$state', 'Upload', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', 'docketService', function (addressBookService, $rootScope, $scope, $state, Upload, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {
  var blankConnection = function blankConnection() {
    return { emailAddress: '', fullName: '', organisationName: '' };
  };

  $scope.newConnections = [blankConnection()];
  $scope.connectionsImport = { loading: false };
  $scope.importMode = false;
  $scope.file = null;

  $scope.$parent.showCreateConnectionsModal = function (importMode, successCb) {
    $scope.importMode = importMode;
    $scope.file = null;
    $scope.successCb = successCb;
    $scope.importStage = 0;
    $scope.newConnections = [blankConnection()];
    $('#createConnectionModal').fadeIn(100);
  };

  $scope.close = function () {
    $('#createConnectionModal').fadeOut(100);
  };

  $scope.addBlankConnection = function () {
    $scope.newConnections.push(blankConnection());
  };

  $scope.send = function () {

    var errorFound = false;
    $scope.newConnections.forEach(function (connection) {
      var thisEmail = connection.emailAddress;
      var isEmail = false;
      var isMobile = false;

      if (thisEmail) {
        var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        if (thisEmail.indexOf('@') != -1 && thisEmail.indexOf('.') != -1) {
          isEmail = true;
        }
        if (thisEmail.length == 10) {
          var foundNotANumber = false;
          for (var j = 0; j < thisEmail.length; j++) {
            if (numbers.indexOf(thisEmail[j]) == -1) {
              foundNotANumber = true;
              break;
            }
          }
          if (!foundNotANumber) {
            isMobile = true;
          }
        }
      }
      if (!isEmail /*&& !isMobile*/) {
          swal({
            title: "Hold Up!",
            text: "Some connections do not contain a valid email",
            type: "warning",
            confirmButtonText: "Ok"
          });
          errorFound = true;
          return;
        }
    });

    if (!errorFound) {
      addressBookService.createConnections($scope.newConnections, function () {
        $scope.close();
        $scope.successCb && $scope.successCb();
      }, function () {
        swal({
          title: "Oops!",
          text: "There was an error creating connection requests.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      });
    }
  };

  var mapping = {
    'full name': 'fullName',
    'email': 'emailAddress',
    'organisation name': 'organisationName'
  };

  var reverseMapping = {};

  Object.keys(mapping).forEach(function (key) {
    reverseMapping[mapping[key]] = key;
  });

  var readTableHeaders = function readTableHeaders(fileData) {
    var headers = fileData.shift().map(function (header) {
      return header.toLowerCase();
    }).map(function (header) {
      var found = null;
      Object.keys(mapping).forEach(function (key) {
        if (header.includes(key)) {
          found = mapping[key];
          return;
        }
      });
      return found;
    }).filter(function (x) {
      return x !== null;
    });

    var headerMissing = function headerMissing(str) {
      return !headers.includes(str);
    };

    var missing = Object.keys(reverseMapping).filter(headerMissing).map(function (header) {
      return reverseMapping[header];
    });

    if (missing.length > 0) {
      swal({
        title: "Oops!",
        text: 'The following columns are missing from the file: ' + missing.join(', '),
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      $scope.connectionsImport.loading = false;
      return null;
    }

    return fileData.map(function (data) {
      var item = {};
      headers.forEach(function (header, i) {
        item[header] = data[i];
      });
      return item;
    });
  };

  $scope.importFromFile = function (fromFile) {
    $scope.connectionsImport.loading = true;

    Upload.upload({
      url: '/v1/parse',
      data: { file: fromFile },
      withCredentials: true
    }).then(function (resp) {
      var data = readTableHeaders(resp.data[0].data);

      if (data == null) {
        return;
      }

      $scope.newConnections = data;

      $scope.connectionsImport.loading = false;
      $scope.importMode = false;
    }, function (resp) {
      $scope.connectionsImport.loading = false;
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "AX6D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "calendar.svg";

/***/ }),

/***/ "B49T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('ordersDesktopController', ['orderService', 'jobService', 'docketService', 'addressBookService', 'resourceService', 'userService', 'xeroService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$q', function (orderService, jobService, docketService, addressBookService, resourceService, userService, xeroService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
  mixpanel.track("Opened Orders Desktop");

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.itemEdit = null;
  $scope.originalOrder = null;
  $scope.preventReloadWithFilters = true;
  $scope.showFilters = false;
  $scope.listView = 'orders';
  $scope.selected = [];
  $scope.hasOrders = true;
  $scope.myDocketbook = $state.params.myDocketbook;
  $scope.customTemplate = [{
    name: 'Last 12 Months',
    dateStart: (0, _momentTimezone2.default)().subtract(12, 'months').toDate(),
    dateEnd: (0, _momentTimezone2.default)().toDate()
  }];

  orderService.getOrders({ limit: 1, offset: 0 }, function (returnData) {
    $scope.hasOrders = returnData.length > 0;
  });

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  $scope.assignOrder = {};
  $scope.assignOrder.selected = [];

  var statusFilterOptions = ['draft', 'sent', 'accepted', 'rejected', 'closed'];

  $scope.filters = {};
  $scope.filters.status = 'All';
  $scope.filters.startDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
  $scope.filters.endDate = (0, _momentTimezone2.default)().toDate();
  $scope.filters.statusOptions = { allView: true, all: true, draft: true, sent: true, accepted: true, rejected: true, closed: true };
  $scope.dateFilterModel = { dateStart: $scope.filters.startDate, dateEnd: $scope.filters.endDate, showTemplate: true };
  if ($scope.currentOrg && $scope.currentOrgGroup) {
    $scope.filters.organisationId = $scope.currentOrg.id;
    $scope.filters.groupId = $scope.currentOrgGroup.id;
  }

  $scope.$watch('dateFilterModel.dateStart', function (before, after) {
    if ($scope.dateFilterModel.dateStart) {
      $scope.filters.startDate = $scope.dateFilterModel.dateStart;
    }
    if (!$scope.preventReloadWithFilters) {
      if ((0, _momentTimezone2.default)(after).diff((0, _momentTimezone2.default)(before), 'days') != 0) {
        $scope.filtersChanged('date selector');
      }
    }
  }, true);

  $scope.$watch('dateFilterModel.dateEnd', function (before, after) {
    if ($scope.dateFilterModel.dateEnd) {
      $scope.filters.endDate = $scope.dateFilterModel.dateEnd;
    }
    if (!$scope.preventReloadWithFilters) {
      if ((0, _momentTimezone2.default)(after).diff((0, _momentTimezone2.default)(before), 'days') != 0) {
        $scope.filtersChanged('date selector');
      }
    }
  }, true);

  $scope.getStatus = function (order) {
    if (order == null) {
      return '';
    }

    if (userService.userCanDoAction('orderIsReviewable', order)) {
      return "Review";
    } else {
      return order.status;
    }
  };

  // New list query pagination
  $scope.query = {
    limit: 30,
    page: 1,
    order: 'orderNumber'
  };
  $scope.promise = null;

  if ($scope.currentOrg != null) {
    docketService.getTemplates({ published: true }, function (templates) {
      $scope.allTemplates = templates;
    });
    addressBookService.getAddressBook(null, function (addressBookFull) {
      $scope.addressBook = addressBookFull;
      $scope.addressBookSearchList = addressBookFull;
    });
    resourceService.getResources(null, function (allResources) {
      $scope.allResources = allResources;
      $scope.resourceSearchList = allResources;
    });
  }

  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  var loadSavedFilters = function loadSavedFilters() {
    var storedFilters = {};
    var lastOrdersFilters = {};
    if (sessionStorage.getItem('ordersLastFilters')) {
      lastOrdersFilters = JSON.parse(sessionStorage.getItem('ordersLastFilters'));
    }
    if (sessionStorage.getItem('filters')) {
      storedFilters = JSON.parse(sessionStorage.getItem('filters'));
      if (storedFilters.startDate != null) {
        $scope.filters.startDate = (0, _momentTimezone2.default)(storedFilters.startDate).toDate();
        $scope.dateFilterModel.dateStart = $scope.filters.startDate;
      }
      if (storedFilters.endDate != null) {
        $scope.filters.endDate = (0, _momentTimezone2.default)(storedFilters.endDate).toDate();
        $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
      }
      if (storedFilters.customerContact != null) {
        $scope.filters.customerContact = storedFilters.customerContact;
      }
      if (storedFilters.supplierContact != null) {
        $scope.filters.supplierContact = storedFilters.supplierContact;
      }
      if (storedFilters.orderNumber != null) {
        $scope.filters.orderNumber = storedFilters.orderNumber;
      } else if (lastOrdersFilters && lastOrdersFilters.orderNumber) {
        $scope.filters.orderNumber = lastOrdersFilters.orderNumber;
      }
      if (storedFilters.supplierRefNo != null) {
        $scope.filters.supplierRefNo = storedFilters.supplierRefNo;
      } else if (lastOrdersFilters && lastOrdersFilters.supplierRefNo) {
        $scope.filters.supplierRefNo = lastOrdersFilters.supplierRefNo;
      }
      if (storedFilters.customerRefNo != null) {
        $scope.filters.customerRefNo = storedFilters.customerRefNo;
      } else if (lastOrdersFilters && lastOrdersFilters.customerRefNo) {
        $scope.filters.customerRefNo = lastOrdersFilters.customerRefNo;
      }
      if (storedFilters.reloadRequired) {
        $scope.filters.reloadRequired = storedFilters.reloadRequired;
      }
      // status filters
      /*if ( storedFilters.statusOptions ) {
        for ( var i = 0; i < statusFilterOptions.length; i++ ) {
          if ( storedFilters.statusOptions[statusFilterOptions[i]] == true ) {
            $scope.filters.statusOptions[statusFilterOptions[i]] = true;
          } else {
            $scope.filters.statusOptions[statusFilterOptions[i]] = false;
          }
        }
        if ( storedFilters.statusOptions.all == true ) {
          $scope.filters.statusOptions.all = true;
          for ( var i = 0; i < statusFilterOptions.length; i++ ) {
            $scope.filters.statusOptions[statusFilterOptions[i]] = true;
          }
        } else {
          $scope.filters.statusOptions.all = false;
        }
      }*/
      // if state params status is set - uisref status has been used and overrite status statusOptions
      /*if ( $stateParams.status != undefined ) {
        $scope.filters.statusOptions.all = false;
        for ( var i = 0; i < statusFilterOptions.length; i++ ) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        }
        $scope.filters.statusOptions[$stateParams.status] = true;
      }*/
      for (var i = 0; i < statusFilterOptions.length; i++) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }

      // load in most recent query params
      if (sessionStorage.getItem('ordersQuery') != null && sessionStorage.getItem('ordersQuery') != "undefined") {
        var queryStored = JSON.parse(sessionStorage.getItem('ordersQuery'));
        if (queryStored != null) {
          if (queryStored.limit) {
            $scope.query.limit = queryStored.limit;
          }
          if (queryStored.page) {
            $scope.query.page = queryStored.page;
          }
          if (queryStored.order) {
            $scope.query.order = queryStored.order;
          }
        }
      }
    }
    sessionStorage.setItem('filters', JSON.stringify($scope.filters));
  };

  loadSavedFilters();

  /*** New Status Filters Helpers ***/

  $scope.prettifyFilterStatusPreview = function () {
    var output = "";

    if ($scope.filters.statusOptions.all) {
      return "All";
    }

    var soFar = 0;
    if ($scope.filters.statusOptions.draft) {
      soFar += 1;
      output += "Draft";
    }
    if ($scope.filters.statusOptions.sent) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Sent";
    }
    if ($scope.filters.statusOptions.accepted) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Accepted";
    }
    if ($scope.filters.statusOptions.rejected) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Rejected";
    }
    if ($scope.filters.statusOptions.closed) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Closed";
    }
    if (soFar == 0) {
      output += "None selected";
    }
    return output;
  };

  $scope.statusFiltersChanged = function () {
    var selectedCount = 0;
    for (var option in statusFilterOptions) {
      if ($scope.filters.statusOptions[statusFilterOptions[option]]) {
        selectedCount += 1;
      }
    }
    if (selectedCount == statusFilterOptions.length) {
      $scope.filters.statusOptions.all = true;
    } else {
      $scope.filters.statusOptions.all = false;
      $scope.filters.statusOptions.allView = false;
    }
    if (!$scope.preventReloadWithFilters) {
      $scope.filtersChanged('status options');
    }
  };

  $scope.swapStatusFilter = function (option) {
    if (option == 'all' && $scope.filters.statusOptions.all == false) {
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
      $scope.filters.statusOptions.allView = true;
      $scope.filters.statusOptions.all = true;
    } else if (option == 'all' && $scope.filters.statusOptions.all == true) {
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = false;
      }
      $scope.filters.statusOptions.allView = false;
      $scope.filters.statusOptions.all = false;
    }
    $scope.statusFiltersChanged();
  };

  $scope.setOnlyFilter = function (option) {
    $scope.filters.statusOptions.all = false;
    for (var i in statusFilterOptions) {
      if (statusFilterOptions[i] != option) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = false;
      } else {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
    }
    $scope.statusFiltersChanged();
  };

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  $scope.itemEditClosed = function (itemEdit) {
    if (itemEdit && !itemEdit.editing) {
      return true;
    } else {
      return false;
    }
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    //originatorEv = ev;
    $mdOpenMenu(ev);
  };

  /**************************************/
  /***** Order Detail View Controls *****/
  /**************************************/

  var openOrder = function openOrder(order) {
    $scope.orderLoadingError = null;
    $scope.currentOrder = order;
    $scope.listView = 'orders';
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.minimiseList();
    $scope.prepareForOrderFromParent(null, order);
    orderService.getOrder(order, function (fullOrder) {
      // setup line item quantities
      for (var i = 0; i < fullOrder.lineItems.length; i++) {
        if (fullOrder.lineItems[i].resource && fullOrder.lineItems[i].resource.uom.isTime) {
          var quantity = fullOrder.lineItems[i].quantity;
          var hours = Math.floor(quantity / 60);
          var minutes = quantity % 60;
          fullOrder.lineItems[i].quantityHoursEdit = hours;
          fullOrder.lineItems[i].quantityMinutesEdit = minutes;
        } else {
          fullOrder.lineItems[i].quantityEdit = fullOrder.lineItems[i].quantity;
        }
      }
      $scope.originalOrder = angular.copy(fullOrder);
      $scope.loadOrderFromParent(fullOrder);
    }, function (err) {
      $scope.orderLoadingErrorFull = err;
      $scope.orderLoadingError = "Error Getting Order";
    });
  };

  $scope.openOrderDesktop = function (order, skipDiffCheck) {
    var currentOrder = $scope.getOrderFromParent();
    var orderId = order;
    if (orderId.id != null) {
      orderId = orderId.id;
    }
    if (currentOrder && currentOrder.id == orderId) {
      return;
    }
    if (skipDiffCheck && skipDiffCheck == true) {
      if ($scope.currentOrg) {
        $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
      } else {
        $state.go('main.orderDetail', { orderId: order.id });
      }
      return;
    }
    if (currentOrder != null && currentOrder.editing) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0 || currentOrder.id == null) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveOrder(currentOrder, function () {
                if ($scope.currentOrg) {
                  $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
                } else {
                  $state.go('main.orderDetail', { orderId: order.id });
                }
              });
            } else if (actionSelected == 'dontSave') {
              if ($scope.currentOrg) {
                $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
              } else {
                $state.go('main.orderDetail', { orderId: order.id });
              }
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          if ($scope.currentOrg) {
            $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
          } else {
            $state.go('main.orderDetail', { orderId: order.id });
          }
        }
      });
    } else {
      if ($scope.currentOrg) {
        $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
      } else {
        $state.go('main.orderDetail', { orderId: order.id });
      }
    }
  };

  var closeOrder = function closeOrder() {
    $scope.clearOrderFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    $scope.maximiseList();
  };

  $scope.closeOrder = closeOrder;

  $scope.closeOrderDesktop = function () {
    // check if existing order is in edit mode and has unsaved changes
    var currentOrder = $scope.getOrderFromParent();
    if (currentOrder != null && currentOrder.editing && !currentOrder.newOrder) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveOrder(currentOrder, function () {
                if ($scope.currentOrg) {
                  $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  $state.go('main.orders');
                }
              });
            } else if (actionSelected == 'dontSave') {
              if ($scope.currentOrg) {
                $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                $state.go('main.orders');
              }
            }
          });
        } else {
          if ($scope.currentOrg) {
            $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          } else {
            $state.go('main.orders');
          }
        }
      });
    } else {
      $scope.closeOrder();
      if ($scope.currentOrg) {
        $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else {
        $state.go('main.orders');
      }
    }
  };

  var newOrder = function newOrder() {
    $scope.listView = 'orders';
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.minimiseList();
    $scope.newOrderFromParent();
    $scope.originalOrder = {};
  };

  $scope.goToNewOrder = function (fromOption) {
    if ($scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.quotesEnabled && fromOption == 'xeroQuote') {
      $scope.quoteSelectFromParent(function (quoteSelected) {
        if (quoteSelected != null) {
          $scope.listView = 'orders';
          $scope.splitListFunc.slideTableListDetailOpen();
          $scope.minimiseList();
          $scope.newOrderFromParent('fromXeroQuote', quoteSelected);
          $scope.originalOrder = {};
        }
      });
    } else {
      $scope.listView = 'orders';
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.minimiseList();
      $scope.newOrderFromParent();
      $scope.originalOrder = {};
    }
  };

  $scope.newOrder = function (fromOption) {
    // check if existing order is in edit mode and has unsaved changes
    var currentOrder = $scope.getOrderFromParent();
    if (currentOrder != null && currentOrder.editing) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveOrder(currentOrder, function () {
                $scope.goToNewOrder(fromOption);
                //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
              });
            } else if (actionSelected == 'dontSave') {
              $scope.goToNewOrder(fromOption);
              //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
            } else {
                // do nothing - stay where we are
              }
          });
        } else {
          $scope.goToNewOrder(fromOption);
          //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
        }
      });
    } else {
      $scope.goToNewOrder(fromOption);
      //$state.go('main.groupOrderDetail', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id, orderId: 'new'});
    }
  };

  $scope.saveOrder = function (order, cb) {
    var newOrder = false;
    if (order.id == null) {
      newOrder = true;
    }
    order.loading = true;
    order.loadingType = "saving";

    // convert quantities for line items back
    if (order.lineItems) {
      for (var i = 0; i < order.lineItems.length; i++) {
        if (order.lineItems[i].resource) {
          if (order.lineItems[i].resource.uom.isTime) {
            var totalMinutes = 0;
            if (order.lineItems[i].quantityHoursEdit) {
              totalMinutes += parseInt(order.lineItems[i].quantityHoursEdit) * 60;
            }
            if (order.lineItems[i].quantityMinutesEdit) {
              totalMinutes += parseInt(order.lineItems[i].quantityMinutesEdit);
            }
            order.lineItems[i].quantity = totalMinutes;
          } else {
            order.lineItems[i].quantity = order.lineItems[i].quantityEdit;
          }
        } else {
          order.lineItems[i].quantity = order.lineItems[i].quantityEdit;
        }
      }
    }

    // docket prefill field stores - update any date fields and save in correct format
    if (order.docketPrefillValueStore && order.template) {
      var prefillKeys = Object.keys(order.docketPrefillValueStore);
      for (var i = 0; i < prefillKeys.length; i++) {
        // check against template if this field id is a date field
        for (var j = 0; j < order.template.blocks.length; j++) {
          for (var k = 0; k < order.template.blocks[j].fields.length; k++) {
            if (order.template.blocks[j].fields[k].id == prefillKeys[i] && order.template.blocks[j].fields[k].type == 'date') {
              var preValue = order.docketPrefillValueStore[prefillKeys[i]];
              var translatedValue = (0, _momentTimezone2.default)(preValue).format('YYYY-MM-DD');
              translatedValue += "T00:00:00.000Z";
              order.docketPrefillValueStore[prefillKeys[i]] = translatedValue;
            }
          }
        }
      }
    }

    // Get order diff
    orderService.getOrderDiff($scope.originalOrder, order, function (diffedOrder, diffCount) {
      if (diffCount > 0 || newOrder == true) {
        orderService.saveOrder(diffedOrder, function (orderUpdated) {
          if (newOrder) {
            if (!cb) {
              // add reloadRequired = true
              $scope.filters.reloadRequired = true;
              sessionStorage.setItem('filters', JSON.stringify($scope.filters));
              $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: orderUpdated.id });
              return;
            }
          } else {
            $scope.showToast('Order Changed Saved');
          }
          $scope.originalOrder = order;
          if (!cb) {
            openOrder(orderUpdated.id);
            $scope.loadOrdersList();
          } else {
            cb();
          }
        }, function (err) {
          $scope.alertService.presentAutoAlert('saveOrder', err);
          order.loading = false;
        });
      } else {
        order.loading = false;
        if (newOrder) {
          $scope.showToast('New Order Saved');
        } else {
          $scope.showToast('Order Changed Saved');
        }
        $scope.originalOrder = order;
        if (!cb) {
          openOrder(order.id);
          $scope.loadOrdersList();
        } else {
          cb();
        }
      }
    });
  };

  $scope.removeOrderFromCachedList = function (order) {
    var ordersListParsed = JSON.parse(sessionStorage.getItem('ordersList'));
    if (ordersListParsed) {
      var newList = [];
      for (var i = 0; i < ordersListParsed.length; i++) {
        if (ordersListParsed[i].id != order.id) {
          newList.push(ordersListParsed[i]);
        }
      }
      sessionStorage.setItem('ordersList', JSON.stringify(newList));
    }
  };

  $scope.deleteOrder = function (order) {
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete this order?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        $scope.removeOrderFromCachedList(order);
        orderService.deleteOrder(order.id, function () {
          if ($scope.currentOrg) {
            $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          } else {
            $state.go('main.orders');
          }
        });
      }
    });
  };

  $scope.editOrder = function (order) {
    order.editing = true;
  };

  $scope.cancelEditOrder = function (order) {
    order.editing = false;

    var newOrder = false;
    if (order.id == null) {
      newOrder = true;
    }

    if (newOrder) {
      $scope.closeOrder();
    } else {
      openOrder(order);
    }
  };

  $scope.reDraftOrder = function (order) {
    order.loading = true;
    order.loadingType = 'saving';
    orderService.reDraftOrder(order, function (orderUpdated) {
      openOrder(orderUpdated.id);
      $scope.loadOrdersList();
    }, function (error) {
      $scope.showToast('Error Re-Drafting Order');
      order.loading = false;
    });
  };

  $scope.sendOrder = function (order) {
    order.loading = true;
    order.loadingType = 'saving';

    // validate parameters before trying to save order
    orderService.validateSendOrder(order, function () {
      orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
        if (diffCount > 0) {
          orderService.saveOrder(diff, function (orderUpdated) {
            sendOrder(orderUpdated);
          }, function (err) {
            $scope.alertService.presentAutoAlert('saveOrder', err);
            order.loading = false;
          });
        } else {
          sendOrder(order);
        }
      });
    }, function (exceptions) {
      order.loading = false;
      $scope.alertService.presentAutoValidationAlert('sendOrder', exceptions);
    });
  };

  var sendOrder = function sendOrder(order) {
    orderService.sendOrder(order, function (order) {
      $scope.originalOrder = order;
      openOrder(order.id);
      $scope.loadOrdersList();
    }, function (error) {
      $scope.alertService.presentAutoAlert('sendOrder', error);
      order.loading = false;
    });
  };

  $scope.acceptOrder = function (order, successCb, failureCb) {
    order.loading = true;
    order.loadingType = 'saving';

    if (userService.userCanDoAction('isOrderSupplier', order) && !order.template) {
      order.template = $scope.currentOrgGroup.defaultTemplate;
    }

    orderService.validateAcceptOrder(order, function () {
      orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
        if (diffCount > 0) {
          orderService.saveOrder(diff, function (orderUpdated) {
            acceptOrder(orderUpdated, successCb, failureCb);
          }, function (err) {
            $scope.alertService.presentAutoAlert('saveOrder', err);
          });
        } else {
          acceptOrder(order, successCb, failureCb);
        }
      });
    }, function (exceptions) {
      order.loading = false;
      $scope.alertService.presentAutoValidationAlert('acceptOrder', exceptions);
    });
  };

  var acceptOrder = function acceptOrder(order, successCb, failureCb) {
    orderService.acceptOrder(order, function (orderUpdated) {
      openOrder(orderUpdated.id);
      $scope.loadOrdersList();
      if (successCb) {
        successCb();
      }
    }, function (err) {
      $scope.alertService.presentAutoAlert('acceptOrder', error);
      order.loading = false;
      if (failureCb) {
        failureCb();
      }
    });
  };

  $scope.rejectOrder = function (order) {
    order.loading = true;
    order.loadingType = 'saving';
    orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
      if (diffCount > 0) {
        orderService.saveOrder(diff, function (orderUpdated) {
          rejectOrder(orderUpdated);
        }, function (err) {
          $scope.alertService.presentAutoAlert('saveOrder', err);
        });
      } else {
        rejectOrder(order);
      }
    });
  };

  var rejectOrder = function rejectOrder(order) {
    orderService.rejectOrder(order, function (orderUpdated) {
      openOrder(orderUpdated.id);
      $scope.loadOrdersList();
    }, function (err) {
      $scope.alertService.presentAutoAlert('rejectOrder', err);
      order.loading = false;
    });
  };

  $scope.finishOrder = function (order) {
    order.loading = true;
    order.loadingType = 'saving';

    var buttonActions = [{ title: "Confirm", action: 'confirm', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
    var buttonSelected = function buttonSelected(selectedOption) {
      switch (selectedOption) {
        case "confirm":
          orderService.closeOrder(order, function (orderUpdated) {
            if ($scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled == true && $scope.currentOrg.planFeatures.accountingIntegrationEnabled == true && order.supplierRefNo && order.supplierRefNo.indexOf('xq') == 0) {
              // get quote ID
              var splits = order.supplierRefNo.split('_');
              xeroService.markXeroQuoteInvoiced(splits[2], function (success) {
                openOrder(orderUpdated.id);
                $scope.loadOrdersList();
              }, function (failed) {
                openOrder(orderUpdated.id);
                $scope.loadOrdersList();
              });
            } else {
              openOrder(orderUpdated.id);
              $scope.loadOrdersList();
            }
          }, function (error) {
            $scope.alertService.presentAutoAlert('closeOrder', error);
            order.loading = false;
          });
          break;
        default:
      };
    };
    $scope.alertService.presentConfirmAlert('Confirm Close', 'Are you sure you want to close this order? You will no longer be able to create Jobs or Dockets.', buttonActions, buttonSelected);
  };

  /********************************************/
  /***** Create New Docket/Job From Order *****/
  /********************************************/

  $scope.jobsListForOrder = function (order) {
    var currentOrder = $scope.getOrderFromParent();
    if (currentOrder != null && currentOrder.editing) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveOrder(currentOrder, function () {
                $state.go('main.groupJobs', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              });
            } else if (actionSelected == 'dontSave') {
              $state.go('main.groupJobs', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          $state.go('main.groupJobs', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      });
    } else {
      $state.go('main.groupJobs', { orderId: order.id, orderNumber: order.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }
  };

  $scope.newJobFromOrder = function (order) {
    // First check if order has been saved?
    var currentOrder = $scope.getOrderFromParent();
    orderService.validateCreateJob(order, function () {
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveOrder(currentOrder, function () {
                  $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                });
              } else if (actionSelected == 'dontSave') {
                $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }, function (exceptions) {
      order.loading = false;
      $scope.alertService.presentAutoValidationAlert('orderCreateJob', exceptions);
    });
  };

  $scope.docketsListForOrder = function (order) {
    var currentOrder = $scope.getOrderFromParent();
    if (currentOrder != null && currentOrder.editing) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveOrder(currentOrder, function () {
                $state.go('main.groupDockets', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              });
            } else if (actionSelected == 'dontSave') {
              $state.go('main.groupDockets', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          $state.go('main.groupDockets', { orderId: currentOrder.id, orderNumber: currentOrder.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      });
    } else {
      $state.go('main.groupDockets', { orderId: order.id, orderNumber: order.orderNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }
  };

  $scope.newDocketFromOrder = function (order) {
    // First check if order has been saved?
    var currentOrder = $scope.getOrderFromParent();
    orderService.validateCreateJob(order, function () {
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveOrder(currentOrder, function () {
                  $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                });
              } else if (actionSelected == 'dontSave') {
                $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: order.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }, function (exceptions) {
      order.loading = false;
      $scope.alertService.presentAutoValidationAlert('orderCreateDocket', exceptions);
    });
  };

  /**********************************/
  /***** Bulk Selection Helpers *****/
  /**********************************/

  $scope.bulkSelectionDelete = function () {
    var itemsToDelete = $scope.selected;
    $scope.clearOrderFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete these " + itemsToDelete.length + " orders?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        orderService.deleteBulkOrders(itemsToDelete, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkOrders', { status: 202, requestName: 'Delete bulk orders - failures ' + failures.length + ' of ' + itemsToDelete.length });
            $scope.loadOrdersList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkOrders', { status: 200 });
            $scope.loadOrdersList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  $scope.bulkSelectionSend = function () {
    var itemsToSend = $scope.selected;
    $scope.clearOrderFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    swal({
      title: "Are you sure?",
      text: "Do you really want to send these " + itemsToSend.length + " orders?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, send them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        orderService.sendBulkOrders(itemsToSend, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('sendBulkOrders', { status: 202, requestName: 'Send bulk orders - failures ' + failures.length + ' of ' + itemsToSend.length });
            $scope.loadOrdersList();
          } else {
            $scope.alertService.presentAutoAlert('sendBulkOrders', { status: 200 });
            $scope.loadOrdersList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  $scope.bulkSelectionAccept = function () {
    var itemsTo = $scope.selected;
    $scope.clearOrderFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    swal({
      title: "Are you sure?",
      text: "Do you really want to accept these " + itemsTo.length + " orders?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, accept them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        orderService.acceptBulkOrders(itemsTo, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('acceptBulkOrders', { status: 202, requestName: 'Accept bulk orders - failures ' + failures.length + ' of ' + itemsTo.length });
            $scope.loadOrdersList();
          } else {
            $scope.alertService.presentAutoAlert('acceptBulkOrders', { status: 200 });
            $scope.loadOrdersList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  $scope.bulkSelectionReject = function () {
    var itemsTo = $scope.selected;
    $scope.clearOrderFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    swal({
      title: "Are you sure?",
      text: "Do you really want to reject these " + itemsTo.length + " orders?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, reject them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        orderService.rejectBulkOrders(itemsTo, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('rejectBulkOrders', { status: 202, requestName: 'Reject bulk orders - failures ' + failures.length + ' of ' + itemsTo.length });
            $scope.loadOrdersList();
          } else {
            $scope.alertService.presentAutoAlert('rejectBulkOrders', { status: 200 });
            $scope.loadOrdersList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  $scope.bulkSelectionClose = function () {
    var itemsTo = $scope.selected;
    $scope.clearOrderFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    $scope.clearOrderFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    swal({
      title: "Are you sure?",
      text: "Do you really want to close these " + itemsTo.length + " orders?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, close them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        orderService.closeBulkOrders(itemsTo, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('closeBulkOrders', { status: 202, requestName: 'Close bulk orders - failures ' + failures.length + ' of ' + itemsTo.length });
            $scope.loadOrdersList();
          } else {
            $scope.alertService.presentAutoAlert('closeBulkOrders', { status: 200 });
            $scope.loadOrdersList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  /********************************/
  /****** Order List Controls *****/
  /********************************/

  $scope.filtersChanged = function (from) {
    if (!$scope.preventReloadWithFilters) {
      // check toDate is after fromDate
      if ((0, _momentTimezone2.default)($scope.filters.endDate).isBefore($scope.filters.startDate)) {
        $scope.filters.endDate = $scope.filters.startDate;
      }

      $scope.query.page = 1;

      $scope.loadOrdersList();
      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    }
  };

  $scope.ordersChildControllerReady = function () {
    // check stateParams for any filter presets
    if ($scope.currentOrg && sessionStorage.getItem('ordersList') != undefined) {
      // check if last stored orders filters is the same as current filters
      var lastOrdersFilters = {};
      if (sessionStorage.getItem('ordersLastFilters')) {
        lastOrdersFilters = JSON.parse(sessionStorage.getItem('ordersLastFilters'));
      }
      var loadNew = false;
      if (sessionStorage.getItem('filters')) {
        var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
        if (storedFilters.reloadRequired == true) {
          loadNew = true;
          $scope.filters.reloadRequired = false;
        }
      }
      if (lastOrdersFilters && lastOrdersFilters != undefined) {
        if (lastOrdersFilters.organisationId != $scope.currentOrg.id || lastOrdersFilters.groupId != $scope.currentOrgGroup.id) {
          loadNew = true;
        }
        if (lastOrdersFilters.startDate && (0, _momentTimezone2.default)(lastOrdersFilters.startDate).diff((0, _momentTimezone2.default)($scope.filters.startDate), 'days') != 0) {
          loadNew = true;
        } else if (lastOrdersFilters.endDate && (0, _momentTimezone2.default)(lastOrdersFilters.endDate).diff((0, _momentTimezone2.default)($scope.filters.endDate), 'days') != 0) {
          loadNew = true;
        }
        // check if status options have changed
        if (lastOrdersFilters.statusOptions.all == true && $scope.filters.statusOptions.all != true) {
          loadNew = true;
        } else {
          for (var i = 0; i < statusFilterOptions.length; i++) {
            if (lastOrdersFilters.statusOptions[statusFilterOptions[i]] != $scope.filters.statusOptions[statusFilterOptions[i]]) {
              loadNew = true;
            }
          }
        }
        if (lastOrdersFilters.customerContact && !$scope.filters.customerContact) {
          loadNew = true;
        } else if (!lastOrdersFilters.customerContact && $scope.filters.customerContact) {
          loadNew = true;
        } else if (!lastOrdersFilters.customerContact && !$scope.filters.customerContact) {
          // do nothing
        } else if (lastOrdersFilters.customerContact.id != $scope.filters.customerContact.id) {
          loadNew = true;
        }
        if (lastOrdersFilters.supplierContact && !$scope.filters.supplierContact) {
          loadNew = true;
        } else if (!lastOrdersFilters.supplierContact && $scope.filters.supplierContact) {
          loadNew = true;
        } else if (!lastOrdersFilters.supplierContact && !$scope.filters.supplierContact) {
          // do nothing
        } else if (lastOrdersFilters.supplierContact.id != $scope.filters.supplierContact.id) {
          loadNew = true;
        }
      } else {
        // no previous filters stored, load new list
        loadNew = true;
      }

      if (loadNew) {
        $scope.query.page = 1;
        $scope.loadOrdersList();
      } else {
        var ordersListParsed = JSON.parse(sessionStorage.getItem('ordersList'));
        var ordersListCount = JSON.parse(sessionStorage.getItem('ordersListCount'));
        $scope.loadOrdersListFromParent(ordersListParsed, ordersListCount);
        $scope.preventReloadWithFilters = false;
      }
    } else {
      $scope.loadOrdersList();
    }
  };

  $scope.detailControllerReady = function () {
    // Parameter controls to open specific order
    if ($stateParams.orderId != null) {
      if ($stateParams.orderId == 'new') {
        newOrder();
      } else {
        openOrder($stateParams.orderId);
      }
    }
  };

  $scope.loadOrdersListFromMdTable = function () {
    $scope.loadOrdersList();
  };

  $scope.loadOrdersList = function (searchValue, reload) {
    $scope.promise = $q(function (resolve, reject) {
      var params = $scope.getFilterParams();
      params['limit'] = $scope.query.limit;
      params['offset'] = $scope.query.limit * ($scope.query.page - 1);
      params['sort'] = $scope.query.order;
      params['prioritizePending'] = true;
      if (searchValue != null && searchValue != "") {
        params['search'] = searchValue;
      }

      orderService.getOrders(params, function (returnData) {
        var ordersListParsed = orderService.parseOrders(returnData);
        var count = 0;
        if (params.offset <= 0 && returnData.length < params.limit) {
          count = returnData.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        $scope.loadOrdersListFromParent(ordersListParsed, count);
        if (reload && reload == true) {
          var currentOrder = $scope.getOrderFromParent();
          if (currentOrder && !currentOrder.editing && currentOrder.id != null) {
            openOrder(currentOrder.id);
          }
        }
        $scope.preventReloadWithFilters = false;
        // store list in sessionStorage
        sessionStorage.setItem('ordersList', JSON.stringify(ordersListParsed));
        sessionStorage.setItem('ordersListCount', count);
        sessionStorage.setItem('ordersQuery', JSON.stringify($scope.query));
        sessionStorage.setItem('filters', JSON.stringify($scope.filters));
        sessionStorage.setItem('ordersLastFilters', JSON.stringify($scope.filters));
        resolve('Done');
      }, function (err) {
        reject('Error');
      });
    });
  };

  /******************************/
  /***** List View Controls *****/
  /******************************/

  $scope.selectContactFilter = function (type) {
    var existingContact = null;
    if (type == 'customer') {
      if ($scope.filters.customerContact != null) {
        existingContact = $scope.filters.customerContact;
      }
    } else {
      if ($scope.filters.supplierContact != null) {
        existingContact = $scope.filters.supplierContact;
      }
    }
    $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
      if (contactSelected != null) {
        if (type == 'customer') {
          $scope.filters.customerContact = contactSelected;
        } else {
          $scope.filters.supplierContact = contactSelected;
        }
        $scope.filtersChanged(type);
      }
    });
  };

  $scope.editContactForOrder = function (contactItem, cb) {
    $scope.editContactFromParent(contactItem, function (contactEdited) {
      cb(contactEdited);
    });
  };

  $scope.selectContactForShare = function (cb) {
    $scope.contactSelectFromParent(null, null, function (contactSelected) {
      cb(contactSelected);
    });
  };

  $scope.selectContactForOrder = function (order, companyType, cb) {
    $scope.selectContactCallback = cb;
    var existingContacts = [];
    var selectedContact = null;
    if (companyType == 'customerContact') {
      if (order.supplierContact != null) {
        existingContacts.push(order.supplierContact);
      }
      if (order.customerContact != null) {
        selectedContact = order.customerContact;
      }
    } else if (companyType == 'supplierContact') {
      if (order.customerContact != null) {
        existingContacts.push(order.customerContact);
      }
      if (order.supplierContact != null) {
        selectedContact = order.supplierContact;
      }
    }

    if (selectedContact) {
      var newContactAddresses = [];
      var keys = Object.keys(selectedContact.contactAddresses);
      for (var i = 0; i < keys.length; i++) {
        var newContactAddress = {};
        newContactAddress.emailAddress = keys[i];
        newContactAddress.accessLevel = selectedContact.contactAddresses[keys[i]][0];
        newContactAddresses.push(newContactAddress);
      }
      selectedContact.contactAddresses = newContactAddresses;
      for (var i = 0; i < selectedContact.addresses.length; i++) {
        var address = selectedContact.addresses[i];
        if (address.streetNum == null) {
          delete address.streetNum;
        }
        if (address.streetName == null) {
          delete address.streetName;
        }
      }
    }

    $scope.contactSelectFromParent(existingContacts, selectedContact, function (contactSelected) {
      $scope.selectContactCallback(contactSelected);
    });
  };

  $scope.selectTemplateForOrder = function (sourceList, cb) {
    $scope.selectTemplateCallback = cb;
    $scope.templateSelectFromParent(sourceList, function (templateSelected) {
      $scope.selectTemplateCallback(templateSelected);
    });
  };

  $scope.selectResourceForOrder = function (options, cb) {
    $scope.selectResourceCallback = cb;
    $scope.desktopResourceSelectFromParent(options, function (resourcesSelected) {
      $scope.selectResourceCallback(resourcesSelected);
    });
  };

  $scope.selectOrganisationForOrder = function (order, cb) {
    $("#assignOrderModal").fadeIn(100);
    $scope.selectOrganisationCallback = cb;
    $scope.assignOrder = {};
    $scope.assignOrder.selected = [];
    $scope.assignOrder.orderNumber = order.orderNumber;
    $scope.assignOrder.organisations = accessControl.allowedOrganisations();
  };

  $scope.assignOrderContinue = function () {
    var group = $scope.assignOrder.selected[0];
    $("#assignOrderModal").fadeOut(100);
    $scope.selectOrganisationCallback(group);
  };

  $scope.closeAssignOrderModal = function () {
    $("#assignOrderModal").fadeOut(100);
    $scope.selectOrganisationCallback(null, null);
  };

  /******************************************/
  /**** List Selector & Search Controls *****/
  /******************************************/

  $scope.searchCustomerChange = function (item, searchText) {
    if (searchText == "") {
      $scope.addressBookSearchList = $scope.addressBook;
      return;
    }

    var filteredList = [];
    for (var i = 0; i < $scope.addressBook.length; i++) {
      if ($scope.addressBook[i].displayName.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
        filteredList.push($scope.addressBook[i]);
      }
    }

    $scope.addressBookSearchList = filteredList;
  };

  $scope.searchSupplierChange = function (item, searchText) {
    if (searchText == "") {
      $scope.addressBookSearchList = $scope.addressBook;
      return;
    }

    var filteredList = [];
    for (var i = 0; i < $scope.addressBook.length; i++) {
      if ($scope.addressBook[i].displayName.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
        filteredList.push($scope.addressBook[i]);
      }
    }

    $scope.addressBookSearchList = filteredList;
  };

  $scope.selectCustomerChange = function (orderEdit) {
    // make sure customer contact is formatted correctly
    if (orderEdit.customerContact != null) {
      var newContactAddresses = {};
      for (var i = 0; i < orderEdit.customerContact.contactAddresses.length; i++) {
        newContactAddresses[orderEdit.customerContact.contactAddresses[i].emailAddress] = ['approver'];
      }
      orderEdit.customerContact.contactAddresses = newContactAddresses;
    }
  };

  $scope.selectSupplierChange = function (orderEdit) {
    // make sure supplier contact is formatted correctly
    if (orderEdit.supplierContact) {
      var newContactAddresses = {};
      for (var i = 0; i < orderEdit.supplierContact.contactAddresses.length; i++) {
        newContactAddresses[orderEdit.supplierContact.contactAddresses[i].emailAddress] = ['approver'];
      }
      orderEdit.supplierContact.contactAddresses = newContactAddresses;
    }
  };

  /*******************/
  /***** Filters *****/
  /*******************/

  $scope.toggleFilters = function () {
    $scope.showFilters = !$scope.showFilters;
  };

  $scope.resetAllFilters = function () {
    // SETUP filters
    $scope.filters = {};
    $scope.filters.status = 'All';
    $scope.filters.startFromDate = null; //moment().subtract(7,'days').toDate();
    $scope.filters.startToDate = null;
    $scope.filters.endFromDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.filters.endToDate = null;
    $scope.filters.orderNumber = null;
    $scope.filters.supplierRefNo = null;
    $scope.filters.customerRefNo = null;
  };

  $scope.searchOrdersChange = function (value) {
    $scope.loadOrdersList(value);
  };

  $scope.clearFilters = function () {
    $scope.filters.customerContact = null;
    $scope.filters.supplierContact = null;
    $scope.filters.customerRefNo = null;
    $scope.filters.supplierRefNo = null;
    $scope.filters.orderNumber = null;
    for (var i in statusFilterOptions) {
      $scope.filters.statusOptions[statusFilterOptions[i]] = true;
    }
    $scope.filters.statusOptions.allView = true;
    $scope.filters.statusOptions.all = true;
    // reset date filters
    $scope.filters.startDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate(); //startFromDate
    $scope.filters.endDate = (0, _momentTimezone2.default)().toDate(); //endToDate
    $scope.dateFilterModel.dateStart = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.dateFilterModel.dateEnd = (0, _momentTimezone2.default)().toDate();
    $scope.filtersChanged('cleared');
    window.location.reload();
  };

  $scope.clearFilterItem = function (name) {
    $scope.filters[name] = null;
    $scope.filtersChanged(name);
  };

  $scope.clearFilterDateSet = function (firstDate, secondDate) {
    $scope.filters[firstDate] = null;
    $scope.filters[secondDate] = null;
  };

  $scope.getFilterParams = function () {
    var params = {};
    if ($scope.filters.endDate != null) {
      var startToDate = (0, _momentTimezone2.default)($scope.filters.endDate);
      params.startToDate = startToDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.startDate != null) {
      var endFromDate = (0, _momentTimezone2.default)($scope.filters.startDate);
      params.endFromDate = endFromDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.statusOptions.all == true) {
      params['status'] = null;
    } else {
      var statusParam = "";
      var count = 0;
      for (var i in statusFilterOptions) {
        if ($scope.filters.statusOptions[statusFilterOptions[i]] == true) {
          count += 1;
          if (count > 1) {
            statusParam += ",";
          }
          statusParam += statusFilterOptions[i];
        }
      }
      params['statusList'] = statusParam;
      params['status'] = null;
    }
    if ($scope.filters.supplierRefNo != null && $scope.filters.supplierRefNo != "") {
      params.supplierRefNo = $scope.filters.supplierRefNo;
    }
    if ($scope.filters.customerRefNo != null && $scope.filters.customerRefNo != "") {
      params.customerRefNo = $scope.filters.customerRefNo;
    }
    if ($scope.filters.customerContact != null) {
      if ($scope.filters.customerContact.contactAddresses.length > 0) {
        var customerAddresses = [];
        for (var i = 0; i < $scope.filters.customerContact.contactAddresses.length; i++) {
          customerAddresses.push($scope.filters.customerContact.contactAddresses[i].emailAddress);
        }
        params.customer = customerAddresses.join(',');
      } else {
        params.search = $scope.filters.customerContact.displayName;
      }
    }
    if ($scope.filters.supplierContact != null) {
      var supplierAddresses = [];
      for (var i = 0; i < $scope.filters.supplierContact.contactAddresses.length; i++) {
        supplierAddresses.push($scope.filters.supplierContact.contactAddresses[i].emailAddress);
      }
      params.supplier = supplierAddresses.join(',');
    }
    if ($scope.filters.orderNumber != null && $scope.filters.orderNumber != "") {
      params.orderNumber = $scope.filters.orderNumber;
    }

    return params;
  };

  /*$scope.updateFilterHeading = function() {
    var newHeading = "Filtered by";
    var filterCount = 0;
    if ( $scope.filters.customerContact != null ) {
      newHeading += " customer " + $scope.filters.customerContact.displayName + ",";
      filterCount += 1;
    }
    if ( $scope.filters.supplierContact != null ) {
      newHeading += " supplier " + $scope.filters.supplierContact.displayName + ",";
      filterCount += 1;
    }
    if ( $scope.filters.customerRefNo != null && $scope.filters.customerRefNo != "" ) {
      newHeading += " customer ref no " + $scope.filters.customerRefNo + ",";
      filterCount += 1;
    }
    if ( $scope.filters.supplierRefNo != null && $scope.filters.supplierRefNo != "" ) {
      newHeading += " supplier ref no " + $scope.filters.supplierRefNo + ",";
      filterCount += 1;
    }
    if ( $scope.filters.startFromDate != null || $scope.filters.endToDate != null || $scope.filters.startToDate != null || $scope.filters.endFromDate != null ) {
      newHeading += " date range,";
      filterCount += 1;
    }
    if ( newHeading[newHeading.length - 1] == "," ) {
      newHeading = newHeading.substring(0, newHeading.length - 1);
    }
    if ( filterCount > 0 ) {
      $scope.activeFilters = filterCount;
      $scope.filterHeading = newHeading;
    } else {
      $scope.activeFilters = 0;
      $scope.filterHeading = "";
    }
  }*/

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "B5fK":
/***/ (function(module, exports) {

var path = 'views/modals/viewContactModal.html';
var html = "<div class=\"niceModal\" id=\"viewContactModal\">\n  <div class=\"modalContainer\">\n    <div class=\"mobileDetailHeader visible-xs\">\n      <div class=\"backButton\" ng-click=\"closeViewContactModal()\"></div>\n      <div class=\"contactItemHeader\">\n        <div class=\"avatar\">\n          {{contactDetail.initials}}\n        </div>\n        <div class=\"contactName\" ng-if=\"!contactDetail.editing\">\n          {{contactDetail.displayName}}\n        </div>\n        <div class=\"contactName\" ng-if=\"contactDetail.editing\">\n          <md-input-container class=\"md-block\" flex-gt-sm>\n            <input ng-model=\"contactDetail.displayName\" aria-label=\"Contact Display Name\">\n          </md-input-container>\n        </div>\n      </div>\n      <div class=\"doneButton\" ng-click=\"editContactDetails()\" ng-if=\"!contactDetail.editing\">Edit</div>\n      <div class=\"doneButton\" ng-click=\"saveContactDetails()\" ng-if=\"contactDetail.editing\">Save</div>\n    </div>\n    <div class=\"content noPadding contact\">\n      <md-list>\n        <md-subheader class=\"md-no-sticky\">Addresses</md-subheader>\n        <md-list-item ng-show=\"!contactDetail.addressesEdit || contactDetail.addressesEdit.length <= 0\">\n          This contact has no addresses\n        </md-list-item>\n        <md-list-item ng-repeat=\"address in contactDetail.addressesEdit\" class=\"addressItem\">\n          <md-checkbox ng-model=\"address.selected\" ng-if=\"!contactDetail.editing\"></md-checkbox>\n          <p>{{stringifyAddress(address.address)}}</p>\n        </md-list-item>\n\n        <md-subheader class=\"md-no-sticky extra-margin\">Email Addresses</md-subheader>\n        <md-list-item ng-repeat=\"address in contactDetail.contactAddresses\" class=\"addressItem\">\n          <md-checkbox ng-model=\"address.selected\" ng-if=\"!contactDetail.editing\"></md-checkbox>\n          <p ng-if=\"!contactDetail.editing\">{{address.emailAddress}}</p>\n          <md-input-container class=\"md-block\" ng-if=\"contactDetail.editing\">\n            <input ng-model=\"address.emailAddress\" aria-label=\"Contact Email Address\">\n          </md-input-container>\n        </md-list-item>\n      </md-list>\n\n      <div class=\"fullWidthButtonOuter\" ng-if=\"!contactDetail.editing\">\n        <div class=\"fullWidthButton\" ng-click=\"mobileContactContinue(contactDetail)\">\n          Continue\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "BLrg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _sweetalert = __webpack_require__("z3Aj");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('adminAccountController', ['$location', '$scope', '$rootScope', 'Restangular', '$state', '$stateParams', 'accessControl', '$timeout', function ($location, $scope, $rootScope, Restangular, $state, $stateParams, accessControl, $timeout) {
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentUser = accessControl.currentUser();
  $scope.myAccount = true;
  $scope.pincodeActive = false;
  $scope.pincodeInput = '';
  $scope.verify = {};
  $scope.verify.loading = false;
  $scope.pass = {
    changingPassword: false
  };
  $scope.phoneRegister = {
    state: 'start'
  };
  $scope.emailRegister = {
    state: 'start'
  };

  var baseUser = Restangular.all('user');

  $scope.organisations = accessControl.allowedOrganisations();

  $rootScope.$on('OrganisationsListRefreshed', function () {
    $scope.organisations = accessControl.allowedOrganisations();
  });

  $rootScope.$on('ScopeUpdated', function () {
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.closeScopeDropdown();
  });

  /* Create a new company */
  $scope.newCompany = function (isSampleCompany) {
    $scope.closeScopeDropdown();
    $scope.createNewCompanyFromParent(isSampleCompany, function (newOrg) {
      if (newOrg != null) {
        $state.go('main.groupDashboard', { orgId: newOrg.id });
      }
    });
  };

  /********************************/
  /***** Account Funtionality *****/
  /********************************/

  function getCurrentUserActual() {
    var addresses = [$scope.currentUser.emailAddress];
    $scope.currentUser.emailAddresses.forEach(function (addr) {
      if (addresses.indexOf(addr) === -1) {
        addresses.push(addr);
      }
    });

    addresses.forEach(function (addr) {
      var left = addr.split('@')[0];
      if (left[0] === '+' && !isNaN(left.substring(1))) {
        $scope.currentUser.hasPhoneNumber = true;
        if (!$scope.currentUser.realPhoneNumber) {
          var adjusted = '0' + left.substring(3);
          $scope.currentUser.realPhoneNumber = adjusted;
        }
        //need to check if its unverified
        var isUnverified = false;
        if ($scope.currentUser.unverifiedPrincipals) {
          $scope.currentUser.unverifiedPrincipals.forEach(function (prin) {
            if (prin === addr) {
              isUnverified = true;
            }
          });
        }
        if (isUnverified) {
          $scope.currentUser.hasUnverifiedPhoneNumber = true;
          $scope.currentUser.unverifiedPhoneNumber = addr;
        }
      } else {
        $scope.currentUser.hasEmailAddress = true;
        if (!$scope.currentUser.realEmailAddress) {
          $scope.currentUser.realEmailAddress = addr;
        }
      }
    });
    $scope.currentUser.loading = false;
    $scope.userOriginal = angular.copy($scope.currentUser);
    return;
  }

  getCurrentUserActual();

  $scope.updateAccountForNotifications = function () {
    $scope.currentUser.loading = true;
    var sendData = {
      preferEmailNotifications: $scope.currentUser.preferEmailNotifications,
      docketPdfInNotifications: $scope.currentUser.docketPdfInNotifications,
      receiveSelfNotifications: $scope.currentUser.receiveSelfNotifications,
      receiveOrderNotifications: $scope.currentUser.receiveOrderNotifications
    };
    baseUser.customPUT(sendData).then($scope.updateAccountSuccess, $scope.updateAccountFailure);
  };

  $scope.updateAccount = function (isValid) {
    $scope.currentUser.loading = true;
    var sendData = {};
    var keys = Object.keys($scope.currentUser);
    keys.forEach(function (key) {
      if (key != 'password' && key != 'pinCode') {
        if (!angular.equals($scope.currentUser[key], $scope.userOriginal[key])) {
          sendData[key] = $scope.currentUser[key];
        }
      }
      if (sendData.name != null && sendData.name.full != null) {
        delete sendData.name.full;
      }
    });

    if ($scope.currentUser.password) {
      sendData.password = $scope.currentUser.password;
    }
    if ($scope.currentUser.pinCode) {
      sendData.pinCode = $scope.currentUser.pinCode;
    }

    delete sendData.loading;

    baseUser.customPUT(sendData).then($scope.updateAccountSuccess, $scope.updateAccountFailure);
  };
  $scope.changePassword = function (isValid) {
    if ($scope.pass.password !== $scope.pass.confirmPassword) {
      (0, _sweetalert2.default)({
        title: "Oops!",
        text: "Your passwords do not match.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return;
    }
    var sendData = {
      password: $scope.pass.password
    };
    baseUser.one('password').customPUT(sendData).then(function (result) {
      (0, _sweetalert2.default)("Password updated!", "Use your new password when you login next time", "success");
    }).catch(function (err) {
      (0, _sweetalert2.default)({
        title: "Oops!",
        text: "We couldn't update your password. Please try again later",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    });
  };

  $scope.registerPhoneNumber = function () {
    if ($scope.phoneRegister.phoneNumber.length !== 10 || $scope.phoneRegister.phoneNumber.substring(0, 2) !== '04') {
      (0, _sweetalert2.default)({
        title: "Oops!",
        text: "Please enter a valid mobile phone number",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return;
    }
    var adjusted = "+61" + $scope.phoneRegister.phoneNumber.substring(1);
    var postObj = {
      address: adjusted
    };
    return baseUser.one('address').customPOST(postObj).then(function (result) {
      $scope.verifyPledge = result;
      $scope.phoneRegister.state = 'verify';
    }).catch(function (err) {
      if (err.status === 409) {
        (0, _sweetalert2.default)({
          title: "Oops!",
          text: "That number is already registered to another user.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      } else {
        (0, _sweetalert2.default)({
          title: "Oops!",
          text: "Unable to register your number. Please try again later",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      }
    });
  };

  $scope.registerEmailAddress = function () {
    var postObj = {
      address: $scope.emailRegister.emailAddress
    };
    return baseUser.one('address').customPOST(postObj).then(function (result) {
      $scope.emailRegister.state = 'verify';
    }).catch(function (err) {
      if (err.status === 409) {
        (0, _sweetalert2.default)({
          title: "Oops!",
          text: "That email address is already registered to another user.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      } else {
        (0, _sweetalert2.default)({
          title: "Oops!",
          text: "Unable to register your number. Please try again later",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      }
    });
  };

  $scope.verifyPhoneNumber = function () {
    if ($scope.phoneRegister.verificationCode.length !== 6) {
      (0, _sweetalert2.default)({
        title: "Oops!",
        text: "The verification code needs to be 6 digits",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return;
    }
    return baseUser.one('address').one($scope.verifyPledge.id).one('verify').customPUT({
      secret: $scope.phoneRegister.verificationCode
    }).then(function (result) {
      $scope.phoneRegister.state = 'done';
      $scope.currentUser.hasPhoneNumber = true;
      $scope.currentUser.realPhoneNumber = $scope.phoneRegister.phoneNumber;
    });
  };

  $scope.confirmUnverifiedPhoneNumber = function () {
    if ($scope.phoneRegister.verificationCode.length !== 6) {
      (0, _sweetalert2.default)({
        title: "Oops!",
        text: "The verification code needs to be 6 digits",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return;
    }
    return baseUser.one('principal').customPOST({
      principal: $scope.currentUser.unverifiedPhoneNumber,
      secret: $scope.phoneRegister.verificationCode
    }).then(function (result) {
      delete $scope.currentUser.unverifiedPhoneNumber;
      $scope.currentUser.hasUnverifiedPhoneNumber = false;
      $scope.phoneRegister.state = 'done';
      accessControl.refreshCurrentUser();
    });
  };

  $scope.updateAccountSuccess = function () {
    getCurrentUserActual($stateParams.currentUser.id);
    (0, _sweetalert2.default)("Account updated!", "Changes will be effective the next time you log in.", "success");
  };

  $scope.updateAccountFailure = function (err) {
    $scope.currentUser.loading = false;
    (0, _sweetalert2.default)({
      title: "Oops!",
      text: "Something bad happened while we were trying to update your account, please try again.",
      type: "error",
      confirmButtonText: "Ok, got it."
    });
  };

  $scope.setPincode = function () {
    $scope.pincodeActive = true;
    $("#pincodeModal").fadeIn(100);
  };

  /* Pincode functionality */
  var resetPincode = function resetPincode() {
    var dotCount = [1, 2, 3, 4];
    var numberCount = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    $scope.pincodeInput = '';
    $timeout(function () {
      dotCount.forEach(function (dotNumber) {
        $("#dot" + dotNumber).removeAttr('class');
        $("#dot" + dotNumber).attr('class', 'dot');
        $("#dot" + dotNumber)[0].className = 'dot';
      });
      numberCount.forEach(function (number) {
        $("#number" + number).removeAttr('class');
        $("#number" + number).attr('class', 'number');
        $("#number" + number)[0].className = 'number';
      });
    }, 1000);
  };

  $scope.closePincodeModal = function () {
    resetPincode();
    $scope.pincodeActive = false;
    $("#pincodeModal").fadeOut(100);
  };

  /* Pincode Functionality */
  $scope.pinPress = function (number) {
    var dotCount = [1, 2, 3, 4];
    $scope.pincodeInput += number;
    $("#number" + number).addClass('grow');
    $("#dot" + $scope.pincodeInput.length).addClass('active');
    $timeout(function () {
      $("#number" + number).removeAttr('class');
      $("#number" + number).attr('class', 'number');
      $("#number" + number)[0].className = 'number';
    }, 900);
    if ($scope.pincodeInput.length >= 4) {
      // add pincode to user account
      $scope.currentUser.pinCode = $scope.pincodeInput;
      $scope.closePincodeModal();
    }
  };

  $(document).on('keypress', function (e) {
    var charCode = e.charCode;
    if ($scope.pincodeActive && charCode >= 49 && charCode <= 57) {
      var number = charCode - 48;
      if (number > 0) {
        $scope.pinPress(number);
      }
    }
  });

  /* PHONE VERIFICATION */
  $scope.checkVerificationCode = function () {
    $scope.verify.loading = true;
    var postObj = {};
    postObj.phoneNumber = $scope.currentUser.phoneNumber;
    postObj.verificationCode = $scope.verify.verificationCode;
    Restangular.all('verify').all('phone').customPOST(postObj).then(function () {
      $scope.verify = {};
      // TODO: update the user account
      delete $scope.currentUser.phoneVerificationCode;
      // verify code correct -success
    }, function (err) {
      // error occured during verification
      $scope.verify.loading = false;
      alert('err');
    });
  };

  /*** ORG SCOPE FUNCTIONS - FOR MOBILE ****/
  $scope.openScopeDropdown = function () {
    $(".mobileSideNav").animate({
      left: "0px"
    }, 400);
    /*$("body").addClass('noscroll');*/
  };

  $scope.closeScopeDropdown = function () {
    $(".mobileSideNav").animate({
      left: "-90%"
    }, 400);
    /*$("body").removeClass('noscroll');*/
  };

  $scope.changeOrganisation = function (org) {
    if (org != null) {
      var locatedOrgGroup = null;
      for (var i = 0; i < org.groups.length; i++) {
        if (org.groups[i].parent == null) {
          locatedOrgGroup = org.groups[i];
          break;
        }
      }
      if (locatedOrgGroup == null && org.groups && org.groups.length > 0) {
        locatedOrgGroup = org.groups[0];
      }
      $scope.changeOrganisationGroup(org, locatedOrgGroup);
    } else {
      $state.go('main.dashboard');
    }
  };

  $scope.changeOrganisationGroup = function (org, orgGroup) {
    accessControl.getOrgPagePermissions(org, orgGroup, function (res) {
      var permissions = res.permissions[$scope.currentUser.id];
      if (permissions.indexOf('group-owner') != -1 || permissions.indexOf('global-administrator') != -1) {
        $state.go('main.groupOrders', { orgId: org.id, groupId: orgGroup.id });
      } else if (permissions.indexOf('io.docketbook.ojdapi.getOrder') != -1) {
        $state.go('main.groupOrders', { orgId: org.id, groupId: orgGroup.id });
      } else if (permissions.indexOf('io.docketbook.ojdapi.getJob') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyJob') != -1) {
        $state.go('main.groupJobs', { orgId: org.id, groupId: orgGroup.id });
      } else if (permissions.indexOf('io.docketbook.ojdapi.getDocket') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyDocket') != -1) {
        $state.go('main.groupDockets', { orgId: org.id, groupId: orgGroup.id });
      } else {
        $state.go('main.groupDashboard', { orgId: org.id, groupId: orgGroup.id });
      }
    });
  };

  $scope.logout = function () {
    window.location.href = "/v1/logout";
  };

  /******** END TEST ORG SCOPE STUFF ************/
  /*************************/
  /***** Intercom JS API  **/
  /*************************/

  $scope.openIntercom = function () {
    window.FreshworksWidget('open', 'ticketForm');
  };

  /***********************/
  /***** Permissions *****/
  /***********************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "BN4o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('recommendLineItemResourceModalController', ['addressBookService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', 'docketService', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {

  $scope.loading = false;
  $scope.resources = [];
  $scope.lineItem = {};

  $scope.acceptCb = null;
  $scope.continueToSearchCb = null;
  $scope.selectedResources = [];

  $scope.$parent.showRecommendLineItemResourceModal = function (lineItem, resources, acceptCb, continueToSearchCb) {
    $scope.resources = resources;

    if (resources.length == 1) {
      $scope.selectedResources = resources;
    }
    $scope.lineItem = lineItem;
    $scope.acceptCb = acceptCb;
    $scope.continueToSearchCb = continueToSearchCb;

    $('#recommendLineItemResourceModal').fadeIn(100);
  };

  $scope.continueToSearch = function () {
    $('#recommendLineItemResourceModal').fadeOut(100);
    $scope.continueToSearchCb();
  };

  $scope.close = function () {
    $('#recommendLineItemResourceModal').fadeOut(100);
  };

  $scope.addResource = function () {
    $('#recommendLineItemResourceModal').fadeOut(100);

    $scope.acceptCb($scope.selectedResources[0]);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "BOhu":
/***/ (function(module, exports) {

var path = 'views/selectors/companyList.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"contactSearchLoading || contactLoadingError\">\n  <div my-loader text=\"Loading Contacts\" ng-if=\"contactSearchLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"contactLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{contactLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"loadContactSearchList()\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListTopContainer showMobile\">\n    <div class=\"contentSplitListTopInner\">\n      <div class=\"contentHeader selectCompany\">\n        <h2>\n          Select Contact\n          <span ng-if=\"selectCompantType == 'customerContact'\">Customer</span>\n          <span ng-if=\"selectCompanyType == 'supplierContact'\">Supplier</span>\n        </h2>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"contact in contactSearchList\" ng-click=\"mobileSelectContact(contact)\" id=\"listItem{{contact.id}}\">\n          <div class=\"listRowItem itemNumber\">{{contact.displayName}}</div>\n          <div class=\"listRowItem collapsedDetail\">{{contact.contactAddresses[0].emailAddress}}</div>\n        </div>\n\n        <div class=\"mobileListButtons hidden-xs\">\n          <div class=\"btn btn-rounded btn-primary\" ng-click=\"closeContactSelectList()\">\n            Cancel\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Bi8V":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/fields.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\">\n    <div class=\"left\">\n      <h3>Fields</h3>\n    </div>\n    <div class=\"right\">\n      <md-button class=\"md-icon-button\" ng-click=\"openNewFieldModal()\" aria-label=\"New Field\">\n        <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n      </md-button>\n      <md-button class=\"md-icon-button\" ng-click=\"loadFieldsList()\" aria-label=\"Reload Fields List\">\n        <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n      </md-button>\n      <md-menu>\n        <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n          <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"4\">\n          <md-menu-item ng-click=\"deleteSelectedFields()\" aria-label=\"Delete Selected Fields\">\n            <md-button>\n              Delete Selected Fields\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </div>\n  </div>\n\n  <div class=\"settingsTableOuterContainer\">\n    <md-table-container>\n      <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column><span>Display Name</span></th>\n            <th md-column><span>Mandatory</span></th>\n            <th md-column><span>Type</span></th>\n            <th md-column><span>Identifier</span></th>\n            <th md-column></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row md-select=\"field\" md-select-id=\"id\" ng-repeat=\"field in allFields\" ng-click=\"editField(field)\" style=\"cursor: pointer;\">\n            <td md-cell>{{field.displayName}}</td>\n            <td md-cell>\n              {{field.mandatory ? 'Yes' : 'No'}}\n            </td>\n            <td md-cell>\n              {{field.type}}\n            </td>\n            <td md-cell>{{field.id}}</td>\n            <td md-cell>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n    <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadFieldsList\" md-total=\"{{listCount}}\" md-page-select>\n    </md-table-pagination>\n  </div>\n</div>\n\n<ng-include src=\"'views/modals/fieldModal.html'\" ng-controller=\"fieldModalController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "BjMu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('lineItemModalController', ['userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', 'accessControl', '$timeout', 'geolocation', function (userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

  $scope.orderEditing = null;

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.newLineItemFromParent = function (order, cb) {
    $scope.lineItemCallback = cb;
    $scope.lineItemDetail = {};
    $scope.lineItemDetail.quantityEdit = 0;
    $scope.orderEditing = order;
    if (userService.userCanDoAction('isOrderSupplier', order)) {
      $scope.selectResource();
      $scope.lineItemDetail.customerCreated = false;
    } else {
      $scope.lineItemDetail.customerCreated = true;
      $("#lineItemModal").fadeIn(100);
    }

    //$("#lineItemModal").fadeIn(100);
  };

  $scope.$parent.editLineItemFromParent = function (order, item, cb) {
    $scope.lineItemCallback = cb;
    $scope.lineItemDetail = item;
    $scope.orderEditing = order;

    $("#lineItemModal").fadeIn(100);
  };

  /*******************************/
  /***** Line Item Functions *****/
  /*******************************/

  $scope.closeLineItemModal = function () {
    $("#lineItemModal").fadeOut(100);
    $scope.lineItemCallback(null);
  };

  $scope.selectResource = function () {
    $("#lineItemModal").fadeOut(100);
    $scope.$parent.selectResourceForLine(function (resourceSelected) {
      if (resourceSelected == null) {
        $scope.lineItemCallback();
      } else {
        $scope.lineItemDetail.resource = resourceSelected;
        $("#lineItemModal").fadeIn(100);
      }
    });
  };

  $scope.saveLineItem = function () {
    $("#lineItemModal").fadeOut(100);
    $scope.lineItemCallback($scope.lineItemDetail);
  };

  /***************************************/
  /***** Quantity Edit Functionality *****/
  /***************************************/

  // Mobile only - edit line item quantity
  $scope.editLineItemQuantity = function (lineItemDetail) {
    $("#lineItemModal").fadeOut(100);
    //$("#quantityKeypadModal").fadeIn(100);
    $scope.quantityKeypadValue = angular.copy(lineItemDetail.quantityEdit);
    $scope.quantityKeypadUom = lineItemDetail.resource.uom;
  };

  $scope.closeQuantityEditModal = function () {
    //$("#quantityKeypadModal").fadeOut(100);
    $("#lineItemModal").fadeIn(100);
  };

  $scope.saveQuantityEdit = function () {
    var newValueFloat = parseFloat($scope.quantityKeypadValue);
    $scope.lineItemDetail.quantityEdit = newValueFloat;
    $scope.closeQuantityEditModal();
  };

  $scope.keypadButtonPress = function (buttonValue) {
    if ($scope.quantityKeypadValue == null) {
      $scope.quantityKeypadValue = 0;
    }

    var currentValString = $scope.quantityKeypadValue.toString();

    if (buttonValue == '.') {
      currentValString += ".";
    } else if (buttonValue == 'back') {
      if (currentValString.length > 1) {
        currentValString = currentValString.substring(0, currentValString.length - 1);
      } else if (currentValString.length == 1) {
        currentValString = "0";
      }
    } else {
      if (currentValString == "0") {
        currentValString = buttonValue.toString();
      } else {
        currentValString += buttonValue.toString();
      }
    }

    $scope.quantityKeypadValue = currentValString;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "CLCx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clearSvg = __webpack_require__("8Pnt");

angular.module('docketbook').controller('timesheetsDesktopController', ['docketService', 'orderService', 'resourceService', 'userService', 'batchService', 'xeroService', 'addressBookService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$q', '$location', function (docketService, orderService, resourceService, userService, batchService, xeroService, addressBookService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q, $location) {
  mixpanel.track("Opened Timesheets Desktop");

  $scope.clearSvgImagePath = clearSvg;
  /***************************/
  /***** Setup Variables *****/
  /***************************/
  $scope.moment = _momentTimezone2.default;

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  $scope.fullApiPath = "" + "/" + $scope.urlVersion;

  $scope.showFilters = false;
  $scope.preventReloadWithFilters = true;

  $scope.weekStartDay = 'monday';
  var startDayTransform = { 'monday': 1, 'tuesday': 2, 'wednesday': 3, 'thursday': 4, 'friday': 5, 'saturday': 6, 'sunday': 0 };

  // AAEH Custom work week modifier - temporary
  if ($scope.currentOrg && $scope.currentOrg.id == '0135a923-c035-46c0-9d95-f047f797f75e') {
    $scope.weekStartDay = 'friday';
  }

  $scope.weekStartDayNum = startDayTransform[$scope.weekStartDay];

  // Filters initial
  $scope.filters = {};
  $scope.filters.status = "All";
  $scope.filters.startFromDate = (0, _momentTimezone2.default)().startOf('week').add('days', $scope.weekStartDayNum).toDate(); // was 1
  $scope.filters.endToDate = (0, _momentTimezone2.default)().startOf('week').add('days', $scope.weekStartDayNum + 6).toDate(); // was 7
  $scope.filters.author = null;
  $scope.filterHeading = "";
  $scope.activeFilters = 0;

  // New list query pagination
  $scope.query = {
    limit: 30,
    page: 1,
    order: 'date'
  };
  $scope.promise = null;

  // Timesheets data
  $scope.allDockets = [];
  $scope.userSummaries = {};
  $scope.timeDaySummaries = {};
  $scope.allUsers = [];
  $scope.orderedUsers = [];

  $scope.loadUsers = function (cb) {
    userService.getMembers(null, function (users) {
      $scope.allUsers = users;
      cb();
    }, function (err) {
      $scope.allUsers = [];
      cb();
    });
  };

  // Allocations filter go back a week
  $scope.jobAllocationsFiltersBackWeek = function () {
    var startWeek = (0, _momentTimezone2.default)($scope.filters.startFromDate).subtract('week', 1);
    $scope.filters.endToDate = (0, _momentTimezone2.default)(startWeek).add('days', 6).toDate();
    $scope.filters.startFromDate = startWeek.toDate();
    sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    $scope.loadDocketsList();
  };

  // Allocations filter go forward a week
  $scope.jobAllocationsFiltersNextWeek = function () {
    var startWeek = (0, _momentTimezone2.default)($scope.filters.startFromDate).add('week', 1);
    $scope.filters.endToDate = (0, _momentTimezone2.default)(startWeek).add('days', 6).toDate();
    $scope.filters.startFromDate = startWeek.toDate();
    sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    $scope.loadDocketsList();
  };

  // Load Dockets
  $scope.loadDocketsList = function (searchValue, reload) {
    $scope.promise = $q(function (resolve, reject) {
      var params = $scope.getFilterParams();
      //params['limit'] = $scope.query.limit;
      //params['offset'] = $scope.query.limit * ($scope.query.page - 1);
      //params['sort'] = $scope.query.order;
      if (searchValue != null && searchValue != "") {
        params['search'] = searchValue;
      }

      docketService.getDockets(params, function (returnData) {
        $scope.userSummaries = {};
        $scope.orderedUsers = [];
        $scope.timeDaySummaries = { 1: { total: 0, travel: 0, break: 0 }, 2: { total: 0, travel: 0, break: 0 }, 3: { total: 0, travel: 0, break: 0 }, 4: { total: 0, travel: 0, break: 0 }, 5: { total: 0, travel: 0, break: 0 }, 6: { total: 0, travel: 0, break: 0 }, 7: { total: 0, travel: 0, break: 0 } };
        var docketsListParsed = docketService.parseDockets(returnData);
        var count = 0;
        if (params.offset <= 0 && returnData.length < params.limit) {
          count = returnData.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        $scope.allDockets = returnData;

        // categories dockets by members
        for (var i = 0; i < $scope.allDockets.length; i++) {
          var thisDocket = $scope.allDockets[i];
          if (thisDocket.status != 'Draft' && thisDocket.status != 'Rejected') {
            if (!$scope.userSummaries[thisDocket.author]) {
              $scope.userSummaries[thisDocket.author] = { dockets: [], totalSummary: {}, docketSummaries: {}, daySummaries: { 1: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 2: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 3: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 4: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 5: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 6: { totalWorked: 0, travelTime: 0, breakTime: 0 }, 7: { totalWorked: 0, travelTime: 0, breakTime: 0 } } };
            }
            $scope.userSummaries[thisDocket.author].dockets.push(thisDocket);
            // get time summary for this docket
            var totalMinutes = 0;
            var hasBothTimes = false;
            if (thisDocket.startTime && thisDocket.endTime) {
              var startTime = (0, _momentTimezone2.default)(thisDocket.startTime).format('HH:mm');
              var endTime = (0, _momentTimezone2.default)(thisDocket.endTime).format('HH:mm');
              totalMinutes = (0, _momentTimezone2.default)(endTime, 'HH:mm').diff((0, _momentTimezone2.default)(startTime, 'HH:mm'), 'minutes');
              if (totalMinutes < 0) {
                totalMinutes = totalMinutes + 24 * 60;
              }
              hasBothTimes = true;
            }
            var summary = { totalMinutes: totalMinutes };
            if (thisDocket.travelTime != undefined && thisDocket.travelTime >= 0) {
              summary.travelTime = thisDocket.travelTime;
            } else {
              summary.travelTime = 0;
            }
            if (thisDocket.breakTime != undefined && thisDocket.breakTime >= 0) {
              summary.breakTime = thisDocket.breakTime;
            } else {
              summary.breakTime = 0;
            }
            var totalWorked = 0;
            if (hasBothTimes) {
              totalWorked = totalMinutes - summary.breakTime + summary.travelTime;
            }
            summary.totalWorked = totalWorked;
            $scope.userSummaries[thisDocket.author].docketSummaries[thisDocket.id] = summary;
            // add to day summaries
            var docketDay = (0, _momentTimezone2.default)(thisDocket.date, 'YYYY-MM-DD').diff((0, _momentTimezone2.default)($scope.filters.startFromDate), 'days') + 1;
            $scope.userSummaries[thisDocket.author].daySummaries[docketDay].totalWorked += summary.totalWorked;
            $scope.userSummaries[thisDocket.author].daySummaries[docketDay].breakTime += summary.breakTime;
            $scope.userSummaries[thisDocket.author].daySummaries[docketDay].travelTime += summary.travelTime;
            $scope.timeDaySummaries[docketDay].totalWorked += summary.totalWorked;
            $scope.timeDaySummaries[docketDay].breakTime += summary.breakTime;
            $scope.timeDaySummaries[docketDay].travelTime += summary.travelTime;
          }
        }

        // generate user total summaries
        for (var userId in $scope.userSummaries) {
          var totalSummary = { totalMinutes: 0, totalBreak: 0, totalTravel: 0 };
          for (var docketId in $scope.userSummaries[userId].docketSummaries) {
            totalSummary.totalMinutes += $scope.userSummaries[userId].docketSummaries[docketId].totalWorked;
            totalSummary.totalBreak += $scope.userSummaries[userId].docketSummaries[docketId].breakTime;
            totalSummary.totalTravel += $scope.userSummaries[userId].docketSummaries[docketId].travelTime;
          }
          $scope.userSummaries[userId].totalSummary = totalSummary;
        }

        // order users by those with times first
        var usersWithout = [];
        for (var i = 0; i < $scope.allUsers.length; i++) {
          if ($scope.userSummaries[$scope.allUsers[i].id] && $scope.userSummaries[$scope.allUsers[i].id].totalSummary.totalMinutes > 0) {
            $scope.orderedUsers.push($scope.allUsers[i]);
          } else {
            usersWithout.push($scope.allUsers[i]);
          }
        }
        for (var i = 0; i < usersWithout.length; i++) {
          $scope.orderedUsers.push(usersWithout[i]);
        }

        $scope.preventReloadWithFilters = false;
        resolve('Done');
      }, function (err) {
        reject('Error');
      });
    });
  };

  $scope.formatTimeNice = function (mins) {
    if (!mins) {
      return "0h 0m";
    }
    var hours = Math.floor(mins / 60);
    var minutes = mins % 60;
    return hours + "h " + minutes + "m";
  };

  $scope.expandUserTimesheet = function (userId) {
    if ($("#" + userId).is(":hidden")) {
      $("#" + userId).slideDown();
    } else {
      $("#" + userId).slideUp();
    }
  };

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.$watch('filters', function () {
    // check toDate is after fromDate
    if ((0, _momentTimezone2.default)($scope.filters.endToDate).isBefore($scope.filters.startFromDate)) {
      $scope.filters.endToDate = $scope.filters.startFromDate;
    }

    // check if status filter has changed
    var storedFilters = JSON.parse(localStorage.getItem('filters'));

    if (!$scope.preventReloadWithFilters) {
      $scope.loadDocketsList();
    }

    localStorage.setItem('filters', JSON.stringify($scope.filters));
  }, true);

  /*** Filters ***/

  $scope.getFilterParams = function () {
    var params = {};
    params.timezone = _momentTimezone2.default.tz.guess();
    if ($scope.filters.startFromDate != null) {
      var fromDate = (0, _momentTimezone2.default)($scope.filters.startFromDate);
      params.fromDate = fromDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.endToDate != null) {
      var toDate = (0, _momentTimezone2.default)($scope.filters.endToDate);
      params.toDate = toDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.status != 'All') {
      params.status = $scope.filters.status;
    }
    if ($scope.filters.author != null && $scope.filters.author != "") {
      params.authorName = $scope.filters.author;
    }

    return params;
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /*****************************/
  /***** Date/Time Pickers *****/
  /*****************************/

  $scope.selectDate = function (dateObject, field, ev) {
    $mdpDatePicker(dateObject[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      dateObject[field] = selectedDate;
    });
  };

  $scope.showDatePicker = function (field, ev) {
    $mdpDatePicker($scope.itemEdit[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      $scope.itemEdit[field] = selectedDate;
    });
  };

  $scope.showTimePicker = function (field, ev) {
    $mdpTimePicker($scope.itemEdit[field], {
      targetEvent: ev,
      autoSwitch: true
    }).then(function (selectedTime) {
      $scope.itemEdit[field] = selectedTime;
    });
  };

  /** Load Initial Dockets List **/
  $scope.loadUsers(function () {
    $scope.loadDocketsList();
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "CTUr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-120x120.png";

/***/ }),

/***/ "Cld2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('batchListController', ['$rootScope', '$scope', '$state', '$stateParams', '$http', 'Restangular', 'accessControl', 'uuid', function ($rootScope, $scope, $state, $stateParams, $http, Restangular, accessControl, uuid) {
  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.listCount = 0;
  $scope.docketsLoading = false;

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  /***********************/
  /***** Permissions *****/
  /***********************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /*************************/
  /***** Batches Lists *****/
  /*************************/

  $scope.$parent.loadBatchesListFromParent = function (list, count) {
    $scope.listItems = list;
    $scope.listCount = count;
  };

  /**************************************************/
  /***** Alert parent controller of ready state *****/
  /**************************************************/

  $scope.$parent.batchChildControllerReady();
}]);

/***/ }),

/***/ "CsVk":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/desktop/jobDetail.html';
var html = "<div class=\"ojdDesktopDetailOuter\">\n  <form name=\"jobDetailForm\" class=\"jobDetailForm\">\n    <div class=\"ojdDesktopSection header white\">\n      <div class=\"headerTitle\">\n        <h1>{{itemEdit.jobNumber}}</h1>\n      </div>\n\n      <div class=\"bulkActionsButtons\">\n        <div class=\"dbButton\" ng-click=\"editJob(itemEdit)\" ng-if=\"userCanDoAction('editJob', itemEdit)\">\n          Edit\n        </div>\n        <div class=\"dbButton grey rightMargin\" ng-if=\"itemEdit.editing\" ng-click=\"cancelEditJob(itemEdit)\">\n          Cancel\n        </div>\n        <div class=\"dbButton\" ng-click=\"saveJob(itemEdit)\" ng-if=\"userCanDoAction('saveJob', itemEdit)\">\n          Save\n        </div>\n        <md-menu ng-show=\"!itemEdit.loading\">\n          <md-button aria-label=\"More Job Actions Menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item aria-label=\"Accept Job\" ng-show=\"userCanDoAction('acceptJob', itemEdit)\" ng-click=\"assigneeChangeStatus(itemEdit, 'Accepted')\">\n              <md-button>\n                Accept Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Reject Job\" ng-show=\"userCanDoAction('rejectJob', itemEdit)\" ng-click=\"assigneeChangeStatus(itemEdit, 'Rejected')\">\n              <md-button>\n                Reject Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Finish Job\" ng-show=\"userCanDoAction('finishJob', itemEdit)\" ng-click=\"assigneeChangeStatus(itemEdit, 'Completed')\">\n              <md-button>\n                Finish Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Send Job\" ng-show=\"userCanDoAction('sendJob', itemEdit) && itemEdit.status != 'Closed'\" ng-click=\"sendJob(itemEdit)\">\n              <md-button>\n                Send Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Close Job\" ng-show=\"userCanDoAction('closeJob', itemEdit)\" ng-click=\"closeJob(itemEdit)\">\n              <md-button>\n                Close Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Re-Open Job\" ng-show=\"userCanDoAction('sendJob', itemEdit) && itemEdit.status == 'Closed'\" ng-click=\"sendJob(itemEdit)\">\n              <md-button>\n                Re-Open Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Duplicate Job\" ng-show=\"userCanDoAction('duplicateJob', itemEdit)\" ng-click=\"duplicateJob(itemEdit)\">\n              <md-button>\n                Duplicate Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-click=\"shareJob(itemEdit)\" ng-show=\"userCanDoAction('shareJob', itemEdit)\">\n              <md-button>\n                Share Job\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Delete Job\" ng-show=\"userCanDoAction('deleteJob', itemEdit)\" ng-click=\"deleteJob(itemEdit)\">\n              <md-button>\n                Delete Job\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n        <md-button class=\"md-icon-button\" aria-label=\"Close Job Detail\" ng-click=\"closeJobDesktop(itemEdit)\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"desktopLoaderUnder\" ng-if=\"itemEdit.loading || jobLoadingError\">\n      <div my-loader text=\"Loading Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n      <div my-loader text=\"Saving Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n      <div class=\"stdLoader\" ng-show=\"jobLoadingError != null\">\n        <div class=\"desktopLoaderHeader\">\n          <div class=\"bulkActionsButtons\">\n            <md-button class=\"md-icon-button\" aria-label=\"Close Job Detail\" ng-click=\"closeJobDesktop(true)\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"loaderOuterContainer\">\n          <div class=\"loaderInnerContainer\">\n            <div class=\"materialSpinner\">\n              <md-icon md-svg-src=\"error.svg\"></md-icon>\n            </div>\n            <div class=\"loadingText\">\n              {{jobLoadingError}}\n            </div>\n            <div class=\"loadingRetryButton\">\n              <div class=\"dbButton grey margin-right\" ng-click=\"openJobDesktop(currentJob)\">Retry</div>\n              <div class=\"dbButton grey\" ng-click=\"contactSupportError(jobLoadingErrorFull)\">Contact Support</div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <md-tabs md-selected=\"selectedIndex\" md-border-bottom md-autoselect class=\"docketTabsInner\">\n      <md-tab label=\"Job\">\n        <div class=\"docketTab\">\n          <ng-include src=\"'views/pages/jobs/desktop/jobTab.html'\"></ng-include>\n        </div>\n      </md-tab>\n      <md-tab label=\"Dockets ({{itemEdit.dockets.length >= 1000000 ? '10+' : itemEdit.dockets.length}})\">\n        <div class=\"docketTab\">\n          <ng-include src=\"'views/pages/jobs/desktop/docketsTab.html'\"></ng-include>\n        </div>\n      </md-tab>\n      <md-tab label=\"Audit Log\">\n        <div class=\"docketTab\">\n          <ng-include src=\"'views/pages/jobs/desktop/auditLogTab.html'\"></ng-include>\n        </div>\n      </md-tab>\n    </md-tabs>\n  </form>\n</div>\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "D+wi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "account-multiple.svg";

/***/ }),

/***/ "DJqn":
/***/ (function(module, exports) {

var path = 'views/pages/filing/desktop/filingList.html';
var html = "<md-table-container>\n  <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n    <thead md-head md-order=\"query.order\" md-on-reorder=\"loadDocketsList\">\n      <tr md-row>\n        <th md-column md-order-by=\"filingStatus\"><span>Status</span></th>\n        <th md-column md-order-by=\"docketNumber\"><span>Docket Number</span></th>\n        <th md-column md-order-by=\"customerName\"><span>Customer</span></th>\n        <th md-column md-order-by=\"supplierName\" ng-show=\"listFull\"><span>Supplier</span></td>\n        <th md-column md-order-by=\"authorName\" ng-show=\"listFull\"><span>Author</span></th>\n        <th md-column md-order-by=\"date\"><span>Date</span></th>\n      </tr>\n    </thead>\n    <tbody md-body>\n      <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in listItems\" ui-sref=\"main.groupFilingDetail({orgId:currentOrg.id,groupId:currentOrgGroup.id,docketId:item.id})\">\n        <td md-cell>\n          <div class=\"statusDisplay Draft\" ng-show=\"!item.existingDocketFile\">Unfiled</div>\n          <div class=\"statusDisplay Completed\" ng-show=\"item.existingDocketFile\">Filed</div>\n        </td>\n        <td md-cell>{{item.docketNumber}}</td>\n        <td md-cell class=\"tablet-hide-collapsed\"><span ng-if=\"item.customerContact\">{{item.customerContact.displayName}}</span></td>\n        <td md-cell ng-show=\"listFull\"><span ng-if=\"item.supplierContact\">{{item.supplierContact.displayName}}</span></td>\n        <td md-cell ng-show=\"listFull\">{{item.authorName}}</td>\n        <td md-cell>{{moment(item.date).format('DD/MM/YYYY')}}</td>\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>\n<md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadDocketFilingList\" md-total=\"{{listCount}}\" md-page-select>\n\n</md-table-pagination>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "DPfz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').controller('trialActivatedModalController', ['addressBookService', 'userService', 'uuid', '$scope', '$state', '$window', '$location', '$stateParams', 'accessControl', '$rootScope', function (addressBookService, userService, uuid, $scope, $state, $window, $location, $stateParams, accessControl, $rootScope) {

    $scope.show = false;

    $scope.$parent.showTrialActivatedModal = function (cb) {
        $scope.show = true;
        $scope.cb = cb;
    };

    $scope.closeDialog = function () {
        /*$scope.show = false
        if ($scope.cb) {
            $scope.cb()
        }*/
        //$('#trialActivatedModal').fadeOut(100)
        window.location.reload();
    };
}]);

/***/ }),

/***/ "DWd+":
/***/ (function(module, exports) {

var path = 'views/modals/docketSummaryReportModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"summaryReportModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Generate Docket Summary Report</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeSummaryReportModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div my-loader text=\"Generating Report\" ng-if=\"summaryReport.loading\"></div>\n      <form name=\"summaryReportForm\" novalidate ng-if=\"summaryReport.stage == 'filter'\">\n        <div class=\"modalFormTableHeader white intro\">\n          <p>Select filters to generate a docket summary report</p>\n        </div>\n        <div class=\"modalFormTable padding\">\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup\">\n                <h1>Customer</h1>\n                <md-button class=\"md-icon-button selector\" ng-click=\"selectModalContactFilter(summaryReport, 'customerContact', 'summaryReportModal')\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                </md-button>\n                <md-button class=\"md-icon-button selector\" ng-click=\"summaryReport.customerContact = null\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"summaryReport.customerContact.displayName\" ng-disabled=\"true\" aria-label=\"Customer Contact\">\n                </md-input-container>\n              </div>\n            </div>\n\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup\">\n                <h1>Supplier</h1>\n                <md-button class=\"md-icon-button selector\" ng-click=\"selectModalContactFilter(summaryReport, 'supplierContact', 'summaryReportModal')\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                </md-button>\n                <md-button class=\"md-icon-button selector\" ng-click=\"summaryReport.supplierContact = null\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"summaryReport.supplierContact.displayName\" ng-disabled=\"true\" aria-label=\"Supplier Contact\">\n                </md-input-container>\n              </div>\n            </div>\n\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup\">\n                <h1>Order</h1>\n                <md-button class=\"md-icon-button selector\" ng-click=\"selectModalOrderFilter(summaryReport, 'summaryReportModal')\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                </md-button>\n                <md-button class=\"md-icon-button selector\" ng-click=\"summaryReport.order = null\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"summaryReport.order.orderNumber\" ng-disabled=\"true\" aria-label=\"Order\">\n                </md-input-container>\n              </div>\n            </div>\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup autocomplete\">\n                <h1>Customer Name</h1>\n                <md-input-container class=\"md-block\">\n                  <input tabindex=\"0\" type=\"text\" ng-model=\"summaryReport.customerDisplayName\">\n                </md-input-container>\n              </div>\n            </div>\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup autocomplete\">\n                <h1>Supplier Name</h1>\n                <md-input-container class=\"md-block\">\n                  <input tabindex=\"0\" type=\"text\" ng-model=\"summaryReport.supplierDisplayName\">\n                </md-input-container>\n              </div>\n            </div>\n\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup autocomplete\">\n                <h1>Operator</h1>\n                <md-input-container class=\"md-block\">\n                  <md-autocomplete\n                      md-selected-item=\"summaryReport.author\"\n                      md-search-text=\"summaryReport.authorSearchText\"\n                      md-items=\"item in searchMembers(summaryReport.authorSearchText)\"\n                      md-item-text=\"item.name.full\"\n                      md-min-length=\"0\"\n                      placeholder=\"Operator\">\n                    <md-item-template>\n                      <span md-highlight-text=\"summaryReport.authorSearchText\" md-highlight-flags=\"^i\">{{item.name.full}}</span>\n                    </md-item-template>\n                    <md-not-found>\n                      No members matching \"{{summaryReport.authorSearchText}}\" were found.\n                    </md-not-found>\n                  </md-autocomplete>\n                </md-input-container>\n              </div>\n            </div>\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup dates\">\n                <h1>Date From</h1>\n                <div class=\"md-block\">\n                  <md-input-container class=\"filterDatepicker\">\n                    <md-datepicker ng-model=\"summaryReport.startDate\" aria-label=\"From Date Filter\" required></md-datepicker>\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n            <div flex-gt-sm=\"33\">\n              <div class=\"filterGroup dates\">\n                <h1>Date To</h1>\n                <md-input-container class=\"filterDatepicker\">\n                  <md-datepicker ng-model=\"summaryReport.endDate\" aria-label=\"To Date Filter\" required></md-datepicker>\n                </md-input-container>\n              </div>\n            </div>\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup dates\">\n                <h1>Status</h1>\n                <div class=\"md-block\">\n                  <md-checkbox ng-checked=\"statusSelected(summaryReport.status, 'draft')\" ng-click=\"toggleStatus(summaryReport.status, 'draft')\">\n                    Draft\n                  </md-checkbox>\n                  <md-checkbox ng-checked=\"statusSelected(summaryReport.status, 'sent')\" ng-click=\"toggleStatus(summaryReport.status, 'sent')\">\n                    Sent\n                  </md-checkbox>\n                  <md-checkbox ng-checked=\"statusSelected(summaryReport.status, 'accepted')\" ng-click=\"toggleStatus(summaryReport.status, 'accepted')\">\n                    Accepted\n                  </md-checkbox>\n                  <md-checkbox ng-checked=\"statusSelected(summaryReport.status, 'rejected')\" ng-click=\"toggleStatus(summaryReport.status, 'rejected')\">\n                    Rejected\n                  </md-checkbox>\n                </div>\n              </div>\n            </div>\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup dates\">\n                <h1>Sort By</h1>\n                <div class=\"md-block\">\n                  <md-input-container>\n                    <md-select aria-label=\"Sort Report By Field\" ng-model=\"summaryReport.sortBy\">\n                      <md-option value=\"date\">Date - Newest First</md-option>\n                      <md-option value=\"-date\">Date - Oldest First</md-option>\n                      <md-option value=\"docketNumber\">Docket Number - Newest First</md-option>\n                      <md-option value=\"-docketNumber\">Docket Number - Oldest First</md-option>\n                      <md-option value=\"authorName\">Operator</md-option>\n                      <md-option value=\"customerName\">Customer</md-option>\n                    </md-select>\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup dates\">\n                <h1>Options</h1>\n                <div class=\"md-block\" ng-show=\"summaryReport.docType == 'pdf'\">\n                  <md-checkbox ng-model=\"summaryReport.includeSupporting\">\n                    Include Supporting Dockets\n                  </md-checkbox>\n                </div>\n                <div class=\"md-block\" ng-show=\"summaryReport.docType == 'pdf'\">\n                  <md-checkbox ng-model=\"summaryReport.includeInteractionFields\">\n                    Include Interaction Fields\n                  </md-checkbox>\n                </div>\n                <div class=\"md-block\" ng-show=\"summaryReport.docType == 'xlsx'\">\n                  <md-checkbox ng-model=\"summaryReport.aggregateInteractions\">\n                    Aggregate Line Items\n                  </md-checkbox>\n                </div>\n              </div>\n            </div>\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup dates\">\n                <h1>Export As</h1>\n                <div class=\"md-block\">\n                  <md-radio-group ng-model=\"summaryReport.docType\">\n                    <md-radio-button value=\"pdf\">PDF</md-radio-button>\n                    <md-radio-button value=\"xlsx\" class=\"md-primary\">Excel Spreadsheet</md-radio-button>\n                 </md-radio-group>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n      <div class=\"modalFormTable padding\" ng-if=\"summaryReport.stage == 'error'\">\n        <div class=\"billingSuccessOuter error\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n        </div>\n        <div class=\"billingSuccessMessage\">\n          Something went wrong when we tried to generate your report. Please try again.\n          <br/>\n          <div class=\"dbButton\" ng-click=\"summaryReport.stage = 'filter'\">Go Back</div>\n        </div>\n      </div>\n      <div class=\"modalFormTable padding\" ng-if=\"summaryReport.stage == 'fileList' && !summaryReport.includeSupporting\">\n        <p>Your report has been generated, click to download</p>\n\n        <div ng-repeat=\"file in summaryReport.generatedFiles\">\n          <a class=\"dbButton lightBlue\" href=\"{{file}}\" target=\"_blank\">Download Report</a>\n        </div>\n      </div>\n      <div class=\"modalFormTable padding\" ng-if=\"summaryReport.stage == 'fileList' && summaryReport.includeSupporting\">\n        <p>Your report has been queued for generation and will be emailed to you.</p>\n      </div>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white\" ng-click=\"closeSummaryReportModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton blue\" ng-click=\"closeSummaryReportModal()\" ng-if=\"summaryReport.stage == 'fileList' && summaryReport.includeSupporting\">\n            Done\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(summaryReportForm.$invalid || summaryReport.loading) || generateSummaryReport(summaryReport)\" ng-disabled=\"summaryReportForm.$invalid || summaryReport.loading\" ng-if=\"summaryReport.stage == 'filter' && !summaryReport.loading\">\n            <span ng-hide=\"summaryReport.loading\">Generate Report</span>\n            <md-progress-circular ng-show=\"summaryReport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Dxvw":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/desktop/index.html';
var html = "<div ng-show=\"currentOrg.planFeatures.jobsEnabled == true || hasJobs || myDocketbook\" style=\"display: flex; flex-direction: column; height: 100%;\">\n  <div>\n    <ng-include src=\"'views/filterBars/jobsFilterBar.html'\"></ng-include>\n  </div>\n\n  <div style=\"flex-shrink: 1; flex-grow: 1;\">\n    <!-- Job Calendar View Area -->\n    <div ng-show=\"filters.viewType == 'allocate' && currentOrg.betaAllowed == true\" class=\"desktopContainer\">\n      <div class=\"desktopSplitListOuter\">\n        <div class=\"desktopSplitListTableOuter\">\n          <div ng-style=\"{'display' : 'table', 'width':'100%','height':'100%'}\">\n            <ng-include src=\"'views/pages/jobs/desktop/jobsHeading.html'\" ng-style=\"{'display':'table-row','width':'100%'}\"></ng-include>\n            <div ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\">\n              <div ng-style=\"{'width':'100%','height':'100%','position':'relative'}\">\n                <div ng-style=\"{'display':'block','height':'100%','overflow':'auto','position':'absolute','top':'0px','left':'0px','width':'100%'}\">\n                  <div class=\"jobAllocationsViewOuter\">\n                    <div class=\"jobAllocationsTable\">\n                      <div class=\"headerRow\">\n                        <div class=\"headerCell\">\n                        </div>\n                        <div class=\"headerCell {{moment(startWeek).format('D') == moment().format('D') && moment(startWeek).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <h3>{{startWeek.format('ddd')}}</h3>\n                          <h4>{{startWeek.format('D')}}</h4>\n                        </div>\n                        <div class=\"headerCell {{moment(startWeek).add('days',1).format('D') == moment().format('D') && moment(startWeek).add('days',1).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <h3>{{moment(startWeek).add('days',1).format('ddd')}}</h3>\n                          <h4>{{moment(startWeek).add('days',1).format('D')}}</h4>\n                        </div>\n                        <div class=\"headerCell {{moment(startWeek).add('days',2).format('D') == moment().format('D') && moment(startWeek).add('days',2).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <h3>{{moment(startWeek).add('days',2).format('ddd')}}</h3>\n                          <h4>{{moment(startWeek).add('days',2).format('D')}}</h4>\n                        </div>\n                        <div class=\"headerCell {{moment(startWeek).add('days',3).format('D') == moment().format('D') && moment(startWeek).add('days',3).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <h3>{{moment(startWeek).add('days',3).format('ddd')}}</h3>\n                          <h4>{{moment(startWeek).add('days',3).format('D')}}</h4>\n                        </div>\n                        <div class=\"headerCell {{moment(startWeek).add('days',4).format('D') == moment().format('D') && moment(startWeek).add('days',4).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <h3>{{moment(startWeek).add('days',4).format('ddd')}}</h3>\n                          <h4>{{moment(startWeek).add('days',4).format('D')}}</h4>\n                        </div>\n                        <div class=\"headerCell {{moment(startWeek).add('days',5).format('D') == moment().format('D') && moment(startWeek).add('days',5).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <h3>{{moment(startWeek).add('days',5).format('ddd')}}</h3>\n                          <h4>{{moment(startWeek).add('days',5).format('D')}}</h4>\n                        </div>\n                        <div class=\"headerCell {{moment(startWeek).add('days',6).format('D') == moment().format('D') && moment(startWeek).add('days',6).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <h3>{{moment(startWeek).add('days',6).format('ddd')}}</h3>\n                          <h4>{{moment(startWeek).add('days',6).format('D')}}</h4>\n                        </div>\n                      </div>\n                      <div class=\"assigneeRow\" ng-repeat=\"user in allocationUsers\" ng-if=\"jobAllocationsByUser[user.id] != null\">\n                        <div class=\"assigneeCell nameCell\" style=\"height: {{(jobAllocationsByUser[user.id].maxOverlaps + 1) * 60}}px\">\n                          <h4>{{user.name.full}}</h4>\n                          <span ng-repeat=\"email in user.emailAddresses\">\n                            <span ng-if=\"email.indexOf('@users.docketbook.io') == -1\">{{email}}</span>\n                            <span ng-if=\"email.indexOf('@users.docketbook.io') != -1\">{{email.split('@users.docketbook.io')[0]}}</span>\n                          </span>\n                        </div>\n                        <div class=\"assigneeCell  {{moment(startWeek).format('D') == moment().format('D') && moment(startWeek).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <div class=\"jobAssignmentDiv {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" style=\"width: {{jobAllocationsByUser[user.id].jobs[assignment].daysCovered * 90 + ((jobAllocationsByUser[user.id].jobs[assignment].daysCovered - 1) * 10)}}%; top: {{jobAllocationsByUser[user.id].jobVOffsets[assignment] * 55 + 5}}px;\" ng-repeat=\"assignment in jobAllocationsByUser[user.id].startDays[1]\" ng-click=\"openJobAllocation(jobAllocationsByUser[user.id].jobs[assignment])\">\n                            <h3>{{jobAllocationsByUser[user.id].jobs[assignment].customerContact.displayName}} (#{{jobAllocationsByUser[user.id].jobs[assignment].jobNumber.split('-')[2]}})</h3>\n                            <p>{{stringifyAddress(jobAllocationsByUser[user.id].jobs[assignment].customerContact.addresses[0])}}</p>\n                            <p class=\"rejectionComment\" ng-if=\"jobAllocationsByUser[user.id].jobRejectionComments[assignment]\">Rejection Comment: {{jobAllocationsByUser[user.id].jobRejectionComments[assignment]}}</p>\n                            <div class=\"statusDisplay {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" ng-if=\"jobAllocationsByUser[user.id].jobs[assignment].daysCovered > 1\">{{jobAllocationsByUser[user.id].jobStatus[assignment]}}</div>\n                          </div>\n                        </div>\n                        <div class=\"assigneeCell  {{moment(startWeek).add('days',1).format('D') == moment().format('D') && moment(startWeek).add('days',1).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <div class=\"jobAssignmentDiv {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" style=\"width: {{jobAllocationsByUser[user.id].jobs[assignment].daysCovered * 90 + ((jobAllocationsByUser[user.id].jobs[assignment].daysCovered - 1) * 10)}}%; top: {{jobAllocationsByUser[user.id].jobVOffsets[assignment] * 55 + 5}}px;\" ng-repeat=\"assignment in jobAllocationsByUser[user.id].startDays[2]\" ng-click=\"openJobAllocation(jobAllocationsByUser[user.id].jobs[assignment])\">\n                            <h3>{{jobAllocationsByUser[user.id].jobs[assignment].customerContact.displayName}} (#{{jobAllocationsByUser[user.id].jobs[assignment].jobNumber.split('-')[2]}})</h3>\n                            <p>{{stringifyAddress(jobAllocationsByUser[user.id].jobs[assignment].customerContact.addresses[0])}}</p>\n                            <p class=\"rejectionComment\" ng-if=\"jobAllocationsByUser[user.id].jobRejectionComments[assignment]\">Rejection Comment: {{jobAllocationsByUser[user.id].jobRejectionComments[assignment]}}</p>\n                            <div class=\"statusDisplay {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" ng-if=\"jobAllocationsByUser[user.id].jobs[assignment].daysCovered > 1\">{{jobAllocationsByUser[user.id].jobStatus[assignment]}}</div>\n                          </div>\n                        </div>\n                        <div class=\"assigneeCell  {{moment(startWeek).add('days',2).format('D') == moment().format('D') && moment(startWeek).add('days',2).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <div class=\"jobAssignmentDiv {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" style=\"width: {{jobAllocationsByUser[user.id].jobs[assignment].daysCovered * 90 + ((jobAllocationsByUser[user.id].jobs[assignment].daysCovered - 1) * 10)}}%; top: {{jobAllocationsByUser[user.id].jobVOffsets[assignment] * 55 + 5}}px;\" ng-repeat=\"assignment in jobAllocationsByUser[user.id].startDays[3]\" ng-click=\"openJobAllocation(jobAllocationsByUser[user.id].jobs[assignment])\">\n                            <h3>{{jobAllocationsByUser[user.id].jobs[assignment].customerContact.displayName}} (#{{jobAllocationsByUser[user.id].jobs[assignment].jobNumber.split('-')[2]}})</h3>\n                            <p>{{stringifyAddress(jobAllocationsByUser[user.id].jobs[assignment].customerContact.addresses[0])}}</p>\n                            <p class=\"rejectionComment\" ng-if=\"jobAllocationsByUser[user.id].jobRejectionComments[assignment]\">Rejection Comment: {{jobAllocationsByUser[user.id].jobRejectionComments[assignment]}}</p>\n                            <div class=\"statusDisplay {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" ng-if=\"jobAllocationsByUser[user.id].jobs[assignment].daysCovered > 1\">{{jobAllocationsByUser[user.id].jobStatus[assignment]}}</div>\n                          </div>\n                        </div>\n                        <div class=\"assigneeCell  {{moment(startWeek).add('days',3).format('D') == moment().format('D') && moment(startWeek).add('days',3).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <div class=\"jobAssignmentDiv {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" style=\"width: {{jobAllocationsByUser[user.id].jobs[assignment].daysCovered * 90 + ((jobAllocationsByUser[user.id].jobs[assignment].daysCovered - 1) * 10)}}%; top: {{jobAllocationsByUser[user.id].jobVOffsets[assignment] * 55 + 5}}px;\" ng-repeat=\"assignment in jobAllocationsByUser[user.id].startDays[4]\" ng-click=\"openJobAllocation(jobAllocationsByUser[user.id].jobs[assignment])\">\n                            <h3>{{jobAllocationsByUser[user.id].jobs[assignment].customerContact.displayName}} (#{{jobAllocationsByUser[user.id].jobs[assignment].jobNumber.split('-')[2]}})</h3>\n                            <p>{{stringifyAddress(jobAllocationsByUser[user.id].jobs[assignment].customerContact.addresses[0])}}</p>\n                            <p class=\"rejectionComment\" ng-if=\"jobAllocationsByUser[user.id].jobRejectionComments[assignment]\">Rejection Comment: {{jobAllocationsByUser[user.id].jobRejectionComments[assignment]}}</p>\n                            <div class=\"statusDisplay {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" ng-if=\"jobAllocationsByUser[user.id].jobs[assignment].daysCovered > 1\">{{jobAllocationsByUser[user.id].jobStatus[assignment]}}</div>\n                          </div>\n                        </div>\n                        <div class=\"assigneeCell  {{moment(startWeek).add('days',4).format('D') == moment().format('D') && moment(startWeek).add('days',4).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <div class=\"jobAssignmentDiv {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" style=\"width: {{jobAllocationsByUser[user.id].jobs[assignment].daysCovered * 90 + ((jobAllocationsByUser[user.id].jobs[assignment].daysCovered - 1) * 10)}}%; top: {{jobAllocationsByUser[user.id].jobVOffsets[assignment] * 55 + 5}}px;\" ng-repeat=\"assignment in jobAllocationsByUser[user.id].startDays[5]\" ng-click=\"openJobAllocation(jobAllocationsByUser[user.id].jobs[assignment])\">\n                            <h3>{{jobAllocationsByUser[user.id].jobs[assignment].customerContact.displayName}} (#{{jobAllocationsByUser[user.id].jobs[assignment].jobNumber.split('-')[2]}})</h3>\n                            <p>{{stringifyAddress(jobAllocationsByUser[user.id].jobs[assignment].customerContact.addresses[0])}}</p>\n                            <p class=\"rejectionComment\" ng-if=\"jobAllocationsByUser[user.id].jobRejectionComments[assignment]\">Rejection Comment: {{jobAllocationsByUser[user.id].jobRejectionComments[assignment]}}</p>\n                            <div class=\"statusDisplay {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" ng-if=\"jobAllocationsByUser[user.id].jobs[assignment].daysCovered > 1\">{{jobAllocationsByUser[user.id].jobStatus[assignment]}}</div>\n                          </div>\n                        </div>\n                        <div class=\"assigneeCell  {{moment(startWeek).add('days',5).format('D') == moment().format('D') && moment(startWeek).add('days',5).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <div class=\"jobAssignmentDiv {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" style=\"width: {{jobAllocationsByUser[user.id].jobs[assignment].daysCovered * 90 + ((jobAllocationsByUser[user.id].jobs[assignment].daysCovered - 1) * 10)}}%; top: {{jobAllocationsByUser[user.id].jobVOffsets[assignment] * 55 + 5}}px;\" ng-repeat=\"assignment in jobAllocationsByUser[user.id].startDays[6]\" ng-click=\"openJobAllocation(jobAllocationsByUser[user.id].jobs[assignment])\">\n                            <h3>{{jobAllocationsByUser[user.id].jobs[assignment].customerContact.displayName}} (#{{jobAllocationsByUser[user.id].jobs[assignment].jobNumber.split('-')[2]}})</h3>\n                            <p>{{stringifyAddress(jobAllocationsByUser[user.id].jobs[assignment].customerContact.addresses[0])}}</p>\n                            <p class=\"rejectionComment\" ng-if=\"jobAllocationsByUser[user.id].jobRejectionComments[assignment]\">Rejection Comment: {{jobAllocationsByUser[user.id].jobRejectionComments[assignment]}}</p>\n                            <div class=\"statusDisplay {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" ng-if=\"jobAllocationsByUser[user.id].jobs[assignment].daysCovered > 1\">{{jobAllocationsByUser[user.id].jobStatus[assignment]}}</div>\n                          </div>\n                        </div>\n                        <div class=\"assigneeCell  {{moment(startWeek).add('days',6).format('D') == moment().format('D') && moment(startWeek).add('days',6).format('M') == moment().format('M') ? 'today' : ''}}\">\n                          <div class=\"jobAssignmentDiv {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" style=\"width: {{jobAllocationsByUser[user.id].jobs[assignment].daysCovered * 90 + ((jobAllocationsByUser[user.id].jobs[assignment].daysCovered - 1) * 10)}}%; top: {{jobAllocationsByUser[user.id].jobVOffsets[assignment] * 55 + 5}}px;\" ng-repeat=\"assignment in jobAllocationsByUser[user.id].startDays[7]\" ng-click=\"openJobAllocation(jobAllocationsByUser[user.id].jobs[assignment])\">\n                            <h3>{{jobAllocationsByUser[user.id].jobs[assignment].customerContact.displayName}} (#{{jobAllocationsByUser[user.id].jobs[assignment].jobNumber.split('-')[2]}})</h3>\n                            <p>{{stringifyAddress(jobAllocationsByUser[user.id].jobs[assignment].customerContact.addresses[0])}}</p>\n                            <p class=\"rejectionComment\" ng-if=\"jobAllocationsByUser[user.id].jobRejectionComments[assignment]\">Rejection Comment: {{jobAllocationsByUser[user.id].jobRejectionComments[assignment]}}</p>\n                            <div class=\"statusDisplay {{jobAllocationsByUser[user.id].jobStatus[assignment]}}\" ng-if=\"jobAllocationsByUser[user.id].jobs[assignment].daysCovered > 1\">{{jobAllocationsByUser[user.id].jobStatus[assignment]}}</div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- End Job Calendar View Area -->\n\n    <div ng-show=\"filters.viewType == 'list'\" class=\"desktopContainer\">\n      <!-- Content Heading -->\n      <!-- Main content area - with list/detail split functionality -->\n      <div class=\"desktopSplitListOuter\">\n        <div class=\"desktopSplitListTableOuter\">\n          <div ng-style=\"{'display' : 'table', 'width':'100%','height':'100%'}\">\n            <ng-include src=\"'views/pages/jobs/desktop/jobsHeading.html'\" ng-style=\"{'display':'table-row','width':'100%'}\"></ng-include>\n            <div ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\" ng-controller=\"jobListController\">\n              <div ng-style=\"{'width':'100%','height':'100%','position':'relative'}\">\n                <div ng-style=\"{'display':'block','height':'100%','overflow':'auto','position':'absolute','top':'0px','left':'0px','width':'100%'}\">\n                  <ng-include src=\"'views/pages/jobs/desktop/jobsList.html'\"></ng-include>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"desktopSplitListDetailOuter\" ng-controller=\"jobDetailController\">\n          <ng-include src=\"'views/pages/jobs/desktop/jobDetail.html'\" class=\"detailItemContainer\" ng-show=\"itemEdit != null\"></ng-include>\n          <ng-include src=\"'views/modals/shareJobModal.html'\"></ng-include>\n          <ng-include src=\"'views/modals/assignJobModal.html'\" ng-controller=\"assignJobModalController\"></ng-include>\n        </div>\n      </div>\n      <!-- End Main Content Area -->\n    </div>\n  </div>\n\n  <!-- Select Contact Modal -->\n  <ng-include src=\"'views/modals/selectContactModal.html'\" ng-controller=\"selectContactController\"></ng-include>\n\n  <!-- Assignee Select Modal -->\n  <ng-include src=\"'views/modals/selectPersonModal.html'\" ng-controller=\"selectPersonController\"></ng-include>\n  <!-- End Assignee Select Modal -->\n\n  <!-- Line Item Select Modal -->\n  <ng-include src=\"'views/modals/selectLineModal.html'\" ng-controller=\"selectLineController\"></ng-include>\n  <!-- End Line Item Select Modal -->\n\n  <!-- Order Select Modal -->\n  <ng-include src=\"'views/modals/selectOrderModal.html'\" ng-controller=\"selectOrderController\"></ng-include>\n  <!-- Order Select Modal -->\n\n  <!-- Duplicate Jobs Modal -->\n  <ng-include src=\"'views/modals/duplicateJobsModal.html'\"></ng-include>\n  <!-- Duplicate Jobs Modal -->\n\n  <!-- Comments Modal -->\n  <ng-include src=\"'views/modals/jobCommentModal.html'\"></ng-include>\n  <!-- Comments Modal -->\n</div>\n\n\n<ng-include ng-if=\"currentOrg.planFeatures.jobsEnabled != true && !hasJobs && !myDocketbook\" src=\"'views/pages/paywalled/jobs.html'\" ng-controller=\"paywalledController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "E3Sh":
/***/ (function(module, exports) {

var path = 'views/modals/selectContactModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector long\" id=\"selectContactModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Contacts</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeContactSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"splitModalForm\">\n        <div class=\"splitModalFormLeft noPadding white\">\n          <div class=\"searchBar\">\n            <div class=\"title\">\n              <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n            </div>\n            <div class=\"bar\">\n              <input autofocus name=\"searchContactInput\" type=\"text\" ng-model=\"contactSearchValue\" placeholder=\"Search\" ng-change=\"loadContactSearchList(contactSearchValue)\" ng-model-options='{debounce:1000}'>\n            </div>\n          </div>\n          <div class=\"filterGroup\" style=\"padding: 10px; border-bottom: 1px solid #DDD;\">\n            <md-input-container class=\"md-block\" md-no-float>\n              <md-select ng-model=\"selectedContactTagFilter.tags\" placeholder=\"Select tags\" multiple=\"true\" ng-change=\"searchContactChange(contactSearchValue)\">\n                <md-option ng-value=\"tag\" ng-repeat=\"tag in contactTagList\">{{ tag.tag }}</md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n          <div class=\"noListMessage\" ng-show=\"contactSearchList.length <= 0\">\n            There are no contacts matching your search critera.\n          </div>\n          <div class=\"modalListOuter\">\n            <md-list>\n              <md-list-item ng-repeat=\"contact in contactSearchList\" ng-click=\"selectContact(contact)\" class=\"md-2-line\">\n                <div class=\"md-avatar\"><span>{{contact.initials}}</span></div>\n                <div class=\"md-list-item-text\" layout=\"column\">\n                  <h3>{{contact.displayName}} <div class=\"xeroAvatar mini\" ng-if=\"contact.xeroContact\"></div></h3>\n                  <p>{{contact.contactAddresses[0].emailAddress}}</p>\n                </div>\n              </md-list-item>\n            </md-list>\n          </div>\n        </div>\n        <div class=\"splitModalFormRight noPadding\">\n          <span ng-if=\"contactDetail != null\">\n            <div class=\"contactDetailHeader small\">\n              <div class=\"avatar\">{{contactDetail.initials}}</div>\n              <h1>{{contactDetail.displayName}}</h1>\n              <h2 ng-if=\"contactDetail.new == true\">New Contact</h2>\n            </div>\n            <md-list>\n              <md-subheader class=\"md-no-sticky\">Address</md-subheader>\n              <md-list-item ng-if=\"contactDetail.addresses && contactDetail.addresses.length > 0\">\n                <p>{{stringifyAddress(contactDetail.addresses[0])}}</p>\n              </md-list-item>\n              <md-list-item ng-if=\"!contactDetail.addresses || contactDetail.addresses.length <= 0\">\n                <p>No address</p>\n              </md-list-item>\n\n              <md-subheader class=\"md-no-sticky extra-margin\">Email Addresses</md-subheader>\n              <md-list-item ng-if=\"!selectedContactIsValid(contactDetail)\">\n                <inline-alert type=\"warning\">\n                  <md-icon class=\"right-margin\" style=\"color: #F8BB86; margin-right: 4px\" md-svg-icon=\"error-outlined.svg\"></md-icon>\n                  <span style=\"vertical-align: middle;\">No email address</span>\n                </inline-alert>\n              </md-list-item>\n              <md-list-item ng-repeat=\"address in contactDetail.contactAddresses\" class=\"addressItem\">\n                <md-checkbox ng-if=\"contactModalMode == 'select' || address.new\" ng-model=\"address.selected\"></md-checkbox>\n                <p>{{address.emailAddress}}</p>\n              </md-list-item>\n            </md-list>\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeContactSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"contactDetail == null || desktopSelectContactContinue()\" ng-disabled=\"contactDetail == null\" ng-if=\"contactModalMode == 'select'\">\n            Done\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"contactDetail.loading || saveContactEdit(contactDetail)\" ng-disabled=\"contactDetail.loading || ((updateContactOnSelect) && (!contactDetail))\" ng-if=\"contactModalMode == 'edit'\">\n            <span ng-hide=\"contactDetail.loading\">Save</span>\n            <md-progress-circular ng-show=\"contactDetail.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "E9h+":
/***/ (function(module, exports) {

var path = 'views/mainTemplate.html';
var html = "<div id=\"mainTemplateOuter\">\n  <div id=\"mainSectionContainer\">\n    <div>\n      <div id=\"header\">\n        <div class=\"tableLayoutHelperContainer\" ui-view=\"scopeNav\" id=\"scopeNav\"></div>\n      </div>\n    </div>\n    <div style=\"flex: 1 1 auto; overflow: auto;\">\n      <div id=\"contentOuter\" ui-view=\"content\" style=\"flex-grow: 1;\">\n      </div>\n    </div>\n    <div id=\"bottomBanner\" ui-view=\"bottomBanner\"></div>\n  </div>\n</div>\n\n<ng-include src=\"'views/notifications/slider.html'\" ng-controller=\"scopeNavController\"></ng-include>\n<ng-include src=\"'views/modals/selectContactModal.html'\" ng-controller=\"selectContactController\"></ng-include>\n<ng-include src=\"'views/alerts/alertTemplate.html'\"></ng-include>\n<ng-include src=\"'views/modals/newGroupModal.html'\" ng-controller=\"newGroupModalController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "EPqU":
/***/ (function(module, exports) {

var path = 'views/modals/rejectDocketModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"rejectDocketModal\">\n    <div class=\"modalContainer\" style=\"width: 600px;\">\n        <div class=\"header hidden-xs\">\n            <h1 ng-if=\"rejectingDocket != null\">Reject Docket {{rejectingDocket.docketNumber}}</h1>\n            <h1 ng-if=\"rejectingDocket == null\">Reject Dockets</h1>\n            <div class=\"headerCloseButton\" ng-click=\"hideRejectDocketModal()\">\n                <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n        <div class=\"content\">\n            <div ng-if=\"rejectingDocket != null\" style=\"padding-bottom: 20px;\">Please provide a reason for rejecting this docket.</div>\n            <div ng-if=\"rejectingDocket == null\" style=\"padding-bottom: 20px;\">Please provide a reason for rejecting these dockets.</div>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Reason</label>\n              <input type=\"text\" ng-model=\"rejectReason.text\">\n            </md-input-container>\n        </div>\n\n        <div class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\"></div>\n                <div class=\"right\">\n                <div class=\"dbButton white margin-right\" ng-click=\"!rejectLoading && hideRejectDocketModal()\" ng-disabled=\"rejectLoading\">\n                    Cancel\n                </div>\n                <div class=\"dbButton spinner\" ng-click=\"rejectReason.text != '' && !rejectLoading && acceptRejectDocket()\" ng-disabled=\"rejectReason.text == ''\">\n                    <span ng-show=\"!rejectLoading\">Ok</span>\n                    <md-progress-circular ng-show=\"rejectLoading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Eh97":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/list.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"ordersLoading || ordersLoadingError\">\n  <div my-loader text=\"Loading Orders\" ng-if=\"ordersLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"ordersLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{ordersLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <div class=\"dbButton simpleOutline\" ng-click=\"loadOrdersIntoList()\">Retry</div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"contentList paddingWithoutTabBar tabBarBottomPadding\">\n  <div class=\"customListRowOuter\" ng-repeat=\"item in listItems\" id=\"listItem{{item.id}}\">\n    <div class=\"customListRow {{item.status}} {{itemEdit.id == item.id ? 'selected' : ''}}\" ng-click=\"openOrderDetail(item)\">\n      <div class=\"listRowItem status\"><div class=\"statusDisplay {{item.status}}\">{{item.status}}</div></div>\n      <div class=\"listRowItem itemNumber\">\n        <span ng-if=\"item.orderNumber\">{{item.orderNumber}}</span>\n        <span ng-if=\"!item.orderNumber\">\n          Pending\n          <span ng-show=\"userCanDoAction('viewSupplierRefNo', item) && item.supplierRefNo\">({{item.supplierRefNo}})</span>\n          <span ng-show=\"userCanDoAction('viewCustomerRefNo', item) && item.customerRefNo\">({{item.customerRefNo}})</span>\n        </span>\n      </div>\n      <div class=\"listRowItem collapsedDetail showCollapsed\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n            <div class=\"inner\">\n              <span ng-show=\"item.supplierContact\">{{item.supplierContact.displayName}}</span> -\n              <span ng-show=\"item.customerContact\">{{item.customerContact.displayName}}</span>\n            </div>\n          </div>\n          <div class=\"right\">{{moment(item.startDate).format('DD/MM')}} - {{moment(item.endDate).format('DD/MM')}}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"customListRowOuter hidden\" id=\"ordersLoadingMore\">\n    <div class=\"customListRow loadingRow\">\n      <div class=\"progressOuter\">\n        <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n      </div>\n      Loading More Orders\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "EjBE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F+6J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db-logomark.svg";

/***/ }),

/***/ "F6ZY":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/desktop/jobsHeading.html';
var html = "\n\n<div class=\"contentHeadingOuter\">\n  <div class=\"contentHeadingInner desktopTableSearch\">\n    <div class=\"headerSplit\">\n      <div class=\"left\">\n        <h1 ng-if=\"filters.viewType == 'allocate'\">Job Allocations</h1>\n        <h1 ng-if=\"filters.viewType != 'allocate'\">Jobs</h1>\n        <md-button class=\"md-icon-button\" ng-click=\"loadJobsList(null, true)\" aria-label=\"Reload Dockets List\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n      </div>\n      <div class=\"middle\">\n        <div ng-show=\"filters.viewType == 'allocate'\">\n          <div class=\"backWeekButton\">\n            <md-button class=\"md-icon-button\" ng-click=\"jobAllocationsFiltersBackWeek()\" aria-label=\"Last Week\">\n              <md-icon md-svg-icon=\"back-icon.svg\"></md-icon>\n            </md-button>\n          </div>\n          <div class=\"currentWeekFilter\">{{moment(filters.startDate).format('DD/MM/YYYY')}} - {{moment(filters.endDate).format('DD/MM/YYYY')}}</div>\n          <div class=\"backWeekButton\">\n            <md-button class=\"md-icon-button\" ng-click=\"jobAllocationsFiltersNextWeek()\" aria-label=\"Next Week\">\n              <md-icon md-svg-icon=\"next-icon.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n      </div>\n      <div class=\"right\">\n        <div md-menu-origin ng-if=\"userCanDoAction('createJob')\" class=\"newDbButton rightMargin\" ng-click=\"currentOrg.planFeatures.jobsCreate ? newJob() : selectPlan(null, 'jobsCreate', 'from jobs page - new job button')\" aria-label=\"New Job\">\n          <md-icon class=\"smallIcon\" md-svg-icon=\"note_add.svg\"></md-icon>\n          New\n          <span class=\"lockIcon\" ng-if=\"!currentOrg.planFeatures.jobsCreate\">\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </span>\n          <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"bottom\" ng-if=\"currentOrg.planFeatures.jobsCreate != true\">\n            <div style=\"font-size: 12px;\">Unlock Job creation features on the Medium Plan</div>\n          </md-tooltip>\n        </div>\n\n        <div md-menu-origin class=\"newDbButton rightMargin\" ng-click=\"currentOrg.planFeatures.jobsAllocationsView ? swapViewType() : selectPlan(null, 'jobsAllocationsView', 'from jobs page - switch view type')\" ng-if=\"currentOrg.betaAllowed == true\" aria-label=\"Swap View Type\">\n          <md-icon class=\"smallIcon\" md-svg-icon=\"allocate.svg\"></md-icon>\n          <span style=\"white-space: pre;\"> {{filters.viewType == 'list' ? 'Allocate' : 'List'}} View</span>\n          <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.jobsAllocationsView != true\">\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </span>\n          <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"bottom\" ng-if=\"currentOrg.planFeatures.jobsAllocationsView != true\">\n            <div style=\"font-size: 12px;\">Unlock Job Allocations features on the Medium Plan</div>\n          </md-tooltip>\n        </div>\n\n        <md-menu>\n          <div aria-label=\"Open list actions menu\" md-menu-origin class=\"newDbButton whiteOutline\" ng-click=\"(selected.length > 0) && openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n            Actions\n            <md-icon class=\"smallIcon\" md-svg-icon=\"arrow_down.svg\"></md-icon>\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.updateJob')\" ng-click=\"bulkSelectionSend('re-open')\" aria-label=\"Send Selected Jobs\">\n              <md-button>\n                Send Jobs\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.updateJob')\" ng-click=\"bulkSelectionClose()\" aria-label=\"Close Selected Jobs\">\n              <md-button>\n                Close Jobs\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.updateJob')\" ng-click=\"bulkSelectionSend('re-open')\" aria-label=\"Re-Open Selected Jobs\">\n              <md-button>\n                Re-Open Jobs\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.createJob')\" ng-click=\"bulkSelectionDuplicate()\" aria-label=\"Copy Selected Jobs\">\n              <md-button>\n                Duplicate Jobs\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.deleteJob')\" ng-click=\"bulkSelectionDelete()\" aria-label=\"Delete Selected Jobs\">\n              <md-button>\n                Delete Jobs\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "FXvt":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/docketsTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <div class=\"stdLoader\" ng-show=\"orderLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{orderLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"openOrderDesktop(currentOrder)\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Start Dockets Section -->\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Dockets ({{itemEdit.dockets.length >= 10 ? 'Latest 10' : itemEdit.dockets.length}})</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button class=\"md-icon-button\" ng-click=\"docketsListForOrder(itemEdit)\" aria-label=\"View all jobs for order\">\n          <md-icon md-svg-src=\"lines.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"newDocketFromOrder(itemEdit)\" ng-disabled=\"!userCanDoAction('addOrderDocket', itemEdit) || !itemEdit.customerContact\" aria-label=\"New Docket For Order\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <p ng-if=\"itemEdit.dockets == null || itemEdit.dockets.length <= 0\">\n      There are no dockets for this order\n    </p>\n    <md-table-container ng-if=\"itemEdit.dockets != null && itemEdit.dockets.length > 0\">\n      <table md-table multiple md-progress=\"docketsPromise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Docket Number</th>\n            <th md-column>Author</th>\n            <th md-column>Date</th>\n            <th md-column>Status</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"item in itemEdit.dockets\">\n            <td md-cell>\n              <a ui-sref=\"main.groupDocketDetail({docketId:item.id, orderId: itemEdit.id, orderNumber: itemEdit.orderNumber, orgId:currentOrg.id, groupId:currentOrgGroup.id})\">{{ item.docketNumber }}</a>\n            </td>\n            <td md-cell>{{item.authorName}}</td>\n            <td md-cell>{{moment(item.date).format('DD/MM/YYYY')}}</td>\n            <td md-cell width=\"100px\"><div class=\"statusDisplay {{item.status}}\">{{item.status}}</div></td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n  <!-- End Dockets Section -->\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "FY7D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('docketDetailController', ['xeroService', 'docketService', 'orderService', 'jobService', 'addressBookService', 'userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', '$q', 'scroll', 'geolocation', 'Upload', function (xeroService, docketService, orderService, jobService, addressBookService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, $q, scroll, geolocation, Upload) {
  // Main Variables For Doing Stuff
  $scope.moment = _momentTimezone2.default;
  $scope.itemEdit = null;
  $scope.data = { selectedIndex: 0 };
  $scope.newAccessor = {};

  $scope.showLineResyncing = false;

  // Base Access Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentTab = "General";

  // Filing
  $scope.singleUom = false;
  $scope.singleUomAbbreviation = '';
  $scope.totalAmount = 0;

  var timeoutSetting = 500;

  $scope.userCanDoAction = userService.userCanDoAction;

  $scope.contactSearchListFull = [];
  $scope.contactSearchList = [];
  $scope.contactSearchValue = '';

  $scope.contactSearch = { text: ''

    // Include responsive utilities and UI Functionality
  };$scope.splitListFunc = new splitListInterface($scope, $stateParams);

  $scope.geoOptions = {
    enableHighAccuracy: false,
    timeout: 5000,
    maximumAge: 0
  };

  if ($scope.currentOrg && $scope.currentOrg.features.docketSyncing == true) {
    $scope.showLineResyncing = true;
  }

  $scope.showSaveFilingButton = function () {
    return $scope.itemEdit && !$scope.itemEdit.loading && $scope.itemEdit.docketFiling && $scope.itemEdit.docketFiling.method != null && (accessControl.userHasPermission('io.docketbook.ojdapi.fileDockets') || accessControl.userHasPermission('io.docketbook.ojdapi.acceptAndFileDockets') && $scope.$parent.afterFilingAccept);
  };

  $scope.splitQuantityUpdated = function (activity) {
    activity.splitPercentage = parseFloat((activity.splitQuantity / $scope.totalAmount * 100).toFixed(4));
    activity.splitPercentage_display = parseFloat(activity.splitPercentage.toFixed(2));
  };

  $scope.splitPercentageUpdated = function (activity) {
    activity.splitPercentage = activity.splitPercentage_display;
    if ($scope.singleUom) {
      activity.splitQuantity = parseFloat(($scope.totalAmount * activity.splitPercentage / 100).toFixed(2));
    } else {
      $scope.generateUomQuantitiesForActivities($scope.itemEdit);
    }
  };

  $scope.splitQuantityBlur = function (activity) {
    activity.splitQuantity = parseFloat(parseFloat(activity.splitQuantity).toFixed(2));
    $scope.splitQuantityUpdated(activity);
  };

  $scope.loadContactSearchList = function (searchValue) {
    if ($scope.currentOrg == null) {
      return;
    }

    $scope.contactSearchLoading = true;
    $scope.promise = $q(function (resolve, reject) {
      var params = {};
      params.sort = "displayName";
      if (searchValue != null && searchValue != "") {
        params.search = searchValue;
      }

      addressBookService.getAddressBookForUnit(params, function (addressBookFull) {
        $scope.contactSearchList = addressBookFull;
        $scope.contactSearchListFull = angular.copy(addressBookFull);

        for (var i = 0; i < $scope.contactSearchList.length; i++) {
          $scope.contactSearchList[i].existing = false;
          if ($scope.existingContacts && $scope.existingContacts.length > 0) {
            for (var j = 0; j < $scope.existingContacts.length; j++) {
              if ($scope.contactSearchList[i].id == $scope.existingContacts[j].id) {
                $scope.contactSearchList[i].existing = true;
                break;
              }
            }
          }

          var initials = "";
          if ($scope.contactSearchList[i].displayName) {
            var split = $scope.contactSearchList[i].displayName.split(' ');
            if (split.length == 1) {
              initials = split[0].charAt(0).toUpperCase();
            } else if (split.length > 1) {
              initials = split[0].charAt(0).toUpperCase();
              initials += split[1].charAt(0).toUpperCase();
            }
          }
          $scope.contactSearchList[i].initials = initials;
          var existingXeroContact = $scope.contactSearchList[i].externalIdentifiers.find(function (eid) {
            return eid.type === 'xero';
          });
          if (existingXeroContact) {
            $scope.contactSearchList[i].xeroContact = existingXeroContact;
          }
        }
        $scope.contactSearchList = Restangular.stripRestangular($scope.contactSearchList);
        $scope.contactSearchLoading = false;
        resolve('Done');
      }, function (err) {
        $scope.contactSearchLoading = false;
        $scope.contactLoadingError = "Error getting contacts";
        reject('Error');
      });
    });
  };

  $scope.loadContactSearchList('');

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.getCurrentDocketFromParent = function () {
    return $scope.itemEdit;
  };

  $scope.$parent.currentActiveTab = function () {
    return $scope.currentTab;
  };

  $scope.$parent.prepareForDocketFromParent = function (docketId, docket) {
    $scope.itemEdit = {};
    $scope.itemEdit.docketId = docketId;
    if (docket != null && docket.docketNumber != null) {
      $scope.itemEdit.docketNumber = docket.docketNumber;
    }
    $scope.itemEdit.loading = true;
    $scope.itemEdit.loadingType = "getting";
    $scope.itemEdit.docketFiling = { loading: true, loadingType: 'getting' };
    $scope.currentTab = "General";
    $scope.attachmentsLoading = false;
  };

  $scope.$parent.loadDocketFromParent = function (docket, openingTab, editing) {
    $scope.itemEdit = docket;
    $scope.itemEdit.loading = true;
    $scope.itemEdit.loadingType = "getting";
    if ($scope.itemEdit.templateValueStore) {
      var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
      $scope.signatureAttachments = $scope.itemEdit.attachments.reduce(function (acc, attachment) {
        if (templateStoreValues.indexOf(attachment.id) !== -1) {
          acc.push(attachment.id);
        }
        return acc;
      }, []);
    }
    if ($stateParams.device == 'mobile') {
      if (openingTab) {
        $scope.currentTab = openingTab;
        $timeout(function () {
          $scope.openMobileTab(openingTab);
        }, 500);
      } else {
        $timeout(function () {
          $scope.openMobileTab("General");
        }, 500);
      }
    } else if (openingTab != null) {
      $scope.data.selectedIndex = openingTab;
    }
    $scope.itemEdit.loading = false;
    if (editing == true) {
      $scope.itemEdit.editing = true;
    } else {
      $scope.itemEdit.editing = false;
    }
    if ($stateParams.device == 'mobile' && $scope.userCanDoAction('editDocket', $scope.itemEdit)) {
      $scope.itemEdit.editing = true;
    }
    var resourceCount = $scope.itemEdit.resources.length;
    $scope.itemEdit.resources.forEach(function (item) {
      if (resourceCount <= 2) {
        item.collapsed = false;
      } else {
        item.collapsed = true;
      }
    });
    var attachmentsCount = 0;
    if ($scope.itemEdit.attachments) {
      for (var i = 0; i < $scope.itemEdit.attachments.length; i++) {
        if ($scope.itemEdit.attachments[i].fileName != 'supplier-signature' && $scope.itemEdit.attachments[i].fileName != 'customer-signature') {
          attachmentsCount += 1;
        }
      }
    }
    $scope.itemEdit.attachmentCount = attachmentsCount;
    if ($scope.currentOrg != null && $scope.currentOrgGroup != null && (accessControl.userHasPermission('io.docketbook.ojdapi.fileDockets') || accessControl.userHasPermission('io.docketbook.ojdapi.acceptAndFileDockets'))) {
      $scope.setupFilingDetails($scope.itemEdit);
    }
    //$scope.setupAuditLog($scope.itemEdit);
    $scope.itemEdit.signatureFields = {};
    $scope.setupChecklists($scope.itemEdit);
    // check if docket is from an order that has a xero quote referenced
    if (docket.supplierRefNo) {
      var refNoSplit = docket.supplierRefNo.split('_');
      if (refNoSplit.length > 0 && refNoSplit[0] == 'xq') {
        //refNoSplit.shift();
        $scope.itemEdit.xeroQuote = true;
        $scope.itemEdit.xeroQuoteId = refNoSplit[2];
      }
    }
    $scope.loadDocketXeroInfo(docket);
    /*
    We want to not
    $timeout(function () {
      $scope.setupSummaryMap($scope.itemEdit);
    }, timeoutSetting);
    */

    var uomTypes = docket.resources.map(function (resource) {
      return resource.resource.uom;
    });
    $scope.singleUom = _.uniq(uomTypes.map(function (uom) {
      return uom.id;
    })).length == 1;
    if ($scope.singleUom) {
      $scope.singleUomAbbreviation = uomTypes[0].abbreviation;
    }
  };

  $scope.loadDocketXeroInfo = function (docket) {
    // check if recently selected order is a xero quote
    if (!docket.xeroQuoteId && docket.supplierRefNo && docket.supplierRefNo.indexOf('xq') != -1) {
      var splits = docket.supplierRefNo.split('_');
      var xeroQuoteId = splits[2];
      docket.xeroQuoteId = xeroQuoteId;
      docket.xeroQuote = true;
      docket.xeroQuoteFull = { quoteNumber: splits[1] };
    }
    // Load most recent full Xero Quote
    if (docket.xeroQuoteId) {
      xeroService.getXeroQuote(docket.xeroQuoteId, function (quote) {
        docket.xeroQuoteFull = quote;
        // attached quote line reference to docket resources
        for (var i = 0; i < docket.resources.length; i++) {
          if (docket.resources[i].uniqueIdentifier) {
            for (var j = 0; j < quote.lineItems.length; j++) {
              if ('xql-' + quote.lineItems[j].lineItemID == docket.resources[i].uniqueIdentifier) {
                // this is the correct quote line item
                docket.resources[i].xeroQuoteLineItem = quote.lineItems[j];
                break;
              }
            }
          }
        }
      }, function (err) {
        console.error('could not get xero quote', err);
      });
    }
    // get list of xero items to fetch for resources not from quote lines
    var xeroItemIds = [];
    for (var i = 0; i < docket.resources.length; i++) {
      if (docket.resources[i].uniqueIdentifier) {
        var idSplit = docket.resources[i].uniqueIdentifier.split('-');
        if (idSplit[0] == 'xi') {
          idSplit.shift();
          xeroItemIds.push(idSplit.join('-'));
        }
      }
    }
    if (xeroItemIds.length > 0) {
      xeroService.getXeroItems({ externalIds: xeroItemIds.join(',') }, function (xeroItems) {
        for (var i = 0; i < docket.resources.length; i++) {
          if (docket.resources[i].uniqueIdentifier && docket.resources[i].uniqueIdentifier.split('-')[0] == 'xi') {
            for (var j = 0; j < xeroItems.length; j++) {
              if ('xi-' + xeroItems[j].externalId == docket.resources[i].uniqueIdentifier || 'xi-' + xeroItems[j].itemID == docket.resources[i].uniqueIdentifier) {
                docket.resources[i].xeroLineItem = xeroItems[j];
                break;
              }
            }
          }
        }
      }, function (err) {
        console.error('could not get xero items', err);
      });
    }
  };

  $scope.$parent.newDocketFromParent = function (fromType, fromId, cb) {

    $scope.createNewDocket(null, null, fromType, fromId, cb);
  };

  $scope.$parent.newDocketWithAuthorFromParent = function (author, authorName, fromType, fromId, cb) {

    $scope.createNewDocket(author, authorName, fromType, fromId, cb);
  };

  $scope.$parent.clearDocketFromParent = function () {
    $scope.itemEdit = null;
  };

  /*****************************/
  /***** Main UI Functions *****/
  /*****************************/

  $scope.setupChecklists = function (docket) {
    if (docket.template != null) {
      docketService.validateChecklists(docket);
    }
  };

  $scope.updateDocketChecklists = function (docket) {
    docketService.validateChecklists(docket);
  };

  $scope.setupAuditLog = function (docket) {}
  /*var eventLog = docket.eventLog;
  eventLog.sort(function(a,b) {
    return new Date(b.addedOn) - new Date(a.addedOn);
  });*/


  // Get and setup filing details for this docket
  ;$scope.setupFilingDetails = function (docket) {
    docket.docketFiling = { loading: true, loadingType: 'getting' };
    docketService.getDocketFileData(docket.id, function (docketFile) {
      docket.existingDocketFile = docketFile;
      if (docket.existingDocketFile) {
        docket.docketFiling.method = docketFile.fileMethod;
      }
      if (docketFile && docketFile.createdAt) {
        docket.docketFiling.createdAt = docketFile.createdAt;
      }
      if (docketFile && docketFile.updatedAt) {
        docket.docketFiling.updatedAt = docketFile.updatedAt;
      }
      // generate resources/lines summary for docket
      var fullResourcesSummary = {};
      var linesSummary = [];
      for (var i = 0; i < docket.resources.length; i++) {
        var resourceId = docket.resources[i].resource.id;
        if (fullResourcesSummary[resourceId] == null) {
          var resourceSummary = {};
          resourceSummary.interactions = {};
          resourceSummary.resource = docket.resources[i].resource;
          fullResourcesSummary[resourceId] = resourceSummary;
        }
        for (var j = 0; j < docket.resources[i].interactions.length; j++) {
          var interaction = docket.resources[i].interactions[j];
          var quantity = docket.resources[i].interactions[j].quantity;
          var resource = docket.resources[i].interactions[j].resource;
          var lineSummary = {};
          lineSummary.resource = resource;
          lineSummary.quantity = quantity;
          lineSummary.interaction = interaction;
          lineSummary.activityCodes = [];
          // get activityCode for line
          if (docket.existingDocketFile && docket.existingDocketFile.fileMethod == 'lines' && docket.existingDocketFile.lineCodes) {
            var lineCodes = docket.existingDocketFile.lineCodes;
            for (var k = 0; k < lineCodes.length; k++) {
              if (lineCodes[k].interaction.id == lineSummary.interaction.id) {
                // got the right line code = now get the populated file code
                if (lineCodes[k].populatedFileCodes) {
                  for (var fc = 0; fc < lineCodes[k].populatedFileCodes.length; fc++) {
                    var newActivityCode = lineCodes[k].populatedFileCodes[fc];
                    newActivityCode.percentage_display = parseFloat(newActivityCode.percentage.toFixed(2));
                    newActivityCode.quantity = parseFloat((lineSummary.interaction.quantity * newActivityCode.percentage / 100).toFixed(2));

                    lineSummary.activityCodes.push(newActivityCode);
                  }
                }
                break;
              }
            }
          }

          if (lineSummary.activityCodes == null || lineSummary.activityCodes.length == 0) {
            lineSummary.activityCodes = [{
              percentage: 100,
              percentage_display: 100,
              quantity: quantity
            }];
          }

          linesSummary.push(lineSummary);
          if (fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] == null) {
            var interactionSummary = {};
            interactionSummary.interaction = interaction;
            interactionSummary.quantity = quantity;
            fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] = interactionSummary;
          } else {
            fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id].quantity += quantity;
          }
        }
      }
      docket.docketFiling.linesSummary = linesSummary;

      if ($scope.singleUom) {
        $scope.totalAmount = docket.docketFiling.linesSummary.map(function (line) {
          return line.quantity;
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
      }

      // if currently filed by split - get list of file codes and percentages to display
      var fileCodes = [];
      if (docket.existingDocketFile && docket.existingDocketFile.fileMethod == 'split') {
        if (docket.existingDocketFile.lineCodes && docket.existingDocketFile.lineCodes[0] && docket.existingDocketFile.lineCodes[0].populatedFileCodes) {
          for (var i = 0; i < docket.existingDocketFile.lineCodes[0].populatedFileCodes.length; i++) {
            var thisCode = { fileCode: docket.existingDocketFile.lineCodes[0].populatedFileCodes[i].fileCode };
            thisCode.splitPercentage = docket.existingDocketFile.lineCodes[0].populatedFileCodes[i].percentage;
            thisCode.splitPercentage_display = parseFloat(thisCode.splitPercentage.toFixed(2));
            thisCode.splitQuantity = parseFloat(($scope.totalAmount * thisCode.splitPercentage / 100).toFixed(2));
            fileCodes.push(thisCode);
          }
        }
      }
      docket.docketFiling.activityCodes = fileCodes;

      docket.docketFiling.loading = false;
      $scope.generateUomQuantitiesForActivities($scope.itemEdit);

      if ($scope.itemEdit.existingDocketFile == null) {
        $scope.changeFileMethod('split', $scope.itemEdit.docketFiling);
      }
    }, function (err) {
      docket.existingDocketFile = null;
      docket.docketFiling.loading = false;
    });
  };

  $scope.totalPercentage = function () {
    if ($scope.itemEdit == null || $scope.itemEdit.docketFiling == null || $scope.itemEdit.docketFiling.activityCodes == null) {
      return 0;
    }

    return $scope.itemEdit.docketFiling.activityCodes.map(function (x) {
      return Number.parseFloat(x.splitPercentage);
    }).reduce(function (a, b) {
      return a + b;
    }, 0).toFixed(2);
  };

  $scope.totalQuantity = function () {
    if ($scope.itemEdit == null || $scope.itemEdit.docketFiling == null || $scope.itemEdit.docketFiling.activityCodes == null) {
      return 0;
    }

    return $scope.itemEdit.docketFiling.activityCodes.map(function (x) {
      return Number.parseFloat(x.splitQuantity);
    }).reduce(function (a, b) {
      return a + b;
    }, 0).toFixed(2);
  };

  $scope.docketIsSignable = function () {
    // Check if the docket template has a signatures block
    return $scope.itemEdit.template && $scope.itemEdit.template.blocks.map(function (block) {
      return block.type;
    }).includes('signatures');
  };

  // Generate map summary data and setup map
  $scope.setupSummaryMap = function (docket, method) {
    var mapDiv = "";
    if ($stateParams.previewMode == true) {
      mapDiv = ".preAuthDocketContainer #fullInteractionMap";
    } else if ($stateParams.device == 'mobile') {
      mapDiv = ".mobileListContainer #fullInteractionMap";
    } else {
      mapDiv = ".desktopContainer #fullInteractionMap";
    }
    // Get list of interaction lat/lngs to show on a map
    var map = new google.maps.Map($(mapDiv).get(0), options);
    var places = new google.maps.places.PlacesService(map);
    var infowindow = new google.maps.InfoWindow({
      content: "holding.."
    });
    var interactionMarkers = [];
    var centerPos = {};
    var bounds = new google.maps.LatLngBounds();
    if (docket.resources) {
      for (var i = 0; i < docket.resources.length; i++) {
        for (var j = 0; j < docket.resources[i].interactions.length; j++) {
          var thisInteraction = docket.resources[i].interactions[j];

          if (thisInteraction.lat && thisInteraction.long) {
            centerPos = { lat: thisInteraction.lat, lng: thisInteraction.long };
            var htmlString = "";
            if (docket.customerContact) {
              htmlString += '<p>Customer: ' + docket.customerContact.displayName + '</p>';
            }
            htmlString += '<p>Operator: ' + docket.authorName + '</p>';
            if (thisInteraction.resource) {
              htmlString += '<p>Resource: ' + thisInteraction.resource.name + '</p><p>Line Type: ' + thisInteraction.interactionName + '<p>Quantity: ' + thisInteraction.quantity + ' ' + thisInteraction.resource.uom.abbreviation + '</p>';
            }
            htmlString += '<p>' + (0, _momentTimezone2.default)(thisInteraction.createdAt).tz($scope.itemEdit.timezone).format('DD/MM/YY hh:mm a') + '</p>';
            var newMapMarker = new google.maps.Marker({
              position: { lat: thisInteraction.lat, lng: thisInteraction.long },
              title: 'Line Created Here',
              animation: google.maps.Animation.DROP,
              label: 'L',
              html: htmlString
            });
            google.maps.event.addListener(newMapMarker, 'click', function () {
              infowindow.setContent(this.html);
              infowindow.open(map, this);
            });
            var loc = new google.maps.LatLng(thisInteraction.lat, thisInteraction.long);
            bounds.extend(loc);
            interactionMarkers.push(newMapMarker);
          }
        }
      }
    }
    // Submission Marker
    if (docket.lat && docket.long) {
      var submissionMarker = new google.maps.Marker({
        position: { lat: docket.lat, lng: docket.long },
        title: 'Docket Sent Here',
        animation: google.maps.Animation.DROP,
        label: 'S'
      });
      var loc = new google.maps.LatLng(docket.lat, docket.long);
      bounds.extend(loc);
      interactionMarkers.push(submissionMarker);
    }

    // Show Interactions Map
    var options = {
      maxZoom: 18,
      disableDefaultUI: true
    };

    if (interactionMarkers.length == 0) {
      $(".fullSizeMapNoData").show();
      $(".fullSizeMapOuter").hide();
    } else {
      $(".fullSizeMapOuter").show();
      $(".fullSizeMapNoData").hide();
    }

    map.fitBounds(bounds);
    map.panToBounds(bounds);
    for (var i = 0; i < interactionMarkers.length; i++) {
      interactionMarkers[i].setMap(map);
    }
  };

  /*********************************/
  /***** Docket Data Functions *****/
  /*********************************/

  $scope.selectOrderChange = function (searchText) {
    $scope.updateOrderRef();
  };

  $scope.updateOrderRef = function () {
    docketService.updateDocketRefs($scope.itemEdit);
  };

  $scope.createNewDocket = function (author, authorName, fromType, fromId, cb) {

    var timezone = $scope.currentOrgGroup.timezone;
    if (!timezone) {
      timezone = _momentTimezone2.default.tz.guess();
    }
    var shellDocket = { 'docketNumber': 'New Docket', 'status': 'New', 'newDocket': 'true', 'authorName': $scope.currentUser.name.full, 'timezone': timezone };
    shellDocket.date = new Date();
    // setup supplier contact from org group details
    var supplierContact = {};
    supplierContact.displayName = $scope.currentOrgGroup.publicName;
    supplierContact.contactAddresses = {};
    supplierContact.addresses = [];
    if ($scope.currentOrgGroup.address != null) {
      supplierContact.addresses.push($scope.currentOrgGroup.address);
    }
    if ($scope.currentOrgGroup.emailAddress != null) {
      supplierContact.contactAddresses[$scope.currentOrgGroup.emailAddress] = [];
    }
    shellDocket.supplierContact = supplierContact;

    // If from job - get job and check users accessControl
    if (fromType == 'job' && fromId) {
      jobService.createDocketFromJob(fromId, function (newDocket) {
        cb(newDocket);
      }, function (err) {
        cb(shellDocket);
      });
    } else if (fromType == 'order' && fromId) {
      orderService.createDocketFromOrder(fromId, function (newDocket) {
        cb(newDocket);
      }, function (err) {
        cb(shellDocket);
      });
    } else {
      shellDocket.template = $scope.currentOrgGroup.defaultTemplate;
      if (author && authorName) {
        shellDocket.author = author;
        shellDocket.authorName = authorName;
      }
      // get full template
      docketService.getTemplate(shellDocket.template, function (fullTemplate) {
        shellDocket.template = fullTemplate;

        docketService.saveDocket(shellDocket, function (newDocket) {
          cb(newDocket);
        }, function (err) {
          cb(shellDocket);
        });
      }, function (err) {
        cb(shellDocket);
      });
    }
  };

  $scope.$parent.openNewDocketFromParent = function (docket) {
    $scope.openNewDocket(docket);
  };

  $scope.openNewDocket = function (newDocket) {
    $scope.itemEdit = newDocket;
    $scope.itemEdit.editing = true;
    $scope.currentTab = "General";
    $scope.updateOrderRef();
  };

  // Cancel new docket
  $scope.cancelNewDocket = function () {
    $stateParams.active = null;
    $scope.reloadWithFilters();
  };

  /*********************************/
  /**** Access Control Editing *****/
  /*********************************/

  $scope.assignDocketOrg = function (docket) {
    var assignDocket = {};
    $scope.$parent.selectOrganisationForDocket(docket, function (group) {
      if (group != null) {
        $scope.assignDocketSave(docket, group);
      }
    });
  };

  $scope.assignDocketSave = function (docket, group) {
    var losingPrincipal = $scope.currentUser.emailAddress;
    var gainingPrincipal = group.emailAddress;
    docketService.reassignDocket(docket.id, losingPrincipal, gainingPrincipal, function (success) {
      $scope.$parent.closeDocket();
      if ($stateParams.device == 'desktop') {
        $scope.$parent.loadDocketsList();
      }
    }, function (err) {
      swal({
        title: "Error!",
        text: "An error occured while reassigning the docket.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    });
  };

  $scope.shareDocket = function (docket) {
    if (docket.editing) {
      swal({
        title: "Oops!",
        text: "Please save the docket before sharing.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return;
    }

    var userAccessLevels = [];
    $scope.newAccessor = { 'accessLevel': 'editor' };
    $scope.contactSearch.text = '';
    if ($scope.contactSearchListFull.length == 1) {
      $scope.newAccessor.recipient = $scope.contactSearchListFull[0];
    }
    $scope.accessControlEdit = {};
    $scope.accessControlEdit.docketNumber = docket.docketNumber;
    var accessControlEdit = [];
    var currentKeys = Object.keys(docket.accessControl);
    for (var i = 0; i < currentKeys.length; i++) {
      var newAccessControlItem = {};
      newAccessControlItem.emailAddress = currentKeys[i];
      newAccessControlItem.accessLevel = "";
      if (docket.accessControl[currentKeys[i]].indexOf('creator') != -1) {
        newAccessControlItem.accessLevel = 'creator';
        newAccessControlItem.accessLevelSet = true;
      } else if (docket.accessControl[currentKeys[i]].indexOf('editor') != -1) {
        newAccessControlItem.accessLevel = 'editor';
      } else if (docket.accessControl[currentKeys[i]].indexOf('approver') != -1) {
        newAccessControlItem.accessLevel = 'approver';
      } else if (docket.accessControl[currentKeys[i]].indexOf('viewer') != -1) {
        newAccessControlItem.accessLevel = 'viewer';
      }
      newAccessControlItem.accessLevelInitial = newAccessControlItem.accessLevel;
      newAccessControlItem.accessLevelsArray = docket.accessControl[currentKeys[i]];

      // check if customer or supplier
      if (docket.supplierContact) {
        var addressKeys = Object.keys(docket.supplierContact.contactAddresses);
        for (var j = 0; j < addressKeys.length; j++) {
          if (newAccessControlItem.emailAddress == addressKeys[j]) {
            newAccessControlItem.isSupplier = true;
            break;
          }
        }
      }

      if (docket.customerContact) {
        var addressKeys = Object.keys(docket.customerContact.contactAddresses);
        for (var j = 0; j < addressKeys.length; j++) {
          if (newAccessControlItem.emailAddress == addressKeys[j]) {
            newAccessControlItem.isCustomer = true;
            break;
          }
        }
      }

      // check if current user and get accessLevels
      if (newAccessControlItem.emailAddress == $scope.currentUser.emailAddress) {
        for (var j = 0; j < newAccessControlItem.accessLevelsArray.length; j++) {
          userAccessLevels.push(newAccessControlItem.accessLevelsArray[j]);
        }
        newAccessControlItem.isUser = true;
      }

      // check is current org groups email and add get accessLevels
      if ($scope.currentOrgGroup && $scope.currentOrgGroup.emailAddresses) {
        for (var j = 0; j < $scope.currentOrgGroup.emailAddresses.length; j++) {
          if ($scope.currentOrgGroup.emailAddresses[j] == newAccessControlItem.emailAddress) {
            for (var k = 0; k < newAccessControlItem.accessLevelsArray.length; k++) {
              userAccessLevels.push(newAccessControlItem.accessLevelsArray[k]);
            }
            break;
          }
        }
      }
      accessControlEdit.push(newAccessControlItem);
    }

    $scope.accessControlEdit.accessControl = accessControlEdit;

    // get max accessLevel
    var maxLevel = "";
    if (userAccessLevels.indexOf('creator') != -1) {
      maxLevel = "creator";
    } else if (userAccessLevels.indexOf('editor') != -1) {
      maxLevel = "editor";
    } else if (userAccessLevels.indexOf('approver') != -1) {
      maxLevel = "approver";
    } else if (userAccessLevels.indexOf('viewer') != -1) {
      maxLevel = "viewer";
    }
    $scope.accessControlEdit.maxLevel = maxLevel;
    $mdBottomSheet.hide();
    $("#shareDocketModal").fadeIn(100);
  };

  $scope.canSetAccessLevel = function (accessor, accessLevel) {
    if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
      return false;
    }
    if (accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' || $scope.accessControlEdit.maxLevel == 'approver' || $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessLevel == 'approver' && ($scope.accessControlEdit.maxLevel == 'approver' || $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessLevel == 'editor' && ($scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessLevel == 'remove' && accessor.accessLevel == 'editor' && ($scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessLevel == 'remove' && accessor.accessLevel == 'approver' && ($scope.accessControlEdit.maxLevel == 'approver' || $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessLevel == 'remove' && accessor.accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' || $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }

    return false;
  };

  $scope.canChangeAccessLevel = function (accessor) {
    if (accessor.accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' || $scope.accessControlEdit.maxLevel == 'approver' || $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessor.accessLevel == 'editor' && ($scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessor.accessLevel == 'approver' && ($scope.accessControlEdit.maxLevel == 'approver' || $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessor.accessLevel == 'creator' && $scope.accessControlEdit.maxLevel == 'creator') {
      return true;
    }
  };

  $scope.closeAccessControlModal = function () {
    $("#shareDocketModal").fadeOut(100);
  };

  $scope.saveAccessControlEdit = function () {
    $scope.accessControlEdit.loading = true;
    // convert back to accessControl object
    var accessControlObject = {};
    for (var i = 0; i < $scope.accessControlEdit.accessControl.length; i++) {
      var thisAccessItem = $scope.accessControlEdit.accessControl[i];
      if (thisAccessItem.new == true) {
        accessControlObject[thisAccessItem.emailAddress] = {};
        accessControlObject[thisAccessItem.emailAddress].add = [thisAccessItem.accessLevel];
      } else if (thisAccessItem.accessLevelInitial != thisAccessItem.accessLevel) {
        // access has been changed - need to construct add/remove fields
        if (thisAccessItem.accessLevel == 'remove') {
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
        } else if (thisAccessItem.accessLevel == 'editor') {
          // construct add/remove dependent on initial array
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
          accessControlObject[thisAccessItem.emailAddress].add = ['editor'];
        } else if (thisAccessItem.accessLevel == 'approver') {
          // construct add/remove depending on initial array
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
          accessControlObject[thisAccessItem.emailAddress].add = ['approver'];
        } else if (thisAccessItem.accessLevel == 'viewer') {
          // construct ad/remove dependent on initial array
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
          accessControlObject[thisAccessItem.emailAddress].add = ['viewer'];
        }
      }
    }

    docketService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (success) {
      $scope.itemEdit.accessControl = success.accessControl;
      $("#shareDocketModal").fadeOut(100);
    }, function (err) {
      $scope.accessControlEdit.loading = false;
      swal({
        title: "Error!",
        text: "An error occured while sharing the docket.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    });
  };

  $scope.addNewAccessor = function (contactSearchValue) {
    $scope.newAccessor.loading = true;

    var emails = $scope.newAccessor.recipient ? $scope.newAccessor.recipient.contactAddresses.map(function (x) {
      return x.emailAddress;
    }) : [contactSearchValue];

    if (emails.length == 0) {
      swal({
        title: "Oops!",
        text: "The recipient you selected does not have any contact addresses.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      $scope.newAccessor.loading = false;
      return;
    }

    var accessControlObject = {};

    emails.forEach(function (email) {
      $scope.accessControlEdit[email] = { add: $scope.newAccessor.accessLevel };
      $scope.accessControlEdit.accessControl.push({ emailAddress: email, accessLevel: $scope.newAccessor.accessLevel });

      accessControlObject[email] = {};
      accessControlObject[email].add = [$scope.newAccessor.accessLevel];
    });

    docketService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (success) {
      $scope.itemEdit.accessControl = success.accessControl;
      $scope.closeAccessControlModal();
      $scope.newAccessor.recipient = null;
      $scope.newAccessor.loading = false;
    }, function (err) {
      $scope.newAccessor.loading = false;
      swal({
        title: "Error!",
        text: "An error occured while sharing the docket.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    });
  };

  $scope.selectAccessorContact = function () {
    $("#shareDocketModal").fadeOut(100);
    $scope.$parent.selectContactForShare(function (contactSelected) {
      if (contactSelected != null) {
        $("#shareDocketModal").fadeIn(100);
        /*if ( contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress ) {
          $scope.newAccessor.emailAddress = contactSelected.contactAddresses[0].emailAddress;
        }*/
        var emailAddresses = [];
        for (var i = 0; i < contactSelected.contactAddresses.length; i++) {
          if (contactSelected.contactAddresses[i].emailAddress) {
            emailAddresses.push(contactSelected.contactAddresses[i].emailAddress);
          }
        }
        $scope.newAccessor.emailAddress = emailAddresses.join(',');
      } else {
        $("#shareDocketModal").fadeIn(100);
      }
    });
  };

  /****************************/
  /***** UI Functionality *****/
  /****************************/

  $scope.openMobileTab = function (tabName) {
    $scope.currentTab = tabName;
    if ($stateParams.device != 'desktop') {
      var leftOffset = $("#tab" + tabName).offset().left + $("#tab" + tabName).width();
      var width = $(".tabBarMobile.detailTabBar").width();
      var M = width / 2;
      var Y = leftOffset;
      var X = $(".tabBarMobile.detailTabBar").scrollLeft();

      if (Y > M) {
        // scroll right
        $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X + (Y - M) }, 600);
      } else {
        // scroll left
        $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X - (M - Y) }, 600);
      }
    }

    // Trigger background progressive save
    if ($scope.itemEdit && $scope.itemEdit.id != null) {
      $scope.progressiveSaveDocket($scope.itemEdit);
    }

    // Trigger summary map update
    if (tabName == 'Map') {
      $scope.setupSummaryMap($scope.itemEdit, 'tab');
    }
  };

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.getResourceTotalQty = function (resourceGrouped) {
    var totalQuantity = 0;
    for (var i = 0; i < resourceGrouped.interactions.length; i++) {
      if ($scope.itemEdit.template.sumOnlyBillableInteractions) {
        if (resourceGrouped.interactions[i].interactionTemplate.billable) {
          totalQuantity += resourceGrouped.interactions[i].quantity;
        }
      } else {
        totalQuantity += resourceGrouped.interactions[i].quantity;
      }
    }

    totalQuantity = totalQuantity.toFixed(2);

    return totalQuantity;
  };

  $scope.getResourceQtySummary = function (resourceGrouped) {
    var totalQuantity = 0;
    for (var i = 0; i < resourceGrouped.interactions.length; i++) {
      if ($scope.itemEdit.template.sumOnlyBillableInteractions) {
        if (resourceGrouped.interactions[i].interactionTemplate.billable) {
          totalQuantity += resourceGrouped.interactions[i].quantity;
        }
      } else {
        totalQuantity += resourceGrouped.interactions[i].quantity;
      }
    }

    totalQuantity = totalQuantity.toFixed(2);

    var abbreviation = "";
    if (resourceGrouped.resource.uom && resourceGrouped.resource.uom.abbreviation) {
      abbreviation = resourceGrouped.resource.uom.abbreviation;
    }

    return totalQuantity + " " + abbreviation;
  };

  /**************************/
  /***** Assign Order *******/
  /**************************/

  // Select order
  $scope.selectOrder = function () {
    if ($scope.currentOrgGroup) {
      var supplierEmails = $scope.currentOrgGroup.emailAddresses;
    }
    var options = { currentOrder: $scope.itemEdit.orderRef, statusList: 'draft,sent,accepted', supplier: supplierEmails, hasCustomer: true };
    $scope.$parent.selectOrderForDocket(options, function (order) {
      if (order != null) {
        // get full order object
        orderService.getOrder(order.id, function (fullOrder) {
          $scope.itemEdit.orderRef = fullOrder;
          $scope.updateOrderRef();
          $scope.loadDocketXeroInfo($scope.itemEdit);
        }, function (err) {
          $scope.itemEdit.orderRef = order;
          $scope.updateOrderRef();
          $scope.loadDocketXeroInfo($scope.itemEdit);
        });
      }
    });
  };

  /**********************/
  /***** Assign Job *****/
  /**********************/

  $scope.selectJob = function () {
    $scope.$parent.selectJobForDocket({}, function (job) {
      if (job != null) {
        // get full job object
        jobService.getJob(job.id, function (fullJob) {
          $scope.itemEdit.jobRef = fullJob;
          if (fullJob.order) {
            $scope.itemEdit.orderRef = fullJob.order;
            $scope.itemEdit.orderRef.id = fullJob.order.orderId;
          }
          $scope.updateOrderRef();
        }, function (err) {
          $scope.itemEdit.jobRef = job;
          $scope.updateOrderRef();
        });
      }
    });
  };

  /***************************************/
  /***** Select Docket Template Func *****/
  /***************************************/

  // Select company - show list in sidebar
  $scope.selectDocketTemplate = function () {
    $scope.$parent.selectTemplateForDocket($scope.itemEdit.template, function (template) {
      if (template != null) {
        // get full docket template
        docketService.getTemplate(template, function (fullTemplate) {
          $scope.itemEdit.template = fullTemplate;
          docketService.setupChecklists($scope.itemEdit);
        }, function (err) {
          $scope.itemEdit.template = null;
          $scope.showToast('Error Loading Docket Template');
        });
      }
    });
  };

  /****************************************/
  /***** Select Company Functionality *****/
  /****************************************/

  $scope.additionalContactMatch = function (type) {
    if (!$scope.itemEdit.additionalContacts) {
      return undefined;
    }
    return $scope.itemEdit.additionalContacts.find(function (con) {
      return con.additionalContactName === type;
    });
  };

  $scope.selectCompany = function (type) {
    $scope.$parent.selectContactForDocket($scope.itemEdit, type, function (contact) {
      if (contact != null) {
        if (contact.contactAddresses != null) {
          var newContactAddresses = {};
          for (var i = 0; i < contact.contactAddresses.length; i++) {
            if (type == 'customerContact') {
              newContactAddresses[contact.contactAddresses[i].emailAddress] = ['approver'];
            } else {
              newContactAddresses[contact.contactAddresses[i].emailAddress] = ['editor'];
            }
          }

          contact.contactAddresses = newContactAddresses;
        }
        var additionalMatch = undefined;
        if ($scope.itemEdit.template && $scope.itemEdit.template.additionalContactNames) {
          additionalMatch = $scope.itemEdit.template.additionalContactNames.find(function (item) {
            return item.contactName == type;
          });
        }
        if (additionalMatch !== undefined) {
          if ($scope.itemEdit.additionalContacts === undefined) {
            $scope.itemEdit.additionalContacts = [];
          }
          var existing = $scope.itemEdit.additionalContacts.find(function (con) {
            return con.additionalContactName === type;
          });
          if (existing === undefined) {
            $scope.itemEdit.additionalContacts.push(Object.assign({}, contact, {
              additionalContactName: type
            }));
          } else {
            $scope.itemEdit.additionalContacts[$scope.itemEdit.additionalContacts.indexOf(existing)] = Object.assign({}, contact, {
              additionalContactName: type
            });
          }
        } else {
          $scope.itemEdit[type] = contact;
        }
      }
    });
  };

  /**************************************/
  /***** Add Resource Functionality *****/
  /**************************************/

  // Add a new resource to the docket
  $scope.addResource = function (method) {
    if ($stateParams.device == 'mobile') {
      $scope.$parent.selectResourceForDocket($scope.itemEdit, function (resource) {
        if (resource != null) {
          $scope.addResourceToDocket(resource, $scope.itemEdit);
        }
      });
    } else {
      $scope.$parent.selectResourceForDocket($scope.itemEdit, function (resources) {
        if (resources != null) {
          for (var i = 0; i < resources.length; i++) {
            $scope.addResourceToDocket(resources[i], $scope.itemEdit);
          }
        }
      });
    }
  };

  $scope.addResourceToDocket = function (resource, docket) {
    if (docket.resources == null) {
      docket.resources = [];
    }

    var newResourceObject = {};
    newResourceObject.resource = resource;
    newResourceObject.description = resource.lineDescription;
    newResourceObject.orderItemId = resource.orderItemId;
    if (resource.orderSupplierRef) {
      newResourceObject.uniqueIdentifier = resource.orderSupplierRef;
    } else if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled) {
      // get xero external identifier
      if (resource.externalIdentifiers) {
        for (var i = 0; i < resource.externalIdentifiers.length; i++) {
          if (resource.externalIdentifiers[i].type == 'xero') {
            newResourceObject.uniqueIdentifier = 'xi-' + resource.externalIdentifiers[i].externalId;
          }
        }
      }
    }
    newResourceObject.collapsed = false;
    newResourceObject.interactions = [];

    // set start and end time of resource to the docket start/end time
    if (docket.startTime != null) {
      newResourceObject.startTime = docket.startTime;
    }

    if (docket.endTime != null) {
      newResourceObject.endTime = docket.endTime;
    }

    if ($stateParams.device == 'mobile') {
      $scope.temporyAddResource = newResourceObject;
      $scope.addInteractionMethod = 'temp';
      $scope.addInteractionToResource($scope.temporyAddResource);
    } else {
      $scope.addInteractionMethod = 'existing';
      docket.resources.push(newResourceObject);
    }
    $scope.loadDocketXeroInfo(docket);
  };

  $scope.addInteractionToResource = function (resource, method) {
    if (method && method == 'existing') {
      $scope.addInteractionMethod = 'existing';
      if ($stateParams.device == 'mobile') {
        $scope.itemEdit.loading = true;
        $scope.itemEdit.loadingType = 'saving';
      }
    }
    $scope.$parent.newInteractionForResource($scope.itemEdit, resource, function (newInteraction) {
      if (newInteraction == null) {
        $scope.itemEdit.loading = false;
        return;
      }

      if (resource.interactions == null) {
        resource.interactions = [];
      }

      if (newInteraction.quantityEdit === null || newInteraction.quantityEdit === undefined || isNaN(newInteraction.quantityEdit)) {
        newInteraction.quantityEdit = 0;
      }

      // strip interaction template to be only a reference
      var interactionTemplateNew = {};
      interactionTemplateNew.billable = newInteraction.interactionTemplate.billable;
      interactionTemplateNew.xeroQuantity = newInteraction.interactionTemplate.xeroQuantity;
      interactionTemplateNew.descripton = newInteraction.interactionTemplate.description;
      interactionTemplateNew.fields = newInteraction.interactionTemplate.fields;
      interactionTemplateNew.id = newInteraction.interactionTemplate.id;
      interactionTemplateNew.name = newInteraction.interactionTemplate.name;
      interactionTemplateNew.refersParent = true;
      newInteraction.interactionTemplate = interactionTemplateNew;

      // check quantity is time and convert to minutes
      if (newInteraction.resource.uom.isTime) {
        // convert quantity to minutes
        var abbreviation = newInteraction.resource.uom.abbreviation;
        if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
          // convert from hours to minutes
          newInteraction.quantity = newInteraction.quantityEdit * 60;
        }
        if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
          // display from hours&minutes to minutes
          var totalMinutes = 0;
          totalMinutes += parseInt(newInteraction.quantityHoursEdit) * 60;
          totalMinutes += parseInt(newInteraction.quantityMinutesEdit);
          newInteraction.quantity = totalMinutes;
        }
        if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
          newInteraction.quantity = newInteraction.quantityEdit;
        }
      } else {
        newInteraction.quantity = newInteraction.quantityEdit;
      }

      // Add createdAt timestamp
      newInteraction.createdAt = _momentTimezone2.default.tz($scope.itemEdit.timezone).toISOString();

      $scope.getLatestGeolcation(function (geolocation) {
        if (geolocation != null) {
          newInteraction.lat = geolocation.lat;
          newInteraction.long = geolocation.long;
        }
        resource.interactions.push(newInteraction);
        if ($scope.addInteractionMethod == 'temp') {
          $scope.itemEdit.resources.push($scope.temporyAddResource);
        }
        if ($stateParams.device == 'mobile') {
          $scope.itemEdit.loading = false;
          $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
        }
      });
    });
  };

  $scope.removeResourceFromDocket = function (resource, docket) {
    if (docket.id != null) {
      resource.delete = true;
      if ($stateParams.device == 'mobile') {
        $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
      }
    } else {
      var index = docket.resources.indexOf(resource);
      if (index != -1) {
        docket.resources.splice(index, 1);
      }
    }
  };

  $scope.removeInteractionFromResource = function (interaction, resource, cb) {
    var index = resource.interactions.indexOf(interaction);
    if (index != -1) {
      resource.interactions.splice(index, 1);
    }

    if ($stateParams.device == 'mobile') {
      $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
    }
    if (cb) {
      cb();
    }
  };

  $scope.viewInteraction = function (interaction) {};

  $scope.editInteraction = function (interaction, resource) {
    $scope.$parent.editInteractionForResource(interaction, $scope.itemEdit, resource, function (response) {
      if (response != null) {
        if (response.delete) {
          var index = 0;
          for (var i = 0; i < resource.interactions.length; i++) {
            if (resource.interactions[i].id == response.id) {
              index = i;
              break;
            }
          }
          if (index != -1) {
            resource.interactions.splice(index, 1);
          }
        } else {
          // check quantity is time and convert to minutes
          if (response.resource.uom.isTime) {
            // convert quantity to minutes
            var abbreviation = response.resource.uom.abbreviation;
            if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
              // convert from hours to minutes
              response.quantity = response.quantityEdit * 60;
            }
            if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
              // display from hours&minutes to minutes
              var totalMinutes = 0;
              totalMinutes += parseInt(response.quantityHoursEdit) * 60;
              totalMinutes += parseInt(response.quantityMinutesEdit);
              response.quantity = totalMinutes;
            }
            if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
              response.quantity = response.quantityEdit;
            }
          } else {
            response.quantity = response.quantityEdit;
          }
        }
        if ($stateParams.device == 'mobile') {
          $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
        }
      }
    });
  };

  /******************************/
  /***** Capture Signature ******/
  /******************************/

  $scope.captureCustomerSignatureFromCustomer = function () {
    var target = $scope.$parent;
    if ('captureSignatureForDocket' in $scope) {
      target = $scope;
    }
    target.captureSignatureForDocket("Customer", true, "", true, $scope.itemEdit.template, function (signatureObject) {
      if (signatureObject != null) {
        $scope.itemEdit.customerSignatureData = signatureObject.signatureImage;
        $scope.itemEdit.customerSignatureImage = signatureObject.signatureImageFull;
        $scope.itemEdit.customerSignatureName = signatureObject.signatureName;
        docketService.saveMyDocketSignature($scope.itemEdit, function () {
          //alert('saved');
        }, function () {
          //alert('err');
        });
      }
    });
  };

  $scope.captureSignature = function (signatureField) {
    var nameRequired = false;
    var termsRequired = false;
    var entity = "";
    var name = "";
    if (signatureField == 'customerSignature') {
      nameRequired = true;
      termsRequired = true;
      name = "";
      entity = "Customer";
    } else {
      nameRequired = false;
      termsRequired = false;
      name = $scope.itemEdit.authorName;
      entity = "Operator";
    }

    $scope.$parent.captureSignatureForDocket(entity, nameRequired, name, termsRequired, $scope.itemEdit.template, function (signatureObject) {
      if (signatureObject != null) {
        if (signatureField == 'customerSignature') {
          $scope.itemEdit.customerSignatureData = signatureObject.signatureImage;
          $scope.itemEdit.customerSignatureImage = signatureObject.signatureImageFull;
        } else {
          $scope.itemEdit.supplierSignatureData = signatureObject.signatureImage;
          $scope.itemEdit.supplierSignatureImage = signatureObject.signatureImageFull;
        }
        if (nameRequired) {
          $scope.itemEdit.customerSignatureName = signatureObject.signatureName;
        }
      }
    });
  };

  $scope.captureFieldSignature = function (block, field) {

    $scope.$parent.captureSignatureForDocket(field.displayName, false, " ", false, $scope.itemEdit.template, function (signatureObject) {
      if (signatureObject != null) {
        if ($scope.itemEdit.signatureFields == null) {
          $scope.itemEdit.signatureFields = {};
        }
        signatureObject.blockId = block.id;
        signatureObject.fieldId = field.id;
        signatureObject.displayName = field.displayName;
        $scope.itemEdit.signatureFields[block.id + '-' + field.id] = signatureObject;
      }
    });
  };

  /***************************/
  /***** Checklist Funct *****/
  /***************************/

  $scope.openChecklistDetailModal = function (container) {
    $scope.$parent.editChecklistForDocket($scope.itemEdit.checklists, container, function (checklistsDataNew) {
      if (checklistsDataNew != null) {
        // validate checklists
        $scope.itemEdit.checklists = checklistsDataNew;
        var checklistsWithErrors = docketService.validateChecklists($scope.itemEdit);
        if ($stateParams.device == 'mobile') {
          $scope.progressiveSaveDocket($scope.itemEdit);
        }
      }
    });
  };

  /*$scope.closeWithoutSave = function(docket) {
   }*/

  /******************* OLD SEND DOCKET STUFF *****************/

  // Open send docket modal
  /*$scope.openSendDocket = function(docket) {
    $scope.docketSend = {};
    $scope.docketSend.docket = docket;
    $scope.docketSend.mode = "details";
    $("#sendDocketModal").fadeIn(100);
  }
   // Send docket to contact
  $scope.sendDocket = function(docketSend) {
    $scope.docketSend.mode = "sending";
     var url = '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docketSend.docket.id + '/generatepdf';
    $http.post(url, {emails: docketSend.contacts})
      .success(function(data, status, headers, config) {
        $scope.docketSend.mode = "sent";
      }).error(function(data, status, header, config) {
        $scope.docketSend.mode = "sendError";
      });
  }
   $scope.restartSendDocket = function() {
    $scope.docketSend.mode = "details";
  }
   // Close send docket modal
  $scope.closeSendDocket = function() {
    $scope.docketSend = {};
    $("#sendDocketModal").fadeOut(100);
  }*/

  // Add contact to docketSend contacts
  $scope.addContactToSend = function (docketSend, newContact) {
    if (docketSend.contacts == null) {
      docketSend.contacts = [];
    }

    docketSend.contacts.push(newContact);
    docketSend.newContact = "";
  };

  $scope.downloadDocket = function (docket) {
    var url = "";
    if ($scope.currentOrg != null) {
      url = "" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docket.id + '/downloadpdf';
    } else {
      url = "" + "/" + $scope.urlVersion + '/dockets/' + docket.id + '/downloadpdf';
    }
    window.open(url, "_blank");
  };

  /********************************/
  /**** OTHER UI FUNC - CHECK *****/
  /********************************/

  // Check if item editability is closed (by status)
  $scope.itemEditClosed = function (docket) {
    if (docket != null) {
      if (docket.status == 'Sent' || docket.status == 'Accepted' || docket.editing == false) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  // Validate Docket Before Submission
  $scope.validateDocket = function (docket, cb) {
    // VALIDATE CHECKLISTS
    var checklistsWithErrors = docketService.validateChecklists(docket, "beforeSubmission");

    if (checklistsWithErrors.length > 0) {
      swal({
        title: "Error!",
        text: "Some checklists that are required have not been completed fully.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      cb(false);
      return;
    }

    //TODO: VALIDATE RESOURCES

    // VALIDATE CUSTOMER
    if (docket.customer == null && docket.customerContact == null) {
      swal({
        title: "Error!",
        text: "A customer must be added before sending a docket.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      cb(false);
      return;
    }

    cb(true);
  };

  /*******************************/
  /***** Attachment Uploader *****/
  /*******************************/

  $scope.attachmentFile = {};

  $scope.uploadNewAttachment = function ($file) {
    $scope.attachmentsLoading = true;
    $scope.progressiveSaveInProcess = true;
    Upload.upload({
      method: 'PUT',
      url: "" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/dockets/" + $scope.itemEdit.id + "/attachment",
      data: { file: $file },
      withCredentials: true
    }).then(function (resp) {
      $scope.progressiveSaveInProcess = false;
      docketService.getDocket($scope.itemEdit.id, false, function (docketUpdated) {
        $scope.itemEdit.attachments = docketUpdated.attachments;
        var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
        $scope.signatureAttachments = $scope.itemEdit.attachments.reduce(function (acc, attachment) {
          if (templateStoreValues.indexOf(attachment.id) !== -1) {
            acc.push(attachment.id);
          }
          return acc;
        }, []);

        $scope.attachmentsLoading = false;
      }, function (err) {
        $scope.attachmentsLoading = false;
      });
    }, function (resp) {
      $scope.progressiveSaveInProcess = false;
      $scope.alertService.presentAutoAlert('uploadDocketAttachment', resp);
      $scope.attachmentsLoading = false;
    }, function (evt) {
      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  };

  $scope.openAttachment = function (attachment) {
    if ($scope.currentOrg != null) {
      window.open("" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + $scope.itemEdit.id + '/attachment/' + attachment.id);
    } else {
      window.open("" + '/' + $scope.urlVersion + '/dockets/' + $scope.itemEdit.id + '/attachment/' + attachment.id);
    }
  };

  $scope.openTemplateAttachment = function (attachment) {
    if ($scope.currentOrg != null) {
      window.open("" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/templates/' + $scope.itemEdit.template.id + '/attachment/' + attachment.id);
    }
  };

  $scope.deleteAttachment = function (attachment) {
    $scope.attachmentsLoading = true;
    var baseAttachment = Restangular.all('organisations').one($scope.currentOrg.id).all('groups').one($scope.currentOrgGroup.id).all('dockets').one($scope.itemEdit.id).all('attachment').one(attachment.id);
    baseAttachment.remove().then(function (success) {
      docketService.getDocket($scope.itemEdit.id, false, function (docketUpdated) {
        $scope.itemEdit.attachments = docketUpdated.attachments;
        var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
        $scope.signatureAttachments = $scope.itemEdit.attachments.reduce(function (acc, attachment) {
          if (templateStoreValues.indexOf(attachment.id) !== -1) {
            acc.push(attachment.id);
          }
          return acc;
        }, []);
        $scope.attachmentsLoading = false;
      }, function (err) {
        $scope.attachmentsLoading = false;
      });
    }, function (err) {
      swal({
        title: "Delete Failed",
        text: "An error occured while deleting your attachment. Please try again.",
        type: "error",
        confirmButtonText: "Ok."
      });
      $scope.attachmentsLoading = false;
    });
  };

  /*****************************/
  /***** File Code Methods *****/
  /*****************************/

  $scope.searchFileCodes = function (searchText) {
    return $q(function (resolve, reject) {
      var params = {};
      if (searchText != null) {
        if (searchText != "") {
          params.search = searchText;
        } else {
          resolve([]);
          return;
        }
      }
      docketService.getFileCodes(params, function (fileCodes) {
        resolve(fileCodes);
      }, function (err) {
        reject("err");
      });
    });
  };

  $scope.changeFileMethod = function (method, docketFiling) {
    if (method == 'split') {
      if (docketFiling.activityCodes == null) {
        docketFiling.activityCodes = [];
      }
      if (docketFiling.activityCodes.length == 0) {
        $scope.addSplitFileCodeDesktop();
      }
    }

    docketFiling.method = method;
  };

  $scope.addSplitFileCodeDesktop = function () {
    if ($scope.itemEdit.docketFiling.activityCodes == null) {
      $scope.itemEdit.docketFiling.activityCodes = [];
    }

    var totalPercentage = 0;
    for (var i = 0; i < $scope.itemEdit.docketFiling.activityCodes.length; i++) {
      if ($scope.itemEdit.docketFiling.activityCodes[i].splitPercentage) {
        totalPercentage += $scope.itemEdit.docketFiling.activityCodes[i].splitPercentage;
      }
    }

    var remainingPercentage = 0;
    if (totalPercentage < 100) {
      remainingPercentage = parseFloat((100 - totalPercentage).toFixed(2));
    }

    var splitQuantity = parseFloat(($scope.totalAmount * remainingPercentage / 100).toFixed(2));
    $scope.itemEdit.docketFiling.activityCodes.push({ splitPercentage: remainingPercentage, fileCode: null, splitQuantity: splitQuantity });

    $scope.generateUomQuantitiesForActivities($scope.itemEdit);
  };

  $scope.removeSplitFileCode = function (activityCode) {
    var index = $scope.itemEdit.docketFiling.activityCodes.indexOf(activityCode);
    if (index != -1) {
      $scope.itemEdit.docketFiling.activityCodes.splice(index, 1);
    }
  };

  $scope.selectActivityCodeChange = function () {
    $scope.generateUomQuantitiesForActivities($scope.itemEdit);
  };

  $scope.generateUomQuantitiesForActivities = function (docket) {
    // only generate if docket items are all of the same UOM
    var uomSummaries = {};
    for (var i = 0; i < docket.resources.length; i++) {
      if (uomSummaries[docket.resources[i].resource.uom.id] == null) {
        uomSummaries[docket.resources[i].resource.uom.id] = { sumQuantity: 0, uom: docket.resources[i].resource.uom };
      }

      // get sumQuantity for this resource
      var interactionsSumQuantity = 0;
      for (var j = 0; j < docket.resources[i].interactions.length; j++) {
        interactionsSumQuantity += docket.resources[i].interactions[j].quantity;
      }
      uomSummaries[docket.resources[i].resource.uom.id].sumQuantity += interactionsSumQuantity;
    }

    for (var i = 0; i < docket.docketFiling.activityCodes.length; i++) {
      // generate uom summary based on the splitPercentage for this activity
      var activityUomSummary = {};
      for (var uom in uomSummaries) {
        activityUomSummary[uom] = { uom: uomSummaries[uom].uom, splitQuantity: docket.docketFiling.activityCodes[i].splitPercentage / 100 * uomSummaries[uom].sumQuantity };
      }
      docket.docketFiling.activityCodes[i].uomSummaries = activityUomSummary;
    }
  };

  $scope.selectActivityForLine = function (docketFiling, line) {
    var existing = [];
    if (line.activityCode != null) {
      existing.push(line.activityCode);
    }
    $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
      if (activity != null) {
        line.activityCode = activity;
      }
    });
  };

  $scope.getLineTotalPercent = function (line) {
    return line.activityCodes.map(function (activityCode) {
      return activityCode.percentage;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  };

  $scope.splitLineFiling = function (line) {
    var remainingPercent = 100 - $scope.getLineTotalPercent(line);

    line.activityCodes.push({
      percentage: remainingPercent,
      percentage_display: parseFloat(remainingPercent.toFixed(2)),
      quantity: parseFloat((line.quantity * remainingPercent / 100).toFixed(2))
    });
  };

  $scope.removeSplitLineFiling = function (line, index) {
    line.activityCodes.splice(index, 1);
    if (line.activityCodes.length == 1) {
      line.activityCodes[0].percentage = 100;
    }
  };

  $scope.activityCodePercentageUpdated = function (line, activityCode, index) {
    activityCode.percentage = activityCode.percentage_display;
    activityCode.quantity = parseFloat((line.quantity * activityCode.percentage / 100).toFixed(2));

    if (line.activityCodes.length == 2) {
      var otherActivityCode = line.activityCodes[index == 0 ? 1 : 0];
      otherActivityCode.percentage = 100 - activityCode.percentage;
      otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2));
      otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2));
    }
  };

  $scope.activityCodeQuantityUpdated = function (line, activityCode, index) {
    activityCode.percentage = parseFloat((activityCode.quantity / line.quantity * 100).toFixed(4));
    activityCode.percentage_display = parseFloat(activityCode.percentage.toFixed(2));

    if (line.activityCodes.length == 2) {
      var otherActivityCode = line.activityCodes[index == 0 ? 1 : 0];
      otherActivityCode.percentage = 100 - activityCode.percentage;
      otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2));
      otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2));
    }
  };

  $scope.selectActivityForSplit = function (docketFiling, activityCode) {
    // get list of used file codes
    var existing = [];
    if (docketFiling.activityCodes != null) {
      for (var i = 0; i < docketFiling.activityCodes.length; i++) {
        if (docketFiling.activityCodes[i].fileCode != null) {
          existing.push(docketFiling.activityCodes[i].fileCode);
        }
      }
    }
    $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
      if (activity != null) {
        activityCode.fileCode = activity;
      }
    });
  };

  /*****************************/
  /***** Date/Time Pickers *****/
  /*****************************/

  $scope.selectDateTime = function (type, dateObject, dateField) {
    if (type == 'DateTime' || type == 'Date') {
      $mdpDatePicker(dateObject[dateField]).then(function (selectedDate) {
        dateObject[dateField] = selectedDate;
      });
    } else if (type == 'Time') {
      $mdpTimePicker(dateObject[dateField], {
        autoSwitch: true
      }).then(function (selectedTime) {
        dateObject[dateField] = selectedTime;
      });
    }
  };

  $scope.showDatePicker = function (field, ev) {
    $mdpDatePicker($scope.itemEdit[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      $scope.itemEdit[field] = selectedDate;
    });
  };

  $scope.showTimePicker = function (field, ev) {
    $mdpTimePicker($scope.itemEdit[field], {
      targetEvent: ev,
      autoSwitch: true
    }).then(function (selectedTime) {
      $scope.itemEdit[field] = selectedTime;
    });
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /***********************/
  /**** Bottom Sheet *****/
  /***********************/

  $scope.openBottomSheet = function () {
    $mdBottomSheet.show({
      templateUrl: 'views/pages/dockets/mobile/docketsBottomSheet.html',
      scope: $scope,
      preserveScope: true
    }).then(function () {});
  };

  /***********************************/
  /****** Get latest geolcation ******/
  /***********************************/

  $scope.getLatestGeolcation = function (cb) {
    var afterGeolocateCallback = cb;
    if ($scope.lastGeolocation.lat != null) {
      afterGeolocateCallback($scope.lastGeolocation);
      afterGeolocateCallback = null;
      return;
    } else {

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (data) {
          var coords = data.coords;
          var geolocation = {};
          geolocation.lat = coords.latitude;
          geolocation.long = coords.longitude;

          if (afterGeolocateCallback) {
            afterGeolocateCallback(geolocation);
            afterGeolocateCallback = null;
          }
          return;
        }, function (err) {
          if (afterGeolocateCallback) {
            afterGeolocateCallback(null);
            afterGeolocateCallback = null;
          }
          return;
        }, { enableHighAccuracy: true, timeout: 5000 });
      } else {

        if (afterGeolocateCallback) {
          afterGeolocateCallback(null);
          afterGeolocateCallback = null;
        }
        return;
      }
    }
  };

  /************************/
  /**** New Xero tools ****/
  /************************/

  $scope.xeroDisplayUnitPrices = function () {
    if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.displayUnitPrices) {
      return true;
    } else {
      return false;
    }
  };

  $scope.calculateResourceXeroTotalPrice = function (resource) {
    var unitPrice = 0;
    if (resource.xeroQuoteLineItem) {
      unitPrice = resource.xeroQuoteLineItem.unitAmount;
    } else if (resource.xeroLineItem) {
      unitPrice = resource.xeroLineItem.salesDetails.unitPrice;
    }

    var totalQuantity = $scope.getResourceTotalQty(resource);
    if (unitPrice >= 0 && totalQuantity >= 0) {
      var totalPrice = unitPrice * totalQuantity;
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;
    } else {
      return 0;
    }
  };

  /**************************************/
  /**** Receiver Docket Line Syncing ****/
  /**************************************/

  $scope.findOrderLineForItem = function (resource) {
    if ($scope.itemEdit.orderRef && $scope.itemEdit.orderRef.lineItems) {
      var orderItemFound = null;
      for (var i = 0; i < $scope.itemEdit.orderRef.lineItems.length; i++) {
        if (resource.orderItemId == $scope.itemEdit.orderRef.lineItems[i].id) {
          orderItemFound = $scope.itemEdit.orderRef.lineItems[i];
          return orderItemFound;
        }
      }
    }

    return null;
  };

  $scope.linkOrderLineForResource = function (resource) {
    $scope.orderLineSelectFromParent($scope.itemEdit.orderRef.lineItems, function (lineItemSelected) {

      if (lineItemSelected != null) {
        // patch up the line item ref on this resource
        resource.orderItemId = lineItemSelected.id;
        resource.description = lineItemSelected.itemDescription;
        // trigger save of this docket now
        if (!$scope.itemEdit.editing) {
          $scope.saveDocket($scope.itemEdit, function () {
            $scope.$parent.loadDocketFromParent($scope.itemEdit, 0, $scope.itemEdit.editing);
          });
        }
      }
    });
  };

  /***********************************/
  /***** Alert Parent Controller *****/
  /***********************************/

  $scope.$parent.detailControllerReady();
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "FfM6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "more_vert.svg";

/***/ }),

/***/ "FqnB":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/itemsTab.html';
var html = "<div my-loader text=\"Updating Items\" ng-if=\"resourcesSaveInProcess\"></div>\n<div class=\"customListRowOuter\" ng-show=\"itemEdit.editing\" ng-click=\"addResource('mobile')\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem createNew\">\n      <div class=\"dbButton lightBlue\">Add Item</div>\n    </div>\n  </div>\n</div>\n<div class=\"customListGroupOuter\" ng-repeat=\"resource in itemEdit.resources\" ng-show=\"!resource.delete\">\n  <div class=\"customListRowOuter\" id=\"listItem{{resource.id}}\">\n    <div class=\"customListRow resourceHeader\" hm-swipeLeft=\"splitListFunc.swipeListItem(resource.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(resource.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}'>\n      <div class=\"leftDetail\">\n        <div class=\"listRowItem status\"><div class=\"quantityDisplay\"></div></div>\n        <div class=\"listRowItem itemNumber\">{{resource.resource.name}}</div>\n        <div class=\"listRowItem collapsedDetail showCollapsed fluidHeight\">\n          {{resource.resource.identifier}} - {{resource.description}}\n        </div>\n      </div>\n      <div class=\"rightButton\">\n        <div class=\"dbButton round lightBlue\" ng-click=\"addInteractionToResource(resource, 'existing')\" ng-show=\"itemEdit.editing\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </div>\n      </div>\n    </div>\n    <div class=\"mobileListItemUnder\">\n      <div class=\"listItemControls\" id=\"listItemControls{{resource.id}}\">\n        <div class=\"listItemBtn deleteIcon\" ng-click=\"removeResourceFromDocket(resource, itemEdit)\" ng-show=\"itemEdit.editing\">\n          <md-icon md-svg-src=\"delete.svg\"></md-icon>\n          <div class=\"btnName\">Delete</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"customListRowOuter\" ng-repeat=\"interaction in resource.interactions\" id=\"listItem{{interaction.id}}\" ng-show=\"!interaction.delete\">\n    <div class=\"customListRow interaction\" ng-click=\"editInteraction(interaction, resource)\" hm-swipeLeft=\"splitListFunc.swipeListItem(interaction.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(interaction.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}'>\n      <div class=\"interactionRowInner\">\n        <div class=\"left\">\n          {{interaction.interactionName}}\n          <span ng-show=\"!(interaction.resource.id == resource.resource.id)\"> - {{interaction.resource.name}}</span>\n        </div>\n        <div class=\"right\">\n          <span ng-if=\"!interaction.interactionTemplate.xeroQuantity\">\n            <span ng-show=\"interaction.resource.uom.isTime\">{{formatTimeQuantity(interaction.quantity, interaction.resource.uom.abbreviation)}}</span>\n            <span ng-show=\"!interaction.resource.uom.isTime\">{{interaction.quantity}}</span>\n            <span ng-show=\"!interaction.resource.uom.isTime\"> {{interaction.resource.uom.abbreviation}}</span>\n          </span>\n          <md-icon md-svg-src=\"location.svg\" ng-show=\"interaction.lat && interaction.long\"></md-icon>\n        </div>\n      </div>\n      <div class=\"interactionRowInner customField\" ng-repeat=\"field in interaction.interactionTemplate.fields\">\n        <div class=\"left\">\n          {{field.displayName}}\n        </div>\n        <div class=\"right\">\n          <span ng-if=\"field.type == 'time'\">\n            {{moment.tz(interaction.customFields[field.id], itemEdit.timezone).format('hh:mm A')}}\n          </span>\n          <span ng-if=\"field.type != 'time'\">\n            {{interaction.customFields[field.id]}}\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"mobileListItemUnder\">\n      <div class=\"listItemControls slimline\" id=\"listItemControls{{interaction.id}}\">\n        <div class=\"listItemBtn deleteIcon\" ng-click=\"removeInteractionFromResource(interaction, resource)\" ng-show=\"itemEdit.editing\">\n          <md-icon md-svg-src=\"delete.svg\"></md-icon>\n          <div class=\"btnName\">Remove</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"clearfix\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "G1+b":
/***/ (function(module, exports) {

var path = 'views/modals/shareContactModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"shareContactModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>New Message</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeNewShareModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"editContactForm\" novalidate>\n        <div class=\"modalFormTableHeader slimline\" ng-if=\"!shareEdit.shareWith || shareEdit.recipient\">\n          <div class=\"to\">\n            <strong>To</strong>\n          </div>\n          <div class=\"email\">\n            <input type=\"text\" placeholder=\"Email or Phone Number\" ng-model=\"shareEdit.recipient\" required>\n          </div>\n        </div>\n        <div class=\"modalFormTableHeader white\" ng-if=\"shareEdit.shareWith && !shareEdit.recipient\">\n          <p class=\"margin-bottom\">Select the contact email addresses from the contact details saved for {{shareEdit.shareWith.displayName}} to send your contact details to.</p>\n          <md-input-container class=\"slimline md-block\" ng-repeat=\"email in shareEdit.shareWith.contactAddresses\">\n            <md-checkbox ng-model=\"email.selected\">{{email.emailAddress}}</md-checkbox>\n          </md-input-container>\n        </div>\n        <div class=\"modalFormTableHeader message\">\n          <div class=\"\">\n            <strong>Message</strong>\n          </div>\n          <div class=\"text\">\n            <md-input-container class=\"md-block\" aria-label=\"Comment\">\n              <textarea ng-model=\"shareEdit.comment\"></textarea>\n            </md-input-container>\n          </div>\n        </div>\n        <div class=\"modalFormTableHeader\">\n          <div class=\"left\">\n            <h2>Contact Information</h2>\n            <p class=\"subHead\">\n              Your contact details to send\n            </p>\n          </div>\n          <div class=\"right\">\n\n          </div>\n        </div>\n        <div class=\"modalFormTable padding\">\n          <md-input-container class=\"md-block\" flex-gt-sm>\n            <label>Your Display Name</label>\n            <input ng-model=\"shareEdit.displayName\" required>\n          </md-input-container>\n\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Unit Number</label>\n              <input ng-model=\"shareEdit.address.num\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Number</label>\n              <input ng-model=\"shareEdit.address.streetNum\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Name</label>\n              <input ng-model=\"shareEdit.address.streetName\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Suburb</label>\n              <input ng-model=\"shareEdit.address.suburb\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>State</label>\n              <input ng-model=\"shareEdit.address.state\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Post Code</label>\n              <input ng-model=\"shareEdit.address.postCode\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Country</label>\n              <input ng-model=\"shareEdit.address.country\">\n            </md-input-container>\n          </div>\n        </div>\n        <div class=\"modalFormTableHeader\">\n          <div class=\"left\">\n            <h2>Contact Addresses</h2>\n            <p class=\"subHead\">\n              Email addresses for this contact\n            </p>\n          </div>\n          <div class=\"right\">\n            <md-button class=\"md-icon-button\" ng-click=\"addNewShareEmail(shareEdit)\" aria-label=\"Add Contact Email To Docket\">\n              <md-icon md-svg-src=\"add.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"modalFormTable\">\n          <md-table-container>\n            <table md-table>\n              <thead md-head>\n                <tr md-row>\n                  <th md-column>Email</th>\n                  <th md-column width=\"100px\">Action</th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row ng-repeat=\"contact in shareEdit.contactAddresses\">\n                  <td md-cell>\n                    <md-input-container class=\"md-block\">\n                      <label>Email Address</label>\n                      <input type=\"text\" ng-model=\"contact.emailAddress\">\n                    </md-input-container>\n                  </td>\n                  <td md-cell>\n                    <md-button class=\"md-icon-button\" ng-click=\"removeShareEmail(contact, shareEdit)\" aria-label=\"Remove Email From Contact\">\n                      <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                    </md-button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeNewShareModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(editContactForm.$invalid || shareEdit.loading) || saveShare(shareEdit)\" ng-disabled=\"editContactForm.$invalid || shareEdit.loading\">\n            <span ng-hide=\"shareEdit.loading\">Send</span>\n            <md-progress-circular ng-show=\"shareEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "G7vu":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/generalTabPreAuth.html';
var html = "<div class=\"preAuthDocketMainSections\">\n  <!-- Start Summary Section -->\n  <div class=\"preAuthDocketSection\" style=\"border-top: 0px;padding-top: 0px;\">\n    <div class=\"ojdDesktopRow\" ng-if=\"itemEdit.supplierContact || itemEdit.customerContact\" style=\"margin-bottom:0px;margin-top: 0px;\">\n      <div class=\"ojdDesktopField\" ng-show=\"itemEdit.supplierContact\">\n        <label class=\"order\">Supplier</label>\n        <h2 ng-if=\"itemEdit.supplierContact\">{{itemEdit.supplierContact.displayName}}</h2>\n        <h3 ng-if=\"itemEdit.supplierContact.addresses\">{{stringifyAddress(itemEdit.supplierContact.addresses[0])}}</h3>\n      </div>\n      <div class=\"ojdDesktopField\" ng-click=\"!userCanDoAction('changeDocketCustomer', itemEdit) || selectCompany('customerContact')\">\n        <label class=\"order\">Customer</label>\n        <h2 ng-if=\"itemEdit.customerContact\">{{itemEdit.customerContact.displayName}}</h2>\n        <h2 ng-if=\"!itemEdit.customerContact\">Not Selected</h2>\n        <h3 ng-if=\"itemEdit.customerContact.addresses\">{{stringifyAddress(itemEdit.customerContact.addresses[0])}}</h3>\n        <h3 ng-if=\"userCanDoAction('changeDocketCustomer', itemEdit)\">Click to select customer</h3>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\" ng-if=\"itemEdit.supplierRefNo || itemEdit.customerRefNo\">\n      <div class=\"ojdDesktopField\" ng-show=\"itemEdit.supplierRefNo\">\n        <label class=\"order\">Supplier Ref No</label>\n        <h2>{{itemEdit.supplierRefNo}}</h2>\n      </div>\n      <div class=\"ojdDesktopField\" ng-show=\"itemEdit.customerRefNo\">\n        <label class=\"order\">Customer Ref No</label>\n        <h2>{{itemEdit.customerRefNo}}</h2>\n      </div>\n    </div>\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Operator</label>\n        <h2>{{itemEdit.authorName}}</h2>\n      </div>\n      <div class=\"ojdDesktopField\">\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\" ng-if=\"itemEdit.rejectionComment && itemEdit.status == 'Rejected'\">\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Rejection Comment</label>\n        <h2>{{itemEdit.rejectionComment}}</h2>\n      </div>\n    </div>\n  </div>\n  <!-- End Summary Section -->\n\n  <span class=\"repeatingOJDSection\" ng-repeat=\"block in itemEdit.template.blocks\" ng-if=\"(!itemEdit.hiddenBlockNames || itemEdit.hiddenBlockNames.indexOf(block.name)) && (block.type != 'checklists' || (block.type == 'checklists' && itemEdit.template.checklistContainers && itemEdit.template.checklistContainers.length > 0))\">\n    <!-- Time Section -->\n    <div class=\"preAuthDocketSection\" ng-if=\"block.type == 'time'\">\n      <h2 class=\"sectionHeading\">Time</h2>\n\n      <div class=\"ojdDesktopRow\">\n        <div class=\"ojdDesktopField\">\n          <label class=\"order\">Start Time</label>\n          <h2>{{moment(itemEdit.startTime).format('h:mm A')}}</h2>\n        </div>\n        <div class=\"ojdDesktopField\">\n          <label class=\"order\">End Time</label>\n          <h2>{{moment(itemEdit.endTime).format('h:mm A')}}</h2>\n        </div>\n      </div>\n      <div class=\"ojdDesktopRow\">\n        <div class=\"ojdDesktopField\" ng-click=\"itemEditClosed(itemEdit) || selectBreakTime(itemEdit, 'breakTime')\">\n          <label class=\"order\">Break Time (minutes)</label>\n          <h2>{{itemEdit.breakTime}}</h2>\n        </div>\n        <div class=\"ojdDesktopField\" ng-click=\"itemEditClosed(itemEdit) || selectBreakTime(itemEdit, 'travelTime')\">\n          <label class=\"order\">Travel Time (minutes)</label>\n          <h2>{{itemEdit.travelTime}}</h2>\n        </div>\n      </div>\n      <div class=\"ojdDesktopRow\">\n        <div class=\"ojdDesktopField\">\n          <label class=\"order\">Total Time (calculated):</label>\n          <h2>{{itemEdit.totalTime}}</h2>\n        </div>\n      </div>\n    </div>\n    <!-- End Time Section -->\n\n    <!-- Start Items Section -->\n    <div class=\"preAuthDocketSection\" ng-if=\"block.type == 'resources'\">\n      <h2 class=\"sectionHeading\">Items</h2>\n\n      <p ng-if=\"itemEdit.resources == null || itemEdit.resources.length <= 0\">\n        There are no items on this docket\n      </p>\n\n      <table class=\"preAuthDocketItemsTable\" ng-show=\"itemEdit.resources != null && itemEdit.resources.length > 0\">\n        <tr class=\"resourceOverview\" ng-repeat=\"resource in itemEdit.resources\">\n          <td>\n            {{resource.resource.name}} ({{resource.resource.identifier}})<span ng-if=\"resource.description\"> - {{resource.description}}</span>\n          </td>\n          <td class=\"quantity\">\n            <span ng-if=\"resource.resource.uom.isTime\">\n              {{formatTimeQuantity(getResourceQtySummary(resource), resource.resource.uom.abbreviation)}}\n            </span>\n            <span ng-if=\"!resource.resource.uom.isTime\">\n              {{getResourceQtySummary(resource)}}\n            </span>\n          </td>\n        </tr>\n      </table>\n    </div>\n    <!-- End Items Section -->\n\n    <!-- Start Signatures Section -->\n    <div class=\"preAuthDocketSection noPadding\" ng-if=\"block.type == 'signatures'\">\n      <h2 class=\"sectionHeading\">Signatures</h2>\n\n      <div class=\"ojdDesktopRow\">\n        <div class=\"ojdDesktopField\" ng-click=\"!userCanDoAction('captureSupplierSignature', itemEdit) || captureSignature('supplierSignature')\">\n          <div><label class=\"order\">Operator</label></div>\n          <span ng-if=\"itemEdit.supplierSignatureAttachment && itemEdit.supplierSignatureAttachment != '' && (currentOrg === null || currentOrg === undefined)\">\n            <div class=\"preAuthSignatureView\" style=\"background-image:url('{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.supplierSignatureAttachment}}')\"></div>\n          </span>\n          <h2 ng-if=\"!itemEdit.supplierSignatureAttachment && !itemEdit.supplierSignatureImage\">\n            Not Captured\n          </h2>\n          <h3 ng-if=\"userCanDoAction('captureSupplierSignature', itemEdit)\">\n            <span ng-show=\"itemEdit.editing\">Click to capture signature</span>\n          </h3>\n        </div>\n\n        <div class=\"ojdDesktopField\" style=\"padding-left:20px;\" ng-click=\"!userCanDoAction('captureCustomerSignature', itemEdit) || captureSignature('customerSignature')\">\n          <div><label class=\"order\">Customer<span ng-if=\"itemEdit.customerSignatureName\"> ({{itemEdit.customerSignatureName}})</span></label></div>\n          <span ng-if=\"!itemEdit.customerSignatureImage && itemEdit.customerSignatureAttachment && itemEdit.customerSignatureAttachment != '' && currentOrg == null\">\n            <div class=\"preAuthSignatureView\" style=\"background-image:url('{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.customerSignatureAttachment}}')\"></div>\n          </span>\n          <span ng-if=\"itemEdit.customerSignatureImage\">\n            <div class=\"preAuthSignatureView\" style=\"background-image:url('{{itemEdit.customerSignatureImage}}')\"></div>\n          </span>\n          <h2 ng-if=\"!itemEdit.customerSignatureAttachment && !itemEdit.customerSignatureImage\">\n            Not Captured\n          </h2>\n          <h3 ng-if=\"userCanDoAction('captureCustomerSignature', itemEdit)\">\n            <span ng-show=\"itemEdit.editing\">Click to capture signature</span>\n          </h3>\n        </div>\n      </div>\n    </div>\n    <!-- End Signatures Section -->\n\n    <!-- Start Custom Section -->\n    <div class=\"preAuthDocketSection\" ng-if=\"block.type == 'custom'\">\n      <h2 class=\"sectionHeading\" style=\"margin-bottom: 0px;\">{{block.name}}</h2>\n\n      <div class=\"ojdDesktopRow\" style=\"margin-top: 0px;\">\n        <div class=\"autoRepeatingFieldOuter\" ng-repeat=\"field in block.fields\">\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'datetime' || field.type == 'date'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{moment(itemEdit.templateValueStore[block.id + '-' + field.id]).format('DD/MM/YYYY')}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'time'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{moment(itemEdit.templateValueStore[block.id + '-' + field.id]).format('h:mm A')}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'text'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'boolean'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'number'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'select'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'multiline'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'label'\">\n            <label class=\"order\">{{field.displayName}}</label>\n            <p class=\"labelFieldText\">{{field.text}}</p>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'address'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h2>{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h2>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'location'\">\n            <label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label>\n            <h3>Coming Soon</h3>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"field.type == 'signature'\" ng-click=\"!(itemEdit.editing && !itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]) || captureFieldSignature(block, field)\">\n            <div><label class=\"order\">{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></label></div>\n            <h2 ng-if=\"!itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]\">\n              Not Captured\n            </h2>\n            <span ng-if=\"itemEdit.signatureFields[block.id + '-' + field.id].signatureImage != null\">\n              <img ng-src=\"{{itemEdit.signatureFields[block.id + '-' + field.id].signatureImageFull}}\">\n            </span>\n            <span ng-if=\"itemEdit.templateValueStore[block.id + '-' + field.id] && currentOrg != null\">\n              <img ng-src=\"{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.templateValueStore[block.id + '-' + field.id]}}\" height=\"90px\">\n            </span>\n            <span ng-if=\"itemEdit.templateValueStore[block.id + '-' + field.id] && currentOrg == null\">\n              <img ng-src=\"{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.templateValueStore[block.id + '-' + field.id]}}\" height=\"90px\">\n            </span>\n            <h3 ng-if=\"itemEdit.editing && !itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]\">\n              <span>Click to capture signature</span>\n            </h3>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- End Custom Section -->\n\n    <!-- Start Checklists Section -->\n    <div class=\"preAuthDocketSection noPadding\" ng-if=\"block.type == 'checklists' && itemEdit.template && itemEdit.template.checklistContainers && itemEdit.template.checklistContainers.length > 0\">\n      <h2 class=\"sectionHeading\">Checklists</h2>\n\n      <p ng-if=\"itemEdit.template.checklistContainers == null || itemEdit.template.checklistContainers.length <= 0\">\n        There are no checklists on this docket\n      </p>\n\n      <table class=\"preAuthDocketItemsTable\" ng-show=\"itemEdit.template.checklistContainers != null && itemEdit.template.checklistContainers.length > 0\">\n        <tr class=\"resourceOverview\" ng-repeat=\"container in itemEdit.template.checklistContainers\">\n          <td>\n            {{container.checklistTemplate.name}}\n          </td>\n          <td class=\"quantity\">\n            <span ng-show=\"!itemEdit.checklists[container.checklistTemplate.id].complete\"><div class=\"statusDisplay Declined\">Incomplete</div></span>\n            <span ng-show=\"itemEdit.checklists[container.checklistTemplate.id].complete\"><div class=\"statusDisplay Completed\">Complete</div></span>\n          </td>\n        </tr>\n      </table>\n    </div>\n    <!-- End Checklists Section -->\n  </span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "G7y8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var clearSvg = __webpack_require__("8Pnt");

angular.module('docketbook').controller('checklistModalController', ['$rootScope', '$scope', '$state', '$stateParams', 'accessControl', '$timeout', 'geolocation', function ($rootScope, $scope, $state, $stateParams, accessControl, $timeout, geolocation) {
  $scope.clearSvgImagePath = clearSvg;
  $scope.checklistDetail = {};

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.openChecklistFromParent = function (checklistsData, checklist, cb) {
    $("#checklistDetailModal").fadeIn(100);
    $scope.checklistCallback = cb;
    $scope.checklistDetail = checklist;
    $scope.checklistsData = angular.copy(checklistsData);
  };

  /*******************************/
  /***** Checklist Functions *****/
  /*******************************/

  $scope.saveChecklistDetail = function () {
    $scope.checklistCallback($scope.checklistsData);
    $("#checklistDetailModal").fadeOut(100);
  };

  $scope.closeChecklistDetailModal = function () {
    $("#checklistDetailModal").fadeOut(100);
    $scope.checklistCallback(null);
  };

  $scope.setChecklistItem = function (itemField, itemKey, newValue) {
    itemField[itemKey] = newValue;
  };

  $scope.resetChecklist = function (checklistDetail) {
    for (var i = 0; i < checklistDetail.checklistTemplate.fields.length; i++) {
      var field = checklistDetail.checklistTemplate.fields[i];
      $scope.checklistsData[checklistDetail.checklistTemplate.id].answers[field.id] = "";
    }
    $scope.$parent.showToast('Checklist Reset');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "GCPq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "allocate.svg";

/***/ }),

/***/ "GFrL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GYqn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "domain.svg";

/***/ }),

/***/ "HE5Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "text-field.svg";

/***/ }),

/***/ "HJwN":
/***/ (function(module, exports) {

var path = 'views/modals/assignDocketModal.html';
var html = "\n<div class=\"niceModal desktopSelector\" id=\"assignDocketModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Assign Docket {{assignDocket.docketNumber}}</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeAssignDocketModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeAssignDocketModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Assign Docket {{assignDocket.docketNumber}}\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"assignDocketSave(assignDocket)\" ng-show=\"assignDocket.selected.length > 0\">Done</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"\" novalidate>\n        <div class=\"modalFormMobileHeader\">\n          Select the organisation/group to add this docket to\n        </div>\n        <div class=\"modalFormTableHeader\">\n          Select the organisation/group to add this docket to\n        </div>\n\n        <div class=\"modalFormTable\">\n          <md-table-container>\n            <table md-table md-row-select ng-show=\"assignDocket.organisations && assignDocket.organisations.length > 0\" ng-model=\"assignDocket.selected\">\n              <tbody md-body ng-repeat=\"organisation in assignDocket.organisations\">\n                <form name=\"innerForm\">\n                  <tr md-row ng-repeat=\"group in organisation.groups\" md-select=\"group\" md-auto-select md-select-id=\"id\">\n                    <td md-cell>\n                      {{organisation.name}}\n                      <span ng-if=\"group.parent != null\">\n                        - {{group.publicName}}\n                      </span>\n                    </td>\n                  </tr>\n                </form>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeAssignDocketModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"assignDocket.selected.length <= 0 || assignDocketContinue()\" ng-disabled=\"assignDocket.selected.length <= 0\">\n            Save\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "HWVN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

angular.module('docketbook').controller('trialBannerController', ['addressBookService', 'userService', 'uuid', '$scope', '$state', '$window', '$location', '$stateParams', 'accessControl', '$rootScope', function (addressBookService, userService, uuid, $scope, $state, $window, $location, $stateParams, accessControl, $rootScope) {
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentUser = accessControl.currentUser();
    $scope.organisations = accessControl.allowedOrganisations();

    if ($scope.currentOrg && $scope.currentOrg.trial_end) {
        $scope.expiryDays = moment(new Date($scope.currentOrg.trial_end * 1000)).diff(new Date(), "days") + 1;
        $scope.trialFinishedWithin1Week = $scope.expiryDays <= 0 && moment(new Date()).diff(new Date($scope.currentOrg.trial_end * 1000), "days") <= 7;
    }
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("PJh5")))

/***/ }),

/***/ "HqXb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('jobsDesktopController', ['jobService', 'orderService', 'userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$q', function (jobService, orderService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
  mixpanel.track("Opened Jobs Desktop");

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.itemEdit = null;
  $scope.showFilters = false;
  $scope.preventReloadWithFilters = true;
  $scope.selected = [];
  $scope.jobsSearch = "";
  $scope.allUsers = [];
  $scope.allocationUsers = [];
  $scope.jobAllocationsByUser = {};
  $scope.hasJobs = true;
  $scope.myDocketbook = $state.params.myDocketbook;
  $scope.customTemplate = [{
    name: 'Last 12 Months',
    dateStart: (0, _momentTimezone2.default)().subtract(12, 'months').toDate(),
    dateEnd: (0, _momentTimezone2.default)().toDate()
  }];

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  var statusFilterOptions = ['draft', 'sent', 'closed'];
  var assigneeStatusFilterOptions = ['assigned', 'accepted', 'rejected'];

  jobService.getJobs({ limit: 1, offset: 0 }, function (returnData) {
    $scope.hasJobs = returnData.length > 0;
  });

  $scope.getStatus = function (item) {
    if (item == null) {
      return "";
    }

    /*if ( userService.userCanDoAction('assignUserToJob', item) && item && item.assignees && item.assignees.map(a => a.status.toLowerCase() != 'rejected').length == 0 ) {
      return "Unassigned"
    } else {*/
    return item.status;
    //}
  };

  // Filters initial
  $scope.filters = {};
  $scope.filters.status = 'All';
  $scope.filters.startDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate(); //startToDate
  $scope.filters.endDate = (0, _momentTimezone2.default)().toDate(); //endFromDate
  $scope.startWeek = (0, _momentTimezone2.default)($scope.filters.startDate);
  $scope.filters.customer = 'All';
  $scope.filters.assignee = 'All';
  $scope.filters.assigneeList = [];
  $scope.filters.forwarder = null;
  $scope.filters.hasRejections = false;
  $scope.filters.viewType = 'list';
  $scope.filters.statusOptions = { allView: true, all: true, draft: true, sent: true, closed: true };
  $scope.filters.assigneeStatusOptions = { allView: true, all: true, assigned: true, accepted: true, rejected: true };
  $scope.filterHeading = "";
  $scope.activeFilters = 0;
  $scope.dateFilterModel = { dateStart: $scope.filters.startDate, dateEnd: $scope.filters.endDate, showTemplate: true };
  if ($scope.currentOrg && $scope.currentOrgGroup) {
    $scope.filters.organisationId = $scope.currentOrg.id;
    $scope.filters.groupId = $scope.currentOrgGroup.id;
  }

  // Default query pagination
  $scope.query = {
    limit: 30,
    page: 1,
    order: 'jobNumber'
  };
  $scope.promise = null;

  $scope.$watch('filters.startDate', function (before, after) {
    $scope.startWeek = (0, _momentTimezone2.default)($scope.filters.startDate);
  }, true);

  $scope.$watch('dateFilterModel.dateStart', function (before, after) {
    if ($scope.dateFilterModel.dateStart) {
      $scope.filters.startDate = $scope.dateFilterModel.dateStart;
    }
    if (!$scope.preventReloadWithFilters) {
      if ((0, _momentTimezone2.default)(after).diff((0, _momentTimezone2.default)(before), 'days') != 0) {
        $scope.filtersChanged('date selector');
      }
    }
  }, true);

  $scope.$watch('dateFilterModel.dateEnd', function (before, after) {
    if ($scope.dateFilterModel.dateEnd) {
      $scope.filters.endDate = $scope.dateFilterModel.dateEnd;
    }
    if (!$scope.preventReloadWithFilters) {
      if ((0, _momentTimezone2.default)(after).diff((0, _momentTimezone2.default)(before), 'days') != 0) {
        $scope.filtersChanged('date selector');
      }
    }
  }, true);

  //var today = moment();
  //var startWeek = moment().startOf('week').add('days',1);
  //$scope.startWeek = startWeek;

  var loadSavedFilters = function loadSavedFilters() {
    var storedFilters = {};
    var lastJobsFilters = {};
    if (sessionStorage.getItem('jobsLastFilters')) {
      lastJobsFilters = JSON.parse(sessionStorage.getItem('jobsLastFilters'));
    }
    if (sessionStorage.getItem('filters')) {
      storedFilters = JSON.parse(sessionStorage.getItem('filters'));

      if (storedFilters.order && storedFilters.order.id) {
        $scope.filters.order = storedFilters.order;
      }
      // if url param has order - override stored filter order
      if ($stateParams.orderId != null) {
        $scope.filters.order = { id: $stateParams.orderId };
        if ($stateParams.orderNumber != null) {
          $scope.filters.order.orderNumber = $stateParams.orderNumber;
        }
      }
      if (storedFilters.startDate != null) {
        $scope.filters.startDate = (0, _momentTimezone2.default)(storedFilters.startDate).toDate();
        $scope.dateFilterModel.dateStart = $scope.filters.startDate;
      }
      if (storedFilters.endDate != null) {
        $scope.filters.endDate = (0, _momentTimezone2.default)(storedFilters.endDate).toDate();
        $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
      }
      if (storedFilters.customerContact != null) {
        $scope.filters.customerContact = storedFilters.customerContact;
      }
      if (storedFilters.supplierContact != null) {
        $scope.filters.supplierContact = storedFilters.supplierContact;
      }
      if (storedFilters.forwarderContact != null) {
        $scope.filters.forwarderContact = storedFilters.forwarderContact;
      } else if (lastJobsFilters && lastJobsFilters.forwarderContact) {
        $scope.filters.forwarderContact = lastJobsFilters.forwarderContact;
      }
      if (storedFilters.jobNumber != null) {
        $scope.filters.jobNumber = storedFilters.jobNumber;
      } else if (lastJobsFilters && lastJobsFilters.jobNumber) {
        $scope.filters.jobNumber = lastJobsFilters.jobNumber;
      }
      if (storedFilters.reloadRequired) {
        $scope.filters.reloadRequired = storedFilters.reloadRequired;
      }
      // status filters
      if (storedFilters.statusOptions) {
        for (var i = 0; i < statusFilterOptions.length; i++) {
          if (storedFilters.statusOptions[statusFilterOptions[i]] == true) {
            $scope.filters.statusOptions[statusFilterOptions[i]] = true;
          } else {
            $scope.filters.statusOptions[statusFilterOptions[i]] = false;
          }
        }
        if (storedFilters.statusOptions.all == true) {
          $scope.filters.statusOptions.all = true;
          for (var i = 0; i < statusFilterOptions.length; i++) {
            $scope.filters.statusOptions[statusFilterOptions[i]] = true;
          }
        } else {
          $scope.filters.statusOptions.all = false;
        }
      }
      // if state params status is set - uisref status has been used and overrite status statusOptions
      if ($stateParams.status != undefined) {
        $scope.filters.statusOptions.all = false;
        for (var i = 0; i < statusFilterOptions.length; i++) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        }
        $scope.filters.statusOptions[$stateParams.status] = true;
      }
      // assignee status filters
      if (lastJobsFilters.assigneeStatusOptions) {
        for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
          if (lastJobsFilters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] == true) {
            $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
          } else {
            $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
          }
        }
        if (lastJobsFilters.assigneeStatusOptions.all == true) {
          $scope.filters.assigneeStatusOptions.all = true;
          for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
            $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
          }
        } else {
          $scope.filters.assigneeStatusOptions.all = false;
        }
      }
      // if state params assigneeStatus is set - uisref status has been used and overrite status statusOptions
      if ($stateParams.assigneeStatus != undefined) {
        $scope.filters.assigneeStatusOptions.all = false;
        for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
          $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
        }
        $scope.filters.assigneeStatusOptions[$stateParams.assigneeStatus] = true;
      }
      // to hook up properly - allocate view type filters
      if (storedFilters.viewType != null && storedFilters.jobId == null) {
        $scope.filters.viewType = storedFilters.viewType;
      }
      if ($scope.filters.viewType == 'allocate') {
        if (storedFilters.startDate && storedFilters.endDate) {
          $scope.filters.startDate = (0, _momentTimezone2.default)($scope.filters.startDate).startOf('week').add('days', 1).toDate();
          $scope.dateFilterModel.dateStart = $scope.filters.startDate;
          $scope.filters.endDate = (0, _momentTimezone2.default)($scope.filters.startDate).add('days', 6).toDate();
        }
        if ($scope.filters.endDate == null) {
          $scope.filters.endDate = (0, _momentTimezone2.default)().add('days', 6).toDate();
          $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
        }
        if ($scope.filters.startDate == null) {
          $scope.filters.startDate = (0, _momentTimezone2.default)().startOf('week').add('days', 1).toDate();
          $scope.dateFilterModel.dateStart = $scope.filters.startDate;
        }
      }
      // load in most recent query params
      if (sessionStorage.getItem('jobsQuery') != null && sessionStorage.getItem('jobsQuery') != "undefined") {
        var queryStored = JSON.parse(sessionStorage.getItem('jobsQuery'));
        if (queryStored != null) {
          if (queryStored.limit) {
            $scope.query.limit = queryStored.limit;
          }
          if (queryStored.page) {
            $scope.query.page = queryStored.page;
          }
          if (queryStored.order) {
            $scope.query.order = queryStored.order;
          }
        }
      }
    }
    sessionStorage.setItem('filters', JSON.stringify($scope.filters));
  };

  loadSavedFilters();

  /**** Job Allocations Specific Handlers *****/

  $scope.loadUsers = function (cb) {
    userService.getMembers(null, function (users) {
      $scope.allUsers = users;
      $scope.allocationUsers = users;
      cb();
    }, function (err) {
      $scope.allUsers = [];
      $scope.allocationUsers = [];
      cb();
    });
  };

  /*** New Status Filters Helpers ***/

  $scope.prettifyFilterStatusPreview = function () {
    var output = "";

    if ($scope.filters.statusOptions.all) {
      return "All";
    }

    var soFar = 0;
    if ($scope.filters.statusOptions.draft) {
      soFar += 1;
      output += "Draft";
    }
    if ($scope.filters.statusOptions.sent) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Sent";
    }
    if ($scope.filters.statusOptions.closed) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Closed";
    }
    if (soFar == 0) {
      output += "None selected";
    }
    return output;
  };

  $scope.prettifyAssigneeFilterStatusPreview = function () {
    var output = "";

    if ($scope.filters.assigneeStatusOptions.all) {
      return "All";
    }

    var soFar = 0;
    if ($scope.filters.assigneeStatusOptions.assigned) {
      soFar += 1;
      output += "Assigned";
    }
    if ($scope.filters.assigneeStatusOptions.accepted) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Accepted";
    }
    if ($scope.filters.assigneeStatusOptions.rejected) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Rejected";
    }
    if (soFar == 0) {
      output += "None selected";
    }
    return output;
  };

  $scope.statusFiltersChanged = function () {
    var selectedCount = 0;
    for (var option in statusFilterOptions) {
      if ($scope.filters.statusOptions[statusFilterOptions[option]]) {
        selectedCount += 1;
      }
    }
    if (selectedCount == statusFilterOptions.length) {
      $scope.filters.statusOptions.all = true;
    } else {
      $scope.filters.statusOptions.all = false;
    }
    if (!$scope.preventReloadWithFilters) {
      $scope.filtersChanged('status options');
    }
  };

  $scope.assigneeStatusFiltersChanged = function () {
    var selectedCount = 0;
    for (var option in assigneeStatusFilterOptions) {
      if ($scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[option]]) {
        selectedCount += 1;
      }
    }
    if (selectedCount == assigneeStatusFilterOptions.length) {
      $scope.filters.assigneeStatusOptions.all = true;
    } else {
      $scope.filters.assigneeStatusOptions.all = false;
    }
    if (!$scope.preventReloadWithFilters) {
      $scope.filtersChanged('assignee status options');
    }
  };

  $scope.swapStatusFilter = function (option) {
    if (option == 'all' && $scope.filters.statusOptions.all == false) {
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
      $scope.filters.statusOptions.allView = true;
      $scope.filters.statusOptions.all = true;
    } else if (option == 'all' && $scope.filters.statusOptions.all == true) {
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = false;
      }
      $scope.filters.statusOptions.allView = false;
      $scope.filters.statusOptions.all = false;
    }
    $scope.statusFiltersChanged();
  };

  $scope.swapAssigneeStatusFilter = function (option) {
    if (option == 'all' && $scope.filters.assigneeStatusOptions.all == false) {
      for (var i in assigneeStatusFilterOptions) {
        $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
      }
      $scope.filters.assigneeStatusOptions.allView = true;
      $scope.filters.assigneeStatusOptions.all = true;
    } else if (option == 'all' && $scope.filters.assigneeStatusOptions.all == true) {
      for (var i in assigneeStatusFilterOptions) {
        $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
      }
      $scope.filters.assigneeStatusOptions.allView = false;
      $scope.filters.assigneeStatusOptions.all = false;
    }
    $scope.assigneeStatusFiltersChanged();
  };

  $scope.setOnlyFilter = function (option) {
    $scope.filters.statusOptions.all = false;
    for (var i in statusFilterOptions) {
      if (statusFilterOptions[i] != option) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = false;
      } else {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
    }
    $scope.statusFiltersChanged();
  };

  $scope.setAssigneeOnlyFilter = function (option) {
    $scope.filters.assigneeStatusOptions.all = false;
    for (var i in assigneeStatusFilterOptions) {
      if (assigneeStatusFilterOptions[i] != option) {
        $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = false;
      } else {
        $scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] = true;
      }
    }
    $scope.assigneeStatusFiltersChanged();
  };

  /**** New Filters for Job Allocations View ****/

  $scope.swapViewType = function () {
    if ($scope.filters.viewType == 'allocate') {
      $scope.filters.viewType = 'list';
      // set filters to show this current week from the allocate view
      //$scope.filters.startDate = moment($scope.filters.startDate).startOf('week').add('days',1).toDate();
      //$scope.filters.endDate = moment($scope.filters.startDate).add('days', 6).toDate();
      $scope.dateFilterModel.dateStart = $scope.filters.startDate;
      $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
      $scope.filtersChanged('viewswap');
    } else {
      $scope.filters.viewType = 'allocate';
      var startWeek = (0, _momentTimezone2.default)($scope.filters.startDate).startOf('week').add('days', 1);
      $scope.filters.startDate = startWeek.toDate();
      $scope.filters.endDate = startWeek.add('days', 6).toDate();
      $scope.filtersChanged('viewswap');
    }
  };

  // Allocations filter go back a week
  $scope.jobAllocationsFiltersBackWeek = function () {
    $scope.filters.startDate = (0, _momentTimezone2.default)($scope.filters.startDate).subtract('week', 1).toDate();
    $scope.filters.endDate = (0, _momentTimezone2.default)($scope.filters.endDate).subtract('week', 1).toDate();
    $scope.filtersChanged('backweek');
  };

  // Allocations filter go forward a week
  $scope.jobAllocationsFiltersNextWeek = function () {
    $scope.filters.startDate = (0, _momentTimezone2.default)($scope.filters.startDate).add('week', 1).toDate();
    $scope.filters.endDate = (0, _momentTimezone2.default)($scope.filters.endDate).add('week', 1).toDate();
    $scope.filtersChanged('nextweek');
  };

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************************/
  /***** Job Detail View Controls *****/
  /************************************/

  var openJob = function openJob(job) {
    $scope.currentJob = job;
    $scope.jobLoadingError = null;
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.minimiseList();
    $scope.prepareForJobFromParent(null, job.jobNumber);
    jobService.getJob(job, function (jobFull) {
      // setup line item quantities
      for (var i = 0; i < jobFull.lineItems.length; i++) {
        if (jobFull.lineItems[i].resource.uom.isTime) {
          var quantity = jobFull.lineItems[i].quantity;
          var hours = Math.floor(quantity / 60);
          var minutes = quantity % 60;
          jobFull.lineItems[i].quantityHoursEdit = hours;
          jobFull.lineItems[i].quantityMinutesEdit = minutes;
        } else {
          jobFull.lineItems[i].quantityEdit = jobFull.lineItems[i].quantity;
        }
      }

      if (accessControl.userHasPermission('io.docketbook.ojdapi.getOrder') && jobFull.orderRef != null) {
        orderService.getOrder(jobFull.orderRef, function (orderFull) {
          jobFull.orderRef = orderFull;
          $scope.lastCleanJob = angular.copy(jobFull);
          $scope.loadJobFromParent(jobFull);
          return;
        }, function (err) {
          if (jobFull.order != null) {
            var newOrderRef = {};
            newOrderRef.id = jobFull.order.orderId;
            newOrderRef.orderNumber = jobFull.order.orderNumber;
            jobFull.orderRef = newOrderRef;
          }
          $scope.lastCleanJob = angular.copy(jobFull);
          $scope.loadJobFromParent(jobFull);
          return;
        });
      } else {
        if (jobFull.order != null) {
          var newOrderRef = {};
          newOrderRef.id = jobFull.order.orderId;
          newOrderRef.orderNumber = jobFull.order.orderNumber;
          jobFull.orderRef = newOrderRef;
        }
      }

      $scope.lastCleanJob = angular.copy(jobFull);
      $scope.loadJobFromParent(jobFull);
    }, function (err) {
      $scope.jobLoadingErrorFull = err;
      $scope.jobLoadingError = "Error Getting Job";
    });
  };

  $scope.openJobAllocation = function (job) {
    if ($scope.filters.viewType == 'allocate') {
      $scope.swapViewType();
    }
    $scope.openJobDesktop(job, false);
  };

  $scope.openJobDesktop = function (job, skipDiffCheck) {
    var currentJob = $scope.getJobFromParent();
    var jobId = job;
    if (jobId.id != null) {
      jobId = jobId.id;
    }
    if (currentJob && currentJob.id == jobId) {
      return;
    }
    if (currentJob != null && currentJob.editing && !skipDiffCheck) {
      jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveJob(currentJob, function () {
                if ($scope.currentOrg) {
                  $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
                } else {
                  $state.go('main.jobDetail', { jobId: jobId });
                }
              });
            } else if (actionSelected == 'dontSave') {
              if ($scope.currentOrg) {
                $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
              } else {
                $state.go('main.jobDetail', { jobId: jobId });
              }
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          if ($scope.currentOrg) {
            $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
          } else {
            $state.go('main.jobDetail', { jobId: jobId });
          }
        }
      });
    } else {
      if ($scope.currentOrg) {
        $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: jobId });
      } else {
        $state.go('main.jobDetail', { jobId: jobId });
      }
    }
  };

  var closeJob = function closeJob() {
    $scope.splitListFunc.slideTableListDetailClosed();
    $scope.maximiseList();
    $scope.clearJobFromParent();
  };

  $scope.closeJobDesktop = function (skipDiff) {
    if (skipDiff && skipDiff == true) {
      if ($scope.currentOrg) {
        $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else {
        $state.go('main.jobs');
      }
      return;
    }
    // get diff and check if any changes first
    var currentJob = $scope.getJobFromParent();
    jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
      if (diffCount > 0) {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            $scope.saveJob(currentJob, function () {
              if ($scope.currentOrg) {
                $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                $state.go('main.jobs');
              }
            });
          } else if (actionSelected == 'dontSave') {
            if ($scope.currentOrg) {
              $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              $state.go('main.jobs');
            }
          } else {
            // do nothing - stay where we are
          }
        });
        return;
      } else {
        if ($scope.currentOrg) {
          $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else {
          $state.go('main.jobs');
        }
      }
    });
  };

  $scope.assigneeChangeStatus = function (job, statusTo) {
    if (statusTo.toLowerCase() == 'rejected') {
      // check if assignee has any dockets created for this job
      var authoredDocketsCount = 0;
      for (var i = 0; i < job.dockets.length; i++) {
        if (job.dockets[i].author == $scope.currentUser.id) {
          authoredDocketsCount += 1;
        }
      }
      if (authoredDocketsCount > 0) {
        $scope.alertService.presentAutoAlert('rejectJobWithDockets', { status: 400 });
        return;
      }
      swal({
        title: "Reject Job " + job.jobNumber,
        text: "Please provide a reason for rejecting this job.",
        type: "input",
        showCancelButton: true,
        closeOnConfirm: true,
        inputPlaceholder: "Reason"
      }, function (inputValue) {
        if (inputValue === false) {
          return;
        }
        jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, inputValue, function (success) {
          // status change successful - reload jobs list
          $scope.showToast('Job Status Updated');
          openJob(job);
        }, function (err) {
          $scope.alertService.presentAutoAlert('jobStatusChange', err);
        });
      });
    } else {
      jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, null, function (success) {
        // status change successful - reload jobs list
        $scope.showToast("Job Status Updated");
        openJob(job);
      }, function (err) {
        $scope.alertService.presentAutoAlert('jobStatusChange', err);
      });
    }
  };

  var newJob = function newJob(fromOrder) {
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.minimiseList();
    $scope.lastCleanJob = {};
    $scope.newJobFromParent(fromOrder);
  };

  $scope.newJob = function (fromOrder) {
    if ($scope.filters.viewType == 'allocate') {
      $scope.swapViewType();
    }
    var currentJob = $scope.getJobFromParent();
    if (currentJob != null && currentJob.editing) {
      jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveJob(currentJob, function () {
                $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
              });
            } else if (actionSelected == 'dontSave') {
              $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
            } else {
              // do nothing - stay where we are
            }
          });
          return;
        } else {
          $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
        }
      });
    } else {
      $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: 'new', fromOrder: fromOrder });
    }
  };

  var newJobFromDuplicate = function newJobFromDuplicate(jobFrame) {
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.minimiseList();
    $scope.lastCleanJob = {};
    $scope.loadJobFromParent(jobFrame, true);
  };

  $scope.newJobFromDuplicate = function (jobFrame) {
    var currentJob = $scope.getJobFromParent();
    if (currentJob != null && currentJob.editing) {
      jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveJob(currentJob, function () {
                newJobFromDuplicate(jobFrame);
              });
            } else if (actionSelected == 'dontSave') {
              newJobFromDuplicate(jobFrame);
            } else {
              // do nothing - stay where we are
            }
          });
          return;
        } else {
          newJobFromDuplicate(jobFrame);
        }
      });
    } else {
      newJobFromDuplicate(jobFrame);
    }
  };

  $scope.saveJob = function (job, cb) {
    var newJob = false;
    if (job.id == null) {
      newJob = true;
    }

    job.loading = true;
    job.loadingType = "saving";
    jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
      if (diffCount > 0 || newJob == true) {
        jobService.saveJob(diff, function (jobUpdated) {
          if (!cb) {
            openJob(jobUpdated, true);
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          } else {
            cb();
          }
        }, function (err) {
          job.loading = false;
          $scope.alertService.presentAutoAlert('saveJob', err);
        });
      } else {
        if (newJob) {
          $scope.showToast('New Job Saved');
        } else {
          $scope.showToast('Job Changes Saved');
        }
        if (!cb) {
          openJob(job, true);
          if ($scope.filters.viewType == 'allocate') {
            $scope.loadJobAllocationsList();
          } else {
            $scope.loadJobsList();
          }
        } else {
          cb();
        }
      }
    });
  };

  $scope.removeJobFromCachedList = function (job) {
    var jobsListParsed = JSON.parse(sessionStorage.getItem('jobsList'));
    if (jobsListParsed) {
      var newList = [];
      for (var i = 0; i < jobsListParsed.length; i++) {
        if (jobsListParsed[i].id != job.id) {
          newList.push(jobsListParsed[i]);
        }
      }
      sessionStorage.setItem('jobsList', JSON.stringify(newList));
    }
  };

  $scope.deleteJob = function (job) {
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete this job?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        $scope.removeJobFromCachedList(job);
        jobService.deleteJob(job, function () {
          if ($scope.currentOrg) {
            $state.go('main.groupJobs', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          } else {
            $state.go('main.jobs');
          }
        }, function (err) {
          $scope.alertService.presentAutoAlert('deleteJob', err);
        });
      }
    });
  };

  $scope.editJob = function (job) {
    job.editing = true;
  };

  $scope.cancelEditJob = function (job) {
    if (job.status == "New") {
      $scope.closeJobDesktop(job);
    } else {
      openJob(job);
    }
  };

  $scope.sendJob = function (job) {
    // Check if job is valid before attempting to do send
    jobService.validateSendJob(job, function () {
      jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
        if (diffCount > 0) {
          diff.status = 'sent';
          jobService.saveJob(diff, function (jobUpdated) {
            openJob(jobUpdated, true);
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          }, function (err) {
            job.loading = false;
            $scope.alertService.presentAutoAlert('sendJob', err);
          });
        } else {
          jobService.sendJob(job, function () {
            openJob(job, true);
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          }, function (err) {
            job.loading = false;
            $scope.alertService.presentAutoAlert('sendJob', err);
          });
        }
      });
    }, function (exceptions) {
      job.loading = false;
      $scope.alertService.presentAutoValidationAlert('sendJob', exceptions);
    });
  };

  $scope.closeJob = function (job) {
    jobService.closeJob(job, function () {
      openJob(job, true);
      if ($scope.filters.viewType == 'allocate') {
        $scope.loadJobAllocationsList();
      } else {
        $scope.loadJobsList();
      }
    }, function (err) {
      job.loading = false;
      $scope.alertService.presentAutoAlert('closeJob', err);
    });
  };

  $scope.duplicateJob = function (job) {
    var jobCopy = angular.copy(job);

    var newJobFrame = {};
    newJobFrame.status = "New";
    newJobFrame.statusDisplay = "New";
    newJobFrame.jobNumber = "New Job";
    newJobFrame.orderRef = jobCopy.orderRef;
    newJobFrame.order = jobCopy.orderRef;
    newJobFrame.customerContact = jobCopy.customerContact;
    newJobFrame.supplierContact = jobCopy.supplierContact;
    newJobFrame.fromAddress = jobCopy.fromAddress;
    newJobFrame.toAddress = jobCopy.toAddress;
    newJobFrame.instructions = jobCopy.instructions;
    newJobFrame.assignees = [];
    newJobFrame.accessControl = {};
    newJobFrame.editing = true;
    newJobFrame.organisation = jobCopy.organisation;
    newJobFrame.organisationGroup = jobCopy.organisationGroup;
    if (jobCopy.assignees) {
      for (var i = 0; i < jobCopy.assignees.length; i++) {
        var assignee = jobCopy.assignees[i];
        if (assignee.organisation && assignee.organisation !== $scope.currentOrg.id || assignee.organisationGroup && assignee.organisationGroup !== $scope.currentOrgGroup.id) {
          continue;
        }
        //verify that this assignee is part of the current org/org group context
        jobCopy.assignees[i].status = 'Assigned';
        newJobFrame.assignees.push(jobCopy.assignees[i]);
      }
    }
    // copy accessControl items that are forwarders
    var accessControlKeys = Object.keys(jobCopy.accessControl);
    for (var i = 0; i < accessControlKeys.length; i++) {
      if (jobCopy.accessControl[accessControlKeys[i]].indexOf('forwarder') != -1) {
        // this is a forwarder organisation - needs to be added to the new jobs accessControl list
        newJobFrame.accessControl[accessControlKeys[i]] = { 'add': ['forwarder'] };
      }
    }
    newJobFrame.lineItems = jobCopy.lineItems;
    for (var i = 0; i < newJobFrame.lineItems.length; i++) {
      delete newJobFrame.lineItems[i].id;
    }

    $scope.newJobFromDuplicate(newJobFrame);
  };

  /********************************/
  /**** Dockets Lists / Detail ****/
  /********************************/

  $scope.newDocketForJob = function (job) {
    if (!$scope.currentOrg) {
      return;
    }
    jobService.validateCreateDocket(job, function () {
      if (job != null && job.editing) {
        jobService.getJobDiff($scope.lastCleanJob, job, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                $scope.saveJob(job, function () {
                  $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                });
              } else if (actionSelected == 'dontSave') {
                $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                // do nothing - stay where we are
              }
            });
          } else {
            $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupDocketDetail', { docketId: 'new', fromJob: job.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }, function (exceptions) {
      job.loading = false;
      $scope.alertService.presentAutoValidationAlert('jobCreateDocket', exceptions);
    });
  };

  $scope.docketsListForJob = function (job) {
    var currentJob = $scope.getJobFromParent();
    if (currentJob != null && currentJob.editing) {
      jobService.getJobDiff($scope.lastCleanJob, currentJob, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveJob(job, function () {
                if ($scope.currentOrg) {
                  $state.go('main.groupDockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  $state.go('main.dockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber });
                }
              });
            } else if (actionSelected == 'dontSave') {
              if ($scope.currentOrg) {
                $state.go('main.groupDockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                $state.go('main.dockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber });
              }
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          if ($scope.currentOrg) {
            $state.go('main.groupDockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          } else {
            $state.go('main.dockets', { jobId: currentJob.id, jobNumber: currentJob.jobNumber });
          }
        }
      });
    } else {
      if ($scope.currentOrg) {
        $state.go('main.groupDockets', { jobId: job.id, jobNumber: job.jobNumber, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else {
        $state.go('main.dockets', { jobId: job.id, jobNumber: job.jobNumber });
      }
    }
  };

  /*****************************/
  /***** Job List Controls *****/
  /*****************************/

  $scope.filtersChanged = function (from) {
    if (!$scope.preventReloadWithFilters) {
      // check toDate is after fromDate
      if ((0, _momentTimezone2.default)($scope.filters.endDate).isBefore($scope.filters.startDate)) {
        $scope.filters.endDate = $scope.filters.startDate;
      }

      // check if status filter has changed
      //var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
      //if ( storedFilters.status != $scope.filters.status ) {
      //$scope.query.page = 1;
      //}
      $scope.query.page = 1;
      if ($scope.filters.viewType == 'allocate') {

        $scope.loadJobAllocationsList();
      } else {
        $scope.loadJobsList();
      }

      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    } else {}
  };

  /*$scope.jobsAllocationViewReady = function() {
    // check stateParams for any filter presets
    if ( $stateParams.orderId != null ) {
      $scope.filters.order = { id : $stateParams.orderId };
      if ( $stateParams.orderNumber != null ) {
        $scope.filters.order.orderNumber = $stateParams.orderNumber;
      }
    }
    if ( $stateParams.startDate != null ) {
      $scope.filters.startDate = moment($stateParams.startDate).toDate();
    }
    if ( $stateParams.endDate != null ) {
      $scope.filters.endDate = moment($stateParams.endDate).toDate();
    }
    if ( $stateParams.customerContact != null ) {
      $scope.filters.customerContact = $stateParams.customerContact;
    }
    if ( $stateParams.supplierContact != null ) {
      $scope.filters.supplierContact = $stateParams.supplierContact;
    }
    if ( $stateParams.forwarderContact != null ) {
      $scope.filters.forwarderContact = $stateParams.forwarderContact;
    }
    sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    $scope.loadJobAllocationsList();
  }*/

  $scope.jobsChildControllerReady = function () {
    // check stateParams for any filter presets
    if ($scope.currentOrg && sessionStorage.getItem('jobsList') != undefined) {
      // check if last stored jobs filters is the same as current filters
      var lastJobsFilters = {};
      if (sessionStorage.getItem('jobsLastFilters')) {
        lastJobsFilters = JSON.parse(sessionStorage.getItem('jobsLastFilters'));
      }
      var loadNew = false;
      if (sessionStorage.getItem('filters')) {
        var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
        if (storedFilters.reloadRequired == true) {
          loadNew = true;
          $scope.filters.reloadRequired = false;
        }
      }
      if (lastJobsFilters && lastJobsFilters != undefined) {
        if (lastJobsFilters.organisationId != $scope.currentOrg.id || lastJobsFilters.groupId != $scope.currentOrgGroup.id) {
          loadNew = true;
          $scope.filters.order = null;
        }
        if (lastJobsFilters.startDate && (0, _momentTimezone2.default)(lastJobsFilters.startDate).diff((0, _momentTimezone2.default)($scope.filters.startDate), 'days') != 0) {
          loadNew = true;
        } else if (lastJobsFilters.endDate && (0, _momentTimezone2.default)(lastJobsFilters.endDate).diff((0, _momentTimezone2.default)($scope.filters.endDate), 'days') != 0) {
          loadNew = true;
        }
        // check if status options have changed
        if (lastJobsFilters.statusOptions.all == true && $scope.filters.statusOptions.all != true) {
          loadNew = true;
        } else {
          for (var i = 0; i < statusFilterOptions.length; i++) {
            if (lastJobsFilters.statusOptions[statusFilterOptions[i]] != $scope.filters.statusOptions[statusFilterOptions[i]]) {
              loadNew = true;
            }
          }
        }
        if (lastJobsFilters.customerContact && !$scope.filters.customerContact) {
          loadNew = true;
        } else if (!lastJobsFilters.customerContact && $scope.filters.customerContact) {
          loadNew = true;
        } else if (!lastJobsFilters.customerContact && !$scope.filters.customerContact) {
          // do nothing
        } else if (lastJobsFilters.customerContact.id != $scope.filters.customerContact.id) {
          loadNew = true;
        }
      } else {
        // no previous filters stored, load new list
        loadNew = true;
      }
      // check if order has changed
      if (lastJobsFilters.order && !$scope.filters.order) {
        loadNew = true;
      } else if (!lastJobsFilters.order && $scope.filters.order) {
        loadNew = true;
      } else if (!lastJobsFilters.order && !$scope.filters.order) {
        // do nothing
      } else if (lastJobsFilters.order.id != $scope.filters.order.id) {
        loadNew = true;
      }

      if (loadNew) {
        $scope.query.page = 1;
        $scope.loadJobsList();
      } else {
        var jobsListParsed = JSON.parse(sessionStorage.getItem('jobsList'));
        var jobsListCount = JSON.parse(sessionStorage.getItem('jobsListCount'));
        $scope.loadJobsListFromParent(jobsListParsed, jobsListCount);
        $scope.preventReloadWithFilters = false;
      }
    } else {
      $scope.loadJobsList();
    }
  };

  $scope.detailControllerReady = function () {
    if ($stateParams.jobId != null) {
      if ($stateParams.jobId == 'new') {
        if ($stateParams.fromOrder != null) {
          newJob($stateParams.fromOrder);
        } else {
          newJob();
        }
      } else {
        openJob($stateParams.jobId);
      }
    }
  };

  $scope.loadJobsList = function (searchValue, reload) {
    $scope.selected = [];
    $scope.promise = $q(function (resolve, reject) {
      var params = $scope.getFilterParams();
      params['limit'] = $scope.query.limit;
      params['offset'] = $scope.query.limit * ($scope.query.page - 1);
      params['sort'] = $scope.query.order;

      if (searchValue != null && searchValue != "") {
        params['search'] = searchValue;
      }

      jobService.getJobs(params, function (returnData) {
        var jobsListParsed = jobService.parseJobs(returnData);
        var count = 0;
        if (params.offset <= 0 && returnData.length < params.limit) {
          count = returnData.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        $scope.loadJobsListFromParent(jobsListParsed, count);
        if (reload && reload == true) {
          var currentJob = $scope.getJobFromParent();
          if (currentJob && !currentJob.editing && currentJob.id != null) {
            openJob(currentJob.id);
          }
        }
        $scope.preventReloadWithFilters = false;
        // store list in sessionStorage
        sessionStorage.setItem('jobsList', JSON.stringify(jobsListParsed));
        sessionStorage.setItem('jobsListCount', count);
        sessionStorage.setItem('jobsQuery', JSON.stringify($scope.query));
        sessionStorage.setItem('filters', JSON.stringify($scope.filters));
        sessionStorage.setItem('jobsLastFilters', JSON.stringify($scope.filters));
        resolve('Done');
      }, function (err) {
        reject('error');
      });
    });
  };

  $scope.loadJobAllocationsList = function (searchValue, reload) {
    $scope.promise = $q(function (resolve, reject) {
      $scope.allocationUsers = [];
      var params = $scope.getFilterParams();
      //params['limit'] = '500';
      //params['offset'] = $scope.query.limit * ($scope.query.page - 1);
      //params['sort'] = 'startDate';


      if (searchValue != null && searchValue != "") {
        params['search'] = searchValue;
      }

      var fromDateBeforeConvert = (0, _momentTimezone2.default)(params.endFromDate, 'YYYY-MM-DD');
      params.endFromDate = fromDateBeforeConvert.subtract('days', 1).format('YYYY-MM-DD');
      var toDateBeforeConvert = (0, _momentTimezone2.default)(params.startToDate, 'YYYY-MM-DD');
      params.startToDate = toDateBeforeConvert.add('days', 1).format('YYYY-MM-DD');

      jobService.getJobs(params, function (returnData) {
        var jobsListParsed = jobService.parseJobs(returnData);
        var count = 0;
        if (params.offset <= 0 && returnData.length < params.limit) {
          count = returnData.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        var jobAllocationsByUser = {};
        for (var i = 0; i < returnData.length; i++) {
          var thisJob = returnData[i];
          // check if this job lies within this week
          if ((0, _momentTimezone2.default)(thisJob.endDate, 'YYYY-MM-DD').diff((0, _momentTimezone2.default)($scope.filters.startDate)) >= 0 && (0, _momentTimezone2.default)(thisJob.startDate, 'YYYY-MM-DD').diff((0, _momentTimezone2.default)($scope.filters.startDate).add('days', 6)) <= 0) {
            for (var j = 0; j < thisJob.assignees.length; j++) {
              if (jobAllocationsByUser[thisJob.assignees[j].assignee] == null) {
                jobAllocationsByUser[thisJob.assignees[j].assignee] = { maxOverlaps: 0, jobs: {}, startDays: { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }, intersectDays: { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }, jobVOffsets: {}, jobStatus: {}, jobRejectionComments: {} };
              }

              thisJob.displayVerticalOffset = 0;
              jobAllocationsByUser[thisJob.assignees[j].assignee].jobs[thisJob.id] = thisJob;
              jobAllocationsByUser[thisJob.assignees[j].assignee].jobVOffsets[thisJob.id] = 0;

              // find which day(s) this job is on
              var jobStartDay = (0, _momentTimezone2.default)(thisJob.startDate, 'YYYY-MM-DD').diff((0, _momentTimezone2.default)($scope.filters.startDate), 'days') + 1;
              var jobEndDay = (0, _momentTimezone2.default)(thisJob.endDate, 'YYYY-MM-DD').diff((0, _momentTimezone2.default)($scope.filters.startDate), 'days') + 1;
              if (jobStartDay < 1) {
                jobStartDay = 1;
              }
              if (jobEndDay > 7) {
                jobEndDay = 7;
              }
              thisJob.daysCovered = jobEndDay - jobStartDay + 1;

              jobAllocationsByUser[thisJob.assignees[j].assignee].startDays[jobStartDay].push(thisJob.id);

              for (var k = jobStartDay; k <= jobEndDay; k++) {
                jobAllocationsByUser[thisJob.assignees[j].assignee].intersectDays[k].push(thisJob.id);
              }

              // get the status to display for the allocation item
              var status = thisJob.status;
              if (thisJob.status == 'Sent') {
                // get the assignee status
                status = thisJob.assignees[j].status;
                if (status == 'Rejected') {
                  jobAllocationsByUser[thisJob.assignees[j].assignee].jobRejectionComments[thisJob.id] = thisJob.assignees[j].rejectionComment;
                }
              } else if (thisJob.status == 'Draft') {
                status = 'In Draft';
              }
              jobAllocationsByUser[thisJob.assignees[j].assignee].jobStatus[thisJob.id] = status;
            }
          }
        }
        // find intersects on days for each assignee and add offsets
        for (var assignee in jobAllocationsByUser) {
          for (var i = 1; i <= 7; i++) {
            for (var j = 0; j < jobAllocationsByUser[assignee].intersectDays[i].length; j++) {
              if (j > jobAllocationsByUser[assignee].jobVOffsets[jobAllocationsByUser[assignee].intersectDays[i][j]]) {
                jobAllocationsByUser[assignee].jobVOffsets[jobAllocationsByUser[assignee].intersectDays[i][j]] = j;
                if (jobAllocationsByUser[assignee].maxOverlaps < j) {
                  jobAllocationsByUser[assignee].maxOverlaps = j;
                }
              }
            }
          }
        }
        $scope.jobAllocationsByUser = jobAllocationsByUser;

        // re-order users list by number of assignments
        var reorderedUsers = [];
        var unallocatedUsers = [];
        for (var i = 0; i < $scope.allUsers.length; i++) {
          if ($scope.jobAllocationsByUser[$scope.allUsers[i].id] && Object.keys($scope.jobAllocationsByUser[$scope.allUsers[i].id].jobs).length > 0) {
            reorderedUsers.push($scope.allUsers[i]);
          } else {
            unallocatedUsers.push($scope.allUsers[i]);
          }
        }
        for (var i = 0; i < unallocatedUsers.length; i++) {
          reorderedUsers.push(unallocatedUsers[i]);
        }
        $scope.allocationUsers = reorderedUsers;

        resolve('Done');
      }, function (err) {
        reject('error');
      });
    });
  };

  /*****************************/
  /***** List View Controls ****/
  /*****************************/

  $scope.selectContactFilter = function (type) {
    var existingContact = null;
    if (type == 'customer') {
      if ($scope.filters.customerContact != null) {
        existingContact = $scope.filters.customerContact;
      }
    } else if (type === 'forwarder') {
      if ($scope.filters.forwarderContact != null) {
        existingContact = $scope.filters.forwarderContact;
      }
    }
    $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
      if (contactSelected != null) {
        if (type == 'customer') {
          $scope.filters.customerContact = contactSelected;
        } else if (type === 'forwarder') {
          $scope.filters.forwarderContact = contactSelected;
        }
        $scope.filtersChanged(contactSelected);
      }
    });
  };

  $scope.selectOrderForJob = function (options, cb) {
    $scope.splitListFunc.ensureListOpen();
    $scope.selectOrderCallback = cb;
    $scope.orderSelectFromParent(options, function (orderSelected) {
      $scope.selectOrderCallback(orderSelected);
    });
  };

  $scope.selectOrderFilter = function () {
    var currentOrder = null;
    var options = {};
    if ($scope.filters.order != null) {
      options.currentOrder = $scope.filters.order;
    }
    $scope.orderSelectFromParent(options, function (orderSelected) {
      if (orderSelected != null) {
        $scope.filters.order = orderSelected;
        $scope.filtersChanged('order');
      }
    });
  };

  $scope.selectPersonForJob = function (assignedUsers, cb) {
    $scope.splitListFunc.ensureListOpen();
    $scope.selectPersonCallback = cb;
    $scope.desktopPeopleSelectFromParent(assignedUsers, function (peopleSelected) {
      $scope.selectPersonCallback(peopleSelected);
    });
  };

  $scope.selectLineFromOrder = function (sourceList, cb) {
    $scope.splitListFunc.ensureListOpen();
    $scope.selectLineCallback = cb;
    $scope.lineSelectFromParent(sourceList, function (linesSelected) {
      $scope.selectLineCallback(linesSelected, 'desktop');
    });
  };

  $scope.selectContactForJob = function (cb) {
    $scope.contactSelectFromParent(null, null, function (contactSelected) {
      cb(contactSelected);
    });
  };

  /***************************/
  /***** Job Data Helpers ****/
  /***************************/

  // Bulk Delete
  $scope.bulkSelectionDelete = function () {
    var itemsToDelete = $scope.selected;
    $scope.clearJobFromParent();
    $scope.splitListFunc.slideTableListDetailClosed();
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete these " + itemsToDelete.length + " jobs?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        jobService.deleteBulkJobs(itemsToDelete, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkJobs', { status: 202, requestName: 'Delete bulk jobs - failures ' + failures.length + ' of ' + itemsToDelete.length });
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkJobs', { status: 200 });
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          }
          $scope.selected = [];
        });
      }
    });
  };

  // Bulk Send
  $scope.bulkSelectionSend = function (confirmationText) {
    confirmationText = confirmationText ? confirmationText : 'send';
    var itemsToSend = $scope.selected;

    if (confirmationText == 're-open' && itemsToSend.filter(function (x) {
      return x.status != 'Closed';
    }).length > 0) {
      swal({
        type: 'warning',
        text: 'It looks like some of the jobs selected are not closed. Check your selection and try again.',
        title: 'Hold Tight!'
      });
      return;
    }

    swal({
      title: "Are you sure?",
      text: 'Do you really want to ' + confirmationText + ' these ' + itemsToSend.length + ' jobs?',
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: 'Yes, ' + confirmationText + ' them!',
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        jobService.sendBulkJobs(itemsToSend, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('sendBulkJobs', { status: 202, requestName: 'Send bulk jobs - failures ' + failures.length + ' of ' + itemsToSend.length });
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          } else {
            $scope.alertService.presentAutoAlert('sendBulkJobs', { status: 200 });
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          }
          $scope.selected = [];
        });
      }
    });
  };

  // Bulk Close
  $scope.bulkSelectionClose = function () {
    var itemsToClose = $scope.selected;
    swal({
      title: "Are you sure?",
      text: "Do you really want to close these " + itemsToClose.length + " jobs?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, close them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        jobService.closeBulkJobs(itemsToClose, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('closeBulkJobs', { status: 202, requestName: 'Close bulk jobs - failures ' + failures.length + ' of ' + itemsToClose.length });
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          } else {
            $scope.alertService.presentAutoAlert('closeBulkJobs', { status: 200 });
            if ($scope.filters.viewType == 'allocate') {
              $scope.loadJobAllocationsList();
            } else {
              $scope.loadJobsList();
            }
          }
          $scope.selected = [];
        });
      }
    });
  };

  // Bulk Duplicate
  $scope.bulkSelectionDuplicate = function () {
    $scope.duplicateJobs = {};
    $scope.duplicateJobs.list = $scope.selected;
    $("#duplicateJobsModal").fadeIn(100);
  };

  $scope.closeDuplicateJobsModal = function () {
    $("#duplicateJobsModal").fadeOut(100);
  };

  $scope.duplicateJobsContinue = function () {
    // create new jobs for each in duplicates list with start and end date overwritten
    $scope.duplicateJobs.saving = true;
    var jobsToSave = [];

    for (var i = 0; i < $scope.duplicateJobs.list.length; i++) {
      var jobCopy = $scope.duplicateJobs.list[i];
      var newJobFrame = {};
      newJobFrame.status = "New";
      newJobFrame.statusDisplay = "New";
      newJobFrame.jobNumber = "New Job";
      if (jobCopy.orderRef) {
        newJobFrame.orderRef = jobCopy.orderRef;
      }
      if (jobCopy.customerContact) {
        newJobFrame.customerContact = angular.copy(jobCopy.customerContact);
      }
      if (jobCopy.supplierContact) {
        newJobFrame.supplierContact = angular.copy(jobCopy.supplierContact);
      }
      if (jobCopy.fromAddress) {
        newJobFrame.fromAddress = jobCopy.fromAddress;
      }
      if (jobCopy.toAddress) {
        newJobFrame.toAddress = jobCopy.toAddress;
      }
      if (jobCopy.instructions) {
        newJobFrame.instructions = jobCopy.instructions;
      }
      newJobFrame.assignees = [];
      newJobFrame.startDate = $scope.duplicateJobs.startDate;
      newJobFrame.endDate = $scope.duplicateJobs.endDate;
      if (jobCopy.assignees) {
        for (var j = 0; j < jobCopy.assignees.length; j++) {
          newJobFrame.assignees.push({ assignee: jobCopy.assignees[j].assignee, emailAddress: jobCopy.assignees[j].emailAddress, name: jobCopy.assignees[j].name, status: 'assigned' });
        }
      }
      if (jobCopy.lineItems) {
        newJobFrame.lineItems = angular.copy(jobCopy.lineItems);
      }
      jobsToSave.push(newJobFrame);
    }

    $scope.saveDuplicateJobs(jobsToSave, 0, [], function (jobsCreated) {
      $("#duplicateJobsModal").fadeOut(100);
      if ($scope.filters.viewType == 'allocate') {
        $scope.loadJobAllocationsList();
      } else {
        $scope.loadJobsList();
      }
    });
  };

  $scope.saveDuplicateJobs = function (jobsList, index, jobsCreated, cb) {
    if (index >= jobsList.length) {
      cb(jobsCreated);
      return;
    }

    jobService.saveJob(jobsList[index], function (savedJob) {
      jobsCreated.push(savedJob);
      $scope.saveDuplicateJobs(jobsList, index + 1, jobsCreated, cb);
    }, function (err) {
      $scope.saveDuplicateJobs(jobsList, index + 1, jobsCreated, cb);
    });
  };

  /***********************/
  /**** Job Comments *****/
  /***********************/

  $scope.addNewComment = function (job) {
    $("#jobCommentModal").fadeIn(100);
    $scope.newJobComment = {};
    $scope.newJobComment.comment = "";
    $scope.newJobComment.job = job;
  };

  $scope.closeJobCommentModal = function () {
    $("#jobCommentModal").fadeOut(100);
    $scope.newJobComment = {};
  };

  $scope.addCommentModalNext = function () {
    $scope.newJobComment.loading = true;
    $scope.addCommentToJob($scope.newJobComment.job, $scope.newJobComment.comment);
  };

  $scope.addCommentToJob = function (job, commentText) {
    if (!job.editing && job.userAssigneeData) {
      // add comment as an assignee
      jobService.addAssigneeComment(job, commentText, function (jobUpdated) {
        job.comments = jobUpdated.comments;
        $("#jobCommentModal").fadeOut(100);
      }, function (err) {
        $scope.newJobComment.loading = false;
        $scope.alertService.presentAutoAlert('addJobComment', err);
      });
    } else {
      var comment = {};
      comment.comment = commentText;
      comment.author = $scope.currentUser.id;
      comment.authorName = $scope.currentUser.name.full;
      comment.date = (0, _momentTimezone2.default)().toISOString();

      jobService.addComment(job, comment, function (jobUpdated) {
        job.comments = jobUpdated.comments;
        $("#jobCommentModal").fadeOut(100);
      }, function (err) {
        $scope.newJobComment.loading = false;
        $scope.alertService.presentAutoAlert('addJobComment', err);
      });
    }
  };

  $scope.removeCommentFromJob = function (job, comment) {
    jobService.deleteComment(job, comment, function (jobUpdated) {
      job.comments = jobUpdated.comments;
    }, function (err) {
      $scope.alertService.presentAutoAlert('removeJobComment', err);
    });
  };

  /********************/
  /***** Filters ******/
  /********************/

  $scope.getFilterParams = function () {
    var params = {};
    if ($scope.filters.endDate != null) {
      var startToDate = (0, _momentTimezone2.default)($scope.filters.endDate);
      params.startToDate = startToDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.startDate != null) {
      var endFromDate = (0, _momentTimezone2.default)($scope.filters.startDate);
      params.endFromDate = endFromDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.customer != 'All' && $scope.filters.customer != null) {
      params.customer = $scope.filters.customer;
    }
    if ($scope.filters.assignee != 'All' && $scope.filters.assignee != null) {
      if ($scope.filters.assignee == 'Me') {
        params.assignee = $scope.currentUser.id;
      } else {
        // generate uuid list of assignees
        var uuidList = [];
        for (var i = 0; i < $scope.filters.assigneeList.length; i++) {
          uuidList.push($scope.filters.assigneeList[i].id);
        }
        params.assignee = uuidList;
      }
    }
    if ($scope.filters.statusOptions.all == true) {
      params['status'] = null;
    } else {
      var statusParam = "";
      var count = 0;
      for (var i in statusFilterOptions) {
        if ($scope.filters.statusOptions[statusFilterOptions[i]] == true) {
          count += 1;
          if (count > 1) {
            statusParam += ", ";
          }
          statusParam += statusFilterOptions[i];
        }
      }
      params['status'] = statusParam;
    }
    if ($scope.filters.assigneeStatusOptions.all == true) {
      params['hasRejections'] = false;
    } else {
      var statusCount = 0;
      for (var i = 0; i < assigneeStatusFilterOptions.length; i++) {
        if ($scope.filters.assigneeStatusOptions[assigneeStatusFilterOptions[i]] == true) {
          statusCount += 1;
        }
      }
      if ($scope.filters.assigneeStatusOptions.rejected == true && statusCount == 1) {
        params['hasRejections'] = true;
      }
    }
    // filtering by order
    if ($scope.filters.order != null && $scope.filters.order.id != null) {
      params.orderRef = $scope.filters.order.id;
    }
    if ($scope.filters.customerContact != null) {
      var customerAddresses = [];
      for (var i = 0; i < $scope.filters.customerContact.contactAddresses.length; i++) {
        customerAddresses.push($scope.filters.customerContact.contactAddresses[i].emailAddress);
      }
      params.customer = customerAddresses.join(',');
    }
    if ($scope.filters.jobNumber != null && $scope.filters.jobNumber != "") {
      params.jobNumber = $scope.filters.jobNumber;
    }
    if ($scope.filters.forwarderContact) {
      params.forwarders = $scope.filters.forwarderContact.contactAddresses.map(function (address) {
        return address.emailAddress;
      }).join(',');
    }
    if ($scope.filters.hasRejections === true) {
      params.hasRejections = 'true';
    }
    return params;
  };

  $scope.resetAllFilters = function () {
    // SETUP filters
    $scope.filters = {};
    $scope.filters.status = 'All';
    $scope.filters.startDate = null; // moment().subtract(7,'days').toDate();
    $scope.filters.endDate = null;
    $scope.filters.customer = 'All';
    $scope.filters.assignee = 'All';
    $scope.filters.jobNumber = null;
    $scope.filters.assigneeList = [];
  };

  $scope.searchJobsChange = function (value) {
    if ($scope.filters.viewType == 'allocate') {
      $scope.loadJobAllocationsList();
    } else {
      $scope.loadJobsList();
    }
  };

  $scope.clearFilterItem = function (name) {
    $scope.filters[name] = null;
    $scope.filtersChanged(name);
  };

  $scope.clearFilters = function () {
    $scope.filters.order = null;
    $scope.filters.jobNumber = null;
    $scope.filters.customerContact = null;
    $scope.filters.forwarderContact = null;
    $scope.filters.hasRejections = false;
    for (var i in statusFilterOptions) {
      $scope.filters.statusOptions[statusFilterOptions[i]] = true;
    }
    $scope.filters.statusOptions.allView = true;
    $scope.filters.statusOptions.all = true;
    // reset date filters
    $scope.filters.startDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate(); //startFromDate
    $scope.filters.endDate = (0, _momentTimezone2.default)().toDate(); //endToDate
    $scope.dateFilterModel.dateStart = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.dateFilterModel.dateEnd = (0, _momentTimezone2.default)().toDate();
    $scope.filtersChanged('cleared');
    window.location.reload();
  };

  $scope.clearFilterDateSet = function (firstDate, secondDate) {
    $scope.filters[firstDate] = null;
    $scope.filters[secondDate] = null;
  };

  $scope.toggleFilters = function () {
    $scope.showFilters = !$scope.showFilters;
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /*$scope.$watch('filters', function() {
    if ( !$scope.preventReloadWithFilters ) {
      if ( $scope.filters.viewType == 'allocation' ) {
        $scope.loadJobAllocationsList();
      }
    }
  },true);*/

  /* Currently Load Allocations Immediately */
  if ($scope.currentOrg != null) {
    $scope.loadUsers(function () {
      //$scope.jobsAllocationViewReady(
      if ($scope.filters.viewType == 'allocate') {
        $scope.loadJobAllocationsList();
      }
    });
  }

  $scope.showUpgradePlanModal = function (_, feature, trackingText) {
    $scope.selectPlan(null, feature, trackingText);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "Hv7s":
/***/ (function(module, exports) {

var path = 'views/modals/selectXeroContactModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector long noFooter\" id=\"selectXeroContactModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Xero Contact</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeXeroContactSelect()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"splitModalForm\">\n        <div class=\"splitModalFormLeft noPadding white\">\n          <div class=\"searchBar\">\n            <div class=\"title\">\n              <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n            </div>\n            <div class=\"bar\">\n              <input type=\"text\" ng-model=\"xeroContactSearchValue\" placeholder=\"Search\" ng-change=\"searchXeroContactChange(xeroContactSearchValue)\" ng-model-options='{debounce:100}'>\n            </div>\n          </div>\n          <div class=\"noListMessage\" ng-show=\"xeroContactSearchList.length <= 0\">\n            There are no contacts matching your search criteria.\n          </div>\n          <div class=\"modalListOuter\">\n            <md-list>\n              <md-list-item ng-repeat=\"contact in xeroContactSearchList\" ng-click=\"selectXeroContact(contact)\" class=\"md-2-line\">\n                <div class=\"md-avatar xero\"><span></span></div>\n                <div class=\"md-list-item-text\" layout=\"column\">\n                  <h3>{{contact.name}}</h3>\n                  <p ng-if=\"contact.emailAddresses.length > 0\"><{{contact.emailAddresses[0]}}></p>\n                </div>\n              </md-list-item>\n            </md-list>\n          </div>\n        </div>\n        <div class=\"splitModalFormRight noPadding\">\n          <span ng-if=\"xeroContactDetail != null\">\n            <div class=\"contactDetailHeader small\">\n              <div class=\"avatar xero\"></div>\n              <h1>{{xeroContactDetail.name}}</h1>\n            </div>\n            <md-list>\n              <md-subheader class=\"md-no-sticky\">Address</md-subheader>\n              <md-list-item ng-if=\"xeroContactDetail.addresses && xeroContactDetail.addresses.length > 0\">\n                <p>{{stringifyAddress(xeroContactDetail.addresses[0])}}</p>\n              </md-list-item>\n              <md-list-item ng-if=\"!xeroContactDetail.addresses || xeroContactDetail.addresses.length <= 0\">\n                <p>No Address</p>\n              </md-list-item>\n\n              <md-subheader class=\"md-no-sticky extra-margin\">Email Addresses</md-subheader>\n              <md-list-item ng-repeat=\"email in xeroContactDetail.emailAddresses\" class=\"addressItem\">\n                <p>{{email}}</p>\n              </md-list-item>\n            </md-list>\n            <div style=\"padding: 20px;\">\n              <div class=\"dbButton lightBlue block\" ng-click=\"assignXeroContact(xeroContactDetail)\">Select Contact</div>\n            </div>\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "I/pv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').controller('connectionsController', ['addressBookService', '$rootScope', 'splitListInterface', '$scope', 'userService', '$window', 'Restangular', '$state', '$stateParams', 'accessControl', 'uuid', '$q', function (addressBookService, $rootScope, splitListInterface, $scope, userService, $window, Restangular, $state, $stateParams, accessControl, uuid, $q) {

  $scope.query = {
    limit: 30,
    page: 1,
    order: 'displayName'
  };
  $scope.promise = null;
  $scope.connectionEdit = null;

  $scope.connections = [];
  $scope.selected = [];
  $scope.currentOrg = accessControl.currentOrg();

  /** Details **/
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  $scope.openConnection = function (connection) {
    if (connection.targetId == null && connection.sourceId != $scope.currentOrg.id) {
      $scope.showAcceptConnectionModal(connection, function () {
        $scope.loadConnections();
        $rootScope.updateScopeNavConnections();
      });
      return;
    }

    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.connectionEdit = angular.copy(connection);
  };

  $scope.closeConnection = function () {
    $scope.contactEdit = null;
    $scope.splitListFunc.slideTableListDetailClosed();
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.acceptConnection = function (connection) {
    connection.status = 'accept';

    addressBookService.saveInvitation(connection, function (updatedConnection) {
      $scope.loadConnections();
      $scope.openConnection(updatedConnection);
    }, function (err) {
      $scope.alertService.presentAutoAlert('saveConnection', err);
    });
  };

  /****/

  $scope.getConnectionStatus = function (connection) {
    if (connection == null) return '';

    switch (connection.status) {
      case 'requested':
        {
          if (connection.sourceId != $scope.currentOrg.id) {
            return 'Request received';
          } else {
            return 'Request sent';
          }
        }
      case 'accepted':
        return 'Connected';
      case 'declined':
        return 'Declined';
    }
  };

  $scope.rejectConnection = function (connection) {
    swal({
      title: "Are you sure?",
      text: 'Do you really want to decline the connection with ' + connection.company + '?',
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        connection.status = 'decline';
        addressBookService.saveInvitation(connection, function () {
          $scope.loadConnections();
          $rootScope.updateScopeNavConnections();
        }, function (err) {
          swal("Oops", "Something went wrong", "warning");
          $scope.alertService.presentAutoAlert('saveConnection', err);
        });
      }
    });
  };

  $scope.deleteConnection = function (connection) {
    swal({
      title: "Are you sure?",
      text: 'Do you really want to delete the connection with ' + connection.companyName + '?',
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        addressBookService.removeConnection(connection, function () {
          $scope.closeConnection();
          $scope.loadConnections();
          $rootScope.updateScopeNavConnections();
        }, function (err) {
          swal("Oops", "Something went wrong", "warning");
          $scope.alertService.presentAutoAlert('saveConnection', err);
        });
      }
    });
  };

  $scope.cancelRequestedConnection = function (connection) {
    swal({
      title: "Are you sure?",
      text: 'Do you really want to cancel the requested connection' + (connection.companyName ? ' with ' + connection.companyName : '') + '?',
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        addressBookService.removeConnection(connection, function () {
          $scope.closeConnection();
          $scope.loadConnections();
        }, function (err) {
          swal("Oops", "Something went wrong", "warning");
          $scope.alertService.presentAutoAlert('saveConnection', err);
        });
      }
    });
  };

  $scope.newConnection = function () {
    $scope.showCreateConnectionsModal(false, function () {
      $scope.loadConnections();
    });
  };

  $scope.importConnections = function () {
    $scope.showCreateConnectionsModal(true, function () {
      $scope.loadConnections();
    });
  };

  function getUserConnections(cb) {
    function addToConnections(connections) {
      userService.getUserInvitations(function (invitations) {
        invitations.forEach(function (invitation) {
          var foundConnection = connections.find(function (conn) {
            return conn.id == invitation.connectionId;
          });
          if (foundConnection) {
            foundConnection.invitation = invitation;
          }
        });
        cb(connections);
      }, function () {
        return cb([]);
      });
    }
    userService.getUserConnections(addToConnections, function () {
      return cb([]);
    });
  }

  function getRelevantInvitations() {
    return $q(function (resolve, reject) {
      if ($scope.connections.length > 0) {
        // Link invitations to connections
        addressBookService.getFilteredInvitations({ connectionIds: $scope.connections.map(function (conn) {
            return conn.id;
          }) }, function (invitations) {
          invitations.forEach(function (invitation) {
            var foundConnection = $scope.connections.find(function (conn) {
              return conn.id == invitation.connectionId;
            });
            if (foundConnection) {
              foundConnection.invitation = invitation;
            }
            resolve('Done');
          });
        }, function (err) {
          reject('Error');
        });
      } else {
        resolve('Done');
      }
    });
  }

  $scope.loadConnections = function () {
    $scope.promise = $q(function (resolve, reject) {
      var _$scope$query = $scope.query,
          limit = _$scope$query.limit,
          page = _$scope$query.page,
          order = _$scope$query.order;


      var params = {
        limit: limit,
        offset: limit * (page - 1),
        sort: order
      };
      if ($scope.search != null && $scope.search != "") {
        params.search = $scope.search;
      }

      addressBookService.getConnections(params, function (connections) {
        $scope.connections = connections;

        var count = 0;
        if (params.offset <= 0 && connections.length < params.limit) {
          count = connections.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        $scope.listCount = count;

        getUserConnections(function (userConnections) {
          $scope.connections = connections.concat(userConnections);
          $scope.connections.forEach(function (conn) {
            return conn.invitation = {};
          });

          getRelevantInvitations().then(function () {
            $scope.connections.filter(function (connection) {
              return connection.sourceId != $scope.currentOrg.id && connection.status == 'requested' || connection.status == 'accepted';
            }).forEach(function (connection) {
              connection.invitation.orgData = {};

              var orgIdToGet = connection.sourceId == $scope.currentOrg.id ? connection.targetId : connection.sourceId;
              userService.getOrgData(orgIdToGet, function (orgData) {
                connection.orgData = {
                  organisationName: orgData.name,
                  fullName: orgData.contacts[0].name,
                  emailAddress: orgData.contacts[0].emailAddress
                };
              }, function (err) {
                console.error('could not get organisational data', err);
              });
            });
            resolve('Done');
          }).catch(function (err) {
            reject(err);
          });
        });
      }, function (err) {
        reject('Error');
      });
    });
  };

  $scope.loadConnections();

  $scope.deleteSelectedConnections = function () {
    swal({
      title: "Are you sure?",
      text: 'Do you really want to delete the requested connections?',
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "No, keep them!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        $q.all($scope.selected.map(function (connection) {
          return $q(function (resolve) {
            return addressBookService.removeConnection(connection, resolve, resolve);
          });
        })).then(function () {
          $scope.loadConnections();
          $rootScope.updateScopeNavConnections();
          $scope.selected = [];
        });
      }
    });
  };
}]);

/***/ }),

/***/ "I6CZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "org.svg";

/***/ }),

/***/ "ICZc":
/***/ (function(module, exports) {

var path = 'views/modals/xeroInvoice.html';
var html = "<div class=\"niceModal desktopSelector noFooter newCompanyModal\" id=\"xeroInvoiceModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Create a Xero Invoice</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeXeroInvoiceModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div my-loader text=\"Hang tight, we are checking a few things\" ng-if=\"xeroInvoice.loading\"></div>\n      <div class=\"modalFormTable padding\" ng-if=\"xeroInvoice.stage == 'checkConnection'\">\n        Checking your xero organisation connection..Please wait\n      </div>\n      <div class=\"\" ng-if=\"xeroInvoice.stage == 'invoiceDetails'\">\n        <form name=\"invoiceDetailsForm\">\n          <h2>Who is the invoice for?</h2>\n\n          <md-radio-group ng-model=\"xeroInvoice.target\">\n            <div class=\"signatureSelectionOuter\">\n              <div class=\"left\">\n                <md-radio-button value=\"customer\" class=\"md-primary\" ng-disabled=\"xeroInvoice.disableCustomer || !xeroInvoice.customerContact.xeroLinked\"><h4 class=\"normal\">Customer</h4><p>{{xeroInvoice.customerContact.displayName}}</p><p ng-if=\"!xeroInvoice.customerContact.xeroLinked\">This contact has not been linked to a Xero contact.</p></md-radio-button>\n              </div>\n              <div class=\"right\">\n                <md-radio-button value=\"supplier\" class=\"md-primary\" ng-disabled=\"xeroInvoice.disableSupplier || !xeroInvoice.supplierContact.xeroLinked\"><h4 class=\"normal\">Supplier</h4><p>{{xeroInvoice.supplierContact.displayName}}</p><p ng-if=\"!xeroInvoice.supplierContact.xeroLinked\">This contact has not been linked to a Xero contact.</p></md-radio-button>\n              </div>\n            </div>\n          </md-radio-group>\n\n          <h2 class=\"topMargin\">How should the items be exported?</h2>\n\n          <md-radio-group ng-model=\"xeroInvoice.type\">\n            <div class=\"signatureSelectionOuter\">\n              <div class=\"left\">\n                <md-radio-button value=\"aggregate\" class=\"md-primary\"><h4 class=\"normal\">Aggregate</h4><p>Aggregate items and interactions together.</p></md-radio-button>\n              </div>\n              <div class=\"right\">\n                <md-radio-button value=\"lines\" class=\"md-primary\"><h4 class=\"normal\">Individual</h4><p>Item lines will be exported individually.</p></md-radio-button>\n              </div>\n            </div>\n          </md-radio-group>\n\n          <div class=\"xeroInvoiceButtons\">\n            <div class=\"dbButton lightBlue\" ng-click=\"(xeroInvoice.target == null) || createInvoice()\" ng-disabled=\"xeroInvoice.target == null\">Create Invoice</div>\n          </div>\n        </form>\n      </div>\n      <div class=\"\" ng-if=\"xeroInvoice.stage == 'error'\">\n        <div class=\"billingSuccessOuter error\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n        </div>\n        <div class=\"billingSuccessMessage\">\n          Something went wrong when we tried to create your new Xero Invoice. Please try again.\n          <br/>\n          <div class=\"dbButton\" ng-click=\"xeroInvoice.stage = 'invoiceDetails'\">Go Back</div>\n        </div>\n      </div>\n      <div class=\"\" ng-if=\"xeroInvoice.stage == 'success'\">\n        <p>Your Xero invoice was successfully created!</p>\n\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "IX6N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "back-icon.svg";

/***/ }),

/***/ "Ib4p":
/***/ (function(module, exports) {

var path = 'views/modals/importResourcesModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector wide long\" id=\"importResourcesModal\">\n    <div class=\"modalContainer\">\n        <div class=\"header hidden-xs\">\n            <h1>Import Resources</h1>\n            <div class=\"headerCloseButton\" ng-click=\"close()\">\n                <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n\n        <md-progress-circular ng-if=\"xeroSyncLoading\" md-diameter=\"35px\" style=\"position: absolute; left: 50%; top: 50%; z-index: 98;\"></md-progress-circular>\n\n        <div ng-show=\"!(currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled)\" class=\"content noPadding\">\n            <div ng-show=\"fileStage == 1\">\n                <form name=\"importResourcesForm\" novalidate>\n                    <div class=\"content\">\n                        Excel files only (.xls or .xlsx)\n                        <br/>\n                        <br/>\n                        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n                    </div>\n                </form>\n            </div>\n            <div ng-show=\"fileStage == 2\">\n                <md-table-container>\n                    <table md-table md-row-select multiple ng-model=\"importSelected\" md-progress=\"importPromise\">\n                        <thead md-head>\n                            <tr md-row>\n                                <!--th md-column><span>Status</span></th-->\n                                <th md-column><span>Name</span></th>\n                                <th md-column><span>Identifier</span></th>\n                                <th md-column><span>Category</span></th>\n                                <th md-column><span>Unit of Measure</span></th>\n                            </tr>\n                        </thead>\n                        <tbody md-body>\n                            <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in importList\">\n                                <!--td md-cell>\n                                    <div class=\"statusDisplay {{item.status == 'New' ? 'Completed' : 'Requested'}}\">{{item.status}}</div>\n                                </td-->\n                                <td md-cell>\n                                    <md-input-container>\n                                        <input ng-model=\"item.name\" type=\"text\" required ng-change=\"validateFileCodeItem(fileCode)\"/>\n                                    </md-input-container>\n                                </td>\n                                <td md-cell>\n                                    <md-input-container>\n                                        <input ng-model=\"item.identifier\" type=\"text\" required ng-change=\"validateAllResourceItems()\"/>\n                                        <div ng-show=\"item.identifierNotUnique\" class=\"errorMessage\">\n                                            Identifier not unique\n                                        </div>\n                                    </md-input-container>\n                                </td>\n                                <td md-cell>\n                                    <ng-form name=\"categoryForm\">\n                                        <md-autocomplete required md-input-name=\"autocompleteCategory\"\n                                            ng-disabled=\"false\" md-no-cache=\"true\"\n                                            md-selected-item=\"item.category\"\n                                            md-search-text-change=\"searchCategoryChange(searchTextCategory)\"\n                                            md-search-text=\"searchTextCategory\"\n                                            md-selected-item-change=\"validateResourceItem(item)\"\n                                            md-items=\"category in allResourceCategories\" md-item-text=\"category.name\"\n                                            md-min-length=\"0\" placeholder=\"Search for a resource category\"\n                                            md-menu-class=\"autocomplete-custom-template\"\n                                        >\n                                            <md-item-template>\n                                                <span class=\"item-title\">{{category.name}}</span>\n                                            </md-item-template>\n                                            <md-not-found>\n                                                No matches found.\n                                            </md-not-found>\n                                        </md-autocomplete>\n                                        <div ng-show=\"categoryForm.autocompleteCategory.$error.required || !item.category || !item.category.id\" class=\"errorMessage\">\n                                            Please select a valid category\n                                        </div>\n                                    </ng-form>\n                                </td>\n                                <td md-cell>\n                                    <ng-form name=\"uomForm\">\n                                        <md-autocomplete required md-input-name=\"autocompleteUom\"\n                                            ng-disabled=\"false\" md-no-cache=\"true\"\n                                            md-selected-item=\"item.uom\"\n                                            md-search-text-change=\"searchUomChange(searchTextUom)\"\n                                            md-search-text=\"searchTextUom\"\n                                            md-selected-item-change=\"validateResourceItem(item)\"\n                                            md-items=\"uom in allUoms\" md-item-text=\"uom.abbreviation\"\n                                            md-min-length=\"0\" placeholder=\"Search for a unit of measure\"\n                                            md-menu-class=\"autocomplete-custom-template\"\n                                        >\n                                            <md-item-template>\n                                                <span class=\"item-title\">{{uom.abbreviation}} - {{uom.description}}</span>\n                                            </md-item-template>\n                                            <md-not-found>\n                                                No matches found.\n                                            </md-not-found>\n                                        </md-autocomplete>\n                                        <div ng-show=\"uomForm.autocompleteUom.$error.required || !item.uom || !item.uom.id\" class=\"errorMessage\">\n                                            Please select a valid UOM\n                                        </div>\n                                    </ng-form>\n                                </td>\n                                <td md-cell>\n                                    <md-button class=\"md-icon-button\" ng-click=\"removeResourceFromImport(item, importList)\" aria-label=\"Remove Resource From Import List\">\n                                        <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                                    </md-button>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </md-table-container>\n            </div>\n        </div>\n\n        <div ng-show=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\" class=\"content noPadding\">\n            <md-tabs md-dynamic-height md-selected=\"selectedTabIndex\" md-border-bottom md-autoselect>\n                <md-tab>\n                    <md-tab-label>\n                        From Xero\n                    </md-tab-label>\n                    <md-tab-body>\n                        <div ng-if=\"!userIsXeroAuthenticated\">Not authenticated</div>\n                        <div ng-if=\"userIsXeroAuthenticated\">\n                            <div ng-if=\"stage == 1\" class=\"content noPadding\">\n                                <div class=\"splitModalForm\" ng-style=\"getTableStyle()\">\n                                    <div class=\"splitModalFormLeft noPadding white\">\n                                        <div class=\"searchBar\">\n                                            <div class=\"title\">\n                                                <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                                            </div>\n                                            <div class=\"bar\">\n                                                <input type=\"text\" ng-model=\"xeroSearchValue\" placeholder=\"Search\" ng-change=\"searchXeroChange(xeroSearchValue)\" ng-model-options='{debounce:100}'>\n                                            </div>\n                                        </div>\n                                        <div class=\"noListMessage\" ng-show=\"xeroContactSearchList.length <= 0\">\n                                            There are no resources matching your search criteria.\n                                        </div>\n\n                                        <md-table-container>\n                                            <table md-table md-row-select multiple=\"true\" ng-model=\"selectedItems\" md-progress=\"promise\">\n                                                <thead md-head>\n                                                    <tr md-row>\n                                                        <th md-column><span>Name</span></th>\n                                                        <!--<th md-column><span>Description</span></th>-->\n                                                        <th md-column><span>Code</span></th>\n                                                    </tr>\n                                                </thead>\n                                                <tbody md-body>\n                                                    <tr md-row md-select=\"xeroItem\" md-select-id=\"id\" ng-repeat=\"xeroItem in filteredXeroItems\" ng-disabled=\"xeroSyncLoading\">\n                                                        <td md-cell>\n                                                            {{xeroItem.name}}\n                                                        </td>\n                                                        <!--<td md-cell>\n                                                            {{xeroItem.description}}\n                                                        </td>-->\n                                                        <td md-cell>\n                                                            {{xeroItem.userCode}}\n                                                        </td>\n                                                    </tr>\n                                                </tbody>\n                                            </table>\n                                        </md-table-container>\n                                        <md-table-pagination md-limit=\"xeroQuery.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"xeroQuery.page\" md-on-paginate=\"getXeroItems\" md-total=\"{{xeroListCount}}\" md-page-select>\n                                        </md-table-pagination>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div ng-if=\"stage == 2\" class=\"content\">\n                                <div style=\"padding-bottom: 20px;\">\n                                    <h2 class=\"inlineBlock\">Prefill Category and/or Unit of Measure to all resources</h2>\n                                    <p class=\"subHead\">Which you like all resources to have a prefilled Category and/or Unit of Measure?</p>\n                                </div>\n                                <div style=\"padding-bottom: 15px;\">\n                                    <ng-form name=\"categoryForm\">\n                                        <md-autocomplete required md-input-name=\"autocompleteCategory\"\n                                            ng-disabled=\"false\" md-no-cache=\"true\"\n                                            md-selected-item=\"prefilled.category\"\n                                            md-search-text-change=\"searchCategoryChange(searchTextCategory)\"\n                                            md-search-text=\"searchTextCategory\"\n\n                                            md-items=\"category in allResourceCategories\" md-item-text=\"category.name\"\n                                            md-min-length=\"0\" placeholder=\"Search for a resource category\"\n                                            md-menu-class=\"autocomplete-custom-template\"\n                                        >\n                                            <md-item-template>\n                                                <span class=\"item-title\">{{category.name}}</span>\n                                            </md-item-template>\n                                            <md-not-found>\n                                                No matches found.\n                                            </md-not-found>\n                                        </md-autocomplete>\n                                        <!--<div ng-show=\"categoryForm.autocompleteCategory.$error.required || !prefillCategory || !prefillCategory.id\" class=\"errorMessage\">\n                                            Valid category not selected\n                                        </div>-->\n                                    </ng-form>\n                                </div>\n\n                                <ng-form name=\"uomForm\">\n                                    <md-autocomplete required md-input-name=\"autocompleteUom\"\n                                        ng-disabled=\"false\" md-no-cache=\"true\"\n                                        md-selected-item=\"prefilled.uom\"\n                                        md-search-text-change=\"searchUomChange(searchTextUom)\"\n                                        md-search-text=\"searchTextUom\"\n                                        md-items=\"uom in allUoms\" md-item-text=\"uom.abbreviation\"\n                                        md-min-length=\"0\" placeholder=\"Search for a unit of measure\"\n                                        md-menu-class=\"autocomplete-custom-template\"\n                                    >\n                                        <md-item-template>\n                                            <span class=\"item-title\">{{uom.abbreviation}} - {{uom.description}}</span>\n                                        </md-item-template>\n                                        <md-not-found>\n                                            No matches found.\n                                        </md-not-found>\n                                    </md-autocomplete>\n                                    <!--<div ng-show=\"uomForm.autocompleteUom.$error.required || !preFilledUom || !preFilledUom.id\" class=\"errorMessage\">\n                                        Valid UOM not selected\n                                    </div>-->\n                                </ng-form>\n                            </div>\n\n\n                            <div ng-if=\"stage == 3\" class=\"content noPadding\">\n                                <md-table-container>\n                                    <table md-table>\n                                        <thead md-head>\n                                            <tr md-row>\n                                                <th md-column><span>Name</span></th>\n                                                <th md-column><span>Identifier</span></th>\n                                                <th md-column><span>Category</span></th>\n                                                <th md-column><span>Unit of Measure</span></th>\n                                            </tr>\n                                        </thead>\n                                        <tbody md-body>\n                                            <tr md-row md-select=\"xeroItem\" md-select-id=\"id\" ng-repeat=\"item in selectedItems\" ng-disabled=\"xeroSyncLoading\">\n                                                <td md-cell>\n                                                    <md-input-container>\n                                                        <input ng-model=\"item.name\" type=\"text\" required ng-change=\"validateFileCodeItem(fileCode)\">\n                                                    </md-input-container>\n                                                </td>\n                                                <td md-cell>\n                                                    <md-input-container>\n                                                        <input ng-model=\"item.identifier\" type=\"text\" required ng-change=\"validateAllResourceItems()\">\n                                                    </md-input-container>\n                                                </td>\n                                                <td md-cell>\n                                                    <ng-form name=\"categoryForm\">\n                                                        <md-autocomplete required md-input-name=\"autocompleteCategory\"\n                                                            ng-disabled=\"false\" md-no-cache=\"true\"\n                                                            md-selected-item=\"item.category\"\n                                                            md-search-text-change=\"searchCategoryChange(searchTextCategory)\"\n                                                            md-search-text=\"searchTextCategory\"\n                                                            md-selected-item-change=\"validateResourceItem(item)\"\n                                                            md-items=\"category in allResourceCategories\" md-item-text=\"category.name\"\n                                                            md-min-length=\"0\" placeholder=\"Search for a resource category\"\n                                                            md-menu-class=\"autocomplete-custom-template\"\n                                                        >\n                                                            <md-item-template>\n                                                                <span class=\"item-title\">{{category.name}}</span>\n                                                            </md-item-template>\n                                                            <md-not-found>\n                                                                No matches found.\n                                                            </md-not-found>\n                                                        </md-autocomplete>\n                                                        <div ng-show=\"categoryForm.autocompleteCategory.$error.required || !item.category || !item.category.id\" class=\"errorMessage\">\n                                                            Please select a valid category\n                                                        </div>\n                                                    </ng-form>\n                                                </td>\n                                                <td md-cell>\n                                                    <ng-form name=\"uomForm\">\n                                                        <md-autocomplete required md-input-name=\"autocompleteUom\"\n                                                            ng-disabled=\"false\" md-no-cache=\"true\"\n                                                            md-selected-item=\"item.uom\"\n                                                            md-search-text-change=\"searchUomChange(searchTextUom)\"\n                                                            md-search-text=\"searchTextUom\"\n                                                            md-selected-item-change=\"validateResourceItem(item)\"\n                                                            md-items=\"uom in allUoms\" md-item-text=\"uom.abbreviation\"\n                                                            md-min-length=\"0\" placeholder=\"Search for a unit of measure\"\n                                                            md-menu-class=\"autocomplete-custom-template\"\n                                                        >\n                                                            <md-item-template>\n                                                                <span class=\"item-title\">{{uom.abbreviation}} - {{uom.description}}</span>\n                                                            </md-item-template>\n                                                            <md-not-found>\n                                                                No matches found.\n                                                            </md-not-found>\n                                                        </md-autocomplete>\n                                                        <div ng-show=\"uomForm.autocompleteUom.$error.required || !item.uom || !item.uom.id\" class=\"errorMessage\">\n                                                            Please select a valid UOM\n                                                        </div>\n                                                    </ng-form>\n                                                </td>\n                                            </tr>\n                                        </tbody>\n                                    </table>\n                                </md-table-container>\n                            </div>\n                        </div>\n                    </md-tab-body>\n                </md-tab>\n                <md-tab label=\"From File\">\n                    <!--<ng-include src=\"'views/modals/importResourceFromFile.html'\"></ng-include>-->\n                    <div ng-show=\"fileStage == 1\">\n                        <form name=\"importResourcesForm\" novalidate>\n                            <div class=\"content\">\n                                Excel files only (.xls or .xlsx)\n                                <br/>\n                                <br/>\n                                <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n                            </div>\n                        </form>\n                    </div>\n                    <div ng-show=\"fileStage == 2\">\n                        <md-table-container>\n                            <table md-table md-row-select multiple ng-model=\"importSelected\" md-progress=\"importPromise\">\n                                <thead md-head>\n                                    <tr md-row>\n                                        <!--th md-column><span>Status</span></th-->\n                                        <th md-column><span>Name</span></th>\n                                        <th md-column><span>Identifier</span></th>\n                                        <th md-column><span>Category</span></th>\n                                        <th md-column><span>Unit of Measure</span></th>\n                                    </tr>\n                                </thead>\n                                <tbody md-body>\n                                    <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in importList\">\n                                        <!--td md-cell>\n                                            <div class=\"statusDisplay {{item.status == 'New' ? 'Completed' : 'Requested'}}\">{{item.status}}</div>\n                                        </td-->\n                                        <td md-cell>\n                                            <md-input-container>\n                                                <input ng-model=\"item.name\" type=\"text\" required ng-change=\"validateFileCodeItem(fileCode)\">\n                                            </md-input-container>\n                                        </td>\n                                        <td md-cell>\n                                            <md-input-container>\n                                                <input ng-model=\"item.identifier\" type=\"text\" required ng-change=\"validateAllResourceItems()\">\n                                            </md-input-container>\n                                        </td>\n                                        <td md-cell>\n                                            <ng-form name=\"categoryForm\">\n                                                <md-autocomplete required md-input-name=\"autocompleteCategory\"\n                                                    ng-disabled=\"false\" md-no-cache=\"true\"\n                                                    md-selected-item=\"item.category\"\n                                                    md-search-text-change=\"searchCategoryChange(searchTextCategory)\"\n                                                    md-search-text=\"searchTextCategory\"\n                                                    md-selected-item-change=\"validateResourceItem(item)\"\n                                                    md-items=\"category in allResourceCategories\" md-item-text=\"category.name\"\n                                                    md-min-length=\"0\" placeholder=\"Search for a resource category\"\n                                                    md-menu-class=\"autocomplete-custom-template\"\n                                                >\n                                                    <md-item-template>\n                                                        <span class=\"item-title\">{{category.name}}</span>\n                                                    </md-item-template>\n                                                    <md-not-found>\n                                                        No matches found.\n                                                    </md-not-found>\n                                                </md-autocomplete>\n                                                <div ng-show=\"categoryForm.autocompleteCategory.$error.required || !item.category || !item.category.id\" class=\"errorMessage\">\n                                                    Please select a valid category\n                                                </div>\n                                            </ng-form>\n                                        </td>\n                                        <td md-cell>\n                                            <ng-form name=\"uomForm\">\n                                                <md-autocomplete required md-input-name=\"autocompleteUom\"\n                                                    ng-disabled=\"false\" md-no-cache=\"true\"\n                                                    md-selected-item=\"item.uom\"\n                                                    md-search-text-change=\"searchUomChange(searchTextUom)\"\n                                                    md-search-text=\"searchTextUom\"\n                                                    md-selected-item-change=\"validateResourceItem(item)\"\n                                                    md-items=\"uom in allUoms\" md-item-text=\"uom.abbreviation\"\n                                                    md-min-length=\"0\" placeholder=\"Search for a unit of measure\"\n                                                    md-menu-class=\"autocomplete-custom-template\"\n                                                >\n                                                    <md-item-template>\n                                                        <span class=\"item-title\">{{uom.abbreviation}} - {{uom.description}}</span>\n                                                    </md-item-template>\n                                                    <md-not-found>\n                                                        No matches found.\n                                                    </md-not-found>\n                                                </md-autocomplete>\n                                                <div ng-show=\"uomForm.autocompleteUom.$error.required || !item.uom || !item.uom.id\" class=\"errorMessage\">\n                                                    Please select a valid UOM\n                                                </div>\n                                            </ng-form>\n                                        </td>\n                                        <td md-cell>\n                                            <md-button class=\"md-icon-button\" ng-click=\"removeResourceFromImport(item, importList)\" aria-label=\"Remove Resource From Import List\">\n                                                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                                            </md-button>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </md-table-container>\n                    </div>\n                </md-tab>\n            </md-tabs>\n        </div>\n\n\n        <div ng-if=\"!(currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled) || selectedTabIndex == 1\" class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\" ng-show=\"fileStage == 1\">\n                <div class=\"left\">\n                </div>\n                <div class=\"right\">\n                    <div class=\"dbButton white margin-right\" ng-click=\"close()\">\n                        Cancel\n                    </div>\n                    <div class=\"dbButton spinner\" ng-click=\"(importResourcesForm.$invalid || resourceImport.loading) || importFromFile(file)\" ng-disabled=\"importResourcesForm.$invalid || resourceImport.loading\">\n                        <span ng-hide=\"resourceImport.loading\">Next</span>\n                        <md-progress-circular ng-show=\"resourceImport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"tableLayoutHelperContainer\" ng-show=\"fileStage == 2\">\n                <div class=\"left\">\n                </div>\n                <div class=\"right\">\n                    <div ng-click=\"close()\" class=\"dbButton white margin-right\">\n                        Cancel\n                    </div>\n                    <div ng-click=\"bulkImportResources()\" class=\"dbButton spinner\" ng-disabled=\"!fileFormValid()\">\n                        <span ng-hide=\"resourceImport.loading\">Import</span>\n                        <md-progress-circular ng-show=\"resourceImport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled && selectedTabIndex == 0\" class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                    <div ng-if=\"stage == 1\" class=\"dbButton\" ng-click=\"xeroSyncLoading == false && reSyncXeroResources()\" ng-disabled=\"xeroSyncLoading\">\n                        Sync Xero Items\n                    </div>\n                </div>\n                <div class=\"right\">\n                    <div ng-if=\"stage == 1\" class=\"dbButton white margin-right\" ng-click=\"close()\">\n                        Cancel\n                    </div>\n                    <div ng-if=\"stage == 1\" class=\"dbButton\" ng-click=\"selectedItems.length > 0 && goToStage2()\" ng-disabled=\"selectedItems.length == 0\">\n                        Next\n                    </div>\n\n                    <div ng-if=\"stage >= 2\" class=\"dbButton white margin-right\" ng-click=\"back()\">\n                        Back\n                    </div>\n                    <div ng-if=\"stage == 2\" class=\"dbButton margin-right\" ng-click=\"goToStage3(true)\">\n                        Skip\n                    </div>\n                    <div ng-if=\"stage == 2\" class=\"dbButton\" ng-click=\"(prefilled.category != null || prefilled.uom != null) && goToStage3(false)\" ng-disabled=\"prefilled.category == null && prefilled.uom == null\">\n                        Next\n                    </div>\n\n                    <div ng-if=\"stage == 3\" class=\"dbButton\" ng-click=\"formValid() && !importing && import()\" ng-disabled=\"!formValid() || importing || selectedContacts.length == 0\">\n                        <md-progress-circular class=\"margin-right\" ng-show=\"importing\" class=\"md-hue-2\" md-diameter=\"16px\"></md-progress-circular>\n                        Import\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Io/4":
/***/ (function(module, exports) {

var path = 'views/mainNav.html';
var html = "<!-- Desktop only navigation - horizontally aligned -->\n<div class=\"navSplitContainer\">\n  <div class=\"layoutBox flex1\">\n    <div class=\"navHeading\" ng-if=\"currentOrgGroup != null\">\n      <div class=\"navHeading withButton\">\n        <div class=\"left\">{{currentOrgGroup.name}}</div>\n        <div class=\"navSettingsButton\" ui-sref=\"companySettings.general({orgId:currentOrg.id})\" ng-if=\"currentOrgGroup.parent == null && userCanDoAction('viewCompanySettings')\"><md-icon md-svg-src=\"companysettings.svg\"></md-icon></div>\n        <div class=\"navSettingsButton\" ui-sref=\"groupSettings.general({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrgGroup.parent != null && userCanDoAction('viewGroupSettings')\"><md-icon md-svg-src=\"companysettings.svg\"></md-icon></div>\n      </div>\n    </div>\n    <div class=\"navHeading\" ng-if=\"currentOrgGroup == null && myDocketbook != true\">Home</div>\n    <div class=\"navHeading\" ng-if=\"currentOrgGroup == null && myDocketbook == true\">My Docketbook</div>\n    <ul class=\"hidden-xs desktop\">\n      <a ui-sref=\"main.groupDashboard({orgId: currentOrg.id, groupId: currentOrgGroup.id})\" ng-if=\"currentOrg != null\" class=\"main\">\n        <li class=\"{{currentState.data.mainnavOption == 'dashboard' ? 'selected' : ''}}\">\n          <!--<md-icon md-svg-src=\"dashboard.svg\"></md-icon>-->\n          Dashboard\n        </li>\n      </a>\n      <a ui-sref=\"main.dockets\" ng-if=\"myDocketbook == true\" class=\"main\">\n        <li class=\"{{currentState.data.mainnavOption == 'dockets' ? 'selected' : ''}}\">\n          <!--<md-icon md-svg-src=\"description.svg\"></md-icon>-->\n          My Dockets\n        </li>\n      </a>\n      <a ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg != null && ( userHasPermission('io.docketbook.ojdapi.getDocket') || userHasPermission('io.docketbook.ojdapi.getMyDocket') )\" class=\"main\">\n        <li class=\"{{currentState.data.mainnavOption == 'dockets' ? 'selected' : ''}}\">\n          <!--<md-icon md-svg-src=\"description.svg\"></md-icon>-->\n          Dockets\n        </li>\n      </a>\n      <a ui-sref=\"main.orders\" ng-if=\"myDocketbook == true\" class=\"main\">\n        <li class=\"{{currentState.data.mainnavOption == 'orders' ? 'selected' : ''}}\">\n          <!--<md-icon md-svg-src=\"folder.svg\"></md-icon>-->\n          My Orders\n        </li>\n      </a>\n      <span ng-if=\"currentOrg != null && userHasPermission('io.docketbook.ojdapi.getOrder')\">\n        <a ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg.planFeatures.ordersEnabled == true\" class=\"main\">\n          <li class=\"{{currentState.data.mainnavOption == 'orders' ? 'selected' : ''}}\">\n            <!--<md-icon md-svg-src=\"folder.svg\"></md-icon>-->\n            Orders\n          </li>\n        </a>\n        <a ng-if=\"!(currentOrg.planFeatures.ordersEnabled == true)\" class=\"main\">\n          <li class=\"disabledNavButton\">\n            Orders\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </li>\n        </a>\n      </span>\n      <a ui-sref=\"main.jobs\" ng-if=\"myDocketbook == true\" class=\"main\">\n        <li class=\"{{currentState.data.mainnavOption == 'jobs' ? 'selected' : ''}}\">\n          <!--<md-icon md-svg-src=\"job.svg\"></md-icon>-->\n          My Jobs\n        </li>\n      </a>\n      <span ng-if=\"currentOrg != null && ( userHasPermission('io.docketbook.ojdapi.getJob') || userHasPermission('io.docketbook.ojdapi.getMyJob') )\">\n        <a ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg.planFeatures.jobsEnabled == true\" class=\"main\">\n          <li class=\"{{currentState.data.mainnavOption == 'jobs' ? 'selected' : ''}}\">\n            <!--<md-icon md-svg-src=\"job.svg\"></md-icon>-->\n            Jobs\n          </li>\n        </a>\n        <a ng-if=\"currentOrg.planFeatures.jobsEnabled != true\" class=\"main\">\n          <li class=\"disabledNavButton\">\n            Jobs\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </li>\n        </a>\n      </span>\n      <span ng-if=\"currentOrgGroup != null && currentOrg != null\">\n        <a ui-sref=\"main.groupTimesheets({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg.planFeatures.docketsTimesheetsView == true\" class=\"main\">\n          <li class=\"{{currentState.data.mainnavOption == 'timesheets' ? 'selected' : ''}}\">\n            <!--<md-icon md-svg-src=\"calendar2.svg\"></md-icon>-->\n            Timesheets\n          </li>\n        </a>\n        <a ng-if=\"currentOrg.planFeatures.docketsTimesheetsView != true\" class=\"main\">\n          <li class=\"disabledNavButton\">\n            Timesheets\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </li>\n        </a>\n      </span>\n      <a ui-sref=\"main.groupContacts({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrgGroup != null && ( userHasPermission('io.docketbook.uoapi.getAddressBook') )\" class=\"main\">\n        <li class=\"{{currentState.data.mainnavOption == 'contacts' ? 'selected' : ''}}\">\n          <!--<md-icon md-svg-src=\"account.svg\"></md-icon>-->\n          Contacts\n        </li>\n      </a>\n      <!--<a ui-sref=\"admin.dashboard({orgId:currentOrg.id})\" class=\"main\" ng-if=\"currentOrg != null && userHasPermission('io.docketbook.uoapi.viewOrganisationSettings')\">\n        <li class=\"{{currentState.data.mainnavOption == 'admin' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"_settings.svg\"></md-icon>\n          Settings\n        </li>\n      </a>-->\n    </ul>\n  </div>\n  <div class=\"layoutBox\">\n    <ul class=\"hidden-xs desktop\">\n\n      <!--<a href=\"#/user/account\" class=\"main\">\n        <li class=\"{{currentState.data.mainnavOption == 'user' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"account.svg\"></md-icon>\n          Account\n        </li>\n      </a>-->\n\n      <a href=\"https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us\" target=\"_blank\">\n        <li class=\"\">\n          <md-icon md-svg-src=\"help.svg\"></md-icon>\n          Help\n        </li>\n      </a>\n    </ul>\n  </div>\n</div>\n<!-- End Desktop only navigation -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "IvK/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "custom-section.svg";

/***/ }),

/***/ "IvMQ":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/nav.html';
var html = "<div class=\"navSplitContainer companySettings\">\n  <div class=\"layoutBox flex1\">\n    <div class=\"settingsNavHeading\">\n      Company Settings\n    </div>\n    <ul class=\"hidden-xs desktop\">\n      <a ui-sref=\"companySettings.general({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'general' ? 'selected' : ''}}\">\n          Overview\n        </li>\n      </a>\n      <a ng-if=\"!sampleCompany\" ui-sref=\"companySettings.billing({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'billing' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"credit-card.svg\"></md-icon>\n          Plan Details & Billing\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.groups({orgId: currentOrg.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'groups' ? 'selected' : ''}}\">\n          Groups\n          <!--span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.includedOrganisationGroups != 0 && currentOrg.planFeatures.includedOrganisationGroups <= 1\">\n            <md-icon style=\"display: inline-block;\" md-svg-src=\"padlock.svg\"></md-icon>\n          </span-->\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.users({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'users' ? 'selected' : ''}}\">\n          Users\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.roles({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'roles' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"roles.svg\"></md-icon>\n          Roles\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.templates({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'templates' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"templatedesigner.svg\"></md-icon>\n          Docket Templates\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.fields({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'fields' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"fields.svg\"></md-icon>\n          Fields\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.checklists({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'checklists' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"checklist.svg\"></md-icon>\n          Checklists\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.resources({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'resources' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"truck.svg\"></md-icon>\n          Resources\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.addressBookTags({orgId: currentOrg.id})\" class=\"main\" ng-show=\"canViewOrgSettings\">\n        <li class=\"{{currentState.data.subnavOption == 'tags' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"unit.svg\"></md-icon>\n          Contact Tags\n        </li>\n      </a>\n      <div class=\"navBreakLine\"></div>\n      <a href=\"https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us\" target=\"_blank\" class=\"main\">\n        <li class=\"\">\n          <md-icon md-svg-src=\"help.svg\"></md-icon>\n          Help\n        </li>\n      </a>\n      <!--\n      <a ui-sref=\"companySettings.members({orgId: currentOrg.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'members' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"user-group.svg\"></md-icon>\n          Members\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.admins({orgId: currentOrg.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'admins' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"admin-user.svg\"></md-icon>\n          Administrators\n        </li>\n      </a>\n      <a ui-sref=\"companySettings.monitors({orgId: currentOrg.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'monitors' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"eye.svg\"></md-icon>\n          Monitors\n        </li>\n      </a>\n      -->\n    </ul>\n  </div>\n</div>\n\n\n\n<!--\n<ul>\n  <a ui-sref=\"admin.dashboard({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.uoapi.getOrganisation')\">\n    <li class=\"{{currentState.data.subnavOption == 'general' ? 'selected' : ''}}\">General</li>\n  </a>\n  <a ui-sref=\"admin.billing({orgId:currentOrg.id})\" ng-if=\"userHasPermission('global-administrator')\">\n    <li class=\"{{currentState.data.subnavOption == 'billing' ? 'selected' : ''}}\">Billing</li>\n  </a>\n  <a ui-sref=\"admin.roles({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.uoapi.getOrganisationGroup')\">\n    <li class=\"{{currentState.data.subnavOption == 'roles' ? 'selected' : ''}}\">Roles</li>\n  </a>\n  <div class=\"listSpacer\"></div>\n  <a ui-sref=\"admin.templates({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.ojdapi.getTemplate')\">\n    <li class=\"{{currentState.data.subnavOption == 'templates' ? 'selected' : ''}}\">Docket Templates</li>\n  </a>\n  <a ui-sref=\"admin.fields({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.ojdapi.getField')\">\n    <li class=\"{{currentState.data.subnavOption == 'fields' ? 'selected' : ''}}\">Fields</li>\n  </a>\n  <a ui-sref=\"admin.checklists({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.ojdapi.getChecklist')\">\n    <li class=\"{{currentState.data.subnavOption == 'checklists' ? 'selected' : ''}}\">Checklists</li>\n  </a>\n  <a ui-sref=\"admin.filing({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.uoapi.getFileCodes')\">\n    <li class=\"{{currentState.data.subnavOption == 'filing' ? 'selected' : ''}}\">File Codes</li>\n  </a>\n  <div class=\"listSpacer\"></div>\n  <a ui-sref=\"admin.resources({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.rsapi.getResource')\">\n    <li class=\"{{currentState.data.subnavOption == 'resources' ? 'selected' : ''}}\">Resources</li>\n  </a>\n  <a ui-sref=\"admin.resourceCategories({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.rsapi.getCategory')\">\n    <li class=\"{{currentState.data.subnavOption == 'categories' ? 'selected' : ''}}\">Resource Categories</li>\n  </a>\n  <a ui-sref=\"admin.uoms({orgId:currentOrg.id})\" ng-if=\"userHasPermission('io.docketbook.rsapi.getUom')\">\n    <li class=\"{{currentState.data.subnavOption == 'uoms' ? 'selected' : ''}}\">Units of Measure</li>\n  </a>\n</ul>\n-->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "JQ6r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('filingDetailController', ['docketService', 'orderService', 'jobService', 'resourceService', 'userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$q', '$timeout', 'scroll', 'geolocation', function (docketService, orderService, jobService, resourceService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $q, $timeout, scroll, geolocation) {
  // Main Variables For Doing Stuff
  $scope.moment = _momentTimezone2.default;
  $scope.docketsFiling = null;
  $scope.filingMode = null;

  // Base Access Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentTab = "General";
  $scope.docketLoadingError = null;
  $scope.singleUom = false;
  $scope.singleUomAbbreviation = '';
  $scope.totalAmount = 0;

  $scope.userCanDoAction = userService.userCanDoAction;

  // Include responsive utilities and UI Functionality
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.currentActiveTab = function () {
    return $scope.currentTab;
  };

  $scope.$parent.prepareForFilingFromParent = function () {
    $scope.docketFiling = {};
    $scope.docketFiling.loading = true;
    $scope.docketFiling.loadingType = 'getting';
    $scope.docketLoadingError = null;
  };

  $scope.$parent.loadingErrorFromParent = function (err) {
    $scope.docketLoadingError = err;
    $scope.docketFiling.loading = false;
  };

  $scope.splitQuantityUpdated = function (activity) {
    activity.splitPercentage = parseFloat((activity.splitQuantity / $scope.totalAmount * 100).toFixed(4));
    activity.splitPercentage_display = parseFloat(activity.splitPercentage.toFixed(2));
  };

  $scope.splitPercentageUpdated = function (activity) {

    if (activity.splitPercentage.toFixed(2) == activity.splitPercentage_display.toFixed(2)) {
      return;
    }

    activity.splitPercentage = activity.splitPercentage_display;
    activity.splitQuantity = parseFloat(($scope.totalAmount * activity.splitPercentage / 100).toFixed(2));
  };

  $scope.splitQuantityBlur = function (activity) {
    activity.splitQuantity = parseFloat(parseFloat(activity.splitQuantity).toFixed(2));
    $scope.splitQuantityUpdated(activity);
  };

  $scope.totalPercentage = function () {
    if ($scope.docketFiling == null || $scope.docketFiling.activityCodes == null) {
      return 0;
    }

    return $scope.docketFiling.activityCodes.map(function (x) {
      return Number.parseFloat(x.splitPercentage);
    }).reduce(function (a, b) {
      return a + b;
    }, 0).toFixed(2);
  };

  $scope.totalQuantity = function () {
    if ($scope.docketFiling == null || $scope.docketFiling.activityCodes == null) {
      return 0;
    }

    return $scope.docketFiling.activityCodes.map(function (x) {
      return Number.parseFloat(x.splitQuantity);
    }).reduce(function (a, b) {
      return a + b;
    }, 0).toFixed(2);
  };

  $scope.$parent.loadBulkDocketsFromParent = function (dockets) {
    $scope.docketFiling.dockets = dockets;
    $scope.docketLoadingError = null;

    var uomTypes = _.flatten(dockets.map(function (docket) {
      return docket.resources;
    })).map(function (resource) {
      return resource.resource.uom;
    });
    $scope.singleUom = _.uniq(uomTypes.map(function (uom) {
      return uom.id;
    })).length == 1;
    if ($scope.singleUom) {
      $scope.singleUomAbbreviation = uomTypes[0].abbreviation;
    }

    var fullResourcesSummary = {};
    // generate resource and line summary
    for (var i = 0; i < dockets.length; i++) {
      var linesSummary = [];
      for (var j = 0; j < dockets[i].resources.length; j++) {
        var resourceId = dockets[i].resources[j].resource.id;
        if (fullResourcesSummary[resourceId] == null) {
          var resourceSummary = {};
          resourceSummary.interactions = {};
          resourceSummary.resource = dockets[i].resources[j].resource;
          fullResourcesSummary[resourceId] = resourceSummary;
        }
        for (var k = 0; k < dockets[i].resources[j].interactions.length; k++) {
          var childResource = dockets[i].resources[j].interactions[k].resource;
          var quantity = dockets[i].resources[j].interactions[k].quantity;
          var interaction = dockets[i].resources[j].interactions[k];
          var lineSummary = {};
          lineSummary.resource = childResource;
          lineSummary.quantity = quantity;
          lineSummary.interaction = interaction;
          lineSummary.activityCodes = [];
          // get activityCode for line
          if (dockets[i].existingDocketFile && dockets[i].existingDocketFile.fileMethod == 'lines' && dockets[i].existingDocketFile.lineCodes) {
            var lineCodes = dockets[i].existingDocketFile.lineCodes;
            for (var l = 0; l < lineCodes.length; l++) {
              if (lineCodes[k].interaction.id == lineSummary.interaction.id) {
                // got the right line code = now get the populated file code
                if (lineCodes[k].populatedFileCodes) {
                  for (var fc = 0; fc < lineCodes[k].populatedFileCodes.length; fc++) {
                    var newActivityCode = lineCodes[k].populatedFileCodes[fc];
                    newActivityCode.percentage_display = parseFloat(newActivityCode.percentage.toFixed(2));
                    newActivityCode.quantity = parseFloat((lineSummary.interaction.quantity * newActivityCode.percentage / 100).toFixed(2));

                    lineSummary.activityCodes.push(newActivityCode);
                  }
                }
                break;
              }
            }
          }

          if (lineSummary.activityCodes == null || lineSummary.activityCodes.length == 0) {
            lineSummary.activityCodes = [{
              percentage: 100,
              percentage_display: 100,
              quantity: quantity
            }];
          }

          linesSummary.push(lineSummary);
          if (fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] == null) {
            var interactionSummary = {};
            interactionSummary.interaction = interaction;
            interactionSummary.quantity = quantity;
            fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] = interactionSummary;
          } else {
            fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id].quantity += quantity;
          }
        }
      }
      if (dockets[i].existingDocketFile && dockets[i].existingDocketFile.fileMethod == 'split') {
        if (dockets[i].existingDocketFile.lineCodes && dockets[i].existingDocketFile.lineCodes[0] && dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes) {
          var fileCodes = [];
          for (var j = 0; j < dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes.length; j++) {
            var thisCode = dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes[j].fileCode;
            thisCode.splitPercentage = dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes[j].percentage;
            thisCode.splitPercentage_display = parseFloat(thisCode.splitPercentage.toFixed(2));
            fileCodes.push(thisCode);
          }
          dockets[i].fileCodes = fileCodes;
        }
      }
      dockets[i].linesSummary = linesSummary;
      // TODO: generate resource summary for docket
    }

    // convert resources summary to array
    var fullLinesSummary = [];
    var keys = Object.keys(fullResourcesSummary);
    for (var i = 0; i < keys.length; i++) {
      var interactionKeys = Object.keys(fullResourcesSummary[keys[i]].interactions);
      for (var j = 0; j < interactionKeys.length; j++) {
        var lineSummary = {};
        lineSummary.resource = fullResourcesSummary[keys[i]].resource;
        lineSummary.interaction = fullResourcesSummary[keys[i]].interactions[interactionKeys[j]].interaction;
        lineSummary.quantity = fullResourcesSummary[keys[i]].interactions[interactionKeys[j]].quantity;
        lineSummary.activityCodes = [{
          percentage: 100,
          percentage_display: 100,
          quantity: lineSummary.quantity
        }];
        fullLinesSummary.push(lineSummary);
      }
    }
    $scope.docketFiling.linesSummary = fullLinesSummary;

    if (dockets.length == 1) {
      // No existing file code for the selected docket - prefill lines summary
      var linesSummary = [];
      for (var i = 0; i < dockets[0].resources.length; i++) {
        for (var j = 0; j < dockets[0].resources[i].interactions.length; j++) {
          var childResource = dockets[0].resources[i].interactions[j].resource;
          var quantity = dockets[0].resources[i].interactions[j].quantity;
          var interaction = dockets[0].resources[i].interactions[j];
          var lineSummary = {};
          lineSummary.resource = childResource;
          lineSummary.quantity = quantity;
          lineSummary.interaction = interaction;
          //lineSummary.activityCode = null;
          linesSummary.push(lineSummary);
        }
      }
      $scope.docketFiling.linesSummary = linesSummary;

      // generate resource summary for docket
      var resourceSummary = {};
      for (var i = 0; i < dockets[0].resources.length; i++) {
        for (var j = 0; j < dockets[0].resources[i].interactions.length; j++) {
          var thisInteraction = dockets[0].resources[i].interactions[j];
          var thisResource = dockets[0].resources[i].interactions[j].resource;
          if (resourceSummary[thisResource.id]) {
            resourceSummary[thisResource.id].totalQuantity += thisInteraction.quantity;
          } else {
            resourceSummary[thisResource.id] = { resource: thisResource, totalQuantity: thisInteraction.quantity };
          }
        }
      }
      // convert to array
      var resourceSummaryList = [];
      var keys = Object.keys(resourceSummary);
      for (var i = 0; i < keys.length; i++) {
        resourceSummaryList.push(resourceSummary[keys[i]]);
      }
      $scope.docketFiling.resourceSummary = resourceSummaryList;
      $scope.docketFiling.dockets[0].detailOpen = true;
    }

    if (dockets.length == 1 && dockets[0].existingDocketFile) {
      $scope.docketFiling.filed = true;
      $scope.docketFiling.method = dockets[0].existingDocketFile.fileMethod;

      if ($scope.docketFiling.method == 'split') {
        if (dockets[0].existingDocketFile.lineCodes && dockets[0].existingDocketFile.lineCodes.length > 0) {
          var activityCodes = [];
          if (dockets[0].existingDocketFile.lineCodes[0].populatedFileCodes) {
            var fileCodesList = dockets[0].existingDocketFile.lineCodes[0].populatedFileCodes;
            for (var i = 0; i < fileCodesList.length; i++) {
              var code = fileCodesList[i].fileCode;
              var splitPercentage = fileCodesList[i].percentage;
              var newActivity = { fileCode: code, splitPercentage: splitPercentage, splitPercentage_display: parseFloat(splitPercentage.toFixed(2)) };
              activityCodes.push(newActivity);
            }
          }
          $scope.docketFiling.activityCodes = activityCodes;
        }
      } else if ($scope.docketFiling.method == 'lines') {
        if (dockets[0].existingDocketFile.lineCodes && dockets[0].existingDocketFile.lineCodes.length > 0) {
          var linesSummary = [];
          for (var i = 0; i < dockets[0].resources.length; i++) {
            for (var j = 0; j < dockets[0].resources[i].interactions.length; j++) {
              var childResource = dockets[0].resources[i].interactions[j].resource;
              var quantity = dockets[0].resources[i].interactions[j].quantity;
              var interaction = dockets[0].resources[i].interactions[j];
              var lineSummary = {};
              lineSummary.resource = childResource;
              lineSummary.quantity = quantity;
              lineSummary.interaction = interaction;
              lineSummary.activityCodes = [];
              // find existing activity code
              for (var k = 0; k < dockets[0].existingDocketFile.lineCodes.length; k++) {
                if (dockets[0].existingDocketFile.lineCodes[k].interaction.id == lineSummary.interaction.id) {

                  if (lineCodes[k].populatedFileCodes) {
                    for (var fc = 0; fc < lineCodes[k].populatedFileCodes.length; fc++) {
                      var newActivityCode = lineCodes[k].populatedFileCodes[fc];
                      newActivityCode.percentage_display = parseFloat(newActivityCode.percentage.toFixed(2));
                      newActivityCode.quantity = parseFloat((lineSummary.interaction.quantity * newActivityCode.percentage / 100).toFixed(2));

                      lineSummary.activityCodes.push(newActivityCode);
                    }
                  }
                  break;
                }
              }

              if (lineSummary.activityCodes == null || lineSummary.activityCodes.length == 0) {
                lineSummary.activityCodes = [{
                  percentage: 100,
                  percentage_display: 100,
                  quantity: quantity
                }];
              }

              linesSummary.push(lineSummary);
            }
          }
          $scope.docketFiling.linesSummary = linesSummary;
        }
      }
    } else {
      $scope.docketFiling.filed = false;
      $scope.docketFiling.method = null;
    }

    $scope.totalAmount = $scope.docketFiling.linesSummary.map(function (line) {
      return line.quantity;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);

    $scope.docketFiling.method = 'split';
    $scope.addSplitFileCodeDesktop();

    $scope.docketFiling.activityCodes.forEach($scope.splitPercentageUpdated);

    $scope.docketFiling.loading = false;
  };

  $scope.$parent.clearDocketFilingFromParent = function () {
    $scope.docketFiling = null;
  };

  /*****************************/
  /***** Main UI Functions *****/
  /*****************************/

  $scope.changeFileMethod = function (method, docketFiling) {
    if (method == 'split') {
      docketFiling.method = 'split';
      if (docketFiling.activityCodes == null || docketFiling.activityCodes.length <= 0) {
        $scope.addSplitFileCode();
      }
    } else {
      docketFiling.method = method;
    }
  };

  $scope.changeFileMethodDesktop = function (method, docketFiling) {
    if (method == 'split') {
      $scope.addSplitFileCodeDesktop();
    }
    docketFiling.method = method;
  };

  $scope.addSplitFileCode = function () {
    if ($scope.docketFiling.activityCodes == null) {
      $scope.docketFiling.activityCodes = [];
    }

    $scope.$parent.selectActivityForDocketFile(null, function (activity) {
      if (activity != null) {
        var totalPercentage = 0;
        for (var i = 0; i < $scope.docketFiling.activityCodes.length; i++) {
          if ($scope.docketFiling.activityCodes[i].splitPercentage) {
            totalPercentage += $scope.docketFiling.activityCodes[i].splitPercentage;
          }
        }

        var remainingPercentage = 0;
        if (totalPercentage < 100) {
          remainingPercentage = parseFloat(100 - totalPercentage);
        }

        var splitQuantity = parseFloat($scope.totalAmount * remainingPercentage / 100);
        $scope.docketFiling.activityCodes.push({ splitPercentage: remainingPercentage, splitPercentage_display: parseFloat(remainingPercentage.toFixed(2)), fileCode: activity, splitQuantity: splitQuantity });
      }
    });
  };

  $scope.addSplitFileCodeDesktop = function () {
    if ($scope.docketFiling.activityCodes == null) {
      $scope.docketFiling.activityCodes = [];
    }

    var totalPercentage = 0;
    for (var i = 0; i < $scope.docketFiling.activityCodes.length; i++) {
      if ($scope.docketFiling.activityCodes[i].splitPercentage) {
        totalPercentage += Number.parseFloat($scope.docketFiling.activityCodes[i].splitPercentage);
      }
    }

    var remainingPercentage = 0;
    if (totalPercentage < 100) {
      remainingPercentage = parseFloat((100 - totalPercentage).toFixed(2));
    }

    var splitQuantity = parseFloat(($scope.totalAmount * remainingPercentage / 100).toFixed(2));
    $scope.docketFiling.activityCodes.push({ splitPercentage: remainingPercentage, splitPercentage_display: parseFloat(remainingPercentage.toFixed(2)), fileCode: null, splitQuantity: splitQuantity });
  };

  $scope.removeSplitFileCode = function (activityCode) {
    var index = $scope.docketFiling.activityCodes.indexOf(activityCode);
    if (index != -1) {
      $scope.docketFiling.activityCodes.splice(index, 1);
    }
  };

  $scope.selectActivityForLine = function (docketFiling, line) {
    var existing = [];
    if (line.activityCode != null) {
      existing.push(line.activityCode);
    }
    $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
      if (activity != null) {
        line.activityCode = activity;
      }
    });
  };

  $scope.selectActivityForSplit = function (docketFiling, activityCode) {
    // get list of used file codes
    var existing = [];
    if (docketFiling.activityCodes != null) {
      for (var i = 0; i < docketFiling.activityCodes.length; i++) {
        if (docketFiling.activityCodes[i].fileCode != null) {
          existing.push(docketFiling.activityCodes[i].fileCode);
        }
      }
    }
    $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
      if (activity != null) {
        activityCode.fileCode = activity;
      }
    });
  };

  $scope.searchFileCodes = function (searchText) {
    return $q(function (resolve, reject) {
      var params = {};
      if (searchText != null) {
        if (searchText != "") {
          params.search = searchText;
        } else {
          resolve([]);
          return;
        }
      }
      docketService.getFileCodes(params, function (fileCodes) {
        resolve(fileCodes);
      }, function (err) {
        reject("err");
      });
    });
  };

  /****************************/
  /***** UI Functionality *****/
  /****************************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /***********************************/
  /***** Alert Parent Controller *****/
  /***********************************/

  $scope.$parent.filingDetailControllerReady();

  $scope.activityCodePercentageUpdated = function (line, activityCode, index) {
    activityCode.percentage = activityCode.percentage_display;
    activityCode.quantity = parseFloat((line.quantity * activityCode.percentage / 100).toFixed(2));

    if (line.activityCodes.length == 2) {
      var otherActivityCode = line.activityCodes[index == 0 ? 1 : 0];
      otherActivityCode.percentage = 100 - activityCode.percentage;
      otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2));
      otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2));
    }
  };

  $scope.activityCodeQuantityUpdated = function (line, activityCode, index) {
    activityCode.percentage = parseFloat((activityCode.quantity / line.quantity * 100).toFixed(4));
    activityCode.percentage_display = parseFloat(activityCode.percentage.toFixed(2));

    if (line.activityCodes.length == 2) {
      var otherActivityCode = line.activityCodes[index == 0 ? 1 : 0];
      otherActivityCode.percentage = 100 - activityCode.percentage;
      otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2));
      otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2));
    }
  };

  $scope.getLineTotalPercent = function (line) {
    return line.activityCodes.map(function (activityCode) {
      return activityCode.percentage;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  };

  $scope.splitLineFiling = function (line) {
    var remainingPercent = 100 - $scope.getLineTotalPercent(line);

    line.activityCodes.push({
      percentage: remainingPercent,
      percentage_display: parseFloat(remainingPercent.toFixed(2)),
      quantity: parseFloat((line.quantity * remainingPercent / 100).toFixed(2))
    });
  };

  $scope.removeSplitLineFiling = function (line, index) {
    line.activityCodes.splice(index, 1);
    if (line.activityCodes.length == 1) {
      line.activityCodes[0].percentage = 100;
    }
  };
}]);

/***/ }),

/***/ "Jvkl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eye.svg";

/***/ }),

/***/ "K4Wd":
/***/ (function(module, exports) {

var path = 'views/modals/shareJobModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"shareJobModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Share Job</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeAccessControlModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeAccessControlModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n              Share Job\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"saveAccessControlEdit(accessControlEdit)\">Save</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"\" novalidate>\n        <div class=\"modalFormMobileHeader\">\n          <div class=\"row1\">\n            <div class=\"to\">\n              <strong>To:</strong>\n            </div>\n            <div class=\"email\">\n              <input type=\"text\" placeholder=\"Email or Phone Number\" ng-model=\"newAccessor.emailAddress\">\n            </div>\n            <div class=\"selector\">\n              <md-button class=\"md-icon-button\" ng-click=\"selectAccessorContact()\" aria-label=\"Select Person\">\n                <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"row1\">\n            <div class=\"to\">\n              <strong>Role:</strong>\n            </div>\n            <div class=\"select\">\n              <md-select ng-model=\"newAccessor.accessLevel\" aria-label=\"Select access level\">\n                <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(newAccessor, 'viewer')\">\n                  Viewer\n                </md-option>\n                <md-option value=\"forwarder\" ng-show=\"canSetAccessLevel(newAccessor, 'forwarder')\">\n                  Forwarder\n                </md-option>\n                <md-option value=\"editor\" ng-show=\"canSetAccessLevel(newAccessor,'editor')\">\n                  Editor\n                </md-option>\n              </md-select>\n            </div>\n          </div>\n          <div class=\"row1\">\n            <div class=\"add\">\n              <div class=\"dbButton lightBlue\" ng-click=\"(newAccessor.emailAddress == '' || newAccessor.emailAddress == null) || addNewAccessor(newAccessor)\" ng-disabled=\"newAccessor.emailAddress == '' || newAccessor.emailAddress == null\">\n                Add\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modalFormTableHeader slimline\">\n          <div class=\"to\">\n            <strong>To:</strong>\n          </div>\n          <div class=\"email\">\n            <input type=\"text\" placeholder=\"Email or Phone Number\" ng-model=\"newAccessor.emailAddress\">\n          </div>\n          <div class=\"selector\">\n            <md-button class=\"md-icon-button\" ng-click=\"selectAccessorContact()\" aria-label=\"Select Person\">\n              <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n            </md-button>\n          </div>\n          <div class=\"select\">\n            <md-select ng-model=\"newAccessor.accessLevel\" aria-label=\"Select access level\">\n              <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(newAccessor, 'viewer')\">\n                Viewer\n              </md-option>\n              <md-option value=\"forwarder\" ng-show=\"canSetAccessLevel(newAccessor, 'forwarder')\">\n                Forwarder\n              </md-option>\n              <md-option value=\"editor\" ng-show=\"canSetAccessLevel(newAccessor,'editor')\">\n                Editor\n              </md-option>\n            </md-select>\n          </div>\n          <div class=\"add\">\n            <div class=\"dbButton lightBlue\" ng-click=\"(newAccessor.emailAddress == '' || newAccessor.emailAddress == null) || addNewAccessor(newAccessor)\" ng-disabled=\"newAccessor.emailAddress == '' || newAccessor.emailAddress == null\">\n              Add\n            </div>\n          </div>\n        </div>\n        <div class=\"modalFormTable\">\n          <md-table-container>\n            <table md-table ng-show=\"accessControlEdit.accessControl.length > 0\">\n              <tbody md-body ng-repeat=\"accessor in accessControlEdit.accessControl\">\n                <form name=\"innerForm\">\n                  <tr md-row class=\"{{accessor.accessLevel=='remove'?'disabled remove':''}}\">\n                    <td md-cell>\n                      {{accessor.emailAddress}}\n                    </td>\n                    <td md-cell>\n                      <md-select ng-model=\"accessor.accessLevel\" ng-disabled=\"accessor.accessLevelSet || accessor.isSupplier || accessor.isUser || !canChangeAccessLevel(accessor)\">\n                        <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(accessor, 'viewer')\">\n                          Viewer\n                        </md-option>\n                        <md-option value=\"assignee\" ng-show=\"canSetAccessLevel(accessor, 'assignee')\">\n                          Assignee\n                        </md-option>\n                        <md-option value=\"forwarder\" ng-show=\"canSetAccessLevel(accessor, 'forwarder')\">\n                          Forwarder\n                        </md-option>\n                        <md-option value=\"editor\" ng-show=\"canSetAccessLevel(accessor,'editor')\">\n                          Editor\n                        </md-option>\n                        <md-option value=\"remove\" ng-show=\"canSetAccessLevel(accessor,'remove')\">\n                          Remove\n                        </md-option>\n                      </md-select>\n                    </td>\n                  </tr>\n                </form>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeAccessControlModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"accessControlEdit.loading || saveAccessControlEdit(accessControlEdit)\" ng-disabled=\"accessControlEdit.loading\">\n            <span ng-hide=\"accessControlEdit.loading\">Save</span>\n            <md-progress-circular ng-show=\"accessControlEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "KM5U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('companySettingsUsersController', ['userService', '$scope', 'Restangular', '$state', '$stateParams', '$q', 'accessControl', 'Upload', function (userService, $scope, Restangular, $state, $stateParams, $q, accessControl, Upload) {
  mixpanel.track("Opened CompanySettings-Users Desktop");
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentState = $state.current;
  $scope.logoLoading = false;
  $scope.allTimeFormats = ['12HR', '24HR'];
  $scope.timeFormatDisplay = { '12HR': '12 Hour Time', '24HR': '24 Hour Time' };

  $scope.includedUsers;

  $scope.allUsers = [];
  $scope.activeUsers = [];
  $scope.invitedUsers = [];
  $scope.allRoles = [];
  $scope.globalAdministrators = {};

  $scope.getMembers = function () {
    for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
      $scope.globalAdministrators[$scope.currentOrg.globalAdministrators[i]] = $scope.currentOrg.globalAdministrators[i];
    }
    return $q(function (resolve, reject) {
      userService.getMembers(null, function (users) {
        $scope.orgUsers = users;
        var globalAdminUsers = [];
        // go through currentOrg globalAdmins and populate names
        for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
          for (var j = 0; j < $scope.orgUsers.length; j++) {
            if ($scope.currentOrg.globalAdministrators[i] == $scope.orgUsers[j].id) {
              globalAdminUsers.push($scope.orgUsers[j]);
            }
          }
        }
        $scope.currentOrg.globalAdminUsers = globalAdminUsers;
        resolve();
      });
    });
  };

  $scope.getMembers();

  userService.getRoles(null, function (roles) {
    $scope.allRoles = roles;
  }, function (err) {
    $scope.allRoles = [];
  });

  $scope.loadAllUsers = function () {
    $scope.invitedUsers = [];
    $scope.activeUsers = [];

    userService.getMembers(null, function (users) {
      // get root group members to provide role details
      var rootGroupId = null;
      for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
        if ($scope.currentOrg.groups[i].parent == null) {
          rootGroupId = $scope.currentOrg.groups[i].id;
        }
      }
      userService.getOrganisationGroup(rootGroupId, function (groupFull) {

        $scope.allUsers = users;
        for (var i = 0; i < users.length; i++) {
          // check if this user is a global admin
          if ($scope.globalAdministrators[users[i].id]) {
            users[i].isGlobalAdmin = true;
          } else {
            users[i].isGlobalAdmin = false;
          }

          users[i].roles = [];

          for (var j = 0; j < groupFull.members.length; j++) {
            if (groupFull.members[j].user.id == users[i].id) {
              users[i].roles.push(groupFull.members[j].role);
            }
          }

          if (users[i].roles.length > 0) {
            users[i].roles[users[i].roles.length - 1].last = true;
          }

          if (users[i].invitationPending == true) {
            users[i].invitedGroupsString = $scope.currentOrg.groups.map(function (group) {
              var roles = group.members.filter(function (m) {
                return m.user == users[i].id;
              }).map(function (role) {
                return $scope.allRoles.find(function (r) {
                  return r.id == role.role;
                }).name;
              });
              return { group: group.name, roles: roles };
            }).filter(function (_ref) {
              var roles = _ref.roles;
              return roles.length > 0;
            }).map(function (_ref2) {
              var group = _ref2.group,
                  roles = _ref2.roles;
              return group + ' (' + roles.join(', ') + ')';
            }).join(', ');

            $scope.invitedUsers.push(users[i]);
          } else {
            $scope.activeUsers.push(users[i]);
          }
        }
      });
    }, function (err) {
      $scope.allUsers = [];
    });
  };

  $scope.uninviteMember = function (member) {

    var sortedGroups = _.sortBy($scope.currentOrg.groups, function (group) {
      return group.parent == null ? 0 : 1;
    });
    var filteredGroups = sortedGroups.filter(function (group) {
      return group.members.map(function (member) {
        return member.user;
      }).includes(member.id);
    });
    var groupsToRemove = filteredGroups.map(function (group) {
      return group.id;
    });

    var failures = [];

    var removeMembership = function removeMembership() {
      if (groupsToRemove.length == 0) {
        if (failures.length == 0) {
          $scope.invitedUsers = $scope.invitedUsers.filter(function (user) {
            return user.id != member.id;
          });
        } else {
          swal({
            title: "Oops!",
            text: "Sorry! An error occured while trying to remove the user",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        }
        return;
      }

      var toRemove = groupsToRemove.pop();
      userService.removeMemberFromGroup(toRemove, member.id, removeMembership, function (err) {
        failures.push(err);
        removeMembership();
      });
    };

    removeMembership();
  };

  $scope.loadAllUsers();

  /******************/
  /* Invite Members */
  /******************/

  $scope.inviteNewMembers = function (group, type) {
    $("#inviteMembersModal").fadeIn(200);
    $scope.newMemberInvitesLoading = false;
    $scope.inviteMembers = {};
    if (type) {
      $scope.inviteMembers.type = type;
    } else {
      $scope.inviteMembers.type = 'member';
    }
    $scope.newMemberInvites = [{}];
  };

  // File Import
  $scope.file = null;

  var mapping = {
    'first name': 'firstName',
    'last name': 'lastName',
    'contact': 'contact',
    'groups': 'groups',
    'role': 'role'
  };

  var reverseMapping = {};

  Object.keys(mapping).forEach(function (key) {
    reverseMapping[mapping[key]] = key;
  });

  var readTableHeaders = function readTableHeaders(fileData) {
    var headers = fileData.shift().map(function (header) {
      return header.toLowerCase();
    }).map(function (header) {
      var found = null;
      Object.keys(mapping).forEach(function (key) {
        if (header.includes(key)) {
          found = mapping[key];
          return;
        }
      });
      return found;
    }).filter(function (x) {
      return x !== null;
    });

    var headerMissing = function headerMissing(str) {
      return !headers.includes(str);
    };

    var missing = Object.keys(reverseMapping).filter(headerMissing).map(function (header) {
      return reverseMapping[header];
    });

    if (missing.length > 0) {
      swal({
        title: "Oops!",
        text: 'The following columns are missing from the file: ' + missing.join(', '),
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return null;
    }

    return fileData.map(function (data) {
      var item = {};
      headers.forEach(function (header, i) {
        item[header] = data[i];
      });
      return item;
    });
  };

  $scope.parseFile = function (fileToUpload) {
    $scope.importLoading = true;

    Upload.upload({
      url: '/v1/parse',
      data: { file: fileToUpload },
      withCredentials: true
    }).then(function (resp) {
      var data = readTableHeaders(resp.data[0].data);
      if (data == null) {
        $scope.importLoading = false;
        return;
      }

      $scope.parseContactsForImport(data);
    }, function (resp) {
      $scope.importLoading = false;
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  };

  $scope.parseContactsForImport = function (data) {
    data.forEach(function (_ref3) {
      var firstName = _ref3.firstName,
          lastName = _ref3.lastName,
          contact = _ref3.contact,
          groups = _ref3.groups,
          role = _ref3.role;

      contact = contact.trim().replace(/"/g, "").replace(/'/g, "");

      var groupsToAdd = $scope.currentOrg.groups.length == 1 ? $scope.currentOrg.groups : groups && groups.toLowerCase() == 'all groups' ? $scope.currentOrg.groups : groups ? groups.split(',').map(function (name) {
        return name.trim();
      }).map(function (groupName) {
        var potentialGroups = $scope.currentOrg.groups.map(function (group) {
          return {
            similarity: _stringSimilarity2.default.compareTwoStrings(group.name, groupName),
            group: group
          };
        }).filter(function (x) {
          return x.similarity >= 0.7;
        });

        return potentialGroups.length > 0 ? _.max(potentialGroups, function (x) {
          return x.similarity;
        }).group : null;
      }).filter(function (group) {
        return group != null;
      }) : null;

      var potentialRoles = role ? $scope.allRoles.map(function (checkRole) {
        return {
          similarity: _stringSimilarity2.default.compareTwoStrings(checkRole.name, role),
          role: checkRole
        };
      }).filter(function (x) {
        return x.similarity >= 0.7;
      }) : null;

      var roleToAdd = potentialRoles && potentialRoles.length > 0 ? _.max(potentialRoles, function (x) {
        return x.similarity;
      }).role : null;

      $scope.newMemberInvites.push({ firstName: firstName, lastName: lastName, emailAddress: contact, groupsToAdd: groupsToAdd, role: roleToAdd });
    });
    $scope.importLoading = false;
    $scope.importFromFile = false;
  };

  $scope.importNewMembers = function () {
    $scope.importFromFile = true;
    $scope.inviteMembers = { type: 'member' };
    $scope.newMemberInvites = [];
    $("#inviteMembersModal").fadeIn(200);
  };

  $scope.closeInviteMembers = function () {
    $("#inviteMembersModal").fadeOut(200);
    $scope.importFromFile = false;
  };

  $scope.addBlankInvitee = function () {
    $scope.newMemberInvites.push({});
  };

  $scope.removeInvitee = function (invitee) {
    $scope.newMemberInvites.splice($scope.newMemberInvites.indexOf(invitee), 1);
  };

  $scope.inviteMembersContinue = function () {
    $scope.newMemberInvitesLoading = true;
    var invitesArray = [];
    var invitesByGroup = {};
    for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
      invitesByGroup[$scope.currentOrg.groups[i].id] = [];
    }
    for (var i = 0; i < $scope.newMemberInvites.length; i++) {
      var roleAdd = $scope.newMemberInvites[i].role.id;
      var roles = [roleAdd];
      var groupsToAddTo = [];
      var addAllGroups = false;
      for (var j = 0; j < $scope.newMemberInvites[i].groupsToAdd.length; j++) {
        if ($scope.newMemberInvites[i].groupsToAdd[j].allGroups == true) {
          addAllGroups = true;
        }
        groupsToAddTo.push($scope.newMemberInvites[i].groupsToAdd[j].id);
      }
      if (addAllGroups == true) {
        groupsToAddTo = [];
        for (var j = 0; j < $scope.currentOrg.groups.length; j++) {
          groupsToAddTo.push($scope.currentOrg.groups[j].id);
        }
      }
      var newInvite = { 'emailAddress': $scope.newMemberInvites[i].emailAddress.replace(/\s/g, ''), 'roles': roles, 'firstName': $scope.newMemberInvites[i].firstName, 'lastName': $scope.newMemberInvites[i].lastName };
      for (var j = 0; j < groupsToAddTo.length; j++) {
        invitesByGroup[groupsToAddTo[j]].push(newInvite);
      }
    }

    userService.assignMembersToOrg(invitesByGroup, function (success) {
      $scope.loadAllUsers();
      $scope.closeInviteMembers();
    }, function (err) {
      $scope.newMemberInvitesLoading = false;
      $scope.alertService.presentAutoAlert('addGroupMembers', err);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "KMj0":
/***/ (function(module, exports) {

var path = 'views/pages/home.html';
var html = "<div class=\"desktopContainer dashboard\" ng-if=\"!currentUser.redirecting\">\n\n  <div class=\"trialBanner\" ng-if=\"unverifiedPhone !== undefined\">\n    When you receive the confirmation code we sent to {{unverifiedPhone}}, please go to <a ui-sref=\"user.account()\">My Account</a> to verify your account.\n  </div>\n  <div class=\"trialBanner\" ng-if=\"unverifiedEmail !== undefined\">\n    Please check your email address {{unverifiedEmail}} for a verification message. When you receive it, open the link it contains to verify your account.\n  </div>\n\n  <!--<div class=\"newCompaniesList\">\n    <div class=\"companyListItem\" ng-repeat=\"org in organisations\" ui-sref=\"main.groupDashboard({orgId:org.id, groupId:'home'})\">\n      {{org.name}}\n    </div>\n  </div>-->\n\n  <div ng-show=\"organisations.length == 0\" class=\"newCompanySelectorOuter onboardingSelectorOuter\">\n    <h1 style=\"text-align: left; margin-bottom: 20px\">Hi {{currentUser.name.first}},</h1>\n    <div style=\"text-align: left; margin-bottom: 40px;\">How would do you want to use Docketbook? Choose one option:</div>\n    <div ng-click=\"goToOnbboardingSession(onboardingSessions.length > 0 ? onboardingSessions[0] : undefined)\" class=\"userIntent\">\n      <div class=\"userIntentIcon\">\n        <img ng-src='domain.svg'></img>\n      </div>\n      <div ng-if=\"onboardingSessions.length == 0\">\n        I want to create a company\n      </div>\n      <div ng-if=\"onboardingSessions.length > 0\">\n        Continue setting up {{onboardingSessions[0].data.companyInfo.name}}\n      </div>\n    </div>\n\n    <div ng-click=\"showWaitToBeInvitedModal()\" class=\"userIntent\">\n      <div class=\"userIntentIcon\">\n        <img ng-src='account-multiple.svg'></img>\n      </div>\n      <div>\n        I want to join a company already on Docketbook\n      </div>\n    </div>\n\n    <div ng-click=\"goToMyDocketbook()\" class=\"userIntent\">\n      <div class=\"userIntentIcon\">\n        <img ng-src='file-document.svg'></img>\n      </div>\n      <div>\n        I want to view dockets that I've been sent\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"organisations.length > 0\" class=\"newCompanySelectorOuter\">\n    <h1>Select A Company To Continue</h1>\n    <div class=\"newCompaniesList\">\n      <div class=\"companyListItem\" ng-repeat=\"org in organisations\" ui-sref=\"main.groupDashboard({orgId:org.id, groupId:'home'})\">\n        <!--<div class=\"logo\">\n          <div class=\"orgLogoInner\" style=\"background-image: url('{{apiPath}}/{{urlVersion}}/organisations/{{org.id}}/logo');\" ng-if=\"org.logoAttachmentName\"></div>\n        </div>-->\n        <div class=\"mainDetails\">\n          <div class=\"orgName\">{{org.name}}</div>\n        </div>\n        <div class=\"otherDetails\"></div>\n      </div>\n      <div class=\"companyListItem new\" ng-repeat=\"session in onboardingSessions\" ng-click=\"goToOnbboardingSession(session)\">\n        <div class=\"mainDetails\">\n          <div class=\"orgName\">Incomplete Organisation - Last modified {{session.updatedAt}}</div>\n          <md-button class=\"md-icon-button\" aria-label=\"Delete incomplete company\" ng-click=\"deleteSession($event, session)\">\n            <md-icon md-svg-icon=\"delete.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div class=\"companyListItem new\" ng-if=\"currentUser.restricted !== true\" ng-click=\"newCompany(false)\">\n        <div class=\"mainDetails\">\n          <div class=\"orgName\">Create a new company</div>\n        </div>\n      </div>\n      <div class=\"companyListItem disabled\" ng-if=\"currentUser.restricted === true\">\n        <div class=\"mainDetails\">\n          <div class=\"orgName\">To create a company, please verify your account</div>\n        </div>\n      </div>\n      <div class=\"companyListItem new\" ng-click=\"newCompany(true)\" ng-if=\"!hasSampleCompany && organisation.length <= 0\">\n        <div class=\"mainDetails\">\n          <div class=\"orgName\">Create a demo company</div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!--<div class=\"homeOrgsListOuter\">\n    <div class=\"orgSelector\" ng-repeat=\"org in organisations\" ui-sref=\"main.groupDashboard({orgId:org.id, groupId:'home'})\">\n      <div class=\"orgSelectorImageUnder\" ng-if=\"!org.logoAttachmentName\"></div>\n      <div class=\"orgSelectorImage\" style=\"background-image: url('{{apiPath}}/{{urlVersion}}/organisations/{{org.id}}/logo');\" ng-if=\"org.logoAttachmentName\">\n      </div>\n      <div class=\"orgSelectorName\">{{org.name}}</div>\n    </div>\n    <div class=\"orgSelector new\" ng-click=\"newCompany(false)\" ng-if=\"currentUser.restricted !== true\">\n      <a ng-if=\"organisations.length > 0\">Click to create another company</a>\n      <a ng-if=\"organisations.length <= 0\">Click to create a company</a>\n    </div>\n    <div class=\"orgSelector new\" ng-if=\"currentUser.restricted === true\">\n      <a>To create a company, please verify your account</a>\n    </div>\n    <div class=\"orgSelector new\" ng-click=\"newCompany(true)\" ng-if=\"!hasSampleCompany\">\n      <a>Create a Demo Company</a>\n    </div>\n  </div>-->\n</div>\n\n<div class=\"mobileContainer\">\n  <div class=\"dashboardHeading\" ng-show=\"!currentOrg\">\n    <h1 class=\"dashboardHeader\">\n      <strong>Hi {{currentUser.name.first}},</strong> welcome back\n    </h1>\n  </div>\n</div>\n\n<!-- Create new org modal -->\n<ng-include src=\"'views/modals/editOrgModal.html'\" ng-controller=\"newOrgModalController\"></ng-include>\n<ng-include src=\"'views/modals/waitToBeInvitedModal.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "KOph":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_down.svg";

/***/ }),

/***/ "KQjo":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/detail.html';
var html = "<div class=\"mobileContainer\">\n  <!-- Order Detail View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState=='order'\" ng-controller=\"orderDetailController\">\n    <div class=\"mobileDetailHeader fixed {{itemEdit.status}}\">\n      <div class=\"headerLoadingSpinner\">\n        <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"15\" ng-show=\"backgroundLoadCount > 0\"></md-progress-circular>\n      </div>\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"cancelButtonHover\" ng-click=\"closeWithoutSave(itemEdit)\">\n          <div class=\"cancelButton\">\n            <div class=\"line1\"></div>\n            <div class=\"line2\"></div>\n            <div class=\"line3\"></div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n          </div>\n          <div class=\"middle\">\n              &nbsp;\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"saveAndStay(itemEdit)\" ng-show=\"itemEdit.editing\">Save</div>\n          </div>\n        </div>\n        <div class=\"mobileHeaderLower\">\n          <div class=\"left\">\n            <span ng-if=\"itemEdit.orderNumber != 'New Order'\">Order </span>{{itemEdit.orderNumber}}\n          </div>\n          <div class=\"right\">\n            <div class=\"actionButton\" ng-click=\"openBottomSheet()\">\n              <md-icon md-svg-src=\"more_vert.svg\"></md-icon>\n            </div>\n          </div>\n        </div>\n      </div>\n      <ng-include src=\"'views/pages/orders/mobile/mobileTabBar.html'\" class=\"blockLayoutHelper\"></ng-include>\n    </div>\n\n    <div class=\"itemDetailLoaderUnder\" ng-show=\"itemEdit.loading || orderLoadingError\">\n      <div my-loader text=\"Loading Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n      <div my-loader text=\"Saving Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n      <div class=\"stdLoader\" ng-show=\"orderLoadingError != null\">\n        <div class=\"loaderOuterContainer\">\n          <div class=\"loaderInnerContainer headerPadding\">\n            <div class=\"materialSpinner\">\n              <md-icon md-svg-src=\"error.svg\"></md-icon>\n            </div>\n            <div class=\"loadingText\">\n              {{orderLoadingError}}\n            </div>\n            <div class=\"loadingRetryButton\">\n              <div class=\"dbButton simpleOutline\" ng-click=\"openOrderMobile(itemEdit.orderId)\">Retry</div>\n              <br/>\n              <div class=\"dbButton simpleOutline margin-top\" ng-click=\"contactSupportError(orderLoadingErrorFull)\">Contact Support</div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"tableCellHelperContainer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"contentSplitDetail listItemDetail mobile {{itemEdit.status}}\">\n          <ng-include src=\"'views/pages/orders/mobile/orderDetail.html'\" class=\"includeContainer mobileListContainer\"></ng-include>\n        </div>\n      </div>\n    </div>\n    <ng-include src=\"'views/modals/shareOrderModal.html'\"></ng-include>\n  </div>\n  <!-- End Order Detail View -->\n\n  <!-- Select Organisation View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'organisation'\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"cancelSelectOrganisation()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Org Unit\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/organisationList.html'\" class=\"includeContainer mobilePadding\"></ng-include>\n  </div>\n  <!-- End Select Company View -->\n\n  <!-- Select Company View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'company'\" ng-controller=\"selectContactController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeContactSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Contact\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"contactSearchValue\" ng-change=\"searchContactChange(contactSearchValue)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/companyList.html'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n    <ng-include src=\"'views/modals/viewContactModal.html'\"></ng-include>\n  </div>\n  <!-- End Select Company View -->\n\n  <!-- Select Template View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'docketTemplate'\" ng-controller=\"selectTemplateController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeTemplateSelectList()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Docket Template\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/templateList.html'\" class=\"includeContainer mobilePadding\"></ng-include>\n  </div>\n  <!-- End Select Template View -->\n\n  <!-- Select Resource View -->\n  <div class=\"tableLayoutHelperContainer\" ng-show=\"viewState == 'resource'\" ng-controller=\"selectResourceController\">\n    <div class=\"mobileDetailHeader selectHeader fixed\" ng-show=\"resourceSelectState == 'category'\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"categoryListBackPress()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Select Resource Category\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader fixed\" ng-if=\"resourceSelectState == 'resource'\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton\" ng-click=\"resourceListBackPress()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            {{resourceCateogorySelected.name}} Resources\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n      <div class=\"searchBar\">\n        <div class=\"left\">\n          <md-icon md-svg-src=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"right\">\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"resourceSearchText\" ng-change=\"mobileResourceSearch(resourceSearchText)\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n      </div>\n    </div>\n\n    <ng-include src=\"'views/selectors/resourceCategoryList.html'\" ng-show=\"resourceSelectState == 'category'\" class=\"includeContainer mobilePadding\"></ng-include>\n    <ng-include src=\"'views/selectors/resourceList.html'\" ng-show=\"resourceSelectState == 'resource'\" class=\"includeContainer mobilePadding searchBarPadding\"></ng-include>\n  </div>\n  <!-- End Select Resource View -->\n</div>\n\n\n<!-- Line Item Modals -->\n<span ng-controller=\"lineItemModalController\">\n  <ng-include src=\"'views/modals/mobileLineItemModal.html'\"></ng-include>\n</span>\n<!-- End Line Item Modals -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "KYo1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('batchDetailController', ['docketService', 'orderService', 'jobService', 'resourceService', 'userService', 'xeroService', 'addressBookService', 'batchService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', '$q', 'scroll', 'geolocation', 'Upload', '$location', function (docketService, orderService, jobService, resourceService, userService, xeroService, addressBookService, batchService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, $q, scroll, geolocation, Upload, $location) {
  // Main Variables For Doing Stuff
  $scope.moment = _momentTimezone2.default;
  $scope.itemEdit = null;
  $scope.selectedIndex = 0;

  // Base Access Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  var timeoutSetting = 500;

  $scope.userCanDoAction = userService.userCanDoAction;

  // Include responsive utilities and UI Functionality
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  $scope.$parent.prepareForBatchFromParent = function (batch) {
    $scope.docketBatch = {};
    $scope.docketBatch.localIdentifier = batch.localIdentifier;
    $scope.docketBatch.loading = true;
    $scope.docketBatch.loadingType = "getting";
  };

  $scope.$parent.loadBatchFromParent = function (batch) {
    $scope.docketBatch = batch;

    $scope.loadDocketsForBatch();
    // get batch customer contact
    if ($scope.docketBatch.attribution && $scope.docketBatch.attribution.customer && $scope.docketBatch.attribution.customer.addressBookId) {
      addressBookService.getAddressBookContact($scope.docketBatch.attribution.customer.addressBookId, function (contactItem) {
        $scope.docketBatch.customerContact = contactItem;
        $scope.docketBatch.customerContact.xeroLinked = $scope.docketBatch.customerContact.externalIdentifiers.find(function (extId) {
          if (extId.type == 'xero') {
            return true;
          }
        });
      });
    }
    // get batch supplier contact
    if ($scope.docketBatch.attribution && $scope.docketBatch.attribution.supplier && $scope.docketBatch.attribution.supplier.addressBookId) {
      addressBookService.getAddressBookContact($scope.docketBatch.attribution.supplier.addressBookId, function (contactItem) {
        $scope.docketBatch.supplierContact = contactItem;
        $scope.docketBatch.supplierContact.xeroLinked = $scope.docketBatch.supplierContact.externalIdentifiers.find(function (extId) {
          if (extId.type == 'xero') {
            return true;
          }
        });
      });
    }
    batch.aggregations.forEach(function (aggregate) {
      aggregate.export = false;
      batch.selectedResources.forEach(function (resource) {
        if (resource.resourceId === aggregate.resource.id && resource.interactionName === aggregate.interactionName) {
          aggregate.export = true;
        }
      });
    });
    if ($stateParams.action && $stateParams.action == 'xeroinv') {
      $timeout(function () {
        $scope.generateXeroInvoice();
      }, 1000);
    }
  };

  $scope.$parent.clearBatchFromParent = function () {
    $scope.docketBatch = null;
  };

  $scope.loadDocketsForBatch = function (docketsList) {
    var dockets = $scope.docketBatch.dockets;
    if (dockets && dockets.length > 0) {
      docketService.getDockets({ ids: dockets.join(',') }, function (docketsList) {
        $scope.docketBatch.docketsList = docketsList.sort(function (a, b) {
          return $scope.docketBatch.dockets.indexOf(a.id) - $scope.docketBatch.dockets.indexOf(b.id);
        });

        for (var i = 0; i < $scope.docketBatch.docketsList.length; i++) {
          $scope.docketBatch.docketsList[i].status = $scope.docketBatch.docketsList[i].status.charAt(0).toUpperCase() + $scope.docketBatch.docketsList[i].status.slice(1);
        }
      }, function (err) {
        console.error('could not get dockets list', err);
      });
    }
  };

  $scope.saveDocketBatch = function (batch) {
    batch.loading = true;
    batch.loadingType = 'saving';
    // update selectedResources from aggregate.export value
    var selectedResources = { add: [], remove: [] };
    var preSelectedResources = {};
    batch.selectedResources.forEach(function (resource) {
      if (preSelectedResources[resource.resourceId] == null) {
        preSelectedResources[resource.resourceId] = {};
      }
      preSelectedResources[resource.resourceId][resource.interactionName] = true;
    });
    batch.aggregations.forEach(function (aggregate) {
      // check if resource/interaction combo is already in selectedResources
      if (aggregate.export == true && (preSelectedResources[aggregate.resource.id] == null || preSelectedResources[aggregate.resource.id][aggregate.interactionName] == null)) {
        selectedResources.add.push({ resourceId: aggregate.resource.id, interactionName: aggregate.interactionName });
      } else if (aggregate.export != true && preSelectedResources[aggregate.resource.id] != null && preSelectedResources[aggregate.resource.id][aggregate.interactionName] == true) {
        selectedResources.remove.push({ resourceId: aggregate.resource.id, interactionName: aggregate.interactionName });
      }
    });
    var batchUpdate = { id: batch.id, selectedResources: selectedResources };
    batchService.saveBatch(batchUpdate, function (batchUpdated) {
      batch.loading = false;
    }, function (err) {
      console.error('could not update batch aggregation', err);
    });
  };

  /**** Generate Xero Invoice ****/

  $scope.generateXeroInvoice = function () {
    /*$scope.xeroInvoice = {stage:'checkConnection'};
    $("#xeroInvoiceModal").fadeIn(100);*/
    $scope.xeroInvoice = { stage: 'invoiceDetails', type: 'aggregate' };
    $scope.xeroInvoice.stage = 'invoiceDetails';
    $scope.xeroInvoice.type = 'aggregate';
    //$scope.xeroInvoice.target = 'customer';
    // get batch customer contact
    if ($scope.docketBatch.customerContact) {
      $scope.xeroInvoice.customerContact = $scope.docketBatch.customerContact;
    }
    if ($scope.docketBatch.supplierContact) {
      $scope.xeroInvoice.supplierContact = $scope.docketBatch.supplierContact;
      $scope.xeroInvoice.disableSupplier = false;
    } else {
      $scope.xeroInvoice.disableSupplier = true;
    }
    if ($scope.docketBatch.attribution) {
      if ($scope.docketBatch.attribution.supplier && !$scope.docketBatch.attribution.customer && $scope.docketBatch.supplierContact.xeroLinked) {
        $scope.xeroInvoice.target = 'supplier';
      } else if ($scope.docketBatch.customerContact.xeroLinked) {
        $scope.xeroInvoice.target = 'customer';
      }
      $scope.xeroInvoice.disableCustomer = false;
    } else {
      $scope.xeroInvoice.disableCustomer = true;
    }
    /*if ( $scope.currentUser.xeroAuthentication ) {
      var xeroAuthTo = moment($scope.currentUser.xeroAuthentication.authenticatedUntil);
      var duration = moment.duration(xeroAuthTo.diff(moment()));
      if ( duration <= 1 ) {
        $scope.closeXeroInvoiceModal();
        $scope.openXeroConnect();
      } else {
        $scope.xeroInvoice.stage = 'invoiceDetails';
        $scope.xeroInvoice.type = 'aggregate';
        //$scope.xeroInvoice.target = 'customer';
        // get batch customer contact
        if ( $scope.docketBatch.customerContact ) {
          $scope.xeroInvoice.customerContact = $scope.docketBatch.customerContact;
        }
        if ( $scope.docketBatch.supplierContact ) {
          $scope.xeroInvoice.supplierContact = $scope.docketBatch.supplierContact;
          $scope.xeroInvoice.disableSupplier = false;
        } else {
          $scope.xeroInvoice.disableSupplier = true;
        }
        if ( $scope.docketBatch.attribution ) {
          if ( $scope.docketBatch.attribution.supplier && !$scope.docketBatch.attribution.customer && $scope.docketBatch.supplierContact.xeroLinked ) {
            $scope.xeroInvoice.target = 'supplier';
          } else if ( $scope.docketBatch.customerContact.xeroLinked ){
            $scope.xeroInvoice.target = 'customer';
          }
          $scope.xeroInvoice.disableCustomer = false;
        } else {
          $scope.xeroInvoice.disableCustomer = true;
        }
      }
    } else {
      $scope.closeXeroInvoiceModal();
      $scope.openXeroConnect();
    }*/
  };

  $scope.closeXeroInvoiceModal = function () {
    $("#xeroInvoiceModal").fadeOut(100);
  };

  $scope.createInvoice = function () {
    $scope.xeroInvoice.loading = true;
    var postObj = { id: $scope.docketBatch.id, type: $scope.xeroInvoice.type, target: $scope.xeroInvoice.target };
    xeroService.createXeroInvoice(postObj, function (success) {
      $scope.xeroInvoice.loading = false;
      $scope.xeroInvoice.stage = 'success';
    }, function (err) {
      $scope.xeroInvoice.loading = false;
      $scope.xeroInvoice.stage = 'error';
    });
  };

  /**** Xero Connect Modal ****/
  $scope.openXeroConnect = function () {
    $scope.xeroConnectLogin('xeroinv');
  };

  /***** Xero Contact Link *****/
  $scope.linkXeroContact = function (type) {
    $scope.xeroContactSelectFromParent(function (contactSelected) {
      if (contactSelected != null) {
        $scope.docketBatch[type + 'Contact'].xeroLinkLoading = true;
        var xeroId = contactSelected.externalId;
        var contactUpdate = { id: $scope.docketBatch[type + 'Contact'].id, externalIdentifiers: { add: [{ type: 'xero', externalId: xeroId }] } };
        addressBookService.saveContact(contactUpdate, function (contactUpdated) {
          $scope.docketBatch[type + 'Contact'] = contactUpdated;
          $scope.docketBatch[type + 'Contact'].xeroLinked = true;
        }, function (err) {
          $scope.docketBatch[type + 'Contact'].xeroLinkLoading = false;
        });
      }
    });
  };

  /***********************************/
  /***** Alert Parent Controller *****/
  /***********************************/

  $scope.$parent.batchDetailControllerReady();
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "KZqe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_square-mask.svg";

/***/ }),

/***/ "KlyX":
/***/ (function(module, exports) {

var path = 'views/modals/inviteMembersModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector wider\" id=\"inviteMembersModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Invite New Users</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeInviteMembers()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div ng-show=\"importFromFile\" class=\"content\">\n      <form name=\"importUserForm\" novalidate>\n        <div class=\"content\">\n          Excel files only (.xls or .xlsx)\n          <br/>\n          <br/>\n          <input type=\"file\" ngf-select ng-model=\"usersFile\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n        </div>\n      </form>\n    </div>\n\n    <form ng-show=\"!importFromFile\" name=\"inviteMembersForm\">\n      <div class=\"content noPadding\">\n        <div class=\"itemDetailModalPart descriptionButton\">\n          <div class=\"left\">\n            Add people to invite to your organisation. If they don't have a Docketbook account, we will send them an invite!\n          </div>\n        </div>\n        <md-table-container>\n          <table md-table>\n            <thead md-head>\n              <tr md-row>\n                <th md-column>First Name</th>\n                <th md-column>Last Name</th>\n                <th md-column>Contact (Email or Mobile)</th>\n                <th md-column ng-if=\"currentOrgGroup.parent == null && !(inviteMembers.singleGroup == true)\">Groups</th>\n                <th md-column>Role</th>\n                <th md-column ng-if=\"inviteMembers.singleGroup == true\" width=\"200px\">Monitor</th>\n                <th md-column></th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row ng-repeat=\"member in newMemberInvites\">\n                <td md-cell>\n                  <md-input-container class=\"md-block\">\n                    <input type=\"text\" ng-model=\"member.firstName\">\n                  </md-input-container>\n                </td>\n                <td md-cell>\n                  <md-input-container class=\"md-block\">\n                    <input type=\"text\" ng-model=\"member.lastName\">\n                  </md-input-container>\n                </td>\n                <td md-cell>\n                  <md-input-container class=\"md-block\">\n                    <input type=\"text\" ng-model=\"member.emailAddress\" required>\n                  </md-input-container>\n                </td>\n                <td md-cell ng-if=\"currentOrgGroup.parent == null && !(inviteMembers.singleGroup == true)\">\n                  <md-input-container class=\"md-block\">\n                    <md-select ng-model=\"member.groupsToAdd\" placeholder=\"Select Groups\" required multiple>\n                      <md-option ng-value=\"{allGroups:true}\">\n                        All Groups\n                      </md-option>\n                      <md-option ng-repeat=\"group in currentOrg.groups\" ng-value=\"group\">\n                        {{group.name}}\n                      </md-option>\n                    </md-select>\n                  </md-input-container>\n                </td>\n                <td md-cell>\n                  <md-input-container class=\"md-block\">\n                    <md-select ng-model=\"member.role\" placeholder=\"Select a role\" required>\n                      <md-option ng-repeat=\"role in allRoles\" ng-value=\"role\">\n                        {{role.name}}\n                      </md-option>\n                    </md-select>\n                  </md-input-container>\n                </td>\n                <td md-cell ng-if=\"inviteMembers.singleGroup == true\">\n                  <md-checkbox ng-model=\"member.addAsMonitor\" aria-label=\"Add Member As A Monitor\" style=\"width: auto;\">\n                    Add As A Monitor\n                  </md-checkbox>\n                </td>\n                <td md-cell>\n                  <md-button class=\"md-icon-button\" ng-click=\"removeInvitee(member)\">\n                    <md-icon md-svg-icon=\"delete.svg\"></md-icon>\n                  </md-button>\n                </td>\n              </tr>\n              <tr md-row>\n                <td md-cell colspan=\"5\" style=\"text-align:center;padding:15px;\">\n                  <div class=\"dbButton grey\" ng-click=\"addBlankInvitee()\">Add Another</div>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </div>\n    </form>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n          <span ng-show=\"newMemberInvites.length > 0 && !importFromFile\">\n            {{newMemberInvites.length}} new user{{newMemberInvites.length > 1 ? 's' : ''}} will be invited to join this org unit.\n          </span>\n          <div ng-show=\"currentOrg.planFeatures.includedUsers != -1 && newMemberInvites.length > 0 && !importFromFile && (newMemberInvites.length + allUsers.length) > currentOrg.planFeatures.includedUsers\">\n            <span style=\"color: #EF3B4A;\">\n              {{newMemberInvites.length + allUsers.length - currentOrg.planFeatures.includedUsers}} over your limit of {{currentOrg.planFeatures.includedUsers}} user{{currentOrg.planFeatures.includedUsers > 1 ? 's' : ''}}.\n            </span>\n          </div>\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white\" ng-click=\"closeInviteMembers()\">\n            Cancel\n          </div>\n          \n          <div ng-if=\"importFromFile\" class=\"dbButton spinner\" ng-click=\"(importUserForm.$invalid || importLoading) || parseFile(usersFile)\" ng-disabled=\"importUserForm.$invalid || importLoading\">\n            <span ng-hide=\"importLoading\">Next</span>\n            <md-progress-circular ng-show=\"importLoading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n\n          <div ng-if=\"!importFromFile\" class=\"dbButton spinner\"\n            ng-click=\"(newMemberInvites.length <= 0 || inviteMembersForm.$invalid || (currentOrg.planFeatures.includedUsers != -1 && (newMemberInvites.length + allUsers.length) > currentOrg.planFeatures.includedUsers)) || inviteMembersContinue()\" \n            ng-disabled=\"newMemberInvites.length <= 0 || inviteMembersForm.$invalid || (currentOrg.planFeatures.includedUsers != -1 && (newMemberInvites.length + allUsers.length) > currentOrg.planFeatures.includedUsers)\">\n            <span ng-hide=\"newMemberInvitesLoading\">Save</span>\n            <md-progress-circular ng-show=\"newMemberInvitesLoading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Knd3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clearSvg = __webpack_require__("8Pnt");

angular.module('docketbook').controller('docketDesktopController', ['docketService', 'orderService', 'resourceService', 'userService', 'batchService', 'xeroService', 'addressBookService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$q', '$location', function (docketService, orderService, resourceService, userService, batchService, xeroService, addressBookService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q, $location) {
  mixpanel.track("Opened Dockets Desktop");

  $scope.myDocketbook = $stateParams.myDocketbook == true;
  if ($scope.myDocketbook) {
    mixpanel.track("Opened Dockets Desktop - My Docketbook");
  }

  $scope.clearSvgImagePath = clearSvg;
  /***************************/
  /***** Setup Variables *****/
  /***************************/
  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.itemEdit = null;
  $scope.listView = 'dockets';
  $scope.detailView = 'dockets';
  $scope.listFull = true;
  $scope.xeroContacts = [];
  $scope.customTemplate = [{
    name: 'Last 12 Months',
    dateStart: (0, _momentTimezone2.default)().subtract(12, 'months').toDate(),
    dateEnd: (0, _momentTimezone2.default)().toDate()
  }];

  $scope.rejectReason = { text: '' };
  $scope.rejectingDockets = [];
  $scope.rejectingDocket = null;
  $scope.rejectLoading = false;
  $scope.bulkReject = false;

  var statusFilterOptions = ['draft', 'sent', 'accepted', 'rejected'];
  var customerSignatureOptions = ['signed', 'unsigned'];
  var invoicedStatusFilterOptions = ['invoiced', 'uninvoiced'];
  var filedOptions = ['filed', 'unfiled'];

  if ($stateParams.viewMode && $stateParams.viewMode == 'filing') {
    $scope.listView = 'filing';
    $scope.detailView = 'filing';
  } else if ($stateParams.viewMode && $stateParams.viewMode == 'batch') {
    $scope.listView = 'batch';
    $scope.detailView = 'batch';
  } else {
    $scope.listView = 'dockets';
    $scope.detailView = 'dockets';
  }

  $scope.fullApiPath = "" + "/" + $scope.urlVersion;

  $scope.detailOpen = false;
  $scope.showFilters = false;
  $scope.preventReloadWithFilters = true;
  $scope.selected = [];
  $scope.assignDocket = {};
  $scope.assignDocket.selected = [];

  // Last geolocation
  $scope.lastGeolocation = {};
  $scope.lastGeolocationCheck = (0, _momentTimezone2.default)();

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  // Filters initial
  $scope.subFilters = {};
  $scope.filters = {};
  $scope.filters.customerSignatureOptions = { allView: true, all: true, signed: true, unsigned: true, display: false };
  $scope.filters.filedOptions = { all: true, filed: false, unfiled: false };
  $scope.filters.otherParty = "All";
  $scope.filters.statusTab = "All";
  $scope.filters.status = "All";
  $scope.filters.invoicedStatus = "All";
  $scope.filters.fileStatusTab = 'all';
  $scope.filters.batchStatusTab = 'all';
  $scope.filters.organisation = "All";
  $scope.filters.startDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate(); //startFromDate
  $scope.filters.endDate = (0, _momentTimezone2.default)().toDate(); //endToDate
  $scope.dateFilterModel = { dateStart: $scope.filters.startDate, dateEnd: $scope.filters.endDate, showTemplate: true };
  $scope.filters.customerGroup = null;
  $scope.filters.supplierGroup = null;
  $scope.filters.author = null;
  $scope.filters.statusOptions = { allView: true, all: true, draft: true, sent: true, accepted: true, rejected: true };
  $scope.filters.invoicedStatusOptions = { allView: true, all: true, invoiced: true, uninvoiced: true };
  $scope.filterHeading = "";
  $scope.activeFilters = 0;
  $scope.filters.organisationId = $scope.currentOrg ? $scope.currentOrg.id : null;
  $scope.filters.groupId = $scope.currentOrgGroup ? $scope.currentOrgGroup.id : null;
  $scope.filters.customerDisplayName = null;
  $scope.filters.supplierDisplayName = null;
  $scope.filters.customerSignatureName = null;
  $scope.filters.acceptedBy = null;
  $scope.filters.custom = $scope.currentOrg && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.customColumns ? $scope.currentOrg.features.dockets.customColumns.map(function (fieldName) {
    return { fieldName: fieldName, prettyName: fieldName.match(/[A-Z][a-z,1-9]+/g).join(' '), display: false, value: '' };
  }) : [];

  $scope.goToBulkDocketImport = function () {
    window.location.href = '/app/org/' + $scope.currentOrg.id + '/group/' + $scope.currentOrgGroup.id + '/dockets/bulkimport';
  };

  $scope.isDisabledDate = function (date) {
    //if ($scope.currentOrg.plan == null || $scope.currentOrg.planFeatures == null || !$scope.currentOrg.planFeatures.docketsHistoricalDateLimit) { return true; }

    if ($scope.currentOrg == null || $scope.currentOrg.planFeatures.docketsHistoricalDateLimit == -1) {
      return false;
    }

    var diff = (new Date() - date) / (1000 * 60 * 60 * 24);
    return diff > $scope.currentOrg.planFeatures.docketsHistoricalDateLimit;
  };

  $scope.$watch('dateFilterModel.dateStart', function (before, after) {
    if ($scope.dateFilterModel.dateStart) {
      if ($scope.currentOrg && $scope.currentOrg.planFeatures.docketsHistoricalDateLimit != -1) {
        if ((0, _momentTimezone2.default)().diff((0, _momentTimezone2.default)($scope.dateFilterModel.dateStart), 'days') > $scope.currentOrg.planFeatures.docketsHistoricalDateLimit) {
          $scope.dateFilterModel.dateStart = (0, _momentTimezone2.default)().add(-$scope.currentOrg.planFeatures.docketsHistoricalDateLimit, 'days').toDate();

          if ((0, _momentTimezone2.default)($scope.dateFilterModel.dateEnd).isBefore($scope.dateFilterModel.dateStart)) {
            $scope.dateFilterModel.dateEnd = (0, _momentTimezone2.default)($scope.dateFilterModel.dateStart).toDate();
          }

          swal({
            title: "Oops!",
            text: 'The ' + ($scope.currentOrg.planFeatures.name == null ? 'free' : $scope.currentOrg.planFeatures.name) + ' plan only allows docket history up to ' + $scope.currentOrg.planFeatures.docketsHistoricalDateLimit + ' days.  The search value has been updated.',
            type: "warning",
            confirmButtonText: "Ok, got it."
          });
        }
      }
      $scope.filters.startDate = $scope.dateFilterModel.dateStart;
    }
    if (!$scope.preventReloadWithFilters) {
      if ((0, _momentTimezone2.default)(after).diff((0, _momentTimezone2.default)(before), 'days') != 0) {
        $scope.filtersChanged('date selector');
      }
    }
  }, true);

  $scope.$watch('dateFilterModel.dateEnd', function (before, after) {
    if ($scope.dateFilterModel.dateEnd) {
      $scope.filters.endDate = $scope.dateFilterModel.dateEnd;
    }
    if (!$scope.preventReloadWithFilters) {
      if ((0, _momentTimezone2.default)(after).diff((0, _momentTimezone2.default)(before), 'days') != 0) {
        $scope.filtersChanged('date selector');
      }
    }
  }, true);

  // New list query pagination
  $scope.filters.query = {
    limit: 30,
    page: 1,
    order: 'docketNumber'
  };

  $scope.reportButtonClick = function (mdOpenMenu, evt) {
    if ($scope.currentOrg.planFeatures.docketsReports) {
      $scope.openMenu(mdOpenMenu, evt);
    } else {
      /*if ( $scope.currentOrg ) {
        $state.go('main.groupExportDockets', {orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id});
      } else {
        $state.go('main.exportDockets');
      }*/
      $scope.showUpgradePlanModal(null, 'docketsReports', 'from dockets page - report button click');
    }
  };

  var loadSavedFilters = function loadSavedFilters() {
    var storedFilters = {};
    if (sessionStorage.getItem('filters')) {
      storedFilters = JSON.parse(sessionStorage.getItem('filters'));
    }
    var lastDocketsFilters = {};
    if (sessionStorage.getItem('docketsLastFilters')) {
      lastDocketsFilters = JSON.parse(sessionStorage.getItem('docketsLastFilters'));
    }
    if ($scope.listView == 'dockets') {
      if (storedFilters) {
        if (storedFilters.order && storedFilters.order.id) {
          $scope.filters.order = storedFilters.order;
        }
        // if url params has order - override stored filter order
        if ($stateParams.orderId != null) {
          $scope.filters.order = { id: $stateParams.orderId };
          if ($stateParams.orderNumber != null) {
            $scope.filters.order.orderNumber = $stateParams.orderNumber;
          }
        }
        if (storedFilters.job && storedFilters.job.id) {
          $scope.filters.job = storedFilters.job;
        }
        // if url params has job - override stored filter job
        if ($stateParams.jobId != null) {
          $scope.filters.job = { id: $stateParams.jobId };
          if ($stateParams.jobNumber != null) {
            $scope.filters.job.jobNumber = $stateParams.jobNumber;
          }
        }
        if (storedFilters.statusOptions) {
          for (var i = 0; i < statusFilterOptions.length; i++) {
            if (storedFilters.statusOptions[statusFilterOptions[i]] == true) {
              $scope.filters.statusOptions[statusFilterOptions[i]] = true;
            } else {
              $scope.filters.statusOptions[statusFilterOptions[i]] = false;
            }
          }
          if (storedFilters.statusOptions.all == true) {
            $scope.filters.statusOptions.all = true;
            for (var i = 0; i < statusFilterOptions.length; i++) {
              $scope.filters.statusOptions[statusFilterOptions[i]] = true;
            }
          } else {
            $scope.filters.statusOptions.all = false;
          }
        }
        if (storedFilters.customerSignatureOptions) {
          var displayOption = true;
          if (storedFilters.customerSignatureOptions.display == false) {
            displayOption = false;
          }
          for (var i = 0; i < customerSignatureOptions.length; i++) {
            if (storedFilters.customerSignatureOptions[customerSignatureOptions[i]] == true) {
              $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
            } else {
              $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = false;
            }
          }
          if (storedFilters.customerSignatureOptions.all == true) {
            $scope.filters.customerSignatureOptions.all = true;
            for (var i = 0; i < customerSignatureOptions.length; i++) {
              $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
            }
          } else {
            $scope.filters.customerSignatureOptions.all = false;
          }
          $scope.filters.customerSignatureOptions.display = displayOption;
        }
        if (storedFilters.filedOptions) {
          $scope.filters.filedOptions = Object.assign({}, storedFilters.filedOptions);
        }
        if (storedFilters.invoicedStatusOptions) {
          for (var i = 0; i < invoicedStatusFilterOptions.length; i++) {
            if (storedFilters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] == true) {
              $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
            } else {
              $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = false;
            }
          }
          if (storedFilters.invoicedStatusOptions.all == true) {
            $scope.filters.invoicedStatusOptions.all = true;
            for (var i = 0; i < invoicedStatusFilterOptions.length; i++) {
              $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
            }
          } else {
            $scope.filters.invoicedStatusOptions.all = false;
          }
        }
        // if state params status is set - uisref status has been used and overrite status statusOptions
        if ($stateParams.status != undefined) {
          $scope.filters.statusOptions.all = false;
          for (var i = 0; i < statusFilterOptions.length; i++) {
            $scope.filters.statusOptions[statusFilterOptions[i]] = false;
          }
          $scope.filters.statusOptions[$stateParams.status] = true;
        }
        if (storedFilters.customerContact != null) {
          $scope.filters.customerContact = storedFilters.customerContact;
        }
        if (storedFilters.supplierContact != null) {
          $scope.filters.supplierContact = storedFilters.supplierContact;
        }
        if (storedFilters.customerDisplayName != null) {
          $scope.filters.customerDisplayName = storedFilters.customerDisplayName;
        }
        if (storedFilters.supplierDisplayName != null) {
          $scope.filters.supplierDisplayName = storedFilters.supplierDisplayName;
        }
        if (storedFilters.customerSignatureName != null) {
          $scope.filters.customerSignatureName = storedFilters.customerSignatureName;
        }
        if (storedFilters.custom != null) {
          $scope.filters.custom = storedFilters.custom;
        }
        if (storedFilters.acceptedBy != null) {
          $scope.filters.acceptedBy = storedFilters.acceptedBy;
        }
        if (storedFilters.startDate != null) {
          $scope.filters.startDate = (0, _momentTimezone2.default)(storedFilters.startDate).toDate();
          $scope.dateFilterModel.dateStart = $scope.filters.startDate;
        }
        if (storedFilters.endDate != null) {
          $scope.filters.endDate = (0, _momentTimezone2.default)(storedFilters.endDate).toDate();
          $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
        }
        if (storedFilters.docketNumber != null) {
          $scope.filters.docketNumber = storedFilters.docketNumber;
        } else if (lastDocketsFilters.docketNumber) {
          $scope.filters.docketNumber = lastDocketsFilters.docketNumber;
        }
        if (storedFilters.customerRefNo != null) {
          $scope.filters.customerRefNo = storedFilters.customerRefNo;
        } else if (lastDocketsFilters.customerRefNo) {
          $scope.filters.customerRefNo = lastDocketsFilters.customerRefNo;
        }
        if (storedFilters.supplierRefNo != null) {
          $scope.filters.supplierRefNo = storedFilters.supplierRefNo;
        } else if (lastDocketsFilters.supplierRefNo) {
          $scope.filters.supplierRefNo = lastDocketsFilters.supplierRefNo;
        }
        if (storedFilters.author != null) {
          $scope.filters.author = storedFilters.author;
        } else if (lastDocketsFilters.author) {
          $scope.filters.author = lastDocketsFilters.author;
        }
        if (storedFilters.reloadRequired) {
          $scope.filters.reloadRequired = storedFilters.reloadRequired;
        }
      }
    } else if ($scope.listView == 'filing') {
      if (storedFilters) {
        if (storedFilters.orderId != null) {
          $scope.filters.order = { id: storedFilters.orderId };
          if (storedFilters.orderNumber != null) {
            $scope.filters.order.orderNumber = storedFilters.orderNumber;
          }
        }
        if (storedFilters.jobId != null) {
          $scope.filters.job = { id: storedFilters.jobId };
          if (storedFilters.jobNumber != null) {
            $scope.filters.job.jobNumber = storedFilters.jobNumber;
          }
        }
        if (storedFilters.customerContact != null) {
          $scope.filters.customerContact = storedFilters.customerContact;
        }
        if (storedFilters.supplierContact != null) {
          $scope.filters.supplierContact = storedFilters.supplierContact;
        }
        if (storedFilters.docketNumber != null) {
          $scope.filters.docketNumber = storedFilters.docketNumber;
        }
        if (storedFilters.customerRefNo != null) {
          $scope.filters.customerRefNo = storedFilters.customerRefNo;
        }
        if (storedFilters.supplierRefNo != null) {
          $scope.filters.supplierRefNo = storedFilters.supplierRefNo;
        }
        if (storedFilters.author != null) {
          $scope.filters.author = storedFilters.author;
        }
        if (storedFilters.startDate != null) {
          $scope.filters.startDate = (0, _momentTimezone2.default)(storedFilters.startDate).toDate();
          $scope.dateFilterModel.dateStart = $scope.filters.startDate;
        }
        if (storedFilters.endDate != null) {
          $scope.filters.endDate = (0, _momentTimezone2.default)(storedFilters.endDate).toDate();
          $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
        }
      }
    } else if ($scope.listView == 'batch') {
      if (storedFilters) {
        if (storedFilters.orderId != null) {
          $scope.filters.order = { id: storedFilters.orderId };
          if (storedFilters.orderNumber != null) {
            $scope.filters.order.orderNumber = storedFilters.orderNumber;
          }
        }
        if (storedFilters.jobId != null) {
          $scope.filters.job = { id: storedFilters.jobId };
          if (storedFilters.jobNumber != null) {
            $scope.filters.job.jobNumber = storedFilters.jobNumber;
          }
        }
        if (storedFilters.customerContact != null) {
          $scope.filters.customerContact = storedFilters.customerContact;
        }
        if (storedFilters.supplierContact != null) {
          $scope.filters.supplierContact = storedFilters.supplierContact;
        }
        if (storedFilters.startDate != null) {
          $scope.filters.startDate = (0, _momentTimezone2.default)(storedFilters.startDate).toDate();
          $scope.dateFilterModel.dateStart = $scope.filters.startDate;
        }
        if (storedFilters.endDate != null) {
          $scope.filters.endDate = (0, _momentTimezone2.default)(storedFilters.endDate).toDate();
          $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
        }
      }
    }
    // load in most recent query params
    if (sessionStorage.getItem('docketsQuery')) {
      var queryStored = JSON.parse(sessionStorage.getItem('docketsQuery'));
      if (queryStored != null) {
        if (queryStored.limit) {
          $scope.filters.query.limit = queryStored.limit;
        }
        if (queryStored.page) {
          $scope.filters.query.page = queryStored.page;
        }
        if (queryStored.order) {
          $scope.filters.query.order = queryStored.order;
        }
      }
    }
    sessionStorage.setItem('filters', JSON.stringify($scope.filters));
  };

  loadSavedFilters();

  $scope.promise = null;

  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  $scope.setListView = function (view) {
    $scope.listView = view;

    if (view == 'filing') {
      $scope.loadDocketFilingList();
    } else if (view == 'dockets') {
      $scope.loadDocketsList();
    } else if (view == 'batch') {
      $scope.loadBatchesList();
    }
  };

  /*** New Filters Helpers ***/

  $scope.prettifyFilterStatusPreview = function () {
    var output = "";

    if ($scope.filters.statusOptions.all) {
      return "All";
    }

    var soFar = 0;
    if ($scope.filters.statusOptions.draft) {
      soFar += 1;
      output += "Draft";
    }
    if ($scope.filters.statusOptions.sent) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Sent";
    }
    if ($scope.filters.statusOptions.accepted) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Accepted";
    }
    if ($scope.filters.statusOptions.rejected) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Rejected";
    }
    if (soFar == 0) {
      output += "None selected";
    }
    return output;
  };

  $scope.prettifyFilterCustomerSignaturePreview = function () {
    var output = "";

    if ($scope.filters.customerSignatureOptions.all) {
      return "All";
    }

    var soFar = 0;
    if ($scope.filters.customerSignatureOptions.signed) {
      soFar += 1;
      output += "Signed";
    }
    if ($scope.filters.customerSignatureOptions.unsigned) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Unsigned";
    }
    if (soFar == 0) {
      output += "None selected";
    }
    return output;
  };

  $scope.prettifyFilterFiledPreview = function () {
    return $scope.filters.filedOptions.all ? "All" : $scope.filters.filedOptions.filed ? "Filed" : $scope.filters.filedOptions.unfiled ? "Unfiled" : "None selected";
  };

  $scope.statusFilterCheckboxChanged = function () {
    $scope.statusFiltersChanged();
  };

  $scope.statusFiltersChanged = function () {
    var selectedCount = 0;
    for (var option in statusFilterOptions) {
      if ($scope.filters.statusOptions[statusFilterOptions[option]]) {
        selectedCount += 1;
      }
    }
    if (selectedCount == statusFilterOptions.length) {
      $scope.filters.statusOptions.all = true;
    } else {
      $scope.filters.statusOptions.all = false;
    }
    if (!$scope.preventReloadWithFilters) {
      $scope.filtersChanged('status options');
    }
  };

  $scope.customerSignatureFiltersChanged = function () {
    var selectedCount = 0;
    for (var option in customerSignatureOptions) {
      if ($scope.filters.customerSignatureOptions[customerSignatureOptions[option]]) {
        selectedCount += 1;
      }
    }
    if (selectedCount == customerSignatureOptions.length) {
      $scope.filters.customerSignatureOptions.all = true;
    } else {
      $scope.filters.customerSignatureOptions.all = false;
    }
    if (!$scope.preventReloadWithFilters) {
      $scope.filtersChanged('customerSignature options');
    }
  };

  $scope.filedFiltersChanged = function () {
    var selectedCount = 0;
    for (var option in filedOptions) {
      if ($scope.filters.filedOptions[filedOptions[option]]) {
        selectedCount += 1;
      }
    }
    if (selectedCount == filedOptions.length) {
      $scope.filters.filedOptions.all = true;
    } else {
      $scope.filters.filedOptions.all = false;
    }
    if (!$scope.preventReloadWithFilters) {
      $scope.filtersChanged('filed options');
    }
  };

  $scope.swapStatusFilter = function (option) {
    if (option == 'all' && $scope.filters.statusOptions.all == false) {
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
      $scope.filters.statusOptions.allView = true;
      $scope.filters.statusOptions.all = true;
    } else if (option == 'all' && $scope.filters.statusOptions.all == true) {
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = false;
      }
      $scope.filters.statusOptions.allView = false;
      $scope.filters.statusOptions.all = false;
    }
    $scope.statusFiltersChanged();
  };

  $scope.swapCustomerSignatureFilter = function (option) {
    if (option == 'all' && $scope.filters.customerSignatureOptions.all == false) {
      for (var i in customerSignatureOptions) {
        $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
      }
      $scope.filters.customerSignatureOptions.allView = true;
      $scope.filters.customerSignatureOptions.all = true;
    } else if (option == 'all' && $scope.filters.customerSignatureOptions.all == true) {
      for (var i in customerSignatureOptions) {
        $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = false;
      }
      $scope.filters.customerSignatureOptions.allView = false;
      $scope.filters.customerSignatureOptions.all = false;
    }
    $scope.customerSignatureFiltersChanged();
  };

  $scope.swapFiledFilter = function (option) {
    if (option == 'all' && $scope.filters.filedOptions.all == false) {
      for (var i in filedOptions) {
        $scope.filters.filedOptions[filedOptions[i]] = true;
      }
      $scope.filters.filedOptions.allView = true;
      $scope.filters.filedOptions.all = true;
    } else if (option == 'all' && $scope.filters.filedOptions.all == true) {
      for (var i in filedOptions) {
        $scope.filters.filedOptions[filedOptions[i]] = false;
      }
      $scope.filters.filedOptions.allView = false;
      $scope.filters.filedOptions.all = false;
    }
    $scope.filedFiltersChanged();
  };

  $scope.setOnlyFilter = function (option) {
    $scope.filters.statusOptions.all = false;
    for (var i in statusFilterOptions) {
      if (statusFilterOptions[i] != option) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = false;
      } else {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
    }
    $scope.statusFiltersChanged();
  };

  $scope.setCustomerSignatureOnlyFilter = function (option) {
    $scope.filters.customerSignatureOptions.all = false;
    for (var i in customerSignatureOptions) {
      if (customerSignatureOptions[i] != option) {
        $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = false;
      } else {
        $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
      }
    }
    $scope.customerSignatureFiltersChanged();
  };

  $scope.setFiledOnlyFilter = function (option) {
    $scope.filters.filedOptions.all = false;
    for (var i in filedOptions) {
      if (filedOptions[i] != option) {
        $scope.filters.filedOptions[filedOptions[i]] = false;
      } else {
        $scope.filters.filedOptions[filedOptions[i]] = true;
      }
    }
    $scope.filedFiltersChanged();
  };

  /*** New Invoiced/Uninvoiced Filters Helpers ***/

  $scope.prettifyInvoicedFilterStatusPreview = function () {
    var output = "";

    if ($scope.filters.invoicedStatusOptions.all) {
      return "All";
    }

    var soFar = 0;
    if ($scope.filters.invoicedStatusOptions.invoiced) {
      soFar += 1;
      output += "Invoiced";
    }
    if ($scope.filters.invoicedStatusOptions.uninvoiced) {
      if (soFar > 0) {
        output += ", ";
      }
      soFar += 1;
      output += "Uninvoiced";
    }
    if (soFar == 0) {
      output += "None selected";
    }
    return output;
  };

  $scope.invoicedStatusFilterCheckboxChanged = function () {
    $scope.invoicedStatusFiltersChanged();
  };

  $scope.customerSignatureFilterCheckboxChanged = function () {
    $scope.customerSignatureFiltersChanged();
  };

  $scope.hideCustomerSignatureFilter = function () {
    $scope.filters.customerSignatureOptions.display = false;
    $scope.swapCustomerSignatureFilter('all');
    $scope.filtersChanged('customer signature filter hidden');
  };

  $scope.filedFilterCheckboxChanged = function () {
    $scope.filedFiltersChanged();
  };

  $scope.hideFiledFilter = function () {
    $scope.filters.filedOptions.display = false;
    $scope.swapFiledFilter('all');
    $scope.filtersChanged('filed filter hidden');
  };

  $scope.invoicedStatusFiltersChanged = function () {
    var selectedCount = 0;
    for (var option in invoicedStatusFilterOptions) {
      if ($scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[option]]) {
        selectedCount += 1;
      }
    }
    if (selectedCount == invoicedStatusFilterOptions.length) {
      $scope.filters.invoicedStatusOptions.all = true;
    } else {
      $scope.filters.invoicedStatusOptions.all = false;
    }
    if (!$scope.preventReloadWithFilters) {
      $scope.filtersChanged('invoiced status options');
    }
  };

  $scope.swapInvoicedStatusFilter = function (option) {
    if (option == 'all' && $scope.filters.invoicedStatusOptions.all == false) {
      for (var i in invoicedStatusFilterOptions) {
        $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
      }
      $scope.filters.invoicedStatusOptions.allView = true;
      $scope.filters.invoicedStatusOptions.all = true;
    } else if (option == 'all' && $scope.filters.invoicedStatusOptions.all == true) {
      for (var i in invoicedStatusFilterOptions) {
        $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = false;
      }
      $scope.filters.invoicedStatusOptions.allView = false;
      $scope.filters.invoicedStatusOptions.all = false;
    }
    $scope.invoicedStatusFiltersChanged();
  };

  $scope.setOnlyInvoicedFilter = function (option) {
    $scope.filters.invoicedStatusOptions.all = false;
    for (var i in invoicedStatusFilterOptions) {
      if (invoicedStatusFilterOptions[i] != option) {
        $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = false;
      } else {
        $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
      }
    }
    $scope.invoicedStatusFiltersChanged();
  };

  $scope.hideInvoicedFilter = function () {
    $scope.filters.invoicedStatusOptions.display = false;
    $scope.swapInvoicedStatusFilter('all');
    $scope.invoicedStatusFiltersChanged('invoiced filter hidden');
  };

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /***************************************/
  /***** Docket Detail View Controls *****/
  /***************************************/

  $scope.openDocketDesktop = function (docket, editing, tab) {
    var currentDocket = $scope.getCurrentDocketFromParent();
    var docketId = docket;
    if (docketId.id != null) {
      docketId = docketId.id;
    }
    if (!currentDocket) {
      if ($scope.currentOrg) {
        $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
      } else {
        $state.go('main.docketDetail', { docketId: docketId });
      }
      //openDocket(docket, editing, tab);
      return;
    } else if (currentDocket.id == docketId) {
      return;
    }
    var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'getDiffedDocket', function (diff, count) {
      if (count > 0) {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            $scope.saveDocket(currentDocket, function () {
              if ($scope.currentOrg) {
                $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
              } else {
                $state.go('main.docketDetail', { docketId: docketId });
              }
            });
          } else if (actionSelected == 'dontSave') {
            if ($scope.currentOrg) {
              $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
            } else {
              $state.go('main.docketDetail', { docketId: docketId });
            }
          } else {
            // do nothing - stay where we are
          }
        });
      } else {
        if ($scope.currentOrg) {
          $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
        } else {
          $state.go('main.docketDetail', { docketId: docketId });
        }
      }
    });
  };

  var openDocket = function openDocket(docket, editing, tab, afterFilingAccept) {
    $scope.currentDocket = docket;
    $scope.afterFilingAccept = afterFilingAccept;
    $scope.docketLoadingError = null;
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.listFull = false;
    $scope.detailView = 'dockets';
    $scope.prepareForDocketFromParent(null, docket);
    docketService.getDocket(docket, true, function (fullDocket) {
      $scope.lastCleanDocket = angular.copy(fullDocket);
      $scope.getDocketTotalTime(fullDocket);
      $scope.loadDocketFromParent(fullDocket, tab, editing);
      $scope.updateSelectedDocketFromParent(fullDocket);
    }, function (err) {
      $scope.docketLoadingError = "Error Getting Docket";
      $scope.docketLoadingErrorFull = err;
    });
  };

  $scope.closeDocketDesktop = function () {
    var currentDocket = $scope.getCurrentDocketFromParent();
    if (!currentDocket || currentDocket.id == null) {
      if ($scope.currentOrg) {
        $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else {
        $state.go('main.dockets');
      }
      return;
    }
    var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'resources', function (diff, count) {
      if (count > 0) {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            $scope.saveDocket(currentDocket, function () {
              if ($scope.currentOrg) {
                $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                $state.go('main.dockets');
              }
            });
          } else if (actionSelected == 'dontSave') {
            if ($scope.currentOrg) {
              $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              $state.go('main.dockets');
            }
          } else {
            // do nothing - stay where we are
          }
        });
      } else {
        if ($scope.currentOrg) {
          $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else {
          $state.go('main.dockets');
        }
      }
    });
  };

  var closeDocket = function closeDocket() {
    $scope.splitListFunc.slideTableListDetailClosed();
    $scope.afterFilingAccept = false;
    $scope.listFull = true;
    $scope.clearDocketFromParent();
  };

  $scope.closeDocket = $scope.closeDocketDesktop;

  $scope.newDocket = function (fromType, fromId, forOperator) {
    mixpanel.track("Clicked Create New Docket");

    var currentDocket = $scope.getCurrentDocketFromParent();
    if (!currentDocket) {
      $scope.selectAuthorAndCreateDocket(forOperator);
      return;
    }

    var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'resources', function (diff, count) {
      if (count > 0) {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            $scope.saveDocket(currentDocket, function () {
              $scope.selectAuthorAndCreateDocket(forOperator);
              return;
            });
          } else if (actionSelected == 'dontSave') {
            $scope.selectAuthorAndCreateDocket(forOperator);
            return;
          } else {
            // do nothing - stay where we are
          }
        });
      } else {
        $scope.selectAuthorAndCreateDocket(forOperator);
        return;
      }
    });
  };

  $scope.selectAuthorAndCreateDocket = function (forOperator) {
    if (!forOperator) {
      $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: 'new', author: null, authorName: null, fromOrder: null, fromJob: null });
      return;
    } else {
      $scope.desktopPeopleSelectFromParent([], function (selected) {
        if (selected && selected[0]) {
          // TODO: ADD AUTHOR TO ROUTE
          $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: 'new', author: selected[0].id, authorName: selected[0].name.full, fromOrder: null, fromJob: null });
          return;
        } else {
          return;
        }
      });
    }
  };

  var newDocket = function newDocket(fromType, fromId) {
    $scope.listView = 'dockets';
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.afterFilingAccept = false;
    $scope.listFull = false;
    $scope.docketLoadingError = null;
    $scope.docketLoadingErrorFull = null;
    $scope.newDocketFromParent(fromType, fromId, function (newDocket) {
      if (newDocket.id != null) {
        $scope.openDocketDesktop(newDocket, true, 0);
        $scope.loadDocketsList();
      } else {
        $scope.openNewDocketFromParent(newDocket);
      }
    });
  };

  var newDocketForAuthor = function newDocketForAuthor(author, authorName, fromType, fromId) {
    $scope.listView = 'dockets';
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.afterFilingAccept = false;
    $scope.listFull = false;
    $scope.docketLoadingError = null;
    $scope.docketLoadingErrorFull = null;
    $scope.newDocketWithAuthorFromParent(author, authorName, fromType, fromId, function (newDocket) {
      if (newDocket.id != null) {
        $scope.openDocketDesktop(newDocket, true, 0);
        $scope.loadDocketsList();
      } else {
        $scope.openNewDocketFromParent(newDocket);
      }
    });
  };

  $scope.saveDocket = function (docket, cb) {
    mixpanel.track("Clicked Save Docket");
    var newDocket = false;
    if (docket.id == null) {
      newDocket = true;
    }
    docket.loading = true;
    docket.loadingType = "saving";
    // get diff of docket before saving
    if (!newDocket) {
      var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, docket, 'resources', function (diff, count) {
        if (count > 0) {
          docketService.saveDocket(diff, function (docketUpdated) {
            $scope.showToast('Docket Changes Saved');
            if (!cb) {
              openDocket(docketUpdated.id);
              $scope.loadDocketsList();
            } else {
              cb();
            }
          }, function (err) {
            docket.loading = false;
            $scope.alertService.presentAutoAlert('saveDocket', err);
          });
        } else {
          docket.loading = false;
          docket.editing = false;
          if (cb) {
            cb();
          }
        }
      });
    } else {
      docketService.saveDocket(docket, function (docketUpdated) {
        if (!cb) {
          $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketUpdated.id });
        } else {
          cb();
        }
      }, function (err) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('saveDocket', err);
      });
    }
  };

  $scope.removeDocketFromCachedList = function (docket) {
    var docketsListParsed = JSON.parse(sessionStorage.getItem('docketsList'));
    if (docketsListParsed) {
      var newList = [];
      for (var i = 0; i < docketsListParsed.length; i++) {
        if (docketsListParsed[i].id != docket.id) {
          newList.push(docketsListParsed[i]);
        }
      }
      sessionStorage.setItem('docketsList', JSON.stringify(newList));
    }
  };

  $scope.deleteDocket = function (docket) {
    mixpanel.track("Clicked Delete Docket");
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete this docket?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteDocket(docket, function () {
          // remove delete docket from cached list of dockets
          $scope.removeDocketFromCachedList(docket);
          if ($scope.currentOrg) {
            $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          } else {
            $state.go('main.dockets');
          }
        }, function (err) {
          $scope.alertService.presentAutoAlert('deleteDocket', err);
        });
      }
    });
  };

  $scope.editDocket = function (docket) {
    mixpanel.track("Clicked Edit Docket");
    docket.editing = true;
  };

  $scope.cancelEditDocket = function (docket) {
    mixpanel.track("Clicked Cancel Edit Docket");

    var newDocket = false;
    if (docket.id == null) {
      newDocket = true;
    }
    if (newDocket) {
      $scope.closeDocketDesktop($scope.itemEdit);
      return;
    }

    var currentDocket = $scope.getCurrentDocketFromParent();
    var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'resources', function (diff, count) {
      if (count > 0) {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            $scope.saveDocket(currentDocket, function () {
              openDocket(docket);
            });
          } else if (actionSelected == 'dontSave') {
            openDocket(docket);
          } else {
            // do nothing - stay where we are
          }
        });
      } else {
        openDocket(docket);
      }
    });
  };

  $scope.sendDocket = function (docket) {
    mixpanel.track("Clicked Send Docket");
    docket.loading = true;
    docket.loadingType = "saving";
    docketService.validateDocket(docket, function () {
      docketService.sendDocket($scope.lastCleanDocket, docket, function (docketUpdated) {
        openDocket(docketUpdated.id);
        $scope.loadDocketsList();
      }, function (error) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('sendDocket', error);
      });
    }, function (errors) {
      docket.loading = false;
      var reasons = [];
      for (var i = 0; i < errors.length; i++) {
        reasons.push(errors[i].name);
      }
      $scope.alertService.presentAutoValidationAlert('sendDocket', reasons);
    });
  };

  $scope.recallDocket = function (docket) {
    mixpanel.track("Clicked Recall Docket");
    docket.loading = true;
    docket.loadingType = "saving";
    docketService.recallDocket(docket, function (docketUpdated) {
      docket.loading = false;
      openDocket(docketUpdated.id);
      $scope.loadDocketsList();
    }, function (err) {
      docket.loading = false;
      $scope.alertService.presentAutoAlert('recallDocket', err);
    });
  };

  $scope.acceptDocket = function (docket) {
    mixpanel.track("Clicked Accept Docket");
    docket.loading = true;
    docket.loadingType = "saving";
    docketService.acceptDocket(docket, function (docketUpdated) {
      docket.loading = false;
      openDocket(docketUpdated.id);
      $scope.loadDocketsList();
    }, function (err) {
      docket.loading = false;
      $scope.alertService.presentAutoAlert('acceptDocket', err);
    });
  };

  $scope.reDraftDocket = function (docket) {
    mixpanel.track("Clicked Recall Docket");
    docket.loading = true;
    docket.loadingType = "saving";
    docketService.reDraftDocket(docket, function (docketUpdated) {
      docket.loading = false;
      openDocket(docketUpdated.id, true);
      $scope.loadDocketsList();
    }, function (err) {
      docket.loading = false;
      $scope.showToast('Error Re-Drafting Docket');
    });
  };

  $scope.hideRejectDocketModal = function () {
    if ($scope.rejectingDocket) {
      $scope.rejectingDocket.loading = false;
    }

    $("#rejectDocketModal").fadeOut(100);
    $scope.rejectLoading = false;
    $scope.rejectReason.text = '';
    $scope.rejectingDockets = [];
    $scope.rejectingDocket = null;
  };

  $scope.acceptRejectDocket = function () {
    $scope.rejectLoading = true;

    if ($scope.rejectingDockets.length == 1) {
      docketService.rejectDocket($scope.rejectingDockets[0], $scope.rejectReason.text, function (docketUpdated) {
        $scope.hideRejectDocketModal();
        if (!$scope.bulkReject) {
          openDocket(docketUpdated.id);
        }
        $scope.loadDocketsList();
      }, function (err) {
        $scope.hideRejectDocketModal();
        $scope.alertService.presentAutoAlert('rejectDocket', err);
      });
    } else {
      docketService.rejectBulkDockets($scope.rejectingDockets, $scope.rejectReason.text, function (failures) {
        if (failures && failures.length > 0) {
          $scope.hideRejectDocketModal();
          $scope.alertService.presentAutoAlert('rejectBulkDockets', { status: 202, requestName: 'Reject bulk dockets - failures ' + failures.length + ' of ' + $scope.rejectingDockets.length });
          $scope.loadDocketsList();
        } else {
          $scope.hideRejectDocketModal();
          $scope.alertService.presentAutoAlert('rejectBulkDockets', { status: 200 });
          $scope.loadDocketsList();
        }
        $scope.selected = [];
      });
    }
  };

  $scope.rejectDocket = function (docket) {
    $scope.bulkReject = false;
    $scope.rejectReason.text = '';
    $scope.rejectingDockets = [docket];
    $scope.rejectingDocket = docket;
    $("#rejectDocketModal").fadeIn(100);
    mixpanel.track("Clicked Reject Docket");
    docket.loading = true;
    docket.loadingType = 'saving';
  };

  $scope.downloadDocket = function (docket) {
    mixpanel.track("Clicked Download Docket");
    var url = '/v1/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docket.id + '/downloadpdf';
    window.open(url, "_blank");
  };

  $scope.fileDocket = function (docket) {
    mixpanel.track("Clicked File Docket");
    docket.loading = true;
    docket.loadingType = "saving";
    $mdBottomSheet.hide();
    openDocket(docket.id, false, 1);
  };

  $scope.acceptAndFileDocket = function (docket) {
    mixpanel.track("Clicked Accept and File Docket");
    docket.loading = true;
    docket.loadingType = "saving";
    $mdBottomSheet.hide();
    openDocket(docket.id, false, 1, true);
  };

  // Calculate the total time on the docket for the time block
  $scope.getDocketTotalTime = function (docket) {
    if (docket.startTime && docket.endTime) {
      var startTimePart = (0, _momentTimezone2.default)(docket.startTime).format('HH:mm');
      var endTimePart = (0, _momentTimezone2.default)(docket.endTime).format('HH:mm');
      var timeFixerPre = (0, _momentTimezone2.default)().format('DD/MM/YYYY');
      var startTimeFixed = timeFixerPre + "T" + startTimePart;
      var endTimeFixed = timeFixerPre + "T" + endTimePart;
      var startTimeMoment = (0, _momentTimezone2.default)(startTimeFixed, 'DD/MM/YYYYTHH:mm');
      var endTimeMoment = (0, _momentTimezone2.default)(endTimeFixed, 'DD/MM/YYYYTHH:mm');
      var minsTotal = 0;
      // if start time is before end time - standard hours calculation
      // if start time is after end time - overnight shift calculation
      if (!startTimeMoment.isBefore(endTimeMoment)) {
        endTimeMoment = endTimeMoment.add('days', 1);
      }

      minsTotal = parseInt(endTimeMoment.diff(startTimeMoment, 'minutes'));

      if (docket.breakTime) {
        minsTotal -= docket.breakTime;
      }
      if (docket.travelTime) {
        minsTotal += parseInt(docket.travelTime);
      }

      /*var hoursPart = Math.floor(minsTotal / 60);
      var minsPart = minsTotal - (hoursPart * 60);
      display = hoursPart += "h " + minsPart + "m";*/

      docket.totalTime = (minsTotal / 60).toFixed(2) + ' Hrs';
    }
  };

  /*******************************/
  /***** Docket List Controls ****/
  /*******************************/

  $scope.filtersChanged = function (from) {
    if (!$scope.preventReloadWithFilters) {
      // check toDate is after fromDate
      if ((0, _momentTimezone2.default)($scope.filters.endDate).isBefore($scope.filters.startDate)) {
        $scope.filters.endDate = $scope.filters.startDate;
      }

      // check if status filter has changed
      /*var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
      if ( $scope.listView == 'dockets' ) {
        if ( storedFilters.status != $scope.filters.status ) {
          $scope.filters.query.page = 1;
        }
      } else {
        if ( storedFilters.fileStatusTab != $scope.filters.fileStatusTab ) {
          $scope.filters.query.page = 1;
        }
      }*/
      $scope.filters.query.page = 1;

      if ($scope.listView == 'dockets') {
        $scope.loadDocketsList();
      } else if ($scope.listView == 'filing') {
        $scope.loadDocketFilingList();
      } else if ($scope.listView == 'batch') {
        $scope.loadBatchesList();
      }

      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    } else {}
  };

  $scope.filingsChildControllerReady = function () {
    if ($scope.listView == 'filing') {
      // loading of stateParams filters was in here
      $scope.loadDocketFilingList();
    }
  };

  $scope.batchChildControllerReady = function () {
    if ($stateParams.action && $stateParams.action == 'newbatch') {
      $timeout(function () {
        $scope.openDocketBatchModal();
      }, 1000);
    }
    if ($scope.listView == 'batch') {
      // loading of stateParams filters was here
      $scope.loadBatchesList();
    }
  };

  $scope.detailControllerReady = function () {
    if ($stateParams.docketId != null) {
      if ($stateParams.docketId == 'new') {
        if (!($stateParams.author != null && $stateParams.authorName != null)) {
          if ($stateParams.fromOrder != null) {
            newDocket('order', $stateParams.fromOrder);
          } else if ($stateParams.fromJob != null) {
            newDocket('job', $stateParams.fromJob);
          } else {
            newDocket();
          }
        } else {
          if ($stateParams.fromOrder != null) {
            newDocketForAuthor($stateParams.author, $stateParams.authorName, 'order', $stateParams.fromOrder);
          } else if ($stateParams.fromJob != null) {
            newDocketForAuthor($stateParams.author, $stateParams.authorName, 'job', $stateParams.fromJob);
          } else {
            newDocketForAuthor($stateParams.author, $stateParams.authorName);
          }
        }
      } else {
        if ($stateParams.viewMode == 'filing') {
          openDocket($stateParams.docketId, false, 1);
        } else {
          var editing = false;
          if ($stateParams.editing && $stateParams.editing == true) {
            editing = true;
          }
          openDocket($stateParams.docketId, editing, 0);
        }
      }
    }
  };

  $scope.loadDocketsList = function (searchValue, reload) {
    $scope.selected = [];
    $scope.customerFilterOptions = [];
    $scope.customerFilterCounts = {};
    $scope.supplierFilterOptions = [];
    $scope.supplierFilterCounts = {};
    $scope.promise = $q(function (resolve, reject) {
      var params = $scope.getFilterParams();
      params['limit'] = $scope.filters.query.limit;
      params['offset'] = $scope.filters.query.limit * ($scope.filters.query.page - 1);
      params['sort'] = $scope.filters.query.order;
      if (searchValue != null && searchValue != "") {
        params['search'] = searchValue;
      }
      if ($scope.filters.customerSignatureOptions.signed == true && $scope.filters.customerSignatureOptions.unsigned == false) {
        params['customerSigned'] = true;
      } else if ($scope.filters.customerSignatureOptions.signed == false && $scope.filters.customerSignatureOptions.unsigned == true) {
        params['customerSigned'] = false;
      } else {
        params['customerSigned'] = null;
      }
      if ($scope.filters.filedOptions.filed == true && $scope.filters.filedOptions.unfiled == false) {
        params['filed'] = true;
      } else if ($scope.filters.filedOptions.filed == false && $scope.filters.filedOptions.unfiled == true) {
        params['filed'] = false;
      } else {
        params['filed'] = null;
      }
      if ($scope.filters.statusOptions.all == true) {
        params['status'] = null;
      } else {
        var statusParam = "";
        var count = 0;
        var selectedFilters = [];
        for (var i in statusFilterOptions) {
          if ($scope.filters.statusOptions[statusFilterOptions[i]] == true) {
            selectedFilters.push(statusFilterOptions[i]);
          }
        }
        if (selectedFilters.length === 1) {
          params['status'] = selectedFilters[0];
        } else {
          params['statusList'] = selectedFilters.join(',');
        }
      }
      if ($scope.filters.invoicedStatusOptions.all == true) {
        params['invoiced'] = null;
        params['uninvoiced'] = null;
      } else {
        if ($scope.filters.invoicedStatusOptions.invoiced == true) {
          params['invoiced'] = true;
        } else if ($scope.filters.invoicedStatusOptions.uninvoiced == true) {
          params['uninvoiced'] = true;
        }
      }
      // check if this org has custom fields to be injected in dockets list columns
      if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.listViewOrder && $scope.currentOrg.features.dockets.listViewOrder.length > 0) {
        var askForTemplateValueStore = false;
        for (var i = 0; i < $scope.currentOrg.features.dockets.listViewOrder.length; i++) {
          if ($scope.currentOrg.features.dockets.listViewOrder[i].indexOf('customField') == 0) {
            askForTemplateValueStore = true;
          }
        }
        if (askForTemplateValueStore) {
          params.supplyTemplateValueStore = true;
        }
      }

      docketService.getDockets(params, function (returnData) {
        var docketsListParsed = docketService.parseDockets(returnData);

        $scope.injectCustomFields(docketsListParsed);

        var activeCustomFilters = $scope.filters.custom.filter(function (x) {
          return x.display && x.value != '';
        });
        if (activeCustomFilters.length > 0) {
          activeCustomFilters.forEach(function (_ref) {
            var fieldName = _ref.fieldName,
                value = _ref.value;

            docketsListParsed = docketsListParsed.filter(function (docket) {
              return docket.customFieldsInjected[fieldName] && (_stringSimilarity2.default.compareTwoStrings(docket.customFieldsInjected[fieldName], value) > 0.5 || docket.customFieldsInjected[fieldName].toLowerCase().indexOf(value.toLowerCase()) != -1);
            });
          });
        }

        var count = 0;
        if (params.offset <= 0 && returnData.length < params.limit) {
          count = returnData.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        $scope.loadDocketsListFromParent(docketsListParsed, count);
        if ($scope.currentOrg != null) {
          $scope.loadDocketsListFiledStatus(docketsListParsed);
        }

        if (reload && reload == true) {
          var currentDocket = $scope.getCurrentDocketFromParent();
          if (currentDocket && !currentDocket.editing && currentDocket.id != null) {
            openDocket(currentDocket.id);
          }
        }
        $scope.preventReloadWithFilters = false;
        // store list in sessionStorage
        sessionStorage.setItem('docketsList', JSON.stringify(docketsListParsed));
        sessionStorage.setItem('docketsListCount', count);
        sessionStorage.setItem('docketsQuery', JSON.stringify($scope.filters.query));
        sessionStorage.setItem('filters', JSON.stringify($scope.filters));
        sessionStorage.setItem('docketsLastFilters', JSON.stringify($scope.filters));
        resolve('Done');
      }, function (err) {
        reject('Error');
      });
    });
  };

  $scope.loadDocketsListFiledStatus = function (docketsList) {
    var docketsFiledStatus = {};
    var docketIds = [];
    for (var i = 0; i < docketsList.length; i++) {
      docketIds.push(docketsList[i].id);
      docketsFiledStatus[docketsList[i].id] = false;
    }
    // get docket files
    if (docketIds && docketIds.length > 0) {
      docketService.getBulkDocketFileData(docketIds, function (docketFiles) {
        for (var j = 0; j < docketFiles.length; j++) {
          docketsFiledStatus[docketFiles[j].docketRef] = true;
        }
        $scope.loadInDocketFiledStatusFromParent(docketsFiledStatus);
      });
    }
  };

  $scope.loadDocketsListFullFiledStatus = function (docketsList, cb) {
    var docketFilingRecord = {};
    var docketIds = [];
    for (var i = 0; i < docketsList.length; i++) {
      docketIds.push(docketsList[i].id);
      docketFilingRecord[docketsList[i].id] = { filed: false };
    }
    // get docket files
    if (docketIds && docketIds.length > 0) {
      docketService.getBulkDocketFileData(docketIds, function (docketFiles) {
        for (var j = 0; j < docketFiles.length; j++) {
          docketFilingRecord[docketFiles[j].docketRef] = { filed: true, filingRecord: docketFiles[j] };
        }
        cb(docketFilingRecord);
      });
    }
  };

  /********************************/
  /***** Filing List Controls *****/
  /********************************/

  $scope.filingDetailControllerReady = function () {};

  $scope.loadDocketFilingList = function (cb) {
    $scope.promise = $q(function (resolve, reject) {
      var params = $scope.getFilterParams();
      params['limit'] = $scope.filters.query.limit;
      params['offset'] = $scope.filters.query.limit * ($scope.filters.query.page - 1);
      params['sort'] = $scope.filters.query.order;
      params.fileStatus = $scope.filters.fileStatusTab;

      var paramsToSend = angular.copy(params);
      delete paramsToSend.fileStatus;

      docketService.getDockets(paramsToSend, function (returnData) {
        var docketsList = returnData;
        var docketsCount = 0;
        if (params.offset <= 0 && returnData.length < params.limit) {
          docketsCount = returnData.length;
        } else {
          docketsCount = params.offset + (params.limit + 1);
        }
        // list of docket id's for getting existing docket files
        var docketIds = [];
        for (var i = 0; i < docketsList.length; i++) {
          docketIds.push(docketsList[i].id);
        }
        // get docket files
        if (docketIds && docketIds.length > 0) {
          docketService.getBulkDocketFileData(docketIds, function (docketFiles) {
            // populate docket files to dockets with existing
            for (var i = 0; i < docketsList.length; i++) {
              var docketFile = $scope.getDocketFileForDocket(docketsList[i], docketFiles);
              if (docketFile) {
                docketsList[i].existingDocketFile = docketFile;
              }
            }
            var docketsListParsed = docketService.parseDocketsForFiling(docketsList, params.fileStatus.toLowerCase());
            $scope.loadDocketFilingListFromParent(docketsListParsed, docketsCount);
            $scope.preventReloadWithFilters = false;
            resolve('Done');
            if (cb) {
              cb(docketsListParsed);
            }
          }, function (err) {
            reject('Error');
            if (cb) {
              cb([]);
            }
          });
        } else {
          var docketsListParsed = docketService.parseDocketsForFiling(docketsList, params.fileStatus.toLowerCase());
          $scope.loadDocketFilingListFromParent(docketsListParsed, docketsCount);
          $scope.preventReloadWithFilters = false;
          resolve('Done');
          if (cb) {
            cb(docketsListParsed);
          }
        }
      }, function (err) {
        reject('Error');
        if (cb) {
          cb([]);
        }
      });
    });
  };

  $scope.getDocketFileForDocket = function (docket, docketFilesList) {
    for (var i = 0; i < docketFilesList.length; i++) {
      if (docketFilesList[i].docketRef == docket.id) {
        return docketFilesList[i];
      }
    }
    return null;
  };

  $scope.fileBulkDockets = function (acceptAfterSave) {
    $scope.afterFilingAccept = false;
    if (acceptAfterSave) {
      $scope.afterFilingAccept = true;
    }
    mixpanel.track("Clicked File Bulk Dockets");
    $scope.detailView = "filing";

    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.listFull = false;
    $scope.prepareForFilingFromParent();
    $scope.getPopulatedDockets($scope.selected, function (docketsPopulated) {
      // we need to grab the current filing status of these dockets
      $scope.loadDocketsListFullFiledStatus(docketsPopulated, function (filingRecordByDocket) {
        // assign each filing record to the appropriate docket
        for (var i = 0; i < docketsPopulated.length; i++) {
          if (filingRecordByDocket[docketsPopulated[i].id] != null && filingRecordByDocket[docketsPopulated[i].id].filed == true) {
            docketsPopulated[i].existingDocketFile = filingRecordByDocket[docketsPopulated[i].id].filingRecord;
          }
        }
        $scope.loadBulkDocketsFromParent(docketsPopulated);
      });
    }, function (err) {
      $scope.loadingErrorFromParent('Error loading docket files');
    });
  };

  $scope.acceptAndFileBulkDockets = function () {
    mixpanel.track("Clicked Accept and File Bulk Dockets");

    // check that all selected dockets can be accepted first
    var issue = false;
    for (var i = 0; i < $scope.selected.length; i++) {
      if ($scope.selected[i].status != 'Sent') {
        issue = true;
        break;
      }
    }

    if (issue) {
      $scope.alertService.presentAlert('warning', 'Invalid Dockets Selected', 'You have selected dockets that are not in the Sent state - all dockets must be Sent before they can be Accepted & Filed.');
      return;
    }
    $scope.fileBulkDockets(true);

    /*var itemsToAct = $scope.selected;
    swal({
      title: "Are you sure?",
      text: "Do you really want to accept and file these " + itemsToAct.length + " dockets?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, accept and file them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function(isConfirm){
      if (isConfirm) {
        //$scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted',{status:200});
         docketService.acceptBulkDockets(itemsToAct, function(failures) {
          if ( failures && failures.length > 0 ) {
            $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted', {status:202, requestName: 'Accept bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length});
            $scope.loadDocketsList();
          } else {
            $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted',{status:200});
            //$scope.loadDocketsList();
            $scope.fileBulkDockets();
          }
        });
      }
    });*/
  };

  $scope.getPopulatedDockets = function (dockets, successCb, failureCb) {
    // get list of ids
    var ids = [];
    var existingDocketFiles = {};
    for (var i = 0; i < dockets.length; i++) {
      ids.push(dockets[i].id);
      existingDocketFiles[dockets[i].id] = dockets[i].existingDocketFile;
    }

    var params = {};
    params.ids = ids.join(',');

    // get populated list of dockets by ids
    docketService.getDockets(params, function (docketsList) {
      // now re-attach exsitingDocketFiles from first dockets list
      for (var i = 0; i < docketsList.length; i++) {
        docketsList[i].existingDocketFile = existingDocketFiles[docketsList[i].id];
      }
      successCb(docketsList);
    }, function (err) {
      failureCb(err);
    });
  };

  $scope.closeDocketFiling = function () {
    $scope.splitListFunc.slideTableListDetailClosed();
    $scope.listFull = true;
    $scope.clearDocketFilingFromParent();
    $scope.detailView = 'dockets';
    $scope.clearDocketFromParent();
    $scope.selected = [];
  };

  var validateDocketFileBeforeSave = function validateDocketFileBeforeSave(docket) {
    if (docket.docketFiling.method == 'split') {
      var totalPercentage = 0;
      for (var i = 0; i < docket.docketFiling.activityCodes.length; i++) {
        if (docket.docketFiling.activityCodes[i].fileCode == null) {
          return 'missingFileCode';
        }
        totalPercentage += parseFloat(docket.docketFiling.activityCodes[i].splitPercentage);
      }
      totalPercentage = parseFloat(totalPercentage.toFixed(2));
      if (totalPercentage != 100) {
        return 'percentageError';
      } else {
        return true;
      }
    } else if (docket.docketFiling.method == 'lines') {
      for (var i = 0; i < docket.docketFiling.linesSummary.length; i++) {
        for (var j = 0; j < docket.docketFiling.linesSummary[i].activityCodes.length; j++) {
          if (docket.docketFiling.linesSummary[i].activityCodes[j].fileCode == null) {
            return 'missingFileCode';
          }
        }
        var totalPercent = docket.docketFiling.linesSummary[i].activityCodes.map(function (activityCode) {
          return activityCode.percentage;
        }).reduce(function (a, b) {
          return a + b;
        }, 0);

        if (totalPercent != 100) {
          return 'percentageError';
        }
      }
      return true;
    } else if (docket.docketFiling.method == null) {
      return 'missingFileCode';
    } else {

      return true;
    }
  };

  var validateBulkDocketFileBeforeSave = function validateBulkDocketFileBeforeSave(docketFiling) {
    if (docketFiling.method == 'split') {
      var totalPercentage = 0;
      if (!docketFiling.activityCodes) {
        return 'missingFileCode';
      }
      for (var i = 0; i < docketFiling.activityCodes.length; i++) {
        if (docketFiling.activityCodes[i].fileCode == null) {
          return 'missingFileCode';
        }
        totalPercentage += parseFloat(docketFiling.activityCodes[i].splitPercentage);
      }
      totalPercentage = parseFloat(totalPercentage.toFixed(2));
      if (totalPercentage != 100) {
        return 'percentageError';
      } else {
        return true;
      }
    } else if (docketFiling.method == 'lines') {
      for (var i = 0; i < docketFiling.linesSummary.length; i++) {
        var totalPercentage = 0;
        for (var j = 0; j < docketFiling.linesSummary[i].activityCodes.length; j++) {
          totalPercentage += docketFiling.linesSummary[i].activityCodes[j].percentage;
          if (docketFiling.linesSummary[i].activityCodes[j].fileCode == null) {
            return 'missingFileCode';
          }
        }
        if (totalPercentage != 100) {
          return 'percentageError';
        }
      }
      return true;
    } else if (docketFiling.method == null) {
      return 'missingFileCode';
    } else {
      return true;
    }
  };

  function saveFiling(docket, docketFiling) {
    docketService.saveDocketFiling(docketFiling, function (success) {
      docket.loading = false;
      openDocket(docket.id, false, 1);
      $scope.loadDocketsList();
    }, function (err) {
      docket.docketFiling.loading = false;
      $scope.alertService.presentAutoAlert('fileDocket', err);
    });
  }

  $scope.saveDocketFile = function (docket) {
    // validate if filing adds up to 100%
    var validateResult = validateDocketFileBeforeSave(docket);
    if (validateResult == true) {
      docket.docketFiling.loading = true;
      docket.docketFiling.loadingType = 'saving';

      var docketFiling = angular.copy(docket.docketFiling);
      docketFiling.dockets = [];
      docketFiling.dockets.push(docket);

      if ($scope.afterFilingAccept) {
        docketService.acceptDocket(docket, function (docketUpdated) {
          saveFiling(docket, docketFiling);
        }, function (err) {
          docket.loading = false;
          $scope.alertService.presentAutoAlert('acceptDocket', err);
        });
      } else {
        saveFiling(docket, docketFiling);
      }
    } else if (validateResult == 'missingFileCode') {
      $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - a file code is missing. Please check and try again.");
    } else if (validateResult == 'percentageError') {
      $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - filing percentages do not add to 100%.");
    }
  };

  $scope.saveDocketFiling = function (docketFiling) {
    docketFiling.loading = true;

    // validate docket file before save
    var validateResult = validateBulkDocketFileBeforeSave(docketFiling);
    if (validateResult == true) {
      docketService.saveDocketFiling(docketFiling, function (success) {
        $scope.loadDocketFilingList(function (listParsed) {
          // Re-assign filing status's and existingDocketFiles to previously selected dockets
          for (var i = 0; i < $scope.selected.length; i++) {
            for (var j = 0; j < listParsed.length; j++) {
              if (listParsed[j].id == $scope.selected[i].id && listParsed[j].existingDocketFile != null) {
                $scope.selected[i].existingDocketFile = listParsed[j].existingDocketFile;
              }
            }
          }
          if ($scope.afterFilingAccept) {
            docketService.acceptBulkDockets($scope.selected, function (failures) {
              if (failures && failures.length > 0) {
                $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted', { status: 202, requestName: 'Accept bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length });
                $scope.loadDocketsList();
              } else {
                $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted', { status: 200 });
                $scope.fileBulkDockets();
                $scope.loadDocketsList();
              }
            });
          } else {
            $scope.fileBulkDockets();
            $scope.loadDocketsList();
          }
        });
      }, function (err) {
        $scope.alertService.presentAutoAlert('fileDocket', err);
      });
    } else if (validateResult == 'missingFileCode') {
      $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - a file code is missing. Please check and try again.");
      docketFiling.loading = false;
    } else if (validateResult == 'percentageError') {
      $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - filing percentages do not add to 100%.");
      docketFiling.loading = false;
    }
  };

  /******************************/
  /***** List View Controls *****/
  /******************************/

  $scope.selectContactFilter = function (type) {
    var existingContact = null;
    if (type == 'customer') {
      if ($scope.filters.customerContact != null) {
        existingContact = $scope.filters.customerContact;
      }
    } else {
      if ($scope.filters.supplierContact != null) {
        existingContact = $scope.filters.supplierContact;
      }
    }
    $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
      if (contactSelected != null) {
        if (type == 'customer') {
          $scope.filters.customerContact = contactSelected;
        } else {
          $scope.filters.supplierContact = contactSelected;
        }
        $scope.filtersChanged(type + ' contact');
      }
    });
  };

  $scope.selectContactForDocket = function (docket, companyType, cb) {
    $scope.selectContactCallback = cb;
    var existingContacts = [];
    var selectedContact = null;
    if (companyType == 'customerContact') {
      if (docket.supplierContact != null) {
        existingContacts.push(docket.supplierContact);
      }
      if (docket.customerContact != null) {
        selectedContact = docket.customerContact;
      }
    } else if (companyType == 'supplierContact') {
      if (docket.customerContact != null) {
        existingContacts.push(docket.customerContact);
      }
      if (docket.supplierContact != null) {
        selectedContact = docket.supplierContact;
      }
    }

    if (selectedContact) {
      var newContactAddresses = [];
      var keys = Object.keys(selectedContact.contactAddresses);
      for (var i = 0; i < keys.length; i++) {
        var newContactAddress = {};
        newContactAddress.emailAddress = keys[i];
        newContactAddress.accessLevel = selectedContact.contactAddresses[keys[i]][0];
        newContactAddresses.push(newContactAddress);
      }
      selectedContact.contactAddresses = newContactAddresses;
    }

    $scope.contactSelectFromParent(existingContacts, selectedContact, function (contactSelected) {
      $scope.selectContactCallback(contactSelected);
    });
  };

  $scope.selectContactForShare = function (cb) {
    $scope.contactSelectFromParent(null, null, function (contactSelected) {
      cb(contactSelected);
    });
  };

  $scope.selectOrderForDocket = function (options, cb) {
    $scope.selectOrderCallback = cb;
    $scope.orderSelectFromParent(options, function (orderSelected) {
      $scope.selectOrderCallback(orderSelected);
    });
  };

  $scope.selectOrderFilter = function () {
    var currentOrder = null;
    var options = {};
    if ($scope.filters.order != null) {
      options.currentOrder = $scope.filters.order;
    }
    $scope.orderSelectFromParent(options, function (orderSelected) {
      if (orderSelected != null) {
        $scope.filters.order = orderSelected;
        $scope.filtersChanged('order');
      }
    });
  };

  $scope.selectJobFilter = function () {
    var currentJob = null;
    if ($scope.filters.job != null) {
      currentJob = $scope.filters.job;
    }
    $scope.jobSelectFromParent(currentJob, function (jobSelected) {
      if (jobSelected != null) {
        $scope.filters.job = jobSelected;
        $scope.filtersChanged('job select');
      }
    });
  };

  $scope.selectJobForDocket = function (options, cb) {
    $scope.selectJobCallback = cb;
    $scope.jobSelectFromParent(null, function (jobSelected) {
      $scope.selectJobCallback(jobSelected);
    });
  };

  $scope.selectTemplateForDocket = function (currentTemplate, cb) {
    $scope.selectTemplateCallback = cb;
    $scope.templateSelectFromParent(currentTemplate, function (templateSelected) {
      $scope.selectTemplateCallback(templateSelected);
    });
  };

  $scope.selectOrganisationForDocket = function (docket, cb) {
    $("#assignDocketModal").fadeIn(100);
    $scope.selectOrganisationCallback = cb;
    $scope.assignDocket = {};
    $scope.assignDocket.selected = [];
    $scope.assignDocket.docketNumber = docket.docketNumber;
    $scope.assignDocket.organisations = accessControl.allowedOrganisations();
  };

  $scope.assignDocketContinue = function () {
    var group = $scope.assignDocket.selected[0];
    $("#assignDocketModal").fadeOut(100);
    $scope.selectOrganisationCallback(group);
  };

  $scope.closeAssignDocketModal = function () {
    $("#assignDocketModal").fadeOut(100);
    $scope.selectOrganisationCallback(null, null);
  };

  $scope.selectResourceForDocket = function (docket, cb) {
    $scope.selectResourceCallback = cb;

    // Get list of available categories
    var categories = {};
    for (var i = 0; i < docket.template.interactionTemplates.length; i++) {
      var interactionTemplate = docket.template.interactionTemplates[i];
      for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
        if (categories[interactionTemplate.actorCategories[j].id] == null) {
          categories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
          categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
        }
        // Check if resources in category are to be filtered by order or not
        if (categories[interactionTemplate.actorCategories[j].id].filterByOrder == true && interactionTemplate.actorFromOrder != true) {
          categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
        } else if (categories[interactionTemplate.actorCategories[j].id].filterByOrder != true && interactionTemplate.actorFromOrder == true) {
          categories[interactionTemplate.actorCategories[j].id].filterByOrder = true;
        }
      }
    }

    // convert categories dict to array
    var categoriesArray = [];
    var keys = Object.keys(categories);
    for (var i = 0; i < keys.length; i++) {
      categoriesArray.push(categories[keys[i]]);
    }

    var lineItems = [];
    // Get list of line items from job/order that are to be filtered against
    if (docket.jobRef != null && docket.jobRef.lineItems != null) {
      lineItems = docket.jobRef.lineItems;
    } else if (docket.orderRef != null && docket.orderRef.lineItems != null) {
      lineItems = docket.orderRef.lineItems;
    }

    // Get list of existing resources on the docket
    var existingResources = [];
    if (docket && docket.resources) {
      for (var i = 0; i < docket.resources.length; i++) {
        if (!docket.resources[i].delete) {
          existingResources.push(docket.resources[i].resource.id);
        }
      }
    }

    var options = { categories: categoriesArray, lineItems: lineItems, existingResources: existingResources };
    $scope.desktopResourceSelectFromParent(options, function (resourcesSelected) {
      $scope.selectResourceCallback(resourcesSelected);
    });
  };

  /*******************************/
  /***** Batch List Controls *****/
  /*******************************/

  $scope.batchDetailControllerReady = function () {
    if ($stateParams.batchId != null) {
      openBatch($stateParams.batchId);
    }
  };

  $scope.loadBatchesList = function () {
    $scope.selected = [];
    $scope.promise = $q(function (resolve, reject) {
      var params = $scope.getFilterParams();
      params['limit'] = $scope.filters.query.limit;
      params['offset'] = $scope.filters.query.limit * ($scope.filters.query.page - 1);
      params['sort'] = $scope.filters.query.order;

      batchService.getBatches(params, function (returnData) {
        var batchesList = returnData;
        var count = 0;
        if (params.offset <= 0 && returnData.length < params.limit) {
          count = returnData.length;
        } else {
          count = params.offset + (params.limit + 1);
        }
        $scope.loadBatchesListFromParent(batchesList, count);
        $scope.preventReloadWithFilters = false;
        resolve('Done');
      }, function (err) {
        reject('Error');
      });
    });
  };

  $scope.openBatchDesktop = function (batch) {
    $state.go('main.groupBatchDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, batchId: batch.id });
  };

  var openBatch = function openBatch(batch) {
    $scope.batchLoadingError = null;
    $scope.splitListFunc.slideTableListDetailOpen();
    $scope.listFull = false;
    $scope.detailView = 'batch';
    $scope.prepareForBatchFromParent(batch);
    batchService.getBatch(batch, function (fullBatch) {
      $scope.loadBatchFromParent(fullBatch);
    }, function (err) {
      $scope.batchLoadingError = "Error Getting Batch";
      $scope.batchLoadingErrorFull = err;
    });
  };

  var closeBatch = function closeBatch() {
    $scope.splitListFunc.slideTableListDetailClosed();
    $scope.listFull = true;
    $scope.clearBatchFromParent();
    return;
  };

  $scope.closeBatchDesktop = function () {
    $state.go('main.groupBatches', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
  };

  $scope.deleteBatch = function (batch) {
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete this batch?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        batchService.deleteBatch(batch, function () {
          $state.go('main.groupBatches', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }, function (err) {
          $scope.alertService.presentAutoAlert('deleteBatch', err);
        });
      }
    });
  };

  $scope.bulkBatchDelete = function () {
    var itemsToDelete = $scope.selected;
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete these " + itemsToDelete.length + " batches?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        batchService.deleteBulkBatches(itemsToDelete, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkBatches', { status: 202, requestName: 'Delete bulk batches - failures ' + failures.length + ' of ' + itemsToDelete.length });
            $scope.loadBatchesList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkBatches', { status: 200 });
            $scope.loadBatchesList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  /**************************/
  /***** Modal Controls *****/
  /**************************/

  $scope.newInteractionForResource = function (docket, resource, cb) {
    $scope.newInteractionCallback = cb;
    $scope.newInteractionFromParent(docket, resource, function (interaction) {
      $scope.newInteractionCallback(interaction);
    });
  };

  $scope.editInteractionForResource = function (interaction, docket, resource, cb) {
    $scope.editInteractionCallback = cb;
    $scope.editInteractionFromParent(docket, interaction, resource, function (interaction) {
      $scope.editInteractionCallback(interaction);
    });
  };

  $scope.captureSignatureForDocket = function (entity, nameRequired, name, terms, template, cb) {
    $scope.captureSignatureCallback = cb;
    $scope.captureSignatureFromParent(entity, nameRequired, name, terms, template, function (signatureObject) {
      $scope.captureSignatureCallback(signatureObject);
    });
  };

  $scope.editChecklistForDocket = function (checklistsData, checklist, cb) {
    $scope.checklistCallback = cb;
    $scope.openChecklistFromParent(checklistsData, checklist, function (checklistReturned) {
      $scope.checklistCallback(checklistReturned);
    });
  };

  /**** Summary Report Modal ****/

  $scope.openSummaryReport = function () {
    mixpanel.track("Clicked Open Docket Summary Report");
    $scope.summaryReport = { 'stage': 'filter', 'loading': false, 'includeSupporting': false, 'includeInteractionFields': false, 'aggregateInteractions': true, 'startDate': (0, _momentTimezone2.default)().toDate(), 'endDate': (0, _momentTimezone2.default)().toDate(), docType: 'pdf', status: ['draft', 'sent', 'accepted', 'rejected'], sortBy: 'docketNumber' };
    $("#summaryReportModal").fadeIn(100);
  };

  $scope.closeSummaryReportModal = function () {
    mixpanel.track("Abandoned Docket Summary Report");
    $("#summaryReportModal").fadeOut(100);
  };

  /**** File Code Report Modal ****/

  $scope.openFileCodeReport = function () {
    mixpanel.track("Clicked Open File Code Report");
    $scope.fileCodeReport = { 'stage': 'reportType', 'loading': false, 'billableOnly': false, 'startDate': (0, _momentTimezone2.default)().toDate(), 'endDate': (0, _momentTimezone2.default)().toDate(), docType: 'xlsx', status: ['draft', 'sent', 'accepted', 'rejected'] };
    $("#fileCodeReportModal").fadeIn(100);
  };

  $scope.closeFileCodeReportModal = function () {
    mixpanel.track("Abandoned File Code Report");
    $("#fileCodeReportModal").fadeOut(100);
  };

  $scope.dateChanged = function (date) {};

  $scope.fileCodeValid = function () {
    return true;
  };

  $scope.generateFileCodeReport = function (fileCodeReport) {
    mixpanel.track("Clicked Generate File Code Report");
    $scope.fileCodeReport.loading = true;
    var postBody = {
      'fromDate': (0, _momentTimezone2.default)($scope.fileCodeReport.startDate).format('YYYY-MM-DD'),
      'toDate': (0, _momentTimezone2.default)($scope.fileCodeReport.endDate).format('YYYY-MM-DD'),
      'docType': $scope.fileCodeReport.docType,
      'billableOnly': $scope.fileCodeReport.billableOnly,
      'type': $scope.fileCodeReport.type
    };

    if ($scope.fileCodeReport.customerContact) {
      var emailAddresses = [];
      for (var i = 0; i < $scope.fileCodeReport.customerContact.contactAddresses.length; i++) {
        emailAddresses.push($scope.fileCodeReport.customerContact.contactAddresses[i].emailAddress);
      }
      postBody.customer = emailAddresses;
    }
    if ($scope.fileCodeReport.supplierContact) {
      var emailAddresses = [];
      for (var i = 0; i < $scope.fileCodeReport.supplierContact.contactAddresses.length; i++) {
        emailAddresses.push($scope.fileCodeReport.supplierContact.contactAddresses[i].emailAddress);
      }
      postBody.supplier = emailAddresses;
    }
    if ($scope.fileCodeReport.status && $scope.fileCodeReport.status.length > 0) {
      postBody.statusList = $scope.fileCodeReport.status.join(',');
    }
    $http.post($scope.fullApiPath + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/docketfiles/report", postBody, {
      withCredentials: true
    }).success(function (res) {
      var json = res;
      $scope.fileCodeReport.generatedFiles = [];
      $scope.fileCodeReport.generatedFiles.push(json.url);
      $scope.fileCodeReport.loading = false;
      $scope.fileCodeReport.stage = "fileList";
      mixpanel.track("File Code Report Generated");
    }).error(function (err) {
      $scope.fileCodeReport.stage = 'error';
      $scope.fileCodeReport.loading = false;
      mixpanel.track("File Code Report Failed");
    });
  };

  $scope.statusSelected = function (statusObject, status) {
    if (statusObject && statusObject.indexOf(status) != -1) {
      return true;
    }

    return false;
  };

  $scope.toggleStatus = function (statusObject, status) {
    var index = statusObject.indexOf(status);
    if (index != -1) {
      statusObject.splice(index, 1);
    } else {
      statusObject.push(status);
    }
  };

  $scope.searchMembers = function (searchTerm) {
    return $q(function (resolve, reject) {
      userService.getMembers({ search: searchTerm }, function (membersList) {
        resolve(membersList);
      }, function (err) {
        reject();
      });
    });
  };

  $scope.toggleIncludeSupporting = function () {
    $scope.summaryReport.includeSupporting = !$scope.summaryReport.includeSupporting;
  };

  $scope.generateSummaryReport = function (summaryReport) {
    mixpanel.track("Clicked Generate Docket Summary Report");
    $scope.summaryReport.loading = true;
    var postBody = { 'fromDate': (0, _momentTimezone2.default)($scope.summaryReport.startDate).format('YYYY-MM-DD'), 'toDate': (0, _momentTimezone2.default)($scope.summaryReport.endDate).format('YYYY-MM-DD'), 'docType': $scope.summaryReport.docType };
    if ($scope.summaryReport.customerDisplayName) {
      postBody.customerDisplayName = $scope.summaryReport.customerDisplayName;
    }
    if ($scope.summaryReport.supplierDisplayName) {
      postBody.supplierDisplayName = $scope.summaryReport.supplierDisplayName;
    }
    if ($scope.summaryReport.customerContact) {
      var emailAddresses = [];
      for (var i = 0; i < $scope.summaryReport.customerContact.contactAddresses.length; i++) {
        emailAddresses.push($scope.summaryReport.customerContact.contactAddresses[i].emailAddress);
      }
      postBody.customerDisplayName = $scope.summaryReport.customerContact.displayName;
      postBody.customer = emailAddresses;
    }
    if ($scope.summaryReport.supplierContact) {
      var emailAddresses = [];
      for (var i = 0; i < $scope.summaryReport.supplierContact.contactAddresses.length; i++) {
        emailAddresses.push($scope.summaryReport.supplierContact.contactAddresses[i].emailAddress);
      }
      postBody.supplier = emailAddresses;
    }
    if ($scope.summaryReport.order) {
      postBody.orderRef = $scope.summaryReport.order.id;
    }
    if ($scope.summaryReport.status && $scope.summaryReport.status.length > 0) {
      postBody.statusList = $scope.summaryReport.status.join(',');
    }
    if ($scope.summaryReport.author) {
      postBody.author = $scope.summaryReport.author.id;
    }
    if ($scope.summaryReport.sortBy) {
      postBody.sort = $scope.summaryReport.sortBy;
    }
    postBody.includeSupporting = $scope.summaryReport.includeSupporting;
    postBody.includeInteractionFields = $scope.summaryReport.includeInteractionFields;
    postBody.aggregateInteractions = $scope.summaryReport.aggregateInteractions;
    $http.post($scope.fullApiPath + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/dockets/summarypdf", postBody, {
      withCredentials: true
    }).success(function (res) {
      var json = res;
      $scope.summaryReport.generatedFiles = [];
      $scope.summaryReport.generatedFiles.push(json.url);
      $scope.summaryReport.loading = false;
      $scope.summaryReport.stage = "fileList";
      mixpanel.track("Docket Summary Report Generated");
    }).error(function (err) {
      $scope.summaryReport.stage = 'error';
      $scope.summaryReport.loading = false;
      mixpanel.track("Docket Summary Report Failed");
    });
  };

  $scope.selectModalContactFilter = function (filterObject, contactField, modalFor) {
    $("#" + modalFor).hide();
    var existingContact = null;
    if (filterObject[contactField] != null && filterObject[contactField].id != null) {
      existingContact = filterObject[contactField];
    }
    $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
      if (contactSelected != null) {
        filterObject[contactField] = contactSelected;
      }
      $("#" + modalFor).show();
    });
  };

  $scope.selectModalOrderFilter = function (filterObject, modalFor) {
    $("#" + modalFor).hide();
    var options = {};
    if (filterObject.order) {
      options.currentOrder = filterObject.order;
    }
    if (filterObject.customerContact) {
      var emailAddresses = [];
      if (filterObject.customerContact.contactAddresses) {
        filterObject.customerContact.contactAddresses.forEach(function (contactAddress) {
          emailAddresses.push(contactAddress.emailAddress);
        });
      }
      options.customer = emailAddresses;
    }
    $scope.orderSelectFromParent(options, function (orderSelected) {
      if (orderSelected != null) {
        filterObject.order = orderSelected;
      }
      $("#" + modalFor).show();
    });
  };

  /**** Generate Docket Batch Modal ****/

  var checkAndPrefillCustomer = function checkAndPrefillCustomer(dockets, cb) {
    if (!$scope.filters.customerContact) {
      var docketCustomerContacts = {};
      //var otherError = false;
      for (var i = 0; i < dockets.length; i++) {
        if (!dockets[i].customerContact || !dockets[i].customerContact.displayName) {
          //otherError = true;
          break;
        }
        docketCustomerContacts[dockets[i].customerContact.displayName] = true;
      }

      var customerContactName = null;
      /*if ( otherError || Object.keys(docketCustomerContacts).length > 1 ) {
        $scope.newDocketBatch = {'stage':'listGeneratedError','loading':false,attachPDFDockets: true};
        $("#docketBatchModal").fadeIn(100);
        return;
      } else*/if (Object.keys(docketCustomerContacts).length == 1) {
        customerContactName = Object.keys(docketCustomerContacts)[0];

        addressBookService.getAddressBook({ search: customerContactName }, function (contactsFound) {
          if (contactsFound.length == 0) {
            cb(null);
            return;
          } else {
            var customerContactFound = contactsFound[0];
            if (customerContactFound.externalIdentifiers) {
              for (var i = 0; i < customerContactFound.externalIdentifiers.length; i++) {
                if (customerContactFound.externalIdentifiers[i].type == 'xero') {
                  customerContactFound.xeroContact = customerContactFound.externalIdentifiers[i];
                  break;
                }
              }
            }
            cb(customerContactFound);
          }
        }, function (err) {
          cb(null);
        });
      } else {
        cb(null);
      }
    } else {
      cb($scope.filters.customerContact);
    }
  };

  $scope.openDocketBatchModal = function (dockets) {
    //$scope.newDocketBatch = {'stage':'checkConnection','loading':false, 'startDate':moment().toDate(),'endDate':moment().toDate(),status:['draft','sent','accepted','rejected']};
    if (!dockets) {
      $scope.newDocketBatch = { 'method': 'filter', 'stage': 'identifier', 'loading': false, 'startDate': (0, _momentTimezone2.default)().toDate(), 'endDate': (0, _momentTimezone2.default)().toDate(), status: ['sent', 'accepted'], uninvoicedDockets: true, attachPDFDockets: true, invoiceType: 'lines' };
    } else {
      checkAndPrefillCustomer(dockets, function (customerContactPrefilled) {
        var todaysDate = (0, _momentTimezone2.default)().toDate();
        // check dockets all have the same customerContact
        var docketIds = [];
        var customersDetected = {};
        var customerRefNosDetected = {};
        //for ( var i = 0; i < dockets.length; i++ ) {
        dockets.filter(function (docket) {
          return docket.customerContact;
        }).forEach(function (docket) {
          docketIds.push(docket.id);
          if (!customersDetected[docket.customerContact.displayName]) {
            customersDetected[docket.customerContact.displayName] = {};
          }
          if (docket.customerRefNo && docket.customerRefNo != undefined && !customerRefNosDetected[docket.customerRefNo]) {
            customerRefNosDetected[docket.customerRefNo] = 1;
          }
          var contactKeys = Object.keys(docket.customerContact.contactAddresses);
          for (var j = 0; j < contactKeys.length; j++) {
            if (!customersDetected[docket.customerContact.displayName][contactKeys[j]]) {
              customersDetected[docket.customerContact.displayName][contactKeys[j]] = 1;
            }
          }
        });
        docketIds = docketIds.join(',');
        var customersDetectedKeys = Object.keys(customersDetected);
        var customerRefNosDetectedKeys = Object.keys(customerRefNosDetected);
        $scope.newDocketBatch = { 'method': 'docketsSelected', 'stage': 'preconfigure', 'loading': false, attachPDFDockets: true, docketIds: docketIds, date: todaysDate };
        if (customerContactPrefilled) {
          $scope.newDocketBatch.customerContact = customerContactPrefilled;
        } /*else {
          $scope.newDocketBatch = {'stage':'listGeneratedError','loading':false,attachPDFDockets: true, docketIds: docketIds};
          $("#docketBatchModal").fadeIn(100);
          return;
          }*/
        $scope.newDocketBatch.invoiceType = 'lines';
        // if all dockets have same customerRefNo - prefill
        if (customerRefNosDetectedKeys.length == 1) {
          $scope.newDocketBatch.localIdentifier = customerRefNosDetectedKeys[0];
        }
      });
    }
    $("#docketBatchModal").fadeIn(100);
  };

  $scope.closeDocketBatchModal = function () {
    $("#docketBatchModal").fadeOut(100);
    $scope.loadBatchesList();
  };

  $scope.docketBatchIdentifierNext = function () {
    // check that special characters aren't in localIdentifier field
    var invalidChars = ['/', '&', '#', '?', '%', '\\'];
    if (invalidChars.map(function (char) {
      return $scope.newDocketBatch.localIdentifier.indexOf(char) != -1;
    }).filter(function (x) {
      return x == true;
    }).length > 0) {
      $scope.alertService.presentAlert('warning', 'Invalid Field Value', '/, \\, #, %, ? and & characters are not permitted in this field. Please update your reference and try again.');
      return;
    }
    if ($scope.newDocketBatch.docketIds != null) {
      $scope.generateDocketBatch();
    } else {
      $scope.newDocketBatch.stage = 'filter';
    }
  };

  $scope.generateDocketBatch = function () {
    $scope.newDocketBatch.loading = true;
    var postBody = {};
    if ($scope.newDocketBatch.startDate && $scope.newDocketBatch.endDate) {
      postBody.fromDate = (0, _momentTimezone2.default)($scope.newDocketBatch.startDate).format('YYYY-MM-DD');
      postBody.toDate = (0, _momentTimezone2.default)($scope.newDocketBatch.endDate).format('YYYY-MM-DD');
    }
    if ($scope.newDocketBatch.uninvoicedDockets) {
      postBody.uninvoiced = true;
    }
    // only filter by the customer contact if we don't already know the dockets selected for the batch
    if ($scope.newDocketBatch.customerContact && !$scope.newDocketBatch.docketIds) {
      var emailAddresses = [];
      for (var i = 0; i < $scope.newDocketBatch.customerContact.contactAddresses.length; i++) {
        emailAddresses.push($scope.newDocketBatch.customerContact.contactAddresses[i].emailAddress.toLowerCase());
      }
      if (emailAddresses.length > 0) {
        postBody.customer = emailAddresses.join(',');
      }
    }
    if ($scope.newDocketBatch.order) {
      postBody.orderRef = $scope.newDocketBatch.order.id;
    }
    if ($scope.newDocketBatch.status && $scope.newDocketBatch.status.length > 0) {
      postBody.statusList = $scope.newDocketBatch.status.join(',');
    }
    if ($scope.newDocketBatch.docketIds) {
      postBody.ids = $scope.newDocketBatch.docketIds;
    }
    docketService.getDockets(postBody, function (dockets) {
      // get docket ids
      var docketIds = [];
      dockets.forEach(function (docket) {
        docketIds.push(docket.id);
      });
      var identifier = $scope.newDocketBatch.localIdentifier.toUpperCase().replace(/\s/g, '');
      var attributionObj = {};
      if ($scope.newDocketBatch.customerContact) {
        attributionObj.customer = { addressBookId: $scope.newDocketBatch.customerContact.id };
      }
      if ($scope.newDocketBatch.supplierContact) {
        attributionObj.supplier = { addressBookId: $scope.newDocketBatch.supplierContact.id };
      }
      var invoiceDate = (0, _momentTimezone2.default)().format('YYYY-MM-DD');
      if ($scope.newDocketBatch.date) {
        invoiceDate = (0, _momentTimezone2.default)($scope.newDocketBatch.date).format('YYYY-MM-DD');
      }
      var docketBatchPostObj = {};
      if ($scope.newDocketBatch.batchFull && $scope.newDocketBatch.batchFull.id != null) {
        var existingDocketIds = [];
        if ($scope.newDocketBatch.batchFull.dockets) {
          existingDocketIds = $scope.newDocketBatch.batchFull.dockets;
        }
        var removeDocketIds = [];
        for (var i = 0; i < existingDocketIds.length; i++) {
          if (docketIds.indexOf(existingDocketIds[i]) == -1) {
            removeDocketIds.push(existingDocketIds[i]);
          }
        }
        docketBatchPostObj = { date: invoiceDate, id: $scope.newDocketBatch.batchFull.id, dockets: { remove: removeDocketIds, add: docketIds }, attribution: attributionObj };
      } else {
        docketBatchPostObj = { date: invoiceDate, localIdentifier: identifier, dockets: docketIds, attribution: attributionObj };
      }
      batchService.saveBatch(docketBatchPostObj, function (batchCreated) {
        batchService.getBatch(batchCreated.id, function (batchFull) {
          $scope.newDocketBatch.stage = 'itemSummary';
          $scope.newDocketBatch.batchFull = batchFull;
          for (var i = 0; i < $scope.newDocketBatch.batchFull.aggregations.length; i++) {
            $scope.newDocketBatch.batchFull.aggregations[i].export = true;
          }
          $scope.newDocketBatch.loading = false;
        }, function (err) {
          $scope.newDocketBatch.loading = false;
          $scope.newDocketBatch.stage = 'error';
        });
      }, function (err) {
        if (err.status == 409) {
          $scope.newDocketBatch.errorType = "exists";
        }
        $scope.newDocketBatch.loading = false;
        $scope.newDocketBatch.stage = 'error';
      });
    }, function (err) {
      $scope.newDocketBatch.loading = false;
      $scope.newDocketBatch.stage = 'error';
    });
  };

  $scope.updateBatchItems = function () {
    $scope.newDocketBatch.loading = true;
    var selectedResources = [];

    $scope.newDocketBatch.batchFull.aggregations.forEach(function (aggregate) {
      if (aggregate.export == true) {
        selectedResources.push({ resourceId: aggregate.resource.id, interactionName: aggregate.interactionName });
      }
    });
    var batchUpdate = { id: $scope.newDocketBatch.batchFull.id, selectedResources: { add: selectedResources } };
    batchService.saveBatch(batchUpdate, function (batchUpdated) {
      batchService.getBatch(batchUpdated.id, function (batchFull) {
        $scope.newDocketBatch.batchFull = batchFull;
        if (!$scope.newDocketBatch.customerContact || $scope.newDocketBatch.customerContact.xeroContact == null || $scope.newDocketBatch.customerContact.xeroContact.externalId == null) {
          $scope.newDocketBatch.requiresXeroContactSync = true;
          xeroService.getXeroContacts(function (contacts) {
            $scope.xeroContacts = contacts;
            $scope.newDocketBatch.stage = 'invoiceDetails';
            $scope.newDocketBatch.loading = false;
            if ($scope.newDocketBatch.method == 'docketsSelected') {
              $scope.newDocketBatch.stage = 'creatingInvoice';
            }

            if ($scope.newDocketBatch.order && $scope.newDocketBatch.order.customerContact) {
              addressBookService.getAddressBook({ search: $scope.newDocketBatch.order.customerContact.displayName }, function (contactItems) {
                if (contactItems[0] != undefined) {
                  var xeroId = contactItems[0].externalIdentifiers.filter(function (x) {
                    return x.type == 'xero';
                  })[0].externalId;
                  if (xeroId) {
                    var xeroContact = $scope.xeroContacts.find(function (contact) {
                      return contact.externalId == xeroId;
                    });
                    $scope.newDocketBatch.selectedXeroContact = xeroContact;
                  }
                }
              });
            }
          }, function (err) {
            $scope.newDocketBatch.stage = 'invoiceDetails';
            $scope.newDocketBatch.loading = false;
          });
        } else {
          $scope.newDocketBatch.requiresXeroContactSync = false;
          $scope.newDocketBatch.stage = 'invoiceDetails';
          $scope.newDocketBatch.loading = false;
          if ($scope.newDocketBatch.method == 'docketsSelected') {
            $scope.newDocketBatch.loading = true;
            $scope.newDocketBatch.stage = 'creatingInvoice';
            $scope.createBatchInvoice();
          }
        }
      }, function (err) {
        $scope.newDocketBatch.stage = 'error';
        $scope.newDocketBatch.loading = false;
      });
    }, function (err) {
      $scope.newDocketBatch.stage = 'error';
      $scope.newDocketBatch.loading = false;
    });
  };

  $scope.createBatchInvoice = function () {
    $scope.newDocketBatch.loading = true;
    /*if ( $scope.newDocketBatch.requiresXeroContactSync && $scope.newDocketBatch.customerContact ) {
      // sync with customer contact
      var contact = {id: $scope.newDocketBatch.customerContact.id, externalIdentifiers: {add:[{type:'xero', externalId: $scope.newDocketBatch.selectedXeroContact.externalId}]} };
       addressBookService.saveContact(contact, function(contactUpdated) {
        doInvoiceCreation();
      }, function(err) {
        $scope.newDocketBatch.loading = false;
        $scope.alertService.presentAutoAlert('');
      });
    } else*/{
      doInvoiceCreation();
    }
  };

  // target: 'selection', xeroCustomerId: externalidentifier

  var doInvoiceCreation = function doInvoiceCreation() {
    var postObj = { id: $scope.newDocketBatch.batchFull.id, type: $scope.newDocketBatch.invoiceType, target: 'customer', includeSupporting: $scope.newDocketBatch.attachPDFDockets };

    if ($scope.newDocketBatch.requiresXeroContactSync && $scope.newDocketBatch.selectedXeroContact) {
      postObj.target = 'selection';
      postObj.xeroCustomerId = $scope.newDocketBatch.selectedXeroContact.externalId;
    }

    xeroService.createXeroInvoice(postObj, function (invoiceResponse) {
      if (invoiceResponse.localIdentifier) {
        $scope.newDocketBatch.loading = false;
        $scope.newDocketBatch.stage = 'success';
        $scope.newDocketBatch.batchFull = invoiceResponse;
      } else if (!invoiceResponse.jobId) {
        $scope.newDocketBatch.loading = false;
        $scope.newDocketBatch.stage = 'error';
      } else {
        checkForInvoiceCreationCompletion(invoiceResponse.jobId);
      }
    }, function (err) {
      $scope.newDocketBatch.loading = false;
      $scope.newDocketBatch.stage = 'error';
    });
  };

  var checkForInvoiceCreationCompletion = function checkForInvoiceCreationCompletion(jobId) {
    $timeout(function () {
      userService.getTaskStatus(jobId, function (taskInfo) {
        if (taskInfo.status == 'Failed') {
          $scope.newDocketBatch.loading = false;
          $scope.newDocketBatch.stage = 'error';
          $scope.newDocketBatch.errorType = 'complex';
          $scope.newDocketBatch.displayComplexError = false;
          $scope.newDocketBatch.complexErrorMessage = taskInfo.eventLog;
        } else if (taskInfo.status != 'Complete') {
          checkForInvoiceCreationCompletion(jobId);
        } else {
          // get full batch to insert new InvoiceID
          batchService.getBatch($scope.newDocketBatch.batchFull.id, function (batchFull) {
            $scope.newDocketBatch.loading = false;
            $scope.newDocketBatch.stage = 'success';
            $scope.newDocketBatch.batchFull = batchFull;
          }, function (err) {
            $scope.newDocketBatch.loading = false;
            $scope.newDocketBatch.stage = 'error';
          });
        }
      }, function (err) {});
    }, 3000);
  };

  /*******************************/
  /***** Docket Data Helpers *****/
  /*******************************/

  $scope.invoiceSelectedDockets = function () {
    $scope.openDocketBatchModal($scope.selected);
    //$state.go('main.groupBatches', {orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, action:'newbatch', fromDocketsList:ids});
  };

  // Bulk Invoice Summary
  $scope.bulkSelectionSummary = function () {
    var ids = [];
    for (var i = 0; i < $scope.selected.length; i++) {
      ids.push($scope.selected[i].id);
    }

    ids = ids.join(',');

    var url = '/v1/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/downloadinvoicesummary?ids=' + ids;
    window.open(url, "_blank");
  };

  // Bulk Delete
  $scope.bulkSelectionDelete = function () {
    var itemsToDelete = $scope.selected;
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete these " + itemsToDelete.length + " dockets?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteBulkDockets(itemsToDelete, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkDockets', { status: 202, requestName: 'Delete bulk dockets - failures ' + failures.length + ' of ' + itemsToDelete.length });
            $scope.loadDocketsList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkDockets', { status: 200 });
            $scope.loadDocketsList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  $scope.bulkSelectionSend = function () {
    var itemsToAct = $scope.selected;

    swal({
      title: "Are you sure?",
      text: "Do you really want to send these " + itemsToAct.length + " dockets?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, send them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.sendBulkDockets(itemsToAct, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('sendBulkDockets', { status: 202, requestName: 'Send bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length });
            $scope.loadDocketsList();
          } else {
            $scope.alertService.presentAutoAlert('sendBulkDockets', { status: 200 });
            $scope.loadDocketsList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  $scope.bulkSelectionReject = function () {
    $scope.rejectReason.text = '';
    $scope.bulkReject = true;
    $scope.rejectingDockets = $scope.selected.slice();
    if ($scope.rejectingDockets.length == 1) {
      $scope.rejectingDocket = $scope.rejectingDockets[0];
    }
    $("#rejectDocketModal").fadeIn(100);
  };

  $scope.bulkSelectionAccept = function () {
    var itemsToAct = $scope.selected;
    swal({
      title: "Are you sure?",
      text: "Do you really want to accept these " + itemsToAct.length + " dockets?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, accept them!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.acceptBulkDockets(itemsToAct, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('acceptBulkDockets', { status: 202, requestName: 'Accept bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length });
            $scope.loadDocketsList();
          } else {
            $scope.alertService.presentAutoAlert('acceptBulkDockets', { status: 200 });
            $scope.loadDocketsList();
          }
          $scope.selected = [];
        });
      }
    });
  };

  $scope.bulkSelectionExport = function () {
    var itemsToExport = [];
    for (var i = 0; i < $scope.selected.length; i++) {
      if ($scope.selected[i].id) {
        itemsToExport.push($scope.selected[i].id);
      }
    }

    var url = "/v1/organisations/" + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/dockets?export=true&ids=" + itemsToExport.join(',');
    window.open(url, "_blank");
  };

  /*******************/
  /***** Filters *****/
  /*******************/

  $scope.toggleFilters = function () {
    $scope.showFilters = !$scope.showFilters;
  };

  $scope.getFilterParams = function () {
    var params = {};
    params.timezone = _momentTimezone2.default.tz.guess();
    if ($scope.filters.startDate != null) {
      var fromDate = (0, _momentTimezone2.default)($scope.filters.startDate);
      params.fromDate = fromDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.endDate != null) {
      var toDate = (0, _momentTimezone2.default)($scope.filters.endDate);
      params.toDate = toDate.format('YYYY-MM-DD');
    }
    if ($scope.filters.status != 'All') {
      params.status = $scope.filters.status;
    }
    if ($scope.filters.fileStatusTab != 'all') {
      params.fileStatus = $scope.filters.fileStatusTab;
    }
    if ($scope.filters.customerGroup != null) {
      params.customerGroup = $scope.filters.customerGroup;
    }
    if ($scope.filters.supplierGroup != null) {
      params.supplierGroup = $scope.filters.supplierGroup;
    }
    if ($scope.filters.otherParty != 'All') {
      if ($scope.filters.otherParty.organisationGroup != null) {
        params.otherParty = $scope.filters.otherParty.organisationGroup;
      } else {
        var parsed = JSON.parse($scope.filters.otherParty);
        if (parsed.organisationGroup) {
          params.otherParty = parsed.organisationGroup;
        } else {
          params.otherParty = parsed.id;
        }
      }
    }
    if ($scope.filters.order != null && $scope.filters.order.id != null) {
      params.orderRef = $scope.filters.order.id;
    }
    if ($scope.filters.job != null && $scope.filters.job.id != null) {
      params.jobRef = $scope.filters.job.id;
    }
    if ($scope.filters.customerContact != null) {
      if ($scope.filters.customerContact.contactAddresses.length > 0) {
        var customerAddresses = [];
        for (var i = 0; i < $scope.filters.customerContact.contactAddresses.length; i++) {
          customerAddresses.push($scope.filters.customerContact.contactAddresses[i].emailAddress);
        }
        params.customer = customerAddresses.join(',');
      } else {
        params.customerDisplayName = $scope.filters.customerContact.displayName;
      }
    }
    if ($scope.filters.supplierContact != null) {
      var supplierAddresses = [];
      for (var i = 0; i < $scope.filters.supplierContact.contactAddresses.length; i++) {
        supplierAddresses.push($scope.filters.supplierContact.contactAddresses[i].emailAddress);
      }
      params.supplier = supplierAddresses.join(',');
    }
    if ($scope.filters.customerDisplayName != null) {
      params.customerDisplayName = $scope.filters.customerDisplayName;
    }
    if ($scope.filters.supplierDisplayName != null) {
      params.supplierDisplayName = $scope.filters.supplierDisplayName;
    }
    if ($scope.filters.customerSignatureName != null && $scope.filters.customerSignatureName != "") {
      params.customerSignatureName = $scope.filters.customerSignatureName;
    }
    if ($scope.filters.acceptedBy != null && $scope.filters.acceptedBy != "") {
      params.acceptedBy = $scope.filters.acceptedBy;
    }
    if ($scope.filters.docketNumber != null && $scope.filters.docketNumber != "") {
      params.docketNumber = $scope.filters.docketNumber;
    }
    if ($scope.filters.customerRefNo != null && $scope.filters.customerRefNo != "") {
      params.customerRefNo = $scope.filters.customerRefNo;
    }
    if ($scope.filters.supplierRefNo != null && $scope.filters.supplierRefNo != "") {
      params.supplierRefNo = $scope.filters.supplierRefNo;
    }
    if ($scope.filters.author != null && $scope.filters.author != "") {
      params.authorName = $scope.filters.author;
    }

    return params;
  };

  $scope.clearFilterDateSet = function (field1, field2) {
    $scope.filters[field1] = null;
    $scope.filters[field2] = null;
  };

  $scope.searchDocketsChange = function (value) {
    $scope.loadDocketsList(value);
  };

  $scope.clearFilterItem = function (name) {
    $scope.filters[name] = null;
    $scope.filtersChanged(name);
  };

  $scope.clearCustomFilterItem = function (customItem) {
    customItem.value = '';
    customItem.display = false;
    $scope.filtersChanged(customItem.fieldName);
  };

  $scope.clearFilters = function () {
    $scope.filters.order = null;
    $scope.filters.job = null;
    $scope.filters.customerContact = null;
    $scope.filters.supplierContact = null;
    $scope.filters.customerDisplayName = null;
    $scope.filters.supplierDisplayName = null;
    $scope.filters.customerSignatureName = null;
    $scope.filters.acceptedBy = null;
    $scope.filters.docketNumber = null;
    $scope.filters.customerRefNo = null;
    $scope.filters.supplierRefNo = null;
    $scope.filters.author = null;
    $scope.filters.custom = $scope.currentOrg && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.customColumns ? $scope.currentOrg.features.dockets.customColumns.map(function (fieldName) {
      return { fieldName: fieldName, prettyName: fieldName.match(/[A-Z][a-z,1-9]+/g).join(' '), display: false, value: '' };
    }) : [];
    for (var i in statusFilterOptions) {
      $scope.filters.statusOptions[statusFilterOptions[i]] = true;
    }
    $scope.filters.statusOptions.allView = true;
    $scope.filters.statusOptions.all = true;
    // reset date filters
    $scope.filters.startDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate(); //startFromDate
    $scope.filters.endDate = (0, _momentTimezone2.default)().toDate(); //endToDate
    $scope.dateFilterModel.dateStart = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.dateFilterModel.dateEnd = (0, _momentTimezone2.default)().toDate();
    $scope.filtersChanged('cleared');
    window.location.reload();
  };

  $scope.resetAllFilters = function () {
    // SETUP filters
    $scope.filters = {};
    $scope.filters.otherParty = "All";
    $scope.filters.statusTab = "All";
    $scope.filters.status = 'All';
    $scope.filters.fileStatusTab = 'all';
    $scope.filters.batchStatusTab = 'all';
    $scope.filters.organisation = 'All';
    $scope.filters.startDate = null;
    $scope.filters.endDate = null;
    $scope.filters.customerGroup = null;
    $scope.filters.docketNumber = null;
    $scope.filters.customerRefNo = null;
    $scope.filters.supplierRefNo = null;
    $scope.filters.author = null;
    $scope.filters.supplierGroup = null;
    $scope.filters.customerDisplayName = null;
    $scope.filters.supplierDisplayName = null;
    $scope.filters.customerSignatureName = null;
    $scope.filters.custom = $scope.currentOrg && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.customColumns ? $scope.currentOrg.features.dockets.customColumns.map(function (fieldName) {
      return { fieldName: fieldName, prettyName: fieldName.match(/[A-Z][a-z,1-9]+/g).join(' '), display: false, value: '' };
    }) : [];
    $scope.filters.acceptedBy = null;
  };

  $scope.setComplexFilter = function (filterName) {
    if (filterName == 'sentDockets') {
      $scope.filters.statusTab = "Sent";
      $scope.filters.status = "Sent";
      if ($scope.currentOrgGroup) {
        $scope.filters.supplierGroup = $scope.currentOrgGroup.id;
      } else {
        $scope.filters.supplierGroup = null;
      }
      $scope.filters.customerGroup = null;
    } else if (filterName == 'recievedDockets') {
      $scope.filters.statusTab = "Recieved";
      $scope.filters.status = "Sent";
      if ($scope.currentOrgGroup != null) {
        $scope.filters.customerGroup = $scope.currentOrgGroup.id;
      } else {
        $scope.filters.customerGroup = null;
      }
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'draftDockets') {
      $scope.filters.statusTab = "Draft";
      $scope.filters.status = "Draft";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'acceptedDockets') {
      $scope.filters.statusTab = "Accepted";
      $scope.filters.status = "Accepted";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'rejectedDockets') {
      $scope.filters.statusTab = "Rejected";
      $scope.filters.status = "Rejected";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'allDockets') {
      $scope.filters.statusTab = "All";
      $scope.filters.status = "All";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    }
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /*****************************/
  /***** Date/Time Pickers *****/
  /*****************************/

  $scope.selectDate = function (dateObject, field, ev) {
    $mdpDatePicker(dateObject[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      dateObject[field] = selectedDate;
    });
  };

  $scope.showDatePicker = function (field, ev) {
    $mdpDatePicker($scope.itemEdit[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      $scope.itemEdit[field] = selectedDate;
    });
  };

  $scope.showTimePicker = function (field, ev) {
    $mdpTimePicker($scope.itemEdit[field], {
      targetEvent: ev,
      autoSwitch: true
    }).then(function (selectedTime) {
      $scope.itemEdit[field] = selectedTime;
    });
  };

  /***********************************/
  /***** Last geolocation helper *****/
  /***********************************/

  var timeoutPromise = null;

  $scope.updateGeolocation = function (firstTime) {
    var getLocation = false;
    var minutesElapsed = _momentTimezone2.default.duration((0, _momentTimezone2.default)().diff($scope.lastGeolocationCheck)).asMinutes();
    if (minutesElapsed > 2 || firstTime == true) {
      getLocation = true;
    } else {
      getLocation = false;
    }
    if (getLocation) {
      navigator.geolocation.getCurrentPosition(function (data) {
        $scope.lastGeolocation = { lat: data.coords.latitude, long: data.coords.longitude, time: (0, _momentTimezone2.default)() };
        $scope.lastGeolocationCheck = (0, _momentTimezone2.default)();
        timeoutPromise = $timeout(function () {
          $scope.updateGeolocation();
        }, 10000);
      }, function (err) {
        $scope.lastGeolocationCheck = (0, _momentTimezone2.default)();
        timeoutPromise = $timeout(function () {
          $scope.updateGeolocation();
        }, 10000);
      });
    } else {
      timeoutPromise = $timeout(function () {
        $scope.updateGeolocation();
      }, 10000);
    }
  };

  $scope.updateGeolocation(true);

  $scope.$on('$destroy', function () {
    if (timeoutPromise) {
      $timeout.cancel(timeoutPromise);
    }
  });

  // Load dockets list after child controller is ready
  $scope.docketsChildControllerReady = function () {
    if ($scope.listView == 'dockets') {
      // check stateParams for any filter presets
      if ($scope.currentOrg && sessionStorage.getItem('docketsList') != undefined) {
        // check if last stored orders filters is the same as current filters
        var lastDocketsFilters = {};
        if (sessionStorage.getItem('docketsLastFilters')) {
          lastDocketsFilters = JSON.parse(sessionStorage.getItem('docketsLastFilters'));
        }
        var loadNew = false;
        if (sessionStorage.getItem('filters')) {
          var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
          if (storedFilters.reloadRequired == true) {
            loadNew = true;
            $scope.filters.reloadRequired = false;
          }
        }
        if (lastDocketsFilters && lastDocketsFilters != undefined) {
          if (lastDocketsFilters.organisationId != $scope.currentOrg.id || lastDocketsFilters.groupId != $scope.currentOrgGroup.id) {
            loadNew = true;
            $scope.filters.job = null;
            $scope.filters.order = null;
          }
          if (lastDocketsFilters.startDate && (0, _momentTimezone2.default)(lastDocketsFilters.startDate).diff((0, _momentTimezone2.default)($scope.filters.startDate), 'days') != 0) {
            loadNew = true;
          } else if (lastDocketsFilters.endDate && (0, _momentTimezone2.default)(lastDocketsFilters.endDate).diff((0, _momentTimezone2.default)($scope.filters.endDate), 'days') != 0) {
            loadNew = true;
          }
          // check if status options have changed
          if (lastDocketsFilters.statusOptions.all == true && $scope.filters.statusOptions.all != true) {
            loadNew = true;
          } else {
            for (var i = 0; i < statusFilterOptions.length; i++) {
              if (lastDocketsFilters.statusOptions[statusFilterOptions[i]] != $scope.filters.statusOptions[statusFilterOptions[i]]) {
                loadNew = true;
              }
            }
          }
          if (lastDocketsFilters.customerSignatureOptions) {
            $scope.filters.customerSignatureOptions = lastDocketsFilters.customerSignatureOptions;
          }
          if (lastDocketsFilters.filedOptions) {
            $scope.filters.filedOptions = lastDocketsFilters.filedOptions;
          }
          if (lastDocketsFilters.customerContact && !$scope.filters.customerContact) {
            loadNew = true;
          } else if (!lastDocketsFilters.customerContact && $scope.filters.customerContact) {
            loadNew = true;
          } else if (!lastDocketsFilters.customerContact && !$scope.filters.customerContact) {
            // do nothing
          } else if (lastDocketsFilters.customerContact.id != $scope.filters.customerContact.id) {
            loadNew = true;
          }
          if (lastDocketsFilters.supplierContact && !$scope.filters.supplierContact) {
            loadNew = true;
          } else if (!lastDocketsFilters.supplierContact && $scope.filters.supplierContact) {
            loadNew = true;
          } else if (!lastDocketsFilters.supplierContact && !$scope.filters.supplierContact) {
            // do nothing
          } else if (lastDocketsFilters.supplierContact.id != $scope.filters.supplierContact.id) {
            loadNew = true;
          }
          if (lastDocketsFilters.supplierDisplayName != $scope.filters.supplierDisplayName) {
            loadNew = true;
          }
          if (lastDocketsFilters.customerSignatureName != $scope.filters.customerSignatureName) {
            loadNew = true;
          }
          /*if ( _.difference(lastDocketsFilters.custom, $scope.filters.custom).length > 0 ) {
            loadNew = true
          }*/
          if (lastDocketsFilters.acceptedBy != $scope.filters.acceptedBy) {
            loadNew = true;
          }
          if (lastDocketsFilters.customerDisplayName != $scope.filters.customerDisplayName) {
            loadNew = true;
          }
        } else {
          // no previous filters stored, load new list
          loadNew = true;
        }
        // check if order filter has changed
        if (lastDocketsFilters.order && !$scope.filters.order) {
          loadNew = true;
        } else if (!lastDocketsFilters.order && $scope.filters.order) {
          loadNew = true;
        } else if (!lastDocketsFilters.order && !$scope.filters.order) {
          // do nothing
        } else if (lastDocketsFilters.order.id != $scope.filters.order.id) {
          loadNew = true;
        }
        // check if job filter has changed
        if (lastDocketsFilters.job && !$scope.filters.job) {
          loadNew = true;
        } else if (!lastDocketsFilters.job && $scope.filters.job) {
          loadNew = true;
        } else if (!lastDocketsFilters.job && !$scope.filters.job) {
          // do nothing
        } else if (lastDocketsFilters.job.id != $scope.filters.job.id) {
          loadNew = true;
        }

        if (loadNew) {
          $scope.filters.query.page = 1;
          $scope.loadDocketsList();
        } else {
          var docketsListParsed = JSON.parse(sessionStorage.getItem('docketsList'));
          var docketsListCount = JSON.parse(sessionStorage.getItem('docketsListCount'));
          $scope.loadDocketsListFromParent(docketsListParsed, docketsListCount);
          if ($scope.currentOrg != null) {
            $scope.loadDocketsListFiledStatus(docketsListParsed);
          }
          $scope.preventReloadWithFilters = false;
        }
      } else {
        $scope.loadDocketsList();
      }
    }
  };

  $scope.showUpgradePlanModal = function (_, feature, trackingText) {
    $scope.selectPlan(null, feature, trackingText);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "Kq0E":
/***/ (function(module, exports) {

var path = 'views/modals/selectLineModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectLineModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Line To Add To Job</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeLineSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <md-table-container ng-show=\"lineItemList.length > 0\">\n        <table md-table multiple md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Resource</th>\n              <th md-column>Quantity</th>\n              <td md-column>Description</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"lineItem in lineItemList\" md-select=\"lineItem\" md-auto-select md-select-id=\"id\" ng-disabled=\"lineItem.disabled || lineItem.resource == null\" class=\"{{ (lineItem.disabled || lineItem.resource == null) ? 'disabled' : '' }}\">\n              <td md-cell>\n                {{lineItem.resource.name}}\n              </td>\n              <td md-cell>\n                <span ng-show=\"lineItem.resource.uom.isTime\">\n                  <span ng-show=\"!userCanDoAction('editLineItemJob', itemEdit)\">\n                    {{formatTimeQuantity(lineItem.quantity, lineItem.resource.uom.abbreviation)}}\n                  </span>\n                  <span ng-show=\"userCanDoAction('editLineItemJob', itemEdit)\">\n                    <div layout-gt-sm=\"row\">\n                      <md-input-container flex-gt-sm class=\"md-block\">\n                        <label>Hours</label>\n                        <input type=\"text\" ng-model=\"lineItem.quantityHoursEdit\" aria-label=\"Line Item Hours Quantity\">\n                      </md-input-container>\n                      <md-input-container flex-gt-sm class=\"md-block\">\n                        <label>Minutes</label>\n                        <input type=\"text\" ng-model=\"lineItem.quantityMinutesEdit\" aria-label=\"Line Item Minutes Quantity\">\n                      </md-input-container>\n                    </div>\n                  </span>\n                </span>\n                <span ng-show=\"!lineItem.resource.uom.isTime\">\n                  <span ng-show=\"!userCanDoAction('editLineItemJob', itemEdit)\">\n                    {{lineItem.quantity}} {{lineItem.resource.uom.abbreviation}}\n                  </span>\n                  <span ng-show=\"userCanDoAction('editLineItemJob', itemEdit)\">\n                    <md-input-container class=\"md-block\">\n                      <label>{{lineItem.resource.uom.abbreviation}}</label>\n                      <input type=\"text\" ng-model=\"lineItem.quantityEdit\" aria-label=\"Line Item Quantity\">\n                    </md-input-container>\n                  </span>\n                </span>\n              </td>\n              <td md-cell>\n                {{lineItem.itemDescription}}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n          <span ng-show=\"desktopSelected.length > 1\">\n            {{desktopSelected.length}} line items will be added to this job.\n          </span>\n          <span ng-show=\"desktopSelected.length == 1\">\n            1 line item will be added to this job.\n          </span>\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeLineSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || desktopSelectLinesContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "KvAG":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/signaturesTab.html';
var html = "<div class=\"ojdRow\">\n  <div class=\"ojdField\" ng-click=\"!userCanDoAction('captureSupplierSignature', itemEdit) || captureSignature('supplierSignature')\">\n    <h1>Operator</h1>\n    <span ng-if=\"itemEdit.supplierSignatureAttachment && itemEdit.supplierSignatureAttachment != '' && currentOrg != null\">\n      <img ng-src=\"{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.supplierSignatureAttachment}}\" height=\"90px\">\n    </span>\n    <span ng-if=\"itemEdit.supplierSignatureAttachment && itemEdit.supplierSignatureAttachment != '' && currentOrg == null\">\n      <img ng-src=\"{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.supplierSignatureAttachment}}\" height=\"90px\">\n    </span>\n    <span ng-if=\"itemEdit.supplierSignatureImage\">\n      <img ng-src=\"{{itemEdit.supplierSignatureImage}}\" height=\"90px\">\n    </span>\n    <h3 ng-if=\"itemEdit.status != 'Sent' && ( itemEdit.supplierSignatureAttachment == null || itemEdit.supplierSignatureAttachment == '' ) && itemEdit.supplierSignatureImage == null\">\n      <span ng-show=\"itemEdit.editing\">Click to capture signature</span>\n      <span ng-show=\"!itemEdit.editing\">No Signature Captured</span>\n    </h3>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField\" ng-click=\"userCanDoAction('captureCustomerSignature', itemEdit) ? captureSignature('customerSignature') : (userCanDoAction('captureCustomerSignatureFromCustomer', itemEdit) && !itemEdit.customerSignatureAttachment && !itemEdit.customerSignatureImage) ? captureCustomerSignatureFromCustomer(): false\">\n    <h1>Customer<span ng-if=\"itemEdit.customerSignatureName\"> ({{itemEdit.customerSignatureName}})</span></h1>\n    <span ng-if=\"!itemEdit.customerSignatureImage && itemEdit.customerSignatureAttachment && itemEdit.customerSignatureAttachment != '' && currentOrg != null\">\n      <img ng-src=\"{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.customerSignatureAttachment}}\" height=\"90px\">\n    </span>\n    <span ng-if=\"!itemEdit.customerSignatureImage && itemEdit.customerSignatureAttachment && itemEdit.customerSignatureAttachment != '' && currentOrg == null\">\n      <img ng-src=\"{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.customerSignatureAttachment}}\" height=\"90px\">\n    </span>\n    <span ng-if=\"itemEdit.customerSignatureImage\">\n      <img ng-src=\"{{itemEdit.customerSignatureImage}}\">\n    </span>\n    <h3 ng-if=\"itemEdit.status != 'Accepted' && (itemEdit.customerSignatureAttachment == null || itemEdit.customerSignatureAttachment == '') && itemEdit.customerSignatureImage == null\">\n      <span ng-show=\"itemEdit.editing || userCanDoAction('captureCustomerSignatureFromCustomer', itemEdit)\">Click to capture signature</span>\n      <span ng-show=\"!itemEdit.editing && !userCanDoAction('captureCustomerSignatureFromCustomer', itemEdit)\">No Signature Captured</span>\n    </h3>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "L4C1":
/***/ (function(module, exports) {

var path = 'views/modals/newGroupModal.html';
var html = "<div class=\"niceModal desktopSelector newCompanyModal hasMobileVersion\" id=\"newGroupModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>New Group</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeNewGroupModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close New Group Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeNewGroupModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            New Group\n          </div>\n          <div class=\"right text\">\n\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- End Headers -->\n    <div class=\"progressBar\">\n      <div class=\"progressBarInner\" ng-if=\"newGroup.process != 'success'\">\n        <md-progress-linear md-mode=\"determinate\" value=\"{{(newGroup.currentStep / newGroup.stepCount) * 100}}\"></md-progress-linear>\n      </div>\n      <div class=\"successBar\" ng-if=\"newGroup.process == 'success'\">\n        <div class=\"left\"></div>\n        <div class=\"right\">\n          <h2>Congratulations! Your group has been created.</h2>\n          <h4>Start creating dockets.</h4>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"editGroupFormStep1\" novalidate ng-if=\"newGroup.process == 'form' && newGroup.currentStep == 1\" ng-submit=\"newGroupNext()\">\n        <h2>First, what is the name of your new group?</h2>\n        <h4>Don't worry, you can always change this later</h4>\n\n        <div class=\"inputGrouping\">\n          <md-input-container class=\"md-block\">\n            <label>Group Name</label>\n            <input type=\"text\" ng-model=\"newGroup.name\" aria-label=\"Group Name\" required=\"true\">\n          </md-input-container>\n        </div>\n\n        <div class=\"footerButtons\">\n          <button class=\"dbButton lightBlue\" ng-click=\"editGroupFormStep1.$invalid || newGroupNext()\" ng-disabled=\"editGroupFormStep1.$invalid\">Continue</button>\n        </div>\n      </form>\n\n      <form id=\"editGroupFormStep2\" name=\"editGroupFormStep2\" novalidate ng-if=\"newGroup.process == 'form' && newGroup.currentStep == 2\" ng-submit=\"newGroupNext()\">\n        <h2>Great, what is your group address?</h2>\n        <h4>Search for your address below and we will find it for you!</h4>\n\n        <div class=\"enterManualAddress\">\n          <a ng-click=\"newGroupManualAddress()\" ng-if=\"!newGroup.showFullAddress\">Enter address manually</a>\n          <a ng-click=\"newGroupManualAddress()\" ng-if=\"newGroup.showFullAddress\">Let me search for address</a>\n        </div>\n\n        <div class=\"inputGrouping\" ng-if=\"!newGroup.showFullAddress\">\n          <div class=\"group noTopMargin\">\n            <input id=\"location\" type=\"text\" name=\"location\" ng-model=\"newGroup.location\" address-model=\"newGroup.address\" class=\"{{newGroup.location != null ? 'ng-dirty' : ''}}\" googleplace placeholder=\"\">\n            <span class=\"highlight\"></span>\n            <span class=\"bar\"></span>\n            <label>Search Address</label>\n          </div>\n        </div>\n\n        <inline-alert class=\"margin-bottom-big\" type=\"warning\" ng-if=\"newGroup.addressAlert\">We didn't recognise this address - please try again or enter the address manually.</inline-alert>\n\n        <div class=\"addressGrouping\" ng-show=\"newGroup.showFullAddress\">\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Unit Number</label>\n              <input type=\"text\" ng-model=\"newGroup.address.num\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Number</label>\n              <input type=\"text\" ng-model=\"newGroup.address.streetNum\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Name</label>\n              <input type=\"text\" ng-model=\"newGroup.address.streetName\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Suburb</label>\n              <input type=\"text\" ng-model=\"newGroup.address.suburb\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>State</label>\n              <input type=\"text\" ng-model=\"newGroup.address.state\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Post Code</label>\n              <input type=\"text\" ng-model=\"newGroup.address.postCode\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Country</label>\n              <input type=\"text\" ng-model=\"newGroup.address.country\" required>\n            </md-input-container>\n          </div>\n        </div>\n\n        <div class=\"footerButtons additionalTopMargin\">\n          <div class=\"dbButton grey rightMargin\" ng-click=\"newGroupBack()\">Back</div>\n          <button type=\"submit\" class=\"dbButton lightBlue\" ng-click=\"editGroupFormStep2.$invalid || createNewGroup()\" ng-disabled=\"editGroupFormStep2.$invalid\">Continue</button>\n        </div>\n      </form>\n      <form id=\"editGroupFormStep4\" name=\"editGroupFromStep3\" novalidate ng-if=\"newGroup.process == 'creating'\">\n        <h2>Hang tight, your group is being created...</h2>\n        <h4>You'll be creating dockets in minutes</h4>\n\n        <div class=\"savingProgressCircular\">\n          <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"150px\"></md-progress-circular>\n        </div>\n      </form>\n      <form name=\"editGroupFormSuccess\" novalidate ng-if=\"newGroup.process == 'success'\">\n        <h4 class=\"lastStepSubhead\">Your new group {{newGroup.name}} is ready to use.</h4>\n\n        <div class=\"footerButtons additionalTopMargin\">\n          <div class=\"dbButton lightBlue\" ng-click=\"newGroupFinish()\">Continue</div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "L6ju":
/***/ (function(module, exports) {

var path = 'views/modals/assignJobModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"acceptOrderWizardModal\">\n    <div class=\"modalContainer\" style=\"width: 800px;\">\n        <div class=\"header hidden-xs\">\n            <h1>Assign users to Job {{job.jobNumber}}</h1>\n            <div class=\"headerCloseButton\" ng-click=\"close()\">\n                <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n        <div class=\"content noPadding\">\n\n            <div class=\"ojdDesktopSection\">\n                <div class=\"ojdDesktopRow\">\n                    <div class=\"ojdDesktopField\">\n                        <label class=\"order\">Start Date</label>\n                        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n                            <md-datepicker ng-model=\"job.startDate\" name=\"startDate\" ng-disabled=\"true\" aria-label=\"Start Date\"></md-datepicker>\n                        </md-input-container>\n                    </div>\n                    <div class=\"ojdDesktopField\">\n                        <label class=\"order\">End Date</label>\n                        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n                            <md-datepicker ng-model=\"job.endDate\" name=\"endDate\" ng-disabled=\"true\" aria-label=\"End Date\"></md-datepicker>\n                        </md-input-container>\n                    </div>\n                </div>\n            \n                <div class=\"ojdDesktopRow\" ng-if=\"job.orderRef\">\n                    <div class=\"ojdDesktopField\" ng-show=\"job.supplierContact\">\n                        <label class=\"order\">Supplier</label>\n                        <h2 ng-if=\"job.supplierContact\">{{job.supplierContact.displayName}}</h2>\n                        <h3 ng-if=\"job.supplierContact.addresses\">{{stringifyAddress(job.supplierContact.addresses[0])}}</h3>\n                    </div>\n                    <div class=\"ojdDesktopField\" ng-show=\"job.customerContact\">\n                        <label class=\"order\">Customer</label>\n                        <h2 ng-if=\"job.customerContact\">{{job.customerContact.displayName}}</h2>\n                        <h3 ng-if=\"job.customerContact.addresses\">{{stringifyAddress(job.customerContact.addresses[0])}}</h3>\n                    </div>\n                </div>\n            \n                <div class=\"ojdDesktopRow\" ng-if=\"job.order\">\n                    <div class=\"ojdDesktopField\" ng-show=\"job.order.supplierRefNo\">\n                        <label class=\"order\">Supplier Ref No</label>\n                        <h2>{{job.order.supplierRefNo}}</h2>\n                    </div>\n                    <div class=\"ojdDesktopField\" ng-show=\"job.order.customerRefNo\">\n                        <label class=\"order\">Customer Ref No</label>\n                        <h2>{{job.order.customerRefNo}}</h2>\n                    </div>\n                </div>\n            \n                <div class=\"ojdDesktopRow\">\n                    <div class=\"ojdDesktopField\">\n                        <label class=\"order\">Instructions</label>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <textarea ng-model=\"job.instructions\" rows=\"2\" md-select-on-focus ng-disabled=\"true\" aria-label=\"Instructions\"></textarea>\n                        </md-input-container>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"searchBar\">\n                <div class=\"title\">\n                    <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                </div>\n                <div class=\"bar\">\n                    <input name=\"selectPersonInput\" type=\"text\" ng-model=\"personSearch\" placeholder=\"Search\" ng-change=\"searchPeopleChange(personSearch)\" ng-model-options='{debounce:300}'>\n                </div>\n            </div>\n            <div class=\"noListMessage\" ng-show=\"personSearchList.length <= 0 && personSearchListFull.length <= 0\">\n                    There are no people matching your search criteria.\n            </div>\n            <div class=\"noListMessage\" ng-show=\"personSearchList.length <= 0 && personSearchListFull.length > 0\">\n                    There are no people matching your search criteria.\n            </div>\n            <md-table-container ng-show=\"personSearchList.length > 0\">\n                <table md-table multiple=\"true\" md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n                    <thead md-head md-order=\"query.order\" md-on-reorder=\"loadPeopleList\">\n                        <tr md-row>\n                            <th md-column>ID</th>\n                            <th md-column md-order-by=\"first\">First</th>\n                            <th md-column md-order-by=\"last\">Last</th>\n                            <th md-column md-order-by=\"emailAddress\">Email Address</th>\n                            <th md-column>Status</th>\n                        </tr>\n                    </thead>\n                    <tbody md-body>\n                        <tr md-row ng-repeat=\"person in personSearchList\" md-select=\"person\" md-select-id=\"id\">\n                            <td md-cell>\n                                {{person.id}}\n                            </td>\n                            <td md-cell>\n                                {{person.name.first}}\n                            </td>\n                            <td md-cell>\n                                {{person.name.last}}\n                            </td>\n                            <td md-cell>\n                                {{person.emailAddress}}\n                            </td>\n                            <td md-cell>\n                                <span ng-show=\"person.assigned\">Assigned</span>\n                                <span ng-show=\"!person.assigned\">Not Assigned</span>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </md-table-container>\n            <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadPeopleList\" md-total=\"{{listCount}}\" md-page-select>\n            </md-table-pagination>\n        </div>\n        <div class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                </div>\n                <div class=\"right\">\n                    <div class=\"dbButton white margin-right\" style=\"background: inherit\" ng-click=\"close()\">\n                        Cancel\n                    </div>\n                    <div class=\"dbButton\" ng-click=\"saveJob()\" ng-disabled=\"loading || desktopSelected.length < 1\">\n                        Save\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n  ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "LkqX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dashboard.svg";

/***/ }),

/***/ "LrPF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectPersonController', ['userService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', function (userService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

  // Initialise variables to be used
  $scope.personSearch = "";
  $scope.personSearchLoading = false;
  $scope.personLoadingError = null;
  $scope.personSearchList = [];
  $scope.personSearchListFull = [];
  $scope.personSelectCallback = null;
  $scope.desktopSelected = [];
  $scope.listCount = 0;
  $scope.assigned = [];

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'first'
  };

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.personSelectFromParent = function (assigned, cb) {
    $scope.personSearch = "";
    $scope.personSearchLoading = false;
    if (assigned != null) {
      $scope.assigned = assigned;
    } else {
      $scope.assigned = [];
    }
    $scope.personSelectCallback = cb;

    $scope.loadPeopleList();
  };

  $scope.loadPeopleList = function () {
    $scope.personSearchLoading = true;
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      if ($stateParams.device == 'desktop') {
        queryParams.limit = $scope.query.limit;
        queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
        queryParams.sort = $scope.query.order;
      }
      if ($scope.searchText != null && $scope.searchText != "") {
        queryParams.search = $scope.searchText;
      }
      if ($scope.orgFull) {
        userService.getMembers(queryParams, function (returnObject) {
          $scope.personSearchList = returnObject;
          if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
            $scope.listCount = returnObject.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          for (var i = 0; i < $scope.personSearchList.length; i++) {
            // check if person is in assigned list
            for (var j = 0; j < $scope.assigned.length; j++) {
              if ($scope.assigned[j] == $scope.personSearchList[i].id) {
                $scope.personSearchList[i].assigned = true;
                break;
              }
            }
          }
          $scope.personSearchLoading = false;
          resolve('Done');
        }, function (err) {
          $scope.personSearchLoading = false;
          $scope.personLoadingError = "Error getting people";
          reject('Error');
        });
      } else {
        userService.getGroupMembers(queryParams, function (returnObject) {
          $scope.personSearchList = returnObject;
          if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
            $scope.listCount = returnObject.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          for (var i = 0; i < $scope.personSearchList.length; i++) {
            // check if person is in assigned list
            for (var j = 0; j < $scope.assigned.length; j++) {
              if ($scope.assigned[j].assignee == $scope.personSearchList[i].id && $scope.assigned[j].delete != true) {
                $scope.personSearchList[i].assigned = true;
                break;
              }
            }
          }
          $scope.personSearchLoading = false;
          resolve('Done');
        }, function (err) {
          $scope.personSearchLoading = false;
          $scope.personLoadingError = "Error getting people";
          reject('Error');
        });
      }
    });
  };

  $scope.searchPeopleChange = function (searchText) {
    $scope.searchText = searchText;
    $scope.loadPeopleList();
  };

  $scope.$parent.desktopPeopleSelectFromParent = function (assigned, cb) {
    $scope.personSearch = "";
    $scope.personSelectCallback = cb;
    $scope.desktopSelected = [];
    $scope.orgFull = false;
    if (assigned == null) {
      $scope.assigned = [];
    } else {
      $scope.assigned = assigned;
    }
    $scope.query = {
      limit: 10,
      page: 1,
      order: 'first'
    };
    $scope.loadPeopleList();
    $("#selectPersonModal").fadeIn(100);
    $("input[name='selectPersonInput']").focus();
  };

  $scope.$parent.selectOrgPeopleFromParent = function (assigned, cb) {
    $scope.personSearch = "";
    $scope.personSelectCallback = cb;
    $scope.desktopSelected = [];
    $scope.orgFull = true;
    if (assigned == null) {
      $scope.assigned = [];
    } else {
      $scope.assigned = assigned;
    }
    $scope.query = {
      limit: 10,
      page: 1,
      order: 'first'
    };
    $scope.loadPeopleList();
    $("#selectPersonModal").fadeIn(100);
    $("input[name='selectPersonInput']").focus();
  };

  $scope.selectPersonToAssign = function (person) {
    $scope.personSelectCallback(person);
  };

  $scope.closePersonSelectList = function () {
    if ($stateParams.device == 'desktop') {
      $("#selectPersonModal").fadeOut(100);
    }
    $scope.personSelectCallback(null);
  };

  $scope.desktopSelectPeopleContinue = function () {
    $scope.personSelectCallback($scope.desktopSelected);
    $("#selectPersonModal").fadeOut(100);
  };

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.updatePersonSearch = function (searchValue) {
    $scope.personSearchLoading = true;
    if (searchValue === "") {
      $scope.personSearchList = $scope.personSearchListFull;
      return;
    }

    // update personSearchList with filtered results
    var filteredList = [];
    for (var i = 0; i < $scope.personSearchListFull.length; i++) {
      if ($scope.personSearchListFull[i].name.full.indexOf(searchValue) != -1) {
        filteredList.push($scope.personSearchListFull[i]);
      }
    }

    $scope.personSearchList = filteredList;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "LsFw":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/orderDetail.html';
var html = "<form name=\"orderDetailForm\">\n  <div class=\"ojdMobileDetailOuter paddingWithTabBar\">\n    <div class=\"ojdSection {{currentTab == 'General' ? 'mobileShow' : 'mobileHide'}}\" id=\"General\" data-name=\"General\">\n      <ng-include src=\"'views/pages/orders/mobile/generalTab.html'\"></ng-include>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'LineItems' ? 'mobileShow' : 'mobileHide'}}\" id=\"LineItems\">\n      <ng-include src=\"'views/pages/orders/mobile/lineItemsTab.html'\"></ng-include>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'Jobs' ? 'mobileShow' : 'mobileHide'}}\" id=\"Jobs\">\n      <ng-include src=\"'views/pages/orders/mobile/jobsTab.html'\"></ng-include>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'Dockets' ? 'mobileShow' : 'mobileHide'}}\" id=\"Dockets\">\n      <ng-include src=\"'views/pages/orders/mobile/docketsTab.html'\"></ng-include>\n    </div>\n\n    <div id=\"toaster\" class=\"visible-xs\">\n      <!--<div class=\"fabButtonContainer\">\n        <md-button class=\"md-fab md-hue-6\" ng-click=\"openBottomSheet()\" md-theme=\"dbDarkBlue\" aria-label=\"Docket Actions\" ng-show=\"!itemEdit.loading\">\n          <md-icon md-svg-src=\"more_vert.svg\"></md-icon>\n        </md-button>\n      </div>-->\n      <div id=\"toasterInner\">\n        <md-content id=\"content1\" ng-cloak>\n\n        </md-content>\n      </div>\n    </div>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "M0Rw":
/***/ (function(module, exports) {

var path = 'views/modals/desktopInteractionModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"addInteractionModal\">\n  <div my-loader text=\"Saving Line\" ng-if=\"addInteraction.loading\"></div>\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"addInteraction.mode == 'selectTemplate'\">Select Line Type</h1>\n      <h1 ng-show=\"addInteraction.mode == 'detail' && addInteraction.edit != true && !addInteraction.readOnly\">Add Line</h1>\n      <h1 ng-show=\"addInteraction.mode == 'detail' && addInteraction.edit == true && !addInteraction.readOnly\">Edit Line</h1>\n      <h1 ng-show=\"addInteraction.mode == 'detail' && addInteraction.readOnly\">View Line</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeAddInteraction()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <span ng-show=\"addInteraction.mode == 'selectTemplate'\">\n        <p ng-show=\"availableInteractions == null || availableInteractions.length == 0\">\n          There are no available interactions.\n        </p>\n        <md-table-container>\n          <table md-table>\n            <thead md-head>\n              <tr md-row>\n                <th md-column>Item Type</th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row ng-repeat=\"interactionTemplate in availableInteractions\" ng-click=\"selectInteractionTemplate(interactionTemplate)\">\n                <td md-cell>{{interactionTemplate.name}}</td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </span>\n      <span ng-show=\"addInteraction.mode == 'detail'\">\n        <form name=\"addInteractionForm\" novalidate>\n          <div class=\"splitModalForm\">\n            <div class=\"splitModalFormLeft\">\n              <h2>{{addInteraction.interaction.resource.name}}</h2>\n              <p class=\"subHead biggerBottomMargin\">\n                {{addInteraction.interaction.interactionName}}\n              </p>\n              <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"!addInteraction.interactionTemplate.xeroQuantity\">\n                <label>{{addInteraction.interaction.resource.uom.description}}</label>\n                <input ng-model=\"addInteraction.interaction.quantityEdit\" required ng-disabled=\"addInteraction.readOnly\">\n              </md-input-container>\n              <div ng-show=\"addInteraction.interactionTemplate.fields.length > 0\">\n                <span ng-repeat=\"field in addInteraction.interactionTemplate.fields\">\n                  <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"field.type == 'text'\">\n                    <label style=\"top:-50px;\" ng-if=\"addInteraction.readOnly\">{{field.displayName}}</label>\n                    <label ng-if=\"!addInteraction.readOnly\">{{field.displayName}}</label>\n                    <p ng-if=\"addInteraction.readOnly\">{{addInteraction.interaction.customFields[field.id]}}</p>\n                    <input type=\"text\" ng-model=\"addInteraction.interaction.customFields[field.id]\" name=\"{{field.id}}\" ng-disabled=\"addInteraction.readOnly\" ng-if=\"!addInteraction.readOnly && field.mandatory\" required>\n                    <input type=\"text\" ng-model=\"addInteraction.interaction.customFields[field.id]\" name=\"{{field.id}}\" ng-disabled=\"addInteraction.readOnly\" ng-if=\"!addInteraction.readOnly && !field.mandatory\">\n                    <div ng-messages=\"addInteractionForm.{{field.id}}.$error\">\n                      <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This is required.</div>\n                    </div>\n                  </md-input-container>\n\n                  <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"field.type == 'number'\">\n                    <label>{{field.displayName}}</label>\n                    <input type=\"number\" ng-model=\"addInteraction.interaction.customFields[field.id]\" name=\"{{field.id}}\" ng-disabled=\"addInteraction.readOnly\" ng-if=\"field.mandatory\" required>\n                    <input type=\"number\" ng-model=\"addInteraction.interaction.customFields[field.id]\" name=\"{{field.id}}\" ng-disabled=\"addInteraction.readOnly\" ng-if=\"!field.mandatory\">\n                    <div ng-messages=\"addInteractionForm.{{field.id}}.$error\">\n                      <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This is required.</div>\n                    </div>\n                  </md-input-container>\n\n                  <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"field.type == 'date'\">\n                    <label>{{field.displayName}}</label>\n                    <!--{{moment(addInteraction.interaction.customFields[field.id]).tz(docketEditing.timezone).format('Z')}}-->\n                    <md-datepicker ng-model=\"addInteraction.interaction.customFields[field.id]\" name=\"{{field.id}}\" aria-label=\"{{field.displayName}}\" ng-if=\"!field.mandatory\"></md-datepicker>\n                    <md-datepicker ng-model=\"addInteraction.interaction.customFields[field.id]\" name=\"{{field.id}}\" aria-label=\"{{field.displayName}}\" required ng-if=\"field.mandatory\"></md-datepicker>\n                    <div ng-messages=\"addInteractionForm.{{field.id}}.$error\">\n                      <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This date is required</div>\n                    </div>\n                    <!--<mdp-date-picker mdp-open-on-click ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-format=\"DD/MM/YYYY\" name=\"{{field.id}}\" required ng-if=\"field.mandatory\">\n                      <div ng-messages=\"addInteractionForm.{{field.id}}.$error\">\n                        <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This date is required</div>\n                      </div>\n                    </mdp-date-picker>\n                    <mdp-date-picker mdp-open-on-click ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-format=\"DD/MM/YYYY\" name=\"{{field.id}}\" ng-if=\"!field.mandatory\"></mdp-date-picker>-->\n                  </md-input-container>\n\n                  <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"field.type == 'time'\">\n                    <label>{{field.displayName}}</label>\n                    <mdp-time-picker mdp-open-on-click ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-timezone=\"{{docketEditing.timezone}}\" mdp-auto-switch=\"true\" name=\"{{field.id}}\" required ng-if=\"field.mandatory\">\n                      <div ng-messages=\"addInteractionForm.{{field.id}}.$error\">\n                        <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This time is required</div>\n                      </div>\n                    </mdp-time-picker>\n                    <mdp-time-picker mdp-open-on-click ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-timezone=\"{{docketEditing.timezone}}\" mdp-auto-switch=\"true\" name=\"{{field.id}}\" ng-if=\"!field.mandatory\"></mdp-time-picker>\n                  </md-input-container>\n\n                  <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"field.type == 'boolean'\">\n                    <md-checkbox ng-model=\"addInteraction.interaction.customFields[field.id]\" aria-label=\"{{field.displayName}}\">\n                      {{field.displayName}}\n                    </md-checkbox>\n                  </md-input-container>\n                  <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"field.type == 'select'\">\n                    <label>{{field.displayName}}</label>\n\t\t\t\t\t\t\t\t\t\t<md-select ng-model=\"addInteraction.interaction.customFields[field.id]\" aria-label=\"{{field.displayName}}\" ng-if=\"!field.mandatory\">\n\t\t\t\t\t\t\t\t\t\t\t<md-option><em>None</em></md-option>\n\t\t\t\t\t\t\t\t\t\t\t<md-option ng-repeat=\"value in field.selectionFields\" ng-value=\"value\">{{value}}</md-option>\n\t\t\t\t\t\t\t\t\t\t</md-select>\n                    <md-select ng-model=\"addInteraction.interaction.customFields[field.id]\" aria-label=\"{{field.displayName}}\" required ng-if=\"field.mandatory\">\n\t\t\t\t\t\t\t\t\t\t\t<md-option><em>None</em></md-option>\n\t\t\t\t\t\t\t\t\t\t\t<md-option ng-repeat=\"value in field.selectionFields\" ng-value=\"value\">{{value}}</md-option>\n\t\t\t\t\t\t\t\t\t\t</md-select>\n                  </md-input-container>\n                </span>\n              </div>\n            </div>\n            <div class=\"splitModalFormRight map disabled\">\n              <div class=\"mapOuter\" ng-show=\"addInteraction.interaction.createdAt\">\n                <div class=\"createdAt\">\n                  <span ng-if=\"currentOrgGroup.timeFormat == '12HR'\">\n                    Created {{moment(addInteraction.interaction.createdAt).tz(docketEditing.timezone).format('DD/MM/YYYY hh:mm a')}}\n                  </span>\n                  <span ng-if=\"currentOrgGroup.timeFormat == '24HR'\">\n                    Created {{moment(addInteraction.interaction.createdAt).tz(docketEditing.timezone).format('DD/MM/YYYY HH:mm')}}\n                  </span>\n                </div>\n                <div class=\"locationMap\" ng-if=\"addInteraction.interaction.createdAt\">\n                  <div id=\"interactionMap\" ng-if=\"addInteraction.interaction.lat && addInteraction.interaction.long\"></div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </form>\n      </span>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeAddInteraction()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"formLoading || addInteractionForm.$invalid || saveInteraction(addInteraction.interaction)\" ng-disabled=\"addInteractionForm.$invalid\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "M1kX":
/***/ (function(module, exports) {

var path = 'views/pages/connections/connections.html';
var html = "<div class=\"desktopContainer\">\n    <div class=\"desktopSplitListOuter\">\n        <div class=\"desktopSplitListTableOuter contactList\">\n            <div ng-style=\"{'display' : 'table', 'width':'100%','height':'100%'}\">\n                <div ng-style=\"{'display':'table-row','width':'100%','height':'80px'}\">\n                    <div class=\"contentHeadingOuter\">\n                        <div class=\"contentHeadingInner desktopTableSearch\">\n                            <div class=\"headerSplit\">\n                                <div class=\"left\">\n                                    <h1>Connections</h1>\n                                </div>\n                                <div class=\"right\">\n                                    <md-button ng-if=\"userHasPermission('io.docketbook.uoapi.createConnection')\" class=\"md-icon-button\" ng-click=\"newConnection()\" aria-label=\"New Connection\">\n                                        <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n                                    </md-button>\n                                    <md-button ng-if=\"userHasPermission('io.docketbook.uoapi.createConnection')\" class=\"md-icon-button\" ng-click=\"importConnections()\" aria-label=\"Import Connections\">\n                                        <md-icon md-svg-icon=\"import.svg\"></md-icon>\n                                    </md-button>\n                                    <md-menu ng-if=\"userHasPermission('io.docketbook.uoapi.deleteConnection')\">\n                                        <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n                                            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n                                        </md-button>\n                                        <md-menu-content width=\"4\">\n                                            <md-menu-item ng-click=\"deleteSelectedConnections()\" aria-label=\"Delete Selected Contacts\">\n                                                <md-button>\n                                                    Delete Selected Connections\n                                                </md-button>\n                                            </md-menu-item>\n                                        </md-menu-content>\n                                    </md-menu>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\">\n                    <div ng-style=\"{'display':'table-cell','width':'100%','height':'100%','position':'relative'}\">\n                        <div ng-style=\"{'display':'block','height':'100%','position':'absolute','top':'0px','left':'0px','width':'100%','z-index':'10','overflow':'auto'}\">\n                            <div>\n                                <md-table-container>\n                                    <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n                                        <thead md-head md-order=\"query.order\" md-on-reorder=\"loadContacts\">\n                                            <tr md-row>\n                                                <th md-column md-order-by=\"displayName\"><span>Organisation Name</span></th>\n                                                <th md-column><span>Primary Contact</span></th>\n                                                <th md-column md-order-by=\"status\"><span>Status</span></th>\n                                            </tr>\n                                        </thead>\n                                        <tbody md-body>\n                                            <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in connections\" ng-click=\"openConnection(item)\">\n                                                <td md-cell>{{item.orgData ? item.orgData.organisationName : item.invitation.organisationName}}</td>\n                                                <td md-cell>{{item.orgData ? item.orgData.fullName : item.invitation.fullName}} ({{item.orgData ? item.orgData.emailAddress : item.invitation.emailAddress}})</td>\n                                                <td md-cell>\n                                                    <div class=\"connectionStatusDisplay {{(item.targetId == null && item.sourceId != currentOrg.id) ? 'attentionRequired' : item.status}}\">\n                                                        {{getConnectionStatus(item)}}\n                                                    </div>\n                                                </td>\n                                            </tr>\n                                        </tbody>\n                                    </table>\n                                </md-table-container>\n                                <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadAddressBook\" md-total=\"{{listCount}}\" md-page-select>\n                                </md-table-pagination>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n  \n        <div class=\"desktopSplitListDetailOuter contactDetail\">\n            <div class=\"detailItemContainer\">\n                <div class=\"ojdDesktopDetailOuter\">\n                    <form name=\"contactDesktopForm\">\n                        <div class=\"ojdDesktopSection header white\">\n                            <div class=\"headerTitle\">\n                                <h1>Connection Detail</h1>\n                            </div>\n            \n                            <div class=\"bulkActionsButtons\">\n                                <div ng-show=\"connectionEdit.status == 'requested' && connectionEdit.targetId == currentOrg.id\" class=\"dbButton\" ng-click=\"acceptConnection(connectionEdit)\" ng-if=\"connectionEdit.status == 'requested'\">Accept</div>\n                                <md-menu>\n                                    <md-button aria-label=\"Open contact interactions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n                                      <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n                                    </md-button>\n                                    <md-menu-content width=\"4\">\n                                        <md-menu-item ng-show=\"connectionEdit.status == 'requested' && connectionEdit.targetId == currentOrg.id && userHasPermission('io.docketbook.uoapi.acceptConnection')\" ng-click=\"declineConnection(connectionEdit)\">\n                                            <md-button>\n                                                Decline Connection\n                                            </md-button>\n                                        </md-menu-item>\n                                        <md-menu-item ng-show=\"connectionEdit.status == 'accepted' || connectionEdit.status == 'declined' && userHasPermission('io.docketbook.uoapi.deleteConnection')\" ng-click=\"deleteConnection(connectionEdit)\">\n                                            <md-button>\n                                                Remove Connection\n                                            </md-button>\n                                        </md-menu-item>\n                                        <md-menu-item ng-show=\"connectionEdit.status == 'requested' && connectionEdit.sourceId == currentOrg.id && userHasPermission('io.docketbook.uoapi.deleteConnection')\" ng-click=\"cancelRequestedConnection(connectionEdit)\">\n                                            <md-button>\n                                                Cancel Connection Request\n                                            </md-button>\n                                        </md-menu-item>\n                                    </md-menu-content>\n                                </md-menu>\n                                <md-button class=\"md-icon-button\" aria-label=\"Close Connection Detail\" ng-click=\"closeConnection()\">\n                                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                                </md-button>\n                            </div>\n                        </div>\n\n                        <div class=\"ojdDesktopSection header connection {{getConnectionStatus(connectionEdit).replace(' ', '')}}\">\n                            <div class=\"headerTitle\" ng-if=\"connectionEdit.status\">\n                                <h2>Status</h2>\n                                <h1>{{getConnectionStatus(connectionEdit)}}</h1>\n                            </div>\n                        </div>\n\n                        <div class=\"ojdDesktopMainSections\">\n                            <div class=\"ojdDesktopSection noPadding\">\n                                <div class=\"ojdDesktopPaddingOuter\">\n                                    <h4>Organisation Name</h4>\n                                    {{connectionEdit.orgData ? connectionEdit.orgData.organisationName : connectionEdit.invitation.organisationName}}\n                                    <h4 style=\"padding-top: 20px;\">Contact Name</h4>\n                                    {{connectionEdit.orgData ? connectionEdit.orgData.fullName : connectionEdit.invitation.fullName}}\n                                    <h4 style=\"padding-top: 20px;\">Email Address</h4>\n                                    {{connectionEdit.orgData ? connectionEdit.orgData.emailAddress : connectionEdit.invitation.emailAddress}}\n                                </div>\n                            </div>\n                            <md-table-container class=\"docketResourceTable\" ng-show=\"contactEdit.contactAddresses.length > 0\">\n                                <table md-table multiple>\n                                    <tbody md-body>\n                                        <tr md-row ng-repeat=\"address in contactEdit.contactAddresses\">\n                                            <td md-cell>\n                                                <span>{{address.emailAddress}}</span>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </md-table-container>\n\n                            <div ng-if=\"connectionEdit.status == 'accepted'\">\n                                <div class=\"ojdDesktopPaddingOuter\">\n                                    <h4>Original Invitation</h4>\n                                    <div>{{connectionEdit.invitation.organisationName}}</div>\n                                    <div>{{connectionEdit.invitation.fullName}}</div>\n                                    <div>{{connectionEdit.invitation.emailAddress}}</div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<ng-include src=\"'views/modals/acceptConnectionRequestModal.html'\" ng-controller='acceptConnectionRequestModalController'></ng-include>\n<ng-include src=\"'views/modals/createConnectionModal.html'\" ng-controller='createConnectionModalController'></ng-include> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "M1wf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M5CG":
/***/ (function(module, exports) {

var path = 'views/notifications/slider.html';
var html = "<div class=\"notificationsSlideUnderlay\" ng-click=\"closeNotificationsSlider()\"></div>\n<div class=\"notificationsSlideOuterContainer\">\n  <div class=\"sliderHeader\">\n    <div class=\"left\"><h3>Messages</h3></div>\n    <div class=\"right\" ng-click=\"closeNotificationsSlider()\">\n      <div class=\"closeIcon\">\n      </div>\n    </div>\n  </div>\n  <div class=\"notificationsList\">\n    <div ng-show=\"notificationsSummary.loading\">\n      <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n    </div>\n    <div class=\"stdLoader white\" ng-show=\"notificationsSummary.error != null\">\n      <div class=\"loaderOuterContainer\">\n        <div class=\"loaderInnerContainer\">\n          <div class=\"materialSpinner\">\n            <md-icon md-svg-src=\"{{errorSvgImagePath}}\"></md-icon>\n          </div>\n          <div class=\"loadingText\">\n            {{notificationsSummary.error}}\n          </div>\n          <div class=\"loadingRetryButton\">\n          </div>\n          <div class=\"clearfix\"></div>\n        </div>\n      </div>\n    </div>\n    <!-- List of notifications -->\n    <div ng-repeat=\"notification in notificationsSummary.notifications\">\n      <div class=\"notificationItem\" id=\"{{notification.id}}\" ng-if=\"notification.type == 'contactShare'\" ng-click=\"viewNotificationMessage(notification)\">\n        <div class=\"left\">\n          <div class=\"avatar contactShare\"></div>\n        </div>\n        <div class=\"right\">\n          <div class=\"closeButton\">\n            <md-button class=\"md-icon-button\" ng-click=\"closeNotification(notification); $event.stopPropagation();\">\n              <md-icon md-svg-src=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n          <p class=\"title\">{{notification.title}}</p>\n          <div class=\"dateTime\">{{notification.dateTime}}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-include src=\"'views/modals/viewMessageModal.html'\"></ng-include>\n<ng-include src=\"'views/modals/selectOrgUnitModal.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "MOQi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "file-document.svg";

/***/ }),

/***/ "MXov":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "xero-connect-white.svg";

/***/ }),

/***/ "Mf6t":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/customBlockTab.html';
var html = "<div class=\"ojdRow\" ng-repeat=\"field in block.fields\">\n  <div class=\"ojdField\" ng-if=\"field.type == 'date'\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <md-datepicker name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" md-placeholder=\"Enter date\" ng-disabled='!itemEdit.editing' required ng-if=\"field.mandatory\" aria-label=\"{{field.displayName}}\"></md-datepicker>\n      <md-datepicker name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" md-placeholder=\"Enter date\" ng-disabled='!itemEdit.editing' ng-if=\"!field.mandatory\" aria-label=\"{{field.displayName}}\"></md-datepicker>\n      <div class=\"validation-messages\" ng-messages=\"docketDetailForm.{{field.id}}.$error\">\n        <div ng-message=\"required\" ng-show=\"(itemEdit.templateValueStore[block.id + '-' + field.id] == '' || itemEdit.templateValueStore[block.id + '-' + field.id] == null) && field.mandatory\">This date is required.</div>\n      </div>\n    </md-input-container>\n  </div>\n\n  <div class=\"ojdField\" ng-if=\"field.type == 'time'\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <mdp-time-picker name=\"{{field.id}}\" mdp-timezone=\"{{itemEdit.timezone}}\" mdp-auto-switch=\"true\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" required ng-if=\"field.mandatory\" aria-label=\"{{field.displayName}}\"></mdp-time-picker>\n      <mdp-time-picker name=\"{{field.id}}\" mdp-timezone=\"{{itemEdit.timezone}}\" mdp-auto-switch=\"true\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-if=\"!field.mandatory\" aria-label=\"{{field.displayName}}\"></mdp-time-picker>\n      <div class=\"validation-messages\" ng-messages=\"docketDetailForm.{{field.id}}.$error\">\n        <div ng-message=\"required\" ng-show=\"(itemEdit.templateValueStore[block.id + '-' + field.id] == '' || itemEdit.templateValueStore[block.id + '-' + field.id] == null) && field.mandatory\">This date is required.</div>\n      </div>\n    </md-input-container>\n  </div>\n\n  <div class=\"ojdField\" ng-if=\"field.type == 'text'\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <input type=\"text\" name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" required ng-if=\"field.mandatory\" aria-label=\"{{field.displayName}}\">\n      <input type=\"text\" name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" ng-if=\"!(field.mandatory)\" aria-label=\"{{field.displayName}}\">\n      <div ng-messages=\"docketDetailForm.{{field.id}}.$error\">\n        <div ng-message=\"required\" ng-show=\"itemEdit.templateValueStore[block.id + '-' + field.id] == '' || itemEdit.templateValueStore[block.id + '-' + field.id] == null\">This is required.</div>\n      </div>\n    </md-input-container>\n  </div>\n\n  <div class=\"ojdField switchField\" ng-if=\"field.type == 'boolean'\">\n    <div class=\"left\">\n      <h1>{{field.displayName}}</h1>\n    </div>\n    <div class=\"right\">\n      <md-input-container class=\"md-block\" flex-gt-sm>\n        <input type=\"checkbox\" name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" required ng-if=\"field.mandatory\" aria-label=\"{{field.displayName}}\">\n        <input type=\"checkbox\" name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" ng-if=\"!(field.mandatory)\" aria-label=\"{{field.displayName}}\">\n      </md-input-container>\n\n      <!--<md-switch ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" aria-label=\"{{field.displayName}} Boolean\" ng-disabled=\"!itemEdit.editing\">\n      </md-switch>-->\n    </div>\n  </div>\n\n  <div class=\"ojdField\" ng-if=\"field.type == 'number'\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <input type=\"number\" name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" required ng-if=\"field.mandatory\" aria-label=\"{{field.displayName}}\">\n      <input type=\"number\" name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" ng-if=\"!(field.mandatory)\" aria-label=\"{{field.displayName}}\">\n      <div ng-messages=\"docketDetailForm.{{field.id}}.$error\">\n        <div ng-message=\"required\" ng-show=\"itemEdit.templateValueStore[block.id + '-' + field.id] == '' || itemEdit.templateValueStore[block.id + '-' + field.id] == null\">This is required.</div>\n      </div>\n    </md-input-container>\n  </div>\n\n  <div class=\"ojdField\" ng-if=\"field.type == 'select'\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <md-input-container class=\"md-block\">\n      <md-select ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n        <md-option><em>None</em></md-option>\n        <md-option ng-repeat=\"value in field.selectionFields\" ng-value=\"value\">{{value}}</md-option>\n      </md-select>\n    </md-input-container>\n  </div>\n\n  <div class=\"ojdField\" ng-if=\"field.type == 'multiline'\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <textarea rows=\"3\" md-select-on-focus name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" required ng-if=\"field.mandatory\" aria-label=\"{{field.displayName}}\"></textarea>\n      <textarea rows=\"3\" md-select-on-focus name=\"{{field.id}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" ng-if=\"!(field.mandatory)\" aria-label=\"{{field.displayName}}\"></textarea>\n      <div ng-messages=\"docketDetailForm.{{field.id}}.$error\">\n        <div ng-message=\"required\" ng-show=\"(itemEdit.templateValueStore[block.id + '-' + field.id] == '' || itemEdit.templateValueStore[block.id + '-' + field.id] == null) && field.mandatory\">This is required.</div>\n      </div>\n    </md-input-container>\n  </div>\n  <div class=\"ojdField\" ng-if=\"field.type == 'label'\">\n    <h1>{{field.displayName}}</h1>\n    <p class=\"labelFieldText\">{{field.text}}</p>\n  </div>\n\n  <div class=\"ojdField\" ng-if=\"field.type == 'address'\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <div class=\"group\">\n      <input type=\"text\" name=\"location\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" address-model=\"newAddress\" googleplace placeholder=\"\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n      <span class=\"highlight\"></span>\n      <span class=\"bar\"></span>\n    </div>\n  </div>\n\n  <div class=\"ojdField\" ng-if=\"field.type == 'signature'\" ng-click=\"!(itemEdit.editing && !itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]) || captureFieldSignature(block, field)\">\n    <h1>{{field.displayName}} <span ng-if=\"field.mandatory\">*</span></h1>\n    <h2 ng-if=\"!itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]\">\n      Not Captured\n    </h2>\n    <span ng-if=\"itemEdit.signatureFields[block.id + '-' + field.id].signatureImage != null\">\n      <img ng-src=\"{{itemEdit.signatureFields[block.id + '-' + field.id].signatureImageFull}}\">\n    </span>\n    <span ng-if=\"itemEdit.templateValueStore[block.id + '-' + field.id] && currentOrg != null\">\n      <img ng-src=\"{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.templateValueStore[block.id + '-' + field.id]}}\" height=\"90px\">\n    </span>\n    <span ng-if=\"itemEdit.templateValueStore[block.id + '-' + field.id] && currentOrg == null\">\n      <img ng-src=\"{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{itemEdit.templateValueStore[block.id + '-' + field.id]}}\" height=\"90px\">\n    </span>\n    <h3 ng-if=\"itemEdit.editing && !itemEdit.signatureFields[block.id + '-' + field.id].signatureImage && !itemEdit.templateValueStore[block.id + '-' + field.id]\">\n      <span>Click to capture signature</span>\n    </h3>\n  </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Mji+":
/***/ (function(module, exports, __webpack_require__) {

var path = 'views/modals/selectPlanModal.html';
var html = "<!-- Edit Resource Modal -->\n<div class=\"niceModal desktopSelector planSelector\" id=\"selectPlanModal\" ng-style=\"{ display: show ? 'block' : 'none' }\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-if=\"!currentOrg.plan && !selectPlanConfig.updateCardOnly\">Select Plan</h1>\n      <h1 ng-if=\"currentOrg.plan && !selectPlanConfig.updateCardOnly\">Update Plan</h1>\n      <h1 ng-if=\"selectPlanConfig.updateCardOnly\">Update Card Details</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closePlanSelect()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noSidePadding\" ng-if=\"selectPlanConfig.mode == 'plans'\">\n      <div my-loader text=\"Saving Plan Details\" ng-if=\"selectPlanConfig.saving\"></div>\n\n      <h2 ng-if=\"requiredFeatureText\" style=\"margin-bottom: 40px;\">\n        {{requiredFeatureText}}\n      </h2>\n\n      <table class=\"pricingTable\">\n        <tr class=\"header\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}} {{requiredPlan && requiredPlan.id == plan.id ? 'highlighted' : ''}}\" ng-if=\"plan.available\">\n            <h2>{{plan.name}} <span class=\"plan\">Plan</span></h2>\n          </td>\n        </tr>\n        <!--<tr class=\"pricingIcon\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}}\" ng-if=\"plan.available\">\n            <div class=\"{{plan.name.toLowerCase()}}Icon\"></div>\n          </td>\n        </tr>-->\n        <tr class=\"cost\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}} {{requiredPlan && requiredPlan.id == plan.id ? 'highlighted' : ''}}\" ng-if=\"plan.available\">\n            <h1>${{plan.pricePerInterval / 100}}<span class=\"month\">&nbsp;/ Month</span></h1>\n          </td>\n        </tr>\n        <tr class=\"infoRow\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}} {{requiredPlan && requiredPlan.id == plan.id ? 'highlighted' : ''}}\" ng-if=\"plan.available\">\n            <div class=\"infoRowOuter\">\n              <div class=\"icon\">\n                <div class=\"docketIcon\"></div>\n              </div>\n              <div class=\"info\">{{plan.features.includedDockets}} Included Dockets</div>\n            </div>\n          </td>\n        </tr>\n        <tr class=\"infoRow\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}} {{requiredPlan && requiredPlan.id == plan.id ? 'highlighted' : ''}}\" ng-if=\"plan.available\">\n            <div class=\"infoRowOuter\">\n              <div class=\"icon\">\n                <div class=\"addDocketIcon\"></div>\n              </div>\n              <div class=\"info\">{{plan.features.perDocketPrice}}c Per Additional Docket</div>\n            </div>\n          </td>\n        </tr>\n        <tr class=\"infoRow\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}} {{requiredPlan && requiredPlan.id == plan.id ? 'highlighted' : ''}}\" ng-if=\"plan.available\">\n            <div class=\"infoRowOuter\">\n              <div class=\"icon\">\n                <div class=\"usersIcon\"></div>\n              </div>\n              <div class=\"info\" ng-if=\"plan.features.includedUsers != -1\">{{plan.features.includedUsers}} Included Users</div>\n              <div class=\"info\" ng-if=\"plan.features.includedUsers == -1\">Unlimited Users</div>\n            </div>\n          </td>\n        </tr>\n        <tr class=\"infoRow\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}} {{requiredPlan && requiredPlan.id == plan.id ? 'highlighted' : ''}}\" ng-if=\"plan.available\">\n            <div class=\"infoRowOuter\">\n              <div class=\"icon\">\n                <div class=\"groupsIcon\"></div>\n              </div>\n              <div class=\"info\" ng-if=\"plan.features.includedOrganisationGroups != 0\">{{plan.features.includedOrganisationGroups}} Included Organisation Groups</div>\n              <div class=\"info\" ng-if=\"plan.features.includedOrganisationGroups == 0\">Unlimited Organisation Groups</div>\n            </div>\n          </td>\n        </tr>\n        <tr class=\"lastRow infoRow\">\n          <td ng-repeat=\"plan in allPlans\" class=\"{{currentOrg.plan && currentOrg.plan.id == plan.id ? 'selected':''}} {{requiredPlan && requiredPlan.id == plan.id ? 'highlighted' : ''}}\" ng-if=\"plan.available\">\n            <div class=\"dbButton lightBlue\" ng-click=\"selectPlanContinue(plan)\" ng-if=\"!(currentOrg.plan && currentOrg.plan.id == plan.id)\"><span ng-if=\"!currentOrg.plan\">Upgrade to</span><span ng-if=\"currentOrg.plan\">Change To</span> {{plan.name}}</div>\n            <div class=\"currentPlanTitle\" ng-if=\"currentOrg.plan && currentOrg.plan.id == plan.id\"><strong>Current Plan</strong></div>\n          </td>\n        </tr>\n      </table>\n\n      <div class=\"enterpriseTitle\">\n        <h1>Need More?</h1>\n        <h2>Contact us to talk about our Enterprise solution</h2>\n        <a href=\"http://docketbook.io/enterprise\" target=\"_blank\" class=\"dbButton\">Contact Us</a>\n      </div>\n    </div>\n\n    <div class=\"content\" ng-if=\"selectPlanConfig.mode == 'card'\">\n      <div my-loader text=\"Saving Cards Details\" ng-if=\"selectPlanConfig.saving\"></div>\n\n      <h2 class=\"planSelectContentHeader\">Enter your card details</h2>\n\n      <div class=\"cardForm\">\n        <form name=\"cardForm\" ng-submit=\"selectCardContinue()\">\n          <div class=\"cardsList\">\n            <img src=\"" + __webpack_require__("m0E1") + "\" width=\"50px\" class=\"cardImage {{cardForm.creditCardNumber.$ccEagerType == 'Visa' ? 'selected' : ''}}\"/>\n            <img src=\"" + __webpack_require__("229m") + "\" width=\"50px\" class=\"cardImage {{cardForm.creditCardNumber.$ccEagerType == 'MasterCard' ? 'selected':''}}\"/>\n            <img src=\"" + __webpack_require__("h627") + "\" width=\"50px\" class=\"cardImage {{cardForm.creditCardNumber.$ccEagerType == 'American Express' ? 'selected' : ''}}\"/>\n            <img src=\"" + __webpack_require__("9jXu") + "\" width=\"50px\" class=\"cardImage {{cardForm.creditCardNumber.$ccEagerType == 'Discover' ? 'selected' : ''}}\"/>\n            <img src=\"" + __webpack_require__("Rnnk") + "\" width=\"50px\" class=\"cardImage {{cardForm.creditCardNumber.$ccEagerType == 'Diners Club' ? 'selected': ''}}\"/>\n            <img src=\"" + __webpack_require__("sz64") + "\" width=\"50px\" class=\"cardImage {{cardForm.creditCardNumber.$ccEagerType == 'JCB' ? 'selected' : ''}}\"/>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <label>Full Name On Card</label>\n              <input type=\"text\" ng-model=\"selectPlanConfig.cardUpdate.creditCardName\" required name=\"creditCardName\" autocomplete=\"cc-name\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <label>Card Number</label>\n              <input type=\"tel\" inputmode=\"numeric\" ng-model=\"selectPlanConfig.cardUpdate.creditCardNumber\" required cc-number cc-eager-type name=\"creditCardNumber\" id='cc-number' autocomplete=\"cc-number\" pattern=\"[0-9\\s]{13,19}\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <div flex-gt-sm=\"20\">\n              <label class=\"expiryLabel\">Expiry</label>\n            </div>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"40\">\n              <label>Month</label>\n              <md-select aria-label=\"Expiry Month\" ng-model=\"selectPlanConfig.cardUpdate.expiry_month\" id=\"cc-exp-month\" required autocomplete=\"cc-exp-month\">\n                <md-option value=\"1\">01 - January</md-option>\n                <md-option value=\"2\">02 - February</md-option>\n                <md-option value=\"3\">03 - March</md-option>\n                <md-option value=\"4\">04 - April</md-option>\n                <md-option value=\"5\">05 - May</md-option>\n                <md-option value=\"6\">06 - June</md-option>\n                <md-option value=\"7\">07 - July</md-option>\n                <md-option value=\"8\">08 - August</md-option>\n                <md-option value=\"9\">09 - September</md-option>\n                <md-option value=\"10\">10 - October</md-option>\n                <md-option value=\"11\">11 - November</md-option>\n                <md-option value=\"12\">12 - December</md-option>\n              </md-select>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"40\">\n              <label>Year</label>\n              <md-select aria-label=\"Expiry Month\" ng-model=\"selectPlanConfig.cardUpdate.expiry_year\" id=\"cc-exp-year\" required autocomplet=\"cc-exp-year\">\n                <md-option ng-repeat=\"year in cardYears\" ng-value=\"year.short\">{{year.full}}</md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Security Code / CVC</label>\n              <input type=\"text\" ng-model=\"selectPlanConfig.cardUpdate.cvc\" required cc-cvc cc-type=\"cardForm.creditCardNumber.$ccEagerType\" id=\"cc-csc\" autocomplete=\"cc-csc\">\n            </md-input-container>\n            <!--<md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>ZIP / Post Code</label>\n              <input type=\"text\" ng-model=\"selectPlanConfig.cardUpdate.zip\" required>\n            </md-input-container>-->\n          </div>\n          <div class=\"buttons\">\n            <div class=\"dbButton rightMargin\" ng-click=\"backToPlans()\" ng-if=\"!selectPlanConfig.updateCardOnly\">Back</div>\n            <button type=\"submit\" class=\"dbButton lightBlue\" ng-disabled=\"cardForm.$invalid\">Continue</button>\n          </div>\n        </form>\n      </div>\n    </div>\n\n    <div class=\"content\" ng-if=\"selectPlanConfig.mode == 'success'\">\n      <span ng-if=\"selectPlanConfig.saving\">\n        <h1>Hang Tight...Saving</h1>\n      </span>\n      <span ng-if=\"!selectPlanConfig.saving && !selectPlanConfig.error\">\n        <div class=\"billingSuccessOuter\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n        </div>\n        <div class=\"billingSuccessMessage\">\n          You're billing details have been updated!\n          <br/>\n          <div class=\"dbButton\" ng-click=\"refreshPage()\">Done</div>\n        </div>\n      </span>\n      <span ng-if=\"!selectPlanConfig.saving && selectPlanConfig.error\">\n        <div class=\"billingSuccessOuter error\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n        </div>\n        <div class=\"billingSuccessMessage\">\n          Something went wrong when we tried to save your billing details. Please try again.\n          <br/>\n          <div class=\"dbButton\" ng-click=\"closePlanSelect()\">Done</div>\n        </div>\n      </span>\n    </div>\n  </div>\n</div>\n<!-- Edit Resource Modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Mu0W":
/***/ (function(module, exports) {

var path = 'views/modals/selectTemplateModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectTemplateModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Template</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeTemplateSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"noListMessage\" ng-show=\"templateSearchList.length <= 0 && templateSearchListFull.length > 0\">\n        There are no templates matching your search criteria.\n      </div>\n      <md-table-container ng-show=\"templateSearchList.length > 0\">\n        <table md-table md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Name</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"template in templateSearchList\" md-select=\"template\" md-auto-select md-select-id=\"id\" ng-disabled=\"template.existing\" class=\"{{template.existing ? 'disabled':''}}\">\n              <td md-cell>\n                {{template.name}}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeTemplateSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || desktopSelectTemplateContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Muko":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "expand_more.svg";

/***/ }),

/***/ "N+O6":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/users.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\">\n    <div class=\"left\">\n      <h3>Users</h3>\n      <span class=\"subHeading\" ng-if=\"currentOrg.planFeatures.includedUsers != -1 && allUsers.length >= currentOrg.planFeatures.includedUsers\">The {{currentOrg.planFeatures.name}} Plan only includes {{currentOrg.planFeatures.includedUsers}} user{{currentOrg.planFeatures.includedUsers > 1 ? 's' : ''}}. <a ng-click=\"selectPlan(null, 'users', 'from users page - upgrade now')\">Upgrade now</a> to add more users.</span>\n      <span class=\"subHeading\" ng-if=\"currentOrg.planFeatures.includedUsers != -1 && allUsers.length < currentOrg.planFeatures.includedUsers\">You can add {{currentOrg.planFeatures.includedUsers - allUsers.length}} more user{{currentOrg.planFeatures.includedUsers - allUsers.length > 1 ? 's' : ''}} on the {{currentOrg.planFeatures.name}} Plan. Need more? <a ng-click=\"selectPlan(null, null, 'from users page - upgrade now')\">Upgrade now</a></span>\n    </div>\n    <div class=\"right\">\n      <md-button class=\"md-icon-button\" ng-click=\"importNewMembers()\" aria-label=\"Import Users From File\">\n        <md-icon md-svg-icon=\"import.svg\"></md-icon>\n      </md-button>\n      <div class=\"dbButton\" ng-click=\"(currentOrg.planFeatures.includedUsers == -1 || allUsers.length < currentOrg.planFeatures.includedUsers) ? inviteNewMembers() : selectPlan(null, 'users', 'from users page - invite new button')\">\n        Invite New\n        <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.includedUsers != -1 && allUsers.length >= currentOrg.planFeatures.includedUsers\">\n          <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n        </span>\n        <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"right\" ng-if=\"currentOrg.planFeatures.includedUsers != -1 && currentOrg.groups.length >= currentOrg.planFeatures.includedUsers\">\n          <div style=\"font-size: 12px;\">Upgrade your plan to invite more users</div>\n        </md-tooltip>\n      </div>\n    </div>\n  </div>\n  <div class=\"adminTabularContentContainer\">\n    <md-tabs md-dynamic-height md-selected=\"selectedIndex\" md-border-bottom md-autoselect class=\"docketTabsInner\">\n      <md-tab label=\"Current Users ({{activeUsers.length}})\">\n        <div class=\"settingsTabTableContentInner\">\n          <md-table-container>\n            <table md-table>\n              <thead md-head>\n                <tr md-row>\n                  <th md-column>Name</th>\n                  <th md-column>Primary Contact</th>\n                  <th md-column>Access</th>\n                  <th md-column></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row ng-repeat=\"member in activeUsers\">\n                  <td md-cell>{{member.name.full}}</td>\n                  <td md-cell>{{member.emailAddress}}</td>\n                  <td md-cell>\n                    <span ng-if=\"member.isGlobalAdmin\">Super User</span>\n                    <!--<span ng-repeat=\"role in member.roles\">{{role.name}}<span ng-if=\"!role.last\">, </span></span>-->\n                  </td>\n                  <td md-cell style=\"text-align: right;\">\n                    <md-button class=\"md-icon-button\" ng-click=\"showEditUserModal(member)\" aria-label=\"Edit User\">\n                      <md-icon md-svg-icon=\"edit.svg\"></md-icon>\n                    </md-button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </md-tab>\n      <md-tab label=\"Invited ({{invitedUsers.length}})\">\n        <div class=\"settingsTabTableContentInner\">\n          <md-table-container>\n            <table md-table>\n              <thead md-head>\n                <tr md-row>\n                  <th md-column>Name</th>\n                  <th md-column>Primary Contact</th>\n                  <th md-column>Group(s)</th>\n                  <th md-column>Access</th>\n                  <th md-column></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row ng-repeat=\"member in invitedUsers\">\n                  <td md-cell>{{member.name.full}}</td>\n                  <td md-cell>{{member.emailAddress}}</td>\n                  <td md-cell>{{member.invitedGroupsString}}</td>\n                  <td md-cell class=\"iconColumn\">\n                    <span ng-if=\"member.isGlobalAdmin\">Super Admin</span>\n                  </td>\n                  <td md-cell style=\"text-align: right;\">\n                    <md-button class=\"md-icon-button\" ng-click=\"!sampleCompany && uninviteMember(member)\" aria-label=\"Remove Member From Group\" ng-disabled=\"sampleCompany\">\n                      <md-icon ng-hide=\"group.parents.length == 0\" md-svg-icon=\"delete.svg\"></md-icon>\n                      <md-tooltip ng-if=\"sampleCompany\">This feature is disabled inside a demo company.</md-tooltip>\n                    </md-button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </md-tab>\n    </md-tabs>\n  </div>\n</div>\n\n<ng-include src=\"'views/modals/inviteMembersModal.html'\"></ng-include>\n<ng-include src=\"'views/modals/editUserModal.html'\" ng-controller=\"editUserModal\"></ng-include>\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "NDZu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-152x152.png";

/***/ }),

/***/ "Niij":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (f) {
  if (( false ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    var g;if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }g.angularCreditCards = f();
  }
})(function () {
  var define, module, exports;return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
        }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }return n[o].exports;
    }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
      s(r[o]);
    }return s;
  }({ 1: [function (_dereq_, module, exports) {
      exports = module.exports = ap;
      function ap(args, fn) {
        return function () {
          var rest = [].slice.call(arguments),
              first = args.slice();
          first.push.apply(first, rest);
          return fn.apply(this, first);
        };
      }

      exports.pa = pa;
      function pa(args, fn) {
        return function () {
          var rest = [].slice.call(arguments);
          rest.push.apply(rest, args);
          return fn.apply(this, rest);
        };
      }

      exports.apa = apa;
      function apa(left, right, fn) {
        return function () {
          return fn.apply(this, left.concat.apply(left, arguments).concat(right));
        };
      }

      exports.partial = partial;
      function partial(fn) {
        var args = [].slice.call(arguments, 1);
        return ap(args, fn);
      }

      exports.partialRight = partialRight;
      function partialRight(fn) {
        var args = [].slice.call(arguments, 1);
        return pa(args, fn);
      }

      exports.curry = curry;
      function curry(fn) {
        return partial(partial, fn);
      }

      exports.curryRight = function curryRight(fn) {
        return partial(partialRight, fn);
      };
    }, {}], 2: [function (_dereq_, module, exports) {
      var upperCase = _dereq_('upper-case');
      var sentenceCase = _dereq_('sentence-case');

      /**
       * Camel case a string.
       *
       * @param  {String} string
       * @param  {String} [locale]
       * @return {String}
       */
      module.exports = function (string, locale) {
        return sentenceCase(string, locale)
        // Replace periods between numeric entities with an underscore.
        .replace(/(\d) (?=\d)/g, '$1_')
        // Replace spaces between words with an upper cased character.
        .replace(/ (.)/g, function (m, $1) {
          return upperCase($1, locale);
        });
      };
    }, { "sentence-case": 24, "upper-case": 28 }], 3: [function (_dereq_, module, exports) {
      'use strict';

      var isArray = _dereq_('isarray');

      module.exports = function castArray(value) {
        return isArray(value) ? value : [value];
      };
    }, { "isarray": 19 }], 4: [function (_dereq_, module, exports) {
      'use strict';

      exports.card = _dereq_('./src/card');
      exports.cvc = _dereq_('./src/cvc');
      exports.expiration = _dereq_('./src/expiration');
    }, { "./src/card": 9, "./src/cvc": 10, "./src/expiration": 11 }], 5: [function (_dereq_, module, exports) {
      'use strict';

      var types = exports.types = _dereq_('./src/types');
      exports.Type = _dereq_('./src/type');

      exports.find = function findCardType(callback) {
        for (var typeName in types) {
          var type = types[typeName];
          var result = callback(type);
          if (result) return type;
        }
      };
    }, { "./src/type": 7, "./src/types": 8 }], 6: [function (_dereq_, module, exports) {
      module.exports = extend;

      var hasOwnProperty = Object.prototype.hasOwnProperty;

      function extend(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      }
    }, {}], 7: [function (_dereq_, module, exports) {
      'use strict';

      var extend = _dereq_('xtend/mutable');

      module.exports = CardType;

      function CardType(name, config) {
        extend(this, { name: name }, config);
      }

      CardType.prototype.cvcLength = 3;
      CardType.prototype.luhn = true;
      CardType.prototype.groupPattern = /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?/;

      CardType.prototype.group = function (number) {
        return (number.match(this.groupPattern) || []).slice(1).filter(Boolean);
      };

      CardType.prototype.test = function (number, eager) {
        return this[eager ? 'eagerPattern' : 'pattern'].test(number);
      };
    }, { "xtend/mutable": 6 }], 8: [function (_dereq_, module, exports) {
      'use strict';

      var Type = _dereq_('./type');

      var group19 = /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/;

      exports.visa = new Type('Visa', {
        pattern: /^4\d{12}(\d{3}|\d{6})?$/,
        eagerPattern: /^4/,
        groupPattern: group19
      });

      exports.maestro = new Type('Maestro', {
        pattern: /^(?:5[06789]\d\d|(?!6011[0234])(?!60117[4789])(?!60118[6789])(?!60119)(?!64[456789])(?!65)6\d{3})\d{8,15}$/,
        eagerPattern: /^(5(018|0[23]|[68])|6[37]|60111|60115|60117([56]|7[56])|60118[0-5]|64[0-3]|66)/,
        groupPattern: group19
      });

      exports.forbrugsforeningen = new Type('Forbrugsforeningen', {
        pattern: /^600722\d{10}$/,
        eagerPattern: /^600/
      });

      exports.dankort = new Type('Dankort', {
        pattern: /^5019\d{12}$/,
        eagerPattern: /^5019/
      });

      exports.masterCard = new Type('MasterCard', {
        pattern: /^5[1-5]\d{14}$/,
        eagerPattern: /^5[1-5]/
      });

      exports.americanExpress = new Type('American Express', {
        pattern: /^3[47]\d{13}$/,
        eagerPattern: /^3[47]/,
        groupPattern: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        cvcLength: 4
      });

      exports.dinersClub = new Type('Diners Club', {
        pattern: /^3(0[0-5]|[68]\d)\d{11}$/,
        eagerPattern: /^3(0|[68])/,
        groupPattern: /(\d{1,4})?(\d{1,6})?(\d{1,4})?/
      });

      exports.discover = new Type('Discover', {
        pattern: /^6(011(0[0-9]|[2-4]\d|74|7[7-9]|8[6-9]|9[0-9])|4[4-9]\d{3}|5\d{4})\d{10}$/,
        eagerPattern: /^6(011(0[0-9]|[2-4]|74|7[7-9]|8[6-9]|9[0-9])|4[4-9]|5)/
      });

      exports.jcb = new Type('JCB', {
        pattern: /^35\d{14}$/,
        eagerPattern: /^35/
      });

      exports.unionPay = new Type('UnionPay', {
        pattern: /^62[0-5]\d{13,16}$/,
        eagerPattern: /^62/,
        groupPattern: group19,
        luhn: false
      });
    }, { "./type": 7 }], 9: [function (_dereq_, module, exports) {
      'use strict';

      var luhn = _dereq_('fast-luhn');
      var types = _dereq_('./types');

      exports.types = types;

      exports.parse = function parseCard(number) {
        if (typeof number !== 'string') return '';
        return number.replace(/[^\d]/g, '');
      };

      exports.format = function formatCard(number, separator) {
        var type = getType(number, true);
        if (!type) return number;
        return type.group(number).join(separator || ' ');
      };

      exports.type = function cardType(number, eager) {
        var type = getType(number, eager);
        return type ? type.name : undefined;
      };

      exports.luhn = luhn;

      exports.isValid = function isCardValid(number, type) {
        if (type) {
          type = types.get(type);
        } else {
          type = getType(number);
        }
        if (!type) return false;
        return (!type.luhn || luhn(number)) && type.test(number);
      };

      function getType(number, eager) {
        return types.find(function (type) {
          return type.test(number, eager);
        });
      }
    }, { "./types": 12, "fast-luhn": 14 }], 10: [function (_dereq_, module, exports) {
      'use strict';

      var types = _dereq_('./types');
      var cvcRegex = /^\d{3,4}$/;

      exports.isValid = function cvcIsValid(cvc, type) {
        if (typeof cvc !== 'string') return false;
        if (!cvcRegex.test(cvc)) return false;
        if (!type) return true;
        return types.get(type).cvcLength === cvc.length;
      };
    }, { "./types": 12 }], 11: [function (_dereq_, module, exports) {
      'use strict';

      var isValidMonth = _dereq_('is-valid-month');
      var parseIntStrict = _dereq_('parse-int');
      var parseYear = _dereq_('parse-year');

      exports.isPast = function (month, year) {
        return Date.now() >= new Date(year, month);
      };

      exports.month = {
        parse: function parseMonth(month) {
          return parseIntStrict(month);
        },
        isValid: isValidMonth
      };

      exports.year = {
        parse: parseYear,
        format: function formatExpYear(year, strip) {
          year = year.toString();
          return strip ? year.substr(2, 4) : year;
        },
        isValid: function isExpYearValid(year) {
          if (typeof year !== 'number') return false;
          year = parseIntStrict(year);
          return year > 0;
        },
        isPast: function isExpYearPast(year) {
          return new Date().getFullYear() > year;
        }
      };
    }, { "is-valid-month": 18, "parse-int": 22, "parse-year": 23 }], 12: [function (_dereq_, module, exports) {
      'use strict';

      var ccTypes = _dereq_('creditcards-types');
      var camel = _dereq_('camel-case');
      var extend = _dereq_('xtend');

      module.exports = extend(ccTypes, {
        get: function getTypeByName(name) {
          return ccTypes.types[camel(name)];
        }
      });
    }, { "camel-case": 2, "creditcards-types": 5, "xtend": 29 }], 13: [function (_dereq_, module, exports) {
      'use strict';

      var zeroFill = _dereq_('zero-fill');
      var parseIntStrict = _dereq_('parse-int');

      var pad = zeroFill(2);

      module.exports = function expandYear(year, now) {
        now = now || new Date();
        var base = now.getFullYear().toString().substr(0, 2);
        year = parseIntStrict(year);
        return parseIntStrict(base + pad(year));
      };
    }, { "parse-int": 22, "zero-fill": 30 }], 14: [function (_dereq_, module, exports) {
      'use strict';

      module.exports = function (array) {
        return function luhn(number) {
          if (!number) return false;
          var length = number.length;
          var bit = 1;
          var sum = 0;
          var value;

          while (length) {
            value = parseInt(number.charAt(--length), 10);
            sum += (bit ^= 1) ? array[value] : value;
          }

          return !!sum && sum % 10 === 0;
        };
      }([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);
    }, {}], 15: [function (_dereq_, module, exports) {
      var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
      var slice = Array.prototype.slice;
      var toStr = Object.prototype.toString;
      var funcType = '[object Function]';

      module.exports = function bind(that) {
        var target = this;
        if (typeof target !== 'function' || toStr.call(target) !== funcType) {
          throw new TypeError(ERROR_MESSAGE + target);
        }
        var args = slice.call(arguments, 1);

        var binder = function binder() {
          if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice.call(arguments)));
            if (Object(result) === result) {
              return result;
            }
            return this;
          } else {
            return target.apply(that, args.concat(slice.call(arguments)));
          }
        };

        var boundLength = Math.max(0, target.length - args.length);
        var boundArgs = [];
        for (var i = 0; i < boundLength; i++) {
          boundArgs.push('$' + i);
        }

        var bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

        if (target.prototype) {
          var Empty = function Empty() {};
          Empty.prototype = target.prototype;
          bound.prototype = new Empty();
          Empty.prototype = null;
        }

        return bound;
      };
    }, {}], 16: [function (_dereq_, module, exports) {
      'use strict';

      var numberIsNan = _dereq_('number-is-nan');

      module.exports = Number.isFinite || function (val) {
        return !(typeof val !== 'number' || numberIsNan(val) || val === Infinity || val === -Infinity);
      };
    }, { "number-is-nan": 21 }], 17: [function (_dereq_, module, exports) {
      // https://github.com/paulmillr/es6-shim
      // http://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isinteger
      var isFinite = _dereq_("is-finite");
      module.exports = Number.isInteger || function (val) {
        return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
      };
    }, { "is-finite": 16 }], 18: [function (_dereq_, module, exports) {
      'use strict';

      var isInteger = _dereq_('is-integer');

      module.exports = function isValidMonth(month) {
        if (typeof month !== 'number' || !isInteger(month)) return false;
        return month >= 1 && month <= 12;
      };
    }, { "is-integer": 17 }], 19: [function (_dereq_, module, exports) {
      module.exports = Array.isArray || function (arr) {
        return Object.prototype.toString.call(arr) == '[object Array]';
      };
    }, {}], 20: [function (_dereq_, module, exports) {
      /**
       * Special language-specific overrides.
       *
       * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
       *
       * @type {Object}
       */
      var LANGUAGES = {
        tr: {
          regexp: /\u0130|\u0049|\u0049\u0307/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        az: {
          regexp: /[\u0130]/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        lt: {
          regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
          map: {
            "I": "i\u0307",
            "J": "j\u0307",
            "\u012E": "\u012F\u0307",
            "\xCC": "i\u0307\u0300",
            "\xCD": "i\u0307\u0301",
            "\u0128": "i\u0307\u0303"
          }
        }

        /**
         * Lowercase a string.
         *
         * @param  {String} str
         * @return {String}
         */
      };module.exports = function (str, locale) {
        var lang = LANGUAGES[locale];

        str = str == null ? '' : String(str);

        if (lang) {
          str = str.replace(lang.regexp, function (m) {
            return lang.map[m];
          });
        }

        return str.toLowerCase();
      };
    }, {}], 21: [function (_dereq_, module, exports) {
      'use strict';

      module.exports = Number.isNaN || function (x) {
        return x !== x;
      };
    }, {}], 22: [function (_dereq_, module, exports) {
      'use strict';

      var isInteger = _dereq_('is-integer');

      module.exports = function parseIntStrict(int) {
        if (typeof int === 'number') {
          return isInteger(int) ? int : undefined;
        }
        if (typeof int === 'string') {
          return (/^\d+$/.test(int) ? parseInt(int, 10) : undefined
          );
        }
      };
    }, { "is-integer": 17 }], 23: [function (_dereq_, module, exports) {
      'use strict';

      var parseIntStrict = _dereq_('parse-int');
      var expandYear = _dereq_('expand-year');

      module.exports = function parseYear(year, expand, now) {
        year = parseIntStrict(year);
        if (year == null) return;
        if (!expand) return year;
        return expandYear(year, now);
      };
    }, { "expand-year": 13, "parse-int": 22 }], 24: [function (_dereq_, module, exports) {
      var lowerCase = _dereq_('lower-case');

      var NON_WORD_REGEXP = _dereq_('./vendor/non-word-regexp');
      var CAMEL_CASE_REGEXP = _dereq_('./vendor/camel-case-regexp');
      var TRAILING_DIGIT_REGEXP = _dereq_('./vendor/trailing-digit-regexp');

      /**
       * Sentence case a string.
       *
       * @param  {String} str
       * @param  {String} locale
       * @param  {String} replacement
       * @return {String}
       */
      module.exports = function (str, locale, replacement) {
        if (str == null) {
          return '';
        }

        replacement = replacement || ' ';

        function replace(match, index, string) {
          if (index === 0 || index === string.length - match.length) {
            return '';
          }

          return replacement;
        }

        str = String(str)
        // Support camel case ("camelCase" -> "camel Case").
        .replace(CAMEL_CASE_REGEXP, '$1 $2')
        // Support digit groups ("test2012" -> "test 2012").
        .replace(TRAILING_DIGIT_REGEXP, '$1 $2')
        // Remove all non-word characters and replace with a single space.
        .replace(NON_WORD_REGEXP, replace);

        // Lower case the entire string.
        return lowerCase(str, locale);
      };
    }, { "./vendor/camel-case-regexp": 25, "./vendor/non-word-regexp": 26, "./vendor/trailing-digit-regexp": 27, "lower-case": 20 }], 25: [function (_dereq_, module, exports) {
      module.exports = /([\u0061-\u007A\u00B5\u00DF-\u00F6\u00F8-\u00FF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0561-\u0587\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7FA\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])([\u0041-\u005A\u00C0-\u00D6\u00D8-\u00DE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA\uFF21-\uFF3A\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])/g;
    }, {}], 26: [function (_dereq_, module, exports) {
      module.exports = /[^\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g;
    }, {}], 27: [function (_dereq_, module, exports) {
      module.exports = /([\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([^\u0030-\u0039\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])/g;
    }, {}], 28: [function (_dereq_, module, exports) {
      /**
       * Special language-specific overrides.
       *
       * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
       *
       * @type {Object}
       */
      var LANGUAGES = {
        tr: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        az: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        lt: {
          regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
          map: {
            "i\u0307": "I",
            "j\u0307": "J",
            "\u012F\u0307": "\u012E",
            "i\u0307\u0300": "\xCC",
            "i\u0307\u0301": "\xCD",
            "i\u0307\u0303": "\u0128"
          }
        }

        /**
         * Upper case a string.
         *
         * @param  {String} str
         * @return {String}
         */
      };module.exports = function (str, locale) {
        var lang = LANGUAGES[locale];

        str = str == null ? '' : String(str);

        if (lang) {
          str = str.replace(lang.regexp, function (m) {
            return lang.map[m];
          });
        }

        return str.toUpperCase();
      };
    }, {}], 29: [function (_dereq_, module, exports) {
      module.exports = extend;

      var hasOwnProperty = Object.prototype.hasOwnProperty;

      function extend() {
        var target = {};

        for (var i = 0; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      }
    }, {}], 30: [function (_dereq_, module, exports) {
      /**
       * Given a number, return a zero-filled string.
       * From http://stackoverflow.com/questions/1267283/
       * @param  {number} width
       * @param  {number} number
       * @return {string}
       */
      module.exports = function zeroFill(width, number, pad) {
        if (number === undefined) {
          return function (number, pad) {
            return zeroFill(width, number, pad);
          };
        }
        if (pad === undefined) pad = '0';
        width -= number.toString().length;
        if (width > 0) return new Array(width + (/\./.test(number) ? 2 : 1)).join(pad) + number;
        return number + '';
      };
    }, {}], 31: [function (_dereq_, module, exports) {
      'use strict';

      var cvc = _dereq_('creditcards').cvc;
      var bind = _dereq_('function-bind');

      module.exports = factory;

      factory.$inject = ['$parse'];
      function factory($parse) {
        return {
          restrict: 'A',
          require: 'ngModel',
          compile: function compile(element, attributes) {
            attributes.$set('maxlength', 4);
            attributes.$set('pattern', '[0-9]*');
            attributes.$set('xAutocompletetype', 'cc-csc');

            return function (scope, element, attributes, ngModel) {
              ngModel.$validators.ccCvc = function (value) {
                return ngModel.$isEmpty(ngModel.$viewValue) || cvc.isValid(value, $parse(attributes.ccType)(scope));
              };

              if (attributes.ccType) {
                scope.$watch(attributes.ccType, bind.call(ngModel.$validate, ngModel));
              }
            };
          }
        };
      }
    }, { "creditcards": 4, "function-bind": 15 }], 32: [function (_dereq_, module, exports) {
      'use strict';

      var expiration = _dereq_('creditcards').expiration;
      var month = expiration.month;
      var year = expiration.year;
      var ap = _dereq_('ap');

      exports = module.exports = function ccExp() {
        return {
          restrict: 'AE',
          require: 'ccExp',
          controller: CcExpController,
          link: function link(scope, element, attributes, ccExp) {
            ccExp.$watch();
          }
        };
      };

      CcExpController.$inject = ['$scope', '$element'];
      function CcExpController($scope, $element) {
        var nullFormCtrl = {
          $setValidity: noop
        };
        var parentForm = $element.inheritedData('$formController') || nullFormCtrl;
        var ngModel = {
          year: {},
          month: {}
        };

        this.setMonth = function (monthCtrl) {
          ngModel.month = monthCtrl;
        };
        this.setYear = function (yearCtrl) {
          ngModel.year = yearCtrl;
        };

        function setValidity(exp) {
          var expMonth = exp.month;
          var expYear = exp.year;
          var valid = expMonth == null && expYear == null || !!expMonth && !!expYear && !expiration.isPast(expMonth, expYear);
          parentForm.$setValidity('ccExp', valid, $element);
        }

        this.$watch = function $watchExp() {
          $scope.$watch(function watchExp() {
            return {
              month: ngModel.month.$modelValue,
              year: ngModel.year.$modelValue
            };
          }, setValidity, true);
        };
      }

      var nullCcExp = {
        setMonth: noop,
        setYear: noop
      };

      exports.month = function ccExpMonth() {
        return {
          restrict: 'A',
          require: ['ngModel', '^?ccExp'],
          compile: function compile(element, attributes) {
            attributes.$set('maxlength', 2);
            attributes.$set('pattern', '[0-9]*');
            attributes.$set('xAutocompletetype', 'cc-exp-month');

            return function (scope, element, attributes, controllers) {
              var ngModel = controllers[0];
              var ccExp = controllers[1] || nullCcExp;

              ccExp.setMonth(ngModel);
              ngModel.$parsers.unshift(month.parse);
              ngModel.$validators.ccExpMonth = function validateExpMonth(value) {
                return ngModel.$isEmpty(ngModel.$viewValue) || month.isValid(value);
              };
            };
          }
        };
      };

      exports.year = function ccExpYear() {
        return {
          restrict: 'A',
          require: ['ngModel', '^?ccExp'],
          compile: function compile(element, attributes) {
            var fullYear = attributes.fullYear !== undefined;

            attributes.$set('maxlength', fullYear ? 4 : 2);
            attributes.$set('pattern', '[0-9]*');
            attributes.$set('xAutocompletetype', 'cc-exp-year');

            return function (scope, element, attributes, controllers) {
              var ngModel = controllers[0];
              var ccExp = controllers[1] || nullCcExp;

              ccExp.setYear(ngModel);

              ngModel.$parsers.unshift(ap.partialRight(year.parse, !fullYear));

              ngModel.$formatters.unshift(function formatExpYear(value) {
                return value ? year.format(value, !fullYear) : '';
              });

              ngModel.$validators.ccExpYear = function validateExpYear(value) {
                return ngModel.$isEmpty(ngModel.$viewValue) || year.isValid(value) && !year.isPast(value);
              };
            };
          }
        };
      };

      function noop() {}
    }, { "ap": 1, "creditcards": 4 }], 33: [function (_dereq_, module, exports) {
      'use strict';

      var card = _dereq_('creditcards').card;
      var array = _dereq_('cast-array');
      var partial = _dereq_('ap').partial;

      module.exports = factory;

      factory.$inject = ['$parse'];
      function factory($parse) {
        return {
          restrict: 'A',
          require: ['ngModel', 'ccNumber'],
          controller: function controller() {
            this.type = null;
            this.eagerType = null;
          },
          compile: function compile($element, $attributes) {
            $attributes.$set('pattern', '[0-9]*');
            $attributes.$set('xAutocompletetype', 'cc-number');

            return function ($scope, $element, $attributes, controllers) {
              var ngModel = controllers[0];
              var ccNumber = controllers[1];

              $scope.$watch($attributes.ngModel, function (number) {
                ngModel.$ccType = ccNumber.type = card.type(number);
              });

              function $viewValue() {
                return ngModel.$viewValue;
              }

              function setCursorPostion(element, position) {
                if (element.setSelectionRange) {
                  element.setSelectionRange(position, position);
                } else if (element.createTextRange) {
                  var range = element.createTextRange();
                  range.move('character', position);
                  range.select();
                }
              }

              if ($attributes.ccEagerType != null) {
                $scope.$watch($viewValue, function eagerTypeCheck(number) {
                  number = card.parse(number);
                  ngModel.$ccEagerType = ccNumber.eagerType = card.type(number, true);
                });
              }

              if ($attributes.ccType) {
                $scope.$watch($attributes.ccType, function () {
                  ngModel.$validate();
                });
              }

              if ($attributes.ccFormat != null) {
                $element.on('input', function formatInput() {
                  var input = $element.val();
                  var previous = $viewValue();
                  if (!input) return;
                  var element = $element[0];
                  var formatted = card.format(card.parse(input));

                  var selectionEnd = element.selectionEnd;
                  ngModel.$setViewValue(formatted);
                  ngModel.$render();
                  if (formatted && !formatted.charAt(selectionEnd - 1).trim()) {
                    if (previous && previous.length < formatted.length) {
                      selectionEnd++;
                    } else {
                      selectionEnd--;
                    }
                  }
                  setCursorPostion(element, selectionEnd);
                });
              }

              ngModel.$parsers.unshift(card.parse);

              ngModel.$validators.ccNumber = function validateCcNumber(number) {
                return ngModel.$isEmpty(ngModel.$viewValue) || card.isValid(number);
              };

              ngModel.$validators.ccNumberType = function validateCcNumberType(number) {
                if (ngModel.$isEmpty(ngModel.$viewValue)) return true;
                var type = $parse($attributes.ccType)($scope);
                if (!type) card.isValid(number);
                return array(type).some(partial(card.isValid, number));
              };
            };
          }
        };
      }
    }, { "ap": 1, "cast-array": 3, "creditcards": 4 }], 34: [function (_dereq_, module, exports) {
      (function (global) {
        'use strict';

        var angular = typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null;
        var creditcards = _dereq_('creditcards');
        var number = _dereq_('./number');
        var cvc = _dereq_('./cvc');
        var expiration = _dereq_('./expiration');

        module.exports = angular.module('credit-cards', []).value('creditcards', creditcards).directive('ccNumber', number).directive('ccExp', expiration).directive('ccExpMonth', expiration.month).directive('ccExpYear', expiration.year).directive('ccCvc', cvc).name;
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, { "./cvc": 31, "./expiration": 32, "./number": 33, "creditcards": 4 }] }, {}, [34])(34);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "NnfY":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/ordersBottomSheet.html';
var html = "<md-bottom-sheet class=\"md-list\">\n  <md-list>\n    <md-list-item ng-show=\"userCanDoAction('reDraftOrder', itemEdit)\">\n      <md-button ng-click=\"reDraftOrder(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Re-Draft Order</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('sendOrder', itemEdit)\">\n      <md-button ng-click=\"sendOrder(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Send Order</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('acceptOrder', itemEdit)\">\n      <md-button ng-click=\"acceptOrder(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Accept Order</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('rejectOrder', itemEdit)\">\n      <md-button ng-click=\"rejectOrder(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Reject Order</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('finishOrder', itemEdit)\">\n      <md-button ng-click=\"finishOrder(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Close Order</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item>\n      <md-button ng-click=\"shareOrder(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Share Order</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('deleteOrder', itemEdit)\">\n      <md-button ng-click=\"deleteOrder(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Delete Order</span>\n      </md-button>\n    </md-list-item>\n  </md-list>\n</md-bottom-sheet>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Nq2c":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/assigneesTab.html';
var html = "<div class=\"customListRowOuter\" ng-show=\"!userCanDoAction('assignUserToJob', itemEdit) && cleanAssignees.length <= 0\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem message\">No people have been assigned to this job</div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-show=\"userCanDoAction('assignUserToJob', itemEdit)\" ng-click=\"selectPerson()\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem createNew\"><div class=\"dbButton lightBlue\">Assign person to job</div></div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-repeat=\"assignee in cleanAssignees\" id=\"listItem{{assignee.assignee}}\" ng-show=\"!assignee.delete\">\n  <div class=\"customListRow {{assignee.status}}\" hm-swipeLeft=\"splitListFunc.swipeListItem(assignee.assignee)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(assignee.assignee)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}'>\n    <div class=\"listRowItem status\"><div class=\"statusDisplay {{assignee.status}}\">{{assignee.status}}</div></div>\n    <div class=\"listRowItem itemNumber\">{{assignee.name}}</div>\n    <div class=\"listRowItem collapsedDetail showCollapsed\">\n      {{assignee.rejectionComment}}\n    </div>\n  </div>\n  <div class=\"mobileListItemUnder visible-xs\">\n    <div class=\"listItemSelector\">\n      <div class=\"group\">\n        <input type=\"checkbox\" name=\"name\" ng-model=\"item.fileSelected\">\n        <div class=\"box\" ng-click=\"toggleFileSelection(item)\"><div class=\"check\"></div></div>\n      </div>\n    </div>\n      <div class=\"listItemControls\" id=\"listItemControls{{assignee.assignee}}\">\n        <div class=\"listItemBtn deleteIcon\" ng-click=\"unassignPerson(assignee, 'swipe')\" ng-show=\"!assignee.delete && userCanDoAction('unassignUserFromJob', itemEdit)\">\n          <md-icon md-svg-src=\"clear.svg\"></md-icon>\n          <div class=\"btnName\">Unassign</div>\n        </div>\n      </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Nqrr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('docketbook').controller('editUserGroupRolesModalController', ['addressBookService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', 'userService', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, userService) {

    $scope.member = {};
    $scope.originalRoles = [];
    $scope.activeRoles = [];
    $scope.wasMonitor = false;
    $scope.wasAdmin = false;
    $scope.monitor = false;
    $scope.admin = false;
    $scope.saving = false;
    $scope.allRoles = [];
    $scope.group = {};

    $scope.$parent.showEditUserGroupRolesModal = function (member, group) {
        $scope.saving = false;
        $scope.member = member;
        $scope.group = group;

        $scope.admin = group.owners.map(function (m) {
            return m.id;
        }).includes(member.id);
        $scope.wasAdmin = $scope.admin;

        $scope.superUser = member.isGlobalAdmin;

        $scope.allRoles = [];
        $scope.roleDict = {};

        userService.getRoles(null, function (roles) {
            $scope.allRoles = roles;
            roles.forEach(function (role) {
                return $scope.roleDict[role.id] = role;
            });
        }, function (err) {
            $scope.allRoles = [];
        });

        $scope.groupDict = {};
        $scope.currentOrg.groups.forEach(function (group) {
            $scope.groupDict[group.id] = group;
        });

        $("#editUserGroupRolesModal").fadeIn(100);

        userService.getOrganisationGroup(group.id, function (groupFull) {
            $scope.activeRoles = groupFull.members.filter(function (m) {
                return m.user.id == $scope.member.id;
            }).map(function (m) {
                return m.role;
            });

            $scope.originalRoles = $scope.activeRoles.slice();

            $scope.monitor = groupFull.monitors.map(function (m) {
                return m.id;
            }).includes($scope.member.id);
            $scope.wasMonitor = $scope.monitor;
        }, function (err) {
            $scope.alertService.presentAutoAlert('getOrgGroup', err);
        });
    };

    $scope.hasRole = function (role) {
        return $scope.activeRoles.map(function (r) {
            return r.id;
        }).includes(role.id);
    };

    $scope.toggleRole = function (role) {
        var remove = $scope.hasRole(role);
        if (remove) {
            $scope.activeRoles = $scope.activeRoles.filter(function (r) {
                return r.id != role.id;
            });
        } else {
            $scope.activeRoles.push(role);
        }
    };

    $scope.cancel = function () {
        $("#editUserGroupRolesModal").fadeOut(100);
    };

    $scope.removeUser = function () {
        swal({
            title: "Remove Member",
            text: 'Are you sure you wish to remove {member.name} entirely from the company?',
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            closeOnConfirm: true,
            closeOnCancel: true
        }, function (isConfirm) {
            if (isConfirm) {
                var groupsToRemove = $scope.originalMemberships.map(function (m) {
                    return m.groups[0];
                });
                var removeOneGroup = function removeOneGroup() {
                    if (groupsToRemove.length == 0) {
                        $("#editUserGroupRolesModal").fadeOut(100);
                        return;
                    }
                    var groupToRemove = groupsToRemove.pop();
                    userService.removeMemberFromGroup(groupToRemove, $scope.member.id, removeOneGroup, function (err) {
                        $scope.alertService.presentAutoAlert('removeGroupMember', err);
                        removeOneGroup();
                    });
                };
            }
        });
    };

    $scope.toggleAdmin = function () {
        $scope.admin = !$scope.admin;
    };

    $scope.toggleMonitor = function () {
        $scope.monitor = !$scope.monitor;
    };

    var checkMonitorEdit = function checkMonitorEdit() {
        return $q(function (pass, fail) {
            if ($scope.monitor != $scope.wasMonitor) {
                if ($scope.monitor) {
                    var person = [{ user: $scope.member.id, roles: ['monitor'] }];
                    userService.assignMembersToGroup($scope.group.id, person, pass, fail);
                } else {
                    userService.removeMonitorFromGroup($scope.group.id, $scope.member.id, pass, fail);
                }
            } else {
                pass();
            }
        });
    };

    var checkAdminEdit = function checkAdminEdit() {
        return $q(function (pass, fail) {
            if ($scope.admin != $scope.wasAdmin) {
                if ($scope.admin) {
                    var person = [{ user: $scope.member.id, roles: ['owner'] }];
                    userService.assignMembersToGroup($scope.group.id, person, pass, fail);
                } else {
                    userService.removeOwnerFromGroup($scope.group.id, $scope.member.id, pass, fail);
                }
            } else {
                pass();
            }
        });
    };

    $scope.saveUser = function () {

        var failures = [];

        checkMonitorEdit().then(function () {
            checkAdminEdit().then(function () {
                var _ref, _ref2;

                var individualAdds = (_ref = _).without.apply(_ref, [$scope.activeRoles.map(function (r) {
                    return r.id;
                })].concat(_toConsumableArray($scope.originalRoles.map(function (r) {
                    return r.id;
                }))));
                var individualDeletes = (_ref2 = _).without.apply(_ref2, [$scope.originalRoles.map(function (r) {
                    return r.id;
                })].concat(_toConsumableArray($scope.activeRoles.map(function (r) {
                    return r.id;
                }))));

                var removeOneMembership = function removeOneMembership() {
                    if (individualDeletes.length <= 0) {
                        $("#editUserGroupRolesModal").fadeOut(100);
                        $scope.$parent.editOrgGroup($scope.group);
                        return;
                    }

                    var toRemove = individualDeletes.pop();
                    userService.removeMemberRoleFromGroup($scope.group.id, $scope.member.id, toRemove, removeOneMembership, function (err) {
                        failures.push(err);
                        removeOneMembership();
                    });
                };

                var addOneMembership = function addOneMembership() {
                    if (individualAdds.length <= 0) {
                        return removeOneMembership();
                    }

                    var toAdd = individualAdds.pop();
                    var memberAdd = { user: $scope.member.id, role: toAdd };
                    userService.addMemberToGroup($scope.group.id, memberAdd, addOneMembership, function (err) {
                        failures.push(err);
                        addOneMembership();
                    });
                };
                addOneMembership();
            });
        });
    };

    $scope.addMembership = function () {
        $scope.groupsMemberships.push({ groups: [], role: {}, edit: true });
    };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "NtZK":
/***/ (function(module, exports) {

var path = 'views/modals/duplicateJobsModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"duplicateJobsModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Duplicate Jobs</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeDuplicateJobsModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"noListMessage\">\n        You have selected {{duplicateJobs.list.length}} jobs to duplicate.\n        <br/>\n        Set the start and end date for the new jobs to continue.\n      </div>\n      <form name=\"duplicateJobsForm\" novalidate>\n        <div class=\"modalFormTable padding\">\n          <div layout=\"row\" layout-align=\"start\" flex>\n            <md-input-container class=\"md-block datepicker\" flex=\"50\">\n              <label>Start Date</label>\n              <md-datepicker ng-model=\"duplicateJobs.startDate\" name=\"startDate\" required></md-datepicker>\n            </md-input-container>\n\n            <md-input-container class=\"md-block datepicker\" flex=\"50\">\n              <label>End Date</label>\n              <md-datepicker ng-model=\"duplicateJobs.endDate\" name=\"endDate\" required></md-datepicker>\n            </md-input-container>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n          <span ng-show=\"duplicateJobs.list.length > 1\">\n            {{duplicateJobs.list.length}} jobs will be duplicated.\n          </span>\n          <span ng-show=\"duplicateJobs.list.length == 1\">\n            1 job will be duplicated.\n          </span>\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeDuplicateJobsModal()\" ng-disabled=\"duplicateJobs.saving\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(duplicateJobsForm.$invalid || duplicateJobs.saving) || duplicateJobsContinue()\" ng-disabled=\"duplicateJobsForm.$invalid || duplicateJobs.saving\">\n            <span ng-hide=\"duplicateJobs.saving\">Create Jobs</span>\n            <md-progress-circular ng-show=\"duplicateJobs.saving\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "O5Hz":
/***/ (function(module, exports) {

var path = 'views/modals/createConnectionModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"createConnectionModal\">\n  <div class=\"modalContainer\" style=\"width: 700px;\">\n    <div class=\"header hidden-xs\">\n        <h1>Create Connections</h1>\n        <div class=\"headerCloseButton\" ng-click=\"close()\">\n            <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n        </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div ng-show=\"!importMode\">\n        <table md-table>\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Email Address*</th>\n              <th md-column>Company Name</th>\n              <th md-column>Contact Name</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"connection in newConnections\">\n              <td md-cell>\n                <md-input-container class=\"md-block\">\n                  <input tabindex=\"0\" type=\"email\" ng-model=\"connection.emailAddress\" required>\n                </md-input-container>\n              </td>\n              <td md-cell>\n                <md-input-container class=\"md-block\">\n                  <input tabindex=\"0\" type=\"text\" ng-model=\"connection.organisationName\">\n                </md-input-container>\n              </td>\n              <td md-cell>\n                <md-input-container class=\"md-block\">\n                  <input tabindex=\"0\" type=\"text\" ng-model=\"connection.fullName\">\n                </md-input-container>\n              </td>\n            </tr>\n            <tr md-row>\n              <td md-cell colspan=\"5\" style=\"text-align:center;padding:15px;\">\n                <div class=\"dbButton grey\" ng-click=\"addBlankConnection()\">Add Another</div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n      <div ng-show=\"importMode\">\n        <form name=\"importConnectionsForm\" novalidate>\n          <div class=\"content\">\n            Excel files only (.xls or .xlsx)\n            <br/>\n            <br/>\n            <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n          </div>\n        </form>\n      </div>\n    </div>\n\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n      </div>\n      <div class=\"right\">\n        <div ng-show=\"!importMode\">\n          <div class=\"dbButton white margin-right\" ng-click=\"close()\">\n              Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"send()\">\n              Send\n          </div>\n        </div>\n\n        <div ng-show=\"importMode\">\n          <div class=\"dbButton white margin-right\" ng-click=\"close()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(importConnectionsForm.$invalid || connectionsImport.loading) || importFromFile(file)\" ng-disabled=\"importConnectionsForm.$invalid || connectionsImport.loading\">\n            <span ng-hide=\"connectionsImport.loading\">Next</span>\n            <md-progress-circular ng-show=\"connectionsImport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n  ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "OHjz":
/***/ (function(module, exports) {

var path = 'views/selectors/resourceCategoryList.html';
var html = "<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"category in resourceCategorySearchList\"  ng-click=\"selectResourceCategory(category)\" id=\"listItem{{category.id}}\">\n          <div class=\"listRowItem itemNumber\">{{category.name}}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "OVgP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "more-vert.svg";

/***/ }),

/***/ "Om0b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('docketMobileDetailController', ['docketService', 'orderService', 'resourceService', 'addressBookService', 'userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', function (docketService, orderService, resourceService, addressBookService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {
  mixpanel.track("Opened DocketDetail Mobile");

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.itemEdit = null;
  $scope.viewState = 'docket';
  $scope.docketLoadingError = null;

  // Last geolocation
  $scope.lastGeolocation = {};
  $scope.lastGeolocationCheck = (0, _momentTimezone2.default)();

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.assignDocket = { organisations: [], selected: [] };
  $scope.fullApiPath = "" + "/" + $scope.urlVersion;

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  /***************************************/
  /***** Docket Detail View Controls *****/
  /***************************************/

  $scope.openDocketMobile = function (docket, openingTab) {
    $scope.docketLoadingError = null;
    $scope.viewState = 'docket';
    $scope.prepareForDocketFromParent(docket);
    docketService.getDocket(docket, true, function (docketFull) {
      $scope.lastCleanDocket = angular.copy(docketFull);
      $scope.loadDocketFromParent(docketFull, openingTab);
    }, function (err) {
      $scope.docketLoadingErrorFull = err;
      $scope.docketLoadingError = "Error Loading Docket";
    });
  };

  $scope.newDocket = function (fromType, fromId) {
    $scope.docketLoadingError = null;
    $scope.viewState = 'docket';
    $scope.prepareForDocketFromParent();
    $scope.newDocketFromParent(fromType, fromId, function (newDocket) {
      if (newDocket.id != null && $scope.currentOrg != null && $scope.currentOrgGroup != null) {
        $state.go('main.groupDocketDetail', { docketId: newDocket.id, orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else if (newDocket.id != null) {
        $state.go('main.docketDetail', { docketId: newDocket.id });
      } else {
        $scope.openNewDocketFromParent(newDocket);
      }
    });
  };

  $scope.closeDocket = function () {
    var stateBack = {};
    if ($stateParams.stateTrail && $stateParams.stateTrail.length > 0) {
      stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
    }
    var justGoToBasic = false;
    if (stateBack.name == 'main.groupDocketDetail' && stateBack.docketId == 'new') {
      if ($stateParams.stateTrail[$stateParams.stateTrail.length - 2]) {
        stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 2];
      } else {
        justGoToBasic = true;
      }
    }

    var stateOptions = {};
    if (stateBack.orderId) {
      stateOptions.orderId = stateBack.orderId;
    }
    if (stateBack.jobId) {
      stateOptions.jobId = stateBack.jobId;
    }
    if (stateBack.docketId) {
      stateOptions.docketId = stateBack.docketId;
    }
    if (stateBack.fromTab) {
      stateOptions.openTab = stateBack.fromTab;
    }
    if (stateBack.orgId) {
      stateOptions.orgId = stateBack.orgId;
    }
    if (stateBack.groupId) {
      stateOptions.groupId = stateBack.groupId;
    }
    if (justGoToBasic) {
      $state.go('main.groupDockets', stateOptions);
    } else if (stateBack.name) {
      $state.go(stateBack.name, stateOptions);
    } else {
      if ($scope.currentOrg != null) {
        $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else {
        $state.go('main.dockets');
      }
    }
  };

  $scope.saveAndStay = function (docket) {
    var newDocket = false;
    if (docket.id == null) {
      newDocket = true;
    }
    if (!$scope.progressiveSaveInProcess) {
      docket.loading = true;
      docket.loadingType = "saving";

      // get diff of docket
      if (docket.id != null) {
        docketService.getDiffedDocket($scope.lastCleanDocket, docket, null, function (diffedDocket, diffCount) {
          docketService.saveDocket(diffedDocket, function (docketUpdated) {
            $scope.showToast('Docket Changes Saved');
            $scope.openDocketMobile(docketUpdated.id, $scope.currentActiveTab());
          }, function (err) {
            docket.loading = false;
            $scope.alertService.presentAutoAlert('saveDocket', err);
          });
        });
      } else {
        docketService.saveDocket(docket, function (docketUpdated) {
          $scope.showToast('New Docket Saved');
          if ($scope.currentOrg != null) {
            $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketUpdated.id });
          } else {
            $state.go('main.docketDetail', { docketId: docketUpdated.id });
          }
          //$scope.openDocketMobile(docketUpdated.id, $scope.currentActiveTab());
        }, function (err) {
          docket.loading = false;
          $scope.alertService.presentAutoAlert('saveDocket', err);
        });
      }
    }
  };

  $scope.closeWithoutSave = function (docket) {
    // check if there are any changes first
    if (docket.id == null) {
      // new dockets arent checked for their diff - because their wont be one
      $scope.closeDocket();
      return;
    }

    docketService.getDiffedDocket($scope.lastCleanDocket, docket, 'tab', function (diffedDocket, diffCount) {
      if (diffCount > 0) {
        var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
          if (actionSelected == 'save') {
            docketService.saveDocket(diffedDocket, function (docketUpdated) {
              $scope.closeDocket();
            });
          } else if (actionSelected == 'dontSave') {
            $scope.closeDocket();
          } else {
            // do nothing - stay where we are
          }
        });
      } else {
        $scope.closeDocket();
      }
    });
  };

  /**************************/
  /***** Docket Actions *****/
  /**************************/

  $scope.deleteDocket = function (docket) {
    docketService.deleteDocket(docket, function () {
      $scope.closeDocket();
    }, function (err) {
      $scope.alertService.presentAutoAlert('deleteDocket', err);
    });
  };

  $scope.sendDocket = function (docket) {
    docket.loading = true;
    docket.loadingType = "saving";
    $mdBottomSheet.hide();
    docketService.validateDocket(docket, function () {
      // Docket has been validated to be ok - continue with save/send
      docketService.sendDocket($scope.lastCleanDocket, docket, function (docketUpdated) {
        $scope.openDocketMobile(docketUpdated.id);
      }, function (err) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('sendDocket', err);
      });
    }, function (errors) {
      docket.loading = false;
      var reasons = [];
      for (var i = 0; i < errors.length; i++) {
        reasons.push(errors[i].name);
      }
      $scope.alertService.presentAutoValidationAlert('sendDocket', reasons);
    });
  };

  $scope.acceptDocket = function (docket) {
    docket.loading = true;
    docket.loadingType = "saving";
    $mdBottomSheet.hide();
    docketService.acceptDocket(docket, function (docketUpdated) {
      docket.loading = false;
      $scope.openDocketMobile(docketUpdated.id);
    }, function (err) {
      docket.loading = false;
      $scope.alertService.presentAutoAlert('acceptDocket', err);
    });
  };

  $scope.reDraftDocket = function (docket) {
    docket.loading = true;
    docket.loadingType = "saving";
    $mdBottomSheet.hide();
    docketService.reDraftDocket(docket, function (docketUpdated) {
      docket.loading = false;
      $scope.openDocketMobile(docketUpdated.id);
    }, function (err) {
      docket.loading = false;
      $scope.showToast('Error Re-Drafting Docket');
    });
  };

  $scope.rejectDocket = function (docket) {
    docket.loading = true;
    docket.loadingType = 'saving';
    $mdBottomSheet.hide();
    swal({
      title: "Reject Docket " + docket.docketNumber,
      text: "Please provide a reason for rejecting this docket.",
      type: "input",
      showCancelButton: true,
      closeOnConfirm: true,
      inputPlaceholder: "Reason"
    }, function (inputValue) {
      if (inputValue === false) {
        return;
      }

      docketService.rejectDocket(docket, inputValue, function (docketUpdated) {
        docket.loading = false;
        $scope.openDocketMobile(docketUpdated.id);
      }, function (err) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('rejectDocket', err);
      });
    });
  };

  $scope.downloadDocket = function (docket) {
    var url = '/v1/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docket.id + '/downloadpdf';
    window.open(url, "_blank");
  };

  $scope.acceptAndFileDocket = function (docket) {
    docket.loading = true;
    docket.loadingType = "saving";
    $mdBottomSheet.hide();
    docketService.acceptDocket(docket, function (docketUpdated) {
      docket.loading = false;
      $state.go('main.groupFilingDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketUpdated.id });
    }, function (err) {
      docket.loading = false;
      $scope.alertService.presentAutoAlert('acceptDocket', err);
    });
  };

  /*****************************/
  /**** Progressive Saving *****/
  /*****************************/

  // Update docket after progressive save - IE add ID's to things that were new
  $scope.progressiveDocketUpdate = function (docket, updatedDocket) {
    // replace resources with new resources
    if (updatedDocket.resources != null) {
      docket.resources = updatedDocket.resources;
      $scope.resourcesSaveInProcess = false;
    } else {
      $scope.resourcesSaveInProcess = false;
    }
    $scope.lastCleanDocket = angular.copy(docket);

    if (docket.resources != null) {
      for (var i = 0; i < docket.resources.length; i++) {
        if (docket.resources[i].interactions != null) {
          for (var j = 0; j < docket.resources[i].interactions.length; j++) {
            if (docket.resources[i].interactions[j].interactionTemplate.fields) {
              for (var k = 0; k < docket.resources[i].interactions[j].interactionTemplate.fields.length; k++) {
                var field = docket.resources[i].interactions[j].interactionTemplate.fields[k];
                if (field.type == 'date') {
                  docket.resources[i].interactions[j].customFields[field.id] = (0, _momentTimezone2.default)(docket.resources[i].interactions[j].customFields[field.id]).toDate();
                }
              }
            }
          }
        }
      }
    }
  };

  // Detect any changes and save in background
  $scope.progressiveSaveDocket = function (docket, method) {
    if (!method) {
      method = 'tab';
    }
    if (!$scope.progressiveSaveInProcess && docket && docket.id != null) {
      $scope.backgroundLoadCount += 1;
      $scope.progressiveSaveInProcess = true;
      $scope.resourcesSaveInProcess = true;

      var cleanDocketBefore = angular.copy(Restangular.stripRestangular(docket));
      var docketBefore = angular.copy(Restangular.stripRestangular(docket));

      // Determine what has changed
      docketService.getDiffedDocket($scope.lastCleanDocket, docketBefore, method, function (diffedDocket, diffCount) {
        // Now save the diffed docket
        if (diffCount > 0) {
          docketService.saveDocket(diffedDocket, function (updatedDocket) {
            // Reset lastCleanDocket to be the modifed version that we just saved
            $scope.lastCleanDocket = cleanDocketBefore;
            $scope.progressiveDocketUpdate(docket, updatedDocket);
            $scope.progressiveSaveInProcess = false;
            $scope.resourcesSaveInProcess = false;
            $scope.backgroundLoadCount = 0;
            $scope.showToast('Docket Changes Saved');
          }, function (err) {
            $scope.progressiveSaveInProcess = false;
            $scope.resourcesSaveInProcess = false;
            $scope.backgroundLoadCount = 0;
            $scope.showToast('Background Save Failed');
          });
        } else {
          $scope.progressiveSaveInProcess = false;
          $scope.resourcesSaveInProcess = false;
          $scope.backgroundLoadCount = 0;
        }
      });
    }
  };

  /********************************/
  /***** MAIN OPENING CONTROLS ****/
  /********************************/

  // Parameter controls
  $scope.detailControllerReady = function () {
    $scope.assignDocket = { organisations: [], selected: [] };
    $scope.assignDocket.organisations = accessControl.allowedOrganisations();
    if ($stateParams.docketId != null) {
      if ($stateParams.docketId == 'new') {
        if ($stateParams.fromJob != null) {
          $scope.newDocket('job', $stateParams.fromJob);
        } else if ($stateParams.fromOrder != null) {
          $scope.newDocket('order', $stateParams.fromOrder);
        } else {
          $scope.newDocket();
        }
      } else {
        $scope.openDocketMobile($stateParams.docketId);
      }
    }
  };

  /******************************/
  /***** List View Controls *****/
  /******************************/

  $scope.showDocketDetail = function () {
    $scope.viewState = 'docket';
  };

  $scope.selectContactForDocket = function (docket, companyType, cb) {
    $scope.viewState = 'company';
    $scope.selectCompanyCallback = cb;
    var existingContacts = [];
    var selectedContact = null;
    if (companyType == 'customerContact') {
      if (docket.supplierContact != null) {
        existingContacts.push(docket.supplierContact);
      }
      if (docket.customerContact != null) {
        selectedContact = docket.customerContact;
      }
    } else if (companyType == 'supplierContact') {
      if (docket.customerContact != null) {
        existingContacts.push(docket.customerContact);
      }
      if (docket.supplierContact != null) {
        selectedContact = docket.supplierContact;
      }
    }
    $scope.selectCompanyType = companyType;

    $scope.contactSelectFromParent(existingContacts, selectedContact, function (companySelected) {
      $scope.selectCompanyCallback(companySelected);
      $scope.showDocketDetail();
    });
  };

  $scope.selectContactForShare = function (cb) {
    $scope.viewState = 'company';
    $scope.contactSelectFromParent(null, null, function (companySelected) {
      cb(companySelected);
      $scope.showDocketDetail();
    });
  };

  $scope.selectOrderForDocket = function (options, cb) {
    $scope.viewState = 'order';
    $scope.selectOrderCallback = cb;
    $scope.orderSelectFromParent(options, function (orderSelected) {
      $scope.selectOrderCallback(orderSelected);
      $scope.showDocketDetail();
    });
  };

  $scope.selectTemplateForDocket = function (currentTemplate, cb) {
    $scope.viewState = 'docketTemplate';
    $scope.selectTemplateCallback = cb;
    $scope.templateSelectFromParent(currentTemplate, function (templateSelected) {
      $scope.selectTemplateCallback(templateSelected);
      $scope.showDocketDetail();
    });
  };

  $scope.selectOrganisationForDocket = function (docket, cb) {
    $scope.viewState = 'organisation';
    $scope.selectOrganisationCallback = cb;
    $scope.assignDocket = { selected: [] };
    $scope.assignDocket.organisations = accessControl.allowedOrganisations();
  };

  $scope.cancelSelectOrganisation = function () {
    $scope.showDocketDetail();
    $scope.selectOrganisationCallback(null);
  };

  $scope.selectOrganisationContinue = function (group) {
    $scope.showDocketDetail();
    $scope.selectOrganisationCallback(group);
  };

  $scope.selectResourceForDocket = function (docket, cb) {
    $scope.viewState = 'resource';
    $scope.selectResourceCallback = cb;

    // Get list of available categories
    var categories = {};
    for (var i = 0; i < docket.template.interactionTemplates.length; i++) {
      var interactionTemplate = docket.template.interactionTemplates[i];
      for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
        if (categories[interactionTemplate.actorCategories[j].id] == null) {
          categories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
          categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
        }
        // Check if resources in category are to be filtered by order or not
        if (categories[interactionTemplate.actorCategories[j].id].filterByOrder == true && interactionTemplate.actorFromOrder != true) {
          categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
        } else if (categories[interactionTemplate.actorCategories[j].id].filterByOrder != true && interactionTemplate.actorFromOrder == true) {
          categories[interactionTemplate.actorCategories[j].id].filterByOrder = true;
        }
      }
    }

    // convert categories dict to array
    var categoriesArray = [];
    var keys = Object.keys(categories);
    for (var i = 0; i < keys.length; i++) {
      categoriesArray.push(categories[keys[i]]);
    }

    var lineItems = [];
    // Get list of line items from job/order that are to be filtered against
    if (docket.jobRef != null && docket.jobRef.lineItems != null) {
      lineItems = docket.jobRef.lineItems;
    } else if (docket.orderRef != null && docket.orderRef.lineItems != null) {
      lineItems = docket.orderRef.lineItems;
    }

    var options = { categoriesList: categoriesArray, lineItems: lineItems, docketResources: docket.resources };

    $scope.resourceSelectFromParent(options, function (resourceSelected) {
      $scope.selectResourceCallback(resourceSelected);
      $scope.showDocketDetail();
    });
  };

  /**************************/
  /***** Modal Controls *****/
  /**************************/

  $scope.newInteractionForResource = function (docket, resource, cb) {
    $scope.newInteractionCallback = cb;
    $scope.newInteractionFromParent(docket, resource, function (interaction) {
      $scope.newInteractionCallback(interaction);
    });
  };

  $scope.editInteractionForResource = function (interaction, docket, resource, cb) {
    $scope.editInteractionCallback = cb;
    $scope.editInteractionFromParent(docket, interaction, resource, function (interaction) {
      $scope.editInteractionCallback(interaction);
    });
  };

  $scope.captureSignatureForDocket = function (entity, nameRequired, name, terms, template, cb) {
    $scope.captureSignatureCallback = cb;
    $scope.captureSignatureFromParent(entity, nameRequired, name, terms, template, function (signatureObject) {
      $scope.captureSignatureCallback(signatureObject);
    });
  };

  $scope.editChecklistForDocket = function (checklistsData, checklist, cb) {
    $scope.checklistCallback = cb;
    $scope.openChecklistFromParent(checklistsData, checklist, function (checklistReturned) {
      $scope.checklistCallback(checklistReturned);
    });
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /***********************************/
  /***** Last geolocation helper *****/
  /***********************************/

  var timeoutPromise = null;

  $scope.updateGeolocation = function () {
    var getLocation = false;
    var minutesElapsed = _momentTimezone2.default.duration((0, _momentTimezone2.default)().diff($scope.lastGeolocationCheck)).asMinutes();
    if (minutesElapsed > 2) {
      getLocation = true;
    } else {
      getLocation = false;
    }
    if (getLocation) {
      navigator.geolocation.getCurrentPosition(function (data) {
        $scope.lastGeolocation = { lat: data.coords.latitude, long: data.coords.longitude, time: (0, _momentTimezone2.default)() };
        $scope.lastGeolocationCheck = (0, _momentTimezone2.default)();
        timeoutPromise = $timeout(function () {
          $scope.updateGeolocation();
        }, 10000);
      }, function (err) {
        $scope.lastGeolocationCheck = (0, _momentTimezone2.default)();
        timeoutPromise = $timeout(function () {
          $scope.updateGeolocation();
        }, 10000);
      });
    } else {
      timeoutPromise = $timeout(function () {
        $scope.updateGeolocation();
      }, 10000);
    }
  };

  $scope.updateGeolocation();

  $scope.$on('$destroy', function () {
    $timeout.cancel(timeoutPromise);
  });
}]);

/***/ }),

/***/ "OyOn":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/jobsBottomSheet.html';
var html = "<md-bottom-sheet class=\"md-list\">\n  <md-list ng-cloak>\n    <md-list-item ng-show=\"itemEdit.id && ((itemEdit.userAssigneeData && userCanDoAction('assigneeCreateDocketFromJob', itemEdit)) || (!itemEdit.userAssigneeData && userCanDoAction('createDocketFromJob', itemEdit)))\">\n      <md-button ng-click=\"newDocketForJob()\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Create Docket</span>\n      </md-button>\n    </md-list-item>\n    <!-- Assignee Actions -->\n    <md-list-item ng-show=\"userCanDoAction('acceptJob', itemEdit)\">\n      <md-button ng-click=\"assigneeChangeStatus(itemEdit, 'Accepted', 'detail')\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Accept Job</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('rejectJob', itemEdit)\">\n      <md-button ng-click=\"assigneeChangeStatus(itemEdit, 'Rejected', 'detail')\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Reject Job</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('finishJob', itemEdit)\">\n      <md-button ng-click=\"assigneeChangeStatus(itemEdit, 'Completed', 'detail')\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Finish Job</span>\n      </md-button>\n    </md-list-item>\n    <!-- Job Admin Actions -->\n    <md-list-item ng-show=\"userCanDoAction('sendJob', itemEdit)\">\n      <md-button ng-click=\"sendJob(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Send Job</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item ng-show=\"userCanDoAction('closeJob', itemEdit)\">\n      <md-button ng-click=\"closeJobStatus(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Close Job</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item>\n      <md-button ng-click=\"shareJob(itemEdit)\" class=\"md-list-item-content\">\n        <span class=\"md-inline-list-icon-label\">Share Job</span>\n      </md-button>\n    </md-list-item>\n    <md-list-item>\n      <md-button ng-click=\"deleteJob(itemEdit)\" class=\"md-list-item-content\" ng-if=\"userCanDoAction('deleteJob', itemEdit)\">\n        <span class=\"md-inline-list-icon-label\">Delete Job</span>\n      </md-button>\n    </md-list-item>\n  </md-list>\n</md-bottom-sheet>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "PCVv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('docketbook').controller('companySettingsGroupsController', ['userService', 'docketService', '$scope', 'Restangular', '$window', '$state', '$stateParams', 'accessControl', '$q', 'Upload', 'uuid', function (userService, docketService, $scope, Restangular, $window, $state, $stateParams, accessControl, $q, Upload, uuid) {
  mixpanel.track("Opened CompanySettings-Groups Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.mode = 'list';
  $scope.view = 'list';
  $scope.groupEdit = null;
  $scope.selectedIndexContainer = { selectedIndex: 0 };
  $scope.selected = [];
  $scope.allTimezones = moment.tz.names();
  $scope.allTimeFormats = ['12HR', '24HR'];
  $scope.timeFormatDisplay = { '12HR': '12 Hour Time', '24HR': '24 Hour Time' };
  $scope.loadingGroups = false;
  $scope.loadingArchiving = false;

  $scope.allGroupsById = {};

  $scope.tabChanged = function (tabName) {
    $(".tabButtonsGroup").hide();
    $("#tabButtonsGroup" + tabName).show();
  };

  $scope.archiveGroup = function (group) {
    $scope.loadingArchiving = true;
    var newState = !group.active;

    userService.saveOrganisationGroup({ id: group.id, active: newState }, function (updatedGroup) {
      //group.active = newState
      accessControl.refreshAndGetAllowedOrganisations(function (orgsList) {
        $scope.allOrganisations = orgsList;
        for (var i = 0; i < $scope.allOrganisations.length; i++) {
          if ($scope.allOrganisations[i].id == $scope.currentOrg.id) {
            $scope.currentOrg = $scope.allOrganisations[i];
            $scope.loadGroupsList();
            $scope.loadingArchiving = false;
          }
        }
        $scope.loadingGroups = false;
      }, function (err) {});
    }, function (err) {
      swal({
        title: "Oops!",
        text: 'Unable to ' + (newState ? 'restore' : 'archive') + ' group ' + group.name + '. Please try again later',
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      $scope.loadingArchiving = false;
    });
  };

  function path(node) {
    if (node.path !== null && node.path !== undefined) {
      return node.path;
    }
    if (node.parent === null || node.parent === undefined) {
      node.path = '/' + node.id;
    } else {
      node.path = path($scope.allGroupsById[node.parent]) + '/' + node.id;
    }
    return node.path;
  }

  function namePath(node) {
    if (node.namePath !== null && node.namePath !== undefined) {
      return node.namePath;
    }
    if (node.parent === null || node.parent === undefined) {
      node.namePath = '/' + node.name;
    } else {
      node.namePath = namePath($scope.allGroupsById[node.parent]) + '/' + node.name;
    }
    return node.namePath;
  }

  $scope.loadGroupsList = function () {
    $scope.allGroups = [];
    $scope.parentGroupId = null;
    $scope.allGroupsById = {};
    $scope.rootGroupId = null;

    // get root level group first
    for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
      var thisGroup = $scope.currentOrg.groups[i];
      if (thisGroup.parent == null) {
        $scope.rootGroupId = thisGroup.id;
        $scope.parentGroupId = thisGroup.id;
      }
      $scope.allGroupsById[thisGroup.id] = thisGroup;
      $scope.allGroupsById[thisGroup.id].expanded = true;
    }

    var keys = [];

    Object.keys($scope.allGroupsById).map(function (key) {
      var group = $scope.allGroupsById[key];
      keys.push({ path: path(group), namePath: namePath(group), id: key });
    });

    keys.sort(function (a, b) {
      var apath = a.namePath;
      var bpath = b.namePath;

      // probably the best way to compare folder paths..
      return apath.localeCompare(bpath);
    });

    $scope.allGroups = keys.map(function (item) {
      return $scope.allGroupsById[item.id]; // .name; or maybe .path; ??
    });

    // add on the path level for formatting purposed
    for (var i = 0; i < $scope.allGroups.length; i++) {
      $scope.allGroups[i].pathLevel = 0;
      if ($scope.allGroups[i].path) {
        var level = $scope.allGroups[i].path.split('/').length;
        $scope.allGroups[i].pathLevel = level - 2;
      }
    }
  };

  $scope.loadGroupsList();

  $scope.repeatSpansByLevel = function (level) {
    var spans = [];
    for (var i = 0; i < level; i++) {
      spans.push(i + 1);
    }
    return spans;
  };

  $scope.hasChildren = function (group) {
    return $scope.allGroups.map(function (g) {
      return g.parent;
    }).includes(group.id);
  };

  $scope.expandGroup = function (group) {
    $scope.allGroupsById[group.id].expanded = !$scope.allGroupsById[group.id].expanded;
  };

  $scope.groupVisible = function (group) {
    if (!group.parent) {
      return true;
    } else {
      var visible = true;
      var parentToCheck = $scope.allGroupsById[group.parent];
      while (parentToCheck && visible) {
        visible = parentToCheck.expanded;
        parentToCheck = $scope.allGroupsById[parentToCheck.parent];
      }
      return visible;
    }
  };

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /***** DATA *****/
  userService.getMembers(null, function (users) {
    $scope.allUsers = users;
  }, function (err) {
    $scope.allUsers = [];
  });

  userService.getRoles(null, function (roles) {
    $scope.allRoles = roles;
  }, function (err) {
    $scope.allRoles = [];
  });

  docketService.getTemplates(null, function (templates) {
    $scope.allTemplates = templates;
  }, function (err) {
    $scope.allTemplates = [];
  });

  /*************************************/
  /***** Current Org Functionality *****/
  /*************************************/

  $scope.newOrgGroup = function (parentGroup) {
    if (parentGroup == undefined) {
      parentGroup = $scope.allGroups.find(function (g) {
        return g.parent == null;
      });
    }

    $scope.newGroup = true;
    $scope.activeUsers = [];
    $scope.invitedUsers = [];
    $scope.selectedIndexContainer.selectedIndex = 0;
    $scope.view = 'detail';
    $scope.groupEdit = {};
    $scope.groupEdit.orderPrefix = "O";
    $scope.groupEdit.jobPrefix = "J";
    $scope.groupEdit.docketPrefix = "D";
    $scope.groupEdit.invoicePrefix = "INV";

    var timezone = moment.tz.guess();
    if (timezone) {
      $scope.groupEdit.timezone = timezone;
    }
    $scope.groupEdit.timeFormat = '12HR';

    $scope.newGroupHasParent = parentGroup;
    $scope.groupEdit.owners = parentGroup.owners.slice();

    $scope.groupEdit.defaultTemplate = parentGroup.defaultTemplate;
  };

  $scope.closeNewGroupModal = function () {
    $scope.groupEdit = null;
  };

  $scope.closeGroupEdit = function () {
    $scope.groupEdit = null;
    $scope.view = 'list';
  };

  $scope.editOrgGroup = function (group) {
    $scope.groupEdit = { loading: true };
    $scope.selectedIndexContainer.selectedIndex = 0;
    $scope.newGroup = false;
    $scope.view = 'detail';
    userService.getOrganisationGroup(group.id, function (groupFull) {
      $scope.groupEdit = groupFull;
      $scope.groupOriginal = angular.copy(groupFull);
      $scope.loadAllUsers(groupFull);
      /*$scope.newMember = {};
      $scope.groupEdit.membersLoadingError = null;
      // get org group members
      userService.getGroupMembers({ 'sort' : 'first', 'groupId' : group.id }, function(membersUserInfo) {
        getGroupedMembers(groupFull.members, membersUserInfo, function(groupedMembers) {
          $scope.groupEdit.groupedMembers = groupedMembers;
        });
        populateMonitorOwnerStatus($scope.groupEdit, membersUserInfo);
      }, function(err) {
        $scope.groupEdit.groupedMembers = [];
        $scope.groupEdit.membersLoadingError = 'It looks like we had some trouble fetching the list of members for this group. Please try again.';
      });*/
    }, function (err) {
      $scope.groupEdit.loading = false;
      $scope.closeGroupEdit();
      $scope.alertService.presentAutoAlert('getOrgGroup', err);
    });
  };

  $scope.reloadGroupMembers = function (groupEdit) {
    userService.getOrganisationGroup(groupEdit.id, function (groupFull) {
      userService.getGroupMembers({ 'sort': 'first', 'groupId': groupEdit.id }, function (membersUserInfo) {
        getGroupedMembers(groupFull.members, membersUserInfo, function (groupedMembers) {
          groupEdit.groupedMembers = groupedMembers;
        });
      }, function (err) {
        getGroupedMembers(groupFull.members, null, function (groupedMembers) {
          groupEdit.groupedMembers = groupedMembers;
        });
      });
    }, function (err) {
      $scope.alertService.presentAutoAlert('getOrgGroup', err);
    });
  };

  $scope.reloadGroupOwners = function (groupEdit) {
    userService.getOrganisationGroup(groupEdit.id, function (groupFull) {
      groupEdit.owners = groupFull.owners;
    }, function (err) {});
  };

  $scope.reloadGroupMonitors = function (groupEdit) {
    userService.getOrganisationGroup(groupEdit.id, function (groupFull) {
      groupEdit.monitors = groupFull.monitors;
    }, function (err) {});
  };

  // group members (user/role combo) by user
  var getGroupedMembers = function getGroupedMembers(membersList, membersUserInfo, cb) {
    var members = [];

    for (var i = 0; i < membersUserInfo.length; i++) {
      var user = membersUserInfo[i];
      var roles = [];
      for (var j = 0; j < membersList.length; j++) {
        if (membersList[j].user.id == user.id) {
          roles.push(membersList[j].role);
        }
      }
      var newMemberItem = { roles: roles, originalRoles: angular.copy(roles), user: user, editing: false };
      members.push(newMemberItem);
    }

    cb(members);
  };

  // populate onDocketbook status of owners list and monitor list
  var populateMonitorOwnerStatus = function populateMonitorOwnerStatus(group, usersList) {
    for (var i = 0; i < group.owners.length; i++) {
      for (var j = 0; j < usersList.length; j++) {
        if (group.owners[i].id == usersList[j].id) {
          group.owners[i].onDocketbook = usersList[j].onDocketbook;
          break;
        }
      }
    }

    for (var i = 0; i < group.monitors.length; i++) {
      for (var j = 0; j < usersList.length; j++) {
        if (group.monitors[i].id == usersList[j].id) {
          group.monitors[i].onDocketbook = usersList[j].onDocketbook;
          break;
        }
      }
    }
  };

  $scope.saveOrgGroup = function (group) {
    $scope.loadingGroups = true;
    group.loading = true;
    // get diff and save if diffcount > 0
    userService.getGroupDiff($scope.groupOriginal, group, function (diffCount, diff) {
      if (diffCount > 0) {
        if (group.id == null) {
          // Hack for new org groups - appending currentUser as the owner
          if ($scope.newGroupHasParent != null) {
            diff.parent = $scope.newGroupHasParent.id;
            diff.owners = $scope.newGroupHasParent.owners;
          } else {
            diff.parent = $scope.currentOrgGroup.id;
            diff.owners = [$scope.currentUser.id];
          }
        }

        if ($scope.newGroup && $scope.currentOrg.groups.map(function (group) {
          return group.name;
        }).includes($scope.groupEdit.name)) {
          $scope.loadingGroups = false;
          group.loading = false;

          swal({
            title: "Oops!",
            text: 'Group ' + group.name + ' already exists, please choose a different name.',
            type: "error",
            confirmButtonText: "Ok, got it."
          });

          return;
        }

        userService.saveOrganisationGroup(diff, function (groupUpdated) {
          group.loading = false;
          $scope.closeNewGroupModal();
          $scope.view = 'list';
          accessControl.refreshAndGetAllowedOrganisations(function (orgsList) {
            $scope.allOrganisations = orgsList;
            for (var i = 0; i < $scope.allOrganisations.length; i++) {
              if ($scope.allOrganisations[i].id == $scope.currentOrg.id) {
                $scope.currentOrg = $scope.allOrganisations[i];
                $scope.loadGroupsList();
              }
            }
            $scope.loadingGroups = false;
          }, function (err) {});
        }, function (err) {
          group.loading = false;
          $scope.loadingGroups = false;
          $scope.alertService.presentAutoAlert('saveOrgGroup', err);
        });
      } else {
        group.loading = false;
        $scope.loadingGroups = false;
        $scope.view = 'list';
        $scope.closeNewGroupModal();
      }
    });
  };

  // change address
  $scope.openEditAddressModal = function () {
    $("#searchAddressModal").fadeIn(200);
  };

  $scope.closeSearchAddressModal = function () {
    $("#searchAddressModal").fadeOut(200);
  };

  // edit member roles
  $scope.editMemberRoles = function (member) {
    member.editing = true;
  };

  $scope.saveMemberRoles = function (member) {
    // generate list of roles to remove
    var rolesToRemove = [];
    for (var i = 0; i < member.originalRoles.length; i++) {
      // check if role has been removed
      var found = false;
      for (var j = 0; j < member.roles.length; j++) {
        if (member.originalRoles[i].id == member.roles[j].id) {
          found = true;
          break;
        }
      }

      if (!found) {
        rolesToRemove.push(member.originalRoles[i]);
      }
    }

    var rolesToAdd = [];
    for (var i = 0; i < member.roles.length; i++) {
      var found = false;
      for (var j = 0; j < member.originalRoles.length; j++) {
        if (member.originalRoles[j].id == member.roles[i].id) {
          found = true;
          break;
        }
      }

      if (!found) {
        rolesToAdd.push(member.roles[i]);
      }
    }

    var failures = [];
    removeRolesForUser(member.user.id, rolesToRemove, 0, failures, function (failuresFilled) {
      addRolesForUser(member.user.id, rolesToAdd, 0, failuresFilled, function (failuresFilled2) {
        member.editing = false;
      });
    });
  };

  var removeRolesForUser = function removeRolesForUser(userId, rolesToRemove, index, failures, successCb) {
    if (index >= rolesToRemove.length) {
      successCb(failures);
      return;
    }

    userService.removeMemberRoleFromGroup($scope.groupEdit.id, userId, rolesToRemove[index].id, function () {
      removeRolesForUser(userId, rolesToRemove, index + 1, failures, successCb);
    }, function (err) {
      failures.push(err);
      removeRolesForUser(userId, rolesToRemove, index + 1, failures, successCb);
    });
  };

  var addRolesForUser = function addRolesForUser(userId, rolesToAdd, index, failures, successCb) {
    if (index >= rolesToAdd.length) {
      successCb(failures);
      return;
    }

    var newMember = { 'role': rolesToAdd[index].id, 'user': userId };

    userService.addMemberToGroup($scope.groupEdit.id, newMember, function () {
      addRolesForUser(userId, rolesToAdd, index + 1, failures, successCb);
    }, function (err) {
      failures.push(err);
      addRolesForUser(userId, rolesToAdd, index + 1, failures, successCb);
    });
  };

  // Get Resource Type Object From Given ID
  $scope.getResTypeFromId = function (id) {
    if (id.id == null) {
      for (var i = 0; i < $scope.allResourceTypes.length; i++) {
        if ($scope.allResourceTypes[i].id == id) {
          return $scope.allResourceTypes[i];
        }
      }
    } else {
      return id;
    }

    return null;
  };

  // Show list view - close configure views
  $scope.showItemList = function () {
    $scope.mode = 'list';
    $scope.groupConfigure = {};
  };

  /********************/
  /* Group File Codes */
  /********************/

  $scope.fileCodes = {};
  $scope.fileCodes.mode = 'list';
  $scope.fileCodes.listLoading = false;
  $scope.fileCodes.selected = [];
  $scope.fileCodes.importSelected = [];
  $scope.fileCodes.query = {
    limit: 10,
    page: 1,
    sort: 'fileCode'
  };
  $scope.fileCodes.listCount = 0;

  $scope.loadFilingList = function () {
    $scope.promise = $q(function (resolve, reject) {
      // Get templates from docketService
      var queryParams = {};
      queryParams.limit = $scope.fileCodes.query.limit;
      queryParams.offset = $scope.fileCodes.query.limit * ($scope.fileCodes.query.page - 1);
      queryParams.sort = $scope.fileCodes.query.order;
      queryParams.orgGroupId = $scope.groupEdit.id;
      docketService.getFileCodes(queryParams, function (fileCodes) {
        $scope.fileCodes.allFileCodes = fileCodes;
        if (queryParams.offset <= 0 && fileCodes.length < queryParams.limit) {
          $scope.fileCodes.listCount = fileCodes.length;
        } else {
          $scope.fileCodes.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (error) {
        $scope.fileCodes.allFileCodes = [];
        reject('Error');
      });
    });
  };

  //$scope.loadFilingList();

  $scope.newFileCode = function () {
    $scope.fileCodes.fileCodeEdit = {};
    $("#fileCodeModal").fadeIn(100);
  };

  $scope.editFileCode = function (fileCode) {
    $("#fileCodeModal").fadeIn(100);
    $scope.fileCodes.fileCodeEdit = fileCode;
  };

  $scope.saveFileCodeAddAnother = function (fileCode) {
    // saveFileCode
    fileCode.loading = true;
    fileCode.orgGroupId = $scope.groupEdit.id;
    docketService.saveFileCode(fileCode, function () {
      fileCode.loading = false;
      $scope.fileCodes.fileCodeEdit = {};
    }, function (err) {
      fileCode.loading = false;
      $scope.alertService.presentAutoAlert('saveFileCode', err);
    });
  };

  $scope.saveFileCode = function (fileCode) {
    fileCode.loading = true;
    fileCode.orgGroupId = $scope.groupEdit.id;
    docketService.saveFileCode(fileCode, function () {
      fileCode.loading = false;
      $scope.closeFileCodeModal();
      $scope.loadFilingList();
    }, function (err) {
      fileCode.loading = false;
      $scope.alertService.presentAutoAlert('saveFileCode', err);
    });
  };

  $scope.deleteSelectedFileCodes = function () {
    var count = $scope.fileCodes.selected.length;
    swal({
      title: "Are you sure?",
      text: count + " file codes will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteBulkFileCodes($scope.groupEdit.id, $scope.fileCodes.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkFileCodes', { status: 202, requestName: 'Delete bulk file codes - failures ' + failures.length + ' of ' + $scope.fileCodes.selected.length });
            $scope.loadFilingList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkFileCodes', { status: 200 });
            $scope.loadFilingList();
          }
        });
      }
    });
  };

  $scope.closeFileCodeModal = function () {
    $("#fileCodeModal").fadeOut(100);
  };

  $scope.openImportModal = function () {
    $("#importModal").fadeIn(100);
    $scope.fileCodes.mode = 'import';
    $scope.fileCodes.fileCodeImport = { 'loading': false };
  };

  $scope.cancelImport = function () {
    $scope.closeImportModal();
    $scope.fileCodes.mode = 'list';
    $scope.fileCodes.importList = [];
  };

  $scope.closeImportModal = function () {
    $("#importModal").fadeOut(100);
  };

  $scope.importFileCodesFromFile = function (fileToUpload) {
    $scope.fileCodes.fileCodeImport.loading = true;

    Upload.upload({
      url: '/v1/parse',
      data: { file: fileToUpload },
      withCredentials: true
    }).then(function (resp) {
      $scope.parseFileCodesForImport(resp.data);
    }, function (resp) {
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  };

  $scope.parseFileCodesForImport = function (importData) {
    var fileCodesList = [];
    $scope.fileCodes.importSelected = [];

    for (var i = 0; i < importData.length; i++) {
      for (var j = 0; j < importData[i].data.length; j++) {
        var newFileCode = {};
        newFileCode.fileCode = String(importData[i].data[j][0]);
        newFileCode.fileName = String(importData[i].data[j][1]);
        newFileCode.costCode = String(importData[i].data[j][2]);
        newFileCode.systemCodes = importData[i].data[j][3];

        if (newFileCode.fileCode != '' && newFileCode.fileCode != null) {
          var matchedFileCode = $scope.findExistingFileCode(newFileCode.fileCode);
          if (matchedFileCode) {
            newFileCode.status = 'Update';
            newFileCode.uniqueIdentifier = matchedFileCode.uniqueIdentifier;
          } else {
            newFileCode.status = 'New';
          }
        } else {
          newFileCode.error = true;
          newFileCode.status = 'New';
        }

        $scope.validateFileCodeItem(newFileCode);
        newFileCode.importId = uuid.v4();
        $scope.fileCodes.importSelected.push(newFileCode);
        fileCodesList.push(newFileCode);
      }
    }
    $scope.fileCodes.importList = fileCodesList;
    $scope.closeImportModal();
    $scope.fileCodes.fileCodeImport.loading = false;
  };

  $scope.findExistingFileCode = function (fileCode) {
    if (fileCode == null || fileCode == '') {
      return null;
    }

    for (var i = 0; i < $scope.fileCodes.allFileCodes.length; i++) {
      if ($scope.fileCodes.allFileCodes[i].fileCode == fileCode) {
        // found a fileCode with the fileCode as given - exists
        return $scope.fileCodes.allFileCodes[i];
      }
    }

    return null;
  };

  $scope.bulkImportFileCodes = function () {
    var importList = $scope.fileCodes.importSelected;
    var filecodesSave = [];
    for (var i = 0; i < importList.length; i++) {
      if (importList[i].selected) {
        var fileCode = {};
        fileCode.fileCode = importList[i].fileCode;
        fileCode.fileName = importList[i].fileName;
        fileCode.costCode = importList[i].costCode;
        fileCode.organisation = $scope.currentOrg.id;
        fileCode.organisationGroup = $scope.currentOrgGroup.id;
        if (importList[i].uniqueIdentifier) {
          fileCode.uniqueIdentifier = importList[i].uniqueIdentifier;
        }
        //TODO: system codes

        filecodesSave.push(fileCode);
      }
    }

    docketService.importFileCodes($scope.groupEdit.id, filecodesSave, function (resp) {
      var codesCreated = resp.codes;
      var codeExceptions = resp.exceptions;
      $scope.fileCodes.mode = 'list';
      $scope.loadFilingList();
      var text = codesCreated.length + " file codes were successfully imported.";
      $scope.alertService.presentAlert("success", "Import Complete!", text);
      $scope.fileCodes.importList = [];
    }, function (err) {
      $scope.alertService.presentAutoAlert('importFileCodes', err);
    });
  };

  $scope.validateFileCodeItem = function (fileCode) {
    var error = false;
    if (fileCode.fileCode == null || fileCode.fileCode == '') {
      error = true;
    }

    if (fileCode.fileName == null || fileCode.fileName == '') {
      error = true;
    }

    if (fileCode.costCode == null || fileCode.costCode == '') {
      error = true;
    }

    if (error) {
      fileCode.error = error;
      fileCode.selected = false;
    } else {
      fileCode.error = false;
      fileCode.selected = true;
    }
  };

  $scope.removeCodeFromImportList = function (fileCode, importList) {
    var index = importList.indexOf(fileCode);
    if (index != -1) {
      importList.splice(index, 1);
    }
  };

  $scope.toggleRowItem = function (item) {
    if (item.selected) {
      item.selected = false;
    } else {
      item.selected = true;
    }
  };

  /***************/
  /* Group Users */
  /***************/

  $scope.globalAdministrators = {};
  for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
    $scope.globalAdministrators[$scope.currentOrg.globalAdministrators[i]] = $scope.currentOrg.globalAdministrators[i];
  }

  $scope.activeUsers = [];
  $scope.invitedUsers = [];

  $scope.loadAllUsers = function (groupFull) {
    $scope.activeUsers = [];
    $scope.invitedUsers = [];
    // set out monitors list
    $scope.groupMonitors = {};
    for (var i = 0; i < groupFull.monitors.length; i++) {
      $scope.groupMonitors[groupFull.monitors[i].id] = true;
    }
    userService.getGroupMembers({ 'sort': 'first', 'groupId': groupFull.id }, function (membersUserInfo) {
      getGroupedMembers(groupFull.members, membersUserInfo, function (groupedMembers) {
        for (var i = 0; i < groupedMembers.length; i++) {
          if (groupedMembers[i].user.onDocketbook == true) {
            $scope.activeUsers.push(groupedMembers[i]);
          } else {
            $scope.invitedUsers.push(groupedMembers[i]);
          }
        }
      });
    }, function (err) {
      console.error('could not load all users', err);
    });
  };

  // group members (user/role combo) by user
  var getGroupedMembers = function getGroupedMembers(membersList, membersUserInfo, cb) {
    var members = [];

    for (var i = 0; i < membersUserInfo.length; i++) {
      var user = membersUserInfo[i];
      var roles = [];
      for (var j = 0; j < membersList.length; j++) {
        if (membersList[j].user.id == user.id) {
          roles.push(membersList[j].role);
        }
      }
      var newMemberItem = { roles: roles, originalRoles: angular.copy(roles), user: user, editing: false };
      if ($scope.globalAdministrators[user.id]) {
        newMemberItem.isGlobalAdmin = true;
      } else {
        newMemberItem.isGlobalAdmin = false;
      }
      if ($scope.groupMonitors[user.id]) {
        newMemberItem.isMonitor = true;
      } else {
        newMemberItem.isMonitor = false;
      }

      newMemberItem.owner = $scope.groupEdit.owners.map(function (owner) {
        return owner.id;
      }).includes(user.id);

      if (newMemberItem.user.emailAddress.indexOf("users.docketbook.io") !== -1) {
        newMemberItem.user.displayEmailAddress = '0' + newMemberItem.user.emailAddress.split("@")[0].substring(3);
      } else {
        newMemberItem.user.displayEmailAddress = newMemberItem.user.emailAddress;
      }
      if (accessControl.isSampleCompany()) {
        var _user = newMemberItem.user;
        if (_user.name.first === "Chris" && _user.name.last === "Digger") {
          newMemberItem.user.displayEmailAddress = "chris.digger@fakeaddress.com";
        } else if (_user.name.first === "John" && _user.name.last === "Trucks") {
          newMemberItem.user.displayEmailAddress = "john.trucks@fakeaddress.com";
        } else if (_user.name.first === "Steve" && _user.name.last === "Dozer") {
          newMemberItem.user.displayEmailAddress = "steve.dozer@fakeaddress.com";
        }
      }
      members.push(newMemberItem);
    }

    cb(members);
  };

  $scope.getGroupRoles = function (member) {
    var extraRoles = [];
    if (member.isGlobalAdmin) {
      extraRoles.push('Super User');
    }
    if (member.isMonitor) {
      extraRoles.push('Monitor');
    }
    if (!member.isGlobalAdmin && member.owner) {
      extraRoles.push('Administrator');
    }
    if (member.isGlobalAdmin) {
      return extraRoles.join(', ');
    } else {
      return [].concat(extraRoles, _toConsumableArray(member.roles.map(function (role) {
        return role.name;
      }))).join(', ');
    }
  };

  /* OLD */

  // Remove a member(GroupAssignment) from group
  $scope.removeMemberFromGroup = function (member, group) {
    userService.removeMemberFromGroup(group.id, member.user.id, function (success) {
      for (var i = 0; i < group.groupedMembers.length; i++) {
        if (group.groupedMembers[i].user.id == member.user.id) {
          group.groupedMembers.splice(i, 1);
          break;
        }
      }
    }, function (err) {
      $scope.alertService.presentAutoAlert('removeGroupMember', err);
    });
  };

  // Remove an owner from group
  $scope.removeOwnerFromGroup = function (owner, group) {
    userService.removeOwnerFromGroup(group.id, owner.id, function (success) {
      $scope.reloadGroupOwners(group);
    }, function (err) {
      $scope.alertService.presentAutoAlert('removeGroupOwner', err);
    });
  };

  // Remove an monitor from group
  $scope.removeMonitorFromGroup = function (monitor, group) {
    userService.removeMonitorFromGroup(group.id, monitor.id, function (success) {
      $scope.reloadGroupMonitors(group);
    }, function (err) {
      $scope.alertService.presentAutoAlert('removeGroupMonitor', err);
    });
  };

  // Add a new member(GroupAssignment) to group
  $scope.addMemberToGroup = function (newMember, group) {
    var newMemberToAdd = {};
    newMemberToAdd.role = newMember.role.id;

    if (newMember.user != null) {
      // Add user using actual user object
      newMemberToAdd.user = newMember.user.id;
    } else if (newMember.emailAddress != null) {
      // Add user using email address
      newMemberToAdd.emailAddress = newMember.emailAddress;
    } else {
      // No user detail supplied - cannot continue
      alert('no details for the user were supplied, try again.');
      return;
    }

    userService.addMemberToGroup(group.id, newMemberToAdd, function () {
      $scope.editOrgGroup(group);
    }, function (err) {
      $scope.alertService.presentAutoAlert('addGroupMember', err);
    });
  };

  // Add a role to a member
  $scope.addRoleToMember = function (member) {
    var existingRoles = [];
    for (var i = 0; i < member.roles.length; i++) {
      existingRoles.push(member.roles[i].id);
    }
    $scope.roleSelectFromParent(existingRoles, function (rolesSelected) {
      if (rolesSelected != null) {
        for (var i = 0; i < rolesSelected.length; i++) {
          member.roles.push(rolesSelected[i]);
        }
      }
    });
  };

  // Add people to group
  $scope.addMembersToGroup = function (groupEdit) {
    // get list of existing users for this group
    var existingMembers = [];
    for (var i = 0; i < groupEdit.groupedMembers.length; i++) {
      existingMembers.push(groupEdit.groupedMembers[i].user.id);
    }
    $scope.selectOrgPeopleFromParent(existingMembers, function (people) {
      if (people != null) {
        $scope.roleSelectFromParent(null, function (rolesSelected) {
          if (rolesSelected != null) {
            var roles = [];
            for (var i = 0; i < rolesSelected.length; i++) {
              roles.push(rolesSelected[i].id);
            }
            var membersToAdd = [];
            for (var i = 0; i < people.length; i++) {
              var person = { 'user': people[i].id, roles: roles };
              membersToAdd.push(person);
            }

            userService.assignMembersToGroup(groupEdit.id, membersToAdd, function (success) {
              $scope.reloadGroupMembers(groupEdit);
            }, function (err) {
              $scope.alertService.presentAutoAlert('addGroupMember', err);
            });
          }
        });
      }
    });
  };

  // Add owners to group
  $scope.addOwnersToGroup = function (groupEdit) {
    // get list of existing users for this group
    var existingOwners = [];
    for (var i = 0; i < groupEdit.owners.length; i++) {
      existingOwners.push(groupEdit.owners[i].id);
    }
    $scope.selectOrgPeopleFromParent(existingOwners, function (people) {
      if (people != null) {
        var membersToAdd = [];
        for (var i = 0; i < people.length; i++) {
          var person = { 'user': people[i].id, roles: ['owner'] };
          membersToAdd.push(person);
        }

        userService.assignMembersToGroup(groupEdit.id, membersToAdd, function (success) {
          $scope.reloadGroupOwners(groupEdit);
        }, function (err) {
          $scope.alertService.presentAutoAlert('addGroupOwner', err);
        });
      }
    });
  };

  // Add monitors to group
  $scope.addMonitorsToGroup = function (groupEdit) {
    // get list of existing users for this group
    var existingMonitors = [];
    for (var i = 0; i < groupEdit.monitors.length; i++) {
      existingMonitors.push(groupEdit.monitors[i].id);
    }
    $scope.selectOrgPeopleFromParent(existingMonitors, function (people) {
      if (people != null) {
        var membersToAdd = [];
        for (var i = 0; i < people.length; i++) {
          var person = { 'user': people[i].id, roles: ['monitor'] };
          membersToAdd.push(person);
        }

        userService.assignMembersToGroup(groupEdit.id, membersToAdd, function (success) {
          $scope.reloadGroupMonitors(groupEdit);
        }, function (err) {
          $scope.alertService.presentAutoAlert('addGroupMonitor', err);
        });
      }
    });
  };

  // Inviting new members
  $scope.inviteMembersToGroup = function () {
    $("#inviteMembersModal").fadeIn(200);
    $scope.newMemberInvitesLoading = false;
    $scope.inviteMembers = { singleGroup: true };
    $scope.newMemberInvites = [{}];
  };

  $scope.addBlankInvitee = function () {
    $scope.newMemberInvites.push({});
  };

  $scope.removeInvitee = function (invitee) {
    $scope.newMemberInvites.splice($scope.newMemberInvites.indexOf(invitee), 1);
  };

  $scope.closeInviteMembers = function () {
    $("#inviteMembersModal").fadeOut(200);
  };

  $scope.inviteMembersContinue = function () {
    $scope.newMemberInvitesLoading = true;
    var invitesArray = [];
    for (var i = 0; i < $scope.newMemberInvites.length; i++) {
      var roleAdd = "";
      roleAdd = $scope.newMemberInvites[i].role.id;
      var rolesToAdd = [];
      rolesToAdd.push(roleAdd);
      if ($scope.newMemberInvites[i].addAsMonitor == true) {
        rolesToAdd.push('monitor');
      }
      var newInvite = { 'emailAddress': $scope.newMemberInvites[i].emailAddress.replace(/\s/g, ''), 'roles': rolesToAdd, 'firstName': $scope.newMemberInvites[i].firstName, 'lastName': $scope.newMemberInvites[i].lastName };
      invitesArray.push(newInvite);
    }

    userService.assignMembersToGroup($scope.groupEdit.id, invitesArray, function (success) {
      $scope.loadAllUsers($scope.groupEdit);
      $scope.closeInviteMembers();
    }, function (err) {
      $scope.newMemberInvitesLoading = false;
      $scope.alertService.presentAutoAlert('addGroupMembers', err);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("PJh5"), __webpack_require__("7t+N")))

/***/ }),

/***/ "Pisi":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/mobileTabBar.html';
var html = "<md-content class=\"tabBarMobile detailTabBar\">\n  <md-nav-bar md-selected-nav-item=\"currentTab\" nav-bar-aria-label=\"job\">\n    <md-nav-item md-nav-click=\"openMobileTab('General')\" name=\"General\" id=\"tabGeneral\">General</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('AssignedPeople')\" name=\"AssignedPeople\" id=\"tabAssignedPeople\" ng-show=\"userHasPermission('io.docketbook.ojdapi.createJob') || userHasPermission('io.docketbook.ojdapi.updateJob')\">Assignees</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('LineItems')\" name=\"LineItems\" id=\"tabLineItems\">Items</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('Comments')\" name=\"Comments\" id=\"tabComments\">Comments</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('Dockets')\" name=\"Dockets\" id=\"tabDockets\">Dockets</md-nav-item>\n  </md-nav-bar>\n</md-content>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "PjXo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jobs-paywall-illustration.svg";

/***/ }),

/***/ "PrNh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('fieldModalController', ['docketService', '$rootScope', '$scope', '$state', '$stateParams', 'accessControl', '$timeout', 'geolocation', function (docketService, $rootScope, $scope, $state, $stateParams, accessControl, $timeout, geolocation) {

  $scope.fieldEdit = {};

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.editFieldFromParent = function (field, cb) {
    $("#editFieldModal").fadeIn(100);
    $scope.fieldEditCallback = cb;
    $scope.fieldEdit = field;
    $scope.fieldEdit.step = 'name';

    if ($scope.fieldEdit.type == 'select') {
      var valsList = [];
      for (var i = 0; i < $scope.fieldEdit.selectionFields.length; i++) {
        valsList.push({ value: $scope.fieldEdit.selectionFields[i] });
      }
      $scope.fieldEdit.selectionFields = valsList;
    }
  };

  $scope.$parent.newFieldFromParent = function (options, cb) {
    $scope.fieldEditCallback = cb;
    $scope.fieldEdit = { 'hidden': false, 'mandatory': false, 'step': 'type' };
    if (options.ignoreTypes) {
      $scope.fieldEdit.ignoreTypes = options.ignoreTypes;
    }
    $("#editFieldModal").fadeIn(100);
  };

  $scope.closeNewFieldModal = function () {
    $("#editFieldModal").fadeOut(100);
    $scope.fieldEditCallback(null);
  };

  $scope.requiredNextStep = function (field) {
    field.loading = true;
    checkFieldUsedInInteractions(field, function (onTemplates) {
      if (onTemplates.length > 0) {
        $scope.fieldEdit.step = 'updateTemplates';
        $scope.fieldEdit.updateTemplates = true;
        $scope.fieldEdit.onTemplates = onTemplates;
        $scope.fieldEdit.loading = false;
      } else {
        $scope.saveField(field);
      }
    });
  };

  $scope.saveField = function (field) {
    field.loading = true;
    if (field.type == 'select') {
      var valsList = [];
      for (var i = 0; i < field.selectionFields.length; i++) {
        valsList.push(field.selectionFields[i].value);
      }
      field.selectionFields = valsList;
    }
    $("#editFieldModal").fadeOut(100);
    var templatesNeedUpdating = false;
    if ($scope.fieldEdit.step == 'updateTemplates' && $scope.fieldEdit.updateTemplates == true) {
      templatesNeedUpdating = true;
    }
    $scope.fieldEditCallback(field, templatesNeedUpdating, $scope.fieldEdit.onTemplates);
  };

  $scope.selectFieldType = function (type) {
    $scope.fieldEdit.type = type;
    $scope.fieldEdit.step = 'name';
  };

  $scope.addSelectionField = function (fieldEdit) {
    if (fieldEdit.selectionFields == null) {
      fieldEdit.selectionFields = [];
    }

    fieldEdit.selectionFields.push({});
  };

  $scope.removeSelectionField = function (fieldEdit, selectionField) {
    var index = fieldEdit.selectionFields.indexOf(selectionField);

    if (index != -1) {
      fieldEdit.selectionFields.splice(index, 1);
    }
  };

  var checkFieldUsedInInteractions = function checkFieldUsedInInteractions(field, cb) {
    docketService.getTemplates(null, function (templates) {
      var templatesToUpdate = [];
      for (var i = 0; i < templates.length; i++) {
        var updateThisTemplate = false;
        if (templates[i].interactionTemplates) {
          for (var j = 0; j < templates[i].interactionTemplates.length; j++) {
            var thisInteraction = templates[i].interactionTemplates[j];
            if (thisInteraction.fields) {
              for (var k = 0; k < thisInteraction.fields.length; k++) {
                if (thisInteraction.fields[k].id == field.id) {
                  updateThisTemplate = true;
                }
              }
            }
          }
        }
        if (updateThisTemplate) {
          templatesToUpdate.push(templates[i].id);
        }
      }
      cb(templatesToUpdate);
    }, function (error) {
      cb([]);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "PzZ8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "user-group.svg";

/***/ }),

/***/ "QO/u":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/generalTab.html';
var html = "<div class=\"ojdRow\" ng-if=\"itemEdit.userAssigneeData && !userHasPermission('io.docketbook.ojdapi.updateJob')\">\n  <div class=\"ojdField noEdit\">\n    <h1>Status</h1>\n    <h2>{{itemEdit.userAssigneeData.status}}</h2>\n    <h3>\n      {{moment(itemEdit.startDate).format('ddd DD MMM')}} - {{moment(itemEdit.endData).format('ddd DD MMM')}}\n    </h3>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"!itemEdit.userAssigneeData\">\n  <div class=\"ojdField noEdit\" ng-if=\"!itemEdit.userAssigneeData || userHasPermission('io.docketbook.ojdapi.updateJob')\">\n    <h1>Status</h1>\n    <h2>{{itemEdit.status}}</h2>\n    <h3 ng-show=\"!userHasPermission('io.docketbook.ojdapi.updateJob')\">\n      {{moment(itemEdit.startDate).format('ddd DD MMM')}} - {{moment(itemEdit.endData).format('ddd DD MMM')}}\n    </h3>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"itemEdit.userAssigneeData && userHasPermission('io.docketbook.ojdapi.updateJob')\">\n  <div class=\"ojdField noEdit\">\n    <h1>Job Status</h1>\n    <h2>{{itemEdit.status}}</h2>\n  </div>\n  <div class=\"ojdField noEdit\" ng-if=\"itemEdit.userAssigneeData\">\n    <h1>Your Status</h1>\n    <h2>{{itemEdit.userAssigneeData.status}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-show=\"itemEdit.userAssigneeData && itemEdit.userAssigneeData.status == 'Rejected' && itemEdit.userAssigneeData.rejectionComment\">\n  <div class=\"ojdField\">\n    <h1>Rejection Reason</h1>\n    <h2>{{itemEdit.userAssigneeData.rejectionComment}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-show=\"userHasPermission('io.docketbook.ojdapi.updateJob')\">\n  <div class=\"ojdField {{userCanDoAction('changeJobStartDate', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeJobStartDate', itemEdit) || showDatePicker('startDate', $event)\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeJobStartDate', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Start Date</h1>\n    <h2>{{moment(itemEdit.startDate).format('DD/MM/YYYY')}}</h2>\n  </div>\n  <div class=\"ojdField {{userCanDoAction('changeJobEndDate', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeJobEndDate', itemEdit) || showDatePicker('endDate', $event)\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeJobEndDate', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>End Date</h1>\n    <h2>{{moment(itemEdit.endDate).format('DD/MM/YYYY')}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-show=\"userHasPermission('io.docketbook.ojdapi.getOrder')\" ng-if=\"itemEdit.id == null || (currentOrg.id == itemEdit.organisation && currentOrgGroup.id == itemEdit.organisationGroup)\">\n  <div class=\"ojdField {{userCanDoAction('changeJobOrder', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeJobOrder', itemEdit) || selectOrder()\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeJobOrder', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Order Number</h1>\n    <h2 ng-if=\"itemEdit.orderRef\">{{itemEdit.orderRef.orderNumber}}</h2>\n    <h2 ng-if=\"!itemEdit.orderRef && userCanDoAction('changeJobOrder', itemEdit)\">Click to select</h2>\n    <h2 ng-if=\"!itemEdit.orderRef && !userCanDoAction('changeJobOrder', itemEdit)\">Not Assigned</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"itemEdit.supplierContact\">\n  <div class=\"ojdField disabled\">\n    <h1>Supplier</h1>\n    <h2>{{itemEdit.supplierContact.displayName}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"itemEdit.customerContact\">\n  <div class=\"ojdField disabled\">\n    <h1>Customer</h1>\n    <h2>{{itemEdit.customerContact.displayName}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"itemEdit.order\">\n  <div class=\"ojdField disabled\" ng-if=\"itemEdit.order.supplierRefNo\">\n    <h1>Supplier Ref No</h1>\n    <h2>{{itemEdit.order.supplierRefNo}}</h2>\n  </div>\n  <div class=\"ojdField disabled\" ng-if=\"itemEdit.order.customerRefNo\">\n    <h1>Customer Ref No</h1>\n    <h2>{{itemEdit.order.customerRefNo}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\" ng-if=\"itemEdit.editing || itemEdit.instructions\">\n  <div class=\"ojdField {{itemEdit.editing ? '' : 'disabled'}}\">\n    <h1>Instructions</h1>\n    <h2 ng-if=\"!itemEdit.editing\">{{itemEdit.instructions}}</h2>\n    <md-input-container class=\"md-block\" flex-gt-sm ng-if=\"itemEdit.editing\">\n      <textarea rows=\"5\" md-select-on-focus name=\"instructions\" ng-model=\"itemEdit.instructions\"></textarea>\n    </md-input-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "QU81":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('interactionModalController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', 'accessControl', '$timeout', 'geolocation', function ($rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

  $scope.availableInteractions = [];
  $scope.interactionCallback = null;
  $scope.docketEditing = null;
  $scope.formLoading = false;

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.newInteractionFromParent = function (docket, resource, cb) {
    $scope.interactionCallback = cb;
    $scope.addInteraction = {};
    $scope.addInteraction.resource = resource.resource;
    $scope.addInteraction.mode = 'selectTemplate';
    $scope.docketEditing = docket;

    $("#addInteractionModal").fadeIn(100);
    $scope.formLoading = false;

    $scope.getAvailableInteractions(docket, resource.resource, function (availableInteractions) {
      $scope.availableInteractions = availableInteractions;

      if ($scope.availableInteractions.length == 1) {
        $scope.selectInteractionTemplate($scope.availableInteractions[0]);
      }
    });
  };

  $scope.$parent.editInteractionFromParent = function (docket, interaction, resource, cb) {
    $scope.interactionCallback = cb;
    $scope.docketEditing = docket;
    $scope.addInteraction = {};
    $scope.addInteraction.loading = false;
    $scope.addInteraction.mode = 'detail';
    $scope.addInteraction.resource = resource;
    $scope.addInteraction.interaction = interaction;
    $scope.addInteraction.interactionTemplate = interaction.interactionTemplate;
    $scope.addInteraction.edit = true;
    if (!$scope.docketEditing.editing || !$scope.userCanDoAction('editDocketInteraction', docket)) {
      $scope.addInteraction.readOnly = true;
    } else {
      $scope.addInteraction.readOnly = false;
    }

    // if resource is time - convert to abbreviation
    if (interaction.resource.uom.isTime) {
      var quantity = interaction.quantity;
      var abbreviation = interaction.resource.uom.abbreviation;
      if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
        // display as hours
        interaction.quantityEdit = quantity / 60;
        interaction.quantityEditType = 'h';
      }
      if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
        // display as hours and minutes
        var hours = Math.floor(quantity / 60);
        var minutes = quantity % 60;
        interaction.quantityHoursEdit = hours;
        interaction.quantityMinutesEdit = minutes;
        interaction.quantityEditType = 'hm';
      }
      if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
        interaction.quantityEdit = quantity;
        interaction.quantityEditType = 'm';
      }
    } else {
      interaction.quantityEdit = interaction.quantity;
    }

    if ($scope.addInteraction.interaction.interactionTemplate.refersParent == true) {
      $scope.addInteraction.interaction.resourceIsParent = true;
    }

    $("#addInteractionModal").fadeIn(100);
    $scope.formLoading = false;
    $timeout(function () {
      $("#quantityKeypadField").focus();
    }, 1000);

    // Show map
    if ($scope.addInteraction.interaction.lat && $scope.addInteraction.interaction.long) {
      var latLng = { lat: $scope.addInteraction.interaction.lat, lng: $scope.addInteraction.interaction.long };
      var options = {
        //center: new google.maps.LatLng($scope.addInteraction.interaction.latitude, $scope.addInteraction.interaction.longitude),
        center: latLng,
        zoom: 18,
        disableDefaultUI: true
      };

      var marker = new google.maps.Marker({
        position: latLng,
        title: 'Line Created Here',
        animation: google.maps.Animation.DROP
      });

      $timeout(function () {
        var map = new google.maps.Map(document.getElementById('interactionMap'), options);
        var places = new google.maps.places.PlacesService(map);
        marker.setMap(map);
      }, 1000);
    }
  };

  /*********************************/
  /***** Interaction Functions *****/
  /*********************************/

  $scope.selectInteractionTemplate = function (interactionTemplate) {
    // setup the new interaction
    $scope.addInteraction.interactionTemplate = interactionTemplate;
    $scope.addInteraction.interaction = {};
    $scope.addInteraction.interaction.interactionName = $scope.addInteraction.interactionTemplate.name;
    $scope.addInteraction.interaction.interactionTemplate = $scope.addInteraction.interactionTemplate;
    $scope.addInteraction.interaction.quantityEdit = "";
    $scope.addInteraction.interaction.customFields = {};
    // if the interaction template resource refers parent - set resource to parent
    if ($scope.addInteraction.interactionTemplate.refersParent == true) {
      $scope.addInteraction.interaction.resource = $scope.addInteraction.resource;
      $scope.addInteraction.interaction.resourceIsParent = true;
    }
    // setup customFields object store
    if ($scope.addInteraction.interactionTemplate.customFields != null) {
      var objectStore = {};
      $scope.addInteraction.interactionTemplate.customFields.forEach(function (item) {
        objectStore[item] = "";
      });
      $scope.addInteraction.interaction.customFields = objectStore;
    }

    // Ensure time values are set to null so that they don't default to the current time
    $scope.addInteraction.interactionTemplate.fields.forEach(function (field) {
      if (field.type == 'time') {
        $scope.addInteraction.interaction.customFields[field.id] = null;
      }
    });

    if (!interactionTemplate.refersParent) {
      // Now get available resources for this interaction
      $scope.addInteraction.availableCategoriesWithResources = $scope.getAvailableResources(interactionTemplate);
    }

    $scope.addInteraction.mode = 'detail';
    $timeout(function () {
      $("#quantityKeypadField").focus();
    }, 1000);
  };

  $scope.selectResourceForInteraction = function (interaction) {
    $("#addInteractionModal").fadeOut(100);
    $scope.$parent.selectResourceForDocket(interaction.availableCategoriesWithResources, function (resourceSelected) {
      interaction.interaction.resource = resourceSelected;
      $("#addInteractionModal").fadeIn(100);
      $scope.formLoading = false;
    });
  };

  $scope.saveInteraction = function (interaction) {
    $scope.formLoading = true;
    interaction.quantityEdit = parseFloat(interaction.quantityEdit);

    $scope.interactionCallback(interaction);
    $("#addInteractionModal").fadeOut(100);
  };

  $scope.removeEditingInteraction = function () {
    $scope.addInteraction.delete = true;
    $scope.interactionCallback($scope.addInteraction);
    $("#addInteractionModal").fadeOut(100);
  };

  $scope.closeAddInteraction = function () {
    $scope.interactionCallback(null);
    $("#addInteractionModal").fadeOut(100);
  };

  $scope.getAvailableResources = function (interactionTemplate) {
    var orderResources = [];
    if ($scope.docketEditing.jobRef) {
      // docket is from job - use job line items to get resources list
      for (var i = 0; i < $scope.docketEditing.jobRef.lineItems.length; i++) {
        if (orderResources.indexOf($scope.docketEditing.jobRef.lineItems[i].resource) == -1) {
          orderResources.push($scope.docketEditing.jobRef.lineItems[i].resource);
        }
      }
    } else if ($scope.docketEditing.orderRef) {
      // docket is from order - use order line items to get resources list
      for (var i = 0; i < $scope.docketEditing.orderRef.lineItems.length; i++) {
        if (orderResources.indexOf($scope.docketEditing.orderRef.lineItems[i].resource) == -1) {
          orderResources.push($scope.docketEditing.orderRef.lineItems[i].resource);
        }
      }
    }

    if (!interactionTemplate.childFromOrder) {
      // child resources do not have to be from order - set to all from order/job
      orderResources = $scope.allResources;
    }

    // go over categories and group available resources by category
    var availableCategoriesWithResources = [];
    var templateCategories = $scope.addInteraction.interactionTemplate.categories;
    for (var i = 0; i < templateCategories.length; i++) {
      // get all resources for this categories (from orderResources list - already sorted by order/job)
      var categoryResources = [];
      for (var j = 0; j < orderResources.length; j++) {
        if (orderResources[j].categoryId == templateCategories[i].id) {
          categoryResources.push(orderResources[j]);
        }
      }
      templateCategories[i].resources = categoryResources;
      availableCategoriesWithResources.push(templateCategories[i]);
    }

    return availableCategoriesWithResources;
  };

  $scope.getAvailableInteractions = function (docket, resource, cb) {
    var interactionTemplates = [];
    for (var i = 0; i < docket.template.interactionTemplates.length; i++) {
      var currentInteractionTemplate = docket.template.interactionTemplates[i];
      // check if interactionTemplate/actorCategories contains this category id
      for (var j = 0; j < currentInteractionTemplate.actorCategories.length; j++) {
        if (currentInteractionTemplate.actorCategories[j].id == resource.categoryId) {
          interactionTemplates.push(currentInteractionTemplate);
          break;
        }
      }
    }
    cb(interactionTemplates);
  };

  /***************************************/
  /***** Quantity Edit Functionality *****/
  /***************************************/

  // Mobile only - edit line item quantity
  $scope.editInteractionQuantity = function (addInteraction) {
    $("#addInteractionModal").fadeOut(100);
    //$("#quantityKeypadModal").fadeIn(100);
    $scope.quantityKeypadValue = angular.copy(addInteraction.interaction.quantityEdit);
    $scope.quantityEditObject = addInteraction.interaction;
    $scope.quantityEditFieldName = 'quantityEdit';
    $scope.quantityKeypadUom = addInteraction.interaction.resource.uom;
  };

  $scope.closeQuantityEditModal = function () {
    //$("#quantityKeypadModal").fadeOut(100);
    $("#addInteractionModal").fadeIn(100);
  };

  $scope.saveQuantityEdit = function () {
    var newValueFloat = parseFloat($scope.quantityKeypadValue);
    $scope.quantityEditObject[$scope.quantityEditFieldName] = newValueFloat;
    $scope.closeQuantityEditModal();
  };

  $scope.keypadButtonPress = function (buttonValue) {
    if ($scope.quantityKeypadValue == null) {
      $scope.quantityKeypadValue = 0;
    }

    var currentValString = $scope.quantityKeypadValue.toString();

    if (buttonValue == '.') {
      currentValString += ".";
    } else if (buttonValue == 'back') {
      if (currentValString.length > 1) {
        currentValString = currentValString.substring(0, currentValString.length - 1);
      } else if (currentValString.length == 1) {
        currentValString = "0";
      }
    } else {
      if (currentValString == "0") {
        currentValString = buttonValue.toString();
      } else {
        currentValString += buttonValue.toString();
      }
    }

    $scope.quantityKeypadValue = currentValString;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "QUy+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').service('batchService', ['accessControl', '$http', '$stateParams', '$cookies', '$q', 'Restangular', 'geolocation', function (accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

  /***** Get Org/Group Docket Batches *****/
  this.getBatches = function (params, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
    baseBatches.getList().then(function (batches) {
      successCb(batches);
    }, failureCb);
  };

  this.saveBatch = function (batchData, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
    if (batchData.id == null) {
      baseBatches.customPOST(batchData).then(successCb, failureCb);
    } else {
      baseBatches.one(batchData.id).customPUT(batchData).then(successCb, failureCb);
    }
  };

  this.getBatch = function (batchId, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
    if (batchId.id != null) {
      batchId = batchId.id;
    }
    baseBatches.customGET(batchId).then(successCb, failureCb);
  };

  var deleteBatch = function deleteBatch(batchId, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseBatches = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches');
    if (batchId.id != null) {
      batchId = batchId.id;
    }
    baseBatches.one(batchId).remove().then(successCb, failureCb);
  };

  this.deleteBatch = deleteBatch;

  /***** Delete Bulk Batches *****/
  this.deleteBulkBatches = function (batches, successCb) {
    var failures = [];
    deleteBatches(batches, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteBatches = function deleteBatches(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteBatch(list[index].id, function (success) {
      deleteBatches(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteBatches(list, index + 1, failures, successCb);
    });
  };
}]);

/***/ }),

/***/ "QkGc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

//import Raven from 'raven-js';

angular.module('docketbook').factory('accessControl', ['Restangular', '$rootScope', '$state', '$timeout', '$stateParams', '$cookies', '$q', '$window', function (Restangular, $rootScope, $state, $timeout, $stateParams, $cookies, $q, $window) {
  // get current organisation from cookies
  var currentOrgId = $cookies.get('currentOrg');
  var currentOrgGroupId = $cookies.get('currentOrgGroup');
  var currentUserItem = null;
  var currentOrganisation = null;
  var currentOrganisationGroup = null;
  var _allowedOrganisations = [];
  var _onboardingSessions = [];

  var configuration = null;
  var configured = false;
  var configurationPromise = null;

  var baseConfig = Restangular.one('configuration');
  var baseUser = Restangular.one('user/me');
  var baseOrganisations = Restangular.all('organisations');

  /******************************/
  /* Responsive Intercom Checks */
  /******************************/

  var initResponsiveChecks = function initResponsiveChecks() {
    doUpdate();
    updateMode();
  };

  var doUpdate = function doUpdate() {
    $(function () {
      var width = $(window).width();
      if (width <= 768) {
        $rootScope.mode = "mobile";
        /*if ($window.Intercom) {
          $window.Intercom("update", {
            hide_default_launcher: true
          });
        }*/
      } else {
        $rootScope.mode = "desktop";
        /*if ($window.Intercom) {
          $window.Intercom("update", {
            hide_default_launcher: false
          });
        }*/
      }
    });
  };

  var updateMode = function updateMode() {
    $timeout(function () {
      doUpdate();
      updateMode();
    }, 5000);
  };

  $timeout(function () {
    initResponsiveChecks();
  }, 2000);

  /**********************************/
  /* END Responsive Intercom Checks */
  /**********************************/

  function checkFcWidget(cb) {
    if (!window.FreshworksWidget) {
      window.setTimeout(function () {
        return checkFcWidget(cb);
      }, 200);
    } else {
      cb();
    }
  }

  var _checkCompanyEnabled = function _checkCompanyEnabled(orgId, cb) {
    baseOrganisations.getList().then(function (orgs) {
      var orgFound = null;
      for (var i = 0; i < orgs.length; i++) {
        if (orgs[i].id == orgId) {
          orgFound = orgs[i];
          break;
        }
      }
      if (orgFound && orgFound.accessAllowed) {
        cb(true);
      } else if (orgFound && orgFound.accessAllowed == false) {
        cb(false);
      }
    });
  };

  var getUsersPermissions = function getUsersPermissions(user, cb) {
    if (currentOrgId && currentOrgGroupId) {
      var urlString = "organisations/" + currentOrgId + "/groups/" + currentOrgGroupId + "/permissions?user=" + user.id;
      Restangular.one(urlString).get().then(function (permissionsRes) {
        cb(permissionsRes.permissions[user.id]);
      }, function (err) {
        cb(null);
      });
    } else {
      cb([]);
    }
  };

  var getAllowedOrganisations = function getAllowedOrganisations(successCb, failureCb) {
    if (_allowedOrganisations != null && _allowedOrganisations.length > 0) {
      successCb(_allowedOrganisations);
      return;
    }
    baseOrganisations.getList().then(function (orgs) {
      _allowedOrganisations = orgs;
      successCb(_allowedOrganisations);
    }, function (err) {
      failureCb(err);
    });
  };

  var refereshAllowedOrganisation = function refereshAllowedOrganisation(successCb, failureCb) {
    baseOrganisations.getList().then(function (orgs) {
      _allowedOrganisations = orgs;
      $rootScope.$emit('OrganisationsListRefreshed');
      successCb(_allowedOrganisations);
    }, function (err) {
      if (err.status == 401) {
        return resolve([]);
      }
      failureCb(err);
    });
  };

  var getOnboardingSessions = function getOnboardingSessions(successCb) {
    Restangular.all("onboarding").getList().then(function (sessions) {
      sessions.forEach(function (session) {
        session.data = JSON.parse(session.data);
        session.updatedAt = moment(session.updatedAt).format('DD/MM/YY');
        session.createdAt = moment(session.createdAt).format('DD/MM/YY');
      });

      _onboardingSessions = sessions;
      if (successCb) {
        successCb(sessions);
      }
    }, function (e) {
      console.error('failed to fetch onboarding sessions', e);
    });
  };

  getOnboardingSessions();

  var sampleCompanyTest = function sampleCompanyTest(org) {
    if (!org) {
      return false;
    }
    if (!org.features) {
      return false;
    }
    if (!org.features.sampleCompany) {
      return false;
    }
    if (!org.features.sampleCompany.isSample) {
      return false;
    }
    return true;
  };

  return {
    logout: function logout(apiVersion, redirectUrl) {
      var url = "" + '/' + apiVersion + '/logout' + (redirectUrl && redirectUrl !== '' ? '?redirectTo=' + encodeURIComponent(redirectUrl) : '');

      window.location = url;
    },
    isSampleCompany: function isSampleCompany() {
      return sampleCompanyTest(currentOrganisation);
    },
    hasSampleCompany: function hasSampleCompany() {
      if (!_allowedOrganisations) {
        return false;
      }
      var hasSample = false;
      for (var i = 0; i < _allowedOrganisations.length; i++) {
        var org = _allowedOrganisations[i];
        if (sampleCompanyTest(org)) {
          hasSample = true;
          break;
        }
      }
      return hasSample;
    },
    currentUser: function currentUser() {
      return currentUserItem;
    },
    currentOrg: function currentOrg() {
      return currentOrganisation;
    },
    currentOrgGroup: function currentOrgGroup() {
      return currentOrganisationGroup;
    },
    allowedOrganisations: function allowedOrganisations() {
      return _allowedOrganisations;
    },
    checkCompanyEnabled: function checkCompanyEnabled(orgId, cb) {
      return _checkCompanyEnabled(orgId, cb);
    },
    refreshAndGetAllowedOrganisations: function refreshAndGetAllowedOrganisations(successCb, failureCb) {
      refereshAllowedOrganisation(successCb, failureCb);
    },
    onboardingSessions: function onboardingSessions() {
      return _onboardingSessions;
    },
    deleteSession: function deleteSession(session, successCb) {
      Restangular.all("onboarding").one(session.id).remove().then(successCb);
    },
    getOrgPagePermissions: function getOrgPagePermissions(org, group, cb) {
      Restangular.all("organisations").one(org.id).all('groups').one(group.id).all('permissions').customGET("", { user: currentUserItem.id }).then(function (permissions) {
        cb(permissions);
      }, function (err) {
        cb([]);
      });
    },
    userHasPermission: function userHasPermission(permissionName) {
      // check if user is global admin on the group first
      if (currentOrganisation && currentOrganisation.globalAdministrators.indexOf(currentUserItem.id) != -1) {
        return true;
      }
      if (currentOrganisationGroup && currentOrganisationGroup.owners && currentOrganisationGroup.owners.indexOf(currentUserItem.id) != -1) {
        return true;
      }
      // check if user has finite permission second
      if (currentUserItem && currentUserItem.permissions) {
        if (currentUserItem.permissions.indexOf(permissionName) !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    refreshCurrentUser: function refreshCurrentUser() {
      baseUser.get().then(function (user) {
        currentUserItem = user;
      });
    },
    ensureCurrentUser: function ensureCurrentUser() {
      return $q(function (resolve, reject) {
        if (currentUserItem != null) {
          resolve(currentUserItem);
          return;
        }
        // fetch configuration if required
        if (configuration === null && configurationPromise === null) {
          configurationPromise = baseConfig.customGET().then(function (results) {
            configuration = results;

            $window.Stripe.setPublishableKey(configuration.stripe.public);
            //$window.configureIntercom();

            //$window.configureRaven(configuration.sentry.dsn);
            configured = true;
            configurationPromise = null;
            return true;
          });
        }
        baseUser.get().then(function (user) {
          if (user.id != null) {
            currentUserItem = user;
            if (!configured && configurationPromise !== null) {
              configurationPromise = configurationPromise.then(function () {

                /*window.Intercom("boot", {
                  app_id: configuration.intercom.appId,
                  user_id: user.id,
                  name: user.name.full,
                  email: user.emailAddress,
                  user_hash: user.hash,
                  customer_launcher_selector: "#intercom-launcher"
                });*/

                checkFcWidget(function () {
                  console.log('configured fc');
                  //window.fcWidget.setExternalId();
                  window.FreshworksWidget('identify', 'ticketForm', {
                    name: user.name.full,
                    email: user.emailAddress
                  });
                  window.FreshworksWidget('disable', 'ticketForm', ['name', 'email']);
                });

                /*Raven.setUserContext({
                  email: user.emailAddress,
                  name: user.name.full,
                  id: user.id
                });*/
                mixpanel.identify(currentUserItem.uuid);
                mixpanel.people.set({
                  "$email": user.emailAddress,
                  "$first_name": user.name.first,
                  "$last_name": user.name.last
                });
              });
            } else {
              checkFcWidget(function () {
                console.log('configured fc');
                //window.fcWidget.setExternalId();

                window.FreshworksWidget('identify', 'ticketForm', {
                  name: user.name.full,
                  email: user.emailAddress
                });
                window.FreshworksWidget('disable', 'ticketForm', ['name', 'email']);
              });

              /*Raven.setUserContext({
                email: user.emailAddress,
                name: user.name.full,
                id: user.id
              });*/
              mixpanel.identify(currentUserItem.uuid);
              mixpanel.people.set({
                "$email": user.emailAddress,
                "$first_name": user.name.first,
                "$last_name": user.name.last
              });
            }
            resolve(currentUserItem);
            return;
          }
          resolve();
        }, function (err) {
          console.error('received an error for ensureCurrentUser', err);
          reject(err);
        });
      });
    },
    ensureMyDocketbook: function ensureMyDocketbook() {
      return $q(function (resolve, reject) {
        $cookies.remove('currentOrgGroup');
        $cookies.remove('currentOrg');
        currentOrganisation = null;
        currentOrganisationGroup = null;
        currentOrgId = null;
        currentOrgGroupId = null;
        if (currentUserItem) {
          currentUserItem.permissions = [];
        }
        getAllowedOrganisations(function () {
          resolve(null);
        }, function (err) {
          reject(err);
        });
      });
    },
    getOrg: function getOrg(orgId, successCb, failureCb) {
      Restangular.all('organisations').one(orgId).customGET().then(successCb, failureCb);
    },
    getConnections: function getConnections(successCb) {
      Restangular.all('user').one(currentUserItem.id).all('connections').all('invitations').getList().then(function (invitations) {
        successCb && successCb(invitations);
      });
    },
    ensureCurrentOrgGroup: function ensureCurrentOrgGroup(orgId, orgGroupId) {
      if (orgGroupId == 'home') {
        orgGroupId = null;
      }
      return $q(function (resolve, reject) {
        if (orgId == null) {
          $cookies.remove('currentOrgGroup');
          $cookies.remove('currentOrg');
          currentOrganisation = null;
          currentOrganisationGroup = null;
          currentOrgId = null;
          currentOrgGroupId = null;
          resolve(currentOrganisation);
        } else {
          if (currentOrganisation != null && currentOrganisation.id == orgId && currentOrganisationGroup != null && currentOrganisationGroup.id == orgGroupId) {
            // check current org is not disabled
            resolve(currentOrganisation);
            return;
          }

          getAllowedOrganisations(function () {
            var isDev = "production" == 'development';

            var locatedOrg = null;
            if (_allowedOrganisations && _allowedOrganisations.length > 0) {
              for (var i = 0; i < _allowedOrganisations.length; i++) {
                if (_allowedOrganisations[i].id == orgId) {
                  locatedOrg = _allowedOrganisations[i];
                  break;
                }
              }
            }

            var locatedOrgGroup = null;
            if (orgGroupId) {
              if (locatedOrg && locatedOrg.groups) {
                for (var i = 0; i < locatedOrg.groups.length; i++) {
                  if (locatedOrg.groups[i].id == orgGroupId) {
                    locatedOrgGroup = locatedOrg.groups[i];
                    orgGroupId = locatedOrgGroup.id;
                    break;
                  }
                }
              }
            } else {
              if (locatedOrg) {
                for (var i = 0; i < locatedOrg.groups.length; i++) {
                  if (locatedOrg.groups[i].parent == null) {
                    locatedOrgGroup = locatedOrg.groups[i];
                    orgGroupId = locatedOrgGroup.id;
                    break;
                  }
                }
              }
              if (locatedOrgGroup == null && locatedOrg.groups && locatedOrg.groups.length > 0) {
                locatedOrgGroup = locatedOrg.groups[0];
              }
            }

            currentOrganisation = locatedOrg;

            // trim any trailing spaces and convert strings to proper values
            if (currentOrganisation.plan && currentOrganisation.plan.features) {
              var newFeatures = {};
              Object.keys(currentOrganisation.plan.features).forEach(function (feature) {
                var featureVal = currentOrganisation.plan.features[feature];
                if (!isNaN(featureVal)) {
                  newFeatures[feature.trim()] = featureVal === true ? true : featureVal === false ? false : parseInt(featureVal);
                } else {
                  newFeatures[feature.trim()] = featureVal == 'true' ? true : featureVal == 'false' ? false : featureVal;
                }
              });
              currentOrganisation.plan.features = newFeatures;
            }

            currentOrganisation.planFeatures = Object.assign({
              name: 'Free',
              includedUsers: 10,
              includedOrganisationGroups: 1,
              ordersEnabled: false,
              jobsEnabled: false,
              reportingEnabled: false, // future
              invoicesEnabled: false, // future
              accountingIntegrationEnabled: false, // future
              ordersCreate: false,
              jobsCreate: false,
              jobsSubcontractorAllocation: false,
              jobsAllocationsView: false,
              docketsCreate: false,
              docketsCreateFromJob: true,
              docketsFiling: false,
              docketsTimesheetsView: false,
              docketsHistoricalDateLimit: 60,
              docketsReports: false,
              docketsCreateBatches: false,
              docketsViewBatches: false
            }, currentOrganisation.plan ? currentOrganisation.plan.features : {}, currentOrganisation.plan ? { name: currentOrganisation.plan.name } : {});

            currentOrganisation.planFeatures.trialAvailable = true;
            currentOrganisation.planFeatures.inTrial = false;

            if (currentOrganisation.trial_end || isDev) {
              var trialEndDate = new Date(currentOrganisation.trial_end * 1000);
              currentOrganisation.planFeatures.trialAvailable = false;
              if (moment().isBefore(trialEndDate) || isDev) {
                currentOrganisation.planFeatures.inTrial = !isDev;
                currentOrganisation.planFeatures = Object.assign(currentOrganisation.planFeatures, {
                  ordersEnabled: true,
                  jobsEnabled: true,
                  reportingEnabled: true,
                  invoicesEnabled: true,
                  accountingIntegrationEnabled: true,
                  ordersCreate: true,
                  jobsCreate: true,
                  jobsSubcontractorAllocation: true,
                  jobsAllocationsView: true,
                  docketsCreate: true,
                  docketsCreateFromJob: true,
                  docketsFiling: true,
                  docketsTimesheetsView: true,
                  docketsHistoricalDateLimit: -1,
                  docketsReports: true,
                  docketsCreateBatches: true,
                  docketsViewBatches: true
                });
              }
            }

            if (isDev) {
              currentOrganisation.planFeatures.includedOrganisationGroups = 99;
              currentOrganisation.planFeatures.includedUsers = 99;
              currentOrganisation.betaAllowed = true;
              currentOrganisation.features.docketSyncing = true;
              currentOrganisation.features.canChangeOrderResources = true;
              currentOrganisation.features.invoice.enabled = true;
              currentOrganisation.features.reactBeta = true;
            }

            if (currentOrganisation.features.dockets && currentOrganisation.features.dockets.listViewOrder) {
              var customColumns = currentOrganisation.features.dockets.listViewOrder.filter(function (x) {
                return x.split('-')[0] == 'customField';
              });
              if (customColumns.length > 0) {
                currentOrganisation.features.dockets.customColumns = customColumns.map(function (x) {
                  return x.split('-')[1];
                });
              }
            }

            currentOrganisationGroup = locatedOrgGroup;
            currentOrgId = orgId;
            currentOrgGroupId = orgGroupId;
            $cookies.put('currentOrgGroup', orgGroupId);
            $cookies.put('currentOrg', orgId);
            getUsersPermissions(currentUserItem, function (permissions) {
              currentUserItem.permissions = permissions;
              resolve(currentOrganisation);
            });
          }, function () {
            reject();
          });
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N"), __webpack_require__("PJh5")))

/***/ }),

/***/ "QpJk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QuLm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lines.svg";

/***/ }),

/***/ "QyGI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "unit.svg";

/***/ }),

/***/ "R3DX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "next-icon.svg";

/***/ }),

/***/ "RDwX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "templatedesigner.svg";

/***/ }),

/***/ "RMHk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @license ngScroll.js v1.0.0
 * (c) 2014 Daniel Smith http://www.danmasta.com
 * License: MIT
 */
(function (window, angular, undefined) {
  'use strict';

  /**
   * @name ngScroll
   * @description
   *
   * # ngScroll
   *
   * The ngScroll module provides an angular directive for handling scroll events.
   * Expressions are parsed when the document scrolls.
   * Directive implementation is the same as default angular event handlers.
   * Event object is available as $event.
   */

  // define ngScroll module

  var ngScroll = angular.module('ngScroll', []);

  // Factory for checking and binding scroll event to document.
  // Broadcasts 'scroll' event from $rootScope to be inherited by all child scopes
  ngScroll.factory('scroll', ['$window', '$document', '$rootScope', '$interval', function ($window, $document, $rootScope, $interval) {
    function Scroll(event) {
      this.prev = $rootScope.prevScroll || false, this.x = $window.pageXOffset !== undefined ? $window.pageXOffset : ($document[0].documentElement || $document[0].body.parentNode || $document[0].body).scrollLeft, this.y = $window.pageYOffset !== undefined ? $window.pageYOffset : ($document[0].documentElement || $document[0].body.parentNode || $document[0].body).scrollTop, this.type = event.type || event.name, this.timestamp = event.timeStamp || Date.now(), this.timelapse = this.prev ? this.timestamp - this.prev.timestamp : 0, this.distanceX = this.x - (this.prev ? this.prev.x : 0), this.distanceY = this.y - (this.prev ? this.prev.y : 0), this.velocityX = this.distanceX / (this.timestamp - (this.prev ? this.prev.timestamp : 0)), this.velocityY = this.distanceY / (this.timestamp - (this.prev ? this.prev.timestamp : 0)), this.directionX = this.distanceX < 0 ? 'left' : this.distanceX > 0 ? 'right' : false, this.directionY = this.distanceY < 0 ? 'up' : this.distanceY > 0 ? 'down' : false, this.scrollHeight = ($document[0].body.scrollHeight || $document[0].documentElement.scrollHeight) - $window.innerHeight, this.event = event || false;
    };
    return {
      get: function get(event) {
        return new Scroll(event);
      },
      setDate: function setDate() {
        if (!Date.now) {
          Date.now = function () {
            return new Date().getTime();
          };
        };
        return;
      },
      checkBind: function checkBind() {
        if (angular.isUndefined($rootScope.catchScroll)) return false;
        return $rootScope.catchScroll;
      },
      setBind: function setBind() {
        var _this = this;
        var scrollThrottle = 30;
        var didScroll = false;
        var timer = false;
        $document.on('scroll', function (event) {
          if (!didScroll) {
            timer = $interval(function () {
              if (didScroll) {
                didScroll = false;
                $interval.cancel(timer);
                var data = _this.get(event);
                $rootScope.$broadcast('scroll', data);
                $rootScope.prevScroll = data;
              }
            }, scrollThrottle);
          }
          didScroll = true;
        });
        $rootScope.catchScroll = true;
      },
      bind: function bind() {
        if (!this.checkBind()) {
          this.setDate();
          this.setBind();
          return;
        }
      }
    };
  }]);

  // ngScroll directive uses throttled scroll event bound to document.
  // Usage: ng-scroll="expression()"
  // Event data is available as $event
  ngScroll.directive('ngScroll', ['$parse', 'scroll', function ($parse, scroll) {
    return {
      compile: function compile($element, attr) {
        var fn = $parse(attr['ngScroll']);
        return function (scope, element, attr) {
          scroll.bind();
          scope.$on('scroll', function (event, data) {
            fn(scope, { $event: data });
          });
        };
      }
    };
  }]);
})(window, window.angular);

/***/ }),

/***/ "RQoQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RZlY":
/***/ (function(module, exports) {

var path = 'views/pages/mobileSideNav.html';
var html = "<div class=\"mobileSideNav\">\n  <div class=\"closeIconOuter\">\n    <div class=\"closeIcon\" ng-click=\"closeScopeDropdown()\">\n      <md-icon md-svg-src=\"clear.svg\"></md-icon>\n    </div>\n  </div>\n\n  <ul class=\"topLevel\">\n    <li ui-sref=\"main.dashboard\" class=\"{{currentOrg == null && myAccount == null ? 'selected' : ''}}\">\n      <div class=\"listItemInner topLevelInner\">\n        <md-icon md-svg-src=\"db-logomark.svg\"></md-icon>\n        <span>My Docketbook</span>\n      </div>\n    </li>\n    <li ng-repeat=\"org in organisations\"\n      class=\"{{(currentOrg.id == org.id && currentOrgGroup.parent == null) ? 'selected' : ''}}\">\n      <div class=\"listItemInner topLevelInner\" ng-click=\"changeOrganisation(org)\">\n        <!--ui-sref=\"main.groupDashboard({orgId:org.id, groupId:'home'})\">-->\n        <md-icon md-svg-src=\"org.svg\"></md-icon>\n        <span>{{org.name}}</span>\n      </div>\n      <ul class=\"subList\">\n        <li ng-repeat=\"group in org.groups\" ng-click=\"changeOrganisationGroup(org, group)\"\n          ng-show=\"group.parent != null\" class=\"{{currentOrgGroup.id == group.id ? 'selected' : ''}}\">\n          <!--ui-sref=\"main.groupDashboard({orgId:org.id, groupId:group.id})\"-->\n          <div class=\"listItemInner\">\n            <md-icon md-svg-src=\"lines.svg\"></md-icon>\n            <span>{{group.name}}</span>\n          </div>\n        </li>\n      </ul>\n    </li>\n    <li ng-click=\"newCompany(false)\" ng-if=\"currentUser.restricted !== true\">\n      <div class=\"listItemInner\">\n        <md-icon md-svg-src=\"add.svg\"></md-icon>\n        <span>New Company</span>\n      </div>\n    </li>\n    <li ng-if=\"currentUser.restricted === true\">\n      <div class=\"listItemInner\">\n        <md-icon md-svg-src=\"add.svg\"></md-icon>\n        <span>Verify Account to Create Companies</span>\n      </div>\n    </li>\n    <li ng-click=\"newCompany(true)\" ng-if=\"!hasSampleCompany\">\n      <div class=\"listItemInner\">\n        <md-icon md-svg-src=\"add.svg\"></md-icon>\n        <span>Create Sample Company</span>\n      </div>\n    </li>\n    <li ui-sref=\"user.account\" class=\"{{myAccount == true ? 'selected' : ''}}\">\n      <div class=\"listItemInner topLevelInner\">\n        <md-icon md-svg-src=\"account.svg\"></md-icon>\n        <span>My Account</span>\n      </div>\n    </li>\n    <li ng-click=\"openHelpLink()\">\n      <div class=\"listItemInner\">\n        <md-icon md-svg-src=\"help.svg\"></md-icon>\n        <span>Help Guides</span>\n      </div>\n    </li>\n    <li ng-click=\"openIntercom()\">\n      <div class=\"listItemInner\">\n        <md-icon md-svg-src=\"forum.svg\"></md-icon>\n        <span>Support Chat</span>\n      </div>\n    </li>\n    <li ng-click=\"logout()\">\n      <div class=\"listItemInner\">\n        <md-icon md-svg-src=\"logout.svg\"></md-icon>\n        <span>Logout</span>\n      </div>\n    </li>\n  </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "RbuR":
/***/ (function(module, exports) {

var path = 'views/modals/selectQuoteModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector long\" id=\"selectQuoteModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Xero Quotes</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeQuoteSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"splitModalForm\">\n        <div class=\"splitModalFormLeft noPadding white\">\n          <div class=\"searchBar\">\n            <div class=\"title\">\n              <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n            </div>\n            <div class=\"bar\">\n              <input autofocus name=\"searchQuoteInput\" type=\"text\" ng-model=\"quoteSearchValue\" placeholder=\"Search\" ng-change=\"searchQuoteChange(quoteSearchValue)\" ng-model-options='{debounce:1000}'>\n            </div>\n          </div>\n          <div class=\"noListMessage\" ng-show=\"quoteSearchList.length <= 0 && !quoteSearchLoading\">\n            There are no quotes matching your search critera.\n          </div>\n          <div class=\"noListMessage\" ng-show=\"quoteSearchLoading\">\n            Loading Quotes from Xero...please wait\n          </div>\n          <div class=\"modalListOuter\">\n            <md-list>\n              <md-list-item ng-repeat=\"quote in quoteSearchList\" ng-click=\"selectQuote(quote)\" class=\"md-2-line\">\n                <div class=\"md-list-item-text\" layout=\"column\">\n                  <h3>{{quote.quoteNumber}} ({{quote.status}})</h3>\n                  <p>Contact: {{quote.contact.name}}</p>\n                  <p>Date: {{moment(quote.dateString,'YYYY-MM-DD').format('DD/MM/YYYY')}} - Expiry: {{moment(quote.expiryDateString,'YYYY-MM-DD').format('DD/MM/YYYY')}}</p>\n                </div>\n              </md-list-item>\n            </md-list>\n          </div>\n        </div>\n        <div class=\"splitModalFormRight noPadding\">\n          <span ng-if=\"quoteDetail != null\">\n            <div class=\"contactDetailHeader small\">\n              <h1>{{quoteDetail.quoteNumber}}</h1>\n              <h2>{{quoteDetail.contact.name}}</h2>\n              <h2>{{moment(quoteDetail.dateString,'YYYY-MM-DD').format('DD/MM/YYYY')}} - {{moment(quoteDetail.expiryDateString,'YYYY-MM-DD').format('DD/MM/YYYY')}}</h2>\n            </div>\n            <md-list>\n              <md-list-item ng-repeat=\"line in quoteDetail.lineItems\">\n                {{line.description}}({{line.itemCode}}) - QTY {{line.quantity}} - Unit ${{line.unitAmount}} <strong>Total ${{line.unitAmount * line.quantity}}</strong>\n              </md-list-item>\n            </md-list>\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeQuoteSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"(quoteDetail == null  || selectQuoteContinue())\" ng-disabled=\"quoteDetail == null\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Rmmh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').controller('loadingController', ['$scope', '$state', 'accessControl', function loadingController($scope, $state, accessControl) {
  // ensure current user
  accessControl.ensureCurrentUser().then(function (user) {
    var paramsTo = {};
    var stateTo = {};
    var searchParams = {};

    if ($state.params.goToParams) {
      paramsTo = JSON.parse($state.params.goToParams);
    }

    if ($state.params.searchParams) {
      searchParams = JSON.parse($state.params.searchParams);
      for (var paramKey in searchParams) {
        paramsTo[paramKey] = searchParams[paramKey];
      }
    }

    if ($state.params.goToState) {
      stateTo = JSON.parse($state.params.goToState);

      if (stateTo.params === null) {
        stateTo.params = {};
      }

      // copy the params over.
      var jsonParams = JSON.stringify(paramsTo);
      stateTo.params = JSON.parse(jsonParams);
    }

    // if redirectTo is present and the user is logged in, then proceed to redirect
    // to the url specified in the parameter.
    if ($state.params.redirectTo && $state.params.redirectTo !== '') {
      window.location = $state.params.redirectTo;
      return;
    }

    if (user.presignedToken != null && user.presignedTokenTarget != null) {
      var type = user.presignedTokenTarget.split(':')[0];
      var id = user.presignedTokenTarget.split(':')[1];

      $state.go('preauth.docket', { docketId: id, previewMode: true });

      return;
    } else if (stateTo.name === 'preauth.docket') {
      $state.go('main.docketDetail', { docketId: stateTo.params.docketId });

      return;
    } else {
      if (stateTo.name !== 'main.loading') {
        if (stateTo.name === 'main.dashboard') {
          var localStorageId = 'orgGroup-' + user.id;

          if (localStorage.getItem(localStorageId)) {
            var savedSessionOrgGroup = JSON.parse(localStorage.getItem(localStorageId));

            $state.go('main.groupDashboard', savedSessionOrgGroup);

            return;
          }
        }

        if (stateTo.params && stateTo.params.orgId) {
          accessControl.checkCompanyEnabled(stateTo.params.orgId, function (enabled) {
            if (enabled) {
              $state.go(stateTo.name, stateTo.params);
              return;
            } else {
              $state.go('main.groupDashboard', stateTo.params);
              return;
            }
          });
        } else if (stateTo.name === 'main.docketDetail') {
          $state.go('main.docketDetail', stateTo.params);
          return;
        } else {
          $state.go('main.dashboard', searchParams);
          return;
        }
      }

      $state.go('main.dashboard', searchParams);
    }
  }, function (err) {
    accessControl.logout($scope.urlVersion, $state.params.requestedUrl);
  });
}]);

/***/ }),

/***/ "Rnnk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "10.png";

/***/ }),

/***/ "RwwX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('groupSettingsAdminsController', ['userService', '$scope', 'Restangular', '$window', '$state', '$stateParams', 'accessControl', function (userService, $scope, Restangular, $window, $state, $stateParams, accessControl) {
	mixpanel.track("Opened GroupSettings-Admins Desktop");

	$scope.currentUser = accessControl.currentUser();
	$scope.currentState = $state.current;
	$scope.sampleCompany = accessControl.isSampleCompany();
	$scope.currentOrg = accessControl.currentOrg();
	$scope.currentOrgGroup = accessControl.currentOrgGroup();

	$scope.groupEdit = $scope.currentOrgGroup;

	/***** DATA *****/
	userService.getMembers(null, function (users) {
		$scope.allUsers = users;
	}, function (err) {
		$scope.allUsers = [];
	});

	userService.getRoles(null, function (roles) {
		$scope.allRoles = roles;
	}, function (err) {
		$scope.allRoles = [];
	});

	$scope.formattedUsersForDisplay = function (userList) {
		return userList.map(function (owner) {
			if (owner.emailAddress.indexOf("users.docketbook.io") !== -1) {
				owner.displayEmailAddress = '0' + owner.emailAddress.split("@")[0].substring(3);
			} else {
				owner.displayEmailAddress = owner.emailAddress;
			}
			if (accessControl.isSampleCompany()) {
				var user = owner;
				if (user.name.first === "Chris" && user.name.last === "Digger") {
					owner.displayEmailAddress = "chris.digger@fakeaddress.com";
				} else if (user.name.first === "John" && user.name.last === "Trucks") {
					owner.displayEmailAddress = "john.trucks@fakeaddress.com";
				} else if (user.name.first === "Steve" && user.name.last === "Dozer") {
					owner.displayEmailAddress = "steve.dozer@fakeaddress.com";
				}
			}
			return owner;
		});
	};

	userService.getOrganisationGroup($scope.currentOrgGroup.id, function (groupFull) {
		$scope.groupEdit.owners = $scope.formattedUsersForDisplay(groupFull.owners);
		userService.getGroupMembers({ 'sort': 'first', 'groupId': $scope.groupEdit.id }, function (membersUserInfo) {
			populateOwnerStatus($scope.groupEdit, membersUserInfo);
		});
	});

	$scope.reloadGroupOwners = function (groupEdit) {
		userService.getOrganisationGroup(groupEdit.id, function (groupFull) {
			groupEdit.owners = $scope.formattedUsersForDisplay(groupFull.owners);
		}, function (err) {});
	};

	// Add owners to group
	$scope.addOwnersToGroup = function (groupEdit) {
		// get list of existing users for this group
		var existingOwners = [];
		for (var i = 0; i < groupEdit.owners.length; i++) {
			existingOwners.push(groupEdit.owners[i].id);
		}
		$scope.selectOrgPeopleFromParent(existingOwners, function (people) {
			if (people != null) {
				var membersToAdd = [];
				for (var i = 0; i < people.length; i++) {
					var person = { 'user': people[i].id, roles: ['owner'] };
					membersToAdd.push(person);
				}

				userService.assignMembersToGroup(groupEdit.id, membersToAdd, function (success) {
					$scope.reloadGroupOwners(groupEdit);
				}, function (err) {
					$scope.alertService.presentAutoAlert('addGroupOwner', err);
				});
			}
		});
	};

	// populate onDocketbook status of owners list
	var populateOwnerStatus = function populateOwnerStatus(group, usersList) {
		for (var i = 0; i < group.owners.length; i++) {
			for (var j = 0; j < usersList.length; j++) {
				if (group.owners[i].id == usersList[j].id) {
					group.owners[i].onDocketbook = usersList[j].onDocketbook;
					break;
				}
			}
		}
	};

	$scope.removeOwnerFromGroup = function (owner, group) {
		swal({
			title: "Are you sure?",
			text: "Do you really want to remove " + owner.name.full + "?",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, remove!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function (isConfirm) {
			if (isConfirm) {
				userService.removeOwnerFromGroup(group.id, owner.id, function (success) {
					for (var i = 0; i < group.owners.length; i++) {
						if (group.owners[i].id == owner.id) {
							group.owners.splice(i, 1);
							break;
						}
					}
				}, function (err) {
					$scope.alertService.presentAutoAlert('removeGroupOwner', err);
				});
			}
		});
	};

	// Inviting new members
	$scope.inviteNewMembers = function (group, type) {
		$("#inviteMembersModal").fadeIn(200);
		$scope.newMemberInvitesLoading = false;
		$scope.inviteMembers = {};
		if (type) {
			$scope.inviteMembers.type = type;
		} else {
			$scope.inviteMembers.type = 'member';
		}
		$scope.newMemberInvites = [{}];
	};

	$scope.addBlankInvitee = function () {
		$scope.newMemberInvites.push({});
	};

	$scope.removeInvitee = function (invitee) {
		$scope.newMemberInvites.splice($scope.newMemberInvites.indexOf(invitee), 1);
	};

	$scope.closeInviteMembers = function () {
		$("#inviteMembersModal").fadeOut(200);
	};

	$scope.inviteMembersContinue = function () {
		$scope.newMemberInvitesLoading = true;
		var invitesArray = [];
		for (var i = 0; i < $scope.newMemberInvites.length; i++) {
			var roleAdd = "";
			if ($scope.inviteMembers.type == 'members') {
				roleAdd = $scope.newMemberInvites[i].role.id;
			} else if ($scope.inviteMembers.type == 'owner') {
				roleAdd = 'owner';
			} else {
				roleAdd = 'monitor';
			}
			var newInvite = { 'emailAddress': $scope.newMemberInvites[i].emailAddress.replace(/\s/g, ''), 'roles': [roleAdd], 'firstName': $scope.newMemberInvites[i].firstName, 'lastName': $scope.newMemberInvites[i].lastName };
			invitesArray.push(newInvite);
		}

		userService.assignMembersToGroup($scope.groupEdit.id, invitesArray, function (success) {
			if ($scope.inviteMembers.type == 'members') {
				$scope.reloadGroupMembers($scope.groupEdit);
			} else if ($scope.inviteMembers.type == 'owner') {
				$scope.reloadGroupOwners($scope.groupEdit);
			} else {
				$scope.reloadGroupMonitors($scope.groupEdit);
			}
			$scope.closeInviteMembers();
		}, function (err) {
			$scope.newMemberInvitesLoading = false;
			$scope.alertService.presentAutoAlert('addGroupMembers', err);
		});
	};
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "RxaN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('importContactsModalController', ['addressBookService', 'xeroService', '$scope', 'Upload', '$q', function (addressBookService, xeroService, $scope, Upload, $q) {

  /*****************************/
  /*****  Xero Importing   *****/
  /*****************************/

  $scope.xeroContactSearchList = [];
  $scope.xeroContactSearchValue = "";
  $scope.selectedContacts = [];
  $scope.xeroSyncLoading = false;
  $scope.selectedTabIndex = 0;

  $scope.allResourceCategories = [];
  $scope.sortedResourceCategories = {};
  $scope.allUoms = [];
  $scope.sortedUoms = {};

  if ($scope.currentOrg != null) {
    xeroService.getXeroContacts(function (contacts) {
      $scope.xeroContactsList = contacts; /*.map(c => Object.assign(c, c.addresses ? { selectedAddress: c.addresses[0] } : {}))*/
    }, function (err) {
      $scope.xeroContactsList = [];
    });
  }

  $scope.$parent.showImportContactsModal = function () {
    $scope.xeroContactSearchValue = "";
    $scope.xeroContactSearchList = $scope.xeroContactsList;
    $scope.selectedContacts = [];
    $scope.selectedTabIndex = 0;
    $scope.mode = 'import';
    $scope.contactImport = { 'loading': false };
    $scope.file = null;
    $("#importContactsModal").fadeIn(100);
  };

  $scope.close = function () {
    $("#importContactsModal").fadeOut(100);
  };

  $scope.selectAddress = function (contact, address) {
    contact.selectedAddress = address;
  };

  $scope.xeroContactSync = function () {
    $scope.selectedContacts = [];
    $scope.xeroSyncLoading = true;
    xeroService.xeroContactSync(function (taskInfo) {
      if (taskInfo.status == 'Failed') {
        $scope.alertService.presentAlert('error', "We couldn't sync your Xero Contacts", "Something went wrong when we tried to sync your Xero Contacts. Please try again or contact support if this error persists.");
        $scope.xeroSyncLoading = false;
      } else {

        xeroService.getXeroContacts(function (contacts) {
          $scope.xeroContactsList = contacts; /*.map(c => Object.assign(c, c.addresses ? { selectedAddress: c.addresses[0] } : {}))*/
          $scope.xeroContactSearchList = $scope.xeroContactsList;

          $scope.xeroSyncLoading = false;
          $scope.showContactSyncSuccess = true;
        }, function (err) {
          $scope.xeroContactsList = [];
          $scope.xeroSyncLoading = false;
          $scope.showContactSyncSuccess = true;
        });
      }
    });
  };

  $scope.getTableStyle = function () {
    if ($scope.xeroSyncLoading) {
      return { opacity: 0.5 };
    } else {
      return {};
    }
  };

  $scope.searchXeroContactChange = function (searchValue) {
    if (searchValue == "") {
      $scope.xeroContactSearchList = $scope.xeroContactsList;
      return;
    }
    $scope.xeroContactSearchList = $scope.xeroContactsList.filter(function (contact) {
      return _stringSimilarity2.default.compareTwoStrings(contact.name, searchValue) > 0.5 || contact.name.toLowerCase().indexOf(searchValue.toLowerCase()) != -1;
    });
  };

  $scope.import = function () {
    $scope.importing = true;

    var contacts = $scope.selectedContacts.map(function (contact) {
      return {
        displayName: contact.name,
        addresses: contact.addresses,
        xeroContact: contact,
        externalIdentifiers: [{ type: 'xero', externalId: contact.externalId }],
        contactAddresses: contact.emailAddresses.map(function (email) {
          return { emailAddress: email, accessLevel: 'viewer' };
        })
      };
    });

    var errors = [];

    var saveContact = function saveContact() {
      if (contacts.length == 0) {
        $scope.importing = false;
        $scope.$parent.loadAddressBook();
        $("#importContactsModal").fadeOut(100);
      } else {
        var contact = contacts.pop();
        addressBookService.saveContact(contact, saveContact, function (err) {
          errors.push(err);
          saveContact();
        });
      }
    };
    saveContact();
  };

  /*****************************/
  /*****  File Importing   *****/
  /*****************************/

  $scope.cancelImport = function () {
    $scope.close();
    $scope.mode = 'list';
    $scope.importList = [];
  };

  var mapping = {
    'customer name': 'name',
    'email': 'email',
    'unit number': 'unitNum',
    'street number': 'streetNum',
    'street name': 'streetName',
    'suburb': 'suburb',
    'state': 'state',
    'postcode': 'postCode',
    'country': 'country'
  };

  var reverseMapping = {};

  Object.keys(mapping).forEach(function (key) {
    reverseMapping[mapping[key]] = key;
  });

  var readTableHeaders = function readTableHeaders(fileData) {
    var headers = fileData.shift().map(function (header) {
      return header.toLowerCase();
    }).map(function (header) {
      var found = null;
      Object.keys(mapping).forEach(function (key) {
        if (header.includes(key)) {
          found = mapping[key];
          return;
        }
      });
      return found;
    }).filter(function (x) {
      return x !== null;
    });

    var headerMissing = function headerMissing(str) {
      return !headers.includes(str);
    };

    var missing = ['name', 'email'].filter(headerMissing).map(function (header) {
      return reverseMapping[header];
    });

    if (missing.length > 0) {
      swal({
        title: "Oops!",
        text: 'The following columns are missing from the file: ' + missing.join(', '),
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return null;
    }

    return fileData.map(function (data) {
      var item = {};
      headers.forEach(function (header, i) {
        item[header] = data[i];
      });
      return item;
    });
  };

  $scope.importFromFile = function (fileToUpload) {
    $scope.contactImport.loading = true;

    Upload.upload({
      url: '/v1/parse',
      data: { file: fileToUpload },
      withCredentials: true
    }).then(function (resp) {
      var data = readTableHeaders(resp.data[0].data);
      if (data == null) {
        $scope.resourceImport.loading = false;
        return;
      }

      $scope.parseContactsForImport(data);
    }, function (resp) {
      $scope.contactImport.loading = false;
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  };

  var containsEmptyFields = function containsEmptyFields() {
    for (var _len = arguments.length, arr = Array(_len), _key = 0; _key < _len; _key++) {
      arr[_key] = arguments[_key];
    }

    return arr.includes(undefined) || arr.includes(null) || arr.includes('');
  };

  $scope.parseContactsForImport = function (data) {
    $scope.contactImport.loading = true;
    var contactsList = [];
    $scope.importSelected = [];

    var Geocoder = new google.maps.Geocoder();

    var errors = [];

    var promises = data.map(function (_ref, lineNum) {
      var name = _ref.name,
          email = _ref.email,
          unitNum = _ref.unitNum,
          streetNum = _ref.streetNum,
          streetName = _ref.streetName,
          suburb = _ref.suburb,
          state = _ref.state,
          postCode = _ref.postCode,
          country = _ref.country;

      return $q(function (resolve, reject) {
        if ([name, email, unitNum, streetName, suburb, state, postCode, country].filter(function (x) {
          return x != null && x != undefined && x != '';
        }).length == 0) {
          return resolve();
        }

        if (containsEmptyFields(name /*, email*/)) {
          var missing = [];
          if (containsEmptyFields(name)) {
            missing.push('customer name');
          }
          /*if (containsEmptyFields(email)) {
            missing.push('customer email')
          }*/

          errors.push('Line ' + (lineNum + 2) + ': missing data: ' + missing.join(', '));
          return resolve();
        }

        var newUser = {
          displayName: name,
          contactAddresses: email ? [{ emailAddress: email, accessLevel: 'viewer' }] : [],
          tags: []
        };

        if ([streetNum, streetName, suburb, state, postCode, country].filter(function (x) {
          return x != undefined && x != null && x != '';
        }).length == 0 && unitNum != null) {
          Geocoder.geocode({ address: unitNum }).then(function (addr) {
            if (addr.results.length > 0) {
              var loc = addr.results[0];

              var getFromLoc = function getFromLoc(type) {
                var found = loc.address_components.filter(function (l) {
                  return l.types.includes(type);
                });
                if (found.length > 0) {
                  return type == 'administrative_area_level_1' ? found[0].short_name : found[0].long_name;
                } else return '';
              };

              var newAddress = {
                country: getFromLoc('country'),
                state: getFromLoc('administrative_area_level_1'),
                postCode: getFromLoc('postal_code'),
                suburb: getFromLoc('locality'),
                streetName: getFromLoc('route'),
                streetNum: getFromLoc('street_number'),
                num: getFromLoc('subpremise')
              };
              newUser.address = newAddress;
              newUser.addresses = [newAddress];
              $scope.importSelected.push(newUser);
              resolve();
            } else {
              errors.push('Line ' + (lineNum + 2) + ': Address not found.');
              resolve();
            }
          });
        } else if (!containsEmptyFields(streetNum, streetName, suburb, state, postCode, country)) {
          var address = { num: unitNum ? '' + unitNum : undefined, streetNum: '' + streetNum, streetName: streetName, suburb: suburb, state: state, postCode: '' + postCode, country: country };
          newUser.address = address;
          newUser.addresses = [address];
          $scope.importSelected.push(newUser);
          resolve();
        } else if ([unitNum, streetNum, streetName, suburb, state, postCode, country].filter(function (x) {
          return x != undefined && x != null && x != '';
        }).length == 0) {
          newUser.address = {};
          newUser.addresses = [];
          $scope.importSelected.push(newUser);
          resolve();
        } else {
          errors.push('Line ' + (lineNum + 2) + ': Either a full address in separate columns or as a single string in the unit number required.');
          resolve();
        }
      });
    });

    $q.all(promises).then(function () {
      if (errors.length > 0) {
        $scope.close();
        swal({
          title: "Errors in file",
          text: errors.join('\n'),
          type: "warning",
          confirmButtonText: "Ok, got it."
        });
      } else {
        $scope.bulkImportContacts($scope.importSelected, function () {
          $scope.contactImport.loading = false;
          $scope.close();
        }, function () {
          $scope.close();
          swal({
            title: "Oops!",
            text: "Error importing contacts",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        });
      }
    });
  };

  $scope.parseContactsForImport_OLD = function (importData) {
    $scope.contactImport.loading = true;
    var contactsList = [];
    $scope.importSelected = [];

    for (var i = 0; i < importData.length; i++) {
      for (var j = 0; j < importData[i].data.length; j++) {
        var newContact = {};
        newContact.displayName = importData[i].data[j][0];
        newContact.contactAddresses = [];
        if (importData[i].data[j][1] != null) {
          newContact.contactAddresses.push({ emailAddress: importData[i].data[j][1], accessLevel: 'viewer' });
        }
        newContact.addresses = [];
        var newAddress = {};
        var requiredFound = 0;
        if (importData[i].data[j][2] != null) {
          newAddress.num = String(importData[i].data[j][2]);
        }
        if (importData[i].data[j][3] != null) {
          newAddress.streetNum = String(importData[i].data[j][3]);
          //requiredFound += 1;
        }
        if (importData[i].data[j][4] != null) {
          newAddress.streetName = importData[i].data[j][4];
          requiredFound += 1;
        }
        if (importData[i].data[j][5] != null) {
          newAddress.suburb = importData[i].data[j][5];
          requiredFound += 1;
        }
        if (importData[i].data[j][6] != null) {
          newAddress.state = importData[i].data[j][6];
          requiredFound += 1;
        }
        if (importData[i].data[j][7] != null) {
          newAddress.postCode = String(importData[i].data[j][7]);
          requiredFound += 1;
        }
        if (importData[i].data[j][8] != null) {
          newAddress.country = importData[i].data[j][8];
          requiredFound += 1;
        }

        if (requiredFound >= 5) {
          newContact.addresses.push(newAddress);
        }

        $scope.importSelected.push(newContact);
      }
    }
    $scope.bulkImportContacts($scope.importSelected, function () {
      $scope.contactImport.loading = false;
      $scope.close();
    });
  };

  $scope.bulkImportContacts = function (importList, cb) {
    addressBookService.bulkImportContacts(importList, function (resp) {
      $scope.mode = 'list';
      $scope.loadAddressBook(true);
      $scope.importList = [];
      cb();
    }, function (err) {
      $scope.alertService.presentAutoAlert('importContacts', err);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "RzJJ":
/***/ (function(module, exports) {

var path = 'views/modals/selectOrgUnitModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectOrgUnitModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Organisation Unit</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeOrgUnitSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <md-table-container ng-show=\"orgUnitList.length > 0\">\n        <table md-table md-row-select ng-model=\"orgUnitSelected\">\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Organisation Unit</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"orgUnit in orgUnitList\" md-select=\"orgUnit\" md-auto-select md-select-id=\"id\">\n              <td md-cell>\n                {{orgUnit.publicName}}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeOrgUnitSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"orgUnitSelected.length <= 0 || orgUnitSelectContinue()\" ng-disabled=\"orgUnitSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "S2WM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SOKq":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/attachmentsTab.html';
var html = "<div my-loader text=\"Loading Attachments\" ng-if=\"(attachmentsLoading || itemEdit.loading) && !docketLoadingError\"></div>\n<div class=\"ojdRow\" ng-if=\"userCanDoAction('addDocketAttachment', itemEdit)\">\n  <div class=\"ojdField text-center\">\n    <div class=\"dbButton lightBlue\" ngf-select=\"uploadNewAttachment($file)\">Add Attachment</div>\n  </div>\n</div>\n<div class=\"customListGroupOuter\" ng-repeat=\"attachment in itemEdit.attachments\" ng-if=\"attachment.fileName != 'supplier-signature' && attachment.fileName != 'customer-signature' && !attachmentsLoading\">\n  <div class=\"customListRowOuter\" id=\"listItem{{attachment.id}}\">\n    <div class=\"customListRow\" hm-swipeLeft=\"splitListFunc.swipeListItem(attachment.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(attachment.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}' ng-click=\"openAttachment(attachment)\">\n      <div class=\"attachmentThumb image\" style=\"background-image: url('{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{attachment.id}}')\" ng-if=\"attachment.mimeType.indexOf('image') != -1 && currentOrg == null\">\n      </div>\n      <div class=\"attachmentThumb image\" style=\"background-image: url('{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{attachment.id}}')\" ng-if=\"attachment.mimeType.indexOf('image') != -1 && currentOrg != null\">\n      </div>\n      <div class=\"attachmentThumb video\" ng-if=\"attachment.mimeType.indexOf('video') != -1\">\n        <md-icon md-svg-src=\"video_black.svg\"></md-icon>\n      </div>\n      <div class=\"attachmentDetails\">\n        Author: {{attachment.authorName}}<br/>\n        Type: {{attachment.mimeType}}\n      </div>\n    </div>\n    <div class=\"mobileListItemUnder\">\n      <div class=\"listItemControls\" id=\"listItemControls{{attachment.id}}\">\n        <div class=\"listItemBtn deleteIcon\" ng-click=\"deleteAttachment(attachment)\" ng-show=\"itemEdit.editing\">\n          <md-icon md-svg-src=\"delete.svg\"></md-icon>\n          <div class=\"btnName\">Delete</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"customListGroupOuter\" ng-repeat=\"attachment in itemEdit.template.attachments\" ng-if=\"attachment.type == 'termsConditions'\">\n  <div class=\"customListRowOuter\">\n    <div class=\"customListRow\" ng-click=\"openTemplateAttachment(attachment)\">\n      <div class=\"attachmentThumb\"></div>\n      <div class=\"attachmentDetails\">\n        Terms & Conditions - {{attachment.fileName}}\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "SOQP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "note_add.svg";

/***/ }),

/***/ "SOep":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/auditLogTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <div class=\"stdLoader\" ng-show=\"orderLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{orderLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"openOrderDesktop(currentOrder)\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Start Map Section -->\n  <div class=\"ojdDesktopSection noPadding noBottomPadding\" style=\"position: relative;\">\n    <md-table-container>\n      <table md-table>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Date</th>\n            <th md-column>Description</th>\n            <th md-column>User</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"event in itemEdit.eventLog\">\n            <td md-cell>\n              <span ng-if=\"event.addedOn && currentOrgGroup.timeFormat == '12HR'\">{{moment(event.addedOn).tz(itemEdit.timezone).format(\"DD/MM/YYYY hh:mm:ss a\")}}</span>\n              <span ng-if=\"event.addedOn && currentOrgGroup.timeFormat == '24HR'\">{{moment(event.addedOn).tz(itemEdit.timezone).format(\"DD/MM/YYYY HH:mm:ss\")}}</span>\n            </td>\n            <td md-cell>\n              {{event.description}}\n            </td>\n            <td md-cell>\n              {{event.userName}}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Sgih":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/resources.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\">\n    <div class=\"left\" style=\"display: flex; flex-direction: row; align-items: center;\">\n      <h3>Resources</h3>\n    </div>\n    <div class=\"right\">\n      <div ng-if=\"selectedIndex == 0\">\n        <md-button class=\"md-icon-button\" ng-click=\"addNewResource()\" aria-label=\"New Resource\">\n          <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"showImportResourcesModal()\" aria-label=\"Import Resources From File\">\n          <md-icon md-svg-icon=\"import.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"loadResourceList()\" aria-label=\"Reload Resources List\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n        <md-menu>\n          <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"deleteSelectedResources()\" aria-label=\"Delete Selected Resources\">\n              <md-button>\n                Delete Selected Resources\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </div>\n      <div ng-if=\"selectedIndex == 1\">\n        <md-button class=\"md-icon-button\" ng-click=\"openNewResourceCategoryModal()\" aria-label=\"New Resource Category\">\n          <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"loadCategoriesList()\" aria-label=\"Reload Categories List\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n        <md-menu>\n          <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"resourceCategoriesSelected.length <= 0\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"deleteSelectedCategories()\" aria-label=\"Delete Selected Categories\">\n              <md-button>\n                Delete Selected Categories\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </div>\n      <div ng-if=\"selectedIndex == 2\">\n        <md-button class=\"md-icon-button\" ng-click=\"openNewUomModal()\" aria-label=\"New Unit of Measure\">\n          <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"loadUomsList()\" aria-label=\"Reload UOM List\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n        <md-menu>\n          <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"uomsSelected.length <= 0\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"deleteSelectedUoms()\" aria-label=\"Delete Selected UOM's\">\n              <md-button>\n                Delete Selected Uoms\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </div>\n      <div ng-if=\"selectedIndex == 3\">\n        <md-button class=\"md-icon-button\" ng-click=\"loadDeletedResourceList()\" aria-label=\"Reload Resources List\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n        <md-menu>\n          <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected_deleted.length <= 0\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"restoreSelectedResources()\" aria-label=\"Restore Selected Resources\">\n              <md-button>\n                Restore Selected Resources\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </div>\n    </div>\n  </div>\n  <div class=\"adminTabularContentContainer\">\n    <md-tabs md-dynamic-height md-selected=\"selectedIndex\" md-border-bottom md-autoselect class=\"docketTabsInner\">\n      <md-tab label=\"Resources\">\n        <div class=\"settingsTableOuterContainer\">\n          <div>\n            <md-table-container class=\"editableTable\">\n              <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n                <thead md-head md-order=\"query.order\" md-on-reorder=\"loadResourceList\">\n                  <tr md-row>\n                    <th md-column></th>\n                    <th md-column md-order-by=\"name\"><span>Name</span></th>\n                    <th md-column md-order-by=\"identifier\"><span>Identifier</span></th>\n                    <th md-column md-order-by=\"category\"><span>Category</span></th>\n                    <th md-column><span>Unit of Measure</span></th>\n                    <th md-column ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\"><span>Xero Item</span></th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row md-select=\"resource\" md-select-id=\"id\" ng-repeat=\"resource in allResources\">\n                    <td md-cell class=\"buttonCell\">\n                      <md-button class=\"md-icon-button\" ng-click=\"editResourceRow(resource)\" aria-label=\"Edit Resource\" ng-if=\"!resource.editing && !resource.loading\">\n                        <md-icon md-svg-icon=\"edit.svg\"></md-icon>\n                      </md-button>\n                      <md-button class=\"md-icon-button\" ng-click=\"saveResourceRow(resource)\" aria-label=\"Save Resource\" ng-if=\"resource.editing && !resource.loading\">\n                        <md-icon md-svg-icon=\"resourcesave.svg\"></md-icon>\n                      </md-button>\n                      <span ng-if=\"resource.loading\">\n                        <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-5\" md-diameter=\"20\"></md-progress-circular>\n                      </span>\n                    </td>\n                    <td md-cell class=\"md-clickable\">\n                      <md-input-container class=\"md-block\" ng-if=\"resource.editing\">\n                        <input ng-model=\"resource.name\" type=\"text\" required ng-disabled=\"!resource.editing || resource.loading\">\n                      </md-input-container>\n                      <span ng-if=\"!resource.editing\">\n                        {{resource.name}}\n                      </span>\n                    </td>\n                    <td md-cell class=\"md-clickable\">\n                      <md-input-container class=\"md-block\" ng-if=\"resource.editing\">\n                        <input ng-model=\"resource.identifier\" type=\"text\" required ng-disabled=\"!resource.editing || resource.loading\">\n                      </md-input-container>\n                      <span ng-if=\"!resource.editing\">\n                        {{resource.identifier}}\n                      </span>\n                    </td>\n                    <td md-cell>\n                      <span ng-if=\"resource.editing\">\n                        <md-input-container class=\"md-block\">\n                          <md-autocomplete required md-input-name=\"autocompleteCategory\"\n                            ng-disabled=\"!resource.editing\" md-no-cache=\"true\"\n                            md-selected-item=\"resource.category\"\n                            md-search-text-change=\"searchCategoryChange(resource, searchTextCategory)\"\n                            md-search-text=\"searchTextCategory\"\n                            md-items=\"item in filteredCategories\" md-item-text=\"item.name\"\n                            md-min-length=\"0\" placeholder=\"Search for a category\"\n                            md-menu-class=\"autocomplete-custom-template\">\n                            <md-item-template>\n                              <span class=\"item-title\">{{item.name}}</span>\n                            </md-item-template>\n                            <md-not-found>\n                              No matches found.\n                            </md-not-found>\n                          </md-autocomplete>\n                        </md-input-container>\n                      </span>\n                      <span ng-if=\"!resource.editing\">\n                        {{resource.category.name}}\n                      </span>\n                    </td>\n                    <td md-cell>\n                      <span ng-if=\"resource.editing\">\n                        <md-input-container class=\"md-block\">\n                          <md-autocomplete required md-input-name=\"autocompleteUom\"\n                            ng-disabled=\"!resource.editing\" md-no-cache=\"true\"\n                            md-selected-item=\"resource.uom\"\n                            md-search-text-change=\"searchUomChange(resource, searchTextUom)\"\n                            md-search-text=\"searchTextUom\"\n                            md-items=\"item in filteredUoms\" md-item-text=\"item.abbreviation + '(' + item.description + ')'\"\n                            md-min-length=\"0\" placeholder=\"Search for a unit of measure\"\n                            md-menu-class=\"autocomplete-custom-template\">\n                            <md-item-template>\n                              <span class=\"item-title\">{{item.abbreviation}} ({{item.description}})</span>\n                            </md-item-template>\n                            <md-not-found>\n                              No matches found.\n                            </md-not-found>\n                          </md-autocomplete>\n                        </md-input-container>\n                      </span>\n                      <span ng-if=\"!resource.editing\">\n                        {{resource.uom.abbreviation}} ({{resource.uom.description}})\n                      </span>\n                    </td>\n                    <td md-cell ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n                      <span ng-if=\"resource.editing\">\n                        <md-input-container class=\"md-block\">\n                          <md-autocomplete required md-input-name=\"autocompleteXeroID\"\n                            ng-disabled=\"!resource.editing\" md-no-cache=\"true\"\n                            md-selected-item=\"resource.xeroID\"\n                            md-search-text-change=\"searchXeroItemChange(resource, searchTextXeroItem)\"\n                            md-search-text=\"searchTextXeroItem\"\n                            md-selected-item-change=\"resourceXeroItemSelected(resource)\"\n                            md-items=\"item in filteredXeroItems\" md-item-text=\"item.name + ' (' + item.userCode + ')'\"\n                            md-min-length=\"0\" placeholder=\"Search for a xero item\"\n                            md-menu-class=\"autocomplete-custom-template\">\n                            <md-item-template>\n                              <span class=\"item-title\">{{item.name}} ({{item.userCode}})</span>\n                            </md-item-template>\n                            <md-not-found>\n                              No matches found.\n                            </md-not-found>\n                          </md-autocomplete>\n                        </md-input-container>\n                      </span>\n                      <span ng-if=\"!resource.editing && resource.xeroID\">\n                        {{resource.xeroID.name}} ({{resource.xeroID.userCode}})\n                      </span>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </md-table-container>\n            <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadResourceList\" md-total=\"{{listCount}}\" md-page-select>\n            </md-table-pagination>\n          </div>\n          \n        </div>\n      </md-tab>\n      <md-tab label=\"Categories\">\n        \n        <div class=\"settingsTableOuterContainer\">\n          <md-table-container>\n            <table md-table md-row-select multiple ng-model=\"resourceCategoriesSelected\" md-progress=\"promise\">\n              <thead md-head md-order=\"resourceCategoriesQuery.order\" md-on-reorder=\"loadCategoriesList\">\n                <tr md-row>\n                  <th md-column md-order-by=\"name\"><span>Name</span></th>\n                  <th md-column md-order-by=\"description\"><span>Description</span></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row md-select=\"category\" md-select-id=\"id\" ng-repeat=\"category in allResourceCategories\" ng-click=\"editResourceCategory(category)\">\n                  <td md-cell>{{category.name}}</td>\n                  <td md-cell>{{category.description}}</td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n          <md-table-pagination md-limit=\"resourceCategoriesQuery.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"resourceCategoriesQuery.page\" md-on-paginate=\"loadCategoriesList\" md-total=\"{{resourceCategoriesListCount}}\" md-page-select>\n          </md-table-pagination>\n        </div>\n      </md-tab>\n      <md-tab label=\"Units of Measure\">\n        <div class=\"settingsTableOuterContainer\">\n          <md-table-container>\n            <table md-table md-row-select multiple ng-model=\"uomsSelected\" md-progress=\"promise\">\n              <thead md-head md-order=\"uomsQuery.order\" md-on-reorder=\"loadUomsList\">\n                <tr md-row>\n                  <th md-column md-order-by=\"abbreviation\"><span>Abbreviation</span></th>\n                  <th md-column md-order-by=\"description\"><span>Description</span></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row md-select=\"uom\" md-select-id=\"id\" ng-repeat=\"uom in allUoms\" ng-click=\"editUom(uom)\">\n                  <td md-cell>{{uom.abbreviation}}</td>\n                  <td md-cell>{{uom.description}}</td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n          <md-table-pagination md-limit=\"uomsQuery.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"uomsQuery.page\" md-on-paginate=\"loadUomsList\" md-total=\"{{uomsListCount}}\" md-page-select>\n          </md-table-pagination>\n        </div>\n      </md-tab>\n\n\n      <md-tab label=\"Deleted Resources\">\n        <div class=\"settingsTableOuterContainer\">\n          <div>\n            <md-table-container class=\"editableTable\">\n              <table md-table md-row-select multiple ng-model=\"selected_deleted\" md-progress=\"promise\">\n                <thead md-head md-order=\"deltedQuery.order\" md-on-reorder=\"loadDeletedResourceList\">\n                  <tr md-row>\n                    <th md-column></th>\n                    <th md-column md-order-by=\"name\"><span>Name</span></th>\n                    <th md-column md-order-by=\"identifier\"><span>Identifier</span></th>\n                    <th md-column md-order-by=\"category\"><span>Category</span></th>\n                    <th md-column><span>Unit of Measure</span></th>\n                    <th md-column ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\"><span>Xero Item</span></th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row md-select=\"resource\" md-select-id=\"id\" ng-repeat=\"resource in allDeletedResources\">\n                    <td md-cell class=\"buttonCell\">\n                      <span ng-if=\"resource.loading\">\n                        <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-5\" md-diameter=\"20\"></md-progress-circular>\n                      </span>\n                    </td>\n                    <td md-cell class=\"md-clickable\">\n                      <span>\n                        {{resource.name}}\n                      </span>\n                    </td>\n                    <td md-cell class=\"md-clickable\">\n                      <span>\n                        {{resource.identifier}}\n                      </span>\n                    </td>\n                    <td md-cell>\n                      <span>\n                        {{resource.category.name}}\n                      </span>\n                    </td>\n                    <td md-cell>\n                      <span>\n                        {{resource.uom.abbreviation}} ({{resource.uom.description}})\n                      </span>\n                    </td>\n                    <td md-cell ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n                      <span ng-if=\"resource.xeroID\">\n                        {{resource.xeroID.name}} ({{resource.xeroID.userCode}})\n                      </span>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </md-table-container>\n            <md-table-pagination md-limit=\"deltedQuery.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"deltedQuery.page\" md-on-paginate=\"loadDeletedResourceList\" md-total=\"{{listCount}}\" md-page-select>\n            </md-table-pagination>\n          </div>\n          \n        </div>\n      </md-tab>\n    </md-tabs>\n  </div>\n</div>\n\n\n<ng-include src=\"'views/modals/editResourceModal.html'\"></ng-include>\n<ng-include src=\"'views/modals/importResourcesModal.html'\" ng-controller=\"importResourcesModalController\"></ng-include>\n\n\n<!-- Resource Category Edit Modal -->\n<div class=\"niceModal desktopSelector\" id=\"newResourceCategoryModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"itemEdit.id == null\">New Resource Category</h1>\n      <h1 ng-show=\"itemEdit.id != null\">Edit Resource Category</h1>\n    </div>\n    <form name=\"newResourceCategoryForm\" novalidate>\n      <div class=\"content\">\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <label>Category Name</label>\n          <input type=\"text\" ng-model=\"itemEdit.name\" required>\n        </md-input-container>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <label>Description</label>\n          <textarea ng-model=\"itemEdit.description\" required></textarea>\n        </md-input-container>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeNewResourceCategoryModal()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"(newResourceCategoryForm.$invalid || itemEdit.loading) || saveNewResourceCategory(itemEdit)\" ng-disabled=\"newResourceCategoryForm.$invalid || itemEdit.loading\">\n              <span ng-hide=\"itemEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"itemEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- End Resource Category Modal -->\n\n<!-- New UOM Modal -->\n<div class=\"niceModal desktopSelector\" id=\"newUomModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"uomEdit.id == null\">New Unit of Measure</h1>\n      <h1 ng-show=\"uomEdit.id != null\">Edit Unit of Measure</h1>\n    </div>\n    <form name=\"newUomForm\" novalidate>\n      <div class=\"content\">\n        <md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"uomEdit.isTime\">\n          <md-checkbox ng-model=\"uomEdit.isTime\">Is Time Based</md-checkbox>\n        </md-input-container>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"uomEdit.isTime\">\n            <label>Abbreviation</label>\n            <md-select ng-model=\"uomEdit.abbreviation\">\n              <md-option ng-repeat=\"type in timeTypes\" ng-value=\"type\">{{type}}</md-option>\n            </md-select>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\" ng-if=\"!uomEdit.isTime\">\n            <label>Abbreviation</label>\n            <input type=\"text\" ng-model=\"uomEdit.abbreviation\" required>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>Description</label>\n            <textarea ng-model=\"uomEdit.description\"></textarea>\n          </md-input-container>\n        </div>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeNewUomModal()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"(newUomForm.$invalid || uomEdit.loading) || saveNewUom(uomEdit)\" ng-disabled=\"newUomForm.$invalid || uomEdit.loading\">\n              <span ng-hide=\"uomEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"uomEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- End New UOM Modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "T39a":
/***/ (function(module, exports) {

var path = 'views/modals/checklistModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector newCompanyModal\" id=\"editChecklistModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1 ng-show=\"checklistEdit.id == null\">New Checklist</h1>\n      <h1 ng-show=\"checklistEdit.id != null\">Edit Checklist</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeEditChecklistModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content\">\n      <h2>What do you want to call your checklist?</h2>\n      <h4>Enter a name and questions below</h4>\n\n      <form name=\"editChecklistForm\" novalidate>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n            <label>Name</label>\n            <input ng-model=\"checklistEdit.name\" required>\n          </md-input-container>\n        </div>\n\n        <h4 class=\"normal\">Questions</h4>\n        <div class=\"selectionFieldItem\" ng-repeat=\"field in checklistEdit.fields\">\n          <div class=\"left\">\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <input ng-model=\"field.displayName\" placeholder=\"Question Text\">\n            </md-input-container>\n          </div>\n          <div class=\"right\">\n            <md-button class=\"md-icon-button\" aria-label=\"Delete Checklist Question\" ng-click=\"removeChecklistField(field, checklistEdit)\">\n              <md-icon md-svg-icon=\"delete.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"selectionFieldItem new\" ng-click=\"addChecklistField(checklistEdit)\"><div class=\"newInner\">Click to add option</div></div>\n\n        <div class=\"footerButtons additionalTopMargin\">\n          <button class=\"dbButton spinner\" ng-click=\"(editChecklistForm.$invalid || checklistEdit.loading) || saveChecklistEdit(checklistEdit)\" ng-disabled=\"editChecklistForm.$invalid || checklistEdit.loading\">\n            <span ng-hide=\"checklistEdit.loading\">Save</span>\n            <md-progress-circular ng-show=\"checklistEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "T7iu":
/***/ (function(module, exports) {

var path = 'views/pages/mobileLists/listsFooter.html';
var html = "<div class=\"mobileFooterBar\">\n  <div class=\"mobileFooterButtons\">\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'dashboard' ? 'selected' : ''}}\" ui-sref=\"main.dashboard\" ng-if=\"currentOrg == null\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"dashboard.svg\"></md-icon>\n        <div>Home</div>\n      </div>\n    </div>\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'orders' ? 'selected' : ''}}\" ui-sref=\"main.orders()\" ng-if=\"currentOrg == null\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"folder.svg\"></md-icon>\n        <div>Orders</div>\n      </div>\n    </div>\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'orders' ? 'selected' : ''}}\" ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg != null && userHasPermission('io.docketbook.ojdapi.getOrder')\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"folder.svg\"></md-icon>\n        <div>Orders</div>\n      </div>\n    </div>\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'jobs' ? 'selected' : ''}}\" ui-sref=\"main.jobs\" ng-if=\"currentOrg == null\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"job.svg\"></md-icon>\n        <div>Jobs</div>\n      </div>\n    </div>\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'jobs' ? 'selected' : ''}}\" ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg != null && userHasPermission('io.docketbook.ojdapi.getJob') || userHasPermission('io.docketbook.ojdapi.getMyJob')\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"job.svg\"></md-icon>\n        <div>Jobs</div>\n      </div>\n    </div>\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'dockets' ? 'selected' : ''}}\" ui-sref=\"main.dockets\" ng-if=\"currentOrg == null\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"description.svg\"></md-icon>\n        <div>Dockets</div>\n      </div>\n    </div>\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'dockets' && listView == 'dockets' ? 'selected' : ''}}\" ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg != null && userHasPermission('io.docketbook.ojdapi.getDocket') || userHasPermission('io.docketbook.ojdapi.getMyDocket')\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"description.svg\"></md-icon>\n        <div>Dockets</div>\n      </div>\n    </div>\n    <div class=\"ftBtnOuter {{currentState.data.mainnavOption == 'dockets' && listView == 'filing' ? 'selected' : ''}}\" ui-sref=\"main.groupFiling({orgId:currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentOrg != null && userHasPermission('io.docketbook.ojdapi.fileDockets')\">\n      <div class=\"ftBtn\">\n        <md-icon md-svg-src=\"lines.svg\"></md-icon>\n        <div>Filing</div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "TA7C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "xero-disconnect-white.svg";

/***/ }),

/***/ "TEBt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-114x114.png";

/***/ }),

/***/ "TXFk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errorSvg = __webpack_require__("lk0G");

angular.module('docketbook').controller('mainTemplateController', function () {
  $scope.errorSvgImagePath = errorSvg;
});

/***/ }),

/***/ "TgE4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "font.svg";

/***/ }),

/***/ "Tqt0":
/***/ (function(module, exports) {

var path = 'views/pages/filing/desktop/index.html';
var html = "<div class=\"desktopContainer\">\n  <!-- Content Heading -->\n  <!-- Main content area - with list/detail split functionality -->\n  <div class=\"desktopSplitListOuter\">\n    <div class=\"desktopSplitListTableOuter\">\n      <ng-include src=\"'views/pages/filing/desktop/filingHeading.html'\"></ng-include>\n      <ng-include src=\"'views/pages/filing/desktop/filingList.html'\" ng-controller=\"filingListController\"></ng-include>\n    </div>\n    <div class=\"desktopSplitListDetailOuter\" ng-controller=\"filingDetailController\">\n      <ng-include src=\"'views/pages/filing/desktop/filingDetail.html'\" class=\"detailItemContainer\" ng-if=\"docketFiling != null\">\n      </ng-include>\n    </div>\n  </div>\n</div>\n\n<!-- Select Contact Modal -->\n<ng-include src=\"'views/modals/selectContactModal.html'\" ng-controller=\"selectContactController\"></ng-include>\n<!-- Select Order Modal -->\n<ng-include src=\"'views/modals/selectOrderModal.html'\" ng-controller=\"selectOrderController\"></ng-include>\n<!-- Select Job Modal -->\n<ng-include src=\"'views/modals/selectJobModal.html'\" ng-controller=\"selectJobController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "U+TM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorSvg = __webpack_require__("lk0G");

angular.module('docketbook').controller('dashboardController', ['userService', 'billingService', 'addressBookService', 'docketService', '$routeParams', 'jobService', 'orderService', '$rootScope', '$scope', '$stateParams', '$state', 'Restangular', '$location', 'accessControl', 'currentUser', 'uuid', '$timeout', function (userService, billingService, addressBookService, docketService, $routeParams, jobService, orderService, $rootScope, $scope, $stateParams, $state, Restangular, $location, accessControl, currentUser, uuid, $timeout) {
  mixpanel.track("Opened Dashboard Desktop");

  $scope.newOrganisation = {};
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.organisations = accessControl.allowedOrganisations();
  $scope.hasSampleCompany = accessControl.hasSampleCompany();
  $scope.userCanDoAction = userService.userCanDoAction;
  $scope.apiPath = "";
  $scope.unverifiedEmail = undefined;
  $scope.unverifiedPhone = undefined;
  //$scope.orgUnitSelected = [];
  $scope.welcomeMessage = "It's looking rather empty in here..";
  $scope.allTimezones = _momentTimezone2.default.tz.names();
  $scope.errorSvgImagePath = errorSvg;
  $scope.onboardingSessions = accessControl.onboardingSessions();
  $scope.allGroups = [];

  if ($scope.currentOrgGroup) {
    mixpanel.track("Opened Org Group Dashboard");
    var groupsCount = 0;
    for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
      if ($scope.currentOrg.groups[i].parent == $scope.currentOrgGroup.id && $scope.currentOrg.groups[i].active) {
        groupsCount += 1;
      }
    }
    if (groupsCount > 0) {
      $scope.hasGroups = true;
    } else {
      $scope.hasGroups = false;
    }

    $scope.allGroups = $scope.currentOrg.groups.filter(function (group) {
      return group.active;
    });

    localStorage.setItem('orgGroup-' + currentUser.id, JSON.stringify({ orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id }));
  } else {
    $scope.hasGroups = false;
  }

  // Check for mobile/desktop mode
  $scope.$on('$viewContentLoaded', function () {
    if ($("#mainTemplateOuter").length > 0) {
      $("body").addClass('dark');
    }
  });

  // CHECK IF THIS USER ONLY HAS 1 COMPANY AND SEND THEM STRAIGHT THERE
  if ($state.current.name == 'main.dashboard') {
    if ($scope.organisations.length == 1) {
      $state.go('main.groupDashboard', { orgId: $scope.organisations[0].id, groupId: 'home' });
    }
  }

  //if the user doesn't have any verified principals, when we should display a banner
  //telling them their account is unverified
  if ($scope.currentUser.unverifiedPrincipals) {
    var unverifiedOverlap = $scope.currentUser.emailAddresses.filter(function (address) {
      return $scope.currentUser.unverifiedPrincipals.indexOf(address) === -1;
    });
    if (unverifiedOverlap.length === 0) {
      //all their principals are waiting validation - show a banner appropiate for the first principal
      //i.e. email principal requires them to check their email inbox
      //phone number requires them to visit the my account area to validate
      var target = $scope.currentUser.unverifiedPrincipals[0];
      if (target.indexOf('users.docketbook.io') !== -1) {
        //its a phone number
        $scope.unverifiedPhone = "0" + target.split('@')[0].substring(3);
      } else {
        $scope.unverifiedEmail = target;
      }
    }
  }

  $scope.goToMyDocketbook = function () {
    $state.go('main.dockets');
  };

  $scope.goToOnbboardingSession = function (session) {
    window.location.href = '/onboarding/' + (session == undefined ? '' : session.id);
  };

  $scope.showWaitToBeInvitedModal = function () {
    $('#waitToBeInvitedModal').fadeIn(100);
  };

  $scope.closeWaitToBeInvitedModal = function () {
    $('#waitToBeInvitedModal').fadeOut(100);
  };

  $scope.goTo = function (view) {
    var currentPath = $location.path();
    if (currentPath == "/" + view) {
      $scope.mobileNav = false;
    }
    $location.path(view);
  };

  $scope.docketCount = 10;
  $scope.orderCount = 20;
  $scope.jobCount = 30;

  $scope.currentNavItem = "page1";

  /*************************/
  /***** Intercom JS API  **/
  /*************************/

  $scope.openIntercom = function () {
    window.FreshworksWidget('open', 'ticketForm');
  };

  $scope.xeroAuth = function () {
    //href="/v1/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/xero/auth"
    window.location = "/v1/organisations/" + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/xero/auth?source=" + btoa(window.location.hash);
  };

  /*****************************************/
  /***** Standard Permission Functions *****/
  /*****************************************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /*****************************/
  /* Create a new organisation */
  /*****************************/

  $scope.newCompany = function (isSampleCompany) {
    if (isSampleCompany) {
      mixpanel.track("Clicked Create New Demo Company");
    } else {
      mixpanel.track("Clicked Create New Company");
    }
    $scope.createNewCompanyFromParent(isSampleCompany, function (newOrg) {
      if (newOrg != null) {
        $state.go('main.groupDashboard', { orgId: newOrg.id });
        if (isSampleCompany) {
          mixpanel.track("Created New Demo Company");
        } else {
          mixpanel.track("Created New Company");
        }
      } else {
        if (isSampleCompany) {
          mixpanel.track("Abandoned Create New Demo Company");
        } else {
          mixpanel.track("Abandoned Create New Company");
        }
        accessControl.refreshAndGetAllowedOrganisations(function (orgs) {
          $scope.organisations = orgs;
        });
      }
    });
  };

  /*** Select PLan ***/
  $scope.expiredSelectPlan = function () {
    $scope.selectPlan(function () {
      billingService.getOrganisationBilling($scope.currentOrg.id, function (billingDetails) {
        $scope.billingDetails = billingDetails;
        if (billingDetails.currentPlanId == null) {
          $scope.currentOrg.trialExpired = true;
        } else {
          $scope.currentOrg.trialExpired = false;
        }
      });
    }, null, 'select plan modal - view - from expired plan');
  };
  if ($scope.currentOrg) {
    $scope.currentOrg.billingIssue = false;
  }
  if ($scope.currentOrg && $scope.currentOrg.accessAllowed == false && $scope.currentOrg.accessReason == 'trialEnded') {
    billingService.getOrganisationBilling($scope.currentOrg.id, function (billingDetails) {
      $scope.billingDetails = billingDetails;
      if (billingDetails.currentPlanId == null) {
        $scope.currentOrg.trialExpired = true;
      } else {
        $scope.currentOrg.trialExpired = false;
      }
    }, function (err) {
      $scope.currentOrg.trialExpired = true;
    });
  } else if ($scope.currentOrg && $scope.currentOrg.accessAllowed == false && $scope.currentOrg.accessReason == 'billingIssue') {
    $scope.currentOrg.billingIssue = true;
  }

  /************************/
  /***** SUMMARY DATA *****/
  /************************/

  $scope.getInteractionSummary = function (dockets) {
    $scope.interactionSummary = {};
    $scope.interactionSummary.loading = true;

    if (dockets.length == 0) {
      $scope.interactionSummary.disabled = true;
    } else {
      $scope.interactionSummary.disabled = false;
    }

    var ids = [];
    for (var i = 0; i < dockets.length; i++) {
      ids.push(dockets[i].id);
    }

    var params = {};
    params.ids = ids.join(',');

    if (dockets && dockets.length > 0) {
      docketService.getDockets(params, function (docketsList) {
        $scope.setupSummaryMap(docketsList);
      }, function (err) {
        $scope.interactionSummary.loading = false;
        $scope.interactionSummary.error = "Error loading interactions";
      });
    } else {
      $scope.interactionSummary.loading = false;;
    }
  };

  $scope.resetSummaryData = function () {
    $scope.ordersSummary = {};
    $scope.ordersSummary.loading = true;
    $scope.ordersSummary.total = 0;
    $scope.ordersSummary.data = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0 };

    $scope.jobsSummary = {};
    $scope.jobsSummary.loading = true;
    $scope.jobsSummary.total = 0;
    $scope.jobsSummary.assigneesTotal = 0;
    $scope.jobsSummary.data = { 'sent': 0, 'accepted': 0, 'rejected': 0, 'pending': 0 };

    $scope.docketsSummary = {};
    $scope.docketsSummary.loading = true;
    $scope.docketsSummary.total = 0;
    $scope.docketsSummary.data = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0 };

    $scope.notificationsSummary = {};
    $scope.notificationsSummary.loading = true;
    $scope.notificationsSummary.notifications = [];

    $scope.interactionSummary = {};
    $scope.interactionSummary.loading = true;
    $scope.getInteractionSummary([]);
  };

  $scope.resetSummaryData();

  $scope.getDocketsSummaryData = function () {
    if (!(accessControl.userHasPermission('io.docketbook.ojdapi.getDocket') || accessControl.userHasPermission('io.docketbook.ojdapi.getMyDocket'))) {
      $scope.docketsSummary.hide = true;
      $scope.docketsSummary.loading = false;
      $scope.docketsSummary.error = "No Access To Dockets";
      return;
    }
    var params = {};
    params.date = (0, _momentTimezone2.default)().format('YYYY-MM-DD');

    docketService.getDockets(params, function (docketsList) {
      var docketsByStatus = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0, 'closed': 0 };
      for (var i = 0; i < docketsList.length; i++) {
        if (docketsByStatus[docketsList[i].status] != null) {
          docketsByStatus[docketsList[i].status] += 1;
        }
      }
      $scope.docketsSummary.total = docketsList.length;
      $scope.docketsSummary.data = docketsByStatus;
      $scope.docketsSummary.loading = false;
      var listToFetch = docketsList;
      if (docketsList.length > 100) {
        listToFetch = listToFetch.slice(0, 99);
      }
      $scope.getInteractionSummary(listToFetch);
    }, function (err) {
      $scope.docketsSummary.loading = false;
      $scope.docketsSummary.error = "Loading Error";
    });
  };

  $scope.getDocketsSummaryData();

  $scope.getJobsSummaryData = function () {
    if (!(accessControl.userHasPermission('io.docketbook.ojdapi.getJob') || accessControl.userHasPermission('io.docketbook.ojdapi.getMyJob'))) {
      $scope.jobsSummary.hide = true;
      $scope.jobsSummary.loading = false;
      $scope.jobsSummary.error = "No Access To Jobs";
      return;
    }
    var params = {};
    params.activeDate = (0, _momentTimezone2.default)().format('YYYY-MM-DD');

    jobService.getJobs(params, function (jobsList) {
      var jobsByStatus = { 'sent': 0, 'accepted': 0, 'rejected': 0, 'assigned': 0, 'completed': 0 };
      for (var i = 0; i < jobsList.length; i++) {
        if (jobsList[i].status == 'sent') {
          jobsByStatus.sent += 1;
        }
        if (jobsList[i].assignees) {
          for (var j = 0; j < jobsList[i].assignees.length; j++) {
            jobsByStatus[jobsList[i].assignees[j].status] += 1;
          }
        }
      }
      jobsByStatus['pending'] = jobsByStatus['assigned'];
      $scope.jobsSummary.total = jobsList.length;
      $scope.jobsSummary.data = jobsByStatus;
      $scope.jobsSummary.assigneesTotal = 0;
      $scope.jobsSummary.loading = false;
    }, function (err) {
      $scope.jobsSummary.loading = false;
      $scope.jobsSummary.error = "Loading Error";
    });
  };

  $scope.getJobsSummaryData();

  $scope.getOrdersSummaryData = function () {
    if (!accessControl.userHasPermission('io.docketbook.ojdapi.getOrder')) {
      $scope.ordersSummary.hide = true;
      $scope.ordersSummary.loading = false;
      $scope.ordersSummary.error = "No Access To Orders";
      return;
    }
    var params = {};
    params.activeDate = (0, _momentTimezone2.default)().format('YYYY-MM-DD');

    orderService.getOrders(params, function (ordersList) {
      var ordersByStatus = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0 };
      for (var i = 0; i < ordersList.length; i++) {
        if (ordersByStatus[ordersList[i].status] != null) {
          ordersByStatus[ordersList[i].status] += 1;
        }
      }
      $scope.ordersSummary.total = ordersList.length;
      $scope.ordersSummary.data = ordersByStatus;
      $scope.ordersSummary.loading = false;
    }, function (err) {
      $scope.ordersSummary.loading = false;
      $scope.ordersSummary.error = "Loading Error";
    });
  };

  $scope.getOrdersSummaryData();

  $scope.setupSummaryMap = function (dockets) {
    var interactionMarkers = [];
    var centerPos = {};
    var bounds = new google.maps.LatLngBounds();
    var mapDiv = "#fullInteractionMap";
    // Show Interactions Map
    var options = {
      disableDefaultUI: false
    };
    var map = new google.maps.Map($(mapDiv).get(0), options);
    var places = new google.maps.places.PlacesService(map);

    var infowindow = new google.maps.InfoWindow({
      content: "holding.."
    });

    for (var k = 0; k < dockets.length; k++) {
      var docket = dockets[k];
      if (docket.resources) {
        var lastInteraction = null;
        for (var i = 0; i < docket.resources.length; i++) {
          for (var j = 0; j < docket.resources[i].interactions.length; j++) {
            var thisInteraction = docket.resources[i].interactions[j];
            if (thisInteraction.lat && thisInteraction.long && thisInteraction.createdAt) {
              if (lastInteraction == null) {
                lastInteraction = thisInteraction;
              } else if ((0, _momentTimezone2.default)(thisInteraction.createdAt).isAfter((0, _momentTimezone2.default)(lastInteraction.createdAt))) {
                lastInteraction = thisInteraction;
              }
            }
          }
        }

        if (lastInteraction != null && lastInteraction.lat && lastInteraction.long) {
          centerPos = { lat: lastInteraction.lat, lng: lastInteraction.long };
          var htmlString = "";
          if (docket.customerContact) {
            htmlString += '<p>Customer: ' + docket.customerContact.displayName + '</p>';
          }
          htmlString += '<p>Operator: ' + docket.authorName + '</p>';
          if (lastInteraction.resource) {
            htmlString += '<p>Resource: ' + lastInteraction.resource.name + '</p><p>Line Type: ' + lastInteraction.interactionName + '<p>Quantity: ' + lastInteraction.quantity + ' ' + lastInteraction.resource.uom.abbreviation + '</p>';
          }
          htmlString += '<p>' + (0, _momentTimezone2.default)(lastInteraction.createdAt).tz(docket.timezone).format('DD/MM/YY hh:mm a') + '</p>';
          var newMapMarker = new google.maps.Marker({
            position: centerPos,
            title: 'Line Created Here',
            animation: google.maps.Animation.DROP,
            label: 'L',
            html: htmlString
          });
          google.maps.event.addListener(newMapMarker, 'click', function () {
            infowindow.setContent(this.html);
            infowindow.open(map, this);
          });
          var loc = new google.maps.LatLng(centerPos.lat, centerPos.lng);
          bounds.extend(loc);
          interactionMarkers.push(newMapMarker);
        }
      }
    }

    map.fitBounds(bounds);
    map.panToBounds(bounds);
    for (var i = 0; i < interactionMarkers.length; i++) {
      interactionMarkers[i].setMap(map);
    }
    $scope.interactionSummary.loading = false;
  };

  /***************************/
  /****** NOTIFICATIONS ******/
  /***************************/

  $scope.getOrgNotifications = function () {
    var notifications = [];

    /**** Contact Share Messages ****/
    addressBookService.getContactShares(null, function (contactSharesList) {
      $scope.injectContactShareNotifications(contactSharesList, notifications, function () {
        $scope.notificationsSummary.loading = false;
        $scope.notificationsSummary.notifications = notifications;
      });
    });
  };

  $scope.deleteSession = function (event, session) {
    event.stopPropagation();
    accessControl.deleteSession(session, function () {
      $scope.onboardingSessions = _.without($scope.onboardingSessions, session);
    });
  };

  /***** New Group Modal ******/
  $scope.newOrgGroup = function () {
    $state.go('companySettings.groups', { orgId: $scope.currentOrg.id });

    /*mixpanel.track("Clicked Create New Org Group");
    $("#newGroupModal").fadeIn(100);
    $scope.newGroup = {};
    $scope.newGroup.timezone = $scope.currentOrgGroup.timezone;
    $scope.createNewGroupFromParent($scope.currentOrgGroup, function(newGroupCreated) {
      if ( newGroupCreated != null ) {
        mixpanel.track("Created New Org Group");
        accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
          $scope.allOrganisations = orgsList;
          $state.go('main.groupDashboard', {orgId: $scope.currentOrg.id, groupId: newGroupCreated.id});
        });
      } else {
        mixpanel.track("Abandoned New Org Group");
      }
    });*/
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "U586":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "report.svg";

/***/ }),

/***/ "UKje":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

angular.module('docketbook').controller('companySettingsBillingController', ['userService', 'billingService', '$scope', 'Restangular', '$q', '$state', '$window', '$stateParams', 'accessControl', function (userService, billingService, $scope, Restangular, $q, $state, $window, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-Billing Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.mode = 'list';

  $scope.selected = [];

  $scope.billingDetails = billingService.billingDetails;
  billingService.getBillingDetails(function (details) {
    $scope.billingDetails = details;
  });

  $scope.cancellationReason = '';

  $scope.capitaliseBillingCycle = function (cycle) {
    var convert = function convert(_ref) {
      var _ref2 = _toArray(_ref),
          first = _ref2[0],
          rest = _ref2.slice(1);

      return [first.toUpperCase()].concat(_toConsumableArray(rest)).join('');
    };
    return cycle ? convert(cycle) : null;
  };

  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'name'
  };
  $scope.listCount = 0;

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.downloadInvoice = function (invoice) {
    var url = "" + "/" + $scope.urlVersion + "/organisations/" + $scope.currentOrg.id + "/invoices/" + invoice.id;
    window.open(url);
  };

  $scope.selectNewPlan = function () {
    $scope.selectPlan(function () {
      billingService.getBillingDetails();
    }, null, "Selected New Plan For Company");
  };

  $scope.updateCardDetails = function () {
    mixpanel.track("Updated Card Details For Company");
    $scope.selectPlanUpdateCard(function () {
      billingService.getBillingDetails();
    });
  };

  $scope.saveBillingContact = function (billingDetails) {
    billingDetails.contact.loading = true;
    billingService.updateOrganisationBillingContact($scope.currentOrg.id, billingDetails.contact, function (updatedContact) {
      billingDetails.contact.loading = false;
    }, function (err) {
      billingDetails.contact.loading = false;
      $scope.alertService.presentAlert('error', 'Oops.', 'Something went wrong when we tried to update your billing contact details. Please try again.');
    });
  };

  /*$scope.updateCreditCard = function() {
    window.Stripe.createToken({
      number: $scope.cardUpdate.creditCardNumber,
      cvc: $scope.cardUpdate.cvc,
      exp_month: $scope.cardUpdate.expiry_month,
      exp_year: $scope.cardUpdate.expiry_year,
      address_zip: $scope.cardUpdate.zip
    }, function(result, responseObj) {
      if (!responseObj.error) {
        var billingObj = {token : responseObj.id};
        billingService.updateOrganisationBilling($scope.currentOrg.id, billingObj, function() {
          $scope.getBillingDetails();
          $scope.cardUpdate = {};
          $scope.alertService.presentAlert('success','Cool!','Card details updated!');
        }, function(err) {
          $scope.alertService.presentAlert('error', 'Bugger :/', 'Updating card details failed.');
        });
      } else {
        $scope.alertService.presentAlert('error','Bugger :/', 'Getting stripe card token failed!');
      }
    });
  }
   $scope.updatePlan = function() {
    var billingObj = { plan: $scope.planUpdate.plan };
    billingService.updateOrganisationBilling($scope.currentOrg.id, billingObj, function() {
      $scope.getBillingDetails();
      $scope.planUpdate = {};
      $scope.alertService.presentAlert('success','Cool!','Plan details updated!');
    }, function(err) {
      $scope.alertService.presentAlert('error','Bugger :/', 'Updating plan details failed!');
    });
  }*/
}]);

/***/ }),

/***/ "UOAC":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/lineItemsTab.html';
var html = "<div class=\"customListRowOuter\" ng-show=\"userCanDoAction('addLineItem', itemEdit)\" ng-click=\"newLineItem()\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem createNew\">\n      <div class=\"dbButton lightBlue\">Add Item</div>\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-repeat=\"lineItem in itemEdit.lineItems\" id=\"listItem{{lineItem.id ? lineItem.id : lineItem.tempId}}\" ng-show=\"!lineItem.delete\">\n  <div class=\"customListRow\" hm-swipeLeft=\"splitListFunc.swipeListItem(lineItem.id ? lineItem.id : lineItem.tempId)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(lineItem.id ? lineItem.id : lineItem.tempId)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}' ng-click=\"editLineItem(lineItem)\">\n    <div class=\"listRowItem status quantity\"><div class=\"quantityDisplay\">\n      <span ng-show=\"lineItem.resource.uom.isTime\">{{formatTimeQuantity(lineItem.quantity, lineItem.resource.uom.abbreviation)}}</span>\n      <span ng-show=\"!lineItem.resource.uom.isTime\">{{lineItem.quantity}} {{lineItem.resource.uom.abbreviation}}</span>\n    </div></div>\n    <div class=\"listRowItem itemNumber\">{{lineItem.resource.name}}</div>\n    <div class=\"listRowItem collapsedDetail showCollapsed\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">{{lineItem.itemDescription}}</div>\n        <div class=\"right\">{{lineItem.resource.identifier}}</div>\n      </div>\n    </div>\n  </div>\n  <div class=\"mobileListItemUnder\">\n      <div class=\"listItemControls\" id=\"listItemControls{{lineItem.id ? lineItem.id : lineItem.tempId}}\">\n        <div class=\"listItemBtn deleteIcon\" ng-click=\"removeLineItem(lineItem)\" ng-show=\"userCanDoAction('removeLineItem', itemEdit) || (userCanDoAction('editLineItem', itemEdit) && lineItem.id == null)\">\n          <md-icon md-svg-src=\"delete.svg\"></md-icon>\n          <div class=\"btnName\">Remove</div>\n        </div>\n      </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Udxa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "credit-card.svg";

/***/ }),

/***/ "UfB5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "android-icon-192x192.png";

/***/ }),

/***/ "UnmW":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/desktop/docketsTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <div class=\"stdLoader\" ng-show=\"jobLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{jobLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"openJobDesktop(currentJob)\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Dockets ({{itemEdit.dockets.length >= 10 ? 'Latest 10' : itemEdit.dockets.length}})</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button class=\"md-icon-button\" ng-click=\"docketsListForJob(itemEdit)\" aria-label=\"View all jobs for order\">\n          <md-icon md-svg-src=\"lines.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" aria-label=\"Add Docket To Job\" ng-click=\"newDocketForJob(itemEdit)\" ng-if=\"currentOrg && (userCanDoAction('assigneeCreateDocketFromJob', itemEdit) || userCanDoAction('createDocketFromJob', itemEdit))\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <p ng-show=\"itemEdit.dockets == null || itemEdit.dockets.length <= 0\">There are no dockets for this job yet</p>\n\n    <md-table-container ng-show=\"itemEdit.dockets && itemEdit.dockets.length > 0\">\n      <table md-table multiple md-progress=\"docketsPromise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Docket Number</th>\n            <th md-column>Author</th>\n            <th md-column>Date</th>\n            <th md-column>Status</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"docket in itemEdit.dockets\">\n            <td md-cell>\n              <a ui-sref=\"main.docketDetail({docketId:docket.id, jobId: itemEdit.id, jobNumber: itemEdit.jobNumber})\" ng-if=\"currentOrg == null\">{{docket.docketNumber}}</a>\n              <a ui-sref=\"main.groupDocketDetail({docketId:docket.id, jobId: itemEdit.id, jobNumber: itemEdit.jobNumber, orgId: currentOrg.id, groupId: currentOrgGroup.id})\" ng-if=\"currentOrg != null\">{{docket.docketNumber}}</a>\n            </td>\n            <td md-cell>\n              {{docket.authorName}}\n            </td>\n            <td md-cell>\n              {{moment(docket.date).format(\"DD/MM/YYYY\")}}\n            </td>\n            <td md-cell width=\"100px\">\n              <div class=\"statusDisplay {{docket.status}}\">{{docket.status}}</div>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "VFKX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "folder.svg";

/***/ }),

/***/ "VMpT":
/***/ (function(module, exports) {

var path = 'views/selectors/organisationList.html';
var html = "<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div ng-repeat=\"organisation in assignDocket.organisations\">\n          <div class=\"customListRow secondaryList\" ng-repeat=\"group in organisation.groups\" ng-click=\"selectOrganisationContinue(group)\">\n            <div class=\"listRowItem itemNumber\">{{group.name}}</div>\n            <div class=\"listRowItem collapsedDetail\">\n              <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                  <div class=\"inner\">\n                    {{stringifyAddress(group.address)}}\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "VqsW":
/***/ (function(module, exports) {

var path = 'views/modals/importResourceFromFile.html';
var html = "<div ng-show=\"fileStage == 1\" class=\"content\">\n    <form name=\"importResourcesForm\" novalidate>\n        <div class=\"content\">\n            Excel files only (.xls or .xlsx)\n            <br/>\n            <br/>\n            <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n        </div>\n    </form>\n</div>\n\n<div ng-show=\"fileStage == 2\" class=\"content\">\n    <md-table-container>\n        <table md-table md-row-select multiple ng-model=\"importSelected\" md-progress=\"importPromise\">\n            <thead md-head>\n                <tr md-row>\n                    <th md-column><span>Status</span></th>\n                    <th md-column><span>Name</span></th>\n                    <th md-column><span>Identifier</span></th>\n                    <th md-column><span>Category</span></th>\n                    <th md-column><span>Unit of Measure</span></th>\n                </tr>\n            </thead>\n            <tbody md-body>\n                <tr md-row md-select=\"resource\" md-select-id=\"id\" ng-repeat=\"resource in importList\">\n                    <td md-cell>\n                        <div class=\"statusDisplay {{resource.status == 'New' ? 'Completed' : 'Requested'}}\">{{resource.status}}</div>\n                    </td>\n                    <td md-cell>\n                        <md-input-container>\n                        <input ng-model=\"resource.name\" type=\"text\" required ng-change=\"validateFileCodeItem(fileCode)\">\n                        </md-input-container>\n                    </td>\n                    <td md-cell>\n                        <md-input-container>\n                        <input ng-model=\"resource.identifier\" type=\"text\" required ng-change=\"validateResourceItem(resource)\">\n                        </md-input-container>\n                    </td>\n                    <td md-cell>\n                        <ng-form name=\"categoryForm\">\n                            <md-autocomplete required md-input-name=\"autocompleteCategory\"\n                                ng-disabled=\"false\" md-no-cache=\"true\"\n                                md-selected-item=\"resource.category\"\n                                md-search-text-change=\"searchCategoryChange(resource, searchTextCategory)\"\n                                md-search-text=\"searchTextCategory\"\n                                md-selected-item-change=\"validateResourceItem(resource)\"\n                                md-items=\"category in allResourceCategories\" md-item-text=\"category.name\"\n                                md-min-length=\"0\" placeholder=\"Search for a resource category\"\n                                md-menu-class=\"autocomplete-custom-template\">\n                                <md-item-template>\n                                    <span class=\"item-title\">{{category.name}}</span>\n                                </md-item-template>\n                                <md-not-found>\n                                    No matches found.\n                                </md-not-found>\n                            </md-autocomplete>\n                            <div ng-show=\"categoryForm.autocompleteCategory.$error.required || !resource.category || !resource.category.id\" class=\"errorMessage\">\n                                Please select a valid category\n                            </div>\n                        </ng-form>\n                    </td>\n                    <td md-cell>\n                        <ng-form name=\"uomForm\">\n                            <md-autocomplete required md-input-name=\"autocompleteUom\"\n                                ng-disabled=\"false\" md-no-cache=\"true\"\n                                md-selected-item=\"resource.uom\"\n                                md-search-text-change=\"searchUomChange(resource, searchTextUom)\"\n                                md-search-text=\"searchTextUom\"\n                                md-selected-item-change=\"validateResourceItem(resource)\"\n                                md-items=\"uom in allUoms\" md-item-text=\"uom.abbreviation\"\n                                md-min-length=\"0\" placeholder=\"Search for a unit of measure\"\n                                md-menu-class=\"autocomplete-custom-template\">\n                                <md-item-template>\n                                    <span class=\"item-title\">{{uom.abbreviation}} - {{uom.description}}</span>\n                                </md-item-template>\n                                <md-not-found>\n                                    No matches found.\n                                </md-not-found>\n                            </md-autocomplete>\n                            <div ng-show=\"uomForm.autocompleteUom.$error.required || !resource.uom || !resource.uom.id\" class=\"errorMessage\">\n                                Please select a valid UOM\n                            </div>\n                        </ng-form>\n                    </td>\n                    <td md-cell>\n                        <md-button class=\"md-icon-button\" ng-click=\"removeResourceFromImport(resource, importList)\" aria-label=\"Remove Resource From Import List\">\n                            <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                        </md-button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </md-table-container>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Vr5B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W/ff":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectOrderLineController', ['$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', function ($rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout) {

  // Initialise variables to be used
  $scope.lineSearch = "";
  $scope.lineItemList = [];
  $scope.lineItemListFull = [];
  $scope.lineSelectCallback = null;
  $scope.desktopSelected = [];

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.orderLineSelectFromParent = function (list, cb) {
    $scope.lineSearch = "";
    $scope.lineItemListFull = list;
    $scope.lineItemList = list;
    $scope.lineSelectCallback = cb;
    $scope.desktopSelected = [];

    $("#selectOrderLineModal").fadeIn(100);
  };

  $scope.$parent.orderLineSelectFromParentAdvanced = function (list, unavailableLine, cb) {
    $scope.lineSearch = "";
    $scope.lineItemListFull = list;
    $scope.lineItemList = list;
    $scope.lineSelectCallback = cb;
    $scope.desktopSelected = [];

    $scope.isOrderLineReassignment = true;

    if (unavailableLine) {
      $scope.lineUnavailable = unavailableLine;
      for (var i = 0; i < $scope.lineItemList.length; i++) {
        if ($scope.lineItemList[i].id == unavailableLine.id) {
          $scope.lineItemList[i].disabled = true;
        }
      }
    }

    $("#selectOrderLineModal").fadeIn(100);
  };

  $scope.selectOrderLineContinue = function () {
    $scope.lineSelectCallback($scope.desktopSelected[0]);
    $("#selectOrderLineModal").fadeOut(100);
  };

  $scope.closeOrderLineSelect = function () {
    $("#selectOrderLineModal").fadeOut(100);
    $scope.lineSelectCallback(null);
  };

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.updateLineSearch = function (searchValue) {
    if (searchValue === "") {
      $scope.lineItemList = $scope.lineItemListFull;
      return;
    }

    // update lineItemList with filtered results
    var filteredList = [];
    for (var i = 0; i < $scope.lineItemListFull.length; i++) {
      if ($scope.lineItemListFull[i].resource.name.indexOf(searchValue) != -1) {
        filteredList.push($scope.lineItemListFull[i]);
      }
    }

    $scope.lineItemList = filteredList;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "Wa4Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wavj":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/lineItemsTab.html';
var html = "<div class=\"customListRowOuter\" ng-show=\"!userCanDoAction('addLineItemToJob', itemEdit) && itemEdit.lineItems.length <= 0\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem message\">No line items have been added to this job</div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-show=\"getLineItemsRemainingCount(itemEdit) > 0 && userCanDoAction('addLineItemToJob', itemEdit)\" ng-click=\"selectLineItem()\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem createNew\"><div class=\"dbButton lightBlue\">Add Item</div></div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-show=\"itemEdit.orderRef != null && getLineItemsRemainingCount(itemEdit) <= 0 && userCanDoAction('addLineItemToJob', itemEdit)\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem message\">\n      All lines items for the order have been added to this job.\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-show=\"itemEdit.orderRef == null\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem message\">\n      Select an order before adding items to the job.\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-repeat=\"lineItem in itemEdit.lineItems\" id=\"listItem{{lineItem.id}}\" ng-if=\"!lineItem.delete\">\n  <div class=\"customListRow\" hm-swipeLeft=\"splitListFunc.swipeListItem(lineItem.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(lineItem.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}' ng-click=\"!userHasPermission('io.docketbook.ojdapi.updateJob') || editLineItem(lineItem)\">\n    <div class=\"listRowItem status quantity\"><div class=\"quantityDisplay\">\n      <span ng-show=\"lineItem.resource.uom.isTime\">{{formatTimeQuantity(lineItem.quantity, lineItem.resource.uom.abbreviation)}}</span>\n      <span ng-show=\"!lineItem.resource.uom.isTime\">{{lineItem.quantity}} {{lineItem.resource.uom.abbreviation}}</span>\n    </div></div>\n    <div class=\"listRowItem itemNumber\">{{lineItem.resource.name}}</div>\n    <div class=\"listRowItem collapsedDetail showCollapsed fluidHeight\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">{{lineItem.itemDescription}}</div>\n        <div class=\"right\">{{lineItem.resource.identifier}}</div>\n      </div>\n    </div>\n  </div>\n  <div class=\"mobileListItemUnder\">\n      <div class=\"listItemControls\" id=\"listItemControls{{lineItem.id}}\">\n        <div class=\"listItemBtn deleteIcon\" ng-click=\"removeLineItem(lineItem)\" ng-show=\"userCanDoAction('deleteLineItemFromJob', itemEdit)\">\n          <md-icon md-svg-src=\"delete.svg\"></md-icon>\n          <div class=\"btnName\">Remove</div>\n        </div>\n      </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Wc5+":
/***/ (function(module, exports) {

var path = 'views/modals/trialActivatedModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"trialActivatedModal\" ng-style=\"{ display: show ? 'block' : 'none' }\">\n    <div class=\"modalContainer\" style=\"width: 400px; margin-top: 15%;\">\n        <div class=\"header hidden-xs\">\n            <h1 class=\"boldBlueText\">Free Trial Activated</h1>\n            <div class=\"headerCloseButton\" ng-click=\"closeDialog()\">\n                <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n        \n        <div class=\"content\">\n            <div class=\"subHead\">\n                You now have access to all Docketbook features like job allocation and Excel integration for 7 days.\n            </div>\n        </div>\n\n        <div class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n                </div>\n                <div class=\"right\">\n                    <div class=\"newDbButton\" ng-click=\"closeDialog()\">\n                        Close\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Wozb":
/***/ (function(module, exports) {

var path = 'views/modals/signatureCaptureModal.html';
var html = "<div class=\"niceModal\" id=\"signatureCaptureModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Capture Signature</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeSignatureCapture()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeSignatureCapture()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            Capture Signature\n          </div>\n          <div class=\"right text\">\n          </div>\n        </div>\n      </div>\n    </div>\n    <form name=\"signatureCaptureForm\">\n      <div class=\"content noPadding\">\n        <div class=\"itemDetailModalOuter\">\n          <div class=\"itemDetailModalHeader\">\n            <md-input-container class=\"md-block\" ng-show=\"signatureCapture.nameRequired\">\n              <input type=\"text\" ng-model=\"signatureCapture.name\" required aria-label=\"Signature Name\">\n            </md-input-container>\n            <h1 ng-show=\"!signatureCapture.nameRequired\">{{signatureCapture.name}}</h1>\n            <h3 ng-show=\"signatureCapture.nameRequired\">Please enter your name</h3>\n            <h3 ng-show=\"!signatureCapture.nameRequired\">{{signatureCapture.entity}}</h3>\n          </div>\n          <div class=\"itemDetailModalPart normal\" ng-show=\"signatureCapture.termsRequired && signatureCapture.attachments && signatureCapture.attachments.length > 0\">\n            <strong>By signing below you agree to the supplier's Terms & Conditions.</strong>\n          </div>\n          <div class=\"itemDetailModalPart signature\">\n            <div class=\"signatureIconOverlay\">x</div>\n            <div class=\"signatureLineOverlay\"></div>\n            <canvas id=\"signatureCapture\" height=\"120px\"></canvas>\n          </div>\n          <div class=\"itemDetailModalPart button\">\n            <div class=\"dbButton green block readyFalse {{signatureCaptureForm.$invalid ? 'disabled' : ''}}\" ng-click=\"signatureCaptureForm.$invalid || saveSignatureCapture()\" ng-if=\"signatureCapture.termsRequired\">I Agree, Finish</div>\n            <div class=\"dbButton green block {{signatureCaptureForm.$invalid ? 'disabled' : ''}}\" ng-click=\"signatureCaptureForm.$invalid || saveSignatureCapture()\" ng-if=\"!signatureCapture.termsRequired\">Finish</div>\n\n            <div class=\"dbButton block grey topMargin\" ng-click=\"openTermsAttachments(signatureCapture.attachments)\" ng-if=\"signatureCapture.termsRequired && signatureCapture.attachments && signatureCapture.attachments.length > 0 && itemEdit\">\n              Read Terms & Conditions\n            </div>\n            <div class=\"dbButton block grey topMargin\" ng-click=\"openDocketTermsAttachments()\" ng-if=\"signatureCapture.termsRequired && signatureCapture.attachments && signatureCapture.attachments.length > 0 && !itemEdit\">\n              Read Terms & Conditions\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "WqH3":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/index.html';
var html = "<div style=\"display: flex; flex-direction: column; height: 100%;\">\n  <div>\n    <ng-include src=\"'views/filterBars/docketsFilterBar.html'\"></ng-include>\n  </div>\n\n  <div style=\"flex: 1 1 auto;\">\n    <div class=\"desktopContainer\">\n      <!-- Content Heading 'display':'table-row', -->\n      <!-- Main content area - with list/detail split functionality -->\n      <div class=\"desktopSplitListOuter\">\n        <div class=\"desktopSplitListTableOuter\">\n          <div ng-style=\"{'display' : 'table', 'width':'100%','height':'100%'}\">\n            <ng-include src=\"'views/pages/dockets/desktop/docketsHeading.html'\" ng-style=\"{'display':'table-row','width':'100%'}\"></ng-include>\n            <div ng-controller=\"docketListController\" ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\" ng-show=\"listView == 'dockets'\">\n              <div ng-style=\"{'width':'100%','height':'100%','position':'relative'}\">\n                <div ng-style=\"{'display':'block','height':'100%','position':'absolute','top':'0px','left':'0px','width':'100%','z-index':'10','overflow':'auto'}\">\n                  <ng-include src=\"'views/pages/dockets/desktop/docketsList.html'\" ng-if=\"listView == 'dockets'\"></ng-include>\n                </div>\n              </div>\n            </div>\n\n            <div ng-controller=\"filingListController\" ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\" ng-show=\"listView == 'filing'\">\n              <div ng-style=\"{'width':'100%','height':'100%','position':'relative'}\">\n                <div ng-style=\"{'display':'block','height':'100%','overflow':'auto','position':'absolute','top':'0px','left':'0px','width':'100%'}\">\n                  <ng-include src=\"'views/pages/filing/desktop/filingList.html'\" ng-if=\"listView == 'filing'\"></ng-include>\n                </div>\n              </div>\n            </div>\n\n            <div ng-controller=\"batchListController\" ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\" ng-show=\"listView == 'batch'\">\n              <div ng-style=\"{'width':'100%','height':'100%','position':'relative'}\">\n                <div ng-style=\"{'display':'block','height':'100%','overflow':'auto','position':'absolute','top':'0px','left':'0px','width':'100%'}\">\n                  <ng-include src=\"'views/pages/batches/batchList.html'\" ng-if=\"listView == 'batch'\"></ng-include>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"desktopSplitListDetailOuter\" ng-controller=\"docketDetailController\" ng-show=\"detailView == 'dockets'\">\n          <ng-include src=\"'views/pages/dockets/desktop/docketDetail.html'\" class=\"detailItemContainer\" ng-if=\"itemEdit != null\">\n          </ng-include>\n          <!-- Share Docket / Access Control Modal -->\n          <ng-include src=\"'views/modals/shareDocketModal.html'\"></ng-include>\n          <!-- Assign Docket Modal -->\n          <ng-include src=\"'views/modals/assignDocketModal.html'\"></ng-include>\n        </div>\n        <div class=\"desktopSplitListDetailOuter\" ng-controller=\"filingDetailController\" ng-show=\"detailView == 'filing'\">\n          <ng-include src=\"'views/pages/filing/desktop/filingDetail.html'\" class=\"detailItemContainer\" ng-if=\"docketFiling != null\">\n          </ng-include>\n        </div>\n        <div class=\"desktopSplitListDetailOuter\" ng-controller=\"batchDetailController\" ng-show=\"detailView == 'batch' && listView == 'batch'\">\n          <ng-include src=\"'views/pages/batches/batchDetail.html'\" class=\"detailItemContainer\" ng-if=\"docketBatch != null\">\n          </ng-include>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n<!-- Summary Report Modal -->\n<ng-include src=\"'views/modals/docketSummaryReportModal.html'\"></ng-include>\n\n<ng-include src=\"'views/modals/rejectDocketModal.html'\"></ng-include>\n<!-- Summary Report Modal -->\n<ng-include src=\"'views/modals/fileCodeReportModal.html'\"></ng-include>\n<!-- Docket Batch Modal -->\n<ng-include src=\"'views/modals/docketBatch.html'\"></ng-include>\n<!-- Select Resource Modal -->\n<ng-include src=\"'views/modals/selectResourceModal.html'\" ng-controller=\"selectResourceController\"></ng-include>\n<!-- Select Contact Modal -->\n<ng-include src=\"'views/modals/selectContactModal.html'\" ng-controller=\"selectContactController\"></ng-include>\n<!-- Select Template Modal -->\n<ng-include src=\"'views/modals/selectTemplateModal.html'\" ng-controller=\"selectTemplateController\"></ng-include>\n<!-- Select Order Modal -->\n<ng-include src=\"'views/modals/selectOrderModal.html'\" ng-controller=\"selectOrderController\"></ng-include>\n<!-- Select Job Modal -->\n<ng-include src=\"'views/modals/selectJobModal.html'\" ng-controller=\"selectJobController\"></ng-include>\n<!-- Select Xero Contact Modal -->\n<ng-include src=\"'views/modals/selectXeroContactModal.html'\" ng-controller=\"selectXeroContactController\"></ng-include>\n<!--  Xero Connect Modal -->\n<ng-include src=\"'views/modals/xeroConnect.html'\" ng-controller=\"xeroConnectController\"></ng-include>\n<!-- Select Member Modal -->\n<ng-include src=\"'views/modals/selectPersonModal.html'\" ng-controller=\"selectPersonController\"></ng-include>\n\n<!-- Interaction Modals -->\n<span ng-controller=\"interactionModalController\">\n  <ng-include src=\"'views/modals/desktopInteractionModal.html'\"></ng-include>\n</span>\n<!-- End Interaction Modals -->\n<!-- Signature Capture Modal -->\n<span ng-controller=\"signatureModalController\">\n  <ng-include src=\"'views/modals/signatureCaptureModal.html'\"></ng-include>\n</span>\n<!-- End Signature Capture Modal -->\n<!-- Checklist Detail Modal -->\n<span ng-controller=\"checklistModalController\">\n  <ng-include src=\"'views/modals/checklistDetailModal.html'\"></ng-include>\n</span>\n<!-- End Checklist Detail Modal -->\n<!-- Order Line Item Select Modal -->\n<ng-include src=\"'views/modals/selectOrderLine.html'\" ng-controller=\"selectOrderLineController\"></ng-include>\n<!-- End Order Line Item Select Modal -->\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "X+VU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('acceptConnectionRequestModalController', ['addressBookService', 'userService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', 'docketService', function (addressBookService, userService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {

  $scope.orgs = accessControl.allowedOrganisations();
  $scope.data = {
    selectedOrg: null
  };

  $scope.connection = null;
  $scope.cb = null;
  $scope.loading = false;

  $scope.$parent.showAcceptConnectionModal = function (connection, cb) {
    $scope.cb = cb;
    $scope.connection = connection;
    $scope.loading = false;

    $scope.data.selectedOrg = $scope.orgs.length == 1 ? $scope.orgs[0].id : null;

    $('#acceptConnectionRequestModal').fadeIn(100);
  };

  $scope.close = function () {
    $('#acceptConnectionRequestModal').fadeOut(100);
    $scope.loading = false;
  };

  $scope.accept = function () {
    $scope.loading = true;
    userService.getPermissionsForOrg($scope.data.selectedOrg, {}, function (permissions) {
      $scope.connection.invitation.targetId = $scope.data.selectedOrg;
      $scope.connection.invitation.status = 'accept';

      if (!permissions.map(function (p) {
        return p.identifier;
      }).includes('io.docketbook.uoapi.acceptConnection')) {
        swal({
          title: "Error!",
          text: "You do not have permissions to accept the connection, please contact your organisation administrator.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        $scope.loading = false;
        return;
      }

      userService.saveUserInvitation($scope.connection.invitation, function () {
        $scope.close();
        $scope.cb && $scope.cb();
      }, function () {
        $scope.close();
        swal({
          title: "Error!",
          text: "An error occured while accepting the connection.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        $scope.loading = false;
      });
    }, function () {
      swal({
        title: "Error!",
        text: "An error occured while accepting the connection.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      $scope.loading = false;
    });
  };

  $scope.decline = function () {
    swal({
      title: "Are you sure?",
      text: "Do you want to decline this connection request?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        $scope.connection.invitation.status = 'decline';
        userService.saveUserInvitation($scope.connection.invitation, function () {
          $scope.close();
          $scope.cb && $scope.cb();
        }, function () {
          swal({
            title: "Error!",
            text: "An error occured while declining the connection.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        });
      }
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "X0lI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('importResourcesModalController', ['resourceService', 'xeroService', '$scope', 'uuid', 'Upload', function (resourceService, xeroService, $scope, uuid, Upload) {

  $scope.allXeroItems = [];
  $scope.filteredXeroItems = [];
  $scope.selectedItems = [];
  $scope.xeroSyncLoading = false;
  $scope.xeroSearchValue = '';
  $scope.stage = 1;
  $scope.prefillCategory = null;
  $scope.prefillUom = null;
  $scope.selectedTabIndex = 0;
  $scope.prefilled = {};
  $scope.resourceImport = { loading: false };
  $scope.file = null;

  // File import
  $scope.fileStage = 1;
  $scope.importSelected = [];

  $scope.xeroQuery = {
    limit: 100,
    page: 1,
    offset: 0
  };

  $scope.$parent.showImportResourcesModal = function () {
    $scope.stage = 1;
    $scope.selectedItems = [];
    $scope.xeroSearchValue = '';
    $scope.prefilled = {};
    $scope.selectedTabIndex = 0;
    $scope.fileStage = 1;
    $scope.resourceImport = { loading: false };
    $scope.file = null;
    $('#importResourcesModal').fadeIn(100);
  };

  $scope.back = function () {
    $scope.stage--;
  };

  $scope.goToStage2 = function () {
    $scope.stage = 2;
  };

  $scope.goToStage3 = function (skip) {
    if (skip) {
      $scope.selectedItems.forEach(function (item) {
        item.category = null;
        item.uom = null;
      });
    } else {
      if ($scope.prefilled.category) {
        $scope.selectedItems.forEach(function (item) {
          item.category = $scope.prefilled.category;
        });
      }

      if ($scope.prefilled.uom) {
        $scope.selectedItems.forEach(function (item) {
          item.uom = $scope.prefilled.uom;
        });
      }
    }
    $scope.stage = 3;
  };

  $scope.reSyncXeroResources = function () {
    $scope.xeroSyncLoading = true;
    xeroService.xeroItemSync(function (taskInfo) {
      if (taskInfo.status == 'Failed') {
        $scope.alertService.presentAlert('error', "We couldn't sync your Xero Items", "Something went wrong when we tried to sync your Xero Items. Please try again or contact support if this error persists.");
        $scope.xeroContactSyncLoading = false;
      } else {
        xeroService.getXeroItems($scope.xeroQuery, function (items) {
          $scope.allXeroItems = items.map(function (item) {
            var retVal = Object.assign(item, { identifier: item.userCode, xeroId: item.id });
            delete retVal.time;
            delete retVal.type;
            delete retVal.userCode;
            return retVal;
          });
          $scope.searchXeroChange($scope.xeroSearchValue);
          $scope.xeroSyncLoading = false;
        });
      }
    });
  };

  $scope.close = function () {
    $('#importResourcesModal').fadeOut(100);
  };

  $scope.getXeroItems = function () {
    $scope.xeroQuery.offset = $scope.xeroQuery.limit * ($scope.xeroQuery.page - 1);

    xeroService.getXeroItems($scope.xeroQuery, function (items) {
      $scope.allXeroItems = items.map(function (item) {
        var retVal = Object.assign(item, { identifier: item.userCode, xeroId: item.id });
        delete retVal.time;
        delete retVal.type;
        delete retVal.userCode;
        return retVal;
      });
      $scope.filteredXeroItems = angular.copy(items);

      if ($scope.xeroQuery.offset <= 0 && items.length < $scope.xeroQuery.limit) {
        $scope.xeroListCount = items.length;
      } else {
        $scope.xeroListCount = $scope.xeroQuery.offset + ($scope.xeroQuery.limit + 1);
      }
    });
  };

  $scope.getXeroItems();

  $scope.import = function () {
    var resourcesToAdd = $scope.selectedItems.slice();

    var saveOneResource = function saveOneResource() {
      if (resourcesToAdd.length == 0) {
        $('#importResourcesModal').fadeOut(100);
        $scope.$parent.loadResourceList();
        return;
      }

      var resource = Object.assign({}, resourcesToAdd.pop());
      delete resource.id;
      resource.uom = resource.uom.id;
      resource.category = resource.category.id;
      resource.externalIdentifiers = [{ type: 'xero', externalId: resource.externalId }];

      resourceService.saveResource(resource, saveOneResource, function (err) {
        console.error('could not save resource', err);
        saveOneResource();
      });
    };

    saveOneResource();
  };

  $scope.getTableStyle = function () {
    if ($scope.xeroSyncLoading) {
      return { opacity: 0.5 };
    } else {
      return {};
    }
  };

  $scope.formValid = function () {
    return $scope.selectedItems.filter(function (item) {
      return item.name == null || item.name == "" || item.identifier == null || item.identifier == "" || item.category == null || item.uom == null;
    }).length == 0;
  };

  $scope.fileFormValid = function () {
    return $scope.importSelected.filter(function (item) {
      return item.name == null || item.name == "" || item.identifier == null || item.identifier == "" || item.category == null || item.uom == null || item.error;
    }).length == 0;
  };

  $scope.searchXeroChange = function (searchValue) {
    if (searchValue == "") {
      $scope.filteredXeroItems = $scope.allXeroItems;
      return;
    }
    $scope.filteredXeroItems = $scope.allXeroItems.filter(function (resource) {
      return _stringSimilarity2.default.compareTwoStrings(resource.name, searchValue) > 0.3 || resource.name.toLowerCase().indexOf(searchValue.toLowerCase()) != -1;
    });
  };

  $scope.searchUomChange = function (searchText) {
    if (searchText == null || searchText == "") {
      $scope.filteredUoms = angular.copy($scope.allUoms);
    } else {
      $scope.filteredUoms = [];
      for (var i = 0; i < $scope.allUoms.length; i++) {
        if ($scope.allUoms[i].abbreviation.toLowerCase().indexOf(searchText.toLowerCase()) != -1 || $scope.allUoms[i].description.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          $scope.filteredUoms.push($scope.allUoms[i]);
        }
      }
    }
  };

  $scope.searchCategoryChange = function (searchText) {
    if (searchText == null || searchText == "") {
      $scope.filteredCategories = angular.copy($scope.allResourceCategories);
    } else {
      $scope.filteredCategories = [];
      for (var i = 0; i < $scope.allResourceCategories.length; i++) {
        if ($scope.allResourceCategories[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          $scope.filteredCategories.push($scope.allResourceCategories[i]);
        }
      }
    }
  };

  // Fom File

  var mapping = {
    'resource category': 'category',
    'resource id': 'id',
    'resource name': 'name',
    'unit of measure': 'uom'
  };

  var reverseMapping = {};

  Object.keys(mapping).forEach(function (key) {
    reverseMapping[mapping[key]] = key;
  });

  var readTableHeaders = function readTableHeaders(fileData) {
    var headers = fileData.shift().map(function (header) {
      return header.toLowerCase();
    }).map(function (header) {
      var found = null;
      Object.keys(mapping).forEach(function (key) {
        if (header.includes(key)) {
          found = mapping[key];
          return;
        }
      });
      return found;
    }).filter(function (x) {
      return x !== null;
    });

    var headerMissing = function headerMissing(str) {
      return !headers.includes(str);
    };

    var missing = ['category', 'name', 'uom'].filter(headerMissing).map(function (header) {
      return reverseMapping[header];
    });

    if (missing.length > 0) {
      swal({
        title: "Oops!",
        text: 'The following columns are missing from the file: ' + missing.join(', '),
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return null;
    }

    return fileData.map(function (data) {
      var item = {};
      headers.forEach(function (header, i) {
        item[header] = data[i];
      });
      return item;
    });
  };

  $scope.importFromFile = function (fileToImport) {
    $scope.resourceImport.loading = true;

    Upload.upload({
      url: '/v1/parse',
      data: { file: fileToImport },
      withCredentials: true
    }).then(function (resp) {
      var data = readTableHeaders(resp.data[0].data);
      if (data == null) {
        $scope.resourceImport.loading = false;
        return;
      }

      $scope.parseResourcesForImport(data);
    }, function (resp) {
      $scope.resourceImport.loading = false;
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  };

  $scope.parseResourcesForImport = function (data) {
    var resourcesList = [];
    $scope.importSelected = [];

    var existingIds = [];

    data.filter(function (line) {
      return line.name;
    }).forEach(function (line) {
      var category = $scope.findCategory(line.category);
      var uom = $scope.findUom(line.uom);

      var identifier = line.id;
      if (identifier == null) {
        var generatedId = line.name.substring(0, 3).toUpperCase();
        if (existingIds.includes(generatedId)) {
          var generatedNum = 1;
          generatedId += '1';

          while (existingIds.includes(generatedId)) {
            generatedNum++;
            generatedId = generatedId.substring(0, 3) + generatedNum;
          }
        }
        identifier = generatedId;
      }

      var newResource = {
        importId: uuid.v4(),
        name: line.name,
        identifier: String(identifier),
        category: category,
        uom: uom,
        status: 'New'
      };
      $scope.importSelected.push(newResource);
      resourcesList.push(newResource);
    });

    $scope.importList = resourcesList;
    $scope.importList.forEach($scope.validateResourceItem);

    $scope.fileStage = 2;
    $scope.resourceImport.loading = false;
  };

  $scope.parseResourcesForImport_OLD = function (importData) {
    var resourcesList = [];
    $scope.importSelected = [];

    for (var i = 0; i < importData.length; i++) {
      for (var j = 0; j < importData[i].data.length; j++) {
        var newResource = {};
        newResource.name = String(importData[i].data[j][0]);
        newResource.identifier = String(importData[i].data[j][1]);
        newResource.category = String(importData[i].data[j][2]);
        newResource.uom = String(importData[i].data[j][3]);
        if (importData[i].data[j].length >= 5) {
          newResource.uuid = importData[i].data[j][4];
        }

        // See if resource exists by uuid
        if (newResource.uuid != '' && newResource.uuid != null) {
          // check if resource actually exists
          var matchedResource = $scope.findExistingResource(newResource.uuid);
          if (matchedResource) {
            newResource.resource = matchedResource;
            newResource.status = 'Update';
          } else {
            newResource.status = 'New';
          }
        } else {
          newResource.status = 'New';
        }

        // Try and match category from list
        var matchedCategory = $scope.findCategory(newResource.category);
        if (matchedCategory) {
          newResource.category = matchedCategory;
        }

        // Try and match uom from list
        var matchedUom = $scope.findUom(newResource.uom);
        if (matchedUom) {
          newResource.uom = matchedUom;
        }

        newResource.importId = uuid.v4();
        $scope.importSelected.push(newResource);
        resourcesList.push(newResource);
      }
    }
    $scope.importList = resourcesList;
    //$scope.importList.forEach($scope.validateResourceItem)
    $scope.validateAllResourceItems();

    $scope.fileStage = 2;
    $scope.resourceImport.loading = false;
  };

  $scope.findExistingResource = function (resourceUUID) {
    if (resourceUUID == null || resourceUUID == '') {
      return null;
    }

    for (var i = 0; i < $scope.allResources.length; i++) {
      if ($scope.allResources[i].id == resourceUUID) {
        return $scope.allResources[i];
      }
    }

    return null;
  };

  var searchCategoryBy = function searchCategoryBy(searchTerm, categoryProp) {
    var closeMatches = $scope.allResourceCategories.map(function (category) {
      return { category: category, similarity: _stringSimilarity2.default.compareTwoStrings(searchTerm, category[categoryProp]) };
    }).filter(function (x) {
      return x.similarity > 0.7;
    });

    if (closeMatches.length > 0) {
      return _.max(closeMatches, function (x) {
        return x.similarity;
      }).category;
    } else {
      return null;
    }
  };

  $scope.findCategory = function (searchTerm) {
    if (searchTerm == '' || searchTerm == null) {
      return null;
    }

    var searchByName = searchCategoryBy(searchTerm, 'name');
    return searchByName ? searchByName : searchCategoryBy(searchTerm, 'description');
  };

  var findUomBy = function findUomBy(searchTerm, uomProp) {
    var closeMatches = $scope.allUoms.map(function (uom) {
      return { uom: uom, similarity: _stringSimilarity2.default.compareTwoStrings(searchTerm, uom[uomProp]) };
    }).filter(function (x) {
      return x.similarity > 0.7;
    });

    if (closeMatches.length > 0) {
      return _.max(closeMatches, function (x) {
        return x.similarity;
      }).uom;
    } else {
      return null;
    }
  };

  $scope.findUom = function (searchTerm) {
    if (searchTerm == '' || searchTerm == null) {
      return null;
    }

    var byAbbrev = findUomBy(searchTerm, 'abbreviation');
    return byAbbrev ? byAbbrev : findUomBy(searchTerm, 'description');
  };

  $scope.validateImportResources = function (importList) {
    var errorCount = 0;
    for (var i = 0; i < importList.length; i++) {
      var thisItemError = $scope.validateResourceItem(importList[i]);
      if (thisItemError == true) {
        errorCount += 1;
      }
    }

    if (errorCount > 0) {
      return false;
    } else {
      return true;
    }
  };

  $scope.bulkImportResources = function () {
    // get selected
    var importList = $scope.importSelected;
    $scope.resourceImport.loading = true;

    if ($scope.validateImportResources(importList) != true) {
      // validation failed
      $scope.alertService.presentAlert('warning', "Hold Up!", "Some resources do not have categorys or UOMs matched or non-unique identifiers! Please check and try again.");
      $scope.resourceImport.loading = false;
      return;
    }

    // compile object of resources to be imported from list
    var resourcesSave = [];
    for (var i = 0; i < importList.length; i++) {
      if (importList[i].selected) {
        var resource = {};
        resource.name = importList[i].name;
        resource.identifier = importList[i].identifier;
        resource.category = importList[i].category.id;
        resource.uom = importList[i].uom.id;
        resource.organisation = $scope.currentOrg.id;
        resourcesSave.push(resource);
      }
    }

    resourceService.bulkImportResources(resourcesSave, function (resp) {
      $scope.mode = 'list';
      $scope.refreshResources();
      $scope.importList = [];
      $scope.close();
      $scope.resourceImport.loading = false;
    }, function (err) {
      $scope.alertService.presentAutoAlert('importResources', err);
      $scope.resourceImport.loading = false;
    });
  };

  $scope.removeResourceFromImport = function (resource, importList) {
    var index = importList.indexOf(resource);
    if (index != -1) {
      importList.splice(index, 1);
    }

    index = $scope.importSelected.indexOf(resource);
    if (index != -1) {
      $scope.importSelected.splice(index, 1);
    }
  };

  $scope.validateAllResourceItems = function () {
    $scope.importList.forEach($scope.validateResourceItem);
  };

  $scope.validateResourceItem = function (resource) {
    var error = false;
    if (resource.category == null || resource.category.id == null) {
      error = true;
    }

    if (resource.uom == null || resource.uom.id == null) {
      error = true;
    }

    if (resource.name == null || resource.name == '') {
      error = true;
    }

    if (resource.identifier == null || resource.identifier == '') {
      error = true;
    }

    if ($scope.allResources.map(function (resource) {
      return resource.identifier;
    }).includes(resource.identifier) || _.without($scope.importList, resource).map(function (resource) {
      return resource.identifier;
    }).includes(resource.identifier)) {
      error = true;
      resource.identifierNotUnique = true;
    } else {
      resource.identifierNotUnique = false;
    }

    if (error) {
      resource.error = true;
      resource.selected = false;
    } else {
      resource.error = false;
      resource.selected = true;
    }

    return resource.error;
  };

  $scope.toggleRowItem = function (item) {
    if (item.selected) {
      item.selected = false;
    } else {
      item.selected = true;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "X5Gh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('docketListController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', 'orderService', function ($rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, orderService) {

  //$("body").css('touch-action','');

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  var viewMode = "default";

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.listCount = 0;
  $scope.docketsLoading = false;
  //$scope.listFull = true;

  $scope.listViewConfig = {
    docketNumber: { displayName: "Docket Number", modelName: 'docketNumber' },
    customerName: { displayName: "Customer", modelName: 'customerName' },
    supplierName: { displayName: "Supplier", modelName: 'supplierName' },
    authorName: { displayName: "Operator", modelName: 'authorName' },
    customerSignatureName: { displayName: "Signed By", modelName: 'customerSignatureName' },
    date: { displayName: "Date", modelName: 'date' },
    status: { displayName: "Status", modelName: 'status' },
    customerRefNo: { displayName: "Customer Ref No", modelName: 'customerRefNo' },
    supplierRefNo: { displayName: "Supplier Ref No", modelName: 'supplierRefNo' },
    acceptedBy: { displayName: "Accepted By", modelName: 'acceptedBy' },
    orderNumber: { displayName: "Order Number", modelName: '' }
  };

  $scope.listViewInjectCustomFields = [];
  $scope.listViewInjectOrderNumbers = false;

  if (viewMode == 'default') {
    $scope.listViewOrder = ['docketNumber', 'customerName', 'supplierName', 'authorName', 'date', 'status'];
  } else if (viewMode == 'receiver') {
    $scope.listViewOrder = ['docketNumber', 'supplierName', 'authorName', 'customerSignatureName', 'date', 'status'];
  }

  if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.listViewOrder && $scope.currentOrg.features.dockets.listViewOrder.length > 0) {
    $scope.listViewOrder = $scope.currentOrg.features.dockets.listViewOrder;
    for (var i = 0; i < $scope.listViewOrder.length; i++) {
      if ($scope.listViewOrder[i].indexOf('customField') == 0) {
        $scope.listViewInjectCustomFields.push($scope.listViewOrder[i].split('-')[1]);
        // generate a nice display name for this custom field column
        var niceDisplayName = $scope.listViewOrder[i].split('-')[1].match(/[A-Z][a-z,1-9]+/g).join(' ');
        $scope.listViewConfig[$scope.listViewOrder[i]] = { displayName: niceDisplayName, modelName: '' };
      } else if ($scope.listViewOrder[i] == 'orderNumber') {
        $scope.listViewInjectOrderNumbers = true;
      }
    }
  }

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  $scope.selectedItem = null;

  /***********************/
  /***** Permissions *****/
  /***********************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /*******************************/
  /***** Major State Changes *****/
  /*******************************/

  $scope.$parent.updateSelectedDocketFromParent = function (docket) {
    $scope.selectedItem = docket;
  };

  $scope.$parent.prepareForDocketsFromParent = function () {
    $scope.listItems = [];
    $scope.docketsLoading = true;
  };

  $scope.$parent.injectCustomFields = function (docketsList) {
    if ($scope.listViewInjectCustomFields.length > 0) {
      $scope.injectCustomFieldsIntoDocketsList(docketsList, $scope.listViewInjectCustomFields);
    }
  };

  $scope.$parent.loadDocketsListFromParent = function (docketsList, docketCount) {
    $scope.listItems = docketsList;
    $scope.injectCustomFields(docketsList);
    if ($scope.listViewInjectOrderNumbers) {
      $scope.$parent.injectOrderNumbersIntoDocketsList($scope.listItems);
    }
    $scope.listCount = docketCount;
    $scope.docketsLoading = false;
  };

  $scope.$parent.loadAdditionalDocketsFromParent = function (docketsList) {
    for (var i = 0; i < docketsList.length; i++) {
      $scope.listItems.push(docketsList[i]);
    }
  };

  $scope.$parent.loadInDocketFiledStatusFromParent = function (docketsFiledStatus) {
    for (var i = 0; i < $scope.listItems.length; i++) {
      if (docketsFiledStatus[$scope.listItems[i].id]) {
        $scope.listItems[i].filed = true;
      } else {
        $scope.listItems[i].filed = false;
      }
    }

    if ($scope.filters.filedOptions.display && !$scope.filters.filedOptions.all && $scope.filters.filedOptions.filed != $scope.filters.filedOptions.unfiled) {
      if ($scope.filters.filedOptions.filed) {
        $scope.listItems = $scope.listItems.filter(function (item) {
          return item.filed;
        });
      } else {
        $scope.listItems = $scope.listItems.filter(function (item) {
          return !item.filed;
        });
      }
    }
  };

  $scope.injectCustomFieldsIntoDocketsList = function (docketsList, customFieldsToInject) {
    for (var i = 0; i < docketsList.length; i++) {
      var thisDocket = docketsList[i];
      thisDocket.customFieldsInjected = {};
      if (thisDocket.template && thisDocket.template.blocks) {
        for (var j = 0; j < thisDocket.template.blocks.length; j++) {
          for (var k = 0; k < thisDocket.template.blocks[j].fields.length; k++) {
            var thisFieldName = thisDocket.template.blocks[j].fields[k].displayName;
            var thisFieldNameReduced = thisFieldName.split(' ').join('');
            // now check if this custom field matches one from the to inject list
            if (customFieldsToInject.indexOf(thisFieldNameReduced) != -1) {
              // get the templateValueStore value for this custom field
              if (thisDocket && thisDocket.templateValueStore && thisDocket.templateValueStore[thisDocket.template.blocks[j].id + '-' + thisDocket.template.blocks[j].fields[k].id]) {
                thisDocket.customFieldsInjected[thisFieldNameReduced] = thisDocket.templateValueStore[thisDocket.template.blocks[j].id + '-' + thisDocket.template.blocks[j].fields[k].id];
              }
            }
          }
        }
      }
    }
  };

  $scope.injectOrderNumbersIntoDocketsList = function (docketsList) {
    // first we need to get a unique list of order uuid's
    var orderIds = {};
    for (var i = 0; i < docketsList.length; i++) {
      if (docketsList[i].orderRef && !orderIds[docketsList[i].orderRef]) {
        orderIds[docketsList[i].orderRef] = true;
      }
    }

    // now we need to get the orders for the list of ids that we generated
    orderService.getOrders({ ids: Object.keys(orderIds).join(',') }, function (orders) {
      var orderNumbers = {};
      for (var i = 0; i < orders.length; i++) {
        orderNumbers[orders[i].id] = orders[i].orderNumber;
      }
      // now that we have the full orders - we need to inject the orderNumber into each docket list item
      for (var i = 0; i < docketsList.length; i++) {
        if (docketsList[i].orderRef && orderNumbers[docketsList[i].orderRef]) {
          docketsList[i].orderNumber = orderNumbers[docketsList[i].orderRef];
        }
      }
    }, function (failed) {
      console.error('could not get list of orders', failed);
    });
  };

  /*************************************/
  /***** Item List / Swipe Actions *****/
  /*************************************/

  // TODO: change this for desktop options - not used in mobile
  $scope.openDocket = function (docket) {
    $scope.itemEdit = {};
    $scope.openDocketDesktop(docket);
  };

  /**************************************************/
  /***** Alert parent controller of ready state *****/
  /**************************************************/

  $scope.$parent.docketsChildControllerReady();
}]);

/***/ }),

/***/ "XBXZ":
/***/ (function(module, exports) {

var path = 'views/pages/mobileLists/listsMaster.html';
var html = "<div class=\"mobileContainer\">\n  <div class=\"tableLayoutHelperContainer\" id=\"infiniteScrollList\">\n    <ng-include src=\"'views/pages/mobileLists/listsHeader.html'\"></ng-include>\n    <ng-include src=\"'views/pages/mobileLists/listsFooter.html'\"></ng-include>\n\n    <div ng-show=\"listView=='feed' && organisations.length <= 0\" class=\"feedWelcomeDisplay\">\n      <div class=\"welcomeTitle\">Hi {{currentUser.name.first}},</div>\n      <div class=\"welcomeSubText\">How would do you want to use Docketbook? Choose one option:</div>\n      <div class=\"outlineLogo\"></div>\n\n      <div class=\"newCompanySelectorOuter onboardingSelectorOuter\">\n        <div ng-click=\"goToOnbboardingSession(onboardingSessions.length > 0 ? onboardingSessions[0] : undefined)\" class=\"userIntent mobile\">\n          <div class=\"userIntentIcon\">\n            <img ng-src='domain.svg'></img>\n          </div>\n          <div ng-if=\"onboardingSessions.length == 0\">\n            I want to create a company\n          </div>\n          <div ng-if=\"onboardingSessions.length > 0\">\n            Continue setting up {{onboardingSessions[0].data.companyInfo.name}}\n          </div>\n        </div>\n\n        <div ng-click=\"showWaitToBeInvitedModal()\" class=\"userIntent mobile\">\n          <div class=\"userIntentIcon\">\n            <img ng-src='account-multiple.svg'></img>\n          </div>\n          <div>\n            I want to join a company already on Docketbook\n          </div>\n        </div>\n\n        <div ng-click=\"goToMyDocketbook()\" class=\"userIntent mobile\">\n          <div class=\"userIntentIcon\">\n            <img ng-src='file-document.svg'></img>\n          </div>\n          <div>\n            I want to view dockets that I've been sent\n          </div>\n        </div>\n      </div>\n\n    </div>\n    <div ng-show=\"listView=='feed' && organisations.length > 0\">\n      <div class=\"feedList\" style=\"padding-left: 0px; padding-right: 0px; padding-bottom: 0px;\">\n        <div class=\"trialBanner\" ng-if=\"unverifiedPhone !== undefined\">\n          When you receive the confirmation code we sent to {{unverifiedPhone}}, please go to <a ui-sref=\"user.account()\">My Account</a> to verify your account.\n        </div>\n        <div class=\"trialBanner\" ng-if=\"unverifiedEmail !== undefined\">\n          Please check your email address {{unverifiedEmail}} for a verification message. When you receive it, open the link it contains to verify your account.\n        </div>\n      </div>\n      <div class=\"feedList\" style=\"padding-top: 0px\";>\n        <h3>Today</h3>\n        <div class=\"feedItem\" ng-repeat=\"job in activeJobsToday\" ng-click=\"openJobDetail(job)\">\n          <div class=\"itemNumber\">{{job.jobNumber}}</div>\n          <div class=\"statusDisplay {{job.statusDisplay}}\">{{job.statusDisplay}}</div>\n          <div class=\"itemPrimaryDetail\">\n            <div class='left'>{{job.customerContact.displayName}}</div>\n            <div class=\"right\">{{moment(job.startDate).format('DD/MM')}} - {{moment(job.endDate).format('DD/MM')}}</div>\n          </div>\n          <div class=\"itemSubDetail\" ng-if=\"job.instructions\">\n            {{job.instructions}}\n          </div>\n        </div>\n        <div class=\"feedItem\" ng-repeat=\"docket in activeDocketsToday\" ng-click=\"openDocketDetail(docket)\">\n          <div class=\"itemNumber\">{{docket.docketNumber}}</div>\n          <div class=\"statusDisplay {{docket.status}}\">{{docket.status}}</div>\n          <div class=\"itemPrimaryDetail\">\n            <div class='left'>{{docket.customerContact.displayName}}</div>\n            <div class=\"right\">{{moment(docket.date).format('DD/MM')}}</div>\n          </div>\n          <div class=\"itemSubDetail\" ng-if=\"docket.resourceSummary && docket.resourceSummary.totalInteractions > 0\">\n            <div ng-repeat=\"resource in docket.resourceSummary\" class=\"itemInteractionSummaryOuter\">\n              <div ng-repeat=\"interaction in resource.interactionSummary\" class=\"itemInteractionSummary\">\n                <div class=\"left\">\n                  {{resource.resource.name}} - {{interaction.interaction.name}}\n                </div>\n                <div class=\"right\">\n                  {{interaction.quantity}} {{resource.resource.uom.abbreviation}}\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <h3>Tomorrow</h3>\n        <div class=\"feedItem\" ng-repeat=\"job in activeJobsTomorrow\" ng-click=\"openJobDetail(job)\">\n          <div class=\"itemNumber\">{{job.jobNumber}}</div>\n          <div class=\"statusDisplay {{job.statusDisplay}}\">{{job.statusDisplay}}</div>\n          <div class=\"itemPrimaryDetail\">\n            <div class='left'>{{job.customerContact.displayName}}</div>\n            <div class=\"right\">{{moment(job.startDate).format('DD/MM')}} - {{moment(job.endDate).format('DD/MM')}}</div>\n          </div>\n        </div>\n        <div class=\"feedItem\" ng-repeat=\"docket in activeDocketsTomorrow\" ng-click=\"openDocketDetail(job)\">\n          <div class=\"itemNumber\">{{docket.docketNumber}}</div>\n          <div class=\"statusDisplay {{docket.status}}\">{{docket.status}}</div>\n          <div class=\"itemPrimaryDetail\">\n            <div class='left'>{{docket.customerContact.displayName}}</div>\n            <div class=\"right\">{{moment(docket.date).format('DD/MM')}}</div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <span ng-show=\"listView=='dockets'\">\n      <ng-include src=\"'views/pages/dockets/mobile/list.html'\" ng-controller=\"docketListController\"></ng-include>\n      <!--<ng-include src=\"'views/pages/dockets/mobile/mobileFooter.html'\"></ng-include>-->\n    </span>\n\n    <span ng-show=\"listView=='jobs'\">\n      <ng-include src=\"'views/pages/jobs/mobile/list.html'\" ng-controller=\"jobListController\"></ng-include>\n      <!--<ng-include src=\"'views/pages/jobs/mobile/mobileFooter.html'\"></ng-include>-->\n    </span>\n\n    <span ng-show=\"listView=='orders'\">\n      <ng-include src=\"'views/pages/orders/mobile/list.html'\" ng-controller=\"orderListController\"></ng-include>\n      <!--<ng-include src=\"'views/pages/orders/mobile/mobileFooter.html'\"></ng-include>-->\n    </span>\n\n    <span ng-show=\"listView=='filing'\">\n      <ng-include src=\"'views/pages/filing/mobile/list.html'\" ng-controller=\"filingListController\"></ng-include>\n      <!--<ng-include src=\"'views/pages/filing/mobile/mobileFooter.html'\"></ng-include>-->\n    </span>\n  </div>\n  <div id=\"toaster\" class=\"visible-xs\">\n    <div id=\"toasterInner\">\n      <md-content id=\"content1\" ng-cloak>\n\n      </md-content>\n    </div>\n  </div>\n</div>\n<ng-include src=\"'views/pages/mobileSideNav.html'\"></ng-include>\n<ng-include src=\"'views/modals/editOrgModal.html'\" ng-controller=\"newOrgModalController\"></ng-include>\n<ng-include src=\"'views/modals/waitToBeInvitedModal.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "XMIk":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/groups.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\" ng-if=\"view == 'list'\">\n    <div class=\"left\">\n      <h3>Groups</h3>\n      <span class=\"subHeading\"\n        ng-if=\"currentOrg.planFeatures.includedOrganisationGroups != 0 && currentOrg.groups.length >= currentOrg.planFeatures.includedOrganisationGroups\">The\n        {{currentOrg.planFeatures.name}} Plan only includes {{currentOrg.planFeatures.includedOrganisationGroups}}\n        group{{currentOrg.planFeatures.includedOrganisationGroups > 1 ? 's' : ''}}. <a\n          ng-click=\"selectPlan(null, 'groups', 'from groups page - upgrade now')\">Upgrade now</a> to create new\n        groups.</span>\n      <span class=\"subHeading\"\n        ng-if=\"currentOrg.planFeatures.includedOrganisationGroups != 0 && currentOrg.groups.length < currentOrg.planFeatures.includedOrganisationGroups\">You\n        can create {{currentOrg.planFeatures.includedOrganisationGroups - currentOrg.groups.length}} more\n        group{{currentOrg.planFeatures.includedOrganisationGroups - currentOrg.groups.length > 1 ? 's' : ''}} on the\n        {{currentOrg.planFeatures.name}} Plan. Need more? <a\n          ng-click=\"selectPlan(null, null, 'from groups page - upgrade now')\">Upgrade now</a></span>\n    </div>\n    <div class=\"right\">\n      <div class=\"dbButton\"\n        ng-click=\"(currentOrg.planFeatures.includedOrganisationGroups == 0 || currentOrg.groups.length < currentOrg.planFeatures.includedOrganisationGroups) ? newOrgGroup() : selectPlan(null, 'groups', 'from groups page - create new button')\">\n        Create New\n        <span class=\"lockIcon\"\n          ng-if=\"currentOrg.planFeatures.includedOrganisationGroups != 0 && currentOrg.groups.length >= currentOrg.planFeatures.includedOrganisationGroups\">\n          <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n        </span>\n        <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"right\"\n          ng-if=\"currentOrg.planFeatures.includedOrganisationGroups != 0 && currentOrg.groups.length >= currentOrg.planFeatures.includedOrganisationGroups\">\n          <div style=\"font-size: 12px;\">Upgrade your plan to create a new group</div>\n        </md-tooltip>\n      </div>\n    </div>\n  </div>\n  <div class=\"settingsHeader\" ng-if=\"view == 'detail'\">\n    <div class=\"backButton\" ng-click=\"closeGroupEdit()\">\n      <md-icon md-svg-src=\"arrow_left.svg\"></md-icon>\n    </div>\n    <div class=\"left\">\n      <h3 ng-if=\"groupEdit.id != null\">Edit Group - {{groupEdit.name}}{{!groupEdit.active ? ' (Inactive)' : ''}}</h3>\n      <h3 ng-if=\"groupEdit.id == null\">New Group</h3>\n      <div ng-show=\"selectedIndexContainer.selectedIndex == 1 || selectedIndexContainer.selectedIndex == 2\">\n        <span class=\"subHeading\"\n          ng-if=\"currentOrg.planFeatures.includedUsers != -1 && allUsers.length >= currentOrg.planFeatures.includedUsers\">The\n          {{currentOrg.planFeatures.name}} Plan only includes {{currentOrg.planFeatures.includedUsers}}\n          user{{currentOrg.planFeatures.includedUsers > 1 ? 's' : ''}}. <a\n            ng-click=\"selectPlan(null, 'users', 'from edit group page - upgrade now')\">Upgrade now</a> to add more\n          users.</span>\n        <span class=\"subHeading\"\n          ng-if=\"currentOrg.planFeatures.includedUsers != -1 && allUsers.length < currentOrg.planFeatures.includedUsers\">You\n          can add {{currentOrg.planFeatures.includedUsers - allUsers.length}} more\n          user{{currentOrg.planFeatures.includedUsers - allUsers.length > 1 ? 's' : ''}} on the\n          {{currentOrg.planFeatures.name}} Plan. Need more? <a\n            ng-click=\"selectPlan(null, null, 'from edit group page - upgrade now')\">Upgrade now</a></span>\n      </div>\n    </div>\n    <div class=\"right\">\n      <div class=\"tabButtonsGroup initial\" id=\"tabButtonsGroupgeneral\">\n        <div class=\"dbButton spinner\" ng-click=\"group.loading ? null : saveOrgGroup(groupEdit)\"\n          ng-disabled=\"groupEdit.loading\">\n          Save\n          <md-progress-circular ng-show=\"groupEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n        </div>\n      </div>\n      <div class=\"tabButtonsGroup\" id=\"tabButtonsGroupinvitedUsers\">\n        <div class=\"dbButton\" ng-click=\"inviteMembersToGroup()\" aria-label=\"Invite Members To Group\">\n          Invite New\n        </div>\n      </div>\n      <div class=\"tabButtonsGroup\" id=\"tabButtonsGroupactiveUsers\">\n        <div class=\"dbButton\" ng-click=\"inviteMembersToGroup()\" aria-label=\"Invite Members To Group\">\n          Invite New\n        </div>\n      </div>\n      <div class=\"tabButtonsGroup\" id=\"tabButtonsGroupfileCodes\" ng-if=\"currentOrg.planFeatures.docketsFiling == true\">\n        <md-button class=\"md-icon-button\" ng-click=\"newFileCode()\" aria-label=\"New File Code\"\n          ng-if=\"fileCodes.mode != 'import'\">\n          <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"openImportModal()\" aria-label=\"Import File Codes From File\"\n          ng-if=\"fileCodes.mode != 'import'\">\n          <md-icon md-svg-icon=\"import.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"loadFilingList()\" aria-label=\"Reload Filing List\"\n          ng-if=\"fileCodes.mode != 'import'\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n        <md-menu ng-if=\"fileCodes.mode != 'import'\">\n          <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"\n            ng-disabled=\"fileCodes.selected.length <= 0\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"deleteSelectedFileCodes()\" aria-label=\"Delete Selected File Codes\">\n              <md-button>\n                Delete Selected Codes\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n        <md-button ng-click=\"cancelImport()\" ng-show=\"fileCodes.mode == 'import'\" class=\"compact\">\n          Cancel\n        </md-button>\n        <md-button ng-click=\"bulkImportFileCodes(importList)\" ng-show=\"fileCodes.mode == 'import'\" class=\"compact\">\n          Import\n        </md-button>\n      </div>\n    </div>\n  </div>\n  <div class=\"settingsTableOuterContainer\" ng-if=\"view == 'list'\">\n    <div ng-show=\"loadingGroups == true\"\n      style=\"width: 100%; height: 777px; display: flex; justify-content: center; align-items: center;\">\n      <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-5\" md-diameter=\"60\"></md-progress-circular>\n    </div>\n    <md-table-container ng-show=\"loadingGroups == false\">\n      <table md-table md-progress=\"promise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column><span>Name</span></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"group in allGroups\" ng-show=\"groupVisible(group)\">\n            <td md-cell>\n              <span class=\"levelSpacer\" ng-repeat=\"item in repeatSpansByLevel(group.pathLevel)\"></span>\n              <md-button class=\"md-icon-button\" ng-show=\"hasChildren(group)\" ng-click=\"expandGroup(group)\">\n                <md-icon ng-show=\"!allGroupsById[group.id].expanded\" md-svg-src=\"arrow_down.svg\"></md-icon>\n                <md-icon ng-show=\"allGroupsById[group.id].expanded\" md-svg-src=\"arrow_up.svg\"></md-icon>\n              </md-button>\n              <div ng-show=\"!hasChildren(group)\" class=\"md-button md-icon-button\" style=\"cursor: default;\"></div>\n              <a ng-click=\"editOrgGroup(group)\" style=\"{{group.active? '' : 'color: rgba(0, 0, 0, 0.54)'}}\">\n                {{group.name}}\n                {{group.parent == null\n                ? ' (Main Group)'\n                : group.active\n                ? ''\n                : ' (Inactive)'\n                }}\n              </a>\n            </td>\n            <td md-cell style=\"text-align:right;\">\n              <a\n                ng-click=\"(currentOrg.planFeatures.includedOrganisationGroups == 0 || currentOrg.groups.length < currentOrg.planFeatures.includedOrganisationGroups) ? newOrgGroup(group) : selectPlan(null, 'groups', 'from groups page - new sub group button')\">\n                New Sub Group\n                <span class=\"lockIcon\"\n                  ng-if=\"currentOrg.planFeatures.includedOrganisationGroups != 0 && currentOrg.groups.length >= currentOrg.planFeatures.includedOrganisationGroups\">\n                  <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n                </span>\n                <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"right\"\n                  ng-if=\"currentOrg.planFeatures.includedOrganisationGroups != 0 && currentOrg.groups.length >= currentOrg.planFeatures.includedOrganisationGroups\">\n                  <div style=\"font-size: 12px;\">Upgrade your plan to create a new sub group</div>\n                </md-tooltip>\n              </a>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n\n  <div class=\"adminTabularContentContainer\" ng-if=\"view == 'detail'\">\n    <md-tabs md-dynamic-height md-selected=\"selectedIndexContainer.selectedIndex\" md-border-bottom md-autoselect\n      class=\"docketTabsInner\">\n      <md-tab label=\"General\" ng-click=\"tabChanged('general')\">\n        <div class=\"settingsTabContentInner\">\n          <div class=\"adminSettingsFieldsContainer\" ng-if=\"currentOrgGroup.parent == null\">\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Group Name\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.name\" required>\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Group Public Name\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.publicName\" required>\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Group Description\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.description\" required>\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Company Prefix\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.prefix\">\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Order Prefix\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.orderPrefix\">\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Job Prefix\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.jobPrefix\">\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Docket Prefix\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.docketPrefix\">\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Invoice Prefix\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                  <input type=\"text\" ng-model=\"groupEdit.invoicePrefix\">\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Default Docket Template\n              </div>\n              <div class=\"field\">\n                <md-select ng-model=\"groupEdit.defaultTemplate\" required>\n                  <md-option ng-repeat=\"template in allTemplates\" ng-value=\"template.id\">{{template.name}}</md-option>\n                </md-select>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Timezone\n              </div>\n              <div class=\"field\">\n                <md-select ng-model=\"groupEdit.timezone\">\n                  <md-option ng-repeat=\"tz in allTimezones\" ng-value=\"tz\">{{tz}}</md-option>\n                </md-select>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Time Format\n              </div>\n              <div class=\"field\">\n                <md-select ng-model=\"groupEdit.timeFormat\">\n                  <md-option ng-repeat=\"format in allTimeFormats\" ng-value=\"format\">{{timeFormatDisplay[format]}}\n                  </md-option>\n                </md-select>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\">\n              <div class=\"title\">\n                Address\n              </div>\n              <div class=\"field\">\n                {{stringifyAddress(groupEdit.address)}}\n              </div>\n              <div class=\"action\">\n                <a class=\"actionLink\" ng-click=\"openEditAddressModal()\">Change Address</a>\n              </div>\n            </div>\n            <div class=\"settingsField\" ng-if=\"groupEdit.parents && groupEdit.parents.length > 0\">\n              <div class=\"title\">\n                Inherit Permissions From Parent Group\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <md-checkbox ng-model=\"groupEdit.inheritsPermissions\" aria-label=\"Inherits Permissions\">\n                    Inherits Permissions\n                  </md-checkbox>\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\" ng-if=\"groupEdit.parents && groupEdit.parents.length > 0\">\n              <div class=\"title\">\n                Inherit Address Book From Parent Group\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <md-checkbox ng-model=\"groupEdit.inheritsAddressBook\" aria-label=\"Inherits Address Book\">\n                    Inherits Address Book\n                  </md-checkbox>\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n            <div class=\"settingsField\" ng-if=\"groupEdit.parents && groupEdit.parents.length > 0\">\n              <div class=\"title\">\n                Active\n              </div>\n              <div class=\"field\">\n                <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n                  <md-checkbox ng-model=\"groupEdit.active\" aria-label=\"Active\">\n                    Active\n                  </md-checkbox>\n                </md-input-container>\n              </div>\n              <div class=\"action\">\n\n              </div>\n            </div>\n          </div>\n        </div>\n      </md-tab>\n      <md-tab label=\"Current Users ({{activeUsers.length}})\" ng-click=\"tabChanged('activeUsers')\"\n        ng-disabled=\"newGroup\">\n        <md-table-container>\n          <table md-table>\n            <thead md-head>\n              <tr md-row>\n                <th md-column>Name</th>\n                <th md-column>Primary Contact</th>\n                <th md-column>Access</th>\n                <th md-column class=\"iconColumn\"></th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row ng-repeat=\"member in activeUsers\">\n                <td md-cell>{{member.user.name.full}}</td>\n                <td md-cell>{{member.user.emailAddress}}</td>\n                <td md-cell>\n                  {{getGroupRoles(member)}}\n                  <!--<span ng-if=\"member.isGlobalAdmin\">Super Admin</span>\n                  <span ng-if=\"member.isMonitor\">Group Monitor</span>\n                  <span ng-repeat=\"role in member.roles\">{{role.name}}</span>-->\n                </td>\n                <td md-cell>\n                  <md-button class=\"md-icon-button\" ng-click=\"showEditUserGroupRolesModal(member.user, groupEdit)\"\n                    aria-label=\"Edit User\">\n                    <md-icon md-svg-icon=\"edit.svg\"></md-icon>\n                  </md-button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </md-tab>\n      <md-tab label=\"Invited Users ({{invitedUsers.length}})\" ng-click=\"tabChanged('invitedUsers')\"\n        ng-disabled=\"newGroup\">\n        <md-table-container>\n          <table md-table>\n            <thead md-head>\n              <tr md-row>\n                <th md-column>Name</th>\n                <th md-column>Primary Contact</th>\n                <th md-column>Access</th>\n                <th md-column></th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row ng-repeat=\"member in invitedUsers\">\n                <td md-cell>{{member.user.name.full}}</td>\n                <td md-cell>{{member.user.emailAddress}}</td>\n                <td md-cell>\n                  <span ng-if=\"member.isGlobalAdmin\">Super Admin<span\n                      ng-if=\"member.isMonitor || member.roles.length > 0\"> + </span></span>\n                  <span ng-if=\"member.isMonitor\">Group Monitor<span ng-if=\"member.roles.length > 0\"> + </span></span>\n                  <span ng-repeat=\"role in member.roles\">{{role.name}}<span\n                      ng-if=\"member.roles.length > 1 && member.roles.indexOf(role) < member.roles.length - 1\"> +\n                    </span></span>\n                </td>\n                <td md-cell style=\"text-align: right;\">\n\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </md-tab>\n      <md-tab ng-click=\"tabChanged('fileCodes');loadFilingList();\" ng-disabled=\"newGroup\">\n        <md-tab-label>\n          File Codes\n          <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsFiling != true\">\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </span>\n        </md-tab-label>\n        <md-tab-body>\n          <div ng-if=\"currentOrg.planFeatures.docketsFiling != true\" style=\"margin-top: 150px; text-align: center;\">\n            <p style=\"margin-bottom: 20px;\">File codes are available on the Large and Enterprise plans</p>\n            <div class=\"newDbButton centerAligned\"\n              ng-click=\"selectPlan(null, 'docketsFiling', 'from file codes page - upgrade now button')\">\n              Upgrade Now\n            </div>\n          </div>\n\n          <md-table-container ng-if=\"currentOrg.planFeatures.docketsFiling == true\" ng-show=\"fileCodes.mode !='import'\">\n            <table md-table md-row-select multiple ng-model=\"fileCodes.selected\" md-progress=\"promise\">\n              <thead md-head md-order=\"fileCodes.query.order\" md-on-reorder=\"loadFilingList\">\n                <tr md-row>\n                  <th md-column md-order-by=\"fileCode\"><span>File Code</span></th>\n                  <th md-column md-order-by=\"fileName\"><span>File Name</span></th>\n                  <th md-column md-order-by=\"costCode\"><span>Cost Code</span></th>\n                  <th md-column><span>System Codes</span></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row md-select=\"fileCode\" md-select-id=\"id\" ng-repeat=\"fileCode in fileCodes.allFileCodes\"\n                  ng-click=\"editFileCode(fileCode)\" style=\"cursor: pointer;\">\n                  <td md-cell>{{fileCode.fileCode}}</td>\n                  <td md-cell>\n                    {{fileCode.fileName}}\n                  </td>\n                  <td md-cell>\n                    {{fileCode.costCode}}\n                  </td>\n                  <td md-cell>\n                    {{fileCode.systemCodes}}\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n          <md-table-pagination ng-if=\"currentOrg.planFeatures.docketsFiling == true\" md-limit=\"fileCodes.query.limit\"\n            md-limit-options=\"[5,10,15,30,100]\" md-page=\"fileCodes.query.page\" md-on-paginate=\"loadFilingList\"\n            md-total=\"{{fileCodes.listCount}}\" md-page-select>\n          </md-table-pagination>\n\n          <md-table-container ng-show=\"fileCodes.mode =='import'\">\n            <table md-table md-row-select multiple ng-model=\"fileCodes.importSelected\" md-progress=\"promise\">\n              <thead md-head>\n                <tr md-row>\n                  <th md-column><span>Status</span></th>\n                  <th md-column><span>File Code</span></th>\n                  <th md-column><span>File Name</span></th>\n                  <th md-column><span>Cost Code</span></th>\n                  <th md-column><span>System Codes</span></th>\n                  <th md-column><span>Action</span></th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row md-select=\"fileCode\" md-select-id=\"id\" ng-repeat=\"fileCode in fileCodes.importList\"\n                  class=\"{{fileCode.error ? 'error' : ''}}\">\n                  <td md-cell>\n                    <div class=\"statusDisplay {{fileCode.status == 'New' ? 'Completed' : 'Sent'}}\">{{fileCode.status}}\n                    </div>\n                  </td>\n                  <td md-cell>\n                    <span ng-if=\"fileCode.status != 'New'\">{{fileCode.fileCode}}</span>\n                    <md-input-container ng-if=\"fileCode.status == 'New'\">\n                      <input ng-model=\"fileCode.fileCode\" type=\"text\" required\n                        ng-change=\"validateFileCodeItem(fileCode)\">\n                    </md-input-container>\n                  </td>\n                  <td md-cell>\n                    <md-input-container>\n                      <input ng-model=\"fileCode.fileName\" type=\"text\" required\n                        ng-change=\"validateFileCodeItem(fileCode)\">\n                    </md-input-container>\n                  </td>\n                  <td md-cell>\n                    <md-input-container>\n                      <input ng-model=\"fileCode.costCode\" type=\"text\" required\n                        ng-change=\"validateFileCodeItem(fileCode)\">\n                    </md-input-container>\n                  </td>\n                  <td md-cell>\n                    {{fileCode.systemCodes}}\n                  </td>\n                  <td md-cell>\n                    <md-button class=\"md-icon-button\"\n                      ng-click=\"removeCodeFromImportList(fileCode, fileCodes.importList)\"\n                      aria-label=\"Remove File Code From Import List\">\n                      <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                    </md-button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </md-tab-body>\n      </md-tab>\n    </md-tabs>\n  </div>\n</div>\n\n<!-- File Code Modal -->\n<div class=\"niceModal desktopSelector\" id=\"fileCodeModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"fileCodes.fileCodeEdit.id == null\">New File Code</h1>\n      <h1 ng-show=\"fileCodes.fileCodeEdit.id != null\">Edit File Code</h1>\n    </div>\n    <form name=\"newFileCodeForm\" novalidate>\n      <div class=\"content\">\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>File Code</label>\n            <input ng-model=\"fileCodes.fileCodeEdit.fileCode\" ng-readonly=\"fileCodes.fileCodeEdit.id != null\">\n          </md-input-container>\n\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>File Name</label>\n            <input ng-model=\"fileCodes.fileCodeEdit.fileName\" required>\n          </md-input-container>\n        </div>\n\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>Cost Code</label>\n            <input ng-model=\"fileCodes.fileCodeEdit.costCode\" required>\n          </md-input-container>\n        </div>\n        <!-- System Codes Go Here -->\n\n        <div class=\"clearfix\"></div>\n      </div>\n      <div class=\"footer uneven\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeFileCodeModal()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner margin-right\"\n              ng-click=\"(newFileCodeForm.$invalid || fileCodes.fileCodeEdit.loading) || saveFileCode(fileCodes.fileCodeEdit)\"\n              ng-disabled=\"newFileCodeForm.$invalid || fileCodes.fileCodeEdit.loading\">\n              <span ng-hide=\"fileCodes.fileCodeEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"fileCodes.fileCodeEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\">\n              </md-progress-circular>\n            </div>\n            <div class=\"dbButton spinner\"\n              ng-click=\"(newFileCodeForm.$invalid || fileCodes.fileCodeEdit.loading) || saveFileCodeAddAnother(fileCodes.fileCodeEdit)\"\n              ng-disabled=\"newFileCodeForm.$invalid || fileCodes.fileCodeEdit.loading\">\n              <span ng-hide=\"fileCodes.fileCodeEdit.loading\">Save & Add Another</span>\n              <md-progress-circular ng-show=\"fileCodes.fileCodeEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\">\n              </md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- End File Code Modal -->\n\n<!-- Import Modal -->\n<div class=\"niceModal desktopSelector\" id=\"importModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Select File To Import</h1>\n    </div>\n    <form name=\"importFileCodeForm\" novalidate>\n      <div class=\"content\">\n        Excel files only (.xls or .xlsx)\n        <br />\n        <br />\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\"\n          accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"cancelImport()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\"\n              ng-click=\"(importFileCodeForm.$invalid || fileCodes.fileCodeImport.loading) || importFileCodesFromFile(file)\"\n              ng-disabled=\"importFileCodeForm.$invalid || fileCodes.fileCodeImport.loading\">\n              <span ng-hide=\"fileCodes.fileCodeImport.loading\">Next</span>\n              <md-progress-circular ng-show=\"fileCodes.fileCodeImport.loading\" class=\"md-hue-2\" md-diameter=\"20px\">\n              </md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- End Import Modal -->\n\n<div class=\"niceModal desktopSelector\" id=\"searchAddressModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Search Address</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeSearchAddressModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"addressSearchForm\" novalidate>\n        <div class=\"modalFormTableHeader white intro\">\n          <p>Search for an address or manually enter it below.</p>\n        </div>\n        <div class=\"modalFormTable padding\">\n          <div class=\"group\">\n            <input type=\"text\" name=\"location\" ng-model=\"groupEdit.location\" address-model=\"groupEdit.address\"\n              class=\"{{groupEdit.location != null ? 'ng-dirty' : ''}}\" googleplace placeholder=\"\">\n            <span class=\"highlight\"></span>\n            <span class=\"bar\"></span>\n            <label>Search Address</label>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n              <label>Unit Number</label>\n              <input type=\"text\" ng-model=\"groupEdit.address.num\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n              <label>Street Number</label>\n              <input type=\"text\" ng-model=\"groupEdit.address.streetNum\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n              <label>Street Name</label>\n              <input type=\"text\" ng-model=\"groupEdit.address.streetName\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n              <label>Suburb</label>\n              <input type=\"text\" ng-model=\"groupEdit.address.suburb\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n              <label>State</label>\n              <input type=\"text\" ng-model=\"groupEdit.address.state\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n              <label>Post Code</label>\n              <input type=\"text\" ng-model=\"groupEdit.address.postCode\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n              <label>Country</label>\n              <input type=\"text\" ng-model=\"groupEdit.address.country\" required>\n            </md-input-container>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white\" ng-click=\"closeSearchAddressModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"closeSearchAddressModal()\">\n            Continue\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-include src=\"'views/modals/inviteMembersModal.html'\"></ng-include>\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n<ng-include src=\"'views/modals/editUserGroupRolesModal.html'\" ng-controller=\"editUserGroupRolesModalController\">\n</ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "XOs8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBki":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "edit.svg";

/***/ }),

/***/ "YRsZ":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/generalTab.html';
var html = "<div class=\"ojdRow\" ng-if=\"currentOrg == null\">\n  <div class=\"ojdField noEdit disabled\">\n    <h1>Unassigned</h1>\n    <h3>This order is unassigned</h3>\n    <div class=\"dbButton lightBlue margin-top\" ng-click=\"assignOrderOrg(itemEdit)\">Add To Organisation</div>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField noEdit\">\n    <h1>Status</h1>\n    <h2>{{itemEdit.status}}</h2>\n  </div>\n  <div class=\"ojdField {{userCanDoAction('changeOrderDocketTemplate', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeOrderDocketTemplate', itemEdit) || selectDocketTemplate()\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeOrderDocketTemplate', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Docket Template</h1>\n    <h2 ng-if=\"itemEdit.template\">{{itemEdit.template.name}}</h2>\n    <h2 ng-if=\"!itemEdit.template && userCanDoAction('changeOrderDocketTemplate', itemEdit)\">Click to select</h2>\n    <h2 ng-if=\"!itemEdit.template && !userCanDoAction('changeOrderDocketTemplate', itemEdit)\">Not Assigned</h2>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField {{userCanDoAction('changeOrderStartDate', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeOrderStartDate', itemEdit) || showDatePicker('startDate', $event)\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeOrderStartDate', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Start Date</h1>\n    <h2>{{moment(itemEdit.startDate).format('DD/MM/YYYY')}}</h2>\n  </div>\n  <div class=\"ojdField {{userCanDoAction('changeOrderEndDate', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeOrderEndDate', itemEdit) || showDatePicker('endDate', $event)\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeOrderEndDate', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>End Date</h1>\n    <h2>{{moment(itemEdit.endDate).format('DD/MM/YYYY')}}</h2>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField\">\n    <h1>Supplier Ref No</h1>\n    <h2 ng-if=\"itemEdit.supplierRefNo && !userCanDoAction('editSupplierRefNo', itemEdit)\">{{itemEdit.supplierRefNo}}</h2>\n    <h2 ng-if=\"!itemEdit.supplierRefNo && !userCanDoAction('editSupplierRefNo', itemEdit)\">Not Assigned</h2>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <input type=\"text\" ng-model=\"itemEdit.supplierRefNo\" ng-if=\"userCanDoAction('editSupplierRefNo', itemEdit)\">\n    </md-input-container>\n  </div>\n  <div class=\"ojdField\">\n    <h1>Customer Ref No</h1>\n    <h2 ng-if=\"itemEdit.customerRefNo && !userCanDoAction('editCustomerRefNo', itemEdit)\">{{itemEdit.customerRefNo}}</h2>\n    <h2 ng-if=\"!itemEdit.customerRefNo && !userCanDoAction('editCustomerRefNo', itemEdit)\">Not Assigned</h2>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <input type=\"text\" ng-model=\"itemEdit.customerRefNo\" ng-if=\"userCanDoAction('editCustomerRefNo', itemEdit)\">\n    </md-input-container>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField\">\n    <h1>Notes</h1>\n    <md-input-container class=\"md-block\" flex-gt-sm>\n      <textarea ng-model=\"itemEdit.notes\" ng-disabled=\"!userCanDoAction('editOrderNotes', itemEdit)\" aria-label=\"Order Notes\" rows=\"3\" md-select-on-focus ng-disabled=\"!itemEdit.editing\"></textarea>\n    </md-input-container>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField {{userCanDoAction('changeOrderSupplier', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeOrderSupplier', itemEdit) || selectCompany('supplierContact')\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeOrderSupplier', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Supplier</h1>\n    <h2 ng-if=\"itemEdit.supplierContact\">{{itemEdit.supplierContact.displayName}}</h2>\n    <h3 ng-if=\"itemEdit.supplierContact\">{{stringifyAddress(itemEdit.supplierContact.addresses[0])}}</h3>\n    <h2 ng-if=\"!itemEdit.supplierContact && userCanDoAction('changeOrderSuppler', itemEdit)\">Click to select</h2>\n    <h2 ng-if=\"!itemEdit.supplierContact && !userCanDoAction('changeOrderSupplier', itemEdit)\">Not Assigned</h2>\n  </div>\n</div>\n<div class=\"ojdRow\">\n  <div class=\"ojdField {{userCanDoAction('changeOrderCustomer', itemEdit) ? 'editable':'disabled'}}\" ng-click=\"!userCanDoAction('changeOrderCustomer', itemEdit) || selectCompany('customerContact')\">\n    <div class=\"fieldEditIcon\" ng-if=\"userCanDoAction('changeOrderCustomer', itemEdit)\">\n      <md-icon md-svg-src=\"edit.svg\"></md-icon>\n    </div>\n    <h1>Customer</h1>\n    <h2 ng-if=\"itemEdit.customerContact\">{{itemEdit.customerContact.displayName}}</h2>\n    <h3 ng-if=\"itemEdit.customerContact\">{{stringifyAddress(itemEdit.customerContact.addresses[0])}}</h3>\n    <h2 ng-if=\"!itemEdit.customerContact && userCanDoAction('changeOrderCustomer', itemEdit)\">Click to select</h2>\n    <h2 ng-if=\"!itemEdit.customerContact && !userCanDoAction('changeOrderCustomer', itemEdit)\">Not Assigned</h2>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Ygf5":
/***/ (function(module, exports) {

var path = 'views/modals/mobileLineItemModal.html';
var html = "<!-- Line Item Detail modal -->\n<div class=\"niceModal\" id=\"lineItemModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1 ng-show=\"!lineItemDetail.new\">Edit Item</h1>\n      <h1 ng-show=\"lineItemDetail.new\">New Item</h1>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeLineItemModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            <span ng-show=\"!lineItemDetail.new && !lineItemDetail.jobView && !lineItemDetail.readOnly\">Edit Item</span>\n            <span ng-show=\"lineItemDetail.new && !lineItemDetail.jobView && !lineItemDetail.readOnly\">New Item</span>\n            <span ng-show=\"lineItemDetail.readOnly\">View Item</span>\n            <span ng-show=\"lineItemDetail.jobView\">Item</span>\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"lineItemForm.$invalid || saveLineItem()\" ng-show=\"!lineItemDetail.readOnly\">Save</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"lineItemForm\" novalidate>\n        <div class=\"itemDetailModalOuter\">\n          <div class=\"itemDetailModalHeader\" ng-if=\"!lineItemDetail.customerCreated\">\n            <h1 ng-show=\"lineItemDetail.resource\">{{lineItemDetail.resource.name}}</h1>\n            <h3 ng-show=\"lineItemDetail.resource\">{{lineItemDetail.resource.identifier}}</h3>\n            <h1 class=\"selectResource\" ng-show=\"!lineItemDetail.resource\">Select a Resource</h1>\n            <div class=\"btn btn-sm btn-rounded btn-outline white\" ng-show=\"!lineItemDetail.resource && !lineItemDetail.resourceLocked && !lineItemDetail.jobView && !lineItemDetail.readOnly\" ng-click=\"selectResource()\">Select</div>\n          </div>\n          <div class=\"itemDetailModalPart normal\" ng-show=\"!lineItemDetail.resource && !lineItemDetail.customerCreated\">\n            Please select a resource to continue\n          </div>\n          <div class=\"itemDetailModalPart quantity\" ng-show=\"lineItemDetail.resource\">\n            <!--<md-input-container class=\"md-block\" flex-gt-sm>\n              <input ng-model=\"lineItemDetail.quantityEdit\" ng-show=\"!(lineItemDetail.resource.uom.abbreviation == 'hm' || lineItemDetail.resource.uom.abbreviation == 'hrsmins')\">\n              <input ng-model=\"lineItemDetail.quantityHoursEdit\" ng-show=\"lineItemDetail.resource.uom.abbreviation == 'hm' || lineItemDetail.resource.uom.abbreviation == 'hrsmins'\">\n              <input ng-model=\"lineItemDetail.quantityMinutesEdit\" ng-show=\"lineItemDetail.resource.uom.abbreviation == 'hm' || lineItemDetail.resource.uom.abbreviation == 'hrsmins'\">\n            </md-input-container>-->\n            <div class=\"detailPartContent\">\n              <md-input-container class=\"md-block\" ng-disabled=\"lineItemDetail.readOnly\">\n                <input type=\"number\" ng-model=\"lineItemDetail.quantityEdit\" id=\"quantityKeypadField\" aria-label=\"Quantity Value\" ng-disabled=\"lineItemDetail.readOnly\">\n              </md-input-container>\n              <h2>{{lineItemDetail.resource.uom.description}}</h2>\n            </div>\n          </div>\n          <div class=\"itemDetailModalPart normal\">\n            <h3>Description</h3>\n            <md-input-container class=\"md-block\" ng-show=\"!lineItemDetail.readOnly\">\n              <textarea ng-model=\"lineItemDetail.itemDescription\" rows=\"4\" md-select-on-focus aria-label=\"Line Description\"></textarea>\n            </md-input-container>\n            <p ng-show=\"lineItemDetail.readOnly\">\n              {{lineItemDetail.itemDescription}}\n            </p>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </form>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n</div>\n<!-- End Line Item Detail modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Yixd":
/***/ (function(module, exports) {

var path = 'views/modals/editUserModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"editUserModal\">\n    <div class=\"modalContainer\">\n      <div class=\"header hidden-xs\">\n        <h1>Edit User</h1>\n        <div class=\"headerCloseButton\" ng-click=\"cancel()\">\n          <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div class=\"content noPadding\">\n\n        <!-- Start Summary Section -->\n        <div class=\"ojdDesktopSection white\">\n          <div class=\"ojdDesktopRow\">\n            <div class=\"ojdDesktopField\">\n              <label class=\"order\">Name</label>\n              <h3>{{member.name.full}}</h3>\n            </div>\n            <div class=\"ojdDesktopField\">\n              <label class=\"order\">Primary Contact</label>\n              <h3>{{member.emailAddress}}</h3>\n            </div>\n          </div>\n          <div class=\"ojdDesktopRow\">\n            <div class=\"ojdDesktopField\">\n              <md-input-container class=\"md-block\" flex-gt-sm=\"10\" aria-label=\"Super User\">\n                <md-checkbox ng-checked=\"superUser\" ng-click=\"toggleSuperUser()\" aria-label='Super User' style=\"width: 150px; white-space: pre;\">\n                  Super User\n                  <md-icon md-svg-icon=\"help.svg\">\n                    <md-tooltip>Has access to global and billing settings for the company</md-tooltip>\n                  </md-icon>\n                </md-checkbox>\n              </md-input-container>\n            </div>\n            <div class=\"ojdDesktopField\">\n              <div class=\"dbButton whiteOutline\" ng-click=\"removeUser()\">Remove User</div>\n            </div>\n          </div>\n        </div>\n        <!-- End Summary Section -->\n\n        <div ng-if=\"superUser\" class=\"modalFormTableHeader\">\n          Super user has access to all groups.\n        </div>\n\n        <div ng-if=\"!superUser\">\n          <div class=\"modalFormTableHeader\" style=\"padding-bottom: 0px;\">\n            <h2>Group Access</h2>\n          </div>\n\n          <md-table-container>\n            <table md-table>\n              <thead md-head>\n                <tr md-row>\n                  <th md-column>Group</th>\n                  <th md-column>Role</th>\n                  <th md-column>\n                    <span style=\"white-space: pre;\">Monitor </span>\n                    <md-icon md-svg-icon=\"help.svg\">\n                      <md-tooltip>Receives notifications for new orders, jobs and dockets sent to this group</md-tooltip>\n                    </md-icon>\n                  </th>\n                  <th md-column>\n                    <span style=\"white-space: pre;\">Group Super User </span>\n                    <md-icon md-svg-icon=\"help.svg\">\n                      <md-tooltip>Overrides role assignment giving full access to this group</md-tooltip>\n                    </md-icon>\n                  </th>\n                  <th md-column class=\"iconColumn\"></th>\n                </tr>\n              </thead>\n              <tbody md-body style=\"max-width: 100%;\">\n                <tr md-row ng-repeat=\"membership in groupsMemberships\">\n\n                  <!-- Group -->\n                  <td md-cell style=\"max-width: 300px;\">\n                    <span ng-if=\"membership.original != null\">{{getGroupsText(membership)}}</span>\n                    <md-input-container class=\"md-block\" ng-if=\"membership.original == null\">\n                      <md-select ng-model=\"membership.groups\" placeholder=\"Select Groups\" required multiple md-selected-html=\"getGroupsText(membership)\">\n                        <md-option ng-click='allGroupsClick(membership)' ng-value=\"'All Groups'\">\n                          All Groups\n                        </md-option>\n                        <md-option ng-repeat=\"group in currentOrg.groups\" ng-value=\"group.id\">\n                          {{group.parents.length == 0 ? 'Main Group' : group.name}}\n                        </md-option>\n                      </md-select>\n                    </md-input-container>\n                  </td>\n\n                  <!-- Role -->\n                  <td md-cell>\n                    <md-input-container class=\"md-block\">\n                      <md-select ng-model=\"membership.roles\" placeholder=\"Select a role\" required multiple md-selected-html=\"getRolesText(membership)\">\n                        <md-option ng-repeat=\"role in allRoles\" ng-value=\"role.id\" ng-disabled=\"membership.original != null && membership.groups[0] == rootGroup.id && membership.roles.length == 1 && membership.roles[0] == role.id\" ng-click=\"roleSelect(membership, role)\">\n                          {{role.name}}\n                        </md-option>\n                      </md-select>\n                    </md-input-container>\n                  </td>\n\n                  <td md-cell>\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"10\" aria-label=\"Monitor\">\n                      <md-checkbox md-indeterminate='monitorsAny(membership) && !monitorsAll(membership)' ng-checked=\"monitorsAll(membership)\" ng-click=\"toggleMonitor(membership)\" aria-label='Monitor'></md-checkbox>\n                    </md-input-container>\n                  </td>\n                  <td md-cell>\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"10\" aria-label=\"Administrator\">\n                      <md-checkbox md-indeterminate='adminsAny(membership) && !adminsAll(membership)' ng-checked=\"adminsAll(membership)\" ng-click=\"toggleAdmin(membership)\" aria-label='Administrator'></md-checkbox>\n                    </md-input-container>\n                  </td>\n                  <td md-cell>\n                    <md-button ng-if=\"membership.original == null || membership.groups[0] != rootGroup.id\" class=\"md-icon-button\" ng-click=\"removeMembership(membership)\" aria-label=\"Remove Access\">\n                      <md-icon ng-hide=\"group.parents.length == 0\" md-svg-icon=\"delete.svg\"></md-icon>\n                    </md-button>\n                  </td>\n                </tr>\n                <tr md-row>\n                  <td md-cell colspan=\"5\" style=\"text-align: center; padding: 15px;\">\n                    <div class=\"dbButton grey\" ng-click=\"addMembership()\">Add Another</div>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\"></div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"cancel()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"saving || saveUser()\" ng-disabled=\"saving\">\n              <span ng-hide=\"saving\">Save</span>\n              <md-progress-circular ng-show=\"saving\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "Yk9E":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roles.svg";

/***/ }),

/***/ "Ypfo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('mobileListController', ['orderService', 'jobService', 'docketService', 'userService', '$rootScope', '$location', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$window', function (orderService, jobService, docketService, userService, $rootScope, $location, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $window) {

  /***************************/
  /***** Setup Variables *****/
  /***************************/
  $scope.moment = _momentTimezone2.default;
  $scope.currentState = $state.current;
  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.hasSampleCompany = accessControl.hasSampleCompany();

  // Tab bar stuff
  $scope.listView = $state.current.data.listView;

  mixpanel.track("Opened " + $scope.listView + " Mobile");

  $scope.preventDocketsLoad = true;
  $scope.preventJobsLoad = true;
  $scope.preventOrdersLoad = true;
  $scope.preventFilingLoad = true;

  $scope.unverifiedEmail = undefined;
  $scope.unverifiedPhone = undefined;

  // Filters initial
  $scope.docketFilters = {};
  $scope.docketFilters.otherParty = "All";
  $scope.docketFilters.statusTab = "All";
  $scope.docketFilters.status = "All";
  $scope.docketFilters.organisation = "All";
  $scope.docketFilters.fromDate = null; //moment().subtract(7,'days').toDate();
  $scope.docketFilters.toDate = null;
  $scope.docketFilters.customerGroup = null;
  $scope.docketFilters.supplierGroup = null;
  $scope.docketFilters.limit = 10;
  $scope.docketFilters.offset = 0;
  $scope.docketsLoadingError = null;

  $scope.jobFilters = {};
  $scope.jobFilters.status = 'All';
  $scope.jobFilters.startFromDate = null; // moment().subtract(7,'days').toDate();
  $scope.jobFilters.startToDate = null;
  $scope.jobFilters.endFromDate = null; //moment().subtract(7,'days').toDate();
  $scope.jobFilters.endToDate = null;
  $scope.jobFilters.customer = 'All';
  $scope.jobFilters.assignee = 'All';
  $scope.jobFilters.assigneeList = [];
  $scope.jobFilters.limit = 10;
  $scope.jobFilters.offset = 0;
  $scope.jobsLoadingError = null;

  $scope.orderFilters = {};
  $scope.orderFilters.status = 'All';
  $scope.orderFilters.startFromDate = null; // moment().subtract(7,'days').toDate();
  $scope.orderFilters.startToDate = null;
  $scope.orderFilters.endFromDate = null; //moment().subtract(7,'days').toDate();
  $scope.orderFilters.endToDate = null;
  $scope.orderFilters.customer = 'All';
  $scope.orderFilters.assignee = 'All';
  $scope.orderFilters.assigneeList = [];
  $scope.orderFilters.limit = 10;
  $scope.orderFilters.offset = 0;
  $scope.ordersLoadingError = null;

  $scope.filingFilters = {};
  $scope.filingFilters.status = null; //"accepted";
  $scope.filingFilters.statusTab = "All";
  $scope.filingFilters.fromDate = null; //moment().subtract(7,'days').toDate();
  $scope.filingFilters.toDate = null;
  $scope.filingFilters.limit = 10;
  $scope.filingFilters.offset = 0;
  $scope.filingLoadingError = null;

  //if the user doesn't have any verified principals, when we should display a banner
  //telling them their account is unverified
  if ($scope.currentUser.unverifiedPrincipals) {
    var unverifiedOverlap = $scope.currentUser.emailAddresses.filter(function (address) {
      return $scope.currentUser.unverifiedPrincipals.indexOf(address) === -1;
    });
    if (unverifiedOverlap.length === 0) {
      //all their principals are waiting validation - show a banner appropiate for the first principal
      //i.e. email principal requires them to check their email inbox
      //phone number requires them to visit the my account area to validate
      var target = $scope.currentUser.unverifiedPrincipals[0];
      if (target.indexOf('users.docketbook.io') !== -1) {
        //its a phone number
        $scope.unverifiedPhone = "0" + target.split('@')[0].substring(3);
      } else {
        $scope.unverifiedEmail = target;
      }
    }
  }

  // Include responsive utilities and UI Functionality
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  $scope.userCanDoAction = userService.userCanDoAction;

  /******** TEST ORG SCOPE *********/
  $scope.organisations = accessControl.allowedOrganisations();

  $rootScope.$on('OrganisationsListRefreshed', function () {
    $scope.organisations = accessControl.allowedOrganisations();
  });

  $scope.onboardingSessions = accessControl.onboardingSessions();

  $rootScope.$on('ScopeUpdated', function () {
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.hasSampleCompany = accessControl.hasSampleCompany();
    $scope.isSampleCompany = accessControl.isSampleCompany();
    $scope.closeScopeDropdown();
  });

  $scope.goToMyDocketbook = function () {
    $state.go('main.dockets');
  };

  $scope.goToOnbboardingSession = function (session) {
    window.location.href = '/onboarding/' + (session == undefined ? '' : session.id);
  };

  $scope.showWaitToBeInvitedModal = function () {
    $('#waitToBeInvitedModal').fadeIn(100);
  };

  $scope.closeWaitToBeInvitedModal = function () {
    $('#waitToBeInvitedModal').fadeOut(100);
  };

  /* Create a new company */
  $scope.newCompany = function (isSampleCompany) {
    $scope.closeScopeDropdown();
    $scope.createNewCompanyFromParent(isSampleCompany, function (newOrg) {
      if (newOrg != null) {
        $state.go('main.groupDashboard', { orgId: newOrg.id });
      }
    });
  };

  /*** My Docketbook Active Jobs/Dockets Feed List ***/
  $scope.loadActiveFeed = function () {
    if ($scope.listView == 'feed' && $scope.currentOrg == null) {
      jobService.getJobs({ activeDate: (0, _momentTimezone2.default)().format('YYYY-MM-DD'), limit: 2 }, function (jobsList) {
        $scope.activeJobsToday = jobService.parseJobs(jobsList);
        jobService.populateJobDetails($scope.activeJobsToday, function () {});
      }, function (err) {
        $scope.activeJobsToday = [];
      });
      jobService.getJobs({ activeDate: (0, _momentTimezone2.default)().add(1, 'days').format('YYYY-MM-DD'), limit: 2 }, function (jobsList) {
        $scope.activeJobsTomorrow = jobService.parseJobs(jobsList);
        jobService.populateJobDetails($scope.activeJobsTomorrow, function () {});
      }, function (err) {
        $scope.activeJobsTomorrow = [];
      });
      docketService.getDockets({ date: (0, _momentTimezone2.default)().format('YYYY-MM-DD'), limit: 2 }, function (docketsList) {
        $scope.activeDocketsToday = docketService.parseDockets(docketsList);
        docketService.populateDocketsForFeed($scope.activeDocketsToday, function () {});
      }, function (err) {
        $scope.activeDocketsToday = [];
      });
      docketService.getDockets({ date: (0, _momentTimezone2.default)().add(1, 'days').format('YYYY-MM-DD'), limit: 2 }, function (docketsList) {
        $scope.activeDocketsTomorrow = docketService.parseDockets(docketsList);
        docketService.populateDocketsForFeed($scope.activeDocketsTomorrow, function () {});
      }, function (err) {
        $scope.activeDocketsTomorrow = [];
      });
    }
  };

  $scope.loadActiveFeed();

  /*** ORG SCOPE FUNCTIONS - FOR MOBILE ****/
  $scope.openScopeDropdown = function () {
    $(".mobileSideNav").animate({
      left: "0px"
    }, 400);
    /*$("body").addClass('noscroll');*/
  };

  $scope.closeScopeDropdown = function () {
    $(".mobileSideNav").animate({
      left: "-90%"
    }, 400);
    /*$("body").removeClass('noscroll');*/
  };

  $scope.openOrgUnits = function (orgId) {
    if ($("#org" + orgId + " ul.inner").css('display') == 'none') {
      $("#org" + orgId + " ul.inner").slideDown();
    } else {
      $("#org" + orgId + " ul.inner").slideUp();
    }
  };

  $scope.openUserDropdown = function () {
    if ($(".userDropdown").css('display') == 'none') {
      $(".userDropdown").slideDown();
      $(".currentUserControl").addClass('open');
    } else {
      $(".userDropdown").slideUp();
      $(".currentUserControl").removeClass('open');
    }
  };

  $scope.changeOrganisation = function (org) {
    if (org != null) {
      var locatedOrgGroup = null;
      for (var i = 0; i < org.groups.length; i++) {
        if (org.groups[i].parent == null) {
          locatedOrgGroup = org.groups[i];
          break;
        }
      }
      if (locatedOrgGroup == null && org.groups && org.groups.length > 0) {
        locatedOrgGroup = org.groups[0];
      }
      $scope.changeOrganisationGroup(org, locatedOrgGroup);
    } else {
      $state.go('main.dashboard');
    }
  };

  $scope.changeOrganisationGroup = function (org, orgGroup) {
    accessControl.getOrgPagePermissions(org, orgGroup, function (res) {
      var permissions = res.permissions[$scope.currentUser.id];
      if (permissions.indexOf('group-owner') != -1 || permissions.indexOf('global-administrator') != -1) {
        $state.go('main.groupOrders', { orgId: org.id, groupId: orgGroup.id });
      } else if (permissions.indexOf('io.docketbook.ojdapi.getOrder') != -1) {
        $state.go('main.groupOrders', { orgId: org.id, groupId: orgGroup.id });
      } else if (permissions.indexOf('io.docketbook.ojdapi.getJob') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyJob') != -1) {
        $state.go('main.groupJobs', { orgId: org.id, groupId: orgGroup.id });
      } else if (permissions.indexOf('io.docketbook.ojdapi.getDocket') != -1 || permissions.indexOf('io.docketbook.ojdapi.getMyDocket') != -1) {
        $state.go('main.groupDockets', { orgId: org.id, groupId: orgGroup.id });
      } else {
        $state.go('main.groupDashboard', { orgId: org.id, groupId: orgGroup.id });
      }
    });
  };

  $scope.logout = function () {
    window.location.href = "/v1/logout";
  };

  /******** END TEST ORG SCOPE STUFF ************/
  /*************************/
  /***** Intercom JS API  **/
  /*************************/

  $scope.openIntercom = function () {
    window.FreshworksWidget('open', 'ticketForm');
  };

  /***********************/
  /***** Permissions *****/
  /***********************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /**************************************************************************/
  /********************************** Dockets *******************************/
  /**************************************************************************/

  /*************************************/
  /***** Docket List View Controls *****/
  /*************************************/

  // Load Dockets Into List Controller
  $scope.loadDocketsIntoList = function () {
    $scope.docketsLoadingError = null;
    $scope.prepareForDocketsFromParent();
    $scope.getDocketsListFiltered(function (docketsList) {
      var docketsListParsed = docketService.parseDockets(docketsList);
      $scope.loadDocketsListFromParent(docketsListParsed);
      $scope.preventDocketsLoad = false;
    }, function (err) {
      $scope.docketsLoadingError = err;
      $scope.preventDocketsLoad = false;
    });
  };

  // Load more dockets into list
  $scope.loadNextPageOfDockets = function (cb) {
    if ($scope.preventDocketsLoad) {
      cb();
      return;
    } else {
      $scope.docketFilters.offset = $scope.docketFilters.offset + $scope.docketFilters.limit;
      // get the next page of dockets
      $scope.getDocketsListFiltered(function (docketsList) {
        if (docketsList.length == 0) {
          $scope.preventDocketsLoad = true;
          cb();
          return;
        }
        var docketsListParsed = docketService.parseDockets(docketsList);
        $scope.loadAdditionalDocketsFromParent(docketsListParsed);
        $scope.preventDocketsLoad = false;
        cb();
      });
    }
  };

  // When child (listController) controller is ready - load initial list of dockets
  $scope.docketsChildControllerReady = function () {
    if ($scope.listView == 'dockets') {
      $scope.loadDocketsIntoList();
      $scope.bindScrollWatcher();
    }
  };

  // Get dockets
  $scope.getDocketsListFiltered = function (successCb, failureCb) {
    var params = {};
    if ($scope.docketFilters.fromDate != null) {
      var fromDate = (0, _momentTimezone2.default)($scope.docketFilters.fromDate);
      fromDate.set({ 'hour': '0', 'minute': '0', 'second': '1' });
      params.fromDate = fromDate.toISOString();
    }
    if ($scope.docketFilters.toDate != null) {
      var toDate = (0, _momentTimezone2.default)($scope.docketFilters.toDate);
      toDate.set({ 'hour': '23', 'minute': '23', 'second': '59' });
      params.toDate = toDate.toISOString();
    }
    if ($scope.docketFilters.status != 'All') {
      params.status = $scope.docketFilters.status;
    }
    if ($scope.docketFilters.customerGroup != null) {
      params.customerGroup = $scope.docketFilters.customerGroup;
    }
    if ($scope.docketFilters.supplierGroup != null) {
      params.supplierGroup = $scope.docketFilters.supplierGroup;
    }
    if ($scope.docketFilters.otherParty != 'All') {
      if ($scope.docketFilters.otherParty.organisationGroup != null) {
        params.otherParty = $scope.docketFilters.otherParty.organisationGroup;
      } else {
        var parsed = JSON.parse($scope.docketFilters.otherParty);
        if (parsed.organisationGroup) {
          params.otherParty = parsed.organisationGroup;
        } else {
          params.otherParty = parsed.id;
        }
      }
    }

    params['sort'] = 'date';
    params['limit'] = $scope.docketFilters.limit;
    params['offset'] = $scope.docketFilters.offset;

    docketService.getDockets(params, function (response) {
      successCb(response);
    }, function (err) {
      failureCb("Error Loading Dockets");
      return;
    });
  };

  /********************************/
  /****** Docket Data Helpers *****/
  /********************************/

  $scope.deleteDocketSwipe = function (docket) {
    // confirm docket deletion before calling to service
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this docket!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel plx!",
      closeOnConfirm: false,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteDocket(docket, function (success) {
          swal("Deleted!", "Docket " + docket.docketNumber + " has been deleted.", "success");
          $scope.loadDocketsIntoList();
        }, function (error) {
          alert('error deleting docket!');
        });
      }
    });
  };

  $scope.sendDocketSwipe = function (docket) {
    docketService.sendDocket(docket, function (success) {
      $scope.loadDocketsIntoList();
    }, function (error) {
      alert('error sending docket!');
    });
  };

  $scope.rejectDocketSwipe = function (docket) {
    docketService.rejectDocket(docket, function (success) {
      $scope.loadDocketsIntoList();
    }, function (error) {
      alert('error rejecting docket!');
    });
  };

  $scope.acceptDocketSwipe = function (docket) {
    docketService.acceptDocket(docket, function (success) {
      $scope.loadDocketsIntoList();
    }, function (error) {
      alert('error accepting docket!');
    });
  };

  $scope.acceptAndFileDocketSwipe = function (docket) {
    docketService.acceptDocket(docket, function (success) {
      $state.go('main.filingDetail', { docketId: docket.id });
    }, function (error) {
      alert('error accepting docket!');
      $scope.showToast('Error Accepting Docket');
    });
  };

  $scope.fileDocketSwipe = function (docket) {
    var url = "/dockets?";
  };

  /***************************************/
  /***** Docket List Filter Controls *****/
  /***************************************/

  $scope.resetDocketFilters = function () {
    $scope.docketFilters = {};
    $scope.docketFilters.otherParty = "All";
    $scope.docketFilters.statusTab = "All";
    $scope.docketFilters.status = "All";
    $scope.docketFilters.organisation = "All";
    $scope.docketFilters.fromDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.docketFilters.toDate = null;
    $scope.docketFilters.customerGroup = null;
    $scope.docketFilters.supplierGroup = null;
  };

  /**************************/
  /***** Filter Helpers *****/
  /**************************/

  $scope.setDateFilterFromPreset = function (filters, preset) {
    if (preset == 'today') {
      filters.fromDate = new Date();
      filters.toDate = null;
    } else if (preset == 'yesterday') {
      filters.fromDate = (0, _momentTimezone2.default)().add(-1, 'days').toDate();
      filters.toDate = (0, _momentTimezone2.default)().add(-1, 'days').toDate();
    } else if (preset == 'week') {
      filters.fromDate = (0, _momentTimezone2.default)().add(-7, 'days').toDate();
      filters.toDate = null;
    }
  };

  $scope.setComplexFilter = function (filterName) {
    if (filterName == 'sentDockets') {
      $scope.filters.statusTab = "Sent";
      $scope.filters.status = "Sent";
      $scope.filters.supplierGroup = $scope.currentOrgGroup.id;
      $scope.filters.customerGroup = null;
    } else if (filterName == 'recievedDockets') {
      $scope.filters.statusTab = "Recieved";
      $scope.filters.status = "Sent";
      $scope.filters.customerGroup = $scope.currentOrgGroup.id;
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'draftDockets') {
      $scope.filters.statusTab = "Draft";
      $scope.filters.status = "Draft";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'acceptedDockets') {
      $scope.filters.statusTab = "Accepted";
      $scope.filters.status = "Accepted";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'rejectedDockets') {
      $scope.filters.statusTab = "Rejected";
      $scope.filters.status = "Rejected";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    } else if (filterName == 'allDockets') {
      $scope.filters.statusTab = "All";
      $scope.filters.status = "All";
      $scope.filters.customerGroup = null;
      $scope.filters.supplierGroup = null;
    }
  };

  $scope.clearFilterDateSet = function (firstDate, secondDate) {
    $scope.filters[firstDate] = null;
    $scope.filters[secondDate] = null;
  };

  /*******************************/
  /**** Filters Bottom Sheet *****/
  /*******************************/

  $scope.openDocketFiltersSheet = function () {
    $scope.filtersEdit = angular.copy($scope.docketFilters);

    $mdBottomSheet.show({
      templateUrl: 'views/pages/dockets/mobile/filterBottomSheet.html',
      scope: $scope,
      preserveScope: true
    }).then(function () {
      // update changed filters
      $scope.docketFilters = $scope.filtersEdit;
      $scope.loadDocketsIntoList();
    }, function () {
      // update changed filters
      $scope.docketFilters = $scope.filtersEdit;
      $scope.loadDocketsIntoList();
    });
  };

  /**************************************************************************/
  /**************************************** JOBS ****************************/
  /**************************************************************************/

  /***********************************/
  /***** Jobs List View Controls *****/
  /***********************************/

  // Load Jobs Into List Controller
  $scope.loadJobsIntoList = function () {
    $scope.jobsLoadingError = null;
    $scope.prepareForJobsFromParent();
    $scope.getJobsListFiltered(function (jobsList) {
      var jobsListParsed = jobService.parseJobs(jobsList);
      $scope.loadJobsListFromParent(jobsListParsed);
      $scope.preventJobsLoad = false;
    }, function (err) {
      $scope.jobsLoadingError = err;
      $scope.preventJobsLoad = false;
    });
  };

  // Load more jobs into list
  $scope.loadNextPageOfJobs = function (cb) {
    if ($scope.preventJobsLoad) {
      cb();
      return;
    }
    $scope.jobFilters.offset = $scope.jobFilters.offset + $scope.jobFilters.limit;
    // get the next page of dockets
    $scope.getJobsListFiltered(function (jobsList) {
      if (jobsList.length == 0) {
        $scope.preventJobsLoad = true;
        cb();
        return;
      }
      var jobsListParsed = jobService.parseJobs(jobsList);
      $scope.loadAdditionalJobsFromParent(jobsListParsed);
      cb();
      $scope.preventJobsLoad = false;
    });
  };

  // When child (listController) controller is ready - load initial list of jobs
  $scope.jobsChildControllerReady = function () {
    if ($scope.listView == 'jobs') {
      $scope.loadJobsIntoList();
      $scope.bindScrollWatcher();
    }
  };

  $scope.getJobsListFiltered = function (successCb, failureCb) {
    var params = {};
    if ($scope.jobFilters.startFromDate != null) {
      var startFromDate = (0, _momentTimezone2.default)($scope.jobFilters.startFromDate);
      startFromDate.set({ 'hour': '0', 'minute': '0', 'second': '1' });
      params.startFromDate = startFromDate.toISOString();
    }
    if ($scope.jobFilters.startToDate != null) {
      var startToDate = (0, _momentTimezone2.default)($scope.jobFilters.startToDate);
      startToDate.set({ 'hour': '23', 'minute': '59', 'second': '59' });
      params.startToDate = startToDate.toISOString();
    }
    if ($scope.jobFilters.endFromDate != null) {
      var endFromDate = (0, _momentTimezone2.default)($scope.jobFilters.endFromDate);
      endFromDate.set({ 'hour': '0', 'minute': '0', 'second': '1' });
      params.endFromDate = endFromDate.toISOString();
    }
    if ($scope.jobFilters.endToDate != null) {
      var endToDate = (0, _momentTimezone2.default)($scope.jobFilters.endToDate);
      endToDate.set({ 'hour': '23', 'minute': '59', 'second': '59' });
      params.endToDate = endToDate.toISOString();
    }
    if ($scope.jobFilters.customer != 'All' && $scope.jobFilters.customer != null) {
      params.customer = $scope.jobFilters.customer;
    }
    if ($scope.jobFilters.assignee != 'All' && $scope.jobFilters.assignee != null) {
      if ($scope.jobFilters.assignee == 'Me') {
        params.assignee = $scope.currentUser.id;
      } else {
        // generate uuid list of assignees
        var uuidList = [];
        for (var i = 0; i < $scope.jobFilters.assigneeList.length; i++) {
          uuidList.push($scope.jobFilters.assigneeList[i].id);
        }
        params.assignee = uuidList;
      }
    }
    if ($scope.jobFilters.status != 'All') {
      params.status = $scope.jobFilters.status;
    }
    params['sort'] = 'jobNumber';
    params['limit'] = $scope.jobFilters.limit;
    params['offset'] = $scope.jobFilters.offset;

    jobService.getJobs(params, function (response) {
      successCb(response);
      return;
    }, function (err) {
      failureCb("Error Loading Jobs");
      return;
    });
  };

  /****************************/
  /**** Jobs Data Helpers *****/
  /****************************/

  $scope.sendJobSwipe = function (job) {
    jobService.sendJob(job, function (success) {
      $scope.loadJobsIntoList();
    }, function (error) {
      alert('error sending job!');
    });
  };

  $scope.deleteJobSwipe = function (job) {
    jobService.deleteJob(job, function (success) {
      $scope.loadJobsIntoList();
    }, function (error) {
      alert('error deleting job!');
    });
  };

  $scope.assigneeChangeStatusSwipe = function (job, statusTo, method) {
    if (statusTo == 'Rejected') {
      swal({
        title: "Reject Job " + job.jobNumber,
        text: "Please provide a reason for rejecting this job.",
        type: "input",
        showCancelButton: true,
        closeOnConfirm: true,
        inputPlaceholder: "Reason"
      }, function (inputValue) {
        if (inputValue === false) {
          return;
        }
        jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, inputValue, function (success) {
          // status change successful - reload jobs list
          $scope.showToast('Job Status Updated');
          $scope.loadJobsIntoList();
        }, function (err) {
          $scope.showToast("Job Status Update Failed");
        });
      });
    } else {
      jobService.assigneeStatusChange(job, job.userAssigneeData.assignee, statusTo, null, function (success) {
        // status change successful - reload jobs list
        $scope.showToast("Job Status Updated");
        $scope.loadJobsIntoList();
      }, function (err) {
        $scope.showToast("Job Status Update Failed");
      });
    }
  };

  /***************************************/
  /***** Docket List Filter Controls *****/
  /***************************************/

  $scope.resetJobFilters = function () {
    $scope.jobFilters = {};
    $scope.jobFilters.status = 'All';
    $scope.jobFilters.startFromDate = null; // moment().subtract(7,'days').toDate();
    $scope.jobFilters.startToDate = null;
    $scope.jobFilters.endFromDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.jobFilters.endToDate = null;
    $scope.jobFilters.customer = 'All';
    $scope.jobFilters.assignee = 'All';
    $scope.jobFilters.assigneeList = [];
  };

  /*******************************/
  /**** Filters Bottom Sheet *****/
  /*******************************/

  $scope.openJobFiltersSheet = function () {
    $scope.filtersEdit = angular.copy($scope.jobFilters);

    $mdBottomSheet.show({
      templateUrl: 'views/pages/jobs/mobile/filterBottomSheet.html',
      scope: $scope,
      preserveScope: true
    }).then(function () {
      // update changed filters
      $scope.jobFilters = $scope.filtersEdit;
      $scope.loadJobsIntoList();
    }, function () {
      // update changed filters
      $scope.jobFilters = $scope.filtersEdit;
      $scope.loadJobsIntoList();
    });
  };

  /**************************************************************************/
  /********************************** Orders ********************************/
  /**************************************************************************/

  /*************************************/
  /***** Orders List View Controls *****/
  /*************************************/

  // Load Orders Into List Controller
  $scope.loadOrdersIntoList = function () {
    $scope.ordersLoadingError = null;
    $scope.prepareForOrdersFromParent();
    $scope.getOrdersListFiltered(function (ordersList) {
      var ordersListParsed = orderService.parseOrders(ordersList);
      $scope.loadOrdersListFromParent(ordersListParsed);
      $scope.preventOrdersLoad = false;
    }, function (err) {
      $scope.ordersLoadingError = err;
      $scope.preventOrdersLoad = false;
    });
  };

  // Load more orders into list
  $scope.loadNextPageOfOrders = function (cb) {
    if ($scope.preventOrdersLoad) {
      cb();
      return;
    }
    $scope.orderFilters.offset = $scope.orderFilters.offset + $scope.orderFilters.limit;
    // get the next page of orders
    $scope.getOrdersListFiltered(function (ordersList) {
      if (ordersList.length == 0) {
        $scope.preventOrdersLoad = true;
        cb();
        return;
      }
      var ordersListParsed = orderService.parseOrders(ordersList);
      $scope.loadAdditionalOrdersFromParent(ordersListParsed);
      cb();
      $scope.preventOrdersLoad = false;
    });
  };

  // When child (listController) controller is ready - load initial list of orders
  $scope.ordersChildControllerReady = function () {
    if ($scope.listView == 'orders') {
      $scope.loadOrdersIntoList();
      $scope.bindScrollWatcher();
    }
  };

  $scope.getOrdersListFiltered = function (successCb, failureCb) {
    var params = {};
    if ($scope.orderFilters.startFromDate != null) {
      var startFromDate = (0, _momentTimezone2.default)($scope.orderFilters.startFromDate);
      startFromDate.set({ 'hour': '0', 'minute': '0', 'second': '1' });
      params.startFromDate = startFromDate.toISOString();
    }
    if ($scope.orderFilters.startToDate != null) {
      var startToDate = (0, _momentTimezone2.default)($scope.orderFilters.startToDate);
      startToDate.set({ 'hour': '23', 'minute': '59', 'second': '59' });
      params.startToDate = startToDate.toISOString();
    }
    if ($scope.orderFilters.endFromDate != null) {
      var endFromDate = (0, _momentTimezone2.default)($scope.orderFilters.endFromDate);
      endFromDate.set({ 'hour': '0', 'minute': '0', 'second': '1' });
      params.endFromDate = endFromDate.toISOString();
    }
    if ($scope.orderFilters.endToDate != null) {
      var endToDate = (0, _momentTimezone2.default)($scope.orderFilters.endToDate);
      endToDate.set({ 'hour': '23', 'minute': '59', 'second': '59' });
      params.endToDate = endToDate.toISOString();
    }
    if ($scope.orderFilters.status != 'All') {
      params.status = $scope.orderFilters.status;
    }
    params['prioritizePending'] = true;
    params['limit'] = $scope.orderFilters.limit;
    params['offset'] = $scope.orderFilters.offset;
    params['sort'] = 'startDate';

    orderService.getOrders(params, function (response) {
      successCb(response);
      return;
    }, function (err) {
      failureCb("Error Getting Orders");
      return;
    });
  };

  /*******************************/
  /***** Orders Data Helpers *****/
  /*******************************/

  $scope.deleteOrderSwipe = function (order) {
    // confirm order deletion before calling to service
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this order!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel plx!",
      closeOnConfirm: false,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        orderService.deleteOrder(order, function (success) {
          swal("Deleted!", "Order " + order.orderNumber + " has been deleted.", "success");
          $scope.loadOrdersIntoList();
        }, function (error) {
          alert('error deleting order!');
        });
      }
    });
  };

  /**************************************/
  /***** Order List Filter Controls *****/
  /**************************************/

  $scope.resetOrderFilters = function () {
    $scope.orderFilters = {};
    $scope.orderFilters.status = 'All';
    $scope.orderFilters.startFromDate = null; // moment().subtract(7,'days').toDate();
    $scope.orderFilters.startToDate = null;
    $scope.orderFilters.endFromDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.orderFilters.endToDate = null;
    $scope.orderFilters.customer = 'All';
    $scope.orderFilters.assignee = 'All';
    $scope.orderFilters.assigneeList = [];
  };

  /*******************************/
  /**** Filters Bottom Sheet *****/
  /*******************************/

  $scope.openOrderFiltersSheet = function () {
    $scope.filtersEdit = angular.copy($scope.orderFilters);

    $mdBottomSheet.show({
      templateUrl: 'views/pages/orders/mobile/filterBottomSheet.html',
      scope: $scope,
      preserveScope: true
    }).then(function () {
      // update changed filters
      $scope.orderFilters = $scope.filtersEdit;
      $scope.loadOrdersIntoList();
    }, function () {
      // update changed filters
      $scope.orderFilters = $scope.filtersEdit;
      $scope.loadOrdersIntoList();
    });
  };

  /*************************************************************************/
  /********************************** Filing *******************************/
  /*************************************************************************/

  /*************************************/
  /***** Filing List View Controls *****/
  /*************************************/

  // Load Filing Dockets Into List Controller
  $scope.loadFilingIntoList = function () {
    $scope.prepareForFilingListFromParent();
    $scope.getFilingListFiltered(function (filingList) {
      $scope.populateDocketFiles(filingList, function (filingListPopulated) {
        var filingListParsed = docketService.parseDocketsForFiling(filingListPopulated, $scope.filingFilters.statusTab.toLowerCase());
        $scope.loadDocketFilingListFromParent(filingListParsed);
        $scope.preventFilingLoad = false;
      });
    }, function (err) {
      $scope.filingLoadingError = err;
      $scope.preventFilingLoad = false;
    });
  };

  // Load more docket files into list
  $scope.loadNextPageOfFiling = function (cb) {
    if ($scope.preventFilingLoad) {
      cb();
      return;
    }
    $scope.filingFilters.offset = $scope.filingFilters.offset + $scope.filingFilters.limit;
    // get the next page of dockets
    $scope.getFilingListFiltered(function (filingList) {
      $scope.populateDocketFiles(filingList, function (filingListPopulated) {
        if (filingListPopulated.length == 0) {
          $scope.preventFilingLoad = true;
          cb();
          return;
        }
        var filingListParsed = docketService.parseDocketsForFiling(filingListPopulated, $scope.filingFilters.statusTab.toLowerCase());
        $scope.loadAdditionalDocketFilingFromParent(filingListPopulated);
        cb();
        $scope.preventFilingLoad = false;
      });
    });
  };

  // When child (listController) controller is ready - load initial list of dockets
  $scope.filingsChildControllerReady = function () {
    if ($scope.listView == 'filing') {
      $scope.loadFilingIntoList();
      $scope.bindScrollWatcher();
    }
  };

  // Get dockets for filing
  $scope.getFilingListFiltered = function (successCb, failureCb) {
    var params = {};
    if ($scope.filingFilters.fromDate != null) {
      var fromDate = (0, _momentTimezone2.default)($scope.filingFilters.fromDate);
      fromDate.set({ 'hour': '0', 'minute': '0', 'second': '1' });
      params.fromDate = fromDate.toISOString();
    }
    if ($scope.filingFilters.toDate != null) {
      var toDate = (0, _momentTimezone2.default)($scope.filingFilters.toDate);
      toDate.set({ 'hour': '23', 'minute': '23', 'second': '59' });
      params.toDate = toDate.toISOString();
    }
    //params.status = 'accepted';
    params['sort'] = 'date';
    params['limit'] = $scope.filingFilters.limit;
    params['offset'] = $scope.filingFilters.offset;

    docketService.getDockets(params, function (response) {
      successCb(response);
    }, function (err) {
      failureCb("Error Loading Dockets");
    });
  };

  /*******************************/
  /***** Filing Data Helpers *****/
  /*******************************/

  $scope.populateDocketFiles = function (docketList, cb) {
    var index = 0;
    $scope.populateDocketListWithFiles(docketList, index, function () {
      cb(docketList);
    });
  };

  $scope.populateDocketListWithFiles = function (docketList, index, cb) {
    if (index >= docketList.length) {
      cb();
      return;
    }

    // populate this index of the docketList
    $scope.populateDocketFileData(docketList[index], function () {
      // go to next index
      $scope.populateDocketListWithFiles(docketList, index + 1, cb);
    });
  };

  $scope.populateDocketFileData = function (docket, cb) {
    docketService.getDocketFileData(docket, function (docketFile) {
      docket.existingDocketFile = docketFile;
      cb();
    }, function (err) {
      docket.existingDocketFile = null;
      cb();
    });
  };

  /***************************************/
  /***** Docket List Filter Controls *****/
  /***************************************/

  $scope.resetFilingFilters = function () {
    $scope.filingFilters.status = "accepted";
    $scope.filingFilters.fromDate = (0, _momentTimezone2.default)().subtract(7, 'days').toDate();
    $scope.filingFilters.toDate = null;
    $scope.filingFilters.statusTab = "All";
  };

  /*******************************/
  /**** Filters Bottom Sheet *****/
  /*******************************/

  $scope.openFilingFiltersSheet = function () {
    $scope.filtersEdit = angular.copy($scope.filingFilters);

    $mdBottomSheet.show({
      templateUrl: 'views/pages/filing/mobile/filterBottomSheet.html',
      scope: $scope,
      preserveScope: true
    }).then(function () {
      // update changed filters
      $scope.filingFilters = $scope.filtersEdit;
      $scope.loadFilingIntoList();
    }, function () {
      // update changed filters
      $scope.filingFilters = $scope.filtersEdit;
      $scope.loadFilingIntoList();
    });
  };

  /********************************/
  /***** Opening Detail Items *****/
  /********************************/

  $scope.openDocketDetail = function (docket) {
    if ($scope.currentOrg != null) {
      $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docket.id });
    } else {
      // look through accessControl to find an organisation that can open this docket
      var accessKeys = Object.keys(docket.accessControl);
      var allowedOrganisations = accessControl.allowedOrganisations();
      var orgId = null;
      var groupId = null;
      var secondaryOrgs = [];
      for (var i = 0; i < allowedOrganisations.length; i++) {
        for (var j = 0; j < allowedOrganisations[i].groups.length; j++) {
          for (var k = 0; k < allowedOrganisations[i].groups[j].emailAddresses.length; k++) {
            for (var l = 0; l < accessKeys.length; l++) {
              if (accessKeys[l] == allowedOrganisations[i].groups[j].emailAddresses[k]) {
                if (docket.accessControl[accessKeys[l]].indexOf('creator') != -1) {
                  orgId = allowedOrganisations[i].id;
                  groupId = allowedOrganisations[i].groups[j].id;
                  break;
                } else {
                  secondaryOrgs.push({ orgId: allowedOrganisations[i].id, groupId: allowedOrganisations[i].groups[j].id });
                }
              }
            }
          }
        }
      }
      if (orgId && groupId) {
        $state.go('main.groupDocketDetail', { orgId: orgId, groupId: groupId, docketId: docket.id });
      } else if (secondaryOrgs && secondaryOrgs.length > 0) {
        $state.go('main.groupDocketDetail', { orgId: secondaryOrgs[0].orgId, groupId: secondaryOrgs[0].groupId, docketId: docket.id });
      } else {
        $state.go('main.docketDetail', { docketId: docket.id });
      }
    }
  };

  $scope.openJobDetail = function (job) {
    if ($scope.currentOrg != null) {
      $state.go('main.groupJobDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, jobId: job.id });
    } else {
      // determine org and group to open the job inside of
      if (job.userAssigneeData != null && job.userAssigneeData.organisation != null && job.userAssigneeData.organisationGroup != null) {
        $state.go('main.groupJobDetail', { jobId: job.id, orgId: job.userAssigneeData.organisation, groupId: job.userAssigneeData.organisationGroup });
      } else {
        $state.go('main.jobDetail', { jobId: job.id });
      }
    }
  };

  $scope.openOrderDetail = function (order) {
    if ($scope.currentOrg != null) {
      $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: order.id });
    } else {
      $state.go('main.orderDetail', { orderId: order.id });
    }
  };

  $scope.openHelpLink = function () {
    window.open("https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us");
  };

  /**************************************************************************/
  /******************************** Other Helpers ***************************/
  /**************************************************************************/

  /*****************************/
  /***** Date/Time Pickers *****/
  /*****************************/

  $scope.showDatePicker = function (field, ev) {
    $mdpDatePicker($scope.itemEdit[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      $scope.itemEdit[field] = selectedDate;
    });
  };

  $scope.showTimePicker = function (field, ev) {
    $mdpTimePicker($scope.itemEdit[field], {
      targetEvent: ev,
      autoSwitch: true
    }).then(function (selectedTime) {
      $scope.itemEdit[field] = selectedTime;
    });
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /****************************/
  /***** Mobile Nav Setup *****/
  /****************************/

  var tab = "";
  if ($scope.listView == 'dockets') {
    tab = "#navDocketsTab";
  } else if ($scope.listView == 'orders') {
    tab = "#navOrdersTab";
  } else if ($scope.listView == 'jobs') {
    tab = "#navJobsTab";
  } else if ($scope.listView == 'filing') {
    tab = "#navFilingTab";
  }

  if ($(tab).offset()) {
    var leftOffset = $(tab).offset().left + $(tab).width();
    var width = $(".tabBarMobile.mainNavBar").width();
    var M = width / 2;
    var Y = leftOffset;
    var X = $(".tabBarMobile.mainNavBar").scrollLeft();

    if (Y > M) {
      // scroll right
      $(".tabBarMobile.mainNavBar").animate({ scrollLeft: X + (Y - M) }, 600);
    } else {
      // scroll left
      $(".tabBarMobile.mainNavBar").animate({ scrollLeft: X - (M - Y) }, 600);
    }
  }

  /**************************************/
  /***** Infinite Scrolling Methods *****/
  /**************************************/

  $scope.loadingMoreItems = false;
  $scope.docketsListLoadingCount = 0;
  $scope.bindScrollWatcher = function () {
    angular.element($window).on('scroll', function () {
      if ($(window).scrollTop() + $(window).height() > $(document).height() - 20) {
        if ($scope.listView == 'dockets') {
          $scope.scrollLoadDockets();
        } else if ($scope.listView == 'jobs') {
          $scope.scrollLoadJobs();
        } else if ($scope.listView == 'orders') {
          $scope.scrollLoadOrders();
        } else if ($scope.listView == 'filing') {
          $scope.scrollLoadDocketFiles();
        }
      }
    });
  };

  $scope.scrollLoadDocketFiles = function () {
    if (!$scope.loadingMoreItems && !$scope.preventFilingLoad) {
      $scope.loadingMoreItems = true;
      $("#filingLoadingMore").removeClass('hidden');
      $scope.loadNextPageOfFiling(function () {
        $scope.loadingMoreItems = false;
        $("#filingLoadingMore").addClass("hidden");
      });
    }
  };

  $scope.scrollLoadDockets = function () {
    if (!$scope.loadingMoreItems && !$scope.preventDocketsLoad) {
      $scope.loadingMoreItems = true;
      $("#docketsLoadingMore").removeClass('hidden');
      $scope.loadNextPageOfDockets(function () {
        $scope.loadingMoreItems = false;
        $("#docketsLoadingMore").addClass("hidden");
      });
    }
  };

  $scope.scrollLoadJobs = function () {
    if (!$scope.loadingMoreItems && !$scope.preventJobsLoad) {
      $scope.loadingMoreItems = true;
      $("#jobsLoadingMore").removeClass('hidden');
      $scope.loadNextPageOfJobs(function () {
        $scope.loadingMoreItems = false;
        $("#jobsLoadingMore").addClass("hidden");
      });
    }
  };

  $scope.scrollLoadOrders = function () {
    if (!$scope.loadingMoreItems && !$scope.preventOrdersLoad) {
      $scope.loadingMoreItems = true;
      $("#ordersLoadingMore").removeClass('hidden');
      $scope.loadNextPageOfOrders(function () {
        $scope.loadingMoreItems = false;
        $("#ordersLoadingMore").addClass("hidden");
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "YvZY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "companySettingsWhite.svg";

/***/ }),

/***/ "Z/gs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_left.svg";

/***/ }),

/***/ "Z20f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('newGroupModalController', ['userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', 'accessControl', '$timeout', 'geolocation', function (userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {
	$scope.allTimezones = _momentTimezone2.default.tz.names();

	$scope.$parent.createNewGroupFromParent = function (parent, successCb) {
		$scope.newGroupCallback = successCb;
		$scope.parentGroup = parent;
		$scope.newGroup = {};
		$scope.newGroup.currentStep = 1;
		$scope.newGroup.process = 'form';
		$scope.newGroup.stepCount = 2;
		$scope.newGroup.showFullAddress = false;
		$scope.newGroup.timezone = parent.timezone;
		$("#newGroupModal").fadeIn(100);
	};

	$scope.closeNewGroupModal = function () {
		$("#newGroupModal").fadeOut(100);
		$scope.newGroupCallback(null);
	};

	$scope.newGroupNext = function () {
		$scope.newGroup.currentStep += 1;
		$timeout(function () {
			$("#editGroupFormStep" + $scope.newGroup.currentStep + " input:enabled:visible:first").focus();
		}, 200);
	};

	$scope.newGroupBack = function () {
		$scope.newGroup.currentStep -= 1;
	};

	$scope.newGroupManualAddress = function () {
		$scope.newGroup.showFullAddress = !$scope.newGroup.showFullAddress;
	};

	$scope.$watch('newGroup.address', function () {
		var requiredFields = ['streetName', 'suburb', 'state', 'postCode', 'country'];
		var incorrectFields = [];
		if ($scope.newGroup && $scope.newGroup.address) {
			for (var i = 0; i < requiredFields.length; i++) {
				if ($scope.newGroup.address[requiredFields[i]] == null || $scope.newGroup.address[requiredFields[i]] == "") {
					incorrectFields.push(requiredFields[i]);
				}
			}
			if (incorrectFields.length > 0) {
				$scope.newGroup.addressAlert = true;
			} else {
				$scope.newGroup.addressAlert = false;
			}
		}
	});

	$scope.createNewGroup = function (newGroup) {
		$scope.newGroup.process = 'creating';
		$scope.newGroup.loading = true;
		$scope.newGroup.publicName = $scope.newGroup.name;
		var owners = $scope.parentGroup.owners.map(function (owner) {
			if (owner.id) {
				return owner.id;
			} else {
				return owner;
			}
		});
		$scope.newGroup.owners = owners;
		$scope.newGroup.parent = $scope.parentGroup.id;
		userService.saveOrganisationGroup($scope.newGroup, function (groupSaved) {
			$scope.newGroup.process = 'success';
			$scope.newGroup.groupCreated = groupSaved;
		}, function (err) {
			if (err.data.message === "Not allowed to create more groups for for organisation according to current plan/usage.") {
				$scope.alertService.presentAutoAlert('saveOrgGroupExceed', err);
				$("#newGroupModal").fadeOut(100);
			} else if (err.data.message === "Not allowed to create organisation groups on this plan") {
				$scope.alertService.presentAutoAlert('saveOrgGroupDisallowed', err);
				$("#newGroupModal").fadeOut(100);
			} else if (err.data.message === "Not allowed to create more than 5 organisation groups in a sample company") {
				$scope.alertService.presentAutoAlert('saveOrgGroupSample', err);
				$("#newGroupModal").fadeOut(100);
			} else {
				$scope.alertService.presentAutoAlert('saveOrgGroup', err);
			}
			$scope.newGroup.loading = false;
			$scope.newGroup.process = 'form';
		});
	};

	$scope.newGroupFinish = function () {
		$("#newGroupModal").fadeOut(100);
		$scope.newGroupCallback($scope.newGroup.groupCreated);
	};
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "Z8Is":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "checklist-alt.svg";

/***/ }),

/***/ "ZNVM":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/commentsTab.html';
var html = "<div class=\"commentsOuter\">\n  <form name=\"commentFormInner\">\n    <div class=\"comment new thisUser\" ng-show=\"userHasPermission('io.docketbook.ojdapi.updateJob') && ((itemEdit.status != 'Draft' && itemEdit.status != 'New') || itemEdit.editing)\">\n      <div class=\"commentBody\">\n        <md-input-container class=\"md-block\">\n          <label>New Comment</label>\n          <textarea ng-model=\"newComment.commentText\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus name=\"commentTextarea\"></textarea>\n        </md-input-container>\n      </div>\n      <div class=\"commentButtons\">\n        <div class=\"btnOuter\">\n          <div class=\"btn btn-sm btn-success btn-rounded {{(newComment.commentText.length <= 0 || !newComment.commentText.length) ? 'disabled' : ''}}\" ng-click=\"(newComment.commentText.length <= 0 || !newComment.commentText.length) || addCommentToJob(itemEdit, newComment.commentText)\">Add Comment</div>\n        </div>\n        <div class=\"btnOuter\">\n          <div class=\"btn btn-sm btn-primary btn-rounded\" ng-click=\"clearComment(newComment)\">Clear Comment</div>\n        </div>\n      </div>\n    </div>\n  </form>\n  <div class=\"comment new thisUser\" ng-show=\"!userHasPermission('io.docketbook.ojdapi.updateJob') && itemEdit.userAssigneeData\">\n    <div class=\"commentBody\">\n      <md-input-container class=\"md-block\">\n        <label>New Comment</label>\n        <textarea ng-model=\"newComment.commentText\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus></textarea>\n      </md-input-container>\n    </div>\n    <div class=\"commentButtons\">\n      <div class=\"btnOuter\">\n        <div class=\"btn btn-sm btn-success btn-rounded {{(newComment.commentText.length <= 0 || !newComment.commentText.length) ? 'disabled' : ''}}\" ng-click=\"(newComment.commentText.length <= 0 || !newComment.commentText.length) || addAssigneeComment(itemEdit, newComment.commentText)\">Add Comment</div>\n      </div>\n      <div class=\"btnOuter\">\n        <div class=\"btn btn-sm btn-primary btn-rounded\" ng-click=\"clearComment(newComment)\">Clear Comment</div>\n      </div>\n    </div>\n  </div>\n  <div class=\"comment {{comment.author == currentUser.id ? 'thisUser' : 'otherUser'}}\" ng-repeat=\"comment in itemEdit.comments\" id=\"{{comment.id}}\" ng-show=\"!comment.delete\">\n    <div class=\"commentAuthor\">\n      <span ng-show=\"comment.author != currentUser.id && itemEdit.comments[itemEdit.comments.indexOf(comment) - 1].author != comment.author\">{{comment.authorName}}</span>\n      <span ng-show=\"itemEdit.comments.indexOf(comment) == 0 || moment.duration(moment(itemEdit.comments[itemEdit.comments.indexOf(comment) - 1].date, moment.ISO_8601).diff(moment(comment.date, moment.ISO_8601))).asMinutes() > 5\">\n        &nbsp;&nbsp;{{moment(comment.date, moment.ISO_8601).tz(itemEdit.timezone).format('Do MMM h:mm A')}}\n      </span>\n    </div>\n    <div class=\"commentBody\" ng-click=\"toggleCommentControls(comment)\">\n      <span ng-bind-html=\"comment.comment\"></span>\n      <div class=\"commentControls\" ng-show=\"comment.showControls\">\n        <div class=\"controlButton\" ng-click=\"removeCommentFromJob(itemEdit, comment)\" ng-show=\"userHasPermission('io.docketbook.ojdapi.updateJob')\">\n          <md-icon md-svg-src=\"delete.svg\"></md-icon>\n        </div>\n        <div class=\"controlButton\" ng-click=\"deleteAssigneeComment(itemEdit, comment)\" ng-show=\"!userHasPermission('io.docketbook.ojdapi.updateJob') && comment.author == currentUser.id\">\n          <md-icon md-svg-src=\"delete.svg\"></md-icon>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ZOX0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').service('userService', ['accessControl', '$http', '$stateParams', '$cookies', '$q', 'Restangular', 'geolocation', function (accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

  var userHasPermission = accessControl.userHasPermission;

  this.getUserConnections = function (successCb, failureCb) {
    var org = accessControl.currentOrg();
    if (!org) {
      return [];
    }

    Restangular.all('user').all('connections').customGET().then(successCb, failureCb);
  };

  this.getUserInvitations = function (successCb, failureCb) {
    Restangular.all('user').all('connections').all('invitations').customGET().then(successCb, failureCb);
  };

  this.saveUserInvitation = function (invitation, successCb, failureCb) {
    Restangular.all('user').all('connections').all('invitations').one(invitation.id).customPUT({ status: invitation.status, organisationId: invitation.targetId }).then(successCb, failureCb);
  };

  /******* Create a New Organisation ********/
  this.createNewOrganisation = function (orgObj, successCb, failureCb) {
    Restangular.all('organisations').post(orgObj).then(successCb, failureCb);
  };

  /******* Get all members of an organisation ********/
  this.getMembers = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseMembers = Restangular.all("organisations").one(organisation.id).all('members');
    if (params == null) {
      params = {};
    }
    baseMembers.getList(params).then(successCb, failureCb);
  };

  /******* Get all members of an organisation group ********/
  this.getGroupMembers = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseMembers = Restangular.all("organisations").one(organisation.id);
    if (params.groupId != null) {
      baseMembers = baseMembers.all('groups').one(params.groupId).all('members');
    } else {
      baseMembers = baseMembers.all('groups').one(organisationGroup.id).all('members');
    }
    if (params == null) {
      params = {};
    }
    delete params.groupId;
    baseMembers.getList(params).then(successCb, failureCb);
  };

  /****** Get all email addresses of the org groups that the current user is a part of *****/
  this.getOrgEmailAddresses = function () {
    var organisations = accessControl.allowedOrganisations();
    var orgEmails = [];
    if (organisations != null) {
      for (var i = 0; i < organisations.length; i++) {
        for (var j = 0; j < organisations[i].groups.length; j++) {
          if (organisations[i].groups[j].emailAddresses != null) {
            for (var k = 0; k < organisations[i].groups[j].emailAddresses.length; k++) {
              orgEmails.push(organisations[i].groups[j].emailAddresses[k]);
            }
          }
        }
      }
    }

    return orgEmails;
  };

  /****** Get Organisation Full ******/
  this.getOrganisation = function (orgId, successCb, failureCb) {
    //var baseOrganisation = Restangular.all('organisations').one(orgId);
    //baseOrganisation.get().then(successCb, failureCb);

    Restangular.all('organisations').getList().then(function (orgs) {
      return successCb(orgs.filter(function (org) {
        return org.id == orgId;
      })[0]);
    }, failureCb);
  };

  this.getOrgData = function (orgId, successCb, failureCb) {
    Restangular.all('organisations').one(orgId).customGET().then(successCb, failureCb);
  };

  this.getGroups = function (orgId, successCb, failureCb) {
    Restangular.all('organisations').one(orgId).all('groups').customGET().then(successCb, failureCb);
  };

  /****** Request Organisation Setup Support ******/
  this.requestSetupSupport = function (orgId, supportMethod, supportContact, successCb, failureCb) {
    var updatePayload = { supportRequested: true, supportMethod: supportMethod, supportContact: supportContact };
    var baseOrganisation = Restangular.all('organisations').one(orgId);
    baseOrganisation.customPUT(updatePayload).then(successCb, failureCb);
  };

  /****** Update Organisation ******/
  this.updateOrganisation = function (orgId, updatePayload, successCb, failureCb) {
    var baseOrganisation = Restangular.all('organisations').one(orgId);
    baseOrganisation.customPUT(updatePayload).then(successCb, failureCb);
  };

  /****** Get Org Logo ******/
  this.getOrganisationLogo = function (orgId, successCb, failureCb) {
    var baseOrganisation = Restangular.all('organisations').one(orgId).all('logo');
    baseOrganisation.customGET().then(successCb, failureCb);
  };

  /******* Get Org Group Full *******/
  this.getOrganisationGroup = function (orgGroupId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(orgGroupId + "?populate=true");

    baseOrgGroup.get().then(successCb, failureCb);
  };

  /******* Save Org Group ******/
  this.saveOrganisationGroup = function (orgGroup, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroups = Restangular.all('organisations').one(organisation.id).all('groups');

    if (orgGroup.id == null) {
      orgGroup.organisation = organisation.id;
      baseOrgGroups.post(orgGroup).then(successCb, failureCb);
    } else {
      baseOrgGroups.one(orgGroup.id).customPUT(orgGroup).then(successCb, failureCb);
    }
  };

  /****** Add Group Member ******/
  this.addMemberToGroup = function (groupId, member, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
    baseOrgGroup.all('members').post(member).then(successCb, failureCb);
  };

  var inviteMembersToGroup = function inviteMembersToGroup(groupId, invites, successCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);

    baseOrgGroup.all('users').all('add').customPUT(invites).then(function (success) {
      successCb();
      return;
    }, function (err) {
      console.error('could not bulk invite members', err);
      successCb();
      return;
    });
  };

  var inviteMembersToGroups = function inviteMembersToGroups(pos, groupIds, invitesByGroups, successCb) {
    if (pos >= groupIds.length) {
      successCb();
      return;
    }

    inviteMembersToGroup(groupIds[pos], invitesByGroups[groupIds[pos]], function () {
      inviteMembersToGroups(pos + 1, groupIds, invitesByGroups, successCb);
    });
  };

  this.assignMembersToOrg = function (invitesByGroups, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var groupsRequiringInvites = [];
    var allGroupIds = Object.keys(invitesByGroups);
    for (var i = 0; i < allGroupIds.length; i++) {
      if (invitesByGroups[allGroupIds[i]].length > 0) {
        groupsRequiringInvites.push(allGroupIds[i]);
      }
    }

    inviteMembersToGroups(0, groupsRequiringInvites, invitesByGroups, function () {
      successCb();
      return;
    });

    //var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
    //baseOrgGroup.all('users').all('add').customPUT(membersList).then(successCb, failureCb);
  };

  this.assignMembersToGroup = function (groupId, membersList, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
    baseOrgGroup.all('users').all('add').customPUT(membersList).then(successCb, failureCb);
  };

  /****** Remove Group Member Role ******/
  this.removeMemberRoleFromGroup = function (groupId, userId, roleId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
    baseOrgGroup.all('members').one(userId).all('role').one(roleId).remove().then(successCb, failureCb);
  };

  /****** Remove Group Member ******/
  this.removeMemberFromGroup = function (groupId, userId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
    baseOrgGroup.all('members').one(userId).remove().then(successCb, failureCb);
  };

  /****** Remove Group Owner *******/
  this.removeOwnerFromGroup = function (groupId, userId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
    baseOrgGroup.all('owners').one(userId).remove().then(successCb, failureCb);
  };

  /****** Remove Group Monitor *******/
  this.removeMonitorFromGroup = function (groupId, userId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);

    var putObj = [];
    var userRemove = { user: userId, roles: ['monitor'] };
    putObj.push(userRemove);

    baseOrgGroup.all('users').all('remove').customPUT(putObj).then(successCb, failureCb);
  };

  /****** Get Roles ******/
  this.getRoles = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseRoles = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('roles');

    if (params == null) {
      params = {};
    }

    baseRoles.getList(params).then(successCb, failureCb);
  };

  /******* Save Role ********/
  this.saveRole = function (role, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseRoles = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('roles');

    if (role.id == null) {
      role.organisation = organisation.id;
      baseRoles.post(role).then(successCb, failureCb);
    } else {
      baseRoles.one(role.id).customPUT(role).then(successCb, failureCb);
    }
  };

  var deleteRole = function deleteRole(roleId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseRoles = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('roles');

    if (roleId.id != null) {
      roleId = roleId.id;
    }

    baseRoles.one(roleId).remove().then(successCb, failureCb);
  };

  this.deleteRole = deleteRole;

  /******** Delete Bulk Roles ********/
  this.deleteBulkRoles = function (roles, successCb) {
    var failures = [];
    deleteRoles(roles, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteRoles = function deleteRoles(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteRole(list[index].id, function (success) {
      deleteRoles(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteRoles(list, index + 1, failures, successCb);
    });
  };

  /******* Get Permissions *******/
  this.getPermissions = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var basePermissions = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('permissions');

    if (params == null) {
      params = {};
    }

    basePermissions.getList(params).then(successCb, failureCb);
  };

  this.getPermissionsForOrg = function (organisationId, params, successCb, failureCb) {
    var organisationGroup = accessControl.currentOrgGroup();
    var basePermissions = Restangular.all('organisations').one(organisationId).all('groups').one(organisationGroup.id).all('permissions');

    if (params == null) {
      params = {};
    }

    basePermissions.getList(params).then(successCb, failureCb);
  };

  /********* GET GROUP DIFF ************/
  var getGroupDiff = function getGroupDiff(original, modified, successCb) {
    if (modified.id == null) {
      successCb(1, modified);
      return;
    }

    var diffCount = 0;
    var diff = {};

    // Check basic fields
    var fields = ['name', 'publicName', 'prefix', 'orderPrefix', 'jobPrefix', 'invoicePrefix', 'docketPrefix', 'description', 'inheritsPermissions', 'inheritsAddressBook', 'projectGroup', 'defaultTemplate', 'timezone', 'timeFormat', 'active'];

    for (var i = 0; i < fields.length; i++) {
      var fieldName = fields[i];

      if (!original[fieldName] && modified[fieldName]) {
        diffCount += 1;
        diff[fieldName] = modified[fieldName];
      } else if (original[fieldName] != null && modified[fieldName] != null && original[fieldName] != modified[fieldName]) {
        diffCount += 1;
        diff[fieldName] = modified[fieldName];
      }
    }

    if (!original.address && modified.address) {
      diffCount += 1;
      diff.address = modified.address;
    } else if (modified.address) {
      // Check address object
      var addressFields = ['num', 'streetNum', 'streetName', 'suburb', 'state', 'postCode', 'country'];
      var addressChanged = false;
      for (var i = 0; i < addressFields.length; i++) {
        var fieldName = addressFields[i];
        if (!original.address[fieldName] && modified.address[fieldName]) {
          addressChanged = true;
          break;
        } else if (original.address[fieldName] && modified.address[fieldName] && original.address[fieldName] != modified.address[fieldName]) {
          addressChanged = true;
          break;
        }
      }
      if (addressChanged) {
        diffCount += 1;
        diff.address = modified.address;
      }
    }

    diff.id = modified.id;
    successCb(diffCount, diff);
  };

  this.getGroupDiff = getGroupDiff;

  /********* GET ORG DIFF ************/
  var getOrgDiff = function getOrgDiff(original, modified, successCb) {
    var diffCount = 0;
    var diff = {};

    // Check basic fields
    var fields = [];
    for (var i = 0; i < fields.length; i++) {
      var fieldName = fields[i];

      if (!original[fieldName] && modified[fieldName]) {
        diffCount += 1;
        diff[fieldName] = modified[fieldName];
      } else if (original[fieldName] != null && modified[fieldName] != null && original[fieldName] != modified[fieldName]) {
        diffCount += 1;
        diff[fieldName] = modified[fieldName];
      }
    }

    if (original.features && original.features.timesheets && modified.features && modified.features.timesheets) {
      if (modified.features.timesheets.enabled != original.features.timesheets.enabled) {
        diffCount += 1;
        diff.features = {};
        diff.features.timesheets = modified.features.timesheets;
      }
    }

    diff.id = modified.id;
    successCb(diffCount, diff);
  };

  this.getOrgDiff = getOrgDiff;

  /*** Get Task ***/
  this.getTaskStatus = function (taskId, successCb, failureCb) {
    var baseTasks = Restangular.all('tasks');
    baseTasks.one(taskId).get().then(successCb, failureCb);
  };

  /******************************/
  /**** Permission Checker ******/
  /******************************/
  // NB: apiPermission is array and is checking using an OR

  var permissionActions = {};
  /************************/
  /**** Order Actions *****/
  /************************/
  permissionActions['createOperatorDocket'] = {
    apiPermission: ['io.docketbook.ojdapi.createOperatorDocket']
  };
  permissionActions['reDraftOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    itemStatus: ['Sent', 'Rejected', 'Closed'],
    accessControl: ['creator', 'editor']
  };
  permissionActions['sendOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.sendOrder'],
    //orgPermission: 'isCustomer',
    itemStatus: ['Draft'],
    accessControl: ['creator']
    /*valueRules: [{
      field : 'customerContact',
      type : '!=',
      value : null
    }]*/
  };
  permissionActions['acceptOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.acceptOrder'],
    orgPermission: '!creator',
    itemStatus: ['Draft', 'Sent', 'Rejected']
  };
  permissionActions['orderIsReviewable'] = {
    orgPermission: '!creator',
    itemStatus: ['Sent'],
    accessControl: ['supplier']
  };
  permissionActions['rejectOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.rejectOrder'],
    orgPermission: '!creator',
    itemStatus: ['Sent'],
    accessControl: ['supplier', 'customer']
  };
  permissionActions['finishOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.closeOrder'],
    //orgPermission: 'isSupplier',
    itemStatus: ['Sent', 'Accepted', 'Draft'],
    accessControl: ['supplier', 'customer', 'editor']
  };
  permissionActions['editOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    //orgPermission: 'isSupplier',
    //itemStatus: ['Draft', 'Rejected'],
    editing: false,
    accessControl: ['editor', 'creator', 'supplier', 'customer']
  };
  permissionActions['deleteOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.deleteOrder'],
    itemStatus: ['Draft'],
    accessControl: ['creator']
  };
  permissionActions['saveOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder', 'io.docketbook.ojdapi.createOrder'],
    //orgPermission: 'isSupplier',
    //itemStatus: ['Draft', 'Rejected','New'],
    editing: true,
    accessControl: ['editor', 'creator', 'supplier', 'customer']
  };
  permissionActions['createOrder'] = {
    apiPermission: ['io.docketbook.ojdapi.createOrder']
  };
  permissionActions['changeOrderSupplier'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    orgPermission: 'isCustomer',
    itemStatus: ['Draft', 'New', 'Rejected'],
    editing: true
  };
  permissionActions['changeOrderCustomer'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    orgPermission: 'isSupplier',
    itemStatus: ['Draft', 'New', 'Rejected'],
    editing: true
  };
  permissionActions['editOrderCustomer'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    orgPermission: 'isSupplier',
    itemStatus: ['Draft', 'Sent', 'Accepted', 'New', 'Rejected'],
    editing: true
  };
  permissionActions['swapCustomerSupplier'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    itemStatus: ['New'],
    editing: true
  };
  permissionActions['viewOrderDocketTemplate'] = {
    orgPermission: 'isSupplier'
  };
  permissionActions['changeOrderDocketTemplate'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    itemStatus: ['New', 'Draft', 'Rejected', 'Sent', 'Accepted'],
    orgPermission: ['isSupplier'],
    editing: true
    /*valueRules: [{
      field : 'lineItems',
      type : 'arrayempty'
    }]*/
  };
  permissionActions['editLineItem'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    itemStatus: ['New', 'Draft', 'Rejected', 'Sent', 'Accepted'],
    //orgPermission: ['isSupplier'],
    editing: true
  };
  permissionActions['removeLineItem'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    itemStatus: ['New', 'Draft'],
    //orgPermission: ['isSupplier'],
    editing: true
    //valueRules: [{
    //  field : 'dockets',
    //  type : 'arrayempty'
    //}]
  };
  permissionActions['addLineItem'] = {
    apiPermission: ['io.docketbook.ojdapi.updateOrder'],
    itemStatus: ['New', 'Draft', 'Rejected', 'Sent', 'Accepted'],
    //orgPermission: ['isSupplier'],
    editing: true
  };
  permissionActions['isOrderSupplier'] = {
    orgPermission: 'isSupplier'
  };
  permissionActions['isOrderCustomer'] = {
    orgPermission: 'isCustomer'
  };
  permissionActions['customerViewLineItemQty'] = {
    itemStatus: ['Accepted']
  };
  permissionActions['changeOrderLineResource'] = {
    orgPermission: 'isSupplier',
    editing: true
  };
  permissionActions['viewOrderJobs'] = {
    orgPermission: ['isSupplier']
  };
  permissionActions['viewOrderJobsTab'] = {
    apiPermission: ['io.docketbook.ojdapi.getJob']
  };
  permissionActions['addOrderJob'] = {
    apiPermission: ['io.docketbook.ojdapi.createJob'],
    orgPermission: ['isSupplier'],
    valueRules: [{
      field: 'status',
      type: '!=',
      value: 'New'
    }]
  };
  permissionActions['viewOrderDockets'] = {
    //orgPermission: ['isSupplier']
  };
  permissionActions['addOrderDocket'] = {
    apiPermission: ['io.docketbook.ojdapi.createDocket'],
    orgPermission: ['isSupplier'],
    valueRules: [{
      field: 'status',
      type: '!=',
      value: 'New'
    }]
  };
  permissionActions['editCustomerRefNo'] = {
    //itemStatus: ['New', 'Draft'],
    //orgPermission: ['isCustomer'],
    editing: true
  };
  permissionActions['editOrderNotes'] = {
    editing: true
  };
  permissionActions['editSupplierRefNo'] = {
    //itemStatus: ['New', 'Draft'],
    //orgPermission: ['isSupplier'],
    editing: true
  };
  permissionActions['editOrderNumber'] = {
    itemStatus: ['New', 'Draft'],
    editing: true
  };
  permissionActions['viewSupplierRefNo'] = {
    orgPermission: ['isSupplier']
  };
  permissionActions['viewCustomerRefNo'] = {
    orgPermission: ['isCustomer']
  };
  permissionActions['editOrderStartDate'] = {
    itemStatus: ['New', 'Draft', 'Sent', 'Accepted', 'Rejected'],
    editing: true
  };
  permissionActions['changeOrderStartDate'] = permissionActions['editOrderStartDate'];
  permissionActions['editOrderEndDate'] = {
    itemStatus: ['New', 'Draft', 'Sent', 'Accepted', 'Rejected'],
    editing: true
  };
  permissionActions['changeOrderEndDate'] = permissionActions['editOrderEndDate'];

  /***********************/
  /***** Job Actions *****/
  /***********************/
  permissionActions['acceptJob'] = {
    assigneeStatus: ['Assigned'],
    itemStatus: ['Sent'],
    accessControl: ['assignee']
  };
  permissionActions['rejectJob'] = {
    assigneeStatus: ['Assigned'],
    itemStatus: ['Sent'],
    accessControl: ['assignee']
  };
  permissionActions['finishJob'] = {
    assigneeStatus: ['Accepted'],
    itemStatus: ['Sent'],
    accessControl: ['assignee']
  };
  permissionActions['sendJob'] = {
    itemStatus: ['Draft', 'Closed'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor']
  };
  permissionActions['closeJob'] = {
    itemStatus: ['Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor']
  };
  permissionActions['deleteJob'] = {
    itemStatus: ['Draft'],
    apiPermission: ['io.docketbook.ojdapi.deleteJob'],
    accessControl: ['editor']
  };
  permissionActions['shareJob'] = {
    accessControl: ['viewer', 'editor', 'forwarder']
  };
  permissionActions['duplicateJob'] = {
    apiPermission: ['io.docketbook.ojdapi.createJob'],
    editing: false,
    //orgPermission: 'isSupplier',
    valueRules: [{
      field: 'status',
      type: '!=',
      value: 'New'
    }]
  };
  permissionActions['editJob'] = {
    itemStatus: ['Draft', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    editing: false,
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['canEditJob'] = {
    itemStatus: ['Draft', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['saveJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    editing: true
  };
  permissionActions['editJobDetails'] = {
    itemStatus: ['New', 'Draft', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    editing: true,
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['unassignUserFromJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor', 'forwarder'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['assignUserToJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor', 'forwarder'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['deleteLineItemFromJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true,
    editing: true,
    valueRules: [{
      field: 'dockets',
      type: 'arrayempty'
    }]
  };
  permissionActions['addLineItemToJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor'],
    editing: true,
    accessControlIgnoreOnNew: true
  };
  permissionActions['editLineItemJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor'],
    editing: true,
    accessControlIgnoreOnNew: true
  };
  permissionActions['createDocketFromJob'] = {
    //apiPermission: ['io.docketbook.ojdapi.createDocket'],
    apiPermissions: ['io.docketbook.ojdapi.createDocket', 'io.docketbook.ojdapi.editJob'],
    accessControl: ['editor'],
    itemStatus: ['Draft', 'Sent']
  };
  permissionActions['assigneeCreateDocketFromJob'] = {
    assigneeStatus: ['Accepted'],
    itemStatus: ['Sent']
  };
  permissionActions['createJob'] = {
    apiPermission: ['io.docketbook.ojdapi.createJob']
  };
  permissionActions['changeJobOrder'] = {
    itemStatus: ['New', 'Draft'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    editing: true,
    valueRules: [{
      field: 'lineItems',
      type: 'arrayempty'
    }],
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['changeJobStartDate'] = {
    itemStatus: ['New', 'Draft', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    editing: true,
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['changeJobEndDate'] = {
    itemStatus: ['New', 'Draft', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    editing: true,
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['addCommentToJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor', 'assignee', 'forwarder'],
    accessControlIgnoreOnNew: true
  };
  permissionActions['removeCommentFromJob'] = {
    itemStatus: ['Draft', 'New', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateJob'],
    accessControl: ['editor'],
    accessControlIgnoreOnNew: true
  };

  /**************************/
  /***** Docket Actions *****/
  /**************************/
  permissionActions['sendDocket'] = {
    itemStatus: ['Draft', 'New'],
    apiPermission: ['io.docketbook.ojdapi.sendDocket'],
    //orgPermission: 'isSupplier',
    accessControl: ['editor', 'creator']
  };
  permissionActions['recallDocket'] = {
    itemStatus: ['Sent'],
    apiPermission: ['io.docketbook.ojdapi.recallDocket'],
    //orgPermission: 'isSupplier',
    accessControl: ['editor', 'creator']
  };
  permissionActions['approveDocket'] = {
    itemStatus: ['Sent'],
    apiPermission: ['io.docketbook.ojdapi.approveDocket'],
    //orgPermission: 'isCustomer',
    accessControl: ['approver']
  };
  permissionActions['captureCustomerSignatureFromCustomer'] = {
    itemStatus: ['Draft', 'Sent'],
    //apiPermission: ['io.docketbook.ojdapi.approveDocket'],
    //orgPermission: 'isCustomer',
    accessControl: ['approver']
  };
  permissionActions['acceptDocket'] = permissionActions['approveDocket'];
  permissionActions['acceptFileDocket'] = {
    itemStatus: ['Sent'],
    apiPermission: ['io.docketbook.ojdapi.acceptAndFileDockets'],
    //orgPermission: 'isCustomer',
    accessControl: ['approver']
  };
  permissionActions['rejectDocket'] = {
    itemStatus: ['Sent'],
    apiPermission: ['io.docketbook.ojdapi.rejectDocket'],
    //orgPermission: 'isCustomer',
    accessControl: ['approver']
  };
  permissionActions['reDraftDocket'] = {
    itemStatus: ['Rejected'],
    accessControl: ['editor'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket']
  };
  /*permissionActions['sendDocket'] = {
    itemStatus: ['Sent', 'Accepted'],
    //orgPermission: 'isSupplier',
    accessControl: ['editor']
  };*/
  permissionActions['downloadDocket'] = {
    itemStatus: ['Draft', 'Sent', 'Accepted']
  };
  permissionActions['deleteDocket'] = {
    itemStatus: ['Draft'],
    apiPermission: ['io.docketbook.ojdapi.deleteDocket'],
    accessControl: ['editor', 'creator']
  };
  permissionActions['editDocket'] = {
    itemStatus: ['Draft'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: false,
    accessControl: ['editor']
  };
  permissionActions['saveDocket'] = {
    itemStatus: ['Draft', 'New'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: true
  };
  permissionActions['createDocket'] = {
    apiPermission: ['io.docketbook.ojdapi.createDocket']
  };
  permissionActions['createAdhocDocket'] = {
    apiPermission: ['io.docketbook.ojdapi.createAdhocDocket']
  };
  permissionActions['fileDocket'] = {
    itemStatus: ['Accepted'],
    apiPermission: ['io.docketbook.ojdapi.fileDockets']
  };
  permissionActions['editAccessControlItem'] = {
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: true,
    accessControl: ['editor']
  };
  permissionActions['addAccessControlItem'] = {
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: true,
    accessControl: ['editor']
  };
  permissionActions['changeDocketCustomer'] = {
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    orgPermission: 'isSupplier',
    itemStatus: ['Draft', 'New'],
    editing: true,
    valueRules: [{
      field: 'orderRef',
      type: '==',
      value: null
    }]
  };
  permissionActions['changeDocketOrder'] = {
    itemStatus: ['New', 'Draft'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket', 'io.docketbook.ojdapi.getOrder'],
    editing: true,
    valueRules: [{
      field: 'jobRef',
      type: '==',
      value: null
    }]
    /*
      field : 'resources',
      type : 'arrayempty',
      value: 1
    },*/
  };
  permissionActions['changeDocketJob'] = {
    itemStatus: ['New', 'Draft'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket', 'io.docketbook.ojdapi.getJob'],
    editing: true,
    valueRules: [{
      field: 'resources',
      type: 'arrayempty',
      value: 1
    }]
  };
  permissionActions['changeDocketDate'] = {
    itemStatus: ['New', 'Draft'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: true
  };
  permissionActions['changeDocketTemplate'] = {
    itemStatus: ['New', 'Draft'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: true,
    valueRules: [{
      field: 'orderRef',
      type: '==',
      value: null
    }, {
      field: 'resources',
      type: 'arrayempty'
    }]
  };
  permissionActions['captureSupplierSignature'] = {
    itemStatus: ['New', 'Draft'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: true,
    valueRules: [{
      field: 'supplierSignatureAttachment',
      type: 'nullempty'
    }, {
      field: 'supplierSignatureImage',
      type: 'nullempty'
    }, {
      field: 'id',
      type: '!=',
      vaue: null
    }]
  };
  permissionActions['captureCustomerSignature'] = {
    itemStatus: ['New', 'Draft', 'Sent'],
    apiPermission: ['io.docketbook.ojdapi.updateDocket'],
    editing: true,
    valueRules: [{
      field: 'customerSignatureAttachment',
      type: 'nullempty'
    }, {
      field: 'customerSignatureImage',
      type: 'nullempty'
    }, {
      field: 'id',
      type: '!=',
      vaue: null
    }]
  };
  permissionActions['addDocketResource'] = {
    itemStatus: ['New', 'Draft'],
    editing: true,
    accessControl: ['editor']
  };
  permissionActions['editDocketInteraction'] = {
    itemStatus: ['New', 'Draft'],
    editing: true,
    accessControl: ['editor']
  };
  permissionActions['removeDocketInteraction'] = {
    itemStatus: ['New', 'Draft'],
    editing: true,
    accessControl: ['editor']
  };
  permissionActions['addDocketAttachment'] = {
    itemStatus: ['New', 'Draft']
  };
  permissionActions['removeDocketAttachment'] = {
    itemStatus: ['New', 'Draft']
  };
  permissionActions['createBatch'] = {
    apiPermission: ['io.docketbook.ojdapi.createDocket']
  };

  permissionActions['viewOrdersSummary'] = {
    apiPermission: ['io.docketbook.ojdapi.getOrder']
  };
  permissionActions['viewJobsSummary'] = {
    apiPermission: ['io.docketbook.ojdapi.getJob']
  };
  permissionActions['viewDocketsSummary'] = {
    apiPermission: ['io.docketbook.ojdapi.getDocket']
  };

  /****************/
  /**** Admin *****/
  /****************/

  permissionActions['viewOrgBilling'] = {
    apiPermission: ['global-administrator']
  };
  permissionActions['createOrgGroup'] = {
    isAdmin: true
  };
  permissionActions['viewCompanySettings'] = {
    apiPermission: ['io.docketbook.uoapi.viewOrganisationSettings']
  };
  permissionActions['viewGroupSettings'] = {
    apiPermission: ['io.docketbook.uoapi.viewOrganisationSettings']
  };
  permissionActions['acceptConnection'] = {
    apiPermission: ['io.docketbook.uoapi.acceptConnection']
  };
  permissionActions['deleteConnection'] = {
    apiPermission: ['io.docketbook.uoapi.deleteConnection']
  };
  permissionActions['createConnection'] = {
    apiPermission: ['io.docketbook.uoapi.createConnection']
  };
  permissionActions['getConnections'] = {
    apiPermission: ['io.docketbook.uoapi.getConnection']
  };

  this.userCanDoAction = function (actionName, itemEdit) {
    if (itemEdit == null) {
      itemEdit = {};
    }

    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var currentUser = accessControl.currentUser();

    if (permissionActions[actionName] != null) {
      var permissionToCheck = permissionActions[actionName];
      // Check user has admin permission if requireed
      if (permissionToCheck.isAdmin == true) {
        var isAdmin = false;
        if (currentOrg && currentOrg.globalAdministrators.indexOf(currentUser.id) != -1) {
          isAdmin = true;
        }
        if (currentOrg && currentOrg.owners && currentOrg.owners.indexOf(currentUser.id) != -1) {
          isAdmin = true;
        }
        if (currentOrgGroup && currentOrgGroup.owners && currentOrgGroup.owners.indexOf(currentUser.id) != -1) {
          isAdmin = true;
        }
        if (!isAdmin) {
          return false;
        }
      }

      // Check user has api permission if required (apiPermission - OR)
      if (permissionToCheck.apiPermission) {
        var permissionFound = false;
        for (var i = 0; i < permissionToCheck.apiPermission.length; i++) {
          if (userHasPermission(permissionToCheck.apiPermission[i])) {
            permissionFound = true;
          }
        }
        if (!permissionFound) {
          return false;
        }
      }

      // Check user has all require api permissions (apiPermissions - AND)
      if (permissionToCheck.apiPermissions) {
        var hasAllPermissions = true;
        for (var i = 0; i < permissionToCheck.apiPermissions.length; i++) {
          if (!userHasPermission(permissionToCheck.apiPermissions[i])) {
            hasAllPermissions = false;
            break;
          }
        }

        if (!hasAllPermissions) {
          return false;
        }
      }

      // Check user assignee status
      if (permissionToCheck.assigneeStatus) {
        if (!itemEdit.userAssigneeData) {
          return false;
        }
        if (!(itemEdit.userAssigneeData && permissionToCheck.assigneeStatus.indexOf(itemEdit.userAssigneeData.status) != -1)) {
          return false;
        }
      }

      // Check user has org permission if required
      if (permissionToCheck.orgPermission && permissionToCheck.orgPermission == 'isSupplier') {
        // check if currentOrgGroup is the supplierContact
        var foundEmail = false;
        if (currentOrgGroup != null) {
          if (!itemEdit || !currentOrgGroup.emailAddresses || !itemEdit.supplierContact || !itemEdit.supplierContact.contactAddresses) {
            return false;
          }
          for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
            if (itemEdit.supplierContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
              foundEmail = true;
            }
          }
        }

        if (!foundEmail) {
          return false;
        }
      } else if (permissionToCheck.orgPermission && permissionToCheck.orgPermission == 'isCustomer') {
        // check if currentOrgGroup is the supplierContact
        var foundEmail = false;
        if (currentOrgGroup != null) {
          if (!itemEdit || !currentOrgGroup.emailAddresses || !itemEdit.customerContact || !itemEdit.customerContact.contactAddresses) {
            return false;
          }
          for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
            if (itemEdit.customerContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
              foundEmail = true;
            }
          }
        }

        if (!foundEmail) {
          return false;
        }
      } else if (permissionToCheck.orgPermission && permissionToCheck.orgPermission == '!creator') {
        if (!itemEdit.accessControl) {
          return false;
        }

        var foundPermission = false;
        if (currentOrgGroup != null) {
          for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
            if (itemEdit.accessControl[currentOrgGroup.emailAddresses[i]] && itemEdit.accessControl[currentOrgGroup.emailAddresses[i]].indexOf('creator') != -1) {
              foundPermission = true;
              break;
            }
          }
        }

        if (foundPermission) {
          return false;
        }
      }

      // Check item status is ok
      if (permissionToCheck.itemStatus && itemEdit) {
        if (permissionToCheck.itemStatus.indexOf(itemEdit.status) == -1) {
          return false;
        }
      }

      // Check edit status
      if (permissionToCheck.editing != null) {
        if (!itemEdit) {
          return false;
        } else {
          if (permissionToCheck.editing == true && !itemEdit.editing) {
            return false;
          } else if (permissionToCheck.editing == false && itemEdit.editing) {
            return false;
          }
        }
      }

      // Check accessControl permissions
      if (permissionToCheck.accessControl && itemEdit && itemEdit.accessControl && currentOrgGroup) {
        if (permissionToCheck.accessControlIgnoreOnNew && permissionToCheck.accessControlIgnoreOnNew == true) {} else {
          // Check group emailAddresses
          var foundPermission = false;
          for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
            if (itemEdit.accessControl[currentOrgGroup.emailAddresses[i]] != null) {
              for (var j = 0; j < permissionToCheck.accessControl.length; j++) {
                if (itemEdit.accessControl[currentOrgGroup.emailAddresses[i]].indexOf(permissionToCheck.accessControl[j]) != -1) {
                  foundPermission = true;
                  break;
                }
              }
            }
          }

          currentOrgGroup.emailAddresses.some(function (address) {
            if (address in itemEdit.accessControl) {
              permissionToCheck.accessControl.some(function (permission) {
                if (itemEdit.accessControl[address].indexOf(permission) !== -1) {
                  foundPermission = true;
                }
                return foundPermission;
              });
            }
            return foundPermission;
          });

          // Check currentUsers emailAddresses
          for (var i = 0; i < currentUser.emailAddresses.length; i++) {
            if (itemEdit.accessControl[currentUser.emailAddresses[i]] != null) {
              for (var j = 0; j < permissionToCheck.accessControl.length; j++) {
                if (itemEdit.accessControl[currentUser.emailAddresses[i]].indexOf(permissionToCheck.accessControl[j]) != -1) {
                  foundPermission = true;
                  break;
                }
              }
            }
          }

          if (!foundPermission) {
            return false;
          }
        }
      }

      // check valueRules permissions
      if (permissionToCheck.valueRules != null && itemEdit) {
        for (var i = 0; i < permissionToCheck.valueRules.length; i++) {
          var valueRule = permissionToCheck.valueRules[i];
          // do check on this rule now plx
          if (valueRule.type == '==') {
            if (itemEdit[valueRule.field] == valueRule.value) {
              // all is good
            } else {
              return false;
            }
          } else if (valueRule.type == '!=') {
            if (itemEdit[valueRule.field] != valueRule.value) {
              // all is good
            } else {
              return false;
            }
          } else if (valueRule.type == 'length>') {
            if (itemEdit[valueRule.field].length > valueRule.value) {
              // all is good
            } else {
              return false;
            }
          } else if (valueRule.type == 'length<') {
            if (itemEdit[valueRule.field].length < valueRule.value) {
              // all is good
            } else {
              return false;
            }
          } else if (valueRule.type == 'arrayempty') {
            if (itemEdit[valueRule.field] == null || itemEdit[valueRule.field].length <= 0) {
              // all is good - array doesnt exist or is empty
            } else {
              return false;
            }
          } else if (valueRule.type == 'nullempty') {
            if (itemEdit[valueRule.field] == null || itemEdit[valueRule.field] == '') {
              // all is good
            } else {
              return false;
            }
          }
        }
      }
      return true;
    } else {
      return false;
    }
  };
}]);

/***/ }),

/***/ "ZaRN":
/***/ (function(module, exports) {

var path = 'views/selectors/activityList.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"activityLoading || activityLoadingError\">\n  <div my-loader text=\"Loading File Codes\" ng-if=\"activityLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"activityLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{activityLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListTopContainer showMobile\">\n    <div class=\"contentSplitListTopInner\">\n      <div class=\"contentHeader selectCompany\">\n        <h2>File Codes</h2>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"activity in activitySearchList\"  ng-click=\"selectActivity(activity)\" id=\"listItem{{activity.id}}\">\n          <div class=\"listRowItem itemNumber\">{{activity.fileName}}</div>\n          <div class=\"listRowItem collapsedDetail\">{{activity.fileCode}}</div>\n        </div>\n        <div class=\"customListRowOuter hidden\" id=\"fileCodesLoadingMore\">\n          <div class=\"customListRow loadingRow\">\n            <div class=\"progressOuter\">\n              <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n            Loading More File Codes\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ZnTr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectLineController', ['$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', function ($rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout) {

  // Initialise variables to be used
  $scope.lineSearch = "";
  $scope.lineItemList = [];
  $scope.lineItemListFull = [];
  $scope.lineSelectCallback = null;
  $scope.desktopSelected = [];

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.lineSelectFromParent = function (list, cb) {
    $scope.lineSearch = "";
    $scope.lineItemListFull = list;
    $scope.lineItemList = list;
    $scope.lineSelectCallback = cb;
    $scope.desktopSelected = [];

    if ($stateParams.device == 'desktop') {
      $("#selectLineModal").fadeIn(100);
    }
  };

  $scope.selectLineItem = function (lineItem) {
    $scope.lineSelectCallback(lineItem);
  };

  $scope.closeLineSelectList = function () {
    if ($stateParams.device == 'desktop') {
      $("#selectLineModal").fadeOut(100);
    }
    $scope.lineSelectCallback(null);
  };

  $scope.desktopSelectLinesContinue = function () {
    $scope.lineSelectCallback($scope.desktopSelected);
    $("#selectLineModal").fadeOut(100);
  };

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.updateLineSearch = function (searchValue) {
    if (searchValue === "") {
      $scope.lineItemList = $scope.lineItemListFull;
      return;
    }

    // update lineItemList with filtered results
    var filteredList = [];
    for (var i = 0; i < $scope.lineItemListFull.length; i++) {
      if ($scope.lineItemListFull[i].resource.name.indexOf(searchValue) != -1) {
        filteredList.push($scope.lineItemListFull[i]);
      }
    }

    $scope.lineItemList = filteredList;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "ZoNH":
/***/ (function(module, exports) {

var path = 'views/modals/sorryToSeeYouGoModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"sorryToSeeYouGoModal\">\n    <div class=\"modalContainer\">\n      <div class=\"header hidden-xs\">\n        <h1>We're sorry to see you go!</h1>\n        <div class=\"headerCloseButton\" ng-click=\"$('#sorryToSeeYouGoModal').fadeOut(100)\">\n          <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div ng-if=\"noTemplates\" class=\"content\">\n        <p>Your monthly subscription is paid until [RENEWAL DATE]</p>\n        <p>After [RENEWAL DATE] you will lose access to all your orders, dockets and jobs. Not ready to lose your data? Export everything in your account before [RENEWAL DATE].</p>\n        <p>If you would like to proceed with cancelling your subscription, please select 'Cancel Subscription' below.</p>\n      </div>\n      <div class=\"footer\">\n        <div class=\"dbButton white margin-right\" style=\"background: inherit\" ng-click=\"\">\n            Cancel Subscription\n        </div>\n        <div class=\"dbButton\" ng-click=\"$('#sorryToSeeYouGoModal').fadeOut(100)\">\n            Undo\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "a6LV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').service('alertService', ['accessControl', '$rootScope', '$http', '$stateParams', '$q', 'Restangular', '$timeout', function (accessControl, $rootScope, $http, $stateParams, $q, Restangular, $timeout) {

	var predefinedAlerts = {
		'saveOrder': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save your order. Please try again.",
				title: 'Oops'
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this order. Contact your organisation admin.",
				title: 'Access Denied'
			},
			400: {
				type: 'error',
				message: "Something was wrong with the order when we tried to save it. Check all required fields have been supplied.",
				title: "Invalid Order"
			}
		},
		'sendOrder': {
			500: {
				type: 'error',
				message: 'Something went wrong when we tried to update your order. Please try again.',
				title: 'Oops'
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to send this order. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the order when we tried to send it. Check all required fields have been supplied.",
				title: "Invalid Order"
			}
		},
		'acceptOrder': {
			500: {
				type: 'error',
				message: 'Something went wrong when we tried to update your order. Please try again.',
				title: 'Oops'
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to accept this order. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the order when we tried to accept it. Check all required fields have been supplied.",
				title: "Invalid Order"
			}
		},
		'rejectOrder': {
			500: {
				type: 'error',
				message: 'Something went wrong when we tried to update your order. Please try again.',
				title: 'Oops'
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to reject this order. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the order when we tried to reject it. Check all required fields have been supplied.",
				title: "Invalid Order"
			}
		},
		'closeOrder': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to update your order. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to close this order. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the order when we tried to close it. Check all required fields have been supplied.",
				title: "Invalid Order"
			}
		},
		'deleteOrder': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete your order. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to delete this order. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the order when we tried to delete it. Check all required fields have been supplied.",
				title: "Invalid Order"
			}
		},
		'sendBulkOrders': {
			200: {
				type: 'success',
				message: 'Orders successfully sent.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the orders selected could not be sent. Check that they are in valid and try again.',
				title: 'Hold Tight!'
			}
		},
		'acceptBulkOrders': {
			200: {
				type: 'success',
				message: 'Orders successfully accepted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the orders selected could not be accepted. Check that they are in the sent status and try again.',
				title: 'Hold Tight!'
			}
		},
		'rejectBulkOrders': {
			200: {
				type: 'success',
				message: 'Orders successfully rejected.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the orders selected could not be rejected. Check that they are in the sent status and try again.',
				title: 'Hold Tight!'
			}
		},
		'closeBulkOrders': {
			200: {
				type: 'success',
				message: 'Orders successfully closed.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the orders selected could not be closed. Check if they can be closed and try again.',
				title: 'Hold Tight!'
			}
		},
		'deleteBulkOrders': {
			200: {
				type: 'success',
				message: 'Orders successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the orders selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'jobStatusChange': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to update your status. Please try again.",
				title: 'Oops'
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to do this. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'saveJob': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save your job. Please try again.",
				title: 'Oops'
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this job. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the job when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'deleteJob': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete your job. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to delete this job. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'sendJob': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to send your job. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to send this job. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the job when we tried to send it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'rejectJobWithDockets': {
			400: {
				type: 'warning',
				message: "You cannot reject this job because you have already created Dockets for it.",
				title: "Warning"
			}
		},
		'closeJob': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to close your job. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to close this job. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the job when we tried to close it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'addJobComment': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save your comment. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to comment on this job. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'removeJobComment': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to remove this comment. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to remove this comment. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBulkJobs': {
			200: {
				type: 'success',
				message: 'Jobs successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the jobs selected could not be deleted. Check that they can be deleted and try again.',
				title: 'Hold Tight!'
			}
		},
		'sendBulkJobs': {
			200: {
				type: 'success',
				message: 'Jobs successfully sent.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the jobs selected could not be sent. Check that they can be sent and try again.',
				title: 'Hold Tight!'
			}
		},
		'closeBulkJobs': {
			200: {
				type: 'success',
				message: 'Jobs successfully closed.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the jobs selected could not be closed. Check that they can be closed and try again.',
				title: 'Hold Tight!'
			}
		},
		'saveDocket': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this docket. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			551: {
				type: 'error',
				message: "Something went wrong when we tried to save the signatures for this docket. Please try again.",
				title: "Oops"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the docket when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'deleteDocket': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete this docket. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to delete this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'sendDocket': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to send this docket. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to send this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the docket when we tried to send it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'acceptDocket': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to accept this docket. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to accept this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the docket when we tried to accept it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'rejectDocket': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to reject this docket. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to reject this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the docket when we tried to reject it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'deleteBulkDockets': {
			200: {
				type: 'success',
				message: 'Dockets successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the dockets selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'sendBulkDockets': {
			200: {
				type: 'success',
				message: 'Dockets successfully sent.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the dockets selected could not be sent. Remember, dockets have to be valid before they can be sent.',
				title: 'Hold Tight!'
			}
		},
		'rejectBulkDockets': {
			200: {
				type: 'success',
				message: 'Dockets successfully rejected.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the dockets selected could not be rejected.',
				title: 'Hold Tight!'
			}
		},
		'acceptBulkDockets': {
			200: {
				type: 'success',
				message: 'Dockets successfully accepted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the dockets selected could not be accepted.',
				title: 'Hold Tight!'
			}
		},
		'acceptFileBulkDocketsAccepted': {
			200: {
				type: 'success',
				message: 'Dockets successfully accepted and filed.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the dockets selected could not be accepted. Please check failed dockets and try filing again.',
				title: 'Hold Tight!'
			}
		},
		'uploadDocketAttachment': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save your attachment. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to upload attachments for this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'fileDocket': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to file this docket. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to file this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'openDocketFiling': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to open this docket to file. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to open this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'saveDocketFiling': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to file this docket. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to file this docket. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBatch': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete this batch. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to delete this batch. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBulkBatches': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete these batches. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to delete these batches. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'saveContact': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this contact. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this contact. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the contact when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'deleteContact': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete this contact. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to delete this contact. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'importContacts': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to import these contacts. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to import these contacts. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'contactShare': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to send this contact share. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to send a contact share. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'getOrgGroup': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to load this organisation unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to load this organisation unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'saveOrgGroupSample': {
			400: {
				type: 'error',
				message: "Unfortunately, the sample company has a limit of 4 user-creatable organisation groups.",
				title: "Oops"
			}
		},
		'saveOrgGroupExceed': {
			400: {
				type: 'error',
				message: "Creating this organisation group would exceed your current plan limits.",
				title: "Oops"
			}
		},
		'saveOrgGroupDisallowed': {
			400: {
				type: 'error',
				message: "Unfortunately, your plan does now allow for the creation of additional organisation groups.",
				title: "Oops"
			}
		},
		'saveOrgGroup': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this organisation unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this organisation unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the group when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'addGroupMembers': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to add these members to the unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to add members to this unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'removeGroupMember': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to remove this member from the unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to remove this member from the unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'removeGroupOwner': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to remove this owner from the unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to remove this owner from the unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'removeGroupMonitor': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to remove this monitor from the unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to remove this monitor from the unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'addGroupMember': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to add member(s) to the unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to add member(s) to the unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			401: {
				type: 'error',
				message: "It looks like a user with the selected role already exists in this unit.",
				title: "Hold Up!"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'addGroupOwner': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to add owner(s) to the unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to add owner(s) to the unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'addGroupMonitor': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to add monitor(s) to the unit. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to add monitor(s) to the unit. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'saveRole': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this role. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this role. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBulkRoles': {
			200: {
				type: 'success',
				message: 'Roles successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the roles selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'getTemplate': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to load this template. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to load this template. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'saveTemplate': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this template. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this template. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			},
			999: {
				type: 'error',
				message: "A template can not be un-published once it is published",
				title: "Published Template"
			}
		},
		'deleteTemplate': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete this template. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to delete this template. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBulkTemplates': {
			200: {
				type: 'success',
				message: 'Templates successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the templates selected could not be deleted.',
				title: 'Hold Tight!'
			},
			500: {
				type: 'error',
				message: "Something went wrong when we tried to delete these templates. Please try again.",
				title: "Oops"
			}
		},
		'saveField': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this field. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this field. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBulkFields': {
			200: {
				type: 'success',
				message: 'Fields successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the fields selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'saveChecklistTemplate': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this checklist. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this checklist. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBulkChecklists': {
			200: {
				type: 'success',
				message: 'Checklists successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the checklist selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'saveFileCode': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this file code. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this file code. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the file code when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'deleteBulkFileCodes': {
			200: {
				type: 'success',
				message: 'File codes successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the file codes selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'readFile': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to read this file. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to read this file. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'importFileCodes': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to import file codes. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to import file codes. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'createSampleCompany': {
			400: {
				type: 'error',
				message: "It seems you already have a Sample Company setup. Each user is only allowed a single sample company.",
				title: "Oops"
			}
		},
		'saveResource': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this resource. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this resource. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the resource when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'importResources': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save these resources. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save these resources. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		},
		'deleteBulkResources': {
			200: {
				type: 'success',
				message: 'Resources successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the resources selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'saveResourceCategory': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this resource category. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this resource category. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the category when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'deleteBulkResourceCategories': {
			200: {
				type: 'success',
				message: 'Resource categories successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the resource categories selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'saveUom': {
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this unit of measure. Please try again.",
				title: "Oops"
			},
			403: {
				type: 'error',
				message: "It looks like you don't have permission to save this unit of measure. Contact your organisation admin.",
				title: "Access Denied"
			},
			400: {
				type: 'error',
				message: "Something was wrong with the unit of measure when we tried to save it. Please check required fields have been supplied.",
				title: "Oops"
			}
		},
		'deleteBulkUoms': {
			200: {
				type: 'success',
				message: 'Uoms successfully deleted.',
				title: 'Success!'
			},
			202: {
				type: 'warning',
				message: 'It looks like some of the uoms selected could not be deleted.',
				title: 'Hold Tight!'
			}
		},
		'uploadOrgLogo': {
			200: {
				type: 'success',
				message: 'Logo updated.',
				title: "Success!"
			},
			500: {
				type: 'error',
				message: "Something went wrong when we tried to save this logo. Please try again.",
				title: "Oops"
			},
			400: {
				type: 'error',
				message: "An unknown error occured.",
				title: "Oops"
			}
		}
	};

	var predefinedValidationAlerts = {
		'sendOrder': {
			message: 'Some fields are required before you can send this order.'
		},
		'acceptOrder': {
			message: 'Some fields are required before you can accept this order.'
		},
		'orderCreateJob': {
			message: 'Some fields are required before you can create a job for this order.'
		},
		'orderCreateDocket': {
			message: 'Some fields are required before you can create a docket for this order.'
		},
		'sendJob': {
			message: "Some fields are required before you can send this job."
		},
		'jobCreateDocket': {
			message: "Some fields are required before you can create a docket for this job."
		},
		'sendDocket': {
			message: "Some fields are required before you can send this docket."
		}
	};

	var presentValidationAlert = function presentValidationAlert(message, exceptions) {
		$("#alert").hide();
		var fields = [];
		for (var i = 0; i < exceptions.length; i++) {
			var field = exceptions[i].replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
			var words = field.split(" ");
			var fieldFancy = "";
			for (var j = 0; j < words.length; j++) {
				fieldFancy += words[j].substring(0, 1).toUpperCase();
				fieldFancy += words[j].substring(1);
				fieldFancy += " ";
			}
			fields.push(fieldFancy);
		}
		$rootScope.alert = { type: 'warning', title: 'Hold Tight!', message: message, fields: fields };
		$rootScope.closeAlert = function () {
			$("#alert").fadeOut(200);
		};
		$("#alert").fadeIn(200).css('display', 'table');
	};

	this.presentValidationAlert = presentValidationAlert;

	this.presentAutoValidationAlert = function (alertName, exceptions) {
		var alert = predefinedValidationAlerts[alertName];
		presentValidationAlert(alert.message, exceptions);
	};

	var presentAlert = function presentAlert(type, title, message, supportError) {
		$("#alert").hide();
		var showSupport = false;
		if (supportError && supportError.status != 200) {
			showSupport = true;
		}
		$rootScope.alert = { type: type, title: title, message: message, supportError: supportError, showSupportButton: showSupport };
		$rootScope.closeAlert = function () {
			$("#alert").fadeOut(200);
		};
		$("#alert").fadeIn(200).css('display', 'table');
	};

	this.presentAlert = presentAlert;

	this.presentConfirmAlert = function (title, message, buttonActions, cb) {
		$("#alert").hide();
		$rootScope.alert = { type: 'warning', title: title, message: message, alertButtons: buttonActions };
		$rootScope.alertButtonPress = function (action) {
			$("#alert").fadeOut(200);
			cb(action);
		};
		$("#alert").fadeIn(200).css('display', 'table');
	};

	this.presentAutoAlert = function (alertName, errorObject) {
		var alert = predefinedAlerts[alertName][errorObject.status];
		if (alert) {
			presentAlert(alert.type, alert.title, alert.message, errorObject);
		}
	};

	this.contactSupportError = function (err) {
		var requestId = "unknown";
		if (err && err.headers) {
			requestId = err.headers('x-request-id');
		}
		if (err && err.status == 202 && err.requestName) {
			requestId = err.requestName;
		}
		Intercom('showNewMessage', 'Hi, I got an error with the request id: ' + requestId + ' (W) and Status Code: ' + err.status);
	};
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "aoea":
/***/ (function(module, exports) {

var path = 'views/pages/contacts/contacts.html';
var html = "<div class=\"desktopContainer\">\n  <div class=\"desktopSplitListOuter\">\n    <div class=\"desktopSplitListTableOuter contactList\">\n      <div ng-style=\"{'display' : 'table', 'width':'100%','height':'100%'}\">\n        <div ng-style=\"{'display':'table-row','width':'100%','height':'80px'}\">\n          <div class=\"contentHeadingOuter\">\n            <div class=\"contentHeadingInner desktopTableSearch\">\n              <div class=\"headerSplit\">\n                <div class=\"left\">\n                  <h1>Contacts</h1>\n                </div>\n                <div class=\"right\">\n                  <md-button class=\"md-icon-button\" ng-click=\"newContact()\" aria-label=\"New Contact\">\n                    <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n                  </md-button>\n                  <md-button class=\"md-icon-button\" ng-click=\"showImportContactsModal()\" aria-label=\"Import Contacts\">\n                    <md-icon md-svg-icon=\"import.svg\"></md-icon>\n                  </md-button>\n                  <md-button class=\"md-icon-button\" ng-click=\"newContactShare()\" aria-label=\"New Contact Share\">\n                    <md-icon md-svg-icon=\"_contactshare.svg\"></md-icon>\n                  </md-button>\n                  <md-button class=\"has-hover-count md-icon-button {{activeFilters > 0 ? 'md-primary' : '' }}\" ng-click=\"showFilters = !showFilters\" aria-label=\"Show / Hide Filters\">\n                    <md-icon md-svg-icon=\"filter.svg\"></md-icon>\n                    <div class=\"md-icon-hover-count\" ng-show=\"activeFilters > 0\">{{activeFilters}}</div>\n                  </md-button>\n                  <md-menu>\n                    <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n                      <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n                    </md-button>\n                    <md-menu-content width=\"4\">\n                      <md-menu-item ng-click=\"deleteSelectedContacts()\" aria-label=\"Delete Selected Contacts\">\n                        <md-button>\n                          Delete Selected Contacts\n                        </md-button>\n                      </md-menu-item>\n                      <md-menu-item ng-click=\"startBulkTagAssignment()\" aria-label=\"Assign Tags to Contacts\">\n                        <md-button>\n                          Assign Tags to Contacts\n                        </md-button>\n                      </md-menu-item>\n                    </md-menu-content>\n                  </md-menu>\n                </div>\n              </div>\n\n              <div class=\"ojdDesktopFiltersContainer quickFilters\" ng-if=\"showFilters\">\n                <div class=\"filterRow\">\n                  <div class=\"filterGroup dates\" ng-if=\"listView != 'batch'\">\n                    <h1>Search</h1>\n                    <md-button class=\"md-icon-button selector\" ng-click=\"filters.search = null\">\n                      <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                    </md-button>\n                    <md-input-container class=\"md-block\">\n                      <input type=\"text\" ng-model=\"filters.search\" aria-label=\"Search Contact Filter\" ng-model-options=\"{debounce:1000}\">\n                    </md-input-container>\n                  </div>\n                  <div class=\"filterGroup\">\n                    <h1>Tags</h1>\n                    <md-input-container class=\"md-block\" md-no-float>\n                      <md-select ng-model=\"filters.tags\" placeholder=\"Select a tag\" multiple=\"true\">\n                        <md-option ng-value=\"tag\" ng-repeat=\"tag in contactTagList\">{{ tag.tag }}</md-option>\n                      </md-select>\n                    </md-input-container>\n                  </div>\n                  <div class=\"filterGroup\">\n                    <md-button ng-click=\"clearFilters()\" class=\"\">\n                      Clear All Filters\n                    </md-button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\">\n          <div ng-style=\"{'display':'table-cell','width':'100%','height':'100%','position':'relative'}\">\n            <div ng-style=\"{'display':'block','height':'100%','position':'absolute','top':'0px','left':'0px','width':'100%','z-index':'10','overflow':'auto'}\">\n              <div>\n                <md-table-container>\n                  <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n                    <thead md-head md-order=\"query.order\" md-on-reorder=\"loadAddressBook\">\n                      <tr md-row>\n                        <th md-column md-order-by=\"displayName\"><span>Display Name</span></th>\n                        <th md-column><span>Address</span></th>\n                        <th md-column><span>Contact Emails</span></th>\n                        <th md-column><span>Tags</span></th>\n                        <th md-column ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\"><span>Xero Synced</span></th>\n                      </tr>\n                    </thead>\n                    <tbody md-body>\n                      <tr md-row ng-repeat=\"contactShare in addressBookShares\" ng-click=\"openContactShare(contactShare)\">\n                        <td md-cell><div class=\"contactShareRowIcon\"></div>{{contactShare.senderOrganisationName}}</td>\n                        <td md-cell>{{stringifyAddress(contactShare.addresses[0])}}</td>\n                        <td md-cell>{{contactShare.contactAddresses[0]}}</td>\n                        <td md-cell></td>\n                        <td md-cell ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\"></td>\n                      </tr>\n                    </tbody>\n                    <tbody md-body>\n                      <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in addressBook\" ng-click=\"openContact(item)\">\n                        <td md-cell>{{item.displayName}}</td>\n                        <td md-cell>{{stringifyAddress(item.addresses[0])}}</td>\n                        <td md-cell><span ng-repeat=\"contact in item.contactAddresses\">{{contact.emailAddress}} </span></td>\n                        <td md-cell>{{contact.tags ? contact.tags.join(', ') : \"\"}}</td>\n                        <td md-cell ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\"><div class=\"xeroAvatar\" ng-if=\"item.xeroContact\"></div></td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </md-table-container>\n                <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadAddressBook\" md-total=\"{{listCount}}\" md-page-select>\n                </md-table-pagination>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"desktopSplitListDetailOuter contactDetail\">\n      <div class=\"detailItemContainer\">\n        <div class=\"ojdDesktopDetailOuter\">\n          <form name=\"contactDesktopForm\">\n            <div class=\"ojdDesktopSection header white\">\n              <div class=\"headerTitle\">\n                <h1>Contact Detail</h1>\n              </div>\n\n              <div class=\"bulkActionsButtons\">\n                <div class=\"dbButton\" ng-click=\"editContact(contactEdit)\" ng-if=\"!contactEdit.editing\">Edit</div>\n                <div class=\"dbButton\" ng-click=\"saveContact(contactEdit)\" ng-if=\"contactEdit.editing\" ng-disabled=\"contactDesktopForm.$invalid\">Save</div>\n                \n                <md-menu>\n                  <md-button aria-label=\"Open contact interactions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n                    <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n                  </md-button>\n                  <md-menu-content width=\"4\">\n                    <md-menu-item ng-click=\"newContactShare(contactEdit)\">\n                      <md-button>\n                        Send My Details\n                      </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-click=\"removeContact(contactEdit)\">\n                      <md-button>\n                        Delete Contact\n                      </md-button>\n                    </md-menu-item>\n                  </md-menu-content>\n                </md-menu>\n                <md-button class=\"md-icon-button\" aria-label=\"Close Contact Detail\" ng-click=\"closeContact()\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n              </div>\n            </div>\n            <div class=\"ojdDesktopMainSections\">\n              <div class=\"ojdDesktopSection noPadding\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">General</h1>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n                  </div>\n                </div>\n\n                <div class=\"ojdDesktopPaddingOuter\">\n                  <div ng-if=\"!contactEdit.shareSent && contactEdit.id != null && contactEdit.fromShare == null\" class=\"\">\n                    <div>It looks like you haven't shared your contact details with {{contactEdit.displayName}} yet.</div>\n                    <div class=\"dbButton lightBlue margin-top\" ng-click=\"newContactShare(contactEdit)\">Send My Details</div>\n                    <br/><br/>\n                  </div>\n                  <div ng-if=\"contactEdit.fromShare != null\">\n                    <div>This contact information was sent to you by {{contactEdit.senderName}} ({{contactEdit.senderEmail}}) from {{contactEdit.senderOrganisationName}}</div>\n                    <br/><br/>\n                  </div>\n                  <h4>Display Name</h4>\n                  <div layout-gt-sm=\"row\">\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                      <label>Display Name</label>\n                      <input type=\"text\" ng-model=\"contactEdit.displayName\" ng-disabled=\"!contactEdit.editing\" required=\"true\">\n                    </md-input-container>\n                  </div>\n                  <h4>Address</h4>\n                  <div class=\"group\" ng-if=\"contactEdit.editing\">\n                    <input type=\"text\" name=\"location\" ng-model=\"contactEdit.location\" address-model=\"contactEdit.address\" class=\"{{contactEdit.location != null ? 'ng-dirty' : ''}}\" googleplace placeholder=\"\">\n                    <span class=\"highlight\"></span>\n                    <span class=\"bar\"></span>\n                    <label>Search Address</label>\n                  </div>\n                  <div layout-gt-sm=\"row\">\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n                      <label>Unit Number</label>\n                      <input type=\"text\" ng-model=\"contactEdit.address.num\" ng-disabled=\"!contactEdit.editing\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n                      <label>Street Number</label>\n                      <input type=\"text\" ng-model=\"contactEdit.address.streetNum\" ng-disabled=\"!contactEdit.editing\">\n                    </md-input-container>\n                  </div>\n                  <div layout-gt-sm=\"row\">\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n                      <label>Street Name *</label>\n                      <input type=\"text\" ng-model=\"contactEdit.address.streetName\" ng-disabled=\"!contactEdit.editing\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n                      <label>Suburb *</label>\n                      <input type=\"text\" ng-model=\"contactEdit.address.suburb\" ng-disabled=\"!contactEdit.editing\">\n                    </md-input-container>\n                  </div>\n                  <div layout-gt-sm=\"row\">\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n                      <label>State *</label>\n                      <input type=\"text\" ng-model=\"contactEdit.address.state\" ng-disabled=\"!contactEdit.editing\">\n                    </md-input-container>\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n                      <label>Post Code *</label>\n                      <input type=\"text\" ng-model=\"contactEdit.address.postCode\" ng-disabled=\"!contactEdit.editing\">\n                    </md-input-container>\n                  </div>\n                  <div layout-gt-sm=\"row\">\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n                      <label>Country *</label>\n                      <input type=\"text\" ng-model=\"contactEdit.address.country\" ng-disabled=\"!contactEdit.editing\">\n                    </md-input-container>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"ojdDesktopSection noPadding\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">Contact Emails / Mobile Numbers</h1>\n                    <p style=\"padding-left:0px;\">Dockets can be sent via Email or SMS to a mobile phone number.</p>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n                    <md-button class=\"md-icon-button\" ng-if=\"contactEdit.editing\" ng-click=\"addNewContactEmail(contactEdit)\" aria-label=\"Add Email To Contact\">\n                      <md-icon md-svg-src=\"add.svg\"></md-icon>\n                    </md-button>\n                  </div>\n                </div>\n\n                <p ng-if=\"contactEdit.contactAddresses.length <= 0\">\n                  No contact emails for this contact\n                </p>\n\n                <md-table-container class=\"docketResourceTable\" ng-show=\"contactEdit.contactAddresses.length > 0\">\n                  <table md-table multiple>\n                    <tbody md-body>\n                      <tr md-row ng-repeat=\"address in contactEdit.contactAddresses\">\n                        <td md-cell>\n                          <span ng-if=\"!contactEdit.editing\">{{address.emailAddress}}</span>\n                          <md-input-container ng-if=\"contactEdit.editing\" class=\"md-block\" flex-gt-sm>\n                            <input type=\"text\" ng-model=\"address.emailAddress\">\n                          </md-input-container>\n                        </td>\n                        <td md-cell width=\"100px\">\n                          <md-button class=\"md-icon-button\" ng-if=\"contactEdit.editing\" ng-click=\"removeEmailFromContact(address, contactEdit)\" aria-label=\"Remove Email From Contact\">\n                            <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                          </md-button>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </md-table-container>\n              </div>\n\n              <div class=\"ojdDesktopSection noPadding\">\n                  <div class=\"sectionHeadingContainer\">\n                    <div class=\"sectionHeadingLeft\">\n                      <h1 class=\"sectionHeading\">Contact Tags</h1>\n                    </div>\n                    <div class=\"sectionHeadingRight\">\n                      <md-button class=\"md-icon-button\" ng-if=\"contactEdit.editing\" ng-click=\"addNewTags()\" aria-label=\"Add Tags To Contact\">\n                        <md-icon md-svg-src=\"add.svg\"></md-icon>\n                      </md-button>\n                    </div>\n                  </div>\n\n                  <p ng-if=\"contactEdit.tags.length <= 0\">\n                    This contact doesn't have any tags assigned to it.\n                  </p>\n\n                  <md-table-container class=\"docketResourceTable\" ng-show=\"contactEdit.tags.length > 0\">\n                    <table md-table multiple>\n                      <tbody md-body>\n                        <tr md-row ng-repeat=\"tag in contactEdit.tags\">\n                          <td md-cell>\n                            <span>{{tag}}</span>\n                          </td>\n                          <td md-cell width=\"100px\">\n                            <md-button class=\"md-icon-button\" ng-if=\"contactEdit.editing\" ng-click=\"removeTagFromContact(tag, contactEdit)\" aria-label=\"Remove Tag From Contact\">\n                              <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                            </md-button>\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                  </md-table-container>\n                </div>\n\n              <div class=\"ojdDesktopSection noPadding\" ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">Xero Contact</h1>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n                  </div>\n                </div>\n\n                <div class=\"ojdDesktopPaddingOuter\">\n\n                  <div ng-if=\"!contactEdit.xeroID\">\n                    No xero contact synced.\n                    <br/>\n                    <div class=\"dbButton lightBlue margin-top\" ng-click=\"syncXeroContact(contactEdit)\">Select Xero Contact</div>\n                  </div>\n\n                  <div ng-if=\"contactEdit.xeroID\">\n                    <div layout-gt-sm=\"row\">\n                      <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                        <label>Xero ID</label>\n                        <input type=\"text\" ng-model=\"contactEdit.xeroID\" ng-disabled=\"true\">\n                      </md-input-container>\n                    </div>\n                    <div layout-gt-sm=\"row\">\n                      <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                        <label>Name</label>\n                        <input type=\"text\" ng-model=\"contactEdit.xeroContact.name\" ng-disabled=\"true\">\n                      </md-input-container>\n                    </div>\n                    <div layout-gt-sm=\"row\">\n                      <div class=\"dbButton grey\" ng-click=\"syncXeroContact(contactEdit)\">Change Xero Contact</div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n\n<!-- Share Contact Modal -->\n<ng-include src=\"'views/modals/shareContactModal.html'\"></ng-include>\n<ng-include src=\"'views/modals/selectContactTagModal.html'\"></ng-include>\n<ng-include src=\"'views/modals/selectXeroContactModal.html'\" ng-controller=\"selectXeroContactController\"></ng-include>\n<!-- End Share Contact Modal -->\n\n\n<ng-include src=\"'views/modals/importContactsModal.html'\" ng-controller=\"importContactsModalController\"></ng-include>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ap1B":
/***/ (function(module, exports) {

var path = 'views/pages/batches/batchList.html';
var html = "<md-table-container>\n  <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n    <thead md-head md-order=\"query.order\" md-on-reorder=\"loadBatchesList\">\n      <tr md-row>\n        <th md-column md-order-by=\"localIdentifier\"><span>Identifier</span></th>\n        <th md-column md-order-by=\"xeroInvoiceNumber\"><span>Xero Invoice Number</span></th>\n        <th md-column md-order-by=\"dockets\"><span>Dockets</span></th>\n        <th md-column><span>Status</span></th>\n      </tr>\n    </thead>\n    <tbody md-body>\n      <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in listItems\" ng-click=\"openBatchDesktop(item)\">\n        <td md-cell>{{item.localIdentifier}}</td>\n        <td md-cell>{{item.external.xero.invoiceNumber}}</td>\n        <td md-cell>{{item.dockets}}</td>\n        <td md-cell width=\"100px\"><div class=\"statusDisplay {{item.status == 'draft' ? 'draft' : 'Completed'}}\">{{item.status == \"draft\" ? 'Draft' : 'Invoiced'}}</div></td>\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>\n<md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadBatchesList\" md-total=\"{{listCount}}\" md-page-select>\n\n</md-table-pagination>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "atOe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').service('jobService', ['orderService', '$http', '$stateParams', '$cookies', '$q', '$timeout', 'Restangular', 'geolocation', 'accessControl', function (orderService, $http, $stateParams, $cookies, $q, $timeout, Restangular, geolocation, accessControl) {

  /***** Save a job ******/
  var saveJob = function saveJob(job, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var job = angular.copy(job);
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
    if (job.orderRef != null) {
      // extract customer information from order and append to job
      if (job.orderRef.customer) {
        job.customer = job.orderRef.customer;
      }
      if (job.orderRef.customerGroup) {
        job.customerGroup = job.orderRef.customerGroup;
      }
      if (job.orderRef.customerName) {
        job.customerName = job.orderRef.customerName;
      }
      if (job.orderRef.customerAddress) {
        job.customerAddress = job.orderRef.customerAddress;
      }
      if (job.orderRef.id != null) {
        job.orderRef = job.orderRef.id;
      }
    } else {
      delete job.orderRef;
    }

    // convert js dates to ISO date strings
    if (job.startDate) {
      job.startDate = (0, _momentTimezone2.default)(job.startDate).format('YYYY-MM-DD');
    }
    if (job.endDate) {
      job.endDate = (0, _momentTimezone2.default)(job.endDate).format('YYYY-MM-DD');
    }

    // update line items to have id's for ref'd items - not objects
    if (job.lineItems != null) {
      for (var i = 0; i < job.lineItems.length; i++) {
        // save quantities in minutes
        if (job.lineItems[i].resource && job.lineItems[i].resource.uom) {
          if (job.lineItems[i].resource.uom.isTime) {
            var totalMinutes = 0;
            if (job.lineItems[i].quantityHoursEdit) {
              totalMinutes += parseInt(job.lineItems[i].quantityHoursEdit) * 60;
            }
            if (job.lineItems[i].quantityMinutesEdit) {
              totalMinutes += parseInt(job.lineItems[i].quantityMinutesEdit);
            }
            job.lineItems[i].quantity = totalMinutes;
          } else {
            job.lineItems[i].quantity = parseFloat(job.lineItems[i].quantityEdit);
          }
        }

        if (job.lineItems[i].resource && job.lineItems[i].resource.id != null) {
          job.lineItems[i].resource = job.lineItems[i].resource.id;
        }
      }
    }

    // update job assignee status's
    if (job.assignees != null) {
      for (var i = 0; i < job.assignees.length; i++) {
        job.assignees[i].status = job.assignees[i].status.toLowerCase();
      }
    }

    if (job.status) {
      job.status = job.status.toLowerCase();
    }

    if (job.id == null) {
      // new job - save new
      var currentOrg = organisation;
      var currentOrgGroup = organisationGroup;
      job.jobOwner = currentOrg.id;
      job.status = 'draft';
      if (currentOrgGroup != null) {
        job.organisationGroup = currentOrgGroup.id;
      }
      job.jobNumber = null;
      baseJobs.post(job).then(successCb, failureCb);
    } else {
      baseJobs.one(job.id).customPUT(job).then(successCb, failureCb);
    }
  };

  this.saveJob = saveJob;

  /********** Get Single Job *************/
  var getJob = function getJob(jobId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var currentUser = accessControl.currentUser();

    var baseJobs = Restangular.all('jobs');
    if (organisation != null) {
      baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
    }

    if (jobId.id != null) {
      jobId = jobId.id;
    }
    baseJobs.one(jobId).get().then(function (fullJob) {
      fullJob.status = fullJob.status.charAt(0).toUpperCase() + fullJob.status.slice(1);
      if (fullJob.lineItems == null) {
        fullJob.lineItems = [];
      }
      // prepare dates correctly
      if (fullJob.startDate) {
        fullJob.startDate = (0, _momentTimezone2.default)(fullJob.startDate).toDate();
      }
      if (fullJob.endDate) {
        fullJob.endDate = (0, _momentTimezone2.default)(fullJob.endDate).toDate();
      }
      fullJob.statusDisplay = fullJob.status;
      // check if currentUser is an assignee
      for (var i = 0; i < fullJob.assignees.length; i++) {
        fullJob.assignees[i].status = fullJob.assignees[i].status.charAt(0).toUpperCase() + fullJob.assignees[i].status.toLowerCase().slice(1);
        if (fullJob.assignees[i].assignee == currentUser.id) {
          fullJob.userIsAssignee = true;
          fullJob.userAssigneeData = fullJob.assignees[i];
          if (!accessControl.userHasPermission('io.docketbook.ojdapi.updateJob')) {
            fullJob.statusDisplay = fullJob.userAssigneeData.status.charAt(0).toUpperCase() + fullJob.userAssigneeData.status.slice(1);
          }
        }
      }
      // sort job comments by date
      fullJob.comments.sort(function (a, b) {
        return (0, _momentTimezone2.default)(b.date, _momentTimezone2.default.ISO_8601).toDate() - (0, _momentTimezone2.default)(a.date, _momentTimezone2.default.ISO_8601).toDate();
      });
      // make sure job comments are using html line breaks
      for (var i = 0; i < fullJob.comments.length; i++) {
        if (fullJob.comments[i].comment != '') {
          fullJob.comments[i].comment = fullJob.comments[i].comment.replace(/\r?\n/g, '<br/>');
        }
      }
      // fix dockets status's
      for (var i = 0; i < fullJob.dockets.length; i++) {
        fullJob.dockets[i].status = fullJob.dockets[i].status.charAt(0).toUpperCase() + fullJob.dockets[i].status.slice(1);
      }

      // Populate the query params for lookup

      var params = {
        orgs: [],
        groups: [],
        users: []
      };

      var lookupToDo = false;

      fullJob.assignees.forEach(function (a) {
        if (params.orgs.indexOf(a.organisation) === -1) {
          params.orgs.push(a.organisation);
          lookupToDo = true;
        }
        if (params.groups.indexOf(a.organisationGroup) === -1) {
          params.groups.push(a.organisationGroup);
          lookupToDo = true;
        }
        if (params.users.indexOf(a.assignee) === -1) {
          params.users.push(a.assignee);
          lookupToDo = true;
        }
      });

      var lookupPromise = Promise.resolve({
        organisations: [],
        organisationGroups: [],
        users: []
      });
      if (lookupToDo) {
        lookupPromise = Restangular.all('lookup').customGET('', { organisations: params.orgs.join(','), organisationGroups: params.groups.join(',') });
      }

      // successCb(fullJob);
      return Promise.all([fullJob, lookupPromise]);
    }).then(function (response) {
      var fullJob = response[0];
      var lookups = response[1];

      // convert the response into an object of objects for quick lookup

      lookups.organisations = lookups.organisations.reduce(function (acc, value) {
        acc[value.id] = value;
        return acc;
      }, {});

      lookups.organisationGroups = lookups.organisationGroups.reduce(function (acc, value) {
        acc[value.id] = value;
        return acc;
      }, {});

      fullJob.assignees = fullJob.assignees.map(function (assignee) {
        // get company name
        var orgName = "";
        if (lookups.organisations[assignee.organisation]) {
          orgName = lookups.organisations[assignee.organisation].name;
        }

        var groupName = "";
        if (lookups.organisationGroups[assignee.organisationGroup]) {
          groupName = lookups.organisationGroups[assignee.organisationGroup].name;
        }

        var name = orgName + ' - ' + groupName;
        if (orgName === groupName) {
          name = '' + orgName;
        }
        assignee.company = name;
        return assignee;
      });

      return successCb(fullJob);
    }).catch(failureCb);
  };

  this.getJob = getJob;

  /************ Send a Job ************/
  var sendJob = function sendJob(job, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    var jobObject = {};
    jobObject.status = "sent";

    var jobId = job;
    if (jobId.id != null) {
      jobId = jobId.id;
    }

    baseJobs.one(jobId).customPUT(jobObject).then(successCb, failureCb);
  };

  this.sendJob = sendJob;

  /***** Send Bulk Jobs *****/
  this.sendBulkJobs = function (jobs, successCb) {
    var failures = [];
    sendJobs(jobs, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var sendJobs = function sendJobs(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    sendJob(list[index].id, function (success) {
      sendJobs(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      sendJobs(list, index + 1, failures, successCb);
    });
  };

  /*********** Close a Job *************/
  var closeJob = function closeJob(job, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var jobObject = { status: "closed" };
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    var jobId = job;
    if (jobId.id != null) {
      jobId = jobId.id;
    }

    baseJobs.one(jobId).customPUT(jobObject).then(successCb, failureCb);
  };

  this.closeJob = closeJob;

  /***** Close Bulk Jobs ******/
  this.closeBulkJobs = function (jobs, successCb) {
    var failures = [];
    closeJobs(jobs, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var closeJobs = function closeJobs(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    closeJob(list[index].id, function (success) {
      closeJobs(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      closeJobs(list, index + 1, failures, successCb);
    });
  };

  /**** Delete a job ****/
  var deleteJob = function deleteJob(job, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
    var jobId = angular.copy(job);
    if (jobId.id != null) {
      jobId = jobId.id;
    }
    baseJobs.one(jobId).remove().then(successCb, failureCb);
  };

  this.deleteJob = deleteJob;

  /**** Delete Bulk Jobs ****/
  this.deleteBulkJobs = function (jobs, successCb) {
    var failures = [];
    deleteJobs(jobs, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteJobs = function deleteJobs(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteJob(list[index].id, function (success) {
      deleteJobs(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteJobs(list, index + 1, failures, successCb);
    });
  };

  /***** Update Job Access Control Object *****/
  this.updateAccessControl = function (job, accessControlPayload, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('jobs');
    if (organisation != null && organisationGroup != null) {
      baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
    }

    var jobId = job;
    if (jobId.id != null) {
      jobId = jobId.id;
    }

    var accessControlFull = { 'accessControl': accessControlPayload };
    baseJobs.one(jobId).customPUT(accessControlFull).then(successCb, failureCb);
  };

  /**** Assignee status change ****/
  this.assigneeStatusChange = function (job, assignee, statusTo, rejectReason, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var organisationId = null;
    var organisationGroupId = null;

    if (organisation == null || organisation == undefined) {
      organisationId = job.organisation;
    } else {
      organisationId = organisation.id;
    }
    if (organisationGroup == null || organisationGroup == undefined) {
      organisationGroupId = job.organisationGroup;
    } else {
      organisationGroupId = organisationGroup.id;
    }

    var baseJobs = Restangular.all('organisations').one(organisationId).all('groups').one(organisationGroupId).all('jobs');
    var job = angular.copy(job);

    var postObj = {};
    postObj.assignee = assignee;
    postObj.status = statusTo.toLowerCase();
    if (rejectReason) {
      postObj.rejectionComment = rejectReason;
    }

    baseJobs.one(job.id).all('assignee').customPUT(postObj).then(function (success) {
      successCb();
    }, failureCb);
  };

  /******* Add Assignee(s) to job ********/
  this.addAssignee = function (job, people, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    // get current job
    baseJobs.one(job.id).get().then(function (fullJob) {
      var currentAssignees = fullJob.assignees;

      for (var i = 0; i < people.length; i++) {
        // make sure this person is not already assigned
        var found = false;
        for (var j = 0; j < currentAssignees.length; j++) {
          if (currentAssignees[j].assignee == people[i].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          var newAssignee = {};
          newAssignee.assignee = people[i].id;
          newAssignee.name = people[i].name.full;
          newAssignee.status = "assigned";
          currentAssignees.push(newAssignee);
        }
      }

      var putObj = { 'assignees': currentAssignees };
      baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
    }, function (err) {
      failureCb(err);
    });
  };

  /******* Remove Assignee from job *******/
  this.removeAssignee = function (job, assignee, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    // get current job
    baseJobs.one(job.id).get().then(function (fullJob) {
      var currentAssignees = fullJob.assignees;
      for (var i = 0; i < currentAssignees.length; i++) {
        if (currentAssignees[i].id == assignee.id) {
          currentAssignees[i].delete = true;
        }
      }

      var putObj = { 'assignees': currentAssignees };
      baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
    }, function (err) {
      failureCb(err);
    });
  };

  this.removeAssignees = function (job, assignees, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    // get current job
    baseJobs.one(job.id).get().then(function (fullJob) {
      var currentAssignees = fullJob.assignees;
      for (var i = 0; i < currentAssignees.length; i++) {
        if (assignees.map(function (a) {
          return a.id;
        }).includes(currentAssignees[i].id)) {
          currentAssignees[i].delete = true;
        }
      }

      var putObj = { 'assignees': currentAssignees };
      baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
    }, function (err) {
      failureCb(err);
    });
  };

  /******* Assginee Comment ********/
  this.addAssigneeComment = function (job, commentText, successCb, failureCb) {
    var postObj = {};
    postObj.assignee = job.userAssigneeData.assignee;
    postObj.comment = {};
    postObj.comment.comment = commentText;
    postObj.comment.date = (0, _momentTimezone2.default)().toISOString();

    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = "";

    if (organisation == null || organisationGroup == null) {
      baseJobs = Restangular.all('organisations').one(job.organisation).all('groups').one(job.organisationGroup).all('jobs');
    } else {
      baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
    }

    baseJobs.one(job.id).all('assignee').customPUT(postObj).then(successCb, failureCb);
  };

  /******* Delete Assginee Comment *******/
  this.deleteAssigneeComment = function (job, comment, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    var postObj = {};
    postObj.assignee = job.userAssigneeData.assignee;
    postObj.comment = {};
    postObj.comment.id = comment.id;
    postObj.comment.delete = true;
    baseJobs.one(job.id).all('assignee').customPUT(postObj).then(successCb, failureCb);
  };

  /******* Add editor comment to job *******/
  this.addComment = function (job, comment, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    baseJobs.one(job.id).get().then(function (fullJob) {
      if (fullJob.comments == null) {
        fullJob.comments = [];
      }

      job.comments.splice(0, 0, comment);
      var putObj = { 'comments': job.comments };
      baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
    }, failureCb);
  };

  /******* Delete Comment From Job ********/
  this.deleteComment = function (job, comment, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    baseJobs.one(job.id).get().then(function (fullJob) {
      for (var i = 0; i < fullJob.comments.length; i++) {
        if (fullJob.comments[i].id == comment.id) {
          fullJob.comments[i].delete = true;
          break;
        }
      }

      var putObj = { 'comments': fullJob.comments };
      baseJobs.one(job.id).customPUT(putObj).then(successCb, failureCb);
    }, failureCb);
  };

  /******* Get list of jobs ********/
  this.getJobs = function (params, successCb, failureCb) {
    if (params == null) {
      params = {};
    }

    /**** Setup scope - group or myDocketbook ****/
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = null;

    if (organisationGroup != null) {
      baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');
    } else {
      baseJobs = Restangular.all('jobs');
    }
    /**** End scope setup ****/

    if (params['status'] != null) {
      params['status'] = params['status'].toLowerCase();
    }
    if (params['offset'] != null && params['limit'] != null) {
      baseJobs.customGET("", params).then(successCb, failureCb);
    } else {
      baseJobs.getList(params).then(successCb, failureCb);
    }
  };

  /******** Populate Job Detail ********/
  this.populateJobDetails = function (jobsList, cb) {
    populateDetailOnJobs(jobsList, 0, cb);
  };

  var populateDetailOnJobs = function populateDetailOnJobs(jobsList, index, cb) {
    if (index >= jobsList.length) {
      cb(jobsList);
      return;
    }

    getJob(jobsList[index].id, function (jobDetail) {
      jobsList[index] = jobDetail;
      populateDetailOnJobs(jobsList, index + 1, cb);
    }, function (err) {
      populateDetailOnJobs(jobsList, index + 1, cb);
    });
  };

  /******** Parse Jobs **********/
  var parseJobs = function parseJobs(data) {
    var currentUser = accessControl.currentUser();
    var jobs = [];
    data.forEach(function (job) {
      job.loading = false;
      job.status = job.status.charAt(0).toUpperCase() + job.status.slice(1);
      job.statusDisplay = job.status;
      // get summary data on assignee status'
      job.assignedCount = 0;
      job.acceptedCount = 0;
      job.rejectedCount = 0;
      job.completedCount = 0;
      job.assignedUsers = [];
      job.acceptedUsers = [];
      job.rejectedUsers = [];
      job.completedUsers = [];
      job.selected = false;
      for (var i = 0; i < job.assignees.length; i++) {
        job.assignees[i].status = job.assignees[i].status.charAt(0).toUpperCase() + job.assignees[i].status.toLowerCase().slice(1);
        // check if user is an assignee on job
        if (job.assignees[i].assignee == currentUser.id) {
          job.userAssigneeData = job.assignees[i];
          job.statusDisplay = job.userAssigneeData.status.charAt(0).toUpperCase() + job.userAssigneeData.status.slice(1);
        }
        if (job.assignees[i].status.toLowerCase() == 'assigned') {
          job.assignedCount += 1;
          job.assignedUsers.push(job.assignees[i]);
        }
        if (job.assignees[i].status.toLowerCase() == 'accepted') {
          job.acceptedCount += 1;
          job.acceptedUsers.push(job.assignees[i]);
        }
        if (job.assignees[i].status.toLowerCase() == 'rejected') {
          job.rejectedCount += 1;
          job.rejectedUsers.push(job.assignees[i]);
        }
        if (job.assignees[i].status.toLowerCase() == 'completed') {
          job.completedCount += 1;
          job.completedUsers.push(job.assignees[i]);
        }
      }
      jobs.push(job);
    });

    return jobs;
  };

  this.parseJobs = parseJobs;

  /******* Get New Docket From Job *******/
  this.createDocketFromJob = function (job, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseJobs = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('jobs');

    var jobId = job;
    if (jobId.id != null) {
      jobId = jobId.id;
    }

    baseJobs.one(jobId).post().then(successCb, failureCb);
  };

  /******* Get job diff ********/
  this.getJobDiff = function (original, modified, cb) {
    // check start/end date fields
    if (modified.id == null) {
      cb(modified, 1);
      return;
    }
    var diff = {};
    var diffCount = 0;
    if (!original.startDate && modified.startDate) {
      diff.startDate = modified.startDate;
      diffCount += 1;
    }
    if (original.startDate && modified.startDate && original.startDate.getTime() != modified.startDate.getTime()) {
      diff.startDate = modified.startDate;
      diffCount += 1;
    }
    if (!original.endDate && modified.endDate) {
      diff.endDate = modified.endDate;
      diffCount += 1;
    }
    if (original.endDate && modified.endDate && original.endDate.getTime() != modified.endDate.getTime()) {
      diff.endDate = modified.endDate;
      diffCount += 1;
    }

    // check order ref
    if (!original.orderRef && modified.orderRef) {
      diff.orderRef = modified.orderRef;
      diff.customerContact = modified.customerContact;
      diff.supplierContact = modified.supplierContact;
      diffCount += 1;
    }
    if (original.orderRef && modified.orderRef) {
      if (original.orderRef.id != null && modified.orderRef.id != null && original.orderRef.id != modified.orderRef.id) {
        diff.orderRef = modified.orderRef;
        diff.customerContact = modified.customerContact;
        diff.supplierContact = modified.supplierContact;
        diffCount += 1;
      } else if (original.orderRef.id == null && modified.orderRef.id == null && original.orderRef != modified.orderRef) {
        diff.orderRef = modified.orderRef;
        diff.customerContact = modified.customerContact;
        diff.supplierContact = modified.supplierContact;
        diffCount += 1;
      }
    }
    // check customer contact
    if (!original.customerContact && modified.customerContact) {
      diff.customerContact = modified.customerContact;
      diffCount += 1;
    }
    if (original.customerContact && modified.customerContact && original.customerContact.displayName != modified.customerContact.displayName) {
      diff.customerContact = modified.customerContact;
      diffCount += 1;
    }
    // check supplier contact
    if (!original.supplierContact && modified.supplierContact) {
      diff.supplierContact = modified.supplierContact;
      diffCount += 1;
    }
    if (original.supplierContact && modified.supplierContact && original.supplierContact.displayName != modified.supplierContact.displayName) {
      diff.supplierContact = modified.supplierContact;
      diffCount += 1;
    }
    // check line items
    if (!original.lineItems && modified.lineItems) {
      diff.lineItems = modified.lineItems;
      diffCount += 1;
    }
    if (original.lineItems && modified.lineItems) {
      var linesChanged = false;
      if (original.lineItems.length != modified.lineItems.length) {
        linesChanged = true;
      } else {
        for (var i = 0; i < modified.lineItems.length; i++) {
          if (modified.lineItems[i].delete == true) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].id != original.lineItems[i].id) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].itemDescription != original.lineItems[i].itemDescription) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].resource.id != original.lineItems[i].resource.id) {
            linesChanged = true;
            break;
          }
          if ($stateParams.device == 'desktop') {
            if (original.lineItems[i].quantityEdit != modified.lineItems[i].quantityEdit) {
              linesChanged = true;
              break;
            }
            if (original.lineItems[i].quantityHoursEdit != modified.lineItems[i].quantityHoursEdit) {
              linesChanged = true;
              break;
            }
            if (original.lineItems[i].quantityMinutesEdit != modified.lineItems[i].quantityMinutesEdit) {
              linesChanged = true;
              break;
            }
          } else {
            if (!original.lineItems[i].quantity && modified.lineItems[i].quantity) {
              linesChanged = true;
              break;
            }
            if (modified.lineItems[i].quantity && original.lineItems[i].quantity && modified.lineItems[i].quantity != original.lineItems[i].quantity) {
              linesChanged = true;
              break;
            }
          }
        }
      }
      if (linesChanged) {
        diff.lineItems = modified.lineItems;
        diffCount += 1;
      }
    }

    // check instructions
    if (!original.instructions && modified.instructions) {
      diff.instructions = modified.instructions;
      diffCount += 1;
    }
    if (original.instructions && modified.instructions && original.instructions != modified.instructions) {
      diff.instructions = modified.instructions;
      diffCount += 1;
    }
    // check from and to addresses
    if (!original.fromAddress && modified.fromAddress) {
      diff.fromAddress = modified.fromAddress;
      diffCount += 1;
    }
    if (original.fromAddress && modified.fromAddress && original.fromAddress != modified.fromAddress) {
      diff.fromAddress = modified.fromAddress;
      diffCount += 1;
    }
    if (!original.toAddress && modified.toAddress) {
      diff.toAddress = modified.toAddress;
      diffCount += 1;
    }
    if (original.toAddress && modified.toAddress && original.toAddress != modified.toAddress) {
      diff.toAddress = modified.toAddress;
      diffCount += 1;
    }

    // check assignees array
    /*if ( !original.assignees && modified.assignees ) {
      diff.assignees = modified.assignees;
      diffCount += 1;
    }
    if ( original.assignees && modified.assignees ) {
      var assigneesChanged = false;
      if ( original.assignees.length != modified.assignees.length ) {
        assigneesChanged = true;
      } else {
        for ( var i = 0; i < modified.assignees.length; i++ ) {
          if ( modified.assignees[i].assignee != original.assignees[i].assignee ) {
            assigneesChanged = true;
            break;
          } else if ( modified.assignees[i].delete == true ) {
            assigneesChanged = true;
            break;
          }
        }
      }
      if ( assigneesChanged ) {
        diff.assignees = modified.assignees;
        diffCount += 1;
      }
    }*/

    // check comments array
    /*if ( !original.comments && modified.comments ) {
      diff.comments = modified.comments;
      diffCount += 1;
    }
    if ( original.comments && modified.comments ) {
      var commentsChanged = false;
      if ( original.comments.length != modified.comments.length ) {
        commentsChanged = true;
      } else {
        for ( var i = 0; i < modified.comments.length; i++ ) {
          if ( modified.comments[i].comment != original.comments[i].comment ) {
            commentsChanged = true;
            break;
          } else if ( modified.comments[i].delete == true ) {
            commentsChanged = true;
            break;
          }
        }
      }
      if ( commentsChanged ) {
        diff.comments = modified.comments;
        diffCount += 1;
      }
    }*/

    diff.id = modified.id;
    cb(diff, diffCount);
  };

  /** Validation Parameters **/
  // Lists the required fields for each action on the job and their respective types
  var validationParameters = {
    'sendJob': { 'orderRef': 'string', 'startDate': 'string', 'endDate': 'string', 'lineItems': 'array' },
    'createDocketFromJob': { 'orderRef': 'string' }
  };
  var niceFieldDisplays = {
    'orderRef': 'Order',
    'startDate': 'Start Date',
    'endDate': 'End Date',
    'assignees': 'Assignees',
    'lineItems': 'Items'
  };

  var checkRequiredParameters = function checkRequiredParameters(job, parameters, successCb, failureCb) {
    var exceptions = [];
    var paramsKeys = Object.keys(parameters);
    for (var i = 0; i < paramsKeys.length; i++) {
      var thisParam = paramsKeys[i];
      if (parameters[thisParam] == 'string' && (job[thisParam] == null || job[thisParam] == "")) {
        if (niceFieldDisplays[thisParam] != null) {
          exceptions.push(niceFieldDisplays[thisParam]);
        } else {
          exceptions.push(thisParam);
        }
      } else if (parameters[thisParam] == 'array' && (job[thisParam] == null || job[thisParam].length <= 0)) {
        if (niceFieldDisplays[thisParam] != null) {
          exceptions.push(niceFieldDisplays[thisParam]);
        } else {
          exceptions.push(thisParam);
        }
      }
    }

    if (exceptions.length > 0) {
      failureCb(exceptions);
    } else {
      successCb();
    }
  };

  /* Send Job Validation Helper */
  this.validateSendJob = function (job, successCb, failureCb) {
    var validateParams = validationParameters['sendJob'];
    checkRequiredParameters(job, validateParams, successCb, failureCb);
  };

  /* Create Docket From Job Validation Helper */
  this.validateCreateDocket = function (job, successCb, failureCb) {
    var validateParams = validationParameters['createDocketFromJob'];
    checkRequiredParameters(job, validateParams, successCb, failureCb);
  };
}]);

/***/ }),

/***/ "b1Sf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "copy.svg";

/***/ }),

/***/ "b2rq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "drag.svg";

/***/ }),

/***/ "b5+9":
/***/ (function(module, exports) {

var path = 'views/selectors/personList.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"personSearchLoading || personLoadingError\">\n  <div my-loader text=\"Loading People\" ng-if=\"personSearchLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"personLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{peopleLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"loadPeopleList()\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"person in personSearchList\" ng-click=\"selectPersonToAssign(person)\" ng-show=\"!person.assigned\" id=\"listItem{{person.id}}\">\n          <div class=\"listRowItem itemNumber\">{{person.name.full}}</div>\n          <div class=\"listRowItem collapsedDetail\">{{person.emailAddress}}</div>\n        </div>\n\n        <div class=\"mobileListButtons hidden-xs\">\n          <div class=\"btn btn-rounded btn-primary\" ng-click=\"closePersonSelectList()\">\n            Cancel\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "bACn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "warningline.svg";

/***/ }),

/***/ "bHPv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Angucomplete
 * Autocomplete directive for AngularJS
 * By Daryl Rowland
 */

angular.module('angucomplete', []).directive('angucomplete', ['$parse', '$http', '$sce', '$timeout', function ($parse, $http, $sce, $timeout) {
  return {
    restrict: 'EA',
    scope: {
      "id": "@id",
      "placeholder": "@placeholder",
      "selectedObject": "=selectedobject",
      "url": "@url",
      "dataField": "@datafield",
      "titleField": "@titlefield",
      "descriptionField": "@descriptionfield",
      "imageField": "@imagefield",
      "imageUri": "@imageuri",
      "inputClass": "@inputclass",
      "userPause": "@pause",
      "localData": "=localdata",
      "searchFields": "@searchfields",
      "minLengthUser": "@minlength",
      "matchClass": "@matchclass"
    },
    template: '<div class="angucomplete-holder"><input id="{{id}}_value" ng-model="searchStr" type="text" placeholder="{{placeholder}}" class="{{inputClass}}" onmouseup="this.select();" ng-focus="resetHideResults()" ng-blur="hideResults()" autocomplete="off" /><div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-if="showDropdown"><div class="angucomplete-searching" ng-show="searching">Searching...</div><div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)">No results found</div><div class="angucomplete-row" ng-repeat="result in results" ng-mousedown="selectResult(result)" ng-mouseover="hoverRow()" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}"><div ng-if="imageField" class="angucomplete-image-holder"><img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}" class="angucomplete-image"/><div ng-if="!result.image && result.image != \'\'" class="angucomplete-image-default"></div></div><div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div><div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div><div ng-if="result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div></div></div></div>',

    link: function link($scope, elem, attrs) {
      $scope.lastSearchTerm = null;
      $scope.currentIndex = null;
      $scope.justChanged = false;
      $scope.searchTimer = null;
      $scope.hideTimer = null;
      $scope.searching = false;
      $scope.pause = 500;
      $scope.minLength = 3;
      $scope.searchStr = null;

      if ($scope.minLengthUser && $scope.minLengthUser != "") {
        $scope.minLength = $scope.minLengthUser;
      }

      if ($scope.userPause) {
        $scope.pause = $scope.userPause;
      }

      isNewSearchNeeded = function isNewSearchNeeded(newTerm, oldTerm) {
        return newTerm.length >= $scope.minLength && newTerm != oldTerm;
      };

      $scope.processResults = function (responseData, str) {
        if (responseData && responseData.length > 0) {
          $scope.results = [];

          var titleFields = [];
          if ($scope.titleField && $scope.titleField != "") {
            titleFields = $scope.titleField.split(",");
          }

          for (var i = 0; i < responseData.length; i++) {
            // Get title variables
            var titleCode = [];

            for (var t = 0; t < titleFields.length; t++) {
              titleCode.push(responseData[i][titleFields[t]]);
            }

            var description = "";
            if ($scope.descriptionField) {
              description = responseData[i][$scope.descriptionField];
            }

            var imageUri = "";
            if ($scope.imageUri) {
              imageUri = $scope.imageUri;
            }

            var image = "";
            if ($scope.imageField) {
              image = imageUri + responseData[i][$scope.imageField];
            }

            var text = titleCode.join(' ');
            if ($scope.matchClass) {
              var re = new RegExp(str, 'i');
              var strPart = text.match(re)[0];
              text = $sce.trustAsHtml(text.replace(re, '<span class="' + $scope.matchClass + '">' + strPart + '</span>'));
            }

            var resultRow = {
              title: text,
              description: description,
              image: image,
              originalObject: responseData[i]
            };

            $scope.results[$scope.results.length] = resultRow;
          }
        } else {
          $scope.results = [];
        }
      };

      $scope.searchTimerComplete = function (str) {
        // Begin the search

        if (str.length >= $scope.minLength) {
          if ($scope.localData) {
            var searchFields = $scope.searchFields.split(",");

            var matches = [];

            for (var i = 0; i < $scope.localData.length; i++) {
              var match = false;

              for (var s = 0; s < searchFields.length; s++) {
                match = match || typeof $scope.localData[i][searchFields[s]] === 'string' && typeof str === 'string' && $scope.localData[i][searchFields[s]].toLowerCase().indexOf(str.toLowerCase()) >= 0;
              }

              if (match) {
                matches[matches.length] = $scope.localData[i];
              }
            }

            $scope.searching = false;
            $scope.processResults(matches, str);
          } else {
            $http.get($scope.url + str, {}).success(function (responseData, status, headers, config) {
              $scope.searching = false;
              $scope.processResults($scope.dataField ? responseData[$scope.dataField] : responseData, str);
            }).error(function (data, status, headers, config) {
              //no-op
            });
          }
        }
      };

      $scope.hideResults = function () {
        $scope.hideTimer = $timeout(function () {
          $scope.showDropdown = false;
        }, $scope.pause);
      };

      $scope.resetHideResults = function () {
        if ($scope.hideTimer) {
          $timeout.cancel($scope.hideTimer);
        };
      };

      $scope.hoverRow = function (index) {
        $scope.currentIndex = index;
      };

      $scope.keyPressed = function (event) {
        if (!(event.which == 38 || event.which == 40 || event.which == 13)) {
          if (!$scope.searchStr || $scope.searchStr == "") {
            $scope.showDropdown = false;
            $scope.lastSearchTerm = null;
          } else if (isNewSearchNeeded($scope.searchStr, $scope.lastSearchTerm)) {
            $scope.lastSearchTerm = $scope.searchStr;
            $scope.showDropdown = true;
            $scope.currentIndex = -1;
            $scope.results = [];

            if ($scope.searchTimer) {
              $timeout.cancel($scope.searchTimer);
            }

            $scope.searching = true;

            $scope.searchTimer = $timeout(function () {
              $scope.searchTimerComplete($scope.searchStr);
            }, $scope.pause);
          }
        } else {
          event.preventDefault();
        }
      };

      $scope.selectResult = function (result) {
        if ($scope.matchClass) {
          result.title = result.title.toString().replace(/(<([^>]+)>)/ig, '');
        }
        $scope.searchStr = $scope.lastSearchTerm = result.title;
        $scope.selectedObject = result;
        $scope.showDropdown = false;
        $scope.results = [];
        //$scope.$apply();
      };

      var inputField = elem.find('input');

      inputField.on('keyup', $scope.keyPressed);

      elem.on("keyup", function (event) {
        if (event.which === 40) {
          if ($scope.results && $scope.currentIndex + 1 < $scope.results.length) {
            $scope.currentIndex++;
            $scope.$apply();
            event.preventDefault;
            event.stopPropagation();
          }

          $scope.$apply();
        } else if (event.which == 38) {
          if ($scope.currentIndex >= 1) {
            $scope.currentIndex--;
            $scope.$apply();
            event.preventDefault;
            event.stopPropagation();
          }
        } else if (event.which == 13) {
          if ($scope.results && $scope.currentIndex >= 0 && $scope.currentIndex < $scope.results.length) {
            $scope.selectResult($scope.results[$scope.currentIndex]);
            $scope.$apply();
            event.preventDefault;
            event.stopPropagation();
          } else {
            $scope.results = [];
            $scope.$apply();
            event.preventDefault;
            event.stopPropagation();
          }
        } else if (event.which == 27) {
          $scope.results = [];
          $scope.showDropdown = false;
          $scope.$apply();
        } else if (event.which == 8) {
          $scope.selectedObject = null;
          $scope.$apply();
        }
      });
    }
  };
}]);

/***/ }),

/***/ "bPb8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "truck.svg";

/***/ }),

/***/ "bTU9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resourcesave.svg";

/***/ }),

/***/ "bhEf":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/list.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"jobsLoading || jobsLoadingError\">\n  <div my-loader text=\"Loading Jobs\" ng-if=\"jobsLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"jobsLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{jobsLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <div class=\"dbButton simpleOutline\" ng-click=\"loadJobsIntoList()\">Retry</div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"contentList paddingWithoutTabBar tabBarBottomPadding\">\n  <div class=\"customListRowOuter\" ng-repeat=\"item in listItems\" id=\"listItem{{item.id}}\" >\n    <div class=\"customListRow {{(itemEdit.id == item.id || item.selected) ? 'selected' : ''}}\" ng-click=\"openJobDetail(item)\">\n      <div class=\"listRowItem status\"><div class=\"statusDisplay {{item.statusDisplay}}\">{{item.statusDisplay}}</div></div>\n      <div class=\"listRowItem itemNumber\">{{item.jobNumber}}</div>\n      <div class=\"listRowItem collapsedDetail showCollapsed\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\" ng-if=\"item.customerContact\">\n            <div class=\"inner\">\n              {{item.customerContact.displayName}}\n            </div>\n          </div>\n          <div class=\"right\">{{moment(item.startDate).format('DD/MM')}} - {{moment(item.endDate).format('DD/MM')}}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"customListRowOuter hidden\" id=\"jobsLoadingMore\">\n    <div class=\"customListRow loadingRow\">\n      <div class=\"progressOuter\">\n        <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n      </div>\n      Loading More Jobs\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "bvO+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "orders-paywall-illustration.svg";

/***/ }),

/***/ "cB/W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('selectXeroContactController', ['addressBookService', 'xeroService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', function (addressBookService, xeroService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {
  // Initialise variables to be used
  $scope.xeroContactSearchValue = "";
  $scope.contactSelectCallback = null;
  $scope.xeroContactSearchList = [];
  $scope.contactLoadingError = null;
  $scope.contactsSelected = [];
  $scope.xeroContactsList = [];

  if ($scope.currentOrg != null) {
    xeroService.getXeroContacts(function (contacts) {
      $scope.xeroContactsList = contacts;
    }, function (err) {
      $scope.xeroContactsList = [];
    });
  }

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.xeroContactSelectFromParent = function (cb) {
    $("#selectXeroContactModal").fadeIn(100);
    $scope.contactSelectCallback = cb;
    $scope.xeroContactSearchList = $scope.xeroContactsList;
    $scope.xeroContactSearchValue = "";
  };

  $scope.searchXeroContactChange = function (searchValue) {
    if (searchValue == "") {
      $scope.xeroContactSearchList = $scope.xeroContactsList;
      return;
    }

    $scope.xeroContactSearchList = $scope.xeroContactsList.filter(function (contact) {
      return _stringSimilarity2.default.compareTwoStrings(contact.name, searchValue) > 0.5 || contact.name.toLowerCase().indexOf(searchValue.toLowerCase()) != -1;
    });
  };

  $scope.selectXeroContact = function (xeroContact) {
    $scope.xeroContactDetail = xeroContact;
  };

  $scope.closeXeroContactSelect = function () {
    $("#selectXeroContactModal").fadeOut(100);
  };

  $scope.assignXeroContact = function (xeroContact) {
    $scope.closeXeroContactSelect();
    $scope.contactSelectCallback(xeroContact);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "cFdt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cIse":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_switch.svg";

/***/ }),

/***/ "cLTV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "location.svg";

/***/ }),

/***/ "cSZv":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/orderTab.html';
var html = "<div class=\"ojdDesktopSection header {{getStatus(itemEdit)}}\">\n  <div class=\"headerTitle\" ng-if=\"itemEdit.status\">\n    <div class=\"centerAligned\">\n      <h2>Status</h2>\n      <h1>{{getStatus(itemEdit)}}</h1>\n    </div>\n    <div class=\"dbButton floatRight centerAligned\" ng-click=\"showAcceptOrderWizard()\" ng-if=\"userCanDoAction('acceptOrder', itemEdit) && !itemEdit.loading\">Review and Accept</div>\n  </div>\n</div>\n\n<div class=\"ojdDesktopSection\" style=\"text-align:center;\" ng-if=\"currentOrg == null\">\n  This order is not assigned to an organisation.\n  <br/>\n  <div class=\"dbButton lightBlue margin-top\" ng-click=\"assignOrderOrg(itemEdit)\">Select Organisation</div>\n</div>\n<div class=\"ojdDesktopMainSections\">\n  <!-- Start Summary Section -->\n  <div class=\"ojdDesktopSection\">\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Order Number</label>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <input ng-model=\"itemEdit.orderNumber\" ng-disabled=\"!userCanDoAction('editOrderNumber', itemEdit)\" aria-label=\"Order Number\">\n        </md-input-container>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\" ng-click=\"!userCanDoAction('changeOrderSupplier', itemEdit) || selectCompany('supplierContact')\">\n        <label class=\"order\">Supplier</label>\n        <h2 ng-if=\"itemEdit.supplierContact\">{{itemEdit.supplierContact.displayName}}</h2>\n        <h2 ng-if=\"!itemEdit.supplierContact\">Not Selected</h2>\n        <h3 ng-if=\"itemEdit.supplierContact\">{{stringifyAddress(itemEdit.supplierContact.addresses[0])}}</h3>\n        <h3 ng-if=\"userCanDoAction('changeOrderSupplier', itemEdit)\">\n          Click to <span ng-if=\"itemEdit.supplierContact\">change</span><span ng-if=\"!itemEdit.supplierContact\">select</span> supplier\n        </h3>\n      </div>\n      <div class=\"ojdDesktopField\" ng-if=\"!itemEdit.customerContact\" ng-click=\"!userCanDoAction('changeOrderCustomer', itemEdit) || selectCompany('customerContact')\">\n        <label class=\"order\">Customer</label>\n        <h2>Not Selected</h2>\n        <h3 ng-if=\"userCanDoAction('changeOrderCustomer', itemEdit)\">\n          Click to select customer\n        </h3>\n      </div>\n      <div class=\"ojdDesktopField\" ng-if=\"itemEdit.customerContact\" ng-click=\"!userCanDoAction('editOrderCustomer', itemEdit) || editOrderCustomer(itemEdit)\">\n        <label class=\"order\">Customer</label>\n        <h2>{{itemEdit.customerContact.displayName}}</h2>\n        <h3>{{stringifyAddress(itemEdit.customerContact.addresses[0])}}</h3>\n        <h3 ng-if=\"userCanDoAction('editOrderCustomer', itemEdit)\">\n          Click to edit customer\n        </h3>\n      </div>\n      <md-button ng-click=\"swapCustSup(itemEdit)\" aria-label=\"Swap Customer & Supplier\" ng-if=\"userCanDoAction('swapCustomerSupplier', itemEdit)\">\n        Swap Cust/Sup\n      </md-button>\n    </div>\n\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\" ng-if=\"!itemEdit.xeroQuote\">\n        <label class=\"order\">Supplier Ref No</label>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <input ng-model=\"itemEdit.supplierRefNo\" ng-disabled=\"!userCanDoAction('editSupplierRefNo', itemEdit)\" aria-label=\"Supplier Reference Number\">\n        </md-input-container>\n      </div>\n      <div class=\"ojdDesktopField\" ng-if=\"itemEdit.xeroQuote\">\n        <label class=\"order\">Xero Quote</label>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <div ng-if=\"itemEdit.xeroQuoteFull\"><div class=\"xeroAvatar\"></div><a target=\"_blank\" href=\"https://go.xero.com/organisationlogin/default.aspx?shortcode={{currentOrg.features.xero.shortCode}}&redirecturl=/Accounts/Receivable/Quotes/Edit/{{itemEdit.xeroQuoteFull.quoteID}}\">{{itemEdit.xeroQuoteFull.quoteNumber}} ({{itemEdit.xeroQuoteFull.status}})</a></div>\n        </md-input-container>\n      </div>\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Customer Ref No</label>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <input ng-model=\"itemEdit.customerRefNo\" ng-disabled=\"!userCanDoAction('editCustomerRefNo', itemEdit)\" aria-label=\"Customer Reference Number\">\n        </md-input-container>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Notes</label>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <textarea ng-model=\"itemEdit.notes\" ng-disabled=\"!userCanDoAction('editOrderNotes', itemEdit)\" aria-label=\"Order Notes\" rows=\"3\" md-select-on-focus ng-disabled=\"!itemEdit.editing\"></textarea>\n        </md-input-container>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopRow\">\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">Start Date</label>\n        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n          <md-datepicker ng-model=\"itemEdit.startDate\" name=\"startDate\" ng-disabled=\"!userCanDoAction('editOrderStartDate', itemEdit)\" aria-label=\"Start Date\"></md-datepicker>\n        </md-input-container>\n      </div>\n      <div class=\"ojdDesktopField\">\n        <label class=\"order\">End Date</label>\n        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n          <md-datepicker ng-model=\"itemEdit.endDate\" name=\"endDate\" ng-disabled=\"!userCanDoAction('editOrderEndDate', itemEdit)\" aria-label=\"End Date\"></md-datepicker>\n        </md-input-container>\n      </div>\n      <div class=\"ojdDesktopField\" ng-click=\"!userCanDoAction('changeOrderDocketTemplate', itemEdit) || selectDocketTemplate()\" ng-if=\"userCanDoAction('viewOrderDocketTemplate', itemEdit)\">\n        <label class=\"order\">Docket Template</label>\n        <h2 ng-if=\"itemEdit.template\">{{itemEdit.template.name}}</h2>\n        <h2 ng-if=\"!itemEdit.template\">Not Selected</h2>\n        <h3 ng-if=\"userCanDoAction('changeOrderDocketTemplate', itemEdit)\">\n          Click to <span ng-if=\"itemEdit.template\">change</span><span ng-if=\"!itemEdit.template\">select</span> template\n        </h3>\n      </div>\n    </div>\n  </div>\n  <!-- End Summary Section -->\n\n  <!-- Start Docket Fields Section -->\n  <div class=\"ojdDesktopSection noPadding\" ng-if=\"itemEdit.template.orderPrefillFields && itemEdit.template.orderPrefillFields.length > 0\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Docket Fields</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n\n      </div>\n    </div>\n    <div class=\"ojdDesktopPaddingOuter\">\n      <div class=\"ojdDesktopRow\">\n        <div class=\"autoRepeatingFieldOuter\" ng-repeat=\"field in itemEdit.template.orderPrefillFields\" ng-if=\"allFields[field]\">\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'datetime' || allFields[field].type == 'date'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n              <md-datepicker ng-model=\"itemEdit.docketPrefillValueStore[field]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{allFields[field].displayName}}\"></md-datepicker>\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'time'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n              <mdp-time-picker ng-model=\"itemEdit.docketPrefillValueStore[field]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{allFields[field].displayName}}\"  mdp-timezone=\"{{itemEdit.timezone}}\"></mdp-time-picker>\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'text'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <input type=\"text\" ng-model=\"itemEdit.docketPrefillValueStore[field]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{allFields[field].displayName}}\">\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'boolean'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <md-checkbox ng-model=\"itemEdit.docketPrefillValueStore[field]\" aria-label=\"{{allFields[field].displayName}}\" ng-disabled=\"!itemEdit.editing\">\n              </md-checkbox>\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'number'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <input type=\"number\" ng-model=\"itemEdit.docketPrefillValueStore[field]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{allFields[field].displayName}}\">\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'select'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <md-input-container class=\"md-block\">\n              <md-select aria-label=\"Select Field Value\" ng-model=\"itemEdit.docketPrefillValueStore[field]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{allFields[field].displayName}}\">\n                <md-option ng-repeat=\"value in allFields[field].selectionFields\" ng-value=\"value\">{{value}}</md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'multiline'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <md-input-container class=\"md-block\">\n              <textarea aria-label=\"{{allFields[field].displayName}}\" ng-model=\"itemEdit.docketPrefillValueStore[field]\" rows=\"3\" md-select-on-focus ng-disabled=\"!itemEdit.editing\"></textarea>\n            </md-input-container>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'label'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <p class=\"labelFieldText\">{{allFields[field].text}}</p>\n          </div>\n          <div class=\"ojdDesktopField\" ng-if=\"allFields[field].type == 'address'\">\n            <label class=\"order\">{{allFields[field].displayName}}</label>\n            <div class=\"group\" ng-show=\"itemEdit.editing\">\n              <input type=\"text\" name=\"location\" ng-model=\"itemEdit.docketPrefillValueStore[field]\" address-model=\"newAddress\" googleplace placeholder=\"\" aria-label=\"{{allFields[field].displayName}}\">\n              <span class=\"highlight\"></span>\n              <span class=\"bar\"></span>\n            </div>\n            <h3 ng-show=\"!itemEdit.editing\">{{itemEdit.docketPrefillValueStore[field]}}</h3>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!-- END Docket Fields Section -->\n\n  <!-- Start items Section -->\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Items</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button class=\"md-icon-button\" ng-disabled=\"!userCanDoAction('addLineItem', itemEdit)\" ng-click=\"newLineItemDesktop()\" aria-label=\"Add Line Item\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <p ng-if=\"itemEdit.lineItems == null || itemEdit.lineItems.length <= 0\">\n      There are no lines on this order\n    </p>\n    <md-table-container ng-show=\"itemEdit.lineItems != null && itemEdit.lineItems.length > 0\">\n      <table md-table multiple>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Resource</th>\n            <th md-column>Description</th>\n            <th md-column>Qty</th>\n            <th md-column>Completion</th>\n            <th md-column>Reference</th>\n            <th md-column ng-show=\"userHasPermission('io.docketbook.ojdapi.viewOrderRates')\">Rate</th>\n            <th md-column ng-show=\"canChangeLineResources == true\">Comments</th>\n            <th md-column></th><!--ng-show=\"userCanDoAction('removeLineItem', itemEdit)\"-->\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"lineItem in itemEdit.lineItems\" ng-show=\"!lineItem.delete\">\n            <td md-cell>\n              <span ng-if=\"lineItem.resource\">{{lineItem.resource.name}} ({{lineItem.resource.identifier}})</span>\n              <md-button ng-if=\"!lineItem.resource && userCanDoAction('changeOrderLineResource', itemEdit)\" ng-click=\"selectResourceForLine(lineItem)\">Select</md-button>\n            </td>\n            <td md-cell>\n              <span ng-show=\"!userCanDoAction('editLineItem', itemEdit)\">{{lineItem.itemDescription}}</span>\n              <span ng-show=\"userCanDoAction('editLineItem', itemEdit)\">\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"lineItem.itemDescription\" aria-label=\"Line Item Description\">\n                </md-input-container>\n              </span>\n            </td>\n            <td md-cell>\n              <span ng-if=\"userCanDoAction('isOrderSupplier', itemEdit) || lineItem.resource != null\">\n                <span ng-show=\"lineItem.resource.uom.isTime\">\n                  <span ng-show=\"!userCanDoAction('editLineItem', itemEdit)\">\n                    <span ng-if=\"lineItem.uom\">\n                      {{formatTimeQuantity(lineItem.quantity, lineItem.uom.abbreviation)}}\n                    </span>\n                    <span ng-if=\"!lineItem.uom\">\n                      {{formatTimeQuantity(lineItem.quantity, lineItem.resource.uom.abbreviation)}}\n                    </span>\n                  </span>\n                  <span ng-show=\"userCanDoAction('editLineItem', itemEdit)\">\n                    <div layout-gt-sm=\"row\">\n                      <md-input-container flex-gt-sm class=\"md-block\">\n                        <label>Hours</label>\n                        <input type=\"text\" ng-model=\"lineItem.quantityHoursEdit\" aria-label=\"Line Item Hours Quantity\">\n                      </md-input-container>\n                      <md-input-container flex-gt-sm class=\"md-block\">\n                        <label>Minutes</label>\n                        <input type=\"text\" ng-model=\"lineItem.quantityMinutesEdit\" aria-label=\"Line Item Minutes Quantity\">\n                      </md-input-container>\n                    </div>\n                  </span>\n                </span>\n                <span ng-show=\"!lineItem.resource.uom.isTime\">\n                  <span ng-show=\"!userCanDoAction('editLineItem', itemEdit) && lineItem.uom\">\n                    {{lineItem.quantity}} {{lineItem.uom.abbreviation}}\n                  </span>\n                  <span ng-show=\"!userCanDoAction('editLineItem', itemEdit) && !lineItem.uom\">\n                    {{lineItem.quantity}} {{lineItem.resource.uom.abbreviation}}\n                  </span>\n                  <span ng-show=\"userCanDoAction('editLineItem', itemEdit)\">\n                    <md-input-container class=\"md-block\">\n                      <label ng-if=\"lineItem.uom\">{{lineItem.uom.description}}</label>\n                      <label ng-if=\"!lineItem.uom\">{{lineItem.resource.uom.description}}</label>\n                      <input type=\"text\" ng-model=\"lineItem.quantityEdit\" aria-label=\"Line Item Quantity\">\n                    </md-input-container>\n                  </span>\n                </span>\n              </span>\n              <span ng-if=\"userCanDoAction('isOrderCustomer', itemEdit) && lineItem.resource == null\">\n                <span ng-show=\"userCanDoAction('editLineItem', itemEdit)\">\n                  <md-input-container class=\"md-block\">\n                    <label>Quantity</label>\n                    <input type=\"text\" ng-model=\"lineItem.quantityEdit\" aria-label=\"Line Item Quantity\">\n                  </md-input-container>\n                </span>\n                <span ng-show=\"!userCanDoAction('editLineItem', itemEdit)\">\n                  {{lineItem.quantity}}\n                </span>\n              </span>\n            </td>\n            <td md-cell ng-if=\"lineItem.uom\">\n              {{itemEdit.lineTotals[lineItem.id].quantity}} {{lineItem.uom.abbreviation}}\n            </td>\n            <td md-cell ng-if=\"!lineItem.uom\">\n              {{itemEdit.lineTotals[lineItem.id].quantity}} {{lineItem.resource.uom.abbreviation}}\n            </td>\n            <td md-cell>\n              <span ng-if=\"userCanDoAction('editLineItem', itemEdit)\">\n                <md-input-container class=\"md-block\" ng-if=\"userCanDoAction('isOrderCustomer', itemEdit)\">\n                  <label>Customer Ref</label>\n                  <input type=\"text\" ng-model=\"lineItem.customerRef\" aria-label=\"Line Customer Reference Number\">\n                </md-input-container>\n                <md-input-container class=\"md-block\" ng-if=\"userCanDoAction('isOrderSupplier', itemEdit)\">\n                  <label>Supplier Ref</label>\n                  <input type=\"text\" ng-model=\"lineItem.supplierRef\" aria-label=\"Line Supplier Reference Number\">\n                </md-input-container>\n              </span>\n              <span ng-if=\"!userCanDoAction('editLineItem', itemEdit)\">\n                <span ng-if=\"userCanDoAction('isOrderCustomer', itemEdit)\">{{lineItem.customerRef}}</span>\n                <span ng-if=\"userCanDoAction('isOrderSupplier', itemEdit) && !itemEdit.xeroQuote && !lineItem.xeroLineItem\">\n                  {{lineItem.supplierRef}}\n                </span>\n                <span ng-if=\"userCanDoAction('isOrderSupplier', itemEdit) && itemEdit.xeroQuote && lineItem.xeroQuoteLineItem\">\n                  <div class=\"xeroAvatar\"></div><br/>${{lineItem.xeroQuoteLineItem.unitAmount}} Each\n                </span>\n                <span ng-if=\"userCanDoAction('isOrderSupplier', itemEdit) && !itemEdit.xeroQuote && lineItem.xeroLineItem\">\n                  <div class=\"xeroAvatar\"></div><br/>${{lineItem.xeroLineItem.salesDetails.unitPrice}} Each\n                </span>\n              </span>\n            </td>\n\n\n            <td md-cell ng-show=\"userHasPermission('io.docketbook.ojdapi.viewOrderRates')\">\n              <span ng-show=\"!userCanDoAction('editLineItem', itemEdit) || !userHasPermission('io.docketbook.ojdapi.updateOrderRates')\">{{lineItem.rate}}</span>\n              <span ng-show=\"userCanDoAction('editLineItem', itemEdit) && userHasPermission('io.docketbook.ojdapi.updateOrderRates')\">\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"lineItem.rate\" aria-label=\"Line Item Rate\">\n                </md-input-container>\n              </span>\n            </td>\n\n            <td md-cell ng-show=\"canChangeLineResources == true\">\n              <p ng-show=\"lineItem.comment != undefined\">{{lineItem.comment}} ({{lineItem.commentAuthor}})</p>\n            </td>\n\n            <td md-cell>\n              <md-menu ng-show=\"userCanDoAction('editLineItem', itemEdit) || userCanDoAction('changeOrderLineResource', itemEdit)\">\n                <md-button aria-label=\"Line Item Actions Menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" aria-label=\"More Line Item Options\">\n                  <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n                </md-button>\n                <md-menu-content width=\"4\">\n                  <md-menu-item ng-show=\"userCanDoAction('editLineItem', itemEdit)\" ng-click=\"reassignOrderLine(lineItem)\" aria-label=\"Reassign Line Item\">\n                    <md-button>\n                      Move Resource to Other Line\n                    </md-button>\n                  </md-menu-item>\n                  <md-menu-item ng-show=\"lineItem.resource && userCanDoAction('changeOrderLineResource', itemEdit)\" ng-click=\"selectResourceForLine(lineItem)\" aria-label=\"Change Line Item Resource\">\n                    <md-button>\n                      Change Resource\n                    </md-button>\n                  </md-menu-item>\n                  <md-menu-item ng-show=\"lineItem.resource && userCanDoAction('changeOrderLineResource', itemEdit)\" ng-click=\"removeResourceForLine(lineItem)\" aria-label=\"Remove Line Item Resource\">\n                    <md-button>\n                      Remove Resource\n                    </md-button>\n                  </md-menu-item>\n                  <md-menu-item ng-show=\"userCanDoAction('editLineItem', itemEdit) && canDeleteOrderLineItem(itemEdit)\" ng-click=\"removeLineItem(lineItem)\" aria-label=\"Delete Line Item\">\n                    <md-button>\n                      Delete Line Item\n                    </md-button>\n                  </md-menu-item>\n                </md-menu-content>\n              </md-menu>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n  <!-- End Items Section -->\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "cdph":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('companySettingsResourceCategoriesController', ['resourceService', '$q', '$scope', '$window', 'Restangular', '$state', '$stateParams', 'accessControl', function (resourceService, $q, $scope, $window, Restangular, $state, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-ResourceCategories Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.selected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    order: 'name'
  };
  $scope.listCount = 0;

  $scope.loadCategoriesList = function () {
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      resourceService.getResourceCategories(queryParams, function (categories) {
        $scope.allResourceCategories = categories;
        if (queryParams.offset <= 0 && categories.length < queryParams.limit) {
          $scope.listCount = categories.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (err) {
        $scope.allResourceCategories = [];
        reject('Error');
      });
    });
  };

  $scope.loadCategoriesList();

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************************/
  /***** Resource Categories Func *****/
  /************************************/

  // Create a new resource type modal
  $scope.openNewResourceCategoryModal = function () {
    $scope.itemEdit = {};
    $("#newResourceCategoryModal").fadeIn(100);
  };

  // Close new resource modal
  $scope.closeNewResourceCategoryModal = function () {
    $("#newResourceCategoryModal").fadeOut(100, function () {
      $scope.itemEdit = {};
    });
  };

  $scope.editResourceCategory = function (item) {
    $scope.itemEdit = item;
    item.loading = false;
    $("#newResourceCategoryModal").fadeIn(100);
  };

  var refreshResourceCategories = function refreshResourceCategories() {
    $scope.loadCategoriesList();
  };

  // Save a new resource cat for the organisation
  $scope.saveNewResourceCategory = function (category) {
    category.loading = true;
    resourceService.saveResourceCategory(category, function (updatedCategory) {
      $("#newResourceCategoryModal").fadeOut(100);
      $scope.loadCategoriesList();
    }, function (err) {
      category.loading = false;
      $scope.alertService.presentAutoAlert('saveResourceCategory', err);
    });
  };

  $scope.deleteSelectedCategories = function () {
    var count = $scope.selected.length;
    swal({
      title: "Are you sure?",
      text: count + " categories will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        resourceService.deleteBulkResourceCategories($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkResourceCategories', { status: 202, requestName: 'Delete bulk resource categories - failures ' + failures.length + ' of ' + $scope.selected.length });
            $scope.loadCategoriesList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkResourceCategories', { status: 200 });
            $scope.loadCategoriesList();
          }
        });
      }
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "cfCM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('editContactController', ['addressBookService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.editContactFromParent = function (contactItem, cb) {
    $("#editContactModal").fadeIn(100);
    $scope.contactEditing = angular.copy(contactItem);
    var initials = "";
    if ($scope.contactEditing.displayName) {
      var split = $scope.contactEditing.displayName.split(' ');
      if (split.length == 1) {
        initials = split[0].charAt(0).toUpperCase();
      } else if (split.length > 1) {
        initials = split[0].charAt(0).toUpperCase();
        initials += split[1].charAt(0).toUpperCase();
      }
    }
    $scope.contactEditing.initials = initials;
    if ($scope.contactEditing.addresses[0]) {
      $scope.contactEditing.address = $scope.contactEditing.addresses[0];
    }
    var emailAddresses = [];
    for (var emailKey in $scope.contactEditing.contactAddresses) {
      var editable = true;
      if (emailKey.indexOf('.on.docketbook.io') != -1) {
        editable = false;
      }
      var emailAddressEntry = { emailAddress: emailKey, permissions: $scope.contactEditing.contactAddresses[emailKey], editable: editable };
      emailAddresses.push(emailAddressEntry);
    }
    $scope.contactEditing.emailAddresses = emailAddresses;
    $scope.contactEditCallback = cb;
  };

  $scope.selectNewContact = function () {
    $("#editContactModal").fadeOut(100);
    $scope.contactEditCallback('select');
  };

  $scope.closeContactEdit = function () {
    $("#editContactModal").fadeOut(100);
    $scope.contactEditCallback(null);
  };

  $scope.saveContactEdit = function () {
    $("#editContactModal").fadeOut(100);
    if ($scope.contactEditing.address) {
      $scope.contactEditing.addresses[0] = $scope.contactEditing.address;
    }
    var contactAddresses = {};
    if ($scope.contactEditing.emailAddresses.length > 0) {
      for (var i = 0; i < $scope.contactEditing.emailAddresses.length; i++) {
        var addressItem = $scope.contactEditing.emailAddresses[i];
        contactAddresses[addressItem.emailAddress] = addressItem.permissions;
      }
    }
    $scope.contactEditing.contactAddresses = contactAddresses;
    $scope.contactEditCallback($scope.contactEditing);
  };

  $scope.removeEmailAddressFromContact = function (email) {
    var index = $scope.contactEditing.emailAddresses.indexOf(email);
    if (index != -1) {
      $scope.contactEditing.emailAddresses.splice(index, 1);
    }
  };

  $scope.addAnotherEmailAddress = function () {
    $scope.contactEditing.emailAddresses.push({ emailAddress: "", permissions: ['approver'], editable: true });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "clRN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('newOrgModalController', ['userService', 'billingService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', 'accessControl', '$timeout', 'geolocation', function (userService, billingService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

  $scope.$parent.createNewCompanyFromParent = function (isSampleCompany, successCb) {

    if (!isSampleCompany) {
      window.location.href = '/onboarding/new';
      return;
    }

    $scope.newCompanyCallback = successCb;
    $scope.newCompany = {};
    $scope.newCompany.currentStep = 1;
    $scope.newCompany.stepCount = 3;
    $scope.newCompany.process = 'form';
    $scope.newCompany.helpMethodStep = 'select';
    $scope.newCompany.showFullAddress = false;
    var timezone = _momentTimezone2.default.tz.guess();
    if (timezone) {
      $scope.newCompany.timezone = timezone;
    }
    $("#editOrgModal").fadeIn(100);
    if (isSampleCompany === true) {
      return $scope.performSampleCompany();
    }
  };

  $scope.performSampleCompany = function () {
    $scope.newCompany.process = 'creating';
    var postObj = {
      name: "Sample Company",
      isSampleCompany: true
    };
    userService.createNewOrganisation(postObj, function (org) {
      $scope.newCompany.orgCreated = org;
      accessControl.refreshAndGetAllowedOrganisations(function (orgsList) {
        $scope.newCompanyCallback($scope.newCompany.orgCreated);
      }, function (err) {
        $scope.newCompanyCallback($scope.newCompany.orgCreated);
      });
    }, function (err) {
      $scope.alertService.presentAutoAlert('createSampleCompany', err);
      $("#editOrgModal").fadeOut(100);
    });
  };

  $scope.closeOrgEditModal = function () {
    $("#editOrgModal").fadeOut(100);
    $scope.newCompanyCallback(null);
  };

  $scope.newCompanyNext = function () {
    $scope.newCompany.currentStep += 1;
    $timeout(function () {
      $("#editOrgFormStep" + $scope.newCompany.currentStep + " input:enabled:visible:first").focus();
    }, 200);
  };

  $scope.newCompanyBack = function () {
    $scope.newCompany.currentStep -= 1;
  };

  $scope.newCompanyManualAddress = function () {
    $scope.newCompany.showFullAddress = !$scope.newCompany.showFullAddress;
  };

  $scope.$watch('newCompany.address', function () {
    var requiredFields = ['streetName', 'suburb', 'state', 'postCode', 'country'];
    var incorrectFields = [];
    if ($scope.newCompany && $scope.newCompany.address) {
      for (var i = 0; i < requiredFields.length; i++) {
        if ($scope.newCompany.address[requiredFields[i]] == null || $scope.newCompany.address[requiredFields[i]] == "") {
          incorrectFields.push(requiredFields[i]);
        }
      }
      if (incorrectFields.length > 0) {
        $scope.newCompany.addressAlert = true;
      } else {
        $scope.newCompany.addressAlert = false;
      }
    }
  });

  $scope.createNewCompany = function () {
    $scope.newCompany.process = 'creating';
    var postObj = angular.copy($scope.newCompany);
    postObj.user = $scope.currentUser;
    userService.createNewOrganisation(postObj, function (org) {
      ga('send', 'event', 'Company', 'created', postObj.name);
      goog_report_conversion();
      // TODO: send update billing information
      var num = $scope.newCompany.contactNumber.replace(/\D/g, '');
      var contactDetails = { phoneNumber: num };
      billingService.updateOrganisationBillingContact(org.id, contactDetails, function (success) {
        $scope.newCompany.process = 'success';
        $scope.newCompany.orgCreated = org;
        accessControl.refreshAndGetAllowedOrganisations(function (orgsList) {}, function (err) {});
      }, function (err) {
        $scope.newCompany.process = 'success';
        $scope.newCompany.orgCreated = org;
        accessControl.refreshAndGetAllowedOrganisations(function (orgsList) {}, function (err) {});
      });
    }, function (err) {
      console.log('error creating org', err);
    });
  };

  $scope.newCompanySetupContinue = function (option) {
    if (option == 'alone') {
      $scope.newCompany.process = 'aloneCongratulations';
    } else {
      $scope.newCompany.process = 'selectHelpMethod';
    }
  };

  $scope.newCompanySetupAloneFinish = function () {
    $scope.newCompanyCallback($scope.newCompany.orgCreated);
  };

  $scope.newCompanyHelpMethodSelect = function (option) {
    /*var supportContact = null;
    if ( option == 'phone' ) {
    	supportContact = $scope.newCompany.contactNumber;
    }
    var update = {
        user_id: $scope.currentUser.id,
        user_hash: $scope.currentUser.hash,
      };
    update.company = {
    	id: $scope.newCompany.orgCreated.id,
    	name: $scope.newCompany.orgCreated.name,
    	supportMethod: option,
    	supportContact: supportContact
    };
    window.Intercom("update", update);*/

    if (option == 'phone' || option == 'email') {
      var contactNumber = '';
      if (option == 'phone') {
        contactNumber = supportContact;
      }
      userService.requestSetupSupport($scope.newCompany.orgCreated.id, option, contactNumber, function () {
        console.log('support request successful');
      }, function () {
        console.log('support request failed');
      });
    }

    if (option == 'intercom') {
      //$scope.newCompanyCallback($scope.newCompany.orgCreated);
      $scope.newCompany.helpMethodStep = 'confirm';
    } else if (option == 'phone') {
      $scope.newCompany.helpMethodStep = 'confirm';
    } else if (option == 'email') {
      $scope.newCompany.helpMethodStep = 'confirm';
    }
  };

  $scope.helpMethodFinish = function () {
    $scope.newCompanyCallback($scope.newCompany.orgCreated);
    //$state.go('main.groupDashboard', {orgId: $scope.newCompany.orgCreated.id});
  };

  // Send post request to MAPI to create new org
  /*$scope.saveOrgEdit = function(orgEdit) {
  	orgEdit.loading = true;
  	var postObj = {};
  	postObj.user = $stateParams.currentUser;
  	postObj.name = orgEdit.name;
  	postObj.address = orgEdit.address;
  	postObj.timezone = orgEdit.timezone;
  	userService.createNewOrganisation(postObj, function(org) {
  		// referesh allowed organisations
  		accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
  			$state.go('main.groupDashboard', {orgId:org.id});
  		}, function(err) {
  			$("#editOrgModal").fadeOut(100);
  		});
  	}, function(err) {
  		orgEdit.loading = false;
  		$scope.alertService.presentAlert("error", "Oops.", "Something went wrong while we were setting up your new organisation. Please try again.");
  	});
  }*/
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "dBuK":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/docketsTab.html';
var html = "<h1 class=\"containerHeading hidden-xs\">Dockets</h1>\n\n<div class=\"customListRowOuter\" ng-show=\"userCanDoAction('addOrderDocket', itemEdit) && itemEdit.customerContact != null\" ng-click=\"newDocketForOrder()\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem createNew\"><div class=\"dbButton lightBlue\">New Docket</div></div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-show=\"itemEdit.id == null\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem message\">\n      Save order before creating dockets.\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-repeat=\"item in itemEdit.dockets\" id=\"listItem{{item.id}}\">\n  <div class=\"customListRow\" hm-swipeLeft=\"splitListFunc.swipeListItem(item.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(item.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}' ng-click=\"openDocket(item)\">\n    <div class=\"listRowItem status\"><div class=\"statusDisplay {{item.status}}\">{{item.status}}</div></div>\n    <div class=\"listRowItem itemNumber\">{{item.docketNumber}}</div>\n    <div class=\"listRowItem collapsedDetail showCollapsed\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\"><span ng-show=\"item.customerContact\">{{item.customerContact.displayName}}</span></div>\n        <div class=\"right\">{{moment(item.date).format('DD/MM')}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter hidden\" id=\"docketsLoadingMore\">\n  <div class=\"customListRow loadingRow\">\n    <div class=\"progressOuter\">\n      <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n    </div>\n    Loading More Dockets\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "dOK4":
/***/ (function(module, exports) {

var path = 'views/trialBanner.html';
var html = "<div ng-if=\"(currentOrg.planFeatures.inTrial == true || trialFinishedWithin1Week) && currentOrg.plan.id == null\" id=\"trialBanner\">\n    <div style=\"display: flex; flex-direction: column; text-align: center; height: 100%;\">\n        <div style=\"flex-grow: 1;\"></div>\n        <div>\n            <h5 ng-if=\"!trialFinishedWithin1Week\" class=\"centerAligned\" style=\"color: #FFFFFF; white-space: pre;\">Your trial expires in {{expiryDays}} day{{expiryDays > 1 ? 's' : ''}}</h5>\n            <h5 ng-if=\"trialFinishedWithin1Week\" class=\"centerAligned\" style=\"color: #FFFFFF; white-space: pre;\">Your trial has expired</h5>\n            <div class=\"newDbButton whiteOutline centerAligned leftMargin\" style=\"background-color: white; border-color: #0077E6; color: #0077E6;\" ng-click=\"selectPlan(null, null, 'select plan modal - view - from trial banner')\">\n                Upgrade Now\n            </div>\n        </div>\n        <div style=\"flex-grow: 1;\"></div>\n    </div>\n</div>\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "dZyO":
/***/ (function(module, exports) {

var path = 'views/modals/recommendLineItemResourceModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"recommendLineItemResourceModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Match Line Item</h1>\n      <div class=\"headerCloseButton\" ng-click=\"close()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div ng-if=\"resources.length == 1\" class=\"content\" style=\"text-align: center;\">\n      <h3>It looks like <b>{{selectedResources[0].name}} ({{selectedResources[0].identifier}})</b> matches line item <b>{{lineItem.itemDescription}}</b></h3>\n      <h3>Would you like to add this resource or continue to search?</h3>\n    </div>\n\n    <div ng-if=\"resources.length > 1\" class=\"content noPadding\" style=\"text-align: center;\">\n      <h3>It looks like these resources might match line item <b>{{lineItem.itemDescription}}:</b></h3>\n\n      <md-table-container class=\"editableTable\">\n        <table md-table md-row-select multiple=\"false\" ng-model=\"selectedResources\" md-progress=\"promise\">\n          <thead md-head>\n            <tr md-row>\n              <th md-column md-order-by=\"name\"><span>Name</span></th>\n              <th md-column md-order-by=\"identifier\"><span>Identifier</span></th>\n              <th md-column md-order-by=\"category\"><span>Category</span></th>\n              <th md-column><span>Unit of Measure</span></th>\n              <th md-column ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\"><span>Xero Item</span></th>\n            </tr>\n          </thead>\n          <tbody md-body style=\"cursor: pointer;\">\n            <tr md-row md-select=\"resource\" md-select-id=\"id\" ng-repeat=\"resource in resources\" onClick=\"selectedResources = [resource]\">\n              <td md-cell>\n                <span>\n                  {{resource.name}}\n                </span>\n              </td>\n              <td md-cell>\n                <span>\n                  {{resource.identifier}}\n                </span>\n              </td>\n              <td md-cell>\n                <span>\n                  {{resource.category.name}}\n                </span>\n              </td>\n              <td md-cell>\n                <span>\n                  {{resource.uom.abbreviation}} ({{resource.uom.description}})\n                </span>\n              </td>\n              <td md-cell ng-if=\"currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n                <span ng-if=\"resource.xeroID\">\n                  {{resource.xeroID.name}} ({{resource.xeroID.userCode}})\n                </span>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    </div>\n    \n    <div class=\"footer\">\n        <div style=\"text-align: center;\">\n          <div class=\"dbButton margin-right\" ng-click=\"continueToSearch()\">\n            Search\n          </div>\n          <div class=\"dbButton\" ng-click=\"addResource()\" ng-disabled=\"loading || selectedResources.length == 0\">\n            {{resources.length == 1 ? 'Add Resource' : 'Done'}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "dfBi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').controller('addressBookTagController', ['$scope', 'addressBookService', 'Restangular', '$state', '$window', '$stateParams', 'accessControl', '$q', function ($scope, addressBookService, Restangular, $state, $window, $stateParams, accessControl, $q) {
  mixpanel.track("Opened CompanySettings-AddressBookTags Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.selected = [];
  $scope.allTags = [];

  $scope.loadTagList = function () {
    $scope.loadPromise = $q(function (resolve, reject) {
      addressBookService.getAddressBookTags({}, function (results) {
        $scope.allTags = results.map(function (tag) {
          return Object.assign({
            editing: false
          }, tag);
        });
        resolve($scope.allTags);
      }, function (err) {
        $scope.allTags = [];
        reject('Error');
      });
    });
  };

  $scope.deleteSelectedTags = function () {
    var promises = $scope.selected.map(function (item) {
      return $q(function (resolve, reject) {
        addressBookService.deleteAddressBookTag(item, function () {
          resolve();
        }, function (err) {
          reject(err);
        });
      });
    });
    $q.all(promises).then(function () {
      $scope.loadTagList();
    }).catch(function (err) {
      $scope.loadTagList();
    });
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  $scope.insertNewTag = function () {
    $scope.allTags.splice(0, 0, {
      tag: "",
      description: "",
      editing: true
    });
  };

  $scope.saveTagRow = function (tag) {
    addressBookService.saveAddressBookTag(tag, function (results) {
      $scope.loadTagList();
    }, function (err) {
      reject('Error');
    });
  };

  $scope.editTagRow = function (tag) {
    tag.editing = true;
  };

  $scope.loadTagList();
}]);

/***/ }),

/***/ "dqTQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "droZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('xeroConnectController', ['userService', 'xeroService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', 'accessControl', '$timeout', 'geolocation', function (userService, xeroService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

  $scope.$parent.xeroConnectLogin = function (returnAction) {
    if (returnAction) {
      $scope.returnAction = returnAction;
    } else {
      $scope.returnAction = null;
    }
    $("#xeroConnectModal").fadeIn(100);
    $scope.xeroConnect = { redirecting: false, stage: 'initial' };
  };

  $scope.$parent.xeroConnectConfirm = function (returnAction, returnCallback) {
    $scope.xeroConnect.confirming = false;
    $scope.confirmCallback = returnCallback;
    if (returnAction) {
      $scope.returnAction = returnAction;
    } else {
      $scope.returnAction = null;
    }
    xeroService.getXeroAuthTenants(function (authDetails) {
      if (authDetails && authDetails.length > 0) {
        $("#xeroConnectModal").fadeIn(100);
        $scope.xeroConnect = { redirecting: false, stage: 'confirm', tenantsAvailable: authDetails, tenantSelected: authDetails[0].tenantId };
      } else {
        // show error message
        alert('error getting xero tenants back');
      }
    }, function (err) {
      alert('error getting xero tenants back');
    });
  };

  $scope.$parent.directReauthenticate = function () {
    $scope.xeroConnectAuthorise();
  };

  $scope.closeXeroConnectModal = function () {
    $("#xeroConnectModal").fadeOut(100);
  };

  $scope.xeroConnectAuthorise = function () {
    $scope.xeroConnect.redirecting = true;
    if ($scope.returnAction) {
      window.location.href += "?action=" + $scope.returnAction;
    }
    window.location = "" + "/" + $scope.urlVersion + "/organisations/" + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/xero/auth?source=" + btoa(window.location.hash);
  };

  $scope.xeroConfirmConnection = function () {
    $scope.xeroConnect.confirming = true;
    $scope.xeroEndpoint.one('enablement').customPUT({
      enabled: true,
      tenantSelected: $scope.xeroConnect.tenantSelected
    }).then(function (response) {
      $scope.xeroConnect.confirming = false;
      $scope.closeXeroConnectModal();
      $scope.confirmCallback(response);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "dzYx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon-16x16.png";

/***/ }),

/***/ "eOp7":
/***/ (function(module, exports) {

var path = 'views/pages/groupSettings/filing.html';
var html = "<div class=\"desktopContainer dashboard adminSettingsView\">\n  <div class=\"dashboardWelcomeHeader\">\n    <div class=\"left\">\n      <h3>Manage File Codes</h3>\n      <p>Use file codes to organise dockets and line items into your preferred grouping method. Your file codes could reflect your cost codes or simply help you organise your dockets. Create file codes individually or import in bulk using our excel spreadsheet uploader.  </p>\n    </div>\n    <div class=\"right\">\n      <md-button class=\"md-icon-button\" ng-click=\"newFileCode()\" aria-label=\"New File Code\" ng-if=\"mode != 'import'\">\n        <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n      </md-button>\n      <md-button class=\"md-icon-button\" ng-click=\"openImportModal()\" aria-label=\"Import File Codes From File\" ng-if=\"mode != 'import'\">\n        <md-icon md-svg-icon=\"import.svg\"></md-icon>\n      </md-button>\n      <md-button class=\"md-icon-button\" ng-click=\"loadFilingList()\" aria-label=\"Reload Filing List\" ng-if=\"mode != 'import'\">\n        <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n      </md-button>\n      <md-menu ng-if=\"mode != 'import'\">\n        <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n          <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"4\">\n          <md-menu-item ng-click=\"deleteSelectedFileCodes()\" aria-label=\"Delete Selected File Codes\">\n            <md-button>\n              Delete Selected Codes\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n\n      <md-button ng-click=\"cancelImport()\" ng-show=\"mode == 'import'\" class=\"compact\">\n        Cancel\n      </md-button>\n      <md-button ng-click=\"bulkImportFileCodes(importList)\" ng-show=\"mode == 'import'\" class=\"compact\">\n        Import\n      </md-button>\n    </div>\n  </div>\n\n  <div class=\"adminBasicContentContainer bare\">\n    <div class=\"adminSettingGroupContainer noPadding\" style=\"position:relative;margin-top:0px;\">\n      <div class=\"adminContentInner bare\">\n        <md-table-container ng-show=\"mode !='import'\">\n          <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n            <thead md-head md-order=\"query.order\" md-on-reorder=\"loadFilingList\">\n              <tr md-row>\n                <th md-column md-order-by=\"fileCode\"><span>File Code</span></th>\n                <th md-column md-order-by=\"fileName\"><span>File Name</span></th>\n                <th md-column md-order-by=\"costCode\"><span>Cost Code</span></th>\n                <th md-column><span>System Codes</span></th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row md-select=\"fileCode\" md-select-id=\"id\" ng-repeat=\"fileCode in allFileCodes\" ng-click=\"editFileCode(fileCode)\">\n                <td md-cell>{{fileCode.fileCode}}</td>\n                <td md-cell>\n                  {{fileCode.fileName}}\n                </td>\n                <td md-cell>\n                  {{fileCode.costCode}}\n                </td>\n                <td md-cell>\n                  {{fileCode.systemCodes}}\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n        <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadFilingList\" md-total=\"{{listCount}}\" md-page-select>\n        </md-table-pagination>\n\n        <md-table-container ng-show=\"mode =='import'\">\n          <table md-table md-row-select multiple ng-model=\"importSelected\" md-progress=\"promise\">\n            <thead md-head>\n              <tr md-row>\n                <th md-column><span>Status</span></th>\n                <th md-column><span>File Code</span></th>\n                <th md-column><span>File Name</span></th>\n                <th md-column><span>Cost Code</span></th>\n                <th md-column><span>System Codes</span></th>\n                <th md-column><span>Action</span></th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row md-select=\"fileCode\" md-select-id=\"id\" ng-repeat=\"fileCode in importList\" class=\"{{fileCode.error ? 'error' : ''}}\">\n                <td md-cell><div class=\"statusDisplay {{fileCode.status == 'New' ? 'Completed' : 'Sent'}}\">{{fileCode.status}}</div></td>\n                <td md-cell>\n                  <span ng-if=\"fileCode.status != 'New'\">{{fileCode.fileCode}}</span>\n                  <md-input-container ng-if=\"fileCode.status == 'New'\">\n                    <input ng-model=\"fileCode.fileCode\" type=\"text\" required ng-change=\"validateFileCodeItem(fileCode)\">\n                  </md-input-container>\n                </td>\n                <td md-cell>\n                  <md-input-container>\n                    <input ng-model=\"fileCode.fileName\" type=\"text\" required ng-change=\"validateFileCodeItem(fileCode)\">\n                  </md-input-container>\n                </td>\n                <td md-cell>\n                  <md-input-container>\n                    <input ng-model=\"fileCode.costCode\" type=\"text\" required ng-change=\"validateFileCodeItem(fileCode)\">\n                  </md-input-container>\n                </td>\n                <td md-cell>\n                  {{fileCode.systemCodes}}\n                </td>\n                <td md-cell>\n                  <md-button class=\"md-icon-button\" ng-click=\"removeCodeFromImportList(fileCode, importList)\" aria-label=\"Remove File Code From Import List\">\n                    <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                  </md-button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- File Code Modal -->\n<div class=\"niceModal desktopSelector\" id=\"fileCodeModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"fileCodeEdit.id == null\">New File Code</h1>\n      <h1 ng-show=\"fileCodeEdit.id != null\">Edit File Code</h1>\n    </div>\n    <form name=\"newFileCodeForm\" novalidate>\n      <div class=\"content\">\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>File Code</label>\n            <input ng-model=\"fileCodeEdit.fileCode\" required>\n          </md-input-container>\n\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>File Name</label>\n            <input ng-model=\"fileCodeEdit.fileName\" required>\n          </md-input-container>\n        </div>\n\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n            <label>Cost Code</label>\n            <input ng-model=\"fileCodeEdit.costCode\" required>\n          </md-input-container>\n        </div>\n        <!-- System Codes Go Here -->\n\n        <div class=\"clearfix\"></div>\n      </div>\n      <div class=\"footer uneven\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeFileCodeModal()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner margin-right\" ng-click=\"(newFileCodeForm.$invalid || fileCodeEdit.loading) || saveFileCode(fileCodeEdit)\" ng-disabled=\"newFileCodeForm.$invalid || fileCodeEdit.loading\">\n              <span ng-hide=\"fileCodeEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"fileCodeEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"(newFileCodeForm.$invalid || fileCodeEdit.loading) || saveFileCodeAddAnother(fileCodeEdit)\" ng-disabled=\"newFileCodeForm.$invalid || fileCodeEdit.loading\">\n              <span ng-hide=\"fileCodeEdit.loading\">Save & Add Another</span>\n              <md-progress-circular ng-show=\"fileCodeEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- End File Code Modal -->\n\n<!-- Import Modal -->\n<div class=\"niceModal desktopSelector\" id=\"importModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Select File To Import</h1>\n    </div>\n    <form name=\"importFileCodeForm\" novalidate>\n      <div class=\"content\">\n        Excel files only (.xls or .xlsx)\n        <br/>\n        <br/>\n        <input type=\"file\" ngf-select ng-model=\"file\" name=\"file\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"cancelImport()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"(importFileCodeForm.$invalid || fileCodeImport.loading) || importFileCodesFromFile(file)\" ng-disabled=\"importFileCodeForm.$invalid || fileCodeImport.loading\">\n              <span ng-hide=\"fileCodeImport.loading\">Next</span>\n              <md-progress-circular ng-show=\"fileCodeImport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </form>\n  </div>\n</div>\n<!-- End Import Modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "eiOV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "calendar2.svg";

/***/ }),

/***/ "eslX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

var _jqueryUi = __webpack_require__("d2PX");

var _jqueryUi2 = _interopRequireDefault(_jqueryUi);

var _angular = __webpack_require__("/jXN");

var _angular2 = _interopRequireDefault(_angular);

var _angularRoute = __webpack_require__("gpvE");

var _angularRoute2 = _interopRequireDefault(_angularRoute);

var _angularUiRouter = __webpack_require__("SfIo");

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _restangular = __webpack_require__("yHZ/");

var _restangular2 = _interopRequireDefault(_restangular);

var _lodash = __webpack_require__("xSkL");

var _lodash2 = _interopRequireDefault(_lodash);

var _underscore = __webpack_require__("rdLu");

var _underscore2 = _interopRequireDefault(_underscore);

var _hammerjs = __webpack_require__("rxKx");

var _hammerjs2 = _interopRequireDefault(_hammerjs);

var _angularHammer = __webpack_require__("P/Dl");

var _angularHammer2 = _interopRequireDefault(_angularHammer);

var _angularCookies = __webpack_require__("5/fh");

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _ngPickadate = __webpack_require__("peSY");

var _ngPickadate2 = _interopRequireDefault(_ngPickadate);

var _angularUuid = __webpack_require__("jofQ");

var _angularUuid2 = _interopRequireDefault(_angularUuid);

var _ngscroll = __webpack_require__("RMHk");

var _ngscroll2 = _interopRequireDefault(_ngscroll);

var _angucomplete = __webpack_require__("bHPv");

var _angucomplete2 = _interopRequireDefault(_angucomplete);

var _angularUiSortable = __webpack_require__("pxq1");

var _angularUiSortable2 = _interopRequireDefault(_angularUiSortable);

var _angularMaterial = __webpack_require__("KRpg");

var _angularMaterial2 = _interopRequireDefault(_angularMaterial);

var _mdPickers = __webpack_require__("HTnB");

var _mdPickers2 = _interopRequireDefault(_mdPickers);

var _ngFileUpload = __webpack_require__("RgsW");

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _angularSanitize = __webpack_require__("AFu3");

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularjsGeolocation = __webpack_require__("iCBQ");

var _angularjsGeolocation2 = _interopRequireDefault(_angularjsGeolocation);

var _angularMaterialDataTable = __webpack_require__("6Vhj");

var _angularMaterialDataTable2 = _interopRequireDefault(_angularMaterialDataTable);

var _chart = __webpack_require__("WaEV");

var _chart2 = _interopRequireDefault(_chart);

var _angularChart = __webpack_require__("7mCu");

var _angularChart2 = _interopRequireDefault(_angularChart);

var _angularCreditCards = __webpack_require__("Niij");

var _angularCreditCards2 = _interopRequireDefault(_angularCreditCards);

var _angularDragdrop = __webpack_require__("7ybl");

var _angularDragdrop2 = _interopRequireDefault(_angularDragdrop);

var _ngSortable = __webpack_require__("rnmm");

var _ngSortable2 = _interopRequireDefault(_ngSortable);

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _jqueryUiTouchPunch = __webpack_require__("VcG2");

var _jqueryUiTouchPunch2 = _interopRequireDefault(_jqueryUiTouchPunch);

var _angularObjectDiff = __webpack_require__("5Zq+");

var _angularObjectDiff2 = _interopRequireDefault(_angularObjectDiff);

var _mdDateRangePicker = __webpack_require__("VS0Z");

var _mdDateRangePicker2 = _interopRequireDefault(_mdDateRangePicker);

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
//import Raven from 'raven-js';
//import ngRaven from 'raven-js/plugins/angular';


/*Raven.config("https://109b69b91e1d4abfaff2e8a913008d65@sentry.docketbook.io/2").addPlugin(ngRaven).install();
window.configureRaven = (function (dsn) {
  Raven.setDSN(dsn);
});*/

window.redirectToLogout = function () {
  window.location = "" + '/v1/logout';
};

var circularstdbold = __webpack_require__("ppEf");
var circularstdbook = __webpack_require__("sjjA");
var circularstdmedium = __webpack_require__("5/bX");

var companySettingsWhite = __webpack_require__("YvZY");
var squareMaskBg = __webpack_require__("KZqe");
var fileDownload = __webpack_require__("9CBH");
var magnifySvg = __webpack_require__("31Wy");
var clearSvg = __webpack_require__("8Pnt");
var arrowDownSvg = __webpack_require__("KOph");
var arrowUpSvg = __webpack_require__("et1j");
var menuSvg = __webpack_require__("3TTx");
var dbLogomark = __webpack_require__("F+6J");
var account = __webpack_require__("+oWW");
var logout = __webpack_require__("jjR3");
var help = __webpack_require__("2paq");
var settings = __webpack_require__("07i1");
var companysettings = __webpack_require__("xt7z");
var dash = __webpack_require__("LkqX");
var folder = __webpack_require__("VFKX");
var job = __webpack_require__("7ScX");
var desc = __webpack_require__("hCJl");
var err = __webpack_require__("lk0G");
var left = __webpack_require__("/ygr");
var userGroup = __webpack_require__("PzZ8");
var adminUser = __webpack_require__("45qS");
var eye = __webpack_require__("Jvkl");
var creditCardSvg = __webpack_require__("Udxa");
var roles = __webpack_require__("Yk9E");
var templatedesigner = __webpack_require__("RDwX");
var fields = __webpack_require__("uKnp");
var checklist = __webpack_require__("kVWY");
var archive = __webpack_require__("sckJ");
var truck = __webpack_require__("bPb8");
var category = __webpack_require__("sZY0");
var unit = __webpack_require__("QyGI");
var org = __webpack_require__("I6CZ");
var deleteSvg = __webpack_require__("9Kjc");
var noteAdd = __webpack_require__("SOQP");
var reload = __webpack_require__("o2vf");
var moreVert = __webpack_require__("OVgP");
var add = __webpack_require__("8M7Q");
var copy = __webpack_require__("b1Sf");
var arrowLeft = __webpack_require__("Z/gs");
var textField = __webpack_require__("HE5Q");
var multilineField = __webpack_require__("lL5X");
var switchField = __webpack_require__("cIse");
var numberField = __webpack_require__("++zH");
var clockField = __webpack_require__("9ksV");
var calendar = __webpack_require__("AX6D");
var selectField = __webpack_require__("ykr0");
var edit = __webpack_require__("YBki");
var importSvg = __webpack_require__("j5JE");
var filterSvg = __webpack_require__("upso");
var lines = __webpack_require__("QuLm");
var report = __webpack_require__("U586");
var expand_more = __webpack_require__("Muko");
var contactshare = __webpack_require__("74sJ");
var forum = __webpack_require__("iczq");
var otherMoreVert = __webpack_require__("FfM6");
var location = __webpack_require__("cLTV");
var drag = __webpack_require__("b2rq");
var successtick = __webpack_require__("whwM");
var signature = __webpack_require__("gTYR");
var customSection = __webpack_require__("IvK/");
var checklistsAlt = __webpack_require__("Z8Is");
var font = __webpack_require__("TgE4");
var resourcesave = __webpack_require__("bTU9");
var dumpTruck = __webpack_require__("1CjB");
var nextIcon = __webpack_require__("R3DX");
var backIcon = __webpack_require__("IX6N");
var calendar2 = __webpack_require__("eiOV");
var allocate = __webpack_require__("GCPq");
var errorOutline = __webpack_require__("pYzG");
var padlock = __webpack_require__("zqiF");
var numOrgsImage = __webpack_require__("x3VG");
var xeroConnect = __webpack_require__("MXov");
var xeroDisconnect = __webpack_require__("TA7C");
var accountMultiple = __webpack_require__("D+wi");
var domain = __webpack_require__("GYqn");
var newDocument = __webpack_require__("MOQi");

var timesheetsPaywalled = __webpack_require__("fc0h");
var jobsPaywalled = __webpack_require__("PjXo");
var ordersPaywalled = __webpack_require__("bvO+");

var card1 = __webpack_require__("m0E1");
var card2 = __webpack_require__("229m");
var card22 = __webpack_require__("h627");
var card14 = __webpack_require__("9jXu");
var card10 = __webpack_require__("Rnnk");
var card16 = __webpack_require__("sz64");

var favicon1616 = __webpack_require__("dzYx");
var favicon3232 = __webpack_require__("qKzz");
var favicon9696 = __webpack_require__("ogWe");

var appleIcon5757 = __webpack_require__("1015");
var appleIcon6060 = __webpack_require__("/dB1");
var appleIcon7272 = __webpack_require__("zdbw");
var appleIcon7676 = __webpack_require__("nEzz");
var appleIcon114114 = __webpack_require__("TEBt");
var appleIcon120120 = __webpack_require__("CTUr");
var appleIcon144144 = __webpack_require__("k1Tr");
var appleIcon152152 = __webpack_require__("NDZu");
var appleIcon180180 = __webpack_require__("qAMC");
var androidIcon192192 = __webpack_require__("UfB5");
//const mainTemplate = require('ngtemplate-loader!html-loader!./views/mainTemplate.html');

var lineOkIcon = __webpack_require__("1FEJ");
var lineWarningIcon = __webpack_require__("bACn");

var mainTemplate = __webpack_require__("E9h+");
var settingsTemplate = __webpack_require__("4uCk");
var loading = __webpack_require__("fGOF");
var alertTemplate = __webpack_require__("kVoJ");
var slider = __webpack_require__("M5CG");
var selectContactModal = __webpack_require__("E3Sh");
var selectQuoteModal = __webpack_require__("RbuR");
var editContactModal = __webpack_require__("rDzi");
var viewMessageModal = __webpack_require__("so9V");
var selectOrgUnitModal = __webpack_require__("RzJJ");
var home = __webpack_require__("KMj0");
var mainNav = __webpack_require__("Io/4");
var scopeNav = __webpack_require__("fWdn");
var trialBanner = __webpack_require__("dOK4");
var editOrgModal = __webpack_require__("jhP4");
var waitToBeInvitedModal = __webpack_require__("5n2g");
var userAccount = __webpack_require__("hkz0");
var dashboard = __webpack_require__("tIi5");
var newGroupModal = __webpack_require__("L4C1");
var groupSettingsGeneral = __webpack_require__("qwYM");
var companySettingsNav = __webpack_require__("IvMQ");
var searchAbnModal = __webpack_require__("3sj4");
var editBankAccountModal = __webpack_require__("12oT");
var xeroConnectModal = __webpack_require__("ml5I");
var selectRoleModal = __webpack_require__("xTT/");
var inviteMembersModal = __webpack_require__("KlyX");
var editUserGroupRolesModal = __webpack_require__("9qDa");
var selectPersonModal = __webpack_require__("mPWU");
var groupSettingsAdmins = __webpack_require__("8qHh");
var groupSettingsFiling = __webpack_require__("eOp7");
var companySettingsBilling = __webpack_require__("6/3I");
var selectPlanModal = __webpack_require__("Mji+");
var companySettingsRoles = __webpack_require__("vg1r");
var companySettingsTemplates = __webpack_require__("1yJA");
var companySettingsGroups = __webpack_require__("XMIk");
var companySettingsUsers = __webpack_require__("N+O6");
var docketDesigner = __webpack_require__("yQg5");
var fieldModal = __webpack_require__("nzZi");
var checklistModal = __webpack_require__("T39a");
var companySettingsFields = __webpack_require__("Bi8V");
var companySettingsChecklists = __webpack_require__("pDCK");
var companySettingsResources = __webpack_require__("Sgih");
var editResourceModal = __webpack_require__("5zlz");
var companySettingsCategories = __webpack_require__("n3fY");
var companySettingsUoms = __webpack_require__("01v8");
var editUserModal = __webpack_require__("Yixd");
var importContactsModal = __webpack_require__("+IYs");
var importResourcesModal = __webpack_require__("Ib4p");
var exportDocketsLockedPage = __webpack_require__("o5IO");
var trailActivatedModal = __webpack_require__("Wc5+");

var desktopOrders = __webpack_require__("yLTZ");
var desktopOrdersHeading = __webpack_require__("fXTq");
var desktopOrdersList = __webpack_require__("pyL/");
var shareOrderModal = __webpack_require__("kDIr");
var assignOrderModal = __webpack_require__("zurN");
var acceptOrderWizardModal = __webpack_require__("+8HO");
var recommendLineItemResourceModal = __webpack_require__("dZyO");
var sorryToSeeYouGoModal = __webpack_require__("ZoNH");
var cancellationConfirmedModal = __webpack_require__("raTP");

var selectResourceModal = __webpack_require__("9AR7");
var selectTemplateModal = __webpack_require__("Mu0W");

var orderDesktopDetail = __webpack_require__("jqQR");
var orderDesktopOrderTab = __webpack_require__("cSZv");
var orderDesktopJobsTab = __webpack_require__("0Rb/");
var orderDesktopDocketsTab = __webpack_require__("FXvt");
var orderDesktopAuditLogTab = __webpack_require__("SOep");

var desktopJobs = __webpack_require__("Dxvw");
//const desktopJobsHeading = require('./views/pages/jobs/desktop/jobsHeading');
var desktopJobsHeading = __webpack_require__("F6ZY");
var desktopJobsList = __webpack_require__("fWvV");
var shareJobModal = __webpack_require__("K4Wd");
var paywalledJobsPage = __webpack_require__("n83n");
var paywalledTimesheetsPage = __webpack_require__("+gor");
var paywalledOrdersPage = __webpack_require__("u0ca");

var selectLineModal = __webpack_require__("Kq0E");

var duplicateJobsModal = __webpack_require__("NtZK");
var jobCommentModal = __webpack_require__("hup7");
var selectOrderModal = __webpack_require__("yVK2");

var desktopJobsDetail = __webpack_require__("CsVk");
var desktopJobsTab = __webpack_require__("70Tx");
var desktopJobsDocketsTab = __webpack_require__("UnmW");
var desktopJobsAuditLogTab = __webpack_require__("uSZ3");

var desktopDockets = __webpack_require__("WqH3");
var desktopDocketsHeading = __webpack_require__("o3T1");
var desktopDocketsList = __webpack_require__("fWaO");

var docketSummaryReportModal = __webpack_require__("DWd+");
var rejectDocketModal = __webpack_require__("EPqU");
var docketBatchModal = __webpack_require__("haha");
var shareDocketModal = __webpack_require__("th1l");
var assignDocketModal = __webpack_require__("HJwN");
var selectJobModal = __webpack_require__("snsZ");
var selectXeroContactModal = __webpack_require__("Hv7s");
var desktopInteractionModal = __webpack_require__("M0Rw");
var signatureCaptureModal = __webpack_require__("Wozb");
var checklistDetailModal = __webpack_require__("+stf");
var acceptConnectionRequestModal = __webpack_require__("zzO9");
var createConnectionModal = __webpack_require__("O5Hz");

var filingDesktop = __webpack_require__("Tqt0");
var filingDesktopHeading = __webpack_require__("3Pz8");
var filingDesktopList = __webpack_require__("DJqn");
var filingDesktopDetail = __webpack_require__("5lJt");

var batchList = __webpack_require__("ap1B");
var batchDetail = __webpack_require__("hauN");

var xeroInvoiceModal = __webpack_require__("ICZc");
var docketDesktopDetail = __webpack_require__("syk1");
var docketDesktopFilingTab = __webpack_require__("j343");
var docketDesktopGeneralTab = __webpack_require__("8mt0");
var docketDesktopGeneralTabPreAuth = __webpack_require__("G7vu");
var docketDesktopAttachmentsTab = __webpack_require__("tk26");
var docketDesktopAuditLogTab = __webpack_require__("5j+l");
var docketDesktopMapTab = __webpack_require__("/uRc");
var fileCodeReportModal = __webpack_require__("xIgd");

var contacts = __webpack_require__("aoea");
var shareContactModal = __webpack_require__("G1+b");
var connections = __webpack_require__("M1kX");

var mobileListsMaster = __webpack_require__("XBXZ");
var mobileListsHeader = __webpack_require__("zKnx");
var mobileListsFooter = __webpack_require__("T7iu");
var docketMobileList = __webpack_require__("3cXQ");
var jobMobileList = __webpack_require__("bhEf");
var ordersMobileList = __webpack_require__("Eh97");
var filingMobileList = __webpack_require__("kHHu");

var docketMobileDetail = __webpack_require__("6/oi");
var organisationListSelector = __webpack_require__("VMpT");
var docketMobileTabBar = __webpack_require__("iwLq");
var docketMobileDetailOther = __webpack_require__("vOD1");
var docketMobileBottomSheet = __webpack_require__("4KcY");
var companyListSelector = __webpack_require__("BOhu");
var viewContactModal = __webpack_require__("B5fK");
var orderListSelector = __webpack_require__("0r42");
var templateListSelector = __webpack_require__("iWHQ");
var resourceCategoryListSelector = __webpack_require__("OHjz");
var resourceListSelector = __webpack_require__("ufFf");
var mobileInteractionModal = __webpack_require__("sXBn");
var docketMobileGeneralTab = __webpack_require__("9x82");
var docketMobileAttachmentsTab = __webpack_require__("SOKq");
var docketMobileItemsTab = __webpack_require__("FqnB");
var docketMobileSignaturesTab = __webpack_require__("KvAG");
var docketMobileCustomBlockTab = __webpack_require__("Mf6t");
var docketMobileChecklistsTab = __webpack_require__("io7Q");
var docketMobileTimeTab = __webpack_require__("0eZp");

var orderMobileDetail = __webpack_require__("KQjo");
var orderMobileTabBar = __webpack_require__("vfH2");
var orderMobileOrderDetail = __webpack_require__("LsFw");
var orderMobileGeneralTab = __webpack_require__("YRsZ");
var orderMobileLineItemsTab = __webpack_require__("UOAC");
var orderMobileJobsTab = __webpack_require__("9FYg");
var orderMobileDocketsTab = __webpack_require__("dBuK");
var mobileLineItemModal = __webpack_require__("Ygf5");
var orderMobileBottomSheet = __webpack_require__("NnfY");
var importResourceFromFile = __webpack_require__("VqsW");

var jobMobileDetail = __webpack_require__("0fge");
var jobMobileTabBar = __webpack_require__("Pisi");
var jobMobileDetailDetail = __webpack_require__("59Nj");
var personListSelector = __webpack_require__("b5+9");
var lineItemListSelector = __webpack_require__("2/1N");

var jobMobileGeneralTab = __webpack_require__("QO/u");
var jobMobileLineItemsTab = __webpack_require__("Wavj");
var jobMobileDocketsTab = __webpack_require__("tCDi");
var jobMobileCommentsTab = __webpack_require__("ZNVM");
var jobMobileAssigneesTab = __webpack_require__("Nq2c");
var jobMobileBottomSheet = __webpack_require__("OyOn");

var filingMobileDetail = __webpack_require__("4L1n");
var activityListSelector = __webpack_require__("ZaRN");

var mobileSideNav = __webpack_require__("RZlY");

var preAuthTemplate = __webpack_require__("0IaA");
var preAuthDocket = __webpack_require__("pRiB");

var groupSettingsNav = __webpack_require__("n/Jq");

var addressBookTags = __webpack_require__("+9Z+");
var selectContactTagsModal = __webpack_require__("g3Fp");
var assignJobModal = __webpack_require__("L6ju");

var timesheetsDesktopPage = __webpack_require__("fLsd");
var timesheetsHeader = __webpack_require__("n2ZK");

var selectOrderLineModal = __webpack_require__("591S");

var ordersFilterBar = __webpack_require__("qnT2");
var docketsFilterBar = __webpack_require__("8bVM");
var jobsFilterBar = __webpack_require__("5ZyV");

_angular2.default.module('docketbook', ['ngRoute', 'ui.router', 'restangular', 'hmTouchEvents', 'ngCookies', 'pickadate', 'angular-uuid', 'ngScroll',
//'ngRaven',
'angucomplete', 'ui.sortable', 'ngMaterial', 'mdPickers', 'ngFileUpload', 'ngSanitize', 'geolocation', 'md.data.table', 'chart.js', 'ngFileUpload', 'credit-cards', 'ngDragDrop', 'as.sortable', 'ds.objectDiff', 'ngMaterialDateRangePicker']).config(['$routeProvider', '$urlRouterProvider', '$stateProvider', '$httpProvider', '$mdThemingProvider', '$mdDateLocaleProvider', '$sceDelegateProvider', 'RestangularProvider', function ($routeProvider, $urlRouterProvider, $stateProvider, $httpProvider, $mdThemingProvider, $mdDateLocaleProvider, $sceDelegateProvider, RestangularProvider) {

  $urlRouterProvider.otherwise('/dashboard');
  $sceDelegateProvider.resourceUrlWhitelist([
  // Allow same origin resource loads.
  'self',
  // Allow loading from our assets domain.  Notice the difference between * and **.
  'https://dbcdn.global.ssl.fastly.net/**']);
  $mdDateLocaleProvider.formatDate = function (date) {
    return date ? (0, _momentTimezone2.default)(date).format('DD/MM/YYYY') : '';
  };

  $mdDateLocaleProvider.parseDate = function (dateString) {
    var m = (0, _momentTimezone2.default)(dateString, 'DD/MM/YYYY', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };

  RestangularProvider.setDefaultHttpFields({
    withCredentials: true
  });
  RestangularProvider.setBaseUrl("" + '/v1/');

  var docketbookBlue = $mdThemingProvider.extendPalette('light-blue', {
    '500': '#222961',
    'contrastDefaultColor': 'light',
    'contrastLightColors': ['500']
  });

  $mdThemingProvider.definePalette('docketbookBlue', docketbookBlue);

  $mdThemingProvider.theme('default').primaryPalette('docketbookBlue', {
    'default': '500'
  }).accentPalette('docketbookBlue', {
    'default': '500'
  });

  var docketbookDarkBlue = $mdThemingProvider.extendPalette('grey', {
    '500': '#042B42',
    'contrastDefaultColor': 'light',
    'contrastLightColors': ['500']
  });

  $mdThemingProvider.definePalette('docketbookDarkBlue', docketbookDarkBlue);

  $mdThemingProvider.theme('dbDarkBlue').primaryPalette('docketbookDarkBlue', {
    'default': '500'
  }).accentPalette('docketbookDarkBlue', {
    'default': '500'
  });

  $httpProvider.interceptors.push(['$q', function ($q) {
    return {
      'responseError': function responseError(rejection) {
        var defer = $q.defer();
        if (rejection.status == 401) {
          (0, _jquery2.default)("#sessionExpiredModal").fadeIn(100);
        }
        defer.reject(rejection);
        return defer.promise;
      }
    };
  }]);

  $stateProvider.state('main', {
    url: "",
    templateUrl: mainTemplate,
    abstract: true

  }).state('main.dashboard', {
    url: "/dashboard?noredirect&redirectTo",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    data: {
      "mainnavOption": "dashboard",
      "pageTitle": "Home",
      "listView": "feed",
      "newCompany": "false"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/home.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'dashboardController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.companySelect', {
    url: "/companies",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    data: {
      "mainnavOption": "companies",
      "pageTitle": "Home",
      "listView": "feed",
      "newCompany": "false"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/home.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'dashboardController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupDashboard', {
    url: "/org/:orgId/group/:groupId/dashboard",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      orgId: undefined,
      groupId: undefined
    },
    data: {
      "mainnavOption": "dashboard",
      "pageTitle": "Dashboard",
      "listView": "feed"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dashboard.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'dashboardController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.orders', {
    url: "/orders",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      active: undefined,
      test: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders",
      "listView": "orders"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'ordersDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupOrders', {
    url: "/org/:orgId/group/:groupId/orders",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      test: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      status: undefined
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders",
      "listView": "orders"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'ordersDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.orderDetail', {
    url: "/orders/:orderId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      openTab: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/orders/mobile/detail.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'orderMobileDetailController';
          } else {
            return 'ordersDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupOrderDetail', {
    url: "/org/:orgId/group/:groupId/orders/:orderId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      openTab: undefined
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/orders/mobile/detail.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'orderMobileDetailController';
          } else {
            return 'ordersDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.jobs', {
    url: "/jobs",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: _defineProperty({
      active: undefined,
      fromOrder: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined
    }, 'myDocketbook', true),
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs",
      "listView": "jobs"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'jobsDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupJobs', {
    url: "/org/:orgId/group/:groupId/jobs",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      status: undefined,
      assigneeStatus: undefined
    },
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs",
      "listView": "jobs"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'jobsDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.jobDetail', {
    url: "/jobs/:jobId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      fromOrder: undefined,
      openTab: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/jobs/mobile/detail.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'jobMobileDetailController';
          } else {
            return 'jobsDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupJobDetail', {
    url: "/org/:orgId/group/:groupId/jobs/:jobId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      fromOrder: undefined,
      openTab: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined
    },
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/jobs/mobile/detail.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'jobMobileDetailController';
          } else {
            return 'jobsDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.dockets', {
    url: "/dockets",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: _defineProperty({
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined
    }, 'myDocketbook', true),
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets",
      "listView": "dockets"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupDockets', {
    url: "/org/:orgId/group/:groupId/dockets",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'dockets',
      status: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets",
      "listView": "dockets"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupExportDockets', {
    url: "/org/:orgId/group/:groupId/dockets/export",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'dockets',
      status: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets",
      "listView": "dockets"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/paywalled/exportDockets.html',
        controller: 'paywalledController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.docketDetail', {
    url: "/dockets/:docketId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/dockets/mobile/detail.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'docketMobileDetailController';
          } else {
            return 'docketDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupDocketDetail', {
    url: "/org/:orgId/group/:groupId/dockets/:docketId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      editing: undefined,
      author: undefined,
      authorName: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/dockets/mobile/detail.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'docketMobileDetailController';
          } else {
            return 'docketDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupBatches', {
    url: "/org/:orgId/group/:groupId/batches",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      fromTab: undefined,
      docketId: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'batch',
      action: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "subnavOption": "batches",
      "pageTitle": "Batches",
      "listView": "batches"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupBatchDetail', {
    url: "/org/:orgId/group/:groupId/batches/:batchId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      fromTab: undefined,
      docketId: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'batch',
      action: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "subnavOption": "batches",
      "pageTitle": "Batches",
      "listView": "batches"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupTimesheets', {
    url: "/org/:orgId/group/:groupId/timesheets",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined
    },
    data: {
      "mainnavOption": "timesheets",
      "pageTitle": "Timesheets",
      "listView": "timesheets"
    },
    views: {
      'content': {
        templateUrl: function templateUrl($stateParams) {
          return 'views/pages/timesheets/desktop/index.html';
        },
        controllerProvider: ['$stateParams', function controllerProvider($stateParams) {
          return 'timesheetsDesktopController';
        }]
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.loading', {
    url: "/loading",
    params: {
      "goToState": undefined,
      "goToParams": undefined,
      "searchParams": undefined,
      'requestedUrl': undefined,
      'redirectTo': undefined
    },
    views: {
      'content': {
        templateUrl: loading,
        controller: 'loadingController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('companySettings', {
    url: "",
    templateUrl: 'views/settingsTemplate.html',
    abstract: true
  }).state('companySettings.general', {
    url: "/org/:orgId/settings",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    params: {
      action: null
    },
    data: {
      "mainnavOption": "companySettings",
      "subnavOption": "general",
      "pageTitle": "Company Settings"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/general.html',
        controller: 'groupSettingsGeneralController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.groups', {
    url: "/org/:orgId/settings/groups",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Groups",
      "subnavOption": "groups",
      "orgOption": "groups"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/groups.html',
        controller: 'companySettingsGroupsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.users', {
    url: "/org/:orgId/settings/users",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Users",
      "subnavOption": "users",
      "orgOption": "users"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/users.html',
        controller: 'companySettingsUsersController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.billing', {
    url: "/org/:orgId/settings/billing",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Billing Settings",
      "subnavOption": "billing",
      "orgOption": "billing"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/billing.html',
        controller: 'companySettingsBillingController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.roles', {
    url: "/org/:orgId/settings/roles",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Roles",
      "subnavOption": "roles",
      "orgOption": "roles"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/roles.html',
        controller: 'companySettingsRolesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.templates', {
    url: "/org/:orgId/settings/templates",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Templates",
      "subnavOption": "templates",
      "docketsOption": "templates"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/templates.html',
        controller: 'companySettingsTemplatesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('docketDesigner', {
    url: "/org/:orgId/settings/templates/:templateId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    params: {
      "mode": ""
    },
    templateUrl: 'views/pages/docketDesigner/designer.html',
    controller: 'docketDesignerController'
  }).state('companySettings.fields', {
    url: "/org/:orgId/settings/fields",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Fields",
      "subnavOption": "fields",
      "docketsOption": "fields"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/fields.html',
        controller: 'companySettingsFieldsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('companySettings.checklists', {
    url: "/org/:orgId/settings/checklists",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Checklists",
      "subnavOption": "checklists",
      "docketsOption": "checklists"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/checklists.html',
        controller: 'companySettingsChecklistsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.resources', {
    url: "/org/:orgId/settings/resources",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Resources",
      "subnavOption": "resources",
      "resourcesOption": "resources"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/resources.html',
        controller: 'companySettingsResourcesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.addressBookTags', {
    url: "/org/:orgId/settings/tags",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Contact Tags",
      "subnavOption": "tags",
      "resourcesOption": "tags"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/addressBookTag.html',
        controller: 'addressBookTagController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.resourceCategories', {
    url: "/org/:orgId/settings/resourcecategories",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Resource Categories",
      "subnavOption": "categories",
      "resourcesOption": "categories"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/categories.html',
        controller: 'companySettingsResourceCategoriesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.uoms', {
    url: "/org/:orgId/settings/uoms",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Uoms",
      "subnavOption": "uoms",
      "resourcesOption": "uoms"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/uoms.html',
        controller: 'companySettingsUomsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.admins', {
    url: "/org/:orgId/settings/admins",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "subnavOption": "admins",
      "pageTitle": "Admins"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/groupSettings/admins.html',
        controller: 'groupSettingsAdminsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.filing', {
    url: "/org/:orgId/settings/filing",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Filing",
      "subnavOption": "filing",
      "docketsOption": "filing"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/groupSettings/filing.html',
        controller: 'groupSettingsFilingController'
      },
      'navigation': {
        templateUrl: 'views/pages/groupSettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupContacts', {
    url: "/org/:orgId/group/:groupId/contacts",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "contacts",
      "pageTitle": "Contacts",
      "subnavOption": "contacts"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/contacts/contacts.html',
        controller: 'contactsController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.connections', {
    url: "/org/:orgId/group/:groupId/connections",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "connections",
      "pageTitle": "connections",
      "subnavOption": "connections"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/connections/connections.html',
        controller: 'connectionsController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('groupSettings', {
    url: "",
    templateUrl: 'views/settingsTemplate.html',
    abstract: true
  }).state('groupSettings.general', {
    url: "/org/:orgId/group/:groupId/settings",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      action: null
    },
    data: {
      "mainnavOption": "groupSettings",
      "subnavOption": "general",
      "pageTitle": "Group Settings"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/general.html',
        controller: 'groupSettingsGeneralController'
      },
      'navigation': {
        templateUrl: 'views/pages/groupSettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('groupSettings.filing', {
    url: "/org/:orgId/group/:groupId/settings/filing",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "groupSettings",
      "pageTitle": "Filing",
      "subnavOption": "filing",
      "docketsOption": "filing"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/groupSettings/filing.html',
        controller: 'groupSettingsFilingController'
      },
      'navigation': {
        templateUrl: 'views/pages/groupSettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('user', {
    url: "",
    templateUrl: 'views/mainTemplate.html',
    abstract: true
  }).state('user.account', {
    url: "/user/account",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    data: {
      "mainnavOption": "user",
      "pageTitle": "Account",
      "subnavOption": "account"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/user/account.html',
        controller: 'adminAccountController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('preauth', {
    url: "",
    templateUrl: 'views/preAuthTemplate.html',
    abstract: true
  }).state('preauth.docket', {
    url: "/docket/:docketId",
    params: {
      previewMode: true
    },
    views: {
      'content': {
        templateUrl: 'views/pages/preauth/docket.html',
        controller: 'preAuthDocketController'
      }
    }
  });
}]).run(['$state', '$rootScope', '$location', 'accessControl', 'formatHelper', 'alertService', function ($state, $rootScope, $location, accessControl, formatHelper, alertService) {
  $rootScope.urlVersion = "v1";
  $rootScope.alertService = alertService;
  $rootScope.contactSupportError = alertService.contactSupportError;
  $rootScope.formatTimeQuantity = formatHelper.formatTimeQuantity;
  $rootScope.stringifyAddress = formatHelper.stringifyAddress;
  $rootScope.stringifyAddressHtml = formatHelper.stringifyAddressHtml;
  $rootScope.userHasPermission = accessControl.userHasPermission;

  if (window.localStorage) {
    window.localStorage.removeItem("filters");
  }

  $rootScope.imMichelle = $rootScope.imMichelle || decodeURIComponent($location.search().imMichelle) == 'true';
  console.log('imMichelle', $rootScope.imMichelle);

  var redirectTo = '';

  if ($location.search().redirectTo) {
    redirectTo = decodeURIComponent($location.search().redirectTo);
  }

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    var currentUser = accessControl.currentUser();

    // if the user has opt'd into the react beta, redirect them to the react app
    if (currentUser && currentUser.reactBeta && !$rootScope.imMichelle) {
      window.location.href = window.location.href.replace('?applicationId=io.docketbook.webui&authType=session', '').replace('/#/', '/app/');
      return;
    }

    if (toState.name !== 'main.loading' && fromState.name !== 'main.loading' && currentUser == null) {
      event.preventDefault();

      $state.go('main.loading', {
        goToState: JSON.stringify(toState),
        goToParams: JSON.stringify(toParams),
        searchParams: JSON.stringify($location.search()),
        requestedUrl: $location.absUrl(), // this initiates the process of building a return URL if the user is not logged and requries to come back to a specific route.
        redirectTo: redirectTo
      });

      return;
    }

    if (toState.name == 'preauth.docket' && currentUser != null && currentUser.name.full != 'Anonymous User') {
      event.preventDefault();
      $state.go('main.docketDetail', { docketId: toParams.docketId });
      return;
    }

    if ($state.params.device) {
      $rootScope.device = $state.params.device;
    }

    var currentTrail = fromParams.stateTrail;
    if (currentTrail == null) {
      currentTrail = [];
    }

    var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
    if (storedFilters) {
      if (storedFilters.job != null && storedFilters.job.id != null && toParams.jobId == null && (toState.name == 'main.dockets' || toState.name == 'main.groupFiling' || toState.name == 'main.docketDetail' || toState.name == 'main.groupDockets' || toState.name == 'main.groupDocketDetail')) {
        toParams.jobId = storedFilters.job.id;
        toParams.jobNumber = storedFilters.job.jobNumber;
      }
      if (storedFilters.order != null && storedFilters.order.id != null && toParams.orderId == null && (toState.name == 'main.dockets' || toState.name == 'main.groupDockets' || toState.name == 'main.docketDetail' || toState.name == 'main.groupDocketDetail' || toState.name == 'main.jobs' || toState.name == 'main.groupJobs' || toState.name == 'main.jobDetail' || toState.name == 'main.groupJobDetail' || toState.name == 'main.groupFiling')) {
        toParams.orderId = storedFilters.order.id;
        toParams.orderNumber = storedFilters.order.orderNumber;
      }
      if (storedFilters.fromDate != null) {
        toParams.fromDate = storedFilters.fromDate;
      }
      if (storedFilters.toDate != null) {
        toParams.toDate = storedFilters.toDate;
      }
      if (storedFilters.startToDate != null) {
        toParams.startToDate = storedFilters.startToDate;
      }
      if (storedFilters.startFromDate != null) {
        toParams.startFromDate = storedFilters.startFromDate;
      }
      if (storedFilters.endToDate != null) {
        toParams.endToDate = storedFilters.endToDate;
      }
      if (storedFilters.endFromDate != null) {
        toParams.endFromDate = storedFilters.endFromDate;
      }
      if (storedFilters.customerContact != null) {
        toParams.customerContact = storedFilters.customerContact;
      }
      if (storedFilters.supplierContact != null) {
        toParams.supplierContact = storedFilters.supplierContact;
      }
      if (storedFilters.docketNumber != null) {
        toParams.docketNumber = storedFilters.docketNumber;
      }
      if (storedFilters.author != null) {
        toParams.author = storedFilters.author;
      }
      if (storedFilters.forwarderContact != null) {
        toParams.forwarderContact = storedFilters.forwarderContact;
      }
      if (storedFilters.orderNumber != null) {
        toParams.orderNumber = storedFilters.orderNumber;
      }
      if (storedFilters.customerRefNo != null) {
        toParams.customerRefNo = storedFilters.customerRefNo;
      }
      if (storedFilters.supplierRefNo != null) {
        toParams.supplierRefNo = storedFilters.supplierRefNo;
      }
      if (storedFilters.datesCleared == true) {
        toParams.datesCleared = true;
      }
    }

    if (currentTrail.length > 0 && currentTrail[currentTrail.length - 1].name == toState.name) {
      currentTrail.pop();
    } else if (currentTrail.length > 1 && currentTrail[currentTrail.length - 2].name == toState.name) {
      currentTrail.pop();
      currentTrail.pop();
    } else {
      if (fromState.name != 'main.loading' && fromState.name != "") {
        if (fromState.name != toState.name) {
          var stateAdd = {};
          stateAdd.name = fromState.name;
          if (fromParams.currentOrg == null) {
            stateAdd.myDocketbook = true;
          }
          if (fromState.name == 'main.docketDetail' || fromState.name == 'main.groupDocketDetail') {
            stateAdd.docketId = fromParams.docketId;
          } else if (fromState.name == 'main.jobDetail' || fromState.name == 'main.groupJobDetail') {
            stateAdd.jobId = fromParams.jobId;
          } else if (fromState.name == 'main.groupOrderDetail') {
            stateAdd.orderId = fromParams.orderId;
          }
          if (fromParams.orgId) {
            stateAdd.orgId = fromParams.orgId;
          }
          if (fromParams.groupId) {
            stateAdd.groupId = fromParams.groupId;
          }
          if (toParams.fromTab != null) {
            stateAdd.fromTab = toParams.fromTab;
          }

          currentTrail.push(stateAdd);
        }
      } else {
        currentTrail = [];
      }
    }

    toParams.stateTrail = currentTrail;

    var windowWidth = (0, _jquery2.default)(window).width();
    if (windowWidth <= 768) {
      toParams.device = "mobile";
    } else {
      toParams.device = "desktop";
    }

    toParams.currentUser = accessControl.currentUser();
    toParams.currentOrg = accessControl.currentOrg();
    toParams.currentOrgGroup = accessControl.currentOrgGroup();

    if (toParams.currentUser !== null && !toParams.currentUser.redirecting) {
      var ravenContext = {
        id: toParams.currentUser.id,
        email: toParams.currentUser.emailAddress,
        name: toParams.currentUser.name.full
      };
      var update = {
        user_id: toParams.currentUser.id,
        user_hash: toParams.currentUser.hash
      };
      if (toParams.currentOrg !== null) {
        update.company = {
          id: toParams.currentOrg.id,
          name: toParams.currentOrg.name
          //ravenContext.organisationId = toParams.currentOrg.id;
          //ravenContext.organisationName = toParams.currentOrg.name;
        };
      }
      if (toParams.currentOrgGroup !== null) {}
      //ravenContext.organisationGroupId = toParams.currentOrgGroup.id;
      //ravenContext.organisationGroupName = toParams.currentOrgGroup.name;

      /*if (Raven) {
        Raven.setUserContext(ravenContext);
      }*/
    }
  });
}]);

/***/ }),

/***/ "et1j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow_up.svg";

/***/ }),

/***/ "f8wG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('filingDesktopController', ['docketService', 'userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$q', function (docketService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, viewMode: 'filing' });

  $scope.filingsChildControllerReady = function () {};

  $scope.filingDetailControllerReady = function () {};
}]);

/***/ }),

/***/ "fGOF":
/***/ (function(module, exports) {

var path = 'views/loading.html';
var html = "<div class=\"docketbookLoadingSpecial\">\n  <div class=\"lds-ring\"><div></div><div></div><div></div><div></div></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "fLsd":
/***/ (function(module, exports) {

var path = 'views/pages/timesheets/desktop/index.html';
var html = "<div ng-if=\"currentOrg.planFeatures.docketsTimesheetsView == true\" class=\"desktopContainer\">\n  <!-- Content Heading -->\n  <!-- Main content area - with list/detail split functionality -->\n  <div class=\"desktopSplitListOuter\">\n    <div class=\"desktopSplitListTableOuter\">\n      <div ng-style=\"{'display' : 'table', 'width':'100%','height':'100%'}\">\n        <ng-include src=\"'views/pages/timesheets/desktop/timesheetsHeading.html'\" ng-style=\"{'display':'table-row','width':'100%','height':'80px'}\"></ng-include>\n        <div ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\">\n          <div ng-style=\"{'display':'table-cell','width':'100%','height':'100%','position':'relative'}\">\n            <div ng-style=\"{'display':'block','height':'100%','position':'absolute','top':'0px','left':'0px','width':'100%','z-index':'10','overflow':'auto'}\">\n\n              <div class=\"timesheetSummaryOuter\">\n                <div class=\"dateHeaderOuter\">\n                  <div class=\"headerRow\">\n                    <div class=\"headerCell first\">\n\n                    </div>\n                    <div class=\"headerCell {{moment(filters.startFromDate).format('D') == moment().format('D') && moment(filters.startFromDate).format('M') == moment().format('M') ? 'today' : ''}}\">\n                      <h3>{{moment(filters.startFromDate).format('ddd')}}</h3>\n                      <h4>{{moment(filters.startFromDate).format('D')}}</h4>\n                    </div>\n                    <div class=\"headerCell {{moment(filters.startFromDate).add('days',1).format('D') == moment().format('D') && moment(filters.startFromDate).add('days',1).format('M') == moment().format('M') ? 'today' : ''}}\">\n                      <h3>{{moment(filters.startFromDate).add('days',1).format('ddd')}}</h3>\n                      <h4>{{moment(filters.startFromDate).add('days',1).format('D')}}</h4>\n                    </div>\n                    <div class=\"headerCell {{moment(filters.startFromDate).add('days',2).format('D') == moment().format('D') && moment(filters.startFromDate).add('days',2).format('M') == moment().format('M') ? 'today' : ''}}\">\n                      <h3>{{moment(filters.startFromDate).add('days',2).format('ddd')}}</h3>\n                      <h4>{{moment(filters.startFromDate).add('days',2).format('D')}}</h4>\n                    </div>\n                    <div class=\"headerCell {{moment(filters.startFromDate).add('days',3).format('D') == moment().format('D') && moment(filters.startFromDate).add('days',3).format('M') == moment().format('M') ? 'today' : ''}}\">\n                      <h3>{{moment(filters.startFromDate).add('days',3).format('ddd')}}</h3>\n                      <h4>{{moment(filters.startFromDate).add('days',3).format('D')}}</h4>\n                    </div>\n                    <div class=\"headerCell {{moment(filters.startFromDate).add('days',4).format('D') == moment().format('D') && moment(filters.startFromDate).add('days',4).format('M') == moment().format('M') ? 'today' : ''}}\">\n                      <h3>{{moment(filters.startFromDate).add('days',4).format('ddd')}}</h3>\n                      <h4>{{moment(filters.startFromDate).add('days',4).format('D')}}</h4>\n                    </div>\n                    <div class=\"headerCell {{moment(filters.startFromDate).add('days',5).format('D') == moment().format('D') && moment(filters.startFromDate).add('days',5).format('M') == moment().format('M') ? 'today' : ''}}\">\n                      <h3>{{moment(filters.startFromDate).add('days',5).format('ddd')}}</h3>\n                      <h4>{{moment(filters.startFromDate).add('days',5).format('D')}}</h4>\n                    </div>\n                    <div class=\"headerCell {{moment(filters.startFromDate).add('days',6).format('D') == moment().format('D') && moment(filters.startFromDate).add('days',6).format('M') == moment().format('M') ? 'today' : ''}}\">\n                      <h3>{{moment(filters.startFromDate).add('days',6).format('ddd')}}</h3>\n                      <h4>{{moment(filters.startFromDate).add('days',6).format('D')}}</h4>\n                    </div>\n                    <div class=\"headerCell\">\n\n                    </div>\n                  </div>\n                </div>\n                <div class=\"userSummary\" ng-repeat=\"user in orderedUsers\" ng-if=\"userSummaries[user.id]\" ng-click=\"expandUserTimesheet(user.id)\">\n                  <div class=\"totalsSummary\">\n                    <div class=\"item first\">\n                      <h3 >{{user.name.full}}</h3>\n\n                    </div>\n                    <div class=\"item {{userSummaries[user.id] == null || userSummaries[user.id].daySummaries[1].totalWorked <= 0 ? 'xeroTime':''}}\">\n                      <span ng-if=\"userSummaries[user.id].daySummaries[1].totalWorked > 0\">\n                        <h5>{{formatTimeNice(userSummaries[user.id].daySummaries[1].totalWorked)}}</h5>\n                        <p>T: {{formatTimeNice(userSummaries[user.id].daySummaries[1].travelTime)}}</p>\n                        <p>B: {{formatTimeNice(userSummaries[user.id].daySummaries[1].breakTime)}}</p>\n                      </span>\n                    </div>\n                    <div class=\"item {{userSummaries[user.id] == null || userSummaries[user.id].daySummaries[2].totalWorked <= 0 ? 'xeroTime':''}}\">\n                      <span ng-if=\"userSummaries[user.id].daySummaries[2].totalWorked > 0\">\n                        <h5>{{formatTimeNice(userSummaries[user.id].daySummaries[2].totalWorked)}}</h5>\n                        <p>T: {{formatTimeNice(userSummaries[user.id].daySummaries[2].travelTime)}}</p>\n                        <p>B: {{formatTimeNice(userSummaries[user.id].daySummaries[2].breakTime)}}</p>\n                      </span>\n                    </div>\n                    <div class=\"item {{userSummaries[user.id] == null || userSummaries[user.id].daySummaries[3].totalWorked <= 0 ? 'xeroTime':''}}\">\n                      <span ng-if=\"userSummaries[user.id].daySummaries[3].totalWorked > 0\">\n                        <h5>{{formatTimeNice(userSummaries[user.id].daySummaries[3].totalWorked)}}</h5>\n                        <p>T: {{formatTimeNice(userSummaries[user.id].daySummaries[3].travelTime)}}</p>\n                        <p>B: {{formatTimeNice(userSummaries[user.id].daySummaries[3].breakTime)}}</p>\n                      </span>\n                    </div>\n                    <div class=\"item {{userSummaries[user.id] == null || userSummaries[user.id].daySummaries[4].totalWorked <= 0 ? 'xeroTime':''}}\">\n                      <span ng-if=\"userSummaries[user.id].daySummaries[4].totalWorked > 0\">\n                        <h5>{{formatTimeNice(userSummaries[user.id].daySummaries[4].totalWorked)}}</h5>\n                        <p>T: {{formatTimeNice(userSummaries[user.id].daySummaries[4].travelTime)}}</p>\n                        <p>B: {{formatTimeNice(userSummaries[user.id].daySummaries[4].breakTime)}}</p>\n                      </span>\n                    </div>\n                    <div class=\"item {{userSummaries[user.id] == null || userSummaries[user.id].daySummaries[5].totalWorked <= 0 ? 'xeroTime':''}}\">\n                      <span ng-if=\"userSummaries[user.id].daySummaries[5].totalWorked > 0\">\n                        <h5>{{formatTimeNice(userSummaries[user.id].daySummaries[5].totalWorked)}}</h5>\n                        <p>T: {{formatTimeNice(userSummaries[user.id].daySummaries[5].travelTime)}}</p>\n                        <p>B: {{formatTimeNice(userSummaries[user.id].daySummaries[5].breakTime)}}</p>\n                      </span>\n                    </div>\n                    <div class=\"item {{userSummaries[user.id] == null || userSummaries[user.id].daySummaries[6].totalWorked <= 0 ? 'xeroTime':''}}\">\n                      <span ng-if=\"userSummaries[user.id].daySummaries[6].totalWorked > 0\">\n                        <h5>{{formatTimeNice(userSummaries[user.id].daySummaries[6].totalWorked)}}</h5>\n                        <p>T: {{formatTimeNice(userSummaries[user.id].daySummaries[6].travelTime)}}</p>\n                        <p>B: {{formatTimeNice(userSummaries[user.id].daySummaries[6].breakTime)}}</p>\n                      </span>\n                    </div>\n                    <div class=\"item {{userSummaries[user.id] == null || userSummaries[user.id].daySummaries[7].totalWorked <= 0 ? 'xeroTime':''}}\">\n                      <span ng-if=\"userSummaries[user.id].daySummaries[7].totalWorked > 0\">\n                        <h5>{{formatTimeNice(userSummaries[user.id].daySummaries[7].totalWorked)}}</h5>\n                        <p>T: {{formatTimeNice(userSummaries[user.id].daySummaries[7].travelTime)}}</p>\n                        <p>B: {{formatTimeNice(userSummaries[user.id].daySummaries[7].breakTime)}}</p>\n                      </span>\n                    </div>\n                    <div class=\"item last\">\n                      <h5>Total: {{formatTimeNice(userSummaries[user.id].totalSummary.totalMinutes)}}</h5>\n                      <p>Travel: {{formatTimeNice(userSummaries[user.id].totalSummary.totalTravel)}}</p>\n                      <p>Break: {{formatTimeNice(userSummaries[user.id].totalSummary.totalBreak)}}</p>\n                    </div>\n                  </div>\n                  <div class=\"docketRows\" id=\"{{user.id}}\">\n                    <div class=\"docketRow\" ng-repeat=\"docket in userSummaries[user.id].dockets\">\n                      <div class=\"item first\">\n                        <h3>{{docket.docketNumber}}</h3>\n                        <p>{{moment(docket.date,'YYYY-MM-DD').format('ddd - DD/MM')}}</p>\n                      </div>\n                      <div class=\"item docketDetail\">\n                        <div class=\"docketDetailInner\">\n                          <div class=\"docketItem\">\n                            <h5>Customer</h5>\n                            <p>{{docket.customerContact.displayName}}</p>\n                          </div>\n                          <div class=\"docketItem\">\n                            <h5>Start Time</h5>\n                            <p ng-if=\"docket.startTime && docket.startTime != undefined\">{{moment(docket.startTime).format('h:mm a')}}</p>\n                          </div>\n                          <div class=\"docketItem\">\n                            <h5>End Time</h5>\n                            <p ng-if=\"docket.endTime && docket.endTime != undefined\">{{moment(docket.endTime).format('h:mm a')}}</p>\n                          </div>\n                          <div class=\"docketItem\">\n                            <h5>Break Time</h5>\n                            <p>{{formatTimeNice(docket.breakTime)}}</p>\n                          </div>\n                          <div class=\"docketItem\">\n                            <h5>Travel Time</h5>\n                            <p>{{formatTimeNice(docket.travelTime)}}</p>\n                          </div>\n                        </div>\n                      </div>\n                      <!--<div class=\"item\">\n                        <span ng-if=\"moment(docket.date,'YYYY-MM-DD').diff(moment(filters.startFromDate),'days') == 0\">\n                          <p>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</p>\n                          <p>Travel: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].travelTime)}}</p>\n                          <p>Break: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].breakTime)}}</p>\n                        </span>\n                      </div>\n                      <div class=\"item\">\n                        <span ng-if=\"moment(docket.date,'YYYY-MM-DD').diff(moment(filters.startFromDate).add('days',1),'days') == 0\">\n                          <p>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</p>\n                          <p>Travel: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].travelTime)}}</p>\n                          <p>Break: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].breakTime)}}</p>\n                        </span>\n                      </div>\n                      <div class=\"item\">\n                        <span ng-if=\"moment(docket.date,'YYYY-MM-DD').diff(moment(filters.startFromDate).add('days',2),'days') == 0\">\n                          <p>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</p>\n                          <p>Travel: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].travelTime)}}</p>\n                          <p>Break: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].breakTime)}}</p>\n                        </span>\n                      </div>\n                      <div class=\"item\">\n                        <span ng-if=\"moment(docket.date,'YYYY-MM-DD').diff(moment(filters.startFromDate).add('days',3),'days') == 0\">\n                          <p>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</p>\n                          <p>Travel: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].travelTime)}}</p>\n                          <p>Break: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].breakTime)}}</p>\n                        </span>\n                      </div>\n                      <div class=\"item\">\n                        <span ng-if=\"moment(docket.date,'YYYY-MM-DD').diff(moment(filters.startFromDate).add('days',4),'days') == 0\">\n                          <p>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</p>\n                          <p>Travel: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].travelTime)}}</p>\n                          <p>Break: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].breakTime)}}</p>\n                        </span>\n                      </div>\n                      <div class=\"item\">\n                        <span ng-if=\"moment(docket.date,'YYYY-MM-DD').diff(moment(filters.startFromDate).add('days',5),'days') == 0\">\n                          <p>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</p>\n                          <p>Travel: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].travelTime)}}</p>\n                          <p>Break: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].breakTime)}}</p>\n                        </span>\n                      </div>\n                      <div class=\"item\">\n                        <span ng-if=\"moment(docket.date,'YYYY-MM-DD').diff(moment(filters.startFromDate).add('days',6),'days') == 0\">\n                          <p>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</p>\n                          <p>Travel: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].travelTime)}}</p>\n                          <p>Break: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].breakTime)}}</p>\n                        </span>\n                      </div>-->\n                      <div class=\"item last\">\n                        <h5>Total: {{formatTimeNice(userSummaries[user.id].docketSummaries[docket.id].totalWorked)}}</h5>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-include ng-if=\"currentOrg.planFeatures.docketsTimesheetsView != true\" src=\"'views/pages/paywalled/timesheets.html'\" ng-controller=\"paywalledController\"></ng-include>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "fWaO":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/docketsList.html';
var html = "<md-table-container>\n  <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n    <thead md-head md-order=\"filters.query.order\" md-on-reorder=\"loadDocketsList\">\n      <tr md-row>\n        <th md-column ng-repeat=\"columnName in listViewOrder\" md-order-by=\"{{listViewConfig[columnName].modelName}}\">\n          <span>{{listViewConfig[columnName].displayName}}</span>\n        </th>\n      </tr>\n    </thead>\n    <tbody md-body class=\"clickableTable\">\n      <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in listItems\" ng-click=\"openDocketDesktop(item)\">\n        <td md-cell ng-repeat=\"columnName in listViewOrder\" style=\"{{columnName == 'status' ? 'width:140px;' : ''}}\">\n          <span ng-if=\"columnName == 'docketNumber'\">\n            {{item.docketNumber}} <span ng-if=\"!item.assigned && currentOrg == null\">(unassigned)</span>\n          </span>\n          <span ng-if=\"columnName == 'customerName'\">\n            <span ng-if=\"item.customerContact\">{{item.customerContact.displayName}}</span>\n          </span>\n          <span ng-if=\"columnName == 'supplierName'\">\n            <span ng-if=\"item.supplierContact\">{{item.supplierContact.displayName}}</span>\n          </span>\n          <span ng-if=\"columnName == 'acceptedBy'\">\n            <span ng-if=\"item.acceptedBy\">{{item.acceptedBy.user}}</span>\n          </span>\n          <span ng-if=\"columnName == 'authorName'\">\n            {{item.authorName}}\n          </span>\n          <span ng-if=\"columnName == 'customerSignatureName'\">\n            <div class=\"sigDisplay Signed\" ng-if=\"item.customerSignature\"><md-icon md-svg-src=\"_signature.svg\"></md-icon></div>\n            {{item.customerSignatureName}}\n          </span>\n          <span ng-if=\"columnName == 'date'\">\n            {{moment(item.date).format('DD/MM/YYYY')}}\n          </span>\n          <span ng-if=\"columnName == 'customerRefNo'\">\n            {{item.customerRefNo}}\n          </span>\n          <span ng-if=\"columnName == 'supplierRefNo'\">\n            {{item.supplierRefNo}}\n          </span>\n          <span ng-if=\"columnName == 'status'\">\n            <div class=\"statusDisplay {{item.status}}\">{{item.status}}</div>\n            <div class=\"statusDisplay Filed\" ng-if=\"item.filed\">F</div>\n          </span>\n          <span ng-if=\"columnName.indexOf('customField') == 0\">\n            {{item.customFieldsInjected[columnName.split('-')[1]]}}\n          </span>\n          <span ng-if=\"columnName == 'orderNumber'\">\n            {{item.orderNumber}}\n          </span>\n        </td>\n\n\n\n        <!--<td md-cell>{{item.docketNumber}} <span ng-if=\"!item.assigned && currentOrg == null\">(unassigned)</span></td>\n        <td md-cell class=\"tablet-hide-collapsed\"><span ng-if=\"item.customerContact\">{{item.customerContact.displayName}}</span></td>\n        <td md-cell ng-show=\"listFull\"><span ng-if=\"item.supplierContact\">{{item.supplierContact.displayName}}</span></td>\n        <td md-cell>{{item.authorName}}</td>\n        <td md-cell>\n          <div class=\"sigDisplay Signed\" ng-if=\"item.customerSignature\"><md-icon md-svg-src=\"_signature.svg\"></md-icon></div>\n          {{item.customerSignatureName}}\n        </td>\n        <td md-cell>{{moment(item.date).format('DD/MM/YYYY')}}</td>\n        <td md-cell width=\"110px\">\n          <div class=\"statusDisplay {{item.status}}\">{{item.status}}</div>\n          <div class=\"statusDisplay Filed\" ng-if=\"item.filed\">F</div>\n        </td>-->\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>\n<md-table-pagination md-limit=\"filters.query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"filters.query.page\" md-on-paginate=\"loadDocketsList\" md-total=\"{{listCount}}\" md-page-select>\n\n</md-table-pagination>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "fWdn":
/***/ (function(module, exports) {

var path = 'views/scopeNav.html';
var html = "<div>\n  <div style=\"display: flex; height: 54px; align-items: center; justify-content: center;\">\n    <div>\n        <h5 class=\"centerAligned\" style=\"color: #FFFFFF; white-space: pre;\">This view is no longer being maintained, and will not be available in the coming weeks - we recommend switching to the <link ng-click=\"newLook()\">New Look</link></h5>\n    </div>\n    <div class=\"newDbButton whiteOutline\" style=\"background-color: white; margin-left: 60px;\" ng-click=\"newLook()\">\n      Try new look!\n    </div>\n  </div>\n  <div style=\"display: flex;\">\n    <div style=\"flex-grow: 1; flex-basis: 0; min-width: 0;\">\n      <div class=\"logoSmallOuter\" ui-sref=\"main.dashboard\">\n        <div class=\"logoSpacer\"></div>\n        <div class=\"logoMark\" ng-if=\"currentOrg != null || myDocketbook == true || currentState.name == 'main.loading'\">\n        </div>\n      </div>\n\n      <div class=\"orgScopeOuter\">\n        <div class=\"orgScope\">\n          <ul class=\"headerNavGroup\" ng-if=\"currentOrg != null\">\n            <li>\n              <div class=\"pageNavInner\">{{currentOrgGroup.name}}<div class=\"dropdownIcon\"></div>\n                <div class=\"pageNavDropdown\" style=\"max-height: 600px; overflow: auto;\">\n                  <ul>\n                    <li ui-sref=\"main.groupDashboard({orgId:currentOrg.id, groupId:group.id})\"\n                      ng-repeat=\"group in sortedGroups\" class=\"{{group.id == currentOrgGroup.id ? 'selected' : ''}}\">\n                      {{group.name}}</li>\n                  </ul>\n                </div>\n            </li>\n          </ul>\n          <ul class=\"headerNavGroup\" ng-if=\"currentOrg == null && myDocketbook == true\">\n            <li>\n              <div class=\"pageNavInner\">My Docketbook</div>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n    <div id=\"pagesNavOuter\">\n      <div class=\"middleFullLogo\"\n        ng-if=\"(currentOrg == null && myDocketbook == false && currentState.name != 'main.loading')\"\n        ui-sref=\"main.dashboard\"></div>\n      <ul class=\"headerNavGroup\" ng-if=\"currentOrg != null\">\n        <li ui-sref=\"main.groupDashboard({orgId: currentOrg.id, groupId: currentOrgGroup.id})\"\n          class=\"{{currentState.data.mainnavOption == 'dashboard' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\">\n            Dashboard\n          </div>\n        </li>\n\n        <li ng-if=\"userHasPermission('io.docketbook.ojdapi.getOrder')\"\n          ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id})\"\n          class=\"{{currentState.data.mainnavOption == 'orders' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\">\n            Orders\n            <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.ordersEnabled != true && !hasOrders\">\n              <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n            </span>\n            <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\"\n              ng-if=\"currentOrg.planFeatures.ordersEnabled != true && !hasOrders\">\n              <div style=\"font-size: 12px;\">\n                Unlock Orders features on the Small Plan\n              </div>\n            </md-tooltip>\n          </div>\n        </li>\n\n        <li ng-if=\"userHasPermission('io.docketbook.ojdapi.getJob') || userHasPermission('io.docketbook.ojdapi.getMyJob')\"\n          ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id})\"\n          class=\"{{currentState.data.mainnavOption == 'jobs' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\">\n            Jobs\n            <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.jobsEnabled != true && !hasJobs\">\n              <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n            </span>\n            <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"bottom\"\n              ng-if=\"currentOrg.planFeatures.jobsEnabled != true && !hasJobs\">\n              <div style=\"font-size: 12px;\">Unlock Job Allocations features on the Medium Plan</div>\n            </md-tooltip>\n          </div>\n        </li>\n        <li\n          ng-if=\"( userHasPermission('io.docketbook.ojdapi.getDocket') || userHasPermission('io.docketbook.ojdapi.getMyDocket') )\"\n          class=\"{{currentState.data.mainnavOption == 'dockets' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\" ng-click=\"goToDockets()\">\n            <span>Dockets</span>\n            <div class=\"dropdownIcon\"></div>\n          </div>\n          <div class=\"pageNavDropdown\">\n            <ul>\n              <li class=\"{{listView == 'dockets' ? 'selected' : ''}}\"\n                ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id, viewMode: 'dockets'})\">\n                Dockets</li>\n              <!--<li class=\"{{listView == 'filing' ? 'selected' : ''}}\" ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id, viewMode: 'filing'})\">Filing</li>-->\n              <li ng-if=\"currentOrg.planFeatures.docketsViewBatches\" class=\"{{listView == 'batches' ? 'selected' : ''}}\"\n                ui-sref=\"main.groupBatches({orgId:currentOrg.id, groupId:currentOrgGroup.id})\">Batches</li>\n              <li class=\"{{listView == 'timesheets' ? 'selected' : ''}}\"\n                ui-sref=\"main.groupTimesheets({orgId:currentOrg.id, groupId:currentOrgGroup.id})\">\n                Timesheets\n                <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsTimesheetsView != true\">\n                  <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n                </span>\n                <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"right\"\n                  ng-if=\"currentOrg.planFeatures.docketsTimesheetsView != true\">\n                  <div style=\"font-size: 12px;\">Unlock Timesheet features on the Medium Plan</div>\n                </md-tooltip>\n              </li>\n            </ul>\n          </div>\n        </li>\n        <li\n          ng-show=\"currentOrg.features.invoice.enabled == true && userHasPermission('io.docketbook.invoice-srv.getInvoice')\">\n          <div class=\"pageNavInner\" ng-click=\"goToInvoices('receivable')\">\n            <span>Invoices</span>\n            <div class=\"dropdownIcon\"></div>\n          </div>\n          <div class=\"pageNavDropdown\">\n            <ul>\n              <li ng-click=\"goToInvoices('receivable')\">\n                Receivable\n              </li>\n              <li ng-click=\"goToInvoices('payable')\">\n                Payable\n              </li>\n            </ul>\n          </div>\n        </li>\n        <li ng-if=\"userHasPermission('io.docketbook.uoapi.getAddressBook')\"\n          class=\"{{currentState.data.mainnavOption == 'contacts' || currentState.data.mainnavOption == 'connections' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\" ng-click=\"goToContacts()\">\n            Contacts\n            <div class=\"dropdownIcon\" ng-if=\"userHasPermission('io.docketbook.uoapi.getConnection')\"></div>\n            <span ng-if=\"connections.length > 0\" class=\"badge\">\n              {{connections.length}}\n            </span>\n\n            <div class=\"pageNavDropdown\" ng-if=\"userHasPermission('io.docketbook.uoapi.getConnection')\">\n              <ul>\n                <li class=\"{{currentState.data.mainnavOption == 'contacts' ? 'selected' : ''}}\"\n                  ui-sref=\"main.groupContacts({orgId:currentOrg.id, groupId:currentOrgGroup.id})\">Contacts</li>\n                <li class=\"{{currentState.data.mainnavOption == 'connections' ? 'selected' : ''}}\"\n                  ui-sref=\"main.connections({ orgId:currentOrg.id, groupId:currentOrgGroup.id })\">\n                  Connections\n                  <span ng-if=\"connections.length > 0\" class=\"badge\">\n                    {{connections.length}}\n                  </span>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </li>\n\n        <!--<li ng-if=\"userHasPermission('io.docketbook.uoapi.getConnection')\" ui-sref=\"main.connections({ orgId:currentOrg.id, groupId:currentOrgGroup.id })\" class=\"{{currentState.data.mainnavOption == 'connections' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\">\n            Connections\n            <span ng-if=\"connections.length > 0\" class=\"badge\">\n              {{connections.length}}\n            </span>\n          </div>\n        </li>-->\n\n      </ul>\n      <ul class=\"headerNavGroup\" ng-if=\"currentOrg == null && myDocketbook == true\">\n        <li ui-sref=\"main.orders\" class=\"{{currentState.data.mainnavOption == 'orders' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\">My Orders</div>\n        </li>\n        <li ui-sref=\"main.jobs\" class=\"{{currentState.data.mainnavOption == 'jobs' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\">\n            My Jobs\n            <!--span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.jobsEnabled != true\">\n              <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n            </span>\n            <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"right\" ng-if=\"currentOrg.planFeatures.jobsEnabled != true\">\n              <div style=\"font-size: 12px;\">Unlock Job Allocations features on the Medium Plan</div>\n            </md-tooltip-->\n          </div>\n        </li>\n        <li ui-sref=\"main.dockets\" class=\"{{currentState.data.mainnavOption == 'dockets' ? 'selected' : ''}}\">\n          <div class=\"pageNavInner\">My Dockets</div>\n        </li>\n      </ul>\n    </div>\n    <div id=\"controlNavOuter\" style=\"flex-grow: 1; flex-basis: 0;\">\n      <ul class=\"headerNavGroup\" ng-if=\"currentState.name != 'main.loading'\">\n        <li>\n          <div class=\"pageNavInner hasSettingsIcon\" ui-sref=\"companySettings.general({orgId:currentOrg.id})\"\n            ng-if=\"userCanDoAction('viewCompanySettings')\">\n            <!--<div class=\"companySettingsIcon\"></div>-->\n            <md-icon md-menu-origin md-svg-icon=\"companySettingsWhite.svg\"></md-icon>\n          </div>\n        </li>\n        <li>\n          <div class=\"pageNavInner\">{{currentUser.name.full}}<div class=\"dropdownIcon\"></div>\n          </div>\n          <div class=\"pageNavDropdown\">\n            <ul>\n              <li ui-sref=\"main.companySelect\" ng-click=\"myCompaniesClick()\">My Companies</li>\n              <li ui-sref=\"main.dockets\">My Docketbook</li>\n              <li ui-sref=\"user.account\" class=\"{{currentState.data.mainnavOption == 'user' ? 'selected' : ''}}\">My\n                Account</li>\n              <li ng-click=\"logout()\">Logout</li>\n            </ul>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "fWvV":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/desktop/jobsList.html';
var html = "<md-table-container>\n  <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n    <thead md-head md-order=\"query.order\" md-on-reorder=\"loadJobsList\">\n      <tr md-row>\n        <th md-column md-order-by=\"jobNumber\"><span>Job Number</span></th>\n        <th md-column md-order-by=\"customerName\"><span>Customer</span></th>\n        <th md-column md-order-by=\"assigned\" class=\"hidden-md\"><span>Assignee's</span></th>\n        <th md-column md-order-by=\"startDate\" ng-show=\"listFull\"><span>Start Date</span></td>\n        <th md-column md-order-by=\"endDate\" ng-show=\"listFull\"><span>End Date</span></th>\n        <th md-column md-order-by=\"status\"><span>Status</span></th>\n      </tr>\n    </thead>\n    <tbody md-body class=\"clickableTable\">\n      <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in listItems\" ng-click=\"openJobDesktop(item)\">\n        <td md-cell>{{item.jobNumber}}</td>\n        <td md-cell><span ng-if=\"item.customerContact\">{{item.customerContact.displayName}}</span></td>\n        <td md-cell>\n          <span ng-if=\"item.assignedCount + item.acceptedCount + item.rejectedCount + item.completedCount == 0\">Unassigned</span>\n          <span ng-if=\"item.assignedCount + item.acceptedCount + item.rejectedCount + item.completedCount > 1\">A-{{item.assignedCount}} A-{{item.acceptedCount}} D-{{item.rejectedCount}} C-{{item.completedCount}}</span>\n          <span ng-if=\"item.assignedCount + item.acceptedCount + item.rejectedCount + item.completedCount == 1\">{{item.assignees[0].name}} ({{item.assignees[0].status}})</span>\n        </td>\n        <td md-cell ng-show=\"listFull\">{{moment(item.startDate).format('DD/MM/YYYY')}}</td>\n        <td md-cell ng-show=\"listFull\">{{moment(item.endDate).format('DD/MM/YYYY')}}</td>\n\n        <td md-cell width=\"100px\">\n          <div class=\"statusDisplay {{getStatus(item)}}\">\n            <md-icon ng-if=\"getStatus(item) == 'Unassigned'\" class=\"smallIcon Unassigned\" md-svg-icon=\"error-outlined.svg\"></md-icon>\n            <span>{{getStatus(item)}}</span>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>\n<md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadJobsList\" md-total=\"{{listCount}}\" md-page-select>\n\n</md-table-pagination>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "fXTq":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/ordersHeading.html';
var html = "\n<div class=\"contentHeadingOuter\">\n  <div class=\"contentHeadingInner desktopTableSearch\">\n    <div class=\"headerSplit\">\n      <div class=\"left\">\n        <h1 class=\"centerAligned\">Orders</h1>\n        <md-button class=\"md-icon-button\" ng-click=\"loadOrdersList(null, true)\" aria-label=\"Reload Dockets List\">\n          <md-icon class=\"centerAligned\" md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n      </div>\n      <div class=\"right\">\n        <div md-menu-origin ng-if=\"userCanDoAction('createOrder') && !(currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.quotesEnabled)\" class=\"newDbButton rightMargin\" ng-click=\"currentOrg.planFeatures.ordersCreate ? newOrder() : selectPlan(null, 'ordersCreate', 'from orders page - create new order')\" aria-label=\"New Order\">\n          <md-icon class=\"smallIcon\" md-svg-icon=\"note_add.svg\"></md-icon>\n          New\n          <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.ordersCreate != true\">\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </span>\n          <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"right\" ng-if=\"currentOrg.planFeatures.ordersCreate != true\">\n            <div style=\"font-size: 12px;\">Upgrade your plan to create orders</div>\n          </md-tooltip>\n        </div>\n        <md-menu ng-if=\"userCanDoAction('createOrder') && (currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.quotesEnabled)\">\n          <div md-menu-origin aria-label=\"New Order Options Menu\" class=\"newDbButton rightMargin\" ng-click=\"currentOrg.planFeatures.ordersCreate ? openMenu($mdOpenMenu, $event) : selectPlan(null, 'ordersCreate', 'from orders page - create new order')\" aria-label=\"More Options\">\n            <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n            <span>Add New</span>\n            <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.ordersCreate != true\">\n              <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n            </span>\n            <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"right\" ng-if=\"currentOrg.planFeatures.ordersCreate != true\">\n              <div style=\"font-size: 12px;\">Upgrade your plan to create orders</div>\n            </md-tooltip>\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"currentOrg.planFeatures.ordersCreate && newOrder()\" aria-label=\"New Order\">\n              <md-button>\n                New Order\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-click=\"newOrder('xeroQuote')\" aria-label=\"New Order From Xero Quote\">\n              <md-button>\n                New Order From Xero Quote\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n        <md-menu>\n          <div aria-label=\"Open list actions menu\" md-menu-origin class=\"newDbButton whiteOutline\" ng-click=\"(selected.length > 0) && openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n            Actions\n            <md-icon class=\"smallIcon\" md-svg-icon=\"arrow_down.svg\"></md-icon>\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-if=\"userHasPermission('io.docketbook.ojdapi.sendOrder')\" ng-click=\"bulkSelectionSend()\" aria-label=\"Send Selected Orders\">\n              <md-button>\n                Send Orders\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"userHasPermission('io.docketbook.ojdapi.acceptOrder')\" ng-click=\"bulkSelectionAccept()\" aria-label=\"Accept Selected Orders\">\n              <md-button>\n                Accept Orders\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"userHasPermission('io.docketbook.ojdapi.rejectOrder')\" ng-click=\"bulkSelectionReject()\" aria-label=\"Reject Selected Orders\">\n              <md-button>\n                Reject Orders\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"userHasPermission('io.docketbook.ojdapi.updateOrder')\" ng-click=\"bulkSelectionClose()\" aria-label=\"Close Selected Orders\">\n              <md-button>\n                Close Orders\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-if=\"userHasPermission('io.docketbook.ojdapi.deleteOrder')\" ng-click=\"bulkSelectionDelete()\" aria-label=\"Delete Selected Orders\">\n              <md-button>\n                Delete Orders\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "fZNG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').service('orderService', ['accessControl', 'userService', '$http', '$stateParams', '$cookies', '$q', 'Restangular', 'geolocation', '$timeout', function (accessControl, userService, $http, $stateParams, $cookies, $q, Restangular, geolocation, $timeout) {

  /**** Save a order ****/
  var saveOrder = function saveOrder(order, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var order = angular.copy(order);
    var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');

    if (order.orderNumber == "") {
      delete order.orderNumber;
    }

    // update line items to have id's for ref'd items - not objects
    if (order.lineItems != null) {
      for (var i = 0; i < order.lineItems.length; i++) {
        if (order.lineItems[i].resource) {
          order.lineItems[i].resource = order.lineItems[i].resource.id;
        }
        if (order.lineItems[i].new == true) {
          delete order.lineItems[i].id;
          delete order.lineItems[i].new;
        }
        if (order.lineItems[i].quantity) {
          order.lineItems[i].quantity = parseFloat(order.lineItems[i].quantity);
        }

        if (order.lineItems[i].rate) {
          order.lineItems[i].rate = parseFloat(order.lineItems[i].rate);
        }
      }
    }

    // docket prefill field stores - update any date fields and save in correct format
    /*if ( order.docketPrefillValueStore && order.template ) {
      var prefillKeys = Object.keys(order.docketPrefillValueStore);
      for ( var i = 0; i < prefillKeys.length; i++ ) {
        // check against template if this field id is a date field
        for ( var j = 0; j < order.template.blocks.length; j++ ) {
          for ( var k = 0; k < order.template.blocks[j].fields.length; k++ ) {
            if ( order.template.blocks[j].fields[k].id == prefillKeys[i] && order.template.blocks[j].fields[k].type == 'date' ) {
              var preValue = order.docketPrefillValueStore[prefillKeys[i]];
              var translatedValue = moment(preValue).format('YYYY-MM-DD');
              translatedValue += "T00:00:00.000Z";
              order.docketPrefillValueStore[prefillKeys[i]] = translatedValue;
              console.log('translated this prefill field date field type to', translatedValue);
            }
          }
        }
      }
    }*/

    // convert dates to ISO format
    if (order.startDate) {
      order.startDate = (0, _momentTimezone2.default)(order.startDate).format('YYYY-MM-DD');
    }
    if (order.endDate) {
      order.endDate = (0, _momentTimezone2.default)(order.endDate).format('YYYY-MM-DD');
    }

    // strip out customer field if customer linking no create
    // TODO: remove this after new address book is implemented
    if (order.customer == "") {
      delete order.customer;
    }

    if (order.template != null && order.template.id != null) {
      order.template = order.template.id;
    }

    if (order.template == null) {
      delete order.template;
    }

    if (order.customerContact == null) {
      delete order.customerContact;
    } else {
      for (var i = 0; i < order.customerContact.addresses.length; i++) {
        if (order.customerContact.addresses[i].streetNum == null) {
          delete order.customerContact.addresses[i].streetNum;
        }
        if (order.customerContact.addresses[i].streetName == null) {
          delete order.customerContact.addresses[i].streetName;
        }
      }
    }

    if (order.orderNumber == 'New Order') {
      delete order.orderNumber;
    }

    // strip out dockets array
    delete order.dockets;

    // if current group is the supplier contact - add org and org group to the order
    var currentOrg = organisation;
    var currentOrgGroup = organisationGroup;
    if (!order.organisation || !order.organisationGroup) {
      if (currentOrgGroup.emailAddresses && order.supplierContact && order.supplierContact.contactAddresses) {
        var foundEmail = false;
        for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
          if (order.supplierContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
            foundEmail = true;
            break;
          }
        }
        if (foundEmail) {
          order.organisation = currentOrg.id;
          order.organisationGroup = currentOrgGroup.id;
        }
      }
    }
    if (order.id == null) {
      order.status = 'Draft';
      if (order.orderNumber == 'New Order') {
        delete order.orderNumber;
      }
      // strip out any line items that have been deleted
      var lineItemsActual = [];
      if (order.lineItems) {
        for (var i = 0; i < order.lineItems.length; i++) {
          if (!order.lineItems[i].delete) {
            lineItemsActual.push(order.lineItems[i]);
          }
        }
        order.lineItems = lineItemsActual;
      }
      baseOrders.post(order).then(successCb, failureCb);
    } else {
      // existing order - edit
      baseOrders.one(order.id).customPUT(order).then(successCb, failureCb);
    }
  };

  /**** External ref to saveOrder ****/
  this.saveOrder = saveOrder;

  /***** Get Single Template *****/
  var getTemplate = function getTemplate(templateId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
    if (templateId != null && templateId.id != null) {
      templateId = templateId.id;
    }
    baseTemplates.one(templateId).get().then(function (templateFull) {
      successCb(templateFull);
    }, failureCb);
  };

  /***** External ref to getTemplate *****/
  this.getTemplate = getTemplate;

  /***** Get Single Order *****/
  var getOrder = function getOrder(orderId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();

    var baseOrders = null;
    var baseTemplates = null;
    if (organisation != null) {
      baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
      baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
    } else {
      baseOrders = Restangular.all('orders');
    }

    //var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    //var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
    if (orderId.id != null) {
      orderId = orderId.id;
    }
    baseOrders.one(orderId).get().then(function (fullOrder) {
      // convert dates
      if (fullOrder.startDate) {
        fullOrder.startDate = (0, _momentTimezone2.default)(fullOrder.startDate).toDate();
      }
      if (fullOrder.endDate) {
        fullOrder.endDate = (0, _momentTimezone2.default)(fullOrder.endDate).toDate();
      }

      // if template not populated - get full template
      // uppercase status
      fullOrder.status = fullOrder.status.charAt(0).toUpperCase() + fullOrder.status.slice(1);
      if (fullOrder.template != null && fullOrder.template.id == null && baseTemplates != null && userService.userCanDoAction('isOrderSupplier', fullOrder)) {
        getTemplate(fullOrder.template, function (fullTemplate) {
          fullOrder.template = Restangular.stripRestangular(fullTemplate);
          successCb(fullOrder);
        }, function (err) {
          successCb(fullOrder);
        });
      } else {
        successCb(fullOrder);
      }
    }, failureCb);
  };

  this.getOrder = getOrder;

  /****** Delete Single Order *****/
  var deleteOrder = function deleteOrder(orderId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');

    if (orderId.id != null) {
      orderId = orderId.id;
    }

    baseOrders.one(orderId).remove().then(successCb, failureCb);
  };

  this.deleteOrder = deleteOrder;

  /****** Delete Bulk Orders *******/
  this.deleteBulkOrders = function (orders, successCb) {
    var failures = [];
    deleteOrders(orders, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteOrders = function deleteOrders(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteOrder(list[index].id, function (success) {
      deleteOrders(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteOrders(list, index + 1, failures, successCb);
    });
  };

  /****** Get all orders ********/
  this.getOrders = function (params, successCb, failureCb) {
    if (params == null) {
      params = {};
    }
    if (params['status'] != null) {
      params['status'] = params['status'].toLowerCase();
    }

    /**** Setup scope - group or myDocketbook ****/
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = null;

    if (organisationGroup != null) {
      baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    } else {
      baseOrders = Restangular.all('orders');
    }
    /**** End scope setup ****/

    if (params['offset'] != null && params['limit'] != null) {
      baseOrders.customGET("", params).then(successCb, failureCb);
    } else {
      baseOrders.getList(params).then(successCb, failureCb);
    }
  };

  /********** Parse Orders ************/
  var parseOrders = function parseOrders(data) {
    var orders = [];
    data.forEach(function (order) {
      order.loading = false;
      order.status = order.status.charAt(0).toUpperCase() + order.status.slice(1);
      order.selected = false;
      orders.push(order);
    });

    return orders;
  };

  this.parseOrders = parseOrders;

  /******* Send order ********/
  var sendOrder = function sendOrder(order, successCb, failureCb) {
    var orderId = order;
    if (order.id != null) {
      orderId = order.id;
    }
    var order = angular.copy(order);
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    var orderObject = { status: 'sent' };
    baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
  };

  this.sendOrder = sendOrder;

  /****** Send Bulk Orders *******/
  this.sendBulkOrders = function (orders, successCb) {
    var failures = [];
    sendOrders(orders, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var sendOrders = function sendOrders(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    sendOrder(list[index].id, function (success) {
      sendOrders(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      sendOrders(list, index + 1, failures, successCb);
    });
  };

  /******* Re-Draft order ********/
  this.reDraftOrder = function (order, successCb, failureCb) {
    var orderId = order;
    if (order.id != null) {
      orderId = order.id;
    }
    var order = angular.copy(order);
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    var orderObject = { status: 'draft' };
    baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
  };

  /******** Reject order **********/
  var rejectOrder = function rejectOrder(order, successCb, failureCb) {
    var orderId = order;
    if (order.id != null) {
      orderId = order.id;
    }
    var order = angular.copy(order);
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    var orderObject = { status: 'rejected' };
    baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
  };

  this.rejectOrder = rejectOrder;

  /****** Reject Bulk Orders *******/
  this.rejectBulkOrders = function (orders, successCb) {
    var failures = [];
    rejectOrders(orders, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var rejectOrders = function rejectOrders(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    rejectOrder(list[index].id, function (success) {
      rejectOrders(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      rejectOrders(list, index + 1, failures, successCb);
    });
  };

  /******** Accept order **********/
  var acceptOrder = function acceptOrder(order, successCb, failureCb) {
    var orderId = order;
    if (order.id != null) {
      orderId = order.id;
    }
    var order = angular.copy(order);
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    var orderObject = { status: 'Accepted' };
    // need to add org and org group is supplier
    var currentOrg = organisation;
    var currentOrgGroup = organisationGroup;
    if (!order.organisation || !order.organisationGroup) {
      if (currentOrgGroup.emailAddresses && order.supplierContact && order.supplierContact.contactAddresses) {
        var foundEmail = false;
        for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
          if (order.supplierContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
            foundEmail = true;
            break;
          }
        }
        if (foundEmail) {
          orderObject.organisation = currentOrg.id;
          orderObject.organisationGroup = currentOrgGroup.id;
        }
      }
    }
    baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
  };

  this.acceptOrder = acceptOrder;

  /****** Accept Bulk Orders *******/
  this.acceptBulkOrders = function (orders, successCb) {
    var failures = [];
    acceptOrders(orders, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var acceptOrders = function acceptOrders(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    acceptOrder(list[index].id, function (success) {
      acceptOrders(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      acceptOrders(list, index + 1, failures, successCb);
    });
  };

  /******** Close order **********/
  var closeOrder = function closeOrder(order, successCb, failureCb) {
    var orderId = order;
    if (order.id != null) {
      orderId = order.id;
    }
    var order = angular.copy(order);
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    var orderObject = { status: 'closed' };
    baseOrders.one(orderId).customPUT(orderObject).then(successCb, failureCb);
  };

  this.closeOrder = closeOrder;

  /****** Close Bulk Orders *******/
  this.closeBulkOrders = function (orders, successCb) {
    var failures = [];
    closeOrders(orders, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var closeOrders = function closeOrders(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    closeOrder(list[index].id, function (success) {
      closeOrders(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      closeOrders(list, index + 1, failures, successCb);
    });
  };

  /***** Re-assign ORder *****/
  this.reassignOrderLineItems = function (order, losingOrderLineItem, gainingOrderLineItem, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('orders');
    if (organisation != null && organisationGroup != null) {
      baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    }

    var orderId = order;
    if (orderId.id != null) {
      orderId = orderId.id;
    }

    var payload = { 'losingOrderLineItemId': losingOrderLineItem.id, 'gainingOrderLineItemId': gainingOrderLineItem.id, 'gainingOrderLineItemDescription': gainingOrderLineItem.itemDescription };
    baseOrders.one(orderId).all('docket_lines').customPUT(payload).then(successCb, failureCb);
  };

  /***** Re-assign ORder *****/
  this.reassignOrder = function (order, losingPrincipal, gainingPrincipal, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('orders');
    if (organisation != null && organisationGroup != null) {
      baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    }

    var orderId = order;
    if (orderId.id != null) {
      orderId = orderId.id;
    }

    var payload = { 'losingPrincipal': losingPrincipal, 'gainingPrincipal': gainingPrincipal };
    baseOrders.one(orderId).all('reassign').customPOST(payload).then(successCb, failureCb);
  };

  /****** Create Shell Docket From Order *******/
  this.createDocketFromOrder = function (order, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var orderId = order;
    if (orderId.id != null) {
      orderId = orderId.id;
    }

    var shellDocket = { 'status': 'draft', 'authorName': accessControl.currentUser().name.full, 'author': accessControl.currentUser().id, 'organisation': organisation.id };
    shellDocket.date = (0, _momentTimezone2.default)().toISOString();
    // setup supplier contact from org group details
    var supplierContact = {};
    supplierContact.displayName = organisationGroup.publicName;
    supplierContact.contactAddresses = {};
    supplierContact.addresses = [];
    if (organisationGroup.address != null) {
      supplierContact.addresses.push(organisationGroup.address);
    }
    if (organisationGroup.emailAddress != null) {
      supplierContact.contactAddresses[organisationGroup.emailAddress] = [];
    }
    shellDocket.supplierContact = supplierContact;

    getOrder(orderId, function (orderFull) {
      shellDocket.template = orderFull.template;
      shellDocket.orderRef = orderId;
      if (orderFull.customerContact != null) {
        shellDocket.customerContact = orderFull.customerContact;
        /*var addressKeys = Object.keys(shellDocket.customerContact.contactAddresses);
        for ( var i = 0; i < addressKeys.length; i++ ) {
          if ( shellDocket.customerContact.contactAddresses[addressKeys[i]] == null || shellDocket.customerContact.contactAddresses[addressKeys[i]].length == 0 ) {
            shellDocket.customerContact.contactAddresses[addressKeys[i]] = ['approver'];
          }
        }*/
      }
      if (orderFull.supplierContact != null) {
        shellDocket.supplierContact = orderFull.supplierContact;
      }
      if (orderFull.supplierRefNo != null) {
        shellDocket.supplierRefNo = orderFull.supplierRefNo;
      }
      if (orderFull.customerRefNo != null) {
        shellDocket.customerRefNo = orderFull.customerRefNo;
      }

      // copy resources from order onto docket
      var copyItemsFromOrder = true;
      if (orderFull.lineItems && copyItemsFromOrder) {
        shellDocket.resources = [];
        for (var i = 0; i < orderFull.lineItems.length; i++) {
          var lineItem = orderFull.lineItems[i];
          var newResource = {};
          if (lineItem.resource) {
            newResource.resource = lineItem.resource;
            newResource.orderItemId = lineItem.id;
            newResource.name = lineItem.resource.name;
            newResource.description = lineItem.itemDescription;
            newResource.uniqueIdentifier = lineItem.supplierRef;
            shellDocket.resources.push(newResource);
          }
        }
      }

      baseDockets.post(shellDocket).then(successCb, failureCb);
    }, function (err) {
      failureCb('Could not get full order details to create docket from.');
    });
  };

  /**** Update Order Access Control *****/
  this.updateAccessControl = function (order, accessControlPayload, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseOrders = Restangular.all('orders');
    if (organisation != null && organisationGroup != null) {
      baseOrders = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('orders');
    }

    var orderId = order;
    if (orderId.id != null) {
      orderId = orderId.id;
    }

    var accessControlFull = { 'accessControl': accessControlPayload };
    baseOrders.one(orderId).customPUT(accessControlFull).then(successCb, failureCb);
  };

  /****** Get Order Diff ******/
  this.getOrderDiff = function (original, modified, cb) {
    if (modified.id == null) {
      cb(modified, 0);
      return;
    }

    // check start/end date fields
    var diff = {};
    var diffCount = 0;
    if (!original.startDate && modified.startDate) {
      diff.startDate = modified.startDate;
      diffCount += 1;
    }
    if (original.startDate && modified.startDate && original.startDate.getTime() != modified.startDate.getTime()) {
      diff.startDate = modified.startDate;
      diffCount += 1;
    }
    if (!original.endDate && modified.endDate) {
      diff.endDate = modified.endDate;
      diffCount += 1;
    }
    if (original.endDate && modified.endDate && original.endDate.getTime() != modified.endDate.getTime()) {
      diff.endDate = modified.endDate;
      diffCount += 1;
    }
    // check docket template field
    if (!original.template && modified.template) {
      diff.template = modified.template;
      diffCount += 1;
    }
    if (original.template && modified.template && original.template.id != modified.template.id) {
      diff.template = modified.template;
      diffCount += 1;
    }
    // check docket prefill fields
    if (!original.docketPrefillValueStore && modified.docketPrefillValueStore) {
      diff.docketPrefillValueStore = modified.docketPrefillValueStore;
      diffCount += 1;
    }
    if (original.docketPrefillValueStore && modified.docketPrefillValueStore) {
      if (Object.keys(original.docketPrefillValueStore).length != Object.keys(modified.docketPrefillValueStore)) {
        diff.docketPrefillValueStore = modified.docketPrefillValueStore;
        diffCount += 1;
      } else {
        var valueStoreKeys = Object.keys(modified.docketPrefillValueStore);
        for (var i = 0; i < valueStoreKeys.length; i++) {
          if (modified.docketPrefillValueStore[valueStoreKeys[i]] != original.docketPrefillValueStore[valueStoreKeys[i]]) {
            diff.docketPrefillValueStore = modified.docketPrefillValueStore;
            diffCount += 1;
            break;
          }
        }
      }
    }
    // check if the ordernumber has been changed
    if (modified.orderNumber != original.orderNumber) {
      diff.orderNumber = modified.orderNumber;
      diffCount += 1;
    }
    // check supplier contact
    if (!original.supplierContact && modified.supplierContact) {
      diff.supplierContact = modified.supplierContact;
      diffCount += 1;
    }
    if (original.supplierContact && modified.supplierContact && original.supplierContact.id != modified.supplierContact.id) {
      diff.supplierContact = modified.supplierContact;
      diffCount += 1;
    }
    // check customer contact
    if (!original.customerContact && modified.customerContact) {
      diff.customerContact = modified.customerContact;
      diffCount += 1;
    }
    if (original.customerContact && modified.customerContact && original.customerContact.id != modified.customerContact.id) {
      diff.customerContact = modified.customerContact;
      diffCount += 1;
    }
    // check customer contact has been edited
    if (original.customerContact && modified.customerContact) {
      var originalContactAddresses = original.customerContact.contactAddresses;
      var modifiedContactAddresses = modified.customerContact.contactAddresses;
      var originalKeys = Object.keys(originalContactAddresses);
      var modifiedKeys = Object.keys(modifiedContactAddresses);
      var thisDiffed = false;
      if (originalKeys.length != modifiedKeys.length) {
        thisDiffed = true;
      } else {
        for (var i = 0; i < modifiedKeys.length; i++) {
          if (originalKeys.indexOf(modifiedKeys[i]) < 0) {
            thisDiffed = true;
            break;
          }
          if (JSON.stringify(modifiedContactAddresses[modifiedKeys[i]]) != JSON.stringify(originalContactAddresses[modifiedKeys[i]])) {
            thisDiffed = true;
            break;
          }
        }
      }

      if (thisDiffed) {
        diff.customerContact = modified.customerContact;
        diffCount += 1;
      }
    }

    // check line items
    if (!original.lineItems && modified.lineItems) {
      diff.lineItems = modified.lineItems;
      diffCount += 1;
    }
    if (original.lineItems && modified.lineItems) {
      var linesChanged = false;
      if (original.lineItems.length != modified.lineItems.length) {
        linesChanged = true;
      } else {
        for (var i = 0; i < modified.lineItems.length; i++) {
          if (modified.lineItems[i].quantityEdit) {
            var quantityEdit = parseFloat(modified.lineItems[i].quantityEdit);
            if (quantityEdit) {
              modified.lineItems[i].quantity = quantityEdit;
            }
          }
          if (modified.lineItems[i].delete == true) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].id != original.lineItems[i].id) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].itemDescription != original.lineItems[i].itemDescription) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].resource && !original.lineItems[i].resource || !modified.lineItems[i].resource && original.lineItems[i].resource) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].resource && original.lineItems[i].resource && modified.lineItems[i].resource.id != original.lineItems[i].resource.id) {
            linesChanged = true;
            break;
          }
          if (!original.lineItems[i].quantity && modified.lineItems[i].quantity) {
            linesChanged = true;
            break;
          }
          if (modified.lineItems[i].quantity && original.lineItems[i].quantity && modified.lineItems[i].quantity != original.lineItems[i].quantity) {
            linesChanged = true;
            break;
          }
          if (!original.lineItems[i].customerRef && modified.lineItems[i].customerRef) {
            linesChanged = true;
            break;
          }
          if (original.lineItems[i].customerRef && modified.lineItems[i].customerRef && original.lineItems[i].customerRef != modified.lineItems[i].customerRef) {
            linesChanged = true;
            break;
          }
          if (!original.lineItems[i].supplierRef && modified.lineItems[i].supplierRef) {
            linesChanged = true;
            break;
          }
          if (original.lineItems[i].supplierRef && modified.lineItems[i].supplierRef && original.lineItems[i].supplierRef != modified.lineItems[i].supplierRef) {
            linesChanged = true;
            break;
          }
          if (!original.lineItems[i].rate && modified.lineItems[i].rate) {
            linesChanged = true;
            break;
          }
          if (original.lineItems[i].rate && modified.lineItems[i].rate && original.lineItems[i].rate != modified.lineItems[i].rate) {
            linesChanged = true;
            break;
          }
        }
      }
      if (linesChanged) {
        diff.lineItems = modified.lineItems;
        diffCount += 1;
      }
    }
    // check customer and supplier reference numbers
    if (!original.customerRefNo && modified.customerRefNo) {
      diff.customerRefNo = modified.customerRefNo;
      diffCount += 1;
    }
    if (original.customerRefNo && modified.customerRefNo && original.customerRefNo != modified.customerRefNo) {
      diff.customerRefNo = modified.customerRefNo;
      diffCount += 1;
    }
    if (!original.supplierRefNo && modified.supplierRefNo) {
      diff.supplierRefNo = modified.supplierRefNo;
      diffCount += 1;
    }
    if (original.supplierRefNo && modified.supplierRefNo && original.supplierRefNo != modified.supplierRefNo) {
      diff.supplierRefNo = modified.supplierRefNo;
      diffCount += 1;
    }
    // check notes field
    if (!original.notes && modified.notes) {
      diff.notes = modified.notes;
      diffCount += 1;
    }
    if (original.notes && modified.notes && original.notes != modified.notes) {
      diff.notes = modified.notes;
      diffCount += 1;
    }
    if (original.notes && !modified.notes) {
      diff.notes = "";
      diffCount += 1;
    }
    // check status
    if (original.status != modified.status) {
      diff.status = modified.status;
      diffCount += 1;
    }
    diff.id = modified.id;
    cb(diff, diffCount);
  };

  /** Validation Parameters **/
  // Lists the required fields for each action on the order and their respective type
  var validationParameters = {
    'sendOrderCustomer': { 'startDate': 'string', 'endDate': 'string', 'lineItems': 'array' },
    'sendOrderSupplier': { 'startDate': 'string', 'endDate': 'string', 'template': 'string', 'lineItems': 'array', 'customerContact': 'string' },
    'acceptOrderCustomer': {},
    'acceptOrderSupplier': { 'template': 'string' },
    'rejectOrder': {},
    'createJobFromOrder': { 'template': 'string' }
  };

  var niceFieldDisplays = {
    'startDate': 'Start Date',
    'endDate': 'End Date',
    'lineItems': 'Items',
    'template': 'Docket Template',
    'customerContact': 'Customer Contact'
  };

  var checkRequiredParameters = function checkRequiredParameters(order, parameters, successCb, failureCb) {
    var exceptions = [];
    var paramsKeys = Object.keys(parameters);
    for (var i = 0; i < paramsKeys.length; i++) {
      var thisParam = paramsKeys[i];
      if (parameters[thisParam] == 'string' && (order[thisParam] == null || order[thisParam] == "")) {
        if (niceFieldDisplays[thisParam] != null) {
          exceptions.push(niceFieldDisplays[thisParam]);
        } else {
          exceptions.push(thisParam);
        }
      } else if (parameters[thisParam] == 'array' && (order[thisParam] == null || order[thisParam].length <= 0)) {
        if (niceFieldDisplays[thisParam] != null) {
          exceptions.push(niceFieldDisplays[thisParam]);
        } else {
          exceptions.push(thisParam);
        }
      }
    }

    if (exceptions.length > 0) {
      failureCb(exceptions);
    } else {
      successCb();
    }
  };

  /* Send Order Validation Helper */
  this.validateSendOrder = function (order, successCb, failureCb) {
    // check if customer or supplier sending the order
    var validateParams = [];
    if (userService.userCanDoAction('isOrderSupplier', order)) {
      validateParams = validationParameters['sendOrderSupplier'];
    } else {
      validateParams = validationParameters['sendOrderCustomer'];
    }

    checkRequiredParameters(order, validateParams, successCb, failureCb);
  };

  /* Accept Order Validation Helper */
  this.validateAcceptOrder = function (order, successCb, failureCb) {
    // check if customer or supplier accepting the order
    var validateParams = [];
    if (userService.userCanDoAction('isOrderSupplier', order)) {
      validateParams = validationParameters['acceptOrderSupplier'];
    } else {
      validateParams = validationParameters['acceptOrderCustomer'];
    }

    checkRequiredParameters(order, validateParams, successCb, failureCb);
  };

  /* Create Job From Order Validation Helper */
  this.validateCreateJob = function (order, successCb, failureCb) {
    // check if customer or supplier accepting the order
    var validateParams = validationParameters['createJobFromOrder'];
    checkRequiredParameters(order, validateParams, successCb, failureCb);
  };
}]);

/***/ }),

/***/ "fc0h":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "timesheets-paywall-illustration.svg";

/***/ }),

/***/ "ffP+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3Fp":
/***/ (function(module, exports) {

var path = 'views/modals/selectContactTagModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectContactTagModal\">\n    <div class=\"modalContainer\">\n      <div class=\"header hidden-xs\">\n        <h1>Select Contact Tags</h1>\n        <div class=\"headerCloseButton\" ng-click=\"closeContactTagSelectList()\">\n          <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div class=\"content noPadding\">\n        <div class=\"noListMessage\" ng-show=\"contactTagList.length === 0\">\n          There are no contact tags available\n        </div>\n        <md-table-container ng-show=\"contactTagList.length > 0\">\n          <table md-table multiple md-row-select ng-model=\"contactTagsSelected\">\n            <thead md-head>\n              <tr md-row>\n                <th md-column>Tag</th>\n                <th md-column>Description</th>\n              </tr>\n            </thead>\n            <tbody md-body>\n              <tr md-row ng-repeat=\"tag in contactTagList\" md-select=\"tag\" md-auto-select md-select-id=\"tag\" style=\"cursor: pointer;\">\n                <td md-cell>\n                  {{tag.tag}}\n                </td>\n                <td md-cell>\n                  {{tag.description}}\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </md-table-container>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n            <span ng-show=\"contactTagsSelected.length > 1\">\n              {{contactTagsSelected.length}} tags will be added.\n            </span>\n            <span ng-show=\"contactTagsSelected.length == 1\">\n              1 tag will be added.\n            </span>\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeContactTagSelectList()\">\n              Cancel\n            </div>\n            <div class=\"dbButton\" ng-click=\"closeContactTagSelectListDone()\" ng-disabled=\"contactTagsSelected.length === 0\">\n              Done\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "gANg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('filingMobileDetailController', ['docketService', 'userService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$q', function (docketService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.viewState = 'docket';

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  $scope.splitListFunc = new splitListInterface($scope, $stateParams);

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  $scope.openMenu = function ($mdOpenMenu, ev) {
    //originatorEv = ev;
    $mdOpenMenu(ev);
  };

  /*************************************/
  /***** Docket Filing Detail View *****/
  /*************************************/

  $scope.openDocketForFiling = function (docketId) {
    $scope.viewState = 'filing';
    docketService.getDocket(docketId, false, function (fullDocket) {
      var docketsList = [];
      docketsList.push(fullDocket);
      $scope.openBulkDocketsForFiling(docketsList);
    }, function (err) {
      $scope.alertService.presentAutoAlert('openDocketFiling', err);
      $scope.closeDocketFiling();
    });
  };

  $scope.openBulkDocketsForFiling = function (docketsList) {
    $scope.viewState = 'filing';
    $scope.prepareForFilingFromParent();
    // Get full versions of all selected dockets
    $scope.populateDocketFiles(docketsList, function (docketsListPopulated) {
      $scope.loadBulkDocketsFromParent(docketsListPopulated);
    });
  };

  $scope.closeDocketFiling = function () {
    var stateBack = {};
    if ($stateParams.stateTrail && $stateParams.stateTrail.length > 0) {
      stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
    }
    var stateOptions = {};
    if (stateBack.orderId) {
      stateOptions.orderId = stateBack.orderId;
    }
    if (stateBack.jobId) {
      stateOptions.jobId = stateBack.jobId;
    }
    if (stateBack.docketId) {
      stateOptions.docketId = stateBack.docketId;
    }
    if (stateBack.fromTab) {
      stateOptions.openTab = stateBack.fromTab;
    }
    if (stateBack.orgId) {
      stateOptions.orgId = stateBack.orgId;
    }
    if (stateBack.groupId) {
      stateOptions.groupId = stateBack.groupId;
    }
    if (stateBack.name) {
      $state.go(stateBack.name, stateOptions);
    } else {
      $state.go('main.groupFiling', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }
  };

  $scope.saveDocketFiling = function (docketFiling) {
    docketFiling.loading = true;
    docketService.saveDocketFiling(docketFiling, function (success) {
      $scope.closeDocketFiling();
    }, function (err) {
      docketFiling.loading = false;
      $scope.alertService.presentAutoAlert('saveDocketFiling', err);
    });
  };

  /**************************/
  /***** Modal Controls *****/
  /**************************/

  /*******************************/
  /***** Docket Data Helpers *****/
  /*******************************/

  $scope.populateDocketFiles = function (docketList, cb) {
    var index = 0;
    $scope.populateDocketListWithFiles(docketList, index, function () {
      cb(docketList);
    });
  };

  $scope.populateDocketListWithFiles = function (docketList, index, cb) {
    if (index >= docketList.length) {
      cb();
      return;
    }

    // populate this index of the docketList
    $scope.populateDocketFileData(docketList[index], function () {
      // go to next index
      $scope.populateDocketListWithFiles(docketList, index + 1, cb);
    });
  };

  $scope.populateDocketFileData = function (docket, cb) {
    docketService.getDocketFileData(docket, function (docketFile) {
      docket.existingDocketFile = docketFile;
      cb();
    }, function (err) {
      docket.existingDocketFile = null;
      cb();
    });
  };

  /******************************/
  /***** List View Controls *****/
  /******************************/

  $scope.selectActivityForDocketFile = function (sourceList, cb) {
    $scope.viewState = 'activity';
    $scope.selectActivityCallback = cb;
    $scope.activitySelectFromParent(sourceList, function (activitySelected) {
      $scope.selectActivityCallback(activitySelected);
      $scope.viewState = 'filing';
    });
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /*********************************/
  /***** MAIN OPENING CONTROLS *****/
  /*********************************/

  $scope.filingDetailControllerReady = function () {
    if ($stateParams.docketId != null) {
      $scope.prepareForFilingFromParent();
      $scope.openDocketForFiling($stateParams.docketId);
    }
  };
}]);

/***/ }),

/***/ "gTYR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_signature.svg";

/***/ }),

/***/ "h627":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "22.png";

/***/ }),

/***/ "h7J8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('filingListController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', function ($rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.listCount = 0;
  $scope.docketsLoading = false;

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  /***********************/
  /***** Permissions *****/
  /***********************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /*******************************/
  /***** Major State Changes *****/
  /*******************************/

  $scope.$parent.prepareForFilingListFromParent = function () {
    $scope.listItems = [];
    $scope.docketsLoading = true;
  };

  $scope.$parent.loadDocketFilingListFromParent = function (docketsList, docketCount) {
    $scope.listItems = docketsList;
    $scope.listCount = docketCount;
    $scope.docketsLoading = false;
  };

  $scope.$parent.loadAdditionalDocketFilingFromParent = function (dockets) {
    for (var i = 0; i < dockets.length; i++) {
      $scope.listItems.push(dockets[i]);
    }
  };

  /**************************************************/
  /***** Alert parent controller of ready state *****/
  /**************************************************/

  $scope.$parent.filingsChildControllerReady();
}]);

/***/ }),

/***/ "hCJl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "description.svg";

/***/ }),

/***/ "hEss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "haha":
/***/ (function(module, exports) {

var path = 'views/modals/docketBatch.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"docketBatchModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Create Xero Invoice</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeDocketBatchModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"newDocketBatchForm\" novalidate>\n        <div ng-if=\"newDocketBatch.stage == 'checkConnection'\">\n          <div my-loader text=\"Checking Connection to Xero\"></div>\n          Checking xero connection\n          <br/><br/><br/><br/><br/>\n        </div>\n        <div ng-if=\"newDocketBatch.stage == 'listGeneratedError'\">\n          <div class=\"modalFormTable padding\">\n            <h2>The selected dockets contain more than one customer contact</h2>\n            <h4 class=\"sub\">You must select dockets that all have the same customer contact before creating an invoice.</h4>\n          </div>\n        </div>\n        <div ng-if=\"newDocketBatch.stage == 'preconfigure'\">\n          <div class=\"modalFormTable padding\">\n            <h2>Setup your invoice</h2>\n            <h4 class=\"sub\">Configure your new Xero Invoice</h4>\n            <div layout-gt-sm=\"row\" class=\"filterRow\">\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup\">\n                  <h1>Reference Number*</h1>\n                  <md-input-container class=\"md-block\">\n                    <input type=\"text\" ng-model=\"newDocketBatch.localIdentifier\" aria-label=\"Batch Identifier\" required=\"true\">\n                  </md-input-container>\n                </div>\n              </div>\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup dates\">\n                  <h1 style=\"display:block;\">Invoice Date</h1>\n                  <md-input-container class=\"filterDatepicker\">\n                    <md-datepicker ng-model=\"newDocketBatch.date\" aria-label=\"Invoice Date\" required></md-datepicker>\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n            <div layout-gt-sm=\"row\" class=\"filterRow\" style=\"margin-top:50px;\">\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup dates\">\n                  <h1 style=\"display:block;\">Attach PDF Dockets to Xero Invoice</h1>\n                  <md-checkbox ng-checked=\"newDocketBatch.attachPDFDockets\" ng-click=\"newDocketBatch.attachPDFDockets = !newDocketBatch.attachPDFDockets\">\n                    Yes\n                  </md-checkbox>\n                </div>\n              </div>\n            </div>\n            <h4 class=\"sub\">How should Docket line items be represented on the Invoice?</h4>\n            <md-radio-group ng-model=\"newDocketBatch.invoiceType\">\n              <div class=\"signatureSelectionOuter\">\n                <div class=\"left\">\n                  <md-radio-button value=\"aggregate\" class=\"md-primary\"><h4 class=\"normal\">Aggregated</h4><p>Aggregate dockets by item.</p></md-radio-button>\n                </div>\n                <div class=\"right\">\n                  <md-radio-button value=\"lines\" class=\"md-primary\"><h4 class=\"normal\">Individual</h4><p>Display individual docket lines.</p></md-radio-button>\n                </div>\n              </div>\n            </md-radio-group>\n          </div>\n        </div>\n        <div ng-if=\"newDocketBatch.stage == 'identifier'\">\n          <div class=\"modalFormTable padding\">\n            <h2>How do you want to identify the batch for this invoice?</h2>\n            <h4 class=\"sub\">The reference identifier will be attached to the xero invoice. It must be unique.</h4>\n            <div layout-gt-sm=\"row\" class=\"filterRow\">\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup\">\n                  <h1>Your Reference*</h1>\n                  <md-input-container class=\"md-block\">\n                    <input type=\"text\" ng-model=\"newDocketBatch.localIdentifier\" aria-label=\"Batch Identifier\" required=\"true\">\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"newDocketBatch.stage == 'filter'\">\n          <div my-loader text=\"Preparing Invoice\" ng-if=\"newDocketBatch.loading\"></div>\n          <div class=\"modalFormTable padding\">\n            <h2 class=\"topMargin\">Which dockets will be included in the batch?</h2>\n            <h4 class=\"sub\">These filters will be used to select the dockets attached to the invoice</h4>\n            <div layout-gt-sm=\"row\" class=\"filterRow\">\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup\">\n                  <h1>Customer</h1>\n                  <md-button class=\"md-icon-button selector\" ng-click=\"selectModalContactFilter(newDocketBatch,'customerContact', 'docketBatchModal')\">\n                    <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                  </md-button>\n                  <md-button class=\"md-icon-button selector\" ng-click=\"newDocketBatch.customerContact = null\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                  </md-button>\n                  <md-input-container class=\"md-block\">\n                    <input type=\"text\" ng-model=\"newDocketBatch.customerContact.displayName\" ng-disabled=\"true\" aria-label=\"Customer Contact\">\n                  </md-input-container>\n                </div>\n              </div>\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup\">\n                  <h1>Order</h1>\n                  <md-button class=\"md-icon-button selector\" ng-click=\"selectModalOrderFilter(newDocketBatch, 'docketBatchModal')\">\n                    <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                  </md-button>\n                  <md-button class=\"md-icon-button selector\" ng-click=\"newDocketBatch.order = null\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                  </md-button>\n                  <md-input-container class=\"md-block\">\n                    <input type=\"text\" ng-model=\"newDocketBatch.order.orderNumber\" ng-disabled=\"true\" aria-label=\"Order\">\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n            <div ng-if=\"newDocketBatch.customerContact == null && newDocketBatch.order == null\" layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n              <span style=\"color: #EF3B4A\">Either Customer or Order must be selected</span>\n            </div>\n\n            <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup dates\">\n                  <h1 style=\"display:block;\">Date From</h1>\n                  <div class=\"md-block\">\n                    <md-input-container class=\"filterDatepicker\">\n                      <md-datepicker ng-model=\"newDocketBatch.startDate\" aria-label=\"From Date Filter\" required></md-datepicker>\n                    </md-input-container>\n                  </div>\n                </div>\n              </div>\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup dates\">\n                  <h1 style=\"display:block;\">Date To</h1>\n                  <md-input-container class=\"filterDatepicker\">\n                    <md-datepicker ng-model=\"newDocketBatch.endDate\" aria-label=\"To Date Filter\" required></md-datepicker>\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n\n            <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n              <div class=\"filterGroup dates\">\n                <h1>Status</h1>\n                <div class=\"md-block\">\n                  <md-checkbox ng-checked=\"statusSelected(newDocketBatch.status, 'draft')\" ng-click=\"toggleStatus(newDocketBatch.status, 'draft')\">\n                    Draft\n                  </md-checkbox>\n                  <md-checkbox ng-checked=\"statusSelected(newDocketBatch.status, 'sent')\" ng-click=\"toggleStatus(newDocketBatch.status, 'sent')\">\n                    Sent\n                  </md-checkbox>\n                  <md-checkbox ng-checked=\"statusSelected(newDocketBatch.status, 'accepted')\" ng-click=\"toggleStatus(newDocketBatch.status, 'accepted')\">\n                    Accepted\n                  </md-checkbox>\n                  <md-checkbox ng-checked=\"statusSelected(newDocketBatch.status, 'rejected')\" ng-click=\"toggleStatus(newDocketBatch.status, 'rejected')\">\n                    Rejected\n                  </md-checkbox>\n                </div>\n              </div>\n            </div>\n\n            <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup dates\">\n                  <h1 style=\"display:block;\">Only Uninvoiced Dockets</h1>\n                  <div class=\"md-block\">\n                    <md-checkbox ng-checked=\"newDocketBatch.uninvoicedDockets\" ng-click=\"newDocketBatch.uninvoicedDockets = !newDocketBatch.uninvoicedDockets\">\n                      Yes\n                    </md-checkbox>\n                  </div>\n                </div>\n              </div>\n              <div flex-gt-sm=\"50\">\n                <div class=\"filterGroup dates\">\n                  <h1 style=\"display:block;\">Attach PDF Dockets to Xero Invoice</h1>\n                  <md-checkbox ng-checked=\"newDocketBatch.attachPDFDockets\" ng-click=\"newDocketBatch.attachPDFDockets = !newDocketBatch.attachPDFDockets\">\n                    Yes\n                  </md-checkbox>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"newDocketBatch.stage == 'itemSummary'\">\n          <div my-loader text=\"Preparing Invoice\" ng-if=\"newDocketBatch.loading\"></div>\n          <div class=\"modalFormTable padding\">\n            <h2>Which items should be added to the invoice?</h2>\n            <h4 class=\"sub noBottomMargin\">Select which items will be included with the invoice</h4>\n          </div>\n          \n          <div ng-show=\"newDocketBatch.batchFull.aggregations.length == 0\" class=\"modalFormTable padding\">\n            No items to add.\n          </div>\n          \n          <div class=\"modalFormTable\" ng-show=\"newDocketBatch.batchFull.aggregations.length > 0\">\n            <md-table-container>\n              <table md-table>\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column>Export</th>\n                    <th md-column>Resource</th>\n                    <th md-column>Line Type</th>\n                    <th md-column>Quantity</th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"aggregate in newDocketBatch.batchFull.aggregations\">\n                    <td md-cell>\n                      <md-input-container>\n                        <md-checkbox ng-model=\"aggregate.export\"></md-checkbox>\n                      </md-input-container>\n                    </td>\n                    <td md-cell>{{aggregate.resource.name}}</td>\n                    <td md-cell>{{aggregate.interactionName}}</td>\n                    <td md-cell>{{aggregate.quantity}} {{aggregate.resource.uom.abbreviation}}</td>\n                  </tr>\n                </tbody>\n              </table>\n            </md-table-container>\n          </div>\n        </div>\n        <div ng-if=\"newDocketBatch.stage == 'invoiceDetails'\">\n          <div my-loader text=\"Generating Invoice\" ng-if=\"newDocketBatch.loading\"></div>\n          <div class=\"modalFormTable padding\">\n            <div ng-if=\"newDocketBatch.requiresXeroContactSync\">\n              <h2>Who is the invoice for?</h2>\n              <h4 class=\"sub\">Select the Xero Contact for this customer</h4>\n\n              <md-input-container class=\"roundedFullWidthSelect\">\n                <label>Xero Contact</label>\n                <md-select ng-model=\"newDocketBatch.selectedXeroContact\"\n                           md-on-close=\"clearDocketBatchXeroSearchTerm()\"\n                           data-md-container-class=\"selectdemoSelectHeader\">\n                  <md-optgroup label=\"xero contact\">\n                    <md-option ng-value=\"contact\" ng-repeat=\"contact in xeroContacts\">{{contact.name}}<span ng-if=\"contact.emailAddresses.length > 0\"> - {{contact.emailAddresses[0]}}</span></md-option>\n                  </md-optgroup>\n                </md-select>\n              </md-input-container>\n              <br/><br/>\n            </div>\n\n            <h2 class=\"topMargin\">How should the items be exported?</h2>\n            <h4 class=\"sub\">Dockets can be aggregated by item or displayed as individual lines</h4>\n\n            <md-radio-group ng-model=\"newDocketBatch.invoiceType\">\n              <div class=\"signatureSelectionOuter\">\n                <div class=\"left\">\n                  <md-radio-button value=\"aggregate\" class=\"md-primary\"><h4 class=\"normal\">Aggregated</h4><p>Aggregate dockets by item.</p></md-radio-button>\n                </div>\n                <div class=\"right\">\n                  <md-radio-button value=\"lines\" class=\"md-primary\"><h4 class=\"normal\">Individual</h4><p>Display individual docket lines.</p></md-radio-button>\n                </div>\n              </div>\n            </md-radio-group>\n          </div>\n        </div>\n        <div ng-if=\"newDocketBatch.stage == 'creatingInvoice'\">\n          <div my-loader text=\"Generating Invoice\" ng-if=\"newDocketBatch.loading\"></div>\n\n          <div class=\"modalFormTable padding\">\n            <div ng-if=\"!newDocketBatch.requiresXeroContactSync\" style=\"text-align:center;\">\n              <h2 style=\"text-align:center;margin-top: 120px;\">Creating Xero Invoice</h2>\n              <h4 style=\"margin-bottom: 120px;\">Please wait while your xero invoice is created</h4>\n            </div>\n            <div ng-if=\"newDocketBatch.requiresXeroContactSync\">\n              <h2>Who is the invoice for?</h2>\n              <h4 class=\"sub\">Select the Xero Contact for this customer</h4>\n\n              <md-input-container class=\"roundedFullWidthSelect\">\n                <label>Xero Contact</label>\n                <md-select ng-model=\"newDocketBatch.selectedXeroContact\"\n                           md-on-close=\"clearDocketBatchXeroSearchTerm()\"\n                           data-md-container-class=\"selectdemoSelectHeader\">\n                  <md-optgroup label=\"xero contact\">\n                    <md-option ng-value=\"contact\" ng-repeat=\"contact in xeroContacts\">{{contact.name}}<span ng-if=\"contact.emailAddresses.length > 0\"> - {{contact.emailAddresses[0]}}</span></md-option>\n                  </md-optgroup>\n                </md-select>\n              </md-input-container>\n              <br/><br/>\n            </div>\n          </div>\n        </div>\n        <div class=\"modalFormTable padding\" ng-if=\"newDocketBatch.stage == 'error'\">\n          <div class=\"billingSuccessOuter error\">\n            <div class=\"line1\"></div>\n            <div class=\"line2\"></div>\n          </div>\n          <div class=\"billingSuccessMessage\">\n            <span ng-if=\"newDocketBatch.errorType == 'exists'\">\n              A batch with the same reference number already exists. Please try again.\n            </span>\n            <span ng-if=\"!newDocketBatch.errorType == 'exists'\">\n              Something went wrong when we tried to generate your docket batch. Please try again.\n            </span>\n            <span ng-if=\"newDocketBatch.errorType == 'complex'\">\n              Something went wrong when we tried to generate your docket batch. <a ng-click=\"newDocketBatch.displayComplexError = true\">Display Full Error</a>\n              <br/>\n              <span ng-if=\"newDocketBatch.displayComplexError\">{{newDocketBatch.complexErrorMessage}}</span>\n            </span>\n            <br/>\n            <div class=\"dbButton\" ng-click=\"newDocketBatch.stage = 'filter'\" ng-if=\"newDocketBatch.method != 'docketsSelected'\">Go Back</div>\n            <div class=\"dbButton\" ng-click=\"newDocketBatch.stage = 'preconfigure'\" ng-if=\"newDocketBatch.method == 'docketsSelected'\">Go Back</div>\n          </div>\n        </div>\n        <div class=\"modalFormTable padding\" ng-if=\"newDocketBatch.stage == 'success'\">\n          <div class=\"xeroConnectIcon success\"></div>\n          <div class=\"xeroAuthMessage bottomMargin\">\n            <h2>Xero Invoice {{newDocketBatch.batchFull.external.xero.invoiceNumber}} Created!</h2>\n            <a href=\"https://go.xero.com/organisationlogin/default.aspx?shortcode={{newDocketBatch.batchFull.external.xero.organisationShortCode}}&redirecturl=/AccountsReceivable/View.aspx?InvoiceID={{newDocketBatch.batchFull.external.xero.invoiceId}}\" target=\"_blank\">\n              Open Invoice {{newDocketBatch.batchFull.external.xero.invoiceNumber}}\n            </a>\n          </div>\n        </div>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white\" ng-click=\"closeDocketBatchModal()\" ng-if=\"newDocketBatch.stage == 'identifier'\">\n              Cancel\n            </div>\n            <button class=\"dbButton\" ng-click=\"newDocketBatch.localIdentifier == null || docketBatchIdentifierNext()\" ng-if=\"newDocketBatch.stage == 'identifier' || newDocketBatch.stage == 'preconfigure'\" ng-disabled=\"newDocketBatch.localIdentifier == null\">\n              Next\n            </button>\n            <div class=\"dbButton white\" ng-if=\"newDocketBatch.stage == 'filter'\" ng-click=\"newDocketBatch.stage = 'identifier'\">\n              Back\n            </div>\n            <button class=\"dbButton spinner\" ng-click=\"(newDocketBatchForm.$invalid || newDocketBatch.loading) || generateDocketBatch(newDocketBatch)\" ng-disabled=\"(newDocketBatch.customerContact == null && newDocketBatch.order == null) || newDocketBatch.loading\" ng-if=\"newDocketBatch.stage == 'filter'\">\n              <span ng-hide=\"newDocketBatch.loading\">Next</span>\n              <md-progress-circular ng-show=\"newDocketBatch.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </button>\n            <div class=\"dbButton white\" ng-if=\"newDocketBatch.stage == 'itemSummary' && newDocketBatch.method != 'docketsSelected'\" ng-click=\"newDocketBatch.stage = 'filter'\">\n              Back\n            </div>\n            <div class=\"dbButton white\" ng-if=\"newDocketBatch.stage == 'itemSummary' && newDocketBatch.method == 'docketsSelected'\" ng-click=\"newDocketBatch.stage = 'preconfigure'\">\n              Back\n            </div>\n            <button class=\"dbButton spinner\" ng-click=\"newDocketBatch.loading || updateBatchItems(newDocketBatch)\" ng-disabled=\"newDocketBatch.loading || newDocketBatch.batchFull.aggregations.length == 0\" ng-if=\"newDocketBatch.stage == 'itemSummary'\">\n              <span ng-hide=\"newDocketBatch.loading\">Next</span>\n              <md-progress-circular ng-show=\"newDocketBatch.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </button>\n            <div class=\"dbButton white\" ng-if=\"newDocketBatch.stage == 'invoiceDetails'\" ng-click=\"newDocketBatch.stage = 'itemSummary'\">\n              Back\n            </div>\n            <button class=\"dbButton spinner\" ng-click=\"newDocketBatch.loading || createBatchInvoice(newDocketBatch)\" ng-disabled=\"newDocketBatch.loading || newDocketBatch.invoiceType == null || (newDocketBatch.requiresXeroContactSync && newDocketBatch.selectedXeroContact == null)\" ng-if=\"newDocketBatch.stage == 'invoiceDetails'\">\n              <span ng-hide=\"newDocketBatch.loading\">Create Invoice</span>\n              <md-progress-circular ng-show=\"newDocketBatch.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </button>\n            <button class=\"dbButton spinner\" ng-click=\"newDocketBatch.loading || createBatchInvoice(newDocketBatch)\" ng-disabled=\"newDocketBatch.loading || newDocketBatch.invoiceType == null || (newDocketBatch.requiresXeroContactSync && newDocketBatch.selectedXeroContact == null)\" ng-if=\"newDocketBatch.stage == 'creatingInvoice'\">\n              <span ng-hide=\"newDocketBatch.loading\">Create Invoice</span>\n              <md-progress-circular ng-show=\"newDocketBatch.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </button>\n            <div class=\"dbButton\" ng-click=\"closeDocketBatchModal()\" ng-if=\"newDocketBatch.stage == 'success'\">\n              Done\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "hauN":
/***/ (function(module, exports) {

var path = 'views/pages/batches/batchDetail.html';
var html = "<div class=\"ojdDesktopDetailOuter\">\n  <form name=\"batchDetailForm\" class=\"docketDetailForm\">\n    <div class=\"ojdDesktopSection header white\">\n      <div class=\"headerTitle\">\n        <h1>{{docketBatch.localIdentifier}}</h1>\n      </div>\n\n      <div class=\"bulkActionsButtons\">\n        <md-menu>\n          <md-button aria-label=\"Open batch interactions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <!--<md-menu-item ng-click=\"generateXeroInvoice(docketBatch)\" ng-if=\"currentOrg.features.xero != null && currentOrg.features.xero.enabled == true\">\n              <md-button>\n                Create Xero Invoice\n              </md-button>\n            </md-menu-item>-->\n            <md-menu-item ng-click=\"deleteBatch(docketBatch)\">\n              <md-button>\n                Delete Batch\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n        <md-button class=\"md-icon-button\" aria-label=\"Close Docket Batch\" ng-click=\"closeBatchDesktop()\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"desktopLoaderUnder\" ng-if=\"docketBatch.loading || batchLoadingError\">\n      <div my-loader text=\"Loading Docket Batch\" ng-if=\"docketBatch.loading && docketBatch.loadingType == 'getting'\"></div>\n      <div my-loader text=\"Saving Docket Batch\" ng-if=\"docketBatch.loading && docketBatch.loadingType != 'getting'\"></div>\n      <div class=\"stdLoader\" ng-show=\"batchLoadingError != null\">\n        <div class=\"loaderOuterContainer\">\n          <div class=\"loaderInnerContainer\">\n            <div class=\"materialSpinner\">\n              <md-icon md-svg-src=\"error.svg\"></md-icon>\n            </div>\n            <div class=\"loadingText\">\n              {{batchLoadingError}}\n            </div>\n            <div class=\"loadingRetryButton\">\n              <!--<md-button class=\"md-primary\">Retry</md-button>-->\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <md-tabs md-selected=\"selectedIndex\" md-border-bottom md-autoselect class=\"docketTabsInner\">\n      <md-tab label=\"Batch\">\n        <div class=\"docketTab\">\n          <div class=\"ojdDesktopSection header {{docketBatch.status == 'draft' ? 'draft' : 'Completed'}}\">\n            <div class=\"headerTitle\" ng-if=\"docketBatch.status\">\n              <h2>Status</h2>\n              <h1>{{docketBatch.status == 'draft' ? 'Draft' : 'Invoiced'}}</h1>\n            </div>\n          </div>\n          <div class=\"ojdDesktopMainSections\">\n            <div class=\"ojdDesktopSection noPadding\">\n              <div class=\"ojdDesktopPaddingOuter\">\n                <div class=\"ojdDesktopRow\">\n                  <div class=\"ojdDesktopField\" ng-if=\"docketBatch.customerContact\">\n                    <label class=\"order\">Customer<span ng-if=\"docketBatch.customerContact.xeroLinked\"> (Xero Linked)</span></label>\n                    <h2 ng-if=\"docketBatch.customerContact\">{{docketBatch.customerContact.displayName}}</h2>\n                    <h3 ng-if=\"docketBatch.customerContact.addresses\">{{stringifyAddress(docketBatch.customerContact.addresses[0])}}</h3>\n                    <!--<h3 ng-if=\"!docketBatch.customerContact.xeroLinked\">\n                      <span ng-if=\"docketBatch.customerContact.xeroLinkLoading\"><a>Linking..Please wait</a></span>\n                      <span ng-if=\"!docketBatch.customerContact.xeroLinkLoading\">\n                        <a ng-click=\"linkXeroContact('customer')\">Link Xero Contact</a>\n                      </span>\n                    </h3>-->\n                  </div>\n                  <!--<div class=\"ojdDesktopField\" ng-if=\"docketBatch.supplierContact\">\n                    <label class=\"order\">Supplier<span ng-if=\"docketBatch.supplierContact.xeroLinked\"> (Xero Linked)</span></label>\n                    <h2 ng-if=\"docketBatch.supplierContact\">{{docketBatch.supplierContact.displayName}}</h2>\n                    <h3 ng-if=\"docketBatch.supplierContact.addresses\">{{stringifyAddress(docketBatch.supplierContact.addresses[0])}}</h3>\n                    <h3 ng-if=\"!docketBatch.supplierContact.xeroLinked\">\n                      <span ng-if=\"docketBatch.supplierContact.xeroLinkLoading\"><a>Linking..Please wait</a></span>\n                      <span ng-if=\"!docketBatch.supplierContact.xeroLinkLoading\">\n                        <a ng-click=\"linkXeroContact('supplier')\">Link Xero Contact</a>\n                      </span>\n                    </h3>\n                  </div>-->\n                </div>\n                <div class=\"ojdDesktopRow\" ng-if=\"docketBatch.external.xero && docketBatch.external.xero.invoiceId\">\n                  <a href=\"https://go.xero.com/organisationlogin/default.aspx?shortcode={{docketBatch.external.xero.organisationShortCode}}&redirecturl=/AccountsReceivable/View.aspx?InvoiceID={{docketBatch.external.xero.invoiceId}}\" target=\"_blank\">\n                    <div class=\"ojdDesktopField\">\n                      <label class=\"order\">Xero Invoice</label>\n                      <h2>{{docketBatch.external.xero.invoiceNumber}}</h2>\n                      <h3>Click to open in Xero</h3>\n                    </div>\n                  </a>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"ojdDesktopSection noPadding\">\n              <div class=\"sectionHeadingContainer\">\n                <div class=\"sectionHeadingLeft\">\n                  <h1 class=\"sectionHeading\">Item Summary</h1>\n                </div>\n                <div class=\"sectionHeadingRight\">\n\n                </div>\n              </div>\n\n              <md-table-container ng-show=\"docketBatch.aggregations.length > 0\">\n                <table md-table>\n                  <thead md-head>\n                    <tr md-row>\n                      <!--<th md-column>Export</th>-->\n                      <th md-column>Resource</th>\n                      <th md-column>Line Type</th>\n                      <th md-column>Quantity</th>\n                    </tr>\n                  </thead>\n                  <tbody md-body>\n                    <tr md-row ng-repeat=\"aggregate in docketBatch.aggregations\">\n                      <!--<td md-cell>\n                        <md-input-container>\n                          <md-checkbox ng-model=\"aggregate.export\"></md-checkbox>\n                        </md-input-container>\n                      </td>-->\n                      <td md-cell>{{aggregate.resource.name}}</td>\n                      <td md-cell>{{aggregate.interactionName}}</td>\n                      <td md-cell>{{aggregate.quantity}} {{aggregate.resource.uom.abbreviation}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </md-table-container>\n            </div>\n\n            <div class=\"ojdDesktopSection noPadding\">\n              <div class=\"sectionHeadingContainer\">\n                <div class=\"sectionHeadingLeft\">\n                  <h1 class=\"sectionHeading\">Dockets In This Batch</h1>\n                </div>\n                <div class=\"sectionHeadingRight\">\n\n                </div>\n              </div>\n\n              <md-table-container class=\"docketChecklistTable\" ng-show=\"docketBatch.docketsList && docketBatch.docketsList.length > 0\">\n                <table md-table multiple>\n                  <thead md-head>\n                    <tr md-row>\n                      <th md-column width=\"120px\">Status</th>\n                      <th md-column>Docket Number</th>\n                      <th md-column></th>\n                    </tr>\n                  </thead>\n                  <tbody md-body ng-repeat=\"docket in docketBatch.docketsList\">\n                    <tr md-row>\n                      <td md-cell>\n                        <div class=\"statusDisplay {{docket.status}}\">{{docket.status}}</div>\n                      </td>\n                      <td md-cell>\n                        {{docket.docketNumber}}\n                      </td>\n                      <td md-cell>\n\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </md-table-container>\n            </div>\n          </div>\n        </div>\n      </md-tab>\n      <md-tab label=\"Audit Log\">\n        <div class=\"docketTab\">\n          <div class=\"ojdDesktopSection noPadding noBottomPadding\" style=\"position: relative;\">\n            <md-table-container>\n              <table md-table>\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column>Date</th>\n                    <th md-column>Description</th>\n                    <th md-column>User</th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"event in docketBatch.eventLog\">\n                    <td md-cell>\n                      <span ng-if=\"event.addedOn\">{{moment(event.addedOn).tz(currentOrgGroup.timezone).format(\"DD/MM/YYYY hh:mm:ss a\")}}</span>\n                    </td>\n                    <td md-cell>\n                      {{event.description}}\n                    </td>\n                    <td md-cell>\n                      {{event.userName}}\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </md-table-container>\n          </div>\n        </div>\n      </md-tab>\n    </md-tabs>\n  </form>\n</div>\n\n<ng-include src=\"'views/modals/xeroInvoice.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "hkz0":
/***/ (function(module, exports) {

var path = 'views/pages/user/account.html';
var html = "<div class=\"mobileContainer noTopMargin\">\n\t<div class=\"mobileDetailHeader fixed\">\n\t\t<div class=\"mobileDetailHeaderInner\">\n\t\t\t<div class=\"mobileHeaderUpper\">\n\t\t\t\t<div class=\"left\">\n\t\t\t\t\t<div class=\"burgerMenu\" ng-click=\"openScopeDropdown()\">\n\t\t\t\t\t\t<div class=\"line1\"></div>\n\t\t\t\t\t\t<div class=\"line2\"></div>\n\t\t\t\t\t\t<div class=\"line3\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"middle\">\n\n\t\t\t\t</div>\n\t\t\t\t<div class=\"right\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"mobileHeaderLower\">\n\t\t\t\t<div class=\"left\">\n\t\t\t\t\tMy Account\n\t\t\t\t</div>\n\t\t\t\t<div class=\"right\">\n\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"adminSettingsGroup mobile\">\n\t\t<label>Name</label>\n\t\t<form name=\"signupForm\" ng-submit=\"updateAccount(signupForm.$valid)\" novalidate>\n\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t<label>First Name</label>\n\t\t\t\t<input type=\"text\" required name=\"firstName\" ng-model=\"currentUser.name.first\">\n      </md-input-container>\n\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t<label>Last Name</label>\n\t\t\t\t\t<input type=\"text\" required name=\"lastName\" ng-model=\"currentUser.name.last\">\n      </md-input-container>\n\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\tng-disabled=\"signupForm.$invalid || currentUser.loading\">\n\t\t\t\t\t\tUpdate\n\t\t\t\t\t</md-button>\n\t\t</form>\n\n\t\t<label class=\"margin-top\">Password</label>\n\t\t<form name=\"passwordForm\" ng-submit=\"changePassword(passwordForm.$valid)\" novalidate>\n\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t<label>Password</label>\n\t\t\t\t<input type=\"password\" required ng-model=\"pass.password\">\n      </md-input-container>\n\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t<label>Confirm Password</label>\n\t\t\t\t\t<input type=\"password\" required ng-model=\"pass.confirmPassword\">\n      </md-input-container>\n\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"passwordForm.$invalid\">Update\n\t\t\t\t\t</md-button>\n\t\t</form>\n\t</div>\n\n\t<div class=\"adminSettingsGroup\">\n\t\t<h3>Notification Settings</h3>\n\n\t\t<label>Email Address</label>\n\t\t<div ng-show=\"currentUser.hasEmailAddress\">{{currentUser.realEmailAddress}}</div>\n\t\t<div ng-show=\"!currentUser.hasEmailAddress\">\n\t\t\t<div ng-show=\"emailRegister.state === 'start'\">\n\t\t\t\t<p>\n\t\t\t\t\tYou don't currently have an email address registered against your account. If you would like to do\n\t\t\t\t\tso, please enter your address below\n\t\t\t\t</p>\n\t\t\t\t<form name=\"registerEmailAddressForm\" ng-submit=\"registerEmailAddress()\" novalidate>\n\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t<label>Email Address</label>\n\t\t\t\t\t\t<input type=\"text\" required name=\"emailAddress\" ng-model=\"emailRegister.emailAddress\">\n          </md-input-container>\n\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\tng-disabled=\"registerEmailAddressForm.$invalid\">\n\t\t\t\t\t\t\tRegister\n\t\t\t\t\t\t</md-button>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t\t<div ng-show=\"emailRegister.state === 'verify'\">\n\t\t\t\t<p>\n\t\t\t\t\tWe've just sent an email to {{emailRegister.emailAddress}} with a link inside it. When you receive\n\t\t\t\t\tit, just click that link and follow any instructions.\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<label class=\"margin-top\">Mobile Phone Number</label>\n\n\t\t<div ng-if=\"currentUser.hasPhoneNumber\">{{currentUser.realPhoneNumber}}</div>\n\t\t<div ng-if=\"!currentUser.hasUnverifiedPhoneNumber\">\n\t\t\t<p>\n\t\t\t\tPlease enter the 6 digit verification code we sent to {{phoneRegister.phoneNumber}} below.\n\t\t\t</p>\n\t\t\t<form name=\"confirmUnverifiedPhoneNumberForm\" ng-submit=\"confirmUnverifiedPhoneNumber()\" novalidate>\n\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t<label>Verification Code</label>\n\t\t\t\t\t<input type=\"text\" required name=\"verificationCode\" ng-model=\"phoneRegister.verificationCode\">\n        </md-input-container>\n\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\" ng-disabled=\"verifyPhoneNumberForm.$invalid\">\n\t\t\t\t\t\tVerify\n\t\t\t\t\t</md-button>\n\t\t\t</form>\n\t\t</div>\n\t\t<div ng-show=\"!currentUser.hasPhoneNumber\">\n\t\t\t<div ng-show=\"phoneRegister.state === 'start'\">\n\t\t\t\t<p>\n\t\t\t\t\tYou don't currently have a phone number registered against your account. If you would like to do so,\n\t\t\t\t\tplease enter your number below\n\t\t\t\t</p>\n\t\t\t\t<form name=\"registerPhoneNumberForm\" ng-submit=\"registerPhoneNumber()\" novalidate>\n\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t<label>Mobile Phone Number</label>\n\t\t\t\t\t\t<input type=\"text\" required name=\"phoneNumber\" ng-model=\"phoneRegister.phoneNumber\">\n          </md-input-container>\n\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\tng-disabled=\"registerPhoneNumberForm.$invalid\">\n\t\t\t\t\t\t\tRegister\n\t\t\t\t\t\t\t</button>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t\t<div ng-show=\"phoneRegister.state === 'verify'\">\n\t\t\t\t<p>\n\t\t\t\t\tWe've just sent an SMS message to {{phoneRegister.phoneNumber}} with a 6 digit code. Please enter\n\t\t\t\t\tthat code below.\n\t\t\t\t</p>\n\t\t\t\t<form name=\"verifyPhoneNumberForm\" ng-submit=\"verifyPhoneNumber()\" novalidate>\n\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t<label>Verification Code</label>\n\t\t\t\t\t\t<input type=\"text\" required name=\"verificationCode\" ng-model=\"phoneRegister.verificationCode\">\n          </md-input-container>\n\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\tng-disabled=\"verifyPhoneNumberForm.$invalid\">\n\t\t\t\t\t\t\tVerify\n\t\t\t\t\t\t</md-button>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=\"desktopContainer dashboard\">\n\n\t<div class=\"desktopContainer dashboard\">\n\t\t<div class=\"dashboardWelcomeHeader\">\n\t\t\t<div class=\"left\">\n\t\t\t\t<h3>Account Settings</h3>\n\t\t\t\t<p>Manage your account</p>\n\t\t\t</div>\n\t\t\t<div class=\"right\">\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"adminBasicContentContainer\">\n\t\t\t<div class=\"adminSettingGroupContainer\" style=\"position:relative;\">\n\t\t\t\t<table class=\"settingsTable\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td width=\"200px\" class=\"title\">Name</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<form name=\"signupForm\" ng-submit=\"updateAccount(signupForm.$valid)\" novalidate>\n\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t<label>First Name</label>\n\t\t\t\t\t\t\t\t\t<input type=\"text\" required name=\"firstName\" ng-model=\"currentUser.name.first\">\n                </md-input-container>\n\t\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t\t<label>Last Name</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" required name=\"lastName\" ng-model=\"currentUser.name.last\">\n                </md-input-container>\n\t\t\t\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"signupForm.$invalid || currentUser.loading\">\n\t\t\t\t\t\t\t\t\t\t\tUpdate\n\t\t\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td width=\"200px\" class=\"title\">Password</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<form name=\"passwordForm\" ng-submit=\"changePassword(passwordForm.$valid)\" novalidate>\n\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t<label>Password</label>\n\t\t\t\t\t\t\t\t\t<input type=\"password\" required ng-model=\"pass.password\">\n                </md-input-container>\n\t\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t\t<label>Confirm Password</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"password\" required ng-model=\"pass.confirmPassword\">\n                </md-input-container>\n\t\t\t\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"passwordForm.$invalid\">Update</md-button>\n\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\n\t\t\t\t<table class=\"settingsTable\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td width=\"200px\" class=\"title\">Email Address</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span ng-show=\"currentUser.hasEmailAddress\">{{currentUser.realEmailAddress}}</span>\n\t\t\t\t\t\t\t<div ng-show=\"!currentUser.hasEmailAddress\">\n\t\t\t\t\t\t\t\t<div ng-show=\"emailRegister.state === 'start'\">\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\tYou don't currently have an email address registered against your account. If\n\t\t\t\t\t\t\t\t\t\tyou would like to do so, please enter your address below\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<form name=\"registerEmailAddressForm\" ng-submit=\"registerEmailAddress()\" novalidate>\n\t\t\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t\t\t<label>Email Address</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\" required name=\"emailAddress\" ng-model=\"emailRegister.emailAddress\">\n                    </md-input-container>\n\t\t\t\t\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"registerEmailAddressForm.$invalid\">\n\t\t\t\t\t\t\t\t\t\t\t\tRegister\n\t\t\t\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div ng-show=\"emailRegister.state === 'verify'\">\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\tWe've just sent an email to {{emailRegister.emailAddress}} with a link inside\n\t\t\t\t\t\t\t\t\t\tit. When you receive it, just click that link and follow any instructions.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td width=\"200px\" class=\"title\">Mobile Phone Number</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<span ng-if=\"currentUser.hasPhoneNumber\">{{currentUser.realPhoneNumber}}</span>\n\t\t\t\t\t\t\t<div ng-if=\"currentUser.hasUnverifiedPhoneNumber\">\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tPlease enter the 6 digit verification code we sent to {{phoneRegister.phoneNumber}}\n\t\t\t\t\t\t\t\t\tbelow.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<form name=\"confirmUnverifiedPhoneNumberForm\" ng-submit=\"confirmUnverifiedPhoneNumber()\"\n\t\t\t\t\t\t\t\t\tnovalidate>\n\t\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t\t<label>Verification Code</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" required name=\"verificationCode\" ng-model=\"phoneRegister.verificationCode\">\n                  </md-input-container>\n\t\t\t\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"verifyPhoneNumberForm.$invalid\">\n\t\t\t\t\t\t\t\t\t\t\tVerify\n\t\t\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div ng-show=\"!currentUser.hasPhoneNumber\">\n\t\t\t\t\t\t\t\t<div ng-show=\"phoneRegister.state === 'start'\">\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\tYou don't currently have a phone number registered against your account. If you\n\t\t\t\t\t\t\t\t\t\twould like to do so, please enter your number below\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<form name=\"registerPhoneNumberForm\" ng-submit=\"registerPhoneNumber()\" novalidate>\n\t\t\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t\t\t<label>Mobile Phone Number</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\" required name=\"phoneNumber\" ng-model=\"phoneRegister.phoneNumber\">\n                    </md-input-container>\n\t\t\t\t\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"registerPhoneNumberForm.$invalid\">\n\t\t\t\t\t\t\t\t\t\t\t\tRegister\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div ng-show=\"phoneRegister.state === 'verify'\">\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\tWe've just sent an SMS message to {{phoneRegister.phoneNumber}} with a 6 digit\n\t\t\t\t\t\t\t\t\t\tcode. Please entry that code below.\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<form name=\"verifyPhoneNumberForm\" ng-submit=\"verifyPhoneNumber()\" novalidate>\n\t\t\t\t\t\t\t\t\t\t<md-input-container flex-gt-sm>\n\t\t\t\t\t\t\t\t\t\t\t<label>Verification Code</label>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\" required name=\"verificationCode\" ng-model=\"phoneRegister.verificationCode\">\n                    </md-input-container>\n\t\t\t\t\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"verifyPhoneNumberForm.$invalid\">\n\t\t\t\t\t\t\t\t\t\t\t\tVerify\n\t\t\t\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td width=\"200px\" class=\"title\">Notification Delivery</td>\n\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t<div layout-gt-sm=\"row\">\n\t\t\t\t\t\t\t\t<form name=\"notificationForm\" ng-submit=\"updateAccountForNotifications()\" novalidate>\n\t\t\t\t\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm=\"33\" style=\"margin: 0px;\">\n\t\t\t\t\t\t\t\t\t\t<md-checkbox ng-model=\"currentUser.preferEmailNotifications\"\n\t\t\t\t\t\t\t\t\t\t\taria-label=\"Prefer Email Delivery\">\n\t\t\t\t\t\t\t\t\t\t\tReceive Email Notifications for New Dockets\n\t\t\t\t\t\t\t\t\t\t</md-checkbox>\n\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm=\"33\" style=\"margin: 0px;\">\n\t\t\t\t\t\t\t\t\t\t<md-checkbox ng-model=\"currentUser.receiveOrderNotifications\"\n\t\t\t\t\t\t\t\t\t\t\taria-label=\"Prefer Email Delivery\">\n\t\t\t\t\t\t\t\t\t\t\tReceive Email Notifications for New Orders\n\t\t\t\t\t\t\t\t\t\t</md-checkbox>\n\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm=\"33\" style=\"margin: 0px;\">\n\t\t\t\t\t\t\t\t\t\t<md-checkbox ng-model=\"currentUser.docketPdfInNotifications\"\n\t\t\t\t\t\t\t\t\t\t\taria-label=\"Project Group\">\n\t\t\t\t\t\t\t\t\t\t\tInclude PDFs in Docket Notifications\n\t\t\t\t\t\t\t\t\t\t</md-checkbox>\n\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t<md-input-container class=\"md-block\" flex-gt-sm=\"33\" style=\"margin: 0px;\">\n\t\t\t\t\t\t\t\t\t\t<md-checkbox ng-model=\"currentUser.receiveSelfNotifications\"\n\t\t\t\t\t\t\t\t\t\t\taria-label=\"Project Group\">\n\t\t\t\t\t\t\t\t\t\t\tReceive Copies of Notification Emails\n\t\t\t\t\t\t\t\t\t\t</md-checkbox>\n\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t<md-button type=\"submit\" class=\"md-primary md-raised\" flex-gt-sm=\"33\"\n\t\t\t\t\t\t\t\t\t\tstyle=\"margin: 0px;\">\n\t\t\t\t\t\t\t\t\t\tUpdate\n\t\t\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<ng-include src=\"'views/pages/mobileSideNav.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "hup7":
/***/ (function(module, exports) {

var path = 'views/modals/jobCommentModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"jobCommentModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Comment</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeJobCommentModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"jobCommentForm\" novalidate>\n        <div class=\"modalFormTable padding\">\n          <div layout=\"row\" layout-align=\"start\" flex>\n            <md-input-container class=\"md-block\" flex-gt-sm>\n              <label>Comment Text</label>\n              <textarea ng-model=\"newJobComment.comment\" md-maxlength=\"150\" rows=\"2\" md-select-on-focus required></textarea>\n            </md-input-container>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n          <span ng-show=\"duplicateJobs.list.length > 1\">\n            {{duplicateJobs.list.length}} jobs will be duplicated.\n          </span>\n          <span ng-show=\"duplicateJobs.list.length == 1\">\n            1 job will be duplicated.\n          </span>\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeJobCommentModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"(jobCommentForm.$invalid || newJobComment.loading) || addCommentModalNext()\" ng-disabled=\"jobCommentForm.$invalid || newJobComment.loading\">\n            <span ng-hide=\"newJobComment.loading\">Save</span>\n            <md-progress-circular ng-show=\"newJobComment.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "hxIT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module('docketbook').controller('orderDetailController', ['orderService', 'addressBookService', 'resourceService', 'jobService', 'docketService', 'userService', 'xeroService', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', '$q', function (orderService, addressBookService, resourceService, jobService, docketService, userService, xeroService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {

  // Main Variables For Doing Stuff
  $scope.moment = _momentTimezone2.default;
  $scope.itemEdit = null;

  $scope.docketsQuery = {
    limit: 10,
    page: 1,
    order: 'docketNumber'
  };
  $scope.docketsPromise = null;

  $scope.canChangeLineResources = false;

  $scope.jobsQuery = {
    limit: 10,
    page: 1,
    order: 'jobNumber'
  };
  $scope.jobsPromise = null;
  $scope.allFields = {};

  // Base Access Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentTab = "General";
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);
  $scope.userCanDoAction = userService.userCanDoAction;

  if ($scope.currentOrg && $scope.currentOrg.features.canChangeOrderResources == true) {
    $scope.canChangeLineResources = true;
  }

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.currentActiveTab = function () {
    return $scope.currentTab;
  };

  $scope.$parent.prepareForOrderFromParent = function (openTab, order) {
    $scope.itemEdit = {};
    $scope.itemEdit.loading = true;
    $scope.itemEdit.loadingType = "getting";
    if (order) {
      $scope.itemEdit.orderId = order;
    }
    if (order.orderNumber) {
      $scope.itemEdit.orderNumber = order.orderNumber;
    }
    if (openTab) {
      $scope.currentTab = openTab;
    } else {
      $scope.currentTab = "General";
    }
    if ($stateParams.device == 'mobile') {
      $timeout(function () {
        $scope.openMobileTab($scope.currentTab);
      }, 500);
    }
  };

  $scope.$parent.loadOrderFromParent = function (order) {
    $scope.itemEdit = order;
    // TODO change xeroQuote field to use externalId for xero quote id reference
    if (order.supplierRefNo) {
      var refNoSplit = order.supplierRefNo.split('_');
      if (refNoSplit.length > 0 && refNoSplit[0] == 'xq') {
        //refNoSplit.shift();
        //refNoSplit.shift();
        $scope.itemEdit.xeroQuote = true;
        $scope.itemEdit.xeroQuoteId = refNoSplit[2];
      }
    }
    $scope.itemEdit.loading = false;
    if ($stateParams.device == 'desktop') {
      $scope.itemEdit.editing = false;
    } else {
      if ($scope.userCanDoAction('editOrder', $scope.itemEdit)) {
        $scope.itemEdit.editing = true;
      } else {
        $scope.itemEdit.editing = false;
      }
    }
    if ($scope.currentOrg != null && $scope.currentOrgGroup != null) {
      $scope.loadOrderDockets($scope.itemEdit);
      //$scope.loadOrderCompletionRates($scope.itemEdit);
      $scope.loadOrderJobs($scope.itemEdit);
      if ($scope.itemEdit.xeroQuote == true || $scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled == true && $scope.currentOrg.planFeatures.accountingIntegrationEnabled == true) {
        $scope.loadOrderXeroInfo($scope.itemEdit);
      }
    }
    $scope.updateTemplateFields($scope.itemEdit.template);
  };

  $scope.$parent.newOrderFromParent = function (prefillMethod, prefillData) {
    if (prefillMethod && prefillMethod == 'fromXeroQuote') {
      $scope.newOrderFromXeroQuote(prefillData);
    } else {
      $scope.newOrder(prefillMethod, prefillData);
    }
  };

  $scope.$parent.clearOrderFromParent = function () {
    $scope.itemEdit = null;
  };

  $scope.$parent.getOrderFromParent = function () {
    return $scope.itemEdit;
  };

  $scope.loadOrderXeroInfo = function (order) {
    // Load most recent full Xero Quote
    if (order.xeroQuoteId) {
      xeroService.getXeroQuote(order.xeroQuoteId, function (quote) {
        order.xeroQuoteFull = quote;
        // attached quote line reference to order lines
        for (var i = 0; i < order.lineItems.length; i++) {
          if (order.lineItems[i].supplierRef) {
            for (var j = 0; j < quote.lineItems.length; j++) {
              if ('xql-' + quote.lineItems[j].lineItemID == order.lineItems[i].supplierRef) {
                // this is the correct quote line item
                order.lineItems[i].xeroQuoteLineItem = quote.lineItems[j];
                break;
              }
            }
          }
        }
      }, function (err) {
        console.error('could not get xero quote', err);
      });
    } else {
      // check if order has xero line items added to it
      var xeroItemIds = [];
      for (var i = 0; i < order.lineItems.length; i++) {
        if (order.lineItems[i].supplierRef) {
          var idSplit = order.lineItems[i].supplierRef.split('-');
          if (idSplit[0] == 'xi') {
            idSplit.shift();
            xeroItemIds.push(idSplit.join('-'));
          }
        }
      }
      if (xeroItemIds.length > 0) {
        xeroService.getXeroItems({ externalIds: xeroItemIds.join(',') }, function (xeroItems) {
          for (var i = 0; i < order.lineItems.length; i++) {
            if (order.lineItems[i].supplierRef && order.lineItems[i].supplierRef.split('-')[0] == 'xi') {
              for (var j = 0; j < xeroItems.length; j++) {
                if ('xi-' + xeroItems[j].externalId == order.lineItems[i].supplierRef) {
                  order.lineItems[i].xeroLineItem = xeroItems[j];
                  break;
                }
              }
            }
          }
        }, function (err) {
          console.error('could not get xero items', err);
        });
      }
    }
  };

  var loadDocketBlock = function loadDocketBlock(order, page) {
    var params = [];
    params['limit'] = 200;
    params['offset'] = 200 * (page - 1);
    params['sort'] = $scope.docketsQuery.order;
    params['orderRef'] = order.id;

    docketService.getDockets(params, function (returnData) {
      var docketsListParsed = [];
      if (returnData != null) {
        docketsListParsed = docketService.parseDockets(returnData);
      }
      //order.dockets = docketsListParsed;

      order.dockets = order.dockets.concat(docketsListParsed);
      if (docketsListParsed.length >= 200) {
        loadDocketBlock(order, page + 1);
      } else {
        $scope.loadOrderCompletionRates(order);
      }
    });
  };

  $scope.loadOrderDockets = function (order) {
    order.dockets = [];
    loadDocketBlock(order, 1);
  };

  $scope.loadOrderCompletionRates = function (order) {
    var dockets = order.dockets;
    var allDockets = dockets;

    // summarise line data
    var lineTotals = {};
    for (var i = 0; i < order.lineItems.length; i++) {
      lineTotals[order.lineItems[i].id] = { quantity: 0, interactionBreakdown: {} };
    }
    for (var i = 0; i < allDockets.length; i++) {
      var thisDocket = allDockets[i];
      for (var j = 0; j < thisDocket.resources.length; j++) {
        var thisResource = thisDocket.resources[j];
        if (thisResource.orderItemId && lineTotals[thisResource.orderItemId]) {
          // go through interactions and sum quantities
          for (var k = 0; k < thisResource.interactions.length; k++) {
            var thisInteraction = thisResource.interactions[k];
            if (!lineTotals[thisResource.orderItemId].interactionBreakdown[thisInteraction.interactionTemplate.name]) {
              lineTotals[thisResource.orderItemId].interactionBreakdown[thisInteraction.interactionTemplate.name] = { quantity: 0, billable: thisInteraction.interactionTemplate.billable };
            }
            lineTotals[thisResource.orderItemId].interactionBreakdown[thisInteraction.interactionTemplate.name].quantity += thisInteraction.quantity;
            if (thisInteraction.interactionTemplate.billable == true) {
              lineTotals[thisResource.orderItemId].quantity += thisInteraction.quantity;
            }
          }
        }
      }
    }
    for (var i = 0; i < order.lineItems.length; i++) {
      lineTotals[order.lineItems[i].id].quantity = Math.round((lineTotals[order.lineItems[i].id].quantity + Number.EPSILON) * 100) / 100;
    }
    order.lineTotals = lineTotals;
    return;
  };

  $scope.$parent.loadOrderDocketsNextPage = function (cb) {
    var offsetPre = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
    $scope.docketsQuery.page = $scope.docketsQuery.page + 1;
    var offset = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
    // get next page of dockets from docketService using pagination query params
    var params = [];
    params['limit'] = $scope.docketsQuery.limit;
    params['offset'] = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
    params['sort'] = $scope.docketsQuery.order;
    params['orderRef'] = $scope.itemEdit.id;

    docketService.getDockets(params, function (returnData) {
      var docketsListParsed = [];
      docketsListParsed = docketService.parseDockets(returnData);
      for (var i = 0; i < docketsListParsed.length; i++) {
        $scope.itemEdit.dockets.push(docketsListParsed[i]);
      }
      cb();
    });
  };

  $scope.loadOrderJobs = function (order) {
    $scope.jobsPromise = $q(function (resolve, reject) {
      var params = [];
      params['limit'] = $scope.jobsQuery.limit;
      params['offset'] = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
      params['sort'] = $scope.jobsQuery.order;
      params['orderRef'] = order.id;

      jobService.getJobs(params, function (returnData) {
        var jobsListParsed = jobService.parseJobs(returnData);
        order.jobs = jobsListParsed;
        resolve('Done');
      }, function (err) {
        reject('Error');
      });
    });
  };

  $scope.$parent.loadOrderJobsNextPage = function (cb) {
    var offsetPre = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
    $scope.jobsQuery.page = $scope.jobsQuery.page + 1;
    var offset = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
    // get next page of dockets from docketService using pagination query params
    var params = [];
    params['limit'] = $scope.jobsQuery.limit;
    params['offset'] = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
    params['sort'] = $scope.jobsQuery.order;
    params['orderRef'] = $scope.itemEdit.id;

    jobService.getJobs(params, function (returnData) {
      var jobsListParsed = jobService.parseJobs(returnData);
      for (var i = 0; i < jobsListParsed.length; i++) {
        $scope.itemEdit.jobs.push(jobsListParsed[i]);
      }
      cb();
    });
  };

  /*****************************/
  /***** Main Ui Functions *****/
  /*****************************/

  /* Get Field Data */
  $scope.getFields = function () {
    docketService.getFields({}, function (fields) {
      $scope.allFields = {};
      for (var i = 0; i < fields.length; i++) {
        $scope.allFields[fields[i].id] = fields[i];
      }
    }, function (err) {
      $scope.allFields = {};
    });
  };
  $scope.getFields();

  $scope.matchCustomerContact = function (xeroContactId, cb) {
    if (!xeroContactId) {
      cb(null);
      return;
    }
    addressBookService.getAddressBook({ externalId: xeroContactId, externalIdType: 'xero' }, function (addressBook) {
      var matchedContact = null;
      if (addressBook[0] != null) {
        matchedContact = addressBook[0];
        cb(matchedContact);
        return;
      }

      cb(null);
      return;
    }, function (err) {
      console.error('could not get address book', err);
      cb(null);
      return;
    });
  };

  $scope.matchLineItems = function (xeroQuoteLineItems, cb) {
    if (!xeroQuoteLineItems || xeroQuoteLineItems.length <= 0) {
      cb(null);
      return;
    }

    var externalIdMaps = { "identifier": {}, "xero": {} };
    var matchedLines = [];

    var dbResources = [];
    function getAllResources(offset, cb) {
      resourceService.getResources({ limit: 200, offset: offset }, function (resources) {
        dbResources = dbResources.concat(resources);

        if (resources.length == 200) {
          getAllResources(offset + 200, cb);
        } else {
          cb();
        }
      });
    }

    getAllResources(0, function () {
      if (!dbResources || dbResources.length <= 0) {
        cb(null);
        return;
      }

      for (var i = 0; i < dbResources.length; i++) {
        if (dbResources[i].externalIdentifiers) {
          for (var j = 0; j < dbResources[i].externalIdentifiers.length; j++) {
            externalIdMaps[dbResources[i].externalIdentifiers[j].type][dbResources[i].externalIdentifiers[j].externalId] = dbResources[i];
          }
        }
        externalIdMaps["identifier"][dbResources[i].identifier] = dbResources[i];
      }

      for (var i = 0; i < xeroQuoteLineItems.length; i++) {
        if (externalIdMaps["identifier"][xeroQuoteLineItems[i].itemCode] != null) {
          var newLineItem = {};
          var resource = externalIdMaps["identifier"][xeroQuoteLineItems[i].itemCode];
          newLineItem.resource = resource;
          newLineItem.resourceCategory = resource.category.id;
          newLineItem.supplierRef = 'xql-' + xeroQuoteLineItems[i].lineItemID;
          newLineItem.quantity = parseFloat(xeroQuoteLineItems[i].quantity);
          newLineItem.quantityEdit = parseFloat(xeroQuoteLineItems[i].quantity);
          newLineItem.itemDescription = xeroQuoteLineItems[i].description;
          // TODO: add copy of externalID ref field and lineAmount field
          matchedLines.push(newLineItem);
        }
      }

      cb(matchedLines);
      return;
    });
  };

  $scope.newOrderFromXeroQuote = function (prefillData) {
    var newOrder = { 'status': 'New', 'newOrder': 'true' };
    if (prefillData.quoteNumber) {
      newOrder.supplierRefNo = 'xq_' + prefillData.quoteNumber + '_' + prefillData.quoteID;
      //newOrder.orderNumber = prefillData.quoteNumber;
    }
    // TODO: turn the below back on after externalID is setup to store quoteID reference
    /*if ( prefillData.referenceNumber ) {
      newOrder.supplierRefNo = prefillData.referenceNumber;
    }*/
    if (prefillData.dateString) {
      var startDate = (0, _momentTimezone2.default)(prefillData.dateString, 'YYYY-MM-DD').toDate();
      newOrder.startDate = startDate;
    } else {
      newOrder.startDate = (0, _momentTimezone2.default)().toDate();
    }
    if (prefillData.expiryDateString) {
      var endDate = (0, _momentTimezone2.default)(prefillData.expiryDateString, 'YYYY-MM-DD').toDate();
      newOrder.endDate = endDate;
    } else if (prefillData.dateString) {
      var endDate = (0, _momentTimezone2.default)(prefillData.dateString, 'YYYY-MM-DD').toDate();
      newOrder.endDate = endDate;
    } else {
      newOrder.endDate = (0, _momentTimezone2.default)().toDate();
    }
    if (prefillData.summary) {
      newOrder.notes = prefillData.summary;
    }

    // find xero contact
    $scope.matchCustomerContact(prefillData.contact.contactID, function (contact) {
      if (contact != null) {
        var customerContact = contact;
        if (customerContact.contactAddresses != null) {
          var newContactAddresses = {};
          for (var i = 0; i < customerContact.contactAddresses.length; i++) {
            newContactAddresses[customerContact.contactAddresses[i].emailAddress] = ['approver'];
          }

          customerContact.contactAddresses = newContactAddresses;
        }
        //TODO: setup default accessLevels for the contact
        newOrder.customerContact = customerContact;
      }

      $scope.matchLineItems(prefillData.lineItems, function (matchedLineData) {
        if (matchedLineData) {
          newOrder.lineItems = matchedLineData;
        }

        if (!matchedLineData || matchedLineData.length != prefillData.lineItems.length) {
          var missingItems = prefillData.lineItems.length - matchedLineData.length;
          swal({
            title: "Not all Xero resources could be matched.",
            text: missingItems + ' line item' + (missingItems.length > 1 ? 's' : '') + ' from Xero could not be found in your resource list.',
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Ok",
            closeOnConfirm: false
          });
        }

        var currentOrgGroup = $scope.currentOrgGroup;
        var currentOrg = $scope.currentOrg;

        // set supplier contact from this orgs details
        var supplierContact = {};
        supplierContact.displayName = currentOrgGroup.publicName;
        supplierContact.contactAddresses = {};
        supplierContact.addresses = [];
        if (currentOrgGroup.address != null) {
          supplierContact.addresses.push(currentOrgGroup.address);
        }
        if (currentOrgGroup.emailAddress != null) {
          supplierContact.contactAddresses[currentOrgGroup.emailAddress] = [];
        }
        newOrder.supplierContact = supplierContact;

        // set template
        if (currentOrgGroup.defaultTemplate != null) {
          var templateId = currentOrgGroup.defaultTemplate;
          // get template
          orderService.getTemplate(templateId, function (fullTemplate) {
            newOrder.template = fullTemplate;
            $scope.itemEdit = newOrder;
            $scope.itemEdit.editing = true;
            $scope.currentTab = "General";
          }, function (err) {
            newOrder.template = null;
            $scope.itemEdit = newOrder;
            $scope.itemEdit.editing = true;
            $scope.currentTab = "General";
          });
        } else {
          $scope.itemEdit = newOrder;
          $scope.itemEdit.editing = true;
          $scope.currentTab = "General";
        }
      });
    });
  };

  // New Order
  $scope.newOrder = function () {
    var newOrder = _defineProperty({ 'status': 'New', 'orderNumber': 'New Order', 'newOrder': 'true', 'startDate': new Date(), 'endDate': new Date() }, 'orderNumber', '');
    var currentOrgGroup = $scope.currentOrgGroup;
    var currentOrg = $scope.currentOrg;

    // setup supplier contact from org group details
    var supplierContact = {};
    supplierContact.displayName = currentOrgGroup.publicName;
    supplierContact.contactAddresses = {};
    supplierContact.addresses = [];
    if (currentOrgGroup.address != null) {
      supplierContact.addresses.push(currentOrgGroup.address);
    }
    if (currentOrgGroup.emailAddress != null) {
      supplierContact.contactAddresses[currentOrgGroup.emailAddress] = [];
    }
    newOrder.supplierContact = supplierContact;

    if (currentOrgGroup.defaultTemplate != null) {
      var templateId = currentOrgGroup.defaultTemplate;
      // get template
      orderService.getTemplate(templateId, function (fullTemplate) {
        newOrder.template = fullTemplate;
        $scope.itemEdit = newOrder;
        $scope.updateTemplateFields($scope.itemEdit.template);
        $scope.itemEdit.editing = true;
        $scope.currentTab = "General";
      }, function (err) {
        newOrder.template = null;
        $scope.itemEdit = newOrder;
        $scope.itemEdit.editing = true;
        $scope.currentTab = "General";
      });
    } else {
      $scope.itemEdit = newOrder;
      $scope.itemEdit.editing = true;
      $scope.currentTab = "General";
    }
  };

  /***************************************/
  /***** Select Docket Template Func *****/
  /***************************************/

  $scope.assignTemplate = function (template, successCb) {
    if (template != null) {
      var unusableLineItems = templateIsUsable(template);
      if (unusableLineItems <= 0) {
        $scope.itemEdit.template = template;
        $scope.updateTemplateFields($scope.itemEdit.template);
        successCb();
      } else {
        var buttonActions = [{ title: 'Change Template', action: 'use', colour: 'grey' }, { title: "Cancel", action: 'dontUse', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Are you sure?', 'Some existing items on this order are not support by the selected docket template and may be unusable. Are you sure you want to use this template?', buttonActions, function (actionSelected) {
          if (actionSelected == 'use') {
            $scope.itemEdit.template = template;
            $scope.updateTemplateFields($scope.itemEdit.template);
            successCb();
          }
        });
      }
    }
  };

  // Select company - show list in sidebar
  $scope.selectDocketTemplate = function () {
    $scope.$parent.selectTemplateForOrder($scope.allTemplates, function (template) {
      $scope.assignTemplate(template, function () {});
    });
  };

  $scope.updateTemplateFields = function (template) {
    var fields = {};
    if (!template || !template.blocks) {
      return;
    }

    for (var i = 0; i < template.blocks.length; i++) {
      if (template.blocks[i].fields) {
        for (var j = 0; j < template.blocks[i].fields.length; j++) {
          fields[template.blocks[i].fields[j].id] = template.blocks[i].fields[j];
        }
      }
    }
    template.fields = fields;
  };

  var templateIsUsable = function templateIsUsable(template) {
    var categories = [];
    for (var i = 0; i < template.interactionTemplates.length; i++) {
      for (var j = 0; j < template.interactionTemplates[i].actorCategories.length; j++) {
        if (categories.indexOf(template.interactionTemplates[i].actorCategories[j].id) == -1) {
          categories.push(template.interactionTemplates[i].actorCategories[j].id);
        }
      }
    }
    var unusableLineItems = [];
    if ($scope.itemEdit.lineItems) {
      for (var i = 0; i < $scope.itemEdit.lineItems.length; i++) {
        var lineItem = $scope.itemEdit.lineItems[i];
        if (lineItem.resource && categories.indexOf(lineItem.resource.categoryId) == -1) {
          unusableLineItems.push(lineItem);
        }
      }
    }

    return unusableLineItems.length;
  };

  /****************************************/
  /***** Select Company Functionality *****/
  /****************************************/

  $scope.editOrderCustomer = function () {
    $scope.$parent.editContactForOrder($scope.itemEdit.customerContact, function (contactEdited) {
      if (contactEdited == 'select') {
        if ($scope.userCanDoAction('changeOrderCustomer', $scope.itemEdit)) {
          $scope.selectCompany('customerContact');
        }
      } else if (contactEdited != null) {
        $scope.itemEdit.customerContact = contactEdited;
      }
    });
  };

  // Select company - show list in sidebar
  $scope.selectCompany = function (type) {
    $scope.$parent.selectContactForOrder($scope.itemEdit, type, function (contact) {
      if (contact != null) {
        if (contact.contactAddresses != null) {
          var newContactAddresses = {};
          for (var i = 0; i < contact.contactAddresses.length; i++) {
            if (type == 'customerContact') {
              newContactAddresses[contact.contactAddresses[i].emailAddress] = ['approver'];
            } else {
              newContactAddresses[contact.contactAddresses[i].emailAddress] = ['editor'];
            }
          }

          contact.contactAddresses = newContactAddresses;
        }
        //TODO: setup default accessLevels for the contact
        $scope.itemEdit[type] = contact;
      }
    });
  };

  $scope.swapCustSup = function (order) {
    var customerContactCopy = angular.copy(order.customerContact);
    order.customerContact = order.supplierContact;
    order.supplierContact = customerContactCopy;

    if (order.customerContact) {
      var addressKeys = Object.keys(order.customerContact.contactAddresses);
      for (var i = 0; i < addressKeys.length; i++) {
        if (order.customerContact.contactAddresses[addressKeys[i]] == null || order.customerContact.contactAddresses[addressKeys[i]].length == 0) {
          order.customerContact.contactAddresses[addressKeys[i]] = ['approver'];
        }
      }
    }
  };

  /***********************************/
  /***** Line Item Functionality *****/
  /***********************************/

  $scope.newLineItem = function () {
    $scope.$parent.newLineItemForOrder($scope.itemEdit, function (item) {
      if (item != null) {
        // if time resource - format quantity from abbreviation to minutes
        if (item.resource) {
          if (item.resource.uom.isTime) {
            var abbreviation = item.resource.uom.abbreviation;
            if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
              // convert from hours to minutes
              item.quantity = item.quantityEdit * 60;
            }
            if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
              // display from hours&minutes to minutes
              var totalMinutes = 0;
              totalMinutes += parseInt(item.quantityHoursEdit) * 60;
              totalMinutes += parseInt(item.quantityMinutesEdit);
              item.quantity = totalMinutes;
            }
            if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
              item.quantity = item.quantityEdit;
            }
          } else {
            item.quantity = item.quantityEdit;
          }
        }

        item.edit = false;
        item.tempId = uuid.v4();
        if ($scope.itemEdit.lineItems == null) {
          $scope.itemEdit.lineItems = [];
        }
        $scope.itemEdit.lineItems.push(item);
      }
    });
  };

  var loadResources = function loadResources(allowedCategyIds, successCb) {

    if ($scope.currentOrg == null || $scope.currentOrgGroup == null) {
      return;
    }

    $scope.promise = $q(function (resolve, reject) {

      var promises = allowedCategyIds.map(function (categoryId) {
        return $q(function (res) {
          resourceService.getResources({ categoryId: categoryId }, res);
        }).then(function (val) {
          return val;
        });
      });

      $q.all(promises).then(function (results) {
        var resourceSearchList = _.flatten(results);
        successCb(resourceSearchList);
        resolve('Done');
      });
    });
  };

  var manualSelectResourceForLine = function manualSelectResourceForLine(lineItem, successCb) {
    var templateCategories = null;
    if ($scope.itemEdit.template && $scope.itemEdit.template.interactionTemplates) {
      templateCategories = {};
      for (var i = 0; i < $scope.itemEdit.template.interactionTemplates.length; i++) {
        var interactionTemplate = $scope.itemEdit.template.interactionTemplates[i];
        for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
          if (templateCategories[interactionTemplate.actorCategories[j].id] == null) {
            templateCategories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
          }
        }
      }
    }
    var categories = [];
    for (var key in templateCategories) {
      categories.push(templateCategories[key]);
    }

    $scope.$parent.selectResourceForOrder({ multiple: false, categories: categories }, function (resources) {
      if (resources != null && resources[0] != null) {
        lineItem.resource = resources[0];
        if (successCb) {
          successCb();
        }
      }
    });
  };

  $scope.removeResourceForLine = function (lineItem) {
    lineItem.resource = null;
  };

  $scope.selectResourceForLine = function (lineItem, successCb) {

    if ($scope.itemEdit.template && $scope.itemEdit.template.interactionTemplates) {
      var allowedCategoryIds = _.uniq($scope.itemEdit.template.interactionTemplates.flatMap(function (iTemplate) {
        return iTemplate.actorCategories;
      }).map(function (actorCat) {
        return actorCat.id;
      }));
      loadResources(allowedCategoryIds, function (resources) {

        // Append string match to line item value
        resources.forEach(function (r) {
          return r.match = _stringSimilarity2.default.compareTwoStrings(r.name, lineItem.itemDescription);
        });

        // Filter recommended resources
        var recommendedResources = _.sortBy(resources.filter(function (r) {
          return r.match >= 0.45 && allowedCategoryIds.includes(r.categoryId);
        }), function (r) {
          return -r.match;
        });

        if (recommendedResources.length > 0) {
          // Show recommendattion modal
          $scope.showRecommendLineItemResourceModal(lineItem, recommendedResources, function (selectedResource) {
            lineItem.resource = selectedResource;
            if (successCb) {
              successCb();
            }
          }, function () {
            manualSelectResourceForLine(lineItem, successCb);
          });
        } else {
          manualSelectResourceForLine(lineItem, successCb);
        }
      });
    } else {
      manualSelectResourceForLine(lineItem, successCb);
    }
  };

  $scope.newLineItemDesktop = function () {
    if ($scope.userCanDoAction('isOrderSupplier', $scope.itemEdit)) {
      var templateCategories = null;
      if ($scope.itemEdit.template && $scope.itemEdit.template.interactionTemplates) {
        templateCategories = {};
        for (var i = 0; i < $scope.itemEdit.template.interactionTemplates.length; i++) {
          var interactionTemplate = $scope.itemEdit.template.interactionTemplates[i];
          for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
            if (templateCategories[interactionTemplate.actorCategories[j].id] == null) {
              templateCategories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
            }
          }
        }
      }
      var categories = [];
      for (var key in templateCategories) {
        categories.push(templateCategories[key]);
      }
      $scope.$parent.selectResourceForOrder({ multiple: true, categories: categories }, function (resources) {
        if (resources != null) {
          if ($scope.itemEdit.lineItems == null) {
            $scope.itemEdit.lineItems = [];
          }

          for (var i = 0; i < resources.length; i++) {
            if ($scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.quotesEnabled) {
              var xeroExternalId = null;
              var preCreatedSupplierRef = null;
              if (resources[i].externalIdentifiers) {
                for (var j = 0; j < resources[i].externalIdentifiers.length; j++) {
                  if (resources[i].externalIdentifiers[j].type == 'xero') {
                    xeroExternalId = resources[i].externalIdentifiers[j].externalId;
                    break;
                  }
                }
                if (xeroExternalId) {
                  preCreatedSupplierRef = 'xi-' + xeroExternalId;
                }
              }
              $scope.itemEdit.lineItems.push({ resource: resources[i], quantity: 0, quantityEdit: 0, quantityHoursEdit: 0, quantityMinutesEdit: 0, itemDescription: "", supplierRef: preCreatedSupplierRef });
            } else {
              $scope.itemEdit.lineItems.push({ resource: resources[i], quantity: 0, quantityEdit: 0, quantityHoursEdit: 0, quantityMinutesEdit: 0, itemDescription: "", supplierRef: '' });
            }
          }
        }
      });
    } else {
      if ($scope.itemEdit.lineItems == null) {
        $scope.itemEdit.lineItems = [];
      }
      $scope.itemEdit.lineItems.push({ quantity: 0, quantityEdit: 0, quantityHoursEdit: 0, quantityMinutesEdit: 0, itemDescription: "" });
    }
  };

  $scope.editLineItem = function (item) {
    //if ( $scope.itemEdit.status != 'Draft' && !item.new ) {
    //item.readOnly = true;
    //}
    // if time resource - format quantity as per abbreviation
    if (item.new != true && item.resource && item.resource.uom.isTime) {
      var quantity = item.quantity;
      var abbreviation = item.resource.uom.abbreviation;
      if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
        // display as hours
        item.quantityEdit = quantity / 60;
        item.quantityEditType = 'h';
      }
      if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
        // display as hours and minutes
        var hours = Math.floor(quantity / 60);
        var minutes = quantity % 60;
        item.quantityHoursEdit = hours;
        item.quantityMinutesEdit = minutes;
        item.quantityEditType = 'hm';
      }
      if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
        item.quantityEdit = quantity;
        item.quantityEditType = 'm';
      }
    } else {
      item.quantityEdit = item.quantity;
      item.quantityEditType = 'normal';
    }

    if (item.new != true && item.resource != null) {
      item.resourceLocked = true;
    }
    $scope.$parent.editLineItemForOrder($scope.itemEdit, item, function (item) {
      if (item != null) {
        // if time resource - format quantity from abbreviation to minutes
        if (item.resource.uom.isTime) {
          var abbreviation = item.resource.uom.abbreviation;
          if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
            // convert from hours to minutes
            item.quantity = item.quantityEdit * 60;
          }
          if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
            // display from hours&minutes to minutes
            var totalMinutes = 0;
            totalMinutes += parseInt(item.quantityHoursEdit) * 60;
            totalMinutes += parseInt(item.quantityMinutesEdit);
            item.quantity = totalMinutes;
          }
          if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
            item.quantity = item.quantityEdit;
          }
        } else {
          item.quantity = item.quantityEdit;
        }

        item.edit = false;
      }
    });
  };

  $scope.removeLineItem = function (lineItem) {
    var buttonActions = [{ title: 'Delete Order Line', action: 'use', colour: 'green' }, { title: "Cancel", action: 'dontUse', colour: 'grey' }];
    $scope.alertService.presentConfirmAlert('Are you sure?', 'Removing this line item from the order cannot be undone.', buttonActions, function (actionSelected) {
      if (actionSelected == 'use') {
        if (lineItem.id) {
          lineItem.delete = true;
        } else {
          var index = $scope.itemEdit.lineItems.indexOf(lineItem);
          if (index != -1) {
            $scope.itemEdit.lineItems.splice(index, 1);
          }
        }
      }
    });
  };

  /*********************************/
  /**** Access Control Editing *****/
  /*********************************/

  $scope.assignOrderOrg = function (order) {
    var assignOrder = {};
    $scope.$parent.selectOrganisationForOrder(order, function (group) {
      if (group != null) {
        $scope.assignOrderSave(order, group);
      }
    });
  };

  $scope.assignOrderSave = function (order, group) {
    var losingPrincipal = $scope.currentUser.emailAddress;
    var gainingPrincipal = group.emailAddress;
    orderService.reassignOrder(order.id, losingPrincipal, gainingPrincipal, function (success) {
      $scope.$parent.closeOrder();
      if ($stateParams.device == 'desktop') {
        $scope.$parent.loadOrdersList();
      }
    }, function (err) {
      swal({
        title: "Error!",
        text: "An error occured while reassigning the order.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    });
  };

  /*************************************/
  /***** Share Order Functionality *****/
  /*************************************/

  $scope.shareOrder = function (order) {
    var userAccessLevels = [];
    $scope.newAccessor = { 'accessLevel': 'viewer' };
    $scope.accessControlEdit = {};
    $scope.accessControlEdit.orderNumber = order.orderNumber;
    var accessControlEdit = [];
    var currentKeys = Object.keys(order.accessControl);
    for (var i = 0; i < currentKeys.length; i++) {
      var newAccessControlItem = {};
      newAccessControlItem.emailAddress = currentKeys[i];
      newAccessControlItem.accessLevel = "";
      if (order.accessControl[currentKeys[i]].indexOf('creator') != -1) {
        newAccessControlItem.accessLevel = 'creator';
        newAccessControlItem.accessLevelSet = true;
      } else if (order.accessControl[currentKeys[i]].indexOf('supplier') != -1) {
        newAccessControlItem.accessLevel = 'supplier';
      } else if (order.accessControl[currentKeys[i]].indexOf('customer') != -1) {
        newAccessControlItem.accessLevel = 'customer';
      } else if (order.accessControl[currentKeys[i]].indexOf('viewer') != -1) {
        newAccessControlItem.accessLevel = 'viewer';
      }
      newAccessControlItem.accessLevelInitial = newAccessControlItem.accessLevel;
      newAccessControlItem.accessLevelsArray = order.accessControl[currentKeys[i]];

      // check if current user and get accessLevels
      if (newAccessControlItem.emailAddress == $scope.currentUser.emailAddress) {
        for (var j = 0; j < newAccessControlItem.accessLevelsArray.length; j++) {
          userAccessLevels.push(newAccessControlItem.accessLevelsArray[j]);
        }
        newAccessControlItem.isUser = true;
      }

      // check is current org groups email and add get accessLevels
      if ($scope.currentOrgGroup && $scope.currentOrgGroup.emailAddresses) {
        for (var j = 0; j < $scope.currentOrgGroup.emailAddresses.length; j++) {
          if ($scope.currentOrgGroup.emailAddresses[j] == newAccessControlItem.emailAddress) {
            for (var k = 0; k < newAccessControlItem.accessLevelsArray.length; k++) {
              userAccessLevels.push(newAccessControlItem.accessLevelsArray[k]);
            }
            break;
          }
        }
      }
      accessControlEdit.push(newAccessControlItem);
    }

    $scope.accessControlEdit.accessControl = accessControlEdit;

    // get max accessLevel
    var maxLevel = "";
    if (userAccessLevels.indexOf('creator') != -1) {
      maxLevel = "creator";
    } else if (userAccessLevels.indexOf('supplier') != -1) {
      maxLevel = "supplier";
    } else if (userAccessLevels.indexOf('customer') != -1) {
      maxLevel = "customer";
    } else if (userAccessLevels.indexOf('viewer') != -1) {
      maxLevel = "viewer";
    }
    $scope.accessControlEdit.maxLevel = maxLevel;
    $mdBottomSheet.hide();
    $("#shareOrderModal").fadeIn(100);
  };

  $scope.canSetAccessLevel = function (accessor, accessLevel) {
    if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
      return false;
    }
    if (accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' || $scope.accessControlEdit.maxLevel == 'supplier' || $scope.accessControlEdit.maxLevel == 'customer' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessLevel == 'remove' && accessor.accessLevel == 'viewer' && $scope.accessControlEdit.maxLevel == 'creator') {
      return true;
    }

    return false;
  };

  $scope.canChangeAccessLevel = function (accessor) {
    if (accessor.accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' || $scope.accessControlEdit.maxLevel == 'creator')) {
      return true;
    }
    if (accessor.accessLevel == 'creator' && $scope.accessControlEdit.maxLevel == 'creator') {
      return true;
    }
  };

  $scope.closeAccessControlModal = function () {
    $("#shareOrderModal").fadeOut(100);
  };

  $scope.saveAccessControlEdit = function () {
    $scope.accessControlEdit.loading = true;
    // convert back to accessControl object
    var accessControlObject = {};
    for (var i = 0; i < $scope.accessControlEdit.accessControl.length; i++) {
      var thisAccessItem = $scope.accessControlEdit.accessControl[i];
      if (thisAccessItem.new == true) {
        accessControlObject[thisAccessItem.emailAddress] = {};
        accessControlObject[thisAccessItem.emailAddress].add = [thisAccessItem.accessLevel];
      } else if (thisAccessItem.accessLevelInitial != thisAccessItem.accessLevel) {
        // access has been changed - need to construct add/remove fields
        if (thisAccessItem.accessLevel == 'remove') {
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
        } else if (thisAccessItem.accessLevel == 'viewer') {
          // construct ad/remove dependent on initial array
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
          accessControlObject[thisAccessItem.emailAddress].add = ['viewer'];
        }
      }
    }

    orderService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (success) {
      $scope.itemEdit.accessControl = success.accessControl;
      $("#shareOrderModal").fadeOut(100);
    }, function (err) {
      $scope.accessControlEdit.loading = false;
      swal({
        title: "Error!",
        text: "An error occured while sharing the order.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    });
  };

  $scope.addNewAccessor = function () {
    if ($scope.newAccessor.emailAddress != "") {
      $scope.newAccessor.new = true;
      var emailAddresses = $scope.newAccessor.emailAddress.split(',');
      if (emailAddresses.length > 1) {
        for (var i = 0; i < emailAddresses.length; i++) {
          var newAccessor = angular.copy($scope.newAccessor);
          newAccessor.emailAddress = emailAddresses[i];
          $scope.accessControlEdit.accessControl.push(newAccessor);
        }
      } else {
        $scope.accessControlEdit.accessControl.push($scope.newAccessor);
      }
      $scope.newAccessor = { 'accessLevel': 'viewer' };
    }
  };

  $scope.selectAccessorContact = function () {
    $("#shareOrderModal").fadeOut(100);
    $scope.$parent.selectContactForShare(function (contactSelected) {
      if (contactSelected != null) {
        $("#shareOrderModal").fadeIn(100);
        /*if ( contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress ) {
          $scope.newAccessor.emailAddress = contactSelected.contactAddresses[0].emailAddress;
        }*/
        var emailAddresses = [];
        for (var i = 0; i < contactSelected.contactAddresses.length; i++) {
          if (contactSelected.contactAddresses[i].emailAddress) {
            emailAddresses.push(contactSelected.contactAddresses[i].emailAddress);
          }
        }
        $scope.newAccessor.emailAddress = emailAddresses.join(',');
      } else {
        $("#shareOrderModal").fadeIn(100);
      }
    });
  };

  /***********************************/
  /**** Order Line Reassignment ******/
  /***********************************/

  $scope.reassignOrderLine = function (lineItem) {
    $scope.orderLineSelectFromParentAdvanced($scope.itemEdit.lineItems, lineItem, function (lineItemSelected) {
      if (lineItemSelected) {
        var fullMessage = "All dockets associated with the order line item '" + lineItem.itemDescription + "' will be relinked to the order line item '" + lineItemSelected.itemDescription + "'. This operation cannot be reverted.";
        var buttonActions = [{ title: 'Continue', action: 'use', colour: 'green' }, { title: "Cancel", action: 'dontUse', colour: 'grey' }];
        $scope.alertService.presentConfirmAlert('Confirm Order Line Reassignment', fullMessage, buttonActions, function (actionSelected) {
          if (actionSelected == 'use') {
            orderService.reassignOrderLineItems($scope.itemEdit, lineItem, lineItemSelected, function (success) {
              $timeout(function () {
                $scope.alertService.presentAlert('success', 'Order Line Reassigned', 'All dockets associated with this order line change are being updated - this can take a few minutes.');
                // alert about scheduled job
                if (!lineItemSelected.resource) {
                  for (var i = 0; i < $scope.itemEdit.lineItems.length; i++) {
                    if ($scope.itemEdit.lineItems[i].id == lineItemSelected.id) {
                      $scope.itemEdit.lineItems[i].resource = lineItem.resource;
                      $scope.itemEdit.lineItems[i].quantity = lineItem.quantity;
                      $scope.itemEdit.lineItems[i].uom = lineItem.uom;
                    }
                  }
                }
                lineItem.resource = null;
              }, 1000);
            }, function (err) {
              console.error('could not reassign order line', err);
            });
          }
        });
      }
    });
  };

  $scope.canDeleteOrderLineItem = function (order) {
    var hasCreator = false;
    for (var i = 0; i < $scope.currentOrgGroup.emailAddresses.length; i++) {
      if (order.accessControl[$scope.currentOrgGroup.emailAddresses[i]].indexOf('creator') != -1) {
        hasCreator = true;
        break;
      }
    }

    return hasCreator;
  };

  /************************************/
  /***** General UI Functionality *****/
  /************************************/

  $scope.openMobileTab = function (tabName) {
    $scope.currentTab = tabName;
    var leftOffset = $("#tab" + tabName).offset().left + $("#tab" + tabName).width();
    var width = $(".tabBarMobile.detailTabBar").width();
    var M = width / 2;
    var Y = leftOffset;
    var X = $(".tabBarMobile.detailTabBar").scrollLeft();

    if (Y > M) {
      // scroll right
      $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X + (Y - M) }, 600);
    } else {
      // scroll left
      $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X - (M - Y) }, 600);
    }
  };

  $scope.compIsCurrentOrgGroup = function (companyId) {
    if ($scope.currentOrgGroup.id == companyId) {
      return true;
    } else {
      return false;
    }
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /***********************/
  /**** Bottom Sheet *****/
  /***********************/

  $scope.openBottomSheet = function () {
    $mdBottomSheet.show({
      templateUrl: 'views/pages/orders/mobile/ordersBottomSheet.html',
      scope: $scope,
      preserveScope: true
    }).then(function () {});
  };

  /*****************************/
  /***** Date/Time Pickers *****/
  /*****************************/

  $scope.showDatePicker = function (field, ev) {
    $mdpDatePicker($scope.itemEdit[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      $scope.itemEdit[field] = selectedDate;
    });
  };

  $scope.showTimePicker = function (field, ev) {
    $mdpTimePicker($scope.itemEdit[field], {
      targetEvent: ev,
      autoSwitch: true
    }).then(function (selectedTime) {
      $scope.itemEdit[field] = selectedTime;
    });
  };

  /**********************************/
  /**** Alert Parent Controller *****/
  /**********************************/

  $scope.$parent.detailControllerReady();
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "iWHQ":
/***/ (function(module, exports) {

var path = 'views/selectors/templateList.html';
var html = "<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListTopContainer showMobile\">\n    <div class=\"contentSplitListTopInner\">\n\n      <div class=\"contentHeader selectCompany\">\n        <h2>Select Docket Template</h2>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"template in templateSearchList\"  ng-click=\"assignTemplateToDocket(template)\" id=\"listItem{{template.id}}\">\n          <div class=\"listRowItem itemNumber\">{{template.name}}</div>\n        </div>\n\n        <div class=\"mobileListButtons hidden-xs\">\n          <div class=\"btn btn-rounded btn-primary\" ng-click=\"closeTemplateSelectList()\">\n            Cancel\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "iczq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "forum.svg";

/***/ }),

/***/ "io7Q":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/checklistsTab.html';
var html = "<div class=\"customListRowOuter\" id=\"listItem{{resource.id}}\" ng-repeat=\"container in itemEdit.template.checklistContainers\" ng-click=\"openChecklistDetailModal(container)\">\n  <div class=\"customListRow resourceHeader\" hm-swipeLeft=\"splitListFunc.swipeListItem(resource.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(resource.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}'>\n    <div class=\"listRowItem status\">\n      <div class=\"statusDisplay {{itemEdit.checklists[container.checklistTemplate.id].complete ? 'Completed' : 'Rejected'}}\">\n        <span ng-show=\"!itemEdit.checklists[container.checklistTemplate.id].complete\">Incomplete</span>\n        <span ng-show=\"itemEdit.checklists[container.checklistTemplate.id].complete\">Complete</span>\n      </div>\n    </div>\n    <div class=\"listRowItem itemNumber\">{{container.checklistTemplate.name}}</div>\n    <div class=\"listRowItem collapsedDetail showCollapsed\">\n      <span ng-show=\"container.rule == 'required'\">Required Before Submission</span>\n      <span ng-show=\"container.rule == 'notRequired'\">Optional</span>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ioen":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iwLq":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/mobileTabBar.html';
var html = "<md-content class=\"tabBarMobile detailTabBar\">\n  <md-nav-bar md-selected-nav-item=\"currentTab\" nav-bar-aria-label=\"docket\">\n    <md-nav-item md-nav-click=\"openMobileTab('General')\" name=\"General\" id=\"tabGeneral\">General</md-nav-item>\n    <span ng-repeat=\"block in itemEdit.template.blocks\">\n      <md-nav-item ng-if=\"block.type=='custom'\" md-nav-click=\"openMobileTab(block.id)\" name=\"{{block.id}}\" id=\"tab{{block.id}}\">{{block.name}}</md-nav-item>\n      <md-nav-item ng-if=\"block.type=='time'\" md-nav-click=\"openMobileTab('Time')\" name=\"Time\" id=\"tabTime\">Time</md-nav-item>\n      <md-nav-item ng-if=\"block.type=='resources'\" md-nav-click=\"openMobileTab('Resources')\" name=\"Resources\" id=\"tabResources\">Items</md-nav-item>\n      <md-nav-item ng-if=\"block.type=='checklists'\" md-nav-click=\"openMobileTab('Checklists')\" name=\"Checklists\" id=\"tabChecklists\">Checklists</md-nav-item>\n      <md-nav-item ng-if=\"block.type=='signatures'\" md-nav-click=\"openMobileTab('Signatures')\" name=\"Signatures\" id=\"tabSignatures\">Signatures</md-nav-item>\n    </span>\n    <md-nav-item md-nav-click=\"openMobileTab('Map')\" name=\"Map\" id=\"tabMap\">Map</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('Attachments')\" name=\"Attachments\" id=\"tabAttachments\">Attachments</md-nav-item>\n  </md-nav-bar>\n</md-content>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "j343":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/filingTab.html';
var html = "<div class=\"ojdDesktopSection header {{itemEdit.existingDocketFile ? 'Completed' : 'New'}}\">\n  <div class=\"headerTitle\">\n    <h2>Status</h2>\n    <h1 ng-if=\"itemEdit.existingDocketFile\">Filed</h1>\n    <h1 ng-if=\"!itemEdit.existingDocketFile\">Unfiled</h1>\n  </div>\n\n  <div class=\"bulkActionsButtons\">\n    <md-button ng-click=\"saveDocketFile(itemEdit)\" ng-show=\"showSaveFilingButton()\">\n      {{afterFilingAccept ? 'Accept and ' : ''}}Save Filing\n    </md-button>\n  </div>\n</div>\n<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Docket Filing\" ng-if=\"itemEdit.docketFiling.loading && itemEdit.docketFiling.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Docket Filing\" ng-if=\"itemEdit.docketFiling.loading && itemEdit.docketFiling.loadingType != 'getting'\"></div>\n\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">File Codes</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button ng-if=\"itemEdit.docketFiling.method != 'split'\" ng-click=\"changeFileMethod('split', itemEdit.docketFiling)\"><!--ng-click=\"itemEdit.docketFiling.method = 'split'\">-->\n          File By Docket\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"addSplitFileCodeDesktop()\" aria-label=\"Add Split File Code\" ng-if=\"itemEdit.docketFiling.method == 'split'\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <p ng-show=\"itemEdit.docketFiling.activityCodes == null || itemEdit.docketFiling.activityCodes.length <= 0\">\n      No file codes have been added.\n    </p>\n\n    <p ng-show=\"itemEdit.docketFiling.method == 'lines'\">\n      Currently filing by lines\n    </p>\n\n    <md-table-container ng-show=\"itemEdit.docketFiling.activityCodes.length > 0 && itemEdit.docketFiling.method == 'split'\">\n      <table md-table>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>File Code</th>\n            <th md-column>Percentage</th>\n            <th md-column>Quantities</th>\n            <th md-column>Action</th>\n          </tr>\n          <tr md-row ng-repeat=\"activity in itemEdit.docketFiling.activityCodes\">\n            <td md-cell>\n              <ng-form name=\"innerForm\">\n                <md-autocomplete required md-input-name=\"autocomplete\"\n                  ng-disabled=\"itemEdit.docketFiling.method != 'split'\" md-no-cache=\"true\"\n                  md-selected-item=\"activity.fileCode\"\n                  md-search-text=\"searchText\"\n                  md-selected-item-change=\"selectActivityCodeChange(searchText)\"\n                  md-items=\"fileCode in searchFileCodes(searchText)\" md-item-text=\"fileCode.fileName\"\n                  md-min-length=\"0\" placeholder=\"Search for a file code\"\n                  md-menu-class=\"autocomplete-custom-template\">\n                  <md-item-template>\n                    <span class=\"item-title\">{{fileCode.fileCode}} - </span>\n                    <span class=\"item-metadata\">\n                      <span class=\"item-metastat\">{{fileCode.fileName}}</span>\n                      <span class=\"item-metastat\">({{fileCode.costCode}})</span>\n                    </span>\n                  </md-item-template>\n                  <md-not-found>\n                    No matches found.\n                  </md-not-found>\n                </md-autocomplete>\n                <div ng-show=\"innerForm.autocomplete.$error.required && innerForm.autocomplete.$touched\" class=\"errorMessage\">\n                  Please select a file code\n                </div>\n              </ng-form>\n            </td>\n            <td md-cell>\n              <input type=\"number\" ng-model=\"activity.splitPercentage_display\" ng-disabled=\"itemEdit.docketFiling.method != 'split'\" ng-change=\"splitPercentageUpdated(activity)\"> %\n            </td>\n            <td md-cell>\n              <span ng-if=\"!singleUom\" ng-repeat=\"uomSummary in activity.uomSummaries\">{{uomSummary.splitQuantity.toFixed(2)}}{{uomSummary.uom.abbreviation}}<br/></span>\n              <input ng-if=\"singleUom\" type=\"number\" ng-model=\"activity.splitQuantity\" ng-disabled=\"itemEdit.docketFiling.method != 'split'\" ng-change=\"splitQuantityUpdated(activity)\"> {{singleUomAbbreviation}}\n            </td>\n            <td md-cell>\n              <md-button class=\"md-icon-button\" ng-click=\"removeSplitFileCode(activity, itemEdit.docketFiling.activityCodes)\" aria-label=\"Remove Split File Code\" ng-if=\"itemEdit.docketFiling.method == 'split'\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n          <tr md-row>\n            <td md-cell>\n              <b>Summary</b>\n            </td>\n            <td md-cell>\n              <b>{{totalPercentage()}} %</b>\n            </td>\n            <td md-cell>\n              <b>{{totalQuantity()}} {{singleUomAbbreviation}}</b>\n            </td>\n            <td md-cell></td>\n          </tr>\n        </thead>\n      </table>\n    </md-table-container>\n  </div>\n\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Lines Summary</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-button ng-click=\"changeFileMethod('lines', itemEdit.docketFiling)\" ng-if=\"itemEdit.docketFiling.method != 'lines'\">\n          File By Lines\n        </md-button>\n      </div>\n    </div>\n\n    <p ng-if=\"itemEdit.docketFiling.linesSummary == null || itemEdit.docketFiling.linesSummary.length <= 0\">\n      There are no lines on this docket.\n    </p>\n\n    <md-table-container ng-show=\"itemEdit.docketFiling.linesSummary.length > 0\">\n      <table md-table>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Resource</th>\n            <th md-column>Line Type</th>\n            <th md-column>Quantity</th>\n            <th md-column>File Code</th>\n            <th md-column>Percent</th>\n            <th md-column>Action</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat-start=\"line in itemEdit.docketFiling.linesSummary\">\n            <td md-cell>{{line.resource.name}}</td>\n            <td md-cell>{{line.interaction.interactionTemplate.name}}</td>\n            <td md-cell>{{line.quantity}} {{line.resource.uom.abbreviation}}</td>\n            <td md-cell>\n              <ng-form name=\"innerForm\" ng-show=\"line.activityCodes.length == 1\">\n                <md-autocomplete required ng-if=\"itemEdit.docketFiling.method == 'lines'\" md-input-name=\"autocomplete\"\n                  ng-disabled=\"false\" md-no-cache=\"true\"\n                  md-selected-item=\"line.activityCodes[0].fileCode\"\n                  md-search-text=\"searchText\"\n                  md-selected-item-change=\"selectActivityCodeChange(searchText)\"\n                  md-items=\"fileCode in searchFileCodes(searchText)\" md-item-text=\"fileCode.fileName\"\n                  md-min-length=\"0\" placeholder=\"Search for a file code\"\n                  md-menu-class=\"autocomplete-custom-template\">\n                  <md-item-template>\n                    <span class=\"item-title\">{{fileCode.fileCode}} - </span>\n                    <span class=\"item-metadata\">\n                      <span class=\"item-metastat\">{{fileCode.fileName}}</span>\n                      <span class=\"item-metastat\">({{fileCode.costCode}})</span>\n                    </span>\n                  </md-item-template>\n                  <md-not-found>\n                    No matches found.\n                  </md-not-found>\n                </md-autocomplete>\n                <div ng-show=\"innerForm.autocomplete.$error.required && innerForm.autocomplete.$touched\" class=\"errorMessage\">\n                  Please select a file code\n                </div>\n              </ng-form>\n            </td>\n            <td md-cell>\n              {{getLineTotalPercent(line)}} %\n            </td>\n            <td md-cell>\n              <md-button ng-click=\"splitLineFiling(line)\" ng-disabled=\"itemEdit.docketFiling.method != 'lines'\">\n                Split\n              </md-button>\n            </td>\n          </tr>\n          <tr ng-if=\"line.activityCodes.length > 1\" ng-repeat-end ng-repeat=\"activityCode in line.activityCodes\">\n            <td md-cell></td>\n            <td md-cell>{{activityCode.quantity}}</td>\n            <td md-cell>\n              <input type=\"number\" class='filecodeInput' ng-model=\"activityCode.quantity\" ng-disabled=\"itemEdit.docketFiling.method != 'lines'\" ng-change=\"activityCodeQuantityUpdated(line, activityCode, $index)\"> {{line.resource.uom.abbreviation}}\n            </td>\n            <td md-cell>\n              <ng-form name=\"innerForm\">\n                <md-autocomplete required ng-if=\"itemEdit.docketFiling.method == 'lines'\" md-input-name=\"autocomplete\"\n                  ng-disabled=\"false\" md-no-cache=\"true\"\n                  md-selected-item=\"activityCode.fileCode\"\n                  md-search-text=\"searchText\"\n                  md-selected-item-change=\"selectActivityCodeChange(searchText)\"\n                  md-items=\"fileCode in searchFileCodes(searchText)\" md-item-text=\"fileCode.fileName\"\n                  md-min-length=\"0\" placeholder=\"Search for a file code\"\n                  md-menu-class=\"autocomplete-custom-template\">\n                  <md-item-template>\n                    <span class=\"item-title\">{{fileCode.fileCode}} - </span>\n                    <span class=\"item-metadata\">\n                      <span class=\"item-metastat\">{{fileCode.fileName}}</span>\n                      <span class=\"item-metastat\">({{fileCode.costCode}})</span>\n                    </span>\n                  </md-item-template>\n                  <md-not-found>\n                    No matches found.\n                  </md-not-found>\n                </md-autocomplete>\n                <div ng-show=\"innerForm.autocomplete.$error.required && innerForm.autocomplete.$touched\" class=\"errorMessage\">\n                  Please select a file code\n                </div>\n              </ng-form>\n            </td>\n            <td md-cell>\n              <input type=\"number\" class='filecodeInput' ng-model=\"activityCode.percentage_display\" ng-disabled=\"itemEdit.docketFiling.method != 'lines'\" ng-change=\"activityCodePercentageUpdated(line, activityCode, $index)\"> %\n            </td>\n            <td md-cell style=\"text-align: center;\">\n              <md-button class=\"md-icon-button\" ng-click=\"removeSplitLineFiling(line, $index)\" aria-label=\"Remove Split File Code\" ng-if=\"itemEdit.docketFiling.method == 'lines'\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n\n  <div class=\"ojdDesktopSection noPadding\">\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Log Details</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n\n      </div>\n    </div>\n\n    <p ng-if=\"itemEdit.docketFiling.createdAt\">\n      Created At {{moment(itemEdit.docketFiling.createdAt).format('DD/MM/YYYY HH:mm')}}\n    </p>\n    <p ng-if=\"itemEdit.docketFiling.updatedAt\">\n      Updated At {{moment(itemEdit.docketFiling.updatedAt).format('DD/MM/YYYY HH:mm')}}\n    </p>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "j5JE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "import.svg";

/***/ }),

/***/ "jgC+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectRoleController', ['userService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', function (userService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

  // Initialise variables to be used
  $scope.roleSearchLoading = false;
  $scope.rolesSearchList = [];
  $scope.roleSelectCallback = null;
  $scope.desktopSelected = [];

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.roleSelectFromParent = function (existingRoles, cb) {
    $scope.roleSelectCallback = cb;
    $scope.existingRoles = existingRoles;
    $scope.desktopSelected = [];
    $("#selectRoleModal").fadeIn(200);
    $scope.loadRoleList();
  };

  $scope.loadRoleList = function () {
    $scope.promise = $q(function (resolve, reject) {
      userService.getRoles(null, function (returnObject) {
        $scope.rolesSearchList = returnObject;
        for (var i = 0; i < $scope.rolesSearchList.length; i++) {
          if ($scope.existingRoles && $scope.existingRoles.indexOf($scope.rolesSearchList[i].id) != -1) {
            $scope.rolesSearchList[i].assigned = true;
          }
        }
        resolve('Done');
      }, function (err) {
        $scope.rolesSearchList = [];
        reject('Error');
      });
    });
  };

  $scope.closeRoleSelectList = function () {
    $scope.roleSelectCallback(null);
    $("#selectRoleModal").fadeOut(100);
  };

  $scope.desktopSelectRoleContinue = function () {
    $scope.roleSelectCallback($scope.desktopSelected);
    $("#selectRoleModal").fadeOut(100);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "jhP4":
/***/ (function(module, exports) {

var path = 'views/modals/editOrgModal.html';
var html = "<div class=\"niceModal desktopSelector newCompanyModal hasMobileVersion\" id=\"editOrgModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>New Company</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeOrgEditModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeOrgEditModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            New Company\n          </div>\n          <div class=\"right text\">\n\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- End Headers -->\n    <div class=\"progressBar\">\n      <div class=\"progressBarInner\" ng-if=\"newCompany.process != 'success' && newCompany.process != 'selectHelpMethod' && newCompany.process != 'aloneCongratulations'\">\n        <md-progress-linear md-mode=\"determinate\" value=\"{{(newCompany.currentStep / newCompany.stepCount) * 100}}\"></md-progress-linear>\n      </div>\n      <div class=\"successBar\" ng-if=\"newCompany.process == 'success' || newCompany.process == 'selectHelpMethod' || newCompany.process == 'aloneCongratulations'\">\n        <div class=\"left\"></div>\n        <div class=\"right\">\n          <h2>Congratulations! Your company has been created.</h2>\n          <h4>Welcome aboard, its time to go paperless!</h4>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"editOrgFormStep1\" novalidate ng-if=\"newCompany.process == 'form' && newCompany.currentStep == 1\" ng-submit=\"newCompanyNext()\">\n        <h2>First, what is the name of your company?</h2>\n        <h4>Don't worry, you can always change this later</h4>\n\n        <div class=\"inputGrouping\">\n          <md-input-container class=\"md-block\">\n            <label>Company Name</label>\n            <input type=\"text\" ng-model=\"newCompany.name\" aria-label=\"Company Name\" required=\"true\">\n          </md-input-container>\n        </div>\n\n        <div class=\"footerButtons\">\n          <button class=\"dbButton lightBlue\" ng-click=\"editOrgFormStep1.$invalid || newCompanyNext()\" ng-disabled=\"editOrgFormStep1.$invalid\">Continue</button>\n        </div>\n      </form>\n\n      <form id=\"editOrgFormStep2\" name=\"editOrgFormStep2\" novalidate ng-if=\"newCompany.process == 'form' && newCompany.currentStep == 2\" ng-submit=\"newCompanyNext()\">\n        <h2>Great, what is your company address?</h2>\n        <h4>Search for your address below and we will find it for you!</h4>\n\n        <div class=\"enterManualAddress\">\n          <a ng-click=\"newCompanyManualAddress()\" ng-if=\"!newCompany.showFullAddress\">Enter address manually</a>\n          <a ng-click=\"newCompanyManualAddress()\" ng-if=\"newCompany.showFullAddress\">Let me search for address</a>\n        </div>\n\n        <div class=\"inputGrouping\" ng-if=\"!newCompany.showFullAddress\">\n          <div class=\"group noTopMargin\">\n            <input id=\"location\" type=\"text\" name=\"location\" ng-model=\"newCompany.location\" address-model=\"newCompany.address\" class=\"{{newCompany.location != null ? 'ng-dirty' : ''}}\" googleplace placeholder=\"\">\n            <span class=\"highlight\"></span>\n            <span class=\"bar\"></span>\n            <label>Search Address</label>\n          </div>\n        </div>\n\n        <inline-alert class=\"margin-bottom-big\" type=\"warning\" ng-if=\"newCompany.addressAlert\">We didn't recognise this address - please try again or enter the address manually.</inline-alert>\n\n        <div class=\"addressGrouping\" ng-show=\"newCompany.showFullAddress\">\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Unit Number</label>\n              <input type=\"text\" ng-model=\"newCompany.address.num\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Number</label>\n              <input type=\"text\" ng-model=\"newCompany.address.streetNum\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Name</label>\n              <input type=\"text\" ng-model=\"newCompany.address.streetName\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Suburb</label>\n              <input type=\"text\" ng-model=\"newCompany.address.suburb\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>State</label>\n              <input type=\"text\" ng-model=\"newCompany.address.state\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Post Code</label>\n              <input type=\"text\" ng-model=\"newCompany.address.postCode\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Country</label>\n              <input type=\"text\" ng-model=\"newCompany.address.country\" required>\n            </md-input-container>\n          </div>\n        </div>\n\n        <div class=\"footerButtons additionalTopMargin\">\n          <div class=\"dbButton grey rightMargin\" ng-click=\"newCompanyBack()\">Back</div>\n          <button type=\"submit\" class=\"dbButton lightBlue\" ng-click=\"editOrgFormStep2.$invalid || newCompanyNext()\" ng-disabled=\"editOrgFormStep2.$invalid\">Continue</button>\n        </div>\n      </form>\n\n      <form id=\"editOrgFormStep3\" name=\"editOrgFormStep3\" novalidate ng-if=\"newCompany.process == 'form' && newCompany.currentStep == 3\" ng-submit=\"createNewCompany()\">\n        <h2>Lastly, what is your company contact?</h2>\n        <h4>A mobile or landline number, in case we need to contact you.</h4>\n\n        <div class=\"inputGrouping\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n            <label>Phone Number</label>\n            <input type=\"text\" ng-model=\"newCompany.contactNumber\" required>\n          </md-input-container>\n        </div>\n\n        <div class=\"footerButtons additionalTopMargin\">\n          <div class=\"dbButton grey rightMargin\" ng-click=\"newCompanyBack()\">Back</div>\n          <button class=\"dbButton lightBlue\" ng-click=\"editOrgFormStep3.$invalid || createNewCompany()\" ng-disabled=\"editOrgFormStep3.$invalid\">Continue</button>\n        </div>\n      </form>\n\n      <form id=\"editOrgFormStep4\" name=\"editOrgFromStep4\" novalidate ng-if=\"newCompany.process == 'creating'\">\n        <h2>Hang tight, your company is being created...</h2>\n        <h4>You'll be creating dockets in minutes</h4>\n\n        <div class=\"savingProgressCircular\">\n          <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"150px\"></md-progress-circular>\n        </div>\n      </form>\n\n      <form name=\"editOrgFormSuccess\" novalidate ng-if=\"newCompany.process == 'success'\">\n        <h2>How would you like to finish setting up your company?</h2>\n        <h4 class=\"successMoreMessage\">There's a bit more to setting up a company. You will need to design what your Dockets look like, add what items can go on your Dockets and who you will be sending Dockets to.</h4>\n\n        <div class=\"setupOptionsOuter\">\n          <div class=\"setupOption\">\n            <h3>I want a Docketbook team member to help me.</h3>\n\n            <h4>We will walk you through the steps. Its free!</h4>\n\n            <div class=\"buttonContainer\">\n              <div class=\"dbButton lightBlue\" ng-click=\"newCompanySetupContinue('advisor')\">\n                Next\n              </div>\n            </div>\n          </div>\n          <div class=\"setupOption\">\n            <h3>I will set it up on my own.</h3>\n\n            <h4>There's plenty of help guides if you do get stuck!</h4>\n\n            <div class=\"buttonContainer\">\n              <div class=\"dbButton lightBlue\" ng-click=\"newCompanySetupContinue('alone')\">\n                Next\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n\n      <form name=\"editOrgFormSelectHelp\" novalidate ng-if=\"newCompany.process == 'selectHelpMethod' && newCompany.helpMethodStep == 'select'\">\n        <h2>How would you like us to help you?</h2>\n        <h4 class=\"successMoreMessage\">Get the help you need to start making dockets.</h4>\n\n        <div class=\"setupOptionsOuter\">\n          <div class=\"setupOption\">\n            <div class=\"setupOptionIcon phone\"></div>\n            <h3 class=\"iconAbove\">Call Me</h3>\n\n            <h4>We will call you, when it suits you.</h4>\n\n            <div class=\"buttonContainer\">\n              <div class=\"dbButton lightBlue\" ng-click=\"newCompanyHelpMethodSelect('phone')\">\n                Next\n              </div>\n            </div>\n          </div>\n          <div class=\"setupOption\">\n            <div class=\"setupOptionIcon email\"></div>\n            <h3 class=\"iconAbove\">Email Me</h3>\n\n            <h4>We will email you to arrange support.</h4>\n\n            <div class=\"buttonContainer\">\n              <div class=\"dbButton lightBlue\" ng-click=\"newCompanyHelpMethodSelect('email')\">\n                Next\n              </div>\n            </div>\n          </div>\n          <div class=\"setupOption\">\n            <div class=\"setupOptionIcon intercom\"></div>\n            <h3 class=\"iconAbove\">Message Me</h3>\n\n            <h4>Get help through our in app chat service.</h4>\n\n            <div class=\"buttonContainer\">\n              <div class=\"dbButton lightBlue\" ng-click=\"newCompanyHelpMethodSelect('intercom')\">\n                Next\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n\n      <form name=\"editOrgFormConfirmHelp\" novalidate ng-if=\"newCompany.process == 'selectHelpMethod' && newCompany.helpMethodStep == 'confirm'\">\n        <h2>Welcome to Docketbook!</h2>\n        <h4 class=\"lastStepSubhead\">A Docketbook team member will be in touch to arrange your setup. In the mean time, feel free to have a look around.</h4>\n\n        <p>To read help articles about setting up your new Company <a href=\"http://help.docketbook.com.au\" target=\"_blank\">click here.</a></p>\n\n        <div class=\"footerButtons additionalTopMargin\">\n          <div class=\"dbButton lightBlue\" ng-click=\"editOrgFormConfirmHelp.$invalid || helpMethodFinish()\" ng-disabled=\"editOrgFormConfirmHelp.$invalid\">Continue</div>\n        </div>\n      </form>\n\n      <form name=\"editOrgFormConfirmHelp\" novalidate ng-if=\"newCompany.process == 'aloneCongratulations'\">\n        <h2>Welcome to Docketbook!</h2>\n        <h4 class=\"lastStepSubhead\">The company we have created for you has all the basics to get started. Remember, if you need any help we are here!</h4>\n\n        <p>To read help articles about setting up your new Company <a href=\"http://help.docketbook.com.au\" target=\"_blank\">click here.</a></p>\n\n        <div class=\"footerButtons additionalTopMargin\">\n          <div class=\"dbButton lightBlue\" ng-click=\"newCompanySetupAloneFinish()\">Continue</div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "jjR3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logout.svg";

/***/ }),

/***/ "jqQR":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/orderDetail.html';
var html = "<div class=\"ojdDesktopDetailOuter\">\n  <form name=\"orderDetailForm\" class=\"orderDetailForm\">\n    <div class=\"ojdDesktopSection header white\">\n      <div class=\"headerTitle\">\n        <h1 ng-if=\"itemEdit.orderNumber\">{{itemEdit.orderNumber}}</h1>\n        <h1 ng-if=\"!itemEdit.orderNumber\">Pending</h1>\n      </div>\n\n      <div class=\"bulkActionsButtons\">\n        <div class=\"dbButton\" ng-click=\"editOrder(itemEdit)\" ng-if=\"userCanDoAction('editOrder', itemEdit) && !itemEdit.loading\">\n          Edit\n        </div>\n        <div class=\"dbButton grey rightMargin\" ng-if=\"itemEdit.editing\" ng-click=\"cancelEditOrder(itemEdit)\">\n          Cancel\n        </div>\n        <div class=\"dbButton\" ng-click=\"saveOrder(itemEdit)\" ng-if=\"userCanDoAction('saveOrder', itemEdit) && !itemEdit.loading\">\n          Save\n        </div>\n        <md-menu ng-show=\"!itemEdit.loading\">\n          <md-button aria-label=\"More Order Actions Menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" aria-label=\"More Options\">\n            <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-show=\"userCanDoAction('reDraftOrder', itemEdit)\" ng-click=\"reDraftOrder(itemEdit)\" aria-label=\"Re Draft Order\">\n              <md-button>\n                Re-Draft Order\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userCanDoAction('sendOrder', itemEdit)\" ng-click=\"sendOrder(itemEdit)\" aria-label=\"Send Order\">\n              <md-button>\n                Send Order\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userCanDoAction('acceptOrder', itemEdit)\" ng-click=\"acceptOrder(itemEdit)\" aria-label=\"Accept Order\">\n              <md-button>\n                Accept Order\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userCanDoAction('rejectOrder', itemEdit)\" ng-click=\"rejectOrder(itemEdit)\" aria-label=\"Reject Order\">\n              <md-button>\n                Reject Order\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userCanDoAction('finishOrder', itemEdit)\" ng-click=\"finishOrder(itemEdit)\" aria-label=\"Finish Order\">\n              <md-button>\n                Close Order\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-click=\"shareOrder(itemEdit)\" aria-label=\"Share Order\">\n              <md-button>\n                Share Order\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userCanDoAction('deleteOrder', itemEdit)\" ng-click=\"deleteOrder(itemEdit)\" aria-label=\"Delete Order\">\n              <md-button>\n                Delete Order\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n        <md-button class=\"md-icon-button\" aria-label=\"Close Order Detail\" ng-click=\"closeOrderDesktop(itemEdit)\" aria-label=\"Close Order Detail\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"desktopLoaderUnder\" ng-if=\"itemEdit.loading || itemEdit.orderLoadingError\">\n      <div my-loader text=\"Loading Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n      <div my-loader text=\"Saving Order\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n      <div class=\"stdLoader\" ng-show=\"orderLoadingError != null\">\n        <div class=\"desktopLoaderHeader\">\n          <div class=\"bulkActionsButtons\">\n            <md-button class=\"md-icon-button\" aria-label=\"Close Order Detail\" ng-click=\"closeOrderDesktop(itemEdit)\">\n              <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n            </md-button>\n          </div>\n        </div>\n        <div class=\"loaderOuterContainer\">\n          <div class=\"loaderInnerContainer\">\n            <div class=\"materialSpinner\">\n              <md-icon md-svg-src=\"error.svg\"></md-icon>\n            </div>\n            <div class=\"loadingText\">\n              {{orderLoadingError}}\n            </div>\n            <div class=\"loadingRetryButton\">\n              <div class=\"dbButton grey margin-right\" ng-click=\"openOrderDesktop(currentOrder)\">Retry</div>\n              <div class=\"dbButton grey\" ng-click=\"contactSupportError(orderLoadingErrorFull)\">Contact Support</div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <md-tabs md-selected=\"selectedIndex\" md-border-bottom md-autoselect class=\"docketTabsInner\">\n      <md-tab label=\"Order\">\n        <div class=\"docketTab\">\n          <ng-include src=\"'views/pages/orders/desktop/orderTab.html'\"></ng-include>\n        </div>\n      </md-tab>\n      <md-tab label=\"Jobs ({{itemEdit.jobs.length >= 10 ? '10+' : itemEdit.jobs.length}})\">\n        <div class=\"docketTab\">\n          <ng-include src=\"'views/pages/orders/desktop/jobsTab.html'\"></ng-include>\n        </div>\n      </md-tab>\n      <md-tab label=\"Dockets ({{itemEdit.dockets.length >= 1000000 ? '10+' : itemEdit.dockets.length}})\">\n        <div class=\"docketTab\">\n          <ng-include src=\"'views/pages/orders/desktop/docketsTab.html'\"></ng-include>\n        </div>\n      </md-tab>\n      <md-tab label=\"Audit Log\">\n        <div class=\"docketTab\">\n          <ng-include src=\"'views/pages/orders/desktop/auditLogTab.html'\"></ng-include>\n        </div>\n      </md-tab>\n    </md-tabs>\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "k1Tr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-144x144.png";

/***/ }),

/***/ "kDIr":
/***/ (function(module, exports) {

var path = 'views/modals/shareOrderModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"shareOrderModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Share Order</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeAccessControlModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeAccessControlModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n              Share Order\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"saveAccessControlEdit(accessControlEdit)\">Save</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"\" novalidate>\n        <div class=\"modalFormMobileHeader\">\n          <div class=\"row1\">\n            <div class=\"to\">\n              <strong>To:</strong>\n            </div>\n            <div class=\"email\">\n              <input type=\"text\" placeholder=\"Email or Phone Number\" ng-model=\"newAccessor.emailAddress\">\n            </div>\n            <div class=\"selector\">\n              <md-button class=\"md-icon-button\" ng-click=\"selectAccessorContact()\" aria-label=\"Select Person\">\n                <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"row1\">\n            <div class=\"to\">\n              <strong>Role:</strong>\n            </div>\n            <div class=\"select\">\n              <md-select ng-model=\"newAccessor.accessLevel\" aria-label=\"Select access level\">\n                <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(newAccessor, 'viewer')\">\n                  Viewer\n                </md-option>\n              </md-select>\n            </div>\n          </div>\n          <div class=\"row1\">\n            <div class=\"add\">\n              <div class=\"dbButton lightBlue\" ng-click=\"addNewAccessor(newAccessor)\" ng-disabled=\"newAccessor.emailAddress == '' || newAccessor.emailAddress == null\">\n                Add\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modalFormTableHeader slimline\">\n          <div class=\"to\">\n            <strong>To:</strong>\n          </div>\n          <div class=\"email\">\n            <input type=\"text\" placeholder=\"Email or Phone Number\" ng-model=\"newAccessor.emailAddress\">\n          </div>\n          <div class=\"selector\">\n            <md-button class=\"md-icon-button\" ng-click=\"selectAccessorContact()\" aria-label=\"Select Person\">\n              <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n            </md-button>\n          </div>\n          <div class=\"select\">\n            <md-select ng-model=\"newAccessor.accessLevel\" aria-label=\"Select access level\">\n              <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(newAccessor, 'viewer')\">\n                Viewer\n              </md-option>\n            </md-select>\n          </div>\n          <div class=\"add\">\n            <div class=\"dbButton lightBlue\" ng-click=\"addNewAccessor(newAccessor)\" ng-disabled=\"newAccessor.emailAddress == '' || newAccessor.emailAddress == null\">\n              Add\n            </div>\n          </div>\n        </div>\n        <div class=\"modalFormTable\">\n          <md-table-container>\n            <table md-table ng-show=\"accessControlEdit.accessControl.length > 0\">\n              <tbody md-body ng-repeat=\"accessor in accessControlEdit.accessControl\">\n                <form name=\"innerForm\">\n                  <tr md-row class=\"{{accessor.accessLevel=='remove'?'disabled remove':''}}\">\n                    <td md-cell>\n                      {{accessor.emailAddress}}\n                    </td>\n                    <td md-cell>\n                      <md-select ng-model=\"accessor.accessLevel\" ng-disabled=\"accessor.accessLevelSet || accessor.isSupplier || accessor.isUser || !canChangeAccessLevel(accessor)\">\n                        <md-option value=\"creator\" ng-show=\"accessor.accessLevelSet\">\n                          Creator\n                        </md-option>\n                        <md-option value=\"supplier\" ng-show=\"accessor.accessLevelSet\">\n                          Supplier\n                        </md-option>\n                        <md-option value=\"customer\" ng-show=\"accessor.accessLevelSet\">\n                          Customer\n                        </md-option>\n                        <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(accessor, 'viewer')\">\n                          Viewer\n                        </md-option>\n                        <md-option value=\"remove\" ng-show=\"canSetAccessLevel(accessor,'remove')\">\n                          Remove\n                        </md-option>\n                      </md-select>\n                    </td>\n                  </tr>\n                </form>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeAccessControlModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"accessControlEdit.loading || saveAccessControlEdit(accessControlEdit)\" ng-disabled=\"accessControlEdit.loading\">\n            <span ng-hide=\"accessControlEdit.loading\">Save</span>\n            <md-progress-circular ng-show=\"accessControlEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "kHHu":
/***/ (function(module, exports) {

var path = 'views/pages/filing/mobile/list.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"docketsLoading || filingLoadingError\">\n  <div my-loader text=\"Loading Docket Files\" ng-if=\"docketsLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"filingLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{filingLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <div class=\"dbButton simpleOutline\" ng-click=\"loadFilingIntoList()\">Retry</div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"contentList paddingWithoutTabBar tabBarBottomPadding\">\n  <div class=\"customListRowOuter\" ng-repeat=\"item in listItems\" id=\"listItem{{item.id}}\" ui-sref=\"main.groupFilingDetail({orgId:currentOrg.id, groupId:currentOrgGroup.id,docketId:item.id})\">\n    <div class=\"customListRow {{itemEdit.id == item.id ? 'selected' : ''}}\">\n      <!--<div class=\"listRowItem checkbox\">\n        <div class=\"group tableCheckbox\">\n          <input type=\"checkbox\" name=\"name\" ng-model=\"item.selected\">\n          <div class=\"box\" ng-click=\"toggleRowItem(item)\"><div class=\"check\"></div></div>\n        </div>\n      </div>-->\n      <div class=\"listRowItem status\">\n        <div class=\"statusDisplay Draft\" ng-show=\"!item.existingDocketFile\">Unfiled</div>\n        <div class=\"statusDisplay Completed\" ng-show=\"item.existingDocketFile\">Filed</div>\n      </div>\n      <div class=\"listRowItem itemNumber\">{{item.docketNumber}}</div>\n      <div class=\"listRowItem collapsedDetail showCollapsed\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n            <div class=\"inner\">\n              <span ng-show=\"item.supplierContact\">{{item.supplierContact.displayName}}</span> -\n              <span ng-show=\"item.customerContact\">{{item.customerContact.displayName}}</span>\n            </div>\n          </div>\n          <div class=\"right\">{{moment(item.date).format('DD/MM')}}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"customListRowOuter hidden\" id=\"filingLoadingMore\">\n    <div class=\"customListRow loadingRow\">\n      <div class=\"progressOuter\">\n        <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n      </div>\n      Loading More Dockets\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "kVWY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "checklist.svg";

/***/ }),

/***/ "kVoJ":
/***/ (function(module, exports) {

var path = 'views/alerts/alertTemplate.html';
var html = "<div class=\"alertOuterContainer {{alert.type}}\" id=\"alert\">\n  <div class=\"alertVerticalContainer\">\n    <div class=\"alertInnerContainer\">\n      <div class=\"alertHeader\">\n        <div class=\"alertHeaderIcon\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n        </div>\n      </div>\n      <div class=\"alertContent\">\n        <h1 ng-if=\"alert && alert.title\">{{alert.title}}</h1>\n        <p ng-if=\"alert && alert.message\">{{alert.message}}</p>\n        <div class=\"fieldsList\" ng-if=\"alert.fields && alert.fields.length > 0\">\n          <div class=\"field warning\" ng-repeat=\"field in alert.fields\">\n            <md-icon md-svg-src=\"error.svg\"></md-icon>\n            {{field}}\n          </div>\n        </div>\n      </div>\n      <div class=\"alertFooter\" ng-if=\"alert.alertButtons == null || alert.alertButtons.length <= 0\">\n        <div class=\"dbButton alertButton\" ng-click=\"closeAlert()\">\n          Ok\n        </div>\n        <div class=\"dbButton grey leftMargin\" ng-click=\"contactSupportError(alert.supportError)\" ng-if=\"alert.showSupportButton\">\n          Contact Support\n        </div>\n      </div>\n      <div class=\"alertFooter\" ng-if=\"alert.alertButtons != null && alert.alertButtons.length > 0\">\n        <div class=\"dbButton {{button.colour}} rightMargin\" ng-click=\"alertButtonPress(button.action)\" ng-repeat=\"button in alert.alertButtons\">\n          {{button.title}}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "kvq9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lL5X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "multiline-field.svg";

/***/ }),

/***/ "lVK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__("eslX");

var _app2 = _interopRequireDefault(_app);

__webpack_require__("Jmt5");

__webpack_require__("yP4K");

__webpack_require__("3Rdy");

__webpack_require__("vRU/");

__webpack_require__("eqjP");

__webpack_require__("nA7g");

__webpack_require__("vBgc");

__webpack_require__("eKDo");

__webpack_require__("ffP+");

__webpack_require__("oxWV");

__webpack_require__("nsjd");

__webpack_require__("+oZI");

__webpack_require__("M1wf");

__webpack_require__("Vr5B");

__webpack_require__("S2WM");

__webpack_require__("ioen");

__webpack_require__("GFrL");

__webpack_require__("2gQD");

__webpack_require__("dqTQ");

__webpack_require__("QpJk");

__webpack_require__("/WbT");

__webpack_require__("XOs8");

__webpack_require__("+qg2");

__webpack_require__("Wa4Q");

__webpack_require__("hEss");

__webpack_require__("RQoQ");

__webpack_require__("EjBE");

__webpack_require__("kvq9");

__webpack_require__("ubCb");

__webpack_require__("0v67");

__webpack_require__("cFdt");

var _googleplace = __webpack_require__("52ha");

var _googleplace2 = _interopRequireDefault(_googleplace);

var _accessControl = __webpack_require__("QkGc");

var _accessControl2 = _interopRequireDefault(_accessControl);

var _formatHelper = __webpack_require__("8sn0");

var _formatHelper2 = _interopRequireDefault(_formatHelper);

var _splitListInterface = __webpack_require__("mhVA");

var _splitListInterface2 = _interopRequireDefault(_splitListInterface);

var _addressBookService = __webpack_require__("o32f");

var _addressBookService2 = _interopRequireDefault(_addressBookService);

var _alertService = __webpack_require__("a6LV");

var _alertService2 = _interopRequireDefault(_alertService);

var _batchService = __webpack_require__("QUy+");

var _batchService2 = _interopRequireDefault(_batchService);

var _docketService = __webpack_require__("s16B");

var _docketService2 = _interopRequireDefault(_docketService);

var _jobService = __webpack_require__("atOe");

var _jobService2 = _interopRequireDefault(_jobService);

var _orderService = __webpack_require__("fZNG");

var _orderService2 = _interopRequireDefault(_orderService);

var _resourceService = __webpack_require__("5Cpe");

var _resourceService2 = _interopRequireDefault(_resourceService);

var _userService = __webpack_require__("ZOX0");

var _userService2 = _interopRequireDefault(_userService);

var _xeroService = __webpack_require__("ylxt");

var _xeroService2 = _interopRequireDefault(_xeroService);

var _billingService = __webpack_require__("1UHj");

var _billingService2 = _interopRequireDefault(_billingService);

var _loading = __webpack_require__("Rmmh");

var _loading2 = _interopRequireDefault(_loading);

var _scopeNav = __webpack_require__("8YUy");

var _scopeNav2 = _interopRequireDefault(_scopeNav);

var _trialBannerController = __webpack_require__("HWVN");

var _trialBannerController2 = _interopRequireDefault(_trialBannerController);

var _selectContactController = __webpack_require__("lbWa");

var _selectContactController2 = _interopRequireDefault(_selectContactController);

var _selectQuoteController = __webpack_require__("7o4S");

var _selectQuoteController2 = _interopRequireDefault(_selectQuoteController);

var _editContactController = __webpack_require__("cfCM");

var _editContactController2 = _interopRequireDefault(_editContactController);

var _newOrgModalController = __webpack_require__("clRN");

var _newOrgModalController2 = _interopRequireDefault(_newOrgModalController);

var _acceptOrderWizardModalController = __webpack_require__("+zWA");

var _acceptOrderWizardModalController2 = _interopRequireDefault(_acceptOrderWizardModalController);

var _recommendLineItemResourceModalController = __webpack_require__("BN4o");

var _recommendLineItemResourceModalController2 = _interopRequireDefault(_recommendLineItemResourceModalController);

var _editUserModalController = __webpack_require__("+RIn");

var _editUserModalController2 = _interopRequireDefault(_editUserModalController);

var _editUserGroupRolesModalController = __webpack_require__("Nqrr");

var _editUserGroupRolesModalController2 = _interopRequireDefault(_editUserGroupRolesModalController);

var _importContactsModalController = __webpack_require__("RxaN");

var _importContactsModalController2 = _interopRequireDefault(_importContactsModalController);

var _importResourcesModalController = __webpack_require__("X0lI");

var _importResourcesModalController2 = _interopRequireDefault(_importResourcesModalController);

var _assignJobModalController = __webpack_require__("vbfD");

var _assignJobModalController2 = _interopRequireDefault(_assignJobModalController);

var _acceptConnectionRequestModalController = __webpack_require__("X+VU");

var _acceptConnectionRequestModalController2 = _interopRequireDefault(_acceptConnectionRequestModalController);

var _createConnectionModalController = __webpack_require__("A3Uk");

var _createConnectionModalController2 = _interopRequireDefault(_createConnectionModalController);

var _dashboard = __webpack_require__("U+TM");

var _dashboard2 = _interopRequireDefault(_dashboard);

var _navigation = __webpack_require__("x+gH");

var _navigation2 = _interopRequireDefault(_navigation);

var _mainTemplateController = __webpack_require__("TXFk");

var _mainTemplateController2 = _interopRequireDefault(_mainTemplateController);

var _admin = __webpack_require__("BLrg");

var _admin2 = _interopRequireDefault(_admin);

var _general = __webpack_require__("5xBt");

var _general2 = _interopRequireDefault(_general);

var _xeroConnectController = __webpack_require__("droZ");

var _xeroConnectController2 = _interopRequireDefault(_xeroConnectController);

var _selectRoleController = __webpack_require__("jgC+");

var _selectRoleController2 = _interopRequireDefault(_selectRoleController);

var _selectPersonController = __webpack_require__("LrPF");

var _selectPersonController2 = _interopRequireDefault(_selectPersonController);

var _admins = __webpack_require__("RwwX");

var _admins2 = _interopRequireDefault(_admins);

var _filing = __webpack_require__("rsN3");

var _filing2 = _interopRequireDefault(_filing);

var _billing = __webpack_require__("UKje");

var _billing2 = _interopRequireDefault(_billing);

var _users = __webpack_require__("KM5U");

var _users2 = _interopRequireDefault(_users);

var _groups = __webpack_require__("PCVv");

var _groups2 = _interopRequireDefault(_groups);

var _roles = __webpack_require__("4atT");

var _roles2 = _interopRequireDefault(_roles);

var _templates = __webpack_require__("zVOU");

var _templates2 = _interopRequireDefault(_templates);

var _designer = __webpack_require__("pDjR");

var _designer2 = _interopRequireDefault(_designer);

var _fields = __webpack_require__("69jr");

var _fields2 = _interopRequireDefault(_fields);

var _checklists = __webpack_require__("1rFi");

var _checklists2 = _interopRequireDefault(_checklists);

var _resources = __webpack_require__("2R8v");

var _resources2 = _interopRequireDefault(_resources);

var _resourceCategories = __webpack_require__("cdph");

var _resourceCategories2 = _interopRequireDefault(_resourceCategories);

var _uoms = __webpack_require__("7F0w");

var _uoms2 = _interopRequireDefault(_uoms);

var _desktopController = __webpack_require__("B49T");

var _desktopController2 = _interopRequireDefault(_desktopController);

var _detailController = __webpack_require__("hxIT");

var _detailController2 = _interopRequireDefault(_detailController);

var _listController = __webpack_require__("rwyj");

var _listController2 = _interopRequireDefault(_listController);

var _mobileDetailController = __webpack_require__("oqLE");

var _mobileDetailController2 = _interopRequireDefault(_mobileDetailController);

var _selectResourceController = __webpack_require__("vXZX");

var _selectResourceController2 = _interopRequireDefault(_selectResourceController);

var _selectTemplateController = __webpack_require__("mPwe");

var _selectTemplateController2 = _interopRequireDefault(_selectTemplateController);

var _desktopController3 = __webpack_require__("HqXb");

var _desktopController4 = _interopRequireDefault(_desktopController3);

var _detailController3 = __webpack_require__("ruCM");

var _detailController4 = _interopRequireDefault(_detailController3);

var _listController3 = __webpack_require__("uswO");

var _listController4 = _interopRequireDefault(_listController3);

var _mobileDetailController3 = __webpack_require__("0wnD");

var _mobileDetailController4 = _interopRequireDefault(_mobileDetailController3);

var _selectLineController = __webpack_require__("ZnTr");

var _selectLineController2 = _interopRequireDefault(_selectLineController);

var _selectOrderController = __webpack_require__("xYZX");

var _selectOrderController2 = _interopRequireDefault(_selectOrderController);

var _desktopController5 = __webpack_require__("Knd3");

var _desktopController6 = _interopRequireDefault(_desktopController5);

var _detailController5 = __webpack_require__("FY7D");

var _detailController6 = _interopRequireDefault(_detailController5);

var _listController5 = __webpack_require__("X5Gh");

var _listController6 = _interopRequireDefault(_listController5);

var _mobileDetailController5 = __webpack_require__("Om0b");

var _mobileDetailController6 = _interopRequireDefault(_mobileDetailController5);

var _desktopController7 = __webpack_require__("f8wG");

var _desktopController8 = _interopRequireDefault(_desktopController7);

var _listController7 = __webpack_require__("h7J8");

var _listController8 = _interopRequireDefault(_listController7);

var _detailController7 = __webpack_require__("JQ6r");

var _detailController8 = _interopRequireDefault(_detailController7);

var _mobileDetailController7 = __webpack_require__("gANg");

var _mobileDetailController8 = _interopRequireDefault(_mobileDetailController7);

var _batchListController = __webpack_require__("Cld2");

var _batchListController2 = _interopRequireDefault(_batchListController);

var _batchDetailController = __webpack_require__("KYo1");

var _batchDetailController2 = _interopRequireDefault(_batchDetailController);

var _selectJobController = __webpack_require__("+3UW");

var _selectJobController2 = _interopRequireDefault(_selectJobController);

var _selectXeroContactController = __webpack_require__("cB/W");

var _selectXeroContactController2 = _interopRequireDefault(_selectXeroContactController);

var _interactionModalController = __webpack_require__("QU81");

var _interactionModalController2 = _interopRequireDefault(_interactionModalController);

var _signatureModalController = __webpack_require__("no4E");

var _signatureModalController2 = _interopRequireDefault(_signatureModalController);

var _checklistModalController = __webpack_require__("G7y8");

var _checklistModalController2 = _interopRequireDefault(_checklistModalController);

var _desktopController9 = __webpack_require__("CLCx");

var _desktopController10 = _interopRequireDefault(_desktopController9);

var _contacts = __webpack_require__("+XAm");

var _contacts2 = _interopRequireDefault(_contacts);

var _connectionsController = __webpack_require__("I/pv");

var _connectionsController2 = _interopRequireDefault(_connectionsController);

var _mobileListController = __webpack_require__("Ypfo");

var _mobileListController2 = _interopRequireDefault(_mobileListController);

var _lineItemModalController = __webpack_require__("BjMu");

var _lineItemModalController2 = _interopRequireDefault(_lineItemModalController);

var _selectActivityController = __webpack_require__("2pEn");

var _selectActivityController2 = _interopRequireDefault(_selectActivityController);

var _fieldModalController = __webpack_require__("PrNh");

var _fieldModalController2 = _interopRequireDefault(_fieldModalController);

var _newGroupModalController = __webpack_require__("Z20f");

var _newGroupModalController2 = _interopRequireDefault(_newGroupModalController);

var _selectPlanController = __webpack_require__("wHY9");

var _selectPlanController2 = _interopRequireDefault(_selectPlanController);

var _preAuthDocketController = __webpack_require__("9bX9");

var _preAuthDocketController2 = _interopRequireDefault(_preAuthDocketController);

var _addressBookTags = __webpack_require__("dfBi");

var _addressBookTags2 = _interopRequireDefault(_addressBookTags);

var _selectOrderLineController = __webpack_require__("W/ff");

var _selectOrderLineController2 = _interopRequireDefault(_selectOrderLineController);

var _paywalledController = __webpack_require__("vKoR");

var _paywalledController2 = _interopRequireDefault(_paywalledController);

var _trialActivatedModalController = __webpack_require__("DPfz");

var _trialActivatedModalController2 = _interopRequireDefault(_trialActivatedModalController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "lbWa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectContactController', ['addressBookService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {

  // Initialise variables to be used
  $scope.contactSearch = "";
  $scope.contactSelectCallback = null;
  $scope.contactSearchList = [];
  $scope.contactSearchLoading = false;
  $scope.contactLoadingError = null;
  $scope.contactTagList = [];
  $scope.selectedContactTagFilter = {
    tags: []
  };

  $scope.loadTagList = function () {
    $scope.loadPromise = $q(function (resolve, reject) {
      addressBookService.getAddressBookTags({}, function (results) {
        $scope.contactTagList = results;
        resolve($scope.contactTagList);
      }, function (err) {
        $scope.contactTagList = [];
        reject('Error');
      });
    });
  };

  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'displayName'
  };
  $scope.contactsSelected = [];

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.contactSelectFromParent = function (existingContacts, selectedContactPre, cb) {
    $scope.contactModalMode = 'select';
    $scope.updateContactOnSelect = false;
    $scope.contactSearch = "";
    $scope.contactSelectCallback = cb;
    if (selectedContactPre != null) {
      var selectedContact = angular.copy(selectedContactPre);

      var initials = "";
      if (selectedContact.displayName) {
        var split = selectedContact.displayName.split(' ');
        if (split.length == 1) {
          initials = split[0].charAt(0).toUpperCase();
        } else if (split.length > 1) {
          initials = split[0].charAt(0).toUpperCase();
          initials += split[1].charAt(0).toUpperCase();
        }
      }
      selectedContact.initials = initials;
      $scope.selectContact(selectedContact);
    } else {
      $scope.contactDetail = null;
    }
    if (existingContacts) {
      $scope.existingContacts = existingContacts;
    } else {
      $scope.existingContacts = [];
    }
    if ($scope.device == 'mobile') {} else {
      $("#selectContactModal").fadeIn(100);
      $("input[name='searchContactInput']").focus();
    }
    $scope.loadTagList();
    $scope.loadContactSearchList();
  };

  $scope.$parent.updateContactFromParent = function (orgId, orgUnitId, share, cb) {
    $scope.contactModalMode = 'edit';
    $scope.contactSearch = "";
    $scope.contactDetail = null;
    $scope.existingContacts = [];
    $scope.contactCallback = cb;
    $scope.orgFor = orgId;
    $scope.orgUnitFor = orgUnitId;
    $("#selectContactModal").fadeIn(100);
    $("input[name='searchContactInput']").focus();
    $scope.loadContactSearchList();
    $scope.updateContactOnSelect = true;
    $scope.updateContactShare = share;
  };

  $scope.$parent.createContactFromParent = function (orgId, orgUnitId, share, cb) {
    $scope.contactModalMode = 'edit';
    $scope.contactCallback = cb;
    $scope.contactSearch = "";
    $scope.contactDetail = null;
    $scope.existingContacts = [];
    $scope.orgFor = orgId;
    $scope.orgUnitFor = orgUnitId;
    $("#selectContactModal").fadeIn(100);
    $("input[name='searchContactInput']").focus();
    $scope.loadContactSearchList();
    $scope.contactDetail = {};
    $scope.contactDetail.new = true;
    $scope.contactDetail.displayName = share.displayName;
    var initials = "";
    if ($scope.contactDetail.displayName) {
      var split = $scope.contactDetail.displayName.split(' ');
      if (split.length == 1) {
        initials = split[0].charAt(0).toUpperCase();
      } else if (split.length > 1) {
        initials = split[0].charAt(0).toUpperCase();
        initials += split[1].charAt(0).toUpperCase();
      }
    }
    $scope.contactDetail.initials = initials;
    if (share.addresses != null) {
      $scope.contactDetail.addresses = share.addresses;
    } else {
      $scope.contactDetail.addresses = [];
    }
    $scope.contactDetail.contactAddresses = [];
    for (var i = 0; i < share.contactAddresses.length; i++) {
      var newContact = { emailAddress: share.contactAddresses[i], accessLevel: 'viewer', selected: true };
      $scope.contactDetail.contactAddresses.push(newContact);
    }
  };

  $scope.createNewContact = function () {
    $scope.contactDetail = {};
    $scope.contactDetail.newFull = true;
    $scope.contactDetail.displayName = "";
    $scope.contactDetail.initials = "";
    $scope.contactDetail.addresses = [];
    $scope.contactDetail.contactAddresses = [];
  };

  $scope.saveContactEdit = function (contact) {
    contact.loading = true;

    // If contact is not new - format addresses array in add/update/remove format
    if (contact.id != null) {
      var newAddresses = { 'add': [], 'update': [] };
      if (contact.addresses && contact.addresses.length > 0) {
        if (contact.addressesBefore && contact.addressesBefore.length > 0) {
          var newAddressUpdate = contact.addresses[0];
          newAddressUpdate.id = contact.addressesBefore[0].id;
          newAddresses.update.push(newAddressUpdate);
        } else {
          newAddresses.add.push(contact.addresses[0]);
        }
      }
      contact.addresses = newAddresses;
    }

    // remove any new contactAddresses that are not selected
    var contactAddressesUpdated = [];
    for (var i = 0; i < contact.contactAddresses.length; i++) {
      if (contact.contactAddresses[i].new == true && contact.contactAddresses[i].selected == true || contact.contactAddresses[i].new != true) {
        delete contact.contactAddresses[i].new;
        contactAddressesUpdated.push(contact.contactAddresses[i]);
      }
    }
    contact.contactAddresses = contactAddressesUpdated;

    if ($scope.orgFor != null && $scope.orgUnitFor != null) {
      addressBookService.saveContactForUnit($scope.orgFor, $scope.orgUnitFor, contact, function (success) {
        $("#selectContactModal").fadeOut(100);
        $scope.contactCallback();
      });
    } else {
      addressBookService.saveContact(contact, function (success) {
        $("#selectContactModal").fadeOut(100);
        $scope.contactCallback();
      });
    }
  };

  $scope.loadContactSearchList = function (searchValue) {
    $scope.contactSearchLoading = true;
    $scope.promise = $q(function (resolve, reject) {
      var params = {};
      params.sort = "displayName";
      if (searchValue != null && searchValue != "") {
        params.search = searchValue;
      }
      var tags = $scope.selectedContactTagFilter.tags.map(function (tag) {
        return tag.tag;
      });
      if (tags && tags.length > 0) {
        params.tags = tags.join(',');
      }
      addressBookService.getAddressBookForUnit(params, function (addressBookFull) {
        $scope.contactSearchList = addressBookFull;
        $scope.contactSearchListFull = angular.copy(addressBookFull);
        for (var i = 0; i < $scope.contactSearchList.length; i++) {
          $scope.contactSearchList[i].existing = false;
          if ($scope.existingContacts && $scope.existingContacts.length > 0) {
            for (var j = 0; j < $scope.existingContacts.length; j++) {
              if ($scope.contactSearchList[i].id == $scope.existingContacts[j].id) {
                $scope.contactSearchList[i].existing = true;
                break;
              }
            }
          }

          var initials = "";
          if ($scope.contactSearchList[i].displayName) {
            var split = $scope.contactSearchList[i].displayName.split(' ');
            if (split.length == 1) {
              initials = split[0].charAt(0).toUpperCase();
            } else if (split.length > 1) {
              initials = split[0].charAt(0).toUpperCase();
              initials += split[1].charAt(0).toUpperCase();
            }
          }
          $scope.contactSearchList[i].initials = initials;
          var existingXeroContact = $scope.contactSearchList[i].externalIdentifiers.find(function (eid) {
            return eid.type === 'xero';
          });
          if (existingXeroContact) {
            $scope.contactSearchList[i].xeroContact = existingXeroContact;
          }
        }
        $scope.contactSearchList = Restangular.stripRestangular($scope.contactSearchList);
        $scope.contactSearchLoading = false;
        resolve('Done');
      }, function (err) {
        $scope.contactSearchLoading = false;
        $scope.contactLoadingError = "Error getting contacts";
        reject('Error');
      });
    });
  };

  $scope.selectContact = function (contact) {
    if ($scope.contactModalMode === 'edit' && !$scope.updateContactOnSelect) {
      return;
    }
    if (!contact.existing) {
      $scope.contactDetail = angular.copy(contact);
      for (var i = 0; i < $scope.contactDetail.contactAddresses.length; i++) {
        $scope.contactDetail.contactAddresses[i].tempId = uuid.v4();
        $scope.contactDetail.contactAddresses[i].selected = true;
      }
      //$scope.contactDetail.address = {};
      //if ( $scope.contactDetail.addresses != null && $scope.contactDetail.addresses[0] != null ) {
      //$scope.contactDetail.address = $scope.contactDetail.addresses[0];
      //}
    }

    if ($scope.updateContactOnSelect && $scope.updateContactShare) {
      // add details from share into this contact
      //$scope.contactDetail.displayName = $scope.updateContactShare.displayName;
      $scope.contactDetail.addressesBefore = angular.copy($scope.contactDetail.addresses);
      if ($scope.updateContactShare.addresses != null) {
        $scope.contactDetail.addresses = $scope.updateContactShare.addresses;
      }
      if ($scope.updateContactShare.contactAddresses != null) {
        for (var i = 0; i < $scope.updateContactShare.contactAddresses.length; i++) {
          var newContact = { 'emailAddress': $scope.updateContactShare.contactAddresses[i], 'accessLevel': 'viewer', selected: true, new: true };
          $scope.contactDetail.contactAddresses.push(newContact);
        }
      }
    }
  };

  $scope.desktopSelectContactContinue = function () {
    // convert addresses back
    var contactToSend = angular.copy($scope.contactDetail);
    //contactToSend.addresses = [];
    //if ( contactToSend.address && contactToSend.address.suburb != null && contactToSend.address.state != null && contactToSend.address.postCode != null ) {
    //contactToSend.addresses.push(contactToSend.address);
    //}

    // remove contacts that aren't selected
    contactToSend.contactAddresses = [];
    for (var i = 0; i < $scope.contactDetail.contactAddresses.length; i++) {
      if ($scope.contactDetail.contactAddresses[i].selected == true) {
        contactToSend.contactAddresses.push($scope.contactDetail.contactAddresses[i]);
      }
    }
    if ($scope.contactSelectCallback && typeof $scope.contactSelectCallback === 'function') {
      $scope.contactSelectCallback(contactToSend);
    }

    $("#selectContactModal").fadeOut(100);
  };

  $scope.mobileSelectContact = function (contact) {
    //$("#viewContactModal").fadeIn(100);
    if ($scope.contactSelectCallback && typeof $scope.contactSelectCallback === 'function') {
      $scope.contactSelectCallback(contact);
    }
    /*$scope.contactDetail = contact;
    $scope.contactDetail.editing = false;
    for ( var i = 0; i < $scope.contactDetail.contactAddresses.length; i++ ) {
      $scope.contactDetail.contactAddresses[i].tempId = uuid.v4();
      $scope.contactDetail.contactAddresses[i].selected = true;
    }
    $scope.contactDetail.address = {};
    if ( $scope.contactDetail.addresses != null && $scope.contactDetail.addresses[0] != null ) {
      $scope.contactDetail.address = $scope.contactDetail.addresses[0];
    }*/
  };

  $scope.mobileContactContinue = function (contact) {
    $("#viewContactModal").fadeOut(100);
    var contactToSend = $scope.contactDetail;
    contactToSend.addresses = [];
    contactToSend.addresses.push(contactToSend.address);
    if ($scope.contactSelectCallback && typeof $scope.contactSelectCallback === 'function') {
      $scope.contactSelectCallback(contactToSend);
    }
  };

  $scope.closeViewContactModal = function () {
    $("#viewContactModal").fadeOut(100);
  };

  $scope.closeContactSelectList = function () {
    $("#selectContactModal").fadeOut(100);
    if ($scope.contactSelectCallback && typeof $scope.contactSelectCallback === 'function') {
      $scope.contactSelectCallback(null);
    }
  };

  $scope.searchContactChange = function (searchText) {
    $scope.loadContactSearchList(searchText);
  };

  /* Mobile contact detail - edit contact */
  $scope.editContactDetails = function () {
    $scope.contactDetail.editing = true;
  };

  $scope.saveContactDetails = function () {
    $scope.contactDetail.editing = false;
  };

  /* Desktop Contact Select - Check selected contact valid */
  $scope.selectedContactIsValid = function (contactSelected) {
    var valid = false;

    if (contactSelected && contactSelected.contactAddresses) {
      var selectedCount = 0;
      for (var i = 0; i < contactSelected.contactAddresses.length; i++) {
        if (contactSelected.contactAddresses[i].selected) {
          selectedCount += 1;
        }
      }
      if (selectedCount > 0) {
        valid = true;
      }
    }

    return valid;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "lk0G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "error.svg";

/***/ }),

/***/ "m0E1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1.png";

/***/ }),

/***/ "mPWU":
/***/ (function(module, exports) {

var path = 'views/modals/selectPersonModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectPersonModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select People</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closePersonSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"searchBar\">\n        <div class=\"title\">\n          <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"bar\">\n          <input name=\"selectPersonInput\" type=\"text\" ng-model=\"personSearch\" placeholder=\"Search\" ng-change=\"searchPeopleChange(personSearch)\" ng-model-options='{debounce:1000}'>\n        </div>\n      </div>\n      <div class=\"noListMessage\" ng-show=\"personSearchList.length <= 0 && personSearchListFull.length <= 0\">\n        There are no people matching your search criteria.\n      </div>\n      <div class=\"noListMessage\" ng-show=\"personSearchList.length <= 0 && personSearchListFull.length > 0\">\n        There are no people matching your search criteria.\n      </div>\n      <md-table-container ng-show=\"personSearchList.length > 0\">\n        <table md-table multiple md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head md-order=\"query.order\" md-on-reorder=\"loadPeopleList\">\n            <tr md-row>\n              <th md-column md-order-by=\"first\">First</th>\n              <th md-column md-order-by=\"last\">Last</th>\n              <th md-column md-order-by=\"emailAddress\">Email Address</th>\n              <th md-column>Status</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"person in personSearchList\" md-select=\"person\" md-auto-select md-select-id=\"id\" ng-disabled=\"person.assigned\" class=\"{{ person.assigned ? 'disabled' : '' }}\" style=\"cursor: pointer;\">\n              <td md-cell>\n                {{person.name.first}}\n              </td>\n              <td md-cell>\n                {{person.name.last}}\n              </td>\n              <td md-cell>\n                {{person.emailAddress}}\n              </td>\n              <td md-cell>\n                <span ng-show=\"person.assigned\">Assigned</span>\n                <span ng-show=\"!person.assigned\">Not Assigned</span>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n      <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadPeopleList\" md-total=\"{{listCount}}\" md-page-select>\n\n      </md-table-pagination>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n          <span ng-show=\"desktopSelected.length > 1\">\n            {{desktopSelected.length}} people will be added.\n          </span>\n          <span ng-show=\"desktopSelected.length == 1\">\n            1 person will be added.\n          </span>\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closePersonSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || desktopSelectPeopleContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "mPwe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectTemplateController', ['docketService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', function (docketService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

  // Initialise variables to be used
  $scope.templateSearch = "";
  $scope.templateSearchLoading = false;
  $scope.templateSearchList = [];
  $scope.templateSearchListFull = [];
  $scope.templatsSearchCallback = null;
  $scope.listCount = 0;
  $scope.desktopSelected = [];

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.templateSelectFromParent = function (currentTemplate, cb) {
    if ($stateParams.device == 'desktop') {
      $("#selectTemplateModal").fadeIn(100);
    }
    $scope.templateSearch = "";
    $scope.templateSelected = currentTemplate;
    $scope.templateSearchLoading = false;
    $scope.templateSelectCallback = cb;
    $scope.desktopSelected = [];
    $scope.loadTemplateList();
  };

  $scope.assignTemplateToDocket = function (template) {
    docketService.getTemplate(template, function (templateFull) {
      $scope.templateSelectCallback(templateFull);
    }, function (err) {
      $scope.templateSelectCallback(template);
    });
  };

  $scope.closeTemplateSelectList = function () {
    $scope.templateSelectCallback(null);
    if ($stateParams.device == 'desktop') {
      $("#selectTemplateModal").fadeOut(100);
    }
  };

  $scope.desktopSelectTemplateContinue = function () {
    $scope.assignTemplateToDocket($scope.desktopSelected[0]);
    $("#selectTemplateModal").fadeOut(100);
  };

  $scope.loadTemplateList = function () {
    $scope.promise = $q(function (resolve, reject) {
      docketService.getTemplates({ "published": "true" }, function (allTemplates) {
        for (var i = 0; i < allTemplates.length; i++) {
          if (allTemplates[i].id == $scope.templateSelected.id) {
            allTemplates[i].existing = true;
          }
        }
        $scope.templateSearchList = allTemplates;
        $scope.templateSearchListFull = allTemplates;
        resolve('Done');
      }, function (err) {
        $scope.templateSearchList = [];
        $scope.templateSearchListFull = [];
        reject('Error');
      });
    });
  };

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.updateTemplateSearch = function (searchValue) {
    if (searchValue === "") {
      $scope.templateSearchList = $scope.templateSearchListFull;
      return;
    }

    // update addressBookList with filtered results
    var filteredList = [];
    for (var i = 0; i < $scope.templateSearchListFull.length; i++) {
      if ($scope.templateSearchListFull[i].name.indexOf(searchValue) != -1) {
        filteredList.push($scope.templateSearchListFull[i]);
      }
    }

    $scope.templateSearchList = filteredList;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "mhVA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').factory('splitListInterface', ['$timeout', function ($timeout) {
  function Factory($scope, $stateParams) {
    this.$scope = $scope;
    this.$stateParams = $stateParams;
  }

  // Open detail pane - slide from right
  var slideListDetailOpen = function slideListDetailOpen() {
    if ($(".contentSplitList").width() > 100) {
      $(".contentSplitList").animate({
        width: "40%"
      }, 800);
    }
    $(".splitableContentContainer").animate({
      width: "100%"
    }, 800, function () {
      $(".splitableContentContainer").addClass('showDetail');
    });

    $(".contentSplitList").addClass("collapsed");

    // Currently not used anymore -- old filter and control buttons
    $(".splitableContentControls").fadeIn();
    $(".contentSplitList .contentFilters").fadeOut(function () {
      $(".contentSplitList .sidebarControlsHorizontal").fadeIn();
    });
  };

  var slideTableListDetailOpen = function slideTableListDetailOpen() {
    var windowWidth = $(window).width();
    /*if ( $(".desktopSplitListDetailOuter").width() < (.5 * windowWidth) ) {*/
    if (windowWidth >= 1400) {
      $(".desktopSplitListTableOuter").css({ display: 'block' });
      $(".desktopSplitListDetailOuter").css({ display: 'block' });

      //$(".desktopSplitListTableOuter").css({'width':'50%'});
      //$(".desktopSplitListDetailOuter").css({'width':'50%'});
    } else {
      $(".desktopSplitListTableOuter").css({ display: 'none' });
      $(".desktopSplitListDetailOuter").css({ display: 'block' });
      //$(".desktopSplitListTableOuter").hide();
      //$(".desktopSplitListDetailOuter").css({'width':'100%'});
    }
  };

  var slideTableListDetailClosed = function slideTableListDetailClosed() {
    /*$(".desktopSplitListTableOuter").show();
    $(".desktopSplitListTableOuter").css({'width':'100%'});
    $(".desktopSplitListDetailOuter").css({'width':'0px'});*/

    $(".desktopSplitListTableOuter").css({ display: 'block' });
    $(".desktopSplitListDetailOuter").css({ display: 'none' });
  };

  // Close detail pane - slide to right
  var slideListDetailClosed = function slideListDetailClosed(cb) {
    if ($(".contentSplitList").hasClass('collapsed')) {
      $(".splitableContentContainer").animate({
        width: "200%"
      }, 800);

      setTimeout(function () {
        $(".contentSplitList").removeClass('collapsed');
        $(".contentSplitList").animate({
          width: "50%"
        }, 800, function () {
          cb();
        });
      }, 200);
      $(".contentSplitList .sidebarControlsHorizontal").fadeOut(function () {
        $(".contentSplitList .contentFilters").fadeIn();
      });
    }
  };

  Factory.prototype.slideTableListDetailOpen = slideTableListDetailOpen;
  Factory.prototype.slideTableListDetailClosed = slideTableListDetailClosed;

  // Minimise item list bar
  Factory.prototype.minimiseItemList = function () {
    var width = $(".contentSplitList").width();

    if (width > 100) {
      // Minimise list to tiny width
      $(".contentSplitList h1").fadeOut();
      $(".contentSplitList .contentFilters").fadeOut();
      $(".contentSplitList .contentList").fadeOut();
      $(".contentSplitList .splitableContentControls .leftArrow").fadeOut();
      $(".contentSplitList .sidebarControlsHorizontal").fadeOut(function () {
        $(".contentSplitList .sidebarControlsVertical").fadeIn();
      });
      $(".contentSplitList").animate({
        width: '80px'
      }, 800);
    }
  };

  Factory.prototype.maximiseItemList = function () {
    var width = $(".contentSplitList").width();

    var outerScope = this.$scope;
    var outerStateParams = this.$stateParams;

    if (width < 100) {
      $timeout(function () {
        $(".contentSplitList h1").fadeIn();
        $(".contentSplitList .contentList").fadeIn();
        $(".contentSplitList .splitableContentControls .leftArrow").fadeIn();
      }, 400);
      $(".contentSplitList").animate({
        width: '250px'
      }, 800);
    } else {
      slideListDetailClosed(function () {
        outerScope.itemEdit = null;
        outerStateParams.active = null;
        outerStateParams.activeByIndex = null;
      });
    }
  };

  // Ensure that content list is at normal list/detail size
  Factory.prototype.ensureListOpen = function (cb) {
    var width = $(".contentSplitList").width();
    if (width < 100) {
      $timeout(function () {
        $(".contentSplitList h1").fadeIn();
        $(".contentSplitList .contentList").fadeIn();
        $(".contentSplitList .splitableContentControls .leftArrow").fadeIn();
      }, 400);

      $(".contentSplitList").animate({
        width: '250px'
      }, 800, function () {
        if (cb) {
          cb();
        }
      });
    } else {
      if (cb) {
        cb();
      }
    }
  };

  // Expand detail content of list item on angular trigger
  Factory.prototype.openListItemDetail = function (cb) {
    if ($(".contentSplitList .contentList .actualListItem") == null || $(".contentSplitList .contentList .actualListItem").width() == null || $(".contentSplitList .contentList .actualListItem").width() > 0) {
      $timeout(function () {
        slideListDetailOpen();
      }, 200);
    }
    if (cb) {
      cb();
    }
  };

  // Open detail when in mobile mode
  Factory.prototype.openListMobileDetail = function (item, cb) {
    this.$scope.itemEdit = item;
    this.$scope.currentTab = "General";
    $(".mobileTabBar").scrollLeft(0);
    $(".mobileFooterBar").addClass('hidden-xs');
  };

  // Close detail when in mobile mode
  Factory.prototype.closeListMobileDetail = function () {
    if (this.$scope.mode != 'desktop') {
      $(".mobileFooterBar").removeClass('hidden-xs');
    }
  };

  // Toggle expand/contract of mobile filters in mobile footer bar
  Factory.prototype.toggleMobileFilters = function () {
    $("#mobileFilters").toggle(400);
  };

  // Show list item control buttons on angular swipe left gesture
  Factory.prototype.swipeListItem = function (idNumber) {
    var controlsWidth = $("#listItemControls" + idNumber).width();
    var translateX = "-" + controlsWidth + "px";

    $("#listItem" + idNumber + " .customListRow").animate({
      left: translateX
    }, 600, function () {});
  };

  // Close list item control buttons on angular swipe right gesture
  Factory.prototype.swipeListItemClose = function (idNumber) {
    $("#listItem" + idNumber + " .customListRow").animate({
      left: "0px"
    }, 600, function () {});
  };

  // Change the value of a filter
  Factory.prototype.changeFilter = function (filterName, newValue) {
    this.$scope.filters[filterName] = newValue;
  };

  // Toggle value of AND filter
  Factory.prototype.toggleAndFilter = function (filterName, filterOption) {
    if (filterOption == 'all') {
      // special - if any other filters on filterName are selected, set only all to true
      var keys = Object.keys(this.$scope.filters[filterName]);
      var trueCount = 0;
      for (var key in this.$scope.filters[filterName]) {
        if (this.$scope.filters[filterName][key] == true) {
          this.$scope.filters[filterName][key] = false;
          trueCount += 1;
        }
      }
      if (trueCount > 0) {
        this.$scope.filters[filterName]['all'] = true;
      } else {
        this.$scope.filters[filterName]['all'] = false;
      }
    } else {
      this.$scope.filters[filterName][filterOption] = !this.$scope.filters[filterName][filterOption];

      // update all status
      var trueCount = 0;
      for (var key in this.$scope.filters[filterName]) {
        if (this.$scope.filters[filterName][key] == true) {
          trueCount += 1;
        }
      }
      if (trueCount > 0) {
        this.$scope.filters[filterName]['all'] = false;
      } else {
        this.$scope.filters[filterName]['all'] = true;
      }
    }
  };

  Factory.prototype.prepareFormFields = function () {
    $("form input").each(function () {
      $(this).removeClass('ng-dirty');
      $(this).removeClass('ng-touched');
      $(this).removeClass('ng-invalid');
    });
  };

  return Factory;
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "ml5I":
/***/ (function(module, exports) {

var path = 'views/modals/xeroConnect.html';
var html = "<div class=\"niceModal desktopSelector noFooter\" id=\"xeroConnectModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Connect To Xero</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeXeroConnectModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div my-loader text=\"Redirecting to Xero\" ng-if=\"xeroConnect.redirecting\"></div>\n      <div class=\"modalFormTable padding\" ng-if=\"xeroConnect.stage == 'initial'\">\n        <div class=\"xeroConnectIcon\"></div>\n        <div class=\"xeroAuthMessage\">\n          <!--<h2 ng-if=\"currentOrg.features.xero.organisationName\">Connect to {{currentOrg.features.xero.organisationName}}</h2>-->\n          <h2>Connect to Your Xero Organisation</h2>\n          <!--<p ng-if=\"currentOrg.features.xero.organisationName\">We need to connect to your Xero organisation to continue.</p>-->\n          <p>You will be directed to Xero and asked to authorise Docketbook to connect to your Xero organisation.</p>\n          <div class=\"dbButton lightBlue spinner\" ng-click=\"xeroConnect.redirecting || xeroConnectAuthorise()\" ng-disabled=\"xeroConnect.redirecting\">\n            <span ng-hide=\"xeroConnect.redirecting\">Connect</span>\n            <md-progress-circular ng-show=\"xeroConnect.redirecting\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n      <div class=\"modalFormTable padding\" ng-if=\"xeroConnect.stage == 'confirm'\">\n        <div class=\"xeroConnectIcon success\"></div>\n        <div class=\"xeroAuthMessage\">\n          <h2>Confirm Xero Organisation To Connect With</h2>\n          <p>Please select the xero organisation that you would like to connect to Docketbook</p>\n          <md-input-container class=\"md-block\" style=\"width:200px;margin:auto;margin-top:30px;\">\n            <label>Select Xero Organisation</label>\n            <md-select ng-model=\"xeroConnect.tenantSelected\" aria-label=\"Select Xero Organisation to Connect\">\n              <md-option ng-repeat=\"tenant in xeroConnect.tenantsAvailable\" ng-value=\"tenant.tenantId\">{{tenant.tenantName}}</md-option>\n            </md-select>\n          </md-input-container>\n          <div class=\"dbButton lightBlue spinner\" ng-click=\"xeroConnect.confirming || xeroConfirmConnection()\" ng-disabled=\"xeroConnect.confirming\">\n            <span ng-hide=\"xeroConnect.confirming\">Confirm Connection</span>\n            <md-progress-circular ng-show=\"xeroConnect.confirming\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n      </div>\n      <div class=\"modalFormTable padding\" ng-if=\"xeroConnect.stage == 'error'\">\n        <div class=\"billingSuccessOuter error\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n        </div>\n        <div class=\"billingSuccessMessage\">\n          Something went wrong when we tried to connect to Xero. Please try again.\n          <br/>\n          <div class=\"dbButton\" ng-click=\"xeroConnect.stage = 'initial'\">Go Back</div>\n        </div>\n      </div>\n      <div class=\"modalFormTable padding\" ng-if=\"xeroConnect.stage == 'success'\">\n        <p>Your Xero organisation has been connected!</p>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "n/Jq":
/***/ (function(module, exports) {

var path = 'views/pages/groupSettings/nav.html';
var html = "<!-- Desktop only navigation - horizontally aligned -->\n<div class=\"navSplitContainer\">\n  <div class=\"layoutBox flex1\">\n    <div class=\"navHeading withButton settingsHeading\">\n      <!--<div class=\"navBackButton\" ui-sref=\"main.groupDashboard({orgId: currentOrg.id, groupId: currentOrgGroup.id})\"><md-icon md-svg-src=\"left.svg\"></md-icon></div>-->\n      <div class=\"right\">Group Settings</div>\n    </div>\n    <ul class=\"hidden-xs desktop\">\n      <a ui-sref=\"groupSettings.general({orgId: currentOrg.id, groupId: currentOrgGroup.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'general' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"dashboard.svg\"></md-icon>\n          Overview\n        </li>\n      </a>\n      <a ui-sref=\"groupSettings.members({orgId: currentOrg.id, groupId: currentOrgGroup.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'members' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"user-group.svg\"></md-icon>\n          Members\n        </li>\n      </a>\n      <a ui-sref=\"groupSettings.admins({orgId: currentOrg.id, groupId: currentOrgGroup.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'admins' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"admin-user.svg\"></md-icon>\n          Administrators\n        </li>\n      </a>\n      <a ui-sref=\"groupSettings.monitors({orgId: currentOrg.id, groupId: currentOrgGroup.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'monitors' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"eye.svg\"></md-icon>\n          Monitors\n        </li>\n      </a>\n      <a ui-sref=\"groupSettings.filing({orgId: currentOrg.id, groupId: currentOrgGroup.id})\" class=\"main\">\n        <li class=\"{{currentState.data.subnavOption == 'filing' ? 'selected' : ''}}\">\n          <md-icon md-svg-src=\"archive.svg\"></md-icon>\n          File Codes\n        </li>\n      </a>\n    </ul>\n  </div>\n  <div class=\"layoutBox\">\n    <ul class=\"hidden-xs desktop\">\n      <a href=\"https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us\" target=\"_blank\">\n        <li class=\"\">\n          <md-icon md-svg-src=\"help.svg\"></md-icon>\n          Help\n        </li>\n      </a>\n    </ul>\n  </div>\n</div>\n<!-- End Desktop only navigation -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "n2ZK":
/***/ (function(module, exports) {

var path = 'views/pages/timesheets/desktop/timesheetsHeading.html';
var html = "<div class=\"contentHeadingOuter\">\n  <div class=\"contentHeadingInner desktopTableSearch\">\n    <div class=\"headerSplit\">\n      <div class=\"left\">\n        <h1>Timesheets</h1>\n      </div>\n      <div class=\"middle\">\n        <div class=\"backWeekButton\">\n          <md-button class=\"md-icon-button\" ng-click=\"jobAllocationsFiltersBackWeek()\" aria-label=\"Last Week\">\n            <md-icon md-svg-icon=\"back-icon.svg\"></md-icon>\n          </md-button>\n        </div>\n        <div class=\"currentWeekFilter\">{{moment(filters.startFromDate).format('DD/MM/YYYY')}} - {{moment(filters.endToDate).format('DD/MM/YYYY')}}</div>\n        <div class=\"backWeekButton\">\n          <md-button class=\"md-icon-button\" ng-click=\"jobAllocationsFiltersNextWeek()\" aria-label=\"Next Week\">\n            <md-icon md-svg-icon=\"next-icon.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div class=\"right\">\n\n        <!-- Filters Button -->\n        <md-button class=\"has-hover-count md-icon-button {{activeFilters > 0 ? 'md-primary' : '' }}\" ng-click=\"showFilters = !showFilters\" aria-label=\"Show / Hide Filters\">\n          <md-icon md-svg-icon=\"filter.svg\"></md-icon>\n          <div class=\"md-icon-hover-count\" ng-show=\"activeFilters > 0\">{{activeFilters}}</div>\n        </md-button>\n\n        <!-- Reload List Buttons -->\n        <md-button class=\"md-icon-button\" ng-click=\"loadBatchesList()\" aria-label=\"Reload Docket Batch List\" ng-if=\"listView == 'batch'\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n\n    <div class=\"ojdDesktopFiltersContainer quickFilters\" ng-if=\"showFilters\">\n      <div class=\"filterRow\">\n        <div class=\"filterGroup dates\" ng-if=\"listView != 'batch'\">\n          <h1>Date</h1>\n          <div class=\"md-block\">\n            <md-input-container class=\"filterDatepicker\">\n              <label>From</label>\n              <md-datepicker ng-model=\"filters.startFromDate\" aria-label=\"From Date Filter\"></md-datepicker>\n            </md-input-container>\n            <md-input-container class=\"filterDatepicker\">\n              <label>To</label>\n              <md-datepicker ng-model=\"filters.endToDate\" aria-label=\"To Date Filter\"></md-datepicker>\n            </md-input-container>\n          </div>\n        </div>\n\n        <div class=\"filterGroup\" ng-if=\"listView != 'batch'\">\n          <h1>Operator</h1>\n          <md-button class=\"md-icon-button selector\" ng-click=\"filters.author = null\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n          <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"filters.author\" aria-label=\"Docket Operator Filter\" ng-model-options=\"{debounce:1000}\">\n          </md-input-container>\n        </div>\n\n        <div class=\"filterGroup\">\n          <md-button ng-click=\"clearFilters()\" class=\"\">\n            Clear All Filters\n          </md-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "n3fY":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/categories.html';
var html = "<div class=\"desktopContainer dashboard adminSettingsView\">\n  <div class=\"dashboardWelcomeHeader\">\n    <div class=\"left\">\n      <h3>Manage Resource Categories</h3>\n      <p> A resource category can be used to define the type of actions a group of resources can take. For example, the 'Material' category can be configured (within the <a ui-sref=\"companySettings.templates({orgId: currentOrg.id})\">docket template</a>) to only allow loaded/ delivered actions. Whereas the 'People' category could appropriately include worked/break actions. Resource categories are assigned to each entry in the <a ui-sref=\"companySettings.resources({orgId: currentOrg.id})\">Resources</a> section. </p>\n    </div>\n    <div class=\"right\">\n\n    </div>\n  </div>\n\n  <div class=\"adminBasicContentContainer bare\">\n    <div class=\"adminSettingGroupContainer noPadding\" style=\"position:relative;margin-top:0px;\">\n      <div class=\"adminContentInner bare\">\n\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- Resource Category Edit Modal -->\n<!--<div class=\"niceModal desktopSelector\" id=\"newResourceCategoryModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1 ng-show=\"itemEdit.id == null\">New Resource Category</h1>\n      <h1 ng-show=\"itemEdit.id != null\">Edit Resource Category</h1>\n    </div>\n    <form name=\"newResourceCategoryForm\" novalidate>\n      <div class=\"content\">\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <label>Category Name</label>\n          <input type=\"text\" ng-model=\"itemEdit.name\" required>\n        </md-input-container>\n        <md-input-container class=\"md-block\" flex-gt-sm>\n          <label>Description</label>\n          <textarea ng-model=\"itemEdit.description\" required></textarea>\n        </md-input-container>\n      </div>\n      <div class=\"footer\">\n        <div class=\"tableLayoutHelperContainer\">\n          <div class=\"left\">\n\n          </div>\n          <div class=\"right\">\n            <div class=\"dbButton white margin-right\" ng-click=\"closeNewResourceCategoryModal()\">\n              Cancel\n            </div>\n            <div class=\"dbButton spinner\" ng-click=\"(newResourceCategoryForm.$invalid || itemEdit.loading) || saveNewResourceCategory(itemEdit)\" ng-disabled=\"newResourceCategoryForm.$invalid || itemEdit.loading\">\n              <span ng-hide=\"itemEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"itemEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>-->\n<!-- End Resource Category Modal -->\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "n83n":
/***/ (function(module, exports, __webpack_require__) {

var path = 'views/pages/paywalled/jobs.html';
var html = "<div style=\"width: 100%; height: 100%; background-color: white; display: table; padding-top: 40px; padding-bottom: 40px;\">\n    <div style=\"display: table-cell; vertical-align: middle;\">\n        <div class=\"\" style=\"display: flex\">\n            <div style=\"flex: 1 1 auto; min-width: 600px; width: calc(50% - 30px); text-align: end;\">\n                <img style=\"width: 600px;\" src=\"" + __webpack_require__("PjXo") + "\"/>\n            </div>\n            <div style=\"width: 60px;\"></div>\n            <div style=\"flex: 1 1 auto; width: calc(50% - 30px);\">\n                <div class=\"lockSectionTextContainer\">\n                    <h3 class=\"darkBlueBold\">JOBS</h3>\n                    <h1 class=\"boldBlueText\">Easily allocate jobs to your workforce</h1>\n                    <p class=\"lockJobsText\">Jobs are designed to work the way you work - with other companies. Simply design, yet powerful in its implementation, jobs work seamlessly across company boundaries</p>\n                    <a class=\"dbColorText\" target=\"_blank\" href=\"https://help.docketbook.com.au/hc/en-us/sections/360008857393-Jobs-Allocating-Work-to-your-Team\">Learn more about Jobs</a>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"lockSubcardsContainer\">\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Simple work allocation</h3>\n                <span>Manage your projects and allocate tasks at the touch of a button. Intuitive calendars display availability and allow instant allocation and acceptance of jobs.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Forward to all of your subcontractors</h3>\n                <span>Jobs can be allocated to subcontractors, their team members and their subcontractors whilst retaining your corporate brand.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Prevent errors with automated dockets</h3>\n                <span>New dockets are pre-populated with job data, minimising human error and reducing the need for manual data entry.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Know when a job is allocated</h3>\n                <span>With in-app and SMS notifications, your team are kept up to date and can instantly accept or reject a job.</span>\n            </div>\n        </div>\n\n        <div style=\"text-align: center; margin-top: 100px\">\n            <div class=\"newDbButton\" style=\"width: 250px\" ng-click=\"selectPlan(null, 'jobsCreate', 'from jobs paywalled page - upgrade plan')\">\n                Upgrade Plan\n            </div>\n            <div ng-if=\"currentOrg.planFeatures.trialAvailable && !currentOrg.planFeatures.inTrial\" class=\"newDbButton whiteOutline\" style=\"width: 250px; margin-left: 30px;\" ng-click=\"trialButtonClick()\">\n                Start a 7 day free trial\n            </div>\n        </div>\n    </div>\n</div>\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n<ng-include src=\"'views/modals/trialActivatedModal.html'\" ng-controller=\"trialActivatedModalController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "nEzz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-76x76.png";

/***/ }),

/***/ "no4E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("7t+N");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('signatureModalController', ['$rootScope', '$scope', '$state', '$stateParams', 'accessControl', '$timeout', 'geolocation', function ($rootScope, $scope, $state, $stateParams, accessControl, $timeout, geolocation) {

  $scope.signatureCapture = {};

  $scope.configureSignaturePad = function () {
    var canvas = (0, _jquery2.default)("#signatureCapture");
    var context = document.getElementById('signatureCapture').getContext('2d');
    var windowWidth = (0, _jquery2.default)(window).width();
    context.canvas.width = windowWidth;
    var offsetLeft;
    var offsetTop;
    var painting = false;
    var lastX = 0;
    var lastY = 0;
    var lineThickness = 0.5;

    canvas.mousedown(function (e) {
      offsetLeft = canvas.offset().left;
      offsetTop = canvas.offset().top;
      painting = true;
      context.fillStyle = "#000000";
      lastX = e.pageX - offsetLeft;
      lastY = e.pageY - offsetTop;
    });

    canvas.bind('touchstart', function (e) {
      offsetLeft = canvas.offset().left;
      offsetTop = canvas.offset().top;
      lastX = e.originalEvent.touches[0].pageX - offsetLeft;
      lastY = e.originalEvent.touches[0].pageY - offsetTop;
      painting = true;
      context.fillStyle = "#000000";
      e.preventDefault();
    });

    canvas.mouseup(function (e) {
      painting = false;
    });

    canvas.bind('touchend', function (e) {
      painting = false;
      e.preventDefault();
    });

    canvas.mouseleave(function (e) {
      painting = false;
    });

    canvas.mousemove(function (e) {
      if (painting) {
        drawPoint(e.pageX - offsetLeft, e.pageY - offsetTop);
      }
    });

    canvas.bind('touchmove', function (e) {
      if (painting) {
        drawPoint(e.originalEvent.touches[0].pageX - offsetLeft, e.originalEvent.touches[0].pageY - offsetTop);
        e.preventDefault();
      }
    });

    function drawPoint(mouseX, mouseY) {
      // find all points between
      var x1 = mouseX,
          x2 = lastX,
          y1 = mouseY,
          y2 = lastY;

      var steep = Math.abs(y2 - y1) > Math.abs(x2 - x1);

      if (steep) {
        var x = x1;
        x1 = y1;
        y1 = x;

        var y = y2;
        y2 = x2;
        x2 = y;
      }

      if (x1 > x2) {
        var x = x1;
        x1 = x2;
        x2 = x;

        var y = y1;
        y1 = y2;
        y2 = y;
      }

      var dx = x2 - x1,
          dy = Math.abs(y2 - y1),
          error = 0,
          de = dy / dx,
          yStep = -1,
          y = y1;

      if (y1 < y2) {
        yStep = 1;
      }

      lineThickness = 3 - Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1)) / 10;
      if (lineThickness < 1) {
        lineThickness = 1;
      }

      for (var x = x1; x < x2; x++) {
        if (steep) {
          context.fillRect(y, x, lineThickness, lineThickness);
        } else {
          context.fillRect(x, y, lineThickness, lineThickness);
        }

        error += de;
        if (error >= 0.5) {
          y += yStep;
          error -= 1.0;
        }
      }

      lastX = mouseX;
      lastY = mouseY;
    }

    // touch support
    canvas.bind('scroll', function (e) {
      e.preventDefault();
    });
  };

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.captureSignatureFromParent = function (entity, nameRequired, name, terms, template, cb) {
    $scope.signatureCaptureCallback = cb;
    $scope.signatureCapture = {};
    $scope.signatureCapture.entity = entity;
    $scope.signatureCapture.name = name;
    $scope.signatureCapture.attachments = [];
    $scope.signatureCapture.template = template;
    var termsAttachments = [];
    if (template && template.attachments) {
      for (var i = 0; i < template.attachments.length; i++) {
        if (template.attachments[i].type == 'termsConditions') {
          $scope.signatureCapture.attachments.push(template.attachments[i]);
        }
      }
    }
    if (nameRequired != null) {
      $scope.signatureCapture.nameRequired = nameRequired;
    } else {
      $scope.signatureCapture.nameRequired = false;
    }
    if (terms) {
      $scope.signatureCapture.terms = terms;
      $scope.signatureCapture.termsRequired = true;
    } else {
      $scope.signatureCapture.termsRequired = false;
    }
    $scope.configureSignaturePad();
    (0, _jquery2.default)("#signatureCaptureModal").fadeIn(100, function () {
      document.getElementById('signatureCapture').width = (0, _jquery2.default)("#signatureCaptureModal .modalContainer").outerWidth();
    });
  };

  /*******************************/
  /***** Signature Functions *****/
  /*******************************/

  $scope.closeSignatureCapture = function () {
    (0, _jquery2.default)("#signatureCaptureModal").fadeOut(100);
    $scope.signatureCaptureCallback(null);
  };

  function isCanvasBlank(canvas) {
    return !canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data.some(function (channel) {
      return channel !== 0;
    });
  }

  $scope.saveSignatureCapture = function () {
    var canvas = document.getElementById('signatureCapture');
    var image = canvas.toDataURL("image/png");
    var imageToSave = image.split(',')[1];

    if (isCanvasBlank(canvas)) {
      return;
    }

    var returnObject = {};
    returnObject.signatureImage = imageToSave;
    returnObject.signatureImageFull = image;
    if ($scope.signatureCapture.nameRequired) {
      returnObject.signatureName = $scope.signatureCapture.name;
    }

    $scope.signatureCaptureCallback(returnObject);
    (0, _jquery2.default)("#signatureCaptureModal").fadeOut(100);
  };

  $scope.openTermsAttachments = function (attachments) {
    if ($scope.currentOrg && $scope.currentOrg.id) {
      for (var i = 0; i < attachments.length; i++) {
        window.open("" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/templates/' + $scope.signatureCapture.template.id + '/attachment/' + attachments[i].id);
      }
    } else {
      $scope.openDocketTermsAttachments();
    }
  };
}]);

/***/ }),

/***/ "nsjd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nzZi":
/***/ (function(module, exports) {

var path = 'views/modals/fieldModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector newCompanyModal\" id=\"editFieldModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1 ng-show=\"fieldEdit.id == null\">New Docket Field</h1>\n      <h1 ng-show=\"fieldEdit.id != null\">Edit Docket Field</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeNewFieldModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content\">\n      <div ng-if=\"fieldEdit.step == 'type'\">\n        <h2>What type of field would you like to create?</h2>\n        <h4>Click an option below to continue</h4>\n        <div class=\"fieldTypeOptions\">\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('text') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('text')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"text-field.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Text\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('multiline') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('multiline')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"multiline-field.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Multi-line Text\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('boolean') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('boolean')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"_switch.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Boolean\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('number') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('number')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"number-field.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Number\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('date') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('date')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"calendar.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Date\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('time') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('time')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"clock.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Time\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('select') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('select')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"_select-field.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Select\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('label') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('label')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"font.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Label\n              </div>\n            </div>\n          </div>\n          <div class=\"fieldTypeOptionOuter\" ng-if=\"!(fieldEdit.ignoreTypes && fieldEdit.ignoreTypes.indexOf('signature') != -1)\">\n            <div class=\"fieldTypeOption\" ng-click=\"selectFieldType('signature')\">\n              <div class=\"left\">\n                <md-icon md-svg-src=\"_signature.svg\"></md-icon>\n              </div>\n              <div class=\"right\">\n                Signature\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div ng-if=\"fieldEdit.step == 'name'\">\n        <h2>How do you want to name this field?</h2>\n        <h4>Enter a display name below<span ng-if=\"fieldEdit.type == 'select'\"> and add options for user selection</span></h4>\n\n\n        <form name=\"editFieldForm\" novalidate>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <label>Display Name</label>\n              <input ng-model=\"fieldEdit.displayName\" required>\n            </md-input-container>\n          </div>\n\n          <span ng-show=\"fieldEdit.type == 'label'\">\n            <div layout-gt-sm=\"row\">\n              <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                <label>Label Text</label>\n                <textarea ng-model=\"fieldEdit.text\" rows=\"3\" required></textarea>\n              </md-input-container>\n            </div>\n          </span>\n\n          <span ng-show=\"fieldEdit.type == 'select'\">\n            <h4 class=\"normal\">Select Options</h4>\n            <div data-as-sortable data-ng-model=\"fieldEdit.selectionFields\">\n              <div class=\"selectionFieldItem\" ng-repeat=\"selectionField in fieldEdit.selectionFields\" data-as-sortable-item>\n                <div class=\"left\">\n                  <md-input-container class=\"md-block\" flex-gt-sm>\n                    <input ng-model=\"selectionField.value\" placeholder=\"Select Option Text\">\n                  </md-input-container>\n                </div>\n                <div class=\"right\">\n                  <md-button class=\"md-icon-button\" aria-label=\"Delete Select Option\" ng-click=\"removeSelectionField(fieldEdit, selectionField)\">\n                    <md-icon md-svg-icon=\"delete.svg\"></md-icon>\n                  </md-button>\n                  <md-button data-as-sortable-item-handle class=\"md-icon-button\" aria-label=\"Drag\" style=\"cursor: move;\">\n                    <md-icon md-svg-icon=\"drag.svg\" style=\"cursor: move;\"></md-icon>\n                  </md-button>\n                </div>\n              </div>\n            </div>\n            <div class=\"selectionFieldItem new\" ng-click=\"addSelectionField(fieldEdit)\"><div class=\"newInner\">Click to add option</div></div>\n          </span>\n\n          <div class=\"footerButtons additionalTopMargin\" ng-if=\"fieldEdit.type != null\">\n            <div class=\"dbButton grey margin-right\" ng-click=\"fieldEdit.step = 'type'\" ng-if=\"fieldEdit.id == null\">\n              Back\n            </div>\n            <div class=\"dbButton blue\" ng-click=\"fieldEdit.step = 'required'\" ng-if=\"fieldEdit.type != 'label'\">\n              Next\n            </div>\n            <button class=\"dbButton spinner\" ng-click=\"(editFieldForm.$invalid || fieldEdit.loading) || saveField(fieldEdit)\" ng-disabled=\"editFieldForm.$invalid || fieldEdit.loading\" ng-if=\"fieldEdit.type == 'label'\">\n              <span ng-hide=\"fieldEdit.loading\">Save</span>\n              <md-progress-circular ng-show=\"fieldEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </button>\n          </div>\n        </form>\n      </div>\n      <div ng-if=\"fieldEdit.step == 'required'\">\n        <h2>Is this field mandatory?</h2>\n        <h4>Mandatory fields are required before a docket can be sent.</h4>\n\n        <div class=\"wizardQuestionSet\">\n          <div class=\"wizardQuestionItem basicBoolean {{fieldEdit.mandatory ? 'selected': ''}}\" ng-click=\"fieldEdit.mandatory = true\">\n            Yes\n          </div>\n          <div class=\"wizardQuestionItem basicBoolean {{fieldEdit.mandatory ? '': 'selected'}}\" ng-click=\"fieldEdit.mandatory = false\">\n            No\n          </div>\n        </div>\n\n        <div class=\"dbButton grey margin-right\" ng-click=\"fieldEdit.step = 'name'\">\n          Back\n        </div>\n        <button class=\"dbButton spinner\" ng-click=\"(editFieldForm.$invalid || fieldEdit.loading) || requiredNextStep(fieldEdit)\" ng-disabled=\"editFieldForm.$invalid || fieldEdit.loading\">\n          <span ng-hide=\"fieldEdit.loading\">Save</span>\n          <md-progress-circular ng-show=\"fieldEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n        </button>\n      </div>\n      <div ng-if=\"fieldEdit.step == 'updateTemplates'\">\n        <h2>Do you want to update Docket Templates that are using this field?</h2>\n        <h4>It looks like this field is used on a Docket Template - would you like to update those templates?</h4>\n\n        <div class=\"wizardQuestionSet\">\n          <div class=\"wizardQuestionItem basicBoolean {{fieldEdit.updateTemplates ? 'selected': ''}}\" ng-click=\"fieldEdit.updateTemplates = true\">\n            Yes\n          </div>\n          <div class=\"wizardQuestionItem basicBoolean {{fieldEdit.updateTemplates ? '': 'selected'}}\" ng-click=\"fieldEdit.updateTemplates = false\">\n            No\n          </div>\n        </div>\n        <div class=\"dbButton grey margin-right\" ng-click=\"fieldEdit.step = 'required'\">\n          Back\n        </div>\n        <button class=\"dbButton spinner\" ng-click=\"(editFieldForm.$invalid || fieldEdit.loading) || saveField(fieldEdit)\" ng-disabled=\"editFieldForm.$invalid || fieldEdit.loading\">\n          <span ng-hide=\"fieldEdit.loading\">Save</span>\n          <md-progress-circular ng-show=\"fieldEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "o2vf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "reload.svg";

/***/ }),

/***/ "o32f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').service('addressBookService', ['jobService', 'accessControl', '$http', '$stateParams', '$cookies', '$q', 'Restangular', 'geolocation', function (jobService, accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

  this.getConnections = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    if (params == null) {
      params = {};
    }

    Restangular.all('organisations').one(organisation.id).all('connections').getList(params).then(successCb, failureCb);
  };

  this.getFilteredConnections = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    Restangular.all('organisations').one(organisation.id).all('connections').customPOST(params).then(successCb, failureCb);
  };

  this.getInvitations = function (params, successCb, failureCb) {
    if (params == null) {
      params = {};
    }

    var organisation = accessControl.currentOrg();
    Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').getList(params).then(successCb, failureCb);
  };

  this.getFilteredInvitations = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').customPOST(params).then(successCb, failureCb);
  };

  this.saveInvitation = function (invitation, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').one(invitation.id).customPUT({ status: invitation.status }).then(successCb, failureCb);
  };

  this.createConnections = function (connections, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    Restangular.all('organisations').one(organisation.id).all('connections').one('invite').one('bulk').customPOST(connections).then(successCb, failureCb);
  };

  this.cancelInvitation = function (invitation, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    Restangular.all('organisations').one(organisation.id).all('connections').all('invitations').one(invitation.id).customDELETE('').then(successCb, failureCb);
  };

  this.removeConnection = function (connection, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    Restangular.all('organisations').one(organisation.id).all('connections').one(connection.id).customDELETE('').then(successCb, failureCb);
  };

  this.getAddressBookTags = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('tags');
    if (params == null) {
      params = {};
    }
    baseAddressBook.getList(params).then(successCb, failureCb);
  };

  this.saveAddressBookTag = function (tag, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('tags');
    if (!tag.id) {
      baseAddressBook.customPOST(tag).then(successCb, failureCb);
    } else {
      baseAddressBook.one(tag.id).customPUT(tag).then(successCb, failureCb);
    }
  };

  this.deleteAddressBookTag = function (tag, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('tags').one(tag.id);
    baseAddressBook.customDELETE("").then(successCb, failureCb);
  };

  this.getAddressBook = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');
    if (params == null) {
      params = {};
    }
    baseAddressBook.getList(params).then(successCb, failureCb);
  };

  this.getAddressBookContact = function (addressBookId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');
    baseAddressBook.one(addressBookId).get().then(successCb, failureCb);
  };

  this.getAddressBookForUnit = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg().id;
    var organisationGroup = accessControl.currentOrgGroup().id;

    var baseAddressBook = Restangular.all('organisations').one(organisation).all('groups').one(organisationGroup).all('addressbook');
    if (params == null) {
      params = {};
    }
    baseAddressBook.getList(params).then(successCb, failureCb);
  };

  var saveContact = function saveContact(contact, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');

    if (contact.id == null) {
      baseAddressBook.customPOST(contact).then(successCb, failureCb);
    } else {
      baseAddressBook.one(contact.id).customPUT(contact).then(successCb, failureCb);
    }
  };

  this.saveContact = saveContact;

  this.saveContactForUnit = function (org, orgUnit, contact, successCb, failureCb) {
    var organisation = org;
    var organisationGroup = orgUnit;
    if (organisation == null || organisationGroup == null) {
      organisation = accessControl.currentOrg();
      organisation = organisation.id;
      organisationGroup = accessControl.currentOrgGroup();
      organisationGroup = organisationGroup.id;
    }
    var baseAddressBook = Restangular.all('organisations').one(organisation).all('groups').one(organisationGroup).all('addressbook');

    if (contact.id == null) {
      baseAddressBook.customPOST(contact).then(successCb, failureCb);
    } else {
      baseAddressBook.one(contact.id).customPUT(contact).then(successCb, failureCb);
    }
  };

  var deleteContact = function deleteContact(contactId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseAddressBook = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('addressbook');

    if (contactId.id != null) {
      contactId = contactId.id;
    }

    baseAddressBook.one(contactId).remove().then(successCb, failureCb);
  };

  this.deleteContact = deleteContact;

  this.deleteBulkContacts = function (contacts, successCb) {
    var failures = {};
    deleteContacts(contacts, 0, failures, successCb);
  };

  var deleteContacts = function deleteContacts(contacts, index, failures, successCb) {
    if (index >= contacts.length) {
      successCb(failures);
      return;
    }

    deleteContact(contacts[index], function () {
      deleteContacts(contacts, index + 1, failures, successCb);
    }, function (err) {
      failures.push(contacts[index]);
      deleteContacts(contacts, index + 1, failures, successCb);
    });
  };

  /**** Bulk Import Contacts ****/

  this.bulkImportContacts = function (contactsList, successCb, failureCb) {
    var failures = [];
    importContacts(contactsList, 0, failures, successCb);
  };

  var importContacts = function importContacts(contacts, index, failures, successCb) {
    if (index >= contacts.length) {
      successCb(failures);
      return;
    }

    saveContact(contacts[index], function () {
      importContacts(contacts, index + 1, failures, successCb);
    }, function (err) {
      console.error('could not save contact', err);
      failures.push(contacts[index]);
      importContacts(contacts, index + 1, failures, successCb);
    });
  };

  /**** Contact Shares ****/
  this.getContactShares = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseContactShares = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('contact_share');
    if (params == null) {
      params = {};
    }
    baseContactShares.getList(params).then(successCb, failureCb);
  };

  this.getUserContactShares = function (params, successCb, failureCb) {
    var baseContactShares = Restangular.all('contact_share');
    if (params == null) {
      params = {};
    }
    baseContactShares.getList(params).then(successCb, failureCb);
  };

  var saveContactShare = function saveContactShare(share, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseContactShares = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('contact_share');

    if (share.id == null) {
      baseContactShares.customPOST(share).then(successCb, failureCb);
    } else {
      baseContactShares.one(share.id).customPUT(share).then(successCb, failureCb);
    }
  };

  this.saveContactShare = saveContactShare;

  this.saveBulkContactShares = function (emails, share, successCb) {
    var failures = [];
    saveBulkContactShares(0, emails, share, failures, successCb);
  };

  var saveBulkContactShares = function saveBulkContactShares(index, emails, share, failures, successCb) {
    if (index >= emails.length) {
      successCb(failures);
      return;
    }

    var shareToSave = share;
    share.recipient = emails[index];
    saveContactShare(share, function () {
      saveBulkContactShares(index + 1, emails, share, failures, successCb);
    }, function (err) {
      failures.push(emails[index]);
      saveBulkContactShares(index + 1, emails, share, failures, successCb);
    });
  };

  var deleteContactShare = function deleteContactShare(shareId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseContactShares = Restangular.all('contact_share');

    if (organisation != null && organisationGroup != null) {
      baseContactShares = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('contact_share');
    }

    if (shareId.id != null) {
      shareId = shareId.id;
    }

    baseContactShares.one(shareId).remove().then(successCb, failureCb);
  };

  this.deleteContactShare = deleteContactShare;

  this.deleteBulkContactShares = function (shares, successCb) {
    var failures = [];
    deleteContactShares(0, shares, failures, successCb);
  };

  var deleteContactShares = function deleteContactShares(index, shares, failures, successCb) {
    if (index >= shares.length) {
      successCb(failures);
      return;
    }

    deleteContactShare(shares[index], function () {
      deleteContactShares(index + 1, shares, failures, successCb);
    }, function (err) {
      failures.push(shares[index]);
      deleteContactShare(index + 1, shares, failures, successCb);
    });
  };
}]);

/***/ }),

/***/ "o3T1":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/docketsHeading.html';
var html = "<div class=\"contentHeadingOuter\">\n  <div class=\"contentHeadingInner desktopTableSearch\">\n    <div class=\"headerSplit\">\n      <div class=\"left\">\n        <h1 ng-if=\"listView == 'dockets'\">Dockets</h1>\n        <h1 ng-if=\"listView == 'filing'\">Filing</h1>\n        <h1 ng-if=\"listView == 'batch'\">Batches</h1>\n\n        <!-- Reload List Buttons -->\n        <md-button class=\"md-icon-button\" ng-click=\"loadDocketsList(null, true)\" aria-label=\"Reload Dockets List\" ng-if=\"listView == 'dockets'\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"loadDocketFilingList(null, true)\" aria-label=\"Reload Docket Filing List\" ng-if=\"listView == 'filing'\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n        <md-button class=\"md-icon-button\" ng-click=\"loadBatchesList()\" aria-label=\"Reload Docket Batch List\" ng-if=\"listView == 'batch'\">\n          <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n        </md-button>\n\n      </div>\n      <div class=\"right\">\n        <div md-menu-origin ng-if=\"currentOrg.features.dockets.bulkImport\" class=\"newDbButton whiteOutline rightMargin\" ng-click=\"goToBulkDocketImport()\" aria-label=\"Bulk Upload\">\n          Bulk Import\n        </div>\n\n        <!-- Create New Buttons -->\n        <md-menu ng-show=\"userCanDoAction('createOperatorDocket')\" ng-if=\"listView == 'dockets'\">\n          <div md-menu-origin class=\"newDbButton\" aria-label=\"New Docket\" ng-click=\"currentOrg.planFeatures.docketsCreate == true ? openMenu($mdOpenMenu, $event) : showUpgradePlanModal(null, 'docketsCreate', 'from dockets page - new docket button')\">\n            <md-icon class=\"smallIcon\" md-svg-icon=\"note_add.svg\"></md-icon>\n            <span style=\"white-space: pre;\"> New</span>\n\n            <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsCreate != true\">\n              <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n            </span>\n            <md-tooltip ng-if=\"currentOrg.planFeatures.docketsCreate != true\" class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"down\">\n              <div style=\"font-size: 12px;\">Upgrade your plan to create new dockets</div>\n            </md-tooltip>\n\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item aria-label=\"New Docket\" ng-click=\"newDocket()\">\n              <md-button>\n                Create New Docket\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"New Docket For Operator\" ng-click=\"newDocket(null,null,true)\">\n              <md-button>\n                Create New Docket For Operator\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n        <md-menu ng-if=\"listView == 'dockets'\">\n          <div md-menu-origin aria-label=\"Open list actions menu\" class=\"newDbButton whiteOutline leftMargin\" ng-click=\"(selected.length > 0) && openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n            <span>Actions</span>\n            <md-icon class=\"smallIcon\" md-svg-icon=\"arrow_down.svg\"></md-icon>\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.sendDocket')\" ng-click=\"bulkSelectionSend()\" aria-label=\"Send Selected Dockets\">\n              <md-button>\n                Send Dockets\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.approveDocket')\" ng-click=\"bulkSelectionAccept()\" aria-label=\"Aceept Selected Dockets\">\n              <md-button>\n                Accept Dockets\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.rejectDocket')\" ng-click=\"bulkSelectionReject()\" aria-label=\"Reject Selected Dockets\">\n              <md-button>\n                Reject Dockets\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-click=\"currentOrg.planFeatures.docketsReports ? bulkSelectionExport() : selectPlan(null, 'docketsReports', 'from dockets page - export dockets')\" aria-label=\"Export Selected Dockets\">\n              <md-button>\n                Export Dockets\n                <span class=\"lockIcon\" ng-if=\"!currentOrg.planFeatures.docketsReports\">\n                  <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n                </span>\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.fileDockets')\" ng-click=\"currentOrg.planFeatures.docketsFiling ? fileBulkDockets() : selectPlan(null, 'docketsFiling', 'from dockets page - file dockets')\" aria-label=\"File Selected Dockets\">\n              <md-button>\n                File Dockets\n                <span class=\"lockIcon\" ng-if=\"!currentOrg.planFeatures.docketsFiling\">\n                  <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n                </span>\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.acceptAndFileDockets') || (userHasPermission('io.docketbook.ojdapi.fileDockets') && userHasPermission('io.docketbook.ojdapi.approveDocket'))\" ng-click=\"currentOrg.planFeatures.docketsFiling ? acceptAndFileBulkDockets() : selectPlan(null, 'docketsFiling', 'from dockets page - accept and file dockets')\" aria-label=\"Accept and File Selected Dockets\">\n              <md-button>\n                Accept & File Dockets\n                <span class=\"lockIcon\" ng-if=\"!currentOrg.planFeatures.docketsFiling\">\n                  <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n                </span>\n              </md-button>\n            </md-menu-item>\n\n            <!--<md-menu-item ng-click=\"bulkSelectionSummary()\" aria-label=\"Generate Invoice Summary\">\n              <md-button>\n                Generate Invoice Summary\n              </md-button>\n            </md-menu-item>-->\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.deleteDocket')\" ng-click=\"bulkSelectionDelete()\" aria-label=\"Delete Selected Dockets\">\n              <md-button>\n                Delete Dockets\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Invoice\" ng-click=\"invoiceSelectedDockets()\" ng-if=\"currentOrg.planFeatures.docketsCreateBatches\">\n              <md-button>\n                Invoice Dockets (Xero)\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n        <!--md-menu ng-if=\"listView == 'filing'\">\n          <div md-menu-origin aria-label=\"Open list actions menu\" class=\"newDbButton whiteOutline leftMargin\" ng-click=\"(selected.length > 0) && openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n            <span>Actions</span>\n            <md-icon class=\"smallIcon\" md-svg-icon=\"arrow_down.svg\"></md-icon>\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"fileBulkDockets()\" aria-label=\"File Selected Dockets\">\n              <md-button>\n                File Dockets\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu-->\n\n        <div md-menu-origin class=\"newDbButton\" aria-label=\"New Docket\" ng-if=\"listView == 'dockets'\" ng-show=\"userCanDoAction('createAdhocDocket') && !userCanDoAction('createOperatorDocket')\" ng-click=\"currentOrg.planFeatures.docketsCreate == true ? newDocket() : showUpgradePlanModal(null, 'docketsCreate', 'from dockets page - new docket button')\">\n          <md-icon class=\"smallIcon\" md-svg-icon=\"note_add.svg\"></md-icon>\n          <span style=\"white-space: pre;\"> New</span>\n\n          <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsCreate != true\">\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </span>\n          <md-tooltip ng-if=\"currentOrg.planFeatures.docketsCreate != true\" class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"down\">\n            <div style=\"font-size: 12px;\">Upgrade your plan to create new dockets</div>\n          </md-tooltip>\n        </div>\n\n        <div md-menu-origin class=\"newDbButton\" ng-show=\"userCanDoAction('createBatch')\" ng-click=\"currentOrg.planFeatures.docketsCreateBatches == true ? openDocketBatchModal() : showUpgradePlanModal(null, 'docketsCreateBatches', 'from dockets page - create batch button')\" aria-label=\"New Docket Batch\" ng-if=\"listView == 'batch'\">\n          <md-icon class=\"smallIcon\" md-svg-icon=\"note_add.svg\"></md-icon>\n          <span style=\"white-space: pre;\"> New</span>\n\n          <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsCreateBatches != true\">\n            <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n          </span>\n          <md-tooltip ng-if=\"currentOrg.planFeatures.docketsCreateBatches != true\" class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"down\">\n            <div style=\"font-size: 12px;\">Upgrade your plan to create batches</div>\n          </md-tooltip>\n        </div>\n\n        <md-menu ng-if=\"listView == 'batch'\">\n          <div md-menu-origin aria-label=\"Open list actions menu\" class=\"newDbButton whiteOutline leftMargin\" ng-click=\"(selected.length > 0) && openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n            <span>Actions</span>\n            <md-icon class=\"smallIcon\" md-svg-icon=\"arrow_down.svg\"></md-icon>\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-show=\"userHasPermission('io.docketbook.ojdapi.deleteBatch')\" ng-click=\"bulkBatchDelete()\" aria-label=\"Delete Selected Batches\">\n              <md-button>\n                Delete Batches\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n        <!-- Filters Button -->\n        <!--<md-button class=\"has-hover-count md-icon-button {{activeFilters > 0 ? 'md-primary' : '' }}\" ng-click=\"showFilters = !showFilters\" aria-label=\"Show / Hide Filters\">\n          <md-icon md-svg-icon=\"filter.svg\"></md-icon>\n          <div class=\"md-icon-hover-count\" ng-show=\"activeFilters > 0\">{{activeFilters}}</div>\n        </md-button>-->\n\n\n\n        <!-- Dockets Reports Menu -->\n        <md-menu ng-if=\"listView == 'dockets' && !myDocketbook\">\n          <div md-menu-origin aria-label=\"Open list actions menu\" class=\"newDbButton whiteOutline leftMargin\" ng-click=\"reportButtonClick($mdOpenMenu, $event)\">\n            <span>Reports</span>\n            <md-icon class=\"smallIcon\" md-svg-icon=\"arrow_down.svg\"></md-icon>\n\n            <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsReports != true\">\n              <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n            </span>\n\n            <md-tooltip class=\"dbtooltip\" style=\"background-color: #171717;\" md-direction=\"down\" ng-if=\"currentOrg.planFeatures.docketsReports != true\">\n              <div style=\"font-size: 12px;\">Unlock Docket Reporting features on the Small Plan</div>\n            </md-tooltip>\n\n          </div>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"openSummaryReport()\" aria-label=\"Docket Summary Report\">\n              <md-button>\n                Docket Summary Report\n              </md-button>\n            </md-menu-item>\n            <md-menu-item ng-click=\"currentOrg.planFeatures.docketsFiling ? openFileCodeReport() : selectPlan(null, 'docketsFiling', 'from dockets page - file code report')\" aria-label=\"File Code Report\">\n              <md-button>\n                File Code Report\n                <span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsFiling != true\">\n                  <md-icon md-svg-src=\"padlock.svg\"></md-icon>\n                </span>\n              </md-button>\n            </md-menu-item>\n            <md-menu-item aria-label=\"Docket Batch\" ui-sref=\"main.groupBatches({orgId:currentOrg.id, groupId:currentOrgGroup.id,action:'newbatch'})\" ng-if=\"currentOrg.planFeatures.docketsCreateBatches\">\n              <md-button>\n                Generate Xero Invoice\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n        <!-- File Code Reports Menu -->\n        <md-menu ng-if=\"listView == 'filing'\">\n          <md-button aria-label=\"Open reports action menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n            <md-icon md-menu-origin md-svg-icon=\"report.svg\"></md-icon>\n          </md-button>\n          <md-menu-content width=\"4\">\n            <md-menu-item ng-click=\"openFileCodeReport()\" aria-label=\"File Code Report\">\n              <md-button>\n                File Code Report\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "o5IO":
/***/ (function(module, exports, __webpack_require__) {

var path = 'views/pages/paywalled/exportDockets.html';
var html = "<div style=\"width: 100%; height: 100%; background-color: white; display: table; padding-top: 40px; padding-bottom: 40px;\">\n    <div style=\"display: table-cell; vertical-align: middle;\">\n        <div class=\"\" style=\"display: table; margin: auto\">\n            <div style=\"display: table-cell;\">\n                <img src=\"" + __webpack_require__("fc0h") + "\"/>\n            </div>\n            <div class=\"lockSectionTextContainer\">\n                <h3 class=\"darkBlueBold\">EXPORT DOCKET DATA</h3>\n                <h1 class=\"boldBlueText\">Get insights into your business, as the work is done</h1>\n                <p class=\"lockJobsText\">Docketbook’s powerful new reporting engine allows you to see the status of your work, project performance and quantities to date, all in real time, as the work happens.</p>\n                <a class=\"dbColorText\" target=\"_blank\" href=\"https://help.docketbook.com.au/hc/en-us/articles/360051782854-Docket-Export\">Learn more about exporting docket data</a>\n            </div>\n        </div>\n\n        <div class=\"lockSubcardsContainer\">\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Real data in real time</h3>\n                <span>Reports are instantly generated off the very latest docket data – no reading dockets and slaving over spreadsheets.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Engage your audience with data that’s visible</h3>\n                <span>A powerful charting engine means that your data is not just accurate, it’s engaging!</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Address the issues before they become issues</h3>\n                <span>Identify what you need to track and save your reports – see what you want when you want.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Something Else Here</h3>\n                <span>Something Else Here.</span>\n            </div>\n        </div>\n\n        <div style=\"text-align: center; margin-top: 100px\">\n            <div class=\"newDbButton\" style=\"width: 250px\" ng-click=\"selectPlan(null, null, 'from export dockets paywall page')\">\n                Upgrade Plan\n            </div>\n            <div ng-if=\"currentOrg.planFeatures.trialAvailable && !currentOrg.planFeatures.inTrial\" class=\"newDbButton whiteOutline\" style=\"width: 250px; margin-left: 30px;\" ng-click=\"trialButtonClick()\">\n                Start a 7 day free trial\n            </div>\n        </div>\n    </div>\n</div>\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n<ng-include src=\"'views/modals/trialActivatedModal.html'\" ng-controller=\"trialActivatedModalController\"></ng-include>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ogWe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon-96x96.png";

/***/ }),

/***/ "oqLE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('orderMobileDetailController', ['docketService', 'orderService', 'resourceService', 'userService', 'addressBookService', '$rootScope', '$window', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', function (docketService, orderService, resourceService, userService, addressBookService, $rootScope, $window, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {
  mixpanel.track("Opened OrdersDetail Mobile");

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.itemEdit = null;
  $scope.viewState = 'order';
  $scope.originalOrder = {};
  $scope.orderLoadingError = null;

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  // Data
  if ($scope.currentOrg != null) {
    $scope.allResourceCategories = [];
    docketService.getTemplates({ published: true }, function (templates) {
      $scope.allTemplates = templates;
    });
    addressBookService.getAddressBook(null, function (addressBookFull) {
      $scope.addressBook = addressBookFull;
    });
  }

  /**********************/
  /**** Permissions *****/
  /**********************/

  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.userCanDoAction = userService.userCanDoAction;

  /*****************************/
  /**** Load Required Data *****/
  /*****************************/

  $scope.getResourceCategories = function () {
    $scope.allResourceCategories = [];
    resourceService.getResourceCategories({}, function (resourceCategories) {
      $scope.allResourceCategories = resourceCategories;
    }, function (err) {
      console.error('could not get resource categories', err);
    });
  };
  if ($scope.currentOrg != null) {
    $scope.getResourceCategories();
  }

  /**************************************/
  /***** Order Detail View Controls *****/
  /**************************************/

  $scope.openOrderMobile = function (order, tabToOpen) {
    $scope.orderLoadingError = null;
    $scope.viewState = 'order';
    var openTab = tabToOpen;
    if ($stateParams.openTab != null) {
      openTab = $stateParams.openTab;
    }
    $scope.prepareForOrderFromParent(openTab, order);
    orderService.getOrder(order, function (orderFull) {
      $scope.originalOrder = angular.copy(orderFull);
      $scope.loadOrderFromParent(orderFull);
    }, function (err) {
      $scope.orderLoadingErrorFull = err;
      $scope.orderLoadingError = "Error Loading Order";
    });
  };

  $scope.newOrder = function () {
    $scope.viewState = 'order';
    $scope.newOrderFromParent();
    $scope.originalOrder = {};
  };

  $scope.closeOrder = function () {
    var stateBack = {};
    if ($stateParams.stateTrail && $stateParams.stateTrail.length > 0) {
      stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
    }
    var stateOptions = {};
    if (stateBack.orderId) {
      stateOptions.orderId = stateBack.orderId;
    }
    if (stateBack.jobId) {
      stateOptions.jobId = stateBack.jobId;
    }
    if (stateBack.docketId) {
      stateOptions.docketId = stateBack.docketId;
    }
    if (stateBack.fromTab) {
      stateOptions.openTab = stateBack.fromTab;
    }
    if (stateBack.orgId) {
      stateOptions.orgId = stateBack.orgId;
    }
    if (stateBack.groupId) {
      stateOptions.groupId = stateBack.groupId;
    }
    if (stateBack.name) {
      if (stateBack.name == 'main.groupOrderDetail' && stateOptions.orderId == 'new') {
        $state.go('main.groupOrders', stateOptions);
      } else {
        $state.go(stateBack.name, stateOptions);
      }
    } else if ($scope.currentOrg != null) {
      $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    } else {
      $state.go('main.orders');
    }
  };

  $scope.deleteOrder = function (order) {
    orderService.deleteOrder(order.id, function () {
      $scope.closeOrder();
    }, function (err) {
      $scope.alertService.presentAutoAlert('deleteOrder', err);
    });
  };

  $scope.closeWithoutSave = function () {
    var currentOrder = $scope.getOrderFromParent();
    if (currentOrder != null && currentOrder.editing) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              orderService.saveOrder(diff, function (updatedOrder) {
                $scope.closeOrder();
              });
            } else if (actionSelected == 'dontSave') {
              $scope.closeOrder();
            }
          });
        } else {
          $scope.closeOrder();
        }
      });
    } else {
      $scope.closeOrder();
    }
  };

  $scope.saveAndStay = function (order) {
    var newOrder = false;
    if (order.id == null) {
      newOrder = true;
    }
    order.loading = true;
    // get diffed order
    orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
      if (diffCount > 0 || newOrder == true) {
        orderService.saveOrder(diff, function (orderUpdated) {
          if (newOrder) {
            $scope.showToast('New Order Saved');
            $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: orderUpdated.id });
            //$scope.openOrderMobile(orderUpdated);
          } else {
            $scope.showToast('Order Changes Saved');
            $scope.openOrderMobile(orderUpdated.id, $scope.currentActiveTab());
          }
        }, function (err) {
          order.loading = false;
          $scope.alertService.presentAutoAlert('saveOrder', err);
        });
      } else {
        order.loading = false;
      }
    });
  };

  $scope.reDraftOrder = function (order) {
    $mdBottomSheet.hide();
    order.loading = true;
    order.loadingType = 'saving';
    orderService.reDraftOrder(order, function (orderUpdated) {
      $scope.openOrderMobile(orderUpdated.id);
    }, function (error) {
      order.loading = false;
      $scope.showToast('Error Re-Drafting Order');
    });
  };

  $scope.sendOrder = function (order) {
    // first save the order
    $mdBottomSheet.hide();
    order.loading = true;
    order.loadingType = 'saving';
    // get order diff
    orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
      orderService.saveOrder(diff, function (orderUpdated) {
        orderService.sendOrder(orderUpdated, function () {
          $scope.openOrderMobile(orderUpdated.id);
        }, function (error) {
          order.loading = false;
          $scope.alertService.presentAutoAlert('sendOrder', error);
        });
      }, function (error) {
        order.loading = false;
        $scope.alertService.presentAutoAlert('saveOrder', error);
      });
    });
  };

  $scope.acceptOrder = function (order) {
    $mdBottomSheet.hide();
    order.loading = true;
    order.loadingType = 'saving';
    orderService.acceptOrder(order, function () {
      $scope.openOrderMobile(order.id);
    }, function (error) {
      order.loading = false;
      $scope.alertService.presentAutoAlert('acceptOrder', error);
    });
  };

  $scope.rejectOrder = function (order) {
    $mdBottomSheet.hide();
    order.loading = true;
    order.loadingType = 'saving';
    orderService.rejectOrder(order, function () {
      $scope.openOrderMobile(order.id);
    }, function (error) {
      order.loading = false;
      $scope.alertService.presentAutoAlert('rejectOrder', error);
    });
  };

  $scope.finishOrder = function (order) {
    $mdBottomSheet.hide();
    order.loading = true;
    order.loadingType = 'saving';
    orderService.closeOrder(order, function () {
      $scope.openOrderMobile(order.id);
    }, function (error) {
      order.loading = false;
      $scope.alertService.presentAutoAlert('closeOrder', error);
    });
  };

  /********************************/
  /***** MAIN OPENING CONTROLS ****/
  /********************************/

  // Parameter controls
  $scope.detailControllerReady = function () {
    if ($stateParams.orderId != null) {
      if ($stateParams.orderId == 'new') {
        $scope.newOrder();
      } else {
        $scope.openOrderMobile($stateParams.orderId);
      }
    }
  };

  /******************************/
  /***** List View Controls *****/
  /******************************/

  $scope.showOrderDetail = function () {
    $scope.viewState = 'order';
  };

  $scope.selectCompanyForOrder = function (sourceList, companyType, cb) {
    $scope.viewState = 'company';
    $scope.selectCompanyCallback = cb;
    $scope.companySelectFromParent(sourceList, companyType, function (companySelected) {
      $scope.selectCompanyCallback(companySelected);
      $scope.showOrderDetail();
    });
  };

  $scope.selectContactForOrder = function (order, companyType, cb) {
    $scope.viewState = 'company';
    $scope.selectContactCallback = cb;
    var existingContacts = [];
    var selectedContact = null;
    if (companyType == 'customerContact') {
      if (order.supplierContact != null) {
        existingContacts.push(order.supplierContact);
      }
      if (order.customerContact != null) {
        selectedContact = order.customerContact;
      }
    } else if (companyType == 'supplierContact') {
      if (order.customerContact != null) {
        existingContacts.push(order.customerContact);
      }
      if (order.supplierContact != null) {
        selectedContact = order.supplierContact;
      }
    }
    $scope.selectCompanyType = companyType;

    $scope.contactSelectFromParent(existingContacts, selectedContact, function (contactSelected) {
      $scope.selectContactCallback(contactSelected);
      $scope.showOrderDetail();
    });
  };

  $scope.selectContactForShare = function (cb) {
    $scope.viewState = 'company';
    $scope.contactSelectFromParent(null, null, function (companySelected) {
      cb(companySelected);
      $scope.showOrderDetail();
    });
  };

  $scope.selectTemplateForOrder = function (sourceList, cb) {
    $scope.viewState = 'docketTemplate';
    $scope.selectTemplateCallback = cb;
    $scope.templateSelectFromParent(sourceList, function (templateSelected) {
      $scope.selectTemplateCallback(templateSelected);
      $scope.showOrderDetail();
    });
  };

  $scope.selectResourceForLine = function (cb) {
    $scope.viewState = 'resource';
    $scope.selectResourceCallback = cb;
    var order = $scope.getOrderFromParent();
    var templateCategories = null;
    if (order.template && order.template.interactionTemplates) {
      templateCategories = {};
      for (var i = 0; i < order.template.interactionTemplates.length; i++) {
        var interactionTemplate = order.template.interactionTemplates[i];
        for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
          if (templateCategories[interactionTemplate.actorCategories[j].id] == null) {
            templateCategories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
          }
        }
      }
    }
    var categories = [];
    if (templateCategories == null) {
      categories = $scope.allResourceCategories;
    } else {
      for (var key in templateCategories) {
        categories.push(templateCategories[key]);
      }
    }
    var options = { categoriesList: categories };
    $scope.resourceSelectFromParent(options, function (resourceSelected) {
      $scope.selectResourceCallback(resourceSelected);
      $scope.showOrderDetail();
    });
  };

  $scope.selectOrganisationForOrder = function (order, cb) {
    $scope.viewState = 'organisation';
    $scope.selectOrganisationCallback = cb;
    $scope.assignDocket = {};
    $scope.assignDocket.organisations = accessControl.allowedOrganisations();
  };

  $scope.cancelSelectOrganisation = function () {
    $scope.showOrderDetail();
    $scope.selectOrganisationCallback(null);
  };

  $scope.selectOrganisationContinue = function (group) {
    $scope.showOrderDetail();
    $scope.selectOrganisationCallback(group);
  };

  /**************************/
  /***** Modal Controls *****/
  /**************************/

  $scope.newLineItemForOrder = function (order, cb) {
    $scope.newLineItemCallback = cb;
    $scope.newLineItemFromParent(order, function (lineItem) {
      $scope.newLineItemCallback(lineItem);
    });
  };

  $scope.editLineItemForOrder = function (order, item, cb) {
    $scope.editLineItemCallback = cb;
    $scope.editLineItemFromParent(order, item, function (lineItem) {
      $scope.editLineItemCallback(lineItem);
    });
  };

  /**************************************/
  /***** Infinite scrolling methods *****/
  /**************************************/

  $scope.loadingMoreItems = false;
  $scope.docketsListLoadingCount = 0;
  angular.element($window).bind('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 20) {
      if ($scope.currentActiveTab() == 'Dockets' && !$scope.loadingMoreItems) {
        // load next page of dockets
        $scope.loadingMoreItems = true;
        $("#docketsLoadingMore").removeClass("hidden");
        $scope.loadOrderDocketsNextPage(function () {
          $scope.loadingMoreItems = false;
          $("#docketsLoadingMore").addClass('hidden');
        });
      } else if ($scope.currentActiveTab() == 'Jobs' && !$scope.loadingMoreItems) {
        // load next page of jobs
        $scope.loadingMoreItems = true;
        $("#jobsLoadingMore").removeClass('hidden');
        $scope.loadOrderJobsNextPage(function () {
          $scope.loadingMoreItems = false;
          $("#jobsLoadingMore").addClass('hidden');
        });
      }
    }
  });

  /************************************/
  /**** New Job / Docket Controls *****/
  /************************************/

  $scope.newJobForOrder = function () {
    // First check if order has been saved?
    var currentOrder = $scope.getOrderFromParent();
    orderService.validateCreateJob(currentOrder, function () {
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            swal({
              title: "Unsaved Changes",
              text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, close order.",
              cancelButtonText: "No, dont close order.",
              closeOnConfirm: true,
              closeOnCancel: true
            }, function (isConfirm) {
              if (isConfirm) {
                $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              }
            });
          } else {
            $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }, function (exceptions) {
      currentOrder.loading = false;
      $scope.alertService.presentValidationAlert('Some fields are required before you can create a job for this order.', exceptions);
    });
  };

  $scope.openJob = function (job) {
    var currentOrder = $scope.getOrderFromParent();
    if (currentOrder != null && currentOrder.editing) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0) {
          swal({
            title: "Unsaved Changes",
            text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, close order.",
            cancelButtonText: "No, dont close order.",
            closeOnConfirm: true,
            closeOnCancel: true
          }, function (isConfirm) {
            if (isConfirm) {
              $state.go('main.groupJobDetail', { jobId: job.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            }
          });
        } else {
          $state.go('main.groupJobDetail', { jobId: job.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      });
    } else {
      $state.go('main.groupJobDetail', { jobId: job.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }
  };

  $scope.newDocketForOrder = function () {
    // First check if order has been saved?
    var currentOrder = $scope.getOrderFromParent();
    orderService.validateCreateJob(currentOrder, function () {
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            swal({
              title: "Unsaved Changes",
              text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, close order.",
              cancelButtonText: "No, dont close order.",
              closeOnConfirm: true,
              closeOnCancel: true
            }, function (isConfirm) {
              if (isConfirm) {
                $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              }
            });
          } else {
            $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }, function (exceptions) {
      currentOrder.loading = false;
      $scope.alertService.presentValidationAlert('Some fields are required before you can create a docket for this order.', exceptions);
    });
  };

  $scope.openDocket = function (docket) {
    var currentOrder = $scope.getOrderFromParent();
    if (currentOrder != null && currentOrder.editing) {
      orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
        if (diffCount > 0) {
          swal({
            title: "Unsaved Changes",
            text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, close order.",
            cancelButtonText: "No, dont close order.",
            closeOnConfirm: true,
            closeOnCancel: true
          }, function (isConfirm) {
            if (isConfirm) {
              $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            }
          });
        } else {
          $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      });
    } else {
      $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "oxWV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pDCK":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/checklists.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\" ng-if=\"templateEdit == null\">\n    <div class=\"left\">\n      <h3>Checklists</h3>\n    </div>\n    <div class=\"right\">\n      <md-button class=\"md-icon-button\" ng-click=\"newTemplate()\" aria-label=\"New Checklist Template\">\n        <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n      </md-button>\n      <md-button class=\"md-icon-button\" ng-click=\"loadChecklistsList()\" aria-label=\"Reload Checklists List\">\n        <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n      </md-button>\n      <md-menu>\n        <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n          <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"4\">\n          <md-menu-item ng-click=\"deleteSelectedChecklists()\" aria-label=\"Delete Selected Checklists\">\n            <md-button>\n              Delete Selected Checklists\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </div>\n  </div>\n  <div class=\"settingsHeader\" ng-if=\"templateEdit != null\">\n    <div class=\"backButton\" ng-click=\"closeTemplateEdit()\">\n      <md-icon md-svg-src=\"arrow_left.svg\"></md-icon>\n    </div>\n    <div class=\"left\">\n      <h3 ng-if=\"templateEdit.id != null\">Edit Template - {{templateEdit.name}}</h3>\n      <h3 ng-if=\"templateEdit.id == null\">New Template</h3>\n    </div>\n    <div class=\"right\">\n      <div class=\"dbButton spinner\" ng-click=\"saveTemplate(templateEdit)\" ng-disabled=\"checklistEditForm.$invalid || templateEdit.loading\">\n        <span ng-hide=\"templateEdit.loading\">Save</span>\n        <md-progress-circular ng-show=\"templateEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"settingsTableOuterContainer\" ng-if=\"templateEdit == null\">\n    <md-table-container>\n      <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n        <thead md-head md-order=\"query.order\" md-on-reorder=\"loadChecklistsList\">\n          <tr md-row>\n            <th md-column md-order-by=\"name\"><span>Name</span></th>\n            <th md-column md-order-by=\"type\"><span>Type</span></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row md-select=\"template\" md-select-id=\"id\" ng-repeat=\"template in allChecklistTemplates\" ng-click=\"editTemplate(template)\" style=\"cursor: pointer;\">\n            <td md-cell>{{template.name}}</td>\n            <td md-cell>\n              <span ng-if=\"template.type=='day'\">Complete Once Per Day</span>\n              <span ng-if=\"template.type=='docket'\">Complete Once Per Docket</span>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n    <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadChecklistsList\" md-total=\"{{listCount}}\" md-page-select>\n    </md-table-pagination>\n  </div>\n\n  <div class=\"settingsRightContentInner\" ng-if=\"templateEdit != null\">\n    <div class=\"adminBasicContentContainer\" >\n      <div class=\"adminSettingGroupContainer\">\n        <div class=\"adminPaddedContent\">\n          <form name=\"checklistEditForm\">\n            <h4 class=\"top\">General</h4>\n\n            <div layout-gt-sm=\"row\">\n              <md-input-container flex-gt-sm=\"33\">\n                <label>Name</label>\n                <input type=\"text\" name=\"name\" ng-model=\"templateEdit.name\" required />\n              </md-input-container>\n\n              <md-input-container flex-gt-sm=\"33\">\n                <label>Type</label>\n                <md-select name=\"type\" ng-model=\"templateEdit.type\" required>\n                  <md-option value=\"day\">Complete Once Per Day</md-option>\n                  <md-option value=\"docket\">Complete Once Per Docket</md-option>\n                </md-select>\n              </md-input-container>\n            </div>\n\n            <div class=\"listSpacer\"></div>\n\n            <div class=\"headingSplit\">\n              <div class=\"left\">\n                <h4>Checklist Items</h4>\n              </div>\n              <div class=\"right\">\n                <md-button class=\"\" ng-click=\"addBlankFieldToTemplate(templateEdit)\">Add Item</md-button>\n              </div>\n            </div>\n\n            <div class=\"adminInnerTable\">\n              <md-table-container>\n                <table md-table ng-show=\"templateEdit.fields.length > 0\">\n                  <thead md-head>\n                    <tr md-row>\n                      <th md-column>Question</th>\n                      <th md-column width=\"100px\">Action</th>\n                    </tr>\n                  </thead>\n                  <tbody md-body ng-repeat=\"field in templateEdit.fields\">\n                    <form name=\"innerForm\">\n                      <tr md-row>\n                        <td md-cell>\n                          <md-input-container class=\"md-block\" flex-gt-sm>\n                            <input ng-model=\"field.displayName\" required>\n                          </md-input-container>\n                        </td>\n                        <td md-cell>\n                          <md-button class=\"md-icon-button\" ng-click=\"removeFieldFromTemplate(field, templateEdit)\" aria-label=\"Remove Field From Template\">\n                            <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                          </md-button>\n                        </td>\n                      </tr>\n                    </form>\n                  </tbody>\n                </table>\n              </md-table-container>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "pDjR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('docketDesignerController', ['docketService', 'uuid', 'resourceService', 'Upload', '$q', '$scope', '$window', 'Restangular', '$state', '$stateParams', '$timeout', 'accessControl', 'ObjectDiff', function (docketService, uuid, resourceService, Upload, $q, $scope, $window, Restangular, $state, $stateParams, $timeout, accessControl, ObjectDiff) {
  mixpanel.track("Opened DocketDesigner Desktop");

  $scope.currentUser = $state.params.currentUser;
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  if ($stateParams.mode == 'configure') {
    $scope.mode = 'configure';
  } else {
    $scope.mode = 'preview';
  }
  $scope.rightPane = { view: 'fields' };

  $scope.templateEdit = {};
  $scope.originalTemplate = {};
  $scope.currentSection = null;
  $scope.activityEdit = null;
  $scope.allFields = [];
  $scope.availablePrefillFields = [];
  $scope.allChecklists = [];
  $scope.allResourceCategories = [];

  $scope.availablePdfBuilders = [{
    name: 'standard',
    displayName: 'Standard'
  }, {
    name: 'standardOpt',
    displayName: 'Modern'
  }, {
    name: 'compact',
    displayName: 'Compact'
  }];

  /*********************/
  /* Main Data Methods */
  /*********************/

  /* Get Field Data */
  $scope.getFields = function () {
    docketService.getFields({}, function (fields) {
      $scope.allFields = fields;
    }, function (err) {
      $scope.allFields = [];
    });
  };
  $scope.getFields();

  /* Get Checklist Templates */
  $scope.getChecklists = function () {
    docketService.getChecklistTemplates({}, function (checklistTemplates) {
      $scope.allChecklists = checklistTemplates;
    }, function (err) {
      $scope.allChecklists = [];
    });
  };

  $scope.getChecklists();

  /* Get Resource Categories */
  $scope.getResourceCategories = function () {
    resourceService.getResourceCategories({}, function (categories) {
      $scope.allResourceCategories = categories;
    }, function (err) {
      $scope.allResourceCategories = [];
    });
  };

  $scope.getResourceCategories();

  /* Get Tempalate Detail */
  $scope.getTemplate = function () {
    if ($stateParams.templateId && $stateParams.templateId != 'new') {
      docketService.getTemplate($stateParams.templateId, function (templateFull) {
        $scope.templateEdit = templateFull;
        var existingStandardBlocks = [];
        for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
          if ($scope.templateEdit.blocks[i].type != 'custom') {
            existingStandardBlocks.push($scope.templateEdit.blocks[i].type);
          }
        }
        $scope.templateEdit.existingStandardBlocks = existingStandardBlocks;

        // setup interaction templates for categories matrix editing
        var interactionTemplatesMatrix = {};
        for (var i = 0; i < $scope.templateEdit.interactionTemplates.length; i++) {
          var templateMatrix = {};
          for (var j = 0; j < $scope.templateEdit.interactionTemplates[i].actorCategories.length; j++) {
            templateMatrix[$scope.templateEdit.interactionTemplates[i].actorCategories[j].id] = true;
          }
          interactionTemplatesMatrix[$scope.templateEdit.interactionTemplates[i].name] = templateMatrix;
        }
        $scope.templateEdit.interactionTemplatesMatrix = interactionTemplatesMatrix;
        if ($scope.templateEdit.checklistContainers == null) {
          $scope.templateEdit.checklistContainers = [];
        }
        $scope.templateEdit.blockVisibilitySettings = {};
        for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
          var blockName = $scope.templateEdit.blocks[i].name;
          if ($scope.templateEdit.blocks[i].type != 'custom') {
            blockName = $scope.templateEdit.blocks[i].type;
          }
          if ($scope.templateEdit.hiddenBlockNames.indexOf(blockName) != -1) {
            $scope.templateEdit.blockVisibilitySettings[blockName] = false;
          } else {
            $scope.templateEdit.blockVisibilitySettings[blockName] = true;
          }
        }
        // setup prefill fields list
        $scope.templateEdit.addPrefillField = {};
        $scope.templateEdit.updateOrderPrefillFields = {};
        if (!$scope.templateEdit.orderPrefillFields) {
          $scope.templateEdit.orderPrefillFields = [];
        } else {
          for (var i = 0; i < $scope.templateEdit.orderPrefillFields.length; i++) {
            // populate with full field
            for (var j = 0; j < $scope.allFields.length; j++) {
              if ($scope.allFields[j].id == $scope.templateEdit.orderPrefillFields[i]) {
                $scope.templateEdit.orderPrefillFields[i] = $scope.allFields[j];
                $scope.templateEdit.updateOrderPrefillFields[$scope.allFields[j].id] = true;
                break;
              }
            }
          }
        }
        $scope.updateAvailablePrefillFields($scope.templateEdit);

        $scope.templateEdit = Restangular.stripRestangular($scope.templateEdit);
        $scope.originalTemplate = angular.copy($scope.templateEdit);
      }, function (err) {
        $scope.templateEdit = {};
      });
    } else if ($stateParams && $stateParams.templateId == 'new') {
      $scope.mode = 'new';
      $scope.newTemplateStep = 1;
      $scope.newTemplateWizard = { sectionsIncluded: [] };
      $("#templateWizardStep1").fadeIn(200);
      $scope.templateEdit = {};
      $scope.templateEdit.editing = true;
      $scope.templateEdit.checklistContainers = [];
      $scope.templateEdit.signature = true;
      $scope.templateEdit.blocks = [];
      $scope.templateEdit.blockVisibilitySettings = {};
      $scope.templateEdit.interactionTemplates = [];
      $scope.templateEdit.interactionTemplatesMatrix = {};
      $scope.originalTemplate = angular.copy($scope.templateEdit);
    }
  };

  $scope.getTemplate();

  /********************/
  /* UI Functionality */
  /********************/

  $scope.updateAvailablePrefillFields = function (template) {
    var availableFields = [];
    // get list of all fields on docket template
    var allTemplateFields = {};
    for (var i = 0; i < template.blocks.length; i++) {
      if (template.blocks[i].fields) {
        for (var j = 0; j < template.blocks[i].fields.length; j++) {
          if (!allTemplateFields[template.blocks[i].fields[j].id]) {
            allTemplateFields[template.blocks[i].fields[j].id] = template.blocks[i].fields[j];
          }
        }
      }
    }
    var templateFieldIds = Object.keys(allTemplateFields);

    for (var i = 0; i < templateFieldIds.length; i++) {
      // check if this field is in template.orderPrefillFields
      var isUsed = false;
      for (var j = 0; j < template.orderPrefillFields.length; j++) {
        if (template.orderPrefillFields[j].id == templateFieldIds[i]) {
          isUsed = true;
        }
      }
      if (!isUsed) {
        availableFields.push(allTemplateFields[templateFieldIds[i]]);
      }
    }
    $scope.availablePrefillFields = availableFields;
  };

  $scope.addPrefillField = function () {
    if ($scope.templateEdit.addPrefillField && $scope.templateEdit.addPrefillField.id) {
      $scope.templateEdit.orderPrefillFields.push($scope.templateEdit.addPrefillField);
      $scope.templateEdit.updateOrderPrefillFields[$scope.templateEdit.addPrefillField.id] = true;
      $scope.templateEdit.addPrefillField = {};
      $scope.updateAvailablePrefillFields($scope.templateEdit);
    }
  };

  $scope.backToTemplates = function () {
    $scope.templateEdited = angular.copy($scope.templateEdit);
    $scope.templateEdited = JSON.parse(angular.toJson($scope.templateEdited));
    var diffCount = 0;
    if ($scope.templateEdit.id == null) {
      diffCount = 1;
    } else {
      var diff = ObjectDiff.diff($scope.templateEdited, $scope.originalTemplate);
      var standardFields = ['active', 'attachments', 'blocks', 'checklistContainers', 'interactionTemplates', 'name', 'populateResourcesFromJob', 'published', 'signature'];
      if (diff.changed != 'equal') {
        standardFields.forEach(function (field) {
          if (diff.value[field].changed != 'equal') {
            diffCount += 1;
          }
        });
      }
    }

    if (diffCount <= 0) {
      $state.go('companySettings.templates', { orgId: $scope.currentOrg.id });
    } else {
      var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
      $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
        if (actionSelected == 'save') {
          $scope.saveTemplateEdit();
        } else if (actionSelected == 'dontSave') {
          $state.go('companySettings.templates', { orgId: $scope.currentOrg.id });
        } else {
          // do nothing - stay where we are
        }
      });
    }
  };

  $scope.newTemplateWizardNext = function () {
    $("#templateWizardStep" + $scope.newTemplateStep).fadeOut(200, function () {
      $scope.newTemplateStep += 1;
      $("#templateWizardStep" + $scope.newTemplateStep).fadeIn(200);
    });
  };

  $scope.newTemplateWizardBack = function () {
    $("#templateWizardStep" + $scope.newTemplateStep).fadeOut(200, function () {
      $scope.newTemplateStep -= 1;
      $("#templateWizardStep" + $scope.newTemplateStep).fadeIn(200);
    });
  };

  $scope.newTemplateWizardSubmit = function () {
    $scope.templateEdit.loading = true;
    $("#templateWizardStep" + $scope.newTemplateStep).fadeOut(200, function () {
      $("#templateWizardCreating").fadeIn(200);
    });
    $scope.templateEdit.blocks = [];
    for (var i = 0; i < $scope.newTemplateWizard.sectionsIncluded.length; i++) {
      $scope.templateEdit.blocks.push({ type: $scope.newTemplateWizard.sectionsIncluded[i] });
    }
    $timeout(function () {
      $scope.saveTemplateEdit(true);
    }, 2000);
  };

  $scope.newTemplateWizardTC = function (addTc) {
    if (addTc) {
      $scope.newTemplateWizardNext();
    } else {
      $scope.newTemplateWizardSubmit();
    }
  };

  $scope.selectNewTemplateSection = function (sectionName) {
    var index = $scope.newTemplateWizard.sectionsIncluded.indexOf(sectionName);
    if (index == -1) {
      $scope.newTemplateWizard.sectionsIncluded.push(sectionName);
      $(".newTemplateWizardSections .sectionType." + sectionName).addClass('selected');
    } else {
      $scope.newTemplateWizard.sectionsIncluded.splice(index, 1);
      $(".newTemplateWizardSections .sectionType." + sectionName).removeClass('selected');
    }
  };

  $scope.openBuildMode = function () {
    $scope.mode = 'build';
    $scope.openLeftPane();
    if ($scope.currentSection && ($scope.currentSection.type == 'custom' || $scope.activityEdit != null)) {
      $scope.openRightPane('fields');
    }
  };

  $scope.openPreviewMode = function () {
    $scope.mode = 'preview';
    $scope.closeLeftPane();
    $scope.closeRightPane();
  };

  $scope.openConfigureMode = function () {
    $scope.mode = 'configure';
    $scope.closeLeftPane();
    $scope.closeRightPane();
  };

  $scope.openLeftPane = function () {
    $("#leftControlPane").css({ 'display': 'block' });
    if ($scope.windowWidth < 1600) {
      $scope.minimiseLeftPane();
    } else {
      $("#leftControlPane").animate({
        'left': '0px'
      }, 200, function () {
        $scope.checkLeftPaneHoverOut();
      });
    }
  };

  $scope.closeLeftPane = function () {
    $("#leftControlPane").animate({
      'left': '-250px'
    }, 200, function () {
      $("#leftControlPane").css({ 'display': 'none' });
    });
  };

  $scope.openRightPane = function (view) {
    $scope.rightPane.view = view;
    $("#rightControlPane").css({ 'display': 'block' });
    if ($scope.windowWidth < 1600) {
      $scope.minimiseRightPane();
    } else {
      $("#rightControlPane").animate({
        'right': '0px'
      }, 200);
      $scope.checkRightPaneHover();
    }
  };

  $scope.closeRightPane = function () {
    $("#rightControlPane").animate({
      'right': '-250px'
    }, 200, function () {
      $("#rightControlPane").css({ 'display': 'none' });
    });
  };

  $scope.fetchAvailableFieldsForCurrentBlock = function () {
    $scope.availableFields = [];
    var block = $scope.currentSection;
    for (var i = 0; i < $scope.allFields.length; i++) {
      var found = false;
      for (var j = 0; j < block.fields.length; j++) {
        if (block.fields[j].id == $scope.allFields[i].id) {
          found = true;
          break;
        }
      }
      if (!found) {
        $scope.availableFields.push($scope.allFields[i]);
      }
    }
  };

  $scope.fetchAvailableChecklistContainersForCurrentBlock = function () {
    $scope.availableChecklists = [];
    for (var i = 0; i < $scope.allChecklists.length; i++) {
      var found = false;
      for (var j = 0; j < $scope.templateEdit.checklistContainers.length; j++) {
        if ($scope.templateEdit.checklistContainers[j].checklistTemplate.id == $scope.allChecklists[i].id) {
          found = true;
          break;
        }
      }
      if (!found) {
        var location = 1;
        if ($scope.templateEdit.checklistContainers.length > 0 && $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location != null) {
          location = $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location + 1;
        }
        var newChecklistContainer = { location: location, rule: 'notRequired', checklistTemplate: $scope.allChecklists[i] };
        $scope.availableChecklists.push(newChecklistContainer);
      }
    }
  };

  $scope.fetchAvailableFieldsForCurrentActivity = function () {
    $scope.availableFields = [];
    for (var i = 0; i < $scope.allFields.length; i++) {
      var found = false;
      for (var j = 0; j < $scope.activityEdit.fields.length; j++) {
        if ($scope.allFields[i].id == $scope.activityEdit.fields[j].id) {
          found = true;
          break;
        }
      }
      if (!found && $scope.allFields[i].type != 'label' && $scope.allFields[i].type != 'multiline' && $scope.allFields[i].type != 'signature') {
        $scope.availableFields.push($scope.allFields[i]);
      }
    }
  };

  $scope.editSection = function (block) {
    $scope.currentSection = block;
    if (block.type == 'time') {
      $scope.currentSectionName = 'Time';
      $scope.closeRightPane();
    } else if (block.type == 'signatures') {
      $scope.currentSectionName = 'Signatures';
      $scope.closeRightPane();
    } else if (block.type == 'resources') {
      $scope.currentSectionName = 'Resources';
      $scope.closeRightPane();
    } else if (block.type == 'checklists') {
      $scope.currentSectionName = 'Checklists';
      $scope.fetchAvailableChecklistContainersForCurrentBlock();
      $scope.openRightPane('checklists');
    } else if (block.type == 'custom') {
      $scope.fetchAvailableFieldsForCurrentBlock();
      $scope.openRightPane('fields');
    }
  };

  $scope.newFieldList = [];

  $scope.fieldDragDropped = function (item, data) {
    var newestField = null;
    if ($scope.activityEdit != null) {
      newestField = $scope.activityEdit.fields[$scope.activityEdit.fields.length - 1];
    } else {
      newestField = $scope.currentSection.fields[$scope.currentSection.fields.length - 1];
    }
    var index = -1;
    for (var i = 0; i < $scope.availableFields.length; i++) {
      if ($scope.availableFields[i].id == newestField.id) {
        index = i;
        break;
      }
    }
    if (index != -1) {
      $scope.availableFields.splice(index, 1);
    }
    $scope.updateAvailablePrefillFields($scope.templateEdit);
  };

  $scope.checklistDragDropped = function (item, data) {
    var newestChecklist = $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1];
    var index = -1;
    for (var i = 0; i < $scope.availableChecklists.length; i++) {
      if ($scope.availableChecklists[i].checklistTemplate.id == newestChecklist.checklistTemplate.id) {
        index = i;
        break;
      }
    }
    if (index != -1) {
      $scope.availableChecklists.splice(index, 1);
    }
  };

  $scope.addNewBlock = function () {
    // re-generate list of used blocks
    var existingStandardBlocks = [];
    for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
      if ($scope.templateEdit.blocks[i].type != 'custom') {
        existingStandardBlocks.push($scope.templateEdit.blocks[i].type);
      }
    }
    $scope.templateEdit.existingStandardBlocks = existingStandardBlocks;
    var newBlock = { type: 'new', name: 'New Section', fields: [] };
    $scope.closeRightPane();
    $scope.currentSection = newBlock;
  };

  $scope.selectNewBlockType = function (type) {
    $scope.currentSection.type = type;
    $scope.templateEdit.blocks.push($scope.currentSection);
    $scope.editSection($scope.templateEdit.blocks[$scope.templateEdit.blocks.length - 1]);
  };

  $scope.deleteCurrentSection = function () {
    $scope.currentSection.loading = true;
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete this section?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        var index = $scope.templateEdit.blocks.indexOf($scope.currentSection);

        if ($scope.currentSection.type == 'checklists') {
          $scope.templateEdit.checklistContainers = [];
        }

        if (index != -1) {
          $scope.templateEdit.blocks.splice(index, 1);
          $scope.currentSection = null;
        }

        $scope.closeRightPane();
      } else {
        $scope.currentSection.loading = false;
      }
    });
  };

  $scope.deleteSection = function (block) {
    block.loading = true;
    swal({
      title: "Are you sure?",
      text: "Do you really want to delete this section?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        if (block.type === 'signatures') {
          $scope.templateEdit.signature = false;
        }

        if ($scope.currentSection.id == block.id) {
          $scope.closeCurrentSection();
        }
        var index = $scope.templateEdit.blocks.indexOf(block);

        if (index != -1) {
          $scope.templateEdit.blocks.splice(index, 1);
        }
      } else {
        block.loading = false;
      }
    });
  };

  $scope.removeFieldFromBlock = function (field, block) {
    var index = block.fields.indexOf(field);
    if (index != -1) {
      block.fields.splice(index, 1);
    }
    $scope.fetchAvailableFieldsForCurrentBlock();
    $scope.updateAvailablePrefillFields($scope.templateEdit);
  };

  $scope.removeChecklistContainer = function (checklistContainer) {
    var index = $scope.templateEdit.checklistContainers.indexOf(checklistContainer);
    if (index != -1) {
      $scope.templateEdit.checklistContainers.splice(index, 1);
    }
    $scope.fetchAvailableChecklistContainersForCurrentBlock();
  };

  $scope.saveCurrentSection = function () {
    if ($scope.currentSection.type == 'custom') {
      $scope.templateEdit.blockVisibilitySettings[$scope.currentSection.name] = true;
    } else {
      $scope.templateEdit.blockVisibilitySettings[$scope.currentSection.type] = true;
    }
    $scope.currentSection = null;
    $scope.closeRightPane();
  };

  $scope.closeCurrentSection = function () {
    $scope.currentSection = null;
    $scope.closeRightPane();
  };

  $scope.newActivity = function () {
    $scope.activityEdit = { 'new': true, name: '', categories: [], actorCategories: [], actorFromOrder: false, billable: true, xeroQuantity: false, fields: [], refersParent: true };
    $scope.fetchAvailableFieldsForCurrentActivity();
    $scope.openRightPane('fields');
  };

  $scope.editActivity = function (activity) {
    $scope.activityEdit = activity;
    $scope.fetchAvailableFieldsForCurrentActivity();
    $scope.openRightPane('fields');
  };

  $scope.closeActivityEdit = function () {
    $scope.activityEdit = null;
    $scope.closeRightPane();
  };

  $scope.deleteActivity = function (interactionTemplate) {
    var index = $scope.templateEdit.interactionTemplates.indexOf(interactionTemplate);
    if (index != -1) {
      $scope.templateEdit.interactionTemplates.splice(index, 1);
    }
  };

  $scope.removeFieldFromActivity = function (field, activity) {
    var index = activity.fields.indexOf(field);
    if (index != -1) {
      activity.fields.splice(index, 1);
    }
    $scope.fetchAvailableFieldsForCurrentActivity();
  };

  $scope.saveActivityEdit = function () {
    if ($scope.activityEdit.new == true) {
      $scope.templateEdit.interactionTemplates.push($scope.activityEdit);
    }
    delete $scope.activityEdit.new;
    if ($scope.templateEdit.interactionTemplatesMatrix[$scope.activityEdit.name] == null) {
      $scope.templateEdit.interactionTemplatesMatrix[$scope.activityEdit.name] = {};
    }
    $scope.closeActivityEdit();
  };

  $scope.saveTemplateEdit = function (reloadSavedTemplate) {
    if ($scope.templateEdit.blocks.filter(function (block) {
      return block.name == '';
    }).length > 0) {
      swal({
        title: "Oops!",
        text: "Please make sure all sections have a name before continuing.",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      return;
    }

    $scope.templateEdit.loading = true;

    // convert interactionTemplatesMatrix back to interactionTemplates categories list
    for (var i = 0; i < $scope.templateEdit.interactionTemplates.length; i++) {
      var thisTemplate = $scope.templateEdit.interactionTemplates[i];
      var actorCategories = [];
      for (var j = 0; j < $scope.allResourceCategories.length; j++) {
        if ($scope.templateEdit.interactionTemplatesMatrix[thisTemplate.name][$scope.allResourceCategories[j].id] == true) {
          actorCategories.push($scope.allResourceCategories[j]);
        }
      }
      thisTemplate.actorCategories = actorCategories;
    }

    delete $scope.templateEdit.interactionTemplatesMatrix;

    // convert hidden blocks from visibility editor format to list of strings
    var newHiddenBlocksList = [];
    for (var i = 0; i < $scope.templateEdit.blocks.length; i++) {
      var blockName = $scope.templateEdit.blocks[i].name;
      if ($scope.templateEdit.blocks[i].type != 'custom') {
        blockName = $scope.templateEdit.blocks[i].type;
      }
      if ($scope.templateEdit.blockVisibilitySettings[blockName] == false) {
        newHiddenBlocksList.push(blockName);
      }
    }

    $scope.templateEdit.hiddenBlockNames = newHiddenBlocksList;

    // convert orderPrefillFields to id list
    if ($scope.templateEdit.orderPrefillFields) {
      for (var i = 0; i < $scope.templateEdit.orderPrefillFields.length; i++) {
        $scope.templateEdit.orderPrefillFields[i] = $scope.templateEdit.orderPrefillFields[i].id;
      }
    }
    // filter out prefill fields that have been unselected
    var filteredPrefillFields = [];
    if ($scope.templateEdit.orderPrefillFields) {
      for (var i = 0; i < $scope.templateEdit.orderPrefillFields.length; i++) {
        if ($scope.templateEdit.updateOrderPrefillFields[$scope.templateEdit.orderPrefillFields[i]] == true) {
          filteredPrefillFields.push($scope.templateEdit.orderPrefillFields[i]);
        }
      }
    }
    $scope.templateEdit.orderPrefillFields = filteredPrefillFields;
    docketService.saveTemplate($scope.templateEdit, function (templateSaved) {
      if (reloadSavedTemplate && reloadSavedTemplate == true) {
        $state.go('docketDesigner', { orgId: $scope.currentOrg.id, templateId: templateSaved.id });
      } else {
        $state.go('companySettings.templates', { orgId: $scope.currentOrg.id });
      }
    }, function (err) {
      $scope.templateEdit.loading = false;
      if (err.data.statusCode === 400 && JSON.parse(err.data.message).message === "A template can not be un-published once it is published") {
        err.status = 999;
      }
      $scope.alertService.presentAutoAlert('saveTemplate', err);
    });
  };

  /***** Fields modal controls *****/
  $scope.openNewFieldModal = function () {
    var options = {};
    if ($scope.activityEdit != null) {
      options.ignoreTypes = ['multiline', 'signature', 'label'];
    }
    $scope.newFieldFromParent(options, function (field) {
      if (field != null) {
        docketService.saveField(field, function (newField) {
          $scope.availableFields.push(newField);
          $scope.getFields();
        }, function (err) {
          $scope.alertService.presentAutoAlert('saveField', err);
        });
      }
    });
  };

  /***** Checklists modal controls *****/
  $scope.openNewChecklistModal = function () {
    $("#editChecklistModal").fadeIn(100);
    $scope.checklistEdit = { fields: [], name: '', type: 'docket' };
  };

  $scope.closeEditChecklistModal = function () {
    $("#editChecklistModal").fadeOut(100);
  };

  $scope.saveChecklistEdit = function (template) {
    template.loading = true;
    docketService.saveChecklistTemplate(template, function (templateUpdated) {
      $scope.getChecklists();
      var location = 1;
      if ($scope.templateEdit.checklistContainers.length > 0 && $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location != null) {
        location = $scope.templateEdit.checklistContainers[$scope.templateEdit.checklistContainers.length - 1].location + 1;
      }
      var newChecklistContainer = { location: location, rule: 'notRequired', checklistTemplate: templateUpdated };
      $scope.availableChecklists.push(newChecklistContainer);
      $scope.checklistEdit = null;
      $scope.closeEditChecklistModal();
    }, function (err) {
      template.loading = false;
      $scope.alertService.presentAutoAlert('saveChecklistTemplate', err);
    });
  };

  $scope.removeChecklistField = function (field, template) {
    var index = template.fields.indexOf(field);
    if (index != -1) {
      template.fields.splice(index, 1);
    }
  };

  $scope.addChecklistField = function (template) {
    if (template.fields == null) {
      template.field = [];
    }
    var newField = {};
    newField.id = uuid.v4();
    template.fields.push(newField);
  };

  /**************************************/
  /**** Docket Template Attachments *****/
  /**************************************/

  $scope.leftPaneAnimationInProcess = false;
  $scope.RightPaneAnimationInProcess = false;

  $scope.uploadNewTermsAttachment = function ($file) {
    $scope.templateEdit.loading = true;
    Upload.upload({
      method: 'PUT',
      url: "" + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/templates/" + $scope.templateEdit.id + "/attachment",
      data: { file: $file, type: 'termsConditions' },
      withCredentials: true
    }).then(function (resp) {
      $scope.templateEdit.loading = false;
      $scope.getTemplate();
    }, function (resp) {
      $scope.templateEdit.loading = false;
      $scope.alertService.presentAutoAlert('saveTemplate', err);
    }, function (evt) {
      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  };

  $scope.removeTemplateAttachment = function (attachment) {
    $scope.templateEdit.loading = true;
    docketService.deleteTemplateAttachment($scope.templateEdit.id, attachment.id, function () {
      $scope.templateEdit.loading = false;
      $scope.getTemplate();
    }, function () {
      $scope.templateEdit.loading = false;
      $scope.alertService.presentAutoAlert('saveTemplate', err);
    });
  };

  $scope.minimiseLeftPane = function () {
    if (!$scope.leftPaneAnimationInProcess) {
      $scope.leftPaneAnimationInProcess = true;
      $("#leftControlPane .blocksList").fadeOut(100, function () {});
      $("#leftControlPane").animate({
        width: "50px",
        left: "0"
      }, 200, function () {
        $("#leftControlPane .paneHeader").addClass('minimised');
        $("#leftControlPane .blocksList").hide();
        $scope.leftPaneAnimationInProcess = false;
      });
    }
  };

  $scope.maximiseLeftPane = function () {
    if (!$scope.leftPaneAnimationInProcess) {
      $scope.leftPaneAnimationInProcess = true;
      $("#leftControlPane").animate({
        width: "250px"
      }, 200, function () {
        $("#leftControlPane .paneHeader").removeClass('minimised');
        $("#leftControlPane .blocksList").fadeIn(200);
        $scope.leftPaneAnimationInProcess = false;
      });
    }
  };

  $scope.minimiseRightPane = function () {
    if (!$scope.rightPaneAnimationInProcess) {
      $scope.rightPaneAnimationInProcess = true;
      $("#rightControlPane .paneListButtons").fadeOut(100);
      $("#rightControlPane .fieldsList").fadeOut(100, function () {});
      $("#rightControlPane").animate({
        width: "50px",
        right: "0px"
      }, 200, function () {
        $("#rightControlPane .paneHeader").addClass('minimised');
        $("#rightControlPane").addClass('minimised');
        $("#rightControlPane .fieldsList").hide();
        $scope.rightPaneAnimationInProcess = false;
      });
    }
  };

  $scope.maximiseRightPane = function () {
    if (!$scope.rightPaneAnimationInProcess) {
      $scope.rightPaneAnimationInProcess = true;
      $("#rightControlPane").animate({
        width: "250px"
      }, 200, function () {
        $("#rightControlPane").removeClass('minimised');
        $("#rightControlPane .paneHeader").removeClass('minimised');
        $("#rightControlPane .fieldsList").fadeIn(200);
        $("#rightControlPane .paneListButtons").fadeIn(100);
        $scope.rightPaneAnimationInProcess = false;
      });
    }
  };

  $scope.windowWidth = $(window).width();

  $scope.checkLeftPaneHover = function () {
    if ($("#leftControlPane") && $scope.windowWidth < 1600) {
      if ($scope.windowWidth < 1600 && $("#leftControlPane:hover").length > 0) {
        $scope.maximiseLeftPane();
        $scope.checkLeftPaneHoverOut();
      } else {
        $scope.minimiseLeftPane();
      }
    }
  };

  $scope.checkRightPaneHover = function () {
    if ($("#rightControlPane") && $scope.windowWidth < 1600) {
      if ($scope.windowWidth < 1600 && $("#rightControlPane:hover").length > 0) {
        $scope.maximiseRightPane();
        $scope.checkRightPaneHoverOut();
      } else {
        $scope.minimiseRightPane();
      }
    }
  };

  $scope.checkLeftPaneHoverOut = function () {
    if ($scope.windowWidth < 1600) {
      if ($("#leftControlPane:hover").length > 0) {
        $timeout(function () {
          $scope.checkLeftPaneHoverOut();
        }, 300);
      } else {
        $scope.minimiseLeftPane();
      }
    }
  };

  $scope.checkRightPaneHoverOut = function () {
    if ($("#rightControlPane:hover").length > 0) {
      $timeout(function () {
        $scope.checkRightPaneHoverOut();
      }, 300);
    } else {
      $scope.minimiseRightPane();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "pRiB":
/***/ (function(module, exports) {

var path = 'views/pages/preauth/docket.html';
var html = "<!--<div class=\"preAuthSuperHeader\">\n  <div class=\"inner\">\n    <div class=\"tableLayoutHelperContainer\">\n      <div class=\"left\">\n        <div class=\"logo\"></div>\n      </div>\n      <div class=\"right\">\n        <md-button ng-click=\"login()\">Sign In</md-button>\n        <md-button ng-click=\"downloadDocket()\">Download</md-button>\n      </div>\n    </div>\n  </div>\n</div>-->\n<div class=\"preAuthCenterDiv\">\n  <div class=\"preAuthCentreTopPart\">\n    <div class=\"preAuthCentreLogoSplit\">\n      <div class=\"left\">\n        <div class=\"logo\"></div>\n      </div>\n      <div class=\"right\">\n        <div class=\"loginButton\" ng-click=\"login()\">Log In</div>\n      </div>\n    </div>\n    <h1 ng-if=\"!itemEdit.askForSignature\">You've received a Docket<br/>from {{docket.supplierContact.displayName}}</h1>\n    <h1 ng-if=\"itemEdit.askForSignature\">Please sign this docket<br/>from {{docket.supplierContact.displayName}}</h1>\n  </div>\n  <div class=\"preAuthCentreDocketPart\">\n    <div class=\"signButtons\" ng-if=\"docket.askForSignature\">\n      <div class=\"signButton green\" ng-click=\"getCustomerSignature()\" >Sign Docket</div>\n    </div>\n    <div class=\"docketNumberOuter\">\n      <div class=\"left\">\n        <h2>{{docket.docketNumber}}</h2>\n      </div>\n      <div class=\"right\">\n        <h2>{{moment(docket.date,'YYYY-MM-DD').format('DD/MM/YYYY')}}</h2>\n      </div>\n    </div>\n\n    <div class=\"preAuthDocketView\">\n      <ng-include src=\"'views/pages/dockets/desktop/generalTabPreAuth.html'\"></ng-include>\n    </div>\n\n    <div class=\"signButtons\" style=\"margin-bottom:0px;\">\n      <div class=\"signButton green\" ng-click=\"getCustomerSignature()\" ng-if=\"docket.askForSignature\">Sign Docket</div>\n      <div class=\"signButton\" ng-click=\"downloadDocket()\">Download PDF</div>\n    </div>\n  </div>\n</div>\n<!--\n<div class=\"preAuthOuterContent\">\n  <div class=\"preAuthContentContainer\">\n    <div class=\"layoutContainer\">\n      <div class=\"preAuthLayoutContainer\">\n        <div class=\"preAuthInnerContent\">\n          <div class=\"preAuthInnerContentVertical\">\n            <div class=\"preAuthDocketOuter\">\n              <div class=\"preAuthDocketHeaderOuter\">\n                <div class=\"preAuthDocketHeaderLeft\">\n                  <h1>You've received a Docket from {{docket.supplierContact.displayName}}</h1>\n                  <h2>Docket {{docket.docketNumber}}</h2>\n                </div>\n                <div class=\"preAuthDocketHeaderRight\">\n\n                </div>\n              </div>\n\n              <div class=\"preAuthDocketView\">\n                <ng-include src=\"'views/pages/dockets/desktop/generalTabPreAuth.html'\"></ng-include>\n              </div>\n              <div class=\"signButton\" ng-click=\"getCustomerSignature()\">Accept and Sign</div>\n              <div class=\"signButton\" ng-click=\"downloadDocket()\">Download PDF</div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>-->\n<!--\n<div class=\"preAuthDocketContainer\" ng-controller=\"docketDetailController\">\n  <div class=\"docketHeader\">\n    <div class=\"left\">\n      <h1>Docket</h1>\n      <h2>{{docket.docketNumber}}</h2>\n    </div>\n    <div class=\"right\">\n    </div>\n  </div>\n\n  <md-tabs md-selected=\"selectedIndex\" md-dynamic-height md-border-bottom md-autoselect class=\"docketTabsInner\">\n    <md-tab label=\"Docket\">\n      <div class=\"docketTab\">\n        <ng-include src=\"'views/pages/dockets/desktop/generalTab.html'\"></ng-include>\n      </div>\n    </md-tab>\n    <md-tab label=\"Attachments\">\n      <div class=\"docketTab\">\n        <ng-include src=\"'views/pages/dockets/desktop/attachmentsTab.html'\"></ng-include>\n      </div>\n    </md-tab>\n    <md-tab label=\"Audit Log\">\n      <div class=\"docketTab\">\n        <ng-include src=\"'views/pages/dockets/desktop/auditLogTab.html'\"></ng-include>\n      </div>\n    </md-tab>\n    <md-tab label=\"Map\">\n      <div class=\"mapTab\">\n        <ng-include src=\"'views/pages/dockets/desktop/mapTab.html'\" class=\"mapTabIncluder\"></ng-include>\n      </div>\n    </md-tab>\n  </md-tabs>\n</div>-->\n<span ng-controller=\"signatureModalController\">\n  <ng-include src=\"'views/modals/signatureCaptureModal.html'\"></ng-include>\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "pYzG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "error-outlined.svg";

/***/ }),

/***/ "ppEf":
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),

/***/ "pyL/":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/ordersList.html';
var html = "<md-table-container>\n  <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n    <thead md-head md-order=\"query.order\" md-on-reorder=\"loadOrdersListFromMdTable\">\n      <tr md-row>\n        <th md-column md-order-by=\"orderNumber\"><span>Order Number</span></th>\n        <th md-column ng-if=\"!listFull\"><span>Ref No</span></th>\n        <th md-column md-order-by=\"supplierRefNo\" ng-if=\"listFull\"><span>Supplier Ref</span></th>\n        <th md-column md-order-by=\"customerRefNo\" ng-if=\"listFull\"><span>Customer Ref</span></th>\n        <th md-column md-order-by=\"customerName\"><span>Customer</span></th>\n        <th md-column md-order-by=\"supplierName\" ng-if=\"listFull\" class=\"hidden-md\"><span>Supplier</span></td>\n        <th md-column md-order-by=\"startDate\" ng-if=\"listFull\" class=\"hidden-md\"><span>Start Date</span></th>\n        <th md-column md-order-by=\"endDate\" ng-if=\"listFull\" class=\"hidden-md\"><span>End Date</span></th>\n        <th md-column md-order-by=\"status\" width=\"100px\"><span>Status</span></th>\n      </tr>\n    </thead>\n    <tbody md-body class=\"clickableTable\">\n      <tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in listItems\" ng-click=\"openOrderDesktop(item)\">\n        <td md-cell>\n          <span ng-if=\"item.orderNumber\">{{item.orderNumber}}</span>\n          <span ng-if=\"!item.orderNumber\">Pending</span>\n        </td>\n        <td md-cell ng-if=\"!listFull\">\n          <span ng-if=\"userCanDoAction('viewSupplierRefNo', item) && item.supplierRefNo.split('_')[0] != 'xq'\">{{item.supplierRefNo}}</span>\n          <span ng-if=\"userCanDoAction('viewSupplierRefNo', item) && item.supplierRefNo.split('_')[0] == 'xq'\">Quote: {{item.supplierRefNo.split('_')[1]}}</span>\n          <span ng-if=\"userCanDoAction('viewCustomerRefNo', item)\">{{item.customerRefNo}}</span>\n        </td>\n        <td md-cell ng-if=\"listFull\">\n          <span ng-show=\"item.supplierRefNo && item.supplierRefNo.split('_')[0] != 'xq'\">{{item.supplierRefNo}}</span>\n          <span ng-show=\"item.supplierRefNo && item.supplierRefNo.split('_')[0] == 'xq'\">Quote: {{item.supplierRefNo.split('_')[1]}}</span>\n        </td>\n        <td md-cell ng-if=\"listFull\">\n          <span ng-show=\"item.customerRefNo\">{{item.customerRefNo}}</span>\n        </td>\n        <td md-cell>\n          <span ng-if=\"item.customerContact\" class=\"hidden-md\">{{item.customerContact.displayName}}</span>\n        </td>\n        <td md-cell ng-if=\"listFull\" class=\"hidden-md\">\n          <span ng-if=\"item.supplierContact\" class=\"hidden-md\">{{item.supplierContact.displayName}}<span>\n          </td>\n        <td md-cell ng-if=\"listFull\" class=\"hidden-md\">{{moment(item.startDate).format('DD/MM/YYYY')}}</td>\n        <td md-cell ng-if=\"listFull\" class=\"hidden-md\">{{moment(item.endDate).format('DD/MM/YYYY')}}</td>\n        <td md-cell>\n          <div class=\"statusDisplay {{getStatus(item)}}\">\n            <md-icon ng-if=\"getStatus(item) == 'Review'\" class=\"smallIcon Review reviewIcon\" md-svg-icon=\"error-outlined.svg\"></md-icon>\n            <span>\n              {{getStatus(item)}}\n            </span>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</md-table-container>\n<md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadOrdersListFromMdTable\" md-total=\"{{listCount}}\" md-page-select>\n\n</md-table-pagination>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "qAMC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-180x180.png";

/***/ }),

/***/ "qKzz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon-32x32.png";

/***/ }),

/***/ "qnT2":
/***/ (function(module, exports) {

var path = 'views/filterBars/ordersFilterBar.html';
var html = "<div class=\"secondaryHeader\">\n    <div class=\"contentHeadingNavBar filterTabs\">\n      <div class=\"filterTabsContainer\">\n        <div class=\"filterSelectors\">\n          <div class=\"filterSelector\">\n            <h3>Date:</h3>\n\n            <div class=\"filterDropdown clear\">\n              <md-date-range show-template=\"true\" ng-model=\"dateFilterModel\" custom-templates=\"customTemplate\"></md-date-range>\n            </div>\n          </div>\n          <div class=\"filterSelector\">\n            <h3>Status:</h3>\n            <md-menu>\n              <div class=\"filterDropdown\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n                {{prettifyFilterStatusPreview()}}\n              </div>\n              <md-menu-content width=\"4\">\n                <md-menu-item aria-label=\"\" class=\"allSelector\" ng-click=\"swapStatusFilter('all')\">\n                  <div class=\"filterDropdownCheckboxItem\">\n                    <input type=\"checkbox\" name=\"all\" ng-model=\"filters.statusOptions.allView\">Select All\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\">\n                  <div class=\"filterDropdownCheckboxItem\">\n                    <input type=\"checkbox\" name=\"draft\" ng-model=\"filters.statusOptions.draft\" ng-model-options=\"{debounce:1000}\" ng-change=\"statusFiltersChanged()\">Draft\n                    <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('draft')\">Only</div>\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\">\n                  <div class=\"filterDropdownCheckboxItem\">\n                    <input type=\"checkbox\" name=\"sent\" ng-model=\"filters.statusOptions.sent\" ng-model-options=\"{debounce:1000}\" ng-change=\"statusFiltersChanged()\">Sent\n                    <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('sent')\">Only</div>\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\">\n                  <div class=\"filterDropdownCheckboxItem\">\n                    <input type=\"checkbox\" name=\"sent\" ng-model=\"filters.statusOptions.accepted\" ng-model-options=\"{debounce:1000}\" ng-change=\"statusFiltersChanged()\">Accepted\n                    <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('accepted')\">Only</div>\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\">\n                  <div class=\"filterDropdownCheckboxItem\">\n                    <input type=\"checkbox\" name=\"sent\" ng-model=\"filters.statusOptions.rejected\" ng-model-options=\"{debounce:1000}\" ng-change=\"statusFiltersChanged()\">Rejected\n                    <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('rejected')\">Only</div>\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\">\n                  <div class=\"filterDropdownCheckboxItem\">\n                    <input type=\"checkbox\" name=\"closed\" ng-model=\"filters.statusOptions.closed\" ng-model-options=\"{debounce:1000}\" ng-change=\"statusFiltersChanged()\">Closed\n                    <div class=\"filterOnlyButton\" ng-click=\"setOnlyFilter('closed')\">Only</div>\n                  </div>\n                </md-menu-item>\n              </md-menu-content>\n            </md-menu>\n          </div>\n          <div class=\"filterSelector\" ng-if=\"filters.customerContact\">\n            <h3>Customer:</h3>\n            <div class=\"filterDropdown withClearButton\">\n              <span ng-click=\"selectContactFilter('customer')\">{{filters.customerContact.displayName}}</span>\n              <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('customerContact')\">\n                <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"filterSelector\" ng-if=\"filters.supplierContact\">\n            <h3>Supplier:</h3>\n            <div class=\"filterDropdown withClearButton\">\n              <span ng-click=\"selectContactFilter('supplier')\">{{filters.supplierContact.displayName}}</span>\n              <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('supplierContact')\">\n                <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"filterSelector\" ng-if=\"filters.orderNumber\">\n            <h3>Order Number:</h3>\n            <div class=\"filterDropdown withClearButton\">\n              <input type=\"text\" ng-model=\"filters.orderNumber\" aria-label=\"Order Number Filter\" ng-model-options=\"{debounce:1000}\" ng-change=\"filtersChanged('orderNumber')\">\n              <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('orderNumber')\">\n                <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"filterSelector\" ng-if=\"filters.supplierRefNo\">\n            <h3>Supplier Ref No:</h3>\n            <div class=\"filterDropdown withClearButton\">\n              <input type=\"text\" ng-model=\"filters.supplierRefNo\" aria-label=\"Supplier Ref No Filter\" ng-model-options=\"{debounce:1000}\" ng-change=\"filtersChanged('supplierRefNo')\">\n              <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('supplierRefNo')\">\n                <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"filterSelector\" ng-if=\"filters.customerRefNo\">\n            <h3>Customer Ref No:</h3>\n            <div class=\"filterDropdown withClearButton\">\n              <input type=\"text\" ng-model=\"filters.customerRefNo\" aria-label=\"Customer Ref No Filter\" ng-model-options=\"{debounce:1000}\" ng-change=\"filtersChanged('customerRefNo')\">\n              <md-button class=\"md-icon-button selector\" ng-click=\"clearFilterItem('customerRefNo')\">\n                <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"filterSelector\">\n            <md-menu>\n              <div class=\"filterDropdown addFilter\" ng-click=\"openMenu($mdOpenMenu, $event)\">\n                Add A Filter\n              </div>\n              <md-menu-content width=\"4\">\n                <md-menu-item aria-label=\"\" ng-click=\"selectContactFilter('customer')\" ng-if=\"!filters.customerContact\">\n                  <div class=\"filterDropdownCheckboxItem button\">\n                    <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Customer\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\" ng-click=\"selectContactFilter('supplier')\" ng-if=\"!filters.supplierContact\">\n                  <div class=\"filterDropdownCheckboxItem button\">\n                    <md-icon md-svg-icon=\"magnify.svg\"></md-icon>Supplier\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\" ng-click=\"filters.orderNumber = ' '\" ng-if=\"!filters.orderNumber\">\n                  <div class=\"filterDropdownCheckboxItem button\">\n                    <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Order Number\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\" ng-click=\"filters.supplierRefNo = ' '\" ng-if=\"!filters.supplierRefNo\">\n                  <div class=\"filterDropdownCheckboxItem button\">\n                    <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Supplier Ref No\n                  </div>\n                </md-menu-item>\n                <md-menu-item aria-label=\"\" ng-click=\"filters.customerRefNo = ' '\" ng-if=\"!filters.customerRefNo\">\n                  <div class=\"filterDropdownCheckboxItem button\">\n                    <md-icon md-svg-icon=\"text-field.svg\"></md-icon>Customer Ref No\n                  </div>\n                </md-menu-item>\n              </md-menu-content>\n            </md-menu>\n          </div>\n          <div class=\"filterSelector\">\n            <div class=\"filterDropdown addFilter\" ng-click=\"clearFilters()\">\n              Clear all filters\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "qwYM":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/general.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\">\n    <div class=\"left\">\n      <h3>Overview</h3>\n    </div>\n    <div class=\"right\">\n\n    </div>\n  </div>\n  <div class=\"settingsRightContentInner\">\n    <div class=\"adminBasicContentContainer\" style=\"padding-top:40px;\">\n      <div class=\"adminSettingsFieldsContainer\" ng-if=\"currentOrgGroup.parent == null\">\n        <div class=\"settingsField\">\n          <div class=\"title\">\n            Organisation Name\n          </div>\n          <div class=\"field\">\n            <span ng-show=\"!editingName\">{{currentOrg.name}}</span>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <input ng-show=\"editingName\" type=\"text\" ng-model=\"data.newName\" aria-label=\"Organisation Name\">\n            </md-input-container>\n          </div>\n          <div class=\"action\" ng-show=\"!data.loading\">\n            <a ng-show=\"!editingName\" class=\"actionLink\" ng-click=\"editName()\">Edit Name</a>\n            <a ng-show=\"editingName\" class=\"actionLink\" ng-click=\"cancelEditName()\">Cancel</a>\n            <a ng-show=\"editingName\" class=\"actionLink\" ng-click=\"saveEditName()\">Save</a>\n          </div>\n          <div class=\"action\" ng-show=\"data.loading\">\n            <md-progress-circular md-diameter=\"20px\" style=\"float: right;\"></md-progress-circular>\n          </div>\n        </div>\n        <div class=\"settingsField\">\n          <div class=\"title\">\n            Account Number\n          </div>\n          <div class=\"field\">\n            {{currentOrg.primaryDnsName}}\n          </div>\n          <div class=\"action\">\n\n          </div>\n        </div>\n        <div class=\"settingsField\">\n          <div class=\"title\">\n            ABN\n          </div>\n          <div class=\"field\">\n            {{currentOrg.identities.abn}}\n            <span ng-if=\"!currentOrg.identities.abn\">No ABN added</span>\n          </div>\n          <div class=\"action\">\n            <a class=\"actionLink\" ng-click=\"searchAbn()\" ng-if=\"currentOrg.identities.abn == null || currentOrg.identities.abn == ''\">Add ABN</a>\n            <a class=\"actionLink\" ng-click=\"searchAbn()\" ng-if=\"currentOrg.identities.abn != null && currentOrg.identities.abn != ''\">Edit ABN</a>\n          </div>\n        </div>\n\n        <div class=\"settingsField\">\n          <div class=\"title\">\n            Bank Account\n          </div>\n          <div class=\"field\">\n            <span ng-if=\"bankAccount.id != undefined\">\n              {{bankAccount.bankAccountName}}\n              {{bankAccount.bankAccountBsb}} - {{bankAccount.bankAccountNumber}}\n            </span>\n            <span ng-if=\"!bankAccount.id\">No bank account added</span>\n          </div>\n          <div class=\"action\">\n            <a class=\"actionLink\" ng-click=\"showEditBankAccount()\" ng-if=\"bankAccount.id == undefined\">Add bank details</a>\n            <a class=\"actionLink\" ng-click=\"showEditBankAccount()\" ng-if=\"bankAccount.id != undefined\">Edit bank details</a>\n          </div>\n        </div>\n\n        <div class=\"settingsField\">\n          <div class=\"title\">\n            Logo\n          </div>\n          <div class=\"field\">\n            <img ng-src=\"{{apiPath}}/{{urlVersion}}/organisations/{{currentOrg.id}}/logo\" height=\"150px\" id=\"orgLogoImage\" style=\"border:1px solid #CCC;\" ng-if=\"currentOrg.logoAttachmentName\"/>\n            <span ng-if=\"!currentOrg.logoAttachmentName\">No logo added</span>\n          </div>\n          <div class=\"action\">\n            <a class=\"actionLink\" ngf-select=\"uploadNewLogo($file)\" ng-disabled=\"logoLoading\">\n              <span ng-if=\"!logoLoading\">Upload<span ng-if=\"currentOrg.logoAttachmentName\"> New</span> Image</span>\n              <span ng-if=\"logoLoading\">\n                <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Uploading Logo\n              </span>\n            </a>\n          </div>\n        </div>\n      </div>\n\n      <h4 ng-if=\"currentOrgGroup.parent == null && currentOrg.planFeatures.accountingIntegrationEnabled\" style=\"padding-top: 20px;\">Xero Setup</h4>\n\n      <div class=\"adminSettingGroupContainer\" ng-if=\"currentOrgGroup.parent == null && currentOrg.planFeatures.accountingIntegrationEnabled\">\n        <table class=\"settingsTable\">\n          <!--<td class=\"title\">Xero Connectivity</td>-->\n\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">\n              Enabled and connected to {{currentOrg.features.xero.organisationName}}\n            </td>\n            <td>\n              <img ng-src=\"xero-disconnect-white.svg\" style=\"cursor: pointer;\" ng-click=\"xeroDisable()\"></img>\n            </td>\n          </tr>\n\n          <tr ng-if=\"!(currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled)\">\n            <td>\n              <div ng-if=\"!xeroAuthenticated && (!currentOrg.features || !currentOrg.features.xero || !currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled)\">\n                <img ng-src=\"xero-connect-white.svg\" style=\"cursor: pointer;\" ng-click=\"xeroAuth()\"></img>\n              </div>\n\n              <div ng-if=\"xeroAuthenticated && (!currentOrg.features || !currentOrg.features.xero || !currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled)\">\n                <div ng-if=\"xeroOrg === null\">\n                  Loading\n                </div>\n                <div ng-if=\"xeroOrg !== null\">\n                  <div ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled && currentOrg.features.xero.organisationId !== xeroOrg.ID\">\n                    <a class=\"actionLink\" ng-click=\"xeroConnect()\">Change Link to {{xeroOrg.name}} Xero</a>\n                  </div>\n                  <div ng-if=\"!currentOrg.features || !currentOrg.features.xero || !currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n                    <a class=\"actionLink\" ng-click=\"xeroConnect()\">Confirm connection to {{xeroOrg.name}} Xero</a>\n                    <a class=\"actionLink\" ng-click=\"xeroReauth()\">Change Xero Company</a>\n                  </div>\n                </div>\n                <!--<div>\n                  <div class=\"dbButton lightBlue\" ng-click=\"xeroAuth()\">Reauthenticate with Xero</div>\n                </div>-->\n              </div>\n            </td>\n          </tr>\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">Xero Item Sync</td>\n            <td>\n              <inline-alert type='success' class=\"margin-bottom-big\" id=\"xeroItemSyncSuccess\" ng-show=\"showItemSyncSuccess\">Xero items synced!</inline-alert>\n              <a class=\"actionLink\" ng-click=\"xeroItemSync()\" ng-disabled=\"xeroItemSyncLoading\">\n                <span ng-if=\"!xeroItemSyncLoading\">Sync Items</span>\n                <span ng-if=\"xeroItemSyncLoading\">\n                  <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Syncing Items\n                </span>\n              </a>\n            </td>\n          </tr>\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">Xero Contact Sync</td>\n            <td>\n              <inline-alert type='success' class=\"margin-bottom-big\" id=\"xeroContactSyncSuccess\" ng-show=\"showContactSyncSuccess\">Xero contacts synced!</inline-alert>\n              <a class=\"actionLink\" ng-click=\"xeroContactSync()\" ng-disabled=\"xeroContactSyncLoading\">\n                <span ng-if=\"!xeroContactSyncLoading\">Sync Contacts</span>\n                <span ng-if=\"xeroContactSyncLoading\">\n                  <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Syncing Contacts\n                </span>\n              </a>\n            </td>\n          </tr>\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">Enable Xero Quotes on Orders</td>\n            <td>\n              <span ng-if=\"currentOrg.features.xero.quotesEnabled\">Enabled</span>\n              <span ng-if=\"!currentOrg.features.xero.quotesEnabled\">Disabled</span><br/>\n              <a class=\"actionLink\" ng-click=\"toggleXeroQuotes()\" ng-disabled=\"xeroQuotesEnableLoading\">\n                <span ng-if=\"!xeroQuotesEnableLoading && !currentOrg.features.xero.quotesEnabled\">Enable</span>\n                <span ng-if=\"!xeroQuotesEnableLoading && currentOrg.features.xero.quotesEnabled\">Disable</span>\n                <span ng-if=\"xeroQuotesEnableLoading\">\n                  <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Updating...please wait\n                </span>\n              </a>\n            </td>\n          </tr>\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">Display Xero Unit Prices on Items</td>\n            <td>\n              <span ng-if=\"currentOrg.features.xero.displayUnitPrices\">Enabled</span>\n              <span ng-if=\"!currentOrg.features.xero.displayUnitPrices\">Disabled</span><br/>\n              <a class=\"actionLink\" ng-click=\"toggleXeroDisplayPrices()\" ng-disabled=\"xeroPricesEnableLoading\">\n                <span ng-if=\"!xeroPricesEnableLoading && !currentOrg.features.xero.displayUnitPrices\">Enable</span>\n                <span ng-if=\"!xeroPricesEnableLoading && currentOrg.features.xero.displayUnitPrices\">Disable</span>\n                <span ng-if=\"xeroPricesEnableLoading\">\n                  <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Updating...please wait\n                </span>\n              </a>\n            </td>\n          </tr>\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">Invoice Prices Use Quote Prices When Available</td>\n            <td>\n              <span ng-if=\"currentOrg.features.xero.invoicePricesInheritFromQuote\">Enabled</span>\n              <span ng-if=\"!currentOrg.features.xero.invoicePricesInheritFromQuote\">Disabled</span><br/>\n              <a class=\"actionLink\" ng-click=\"toggleXeroInvoicePrices()\" ng-disabled=\"xeroInvoicePricesEnableLoading\">\n                <span ng-if=\"!xeroInvoicePricesEnableLoading && !currentOrg.features.xero.invoicePricesInheritFromQuote\">Enable</span>\n                <span ng-if=\"!xeroInvoicePricesEnableLoading && currentOrg.features.xero.invoicePricesInheritFromQuote\">Disable</span>\n                <span ng-if=\"xeroInvoicePricesEnableLoading\">\n                  <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Updating...please wait\n                </span>\n              </a>\n            </td>\n          </tr>\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">Docket PDF Can Display Unit Prices</td>\n            <td>\n              <span ng-if=\"currentOrg.features.xero.docketPdfDisplayUnitPrices\">Enabled</span>\n              <span ng-if=\"!currentOrg.features.xero.docketPdfDisplayUnitPrices\">Disabled</span><br/>\n              <a class=\"actionLink\" ng-click=\"toggleXeroDocketPdfDisplayPrices()\" ng-disabled=\"xeroDocketPdfPricesEnableLoading\">\n                <span ng-if=\"!xeroDocketPdfPricesEnableLoading && !currentOrg.features.xero.docketPdfDisplayUnitPrices\">Enable</span>\n                <span ng-if=\"!xeroDocketPdfPricesEnableLoading && currentOrg.features.xero.docketPdfDisplayUnitPrices\">Disable</span>\n                <span ng-if=\"xeroDocketPdfPricesEnableLoading\">\n                  <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Updating...please wait\n                </span>\n              </a>\n            </td>\n          </tr>\n          <tr ng-if=\"currentOrg.features && currentOrg.features.xero && currentOrg.features.xero.enabled && currentOrg.planFeatures.accountingIntegrationEnabled\">\n            <td class=\"title\">Include Interaction Name On Invoice Lines</td>\n            <td>\n              <span ng-if=\"currentOrg.features.xero.includeInteractionOnInvoice\">Enabled</span>\n              <span ng-if=\"!currentOrg.features.xero.includeInteractionOnInvoice\">Disabled</span><br/>\n              <a class=\"actionLink\" ng-click=\"toggleXeroInteractionOnInvoice()\" ng-disabled=\"xeroInteractionOnInvoiceLoading\">\n                <span ng-if=\"!xeroInteractionOnInvoiceLoading && !currentOrg.features.xero.includeInteractionOnInvoice\">Enable</span>\n                <span ng-if=\"!xeroInteractionOnInvoiceLoading && currentOrg.features.xero.includeInteractionOnInvoice\">Disable</span>\n                <span ng-if=\"xeroInteractionOnInvoiceLoading\">\n                  <md-progress-circular md-diameter=\"20px\"></md-progress-circular>Updating...please wait\n                </span>\n              </a>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-include src=\"'views/modals/searchAbnModal.html'\"></ng-include>\n<ng-include src=\"'views/modals/editBankAccountModal.html'\"></ng-include>\n<!--  Xero Connect Modal -->\n<ng-include src=\"'views/modals/xeroConnect.html'\" ng-controller=\"xeroConnectController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "rDzi":
/***/ (function(module, exports) {

var path = 'views/modals/editContactModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector long\" id=\"editContactModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Edit Contact</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeContactEdit()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content\">\n      <span ng-if=\"contactEditing != null\">\n        <h4>Name</h4>\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm>\n            <label>Display Name</label>\n            <input type=\"text\" ng-model=\"contactEditing.displayName\">\n          </md-input-container>\n        </div>\n        <h4>Address</h4>\n        <div class=\"padding\">\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Unit Number</label>\n              <input type=\"text\" ng-model=\"contactEditing.address.num\">\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Number</label>\n              <input type=\"text\" ng-model=\"contactEditing.address.streetNum\">\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Street Name</label>\n              <input type=\"text\" ng-model=\"contactEditing.address.streetName\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Suburb</label>\n              <input type=\"text\" ng-model=\"contactEditing.address.suburb\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>State</label>\n              <input type=\"text\" ng-model=\"contactEditing.address.state\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Post Code</label>\n              <input type=\"text\" ng-model=\"contactEditing.address.postCode\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Country</label>\n              <input type=\"text\" ng-model=\"contactEditing.address.country\" required>\n            </md-input-container>\n          </div>\n        </div>\n        <h4>Email Addresses</h4>\n        <table width=\"100%\" class=\"contactEditTable\">\n          <tr ng-repeat=\"address in contactEditing.emailAddresses\">\n            <td>\n              <md-input-container class=\"md-block\" flex-gt-sm>\n                <input type=\"text\" ng-model=\"address.emailAddress\" ng-disabled=\"!address.editable\">\n              </md-input-container>\n              <div ng-if=\"!address.editable\" class=\"noEditWarning\">\n                This email address cannot be edited or removed.\n              </div>\n            </td>\n            <td width=\"100px\">\n              <md-button class=\"md-icon-button\" ng-click=\"removeEmailAddressFromContact(address)\" ng-if=\"address.editable\" aria-label=\"Remove Email From Contact\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </table>\n        <div class=\"dbButton margin-right\" ng-click=\"addAnotherEmailAddress()\">\n          Add Email\n        </div>\n        <div class=\"dbButton margin-right\" ng-click=\"selectNewContact()\">\n          Change Contact\n        </div>\n      </span>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeContactEdit()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"contactEditing.loading || saveContactEdit(contactEditing)\" ng-disabled=\"contactEditing.loading\">\n            <span ng-hide=\"contactEditing.loading\">Save</span>\n            <md-progress-circular ng-show=\"contactEditing.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "raTP":
/***/ (function(module, exports) {

var path = 'views/modals/cancellationConfirmedModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"sorryToSeeYouGoModal\">\n    <div class=\"modalContainer\">\n      <div class=\"header hidden-xs\">\n        <h1>Your cancellation request is confirmed</h1>\n        <div class=\"headerCloseButton\" ng-click=\"$('#sorryToSeeYouGoModal').fadeOut(100)\">\n          <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n            <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n      <div ng-if=\"noTemplates\" class=\"content\">\n        <p>Your credit card will not be charged again, but you will still have access to your account until [RENEWAL DATE]. A member of the Docketbook team will confirm your cancellation by email within 3 business days.</p>\n        <p><b>Tell us why you're cancelling</b></p>\n        <md-input-container class=\"md-block\">\n            <input type=\"text\" ng-model=\"cancellationReason\">\n        </md-input-container>\n      </div>\n      <div class=\"footer\">\n        <div class=\"dbButton\" ng-click=\"\">\n            Submit\n        </div>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "rsN3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('groupSettingsFilingController', ['$scope', 'docketService', 'Restangular', '$window', '$state', '$stateParams', 'accessControl', 'Upload', '$q', 'uuid', function ($scope, docketService, Restangular, $window, $state, $stateParams, accessControl, Upload, $q, uuid) {
  mixpanel.track("Opened GroupSettings-Filing Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.mode = 'list';

  $scope.listLoading = false;
  $scope.selected = [];
  $scope.importSelected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'fileCode'
  };
  $scope.listCount = 0;

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  $scope.openMenu = function ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************/
  /**** List Controls *****/
  /************************/

  $scope.loadFilingList = function () {
    $scope.promise = $q(function (resolve, reject) {
      // Get templates from docketService
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      docketService.getFileCodes(queryParams, function (fileCodes) {
        $scope.allFileCodes = fileCodes;
        if (queryParams.offset <= 0 && fileCodes.length < queryParams.limit) {
          $scope.listCount = fileCodes.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function (error) {
        $scope.allFileCodes = [];
        reject('Error');
      });
    });
  };

  $scope.loadFilingList();

  /*******************************/
  /***** File Code Functions *****/
  /*******************************/

  $scope.newFileCode = function () {
    $scope.fileCodeEdit = {};
    $("#fileCodeModal").fadeIn(100);
  };

  $scope.editFileCode = function (fileCode) {
    $("#fileCodeModal").fadeIn(100);
    $scope.fileCodeEdit = fileCode;
  };

  $scope.saveFileCodeAddAnother = function (fileCode) {
    // saveFileCode
    fileCode.loading = true;
    docketService.saveFileCode(fileCode, function () {
      fileCode.loading = false;
      $scope.fileCodeEdit = {};
    }, function (err) {
      fileCode.loading = false;
      $scope.alertService.presentAutoAlert('saveFileCode', err);
    });
  };

  $scope.saveFileCode = function (fileCode) {
    fileCode.loading = true;
    docketService.saveFileCode(fileCode, function () {
      fileCode.loading = false;
      $scope.closeFileCodeModal();
      $scope.loadFilingList();
    }, function (err) {
      fileCode.loading = false;
      $scope.alertService.presentAutoAlert('saveFileCode', err);
    });
  };

  $scope.deleteSelectedFileCodes = function () {
    var count = $scope.selected.length;
    swal({
      title: "Are you sure?",
      text: count + " file codes will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteBulkFileCodes($scope.selected, function (failures) {
          if (failures && failures.length > 0) {
            $scope.alertService.presentAutoAlert('deleteBulkFileCodes', { status: 202, requestName: 'Delete bulk file codes - failures ' + failures.length + ' of ' + $scope.selected.length });
            $scope.loadFilingList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkFileCodes', { status: 200 });
            $scope.loadFilingList();
          }
        });
      }
    });
  };

  /***************************/
  /**** UI Functionality *****/
  /***************************/

  $scope.closeFileCodeModal = function () {
    $("#fileCodeModal").fadeOut(100);
  };

  /**** Import Functionality ****/
  $scope.openImportModal = function () {
    $("#importModal").fadeIn(100);
    $scope.mode = 'import';
    $scope.fileCodeImport = { 'loading': false };
  };

  $scope.cancelImport = function () {
    $scope.closeImportModal();
    $scope.mode = 'list';
    $scope.importList = [];
  };

  $scope.closeImportModal = function () {
    $("#importModal").fadeOut(100);
  };

  $scope.importFileCodesFromFile = function (fileToUpload) {
    $scope.fileCodeImport.loading = true;

    Upload.upload({
      url: '/v1/parse',
      data: { file: fileToUpload },
      withCredentials: true
    }).then(function (resp) {
      $scope.parseFileCodesForImport(resp.data);
    }, function (resp) {
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  };

  $scope.parseFileCodesForImport = function (importData) {
    var fileCodesList = [];
    $scope.importSelected = [];

    for (var i = 0; i < importData.length; i++) {
      for (var j = 0; j < importData[i].data.length; j++) {
        var newFileCode = {};
        newFileCode.fileCode = String(importData[i].data[j][0]);
        newFileCode.fileName = String(importData[i].data[j][1]);
        newFileCode.costCode = String(importData[i].data[j][2]);
        newFileCode.systemCodes = importData[i].data[j][3];

        if (newFileCode.fileCode != '' && newFileCode.fileCode != null) {
          var matchedFileCode = $scope.findExistingFileCode(newFileCode.fileCode);
          if (matchedFileCode) {
            newFileCode.status = 'Update';
            newFileCode.uniqueIdentifier = matchedFileCode.uniqueIdentifier;
          } else {
            newFileCode.status = 'New';
          }
        } else {
          newFileCode.error = true;
          newFileCode.status = 'New';
        }

        $scope.validateFileCodeItem(newFileCode);
        newFileCode.importId = uuid.v4();
        $scope.importSelected.push(newFileCode);
        fileCodesList.push(newFileCode);
      }
    }
    $scope.importList = fileCodesList;
    $scope.closeImportModal();
    $scope.fileCodeImport.loading = false;
  };

  $scope.findExistingFileCode = function (fileCode) {
    if (fileCode == null || fileCode == '') {
      return null;
    }

    for (var i = 0; i < $scope.allFileCodes.length; i++) {
      if ($scope.allFileCodes[i].fileCode == fileCode) {
        // found a fileCode with the fileCode as given - exists
        return $scope.allFileCodes[i];
      }
    }

    return null;
  };

  $scope.bulkImportFileCodes = function () {
    var importList = $scope.importSelected;
    var filecodesSave = [];
    for (var i = 0; i < importList.length; i++) {
      if (importList[i].selected) {
        var fileCode = {};
        fileCode.fileCode = importList[i].fileCode;
        fileCode.fileName = importList[i].fileName;
        fileCode.costCode = importList[i].costCode;
        fileCode.organisation = $scope.currentOrg.id;
        fileCode.organisationGroup = $scope.currentOrgGroup.id;
        if (importList[i].uniqueIdentifier) {
          fileCode.uniqueIdentifier = importList[i].uniqueIdentifier;
        }
        //TODO: system codes

        filecodesSave.push(fileCode);
      }
    }

    docketService.importFileCodes(filecodesSave, function (resp) {
      var codesCreated = resp.codes;
      var codeExceptions = resp.exceptions;
      $scope.mode = 'list';
      $scope.loadFilingList();
      var text = codesCreated.length + " file codes were successfully imported.";
      $scope.alertService.presentAlert("success", "Import Complete!", text);
      $scope.importList = [];
    }, function (err) {
      $scope.alertService.presentAutoAlert('importFileCodes', err);
    });
  };

  $scope.validateFileCodeItem = function (fileCode) {
    var error = false;
    if (fileCode.fileCode == null || fileCode.fileCode == '') {
      error = true;
    }

    if (fileCode.fileName == null || fileCode.fileName == '') {
      error = true;
    }

    if (fileCode.costCode == null || fileCode.costCode == '') {
      error = true;
    }

    if (error) {
      fileCode.error = error;
      fileCode.selected = false;
    } else {
      fileCode.error = false;
      fileCode.selected = true;
    }
  };

  $scope.removeCodeFromImportList = function (fileCode, importList) {
    var index = importList.indexOf(fileCode);
    if (index != -1) {
      importList.splice(index, 1);
    }
  };

  $scope.toggleRowItem = function (item) {
    if (item.selected) {
      item.selected = false;
    } else {
      item.selected = true;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "ruCM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _lodash = __webpack_require__("xSkL");

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('jobDetailController', ['orderService', 'docketService', 'jobService', 'xeroService', 'userService', '$q', '$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', 'splitListInterface', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', function (orderService, docketService, jobService, xeroService, userService, $q, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {

  // Main Variables For Doing Stuff
  $scope.moment = _momentTimezone2.default;
  $scope.itemEdit = null;

  $scope.docketsQuery = {
    limit: 10,
    page: 1,
    order: 'docketNumber'
  };
  $scope.docketsPromise = null;

  // Base Access Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();
  $scope.splitListFunc = new splitListInterface($scope, $stateParams);
  $scope.userCanDoAction = userService.userCanDoAction;
  $scope.subcontractorCounts = [];
  $scope.resolutionMap = {
    loading: false,
    map: {}
  };
  $scope.cleanAssignees = [];
  $scope.resolveToRealEntities = function () {
    //we want to extract the subcontractors and assignees
    //for each 'forwarder' on the ACL resolve their email address
    //for each 'assignee' resolve the context they were assigned in
    var params = {
      organisations: [],
      organisationGroups: [],
      principals: []
    };
    if ($scope.itemEdit && $scope.itemEdit.accessControl) {
      Object.keys($scope.itemEdit.accessControl).forEach(function (key) {
        var roles = $scope.itemEdit.accessControl[key];
        if (params.principals.indexOf(key) === -1) {
          params.principals.push(key);
        }
      });
    }
    if ($scope.itemEdit && $scope.itemEdit.assignees) {
      $scope.itemEdit.assignees.forEach(function (assignee) {
        if (assignee.organisation && params.organisations.indexOf(assignee.organisation) === -1) {
          params.organisations.push(assignee.organisation);
        }
        if (assignee.organisationGroup && params.organisationGroups.indexOf(assignee.organisationGroup) === -1) {
          params.organisationGroups.push(assignee.organisationGroup);
        }
      });
    }
    var anythingToLookup = false;
    var queryItems = {};
    if (params.organisations.length > 0) {
      queryItems.organisations = params.organisations.join(',');
      anythingToLookup = true;
    }
    if (params.organisationGroups.length > 0) {
      queryItems.organisationGroups = params.organisationGroups.join(',');
      anythingToLookup = true;
    }
    if (params.principals.length > 0) {
      queryItems.principals = params.principals.join(',');
      anythingToLookup = true;
    }
    if (!anythingToLookup) {
      return;
    }
    $scope.resolutionMap.loading = true;
    Restangular.all('lookup').customGET("", queryItems).then(function (response) {
      $scope.resolutionMap.loading = false;
      var newMap = {};
      ['organisations', 'organisationGroups', 'users'].forEach(function (key) {
        if (response[key] === undefined) {
          return;
        }
        response[key].forEach(function (record) {
          record.type = key;
          newMap[record.id] = record;
          if (record.originalPrincipal) {
            newMap[record.originalPrincipal] = record;
          }
        });
      });
      $scope.resolutionMap.map = newMap;
      $scope.updateSubcontractorMappings();
    });
  };

  $scope.updateSubcontractorMappings = function () {
    //to get a full list of subcontractors on this job, its the union between
    //the list of forwarders (from ACL) and the list of org groups from the
    //actual assignees list
    var subcontractors = [];
    if ($scope.itemEdit && $scope.itemEdit.forwarders) {
      $scope.itemEdit.forwarders.forEach(function (forwarder) {
        var newSubcontractor = {
          principal: forwarder,
          name: forwarder
        };
        if ($scope.resolutionMap.map[forwarder] !== undefined) {
          newSubcontractor.entity = $scope.resolutionMap.map[forwarder];
          newSubcontractor.name = newSubcontractor.entity.name;
          newSubcontractor.id = newSubcontractor.entity.id;
        }
        subcontractors.push(newSubcontractor);
      });
    }
    /*
    if (($scope.itemEdit) && ($scope.itemEdit.assignees)) {
      $scope.itemEdit.assignees.forEach((assignee) => {
        //check to see if the subcontractor already exists
        const subMatch = subcontractors.find((sub) => {
          return sub.id && sub.id === assignee.organisationGroup;
        });
        if (subMatch) {
          return;
        }
        const newSubcontractor = {
          id: assignee.organisationGroup,
          name: assignee.organisationGroup,
        }
        if ($scope.resolutionMap.map[assignee.organisationGroup] !== undefined) {
          newSubcontractor.entity = $scope.resolutionMap.map[assignee.organisationGroup];
          newSubcontractor.name = newSubcontractor.entity.name;
          newSubcontractor.id = newSubcontractor.entity.id;
        }
        subcontractors.push(newSubcontractor);
      })
    }*/
    var subContractorCounts = subcontractors.map(function (sub) {
      var countObj = Object.assign({
        assigned: 0,
        accepted: 0,
        rejected: 0
      }, sub);
      if ($scope.itemEdit && $scope.itemEdit.assignees) {
        $scope.itemEdit.assignees.forEach(function (assignee) {
          if (sub.id === assignee.organisationGroup) {
            if (assignee.status.toLowerCase() === 'assigned') {
              countObj.assigned += 1;
            } else if (assignee.status.toLowerCase() === 'accepted') {
              countObj.accepted += 1;
            } else if (assignee.status.toLowerCase() === 'rejected') {
              countObj.rejected += 1;
            }
          }
        });
      }
      return countObj;
    });
    $scope.subcontractorCounts = subContractorCounts;
    if ($scope.itemEdit.organisation === $scope.currentOrg.id) {
      $scope.cleanAssignees = $scope.itemEdit.assignees;
    } else {
      $scope.cleanAssignees = $scope.itemEdit.assignees.filter(function (assignee) {
        if ('organisation' in assignee && 'organisationGroup' in assignee) {
          return assignee.organisation === $scope.currentOrg.id && assignee.organisationGroup === $scope.currentOrgGroup.id;
        }
        return true;
      });
    }
  };

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.currentActiveTab = function () {
    return $scope.currentTab;
  };

  $scope.$parent.getJobFromParent = function () {
    return $scope.itemEdit;
  };

  $scope.$parent.prepareForJobFromParent = function (openTab, jobNumber, job) {
    $scope.itemEdit = {};
    if (jobNumber != null) {
      $scope.itemEdit.jobNumber = jobNumber;
    }
    if (job) {
      $scope.itemEdit.jobId = job;
    }
    $scope.itemEdit.loading = true;
    $scope.itemEdit.loadingType = "getting";
    $scope.newComment = { 'commentText': '' };
    if (openTab) {
      $scope.currentTab = openTab;
    } else {
      $scope.currentTab = "General";
    }
    if ($stateParams.device == 'mobile') {
      $timeout(function () {
        $scope.openMobileTab($scope.currentTab);
      }, 500);
    }
  };

  $scope.refreshForwardersFromAccessControl = function () {
    //we want to extract any forwarders in the ACL and populate the subcontractors list
    var forwarders = Object.keys($scope.itemEdit.accessControl).filter(function (entry) {
      var existingForwarder = false;
      if (Array.isArray($scope.itemEdit.accessControl[entry])) {
        existingForwarder = $scope.itemEdit.accessControl[entry].indexOf('forwarder') !== -1;
      } else {
        if ('add' in $scope.itemEdit.accessControl[entry] && $scope.itemEdit.accessControl[entry].add.indexOf('forwarder') !== -1) {
          existingForwarder = true;
        }
      }

      var newForwarder = false;
      return existingForwarder || newForwarder;
    });
    $scope.itemEdit.forwarders = forwarders;
    $scope.resolveToRealEntities();
  };

  $scope.$parent.loadJobFromParent = function (job, edit) {
    $scope.itemEdit = job;
    $scope.itemEdit.loading = true;
    $scope.itemEdit.loadingType = 'getting';
    $scope.itemEdit.loading = false;

    if ($scope.itemEdit.order && $scope.itemEdit.order.supplierRefNo) {
      var refNoSplit = $scope.itemEdit.order.supplierRefNo.split('_');
      if (refNoSplit.length > 0 && refNoSplit[0] == 'xq') {
        $scope.itemEdit.xeroQuote = true;
        $scope.itemEdit.xeroQuoteId = refNoSplit[2];

        xeroService.getXeroQuote($scope.itemEdit.xeroQuoteId, function (quote) {
          $scope.itemEdit.xeroQuoteFull = quote;
        });
      }
    }

    $scope.refreshForwardersFromAccessControl();
    if ($stateParams.device == 'desktop') {
      if (edit && edit == true) {
        $scope.itemEdit.editing = true;
      } else {
        $scope.itemEdit.editing = false;
      }
    } else {
      if ($scope.userCanDoAction('canEditJob', $scope.itemEdit)) {
        $scope.itemEdit.editing = true;
      } else {
        $scope.itemEdit.editing = false;
      }
    }
    $scope.loadJobDockets($scope.itemEdit);
    $scope.resolveToRealEntities();
  };

  $scope.$parent.newJobFromParent = function (fromId) {
    $scope.newJob(fromId);
  };

  $scope.$parent.clearJobFromParent = function () {
    $scope.itemEdit = null;
  };

  $scope.loadJobDockets = function (job) {
    $scope.docketsPromise = $q(function (resolve, reject) {
      if (job.id == null) {
        job.dockets = [];
        resolve('Done');
        return;
      }

      var params = [];
      params['limit'] = $scope.docketsQuery.limit;
      params['offset'] = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
      params['sort'] = $scope.docketsQuery.order;
      params['jobRef'] = job.id;

      docketService.getDockets(params, function (returnData) {
        var docketsListParsed = docketService.parseDockets(returnData);
        job.dockets = docketsListParsed;
        resolve('Done');
      }, function (err) {
        reject('Error');
      });
    });
  };

  $scope.$parent.loadJobDocketsNextPage = function (cb) {
    var offsetPre = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
    $scope.docketsQuery.page = $scope.docketsQuery.page + 1;
    var offset = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
    // get next page of dockets from docketService using pagination query params
    var params = [];
    params['limit'] = $scope.docketsQuery.limit;
    params['offset'] = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
    params['sort'] = $scope.docketsQuery.order;
    params['jobRef'] = $scope.itemEdit.id;

    docketService.getDockets(params, function (returnData) {
      var docketsListParsed = docketService.parseDockets(returnData);
      for (var i = 0; i < docketsListParsed.length; i++) {
        $scope.itemEdit.dockets.push(docketsListParsed[i]);
      }
      cb();
    });
  };

  /**********************************/
  /***** Main Job Functionality *****/
  /**********************************/

  // Create a new job - setup job data
  $scope.newJob = function (fromId) {
    var newJob = {
      'status': 'New', 'statusDisplay': 'New', 'jobNumber': 'New Job', 'startDate': new Date(), 'endDate': new Date(), 'lineItems': [], 'userIsAssignee': false,
      organisation: $scope.currentOrg.id, organisationGroup: $scope.currentOrgGroup.id
      // accessControl: {
      // 	 [$scope.currentOrgGroup.emailAddress]: ['editor']
      // }
    };

    // if creating from order - pre-populate order ref and line items
    if (fromId != null) {
      orderService.getOrder(fromId, function (fullOrder) {
        newJob.orderRef = fullOrder;
        // populate line items
        newJob.lineItems = [];
        var lineItems = angular.copy(fullOrder.lineItems);
        for (var i = 0; i < lineItems.length; i++) {
          var newLineItem = lineItems[i];
          newLineItem.quantity = "";
          if (newLineItem.id) {
            newLineItem.orderItemId = newLineItem.id;
          }
          delete newLineItem.id;
          if (newLineItem.resource != null) {
            newJob.lineItems.push(newLineItem);
          }
        }
        // copy supplier and customer contact from order
        if (fullOrder.customerContact != null) {
          newJob.customerContact = angular.copy(fullOrder.customerContact);
        }
        if (fullOrder.supplierContact != null) {
          newJob.supplierContact = angular.copy(fullOrder.supplierContact);
        }
        // finish
        $scope.itemEdit = newJob;
        $scope.itemEdit.editing = true;
        $scope.currentTab = "General";
      }, function (err) {
        // finish
        $scope.itemEdit = newJob;
        $scope.itemEdit.editing = true;
        $scope.currentTab = "General";
      });
    } else {
      $scope.itemEdit = newJob;
      $scope.itemEdit.editing = true;
      $scope.currentTab = "General";
    }
  };

  /***********************************/
  /***** Other Job Functionality *****/
  /***********************************/

  $scope.$parent.resetNewComment = function () {
    $scope.newComment = { 'commentText': '' };
  };

  /************************/
  /***** Assign Order *****/
  /************************/

  $scope.selectOrder = function () {
    if ($scope.currentOrgGroup) {
      var supplierEmails = $scope.currentOrgGroup.emailAddresses;
    }
    var options = { currentOrder: $scope.itemEdit.orderRef, statusList: 'draft,sent,accepted', supplier: supplierEmails, hasCustomer: true, hasOrderNumber: true };
    $scope.$parent.selectOrderForJob(options, function (order) {
      if (order != null) {
        orderService.getOrder(order.id, function (fullOrder) {
          $scope.itemEdit.orderRef = fullOrder;
          if (fullOrder.customerContact) {
            $scope.itemEdit.customerContact = fullOrder.customerContact;
          }
          if (fullOrder.supplierContact) {
            $scope.itemEdit.supplierContact = fullOrder.supplierContact;
          }
        }, function (err) {
          console.error('an error occured getting the full order ref for the job', err);
        });
      }
    });
  };

  /**************************/
  /***** Add Line Items *****/
  /**************************/

  $scope.selectLineItem = function () {
    var lineList = $scope.itemEdit.orderRef.lineItems;
    // disabled existing line items
    for (var i = 0; i < lineList.length; i++) {
      lineList[i].disabled = false;
      for (var j = 0; j < $scope.itemEdit.lineItems.length; j++) {
        if (lineList[i].id == $scope.itemEdit.lineItems[j].orderItemId && $scope.itemEdit.lineItems[j].delete != true) {
          lineList[i].disabled = true;
          break;
        }
      }
    }

    $scope.$parent.selectLineFromOrder(lineList, function (lineItem, from) {
      if (lineItem != null) {
        if (from && from == 'desktop') {
          for (var i = 0; i < lineItem.length; i++) {
            var lineItemToPush = angular.copy(lineItem[i]);
            lineItemToPush.orderItemId = lineItem[i].id;
            delete lineItemToPush.id;
            $scope.itemEdit.lineItems.push(lineItemToPush);
          }
        } else {
          var lineItemToPush = angular.copy(lineItem);
          lineItemToPush.orderItemId = lineItem.id;
          delete lineItemToPush.id;
          $scope.itemEdit.lineItems.push(lineItemToPush);
        }
      }
    });
  };

  $scope.removeLineItem = function (lineItem) {
    lineItem.delete = true;
  };

  $scope.editLineItem = function (lineItem) {
    var lineItemEdit = lineItem;
    lineItemEdit.resourceLocked = true;
    lineItemEdit.jobView = true;

    // if time resource - format quantity as per abbreviation
    if (lineItemEdit.resource.uom.isTime) {
      var quantity = lineItemEdit.quantity;
      var abbreviation = lineItemEdit.resource.uom.abbreviation;
      if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
        // display as hours
        lineItemEdit.quantityEdit = quantity / 60;
        lineItemEdit.quantityEditType = 'h';
      }
      if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
        // display as hours and minutes
        var hours = Math.floor(quantity / 60);
        var minutes = quantity % 60;
        lineItemEdit.quantityHoursEdit = hours;
        lineItemEdit.quantityMinutesEdit = minutes;
        lineItemEdit.quantityEditType = 'hm';
      }
      if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
        lineItemEdit.quantityEdit = quantity;
        lineItemEdit.quantityEditType = 'm';
      }
    } else {
      lineItemEdit.quantityEdit = lineItemEdit.quantity;
      lineItemEdit.quantityEditType = 'normal';
    }

    $scope.$parent.editLineItemForJob($scope.itemEdit, lineItemEdit, function (item) {
      if (item != null) {
        // if time resource - format quantity from abbreviation to minutes
        if (item.resource.uom.isTime) {
          var abbreviation = item.resource.uom.abbreviation;
          if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
            // convert from hours to minutes
            item.quantity = item.quantityEdit * 60;
          }
          if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
            // display from hours&minutes to minutes
            var totalMinutes = 0;
            totalMinutes += parseInt(item.quantityHoursEdit) * 60;
            totalMinutes += parseInt(item.quantityMinutesEdit);
            item.quantity = totalMinutes;
          }
          if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
            item.quantity = item.quantityEdit;
          }
        } else {
          item.quantity = item.quantityEdit;
        }

        item.edit = false;
      }
    });
  };

  $scope.getLineItemsRemainingCount = function (itemEdit) {
    if (itemEdit && itemEdit.orderRef && itemEdit.orderRef.lineItems) {
      var unremovedCount = 0;
      if (itemEdit.lineItems) {
        for (var i = 0; i < itemEdit.lineItems.length; i++) {
          if (itemEdit.lineItems[i].delete != true) {
            unremovedCount += 1;
          }
        }
      }

      var orderCount = 0;
      if (itemEdit.orderRef != null) {
        orderCount = itemEdit.orderRef.lineItems.length;
      }

      var remaining = orderCount - unremovedCount;
      return remaining;
    } else {
      return 0;
    }
  };

  /****************************/
  /***** Select Assignee ******/
  /****************************/

  $scope.selectPerson = function () {
    $scope.$parent.selectPersonForJob($scope.itemEdit.assignees, function (person) {
      if (person != null) {
        if ($scope.itemEdit.assignees == null) {
          $scope.itemEdit.assignees = [];
        }

        var people = [];
        if ($stateParams.device == 'desktop') {
          people = person;
        } else {
          // expecting a single object in return
          people = [];
          people.push(person);
        }

        if ($scope.itemEdit.id == null) {
          for (var i = 0; i < people.length; i++) {
            var newAssignee = {};
            newAssignee.assignee = people[i].id;
            newAssignee.name = people[i].name.full;
            newAssignee.status = "Assigned";
            $scope.itemEdit.assignees.push(newAssignee);
          }
          $scope.cleanAssignees = $scope.itemEdit.assignees;
        } else {
          jobService.addAssignee($scope.itemEdit, people, function (updatedJob) {
            $scope.itemEdit.assignees = updatedJob.assignees;
            for (var i = 0; i < $scope.itemEdit.assignees.length; i++) {
              $scope.itemEdit.assignees[i].status = $scope.itemEdit.assignees[i].status.charAt(0).toUpperCase() + $scope.itemEdit.assignees[i].status.slice(1);
              if ($scope.itemEdit.assignees[i].assignee == $scope.currentUser.id) {
                $scope.itemEdit.userIsAssignee = true;
                $scope.itemEdit.userAssigneeData = $scope.itemEdit.assignees[i];
                if (!accessControl.userHasPermission('io.docketbook.ojdapi.updateJob')) {
                  $scope.itemEdit.statusDisplay = $scope.itemEdit.userAssigneeData.status.charAt(0).toUpperCase() + $scope.itemEdit.userAssigneeData.status.slice(1);
                }
              }
            }
            $scope.resolveToRealEntities();
          }, function (err) {
            swal("Oops!", "Adding assignee failed.", 'error');
          });
        }
      }
    });
  };

  // Unassign a person from a job - show 'are you sure' modal first
  $scope.unassignPerson = function (assignee, method) {
    if ($scope.itemEdit.id == null) {
      var index = $scope.itemEdit.assignees.indexOf(assignee);
      if (index != -1) {
        $scope.itemEdit.assignees.splice(index, 1);
      }
    } else {
      swal({
        title: "Unassign. Are you sure?",
        text: assignee.name + " will be unassigned from this job.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, unassign " + assignee.name,
        closeOnConfirm: false
      }, function () {
        jobService.removeAssignee($scope.itemEdit, assignee, function (updatedJob) {
          var index = $scope.itemEdit.assignees.indexOf(assignee);
          if (index != -1) {
            $scope.itemEdit.assignees.splice(index, 1);
            swal({
              title: "Unassigned!",
              text: assignee.name + " was unassigned from this job.",
              timer: 2000,
              showConfirmationButton: false,
              type: "success"
            });
          } else {
            swal({
              title: "Oops!",
              text: assignee.name + " could not be unassigned from the job.",
              timer: 2000,
              showConfirmationButton: false,
              type: "error"
            });
          }
          $scope.resolveToRealEntities();
        }, function (err) {
          swal({
            title: "Oops!",
            text: assignee.name + " could not be unassigned from the job.",
            timer: 2000,
            showConfirmationButton: false,
            type: "error"
          });
        });
      });
    }
  };

  /**********************************/
  /***** Access Control Editing *****/
  /**********************************/

  $scope.shareJob = function (job) {
    var userAccessLevels = [];
    $scope.newAccessor = { 'accessLevel': 'forwarder' };
    $scope.accessControlEdit = {};
    $scope.accessControlEdit.jobNumber = job.jobNumber;
    var accessControlEdit = [];
    var currentKeys = Object.keys(job.accessControl);

    for (var i = 0; i < currentKeys.length; i++) {
      var newAccessControlItem = {};
      newAccessControlItem.emailAddress = currentKeys[i];
      newAccessControlItem.accessLevel = "";
      if (job.accessControl[currentKeys[i]].indexOf('editor') != -1) {
        newAccessControlItem.accessLevel = "editor";
      } else if (job.accessControl[currentKeys[i]].indexOf('forwarder') != -1) {
        newAccessControlItem.accessLevel = "forwarder";
      } else if (job.accessControl[currentKeys[i]].indexOf('assignee') != -1) {
        newAccessControlItem.accessLevel = "assignee";
      } else if (job.accessControl[currentKeys[i]].indexOf('viewer') != -1) {
        newAccessControlItem.accessLevel = "viewer";
      }
      newAccessControlItem.accessLevelInitial = newAccessControlItem.accessLevel;
      newAccessControlItem.accessLevelsArray = job.accessControl[currentKeys[i]];

      // Check if supplier
      if (job.supplierContact) {
        var addressKeys = Object.keys(job.supplierContact.contactAddresses);
        for (var j = 0; j < addressKeys.length; j++) {
          if (newAccessControlItem.emailAddress == addressKeys[j]) {
            newAccessControlItem.isSupplier = true;
            break;
          }
        }
      }

      // Check if current user and get accessLevels
      if (newAccessControlItem.emailAddress == $scope.currentUser.emailAddress) {
        for (var j = 0; j < newAccessControlItem.accessLevelsArray.length; j++) {
          userAccessLevels.push(newAccessControlItem.accessLevelsArray[j]);
        }
        newAccessControlItem.isUser = true;
      }

      // Check if current org groups email and get access levels
      if ($scope.currentOrgGroup && $scope.currentOrgGroup.emailAddresses) {
        for (var j = 0; j < $scope.currentOrgGroup.emailAddresses.length; j++) {
          if ($scope.currentOrgGroup.emailAddresses[j] == newAccessControlItem.emailAddress) {
            for (var k = 0; k < newAccessControlItem.accessLevelsArray.length; k++) {
              userAccessLevels.push(newAccessControlItem.accessLevelsArray[k]);
            }
            break;
          }
        }
      }
      accessControlEdit.push(newAccessControlItem);
    }

    $scope.accessControlEdit.accessControl = accessControlEdit;

    // get max access level
    var maxLevel = "";
    if (userAccessLevels.indexOf('editor') != -1) {
      maxLevel = 'editor';
    } else if (userAccessLevels.indexOf('forwarder') != -1) {
      maxLevel = "forwarder";
    } else if (userAccessLevels.indexOf('assignee') != -1) {
      maxLevel = 'assignee';
    } else if (userAccessLevels.indexOf('viewer') != -1) {
      maxLevel = 'viewer';
    }

    $scope.accessControlEdit.maxLevel = maxLevel;
    $mdBottomSheet.hide();
    $("#shareJobModal").fadeIn(100);
  };

  var maxLevelAllocations = {
    'viewer': ['viewer'],
    'forwarder': ['viewer'],
    'editor': ['editor', 'viewer', 'assignee', 'forwarder', 'remove'],
    'assignee': ['']
  };

  $scope.canSetAccessLevel = function (accessor, accessLevel) {
    if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
      return false;
    }

    if (maxLevelAllocations[$scope.accessControlEdit.maxLevel].indexOf(accessLevel) != -1) {
      return true;
    } else {
      return false;
    }
  };

  $scope.canChangeAccessLevel = function (accessor) {
    if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
      return false;
    }

    if (maxLevelAllocations[$scope.accessControlEdit.maxLevel].indexOf(accessor.accessLevel) != -1) {
      return true;
    } else {
      return false;
    }
  };

  $scope.addNewAccessor = function () {
    if ($scope.newAccessor.emailAddress != "") {
      $scope.newAccessor.new = true;
      var emailAddresses = $scope.newAccessor.emailAddress.split(',');
      if (emailAddresses.length > 1) {
        for (var i = 0; i < emailAddresses.length; i++) {
          var newAccessor = angular.copy($scope.newAccessor);
          newAccessor.emailAddress = emailAddresses[i];
          $scope.accessControlEdit.accessControl.push(newAccessor);
        }
      } else {
        $scope.accessControlEdit.accessControl.push($scope.newAccessor);
      }
      $scope.newAccessor = { 'accessLevel': 'viewer' };
    }
  };

  $scope.selectAccessorContact = function () {
    $("#shareJobModal").fadeOut(100);
    $scope.$parent.selectContactForJob(function (contactSelected) {
      if (contactSelected != null) {
        $("#shareJobModal").fadeIn(100);
        /*if ( contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress ) {
          $scope.newAccessor.emailAddress = contactSelected.contactAddresses[0].emailAddress;
        }*/
        var emailAddresses = [];
        for (var i = 0; i < contactSelected.contactAddresses.length; i++) {
          if (contactSelected.contactAddresses[i].emailAddress) {
            emailAddresses.push(contactSelected.contactAddresses[i].emailAddress);
          }
        }
        $scope.newAccessor.emailAddress = emailAddresses.join(',');
      } else {
        $("#shareJobModal").fadeIn(100);
      }
    });
  };

  $scope.selectSubcontractorContactForAddition = function () {
    $("#shareJobModal").fadeOut(100);
    $scope.$parent.selectContactForJob(function (contactSelected) {
      if (contactSelected && contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress) {
        $scope.accessControlEdit = {
          accessControl: [{
            emailAddress: contactSelected.contactAddresses[0].emailAddress,
            new: true,
            accessLevel: "forwarder"
          }]
        };
        $scope.saveAccessControlEdit();
      }
    });
  };

  $scope.removeSubcontractor = function (emailAddress) {
    $scope.accessControlEdit = {
      accessControl: [{
        emailAddress: emailAddress,
        remove: true,
        accessLevelInitial: "forwarder",
        accessLevel: "remove",
        accessLevelsArray: ["forwarder"]
      }]
    };
    $scope.saveAccessControlEdit();
  };

  $scope.saveAccessControlEdit = function () {
    $scope.accessControlEdit.loading = true;
    // convert back to accessControl object
    var accessControlObject = {};
    for (var i = 0; i < $scope.accessControlEdit.accessControl.length; i++) {
      var thisAccessItem = $scope.accessControlEdit.accessControl[i];
      if (thisAccessItem.new == true) {
        accessControlObject[thisAccessItem.emailAddress] = { 'add': [thisAccessItem.accessLevel] };
      } else if (thisAccessItem.accessLevelInitial != thisAccessItem.accessLevel) {
        // access has been changed - need to construct add/remove fields
        if (thisAccessItem.accessLevel == 'remove') {
          accessControlObject[thisAccessItem.emailAddress] = { 'remove': thisAccessItem.accessLevelsArray };
        } else {
          accessControlObject[thisAccessItem.emailAddress] = { 'remove': thisAccessItem.accessLevelsArray, 'add': [thisAccessItem.accessLevel] };
        }
      }
    }

    if ($scope.itemEdit.id == null) {
      $scope.itemEdit.accessControl = Object.assign({}, $scope.itemEdit.accessControl, accessControlObject);
      $scope.refreshForwardersFromAccessControl();
    } else {
      jobService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (jobUpdated) {
        $("#shareJobModal").fadeOut(100);
        // get updated job object
        $scope.itemEdit.accessControl = jobUpdated.accessControl;
        $scope.refreshForwardersFromAccessControl();
      }, function (err) {
        $scope.accessControlEdit.loading = false;
        $scope.refreshForwardersFromAccessControl();
        swal({
          title: "Error!",
          text: "An error occured while sharing the job.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      });
    }
  };

  $scope.closeAccessControlModal = function () {
    $("#shareJobModal").fadeOut(100);
  };

  /***************************/
  /**** UI Functionality *****/
  /***************************/

  $scope.openMobileTab = function (tabName) {
    $scope.currentTab = tabName;
    var leftOffset = $("#tab" + tabName).offset().left + $("#tab" + tabName).width();
    var width = $(".tabBarMobile.detailTabBar").width();
    var M = width / 2;
    var Y = leftOffset;
    var X = $(".tabBarMobile.detailTabBar").scrollLeft();

    if (Y > M) {
      // scroll right
      $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X + (Y - M) }, 600);
    } else {
      // scroll left
      $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X - (M - Y) }, 600);
    }
  };

  /******************/
  /***** Toasts *****/
  /******************/

  $scope.showToast = function (message) {
    var toast = {};
    if ($stateParams.device == 'desktop') {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000);
    } else {
      toast = $mdToast.simple().textContent(message).position('top right').hideDelay(3000).capsule(false).parent(document.querySelectorAll('#toasterInner'));
    }
    $mdToast.show(toast).then();
  };

  /***********************/
  /**** Bottom Sheet *****/
  /***********************/

  $scope.openBottomSheet = function () {
    $mdBottomSheet.show({
      templateUrl: 'views/pages/jobs/mobile/jobsBottomSheet.html',
      scope: $scope,
      preserveScope: true
    }).then(function () {});
  };

  /*****************************/
  /***** Date/Time Pickers *****/
  /*****************************/

  $scope.showDatePicker = function (field, ev) {
    $mdpDatePicker($scope.itemEdit[field], {
      targetEvent: ev
    }).then(function (selectedDate) {
      $scope.itemEdit[field] = selectedDate;
    });
  };

  $scope.showTimePicker = function (field, ev) {
    $mdpTimePicker($scope.itemEdit[field], {
      targetEvent: ev,
      autoSwitch: true
    }).then(function (selectedTime) {
      $scope.itemEdit[field] = selectedTime;
    });
  };

  /**********************************/
  /***** Alert Parent Controller ****/
  /**********************************/

  $scope.$parent.detailControllerReady();
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "rwyj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('orderListController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', function ($rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {

  /***************************/
  /***** Setup Variables *****/
  /***************************/

  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.listFull = true;
  $scope.listCount = 0;
  $scope.ordersLoading = false;

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  /***********************/
  /***** Permissions *****/
  /***********************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /*******************************/
  /***** Major State Changes *****/
  /*******************************/

  $scope.$parent.prepareForOrdersFromParent = function () {
    $scope.listItems = [];
    $scope.ordersLoading = true;
  };

  $scope.$parent.loadOrdersListFromParent = function (ordersList, count) {
    $scope.listItems = ordersList;
    $scope.listCount = count;
    $scope.ordersLoading = false;
  };

  $scope.$parent.loadAdditionalOrdersFromParent = function (ordersList) {
    for (var i = 0; i < ordersList.length; i++) {
      $scope.listItems.push(ordersList[i]);
    }
  };

  $scope.$parent.minimiseList = function () {
    $scope.listFull = false;
  };

  $scope.$parent.maximiseList = function () {
    $scope.listFull = true;
  };

  /*************************************/
  /***** Item List / Swipe Actions *****/
  /*************************************/

  //delete order, accept order and etc

  /**************************************************/
  /***** Alert parent controller of ready state *****/
  /**************************************************/

  $scope.$parent.ordersChildControllerReady();
}]);

/***/ }),

/***/ "s16B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _moment = __webpack_require__("PJh5");

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').service('docketService', ['orderService', 'userService', 'jobService', 'accessControl', '$http', '$stateParams', '$cookies', '$q', 'Restangular', 'geolocation', '$timeout', '$rootScope', 'Upload', function (orderService, userService, jobService, accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation, $timeout, $rootScope, Upload) {

  /**** Save a my docket signature ****/
  this.saveMyDocketSignature = function (docket, successCb, failureCb) {
    var currentUser = accessControl.currentUser();
    var docket = angular.copy(docket);
    var url = "" + '/' + $rootScope.urlVersion + "/dockets/" + docket.id + "/attachment";

    // check if the user is in the context of an org -> i.e. they are signing as the customer
    if (accessControl.currentOrg() && accessControl.currentOrgGroup()) {
      url = "" + '/' + $rootScope.urlVersion + "/organisations/" + accessControl.currentOrg().id + "/groups/" + accessControl.currentOrgGroup().id + "/dockets/" + docket.id + "/attachment";
    }

    var signatureImage = docket.customerSignatureData;
    var filename = 'customer-signature';
    var body = '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
    body += "--__TEST123__";
    if (docket.customerSignatureName) {
      body += "\r\n";
      body += 'content-disposition: form-data; name="jsondata";filename="customername.json"\r\ncontent-type: application/json\r\n\r\n{"customerSignatureName":"' + docket.customerSignatureName + '"}\r\n--__TEST123__--\r\n';
    } else {
      body += "--";
    }
    var header = 'multipart/form-data; boundary="__TEST123__"';
    $http.put(url, body, {
      headers: { 'Content-Type': header },
      withCredentials: true
    }).success(function (result) {
      successCb();
      return;
    }).error(function (err) {
      failureCb();
      return;
    });
  };

  /**** Save a docket ****/
  var saveDocket = function saveDocket(docket, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var currentUser = accessControl.currentUser();
    var docket = angular.copy(docket);
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
    if (docket.docketNumber == "New Docket") {
      delete docket.docketNumber;
    }
    if (docket.date) {
      docket.date = (0, _momentTimezone2.default)(docket.date).format('YYYY-MM-DD');
    }
    if (docket.startTime) {
      docket.startTime = docket.startTime.toISOString();
    }
    if (docket.endTime) {
      docket.endTime = docket.endTime.toISOString();
    }
    if (docket.breakTime) {
      docket.breakTime = parseInt(docket.breakTime);
    }
    if (docket.travelTime) {
      docket.travelTime = parseInt(docket.travelTime);
    }

    // update line items to have id's for ref'd items - not objects
    if (docket.lineItems != null) {
      for (var i = 0; i < docket.lineItems.length; i++) {
        docket.lineItems[i].resource = docket.lineItems[i].resource.id;
      }
    }

    if (docket.orderRef != null && docket.orderRef.id != null) {
      docket.orderRef = docket.orderRef.id;
    } else if (docket.orderRef == null) {
      delete docket.orderRef;
    }

    if (docket.jobRef != null && docket.jobRef.id != null) {
      docket.jobRef = docket.jobRef.id;
    }

    // update templateValueStore date/datetime and time values to be iso strings
    var signatureFieldsToSave = [];
    if (docket.template != null && docket.templateValueStore != null) {
      for (var i = 0; i < docket.template.blocks.length; i++) {
        var thisBlock = docket.template.blocks[i];
        for (var j = 0; j < thisBlock.fields.length; j++) {
          var thisField = thisBlock.fields[j];

          if (thisField.type == 'date') {
            var beforeValue = docket.templateValueStore[thisBlock.id + '-' + thisField.id];
            var afterValue = (0, _momentTimezone2.default)(beforeValue).format('YYYY-MM-DD');
            afterValue += "T00:00:00.000Z";
            if (beforeValue != "" && beforeValue != null) {
              docket.templateValueStore[thisBlock.id + '-' + thisField.id] = afterValue;
            }
          } else if (thisField.type == 'datetime' || thisField.type == 'time') {
            // convert date to ISO STRING
            var beforeValue = docket.templateValueStore[thisBlock.id + '-' + thisField.id];
            if (beforeValue != "" && beforeValue != null) {
              docket.templateValueStore[thisBlock.id + '-' + thisField.id] = (0, _momentTimezone2.default)(beforeValue).toISOString();
            }
          } else if (thisField.type == 'number') {
            // convert string to integer
            var beforeValue = docket.templateValueStore[thisBlock.id + '-' + thisField.id];
            docket.templateValueStore[thisBlock.id + '-' + thisField.id] = parseFloat(beforeValue);
          }
        }
      }
    }

    // update resource/interaction custom field value store date value to be iso strings
    if (docket.resources != null) {
      for (var i = 0; i < docket.resources.length; i++) {
        if (docket.resources[i].interactions != null) {
          for (var j = 0; j < docket.resources[i].interactions.length; j++) {
            if (docket.resources[i].interactions[j].customFields) {
              docket.resources[i].interactions[j].customFields = Object.fromEntries(Object.entries(docket.resources[i].interactions[j].customFields).filter(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    _ = _ref2[0],
                    v = _ref2[1];

                return v != null;
              }));
            }

            for (var k = 0; k < docket.resources[i].interactions[j].interactionTemplate.fields.length; k++) {
              var field = docket.resources[i].interactions[j].interactionTemplate.fields[k];
              if (field.type == 'date' && docket.resources[i].interactions[j].customFields[field.id]) {
                var dateTransformed = (0, _momentTimezone2.default)(docket.resources[i].interactions[j].customFields[field.id]).format('YYYY-MM-DD');
                dateTransformed += "T00:00:00.000Z";
                docket.resources[i].interactions[j].customFields[field.id] = dateTransformed;
              }
            }
          }
        }
      }
    }

    if (docket.status) {
      docket.status = docket.status.toLowerCase();
    }

    // convert accessControlEdit back to accessControl
    if (docket.accessControlEdit) {
      var accessControlEdited = {};
      for (var i = 0; i < docket.accessControlEdit.length; i++) {
        if (docket.accessControlEdit[i].new && docket.accessControlEdit[i].email != "") {
          var accessLevelsEdit = { 'add': docket.accessControlEdit[i].accessLevels };
          accessControlEdited[docket.accessControlEdit[i].email] = accessLevelsEdit;
        }
      }
      docket.accessControl = accessControlEdited;
    }

    docket.signatureFieldsToSave = [];
    if (docket.signatureFields) {
      var keys = Object.keys(docket.signatureFields);
      for (var i = 0; i < keys.length; i++) {
        docket.signatureFieldsToSave.push(docket.signatureFields[keys[i]]);
      }
    }

    delete docket.customerSignature;
    delete docket.supplierSignature;

    // TODO: maybe remove this after fixing in order setup?
    /*if ( docket.customerContact != null ) {
      var addressKeys = Object.keys(docket.customerContact.contactAddresses);
      for ( var i = 0; i < addressKeys.length; i++ ) {
        if ( docket.customerContact.contactAddresses[addressKeys[i]] == null || docket.customerContact.contactAddresses[addressKeys[i]].length == 0 ) {
          docket.customerContact.contactAddresses[addressKeys[i]] = ['approver'];
        }
      }
    }*/

    if (docket.id == null) {
      // new docket - post new
      docket.status = "draft";
      if (!docket.author) {
        docket.author = currentUser.id;
      }
      docket.organisation = organisation.id;
      if (organisationGroup != null) {
        docket.organisationGroup = organisationGroup.id;
      }
      baseDockets.post(docket).then(successCb, failureCb);
    } else {
      // existing docket - put updated version - upload newly added signatures first
      uploadSignaturesBeforeSave(docket, function () {
        baseDockets.one(docket.id).customPUT(docket).then(successCb, failureCb);
      }, function (err) {
        failureCb({ status: 551 });
        return;
      });
    }
  };

  var uploadSignaturesBeforeSave = function uploadSignaturesBeforeSave(docket, successCb, failureCb) {
    if (docket.supplierSignatureData == null && docket.customerSignatureData == null && docket.signatureFieldsToSave.length <= 0) {
      successCb();
      return;
    }

    uploadSignature('supplier', docket, function () {
      uploadSignature('customer', docket, function () {
        uploadFieldSignatures(docket, 0, function () {
          successCb();
          return;
        });
      }, function (err) {
        failureCb();
        return;
      });
    }, function (err) {
      failureCb();
      return;
    });
  };

  var uploadSignature = function uploadSignature(type, docket, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    if (type == 'supplier' && !docket.supplierSignatureData || type == 'customer' && !docket.customerSignatureData) {
      successCb();
      return;
    }
    var signatureImage = docket.supplierSignatureData;
    var filename = 'supplier-signature';
    if (type == 'customer') {
      signatureImage = docket.customerSignatureData;
      filename = 'customer-signature';
    }
    var url = "" + '/' + $rootScope.urlVersion + '/organisations/' + organisation.id + "/groups/" + organisationGroup.id + "/dockets/" + docket.id + "/attachment";
    var body = '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
    body += "--__TEST123__--\r\n";
    var header = 'multipart/form-data; boundary="__TEST123__"';
    $http.put(url, body, {
      headers: { 'Content-Type': header },
      withCredentials: true
    }).success(function (result) {
      successCb();
      return;
    }).error(function (err) {
      failureCb();
      return;
    });
  };

  var uploadFieldSignatures = function uploadFieldSignatures(docket, index, successCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();

    if (index > docket.signatureFieldsToSave.length - 1) {
      successCb();
      return;
    }

    var fieldToSave = docket.signatureFieldsToSave[index];
    var signatureImage = fieldToSave.signatureImage;
    var filename = fieldToSave.displayName;
    var url = "" + '/' + $rootScope.urlVersion + '/organisations/' + organisation.id + "/groups/" + organisationGroup.id + "/dockets/" + docket.id + "/attachment";
    var body = '--__TEST123__\r\ncontent-disposition: form-data; name="description"\r\n\r\nthis is a customer signature field\r\n';
    body += '--__TEST123__\r\ncontent-disposition: form-data; name="uploadType"\r\n\r\nfieldSignature\r\n';
    body += '--__TEST123__\r\ncontent-disposition: form-data; name="blockId"\r\n\r\n' + fieldToSave.blockId + '\r\n';
    body += '--__TEST123__\r\ncontent-disposition: form-data; name="fieldId"\r\n\r\n' + fieldToSave.fieldId + '\r\n';
    body += '--__TEST123__\r\ncontent-disposition: form-data; name="file"; filename="' + filename + '"\r\ncontent-type: image/png\r\nContent-Transfer-Encoding: base64\r\n\r\n' + signatureImage + '\r\n';
    body += "--__TEST123__--\r\n";
    var header = 'multipart/form-data; boundary="__TEST123__"';
    $http.put(url, body, {
      headers: { 'Content-Type': header },
      withCredentials: true
    }).success(function (result) {
      docket.signatureFields[fieldToSave.blockId + '-' + fieldToSave.fieldId] = null;
      uploadFieldSignatures(docket, index + 1, successCb);
      return;
    }).error(function (err) {
      uploadFieldSignatures(docket, index + 1, successCb);
      return;
    });
  };

  /**** External ref to saveDocket ****/
  this.saveDocket = saveDocket;

  /**** Save Docket Signatures *****/
  this.saveDocketCustomerSignature = function (docketId, customerSignatureName, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var docketId = docketId;
    if (docketId.id != null) {
      docketId = docketId.id;
    }
    var docketObj = {};
    if (customerSignatureName) {
      docketObj = { customerSignatureName: customerSignatureName };
    }
    baseDockets.one(docketId).customPUT(docketObj).then(successCb, failureCb);
  };

  /**** Get a single docket *****/
  var getDocket = function getDocket(docketId, populateOrderJob, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var currentUser = accessControl.currentUser();
    var baseDockets = null;
    if (organisation != null) {
      baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
    } else {
      baseDockets = Restangular.all('dockets');
    }

    if (docketId.id != null) {
      docketId = docketId.id;
    }

    baseDockets.one(docketId).customGET("", { populate: true }).then(function (docket) {
      var timezone = docket.timezone;
      if (timezone == null && organisationGroup != null && organisationGroup.timezone != null) {
        timezone = organisationGroup.timezone;
      } else if (timezone == null) {
        timezone = _momentTimezone2.default.tz.guess();
      }
      docket.status = docket.status.charAt(0).toUpperCase() + docket.status.slice(1);
      setupDocketValueStore(docket);
      if (organisation != null) {
        setupDocketChecklists(docket);
      }
      setupDocketResourceInteractionStore(docket);

      // prepare dates correctly
      if (docket.date) {
        docket.date = (0, _momentTimezone2.default)(docket.date).toDate();
      }
      if (docket.startTime) {
        docket.startTime = (0, _momentTimezone2.default)(docket.startTime).tz(timezone);
      }
      if (docket.endTime) {
        docket.endTime = (0, _momentTimezone2.default)(docket.endTime).tz(timezone);
      }

      // lock down customer if orderRef
      if (docket.orderRef != null) {
        docket.customerLocked = true;
      }

      // If in myDocketbook - check if docket is assigned to an org
      docket.assigned = false;
      if (organisation == null || organisationGroup == null) {
        var orgEmails = userService.getOrgEmailAddresses();
        for (var key in docket.accessControl) {
          if (orgEmails.indexOf(key) != -1) {
            docket.assigned = true;
            break;
          }
        }
      }

      // if not assigned - get users accessLevel
      if (!docket.assigned && docket.accessControl[currentUser.emailAddress] != null) {
        docket.userAccessLevels = docket.accessControl[currentUser.emailAddress];
      }

      // get signature attachment id's
      if (docket.attachments) {
        for (var i = 0; i < docket.attachments.length; i++) {
          if (docket.attachments[i].fileName == 'customer-signature') {
            docket.customerSignatureAttachment = docket.attachments[i].id;
          } else if (docket.attachments[i].fileName == 'supplier-signature') {
            docket.supplierSignatureAttachment = docket.attachments[i].id;
          }
        }
      }

      if (!populateOrderJob) {
        successCb(docket);
        return;
      }

      // populate job / order for getting full line item detail
      if (docket.jobRef != null && (accessControl.userHasPermission('io.docketbook.ojdapi.getJob') || accessControl.userHasPermission('io.docketbook.ojdapi.getMyJob'))) {
        var jobId = docket.jobRef;
        if (jobId.id != null) {
          jobId = jobId.id;
        }
        jobService.getJob(jobId, function (fullJob) {
          docket.jobRef = fullJob;
          successCb(docket);
        }, function (err) {
          successCb(docket);
        });
      } else if (docket.orderRef != null && accessControl.userHasPermission('io.docketbook.ojdapi.getOrder')) {
        var orderId = docket.orderRef;
        if (orderId.id != null) {
          orderId = orderId.id;
        }
        orderService.getOrder(orderId, function (fullOrder) {
          docket.orderRef = fullOrder;
          successCb(docket);
        }, function (err) {
          successCb(docket);
        });
      } else {
        successCb(docket);
      }
    }, failureCb);
  };

  this.getDocket = getDocket;

  /**** Delete a docket ****/
  var deleteDocket = function deleteDocket(docket, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var docketId = docket;
    if (docketId.id != null) {
      docketId = docketId.id;
    }
    baseDockets.one(docketId).remove().then(successCb, failureCb);
  };

  this.deleteDocket = deleteDocket;

  /***** Delete Bulk Dockets *****/
  this.deleteBulkDockets = function (dockets, successCb) {
    var failures = [];
    deleteDockets(dockets, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteDockets = function deleteDockets(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteDocket(list[index].id, function (success) {
      deleteDockets(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteDockets(list, index + 1, failures, successCb);
    });
  };

  /**** Update Docket Access Control *****/
  this.updateAccessControl = function (docket, accessControlPayload, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('dockets');
    if (organisation != null && organisationGroup != null) {
      baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
    }

    var docketId = docket;
    if (docketId.id != null) {
      docketId = docketId.id;
    }

    var accessControlFull = { 'accessControl': accessControlPayload };
    baseDockets.one(docketId).customPUT(accessControlFull).then(successCb, failureCb);
  };

  /***** Re-assign Docket *****/
  this.reassignDocket = function (docket, losingPrincipal, gainingPrincipal, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('dockets');
    if (organisation != null && organisationGroup != null) {
      baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
    }

    var docketId = docket;
    if (docketId.id != null) {
      docketId = docketId.id;
    }

    var payload = { 'losingPrincipal': losingPrincipal, 'gainingPrincipal': gainingPrincipal };
    baseDockets.one(docketId).all('reassign').customPOST(payload).then(successCb, failureCb);
  };

  /**** Send a docket ****/
  var sendDocket = function sendDocket(original, docket, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    if (docket.id == null) {
      // new docket - save first
      saveDocket(docket, function (docketUpdated) {
        var docketObject = {};
        docketObject.status = 'sent';

        if (navigator && navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (data) {
            var coords = data.coords;
            docketObject.lat = coords.latitude;
            docketObject.long = coords.longitude;
            baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
          }, function (err) {
            baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
          }, { enableHighAccuracy: true, timeout: 5000 });
        } else {
          baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
        }

        /*geolocation.getLocation().then(function(data) {
          var coords = data.coords;
          docketObject.lat = coords.latitude;
          docketObject.long = coords.longitude;
          baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
        }, function(err) {
          baseDockets.one(docketUpdated.id).customPUT(docketObject).then(successCb, failureCb);
        });*/
      }, function (err) {
        failureCb('Error saving docket');
      });
    } else {
      // not a new docket - get diff of changes and save if required
      getDiffedDocket(original, docket, 'resources', function (diff, diffCount) {
        if (diffCount > 0) {
          diff.status = 'sent';

          if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (data) {
              var coords = data.coords;
              diff.lat = coords.latitude;
              diff.long = coords.longitude;
              saveDocket(diff, successCb, failureCb);
            }, function (err) {
              saveDocket(diff, successCb, failureCb);
              baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
            }, { enableHighAccuracy: true, timeout: 5000 });
          } else {
            saveDocket(diff, successCb, failureCb);
            baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
          }

          /*geolocation.getLocation().then(function(data) {
            var coords = data.coords;
            diff.lat = coords.latitude;
            diff.long = coords.longitude;
            saveDocket(diff, successCb, failureCb);
            //baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
          }, function(err) {
            saveDocket(diff, successCb, failureCb);
            baseDockets.one(docket.id).customPUT(diff).then(successCb, failureCb);
          });*/
        } else {
          var docketObject = {};
          docketObject.status = 'sent';

          if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (data) {
              var coords = data.coords;
              docketObject.lat = coords.latitude;
              docketObject.long = coords.longitude;
              baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
            }, function (err) {
              baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
            }, { enableHighAccuracy: true, timeout: 5000 });
          } else {
            baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
          }

          /*geolocation.getLocation().then(function(data) {
            var coords = data.coords;
            docketObject.lat = coords.latitude;
            docketObject.long = coords.longitude;
            baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
          }, function(err) {
            baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
          });*/
        }
      });
    }
  };

  this.sendDocket = sendDocket;

  var sendDocketPresetGeo = function sendDocketPresetGeo(docket, geoCoords, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var docketObject = {};
    docketObject.status = 'sent';

    if (geoCoords) {
      docketObject.lat = geoCoords.latitude;
      docketObject.long = geoCoords.longitude;
    }

    baseDockets.one(docket).customPUT(docketObject).then(successCb, failureCb);
  };

  /***** Send Bulk Dockets *****/
  this.sendBulkDockets = function (dockets, successCb) {
    var failures = [];

    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (data) {
        var coords = data.coords;

        sendDockets(coords, dockets, 0, failures, function (failuresFilled) {
          successCb(failuresFilled);
        });
      }, function (err) {
        sendDockets(null, dockets, 0, failures, function (failuresFilled) {
          successCb(failuresFilled);
        });
      }, { enableHighAccuracy: true, timeout: 5000 });
    } else {
      sendDockets(null, dockets, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    /*geolocation.getLocation().then(function(data) {
      var coords = data.coords;
       sendDockets(coords, dockets, 0, failures, function(failuresFilled) {
        successCb(failuresFilled);
      });
    }, function(err) {
      sendDockets(null, dockets, 0, failures, function(failuresFilled) {
        successCb(failuresFilled);
      });
    });*/
  };

  var sendDockets = function sendDockets(geoCoords, list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }
    sendDocketPresetGeo(list[index].id, geoCoords, function (success) {
      sendDockets(geoCoords, list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      sendDockets(geoCoords, list, index + 1, failures, successCb);
    });
  };

  /**** Reject a docket ****/
  var rejectDocket = function rejectDocket(docket, reason, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var docketObject = { status: 'rejected', rejectionComment: reason };
    var docketId = docket;
    if (docketId.id != null) {
      docketId = docketId.id;
    }
    baseDockets.one(docketId).customPUT(docketObject).then(successCb, failureCb);
  };

  this.rejectDocket = rejectDocket;

  /***** Delete Reject Dockets *****/
  this.rejectBulkDockets = function (dockets, reason, successCb) {
    var failures = [];
    rejectDockets(dockets, reason, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var rejectDockets = function rejectDockets(list, reason, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    rejectDocket(list[index].id, reason, function (success) {
      rejectDockets(list, reason, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      rejectDockets(list, reason, index + 1, failures, successCb);
    });
  };

  /**** Accept a docket ****/
  var acceptDocket = function acceptDocket(docket, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var docketObject = { status: 'accepted' };
    var docketId = docket;
    if (docketId.id != null) {
      docketId = docketId.id;
    }
    baseDockets.one(docketId).customPUT(docketObject).then(successCb, failureCb);
  };

  this.acceptDocket = acceptDocket;

  this.recallDocket = function (docket, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var docketObject = { status: 'draft' };
    var docketId = docket;
    if (docketId.id != null) {
      docketId = docketId.id;
    }
    baseDockets.one(docketId).customPUT(docketObject).then(successCb, failureCb);
  };

  /***** Accept Reject Dockets *****/
  this.acceptBulkDockets = function (dockets, successCb) {
    var failures = [];
    acceptDockets(dockets, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var acceptDockets = function acceptDockets(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    acceptDocket(list[index].id, function (success) {
      acceptDockets(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      acceptDockets(list, index + 1, failures, successCb);
    });
  };

  /***** Re-Draft a Docket *****/
  this.reDraftDocket = function (docket, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');

    var docketObject = { status: 'draft' };
    baseDockets.one(docket.id).customPUT(docketObject).then(successCb, failureCb);
  };

  /******* Get list of dockets ********/
  this.getDockets = function (params, successCb, failureCb) {
    if (params == null) {
      params = {};
    }

    /**** Setup scope - group or myDocketbook ****/
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseDockets = null;

    if (organisationGroup != null) {
      baseDockets = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('dockets');
    } else {
      baseDockets = Restangular.all('dockets');
    }
    /**** End scope setup ****/

    if (params['offset'] != null && params['limit'] != null) {
      baseDockets.customGET("", params).then(successCb, failureCb);
    } else {
      baseDockets.getList(params).then(function (dockets) {
        successCb(Restangular.stripRestangular(dockets));
      }, failureCb);
    }
  };

  /****** Get populated dockets for home feed *******/
  this.populateDocketsForFeed = function (docketsList, cb) {
    populateDocketsFeedData(docketsList, 0, cb);
  };

  var populateDocketsFeedData = function populateDocketsFeedData(docketsList, index, cb) {
    if (index >= docketsList.length) {
      cb(docketsList);
      return;
    }

    getDocket(docketsList[index].id, false, function (fullDocket) {
      // generate line summary
      var resourceSummary = { totalInteractions: 0 };
      for (var i = 0; i < fullDocket.resources.length; i++) {
        var resource = fullDocket.resources[i];
        if (resourceSummary[resource.id] == null) {
          resourceSummary[resource.id] = { interactionSummary: {}, resource: resource.resource };
        }
        for (var j = 0; j < resource.interactions.length; j++) {
          if (resourceSummary[resource.id].interactionSummary[resource.interactions[j].interactionTemplate.name] == null) {
            resourceSummary[resource.id].interactionSummary[resource.interactions[j].interactionTemplate.name] = { interaction: resource.interactions[j].interactionTemplate, quantity: resource.interactions[j].quantity };
          } else {
            resourceSummary[resource.id].interactionSummary[resource.interactions[j].interactionTemplate.name].quantity += resource.interactions[j].quantity;
          }
          resourceSummary.totalInteractions += 1;
        }
      }

      fullDocket.resourceSummary = resourceSummary;
      docketsList[index] = fullDocket;
      populateDocketsFeedData(docketsList, index + 1, cb);
    }, function (err) {
      populateDocketsFeedData(docketsList, index + 1, cb);
    });
  };

  /******************/
  /***** Filing *****/
  /******************/

  this.getDocketFileData = function (docket, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

    var docketId = docket;
    if (docket.id != null) {
      docketId = docket.id;
    }

    baseDocketFiles.getList({ 'docket': docketId }).then(function (docketFiles) {
      var existingDocketFile = null;
      var identifiers = {};
      for (var i = 0; i < docketFiles.length; i++) {
        if (docketFiles[i].lineCodes) {
          for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
            var fileCodeIdentifiers = [];
            if (docketFiles[i].lineCodes[j].fileCodes) {
              fileCodeIdentifiers = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
            }
            for (var k = 0; k < fileCodeIdentifiers.length; k++) {
              if (identifiers[fileCodeIdentifiers[k]] == null) {
                identifiers[fileCodeIdentifiers[k]] = { placeholder: true };
              }
            }
          }
        }
      }
      // get list of identifiers
      var identifiersList = Object.keys(identifiers);
      // get all fileCodes from identifiers
      if (identifiersList != null && identifiersList.length > 0) {
        getFileCodes({ ids: identifiersList }, function (fileCodes) {
          // convert fileCodes to dictionary for ease of use
          var fileCodesDict = {};
          for (var i = 0; i < fileCodes.length; i++) {
            fileCodesDict[fileCodes[i].uniqueIdentifier] = fileCodes[i];
          }
          // got list of fileCodes - now re-attach back onto the docket Files
          for (var i = 0; i < docketFiles.length; i++) {
            if (docketFiles[i].lineCodes) {
              for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
                if (docketFiles[i].lineCodes[j].fileCodes) {
                  var fileCodesKeys = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
                  var populatedFileCodes = [];
                  for (var k = 0; k < fileCodesKeys.length; k++) {
                    var newFileCode = {};
                    newFileCode.fileCode = fileCodesDict[fileCodesKeys[k]];
                    newFileCode.percentage = docketFiles[i].lineCodes[j].fileCodes[fileCodesKeys[k]];
                    populatedFileCodes.push(newFileCode);
                  }
                  docketFiles[i].lineCodes[j].populatedFileCodes = populatedFileCodes;
                }
              }
            }
          }
          if (docketFiles.length > 0) {
            existingDocketFile = docketFiles[0];
          }
          successCb(existingDocketFile);
        }, function (err) {
          if (docketFiles.length > 0) {
            existingDocketFile = docketFiles[0];
          }
          successCb(existingDocketFile);
        });
      } else {
        if (docketFiles.length > 0) {
          existingDocketFile = docketFiles[0];
        }
        successCb(existingDocketFile);
      }
    }, function (err) {
      failureCb(err);
    });
  };

  this.getBulkDocketFileData = function (docketIds, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();

    if (currentOrg == null || currentOrgGroup == null) {
      if (failureCb) {
        failureCb();
      }
      return;
    }

    var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

    var docketIdString = '';
    for (var i = 0; i < docketIds.length; i++) {
      if (i == docketIds.length - 1) {
        docketIdString += docketIds[i];
      } else {
        docketIdString += docketIds[i] + ",";
      }
    }

    baseDocketFiles.getList({ 'dockets': docketIdString }).then(function (docketFiles) {
      // get list of fileCodes used by all docketFiles
      var identifiers = {};
      for (var i = 0; i < docketFiles.length; i++) {
        if (docketFiles[i].lineCodes) {
          for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
            var fileCodeIdentifiers = [];
            if (docketFiles[i].lineCodes[j].fileCodes) {
              fileCodeIdentifiers = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
            }
            for (var k = 0; k < fileCodeIdentifiers.length; k++) {
              if (identifiers[fileCodeIdentifiers[k]] == null) {
                identifiers[fileCodeIdentifiers[k]] = { placeholder: true };
              }
            }
          }
        }
      }
      // get list of identifiers
      var identifiersList = Object.keys(identifiers);
      // get all fileCodes from identifiers
      var identifiersParsed = [];
      for (var i = 0; i < identifiersList.length; i++) {
        if (identifiersList[i] != null && identifiersList[i] != undefined && identifiersList[i].length > 10) {
          identifiersParsed.push(identifiersList[i]);
        }
      }
      if (identifiersParsed.length == 0) {
        successCb(docketFiles);
        return;
      }
      getFileCodes({ ids: identifiersParsed }, function (fileCodes) {
        // convert fileCodes to dictionary for ease of use
        var fileCodesDict = {};
        for (var i = 0; i < fileCodes.length; i++) {
          fileCodesDict[fileCodes[i].uniqueIdentifier] = fileCodes[i];
        }
        // got list of fileCodes - now re-attach back onto the docket Files
        for (var i = 0; i < docketFiles.length; i++) {
          if (docketFiles[i].lineCodes) {
            for (var j = 0; j < docketFiles[i].lineCodes.length; j++) {
              if (docketFiles[i].lineCodes[j].fileCodes) {
                var fileCodesKeys = Object.keys(docketFiles[i].lineCodes[j].fileCodes);
                var populatedFileCodes = [];
                for (var k = 0; k < fileCodesKeys.length; k++) {
                  var newFileCode = {};
                  newFileCode.fileCode = fileCodesDict[fileCodesKeys[k]];
                  newFileCode.percentage = docketFiles[i].lineCodes[j].fileCodes[fileCodesKeys[k]];
                  populatedFileCodes.push(newFileCode);
                }
                docketFiles[i].lineCodes[j].populatedFileCodes = populatedFileCodes;
              }
            }
          }
        }
        successCb && successCb(docketFiles);
      }, function (err) {
        successCb && successCb(docketFiles);
      });
    }, function (err) {
      failureCb && failureCb(err);
    });
  };

  /****** Get File Codes *******/
  var getFileCodes = function getFileCodes(params, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var orgGroupId = currentOrgGroup.id;
    if (params.orgGroupId) {
      orgGroupId = params.orgGroupId;
    }
    var baseFileCodes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(orgGroupId).all('filecodes');

    if (params == null) {
      params = {};
    }
    if (params.ids != null) {
      params.ids = params.ids.join(',');
    }

    baseFileCodes.getList(params).then(function (fileCodes) {
      var fileCodesStripped = [];
      for (var i = 0; i < fileCodes.length; i++) {
        fileCodesStripped.push(Restangular.stripRestangular(fileCodes[i]));
      }
      successCb(fileCodesStripped);
    }, failureCb);
  };

  this.getFileCodes = getFileCodes;

  /***** Get File Code *****/
  this.getFileCode = function (fileCode, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseFileCodes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('filecodes');

    var uniqueIdentifier = fileCode;
    if (fileCode.uniqueIdentifier != null) {
      uniqueIdentifier = fileCode.uniqueIdentifier;
    }

    baseFileCodes.one(uniqueIdentifier).get().then(successCb, failureCb);
  };

  /***** Save File Code *****/
  this.saveFileCode = function (fileCode, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var orgGroupId = currentOrgGroup.id;
    if (fileCode.orgGroupId) {
      orgGroupId = fileCode.orgGroupId;
    }
    var baseFileCodes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(orgGroupId).all('filecodes');

    if (fileCode.id == null) {
      fileCode.organisation = currentOrg.id;
      fileCode.organisationGroup = orgGroupId;

      baseFileCodes.post(fileCode).then(successCb, failureCb);
    } else {
      baseFileCodes.one(fileCode.uniqueIdentifier).customPUT(fileCode).then(successCb, failureCb);
    }
  };

  /********* Delete File Code **********/
  var deleteFileCode = function deleteFileCode(orgGroupId, fileCodeId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseFileCodes = Restangular.all('organisations').one(organisation.id).all('groups').one(orgGroupId).all('filecodes');

    if (fileCodeId.uniqueIdentifier != null) {
      fileCodeId = fileCodeId.uniqueIdentifier;
    }

    baseFileCodes.one(fileCodeId).remove().then(successCb, failureCb);
  };

  this.deleteFileCode = deleteFileCode;

  /********** Delete Bulk File Codes **********/
  this.deleteBulkFileCodes = function (orgGroupId, fileCodes, successCb) {
    var failures = [];
    deleteFileCodes(orgGroupId, fileCodes, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteFileCodes = function deleteFileCodes(orgGroupId, list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteFileCode(orgGroupId, list[index].uniqueIdentifier, function (success) {
      deleteFileCodes(orgGroupId, list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteFileCodes(orgGroupId, list, index + 1, failures, successCb);
    });
  };

  /***** Import Bulk File Codes *****/
  this.importFileCodes = function (orgGroupId, fileCodes, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseFileCodeImport = Restangular.all('organisations').one(organisation.id).all('groups').one(orgGroupId).all('filecodes?import=true');

    baseFileCodeImport.customPOST(fileCodes).then(successCb, failureCb);
  };

  /***** Save Docket Filing *****/
  this.saveDocketFiling = function (docketFiling, successCb, failureCb) {
    var dockets = docketFiling.dockets;
    var method = docketFiling.method;

    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

    var docketFilesToSave = [];
    for (var i = 0; i < dockets.length; i++) {
      // Basic docketFile setup for this docket
      var docketFile = {};
      docketFile.fileMethod = docketFiling.method;
      docketFile.docketRef = dockets[i].id;
      if (dockets[i].orderRef) {
        if (dockets[i].orderRef.id) {
          docketFile.orderRef = dockets[i].orderRef.id;
        } else {
          docketFile.orderRef = dockets[i].orderRef;
        }
      }
      if (dockets[i].jobRef) {
        if (dockets[i].jobRef.id) {
          docketFile.jobRef = dockets[i].jobRef.id;
        } else {
          docketFile.jobRef = dockets[i].jobRef;
        }
      }
      docketFile.organisation = currentOrg.id;
      docketFile.organisationGroup = currentOrgGroup.id;

      // Check if docket has an existing docketFile
      if (dockets[i].existingDocketFile) {
        docketFile.fromExisting = dockets[i].existingDocketFile;
        docketFile.id = docketFile.fromExisting.id;
      } else {
        docketFile.fromExisting = null;
      }

      // Create master fileCode if method is docket or split
      var masterFileCode = null;
      if (method == 'docket') {
        masterFileCode = {};
        masterFileCode[docketFiling.activityCode.uniqueIdentifier] = 100;
      } else if (method == 'split') {
        masterFileCode = {};
        if (docketFiling.activityCodes) {
          for (var j = 0; j < docketFiling.activityCodes.length; j++) {
            masterFileCode[docketFiling.activityCodes[j].fileCode.uniqueIdentifier] = parseFloat(docketFiling.activityCodes[j].splitPercentage);
          }
        }
      }

      docketFile.lineCodes = [];
      if (docketFile.fromExisting) {
        docketFile.lineCodes = docketFile.fromExisting.lineCodes;
      }
      for (var j = 0; j < dockets[i].resources.length; j++) {
        for (var k = 0; k < dockets[i].resources[j].interactions.length; k++) {
          var thisInteraction = dockets[i].resources[j].interactions[k];
          // generate fileCodes object for this interaction
          var fileCodes = {};
          if (docketFiling.method == 'docket' || docketFiling.method == 'split') {
            fileCodes = masterFileCode;
          } else {
            // locate lineCode from linesSummary and set fileCodes object
            if (dockets.length == 1) {
              for (var l = 0; l < docketFiling.linesSummary.length; l++) {
                if (docketFiling.linesSummary[l].interaction.id == thisInteraction.id && docketFiling.linesSummary[l].resource.id == thisInteraction.resource.id) {
                  fileCodes = {};
                  for (var dc = 0; dc < docketFiling.linesSummary[l].activityCodes.length; dc++) {
                    var activityCode = docketFiling.linesSummary[l].activityCodes[dc];
                    fileCodes[activityCode.fileCode.uniqueIdentifier] = activityCode.percentage;
                  }
                  break;
                }
              }
            } else {
              for (var l = 0; l < docketFiling.linesSummary.length; l++) {
                if (docketFiling.linesSummary[l].interaction.interactionName == thisInteraction.interactionName && docketFiling.linesSummary[l].resource.id == thisInteraction.resource.id) {
                  fileCodes = {};
                  if (docketFiling.linesSummary[l].activityCodes) {
                    for (var dc = 0; dc < docketFiling.linesSummary[l].activityCodes.length; dc++) {
                      var _activityCode = docketFiling.linesSummary[l].activityCodes[dc];
                      fileCodes[_activityCode.fileCode.uniqueIdentifier] = _activityCode.percentage;
                    }
                  }
                  break;
                }
              }
            }
          }

          // if existing docketFile - check if lineCode already exists for this interaction
          var matched = false;
          for (var l = 0; l < docketFile.lineCodes.length; l++) {
            if (docketFile.lineCodes[l].interaction.id == thisInteraction.id && docketFile.lineCodes[l].resource.id == thisInteraction.resource.id) {
              // lineCode matches - replace
              matched = true;
              docketFile.lineCodes[l].fileCodes = fileCodes;
              break;
            }
          }

          // if interaction not already added as a lineCode - create a new one
          if (!matched) {
            var lineCode = {};
            lineCode.interaction = thisInteraction;
            lineCode.resource = thisInteraction.resource;
            lineCode.quantity = thisInteraction.quantity;
            lineCode.fileCodes = fileCodes;
            docketFile.lineCodes.push(lineCode);
          }
        }
      }
      docketFilesToSave.push(docketFile);
    }

    // Now save the docket files
    saveBulkDocketFiles(docketFilesToSave, 0, function () {
      successCb();
    });
  };

  var saveBulkDocketFiles = function saveBulkDocketFiles(docketFiles, index, cb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseDocketFiles = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docketfiles');

    if (index >= docketFiles.length) {
      cb();
      return;
    }

    var docketFileSave = docketFiles[index];
    if (docketFileSave.fromExisting) {
      baseDocketFiles.one(docketFileSave.fromExisting.id).customPUT(docketFileSave).then(function () {
        saveBulkDocketFiles(docketFiles, index + 1, cb);
      }, function (err) {
        saveBulkDocketFiles(docketFiles, index + 1, cb);
      });
    } else {
      baseDocketFiles.customPOST(docketFileSave).then(function () {
        saveBulkDocketFiles(docketFiles, index + 1, cb);
      }, function (err) {
        saveBulkDocketFiles(docketFiles, index + 1, cb);
      });
    }
  };

  /***************************/
  /**** Helper Functions *****/
  /***************************/

  var setupDocketResourceInteractionStore = function setupDocketResourceInteractionStore(docket) {
    if (docket.resources != null) {
      for (var i = 0; i < docket.resources.length; i++) {
        if (docket.resources[i].interactions != null) {
          for (var j = 0; j < docket.resources[i].interactions.length; j++) {
            if (docket.resources[i].interactions[j].interactionTemplate.fields != null) {
              for (var k = 0; k < docket.resources[i].interactions[j].interactionTemplate.fields.length; k++) {
                var field = docket.resources[i].interactions[j].interactionTemplate.fields[k];
                // check that a value exists in the custom field first
                if (field.type == 'date' && docket.resources[i].interactions[j].customFields && docket.resources[i].interactions[j].customFields[field.id]) {
                  var dateIn = (0, _momentTimezone2.default)(docket.resources[i].interactions[j].customFields[field.id].split('T')[0]).toDate();
                  docket.resources[i].interactions[j].customFields[field.id] = dateIn;
                } else if (field.type == 'time' && docket.resources[i].interactions[j].customFields) {
                  docket.resources[i].interactions[j].customFields[field.id] = docket.resources[i].interactions[j].customFields[field.id] ? _momentTimezone2.default.tz(docket.resources[i].interactions[j].customFields[field.id], docket.timezone) : null;
                }
              }
            }
          }
        }
      }
    }
  };

  this.setupResourceInteractionStore = setupDocketResourceInteractionStore;

  var setupDocketValueStore = function setupDocketValueStore(docket, cb) {
    if (docket.templateValueStore == null) {
      docket.templateValueStore = {};
    }

    if (docket.template != null && docket.template.blocks != null) {
      docket.template.blocks.forEach(function (block) {
        block.fields.forEach(function (field) {
          var keyStore = block.id + '-' + field.id;

          // patch for fixing bug where multiple of the same option are listed in a select field type
          if (field.type == 'select') {
            var selectionFieldsCleaned = [];
            for (var l = 0; l < field.selectionFields.length; l++) {
              if (selectionFieldsCleaned.indexOf(field.selectionFields[l]) == -1) {
                selectionFieldsCleaned.push(field.selectionFields[l]);
              }
            }
            field.selectionFields = selectionFieldsCleaned;
          }

          if (docket.templateValueStore[keyStore] == null) {
            docket.templateValueStore[keyStore] = "";
          } else if (field.type == 'date' || field.type == 'datetime') {
            // field is date/datetime or time type - so convert to js date from ISO String
            var beforeValue = docket.templateValueStore[keyStore];
            if (beforeValue != "" && beforeValue != null) {
              docket.templateValueStore[keyStore] = (0, _momentTimezone2.default)(beforeValue).toDate();
            }
          } else if (field.type == 'time') {
            // field is date/datetime or time type - so convert to js date from ISO String
            var beforeValue = docket.templateValueStore[keyStore];
            if (beforeValue != "" && beforeValue != null) {
              docket.templateValueStore[keyStore] = _momentTimezone2.default.tz(beforeValue, docket.timezone);
            }
          }
        });
      });
      if (cb) {
        cb();
      }
    } else {
      if (cb) {
        cb();
      }
    }
  };

  this.setupValueStore = setupDocketValueStore;

  var setupDocketChecklists = function setupDocketChecklists(docket, cb) {
    var currentOrg = accessControl.currentOrg();
    var currentUser = accessControl.currentUser();
    if (docket.checklists == null) {
      docket.checklists = {};
    }

    if (docket.template != null && docket.template.checklistContainers != null) {
      for (var i = 0; i < docket.template.checklistContainers.length; i++) {
        docket.template.checklistContainers[i].detailOpen = false;
        if (docket.checklists[docket.template.checklistContainers[i].checklistTemplate.id] == null) {
          var newChecklist = {};
          newChecklist.checklistTemplate = docket.template.checklistContainers[i].checklistTemplate.id;
          newChecklist.date = new Date(); // TODO: change this to date when the checklist is filled out
          newChecklist.organisation = accessControl.currentOrg().id;
          newChecklist.author = accessControl.currentUser().id;
          newChecklist.answers = {};
          for (var j = 0; j < docket.template.checklistContainers[i].checklistTemplate.fields.length; j++) {
            newChecklist.answers[docket.template.checklistContainers[i].checklistTemplate.fields[j].id] = "";
          }
          docket.checklists[docket.template.checklistContainers[i].checklistTemplate.id] = newChecklist;
        }
      }
    }

    // check if any once daily checklists have existing answers
    if (docket.id == null && docket.template && docket.template.checklistContainers != null && accessControl.userHasPermission('io.docketbook.ojdapi.getChecklists')) {
      // get all once daily results for this template/user/date
      Restangular.all('organisations/' + currentOrg.id + '/checklists?organisation=' + currentOrg.id + "&author=" + currentUser.id + "&date=" + (0, _momentTimezone2.default)().toISOString()).getList().then(function (checklists) {
        var existingChecklists = Restangular.stripRestangular(checklists);
        for (var i = 0; i < docket.template.checklistContainers.length; i++) {
          for (var j = 0; j < existingChecklists.length; j++) {
            if (docket.template.checklistContainers[i].checklistTemplate.id == existingChecklists[j].checklistTemplate.id) {
              // add answers to checklst item
              if (docket.checklists[existingChecklists[j].checklistTemplate.id] != null) {
                docket.checklists[existingChecklists[j].checklistTemplate.id].answers = existingChecklists[j].answers;
              }
              break;
            }
          }
        }
        if (cb) {
          cb();
        }
      }, function (err) {
        if (cb) {
          cb();
        }
      });
    } else {
      if (cb) {
        cb();
      }
    }
  };

  this.setupChecklists = setupDocketChecklists;

  var autoPopulateResources = function autoPopulateResources(docket, populateInteractions, cb) {
    if (docket.jobRef != null) {
      // if from job - populate from job line items
      docket.resources = [];
      for (var i = 0; i < docket.jobRef.lineItems.length; i++) {
        if (docket.jobRef.lineItems[i].resource != null) {
          var newResource = {};
          newResource.resource = docket.jobRef.lineItems[i].resource;
          newResource.description = docket.jobRef.lineItems[i].itemDescription;
          newResource.orderItemId = docket.jobRef.lineItems[i].id;
          newResource.interactions = [];
          // get interactions for resource - to auto populate if possible
          if (docket.template && docket.template.interactionTemplates && populateInteractions == true) {
            var resourceInteractionTemplates = [];
            for (var j = 0; j < docket.template.interactionTemplates.length; j++) {
              var currInteractionTemplate = docket.template.interactionTemplates[j];
              for (var k = 0; k < currInteractionTemplate.actorCategories.length; k++) {
                if (currInteractionTemplate.actorCategories[k].id == newResource.resource.categoryId && currInteractionTemplate.refersParent == true) {
                  resourceInteractionTemplates.push(currInteractionTemplate);
                  break;
                }
              }
            }
            if (resourceInteractionTemplates.length == 1) {
              var newInteraction = {};
              newInteraction.interactionName = resourceInteractionTemplates[0].name;
              newInteraction.interactionTemplate = resourceInteractionTemplates[0];
              newInteraction.resource = newResource.resource;
              newInteraction.resourceIsParent = true;
              if (docket.jobRef.lineItems[i].quantity) {
                newInteraction.quantity = docket.jobRef.lineItems[i].quantity;
              } else {
                newInteraction.quantity = 0;
              }
              newResource.interactions.push(newInteraction);
            }
          }
          docket.resources.push(newResource);
        }
      }
    } else if (docket.orderRef != null) {
      // if from order - populate from order line items
      if (docket.orderRef.lineItems && (docket.resources == null || docket.resources.length == 0)) {
        docket.resources = [];
        for (var i = 0; i < docket.orderRef.lineItems.length; i++) {
          if (docket.orderRef.lineItems[i].resource != null) {
            var newResource = {};
            newResource.resource = docket.orderRef.lineItems[i].resource;
            newResource.description = docket.orderRef.lineItems[i].itemDescription;
            newResource.orderItemId = docket.orderRef.lineItems[i].id;
            newResource.interactions = [];
            // get interactions for resource - to auto populate if possible
            if (docket.template && docket.template.interactionTemplates && populateInteractions == true) {
              var resourceInteractionTemplates = [];
              for (var j = 0; j < docket.template.interactionTemplates.length; j++) {
                var currInteractionTemplate = docket.template.interactionTemplates[j];
                for (var k = 0; k < currInteractionTemplate.actorCategories.length; k++) {
                  if (currInteractionTemplate.actorCategories[k].id == newResource.resource.categoryId && currInteractionTemplate.refersParent == true) {
                    resourceInteractionTemplates.push(currInteractionTemplate);
                    break;
                  }
                }
              }
              if (resourceInteractionTemplates.length == 1) {
                var newInteraction = {};
                newInteraction.interactionName = resourceInteractionTemplates[0].name;
                newInteraction.interactionTemplate = resourceInteractionTemplates[0];
                newInteraction.resource = newResource.resource;
                newInteraction.resourceIsParent = true;
                newInteraction.quantity = docket.orderRef.lineItems[i].quantity;
                newResource.interactions.push(newInteraction);
              }
            }
            docket.resources.push(newResource);
          }
        }
      }
    }
    if (cb) {
      cb();
    }
  };

  this.autoPopulateResources = autoPopulateResources;

  var updateDocketRefs = function updateDocketRefs(docket, successCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();

    if (docket.orderRef != null) {
      // update customer contacts
      if (docket.orderRef.customerContact != null) {
        docket.customerContact = angular.copy(docket.orderRef.customerContact);
      } else {
        delete docket.customerContact;
      }
      // update supplier contact
      if (docket.orderRef.supplierContact != null) {
        docket.supplierContact = angular.copy(docket.orderRef.supplierContact);
      } // else {
      //delete docket.supplierContact;
      //}
      // update docket template
      if (docket.orderRef.template != null && currentOrg != null) {
        // check if orderRef template is populated
        if (docket.orderRef.template.id != null) {
          docket.template = angular.copy(docket.orderRef.template);
          updateDocketStores(docket, successCb);
        } else {
          // get full template
          var templateId = docket.orderRef.template;
          this.getTemplate(templateId, function (templateFull) {
            docket.template = Restangular.stripRestangular(templateFull);
            updateDocketStores(docket, successCb);
          });
        }
      }
      if (docket.orderRef.supplierRefNo != null) {
        docket.supplierRefNo = docket.orderRef.supplierRefNo;
      }
      if (docket.orderRef.customerRefNo != null) {
        docket.customerRefNo = docket.orderRef.customerRefNo;
      }
    } else {
      if (currentOrgGroup != null && currentOrgGroup.defaultTemplate != null) {
        this.getTemplate(currentOrgGroup.defaultTemplate, function (templateFull) {
          docket.template = Restangular.stripRestangular(templateFull);
          updateDocketStores(docket, successCb);
        });
      }
    }
  };

  this.updateDocketRefs = updateDocketRefs;

  var updateDocketStores = function updateDocketStores(docket, successCb) {
    setupDocketValueStore(docket, function () {
      setupDocketChecklists(docket, function () {
        if (docket.orderRef != null) {
          var populateInteractions = false;
          if (docket.template != null && docket.template.populateResourcesFromJob) {
            populateInteractions = true;
          }
          autoPopulateResources(docket, populateInteractions, function () {
            if (successCb) {
              successCb(docket);
            }
          });
        } else {
          if (successCb) {
            successCb(docket);
          }
        }
      });
    });
  };

  this.updateDocketStores = updateDocketStores;

  var validateChecklists = function validateChecklists(docket) {
    var checklistsWithErrors = [];
    if (docket.template && docket.template.checklistContainers) {
      for (var i = 0; i < docket.template.checklistContainers.length; i++) {
        // check if there are checklist values for this checklist template
        var checklistTemplate = docket.template.checklistContainers[i].checklistTemplate;
        var checklistIncomplete = false;
        if (docket.checklists[checklistTemplate.id] != null) {
          // a checklist object exists for this checklist template - check if each question has an answer
          var checklistObject = docket.checklists[checklistTemplate.id];
          for (var j = 0; j < checklistTemplate.fields.length; j++) {
            // check if field has an answer in checklistObject
            if (checklistObject.answers[checklistTemplate.fields[j].id] == null || checklistObject.answers[checklistTemplate.fields[j].id] == "") {
              checklistIncomplete = true;
            }
          }
        } else {
          checklistIncomplete = true;
        }

        if (checklistIncomplete && docket.checklists[checklistTemplate.id]) {
          docket.checklists[checklistTemplate.id].complete = false;
          if (docket.template.checklistContainers[i].rule == "required") {
            checklistsWithErrors.push(checklistTemplate.id);
          }
        } else if (checklistIncomplete && !docket.checklists[checklistTemplate.id]) {
          if (docket.template.checklistContainers[i].rule == "required") {
            checklistsWithErrors.push(checklistTemplate.id);
          }
        } else {
          docket.checklists[checklistTemplate.id].complete = true;
        }
      }
    }

    return checklistsWithErrors;
  };

  this.validateChecklists = validateChecklists;

  var validateDocket = function validateDocket(docket, successCb, failureCb) {
    var checklistsWithErrors = validateChecklists(docket);
    var errors = [];
    if (checklistsWithErrors.length > 0) {
      var errorNew = { name: 'checklists', detail: 'Some checklists that are required have not been completed fully.' };
      errors.push(errorNew);
    }

    // Validate custom block fields
    for (var i = 0; i < docket.template.blocks.length; i++) {
      var block = docket.template.blocks[i];
      // validate custom blocks
      if (block.type == 'custom') {
        // check if any fields are mandatory and have values
        var blockHasErrors = false;
        for (var j = 0; j < block.fields.length; j++) {
          var field = block.fields[j];
          var fieldValue = docket.templateValueStore[block.id + '-' + field.id];
          if (field.mandatory && (fieldValue === null || fieldValue === '')) {
            blockHasErrors = true;
          }
        }
        if (blockHasErrors) {
          var newError = { name: 'customFields', detail: 'Some mandatory fields have not been completed.' };
          errors.push(newError);
        }
      }

      // validate time block
      /*if ( block.type == 'time' ) {
        // docket has time block, new check if time values have been entered
        if ( docket.startTime == null || docket.startTime == "" || docket.endTime == null || docket.endTime == "" ) {
          var errorNew = {name:'times', detail:'Start and end time are required before submission.'};
          errors.push(errorNew);
        }
      }*/

      // validate signature block
      if (block.type == 'signatures') {
        if (docket.template.signature) {
          // check customer signature
          if ((docket.customerSignature == null || docket.customerSignature == "") && (docket.customerSignatureImage == null || docket.customerSignatureImage == "")) {
            var errorNew = { name: 'customerSignature', detail: 'Customer signature is required before submission.' };
            errors.push(errorNew);
          }
          if ((docket.supplierSignature == null || docket.supplierSignature == "") && (docket.supplierSignatureImage == null || docket.supplierSignatureImage == "")) {
            var errorNew = { name: 'operatorSignature', detail: 'Operator signature is required before submission.' };
            errors.push(errorNew);
          }
        }
      }

      // validate items block
      if (block.type == 'resources') {
        // TODO: validate if minimumInteractionRequired

        if (docket.template.minimumInteractionRequired == true) {
          var interactionsCount = 0;
          for (var j = 0; j < docket.resources.length; j++) {
            for (var k = 0; k < docket.resources[j].interactions.length; k++) {
              interactionsCount += 1;
            }
          }
          if (interactionsCount <= 0) {
            var errorNew = { name: 'minimumInteractionRequired', detail: 'At least one interaction is required before submission.' };
            errors.push(errorNew);
          }
        }
      }
    }

    // VALIDATE CUSTOMER
    if (docket.customer == null && docket.customerContact == null) {
      var errorNew = { name: 'customer', detail: 'A customer must be added before sending the docket' };
      errors.push(errorNew);
    }

    if (errors.length > 0) {
      failureCb(errors);
    } else {
      successCb();
    }
  };

  this.validateDocket = validateDocket;

  // Get diff between original and changed docket
  var getDiffedDocket = function getDiffedDocket(original, modified, method, cb) {
    if (!original || !modified) {
      cb(null);
    }
    var basicFields = [];
    basicFields.push({ name: 'date', type: 'date' });
    basicFields.push({ name: 'startTime', type: 'time' });
    basicFields.push({ name: 'endTime', type: 'time' });
    basicFields.push({ name: 'breakTime', type: 'int' });
    basicFields.push({ name: 'travelTime', type: 'int' });
    basicFields.push({ name: 'customerSignatureData', type: 'string' });
    basicFields.push({ name: 'customerSignatureName', type: 'string' });
    basicFields.push({ name: 'supplierSignatureData', type: 'string' });
    basicFields.push({ name: 'supplierRefNo', type: 'string' });
    basicFields.push({ name: 'customerRefNo', type: 'string' });
    var complexObjects = ['template', 'customerContact']; //, 'additionalContacts'];
    var diffedDocket = {};
    diffedDocket.id = original.id;
    diffedDocket.organisation = original.organisation;
    diffedDocket.organisationGroup = original.organisationGroup;
    var diffCount = 0;
    // Check if any listed fields have changed
    /*
    if (modified['additionalContacts'] !== original['additionalContacts']) {
      diffedDocket['additionalContacts'] = modified['additionalContacts'];
      diffCount += 1;
    }*/
    for (var i = 0; i < basicFields.length; i++) {
      var fieldName = basicFields[i].name;
      var fieldType = basicFields[i].type;
      if (original[fieldName] == null && modified[fieldName] != null) {
        diffedDocket[fieldName] = modified[fieldName];
        diffCount += 1;
      } else if (original[fieldName] != null && modified[fieldName] == null) {
        diffedDocket[fieldName] = null;
        diffCount += 1;
      } else if (original[fieldName] == null && modified[fieldName] == null) {
        // field is the same - no changes
      } else {
        if (fieldType == 'date') {
          var diff = false;
          try {
            if ((original[fieldName] ? original[fieldName].getTime() : null) !== (modified[fieldName] ? modified[fieldName].getTime() : null)) {
              diff = true;
            }
          } catch (err) {
            diff = original[fieldName] !== modified[fieldName];
          }
          if (diff) {
            diffedDocket[fieldName] = modified[fieldName];
            diffCount += 1;
          }
        } else if (fieldType == 'time') {
          var _diff = false;
          try {
            if ((original[fieldName] ? original[fieldName].toDate().getTime() : null) !== (modified[fieldName] ? modified[fieldName].toDate().getTime() : null)) {
              _diff = true;
            }
          } catch (err) {
            _diff = original[fieldName] !== modified[fieldName];
          }
          if (_diff) {
            diffedDocket[fieldName] = modified[fieldName];
            diffCount += 1;
          }
        } else {
          if (original[fieldName] !== modified[fieldName]) {
            diffedDocket[fieldName] = modified[fieldName];
            diffCount += 1;
          }
        }
      }
    }

    // Check if any listed objects have changed
    for (var i = 0; i < complexObjects.length; i++) {
      var objectCheck = complexObjects[i];
      if (original[objectCheck] == null && modified[objectCheck] != null) {
        diffedDocket[objectCheck] = modified[objectCheck];
        diffCount += 1;
      } else if (original[objectCheck] != null && modified[objectCheck] == null) {
        diffedDocket[objectCheck] = null;
        diffCount += 1;
      } else if (original[objectCheck] == null && modified[objectCheck] == null) {
        // object is the same - no changes
      } else if (original[objectCheck].id != modified[objectCheck].id) {
        diffedDocket[objectCheck] = modified[objectCheck];
        diffCount += 1;
      }
    }
    // Check if orderRef has changed
    var orderRefChanged = false;
    if (original.orderRef == null && modified.orderRef != null) {
      orderRefChanged = true;
    } else if (original.orderRef != null && modified.orderRef == null) {
      orderRefChanged = true;
    } else if (original.orderRef == null && modified.orderRef == null) {
      // no change - leave
    } else if (original.orderRef.id != modified.orderRef.id) {
      orderRefChanged = true;
    }

    if (orderRefChanged) {
      diffCount += 1;
      diffedDocket.orderRef = modified.orderRef;
      diffedDocket.customerContact = modified.customerContact;
      diffedDocket.supplierContact = modified.supplierContact;
    }

    // check additional contacts
    if (original.additionalContacts.length != modified.additionalContacts.length) {
      diffedDocket['additionalContacts'] = modified['additionalContacts'];
      diffCount += 1;
    }

    if (original.resources == null) {
      original.resources = [];
    }
    if (modified.resources == null) {
      modified.resources = [];
    }

    // Check Resources
    if (true) {
      //method && method == 'resources'
      if (original.resources.length != modified.resources.length) {
        // there is definitely a change - send entire resources array to update
        diffedDocket.resources = modified.resources;
        diffCount += 1;
      } else {
        // check each element in resources array to check if there are any changes
        //var changesDetected = false;
        var resourcesModified = [];
        for (var i = 0; i < original.resources.length; i++) {
          var originalResource = original.resources[i];
          var modifiedResource = modified.resources[i];

          if (originalResource.resource.id != modifiedResource.resource.id) {
            // resource is different - updates!
            //changesDetected = true;
            resourcesModified.push(modifiedResource);
            break;
          } else if (modifiedResource.delete == true) {
            //changesDetected = true;
            resourcesModified.push(modifiedResource);
          } else if (modifiedResource.interactions.length != originalResource.interactions.length) {
            resourcesModified.push(modifiedResource);
          } else if (modifiedResource.orderItemId != originalResource.orderItemId) {
            resourcesModified.push(modifiedResource);
          } else {
            var interactionsModified = [];
            for (var j = 0; j < modifiedResource.interactions.length; j++) {
              var originalInteraction = originalResource.interactions[j];
              var modifiedInteraction = modifiedResource.interactions[j];
              if (modifiedInteraction.id == null || modifiedInteraction.id != originalInteraction.id) {
                interactionsModified.push(modifiedInteraction);
                break;
              } else if (modifiedInteraction.delete && modifiedInteraction.delete == true) {
                //changesDetected = true;
                interactionsModified.push(modifiedInteraction);
                break;
              } else if (originalInteraction.quantity != modifiedInteraction.quantity) {
                // quantities have changed on the interaction - do updates
                //changesDetected = true;
                interactionsModified.push(modifiedInteraction);
                break;
              } else if (originalInteraction.interactionTemplate.id != modifiedInteraction.interactionTemplate.id) {
                // interaction templates have changed - do updates
                //changesDetected = true;
                interactionsModified.push(modifiedInteraction);
                break;
              } else if (originalInteraction.interactionTemplate.refersParent == false && originalInteraction.resource.id != modifiedInteraction.resource.id) {
                // interaction resource has changed (complex interaction only)
                // do updates
                //changesDetected = true;
                interactionsModified.push(modifiedInteraction);
                break;
              } else {
                // check custom field changes
                var originalCustomFields = [];
                var modifiedCustomFields = [];
                if (originalInteraction.customFields) {
                  originalCustomFields = Object.keys(originalInteraction.customFields);
                }
                if (modifiedInteraction.customFields) {
                  modifiedCustomFields = Object.keys(modifiedInteraction.customFields);
                }
                if (originalCustomFields.length != modifiedCustomFields.length) {
                  // custom fields have definitely changed - do update
                  //changesDetected = true;
                  interactionsModified.push(modifiedInteraction);
                  break;
                } else {
                  // check if any values have changed inside each field
                  var customFieldChanges = false;
                  for (var k = 0; k < originalCustomFields.length; k++) {
                    var key = originalCustomFields[k];

                    var fielsAreMoments = (0, _moment.isMoment)(originalInteraction.customFields[key]);
                    if (fielsAreMoments && !originalInteraction.customFields[key].isSame(modifiedInteraction.customFields[key]) || !fielsAreMoments && originalInteraction.customFields[key] != modifiedInteraction.customFields[key]) {
                      customFieldChanges = true;
                      //changesDetected = true;
                      break;
                    }
                  }

                  if (customFieldChanges) {
                    //changesDetected = true;
                    interactionsModified.push(modifiedInteraction);
                    break;
                  }
                }
              }
            }

            if (interactionsModified.length > 0) {
              resourcesModified.push(modifiedResource);
            }
          }
        }

        if (resourcesModified.length > 0) {
          diffedDocket.resources = resourcesModified;
          diffCount += 1;
        }
      }
    }

    if (original.template && modified.template) {
      // check templateValueStore for custom blocks fields
      var originalValueStoreKeys = Object.keys(original.templateValueStore);
      var modifiedValueStoreKeys = Object.keys(modified.templateValueStore);
      if (originalValueStoreKeys.length != modifiedValueStoreKeys.length) {
        // changes definitely made - do update
        diffedDocket.templateValueStore = modified.templateValueStore;
        diffedDocket.template = modified.template;
        diffCount += 1;
      } else {
        // check value of each template value store item
        var templateChanges = false;
        for (var i = 0; i < original.template.blocks.length; i++) {
          if (original.template.blocks[i].type == 'custom') {
            // custom block - check if templateValueStore values have changed
            var thisBlock = original.template.blocks[i];
            var blockChanges = false;
            for (var j = 0; j < thisBlock.fields.length; j++) {
              var thisField = thisBlock.fields[j];
              var originalValue = original.templateValueStore[thisBlock.id + '-' + thisField.id];
              var modifiedValue = modified.templateValueStore[thisBlock.id + '-' + thisField.id];
              if (thisField.type == 'date' || thisField.type == 'datetime' || thisField.type == 'time') {
                // date time field - compare using date compare
                if (originalValue == "" && modifiedValue != "") {
                  // value was added - changes
                  blockChanges = true;
                  break;
                } else if (originalValue != "" && modifiedValue == "") {
                  // value was removed - changes
                  blockChanges = true;
                  break;
                } else if (originalValue == "" && modifiedValue == "") {
                  // no changes - do nothing
                } else if (thisField.type == 'date') {
                  var _original = originalValue;
                  if (_original) {
                    _original = originalValue.getTime();
                  }
                  var _modified = modifiedValue;
                  if (_modified) {
                    _modified = _modified.getTime();
                  }
                  if (_original !== _modified) {
                    blockChanges = true;
                    break;
                  }
                } else if (thisField.type == 'time') {
                  var _original2 = originalValue;
                  try {
                    if (_original2) {
                      _original2 = _original2.toDate();
                      if (_original2) {
                        _original2 = _original2.getTime();
                      }
                    }
                  } catch (err) {
                    _original2 = originalValue;
                  }
                  var _modified2 = modifiedValue;
                  try {
                    if (_modified2) {
                      _modified2 = _modified2.toDate();
                      if (_modified2) {
                        _modified2 = _modified2.getTime();
                      }
                    }
                  } catch (err) {
                    _modified2 = modifiedValue;
                  }
                  if (_original2 !== _modified2) {
                    blockChanges = true;
                    break;
                  }
                }
              } else if (thisField.type == 'text' || thisField.type == 'boolean' || thisField.type == 'number' || thisField.type == 'select' || thisField.type == 'multiline') {
                // text field - compare strings
                if (originalValue !== modifiedValue) {
                  // a value has changed - do update
                  blockChanges = true;
                  break;
                }
              }
            }

            if (blockChanges) {
              templateChanges = true;
              break;
            }
          }
        }

        if (templateChanges) {
          diffCount += 1;
          diffedDocket.templateValueStore = modified.templateValueStore;
          diffedDocket.template = modified.template;
        }
      }
    }

    if (modified.signatureFields) {
      var keys = Object.keys(modified.signatureFields);
      if (keys.length > 0) {
        diffCount += 1;
        diffedDocket.signatureFields = modified.signatureFields;
      }
    }

    var checklistChanges = false;
    if (original.checklists == null && modified.checklists != null) {
      // checklists have been added - do update
      checklistChanges = true;
    } else if (original.checklists != null && modified.checklists == null) {
      // checklists have been removed - do update
      checklistChanges = true;
    } else {
      var originalChecklistKeys = Object.keys(original.checklists);
      var modifiedChecklistKeys = Object.keys(modified.checklists);

      if (originalChecklistKeys.length != modifiedChecklistKeys.length) {
        // checklists have definitely changed - do update
        checklistChanges = true;
      } else {
        for (var i = 0; i < originalChecklistKeys.length; i++) {
          var currentKey = originalChecklistKeys[i];
          var originalChecklist = original.checklists[currentKey];
          var modifiedChecklist = modified.checklists[currentKey];

          // check if checklistTemplates are the same
          if (originalChecklist.checklistTemplateId != modifiedChecklist.checklistTemplateId) {
            checklistChanges = true;
            break;
          }
          // check if answers have changed
          var originalAnswerKeys = Object.keys(originalChecklist.answers);
          var modifiedAnswerKeys = Object.keys(modifiedChecklist.answers);

          if (originalAnswerKeys.length != modifiedAnswerKeys.length) {
            // answers have definitely changed - do updates
            checklistChanges = true;
            break;
          }

          for (var j = 0; j < originalAnswerKeys.length; j++) {
            var currentAnswerKey = originalAnswerKeys[j];
            if (originalChecklist.answers[currentAnswerKey] != modifiedChecklist.answers[currentAnswerKey]) {
              checklistChanges = true;
              break;
            }
          }

          if (checklistChanges) {
            break;
          }
        }
      }
    }

    if (checklistChanges) {
      diffCount += 1;
      diffedDocket.checklists = modified.checklists;
    }

    cb(diffedDocket, diffCount);
  };

  this.getDiffedDocket = getDiffedDocket;

  /**** Parse Dockets *****/
  var parseDockets = function parseDockets(data) {
    var dockets = [];
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    if (data) {
      data.forEach(function (docket) {
        docket.status = docket.status.charAt(0).toUpperCase() + docket.status.slice(1);
        docket.loading = false;

        docket.assigned = false;
        if (organisation == null || organisationGroup == null) {
          var orgEmails = userService.getOrgEmailAddresses();
          for (var key in docket.accessControl) {
            if (orgEmails.indexOf(key) != -1) {
              docket.assigned = true;
              break;
            }
          }
        }

        dockets.push(docket);
      });
    }

    return dockets;
  };

  this.parseDockets = parseDockets;

  /****** Parse Dockets For Filing ******/
  var parseDocketsForFiling = function parseDocketsForFiling(data, fileStatus) {
    var dockets = [];
    if (data) {
      data.forEach(function (docket) {
        docket.loading = false;
        if (fileStatus == 'all') {
          dockets.push(docket);
        } else if (fileStatus == 'unfiled' && docket.existingDocketFile == null) {
          dockets.push(docket);
        } else if (fileStatus == 'filed' && docket.existingDocketFile != null) {
          dockets.push(docket);
        }
      });
    }

    return dockets;
  };

  this.parseDocketsForFiling = parseDocketsForFiling;

  /******************************/
  /****** Docket Templates ******/
  /******************************/

  /******* Get all docket templates for org group ********/
  this.getTemplates = function (query, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

    if (query == null) {
      query = {};
    }

    baseTemplates.getList(query).then(successCb, failureCb);
  };

  /******** Get a single template *******/
  this.getTemplate = function (template, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

    var templateId = template;
    if (template.id != null) {
      templateId = template.id;
    }

    baseTemplates.one(templateId).get().then(successCb, failureCb);
  };

  /******* Save Template *******/
  this.saveTemplate = function (template, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

    var basicFields = ['active', 'id', 'name', 'populateResourcesFromJob', 'published', 'signature', 'checklistContainers', 'interactionTemplates', 'attachments', 'hiddenBlockNames', 'sumOnlyBillableInteractions', 'orderPrefillFields', 'pdfBuilder', 'minimumInteractionRequired'];
    var templateToSave = {};

    for (var i = 0; i < basicFields.length; i++) {
      if (template[basicFields[i]] != null) {
        templateToSave[basicFields[i]] = template[basicFields[i]];
      }
    }

    // blocks
    var blockFields = ['id', 'location', 'name', 'type'];
    if (template.blocks) {
      templateToSave.blocks = [];
      for (var i = 0; i < template.blocks.length; i++) {
        var newBlock = {};
        for (var j = 0; j < blockFields.length; j++) {
          if (template.blocks[i][blockFields[j]] != null) {
            newBlock[blockFields[j]] = template.blocks[i][blockFields[j]];
          }
        }
        if (template.blocks[i].fields) {
          newBlock.fields = [];
          for (var j = 0; j < template.blocks[i].fields.length; j++) {
            if (template.blocks[i].fields[j].id != null) {
              newBlock.fields.push(template.blocks[i].fields[j].id);
            }
          }
        }
        templateToSave.blocks.push(newBlock);
      }
    }

    // collapse checklist containers
    if (template.checklistContainers) {
      templateToSave.checklistContainers = [];
      for (var i = 0; i < template.checklistContainers.length; i++) {
        var checklistContainer = {};
        checklistContainer.location = i + 1;
        checklistContainer.rule = template.checklistContainers[i].rule;
        checklistContainer.id = template.checklistContainers[i].id;
        checklistContainer.checklistTemplate = template.checklistContainers[i].checklistTemplate.id;
        templateToSave.checklistContainers.push(checklistContainer);
      }
    }

    // collapse interaction template categories lists
    if (template.interactionTemplates) {
      for (var i = 0; i < template.interactionTemplates.length; i++) {
        if (template.interactionTemplates[i].actorCategories == null) {
          template.interactionTemplates[i].actorCategories = [];
        }
        for (var j = 0; j < template.interactionTemplates[i].actorCategories.length; j++) {
          if (template.interactionTemplates[i].actorCategories[j].id != null) {
            template.interactionTemplates[i].actorCategories[j] = template.interactionTemplates[i].actorCategories[j].id;
          }
        }
        for (var j = 0; j < template.interactionTemplates[i].categories.length; j++) {
          if (template.interactionTemplates[i].categories[j].id != null) {
            template.interactionTemplates[i].categories[j] = template.interactionTemplates[i].categories[j].id;
          }
        }
      }
      templateToSave.interactionTemplates = template.interactionTemplates;
    }

    // TODO: collapse attachments?
    if (template.id == null) {
      templateToSave.organisation = organisation.id;
      baseTemplates.post(templateToSave).then(successCb, failureCb);
    } else {
      baseTemplates.one(template.id).customPUT(templateToSave).then(successCb, failureCb);
    }
  };

  /****** Delete a template *******/
  var deleteTemplate = function deleteTemplate(templateId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');

    if (templateId.id != null) {
      templateId = templateId.id;
    }

    baseTemplates.one(templateId).remove().then(successCb, failureCb);
  };

  this.deleteTemplate = deleteTemplate;

  /******** Delete Bulk Templates ********/
  this.deleteBulkTemplates = function (templates, successCb) {
    var failures = [];
    deleteTemplates(templates, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteTemplates = function deleteTemplates(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteTemplate(list[index].id, function (success) {
      deleteTemplates(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteTemplates(list, index + 1, failures, successCb);
    });
  };

  /******** Delete Docket Template Attachment *******/
  this.deleteTemplateAttachment = function (templateId, attachmentId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('templates');
    if (templateId.id != null) {
      templateId = templateId.id;
    }
    if (attachmentId.id != null) {
      attachmentId = attachmentId.id;
    }

    baseTemplates.one(templateId).all('attachment').one(attachmentId).remove().then(successCb, failureCb);
  };

  /******** Get all fields ***********/
  this.getFields = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseFields = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('fields');
    if (params == null) {
      params = {};
    }
    baseFields.getList(params).then(successCb, failureCb);
  };

  /********* Save a field *********/
  this.saveField = function (field, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseFields = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('fields');

    // patch for fixing bug where multiple of the same option are listed in a select field type
    if (field.type == 'select') {
      var selectionFieldsCleaned = [];
      for (var l = 0; l < field.selectionFields.length; l++) {
        if (selectionFieldsCleaned.indexOf(field.selectionFields[l]) == -1) {
          selectionFieldsCleaned.push(field.selectionFields[l]);
        }
      }
      field.selectionFields = selectionFieldsCleaned;
    }

    if (field.id == null) {
      field.organisation = organisation.id;
      baseFields.post(field).then(successCb, failureCb);
    } else {
      baseFields.one(field.id).customPUT(field).then(successCb, failureCb);
    }
  };

  /********* Delete a field *********/
  var deleteField = function deleteField(fieldId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseFields = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('fields');

    if (fieldId.id != null) {
      fieldId = fieldId.id;
    }

    baseFields.one(fieldId).remove().then(successCb, failureCb);
  };

  this.deleteField = deleteField;

  /********** Delete Bulk Fields **********/
  this.deleteBulkFields = function (fields, successCb) {
    var failures = [];
    deleteFields(fields, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteFields = function deleteFields(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteField(list[index].id, function (success) {
      deleteFields(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteFields(list, index + 1, failures, successCb);
    });
  };

  /********** Get all checklist templates ***********/
  this.getChecklistTemplates = function (params, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseChecklistTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('checklisttemplates');
    if (params == null) {
      params = {};
    }
    baseChecklistTemplates.getList(params).then(successCb, failureCb);
  };

  /********** Save Checklist Template **********/
  this.saveChecklistTemplate = function (checklistTemplate, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseChecklistTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('checklisttemplates');

    if (checklistTemplate.id == null) {
      baseChecklistTemplates.post(checklistTemplate).then(successCb, failureCb);
    } else {
      baseChecklistTemplates.one(checklistTemplate.id).customPUT(checklistTemplate).then(successCb, failureCb);
    }
  };

  /********* Delete Checklist Template **********/
  var deleteChecklistTemplate = function deleteChecklistTemplate(templateId, successCb, failureCb) {
    var organisation = accessControl.currentOrg();
    var organisationGroup = accessControl.currentOrgGroup();
    var baseChecklistTemplates = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('checklisttemplates');

    if (templateId.id != null) {
      templateId = templateId.id;
    }

    baseChecklistTemplates.one(templateId).remove().then(successCb, failureCb);
  };

  this.deleteChecklistTemplate = deleteChecklistTemplate;

  /********** Delete Bulk Checklist Templates **********/
  this.deleteBulkChecklistTemplates = function (templates, successCb) {
    var failures = [];
    deleteChecklistTemplates(templates, 0, failures, function (failuresFilled) {
      successCb(failuresFilled);
    });
  };

  var deleteChecklistTemplates = function deleteChecklistTemplates(list, index, failures, successCb) {
    if (index >= list.length) {
      successCb(failures);
      return;
    }

    deleteChecklistTemplate(list[index].id, function (success) {
      deleteChecklistTemplates(list, index + 1, failures, successCb);
    }, function (err) {
      failures.push(list[index]);
      deleteChecklistTemplates(list, index + 1, failures, successCb);
    });
  };
}]);

/***/ }),

/***/ "sXBn":
/***/ (function(module, exports) {

var path = 'views/modals/mobileInteractionModal.html';
var html = "<div class=\"niceModal\" id=\"addInteractionModal\">\n  <div my-loader text=\"Saving Line\" ng-if=\"addInteraction.loading\"></div>\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1 ng-show=\"addInteraction.mode == 'selectTemplate'\">Select Line Type</h1>\n      <h1 ng-show=\"addInteraction.mode == 'detail' && addInteraction.edit != true && !addInteraction.readOnly\">Add Line</h1>\n      <h1 ng-show=\"addInteraction.mode == 'detail' && addInteraction.edit == true && !addInteraction.readOnly\">Edit Line</h1>\n      <h1 ng-show=\"addInteraction.mode == 'detail' && addInteraction.readOnly\">View Line</h1>\n      <div class=\"closeButton\" ng-click=\"closeAddInteraction()\"></div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton {{addInteraction.edit == true ? '' : 'closeButton'}}\" ng-click=\"closeAddInteraction()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n            <span ng-show=\"addInteraction.mode == 'selectTemplate'\">Select Line Type</span>\n            <span ng-show=\"addInteraction.mode == 'detail' && addInteraction.edit != true && !addInteraction.readOnly\">Add Line</span>\n            <span ng-show=\"addInteraction.mode == 'detail' && addInteraction.edit == true && !addInteraction.readOnly\">Edit Line</span>\n            <span ng-show=\"addInteraction.mode == 'detail' && addInteraction.readOnly\">View Line</span>\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton {{interactionForm.$invalid ? 'disabled' : ''}}\" ng-click=\"interactionForm.$invalid || saveInteraction(addInteraction.interaction)\" ng-if=\"addInteraction.mode != 'selectTemplate' && !addInteraction.readOnly\">Save</div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"content noPadding\">\n      <div class=\"col-sm-12 no-padding\" ng-show=\"addInteraction.mode == 'selectTemplate'\">\n        <div class=\"col-sm-12\" ng-show=\"availableInteractions == null || availableInteractions.length == 0\">\n          There are no available line types.\n        </div>\n        <div class=\"customListRowOuter\" ng-repeat=\"interactionTemplate in availableInteractions\" ng-click=\"selectInteractionTemplate(interactionTemplate)\">\n          <div class=\"customListRow\">\n            <div class=\"listRowItem status\"></div>\n            <div class=\"listRowItem itemNumber\">{{interactionTemplate.name}}</div>\n            <div class=\"listRowItem collapsedDetail showCollapsed\">\n\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-12 no-padding\" ng-show=\"addInteraction.mode == 'detail'\">\n        <div class=\"itemDetailModalOuter\">\n          <div class=\"itemDetailModalHeader\">\n            <span ng-show=\"addInteraction.interaction.resourceIsParent\">\n              <h1>{{addInteraction.interaction.resource.name}}</h1>\n              <h3>{{addInteraction.interaction.interactionName}}</h3>\n            </span>\n            <!-- Complex Interaction -->\n            <span ng-show=\"!addInteraction.interaction.resourceIsParent\">\n              <h1 ng-show=\"addInteraction.interaction.resource\">{{addInteraction.interaction.resource.name}}</h1>\n              <h1 ng-show=\"!addInteraction.interaction.resource\">Select a Resource</h1>\n              <h3>{{addInteraction.interaction.interactionName}}</h3>\n              <div class=\"btn btn-sm btn-rounded btn-outline white\" ng-show=\"!addInteraction.interaction.resource && !addInteraction.readOnly\" ng-click=\"selectResourceForInteraction(addInteraction)\">Select</div>\n            </span>\n          </div>\n          <div class=\"itemDetailModalPart normal\" ng-show=\"!addInteraction.interaction.resourceIsParent && !addInteraction.interaction.resource\">\n            Please select a resource to continue\n          </div>\n          <div class=\"itemDetailModalPart quantity\" ng-show=\"addInteraction.interaction.resourceIsParent || ( addInteraction.interaction.resource )\">\n            <div class=\"detailPartContent\">\n              <md-input-container class=\"md-block\">\n                <input type=\"number\" ng-model=\"addInteraction.interaction.quantityEdit\" id=\"quantityKeypadField\" aria-label=\"Quantity Value\" ng-disabled=\"addInteraction.readOnly\">\n              </md-input-container>\n              <!--<h1>{{addInteraction.interaction.quantityEdit}}</h1>-->\n              <h2>{{addInteraction.interaction.resource.uom.description}}</h2>\n            </div>\n            <!--<div class=\"detailPartIcon\" ng-click=\"editInteractionQuantity(addInteraction)\" ng-show=\"!addInteraction.readOnly\">\n              <md-icon md-svg-src=\"edit.svg\"></md-icon>\n            </div>-->\n          </div>\n          <div ng-show=\"(addInteraction.interaction.resourceIsParent || ( addInteraction.interaction.resource )) && addInteraction.interactionTemplate.fields.length > 0\">\n            <form name=\"interactionForm\">\n              <div class=\"itemDetailModalPart normal\" ng-repeat=\"field in addInteraction.interactionTemplate.fields\">\n                <span ng-if=\"addInteraction.readOnly\">\n                  <h3>{{field.displayName}}</h3>\n                  <p ng-show=\"field.type != 'date'\">{{addInteraction.interaction.customFields[field.id]}}</p>\n                  <p ng-show=\"field.type == 'date'\">{{moment(addInteraction.interaction.customFields[field.id],'YYYY-MM-DD').format('DD/MM/YYYY')}}</p>\n                </span>\n                <span ng-if=\"!addInteraction.readOnly\">\n                  <md-input-container class=\"md-block\" ng-if=\"field.type=='text'\">\n                    <label>{{field.displayName}}</label>\n                    <input required name=\"{{field.id}}\" ng-model=\"addInteraction.interaction.customFields[field.id]\" ng-if=\"field.mandatory\">\n                    <input name=\"{{field.id}}\" ng-model=\"addInteraction.interaction.customFields[field.id]\" ng-if=\"!field.mandatory\">\n                    <div ng-messages=\"interactionForm.{{field.id}}.$error\">\n                      <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This is required.</div>\n                    </div>\n                  </md-input-container>\n                  <span ng-if=\"field.type=='date' && field.mandatory\">\n                    <h3>{{field.displayName}} (Mandatory)</h3>\n                    <mdp-date-picker mdp-open-on-click mdp-placeholder=\"Enter Date\" ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-format=\"DD/MM/YYYY\" name=\"{{field.id}}\" required>\n                      <div ng-messages=\"interactionForm.{{field.id}}.$error\">\n                        <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This date is required</div>\n                      </div>\n                    </mdp-date-picker>\n                  </span>\n                  <span ng-if=\"field.type=='date' && !field.mandatory\">\n                    <h3>{{field.displayName}}</h3>\n                    <mdp-date-picker mdp-open-on-click mdp-placeholder=\"Enter Date\" ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-format=\"DD/MM/YYYY\" name=\"{{field.id}}\"></mdp-date-picker>\n                  </span>\n                  <span ng-if=\"field.type=='time' && field.mandatory\">\n                    <h3>{{field.displayName}} (Mandatory)</h3>\n                    <mdp-time-picker mdp-open-on-click mdp-placeholder=\"Enter Time\" ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-timezone=\"{{docketEditing.timezone}}\" mdp-auto-switch=\"true\" name=\"{{field.id}}\" required>\n                      <div ng-messages=\"interactionForm.{{field.id}}.$error\">\n                        <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">This time is required</div>\n                      </div>\n                    </mdp-time-picker>\n                  </span>\n                  <span ng-if=\"field.type=='time' && !field.mandatory\">\n                    <h3>{{field.displayName}}</h3>\n                    <mdp-time-picker mdp-open-on-click mdp-placeholder=\"Enter Time\" ng-model=\"addInteraction.interaction.customFields[field.id]\" mdp-timezone=\"{{docketEditing.timezone}}\" mdp-auto-switch=\"true\" name=\"{{field.id}}\"></mdp-time-picker>\n                  </span>\n                  <span ng-if=\"field.type=='number' && field.mandatory\">\n                    <md-input-container class=\"md-block\">\n                      <label>{{field.displayName}}</label>\n                      <input required type=\"number\" step=\"any\" name=\"{{field.id}}\" ng-model=\"addInteraction.interaction.customFields[field.id]\" />\n\n                      <div ng-messages=\"interactionForm.{{field.id}}.$error\" multiple md-auto-hide=\"false\">\n                        <div ng-message=\"required\" ng-show=\"addInteraction.interaction.customFields[field.id] == null || addInteraction.interaction.customFields[field.id] == ''\">\n                          This is required\n                        </div>\n                      </div>\n                    </md-input-container>\n                  </span>\n                  <span ng-if=\"field.type=='number' && !field.mandatory\">\n                    <md-input-container class=\"md-block\">\n                      <label>{{field.displayName}}</label>\n                      <input type=\"number\" step=\"any\" name=\"{{field.id}}\" ng-model=\"addInteraction.interaction.customFields[field.id]\" />\n                    </md-input-container>\n                  </span>\n                  <span ng-if=\"field.type=='boolean'\">\n                    <md-checkbox ng-model=\"addInteraction.interaction.customFields[field.id]\" aria-label=\"{{field.displayName}}\">\n                      {{field.displayName}}\n                    </md-checkbox>\n                  </span>\n                </span>\n              </div>\n            </form>\n          </div>\n          <div class=\"itemDetailModalPart locationMap\" ng-if=\"addInteraction.interaction.createdAt\">\n            <h3>Created {{moment(addInteraction.interaction.createdAt).tz(docketEditing.timezone).format('DD/MM/YYYY hh:mm a')}}</h3>\n            <div id=\"interactionMap\" ng-if=\"addInteraction.interaction.lat && addInteraction.interaction.long\"></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "sZY0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "category.svg";

/***/ }),

/***/ "sckJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "archive.svg";

/***/ }),

/***/ "sjjA":
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),

/***/ "snsZ":
/***/ (function(module, exports) {

var path = 'views/modals/selectJobModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectJobModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Job</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeJobSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"searchBar\">\n        <div class=\"title\">\n          <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"bar\">\n          <input name=\"selectJobInput\" type=\"text\" ng-model=\"jobSearch\" placeholder=\"Search\" ng-change=\"searchJobChange(jobSearch)\" ng-model-options='{debounce:1000}'>\n        </div>\n      </div>\n      <div class=\"noListMessage\" ng-show=\"jobSearchList.length <= 0\">\n        There are no jobs matching your search criteria.\n      </div>\n      <md-table-container ng-show=\"jobSearchList.length > 0\">\n        <table md-table md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head md-order=\"query.order\" md-on-reorder=\"loadJobList\">\n            <tr md-row>\n              <th md-column md-order-by=\"status\">Status</th>\n              <th md-column md-order-by=\"jobNumber\">Job Number</th>\n              <th md-column md-order-by=\"customer\">Customer</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"job in jobSearchList\" md-select=\"job\" md-auto-select md-select-id=\"id\" ng-disabled=\"job.existing\" class=\"{{job.existing ? 'disabled':''}}\">\n              <td md-cell>\n                <div class=\"statusDisplay {{job.status}}\">{{job.status}}</div>\n              </td>\n              <td md-cell>\n                {{job.jobNumber}}\n              </td>\n              <td md-cell>\n                {{job.customerContact.displayName}}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n      <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadJobList\" md-total=\"{{listCount}}\" md-page-select>\n\n      </md-table-pagination>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeJobSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || desktopSelectJobContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "so9V":
/***/ (function(module, exports) {

var path = 'views/modals/viewMessageModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector noFooter\" id=\"viewMessageModal\">\n  <div class=\"modalUnderlay\" ng-click=\"closeViewMessageModal()\"></div>\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Message</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeViewMessageModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"viewMessageOuter\">\n        <div class=\"heading\">\n          <h2>{{message.title}}</h2>\n          <div class=\"dateTime\" ng-if=\"message.dateTime\">{{message.dateTime}}</div>\n        </div>\n        <div class=\"message\">\n          <div ng-bind-html=\"message.body\"></div>\n          <div ng-if=\"message.type == 'contactShare'\" class=\"contactCard\">\n            <div class=\"contactItemHeader\">\n              <div class=\"left\">\n                <div class=\"avatar dark\">\n                  {{message.contactShare.initials}}\n                </div>\n                <div class=\"contactName\">\n                  {{message.contactShare.displayName}}\n                </div>\n              </div>\n              <div class=\"right\">\n                <strong>Sender Details</strong>\n                <br/>\n                {{message.contactShare.senderOrganisationName}}\n                <br/>\n                {{message.contactShare.senderName}} ({{message.contactShare.senderEmail}})\n              </div>\n            </div>\n            <div class=\"contactDetail\">\n              <h2 ng-if=\"message.contactShare.addresses.length > 0\">Addresses</h2>\n              <p ng-repeat=\"address in message.contactShare.addresses\">\n                {{stringifyAddress(address)}}\n              </p>\n\n              <h2 ng-if=\"message.contactShare.contactAddresses.length > 0\">Email Contacts</h2>\n              <p ng-repeat=\"address in message.contactShare.contactAddresses\">\n                {{address}}\n              </p>\n\n              <div class=\"buttons\" ng-if=\"currentOrg != null\">\n                <div class=\"dbButton lightBlue margin-right\" ng-click=\"newContactFromShare(message.contactShare)\">\n                  Create New Contact\n                </div>\n                <div class=\"dbButton lightBlue\" ng-click=\"addContactShareToExisting(message.contactShare)\">\n                  Add To Existing Contact\n                </div>\n              </div>\n\n              <div class=\"buttons\" ng-if=\"currentOrg == null\">\n                <div class=\"dbButton lightBlue margin-right\" ng-click=\"newContactFromShare(message.contactShare)\">\n                  Create New Contact\n                </div>\n                <div class=\"dbButton lightBlue\" ng-click=\"addContactShareToExisting(message.contactShare)\">\n                  Add To Existing Contact\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "syk1":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/docketDetail.html';
var html = "<div class=\"ojdDesktopDetailOuter\">\n\t<form name=\"docketDetailForm\" class=\"docketDetailForm\">\n\t\t<div class=\"ojdDesktopSection header white\">\n\t\t\t<div class=\"headerTitle\">\n\t\t\t\t<h1>{{itemEdit.docketNumber}}</h1>\n\t\t\t</div>\n\n\t\t\t<div class=\"bulkActionsButtons\">\n\t\t\t\t<div class=\"dbButton\" ng-click=\"editDocket(itemEdit)\" ng-if=\"userCanDoAction('editDocket', itemEdit) && !itemEdit.loading\">\n\t\t\t\t\tEdit\n\t\t\t\t</div>\n\t\t\t\t<div class=\"dbButton\" ng-click=\"reDraftDocket(itemEdit)\" ng-if=\"userCanDoAction('reDraftDocket', itemEdit) && !itemEdit.loading\">\n\t\t\t\t\tEdit\n\t\t\t\t</div>\n\t\t\t\t<div class=\"dbButton grey rightMargin\" ng-if=\"itemEdit.editing\" ng-click=\"cancelEditDocket(itemEdit)\">\n\t\t\t\t\tCancel\n\t\t\t\t</div>\n\t\t\t\t<div class=\"dbButton\" ng-click=\"saveDocket(itemEdit)\" ng-if=\"userCanDoAction('saveDocket', itemEdit) && !itemEdit.loading\">\n\t\t\t\t\tSave\n\t\t\t\t</div>\n\t\t\t\t<md-menu>\n\t\t\t\t\t<md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\"\n\t\t\t\t\t\tng-click=\"openMenu($mdOpenMenu, $event)\">\n\t\t\t\t\t\t<md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n\t\t\t\t\t</md-button>\n\t\t\t\t\t<md-menu-content width=\"4\">\n\t\t\t\t\t\t<md-menu-item ng-click=\"assignDocketOrg(itemEdit)\"\n\t\t\t\t\t\t\tng-if=\"!itemEdit.assigned && currentOrg == null && !itemEdit.editing\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tAssign To Group\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"userCanDoAction('sendDocket', itemEdit)\" ng-click=\"sendDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tSend Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"userCanDoAction('recallDocket', itemEdit)\"\n\t\t\t\t\t\t\tng-click=\"recallDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tRecall Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"userCanDoAction('acceptDocket', itemEdit) || (itemEdit.existingDocketFile && userCanDoAction('acceptFileDocket', itemEdit))\"\n\t\t\t\t\t\t\tng-click=\"acceptDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tAccept Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"!itemEdit.existingDocketFile && (userCanDoAction('acceptFileDocket', itemEdit) || (userHasPermission('io.docketbook.ojdapi.fileDockets') && userCanDoAction('acceptDocket', itemEdit)))\"\n\t\t\t\t\t\t\tng-click=\"acceptAndFileDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tAccept and File Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"userCanDoAction('fileDocket', itemEdit)\"\n\t\t\t\t\t\t\tng-click=\"fileDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tFile Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"userCanDoAction('rejectDocket', itemEdit)\"\n\t\t\t\t\t\t\tng-click=\"rejectDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tReject Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"userCanDoAction('downloadDocket', itemEdit)\"\n\t\t\t\t\t\t\tng-click=\"downloadDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tDownload Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-click=\"shareDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tShare Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t\t<md-menu-item ng-show=\"userCanDoAction('deleteDocket', itemEdit)\"\n\t\t\t\t\t\t\tng-click=\"deleteDocket(itemEdit)\">\n\t\t\t\t\t\t\t<md-button>\n\t\t\t\t\t\t\t\tDelete Docket\n\t\t\t\t\t\t\t</md-button>\n\t\t\t\t\t\t</md-menu-item>\n\t\t\t\t\t</md-menu-content>\n\t\t\t\t</md-menu>\n\n\t\t\t\t<md-button class=\"md-icon-button\" aria-label=\"Close Docket Detail\"\n\t\t\t\t\tng-click=\"closeDocketDesktop(itemEdit)\">\n\t\t\t\t\t<md-icon md-svg-icon=\"clear.svg\"></md-icon>\n\t\t\t\t</md-button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"desktopLoaderUnder\" ng-if=\"itemEdit.loading || docketLoadingError\">\n\t\t\t<div my-loader text=\"Loading Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n\t\t\t<div my-loader text=\"Saving Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n\t\t\t<div class=\"stdLoader\" ng-show=\"docketLoadingError != null\">\n\t\t\t\t<div class=\"desktopLoaderHeader\">\n\t\t\t\t\t<div class=\"bulkActionsButtons\">\n\t\t\t\t\t\t<md-button class=\"md-icon-button\" aria-label=\"Close Docket Detail\"\n\t\t\t\t\t\t\tng-click=\"closeDocketDesktop(itemEdit)\">\n\t\t\t\t\t\t\t<md-icon md-svg-icon=\"clear.svg\"></md-icon>\n\t\t\t\t\t\t</md-button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"loaderOuterContainer\">\n\t\t\t\t\t<div class=\"loaderInnerContainer\">\n\t\t\t\t\t\t<div class=\"materialSpinner\">\n\t\t\t\t\t\t\t<md-icon md-svg-src=\"error.svg\"></md-icon>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"loadingText\">\n\t\t\t\t\t\t\t{{docketLoadingError}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"loadingRetryButton\">\n\t\t\t\t\t\t\t<div class=\"dbButton grey margin-right\" ng-click=\"openDocketDesktop(currentDocket)\">Retry\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"dbButton grey\" ng-click=\"contactSupportError(docketLoadingErrorFull)\">Contact\n\t\t\t\t\t\t\t\tSupport</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"clearfix\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<md-tabs md-selected=\"data.selectedIndex\" md-border-bottom md-autoselect class=\"docketTabsInner\">\n\t\t\t<md-tab label=\"Docket\">\n\t\t\t\t<div class=\"docketTab\">\n\t\t\t\t\t<ng-include src=\"'views/pages/dockets/desktop/generalTab.html'\"></ng-include>\n\t\t\t\t</div>\n\t\t\t</md-tab>\n\t\t\t<md-tab ng-if=\"currentOrg && currentOrgGroup\">\n\t\t\t\t<md-tab-label>\n\t\t\t\t\tFiling\n\t\t\t\t\t<span class=\"lockIcon\" ng-if=\"currentOrg.planFeatures.docketsFiling != true\">\n\t\t\t\t\t  \t<md-icon md-svg-src=\"padlock.svg\"></md-icon>\n\t\t\t\t\t</span>\n\t\t\t\t</md-tab-label>\n\t\t\t\t<md-tab-body>\n\t\t\t\t\t<div class=\"docketTab\">\n\t\t\t\t\t\t<ng-include ng-show=\"currentOrg.planFeatures.docketsFiling\" src=\"'views/pages/dockets/desktop/filingTab.html'\"></ng-include>\n\n\t\t\t\t\t\t<div ng-if=\"currentOrg.planFeatures.docketsFiling != true\" style=\"margin-top: 150px; text-align: center;\">\n\t\t\t\t\t\t\t<p style=\"margin-bottom: 20px;\">File codes are available on the Large and Enterprise plans</p>\n\t\t\t\t\t\t\t<div class=\"newDbButton centerAligned\" ng-click=\"selectPlan(null, 'docketsFiling', 'from file codes page - upgrade now button')\">\n\t\t\t\t\t\t\t\tUpgrade Now\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</md-tab-body>\n\t\t\t</md-tab>\n\t\t\t<md-tab label=\"Attachments{{itemEdit.attachmentCount && itemEdit.attachmentCount > 0 ? ' (' + itemEdit.attachmentCount + ')' : ''}}\">\n\t\t\t\t<div class=\"docketTab\">\n\t\t\t\t\t<ng-include src=\"'views/pages/dockets/desktop/attachmentsTab.html'\"></ng-include>\n\t\t\t\t</div>\n\t\t\t</md-tab>\n\t\t\t<md-tab label=\"Audit Log\">\n\t\t\t\t<div class=\"docketTab\">\n\t\t\t\t\t<ng-include src=\"'views/pages/dockets/desktop/auditLogTab.html'\"></ng-include>\n\t\t\t\t</div>\n\t\t\t</md-tab>\n\t\t\t<md-tab label=\"Map\" md-on-select=\"setupSummaryMap(itemEdit)\">\n\t\t\t\t<div class=\"mapTab\">\n\t\t\t\t\t<ng-include src=\"'views/pages/dockets/desktop/mapTab.html'\" class=\"mapTabIncluder\"></ng-include>\n\t\t\t\t</div>\n\t\t\t</md-tab>\n\t\t</md-tabs>\n\t</form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "sz64":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "16.png";

/***/ }),

/***/ "tCDi":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/mobile/docketsTab.html';
var html = "<div class=\"customListRowOuter\" ng-show=\"itemEdit.id && ((itemEdit.userAssigneeData && userCanDoAction('assigneeCreateDocketFromJob', itemEdit)) || (!itemEdit.userAssigneeData && userCanDoAction('createDocketFromJob', itemEdit)))\" ng-click=\"newDocketForJob()\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem createNew\">\n      <div class=\"dbButton lightBlue\">Create New Docket</div>\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-show=\"itemEdit.id == null\">\n  <div class=\"customListRow\">\n    <div class=\"listRowItem message\">\n      Save job before creating dockets.\n    </div>\n  </div>\n</div>\n<div class=\"customListRowOuter\" ng-repeat=\"item in itemEdit.dockets\" id=\"listItem{{item.id}}\" ng-click=\"openDocket(item)\">\n  <div class=\"customListRow\" hm-swipeLeft=\"splitListFunc.swipeListItem(item.id)\" hm-swipeRight=\"splitListFunc.swipeListItemClose(item.id)\" hm-recognizer-options='{\"type\":\"swipe\", \"directions\":\"DIRECTION_LEFT|DIRECTION_RIGHT\"}'>\n    <div class=\"listRowItem status\"><div class=\"statusDisplay {{item.status}}\">{{item.status}}</div></div>\n    <div class=\"listRowItem itemNumber\">{{item.docketNumber}}</div>\n    <div class=\"listRowItem collapsedDetail showCollapsed\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">{{item.authorName}}</div>\n        <div class=\"right\">{{moment(item.date).format('DD/MM')}}</div>\n      </div>\n    </div>\n  </div>\n  <div class=\"mobileListItemUnder\">\n\n  </div>\n</div>\n<div class=\"customListRowOuter hidden\" id=\"docketsLoadingMore\">\n  <div class=\"customListRow loadingRow\">\n    <div class=\"progressOuter\">\n      <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n    </div>\n    Loading More Dockets ({{docketsListLoadingCount}} of {{docketsListCount}})\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "tIi5":
/***/ (function(module, exports) {

var path = 'views/pages/dashboard.html';
var html = "<div class=\"paywallOverlay\" ng-if=\"currentOrg.billingIssue\">\n  <div class=\"messageContainer\">\n    <div class=\"messageInnerContainer\">\n      <div class=\"messageBox\">\n        <h2>Your subscription has expired</h2>\n        <p>It looks like your subscription has expired. Please check and update your billing details to continue using Docketbook.</p><p>Email <a href=\"mailto:support@docketbook.com.au\">support@docketbook.com.au</a> for help.</p>\n        <div class=\"newBlueButton\" ui-sref=\"companySettings.billing({orgId:currentOrg.id})\">Go To Billing</div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"paywallOverlay\" ng-if=\"currentOrg.trialExpired\">\n  <div class=\"messageContainer\">\n    <div class=\"messageInnerContainer\">\n      <div class=\"messageBox\">\n        <h2>Your trial has ended</h2>\n        <p>Your 30 day trial has ended, to continue using Docketbook select a plan.</p><p>Email <a href=\"mailto:support@docketbook.com.au\">support@docketbook.com.au</a> for help.</p>\n        <div class=\"newBlueButton\" ui-sref=\"companySettings.billing({orgId:currentOrg.id})\">Select a plan</div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"desktopContainer dashboard\" ng-if=\"!currentUser.redirecting\">\n  <div class=\"dashboardWelcomeHeader\" ng-show=\"!currentOrg\">\n    <div class=\"left\">\n      <h3>Hello, {{currentUser.name.first}}</h3>\n    </div>\n  </div>\n\n  <div class=\"trialBanner\" ng-if=\"unverifiedPhone !== undefined\">\n    When you receive the confirmation code we sent to {{unverifiedPhone}}, please go to <a ui-sref=\"user.account()\">My Account</a> to verify your account.\n  </div>\n  <div class=\"trialBanner\" ng-if=\"unverifiedEmail !== undefined\">\n    Please check your email address {{unverifiedEmail}} for a verification message. When you receive it, open the link it contains to verify your account.\n  </div>\n\n  <div class=\"dashboardWelcomeHeader\" ng-show=\"currentOrg\">\n    <div class=\"left\">\n      <h3 ng-if=\"currentOrgGroup.parent == null\">Company Dashboard</h3>\n      <h3 ng-if=\"currentOrgGroup.parent != null\">Group Dashboard</h3>\n      <p>What's happening today at {{currentOrgGroup.name}}.</p>\n    </div>\n    <div class=\"right\">\n      <!--<div class=\"dbButton grey\" ui-sref=\"companySettings.general({orgId:currentOrg.id})\" ng-if=\"currentOrgGroup.parent == null && userCanDoAction('viewCompanySettings')\">Company Settings</div>\n      <div class=\"dbButton grey\" ui-sref=\"groupSettings.general({orgId:currentOrg.id, groupId: currentOrgGroup.id})\" ng-if=\"currentOrgGroup.parent != null && userCanDoAction('viewGroupSettings')\">Group Settings</div>-->\n    </div>\n  </div>\n\n  <!-- New Dashboard -->\n  <div>\n    <div class=\"dashboardWidgetRow\">\n      <div class=\"dashboardWidgetGroup\">\n        <div class=\"dashboardWidgetBlock\" ng-if=\"!ordersSummary.hide && currentOrg.planFeatures.ordersEnabled == true\" ng-if=\"userCanDoAction('viewOrdersSummary')\">\n          <div class=\"widgetLoaderOuter\" ng-if=\"ordersSummary.loading\">\n            <div class=\"widgetLoaderTable\">\n              <div class=\"widgetLoaderInner\">\n                <md-progress-circular md-diameter=\"25px\"></md-progress-circular>\n              </div>\n            </div>\n          </div>\n          <div class=\"stdLoader white noMinHeight\" ng-if=\"ordersSummary.error != null\">\n            <div class=\"loaderOuterContainer\">\n              <div class=\"loaderInnerContainer\">\n                <div class=\"materialSpinner\">\n                  <md-icon md-svg-src=\"error.svg\"></md-icon>\n                </div>\n                <div class=\"loadingText\">\n                  {{ordersSummary.error}}\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n          </div>\n          <h3 ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id})\">Orders</h3>\n          <div class=\"statsBreakdownOuter\">\n            <div class=\"total\">\n              <h2>{{ordersSummary.total}}</h2>\n              <h4>Active Today</h4>\n            </div>\n            <div class=\"graphs\">\n              <div class=\"progressList\">\n                <div class=\"progressItem draft\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{ordersSummary.data.draft > 0 ? (ordersSummary.data.draft / ordersSummary.total) * 100   : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'draft'})\">\n                    {{ordersSummary.data.draft}} Draft\n                  </div>\n                </div>\n                <div class=\"progressItem sent\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{ordersSummary.data.sent > 0 ? (ordersSummary.data.sent / ordersSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'sent'})\">\n                    {{ordersSummary.data.sent}} Sent\n                  </div>\n                </div>\n                <div class=\"progressItem accepted\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{ordersSummary.data.accepted > 0 ? (ordersSummary.data.accepted / ordersSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'accepted'})\">\n                    {{ordersSummary.data.accepted}} Accepted\n                  </div>\n                </div>\n                <div class=\"progressItem rejected\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{ordersSummary.data.rejected > 0 ? (ordersSummary.data.rejected / ordersSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupOrders({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'rejected'})\">\n                    {{ordersSummary.data.rejected}} Rejected\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"dashboardWidgetBlock\" ng-if=\"userCanDoAction('viewJobsSummary') && currentOrg.planFeatures.jobsEnabled == true\">\n          <div class=\"widgetLoaderOuter\" ng-if=\"jobsSummary.loading\">\n            <div class=\"widgetLoaderTable\">\n              <div class=\"widgetLoaderInner\">\n                <md-progress-circular md-diameter=\"25px\"></md-progress-circular>\n              </div>\n            </div>\n          </div>\n          <div class=\"stdLoader white noMinHeight\" ng-if=\"jobsSummary.error != null\">\n            <div class=\"loaderOuterContainer\">\n              <div class=\"loaderInnerContainer\">\n                <div class=\"materialSpinner\">\n                  <md-icon md-svg-src=\"error.svg\"></md-icon>\n                </div>\n                <div class=\"loadingText\">\n                  {{jobsSummary.error}}\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n          </div>\n          <h3 ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id})\">Jobs</h3>\n          <div class=\"statsBreakdownOuter\">\n            <div class=\"total\">\n              <h2>{{jobsSummary.total}}</h2>\n              <h4>Active Today</h4>\n            </div>\n            <div class=\"graphs\">\n              <div class=\"progressList\">\n                <div class=\"progressItem sent\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{jobsSummary.data.sent > 0 ? (jobsSummary.data.sent / jobsSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'sent'})\">\n                    {{jobsSummary.data.sent}} Sent\n                  </div>\n                </div>\n                <div class=\"progressItem accepted\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{jobsSummary.data.accepted > 0 ? (jobsSummary.data.accepted / jobsSummary.assigneesTotal) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'sent', assigneeStatus:'accepted'})\">\n                    {{jobsSummary.data.accepted}} Accepted\n                  </div>\n                </div>\n                <div class=\"progressItem rejected\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{jobsSummary.data.rejected > 0 ? (jobsSummary.data.rejected / jobsSummary.assigneesTotal) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'sent', assigneeStatus:'rejected'})\">\n                    {{jobsSummary.data.rejected}} Rejected\n                  </div>\n                </div>\n                <div class=\"progressItem draft\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{jobsSummary.data.pending > 0 ? (jobsSummary.data.pending / jobsSummary.assigneesTotal) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupJobs({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'sent', assigneeStatus:'assigned'})\">\n                    {{jobsSummary.data.pending}} Pending\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"dashboardWidgetBlock\" ng-if=\"userCanDoAction('viewDocketsSummary')\">\n          <div class=\"widgetLoaderOuter\" ng-if=\"docketsSummary.loading\">\n            <div class=\"widgetLoaderTable\">\n              <div class=\"widgetLoaderInner\">\n                <md-progress-circular md-diameter=\"25px\"></md-progress-circular>\n              </div>\n            </div>\n          </div>\n          <div class=\"stdLoader white noMinHeight\" ng-if=\"docketsSummary.error != null\">\n            <div class=\"loaderOuterContainer\">\n              <div class=\"loaderInnerContainer\">\n                <div class=\"materialSpinner\">\n                  <md-icon md-svg-src=\"error.svg\"></md-icon>\n                </div>\n                <div class=\"loadingText\">\n                  {{docketsSummary.error}}\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n          </div>\n          <h3 ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id})\">Dockets</h3>\n          <div class=\"statsBreakdownOuter\">\n            <div class=\"total\">\n              <h2>{{docketsSummary.total}}</h2>\n              <h4>Active Today</h4>\n            </div>\n            <div class=\"graphs\">\n              <div class=\"progressList\">\n                <div class=\"progressItem draft\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{docketsSummary.data.draft > 0 ? (docketsSummary.data.draft / docketsSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'draft'})\">\n                    {{docketsSummary.data.draft}} Draft\n                  </div>\n                </div>\n                <div class=\"progressItem sent\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{docketsSummary.data.sent > 0 ? (docketsSummary.data.sent / docketsSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'sent'})\">\n                    {{docketsSummary.data.sent}} Sent\n                  </div>\n                </div>\n                <div class=\"progressItem accepted\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{docketsSummary.data.accepted > 0 ? (docketsSummary.data.accepted / docketsSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'accepted'})\">\n                    {{docketsSummary.data.accepted}} Accepted\n                  </div>\n                </div>\n                <div class=\"progressItem rejected\">\n                  <div class=\"left\">\n                    <md-progress-linear md-mode=\"determinate\" value=\"{{docketsSummary.data.rejected > 0 ? (docketsSummary.data.rejected / docketsSummary.total) * 100 : 0}}\"></md-progress-linear>\n                  </div>\n                  <div class=\"right\" ui-sref=\"main.groupDockets({orgId:currentOrg.id, groupId:currentOrgGroup.id, status:'rejected'})\">\n                    {{docketsSummary.data.rejected}} Rejected\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"dashboardWidgetGroup\" ng-if=\"userCanDoAction('viewOrdersSummary') || userCanDoAction('viewJobsSummary') || userCanDoAction('viewDocketsSummary')\">\n        <div class=\"dashboardWidgetBlock map\">\n          <div class=\"loaderOuterContainer\" ng-show=\"interactionSummary.loading\">\n            <div class=\"loaderInnerContainer\">\n              <div class=\"materialSpinner\">\n                <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n              </div>\n              <div class=\"clearfix\"></div>\n            </div>\n          </div>\n          <div class=\"stdLoader white\" ng-show=\"interactionSummary.error != null\">\n            <div class=\"loaderOuterContainer\">\n              <div class=\"loaderInnerContainer\">\n                <div class=\"materialSpinner\">\n                  <md-icon md-svg-src=\"error.svg\"></md-icon>\n                </div>\n                <div class=\"loadingText\">\n                  {{interactionSummary.error}}\n                </div>\n                <div class=\"loadingRetryButton\">\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"disabledMap\" ng-show=\"interactionSummary.disabled\">\n            <div class=\"disabledText\">No Map Data Available</div>\n          </div>\n          <div id=\"fullInteractionMap\" ng-show=\"!interactionSummary.disabled\"></div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"dashboardSectionHeader\">\n      <div class=\"left\">\n        Groups\n      </div>\n      <div class=\"right\">\n        <div class=\"dbButton green\" ng-click=\"newOrgGroup()\" ng-if=\"userCanDoAction('createOrgGroup')\">New Group</div>\n      </div>\n    </div>\n    <div class=\"dashboardWidgetRow hasHeaderAbove\">\n      <div class=\"dashboardWidgetGroup\">\n        <table class=\"dashboardGroupsTable\">\n          <tr ng-if=\"!hasGroups\">\n            <td colspan=\"4\" class=\"centered\">There are no groups yet</td>\n          </tr>\n          <tr ng-repeat=\"group in allGroups\" ng-if=\"group.parent == currentOrgGroup.id && group.active\">\n            <td>\n              <a ui-sref=\"main.groupDashboard({orgId:currentOrg.id, groupId:group.id})\">{{group.name}}</a>\n            </td>\n            <td>{{group.emailAddress}}</td>\n            <td>{{stringifyAddress(group.address)}}</td>\n            <td>{{group.members.length}} Members</td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n  <!-- End New Dashboard -->\n</div>\n\n<div class=\"mobileContainer\">\n  <div class=\"dashboardHeading\" ng-show=\"!currentOrg\">\n    <h1 class=\"dashboardHeader\">\n      <strong>Hi {{currentUser.name.first}},</strong> welcome back\n    </h1>\n  </div>\n</div>\n\n<!-- Create new org modal -->\n<!--<ng-include src=\"'views/modals/newGroupModal.html'\" ng-controller=\"newGroupModalController\"></ng-include>-->\n<!-- Select plan modal -->\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "th1l":
/***/ (function(module, exports) {

var path = 'views/modals/shareDocketModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"shareDocketModal\">\n  <div class=\"modalContainer\" style=\"width: 600px;\">\n    <div class=\"header hidden-xs\">\n      <h1>Share Docket</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeAccessControlModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"mobileDetailHeader selectHeader visible-xs\">\n      <div class=\"mobileDetailHeaderInner\">\n        <div class=\"mobileHeaderUpper\">\n          <div class=\"left\">\n            <div class=\"cancelButtonOuter\">\n              <div class=\"cancelButton closeButton\" ng-click=\"closeAccessControlModal()\">\n                <div class=\"line1\"></div>\n                <div class=\"line2\"></div>\n                <div class=\"line3\"></div>\n              </div>\n            </div>\n          </div>\n          <div class=\"middle\">\n              Share Docket\n          </div>\n          <div class=\"right text\">\n            <div class=\"doneButton\" ng-click=\"saveAccessControlEdit(accessControlEdit)\">Save</div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form novalidate>\n        <div class=\"modalFormMobileHeader\">\n          <div class=\"row1\">\n            <div class=\"to\">\n              <strong>To:</strong>\n            </div>\n            <div class=\"email\">\n              <input type=\"text\" placeholder=\"Email or Phone Number\" ng-model=\"newAccessor.emailAddress\">\n            </div>\n            <div class=\"selector\">\n              <md-button class=\"md-icon-button\" ng-click=\"selectAccessorContact()\" aria-label=\"Select Person\">\n                <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n              </md-button>\n            </div>\n          </div>\n          <div class=\"row1\">\n            <div class=\"to\">\n              <strong>Role:</strong>\n            </div>\n            <div class=\"select\">\n              <md-select ng-model=\"newAccessor.accessLevel\" aria-label=\"Select access level\">\n                <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(newAccessor, 'viewer')\">\n                  Viewer\n                </md-option>\n                <md-option value=\"approver\" ng-show=\"canSetAccessLevel(newAccessor, 'approver')\">\n                  Approver\n                </md-option>\n                <md-option value=\"editor\" ng-show=\"canSetAccessLevel(newAccessor,'editor')\">\n                  Editor\n                </md-option>\n              </md-select>\n            </div>\n          </div>\n          <div class=\"row1\">\n            <div class=\"add\">\n              <div class=\"dbButton lightBlue\" ng-click=\"(newAccessor.emailAddress == null || newAccessor.emailAddress == '') || addNewAccessor(newAccessor)\" ng-disabled=\"newAccessor.emailAddress == '' || newAccessor.emailAddress == null\">\n                Add\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"modalFormTableHeader slimline\">\n          <div>\n            <h2>New Share</h2>\n          </div>\n          <div style=\"display: flex;\">\n            <div style=\"min-width: 300px;\">\n              <md-input-container class=\"md-block\" md-no-float>\n                <md-label>Recipient</md-label>\n                <md-autocomplete \n                  required\n                  id=\"docketSharecontactSearchInput\"\n                  md-input-name=\"autocompleteContact\"\n                  md-selected-item=\"newAccessor.recipient\"\n                  md-search-text-change=\"loadContactSearchList(contactSearch.text)\"\n                  md-search-text=\"contactSearch.text\"\n                  md-items=\"contact in contactSearchList\"\n                  md-item-text=\"contact.displayName\"\n                  md-min-length=\"0\"\n                  md-menu-class=\"autocomplete-custom-template\"\n                  ng-model-options='{debounce:200}'\n                  placeholder=\"Recipient\"\n                >\n                  <md-item-template>\n                    <span class=\"item-title\">{{contact.displayName}}</span>\n                  </md-item-template>\n                  <md-not-found>\n                    No matches found.\n                  </md-not-found>\n                </md-autocomplete>\n              </md-input-container>\n            </div>\n            <div style=\"flex-grow: 1;\"></div>\n            <div style=\"min-width: 200px;\">\n              <md-input-container class=\"md-block\">\n                <md-label>Allow this user to</md-label>\n                <md-select required ng-model=\"newAccessor.accessLevel\" aria-label=\"Select access level\" placeholder=\"Access level\" label=\"Access level\" style=\"height: 40px;\">\n                  <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(newAccessor, 'viewer')\">\n                    View Dockets\n                  </md-option>\n                  <md-option value=\"approver\" ng-show=\"canSetAccessLevel(newAccessor, 'approver')\">\n                    Approve Dockets\n                  </md-option>\n                  <md-option value=\"editor\" ng-show=\"canSetAccessLevel(newAccessor,'editor')\">\n                    Edit Dockets\n                  </md-option>\n                </md-select>\n              </md-input-container>\n            </div>\n          </div>\n\n          <div style=\"height: 60px; margin-top: 8px\">\n            <!--div class=\"dbButton\" ng-click=\"(newAccessor.emailAddress == null || newAccessor.emailAddress == '') || addNewAccessor(newAccessor)\" ng-disabled=\"newAccessor.emailAddress == '' || newAccessor.emailAddress == null\"-->\n            <div class=\"dbButton\" style=\"float: right;\" ng-click=\"newAccessor.loading || (newAccessor.recipient == null && contactSearch.text == '') || addNewAccessor(contactSearch.text)\" ng-disabled=\"newAccessor.loading || (newAccessor.recipient == null && contactSearch.text == '')\">\n              <span ng-hide=\"newAccessor.loading\">Share now</span>\n              <md-progress-circular ng-show=\"newAccessor.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n          </div>\n        </div>\n        <div class=\"modalFormTable\">\n          <div class=\"\" style=\"margin-top: 15px; margin-left: 20px; margin-bottom: 20px;\">\n            <h2>Current Recipients</h2>\n          </div>\n          <md-table-container>\n            <table md-table ng-show=\"accessControlEdit.accessControl.length > 0\">\n              <tbody md-body ng-repeat=\"accessor in accessControlEdit.accessControl\">\n                <form name=\"innerForm\">\n                  <tr md-row class=\"{{accessor.accessLevel=='remove'?'disabled remove':''}}\">\n                    <td md-cell>\n                      {{accessor.emailAddress}}\n                    </td>\n                    <td md-cell>\n                      <md-select ng-model=\"accessor.accessLevel\" ng-disabled=\"accessor.accessLevelSet || accessor.isSupplier || accessor.isCustomer || accessor.isUser || !canChangeAccessLevel(accessor)\">\n                        <md-option value=\"creator\" ng-show=\"accessor.accessLevelSet\">\n                          Creator\n                        </md-option>\n                        <md-option value=\"viewer\" ng-show=\"canSetAccessLevel(accessor, 'viewer')\">\n                          Viewer\n                        </md-option>\n                        <md-option value=\"approver\" ng-show=\"canSetAccessLevel(accessor, 'approver')\">\n                          Approver\n                        </md-option>\n                        <md-option value=\"editor\" ng-show=\"canSetAccessLevel(accessor,'editor')\">\n                          Editor\n                        </md-option>\n                        <md-option value=\"remove\" ng-show=\"canSetAccessLevel(accessor,'remove')\">\n                          Remove\n                        </md-option>\n                      </md-select>\n                    </td>\n                  </tr>\n                </form>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeAccessControlModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"accessControlEdit.loading || saveAccessControlEdit(accessControlEdit)\" ng-disabled=\"accessControlEdit.loading\">\n            <span ng-hide=\"accessControlEdit.loading\">Save</span>\n            <md-progress-circular ng-show=\"accessControlEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "tk26":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/desktop/attachmentsTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Docket\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <!-- Start Map Section -->\n  <div class=\"ojdDesktopSection noPadding noBottomPadding\">\n    <div my-loader text=\"Loading Attachments\" ng-if=\"attachmentsLoading || itemEdit.loading\"></div>\n    <div class=\"sectionHeadingContainer\">\n      <div class=\"sectionHeadingLeft\">\n        <h1 class=\"sectionHeading\">Attachments</h1>\n      </div>\n      <div class=\"sectionHeadingRight\">\n        <md-icon md-svg-src=\"add.svg\" ngf-select=\"uploadNewAttachment($file)\" ng-if=\"userCanDoAction('addDocketAttachment', itemEdit)\"></md-icon>\n      </div>\n    </div>\n\n    <md-table-container class=\"docketResourceTable\" ng-show=\"(itemEdit.attachments != null && itemEdit.attachments.length > 0) || (itemEdit.template.attachments != null && itemEdit.template.attachments.length > 0)\">\n      <table md-table multiple>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Thumbnail</th>\n            <th md-column>Author</th>\n            <th md-column>Type</th>\n            <th md-column width=\"140px\">Action</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"attachment in itemEdit.attachments\" ng-if=\"attachment.fileName != 'supplier-signature' && attachment.fileName != 'customer-signature' && !attachmentsLoading && signatureAttachments.indexOf(attachment.id) === -1\">\n            <td md-cell class=\"thumb\">\n              <div class=\"attachmentThumb image\" style=\"background-image: url('{{fullApiPath}}/dockets/{{itemEdit.id}}/attachment/{{attachment.id}}')\" ng-if=\"attachment.mimeType.indexOf('image') != -1 && currentOrg == null\">\n              </div>\n              <div class=\"attachmentThumb image\" style=\"background-image: url('{{fullApiPath}}/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/dockets/{{itemEdit.id}}/attachment/{{attachment.id}}')\" ng-if=\"attachment.mimeType.indexOf('image') != -1 && currentOrg != null\">\n              </div>\n              <div class=\"attachmentThumb video\" ng-if=\"attachment.mimeType.indexOf('video') != -1\">\n                <md-icon md-svg-src=\"video_black.svg\"></md-icon>\n              </div>\n              <div class=\"attachmentThumb video\" ng-if=\"attachment.mimeType.indexOf('video') == -1 && attachment.mimeType.indexOf('image') == -1\">\n                <md-icon md-svg-src=\"document.svg\"></md-icon>\n              </div>\n            </td>\n            <td md-cell>\n              {{attachment.authorName}}\n            </td>\n            <td md-cell>\n              {{attachment.mimeType}}\n            </td>\n            <td md-cell>\n              <md-button class=\"md-icon-button\" ng-click=\"openAttachment(attachment)\">\n                <md-icon md-svg-src=\"file_download.svg\"></md-icon>\n              </md-button>\n              <md-button class=\"md-icon-button\" ng-click=\"deleteAttachment(attachment)\" ng-if=\"userCanDoAction('removeDocketAttachment', itemEdit)\">\n                <md-icon md-svg-src=\"delete.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n          <tr md-row ng-repeat=\"attachment in itemEdit.template.attachments\" ng-if=\"attachment.type == 'termsConditions'\">\n            <td md-cell class=\"thumb\">\n              <div class=\"attachmentThumb video\">\n\n              </div>\n            </td>\n            <td md-cell>\n              Terms & Conditions - {{attachment.fileName}}\n            </td>\n            <td md-cell>\n\n            </td>\n            <td md-cell>\n              <md-button class=\"md-icon-button\" ng-click=\"openTemplateAttachment(attachment)\">\n                <md-icon md-svg-src=\"file_download.svg\"></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "u0ca":
/***/ (function(module, exports, __webpack_require__) {

var path = 'views/pages/paywalled/orders.html';
var html = "<div style=\"width: 100%; height: 100%; background-color: white; display: table; padding-top: 40px; padding-bottom: 40px;\">\n    <div style=\"display: table-cell; vertical-align: middle;\">\n        <div class=\"\" style=\"display: flex; margin: auto\">\n            <div style=\"flex: 1 1 auto; min-width: 600px; width: calc(50% - 30px); text-align: end;\">\n                <img style=\"width: 600px\" src=\"" + __webpack_require__("bvO+") + "\"/>\n            </div>\n            <div style=\"width: 60px;\"></div>\n            <div style=\"flex: 1 1 auto; width: calc(50% - 30px);\">\n                <div class=\"lockSectionTextContainer\">\n                    <h3 class=\"darkBlueBold\">ORDERS</h3>\n                    <h1 class=\"boldBlueText\">Receive orders from your customers</h1>\n                    <p class=\"lockJobsText\">Orders represent the agreement between supplier and customer. They provide additional structure for integrating with ERP, accounting and ordering systems.</p>\n                    <a class=\"dbColorText\" target=\"_blank\" href=\"https://help.docketbook.com.au/hc/en-us/articles/360049143534-Orders-Overview\">Learn more about Orders</a>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"lockSubcardsContainer\">\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Collaborative workflows</h3>\n                <span>Orders can be sent between customers and suppliers, making them visible to both parties. This ensures transparency and keeps a single version of the truth.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Integrate with your systems</h3>\n                <span>Orders, resources and line items can be uniquely referenced to support integration with your ERP, ordering, accounting and productivity systems.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Multi directional workflow</h3>\n                <span>Orders can be created by either the Customer or Supplier - providing structure to ensure the data is meaningful when it arrives.</span>\n            </div>\n            <div class=\"lockSubcards\">\n                <h3 class=\"darkBlueBold\">Real-time docket updates</h3>\n                <span>Docket quantities are aggregated at order level to provide real time visibility of delivered quantities or worked hours, improving management of purchase orders.</span>\n            </div>\n        </div>\n\n        <div style=\"text-align: center; margin-top: 100px\">\n            <div class=\"newDbButton\" style=\"width: 250px\" ng-click=\"selectPlan(null, 'ordersCreate', 'from orders paywalled page - upgrade plan')\">\n                Upgrade Plan\n            </div>\n            <div ng-if=\"currentOrg.planFeatures.trialAvailable && !currentOrg.planFeatures.inTrial\" class=\"newDbButton whiteOutline\" style=\"width: 250px; margin-left: 30px;\" ng-click=\"trialButtonClick()\">\n                Start a 7 day free trial\n            </div>\n        </div>\n    </div>\n</div>\n\n<ng-include src=\"'views/modals/selectPlanModal.html'\" ng-controller=\"selectPlanController\"></ng-include>\n<ng-include src=\"'views/modals/trialActivatedModal.html'\" ng-controller=\"trialActivatedModalController\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "uKnp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fields.svg";

/***/ }),

/***/ "uSZ3":
/***/ (function(module, exports) {

var path = 'views/pages/jobs/desktop/auditLogTab.html';
var html = "<div class=\"ojdDesktopMainSections\">\n  <div my-loader text=\"Loading Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType == 'getting'\"></div>\n  <div my-loader text=\"Saving Job\" ng-if=\"itemEdit.loading && itemEdit.loadingType != 'getting'\"></div>\n  <div class=\"stdLoader\" ng-show=\"jobLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{jobLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"openJobDesktop(currentJob)\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Start Map Section -->\n  <div class=\"ojdDesktopSection noPadding noBottomPadding\" style=\"position: relative;\">\n    <md-table-container>\n      <table md-table>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Date</th>\n            <th md-column>Description</th>\n            <th md-column>User</th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"event in itemEdit.eventLog\">\n            <td md-cell>\n              <span ng-if=\"event.addedOn && currentOrgGroup.timeFormat == '12HR'\">{{moment(event.addedOn).tz(itemEdit.timezone).format(\"DD/MM/YYYY hh:mm:ss a\")}}</span>\n              <span ng-if=\"event.addedOn && currentOrgGroup.timeFormat == '24HR'\">{{moment(event.addedOn).tz(itemEdit.timezone).format(\"DD/MM/YYYY HH:mm:ss\")}}</span>\n            </td>\n            <td md-cell>\n              {{event.description}}\n            </td>\n            <td md-cell>\n              {{event.userName}}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ubCb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ufFf":
/***/ (function(module, exports) {

var path = 'views/selectors/resourceList.html';
var html = "<div class=\"contentListLoaderUnder\" ng-if=\"resourceSearchLoading || resourceLoadingError\">\n  <div my-loader text=\"Loading Resources\" ng-if=\"resourceSearchLoading == true\"></div>\n  <div class=\"stdLoader\" ng-show=\"resourceLoadingError != null\">\n    <div class=\"loaderOuterContainer\">\n      <div class=\"loaderInnerContainer\">\n        <div class=\"materialSpinner\">\n          <md-icon md-svg-src=\"error.svg\"></md-icon>\n        </div>\n        <div class=\"loadingText\">\n          {{resourceLoadingError}}\n        </div>\n        <div class=\"loadingRetryButton\">\n          <md-button class=\"md-primary\" ng-click=\"\">Retry</md-button>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"contentSplitListInnerContainer\">\n  <div class=\"contentSplitListTopContainer showMobile\">\n    <div class=\"contentSplitListTopInner\">\n      <div class=\"contentHeader selectCompany\">\n        <h2>{{resourceCategorySelected.name}} Resources</h2>\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n  </div>\n\n  <div class=\"contentSplitListBottomContainer\">\n    <div class=\"contentSplitListBottomInner\">\n      <div class=\"contentList\">\n        <div class=\"customListRow secondaryList\" ng-repeat=\"resource in resourceSearchList\"  ng-click=\"assignResourceToItem(resource)\" id=\"listItem{{resource.id}}\">\n          <div class=\"listRowItem itemNumber\">{{resource.name}} <span ng-if=\"resource.existing\">Existing</span></div>\n          <div class=\"listRowItem collapsedDetail\">{{resource.identifier}}</div>\n          <div class=\"listRowItem collapsedDetail more\" ng-show=\"resource.lineDescription\">{{resource.lineDescription}}</div>\n        </div>\n        <div class=\"customListRowOuter hidden\" id=\"resourcesLoadingMore\">\n          <div class=\"customListRow loadingRow\">\n            <div class=\"progressOuter\">\n              <md-progress-circular class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n            </div>\n            Loading More Resources\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "upso":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "filter.svg";

/***/ }),

/***/ "uswO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('jobListController', ['$rootScope', '$scope', '$state', 'userService', '$stateParams', '$mdpDatePicker', '$mdpTimePicker', '$mdToast', '$mdBottomSheet', '$http', 'Restangular', 'accessControl', 'uuid', '$timeout', 'scroll', 'geolocation', function ($rootScope, $scope, $state, userService, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {

  /***************************/
  /***** Setup Variables *****/
  /***************************/
  $scope.moment = _momentTimezone2.default;
  $scope.listItems = [];
  $scope.jobsLoading = false;
  $scope.listFull = true;
  $scope.listCount = 0;

  // Data
  $scope.currentUser = accessControl.currentUser();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  /***********************/
  /***** Permissions *****/
  /***********************/

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  /*******************************/
  /***** Major State Changes *****/
  /*******************************/

  $scope.$parent.prepareForJobsFromParent = function () {
    $scope.listItems = [];
    $scope.jobsLoading = true;
  };

  $scope.$parent.loadJobsListFromParent = function (jobsList, jobsCount) {
    $scope.listItems = jobsList;
    $scope.listCount = jobsCount;
    $scope.jobsLoading = false;
  };

  $scope.$parent.loadAdditionalJobsFromParent = function (jobsList) {
    for (var i = 0; i < jobsList.length; i++) {
      $scope.listItems.push(jobsList[i]);
    }
  };

  $scope.$parent.minimiseList = function () {
    $scope.listFull = false;
  };

  $scope.$parent.maximiseList = function () {
    $scope.listFull = true;
  };

  /*************************************/
  /***** Item List / Swipe Actions *****/
  /*************************************/

  //delete Job, accept job and etc

  /**************************************************/
  /***** Alert parent controller of ready state *****/
  /**************************************************/

  $scope.$parent.jobsChildControllerReady();
}]);

/***/ }),

/***/ "vKoR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('paywalledController', ['$scope', '$state', 'billingService', 'accessControl', function ($scope, $state, billingService, accessControl) {

  var currentOrg = accessControl.currentOrg();

  $scope.trialButtonClick = function () {
    mixpanel.track("Start trial");
    billingService.updateOrganisationBilling(currentOrg.id, {
      plan: currentOrg.currentPlanId,
      features_trial: true
    }, function () {
      /*$scope.$parent.showTrialActivatedModal(function() {
          window.location.reload();
      })*/
      $('#trialActivatedModal').fadeIn(100);
    }, function (err) {
      swal({
        title: "Oops!",
        text: "Sorry, something went wrong.  Please contact Docketbook support",
        type: "error",
        confirmButtonText: "Ok, got it."
      });
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "vOD1":
/***/ (function(module, exports) {

var path = 'views/pages/dockets/mobile/docketDetail.html';
var html = "<form name=\"docketDetailForm\">\n  <div class=\"ojdMobileDetailOuter paddingWithTabBar\">\n\n    <div class=\"ojdSection {{currentTab == 'General' ? 'mobileShow' : 'mobileHide'}}\" id=\"General\" data-name=\"General\">\n      <ng-include src=\"'views/pages/dockets/mobile/generalTab.html'\"></ng-include>\n    </div>\n\n    <span ng-repeat=\"block in itemEdit.template.blocks\" class=\"alternatingBgOuter\" ng-if=\"block.type != 'checklists' || (block.type == 'checklists' && itemEdit.template.checklistContainers && itemEdit.template.checklistContainers.length > 0)\">\n\n      <div class=\"ojdSection {{currentTab == 'Time' ? 'mobileShow' : 'mobileHide'}}\" ng-if=\"block.type == 'time'\" id=\"Time\" data-name=\"Time\">\n        <ng-include src=\"'views/pages/dockets/mobile/timeTab.html'\"></ng-include>\n      </div>\n\n      <div class=\"ojdSection {{currentTab == 'Resources' ? 'mobileShow' : 'mobileHide'}}\" ng-if=\"block.type == 'resources'\" id=\"Resources\" data-name=\"Resources\">\n        <ng-include src=\"'views/pages/dockets/mobile/itemsTab.html'\"></ng-include>\n      </div>\n\n      <div class=\"ojdSection {{currentTab == 'Checklists' ? 'mobileShow' : 'mobileHide'}}\" ng-if=\"block.type == 'checklists' && itemEdit.template && itemEdit.template.checklistContainers && itemEdit.template.checklistContainers.length > 0\" id=\"Checklists\" data-name=\"Checklists\">\n        <ng-include src=\"'views/pages/dockets/mobile/checklistsTab.html'\"></ng-include>\n      </div>\n\n      <div class=\"ojdSection {{currentTab == 'Signatures' ? 'mobileShow' : 'mobileHide'}}\" ng-if=\"block.type == 'signatures'\" id=\"Signatures\" data-name=\"Signatures\">\n        <ng-include src=\"'views/pages/dockets/mobile/signaturesTab.html'\"></ng-include>\n      </div>\n\n      <div class=\"ojdSection {{currentTab == block.id ? 'mobileShow' : 'mobileHide'}}\" ng-if=\"block.type == 'custom'\" id=\"{{block.id}}\" data-name=\"{{block.name}}\">\n        <ng-include src=\"'views/pages/dockets/mobile/customBlockTab.html'\"></ng-include>\n      </div>\n    </span>\n\n    <div class=\"ojdSection mapSection {{currentTab == 'Map' ? 'mobileShow' : 'mobileHide'}}\" id=\"Map\" data-name=\"Map\">\n      <h1 class=\"containerHeading sectionHeading hidden-xs\">Map</h1>\n      <div class=\"fullSizeMapOuter\">\n        <div class=\"fullSizeMap\" id=\"fullInteractionMap\"></div>\n      </div>\n    </div>\n\n    <div class=\"ojdSection {{currentTab == 'Attachments' ? 'mobileShow' : 'mobileHide'}}\" id=\"Attachments\" data-name=\"Attachments\">\n      <ng-include src=\"'views/pages/dockets/mobile/attachmentsTab.html'\"></ng-include>\n    </div>\n\n    <div id=\"toaster\" class=\"visible-xs\">\n      <!--<div class=\"fabButtonContainer\">\n        <md-button class=\"md-fab md-hue-6\" ng-click=\"openBottomSheet()\" md-theme=\"dbDarkBlue\" aria-label=\"Docket Actions\" ng-show=\"!itemEdit.loading\">\n          <md-icon md-svg-src=\"more_vert.svg\"></md-icon>\n        </md-button>\n      </div>-->\n      <div id=\"toasterInner\">\n        <md-content id=\"content1\" ng-cloak>\n\n        </md-content>\n      </div>\n    </div>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "vXZX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _stringSimilarity = __webpack_require__("gUOR");

var _stringSimilarity2 = _interopRequireDefault(_stringSimilarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('selectResourceController', ['xeroService', 'resourceService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$window', '$q', function (xeroService, resourceService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $window, $q) {

  // Initialise variables to be used
  $scope.resourceCategorySearch = "";
  $scope.resourceSearch = "";
  $scope.resourceSearchLoading = false;
  $scope.resourceCategorySearchList = [];
  $scope.resourceCategorySearchListFull = [];
  $scope.resourceSearchCallback = null;
  $scope.resourceSelectState = 'category';
  $scope.listCount = 0;
  $scope.desktopSelected = [];
  $scope.searchText = null;
  $scope.allowedResourceCategories = [];
  $scope.allowedResourceCategoryIds = [];
  $scope.tableSettings = { multiple: true };
  $scope.preventLoad = false;
  $scope.filteredUoms = [];
  $scope.filteredCategories = [];

  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.currentOrg = accessControl.currentOrg();

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'name',
    categoryFilter: 'all'
  };

  $scope.cancelEdit = function (rowEdit, index) {
    if (rowEdit.id == null) {
      // If it's a new resource row simply remove the row
      $scope.resourceSearchList.splice(index, 1);
    } else {
      // Otherwise, refresh the data for the resource
      rowEdit.loading = true;
      resourceService.getResources({ ids: [rowEdit.id] }, function (returnedObjs) {
        Object.assign(rowEdit, returnedObjs[0]);
        rowEdit.loading = false;
        rowEdit.editing = false;
      }, function () {
        // fail
        rowEdit.loading = false;
      });
    }
  };

  /**********************************/
  /***** Secondary Data Models ******/
  /**********************************/

  $scope.allResourceCategories = [];
  $scope.sortedResourceCategories = {};
  $scope.allUoms = [];
  $scope.sortedUoms = {};

  $scope.getResourceCategories = function () {
    resourceService.getResourceCategories(null, function (categories) {
      $scope.allResourceCategories = categories;
      $scope.filteredCategories = categories;
    }, function (err) {
      $scope.allResourceCategories = [];
      $scope.filteredCategories = [];
    });
  };

  $scope.getUoms = function () {
    resourceService.getUoms(null, function (uoms) {
      $scope.allUoms = uoms;
      $scope.filteredUoms = uoms;
    }, function (err) {
      $scope.allUoms = [];
      $scope.filteredUoms = [];
    });
  };

  $scope.getResourceCategories();
  $scope.getUoms();

  // Edit resource table row
  $scope.editResourceRow = function (resourceRow) {
    resourceRow.editing = true;
    resourceRow.loading = false;
  };

  $scope.saveResourceRow = function (resourceRow, successCb) {
    var resourceSave = angular.copy(resourceRow);
    var valid = true;
    if (resourceRow.name == null || resourceRow.name == "") {
      valid = false;
    }
    if (resourceRow.identifier == null || resourceRow.identifier == "") {
      valid = false;
    }
    if (resourceRow.category == null) {
      valid = false;
    } else {
      resourceSave.category = resourceRow.category.id;
    }
    if (resourceRow.uom == null) {
      valid = false;
    } else {
      resourceSave.uom = resourceRow.uom.id;
    }
    resourceSave.name = resourceRow.name;
    resourceSave.identifier = resourceRow.identifier;

    if (!valid) {
      return false;
    }

    resourceRow.editing = false;
    resourceRow.loading = true;
    if (resourceRow.xeroID && resourceRow.id != null) {
      var existingXeroIdentifier = null;
      if (resourceRow.externalIdentifiers) {
        existingXeroIdentifier = resourceRow.externalIdentifiers.find(function (eid) {
          return eid.type === 'xero';
        });
      }
      if (!resourceRow.externalIdentifiers || existingXeroIdentifier === undefined || existingXeroIdentifier === null || existingXeroIdentifier.externalId !== resourceRow.xeroID) {
        resourceSave.externalIdentifiers = {
          add: [{
            type: 'xero',
            externalId: resourceRow.xeroID.externalId
          }]
        };
        if (existingXeroIdentifier !== undefined) {
          resourceSave.externalIdentifiers.delete = [existingXeroIdentifier];
        }
      }
    } else if (resourceRow.xeroID && resourceRow.id == null) {
      resourceSave.externalIdentifiers = [];
      resourceSave.externalIdentifiers.push({
        type: 'xero',
        externalId: resourceRow.xeroID.externalId
      });
    }
    resourceService.saveResource(resourceSave, function (updatedResource) {
      resourceRow.loading = false;
      if (successCb) {
        successCb(updatedResource);
      }
    }, function (err) {
      resourceRow.loading = false;
      $scope.alertService.presentAutoAlert('saveResource', err);
    });
  };

  $scope.searchUomChange = function (resource, searchText) {
    if (searchText == null || searchText == "") {
      $scope.filteredUoms = angular.copy($scope.allUoms);
    } else {
      $scope.filteredUoms = [];
      for (var i = 0; i < $scope.allUoms.length; i++) {
        if ($scope.allUoms[i].abbreviation.toLowerCase().indexOf(searchText.toLowerCase()) != -1 || $scope.allUoms[i].description.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          $scope.filteredUoms.push($scope.allUoms[i]);
        }
      }
    }
  };

  $scope.searchCategoryChange = function (resource, searchText) {
    if (searchText == null || searchText == "") {
      $scope.filteredCategories = angular.copy($scope.allResourceCategories);
    } else {
      $scope.filteredCategories = [];
      for (var i = 0; i < $scope.allResourceCategories.length; i++) {
        if ($scope.allResourceCategories[i].name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
          $scope.filteredCategories.push($scope.allResourceCategories[i]);
        }
      }
    }
  };

  $scope.categoryFilterChanged = function () {
    $scope.loadResourceList();
  };

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  /* For Desktop Specific */
  $scope.loadResourceList = function () {
    if ($scope.currentOrg == null || $scope.currentOrgGroup == null) {
      return;
    }
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      queryParams.sort = $scope.query.order;
      if ($scope.searchText != null && $scope.searchText != "") {
        queryParams.search = $scope.searchText;
      }
      if ($scope.query.categoryFilter != 'all') {
        queryParams.categoryId = $scope.query.categoryFilter;
      }
      $scope.desktopSelected = [];
      resourceService.getResources(queryParams, function (returnObject) {
        var resourceList = returnObject;
        if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
          $scope.listCount = returnObject.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        $scope.resourceSearchList = [];
        if ($scope.allowedResourceCategories == null) {
          $scope.resourceSearchList = returnObject;
        } else {
          for (var i = 0; i < returnObject.length; i++) {
            var newResource = returnObject[i];

            for (var j = 0; j < $scope.allowedResourceCategories.length; j++) {
              var category = $scope.allowedResourceCategories[j];
              if (returnObject[i].categoryId == category.id) {
                if (category.filterByOrder == true && $scope.desktopLineItems) {
                  for (var k = 0; k < $scope.desktopLineItems.length; k++) {
                    if ($scope.desktopLineItems[k].resource && $scope.desktopLineItems[k].resource.id == returnObject[i].id) {
                      newResource.orderItemId = $scope.desktopLineItems[k].id;
                      newResource.orderSupplierRef = $scope.desktopLineItems[k].supplierRef;
                      newResource.lineDescription = $scope.desktopLineItems[k].itemDescription;
                    }
                  }
                }
              }
            }
            $scope.resourceSearchList.push(newResource);
          }
        }
        // populate item descriptions from order/job line items
        if ($scope.desktopLineItems) {
          for (var i = 0; i < $scope.desktopLineItems.length; i++) {
            for (var k = 0; k < $scope.resourceSearchList.length; k++) {
              if ($scope.desktopLineItems[i].resource && $scope.desktopLineItems[i].resource.id == $scope.resourceSearchList[k].id) {
                $scope.resourceSearchList[k].lineDescription = $scope.desktopLineItems[i].itemDescription;
                $scope.resourceSearchList[k].orderItemId = $scope.desktopLineItems[i].id;
                $scope.resourceSearchList[k].orderSupplierRef = $scope.desktopLineItems[i].supplierRef;
              }
            }
          }
        }
        // Disabled any existing resources
        if ($scope.existingResources) {
          for (var i = 0; i < $scope.resourceSearchList.length; i++) {
            if ($scope.existingResources.indexOf($scope.resourceSearchList[i].id) != -1) {
              $scope.resourceSearchList[i].existing = true;
            }
          }
        }

        var externalIds = $scope.resourceSearchList.filter(function (resource) {
          return resource.externalIdentifiers != null;
        }).map(function (resource) {
          return resource.externalIdentifiers.find(function (identifier) {
            return identifier.type == 'xero';
          });
        }).filter(function (identifier) {
          return identifier != undefined;
        }).map(function (identifier) {
          return identifier.externalId;
        }).join(',');

        if ($scope.currentOrg.features && $scope.currentOrg.features.xero /*&& $scope.currentOrg.features.xero.displayUnitPrices*/) {
            xeroService.getXeroItems({ externalIds: externalIds }, function (xeroItems) {
              //for ( var i = 0; i < $scope.resourceSearchList.length; i++ ) {
              $scope.resourceSearchList.filter(function (resource) {
                return resource.externalIdentifiers != null;
              }).forEach(function (resource) {
                resource.externalIdentifiers.filter(function (externalIdentifier) {
                  return externalIdentifier.type == 'xero';
                }).map(function (externalIdentifier) {
                  return externalIdentifier.externalId;
                }).forEach(function (externalId) {
                  xeroItems.forEach(function (xeroItem) {
                    if (externalId == xeroItem.externalId) {
                      resource.xeroItem = xeroItem;
                    }
                  });
                });

                // find xero external id
                /*var xeroExternalId = null;
                //for ( var j = 0; j < $scope.resourceSearchList[i].externalIdentifiers.length; j++ ) {
                const xeroIds = resource.externalIdentifiers.filter(externalId => externalId.type == 'xero')
                if (xeroIds.length > 0) {
                  //if ( $scope.resourceSearchList[i].externalIdentifiers[j].type == 'xero' ) {
                    xeroExternalId = xeroIds[0]
                    //break;
                }
                var foundXeroItem = null;
                if ( xeroExternalId ) {
                  //for ( var j = 0; j < items.length; j++ ) {
                  xeroItems.forEach(xeroItem => {
                    if ( xeroItem.id == xeroExternalId ) {
                      foundXeroItem = xeroItem;
                    }
                  })
                }
                if ( foundXeroItem ) {
                  $scope.resourceSearchList[i].xeroItem = foundXeroItem;
                }*/
              });
            }, function (err) {
              console.error('could not get xero items', err);
            });

            resolve('Done');
          } else {
          resolve('Done');
        }
      }, function (err) {
        $scope.resourceSearchList = [];
        reject('Error');
      });
    });
  };

  $scope.searchResourceChange = function (searchText) {
    $scope.searchText = searchText;
    $scope.loadResourceList();
  };

  $scope.rowClick = function (resource) {
    if (!resource.editing) {}
  };

  $scope.$parent.desktopResourceSelectFromParent = function (options, cb) {
    $scope.orderLineItem = options.orderLineItem;
    var categoriesList = options.categories;
    $scope.existingResources = options.existingResources;
    if (categoriesList != null && categoriesList.length > 0) {
      $scope.allowedResourceCategories = categoriesList;
      $scope.allowedResourceCategoryIds = categoriesList.map(function (category) {
        return category.id;
      });
    } else {
      $scope.allowedResourceCategories = null;
      $scope.allowedResourceCategoryIds = null;
    }
    $scope.desktopLineItems = options.lineItems;

    $scope.resourceSelectCallback = cb;
    $scope.resourceSearch = "";
    $scope.desktopSelected = [];
    if (options && options.multiple == false) {
      //TODO: implement single/multiselect mode changing
      $scope.tableSettings.multiple = false;
    } else {
      $scope.tableSettings.multiple = true;
    }
    $scope.query = {
      limit: 10,
      page: 1,
      order: 'name',
      categoryFilter: 'all'
    };
    $scope.loadResourceList();
    $("#selectResourceModal").fadeIn(100);
    $("input[name='selectResourceInput']").focus();
  };

  $scope.closeResourceSelectList = function () {
    $scope.searchResourceChange("");
    $("input[name='selectResourceInput']").val("");
    $scope.resourceSelectCallback(null);
    $("#selectResourceModal").fadeOut(100);
  };

  $scope.addNewResource = function () {
    var newResource = { name: "", identifier: "", editing: true };
    $scope.resourceSearchList.splice(0, 0, newResource);
    // Select the new resource row
    $scope.desktopSelected = [newResource];
  };

  $scope.desktopSelectResourceContinue = function () {
    if ($scope.desktopSelected[0].editing) {
      $scope.saveResourceRow($scope.desktopSelected[0], function (updatedResource) {
        $scope.resourceSelectCallback([updatedResource]);
        $("#selectResourceModal").fadeOut(100);
      });
    } else {
      $scope.resourceSelectCallback($scope.desktopSelected);
      $("#selectResourceModal").fadeOut(100);
    }
  };

  /* For Mobile */
  $scope.$parent.resourceSelectFromParent = function (options, cb) {
    $scope.resourceCategorySearch = "";
    $scope.resourceSelectCallback = cb;
    $scope.resourceCategorySearchList = options.categoriesList;
    $scope.resourceCategorySearchListFull = options.categoriesList;
    $scope.resourceSearchLoading = false;
    $scope.resourceSelectCategoryCount = 0;
    $scope.resourceSelectState = 'category';
    $scope.lineItems = options.lineItems;
    $scope.preventLoad = false;
    $scope.docketResources = options.docketResources;
  };

  $scope.categoryListBackPress = function () {
    $scope.resourceSelectCallback(null);
  };

  $scope.resourceListBackPress = function () {
    $scope.resourceSelectState = 'category';
  };

  $scope.mobileResourceSearch = function (searchText) {
    $scope.selectResourceCategory($scope.resourceCategorySelected, searchText);
  };

  $scope.selectResourceCategory = function (category, searchText) {
    if (searchText != null && searchText != "") {
      $scope.resourceSearch = searchText;
    } else {
      $scope.resourceSearch = "";
    }
    $scope.query.page = 1;
    $scope.resourceCategorySelected = category;
    $scope.resourceSelectState = 'resource';
    $scope.resourceSearchLoading = true;
    $scope.resourceSearchList = [];
    $scope.lastResourceSearchValue = searchText;
    var newResourceList = [];
    var lineResourceList = [];
    // add any resources by line items from order/job
    if ($scope.lineItems) {
      for (var i = 0; i < $scope.lineItems.length; i++) {
        if ($scope.lineItems[i].resource && $scope.lineItems[i].resource.category && $scope.lineItems[i].resource.category.id == category.id) {
          var thisResource = $scope.lineItems[i].resource;
          thisResource.lineDescription = $scope.lineItems[i].itemDescription;
          thisResource.orderItemId = $scope.lineItems[i].id;
          // check if this line has already been added to the docket
          var okToAdd = true;
          if ($scope.docketResources) {
            for (var j = 0; j < $scope.docketResources.length; j++) {
              if ($scope.docketResources[j].orderItemId == thisResource.orderItemId) {
                okToAdd = false;
                break;
              }
            }
          }
          if (okToAdd) {
            if (searchText != null && searchText != "" && (thisResource.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1 || thisResource.identifier.toLowerCase().indexOf(searchText.toLowerCase()) != -1)) {
              lineResourceList.push(thisResource);
            } else if (searchText == null || searchText == "") {
              lineResourceList.push(thisResource);
            }
          }
        }
      }
    }

    // Get resources for category if filterByOrder not required
    if (category.filterByOrder != true) {
      $scope.getMobileResourcesList(category, searchText, function (resources) {
        for (var i = 0; i < resources.length; i++) {
          newResourceList.push(resources[i]);
          for (var j = 0; j < lineResourceList.length; j++) {
            if (lineResourceList[j].id == resources[i].id) {
              newResourceList.push(lineResourceList[j]);
              break;
            }
          }
        }
        $scope.resourceSearchList = newResourceList;
        $scope.resourceSearchLoading = false;
      }, function (err) {
        alert('Error getting resources');
        if (newResourceList.length > 0) {
          $scope.resourceSearchList = newResourceList;
          $scope.resourceSearchLoading = false;
        } else {
          $scope.resourceSearchLoading = false;
          $scope.resourceLoadingError = "Error Loading Resources";
        }
      });
    } else {
      $scope.resourceSearchList = lineResourceList;
      $scope.resourceSearchLoading = false;
    }
  };

  $scope.assignResourceToItem = function (resource) {
    $scope.resourceSelectCallback(resource);
  };

  $scope.getMobileResourcesList = function (category, searchText, successCb, failureCb) {
    $scope.preventLoad = false;
    var queryParams = {};
    queryParams.limit = $scope.query.limit;
    queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
    queryParams.sort = $scope.query.order;
    if (category && category.id) {
      queryParams.categoryId = category.id;
    }
    if (searchText != null && searchText != "") {
      queryParams.search = searchText;
    }
    resourceService.getResources(queryParams, function (returnObject) {
      var resourceList = [];
      resourceList = returnObject;
      if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
        $scope.listCount = returnObject.length;
      } else {
        $scope.listCount = queryParams.offset + (queryParams.limit + 1);
      }
      successCb(resourceList);
    }, function (err) {
      failureCb(err);
    });
  };

  $scope.loadNextPageOfResources = function (cb) {
    $scope.query.page += 1;
    $scope.getMobileResourcesList($scope.resourceCategorySelected, $scope.lastResourceSearchValue, function (resources) {
      if (resources.length == 0) {
        $scope.preventLoad = true;
      }
      for (var i = 0; i < resources.length; i++) {
        $scope.resourceSearchList.push(resources[i]);
      }
      cb();
    }, function (err) {
      cb();
    });
  };

  $scope.loadingMoreItems = false;
  $scope.resourcesListLoadingCount = 0;
  angular.element($window).on('scroll', function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 20) {
      var offset = $scope.query.limit * ($scope.query.page - 1);
      if (!$scope.loadingMoreItems && !$scope.preventLoad) {
        $scope.loadingMoreItems = true;
        $("#resourcesLoadingMore").removeClass('hidden');
        $scope.loadNextPageOfResources(function () {
          $scope.loadingMoreItems = false;
          $("#resourcesLoadingMore").addClass("hidden");
        });
      }
    }
  });

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.updateResourceCategorySearch = function (searchValue) {
    var categories = $scope.resourceCategorySearchListFull;
    if (searchValue === "") {
      $scope.resourceCategorySearchList = categories;
      return;
    }

    var filteredList = [];
    for (var key in categories) {
      if (categories[key].name.indexOf(searchValue) != -1) {
        filteredList.push(categories[key]);
      }
    }

    $scope.resourceCategorySearchList = filteredList;
    return;
  };

  $scope.updateResourceSearch = function (searchValue) {
    $scope.selectResourceCategory($scope.resourceCategorySelected, searchValue);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "vbfD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('assignJobModalController', ['addressBookService', 'userService', 'jobService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', 'uuid', 'docketService', function (addressBookService, userService, jobService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {

  $scope.job = {};
  $scope.personSearchList = [];
  $scope.personSearchListFull = [];
  $scope.desktopSelected = [];
  $scope.originalDesktopSelected = [];
  $scope.assigned = [];
  $scope.loading = false;

  $scope.$parent.showAssignJobModal = function (job) {
    $scope.job = Object.assign({}, job);
    $scope.loadPeopleList();
    $('#acceptOrderWizardModal').fadeIn(100);
  };

  $scope.close = function () {
    $('#acceptOrderWizardModal').fadeOut(100);
  };

  $scope.loadPeopleList = function () {
    $scope.personSearchLoading = true;
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      if ($stateParams.device == 'desktop') {
        queryParams.limit = $scope.query.limit;
        queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
        queryParams.sort = $scope.query.order;
      }
      if ($scope.searchText != null && $scope.searchText != "") {
        queryParams.search = $scope.searchText;
      }
      userService.getMembers(queryParams, function (returnObject) {
        $scope.personSearchListFull = returnObject;
        $scope.personSearchList = returnObject;
        if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
          $scope.listCount = returnObject.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        for (var i = 0; i < $scope.personSearchList.length; i++) {
          // check if person is in assigned list
          for (var j = 0; j < $scope.assigned.length; j++) {
            if ($scope.assigned[j] == $scope.personSearchList[i].id) {
              $scope.personSearchList[i].assigned = true;
              break;
            }
          }
        }
        $scope.desktopSelected = $scope.job.assignees.map(function (a) {
          return $scope.personSearchList.filter(function (person) {
            return person.id == a.assignee;
          })[0];
        });
        $scope.originalDesktopSelected = $scope.desktopSelected.slice();
        $scope.personSearchList = $scope.personSearchListFull.slice();
        $scope.personSearchLoading = false;
        resolve('Done');
      }, function (err) {
        $scope.personSearchLoading = false;
        $scope.personLoadingError = "Error getting people";
        reject('Error');
      });
    });
  };

  $scope.searchPeopleChange = function (searchText) {
    $scope.searchText = searchText;
    $scope.loadPeopleList();
  };

  $scope.saveJob = function () {
    $scope.loading = true;

    var added = $scope.desktopSelected.filter(function (selected) {
      return !$scope.originalDesktopSelected.map(function (x) {
        return x.id;
      }).includes(selected.id);
    });
    var removed = $scope.job.assignees.filter(function (a) {
      return !$scope.desktopSelected.map(function (x) {
        return x.id;
      }).includes(a.assignee);
    });

    var removePerson = function removePerson() {
      if (removed.length > 0) {
        jobService.removeAssignees($scope.job, removed, function () {}, function () {});
      } else {
        sessionStorage.removeItem('jobsList');
        sessionStorage.removeItem('jobsListCount');
        $scope.$parent.$parent.loadJobFromParent($scope.job);
        $scope.$parent.jobsChildControllerReady();

        $('#acceptOrderWizardModal').fadeOut(100);
      }
    };

    if (added.length > 0) {
      jobService.addAssignee($scope.job, added, function () {
        removePerson();
      }, function (err) {
        removePerson();
      });
    } else {
      removePerson();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "vfH2":
/***/ (function(module, exports) {

var path = 'views/pages/orders/mobile/mobileTabBar.html';
var html = "<md-content class=\"tabBarMobile detailTabBar\">\n  <md-nav-bar md-selected-nav-item=\"currentTab\" nav-bar-aria-label=\"docket\">\n    <md-nav-item md-nav-click=\"openMobileTab('General')\" name=\"General\" id=\"tabGeneral\">General</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('LineItems')\" name=\"LineItems\" id=\"tabLineItems\">Items</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('Jobs')\" name=\"Jobs\" id=\"tabJobs\" ng-if=\"userCanDoAction('viewOrderJobs', itemEdit)\">Jobs</md-nav-item>\n    <md-nav-item md-nav-click=\"openMobileTab('Dockets')\" name=\"Dockets\" id=\"tabDockets\">Dockets</md-nav-item>\n  </md-nav-bar>\n</md-content>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "vg1r":
/***/ (function(module, exports) {

var path = 'views/pages/companySettings/roles.html';
var html = "<div class=\"companySettingsContent\">\n  <div class=\"settingsHeader\" ng-if=\"!roleEdit\">\n    <div class=\"left\">\n      <h3>Roles</h3>\n    </div>\n    <div class=\"right\">\n      <md-button class=\"md-icon-button\" ng-click=\"newRole()\" aria-label=\"New Role\">\n        <md-icon md-svg-icon=\"note_add.svg\"></md-icon>\n      </md-button>\n      <md-button class=\"md-icon-button\" ng-click=\"loadRolesList()\" aria-label=\"Reload Roles List\">\n        <md-icon md-svg-icon=\"reload.svg\"></md-icon>\n      </md-button>\n      <md-menu>\n        <md-button aria-label=\"Open list actions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" ng-disabled=\"selected.length <= 0\">\n          <md-icon md-menu-origin md-svg-icon=\"more-vert.svg\"></md-icon>\n        </md-button>\n        <md-menu-content width=\"4\">\n          <md-menu-item ng-click=\"deleteSelectedRoles()\" aria-label=\"Delete Selected Roles\">\n            <md-button>\n              Delete Selected Roles\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </div>\n  </div>\n  <div class=\"settingsHeader\" ng-if=\"roleEdit\">\n    <div class=\"backButton\" ng-click=\"closeEditRoleModal()\">\n      <md-icon md-svg-src=\"arrow_left.svg\"></md-icon>\n    </div>\n    <div class=\"left\">\n      <h3 ng-if=\"roleEdit.id != null\">Edit Role - {{roleEdit.name}}</h3>\n      <h3 ng-if=\"roleEdit.id == null\">New Role</h3>\n    </div>\n    <div class=\"right\">\n      <div class=\"dbButton\" ng-click=\"saveRole(roleEdit)\">\n        Save\n      </div>\n    </div>\n  </div>\n\n  <div class=\"settingsTableOuterContainer\" ng-if=\"!roleEdit\">\n    <md-table-container ng-if=\"allRoles && allRoles.length > 0\">\n      <table md-table md-row-select multiple ng-model=\"selected\" md-progress=\"promise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column><span>Name</span></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row md-select=\"role\" md-select-id=\"id\" ng-repeat=\"role in allRoles\" ng-click=\"editRole(role)\" style=\"cursor: pointer;\">\n            <td md-cell>{{role.name}}</td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n    <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadRolesList\" md-total=\"{{listCount}}\" md-page-select>\n    </md-table-pagination>\n  </div>\n\n  <div class=\"adminBasicContentContainer\" ng-if=\"roleEdit\">\n    <div class=\"adminSettingGroupContainer\">\n      <form name=\"roleEditForm\">\n        <h4 class=\"top\">Name</h4>\n\n        <div layout-gt-sm=\"row\">\n          <md-input-container class=\"md-block\" flex-gt-sm=\"33\">\n            <label>Name</label>\n            <input type=\"text\" ng-model=\"roleEdit.name\" required>\n          </md-input-container>\n        </div>\n\n        <div class=\"listSpacer\"></div>\n\n        <h4>Existing Permissions</h4>\n\n        <div class=\"adminInnerTable\">\n          <md-table-container>\n            <table md-table>\n              <thead md-head>\n                <tr md-row>\n                  <th md-column>Description</th>\n                  <th md-column>Identifier</th>\n                  <th md-column>Deny</th>\n                  <th md-column>Action</th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row ng-repeat=\"permission in roleEdit.permissions\">\n                  <td md-cell>{{permission.permission.shortDescription}}</td>\n                  <td md-cell>{{permission.permission.identifier}}</td>\n                  <td md-cell>\n                    <md-input-container class=\"md-block\" flex-gt-sm=\"10\">\n                      <md-checkbox ng-model=\"permission.deny\">Deny</md-checkbox>\n                    </md-input-container>\n                  </td>\n                  <td md-cell>\n                    <md-button class=\"md-icon-button\" ng-click=\"removePermissionFromRole(permission, roleEdit)\" aria-label=\"Remove Permission From Role\">\n                      <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                    </md-button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n\n        <h4>Unused Permissions</h4>\n\n        <div class=\"adminInnerTable\">\n          <md-table-container>\n            <table md-table>\n              <thead md-head>\n                <tr md-row>\n                  <th md-column>Description</th>\n                  <th md-column>Identifier</th>\n                  <th md-column>Action</th>\n                </tr>\n              </thead>\n              <tbody md-body>\n                <tr md-row ng-repeat=\"permission in remainingPermissions\">\n                  <td md-cell>{{permission.shortDescription}}</td>\n                  <td md-cell>{{permission.identifier}}</td>\n                  <td md-cell>\n                    <md-button class=\"md-icon-button\" ng-click=\"addUnusedPermissionToRole(permission, roleEdit)\" aria-label=\"Add Permission From Role\">\n                      <md-icon md-svg-src=\"add.svg\"></md-icon>\n                    </md-button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n\n        <div class=\"listSpacer\"></div>\n        <div class=\"adminContentButtons\">\n          <div class=\"dbButton spinner\" ng-click=\"saveRole(roleEdit)\" ng-disabled=\"roleEditForm.$invalid || roleEdit.loading\">\n            <span ng-hide=\"roleEdit.loading\">Save</span>\n            <md-progress-circular ng-show=\"roleEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "wHY9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('selectPlanController', ['userService', 'billingService', '$scope', function (userService, billingService, $scope) {

  $scope.allPlans = [];
  $scope.selectPlanCallback = null;
  $scope.billingDetails = billingService.billingDetails;
  $scope.show = false;

  // Fetch all plans.
  if ($scope.allPlans.length === 0) {
    billingService.getPlans(function (plans) {
      $scope.allPlans = plans;
    }, function () {
      $scope.allPlans = [];
    });
  }

  // Generate credit card expiry years
  $scope.cardYears = [];
  var thisYear = (0, _momentTimezone2.default)().year();
  for (var i = 0; i < 10; i++) {
    var newYear = thisYear + i;
    var newYearShort = parseInt(newYear.toString().substr(-2));
    $scope.cardYears.push({ short: newYearShort, full: newYear });
  }

  var featureToText = {
    ordersEnabled: 'view the orders page',
    jobsEnabled: 'view the jobs page',
    reportingEnabled: 'generate reports', // future
    invoicesEnabled: 'generate invoices', // future
    accountingIntegrationEnabled: 'integrate with accounting software', // future
    ordersCreate: 'create orders',
    jobsCreate: 'create jobs',
    jobsSubcontractorAllocation: 'allocate subcontractors to jobs',
    jobsAllocationsView: 'view the job allocations page',
    docketsCreate: 'create dockets',
    docketsCreateFromJob: 'create dockets from jobs',
    docketsFiling: 'file dockets',
    docketsTimesheetsView: 'view the timesheets page',
    docketsReports: 'generate docket reports',
    docketsCreateBatches: 'create docket batches',
    docketsViewBatches: 'view docket batches'
  };

  $scope.$parent.selectPlan = function (cb, requiredFeature, trackingText) {
    billingService.getBillingDetails(function (billingDetails) {
      $scope.billingDetails = billingDetails;
    });

    mixpanel.track('select plan modal - view');

    if (trackingText) {
      mixpanel.track('select plan modal - ' + trackingText);
    }
    $scope.selectPlanCallback = cb;
    $scope.requiredFeatureText = null;

    $scope.selectPlanConfig = { mode: 'plans', saving: false, updateCardOnly: false };

    $scope.requiredPlan = {};
    var availablePlans = $scope.allPlans.filter(function (plan) {
      return plan.available;
    });

    if (requiredFeature === 'users') {
      userService.getMembers(null, function (users) {
        $scope.requiredPlan = availablePlans.find(function (plan) {
          return plan.features.includedUsers === -1 || plan.features.includedUsers > users.length;
        });

        if ($scope.requiredPlan) {
          $scope.requiredFeatureText = 'To add more users, you will need to upgrade to the ' + $scope.requiredPlan.name + ' plan.';
        }
      }, function (err) {});
    } else if (requiredFeature === 'groups') {
      $scope.requiredPlan = availablePlans.find(function (plan) {
        return plan.features.includedOrganisationGroups == 0 || plan.features.includedOrganisationGroups > $scope.currentOrg.groups.length;
      });
      if ($scope.requiredPlan) {
        $scope.requiredFeatureText = 'To add create more groups, you will need to upgrade to the ' + $scope.requiredPlan.name + ' plan.';
      }
    } else {
      $scope.requiredPlan = availablePlans.find(function (plan) {
        return plan.features[requiredFeature] === 'true';
      });
      if ($scope.requiredPlan) {
        $scope.requiredFeatureText = 'To ' + featureToText[requiredFeature] + ', you will need to upgrade to the ' + $scope.requiredPlan.name + ' plan.';
      }
    }

    $scope.show = true;
  };

  $scope.$parent.selectPlanUpdateCard = function (cb) {
    $scope.selectPlanCallback = cb;
    $scope.selectPlanConfig = { mode: 'card', saving: false, updateCardOnly: true };
    $scope.show = true;
  };

  $scope.closePlanSelect = function () {
    $scope.show = false;
    $scope.selectPlanCallback && $scope.selectPlanCallback(null);
  };

  $scope.selectPlanContinue = function (plan) {
    mixpanel.track("Plan selected - " + plan.name);

    $scope.selectPlanConfig.planSelected = plan;
    $scope.selectPlanConfig.hasCard = false;

    if ($scope.billingDetails.currentCard) {
      $scope.selectPlanConfig.saving = true;
      $scope.finishPlanUpdate();
    } else {
      $scope.selectPlanConfig.mode = 'card';
    }
  };

  $scope.refreshPage = function () {
    window.location.reload();
  };

  $scope.selectCardContinue = function () {
    $scope.selectPlanConfig.hasCard = true;
    $scope.finishPlanUpdate();
  };

  $scope.backToPlans = function () {
    $scope.selectPlanConfig.mode = 'plans';
  };

  $scope.finishPlanUpdate = function () {
    $scope.selectPlanConfig.saving = true;

    var billingObj = {};
    if ($scope.selectPlanConfig.updateCardOnly == false) {
      billingObj.plan = $scope.selectPlanConfig.planSelected.id;
    }
    if ($scope.selectPlanConfig.hasCard) {
      window.Stripe.createToken({
        number: $scope.selectPlanConfig.cardUpdate.creditCardNumber,
        cvc: $scope.selectPlanConfig.cardUpdate.cvc,
        exp_month: $scope.selectPlanConfig.cardUpdate.expiry_month,
        exp_year: $scope.selectPlanConfig.cardUpdate.expiry_year
        //address_zip: $scope.selectPlanConfig.cardUpdate.zip
      }, function (result, responseObj) {
        if (!responseObj.error) {
          billingObj.token = responseObj.id;
          $scope.saveBillingUpdate(billingObj);
        } else {
          $scope.alertService.presentAlert('error', 'Oops.', 'Something went wrong with your card details! Check and try again.');
        }
      });
    } else {
      $scope.saveBillingUpdate(billingObj);
    }
  };

  $scope.saveBillingUpdate = function (billingObj) {
    $scope.selectPlanConfig.mode = 'success';
    $scope.selectPlanConfig.saving = true;
    billingService.updateOrganisationBilling($scope.currentOrg.id, billingObj, function () {
      if (billingObj.plan) {
        ga('send', 'event', 'Plan', 'selected', billingObj.plan);
      }
      $scope.planUpdate = {};
      $scope.selectPlanConfig.saving = false;
    }, function (err) {
      $scope.selectPlanConfig.error = true;
      $scope.selectPlanConfig.saving = false;
    });
  };
}]);

/***/ }),

/***/ "whwM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_successtick.svg";

/***/ }),

/***/ "x+gH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('navController', ['userService', '$scope', '$state', '$location', '$window', '$stateParams', 'accessControl', '$rootScope', '$timeout', function (userService, $scope, $state, $location, $window, $stateParams, accessControl, $rootScope, $timeout) {
  $scope.myDocketbook = false;
  if ($stateParams.myDocketbook == true) {
    $scope.myDocketbook = true;
  }

  $scope.currentState = $state.current;
  $scope.mobileNav = false;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.sampleCompany = accessControl.isSampleCompany();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.navOption = $state.current.data.subnavOption;
  $scope.currentUser = accessControl.currentUser();
  $scope.userCanDoAction = userService.userCanDoAction;
  $scope.organisations = accessControl.allowedOrganisations();

  $rootScope.$on('OrganisationsListRefreshed', function () {
    $scope.organisations = accessControl.allowedOrganisations();
  });

  if ($scope.currentOrg && $scope.currentOrg.accessAllowed == false) {
    if ($scope.currentState && $scope.currentState.name != 'main.groupDashboard' && $scope.currentState.name != 'companySettings.billing') {
      $state.go('main.groupDashboard', { orgId: $scope.currentOrg.id });
    }
  }

  $rootScope.$on('ScopeUpdated', function () {
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
  });

  if ($state.current.data.mainnavOption == 'companySettings') {
    $(".leftNavOuter").addClass('companySettingsHeight');
  }

  $scope.canViewOrgSettings = $scope.currentOrg.globalAdministrators.includes($scope.currentUser.id) || $scope.userHasPermission('io.docketbook.uoapi.viewOrganisationSettings');

  /* F/E Permission Checking */
  $scope.userHasPermission = function (permissionName) {
    return accessControl.userHasPermission(permissionName);
  };

  $scope.openIntercom = function () {
    window.FreshworksWidget('open', 'ticketForm');
  };

  $scope.toggleMobileNav = function () {
    $scope.mobileNav = !$scope.mobileNav;
  };

  $scope.goTo = function (view) {
    var currentPath = $location.path();
    if (currentPath == "/" + view) {
      $scope.mobileNav = false;
    }
    $location.path(view);
  };

  $scope.goToDirect = function (href) {
    $window.location.href = href;
  };

  /*** ORG SCOPE FUNCTIONS - FOR MOBILE ****/
  $scope.openScopeDropdown = function () {
    if ($(".orgScopeDropdown").css('display') == 'none') {
      $(".orgScopeDropdown").slideDown();
      $(".orgScopeIcon").addClass('open');
    } else {
      $(".orgScopeDropdown").slideUp();
      $(".orgScopeIcon").removeClass('open');
      $("ul.inner").each(function (item) {
        if (!$(this).hasClass('open')) {
          $(this).slideUp();
        }
      });
    }
  };

  $scope.openOrgUnits = function (orgId) {
    if ($("#org" + orgId + " ul.inner").css('display') == 'none') {
      $("#org" + orgId + " ul.inner").slideDown();
    } else {
      $("#org" + orgId + " ul.inner").slideUp();
    }
  };

  $scope.openUserDropdown = function () {
    if ($(".userDropdown").css('display') == 'none') {
      $(".userDropdown").slideDown();
      $(".currentUserControl").addClass('open');
    } else {
      $(".userDropdown").slideUp();
      $(".currentUserControl").removeClass('open');
    }
  };

  $scope.openHelpLink = function () {
    window.open("https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us");
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "x3VG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "organisations.svg";

/***/ }),

/***/ "xIgd":
/***/ (function(module, exports) {

var path = 'views/modals/fileCodeReportModal.html';
var html = "<div class=\"niceModal desktopSelector\" id=\"fileCodeReportModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header\">\n      <h1>Generate File Code Report</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeFileCodeReportModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div my-loader text=\"Generating Report\" ng-if=\"fileCodeReport.loading\"></div>\n      <form name=\"fileCodeReportForm\" novalidate ng-if=\"fileCodeReport.stage == 'reportType'\">\n        <div class=\"modalFormTableHeader white intro\">\n          <p>How should the report be structured?</p>\n        </div>\n        <md-radio-group ng-model=\"fileCodeReport.type\">\n          <div class=\"signatureSelectionOuter\">\n            <div class=\"left\">\n              <md-radio-button value=\"quantities\" class=\"md-primary\"><h4 class=\"normal\">Quantities by File Code</h4><p>Quantities shown on dockets will be aggregated by file code</p></md-radio-button>\n            </div>\n            <div class=\"right\">\n              <md-radio-button value=\"lineItems\" class=\"md-primary\"><h4 class=\"normal\">Line Items</h4><p>Individual line items from dockets will be exported along with their filing</p></md-radio-button>\n            </div>\n          </div>\n        </md-radio-group>\n      </form>\n      <form name=\"fileCodeReportFilteringForm\" novalidate ng-if=\"fileCodeReport.stage == 'filter'\">\n        <div class=\"modalFormTableHeader white intro\">\n          <p>Select filters to generate a docket summary report</p>\n        </div>\n        <div class=\"modalFormTable padding\">\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup\">\n                <h1>Customer</h1>\n                <md-button class=\"md-icon-button selector\" ng-click=\"selectModalContactFilter(fileCodeReport, 'customerContact', 'fileCodeReportModal')\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                </md-button>\n                <md-button class=\"md-icon-button selector\" ng-click=\"fileCodeReport.customerContact = null\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"fileCodeReport.customerContact.displayName\" ng-disabled=\"true\" aria-label=\"Customer Contact\">\n                </md-input-container>\n              </div>\n            </div>\n\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup\">\n                <h1>Supplier</h1>\n                <md-button class=\"md-icon-button selector\" ng-click=\"selectModalContactFilter(fileCodeReport, 'supplierContact', 'fileCodeReportModal')\">\n                  <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n                </md-button>\n                <md-button class=\"md-icon-button selector\" ng-click=\"fileCodeReport.supplierContact = null\">\n                  <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n                <md-input-container class=\"md-block\">\n                  <input type=\"text\" ng-model=\"fileCodeReport.supplierContact.displayName\" ng-disabled=\"true\" aria-label=\"Supplier Contact\">\n                </md-input-container>\n              </div>\n            </div>\n\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup dates\">\n                <h1 style=\"display: block;\">Date From</h1>\n                <div class=\"md-block\">\n                  <md-input-container class=\"filterDatepicker\">\n                    <md-datepicker ng-model=\"fileCodeReport.startDate\" aria-label=\"From Date Filter\" ng-required=\"true\"></md-datepicker>\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n            <div flex-gt-sm=\"50\">\n              <div class=\"filterGroup dates\">\n                <h1 style=\"display: block;\">Date To</h1>\n                <md-input-container class=\"filterDatepicker\">\n                  <md-datepicker ng-model=\"fileCodeReport.endDate\" aria-label=\"To Date Filter\" ng-required=\"true\"></md-datepicker>\n                </md-input-container>\n              </div>\n            </div>\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div class=\"filterGroup dates\">\n              <h1>Status</h1>\n              <div class=\"md-block\">\n                <md-checkbox ng-checked=\"statusSelected(fileCodeReport.status, 'draft')\" ng-click=\"toggleStatus(fileCodeReport.status, 'draft')\">\n                  Draft\n                </md-checkbox>\n                <md-checkbox ng-checked=\"statusSelected(fileCodeReport.status, 'sent')\" ng-click=\"toggleStatus(fileCodeReport.status, 'sent')\">\n                  Sent\n                </md-checkbox>\n                <md-checkbox ng-checked=\"statusSelected(fileCodeReport.status, 'accepted')\" ng-click=\"toggleStatus(fileCodeReport.status, 'accepted')\">\n                  Accepted\n                </md-checkbox>\n                <md-checkbox ng-checked=\"statusSelected(fileCodeReport.status, 'rejected')\" ng-click=\"toggleStatus(fileCodeReport.status, 'rejected')\">\n                  Rejected\n                </md-checkbox>\n              </div>\n            </div>\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div class=\"filterGroup dates\">\n              <h1>Options</h1>\n              <div class=\"md-block\">\n                <md-checkbox ng-model=\"fileCodeReport.billableOnly\">\n                  Billable Items Only\n                </md-checkbox>\n              </div>\n            </div>\n          </div>\n\n          <div layout-gt-sm=\"row\" class=\"filterRow marginTop\">\n            <div class=\"filterGroup dates\">\n              <h1>Export As</h1>\n              <div class=\"md-block\">\n                <md-radio-group ng-model=\"fileCodeReport.docType\">\n                  <md-radio-button value=\"pdf\">PDF</md-radio-button>\n                  <md-radio-button value=\"xlsx\" class=\"md-primary\">Excel Spreadsheet</md-radio-button>\n                </md-radio-group>\n              </div>\n            </div>\n          </div>\n\n        </div>\n      </form>\n      <div class=\"modalFormTable padding\" ng-if=\"fileCodeReport.stage == 'error'\">\n        <div class=\"billingSuccessOuter error\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n        </div>\n        <div class=\"billingSuccessMessage\">\n          Something went wrong when we tried to generate your report. Please try again.\n          <br/>\n          <div class=\"dbButton\" ng-click=\"fileCodeReport.stage = 'filter'\">Go Back</div>\n        </div>\n      </div>\n      <div class=\"modalFormTable padding\" ng-if=\"fileCodeReport.stage == 'fileList'\">\n        <p>Your report has been generated, click to download</p>\n  \n        <div ng-repeat=\"file in fileCodeReport.generatedFiles\">\n          <a class=\"dbButton lightBlue\" href=\"{{file}}\" target=\"_blank\">Download Report</a>\n        </div>\n      </div>\n    </div>\n    \n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white\" ng-click=\"closeFileCodeReportModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton blue\" ng-click=\"fileCodeReport.stage = 'filter'\" ng-if=\"fileCodeReport.type !== undefined && fileCodeReport.stage == 'reportType'\">\n            Next\n          </div>\n          <div class=\"dbButton spinner\" ng-click=\"generateFileCodeReport(fileCodeReport)\" ng-if=\"fileCodeReport.stage == 'filter'\" ng-disabled=\"fileCodeReportFilteringForm.$invalid || fileCodeReport.loading\">\n            <span ng-hide=\"fileCodeReport.loading\">Generate Report</span>\n            <md-progress-circular ng-show=\"fileCodeReport.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "xTT/":
/***/ (function(module, exports) {

var path = 'views/modals/selectRoleModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectRoleModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Roles To Assign To Member</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeRoleSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"noListMessage\" ng-show=\"rolesSearchList.length <= 0\">\n        There are no roles matching your search criteria.\n      </div>\n      <md-table-container ng-show=\"rolesSearchList.length > 0\">\n        <table md-table multiple md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Name</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"role in rolesSearchList\" md-select=\"role\" md-auto-select md-select-id=\"id\" ng-disabled=\"role.assigned\" class=\"{{ role.assigned ? 'disabled' : '' }}\">\n              <td md-cell>\n                {{role.name}}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n          <span ng-show=\"desktopSelected.length > 1\">\n            {{desktopSelected.length}} roles will be assigned to this member.\n          </span>\n          <span ng-show=\"desktopSelected.length == 1\">\n            1 role will be assigned to this member.\n          </span>\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeRoleSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || desktopSelectRoleContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "xYZX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('docketbook').controller('selectOrderController', ['orderService', '$rootScope', '$scope', '$state', '$stateParams', 'Restangular', 'accessControl', '$timeout', '$q', function (orderService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

  // Initialise variables to be used
  $scope.orderSearch = "";
  $scope.orderSearchLoading = false;
  $scope.orderSearchList = [];
  $scope.orderSearchListFull = [];
  $scope.orderSelectCallback = null;
  $scope.listCount = 0;
  $scope.desktopSelected = [];

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'orderNumber'
  };

  /***************************************/
  /***** Parent Controlled Functions *****/
  /***************************************/

  $scope.$parent.orderSelectFromParent = function (options, cb) {
    $scope.orderSearch = "";
    $scope.orderSearchLoading = false;
    $scope.orderSearchList = [];
    $scope.orderSearchOptions = options;
    if (options) {
      $scope.orderExisting = options.currentOrder;
    } else {
      $scope.orderExisting = null;
    }
    $scope.orderSelectCallback = cb;
    $scope.desktopSelected = [];
    if ($stateParams.device == 'desktop') {
      $("#selectOrderModal").fadeIn(100);
      $("input[name='selectOrderInput']").focus();
    }
    $scope.loadOrderList();
  };

  $scope.loadOrderList = function () {
    $scope.orderSearchLoading = true;
    var options = {};
    if ($scope.orderSearchOptions) {
      options = $scope.orderSearchOptions;
    }
    var searchValue = options.searchValue;
    $scope.promise = $q(function (resolve, reject) {
      var queryParams = {};
      if ($stateParams.device == 'desktop') {
        queryParams.limit = $scope.query.limit;
        queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
        queryParams.sort = $scope.query.order;
      } else {
        queryParams.sort = 'orderNumber';
      }
      if (options && options.statusList) {
        queryParams.statusList = options.statusList;
      }
      if (options && options.hasCustomer) {
        queryParams.hasCustomer = options.hasCustomer;
      }
      if (options && options.supplier) {
        queryParams.supplier = options.supplier.join(',');
      }
      if (options && options.customer) {
        queryParams.customer = options.customer.join(',');
      }
      if (searchValue != null && searchValue != "") {
        queryParams.orderNumber = searchValue;
      }
      orderService.getOrders(queryParams, function (returnObject) {
        var ordersInList = {};
        $scope.orderSearchList = returnObject;
        if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
          $scope.listCount = returnObject.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        for (var i = 0; i < $scope.orderSearchList.length; i++) {
          $scope.orderSearchList[i].statusDisplay = $scope.orderSearchList[i].status.charAt(0).toUpperCase() + $scope.orderSearchList[i].status.slice(1);
          if ($scope.orderExisting && $scope.orderSearchList[i].id == $scope.orderExisting.id) {
            $scope.orderSearchList[i].existing = true;
          }
          if ($scope.orderSearchOptions.hasOrderNumber && $scope.orderSearchList[i].orderNumber == null) {
            $scope.orderSearchList[i].existing = true;
          }
          ordersInList[$scope.orderSearchList[i].id] = true;
        }
        for (var i = 0; i < $scope.orderSearchList.length; i++) {
          if ($scope.orderSearchList[i].supplierRefNo && $scope.orderSearchList[i].supplierRefNo.indexOf('xq') != -1) {
            var splits = $scope.orderSearchList[i].supplierRefNo.split('_');
            var xeroQuoteNumber = splits[1];
            if (xeroQuoteNumber) {
              $scope.orderSearchList[i].supplierXeroQuoteNumber = xeroQuoteNumber;
            }
          }
          if ($scope.orderSearchList[i].customerRefNo && $scope.orderSearchList[i].customerRefNo.indexOf('xq') != -1) {
            var splits = $scope.orderSearchList[i].customerRefNo.split('_');
            var xeroQuoteNumber = splits[1];
            if (xeroQuoteNumber) {
              $scope.orderSearchList[i].customerXeroQuoteNumber = xeroQuoteNumber;
            }
          }
        }
        // also do a getOrders based on searchValue being a customerRefNo
        if (searchValue != null && searchValue != "") {
          delete queryParams.orderNumber;
          queryParams.customerRefNo = searchValue;
          orderService.getOrders(queryParams, function (returnObject) {
            for (var i = 0; i < returnObject.length; i++) {
              if (ordersInList[returnObject[i]] != true) {
                returnObject[i].statusDisplay = returnObject[i].status.charAt(0).toUpperCase() + returnObject[i].status.slice(1);
                if ($scope.orderExisting && returnObject[i].id == $scope.orderExisting.id) {
                  returnObject[i].existing = true;
                }
                if ($scope.orderSearchOptions.hasOrderNumber && returnObject[i].orderNumber == null) {
                  returnObject[i].existing = true;
                }
                ordersInList[returnObject[i].id] = true;
                $scope.orderSearchList.push(returnObject[i]);
              }
            }
            delete queryParams.customerRefNo;
            queryParams.supplierRefNo = searchValue;
            orderService.getOrders(queryParams, function (returnObject) {
              for (var i = 0; i < returnObject.length; i++) {
                if (ordersInList[returnObject[i]] != true) {
                  returnObject[i].statusDisplay = returnObject[i].status.charAt(0).toUpperCase() + returnObject[i].status.slice(1);
                  if ($scope.orderExisting && returnObject[i].id == $scope.orderExisting.id) {
                    returnObject[i].existing = true;
                  }
                  if ($scope.orderSearchOptions.hasOrderNumber && returnObject[i].orderNumber == null) {
                    returnObject[i].existing = true;
                  }
                  ordersInList[returnObject[i].id] = true;
                  $scope.orderSearchList.push(returnObject[i]);
                }
              }
              for (var i = 0; i < $scope.orderSearchList.length; i++) {
                if ($scope.orderSearchList[i].supplierRefNo && $scope.orderSearchList[i].supplierRefNo.indexOf('xq') != -1) {
                  var splits = $scope.orderSearchList[i].supplierRefNo.split('_');
                  var xeroQuoteNumber = splits[1];
                  if (xeroQuoteNumber) {
                    $scope.orderSearchList[i].supplierXeroQuoteNumber = xeroQuoteNumber;
                  }
                }
                if ($scope.orderSearchList[i].customerRefNo && $scope.orderSearchList[i].customerRefNo.indexOf('xq') != -1) {
                  var splits = $scope.orderSearchList[i].customerRefNo.split('_');
                  var xeroQuoteNumber = splits[1];
                  if (xeroQuoteNumber) {
                    $scope.orderSearchList[i].customerXeroQuoteNumber = xeroQuoteNumber;
                  }
                }
              }
              $scope.orderSearchLoading = false;
              resolve('Done');
            });
          });
        } else {
          $scope.orderSearchLoading = false;
          resolve('Done');
        }
      }, function (err) {
        $scope.orderSearchLoading = false;
        $scope.orderLoadingError = "Error getting orders";
        $scope.orderSearchList = [];
        reject('Error');
      });
    });
  };

  $scope.assignOrderToDocket = function (order) {
    $scope.orderSelectCallback(order);
  };

  $scope.closeOrderSelectList = function () {
    $scope.orderSelectCallback(null);
    if ($stateParams.device == 'desktop') {
      $("#selectOrderModal").fadeOut(100);
    }
  };

  $scope.desktopSelectOrderContinue = function () {
    var selected = $scope.desktopSelected[0];
    $scope.orderSelectCallback(selected);
    $("#selectOrderModal").fadeOut(100);
  };

  /********************************/
  /***** Search Functionality *****/
  /********************************/

  $scope.searchOrderChange = function (searchValue) {
    if ($scope.orderSearchOptions) {
      var options = angular.copy($scope.orderSearchOptions);
      $scope.orderSearchOptions.searchValue = searchValue;
      options.searchValue = searchValue;
      $scope.loadOrderList(null, options);
    } else {
      $scope.loadOrderList(null);
    }
  };

  $scope.updateOrderSearch = function (searchValue) {
    $scope.orderSearchLoading = true;
    $scope.orderSearch = searchValue;
    $scope.loadOrderList();
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "xt7z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "companysettings.svg";

/***/ }),

/***/ "yLTZ":
/***/ (function(module, exports) {

var path = 'views/pages/orders/desktop/index.html';
var html = "<div ng-show=\"currentOrg.planFeatures.ordersEnabled == true || hasOrders || myDocketbook\" style=\"display: flex; flex-direction: column; height: 100%;\">\n  <div>\n    <ng-include src=\"'views/filterBars/ordersFilterBar.html'\"></ng-include>\n  </div>\n\n  <div style=\"flex-shrink: 1; flex: 1 1 auto;\">\n    <div class=\"desktopContainer\">\n      <!-- Content Heading -->\n      <!-- Main content area - with list/detail split functionality -->\n      <div class=\"desktopSplitListOuter\">\n        <div class=\"desktopSplitListTableOuter\">\n          <div ng-style=\"{'display' : 'table', 'width':'100%','height':'100%'}\">\n              <ng-include src=\"'views/pages/orders/desktop/ordersHeading.html'\" ng-style=\"{'display':'table-row','width':'100%'}\"></ng-include>\n              <div ng-controller=\"orderListController\" ng-style=\"{'display':'table-row','width':'100%','height':'100%'}\">\n                <div ng-style=\"{'width':'100%','height':'100%','position':'relative'}\">\n                  <div ng-style=\"{'display':'block','height':'100%','overflow':'auto','position':'absolute','top':'0px','left':'0px','width':'100%'}\">\n                    <ng-include src=\"'views/pages/orders/desktop/ordersList.html'\"></ng-include>\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <div class=\"desktopSplitListDetailOuter\" ng-controller=\"orderDetailController\">\n          <ng-include src=\"'views/pages/orders/desktop/orderDetail.html'\" class=\"detailItemContainer\" ng-if=\"itemEdit != null\">\n          </ng-include>\n          <!-- Share Order Modal -->\n          <ng-include src=\"'views/modals/shareOrderModal.html'\"></ng-include>\n          <!-- Assign Order Modal -->\n          <ng-include src=\"'views/modals/assignOrderModal.html'\"></ng-include>\n          <ng-include src=\"'views/modals/acceptOrderWizardModal.html'\" ng-controller=\"acceptOrderWizardModalController\"></ng-include>\n          <ng-include src=\"'views/modals/recommendLineItemResourceModal.html'\" ng-controller=\"recommendLineItemResourceModalController\"></ng-include>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- Select Contact Modal -->\n<ng-include src=\"'views/modals/editContactModal.html'\" ng-controller=\"editContactController\"></ng-include>\n\n<!-- Select Contact Modal -->\n<ng-include src=\"'views/modals/selectContactModal.html'\" ng-controller=\"selectContactController\"></ng-include>\n<!-- Select Quote Modal -->\n<ng-include src=\"'views/modals/selectQuoteModal.html'\" ng-controller=\"selectQuoteController\"></ng-include>\n<!-- Select Resource Modal -->\n<ng-include src=\"'views/modals/selectResourceModal.html'\" ng-controller=\"selectResourceController\"></ng-include>\n\n<ng-include src=\"'views/modals/selectTemplateModal.html'\" ng-controller=\"selectTemplateController\"></ng-include>\n\n<!-- Order Line Item Select Modal -->\n<ng-include src=\"'views/modals/selectOrderLine.html'\" ng-controller=\"selectOrderLineController\"></ng-include>\n<!-- End Order Line Item Select Modal -->\n\n<ng-include ng-if=\"currentOrg.planFeatures.ordersEnabled != true && !myDocketbook && !hasOrders\" src=\"'views/pages/paywalled/orders.html'\" ng-controller=\"paywalledController\"></ng-include>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "yQg5":
/***/ (function(module, exports) {

var path = 'views/pages/docketDesigner/designer.html';
var html = "<div class=\"docketDesignerOuter\">\n  <div class=\"docketDesignerHeader\">\n    <div class=\"mainHeader\">\n      <div class=\"logo\" ui-sref=\"main.dashboard\">\n        <div class=\"logoInner\"></div>\n      </div>\n      <div class=\"title\">\n        Docket Designer<span ng-if=\"templateEdit.id != null\"> - {{templateEdit.name}}</span>\n      </div>\n      <div class=\"right\">\n        <div class=\"dbButton green spinner\" ng-click=\"templateEdit.loading || saveTemplateEdit()\" ng-disabled=\"templateEdit.loading\" ng-if=\"mode != 'new'\">\n          <span ng-hide=\"templateEdit.loading\">Save Template</span>\n          <md-progress-circular ng-show=\"templateEdit.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n        </div>\n      </div>\n    </div>\n    <div class=\"subHeader\">\n      <div class=\"left\">\n        <div class=\"backButton\" ng-click=\"backToTemplates()\">\n          <md-icon md-svg-src=\"arrow_left.svg\"></md-icon>\n          <span>Templates</span>\n        </div>\n      </div>\n      <div class=\"middle\">\n        <div class=\"navContainer\" ng-if=\"mode != 'new'\">\n          <ul>\n            <li class=\"{{mode == 'preview' ? 'selected' : ''}}\" ng-click=\"openPreviewMode()\">Overview</li>\n            <li class=\"{{mode == 'build' ? 'selected' : ''}}\" ng-click=\"openBuildMode()\">Build</li>\n            <li class=\"{{mode == 'configure' ? 'selected' : ''}}\" ng-click=\"openConfigureMode()\">Settings</li>\n          </ul>\n        </div>\n      </div>\n      <div class=\"right\">\n\n      </div>\n    </div>\n  </div>\n  <div class=\"docketDesignerInnerContainer newWizardOuter\" ng-if=\"mode == 'new'\">\n    <div class=\"newTemplateWizardOuter\">\n      <div class=\"newTemplateWizard\">\n        <div class=\"templateWizardStep\" id=\"templateWizardStep1\">\n          <h2>What do you want to call your new docket template?</h2>\n          <h4>This is how you will distinguish between your docket templates</h4>\n\n          <form name=\"newTemplateFormStep1\" novalidate ng-submit=\"newTemplateWizardNext()\">\n            <div layout-gt-sm=\"row\">\n              <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n                <label>Template Name</label>\n                <input ng-model=\"templateEdit.name\" required>\n              </md-input-container>\n            </div>\n            <div layout-gt-sm=\"row\">\n              <div class=\"dbButton grey rightMargin\" ui-sref=\"companySettings.templates({orgId:currentOrg.id})\">\n                Cancel\n              </div>\n              <button class=\"dbButton green\" type=\"submit\" ng-disabled=\"newTemplateFormStep1.$invalid\">\n                Next\n              </button>\n            </div>\n          </form>\n        </div>\n        <div class=\"templateWizardStep\" id=\"templateWizardStep2\">\n          <h2>What sections do you want to start with?</h2>\n          <h4>Click the sections that you would like on your docket. You can add custom sections in a minute!</h4>\n\n          <div class=\"newSectionSelection newTemplateWizardSections\">\n            <div class=\"sectionType resources\" ng-click=\"selectNewTemplateSection('resources')\">\n              <div class=\"icon resources\"><md-icon md-svg-src=\"dump-truck.svg\"></md-icon></div>\n              <div class=\"title\">Items</div>\n            </div>\n            <div class=\"sectionType checklists\" ng-click=\"selectNewTemplateSection('checklists')\">\n              <div class=\"icon checklists\"><md-icon md-svg-src=\"checklist-alt.svg\"></md-icon></div>\n              <div class=\"title\">Checklists</div>\n            </div>\n            <div class=\"sectionType time\" ng-click=\"selectNewTemplateSection('time')\">\n              <div class=\"icon time\"><md-icon md-svg-src=\"clock.svg\"></md-icon></div>\n              <div class=\"title\">Time</div>\n            </div>\n            <div class=\"sectionType signatures\" ng-click=\"selectNewTemplateSection('signatures')\">\n              <div class=\"icon signatures\"><md-icon md-svg-src=\"_signature.svg\"></md-icon></div>\n              <div class=\"title\">Signatures</div>\n            </div>\n          </div>\n\n          <div class=\"dbButton grey rightMargin\" ng-click=\"newTemplateWizardBack()\">\n            Back\n          </div>\n          <div class=\"dbButton green\" ng-click=\"newTemplateWizardSubmit()\">\n            Next\n          </div>\n        </div>\n        <!--<div class=\"templateWizardStep\" id=\"templateWizardStep3\">\n          <h2>Do you have Terms & Conditions?</h2>\n          <h4>Terms & Conditions documents can be displayed on the signature screen of the docket.</h4>\n\n          <div class=\"wizardQuestionSet\">\n            <div class=\"wizardQuestionItem basicBoolean\" ng-click=\"newTemplateWizardTC(true)\">\n              Yes\n            </div>\n            <div class=\"wizardQuestionItem basicBoolean\" ng-click=\"newTemplateWizardTC(false)\">\n              No\n            </div>\n          </div>\n\n          <div class=\"dbButton grey rightMargin\" ng-click=\"newTemplateWizardBack()\">\n            Back\n          </div>\n        </div>\n        <div class=\"templateWizardStep\" id=\"templateWizardStep4\">\n          <h2>Upload Terms & Conditions</h2>\n          <h4>Upload any terms & conditions documents now.</h4>\n\n          <div class=\"wizardDocumentSet\">\n            <div class=\"wizardDocumentItem new\">\n              Click to upload a document\n            </div>\n\n          </div>\n\n          <div class=\"dbButton grey rightMargin\" ng-click=\"newTemplateWizardBack()\">\n            Back\n          </div>\n          <div class=\"dbButton green\" ng-click=\"newTemplateWizardSubmit()\">\n            Done\n          </div>\n        </div>-->\n        <div class=\"templateWizardStep\" id=\"templateWizardCreating\">\n          <h2>Creating your new template...</h2>\n          <h4>Hang tight while we setup your new docket template.</h4>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"docketDesignerInnerContainer\" ng-if=\"mode != 'new'\">\n    <div class=\"controlPane left\" id=\"leftControlPane\" ng-mouseover=\"checkLeftPaneHover()\">\n      <div class=\"paneHeader\">\n        <h1>Docket Sections</h1>\n        <h3>Drag to reorder</h3>\n      </div>\n      <div class=\"blocksList\">\n        <div class=\"sectionBlock disabled\">\n          <h3>General</h3>\n          This block cannot be moved or modified\n        </div>\n        <ul class=\"sortableList\" data-as-sortable data-ng-model=\"templateEdit.blocks\">\n          <li data-ng-repeat=\"block in templateEdit.blocks\" data-as-sortable-item>\n            <div class=\"block sectionBlock {{currentSection.id == block.id && currentSection != null ? 'active':''}}\" ng-click=\"editSection(block)\">\n              <div class=\"sortIcon\" data-as-sortable-item-handle><md-icon md-svg-src=\"drag.svg\"></md-icon></div>\n              <h3 ng-if=\"block.type == 'time'\">Time</h3>\n              <h3 ng-if=\"block.type == 'resources'\">Items</h3>\n              <h3 ng-if=\"block.type == 'checklists'\">Checklists</h3>\n              <h3 ng-if=\"block.type == 'signatures'\">Signatures</h3>\n              <h3 ng-if=\"block.type == 'custom'\">{{block.name}}</h3>\n              <span ng-if=\"block.type == 'time'\">This block cannot be modified</span>\n              <span ng-if=\"block.type != 'time'\">Click to manage</span>\n          </li>\n        </ul>\n        <div class=\"newSectionButton\">\n          <div class=\"dbButton blue block\" ng-click=\"addNewBlock()\">\n            Add Section\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"controlPane right\" id=\"rightControlPane\" ng-mouseover=\"checkRightPaneHover()\">\n      <div ng-if=\"rightPane.view == 'fields'\" class=\"rightPaneInner\">\n        <div class=\"paneHeader\">\n          <h1>Available Fields</h1>\n          <h3>Drag into section</h3>\n        </div>\n        <div class=\"fieldsList\">\n          <div class=\"field\" ng-repeat=\"field in availableFields\" ng-if=\"field.id != null\" data-drag=\"true\" jqyoui-draggable jqyoui-options=\"{revert:'invalid'}\" ng-model=\"field\">\n            <md-icon md-svg-src=\"text-field.svg\" ng-if=\"field.type == 'text'\"></md-icon>\n            <md-icon md-svg-src=\"multiline-field.svg\" ng-if=\"field.type == 'multiline'\"></md-icon>\n            <md-icon md-svg-src=\"font.svg\" ng-if=\"field.type == 'label'\"></md-icon>\n            <md-icon md-svg-src=\"calendar.svg\" ng-if=\"field.type == 'date'\"></md-icon>\n            <md-icon md-svg-src=\"clock.svg\" ng-if=\"field.type == 'time'\"></md-icon>\n            <md-icon md-svg-src=\"_switch.svg\" ng-if=\"field.type == 'boolean'\"></md-icon>\n            <md-icon md-svg-src=\"_select-field.svg\" ng-if=\"field.type == 'select'\"></md-icon>\n            <md-icon md-svg-src=\"number-field.svg\" ng-if=\"field.type == 'number'\"></md-icon>\n            <md-icon md-svg-src=\"_signature.svg\" ng-if=\"field.type == 'signature'\"></md-icon>\n            &nbsp;{{field.displayName}}\n          </div>\n        </div>\n        <div class=\"paneListButtons\">\n          <div class=\"dbButton lightBlue block\" ng-click=\"openNewFieldModal()\">New Field</div>\n        </div>\n      </div>\n      <div ng-if=\"rightPane.view == 'checklists'\">\n        <div class=\"paneHeader\">\n          <h1>Available Checklists</h1>\n          <h3>Drag into section</h3>\n        </div>\n        <div class=\"fieldsList\">\n          <div class=\"field\" ng-repeat=\"checklistContainer in availableChecklists\" ng-if=\"checklistContainer.rule != null\" data-drag=\"true\" jqyoui-draggable jqyoui-options=\"{revert:'invalid'}\" ng-model=\"checklistContainer\">\n            <md-icon md-svg-src=\"checklist.svg\"></md-icon> {{checklistContainer.checklistTemplate.name}}\n          </div>\n        </div>\n        <div class=\"paneListButtons\">\n          <div class=\"dbButton lightBlue block\" ng-click=\"openNewChecklistModal()\">New Checklist</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"configureContainer\" ng-if=\"mode == 'configure'\">\n      <div class=\"titleContainer\">\n        <h3>Template Settings</h3>\n        <h4>Basic settings for this docket template</h4>\n      </div>\n\n      <div class=\"previewContainer templateSettingsContainer\">\n        <form name=\"configureTemplateForm\" novalidate>\n          <h4>Name</h4>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <label>Template Name</label>\n              <input ng-model=\"templateEdit.name\" required>\n            </md-input-container>\n          </div>\n          <h4>Visibility</h4>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <md-checkbox ng-model=\"templateEdit.published\" aria-label=\"Published\">\n                Published\n              </md-checkbox>\n            </md-input-container>\n            <!--<md-input-container class=\"md-block\" flex-gt-sm=\"20\">\n              <md-checkbox ng-model=\"templateEdit.populateResourcesFromJob\" aria-label=\"Auto Populate Resources From Job\">\n                Auto populate resource from job\n              </md-checkbox>\n            </md-input-container>-->\n          </div>\n          <h4>PDF Download Template</h4>\n          <md-input-container class=\"md-block\">\n            <md-select ng-model=\"templateEdit.pdfBuilder\" aria-label=\"Select PDF Template\">\n              <md-option ng-repeat=\"builder in availablePdfBuilders\" ng-value=\"builder.name\">{{builder.displayName}}</md-option>\n            </md-select>\n          </md-input-container>\n          <h4>Terms & Conditions</h4>\n          <p>Here you can upload your terms and conditions that can be viewed when signing a docket</p>\n\n          <div class=\"termsConditionItemsOuter\">\n            <div class=\"termsConditionsItemOuter\" ng-repeat=\"attachment in templateEdit.attachments\">\n              <div class=\"termsConditionsItem\">\n                <div class=\"termsConditionsItemInner\">\n                  <div class=\"icon document\"></div>\n                  {{attachment.fileName}}\n                  <div class=\"deleteButton\">\n                    <md-button class=\"md-icon-button pull-right\" ng-click=\"removeTemplateAttachment(attachment)\" aria-label=\"Delete Attachment\">\n                      <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                    </md-button>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"termsConditionsItemOuter\">\n              <div class=\"termsConditionsItem new\" ngf-select=\"uploadNewTermsAttachment($file)\">\n                <div class=\"termsConditionsItemInner\">\n                  Click to upload new document\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <h4>Resource Summary Settings</h4>\n          <p>If selected, only interactions that are marked as 'billable' will be included in the sum total quantity for a resource</p>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <md-checkbox ng-model=\"templateEdit.sumOnlyBillableInteractions\" aria-label=\"Sum total only billable interactions\">\n                Resource total quantity is calculated only from billable interactions\n              </md-checkbox>\n            </md-input-container>\n          </div>\n\n          <h4>PDF Export Settings</h4>\n          <p>Sections that are selected below will be visible on the PDF docket</p>\n\n          <div layout-gt-sm=\"row\" ng-repeat=\"block in templateEdit.blocks\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n              <md-checkbox ng-model=\"templateEdit.blockVisibilitySettings['resources']\" aria-label=\"Show {{block.name}} Block on PDF\" ng-if=\"block.type == 'resources'\">\n                Items\n              </md-checkbox>\n              <md-checkbox ng-model=\"templateEdit.blockVisibilitySettings['time']\" aria-label=\"Show {{block.name}} Block on PDF\" ng-if=\"block.type == 'time'\">\n                Time\n              </md-checkbox>\n              <md-checkbox ng-model=\"templateEdit.blockVisibilitySettings['checklists']\" aria-label=\"Show {{block.name}} Block on PDF\" ng-if=\"block.type == 'checklists'\">\n                Checklists\n              </md-checkbox>\n              <md-checkbox ng-model=\"templateEdit.blockVisibilitySettings['signatures']\" aria-label=\"Show {{block.name}} Block on PDF\" ng-if=\"block.type == 'signatures'\">\n                Signatures\n              </md-checkbox>\n              <md-checkbox ng-model=\"templateEdit.blockVisibilitySettings[block.name]\" aria-label=\"Show {{block.name}} Block on PDF\" ng-if=\"block.type == 'custom'\">\n                {{block.name}}\n              </md-checkbox>\n            </md-input-container>\n          </div>\n\n          <h4>Order Prefill Settings</h4>\n          <p>Fields that are added below will be available to be prefilled on the Order</p>\n\n          <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n            <md-checkbox ng-repeat=\"field in templateEdit.orderPrefillFields\" ng-model=\"templateEdit.updateOrderPrefillFields[field.id]\" aria-label=\"Order Prefill Field\">\n              {{field.displayName}}\n            </md-checkbox>\n          </md-input-container>\n\n          <p>Add a new field</p>\n          <md-input-container class=\"md-block\">\n            <md-select aria-label=\"Add a Field\" ng-model=\"templateEdit.addPrefillField\" aria-label=\"Add field to Order\">\n              <md-option ng-repeat=\"field in availablePrefillFields\" ng-value=\"field\">{{field.displayName}}</md-option>\n            </md-select>\n          </md-input-container>\n          <button class=\"dbButton\" ng-click=\"addPrefillField()\">Add</button>\n        </form>\n      </div>\n    </div>\n\n    <div class=\"titleContainer\" ng-if=\"mode == 'preview'\">\n      <h3>Docket Preview</h3>\n      <h4>A preview of your Docketbook Docket</h4>\n    </div>\n\n    <div class=\"titleContainer\" ng-if=\"mode == 'build'\">\n      <h3>Section Builder</h3>\n      <h4 ng-if=\"currentSection != null\">Modify this section below</h4>\n      <h4 ng-if=\"currentSection == null\">Choose a section to edit</h4>\n    </div>\n\n    <div class=\"previewContainer\" ng-if=\"mode == 'build' && activityEdit != null\">\n      <div class=\"previewContainerHeading\">\n        <div class=\"leftBackArrow\">\n          <md-button class=\"md-icon-button\" ng-click=\"closeActivityEdit()\" aria-label=\"Close\">\n            <md-icon md-svg-src=\"left.svg\"></md-icon>\n          </md-button>\n        </div>\n        <div class=\"left\">\n          <h3 ng-if=\"activityEdit.new != true\">Edit Activity</h3>\n          <h3 ng-if=\"activityEdit.new == true\">New Activity</h3>\n        </div>\n        <div class=\"right\">\n\n        </div>\n      </div>\n\n      <form name=\"editActivityForm\" ng-submit=\"saveActivityEdit()\">\n        <div class=\"previewContainerContent\">\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Name</label>\n              <input type=\"text\" ng-model=\"activityEdit.name\" required>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <label>Description</label>\n              <input type=\"text\" ng-model=\"activityEdit.description\" required>\n            </md-input-container>\n          </div>\n          <div layout-gt-sm=\"row\">\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <md-checkbox ng-model=\"activityEdit.actorFromOrder\" aria-label=\"Items From Order\">\n                Only Items From Order\n              </md-checkbox>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <md-checkbox ng-model=\"activityEdit.billable\" aria-label=\"Billable Activity\">\n                Activity Is Billable\n              </md-checkbox>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex-gt-sm=\"50\">\n              <md-checkbox ng-model=\"activityEdit.xeroQuantity\" aria-label=\"Zero Quantity Activity\">\n                Zero Quantity Activity\n              </md-checkbox>\n            </md-input-container>\n          </div>\n          <h4 class=\"withSubText\">Fields</h4>\n          <p class=\"subText\">Drag available fields from right pane</p>\n          <ul class=\"sortableList\" data-as-sortable data-ng-model=\"activityEdit.fields\">\n            <li data-ng-repeat=\"field in activityEdit.fields\" data-as-sortable-item>\n              <div data-as-sortable-item-handle>\n                <div class=\"sectionField\">\n                  <md-icon md-svg-src=\"text-field.svg\" ng-if=\"field.type == 'text'\"></md-icon>\n                  <md-icon md-svg-src=\"multiline-field.svg\" ng-if=\"field.type == 'multiline'\"></md-icon>\n                  <md-icon md-svg-src=\"font.svg\" ng-if=\"field.type == 'label'\"></md-icon>\n                  <md-icon md-svg-src=\"calendar.svg\" ng-if=\"field.type == 'date'\"></md-icon>\n                  <md-icon md-svg-src=\"clock.svg\" ng-if=\"field.type == 'time'\"></md-icon>\n                  <md-icon md-svg-src=\"_switch.svg\" ng-if=\"field.type == 'boolean'\"></md-icon>\n                  <md-icon md-svg-src=\"_select-field.svg\" ng-if=\"field.type == 'select'\"></md-icon>\n                  <md-icon md-svg-src=\"number-field.svg\" ng-if=\"field.type == 'number'\"></md-icon>\n                  <md-icon md-svg-src=\"_signature.svg\" ng-if=\"field.type == 'signature'\"></md-icon>\n                  &nbsp;{{field.displayName}}\n                  <div class=\"sectionFieldControls\">\n                    <md-button class=\"md-icon-button\" ng-click=\"removeFieldFromActivity(field, activityEdit)\" aria-label=\"Remove Field\">\n                      <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                    </md-button>\n                  </div>\n                  <div class=\"sectionFieldMandatorySelect\">\n                    <md-input-container class=\"md-block\">\n                      <md-select aria-label=\"Field Required Selection\" ng-model=\"field.mandatory\" aria-label=\"{{field.displayName}} Required Selection\">\n                        <md-option ng-value=\"true\">Mandatory</md-option>\n                        <md-option ng-value=\"false\">Not Mandatory</md-option>\n                      </md-select>\n                    </md-input-container>\n                  </div>\n                </div>\n              </div>\n            </li>\n          </ul>\n          <div class=\"sectionField new\" data-drop=\"true\" data-jqyoui-options ng-model=\"activityEdit.fields\" jqyoui-droppable=\"{onDrop:'fieldDragDropped'}\">Drag & drop fields here</div>\n        </div>\n\n        <div class=\"saveButtonContainer\">\n          <button type=\"submit\" class=\"dbButton grey\" ng-click=\"saveActivityEdit()\" ng-disabled=\"editActivityForm.$invalid\">Done</button>\n          <div class=\"dbButton red spinner leftMargin\" ng-click=\"currentSection.loading || deleteCurrentSection()\" ng-disabled=\"currentSection.loading\">\n            <span ng-hide=\"currentSection.loading\">Delete</span>\n            <md-progress-circular ng-show=\"currentSection.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-if=\"currentSection.loading\"> Deleting</span>\n          </div>\n        </div>\n      </form>\n    </div>\n\n    <div class=\"previewContainer\" ng-if=\"mode == 'build' && currentSection != null && activityEdit == null\">\n      <div class=\"previewContainerHeading\">\n        <div class=\"left\">\n          <md-input-container ng-if=\"currentSection.type == 'custom'\">\n            <label>Section Name</label>\n            <input type=\"text\" ng-model=\"currentSection.name\">\n          </md-input-container>\n          <h3 ng-if=\"currentSection.type != 'new' && currentSection.type != 'custom' && currentSection.type != 'resources'\">Edit {{currentSectionName}} Section</h3>\n          <h3 ng-if=\"currentSection.type == 'resources'\">Edit Items Section</h3>\n          <h3 ng-if=\"currentSection.type == 'new'\">New Section</h3>\n        </div>\n        <div class=\"right closeButton\">\n          <md-button class=\"md-icon-button\" ng-click=\"closeCurrentSection()\" aria-label=\"Close Section\">\n            <md-icon md-svg-src=\"clear.svg\"></md-icon>\n          </md-button>\n        </div>\n      </div>\n\n      <div class=\"previewContainerContent\" ng-if=\"currentSection.type == 'custom'\" id=\"board\">\n        <h4>Drag and drop fields from the available fields list into this section. <br/>Drag to re-arrange.</h4>\n        <ul class=\"sortableList\" data-as-sortable data-ng-model=\"currentSection.fields\">\n          <li data-ng-repeat=\"field in currentSection.fields\" data-as-sortable-item>\n            <div data-as-sortable-item-handle>\n              <div class=\"sectionField\">\n                <md-icon md-svg-src=\"text-field.svg\" ng-if=\"field.type == 'text'\"></md-icon>\n                <md-icon md-svg-src=\"multiline-field.svg\" ng-if=\"field.type == 'multiline'\"></md-icon>\n                <md-icon md-svg-src=\"font.svg\" ng-if=\"field.type == 'label'\"></md-icon>\n                <md-icon md-svg-src=\"calendar.svg\" ng-if=\"field.type == 'date'\"></md-icon>\n                <md-icon md-svg-src=\"clock.svg\" ng-if=\"field.type == 'time'\"></md-icon>\n                <md-icon md-svg-src=\"_switch.svg\" ng-if=\"field.type == 'boolean'\"></md-icon>\n                <md-icon md-svg-src=\"_select-field.svg\" ng-if=\"field.type == 'select'\"></md-icon>\n                <md-icon md-svg-src=\"number-field.svg\" ng-if=\"field.type == 'number'\"></md-icon>\n                <md-icon md-svg-src=\"_signature.svg\" ng-if=\"field.type == 'signature'\"></md-icon>\n                &nbsp;{{field.displayName}} ({{field.mandatory ? 'Mandatory' : 'Optional'}})\n                <div class=\"sectionFieldControls\">\n                  <md-button class=\"md-icon-button\" ng-click=\"removeFieldFromBlock(field, currentSection)\" aria-label=\"Remove Field\">\n                    <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                  </md-button>\n                </div>\n                <!--<div class=\"sectionFieldMandatorySelect\">\n                  <md-input-container class=\"md-block\">\n                    <md-select aria-label=\"Field Required Selection\" ng-model=\"field.mandatory\" aria-label=\"{{field.displayName}} Required Selection\">\n                      <md-option ng-value=\"true\">Mandatory</md-option>\n                      <md-option ng-value=\"false\">Not Mandatory</md-option>\n                    </md-select>\n                  </md-input-container>\n                </div>-->\n              </div>\n            </div>\n          </li>\n        </ul>\n\n        <div class=\"sectionField new\" data-drop=\"true\" data-jqyoui-options ng-model=\"currentSection.fields\" jqyoui-droppable=\"{onDrop:'fieldDragDropped'}\">Drag & drop fields here</div>\n      </div>\n\n      <div class=\"previewContainerContent wide\" ng-if=\"currentSection.type == 'resources'\">\n        <h4>Configure which items can be added to this docket and the types of lines that can be added.</h4>\n\n        <table class=\"interactionTemplateTable\">\n          <tbody>\n            <tr class=\"headingRow\">\n              <td><h1>Line Types</h1></td>\n              <td ng-repeat=\"category in allResourceCategories\" class=\"categoryName\">{{category.name}}</td>\n              <!--<td class=\"categoryName\"></td>-->\n            </tr>\n            <tr ng-repeat=\"interactionTemplate in templateEdit.interactionTemplates\">\n              <td class=\"activityName\">\n                <a ng-click=\"editActivity(interactionTemplate)\">{{interactionTemplate.name}}</a>\n                <div class=\"activityActionButtons\">\n                  <md-button class=\"md-icon-button\" ng-click=\"editActivity(interactionTemplate)\" aria-label=\"Edit Activity\">\n                    <md-icon md-svg-src=\"edit.svg\"></md-icon>\n                  </md-button>\n                  <md-button class=\"md-icon-button\" ng-click=\"deleteActivity(interactionTemplate)\" aria-label=\"Delete Activity\">\n                    <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                  </md-button>\n                </div>\n              </td>\n              <td ng-repeat=\"category in allResourceCategories\" class=\"activitySelect\">\n                <md-input-container class=\"md-block\">\n                  <md-checkbox ng-model=\"templateEdit.interactionTemplatesMatrix[interactionTemplate.name][category.id]\" aria-label=\"Select Activity\">\n                  </md-checkbox>\n                </md-input-container>\n              </td>\n              <!--<td rowspan=\"{{templateEdit.interactionTemplates.length}}\" class=\"newCategoryCol\" ng-if=\"templateEdit.interactionTemplates.indexOf(interactionTemplate) == 0\">Add Item Category</td>-->\n            </tr>\n            <tr class=\"newActivityRow\">\n              <td colspan=\"{{allResourceCategories.length + 1}}\" ng-click=\"newActivity()\">\n                Click to add new activity\n              </td>\n            </tr>\n          </tbody>\n        </table>\n\n        <h4>Items Required on Docket</h4>\n        <p>At least one item (resource and interaction) is required on a docket before it can be submitted</p>\n        <md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n          <md-checkbox ng-model=\"templateEdit.minimumInteractionRequired\" aria-label=\"Minimum Interaction Required\">\n            Enabled\n          </md-checkbox>\n        </md-input-container>\n\n      </div>\n\n      <div class=\"previewContainerContent\" ng-if=\"currentSection.type == 'checklists'\">\n        <h4>Configure which checklists are visible on this docket and their requirements.</h4>\n        <ul class=\"sortableList\" data-as-sortable data-ng-model=\"templateEdit.checklistContainers\">\n          <li data-ng-repeat=\"checklistContainer in templateEdit.checklistContainers\" data-as-sortable-item>\n            <div data-as-sortable-item-handle>\n              <div class=\"sectionField\">\n                <md-icon md-svg-src=\"checklist.svg\"></md-icon> {{checklistContainer.checklistTemplate.name}}\n                <div class=\"sectionFieldControls\">\n                  <md-button class=\"md-icon-button\" ng-click=\"removeChecklistContainer(checklistContainer)\" aria-label=\"Remove Checklist\">\n                    <md-icon md-svg-src=\"delete.svg\"></md-icon>\n                  </md-button>\n                </div>\n                <div class=\"sectionFieldMandatorySelect\">\n                  <md-input-container class=\"md-block\">\n                    <md-select aria-label=\"Checklist Required Selection\" ng-model=\"checklistContainer.rule\" aria-label=\"{{checklistContainer.checklistTemplate.name}} Required Selection\">\n                      <md-option value=\"required\">Mandatory</md-option>\n                      <md-option value=\"notRequired\">Not Mandatory</md-option>\n                    </md-select>\n                  </md-input-container>\n                </div>\n              </div>\n            </div>\n          </li>\n        </ul>\n\n        <div class=\"sectionField new\" data-drop=\"true\" data-jqyoui-options ng-model=\"templateEdit.checklistContainers\" jqyoui-droppable=\"{onDrop:'checklistDragDropped'}\">Drag & drop checklists here</div>\n      </div>\n\n      <div class=\"previewContainerContent\" ng-if=\"currentSection.type == 'time'\">\n        <h4>The time section cannot be modified.</h4>\n\n      </div>\n\n      <div class=\"previewContainerContent\" ng-if=\"currentSection.type == 'signatures'\">\n        <h4>Select if signatures are mandatory or not.</h4>\n\n        <md-radio-group ng-model=\"templateEdit.signature\">\n          <div class=\"signatureSelectionOuter\">\n            <div class=\"left\">\n              <md-radio-button ng-value=\"true\" class=\"md-primary\"><h4>Mandatory</h4><p>Signatures must be captured before docket can be sent.</p></md-radio-button>\n            </div>\n            <div class=\"right\">\n              <md-radio-button ng-value=\"false\" class=\"md-primary\"><h4>Optional</h4><p>Signatures are optional.</p></md-radio-button>\n            </div>\n          </div>\n        </md-radio-group>\n      </div>\n\n      <div class=\"previewContainerContent newSectionSelection\" ng-if=\"currentSection.type == 'new'\">\n        <h3>What type of section do you want to add?</h3>\n        <div class=\"sectionType\" ng-click=\"selectNewBlockType('resources')\" ng-if=\"templateEdit.existingStandardBlocks.indexOf('resources') == -1\">\n          <div class=\"icon resources\"><md-icon md-svg-src=\"dump-truck.svg\"></md-icon></div>\n          <div class=\"title\">Items</div>\n        </div>\n        <div class=\"sectionType\" ng-click=\"selectNewBlockType('checklists')\" ng-if=\"templateEdit.existingStandardBlocks.indexOf('checklists') == -1\">\n          <div class=\"icon checklists\"><md-icon md-svg-src=\"checklist-alt.svg\"></md-icon></div>\n          <div class=\"title\">Checklists</div>\n        </div>\n        <div class=\"sectionType\" ng-click=\"selectNewBlockType('time')\" ng-if=\"templateEdit.existingStandardBlocks.indexOf('time') == -1\">\n          <div class=\"icon time\"><md-icon md-svg-src=\"clock.svg\"></md-icon></div>\n          <div class=\"title\">Time</div>\n        </div>\n        <div class=\"sectionType\" ng-click=\"selectNewBlockType('signatures')\" ng-if=\"templateEdit.existingStandardBlocks.indexOf('signatures') == -1\">\n          <div class=\"icon signatures\"><md-icon md-svg-src=\"_signature.svg\"></md-icon></div>\n          <div class=\"title\">Signatures</div>\n        </div>\n        <div class=\"sectionType\" ng-click=\"selectNewBlockType('custom')\">\n          <div class=\"icon custom\"><md-icon md-svg-src=\"custom-section.svg\"></md-icon></div>\n          <div class=\"title\">Design my own</div>\n        </div>\n      </div>\n\n      <div class=\"saveButtonContainer\" ng-if=\"currentSection.type != 'new'\">\n        <div class=\"dbButton grey\" ng-click=\"saveCurrentSection()\">Done</div>\n        <div class=\"dbButton red spinner leftMargin\" ng-click=\"currentSection.loading || deleteCurrentSection()\" ng-disabled=\"currentSection.loading\">\n          <span ng-hide=\"currentSection.loading\">Delete</span>\n          <md-progress-circular ng-show=\"currentSection.loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular><span ng-if=\"currentSection.loading\"> Deleting</span>\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"previewContainer\" ng-if=\"mode == 'preview'\">\n      <div class=\"ojdDesktopDetailOuter\">\n        <form name=\"docketDetailForm\" class=\"docketDetailForm\">\n          <div class=\"ojdDesktopMainSections\">\n            <!-- Start Summary Section -->\n            <div class=\"ojdDesktopSection\">\n              <div class=\"ojdDesktopRow\" ng-if=\"!isPreAuthDocket\">\n                <div class=\"ojdDesktopField\">\n                  <label class=\"order\">Order</label>\n                  <h2>EG-O-0001</h2>\n                </div>\n                <div class=\"ojdDesktopField\">\n                  <label class=\"order\">Job</label>\n                  <h2>EG-J-0001</h2>\n                </div>\n              </div>\n\n              <div class=\"ojdDesktopRow\">\n                <div class=\"ojdDesktopField\">\n                  <label class=\"order\">Supplier</label>\n                  <h2>Supplier A</h2>\n                  <h3>1 Breakfast Creek Road, Newstead</h3>\n                </div>\n                <div class=\"ojdDesktopField\">\n                  <label class=\"order\">Customer</label>\n                  <h2>Customer A</h2>\n                  <h3>1 Breakfast Creek Road, Newstead</h3>\n                </div>\n              </div>\n\n              <div class=\"ojdDesktopRow\">\n                <div class=\"ojdDesktopField\">\n                  <label class=\"order\">Date</label>\n                  <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n                    <md-datepicker ng-model=\"itemEdit.date\" name=\"date\" aria-label=\"Docket Date\"></md-datepicker>\n                  </md-input-container>\n                </div>\n\n                <div class=\"ojdDesktopField\">\n                  <label class=\"order\">Operator</label>\n                  <h2>Joe Bloggs</h2>\n                </div>\n\n                <div class=\"ojdDesktopField\">\n                  <label class=\"order\">Docket Template</label>\n                  <h2>Template ABC</h2>\n                </div>\n              </div>\n            </div>\n\n            <span class=\"repeatingOJDSection\" ng-repeat=\"block in templateEdit.blocks\">\n              <div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'time'\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">Time</h1>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n                  </div>\n                </div>\n\n                <div class=\"ojdDesktopPaddingOuter\">\n                  <div class=\"ojdDesktopRow\">\n                    <div class=\"ojdDesktopField\">\n                      <label class=\"order\">Start Time</label>\n                      <md-input-container class=\"md-block\" flex-gt-sm>\n                        <mdp-time-picker ng-model=\"itemEdit.startTime\" mdp-auto-switch=\"true\" aria-label=\"Start Time\"></mdp-time-picker>\n                      </md-input-container>\n                    </div>\n                    <div class=\"ojdDesktopField\">\n                      <label class=\"order\">End Time</label>\n                      <md-input-container class=\"md-block\" flex-gt-sm>\n                        <mdp-time-picker ng-model=\"itemEdit.endTime\"  mdp-auto-switch=\"true\" aria-label=\"End Time\"></mdp-time-picker>\n                      </md-input-container>\n                    </div>\n                  </div>\n                  <div class=\"ojdDesktopRow\">\n                    <div class=\"ojdDesktopField\">\n                      <label class=\"order\">Break Time (minutes)</label>\n                      <md-input-container class=\"md-block\" flex-gt-sm>\n                        <input type=\"text\" ng-model=\"itemEdit.breakTime\" aria-label=\"Break Time\">\n                      </md-input-container>\n                    </div>\n                    <div class=\"ojdDesktopField\">\n                      <label class=\"order\">Travel Time (minutes)</label>\n                      <md-input-container class=\"md-block\" flex-gt-sm>\n                        <input type=\"text\" ng-model=\"itemEdit.travelTime\" aria-label=\"Travel Time\">\n                      </md-input-container>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <!-- Items Section -->\n              <div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'resources'\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">Items</h1>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n\n                  </div>\n                </div>\n\n                <md-table-container class=\"docketResourceTable\">\n                  <table md-table multiple>\n                    <thead md-head>\n                      <tr md-row>\n                        <th md-column>Resource / Line</th>\n                        <th md-column>QTY</th>\n                        <th md-column>Additional Fields</th>\n                        <th md-column>Timestamp</th>\n                        <th md-column>Action</th>\n                      </tr>\n                    </thead>\n                    <tbody md-body>\n                      <tr md-rowclass=\"resourceRow\">\n                        <td md-cell>\n                          Item 1 (ITEM001) - Item Description\n                        </td>\n                        <td md-cell>\n                          12 Tonnes\n                        </td>\n                        <td md-cell colspan=\"2\"></td>\n                        <td md-cell></td>\n                      </tr>\n                      <tr md-row class=\"interactionRow\">\n                        <td md-cell>\n                          Action 1\n                        </td>\n                        <td md-cell>\n                          2 Tonnes\n                        </td>\n                        <td md-cell>\n                          Yes\n                        </td>\n                        <td md-cell>\n                          04:45 AM 12/4/2017\n                        </td>\n                        <td md-cell></td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </md-table-container>\n              </div>\n              <!-- End Items Section -->\n\n              <!-- Signatures Section -->\n              <div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'signatures'\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">Signatures</h1>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n                  </div>\n                </div>\n\n                <div class=\"ojdDesktopPaddingOuter\">\n                  <div class=\"ojdDesktopRow\">\n                    <div class=\"ojdDesktopField\" ng-click=\"!userCanDoAction('captureSupplierSignature', itemEdit) || captureSignature('supplierSignature')\">\n                      <div><label class=\"order\">Operator</label></div>\n                      <h2>\n                        Not Captured\n                      </h2>\n                    </div>\n\n                    <div class=\"ojdDesktopField\" ng-click=\"!userCanDoAction('captureCustomerSignature', itemEdit) || captureSignature('customerSignature')\">\n                      <div><label class=\"order\">Customer</label></div>\n                      <h2>\n                        Not Captured\n                      </h2>\n\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- End Signatures Section -->\n\n              <!-- Start Checklists Section -->\n              <div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'checklists'\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">Checklists</h1>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n                  </div>\n                </div>\n\n                <md-table-container class=\"docketChecklistTable\">\n                  <table md-table multiple>\n                    <thead md-head>\n                      <tr md-row>\n                        <th md-column>Checklist</th>\n                        <th md-column>Rule</th>\n                        <th md-column>Status</th>\n                        <th md-column width=\"100px\">Action</th>\n                      </tr>\n                    </thead>\n                    <tbody md-body>\n                      <tr md-row ng-repeat=\"checklistContainer in templateEdit.checklistContainers\">\n                        <td md-cell>\n                          <strong>{{checklistContainer.checklistTemplate.name}}</strong>\n                        </td>\n                        <td md-cell>\n                          <span ng-if=\"checklistContainer.rule == 'notRequired'\">Not Mandatory</span>\n                          <span ng-if=\"checklistContainer.rule == 'required'\">Mandatory</span>\n                        </td>\n                        <td md-cell>\n                          <div class=\"statusDisplay Declined\">Incomplete</div>\n                        </td>\n                        <td md-cell>\n\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </md-table-container>\n              </div>\n              <!-- End Checklists Section -->\n              <!-- Start Custom Block -->\n              <div class=\"ojdDesktopSection noPadding\" ng-if=\"block.type == 'custom'\">\n                <div class=\"sectionHeadingContainer\">\n                  <div class=\"sectionHeadingLeft\">\n                    <h1 class=\"sectionHeading\">{{block.name}}</h1>\n                  </div>\n                  <div class=\"sectionHeadingRight\">\n                  </div>\n                </div>\n\n                <div class=\"ojdDesktopPaddingOuter\">\n                  <div class=\"ojdDesktopRow\">\n                    <div class=\"autoRepeatingFieldOuter\" ng-repeat=\"field in block.fields\">\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'datetime' || field.type == 'date'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n                          <md-datepicker ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\"></md-datepicker>\n                        </md-input-container>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'time'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <md-input-container class=\"md-block datepicker\" flex-gt-sm>\n                          <mdp-time-picker ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\"  mdp-timezone=\"{{itemEdit.timezone}}\"></mdp-time-picker>\n                        </md-input-container>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'text'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                          <input type=\"text\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n                        </md-input-container>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'boolean'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                          <md-checkbox ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" aria-label=\"{{field.displayName}}\" ng-disabled=\"!itemEdit.editing\">\n                          </md-checkbox>\n                        </md-input-container>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'number'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                          <input type=\"number\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n                        </md-input-container>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'select'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <md-input-container class=\"md-block\">\n                          <md-select aria-label=\"Select Field Value\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" ng-disabled=\"!itemEdit.editing\" aria-label=\"{{field.displayName}}\">\n                            <md-option ng-repeat=\"value in field.selectionFields\" ng-value=\"value\">{{value}}</md-option>\n                          </md-select>\n                        </md-input-container>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'multiline'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <md-input-container class=\"md-block\">\n                          <textarea aria-label=\"{{field.displayName}}\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus ng-disabled=\"!itemEdit.editing\"></textarea>\n                        </md-input-container>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'label'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        {{field.text}}\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'address'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <div class=\"group\" ng-show=\"itemEdit.editing\">\n                          <input type=\"text\" name=\"location\" ng-model=\"itemEdit.templateValueStore[block.id + '-' + field.id]\" address-model=\"newAddress\" googleplace placeholder=\"\" aria-label=\"{{field.displayName}}\">\n                          <span class=\"highlight\"></span>\n                          <span class=\"bar\"></span>\n                        </div>\n                        <h3 ng-show=\"!itemEdit.editing\">{{itemEdit.templateValueStore[block.id + '-' + field.id]}}</h3>\n                      </div>\n                      <div class=\"ojdDesktopField\" ng-if=\"field.type == 'location'\">\n                        <label class=\"order\">{{field.displayName}}</label>\n                        <h3>Coming Soon</h3>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- End custom block -->\n            </div>\n          </span>\n\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-include src=\"'views/alerts/alertTemplate.html'\"></ng-include>\n<ng-include src=\"'views/modals/fieldModal.html'\" ng-controller=\"fieldModalController\"></ng-include>\n<ng-include src=\"'views/modals/checklistModal.html'\"></ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "yVK2":
/***/ (function(module, exports) {

var path = 'views/modals/selectOrderModal.html';
var html = "<!-- This modal is only used for desktop -->\n<div class=\"niceModal desktopSelector\" id=\"selectOrderModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Select Order</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeOrderSelectList()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <div class=\"searchBar\">\n        <div class=\"title\">\n          <md-icon md-svg-icon=\"magnify.svg\"></md-icon>\n        </div>\n        <div class=\"bar\">\n          <input type=\"text\" name=\"selectOrderInput\" ng-model=\"orderSearch\" placeholder=\"Search\" ng-change=\"searchOrderChange(orderSearch)\" ng-model-options='{debounce:1000}'>\n        </div>\n      </div>\n      <div ng-show=\"orderSearchLoading\" style=\"width: 100%; height: 300px; display: flex; justify-content: center; align-items: center;\">\n        <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-5\" md-diameter=\"60\"></md-progress-circular>\n      </div>\n      <div class=\"noListMessage\" ng-show=\"orderSearchList.length <= 0 && !orderSearchLoading\">\n        There are no orders matching your search criteria.\n      </div>\n      <md-table-container ng-show=\"orderSearchList.length > 0 && !orderSearchLoading\">\n        <table md-table md-row-select ng-model=\"desktopSelected\" md-progress=\"promise\">\n          <thead md-head md-order=\"query.order\" md-on-reorder=\"loadOrderList\">\n            <tr md-row>\n              <th md-column md-order-by=\"status\">Status</th>\n              <th md-column md-order-by=\"orderNumber\">Order Number</th>\n              <th md-column md-order-by=\"customer\">Customer</th>\n              <th md-column md-order-by=\"customerRefNo\">Customer Ref</th>\n              <th md-column md-order-by=\"supplierRefNo\">Supplier Ref</th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"order in orderSearchList\" md-select=\"order\" md-auto-select md-select-id=\"id\" ng-disabled=\"order.existing\" class=\"{{order.existing ? 'disabled':''}}\">\n              <td md-cell>\n                <div class=\"statusDisplay {{order.statusDisplay}}\">{{order.statusDisplay}}</div>\n              </td>\n              <td md-cell>\n                {{order.orderNumber}}\n              </td>\n              <td md-cell>\n                {{order.customerContact.displayName}}\n              </td>\n              <td md-cell ng-if=\"order.customerXeroQuoteNumber\">\n                <div class=\"xeroAvatar\"></div> {{order.customerXeroQuoteNumber}}\n              </td>\n              <td md-cell ng-if=\"!order.customerXeroQuoteNumber\">\n                {{order.customerRefNo}}\n              </td>\n              <td md-cell ng-if=\"order.supplierXeroQuoteNumber\">\n                <div class=\"xeroAvatar\"></div> {{order.supplierXeroQuoteNumber}}\n              </td>\n              <td md-cell ng-if=\"!order.supplierXeroQuoteNumber\">\n                {{order.supplierRefNo}}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n      <md-table-pagination md-limit=\"query.limit\" md-limit-options=\"[5,10,15,30,100]\" md-page=\"query.page\" md-on-paginate=\"loadOrderList\" md-total=\"{{listCount}}\" md-page-select>\n\n      </md-table-pagination>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeOrderSelectList()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"desktopSelected.length <= 0 || desktopSelectOrderContinue()\" ng-disabled=\"desktopSelected.length <= 0\">\n            Done\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "ykr0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "_select-field.svg";

/***/ }),

/***/ "ylxt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('docketbook').service('xeroService', ['accessControl', 'userService', '$http', '$stateParams', '$cookies', '$q', '$timeout', 'Restangular', 'geolocation', function (accessControl, userService, $http, $stateParams, $cookies, $q, $timeout, Restangular, geolocation) {

  var currentOrg = accessControl.currentOrg();
  var currentOrgGroup = accessControl.currentOrgGroup();

  /***** Get Xero Quotes *****/
  this.getXeroQuotes = function (params, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseQuotes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/quotes');
    baseQuotes.getList(params).then(function (quotes) {
      successCb(quotes);
    }, failureCb);
  };

  /***** Get Xero Quote *****/
  this.getXeroQuote = function (quoteId, successCb, failureCb) {
    var baseQuotes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('quotes');
    baseQuotes.one(quoteId).customGET("", {}).then(function (quote) {
      successCb(quote[0]);
    }, failureCb);
  };

  /***** Update Xero Quote *****/
  this.markXeroQuoteInvoiced = function (quoteId, successCb, failureCb) {
    var baseQuotes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('quotes');
    baseQuotes.one(quoteId).all('markinvoiced').customPOST({}).then(function (quote) {
      successCb(quote[0]);
    }, failureCb);
  };

  /***** Get Xero Contacts *****/
  this.getXeroContacts = function (successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseContacts = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/contacts');
    baseContacts.getList().then(function (contacts) {
      successCb(contacts);
    }, failureCb);
  };

  /***** Get Xero Items *****/
  this.getXeroItems = function (params, successCb, failureCb) {
    if (params == null) {
      params = {};
    }
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseItems = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/items');
    baseItems.getList(params).then(function (items) {
      successCb(items);
    }, failureCb);
  };

  /***** Get Xero Items ******/
  /*this.getXeroItems = function(params, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var organisationId = null;
    var organisationGroupId = null;
    if ( params && params.organisationId ) {
      organisationId = params.organisationId;
    } else {
      organisationId = currentOrg.id;
    }
    if ( params & params.organisationGroupId ) {
      organisationGroupId = params.organisationGroupId;
    } else {
      organisationGroupId = currentOrgGroup.id;
    }
    var baseItems = Restangular.all('organisations').one(organisationId).all('groups').one(organisationGroupId).all('xero/liveitems');
    baseItems.getList(params).then(function(items) {
      successCb(items);
    }, failureCb);
  }*/

  /***** Get Xero Organisation *****/
  this.getXeroOrganisation = function (successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseContacts = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/organisation/current');
    baseContacts.customGET().then(function (currentXeroOrg) {
      successCb(currentXeroOrg);
    }, failureCb);
  };

  /***** Get Xero Auth Tenants *****/
  this.getXeroAuthTenants = function (successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseContacts = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/authtenants');
    baseContacts.customGET().then(function (authDetails) {
      successCb(authDetails);
    }, failureCb);
  };

  /***** Create Xero Invoice From a Batch *****/
  this.createXeroInvoice = function (data, successCb, failureCb) {
    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();
    var baseXeroExport = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches').one(data.id).all('export/xero');
    baseXeroExport.customPOST({}, null, { target: data.target, type: data.type, includeSupporting: data.includeSupporting, xeroCustomerId: data.xeroCustomerId }).then(successCb, failureCb);
  };

  this.xeroContactSync = function (finishedCb) {
    Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('contacts').one('sync').customPOST().then(function (response) {
      var jobId = response.id;
      checkForXeroSyncCompletion(jobId, finishedCb);
    }, function (err) {});
  };

  this.xeroItemSync = function (finishedCb) {
    Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('items').one('sync').customPOST().then(function (response) {
      var jobId = response.id;
      checkForXeroSyncCompletion(jobId, finishedCb);
    }, function (err) {});
  };

  var checkForXeroSyncCompletion = function checkForXeroSyncCompletion(jobId, finishedCb) {
    $timeout(function () {
      userService.getTaskStatus(jobId, function (taskInfo) {
        if (taskInfo.status == 'In Progress') {
          checkForXeroSyncCompletion(jobId, finishedCb);
        } else {
          finishedCb && finishedCb(taskInfo);
        }
      }, function (err) {
        console.error('could not get task status', err);
      });
    }, 1000);
  };
}]);

/***/ }),

/***/ "zKnx":
/***/ (function(module, exports) {

var path = 'views/pages/mobileLists/listsHeader.html';
var html = "<div class=\"mobileDetailHeader fixed {{currentState.data.listView == 'feed' && organisations.length <= 0 ? 'noShadow':''}}\">\n  <div class=\"mobileDetailHeaderInner\">\n    <div class=\"mobileHeaderUpper\">\n      <div class=\"left\">\n        <div class=\"burgerMenu\" ng-click=\"openScopeDropdown()\">\n          <div class=\"line1\"></div>\n          <div class=\"line2\"></div>\n          <div class=\"line3\"></div>\n        </div>\n      </div>\n      <div class=\"middle\">\n        <span ng-show=\"currentOrgGroup\">{{currentOrgGroup.publicName}}</span>\n        <span ng-show=\"!currentOrgGroup\">My Docketbook</span>\n      </div>\n      <div class=\"right\">\n        <!--<div class=\"bitOperator\"></div>-->\n      </div>\n    </div>\n    <div class=\"mobileHeaderLower\">\n      <div class=\"left\">\n        <span ng-if=\"currentState.data.listView != 'feed'\">{{currentState.data.pageTitle}}</span>\n        <span ng-if=\"currentState.data.listView == 'feed' && organisations.length > 0\">Hello {{currentUser.name.first}}</span>\n      </div>\n      <div class=\"right\">\n        <div class=\"addButton\" ui-sref=\"main.groupOrderDetail({orderId:'new', orgId: currentOrg.id, groupId:currentOrgGroup.id})\" ng-if=\"currentState.data.mainnavOption == 'orders' && userCanDoAction('createOrder')\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </div>\n        <div class=\"addButton\" ui-sref=\"main.groupJobDetail({jobId:'new', orgId: currentOrg.id, groupId: currentOrgGroup.id})\" ng-if=\"currentState.data.mainnavOption == 'jobs' && userCanDoAction('createJob')\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </div>\n        <div class=\"addButton\" ui-sref=\"main.groupDocketDetail({docketId:'new', orgId: currentOrg.id, groupId: currentOrgGroup.id})\" ng-if=\"currentState.data.mainnavOption == 'dockets' && userCanDoAction('createAdhocDocket')\">\n          <md-icon md-svg-src=\"add.svg\"></md-icon>\n        </div>\n      </div>\n    </div>\n  </div>\n    <!--<div class=\"mobileOrgScopeOuter\">\n      <div class=\"orgScope\">\n        <div class=\"orgScopeIcon\" ng-click=\"openScopeDropdown()\">\n          <md-icon md-svg-src=\"menu.svg\"></md-icon>\n        </div>\n      </div>\n    </div>\n    <div class=\"pageTitle\">\n      <span ng-show=\"currentOrgGroup\">{{currentOrgGroup.publicName}}</span>\n      <span ng-show=\"!currentOrgGroup\">My Docketbook</span>\n    </div>\n    <div class=\"mobileNavIcon showfalse\">\n    </div>-->\n\n  <!--<div class=\"blockLayoutHelper\">\n    <md-content class=\"tabBarMobile mainNavBar\">\n      <md-nav-bar md-selected-nav-item=\"listView\" aria-label=\"Navigation Bar\">\n        <md-nav-item md-nav-click=\"changeList('feed')\" name=\"feed\" id=\"navFeedTab\">Home</md-nav-item>\n        <md-nav-item md-nav-click=\"changeList('orders')\" name=\"orders\" id=\"navOrdersTab\" ng-show=\"userHasPermission('io.docketbook.ojdapi.getOrder')\">Orders</md-nav-item>\n        <md-nav-item md-nav-click=\"changeList('jobs')\" name=\"jobs\" id=\"navJobsTab\" ng-show=\"currentOrg == null || userHasPermission('io.docketbook.ojdapi.getJob') || userHasPermission('io.docketbook.ojdapi.getMyJob')\">Jobs</md-nav-item>\n        <md-nav-item md-nav-click=\"changeList('dockets')\" name=\"dockets\" id=\"navDocketsTab\" ng-show=\"currentOrg == null || userHasPermission('io.docketbook.ojdapi.getDocket') || userHasPermission('io.docketbook.ojdapi.getMyDocket')\">Dockets</md-nav-item>\n        <md-nav-item md-nav-click=\"changeList('filing')\" name=\"filing\" id=\"navFilingTab\" ng-show=\"userHasPermission('io.docketbook.ojdapi.fileDockets')\">Filing</md-nav-item>\n      </md-nav-bar>\n    </md-content>\n  </div>-->\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "zVOU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('docketbook').controller('companySettingsTemplatesController', ['docketService', 'resourceService', '$scope', '$window', 'Restangular', 'splitListInterface', '$state', '$stateParams', 'accessControl', 'uuid', '$q', 'Upload', function (docketService, resourceService, $scope, $window, Restangular, splitListInterface, $state, $stateParams, accessControl, uuid, $q, Upload) {
  mixpanel.track("Opened CompanySettings-Templates Desktop");

  $scope.currentUser = $state.params.currentUser;
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.isSampleCompany = accessControl.isSampleCompany();

  $scope.moment = _momentTimezone2.default;

  $scope.goTo = function (href) {
    $window.location.href = href;
  };

  /************************/
  /**** List Controls *****/
  /************************/

  $scope.loadTemplateList = function () {
    $scope.promise = $q(function (resolve, reject) {
      // Get templates from docketService
      docketService.getTemplates(null, function (templates) {
        $scope.allTemplates = templates;
        resolve('Done');
      }, function (error) {
        $scope.allTemplates = [];
        reject('Error');
      });
    });
  };

  $scope.loadTemplateList();

  /****************************/
  /***** Detail Controls ******/
  /****************************/

  $scope.openTemplate = function (template) {
    $state.go('docketDesigner', { templateId: template.id, orgId: $scope.currentOrg.id });
  };

  $scope.openTemplateConfigure = function (template) {
    $state.go('docketDesigner', { templateId: template.id, orgId: $scope.currentOrg.id, mode: 'configure' });
  };

  $scope.newTemplate = function () {
    $state.go('docketDesigner', { templateId: 'new', orgId: $scope.currentOrg.id });
  };

  $scope.duplicateTemplate = function (template) {
    var newTemplate = angular.copy(template);
    delete newTemplate.id;
    newTemplate.name = newTemplate.name + " Copy";
    template.loading = true;

    docketService.saveTemplate(newTemplate, function (templateSaved) {
      template.loading = false;
      $scope.loadTemplateList();
    }, function (err) {
      $scope.alertService.presentAutoAlert('saveTemplate', err);
    });
  };

  $scope.deleteTemplate = function (template) {
    event.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this template!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: false,
      closeOnCancel: true
    }, function (isConfirm) {
      if (isConfirm) {
        docketService.deleteTemplate(template.id, function () {
          swal("Deleted!", "The template has been deleted.", "success");
          $scope.loadTemplateList();
        }, function (err) {
          $scope.alertService.presentAutoAlert('deleteTemplate', err);
        });
      }
    });
  };
}]);

/***/ }),

/***/ "zdbw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apple-icon-72x72.png";

/***/ }),

/***/ "zqiF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "padlock.svg";

/***/ }),

/***/ "zurN":
/***/ (function(module, exports) {

var path = 'views/modals/assignOrderModal.html';
var html = "\n<div class=\"niceModal desktopSelector\" id=\"assignOrderModal\">\n  <div class=\"modalContainer\">\n    <div class=\"header hidden-xs\">\n      <h1>Assign Order {{assignOrder.orderNumber}}</h1>\n      <div class=\"headerCloseButton\" ng-click=\"closeAssignOrderModal()\">\n        <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n          <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n        </md-button>\n      </div>\n    </div>\n    <div class=\"content noPadding\">\n      <form name=\"\" novalidate>\n        <div class=\"modalFormMobileHeader\">\n          Select the organisation/group to add this order to\n        </div>\n        <div class=\"modalFormTableHeader\">\n          Select the organisation/group to add this order to\n        </div>\n\n        <div class=\"modalFormTable\">\n          <md-table-container>\n            <table md-table md-row-select ng-show=\"assignOrder.organisations && assignOrder.organisations.length > 0\" ng-model=\"assignOrder.selected\">\n              <tbody md-body ng-repeat=\"organisation in assignOrder.organisations\">\n                <form name=\"innerForm\">\n                  <tr md-row ng-repeat=\"group in organisation.groups\" md-select=\"group\" md-auto-select md-select-id=\"id\">\n                    <td md-cell>\n                      {{organisation.name}}\n                      <span ng-if=\"group.parent != null\">\n                        - {{group.publicName}}\n                      </span>\n                    </td>\n                  </tr>\n                </form>\n              </tbody>\n            </table>\n          </md-table-container>\n        </div>\n      </form>\n    </div>\n    <div class=\"footer\">\n      <div class=\"tableLayoutHelperContainer\">\n        <div class=\"left\">\n\n        </div>\n        <div class=\"right\">\n          <div class=\"dbButton white margin-right\" ng-click=\"closeAssignOrderModal()\">\n            Cancel\n          </div>\n          <div class=\"dbButton\" ng-click=\"assignOrder.selected.length <= 0 || assignOrderContinue()\" ng-disabled=\"assignOrder.selected.length <= 0\">\n            Save\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ "zzO9":
/***/ (function(module, exports) {

var path = 'views/modals/acceptConnectionRequestModal.html';
var html = "<div class=\"niceModal desktopSelector wide\" id=\"acceptConnectionRequestModal\">\n    <div class=\"modalContainer\" style=\"width: 600px;\">\n        <div class=\"header hidden-xs\">\n            <h1>Connection Requested</h1>\n            <div class=\"headerCloseButton\" ng-click=\"close()\">\n                <md-button class=\"md-icon-button\" aria-label=\"Close Modal\">\n                    <md-icon md-svg-icon=\"clear.svg\"></md-icon>\n                </md-button>\n            </div>\n        </div>\n        <div class=\"content\">\n            <div ng-if=\"connection.orgId\" style=\"padding-bottom: 20px;\">\n                {{connection.orgData.organisationName}} has invited you to connect.  Would you like to accept the connection?\n            </div>\n            <div ng-if=\"connection.orgId == null\">\n                {{connection.orgData.organisationName}} has invited you to connect.  Please select which organisation you would like to create the connection with:\n                <md-input-container class=\"md-block\">\n                    <md-select ng-model=\"data.selectedOrg\" placeholder=\"Select organisation\" required ng-disabled=\"loading\">\n                        <md-option ng-repeat=\"org in orgs\" ng-value=\"org.id\">\n                            {{org.name}}\n                        </md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n        </div>\n        \n        <div class=\"footer\">\n            <div class=\"tableLayoutHelperContainer\">\n                <div class=\"left\">\n            </div>\n            <div class=\"right\">\n                <div class=\"dbButton white margin-right\" ng-click=\"!loading && decline()\" ng-disabled=\"loading\">\n                    Decline\n                </div>\n                <div class=\"dbButton spinner\" ng-click=\"data.selectedOrg && !loading && accept()\" ng-disabled=\"data.selectedOrg == null\">\n                    <span ng-show=\"!loading\">Accept</span>\n                    <md-progress-circular ng-show=\"loading\" class=\"md-hue-2\" md-diameter=\"20px\"></md-progress-circular>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n  ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ })

},["lVK7"]);


// WEBPACK FOOTER //
// main.7cdaa036d0def3128cd5.js